webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindAllOfThis;
/* unused harmony export bindAllOfThisTheHardWay */
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var reactLifecycleFunctions = ["componentWillMount", "componentDidMount", "componentWillReceiveProps", "shouldComponentUpdate", "componentWillUpdate", "componentDidUpdate", "componentWillUnmount", "componentDidCatch"];
var reactComponentFunctions = ["setState", "forceUpdate", "render"];
var functionFunctions = Object.getOwnPropertyNames(Function.prototype);
/**
 * Binds the 'this' context to a given class's functions. This saves you from writing binding code for all functions. Eg, `this.foo = this.foo.bind(this)`.
 *
 * **Note: React lifecycle, component and object functions are ignored.**
 *
 * Usage:
 *
 *    bindAllOfThis(this, YourClass.prototype);
 * @param currentClass This is the current class and will be used for the 'this' context. This will also provide the function list if functionsToBind is empty.
 * @param prototype The prototype of a given class. This is where we are going to get the function list.
 * @param functionsToIgnore The list of functions to ignore. This should not include any react or object functions. Those are already ignored.
 */
function bindAllOfThis(currentClass, prototype, functionsToIgnore) {
    if (functionsToIgnore === void 0) { functionsToIgnore = []; }
    if (currentClass == null || prototype == null) {
        return;
    }
    bindAllOfThisTheHardWay(currentClass, Object.getOwnPropertyNames(prototype), functionsToIgnore);
}
/**
 * Binds the 'this' context to a given class's functions. This is the extended version and contains more options
 *
 * Note: React lifecycle, component and object functions are ignored.
 *
 * Usage: bindAllOfThis(this);
 * @param currentClass This is the current class and will be used for the 'this' context. This will also provide the function list if functionsToBind is empty.
 * @param functionsToBind The list of functions to bind 'this' to. Useful when you are inheriting in a weird way.
 * @param functionsToIgnore The list of functions to ignore. This should not include any react or object functions. Those are already ignored.
 */
function bindAllOfThisTheHardWay(currentClass, functionsToBind, functionsToIgnore) {
    if (functionsToIgnore === void 0) { functionsToIgnore = []; }
    if (currentClass == null) {
        // no
        return;
    }
    if (functionsToBind == null || functionsToBind.length < 1) {
        // Im about 80% sure this branch isnt tested
        console.warn("If this ends up working or breaking, please contact me");
        functionsToBind = Object.getOwnPropertyNames(currentClass);
    }
    var ignoredFunctions = __spreadArrays(reactLifecycleFunctions, reactComponentFunctions, functionFunctions, functionsToIgnore).filter(function (x) { return x; }); // Remove Empty Elements
    functionsToBind.forEach(function (functionName) {
        // Check if x is actually the function and not the name. You must have ES6 as the compiler
        if (typeof (functionName) === 'function') {
            if (functionName.name == null) {
                // Sorry, you need to compile for ES6 in your tsconfig
                return;
            }
            // If we have a name, functionName is technically a function of some kind
            functionName = functionName.name;
        }
        // Check if function name is in the ignored list
        if (ignoredFunctions.findIndex(function (x) { return x === functionName; }) === -1) {
            if (currentClass[functionName]["bind"] == null) {
                // Cannot find bind, which is usually getters/setters. We dont want those
                return;
            }
            currentClass[functionName] = currentClass[functionName].bind(currentClass);
        }
    });
}


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Translate__ = __webpack_require__(1849);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Translate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withLocalize__ = __webpack_require__(756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__withLocalize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocalizeProvider__ = __webpack_require__(1851);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__LocalizeProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocalizeContext__ = __webpack_require__(336);
/* unused harmony reexport LocalizeContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__localize__ = __webpack_require__(247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__localize__["j"]; });
/* unused harmony reexport initialize */
/* unused harmony reexport addTranslation */
/* unused harmony reexport addTranslationForLanguage */
/* unused harmony reexport setActiveLanguage */
/* unused harmony reexport getTranslate */
/* unused harmony reexport getActiveLanguage */
/* unused harmony reexport getLanguages */
/* unused harmony reexport getTranslations */
/* unused harmony reexport getOptions */







/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TranslateApi = /** @class */ (function () {
    function TranslateApi() {
    }
    TranslateApi.currentLanguage = { code: "en-us" };
    return TranslateApi;
}());
/* harmony default export */ __webpack_exports__["a"] = (TranslateApi);


/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Games; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_LandscapingGame_Main__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_DiagnosisGame_Main__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_CollageGame_Main__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_JobMatchingGame_Main__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_ColonyGame_Main__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_PuzzleSlider_Main__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_games_PlumbingGame_Main__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_games_UniversityGame_Main__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_games_PaintGame_Main__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_games_DinerGame_Main__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_games_CareerFairGame_Main__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_games_OrganizeDeskGame_Main__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_games_DiseasedTreesGame_Main__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_games_XraySlider_Main__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_games_DesertTerraformGame_Main__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_games_FitFiveGame_Main__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_games_HotelAuroraGame_Main__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_games_WarehouseGame_Main__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_games_RocketRepairGame_Main__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_games_ProgramRobotGame_Main__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_games_JigsawPuzzleGame_Main__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_games_SpacePortGame_Main__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_games_MailDeliveryGame_Main__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_games_ShipPainting_Main__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_games_SpacePets_Main__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_games_WaiterMemoryGame_Main__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_games_ZooGame_Main__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_games_LibrarianGame_Main__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_games_UniformDesignGame_main__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_games_OceanCleanupGame_Main__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_games_ConstructionMazeGame_Main__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_games_VendingMachine_Main__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_games_SeekAndFindGame_Main__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_games_FindHelpersGame_Main__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_games_TicketTakerGame_Main__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_games_FossilFinderGame_Main__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_games_GroceryBaggerGame_Main__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_games_CakeDecorating_Main__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_games_RideMechanicGame_Main__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_games_StarballGame_Main__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_games_CityBuilderGame_Main__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_games_FacePainting_Main__ = __webpack_require__(978);












































var Games = /** @class */ (function () {
    function Games() {
    }
    Games.FindById = function (id) {
        return this.All.find(function (x) { return x.id === id; }) || this.Default;
    };
    Games.FindByGradeAndPlanet = function (gradeId, planetId) {
        return this.All.find(function (x) { return x.grade.id === gradeId && x.planet.id === planetId; }) || this.Default;
    };
    Games.Default = { id: 0, name: "Default", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Default, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].Default, component: null };
    // 5th grade
    Games.Landscaping = { id: 1, name: "Landscaping", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fifth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R, component: __WEBPACK_IMPORTED_MODULE_2_src_games_LandscapingGame_Main__["a" /* default */] };
    Games.Diagnosis = { id: 2, name: "Diagnosis", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fifth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].I, component: __WEBPACK_IMPORTED_MODULE_3_src_games_DiagnosisGame_Main__["a" /* default */] };
    Games.Collage = { id: 3, name: "Collage", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fifth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].A, component: __WEBPACK_IMPORTED_MODULE_4_src_games_CollageGame_Main__["a" /* default */] };
    Games.JobMatching = { id: 4, name: "JobMatching", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fifth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].S, component: __WEBPACK_IMPORTED_MODULE_5_src_games_JobMatchingGame_Main__["a" /* default */] };
    Games.Colony = { id: 5, name: "Colony", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fifth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].E, component: __WEBPACK_IMPORTED_MODULE_6_src_games_ColonyGame_Main__["a" /* default */] };
    Games.PuzzleSlider = { id: 6, name: "PuzzleSlider", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fifth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C, component: __WEBPACK_IMPORTED_MODULE_7_src_games_PuzzleSlider_Main__["a" /* default */] };
    // 4th grade
    Games.Plumbing = { id: 7, name: "Plumbing", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fourth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R, component: __WEBPACK_IMPORTED_MODULE_8_src_games_PlumbingGame_Main__["a" /* default */] };
    Games.University = { id: 8, name: "University", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fourth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].I, component: __WEBPACK_IMPORTED_MODULE_9_src_games_UniversityGame_Main__["a" /* default */] };
    Games.Paint = { id: 9, name: "Paint", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fourth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].A, component: __WEBPACK_IMPORTED_MODULE_10_src_games_PaintGame_Main__["a" /* default */] };
    Games.Diner = { id: 10, name: "Diner", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fourth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].S, component: __WEBPACK_IMPORTED_MODULE_11_src_games_DinerGame_Main__["a" /* default */] };
    Games.CareerFair = { id: 11, name: "CareerFair", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fourth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].E, component: __WEBPACK_IMPORTED_MODULE_12_src_games_CareerFairGame_Main__["a" /* default */] };
    Games.OrganizeDesk = { id: 12, name: "OrganizeDesk", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Fourth, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C, component: __WEBPACK_IMPORTED_MODULE_13_src_games_OrganizeDeskGame_Main__["a" /* default */] };
    // 3th grade
    Games.DiseasedTrees = { id: 13, name: "DiseasedTrees", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Third, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R, component: __WEBPACK_IMPORTED_MODULE_14_src_games_DiseasedTreesGame_Main__["a" /* default */] };
    Games.XRay = { id: 14, name: "XRay", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Third, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].I, component: __WEBPACK_IMPORTED_MODULE_15_src_games_XraySlider_Main__["a" /* default */] };
    Games.DesertTerraform = { id: 15, name: "DesertTerraform", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Third, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].A, component: __WEBPACK_IMPORTED_MODULE_16_src_games_DesertTerraformGame_Main__["a" /* default */] };
    Games.FitFive = { id: 16, name: "FitFive", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Third, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].S, component: __WEBPACK_IMPORTED_MODULE_17_src_games_FitFiveGame_Main__["a" /* default */] };
    Games.HotelAurora = { id: 17, name: "HotelAurora", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Third, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].E, component: __WEBPACK_IMPORTED_MODULE_18_src_games_HotelAuroraGame_Main__["a" /* default */] };
    Games.Warehouse = { id: 18, name: "Warehouse", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Third, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C, component: __WEBPACK_IMPORTED_MODULE_19_src_games_WarehouseGame_Main__["a" /* default */] };
    // 2th grade
    Games.RocketRepair = { id: 19, name: "RocketRepair", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Second, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R, component: __WEBPACK_IMPORTED_MODULE_20_src_games_RocketRepairGame_Main__["a" /* default */] };
    Games.ProgramRobot = { id: 20, name: "ProgramRobot", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Second, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].I, component: __WEBPACK_IMPORTED_MODULE_21_src_games_ProgramRobotGame_Main__["a" /* default */] };
    Games.ShipPainting = { id: 21, name: "ShipPainting", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Second, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].A, component: __WEBPACK_IMPORTED_MODULE_25_src_games_ShipPainting_Main__["a" /* default */] };
    Games.JigsawPuzzle = { id: 22, name: "JigsawPuzzle", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Second, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].S, component: __WEBPACK_IMPORTED_MODULE_22_src_games_JigsawPuzzleGame_Main__["a" /* default */] };
    Games.SpacePort = { id: 23, name: "SpacePort", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Second, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].E, component: __WEBPACK_IMPORTED_MODULE_23_src_games_SpacePortGame_Main__["a" /* default */] };
    Games.MailDelivery = { id: 24, name: "MailDelivery", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].Second, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C, component: __WEBPACK_IMPORTED_MODULE_24_src_games_MailDeliveryGame_Main__["a" /* default */] };
    // 1th grade
    Games.OceanCleanup = { id: 25, name: "OceanCleanup", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].First, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R, component: __WEBPACK_IMPORTED_MODULE_31_src_games_OceanCleanupGame_Main__["a" /* default */] };
    Games.CityBuilder = { id: 26, name: "CityBuilder", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].First, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].I, component: __WEBPACK_IMPORTED_MODULE_42_src_games_CityBuilderGame_Main__["a" /* default */] };
    Games.UniformDesign = { id: 27, name: "UniformDesign", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].First, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].A, component: __WEBPACK_IMPORTED_MODULE_30_src_games_UniformDesignGame_main__["a" /* default */] };
    Games.SeekAndFind = { id: 28, name: "SeekAndFind", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].First, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].S, component: __WEBPACK_IMPORTED_MODULE_34_src_games_SeekAndFindGame_Main__["a" /* default */] };
    Games.VendingMachine = { id: 29, name: "VendingMachine", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].First, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].E, component: __WEBPACK_IMPORTED_MODULE_33_src_games_VendingMachine_Main__["a" /* default */] };
    Games.SpacePets = { id: 30, name: "SpacePets", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].First, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C, component: __WEBPACK_IMPORTED_MODULE_26_src_games_SpacePets_Main__["a" /* default */] };
    // Kth grade
    Games.ConstructionMaze = { id: 31, name: "ConstructionMaze", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].K, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R, component: __WEBPACK_IMPORTED_MODULE_32_src_games_ConstructionMazeGame_Main__["a" /* default */] };
    Games.Zoo = { id: 32, name: "Zoo", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].K, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].I, component: __WEBPACK_IMPORTED_MODULE_28_src_games_ZooGame_Main__["a" /* default */] };
    Games.CakeDecorating = { id: 33, name: "CakeDecorating", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].K, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].A, component: __WEBPACK_IMPORTED_MODULE_39_src_games_CakeDecorating_Main__["a" /* default */] };
    Games.WaiterMemory = { id: 34, name: "WaiterMemory", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].K, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].S, component: __WEBPACK_IMPORTED_MODULE_27_src_games_WaiterMemoryGame_Main__["a" /* default */] };
    Games.Starball = { id: 35, name: "Starball", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].K, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].E, component: __WEBPACK_IMPORTED_MODULE_41_src_games_StarballGame_Main__["a" /* default */] };
    Games.Librarian = { id: 36, name: "Librarian", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].K, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C, component: __WEBPACK_IMPORTED_MODULE_29_src_games_LibrarianGame_Main__["a" /* default */] };
    // PreK grade
    Games.RideMechanic = { id: 37, name: "RideMechanic", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].PreK, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R, component: __WEBPACK_IMPORTED_MODULE_40_src_games_RideMechanicGame_Main__["a" /* default */] };
    Games.FossilFinder = { id: 38, name: "FossilFinder", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].PreK, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].I, component: __WEBPACK_IMPORTED_MODULE_37_src_games_FossilFinderGame_Main__["a" /* default */] };
    Games.FacePainting = { id: 39, name: "FacePainting", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].PreK, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].A, component: __WEBPACK_IMPORTED_MODULE_43_src_games_FacePainting_Main__["a" /* default */] };
    Games.FindHelpers = { id: 40, name: "FindHelpers", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].PreK, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].S, component: __WEBPACK_IMPORTED_MODULE_35_src_games_FindHelpersGame_Main__["a" /* default */] };
    Games.TicketTaker = { id: 41, name: "TicketTaker", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].PreK, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].E, component: __WEBPACK_IMPORTED_MODULE_36_src_games_TicketTakerGame_Main__["a" /* default */] };
    Games.GroceryBagger = { id: 42, name: "GroceryBagger", grade: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].PreK, planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C, component: __WEBPACK_IMPORTED_MODULE_38_src_games_GroceryBaggerGame_Main__["a" /* default */] };
    Games.All = [
        Games.Landscaping,
        Games.Diagnosis,
        Games.Collage,
        Games.JobMatching,
        Games.Colony,
        Games.PuzzleSlider,
        Games.Plumbing,
        Games.University,
        Games.Paint,
        Games.Diner,
        Games.CareerFair,
        Games.OrganizeDesk,
        Games.DiseasedTrees,
        Games.XRay,
        Games.DesertTerraform,
        Games.FitFive,
        Games.HotelAurora,
        Games.Warehouse,
        Games.RocketRepair,
        Games.ProgramRobot,
        Games.ShipPainting,
        Games.JigsawPuzzle,
        Games.SpacePort,
        Games.MailDelivery,
        Games.SpacePets,
        Games.OceanCleanup,
        Games.CityBuilder,
        Games.UniformDesign,
        Games.SeekAndFind,
        Games.GroceryBagger,
        Games.VendingMachine,
        Games.FindHelpers,
        Games.TicketTaker,
        Games.FacePainting,
        Games.FossilFinder,
        Games.CakeDecorating,
        Games.Starball,
        Games.Librarian,
        Games.Zoo,
        Games.WaiterMemory,
        Games.RideMechanic,
        Games.ConstructionMaze,
    ];
    return Games;
}());



/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Color; });
var Color = /** @class */ (function () {
    function Color(key, value) {
        this.key = key;
        this.value = value;
    }
    Color.colorDictionary = [
        new Color("red", 0xd32815),
        new Color("blue", 0x315ad6),
        new Color("green", 0x2cd657),
        new Color("yellow", 0xfbff30),
        new Color("orange", 0xe89025),
        new Color("purple", 0xa325d1),
        new Color("teal", 0x36dbdb),
        new Color("pink", 0xf442d7),
        new Color("black", 0x000000),
        new Color("white", 0xffffff),
        new Color("light grey", 0xb3b7b7),
        new Color("grey", 0x6e6a70),
        new Color("alien_blood", 0x41f495),
    ];
    /**
     * Map that can be used to look up a color by it's name: ColorValue.COLORS.get("red")
     */
    Color.COLORS = new Map(Color.colorDictionary.map(function (x) { return [x.key, x.value]; }));
    // Designated planet colors
    Color.planetColors = [
        new Color("R", 0x00de0e),
        new Color("I", 0x0033cc),
        new Color("A", 0x9500ca),
        new Color("S", 0xff0700),
        new Color("E", 0xffae00),
        new Color("C", 0xedfd00),
    ];
    Color.PLANET_COLORS = new Map(Color.planetColors.map(function (x) { return [x.key, x.value]; }));
    Color.DIALOG_TEXT_COLOR = 0xF8E71C;
    Color.KUDER_PRIMARY = 0x6ec213;
    Color.KUDER_SECONDARY = 0x1e91d6;
    Color.KUDER_PRIMARY_BUTTON = 0x51821C;
    Color.KUDER_SECONDARY_BUTTON = 0x2A7DA7;
    return Color;
}());



/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_configuration__ = __webpack_require__(789);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return __WEBPACK_IMPORTED_MODULE_0__domain_configuration__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__domain_configuration__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return __WEBPACK_IMPORTED_MODULE_0__domain_configuration__["f"]; });
/* unused harmony reexport INTAKE_SITE_AP1 */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__domain_configuration__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__domain_configuration__["d"]; });
/* unused harmony reexport INTAKE_SITE_US1_FED */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__domain_configuration__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_experimentalFeatures__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_1__tools_experimentalFeatures__["d"]; });
/* unused harmony reexport addExperimentalFeatures */
/* unused harmony reexport resetExperimentalFeatures */
/* unused harmony reexport getExperimentalFeatures */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__tools_experimentalFeatures__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_error_trackRuntimeError__ = __webpack_require__(1951);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return __WEBPACK_IMPORTED_MODULE_2__domain_error_trackRuntimeError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_tracekit__ = __webpack_require__(274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_3__domain_tracekit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__boot_init__ = __webpack_require__(1953);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_4__boot_init__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_4__boot_init__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_report_reportObservable__ = __webpack_require__(1954);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_5__domain_report_reportObservable__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__domain_report_reportObservable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_telemetry__ = __webpack_require__(793);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return __WEBPACK_IMPORTED_MODULE_6__domain_telemetry__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_6__domain_telemetry__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_6__domain_telemetry__["c"]; });
/* unused harmony reexport startFakeTelemetry */
/* unused harmony reexport resetTelemetry */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_6__domain_telemetry__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_6__domain_telemetry__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_monitor__ = __webpack_require__(125);
/* unused harmony reexport monitored */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_7__tools_monitor__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_7__tools_monitor__["a"]; });
/* unused harmony reexport setDebugMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tools_observable__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_8__tools_observable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_session_sessionManager__ = __webpack_require__(1957);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return __WEBPACK_IMPORTED_MODULE_9__domain_session_sessionManager__["a"]; });
/* unused harmony reexport stopSessionManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_session_sessionConstants__ = __webpack_require__(273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_10__domain_session_sessionConstants__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transport__ = __webpack_require__(1958);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_11__transport__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_11__transport__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_11__transport__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_11__transport__["e"]; });
/* unused harmony reexport startBatchWithReplica */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_11__transport__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tools_display__ = __webpack_require__(109);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_12__tools_display__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_12__tools_display__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tools_utils_urlPolyfill__ = __webpack_require__(356);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_13__tools_utils_urlPolyfill__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_13__tools_utils_urlPolyfill__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_13__tools_utils_urlPolyfill__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_13__tools_utils_urlPolyfill__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return __WEBPACK_IMPORTED_MODULE_14__tools_utils_timeUtils__["o"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tools_utils_arrayUtils__ = __webpack_require__(1962);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__tools_serialisation_sanitize__ = __webpack_require__(358);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return __WEBPACK_IMPORTED_MODULE_16__tools_serialisation_sanitize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tools_getGlobalObject__ = __webpack_require__(352);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_17__tools_getGlobalObject__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__tools_abstractLifeCycle__ = __webpack_require__(1963);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_18__tools_abstractLifeCycle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__domain_eventRateLimiter_createEventRateLimiter__ = __webpack_require__(1964);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_19__domain_eventRateLimiter_createEventRateLimiter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__tools_utils_browserDetection__ = __webpack_require__(790);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_20__tools_utils_browserDetection__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__tools_sendToExtension__ = __webpack_require__(794);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return __WEBPACK_IMPORTED_MODULE_21__tools_sendToExtension__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__browser_runOnReadyState__ = __webpack_require__(1965);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return __WEBPACK_IMPORTED_MODULE_22__browser_runOnReadyState__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__tools_getZoneJsOriginalValue__ = __webpack_require__(497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_23__tools_getZoneJsOriginalValue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__tools_instrumentMethod__ = __webpack_require__(357);
/* unused harmony reexport instrumentMethod */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_24__tools_instrumentMethod__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_24__tools_instrumentMethod__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__domain_error_error__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_25__domain_error_error__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_25__domain_error_error__["c"]; });
/* unused harmony reexport toStackTraceString */
/* unused harmony reexport getFileFromStackTraceString */
/* unused harmony reexport NO_ERROR_STACK_PRESENT_MESSAGE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__browser_cookie__ = __webpack_require__(353);
/* unused harmony reexport areCookiesAuthorized */
/* unused harmony reexport getCookie */
/* unused harmony reexport setCookie */
/* unused harmony reexport deleteCookie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__browser_xhrObservable__ = __webpack_require__(1966);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_27__browser_xhrObservable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__browser_fetchObservable__ = __webpack_require__(1967);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_28__browser_fetchObservable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__browser_pageExitObservable__ = __webpack_require__(800);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_29__browser_pageExitObservable__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_29__browser_pageExitObservable__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_29__browser_pageExitObservable__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__browser_addEventListener__ = __webpack_require__(220);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_30__browser_addEventListener__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_30__browser_addEventListener__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__tools_timer__ = __webpack_require__(150);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_31__tools_timer__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_31__tools_timer__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return __WEBPACK_IMPORTED_MODULE_31__tools_timer__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return __WEBPACK_IMPORTED_MODULE_31__tools_timer__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__domain_console_consoleObservable__ = __webpack_require__(1968);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_32__domain_console_consoleObservable__["a"]; });
/* unused harmony reexport resetConsoleObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__tools_boundedBuffer__ = __webpack_require__(1969);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_33__tools_boundedBuffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__tools_catchUserErrors__ = __webpack_require__(495);
/* unused harmony reexport catchUserErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__tools_serialisation_contextManager__ = __webpack_require__(1970);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_35__tools_serialisation_contextManager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__tools_serialisation_heavyCustomerDataWarning__ = __webpack_require__(802);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return __WEBPACK_IMPORTED_MODULE_36__tools_serialisation_heavyCustomerDataWarning__["a"]; });
/* unused harmony reexport CUSTOMER_DATA_BYTES_LIMIT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__tools_valueHistory__ = __webpack_require__(796);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_37__tools_valueHistory__["a"]; });
/* unused harmony reexport CLEAR_OLD_VALUES_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__tools_readBytesFromStream__ = __webpack_require__(1971);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_38__tools_readBytesFromStream__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__domain_session_sessionStore__ = __webpack_require__(496);
/* unused harmony reexport STORAGE_POLL_DELAY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__domain_session_storeStrategies_sessionStoreStrategy__ = __webpack_require__(354);
/* unused harmony reexport SESSION_STORE_KEY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__domain_synthetics_syntheticsWorkerValues__ = __webpack_require__(1972);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return __WEBPACK_IMPORTED_MODULE_41__domain_synthetics_syntheticsWorkerValues__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_41__domain_synthetics_syntheticsWorkerValues__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_41__domain_synthetics_syntheticsWorkerValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__domain_user__ = __webpack_require__(1973);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_42__domain_user__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return __WEBPACK_IMPORTED_MODULE_42__domain_user__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__domain_resourceUtils__ = __webpack_require__(1976);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__ = __webpack_require__(93);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return __WEBPACK_IMPORTED_MODULE_44__tools_utils_polyfills__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__tools_utils_numberUtils__ = __webpack_require__(350);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_45__tools_utils_numberUtils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_45__tools_utils_numberUtils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_45__tools_utils_numberUtils__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_45__tools_utils_numberUtils__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__tools_utils_byteUtils__ = __webpack_require__(218);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_46__tools_utils_byteUtils__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__tools_utils_objectUtils__ = __webpack_require__(351);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_47__tools_utils_objectUtils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_47__tools_utils_objectUtils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_47__tools_utils_objectUtils__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return __WEBPACK_IMPORTED_MODULE_47__tools_utils_objectUtils__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__tools_utils_functionUtils__ = __webpack_require__(185);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_48__tools_utils_functionUtils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return __WEBPACK_IMPORTED_MODULE_48__tools_utils_functionUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__tools_serialisation_jsonStringify__ = __webpack_require__(186);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_49__tools_serialisation_jsonStringify__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__tools_mergeInto__ = __webpack_require__(499);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_50__tools_mergeInto__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_50__tools_mergeInto__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__tools_utils_stringUtils__ = __webpack_require__(219);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_51__tools_utils_stringUtils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_51__tools_utils_stringUtils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return __WEBPACK_IMPORTED_MODULE_51__tools_utils_stringUtils__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__tools_matchOption__ = __webpack_require__(1977);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_52__tools_matchOption__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_52__tools_matchOption__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__tools_utils_responseUtils__ = __webpack_require__(798);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return __WEBPACK_IMPORTED_MODULE_53__tools_utils_responseUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__tools_utils_typeUtils__ = __webpack_require__(360);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_54__tools_utils_typeUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__domain_error_error_types__ = __webpack_require__(359);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_55__domain_error_error_types__["a"]; });
























































//# sourceMappingURL=index.js.map

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid_style_index_less__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid_style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__grid_style_index_less__);



/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid_style_index_less__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid_style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__grid_style_index_less__);



/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Routes = /** @class */ (function () {
    function Routes() {
    }
    /**
     * Returns a path with params injected into URL parameters. Params are injected into the path in the order they are specified.
     *
     * @param path The path to inject params into.
     * @param params Values to inject into path.
     */
    Routes.getRoute = function (path) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        if (typeof path !== 'string') {
            console.error('Path: "' + path + '" is not a string.');
            return;
        }
        var result = '';
        var startIndex = 0;
        var endIndex = 0;
        var i = 0;
        var length = params.length;
        for (i = 0; i < length; ++i) {
            endIndex = path.indexOf(':', startIndex);
            if (endIndex === -1) {
                if (result) {
                    break;
                }
                return path;
            }
            result += path.substring(startIndex, endIndex) + params[i];
            startIndex = path.indexOf('/', endIndex);
            if (startIndex === -1) {
                startIndex = path.length;
            }
        }
        endIndex = path.indexOf(':', startIndex);
        for (i = 0; endIndex > -1; ++i) {
            startIndex = path.indexOf('?', endIndex);
            if (startIndex === -1) {
                console.error('Length of params "' + params + '" does not match number of parameters in "' + path + '".');
                return;
            }
            endIndex = path.indexOf(':', startIndex);
        }
        if (startIndex !== path.length && i === 0) {
            result += path.substring(startIndex);
        }
        return result;
    };
    /* Until we get a better solution, please keep these somewhat organized */
    /* General */
    Routes.BASE_ROUTE = '/';
    Routes.LOGIN = '/login';
    Routes.LOGOUT = '/logout';
    Routes.FORGOT_PASSWORD = '/forgot-password';
    Routes.RESET_PASSWORD = '/reset-password/:userId/:resetPasswordId';
    Routes.ACCOUNT = '/account';
    Routes.STATEMENTS = '/statements';
    Routes.EDIT_STATEMENT = '/statements/:statementId';
    Routes.PARENTS_HOME = '/parents';
    Routes.PARENTS = '/parents/:gradeId';
    Routes.PARENTS_OBJECTIVES = '/parents/:gradeId/objectives';
    Routes.PARENTS_PLANET = '/parents/:gradeId/:planet';
    Routes.TRAINING_AND_EDUCATION_GUIDE = '/training-and-education-guide';
    Routes.HOLLAND_AREAS_GUIDE = '/holland-areas-guide';
    Routes.OCCUPATIONDB = '/occupationdb';
    Routes.OCCUPATION = '/occupation/:id';
    Routes.REGISTER = '/register';
    Routes.REGISTERAFL = '/register-afl';
    Routes.WHO_AM_I = '/whoami';
    Routes.DIAGNOSTICS = '/diagnostics';
    /* Error Handling */
    Routes.ERROR_PAGE = '/the-handler';
    Routes.PROD_ERROR_PAGE = '/errors';
    Routes.PAGE_NOT_FOUND = '/404';
    /* Examples */
    Routes.EXAMPLE_HOME = '/example';
    Routes.EXAMPLE_REDUX = '/example/redux';
    Routes.EXAMPLE_MULTILINGUAL = '/example/multilingual';
    Routes.EXAMPLES_VIDEO = '/example/video';
    Routes.EXAMPLES_FORM = '/example/form';
    /* Admin */
    Routes.ADMIN_OCCUPATIONDB = '/admin/occupationdb';
    Routes.ADMIN_OCCUPATION = '/admin/occupation/:id';
    Routes.ADMIN_USERS = '/admin/users/:isAdminTable';
    Routes.ADMIN_MATCHMAKER = '/admin/matchmaker';
    Routes.ADMIN_SYNC_MATCHMAKER_DATA = '/admin/sync-matchmaker-data';
    Routes.ADMIN_ADD_EDIT_USER = '/admin/add-edit-user/:classroomId/:userId/:isAdmin';
    Routes.ADMIN_AUDIO = '/admin/audio';
    Routes.ADMIN_TEST = '/admin/test/:id';
    Routes.ADMIN_CLIENTS = '/admin/clients';
    Routes.ADMIN_ADD_EDIT_CLIENT = '/admin/add-edit-client/:id';
    Routes.ADMIN_ADD_EDIT_CLIENT_SUBSCRIPTION = '/admin/add-edit-client-subscription/:clientId/:clientSubscriptionId';
    Routes.ADMIN_STATEMENTS = '/admin/statements';
    Routes.ADMIN_STUDENT_STATEMENTS = '/admin/student-statements/:classroomId/:userId';
    Routes.ADMIN_ADD_EDIT_STATEMENT = '/admin/add-edit-statement/:id';
    Routes.ADMIN_DISTRICTS = '/admin/districts/';
    Routes.ADMIN_ADD_EDIT_DISTRICT = '/admin/add-edit-district/:id';
    Routes.ADMIN_SYNC_MANAGEMENT = '/admin/sync-management';
    Routes.ADMIN_SCHOOLS = '/admin/schools/';
    Routes.ADMIN_ADD_EDIT_SCHOOL = '/admin/add-edit-school/:id';
    Routes.ADMIN_ACTIVITIES = '/admin/activities/';
    Routes.ADMIN_ADD_EDIT_ACTIVITY = '/admin/add-edit-activity/:id';
    Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION = '/admin/add-edit-activity-question/:activityId/:activityQuestionId';
    Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION_CATEGORY = '/admin/add-edit-activity-question-category/:activityId/:activityQuestionCategoryId';
    Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION_RESPONSE = '/admin/add-edit-activity-question-response/:activityId/:activityQuestionId/:activityQuestionResponseId';
    Routes.ADMIN_MULTILINGUAL = '/admin/multilingual';
    Routes.ADMIN_CLASSROOMS = '/admin/classrooms/';
    Routes.ADMIN_ADD_EDIT_CLASSROOM = '/admin/add-edit-classroom/:id';
    Routes.ADMIN_ACADEMICS = '/admin/academics/';
    Routes.ADMIN_ADD_EDIT_ACADEMIC_STANDARD = '/admin/add-edit-academic-standard/:id';
    Routes.ADMIN_ADD_EDIT_ACADEMIC_STANDARD_FRAMEWORK = '/admin/add-edit-academic-standard-framework/:id';
    Routes.ADMIN_RESET_PASSWORD = '/admin-reset-password/:classroomId/:userId/:isAdmin';
    Routes.ADMIN_REPORTS = '/admin/reports';
    Routes.ADMIN_REPORT_STUDENT_ACTIVITY_DETAIL = '/admin/reports/student-activity-detail';
    Routes.ADMIN_REPORT_STUDENT_PLANET_COMPLETION = '/admin/reports/student-planet-completion';
    Routes.ADMIN_REPORT_STUDENT_GAME_COMPLETION = '/admin/reports/student-game-completion';
    Routes.ADMIN_REPORT_STUDENT_STATEMENT = '/admin/reports/student-statement';
    Routes.ADMIN_SYNC_RESULTS = '/admin/sync-results/:id/:districtId';
    Routes.ADMIN_ADD_EDIT_ACTIVITY_SUMMARY = "/admin/add-edit-activity-summary/:activityId/:activitySummaryId";
    Routes.ADMIN_STUDENT_VIEWS = '/admin/studentViews';
    Routes.ADMIN_RESOURCES = '/admin/resources';
    Routes.ADMIN_LESSON_PLANS = '/admin/lesson-plans';
    Routes.ADMIN_EMULATE_USER = '/admin/emulate';
    Routes.ADMIN_REPORT_CLASSROOM = '/admin/reports/classroom/:classroomId';
    Routes.ADMIN_REPORT_PRINCIPAL = '/admin/reports/principal/';
    Routes.ADMIN_REPORT_SUPERINTENDENT = '/admin/reports/superintendent/';
    Routes.ADMIN_HOLLAND_AREAS_GUIDE = '/admin/holland-areas-guide';
    /* Universal User Search */
    Routes.ADMIN_UNIVERSAL_USER_SEARCH = '/admin/universal-user-search';
    Routes.ADMIN_UNIVERSAL_USER_SEARCH_STUDENT_STATEMENTS = '/admin/universal-user-search/student-statements/:userId';
    Routes.ADMIN_UNIVERSAL_USER_SEARCH_ADD_EDIT_USER = '/admin/universal-user-search/add-edit-user/:userId';
    Routes.ADMIN_UNIVERSAL_USER_SEARCH_RESET_PASSWORD = '/admin/universal-user-search/admin-reset-password/:userId';
    /* Student */
    Routes.STUDENT_HOME = '/student/'; // Spacestation
    Routes.STUDENT_PLANET = '/student/planet'; // Planet pages
    Routes.STUDENT_RETURN = '/student/return';
    /* Mission */
    Routes.MISSION_SPACE_STATION = '/mission/:gradeId/space-station';
    Routes.MISSION_PLANET = '/mission/:gradeId/planet';
    Routes.MISSION_GAME = '/mission/:gradeId/game';
    Routes.MISSION_ACTIVITY = '/mission/:gradeId/activity';
    Routes.MISSION_CONCLUSION = '/mission/:gradeId/conclusion';
    /* Game Demos */
    Routes.GAMEDEMO_PHASER_DEMO = '/gameDemo/phaserDemo';
    Routes.GAMEDEMO_PHASER_DRAGDROP_DEMO = '/gameDemo/phaserDragDrop';
    Routes.GAMEDEMO_PHASER_PAINT_DEMO = '/gameDemo/phaserPaint';
    Routes.GAMEDEMO_PHASER_PLATFORMER_DEMO = '/gameDemo/phaserPlatformer';
    Routes.GAMEDEMO_PHASER_ANIMATION_DEMO = '/gameDemo/phaserAnimation';
    Routes.GAMEDEMO_PATH_FINDING_DEMO = '/gameDemo/pathFindingDemo';
    Routes.GAMEDEMO_IMAGE_PASTING_DEMO = '/gameDemo/imagePastingDemo';
    Routes.GAMEDEMO_MULTI_SCENE_DEMO = '/gameDemo/phaserMultiSceneDemo';
    Routes.GAMEDEMO_CAMERA_ANIMATION_DEMO = '/gameDemo/phaserCameraAnimationDemo';
    Routes.GAMEDEMO_GAMEPAD_TEST = '/gameDemo/gamePadDemo';
    Routes.GAMEDEMO_MODAL_BUTTON_DEMO = '/gameDemo/modalButtonDemo';
    Routes.GAMEDEMO_NPC_FOLLOWING_DEMO = '/gameDemo/npcFollowingDemo';
    Routes.GAMEDEMO_LANDSCAPING = '/game/old-grade5-r';
    Routes.GAMEDEMO_HOW_TO_PLAY_SCENE = '/game/howToPlayScene';
    /* Games */
    Routes.GAME_HOME = '/game/';
    Routes.GAME_GRADE_5_R = '/game/grade5-r'; // landscaping
    Routes.DIAGNOSIS_GAME = '/game/diagnosisGame';
    Routes.COLLAGE_GAME = '/game/collageGame';
    Routes.GAME_GRADE_5_S = '/game/grade5-s'; // JobMatching
    Routes.COLONY_GAME = '/game/colonyGame';
    Routes.PUZZLE_SLIDER = '/game/puzzleSlider';
    Routes.PLUMBING_PLATFORMER = '/game/grade4-r';
    Routes.GAME_GRADE_4_I = '/game/grade4-i'; //universityGame
    Routes.PHASER_PAINT_GAME = '/game/grade4-a';
    Routes.GAME_GRADE_4_S = '/game/grade4-s'; // dinner_dash
    Routes.GAME_GRADE_4_E = '/game/grade4-e'; // CareerFair
    Routes.ORGANIZE_DESK_GAME = '/game/grade4-c';
    Routes.DISEASED_TREES_GAME = '/game/diseasedTreesGame';
    Routes.XRAY_SLIDER = '/game/xraySlider';
    Routes.GAME_GRADE_3_A = '/game/grade3-a'; // Terraforming
    Routes.FIT_FIVE_GAME = '/game/fitFiveGame';
    Routes.HOTEL_AURORA_GAME = '/game/hotelAuroraGame';
    Routes.WAREHOUSE_GAME = '/game/warehouseGame';
    Routes.MAIL_DELIVERY = "/game/mailDelivery";
    Routes.PROGRAM_ROBOT = '/game/programRobot';
    Routes.ROCKET_REPAIR = "/game/rocketRepair";
    Routes.JIGSAW_PUZZLE = '/game/jigsawPuzzle';
    Routes.SHIP_PAINTING = '/game/shipPainting';
    Routes.SPACE_PORT = '/game/spacePort';
    Routes.SEEK_AND_FIND = '/game/seekAndFind';
    Routes.CITY_BUILDER = '/game/cityBuilder';
    Routes.VENDING_MACHINE = '/game/vendingMachine';
    Routes.SPACE_PETS = '/game/spacePets';
    Routes.OCEAN_CLEANUP = '/game/oceanCleanup';
    Routes.CAKE_DECORATING = '/game/cakeDecorating';
    Routes.UNIFORM_DESIGN = '/game/uniformDesign';
    Routes.FIND_HELPERS = '/game/findHelpers';
    Routes.TICKET_TAKER = '/game/ticketTaker';
    Routes.ZOO = '/game/zoo';
    Routes.CONSTRUCTION_MAZE = '/game/constructionMaze';
    Routes.STARBALL = '/game/starball';
    Routes.LIBRARIAN = '/game/librarian';
    Routes.WAITER_MEMORY = '/game/waiterMemory';
    Routes.RIDE_MECHANIC = '/game/rideMechanic';
    Routes.FOSSIL_FINDER = '/game/fossilFinder';
    Routes.FACE_PAINTING = '/game/facePainting';
    Routes.GROCERY_BAGGER = '/game/groceryBagger';
    return Routes;
}());
/* harmony default export */ __webpack_exports__["a"] = (Routes);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Config__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_DebugUtil__ = __webpack_require__(87);



var AudioTranslations = /** @class */ (function () {
    function AudioTranslations() {
    }
    AudioTranslations.FindByKeyAndLanguage = function (key, languageCode) {
        if (__WEBPACK_IMPORTED_MODULE_2_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
            console.warn("Language Key", key); // JB - Remove this console.warn
        }
        var languageCodeEnhanced = languageCode.toLowerCase();
        var url = __WEBPACK_IMPORTED_MODULE_1_src_constants_Config__["a" /* default */].GetAzureUrl(key, "audio", languageCodeEnhanced);
        return {
            key: key,
            language: __WEBPACK_IMPORTED_MODULE_0_src_constants_Languages__["a" /* default */].FindByCode(languageCodeEnhanced),
            url: url,
        };
    };
    AudioTranslations.FindByKey = function (key) {
        // Assume we want the current language
        var language = __WEBPACK_IMPORTED_MODULE_0_src_constants_Languages__["a" /* default */].GetActiveLanguage();
        return this.FindByKeyAndLanguage(key, language.code);
    };
    return AudioTranslations;
}());
/* harmony default export */ __webpack_exports__["a"] = (AudioTranslations);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PhaserButtonConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhaserButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var PhaserButtonConfig = /** @class */ (function () {
    function PhaserButtonConfig() {
        this.backgroundColor = __WEBPACK_IMPORTED_MODULE_1__ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        this.smartSize = false;
        this.smartHeight = false;
    }
    PhaserButtonConfig.BackButtonConfig = {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_1__ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON,
        smartSize: true,
        smartHeight: true,
        keyMapping: "keydown_LEFT"
    };
    PhaserButtonConfig.NextButtonConfig = {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_1__ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON,
        smartSize: true,
        smartHeight: true,
        keyMapping: "keydown_RIGHT"
    };
    return PhaserButtonConfig;
}());

var PhaserButton = /** @class */ (function (_super) {
    __extends(PhaserButton, _super);
    function PhaserButton(scene, x, y, width, height, text, config) {
        var _this = _super.call(this, scene, x, y) || this;
        _this.padding = 10;
        _this.width = width;
        _this.height = height;
        _this.config = config;
        _this.text = text;
        if (config == null) {
            _this.config = new PhaserButtonConfig();
        }
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserButton.prototype);
        _this.initialize(_this.width, _this.height);
        return _this;
    }
    PhaserButton.createQuickNextButton = function (scene, x, y) {
        var button = new PhaserButton(scene, x, y, 300, 100, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("common.next"), PhaserButtonConfig.NextButtonConfig);
        return button;
    };
    PhaserButton.createQuickBackButton = function (scene, x, y) {
        var button = new PhaserButton(scene, x, y, 200, 100, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("common.back"), PhaserButtonConfig.BackButtonConfig);
        return button;
    };
    PhaserButton.preload = function (scene) {
        scene.load.image("pixel", __webpack_require__(60));
    };
    PhaserButton.prototype.initialize = function (width, height) {
        // Set size
        this.setSize(width, height);
        // Construct Objects
        this.constructObjects();
        this.type = "PhaserButton";
        // Add this modal to the scene
        this.scene.add.existing(this);
    };
    PhaserButton.prototype.constructObjects = function () {
        var _this = this;
        if (this.text != null) {
            // Button text
            this.textObject = this.scene.add.text(0, 0, this.text);
            this.textObject.setSize(this.width, this.height);
            this.textObject.setFontSize(18);
            this.textObject.setTint(0xffffff);
            this.textObject.setFontFamily('Russo One, Arial');
            this.textObject.setWordWrapWidth(this.width - 2 * this.padding, true);
            this.textObject.setAlign('center');
            this.textObject.setScrollFactor(0);
            // Center text to the background
            this.textObject.setOrigin(0.5);
            this.textObject.setPosition(this.width / 2, this.height / 2);
        }
        if (this.config.smartSize) {
            this.width = this.getIdealButtonWidth();
            this.height = this.getIdealButtonHeight();
            this.textObject.setPosition(this.width / 2, this.height / 2);
        }
        else if (this.config.smartHeight) {
            this.height = this.getIdealButtonHeight();
            this.textObject.setPosition(this.width / 2, this.height / 2);
        }
        // Border of the button
        this.border = this.scene.add.image(-5, -5, "pixel");
        this.border.setOrigin(0, 0);
        this.border.setDisplaySize(this.width + this.padding, this.height + this.padding);
        this.border.setTint(0x000000);
        this.border.setInteractive({ useHandCursor: true });
        this.border.setScrollFactor(0);
        // Background of the button
        this.backgroundObject = this.scene.add.image(0, 0, "pixel");
        this.backgroundObject.setOrigin(0, 0);
        this.backgroundObject.setDisplaySize(this.width, this.height);
        this.backgroundObject.setTint(this.config.backgroundColor);
        this.backgroundObject.setInteractive({ useHandCursor: true });
        this.backgroundObject.setScrollFactor(0);
        // Button on click event emits a buttonClicked event (sends pointer, x, and y)
        this.backgroundObject.on('pointerdown', function (pointer, x, y) {
            if (_this.text != null) {
                _this.emit('buttonClicked', pointer, x, y, _this.textObject.text);
            }
            else {
                _this.emit('buttonClicked', pointer, x, y);
            }
        });
        if (this.config.keyMapping != null && this.backgroundObject.input.enabled) {
            this.scene.input.keyboard.on(this.config.keyMapping, function () {
                _this.emit('buttonClicked', _this.textObject.text);
            });
        }
        this.add(this.border);
        this.add(this.backgroundObject);
        this.add(this.textObject);
    };
    PhaserButton.prototype.getIdealButtonHeight = function () {
        // Ideal button height would be the height of the actual text object
        return this.textObject.getBounds().height + 30;
    };
    PhaserButton.prototype.getIdealButtonWidth = function () {
        // Ideal button width would be the width of the actual text object
        return this.textObject.getBounds().width + 2 * this.padding + 15;
    };
    PhaserButton.prototype.setDisplaySize = function (width, height) {
        this.setSize(width, height);
        this.backgroundObject.setDisplaySize(width, height);
        this.border.setDisplaySize(width + this.padding, height + this.padding);
        // Center text to the background
        this.textObject.setOrigin(0.5);
        this.textObject.setWordWrapWidth(width - 2 * this.padding, true);
        this.textObject.setPosition(width / 2, height / 2);
        return this;
    };
    /**
     * Dynamically change the button text by setting the textObject text
     */
    PhaserButton.prototype.setText = function (text) {
        this.textObject.setText(text);
    };
    PhaserButton.prototype.setEnabled = function (enabled) {
        this.backgroundObject.input.enabled = enabled;
    };
    PhaserButton.prototype.getBackground = function () {
        return this.backgroundObject;
    };
    PhaserButton.prototype.isEnabled = function () {
        return this.backgroundObject.input.enabled;
    };
    return PhaserButton;
}(Phaser.GameObjects.Container));



/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var defaultConfig = {
    title: "Generic Phaser Game",
    version: "0.0.1-Pre Alpha",
    width: 1360,
    height: 768,
    type: Phaser.AUTO,
    parent: "phaser-game-parent",
    input: {
        keyboard: true,
        mouse: true,
        touch: true,
        gamepad: true
    },
    backgroundColor: "#000000",
    "render.pixelArt": true,
};
var PhaserGameComponent = /** @class */ (function (_super) {
    __extends(PhaserGameComponent, _super);
    function PhaserGameComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.game = null;
        _this.config = null;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserGameComponent.prototype);
        _this.state = {
            fooStyle: {}
        };
        return _this;
    }
    PhaserGameComponent.prototype.componentDidMount = function () {
        if (this.game == null) {
            this.config = __assign(__assign(__assign({}, defaultConfig), this.props.config), { scene: this.props.scenes });
            if (!this.props.Config.audioEnabled) {
                console.warn("Audio is disabled"); // JB - Remove this console.warn
                this.config = __assign(__assign({}, this.config), { audio: { noAudio: true } });
            }
            this.game = new Phaser.Game(this.config);
            this.game.onComplete = this.props.onComplete;
        }
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    };
    PhaserGameComponent.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.updateDimensions);
        this.game.destroy(true);
        this.game = null;
    };
    PhaserGameComponent.prototype.updateDimensions = function () {
        var PADDING_OFFSET = 0;
        var HEADER_OFFSET = 100;
        var FOOTER_OFFSET = 32; // More of a button offset
        var cool = this.calculateAspectRatioFit(1360, 768, window.innerWidth - (PADDING_OFFSET * 2), window.innerHeight - PADDING_OFFSET - FOOTER_OFFSET - HEADER_OFFSET);
        this.setState({
            fooStyle: __assign({}, cool)
        });
    };
    PhaserGameComponent.prototype.calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight) {
        var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        return { width: srcWidth * ratio, height: srcHeight * ratio };
    };
    PhaserGameComponent.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "phaser-game-parent", style: this.state.fooStyle });
    };
    return PhaserGameComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        Config: state.Config,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(PhaserGameComponent));


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_style__ = __webpack_require__(19);


// style dependencies


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroBaseScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_GameIntroTextBox__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_utils_ConfigUtil__ = __webpack_require__(513);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var GameIntroBaseScene = /** @class */ (function (_super) {
    __extends(GameIntroBaseScene, _super);
    function GameIntroBaseScene() {
        var _this = _super.call(this, {
            key: "GameIntroScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        // To be filled by child class
        _this.introTextKeys = [];
        _this.howToPlayScene = null;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_5_src_constants_Games__["a" /* Games */].Default;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, GameIntroBaseScene.prototype);
        return _this;
    }
    GameIntroBaseScene.prototype.preload = function () {
        var _this = this;
        // This is a "generic" base class and we should sanity check the required conditions are met before proceeding
        if (this.gameRef === __WEBPACK_IMPORTED_MODULE_5_src_constants_Games__["a" /* Games */].Default) {
            throw new Error("GameIntroBaseScene: GameRef has not been initialized");
        }
        if (this.howToPlayScene == null) {
            throw new Error("GameIntroBaseScene: HowToPlayScene has not been initialized");
        }
        if (this.introTextKeys.length < 1) {
            throw new Error("GameIntroBaseScene: IntroTextKeys have not been initialized");
        }
        // Catch load errors here
        this.load.on("loaderror", function (file) {
            console.error("File load error: " + file.key);
            // Audio file missed, load blank audio as it *should* always exist
            if (file.type === "audio") {
                _this.load.audio(file.key, __webpack_require__(514));
            }
        });
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        // Loading only the needed terrain
        switch (this.gameRef.planet) {
            case __WEBPACK_IMPORTED_MODULE_6_src_constants_Planets__["a" /* Planets */].R: {
                this.load.image('terrain', __webpack_require__(367));
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_6_src_constants_Planets__["a" /* Planets */].I: {
                this.load.image('terrain', __webpack_require__(368));
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_6_src_constants_Planets__["a" /* Planets */].A: {
                this.load.image('terrain', __webpack_require__(853));
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_6_src_constants_Planets__["a" /* Planets */].S: {
                this.load.image('terrain', __webpack_require__(515));
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_6_src_constants_Planets__["a" /* Planets */].E: {
                this.load.image('terrain', __webpack_require__(854));
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_6_src_constants_Planets__["a" /* Planets */].C: {
                this.load.image('terrain', __webpack_require__(369));
                break;
            }
        }
        // Load the NPC
        // JB: I wanted this to be offset for grades next to each other, so 1R would be different from 2R, like an offset matrix
        var mustard = (this.gameRef.grade.level + this.gameRef.planet.order) % 3; // 3 is how many aliens we have
        switch (mustard) {
            case 0:
                this.load.image("npc", __webpack_require__(287));
                break;
            case 1:
                this.load.image("npc", __webpack_require__(168));
                break;
            case 2:
            default:
                this.load.image("npc", __webpack_require__(155));
                break;
        }
        this.introTextKeys.forEach(function (key) {
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_3_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    GameIntroBaseScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "outro-map" });
        if (GameIntroBaseScene.StartFromEnd) {
            this.index = this.introTextKeys.length - 1;
        }
        else {
            this.index = 0;
        }
        // Sound management
        this.runSoundEngine();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.box = ob;
                var config = {
                    padding: 20,
                    fontSize: 20,
                    hollandCode: _this.gameRef.planet.name.toLowerCase(),
                    translationKey: _this.introTextKeys[_this.index],
                    onBack: _this.back,
                    onNext: _this.next,
                };
                _this.textBox = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_GameIntroTextBox__["a" /* GameIntroTextBox */](_this, ob, config);
                if (GameIntroBaseScene.StartFromEnd) {
                    _this.textBox.backButton.setVisible(true);
                    _this.textBox.nextButton.getBackground().setTint(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY);
                }
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
        // Reset the static StartFromEnd because it's not being nice
        GameIntroBaseScene.StartFromEnd = false;
    };
    GameIntroBaseScene.prototype.runSoundEngine = function () {
        this.sound.stopAll();
        if (!__WEBPACK_IMPORTED_MODULE_7_src_utils_ConfigUtil__["a" /* default */].AudioEnabled) {
            return;
        }
        this.sound.add(this.introTextKeys[this.index]).play();
    };
    GameIntroBaseScene.prototype.next = function () {
        this.sound.stopAll();
        if (this.index === this.introTextKeys.length - 1) {
            this.scene.remove(this);
            this.scene.add("HowToPlayScene", this.howToPlayScene, true);
        }
        else {
            this.index++;
            this.updateTextBox();
        }
    };
    GameIntroBaseScene.prototype.back = function () {
        if (this.index === 0) {
            return;
        }
        else {
            this.sound.stopAll();
            this.index--;
            this.updateTextBox();
        }
    };
    GameIntroBaseScene.prototype.updateTextBox = function () {
        this.textBox.destroy();
        var config = {
            padding: 20,
            fontSize: 20,
            hollandCode: this.gameRef.planet.name.toLowerCase(),
            translationKey: this.introTextKeys[this.index],
            onBack: this.back,
            onNext: this.next,
        };
        this.textBox = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_GameIntroTextBox__["a" /* GameIntroTextBox */](this, this.box, config);
        this.textBox.backButton.visible = this.index > 0;
        if (this.textBox.backButton.visible) {
            this.textBox.nextButton.getBackground().setTint(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON);
        }
        // Sound management
        this.runSoundEngine();
    };
    // JB: This is so hacky it physically pains me, but it works
    GameIntroBaseScene.StartFromEnd = false;
    return GameIntroBaseScene;
}(Phaser.Scene));



/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlaySceneBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_GameInstructionsTextBox__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_utils_ConfigUtil__ = __webpack_require__(513);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var HowToPlaySceneBase = /** @class */ (function (_super) {
    __extends(HowToPlaySceneBase, _super);
    function HowToPlaySceneBase() {
        var _this = _super.call(this, {
            key: "HowToPlay"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.isTouchDisplayed = false;
        // To be filled by child class
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_7_src_constants_Games__["a" /* Games */].Default;
        _this.mainScene = null;
        _this.gameIntroScene = null;
        _this.gameObjectiveTextKey = "";
        _this.howToPlayOnComputerTextKey = "";
        _this.howToPlayOnTabletTextKey = "";
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, HowToPlaySceneBase.prototype);
        return _this;
    }
    HowToPlaySceneBase.prototype.preload = function () {
        var _this = this;
        // This is a "generic" base class and we should sanity check the required conditions are met before proceeding
        if (this.gameRef == null) {
            throw new Error("HowToPlaySceneBase: GameRef has not been initialized");
        }
        if (this.mainScene == null) {
            throw new Error("HowToPlaySceneBase: MainScene has not been initialized");
        }
        // This was changed as a few games have no intro scene
        if (this.gameIntroScene == null) {
            console.info("GameIntroScene is null. Assuming no intro scene");
        }
        if (this.gameObjectiveTextKey == null) {
            throw new Error("HowToPlaySceneBase: GameObjectiveTextKey has not been initialized");
        }
        if (this.howToPlayOnComputerTextKey == null) {
            throw new Error("HowToPlaySceneBase: HowToPlayOnComputerTextKey has not been initialized");
        }
        if (this.howToPlayOnTabletTextKey == null) {
            throw new Error("HowToPlaySceneBase: HowToPlayOnTabletTextKey has not been initialized");
        }
        // Catch load errors here
        this.load.on("loaderror", function (file) {
            console.error("File load error: " + file.key);
            // Audio file missed, load blank audio as it *should* always exist
            if (file.type === "audio") {
                _this.load.audio(file.key, __webpack_require__(514));
            }
        });
        this.load.tilemapTiledJSON('intro-map', __webpack_require__(855));
        this.load.atlas("pilots", __webpack_require__(189), __webpack_require__(190));
        this.load.atlas("starPods", __webpack_require__(856), __webpack_require__(857));
        this.load.audio(this.gameObjectiveTextKey, __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameObjectiveTextKey, __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        this.load.audio(this.howToPlayOnComputerTextKey, __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.howToPlayOnComputerTextKey, __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        // We dont always have tablet instructions
        if (this.howToPlayOnTabletTextKey.length > 1) {
            this.load.audio(this.howToPlayOnTabletTextKey, __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.howToPlayOnTabletTextKey, __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        }
    };
    HowToPlaySceneBase.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "intro-map" });
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        // Set touch flag
        this.isTouchDisplayed = this.sys.game.device.input.touch && this.howToPlayOnTabletTextKey.length > 1;
        // Sound management
        this.runSoundEngine();
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                var translationKeys = [_this.gameObjectiveTextKey];
                if (_this.isTouchDisplayed) {
                    // Touch device: defaults to show tablet instructions, but also show a button to show them the keyboard instructions
                    translationKeys.push(_this.howToPlayOnTabletTextKey);
                    _this.addKeyboardInstructionsButton(ob);
                }
                else {
                    translationKeys.push(_this.howToPlayOnComputerTextKey);
                }
                var config = {
                    padding: 20,
                    fontSize: 20,
                    hollandCode: _this.gameRef.planet.name.toLowerCase(),
                    translationKeys: translationKeys,
                    onBack: _this.back,
                    onStartGame: _this.startGame,
                };
                _this.textBox = new __WEBPACK_IMPORTED_MODULE_3_src_games_shared_GameInstructionsTextBox__["a" /* GameInstructionsTextBox */](_this, ob, config);
                // If there is no previous scene, we should not be able to go back
                if (_this.gameIntroScene == null) {
                    _this.textBox.backButton.setVisible(false);
                    _this.textBox.backButton.setEnabled(false);
                }
            }
            else if (ob.name === "pod") {
                var starPod = _this.add.image(ob.x, ob.y, "starPods", _this.gameRef.planet.name.toLowerCase());
                starPod.setOrigin(0);
                starPod.setDepth(2);
                starPod.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "pilot") {
                var starPilot = _this.add.image(ob.x, ob.y, "pilots", _this.gameRef.planet.name.toLowerCase());
                starPilot.setOrigin(0);
                starPilot.setDisplaySize(ob.width, ob.height);
                starPilot.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    HowToPlaySceneBase.prototype.runSoundEngine = function () {
        this.sound.stopAll();
        if (!__WEBPACK_IMPORTED_MODULE_8_src_utils_ConfigUtil__["a" /* default */].AudioEnabled) {
            return;
        }
        var objectiveAudio = this.sound.add(this.gameObjectiveTextKey);
        objectiveAudio.play();
        // Add first audio as delay + 0.25 to give some natural space
        if (this.isTouchDisplayed) {
            var howToPlayAudioTablet = this.sound.add(this.howToPlayOnTabletTextKey);
            howToPlayAudioTablet.play("", {
                delay: objectiveAudio.totalDuration + 0.25
            });
        }
        else {
            var howToPlayAudio = this.sound.add(this.howToPlayOnComputerTextKey);
            howToPlayAudio.play("", {
                delay: objectiveAudio.totalDuration + 0.25
            });
        }
    };
    HowToPlaySceneBase.prototype.back = function () {
        if (!this.textBox.backButton.isEnabled()) {
            return;
        }
        this.input.enabled = false;
        this.sound.stopAll();
        this.scene.remove(this);
        __WEBPACK_IMPORTED_MODULE_6_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */].StartFromEnd = true;
        this.scene.add("GameIntroScene", this.gameIntroScene, true);
    };
    HowToPlaySceneBase.prototype.startGame = function () {
        if (!this.input.enabled) {
            return;
        }
        this.input.enabled = false;
        this.sound.stopAll();
        this.scene.remove(this);
        // JB: instanceof decided to be broken, so back to javascript
        // if (this.mainScene instanceof SceneObject) {
        if ('scene' in this.mainScene) {
            var t = this.mainScene;
            this.scene.add(t.key, t.scene, true);
        }
        else {
            this.scene.add("GameScene", this.mainScene, true);
        }
    };
    HowToPlaySceneBase.prototype.addKeyboardInstructionsButton = function (ob) {
        var _this = this;
        var config = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY,
            smartSize: true
        };
        // Button to show keyboard instructions
        this.keyboardButton = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, ob.x, 0, 300, 100, __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].translate("public.keyboardInstructions"), config);
        this.keyboardButton.setDepth(10);
        this.keyboardButton.y = this.gameHeight - this.keyboardButton.height - 50;
        // Hide this textbox & show another one with the keyboard instructions
        this.keyboardButton.on('buttonClicked', function () {
            _this.textBox.visible = false;
            _this.isTouchDisplayed = false;
            _this.runSoundEngine();
            if (_this.keyboardInstructionsBox == null) {
                var config = {
                    padding: 20,
                    fontSize: 20,
                    hollandCode: _this.gameRef.planet.name.toLowerCase(),
                    translationKeys: [_this.gameObjectiveTextKey, _this.howToPlayOnComputerTextKey],
                    onBack: _this.hideKeyboardInstructions,
                    onStartGame: _this.startGame,
                };
                _this.keyboardInstructionsBox = new __WEBPACK_IMPORTED_MODULE_3_src_games_shared_GameInstructionsTextBox__["a" /* GameInstructionsTextBox */](_this, ob, config);
            }
            else {
                _this.keyboardInstructionsBox.visible = true;
                _this.keyboardInstructionsBox.backButton.setEnabled(true);
                _this.keyboardInstructionsBox.startGameButton.setEnabled(true);
            }
            _this.textBox.backButton.setEnabled(false);
            _this.textBox.startGameButton.setEnabled(false);
            _this.keyboardButton.visible = false;
        });
    };
    HowToPlaySceneBase.prototype.hideKeyboardInstructions = function () {
        this.textBox.visible = true;
        this.isTouchDisplayed = true;
        this.keyboardInstructionsBox.visible = false;
        this.keyboardButton.visible = true;
        this.keyboardInstructionsBox.backButton.setEnabled(false);
        this.keyboardInstructionsBox.startGameButton.setEnabled(false);
        this.textBox.backButton.setEnabled(true);
        this.textBox.startGameButton.setEnabled(true);
    };
    return HowToPlaySceneBase;
}(Phaser.Scene));



/***/ }),
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Interfaces_IChannelControls__ = __webpack_require__(1885);
/* unused harmony reexport MinChannelPriorty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(1886);
/* unused harmony reexport EventsDiscardedReason */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_AppInsightsCore__ = __webpack_require__(1888);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_AppInsightsCore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JavaScriptSDK_BaseCore__ = __webpack_require__(762);
/* unused harmony reexport BaseCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__ = __webpack_require__(766);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__["d"]; });
/* unused harmony reexport mwcRandomSeed */
/* unused harmony reexport mwcRandom32 */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__ = __webpack_require__(764);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["a"]; });
/* unused harmony reexport EventHelper */
/* unused harmony reexport Undefined */
/* unused harmony reexport newGuid */
/* unused harmony reexport perfNow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__ = __webpack_require__(71);
/* unused harmony reexport isTypeof */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["s"]; });
/* unused harmony reexport hasOwnProperty */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["C"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["L"]; });
/* unused harmony reexport strStartsWith */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["t"]; });
/* unused harmony reexport isBoolean */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["O"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["M"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["E"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["A"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["N"]; });
/* unused harmony reexport strContains */
/* unused harmony reexport isSymbol */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["J"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["k"]; });
/* unused harmony reexport isNotTruthy */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["G"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["I"]; });
/* unused harmony reexport proxyFunctionAs */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["F"]; });
/* unused harmony reexport isNotUndefined */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["r"]; });
/* unused harmony reexport objFreeze */
/* unused harmony reexport objSeal */
/* unused harmony reexport objExtend */
/* unused harmony reexport objToString */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["h"]; });
/* unused harmony reexport isPlainObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_Enums_EnumHelperFuncs__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_Enums_EnumHelperFuncs__["a"]; });
/* unused harmony reexport createEnumMap */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_Enums_EnumHelperFuncs__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__JavaScriptSDK_EventHelpers__ = __webpack_require__(765);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__JavaScriptSDK_EventHelpers__["d"]; });
/* unused harmony reexport detachEvent */
/* unused harmony reexport addEventHandler */
/* unused harmony reexport addEventListeners */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__JavaScriptSDK_EventHelpers__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_9__JavaScriptSDK_EventHelpers__["b"]; });
/* unused harmony reexport addPageShowEventListener */
/* unused harmony reexport removeEventHandler */
/* unused harmony reexport removeEventListeners */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_9__JavaScriptSDK_EventHelpers__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_9__JavaScriptSDK_EventHelpers__["i"]; });
/* unused harmony reexport removePageShowEventListener */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_9__JavaScriptSDK_EventHelpers__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_9__JavaScriptSDK_EventHelpers__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_9__JavaScriptSDK_EventHelpers__["h"]; });
/* unused harmony reexport __getRegisteredEvents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__ = __webpack_require__(124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["f"]; });
/* unused harmony reexport getCrypto */
/* unused harmony reexport getMsCrypto */
/* unused harmony reexport hasNavigator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["w"]; });
/* unused harmony reexport getConsole */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["a"]; });
/* unused harmony reexport isIE */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["i"]; });
/* unused harmony reexport isSafari */
/* unused harmony reexport setEnableEnvMocks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_EnvUtils__["x"]; });
/* unused harmony reexport findMetaTag */
/* unused harmony reexport findNamedServerTiming */
/* unused harmony reexport sendCustomEvent */
/* unused harmony reexport dispatchEvent */
/* unused harmony reexport createCustomDomEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__microsoft_applicationinsights_shims__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_11__microsoft_applicationinsights_shims__["h"]; });
/* unused harmony reexport objCreate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_11__microsoft_applicationinsights_shims__["l"]; });
/* unused harmony reexport strFunction */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_11__microsoft_applicationinsights_shims__["m"]; });
/* unused harmony reexport strObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__JavaScriptSDK_NotificationManager__ = __webpack_require__(767);
/* unused harmony reexport NotificationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__JavaScriptSDK_PerfManager__ = __webpack_require__(341);
/* unused harmony reexport PerfEvent */
/* unused harmony reexport PerfManager */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_13__JavaScriptSDK_PerfManager__["b"]; });
/* unused harmony reexport getGblPerfMgr */
/* unused harmony reexport setGblPerfMgr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_DiagnosticLogger__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_DiagnosticLogger__["f"]; });
/* unused harmony reexport DiagnosticLogger */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_DiagnosticLogger__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_DiagnosticLogger__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_DiagnosticLogger__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_DiagnosticLogger__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_ProcessTelemetryContext__ = __webpack_require__(340);
/* unused harmony reexport ProcessTelemetryContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_ProcessTelemetryContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__JavaScriptSDK_TelemetryHelpers__ = __webpack_require__(342);
/* unused harmony reexport initializePlugins */
/* unused harmony reexport sortPlugins */
/* unused harmony reexport unloadComponents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(1891);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_Enums_LoggingEnums__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_Enums_LoggingEnums__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__JavaScriptSDK_InstrumentHooks__ = __webpack_require__(1892);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_18__JavaScriptSDK_InstrumentHooks__["c"]; });
/* unused harmony reexport InstrumentProtos */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_18__JavaScriptSDK_InstrumentHooks__["b"]; });
/* unused harmony reexport InstrumentFuncs */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_18__JavaScriptSDK_InstrumentHooks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__JavaScriptSDK_CookieMgr__ = __webpack_require__(485);
/* unused harmony reexport createCookieMgr */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_19__JavaScriptSDK_CookieMgr__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_19__JavaScriptSDK_CookieMgr__["d"]; });
/* unused harmony reexport areCookiesSupported */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__JavaScriptSDK_DbgExtensionUtils__ = __webpack_require__(483);
/* unused harmony reexport getDebugListener */
/* unused harmony reexport getDebugExt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__JavaScriptSDK_DataCacheHelper__ = __webpack_require__(343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_21__JavaScriptSDK_DataCacheHelper__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__JavaScriptSDK_UnloadHandlerContainer__ = __webpack_require__(486);
/* unused harmony reexport createUnloadHandlerContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__JavaScriptSDK_W3cTraceParent__ = __webpack_require__(763);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_23__JavaScriptSDK_W3cTraceParent__["a"]; });
/* unused harmony reexport parseTraceParent */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_23__JavaScriptSDK_W3cTraceParent__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_23__JavaScriptSDK_W3cTraceParent__["c"]; });
/* unused harmony reexport isValidTraceParent */
/* unused harmony reexport isSampledFlag */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_23__JavaScriptSDK_W3cTraceParent__["b"]; });
/* unused harmony reexport findW3cTraceParent */
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
























//# sourceMappingURL=applicationinsights-core-js.js.map

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grid_style__ = __webpack_require__(829);


// style dependencies


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/outro_scene.ae422d52.json";

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_style__ = __webpack_require__(32);


// style dependencies


/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Renderer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Filterer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataTableButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DataTableButtonExport; });
/* unused harmony export DataTableButtonLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DataTableButtonReset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_table__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_table_style_index_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_radio__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_radio_style_index_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_date_picker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_date_picker_style_index_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_notification__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_notification_style_index_js__ = __webpack_require__(2113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_utils_DownloadUtil__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_models_datatable_TableColumnState__ = __webpack_require__(2115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_localize_redux__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






















// import * as moment from 'moment';


var ButtonGroup = __WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */].Group;
var RangePicker = __WEBPACK_IMPORTED_MODULE_15_antd_es_date_picker__["a" /* default */].RangePicker;
var RadioGroup = __WEBPACK_IMPORTED_MODULE_13_antd_es_radio__["c" /* default */].Group;

var Renderer;
(function (Renderer) {
    Renderer[Renderer["DEFAULT"] = 0] = "DEFAULT";
    Renderer[Renderer["BooleanYesNo"] = 1] = "BooleanYesNo";
    Renderer[Renderer["BooleanYesEmpty"] = 2] = "BooleanYesEmpty";
    Renderer[Renderer["BooleanCheckbox"] = 3] = "BooleanCheckbox";
    Renderer[Renderer["ShortDate"] = 4] = "ShortDate";
    Renderer[Renderer["ShortDateTime"] = 5] = "ShortDateTime";
    Renderer[Renderer["Currency"] = 6] = "Currency";
    Renderer[Renderer["Number"] = 7] = "Number";
    Renderer[Renderer["NumberAllowZero"] = 8] = "NumberAllowZero";
    Renderer[Renderer["LinkButtons"] = 9] = "LinkButtons";
})(Renderer || (Renderer = {}));
var Filterer;
(function (Filterer) {
    Filterer[Filterer["NONE"] = 0] = "NONE";
    Filterer[Filterer["Text"] = 1] = "Text";
    Filterer[Filterer["Date"] = 2] = "Date";
    Filterer[Filterer["DateRange"] = 3] = "DateRange";
    Filterer[Filterer["Dropdown"] = 4] = "Dropdown";
    Filterer[Filterer["BooleanCheckbox"] = 5] = "BooleanCheckbox";
    Filterer[Filterer["BooleanRadio"] = 6] = "BooleanRadio";
    Filterer[Filterer["RadioSelect"] = 7] = "RadioSelect";
})(Filterer || (Filterer = {}));
var DataTableButtonType;
(function (DataTableButtonType) {
    DataTableButtonType[DataTableButtonType["Custom"] = 0] = "Custom";
    DataTableButtonType[DataTableButtonType["Export"] = 1] = "Export";
    DataTableButtonType[DataTableButtonType["Reset"] = 2] = "Reset";
    DataTableButtonType[DataTableButtonType["Link"] = 3] = "Link";
})(DataTableButtonType || (DataTableButtonType = {}));
var DataTableButton = /** @class */ (function () {
    function DataTableButton(id, onClick) {
        this.type = DataTableButtonType.Custom;
        this.id = id;
        this.label = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: id });
        this.onClick = onClick;
    }
    DataTableButton.prototype.getType = function () {
        return this.type;
    };
    return DataTableButton;
}());

var DataTableButtonExport = /** @class */ (function (_super) {
    __extends(DataTableButtonExport, _super);
    function DataTableButtonExport(filename) {
        var _this = _super.call(this, 'dataTable.export', function () { return console.log('export clicked'); }) || this;
        _this.type = DataTableButtonType.Export;
        _this.filename = filename;
        return _this;
        // TODO: JB - Removed because I am out of time
        // this.addDateToFilename = addDateToFilename != null ? addDateToFilename : false;
        // this.onComplete = onComplete;
    }
    return DataTableButtonExport;
}(DataTableButton));

var DataTableButtonLink = /** @class */ (function (_super) {
    __extends(DataTableButtonLink, _super);
    function DataTableButtonLink(id, href, onClick) {
        var _this = _super.call(this, id, onClick != null ? onClick : function () { }) || this;
        _this.type = DataTableButtonType.Link;
        _this.href = href;
        return _this;
    }
    return DataTableButtonLink;
}(DataTableButton));

var DataTableButtonReset = /** @class */ (function (_super) {
    __extends(DataTableButtonReset, _super);
    function DataTableButtonReset() {
        var _this = _super.call(this, "dataTable.reset", function () { return console.log('reset clicked'); }) || this;
        _this.type = DataTableButtonType.Reset;
        return _this;
    }
    return DataTableButtonReset;
}(DataTableButton));

var DataTable = /** @class */ (function (_super) {
    __extends(DataTable, _super);
    function DataTable(props) {
        var _this = _super.call(this, props) || this;
        _this.searchInputs = {};
        _this.echo = 0;
        _this.onInputChange = function (e, stateObject, searchButton) {
            var stateCopy = __assign({}, stateObject);
            stateCopy.searchText = e.target.value;
            _this.setState({ columnStates: _this.getUpdatedColumnStateList(stateCopy) }, function () {
                console.log('filter input: state saved');
                if (searchButton) {
                    searchButton.focus();
                }
            });
        };
        _this.onDateInputChange = function (date, dateString, stateObject, searchButton) {
            var stateCopy = __assign({}, stateObject);
            stateCopy.searchText = dateString;
            _this.setState({ columnStates: _this.getUpdatedColumnStateList(stateCopy) }, function () {
                console.log('filter input: state saved');
                searchButton.focus();
            });
        };
        _this.onDateRangeInputChange = function (dates, dateStrings, stateObject, searchButton) {
            var stateCopy = __assign({}, stateObject);
            stateCopy.searchText = dateStrings[0] + " - " + dateStrings[1];
            _this.setState({ columnStates: _this.getUpdatedColumnStateList(stateCopy) }, function () {
                console.log('filter input: state saved');
                searchButton.focus();
            });
        };
        _this.onSearch = function (stateObject) {
            var stateCopy = __assign({}, stateObject);
            var searchText = stateCopy.searchText;
            var reg = new RegExp(searchText ? searchText : '', 'gi');
            stateCopy.filterVisible = false;
            stateCopy.filtered = !!searchText;
            var filters = _this.state.filters.map(function (f) { return f; });
            var filterObj = filters.filter(function (value) { return value.columnProp === stateCopy.columnProp; });
            if (filterObj.length > 0) {
                filterObj[0].filter = searchText;
            }
            else {
                filters.push({ columnProp: stateCopy.columnProp, filter: searchText });
            }
            if (_this.props.serverSide) {
                _this.setState({
                    filters: filters,
                    pagination: __assign(__assign({}, _this.state.pagination), { current: 1 }),
                    columnStates: _this.getUpdatedColumnStateList(stateCopy)
                }, function () { return _this.callFetchData(_this.state.pagination, filters, _this.state.sorter); });
            }
            else {
                _this.setState({
                    filters: filters,
                    columnStates: _this.getUpdatedColumnStateList(stateCopy),
                    filteredData: _this.props.data.map(function (item) {
                        var match = item[stateCopy.columnProp].match(reg);
                        if (!match) {
                            return null;
                        }
                        return __assign({}, item);
                    }).filter(function (item) { return !!item; })
                });
            }
        };
        var $this = _this;
        _this.state = {
            // pagination: DataTable.DefaultPagination,
            pagination: __assign(__assign({}, DataTable.DefaultPagination), (props.tableProps != null && props.tableProps.pagination != null ? props.tableProps.pagination : {})),
            sorter: {},
            filters: [],
            columnStates: _this.props.columns.map(function (column) {
                return __WEBPACK_IMPORTED_MODULE_23_src_models_datatable_TableColumnState__["a" /* default */].create({ columnProp: column.columnProps.dataIndex || column.columnProps.key });
            }),
            data: [],
            filteredData: null
        };
        // this.search = debounce(this.search, 400);
        _this.handleTableChange = _this.handleTableChange.bind(_this);
        return _this;
    }
    DataTable.prototype.componentDidMount = function () {
        if (this.props.serverSide) {
            this.callFetchData(this.state.pagination, this.state.filters, this.state.sorter);
        }
        else {
            this.setState({
                data: this.props.data
            });
        }
    };
    DataTable.prototype.resetTable = function () {
        var pager = __assign({}, this.state.pagination);
        pager.current = 1;
        var columnStates = this.state.columnStates.map(function (colState) {
            colState.filtered = false;
            colState.filterVisible = false;
            colState.searchText = '';
            return colState;
        });
        this.setState({
            pagination: pager,
            sorter: {},
            filters: [],
            columnStates: columnStates
        });
        this.callFetchData(pager, [], {});
    };
    /** Note: Export must be enabled in the datatable provider */
    DataTable.prototype.exportTable = function (filename) {
        if (!this.props.serverSide) {
            // Sorry, only server side for now
            return;
        }
        this.callExportData(this.state.pagination, this.state.filters, this.state.sorter, filename);
    };
    DataTable.prototype.refresh = function () {
        var _this = this;
        if (this.props.serverSide) {
            this.callFetchData(this.state.pagination, this.state.filters, this.state.sorter);
        }
        else {
            this.setState({
                data: this.props.data,
                // filteredData: this.props.data
                filteredData: null,
            }, function () {
                _this.state.columnStates.filter(function (colState) { return colState.filtered; }).forEach(function (colState) { return _this.onSearch(colState); });
            });
        }
    };
    DataTable.prototype.render = function () {
        var _this = this;
        var tableProps = __assign({}, this.props.tableProps);
        tableProps.dataSource = this.state.filteredData || this.state.data;
        tableProps.pagination = this.state.pagination;
        tableProps.size = tableProps.size || 'small';
        tableProps.onChange = this.handleTableChange;
        tableProps.locale = { emptyText: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: 'dataTable.noData' }) };
        tableProps.columns = this.props.columns.map(function (column) {
            var columnProps = __assign({}, column.columnProps);
            var columnState = _this.getColumnState(column);
            // if (!column.columnProps.key) {
            //     column.columnProps.key = column.columnProps.dataIndex;
            // }
            switch (column.filterType) {
                case Filterer.Text:
                    columnProps.filterDropdown = _this.textFilter(columnState, column.columnProps.title);
                    columnProps.filterDropdownVisible = columnState.filterVisible;
                    columnProps.onFilterDropdownVisibleChange = _this.onFilterVisibleChangeWithFocus(columnState);
                    columnProps.filterIcon = _this.filterIcon(columnState);
                    break;
                case Filterer.Date:
                    columnProps.filterDropdown = _this.dateFilter(columnState, column.columnProps.title);
                    columnProps.filterDropdownVisible = columnState.filterVisible;
                    columnProps.onFilterDropdownVisibleChange = _this.onFilterVisibleChangeWithFocus(columnState);
                    columnProps.filterIcon = _this.filterIcon(columnState);
                    break;
                case Filterer.DateRange:
                    columnProps.filterDropdown = _this.dateRangeFilter(columnState, column.columnProps.title);
                    columnProps.filterDropdownVisible = columnState.filterVisible;
                    columnProps.onFilterDropdownVisibleChange = _this.onFilterVisibleChangeWithFocus(columnState);
                    columnProps.filterIcon = _this.filterIcon(columnState);
                    break;
                case Filterer.BooleanRadio:
                    columnProps.filterDropdown = _this.booleanRadioFilter(columnState, column.columnProps.title);
                    columnProps.filterDropdownVisible = columnState.filterVisible;
                    columnProps.onFilterDropdownVisibleChange = _this.onFilterVisibleChange(columnState);
                    columnProps.filterIcon = _this.filterIcon(columnState);
                    break;
                case Filterer.RadioSelect:
                    columnProps.filterDropdown = _this.radioSelectFilter(columnState, column.columnProps.title, column.filterItems);
                    columnProps.filterDropdownVisible = columnState.filterVisible;
                    columnProps.onFilterDropdownVisibleChange = _this.onFilterVisibleChange(columnState);
                    columnProps.filterIcon = _this.filterIcon(columnState);
                    break;
                default:
                    break;
            }
            switch (column.renderer) {
                case Renderer.BooleanYesNo:
                    columnProps.render = function (value, record) {
                        return _this.renderBooleanYesNo(column.renderDataTransform ? column.renderDataTransform(value, record) : value);
                    };
                    break;
                case Renderer.BooleanYesEmpty:
                    columnProps.render = function (value, record) {
                        return _this.renderBooleanYesEmpty(column.renderDataTransform ? column.renderDataTransform(value, record) : value);
                    };
                    break;
                case Renderer.BooleanCheckbox:
                    columnProps.render = function (value, record) {
                        return _this.renderBooleanCheckbox(column.renderDataTransform ? column.renderDataTransform(value, record) : value);
                    };
                    break;
                case Renderer.ShortDate:
                    columnProps.render = function (value, record) {
                        return _this.renderShortDate(column.renderDataTransform ? column.renderDataTransform(value, record) : value);
                    };
                    break;
                case Renderer.ShortDateTime:
                    columnProps.render = function (value, record) {
                        return _this.renderShortDateTime(column.renderDataTransform ? column.renderDataTransform(value, record) : value);
                    };
                    break;
                case Renderer.Currency:
                    columnProps.render = function (value, record) {
                        return _this.renderCurrency(column.renderDataTransform ? column.renderDataTransform(value, record) : value);
                    };
                    break;
                case Renderer.Number:
                    columnProps.render = function (value, record) {
                        return _this.renderNumber(column.renderDataTransform ? column.renderDataTransform(value, record) : value);
                    };
                    break;
                case Renderer.NumberAllowZero:
                    columnProps.render = function (value, record) {
                        return _this.renderNumberAllowZero(column.renderDataTransform ? column.renderDataTransform(value, record) : value);
                    };
                    break;
                case Renderer.LinkButtons:
                    columnProps.render = function (value, record) {
                        return _this.renderLinkButtons(column.renderDataTransform ? column.renderDataTransform(value, record) : value, column.toolTipText, column.icon);
                    };
                    break;
                default:
                    if (!columnProps.render) {
                        columnProps.render = function (value, record) {
                            return column.renderDataTransform ? column.renderDataTransform(value, record) : value;
                        };
                    }
                    break;
            }
            if (columnProps.sorter) {
                if (columnProps.sorter === true && !_this.props.serverSide) {
                    columnProps.sorter = function (a, b) {
                        return columnProps.dataIndex ?
                            ([a[columnProps.dataIndex], b[columnProps.dataIndex]].sort()[0] === a[columnProps.dataIndex] ? 1 : -1) :
                            0;
                        // a[columnProps.dataIndex].localeCompare(b[columnProps.dataIndex]);
                    };
                }
                columnProps.sortOrder = _this.state.sorter.columnKey === columnProps.dataIndex && _this.state.sorter.order;
            }
            return columnProps;
        });
        var _a = this.state, pagination = _a.pagination, filters = _a.filters, sorter = _a.sorter;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.props.className },
            this.props.buttonBar ?
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "dataTable-button-bar" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonGroup, null, this.props.buttonBar.map(function (button, index) {
                        switch (button.getType()) {
                            case DataTableButtonType.Export:
                                var exportButton = button;
                                var filename = exportButton.filename + "_" + __WEBPACK_IMPORTED_MODULE_21_moment___default()().format("YYYYMMDDHHmmss");
                                button.onClick = function () { return _this.exportTable(filename); };
                                break;
                            case DataTableButtonType.Reset:
                                button.onClick = function () { return _this.resetTable(); };
                                break;
                            case DataTableButtonType.Link:
                                // TODO: JB - Please come fix this
                                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { key: button.id, onClick: button.onClick, href: button.href }, button.label);
                            default:
                                break;
                        }
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { key: button.id, onClick: function () { return button.onClick(); } }, button.label);
                    })))
                : null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_table__["a" /* default */], __assign({}, tableProps))));
    };
    DataTable.prototype.callFetchData = function (pagination, filters, sorter) {
        var _this = this;
        if (this.props.fetchData) {
            var requestState_1 = this.getTableStateDTO(pagination, filters, sorter);
            this.props.fetchData(requestState_1, function () { return requestState_1.echo === _this.echo; }, function (response) {
                var pager = __assign({}, _this.state.pagination);
                pager.total = response.filteredCount;
                pager.dataTableUnfilteredTotal = response.totalCount;
                _this.setState({
                    data: response.results || [],
                    pagination: pager
                });
            });
        }
    };
    DataTable.prototype.callExportData = function (pagination, filters, sorter, filename) {
        var _this = this;
        if (this.props.fetchData) {
            var requestState_2 = this.getTableStateDTO(pagination, filters, sorter);
            // Export specific code
            requestState_2.runAsExport = true;
            return this.props.fetchData(requestState_2, function () { return requestState_2.echo === _this.echo; }, function (response) {
                // We don't need to update the table since no new data is coming back
                var reportName = filename + '.xlsx';
                Object(__WEBPACK_IMPORTED_MODULE_22_src_utils_DownloadUtil__["a" /* downloadFile */])(response.reportData, reportName);
                // const pager = { ...this.state.pagination };
                // pager.total = response.filteredCount;
                // pager.dataTableUnfilteredTotal = response.totalCount;
                // this.setState({
                //     data: response.results || [],
                //     pagination: pager
                // });
            });
        }
    };
    DataTable.prototype.handleTableChange = function (pagination, filters, sorter) {
        var pager = __assign({}, this.state.pagination);
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.setState({
            pagination: pager,
            sorter: sorter
        });
        this.callFetchData(pager, this.state.filters, sorter);
    };
    DataTable.prototype.getTableStateDTO = function (pagination, filters, sorter) {
        this.echo += 1;
        return {
            pageLength: pagination.pageSize || pagination.defaultPageSize,
            page: (pagination.current || pagination.defaultCurrent) - 1,
            sortField: sorter.field || null,
            sortOrder: sorter.order || null,
            echo: this.echo,
            filters: filters,
            runAsExport: false
        };
    };
    DataTable.prototype.textFilter = function (stateObject, columnTitle) {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-filter-dropdown" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "textFilter-" + stateObject.columnProp },
                "Text Filter ",
                stateObject.columnProp),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_input__["a" /* default */], { id: "textFilter-" + stateObject.columnProp, ref: function (ele) { return _this.searchInputs[stateObject.columnProp] = ele; }, value: stateObject.searchText || '', onChange: function (e) { return _this.onInputChange(e, stateObject); }, onPressEnter: function () { return _this.onSearch(stateObject); } }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { type: "primary", onClick: function (e) { return _this.onSearch(stateObject); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: 'dataTable.search' }))));
    };
    DataTable.prototype.dateFilter = function (stateObject, columnTitle) {
        var _this = this;
        var div;
        var searchButton;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: function (ele) { return div = ele; }, className: "date-filter-dropdown" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_date_picker__["a" /* default */], { ref: function (ele) { return _this.searchInputs[stateObject.columnProp] = ele; }, onChange: function (date, dateString) { return _this.onDateInputChange(date, dateString, stateObject, searchButton); }, getCalendarContainer: function () { return div; }, format: "M/D/YYYY" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { ref: function (ele) { return searchButton = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](ele); }, type: "primary", onClick: function () { return _this.onSearch(stateObject); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: 'dataTable.search' }))));
    };
    DataTable.prototype.dateRangeFilter = function (stateObject, columnTitle) {
        var _this = this;
        var div;
        var searchButton;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: function (ele) { return div = ele; }, className: "daterange-filter-dropdown" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RangePicker, { ref: function (ele) { return _this.searchInputs[stateObject.columnProp] = ele; }, onChange: function (date, dateString) { return _this.onDateRangeInputChange(date, dateString, stateObject, searchButton); }, onOpenChange: function (status) { return _this.onDateRangePickerOpenChange(status, stateObject); }, getCalendarContainer: function () { return div; }, format: "M/D/YYYY" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { ref: function (ele) { return searchButton = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](ele); }, type: "primary", onClick: function () { return _this.onSearch(stateObject); } }, "Search")));
    };
    DataTable.prototype.booleanRadioFilter = function (stateObject, columnTitle) {
        var _this = this;
        var searchButton;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "boolean-radio-filter-dropdown" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadioGroup, { ref: function (ele) { return _this.searchInputs[stateObject.columnProp] = ele; }, onChange: function (e) { return _this.onInputChange(e, stateObject, searchButton); }, value: stateObject.searchText ? stateObject.searchText : '' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_radio__["c" /* default */], { value: "true" }, "Yes"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_radio__["c" /* default */], { value: "false" }, "No"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_radio__["c" /* default */], { value: "" }, "All")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { ref: function (ele) { return searchButton = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](ele); }, type: "primary", onClick: function () { return _this.onSearch(stateObject); } }, "Search")));
    };
    DataTable.prototype.radioSelectFilter = function (stateObject, columnTitle, filterItems) {
        var _this = this;
        var searchButton;
        // Dev Note: I tried to make an other search box. However, it is much more complicated than I want to go into right now, so here is lays
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "boolean-radio-filter-dropdown" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadioGroup, { ref: function (ele) { return _this.searchInputs[stateObject.columnProp] = ele; }, onChange: function (e) { return _this.onInputChange(e, stateObject, searchButton); }, value: stateObject.searchText ? stateObject.searchText : '', className: "vertical" },
                filterItems.map(function (x) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_radio__["c" /* default */], { value: x }, x)); }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_radio__["c" /* default */], { value: "" }, "All")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { ref: function (ele) { return searchButton = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](ele); }, type: "primary", onClick: function () { return _this.onSearch(stateObject); } }, "Search")));
    };
    DataTable.prototype.filterIcon = function (stateObject) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_icon__["a" /* default */], { type: "filter", style: { color: stateObject.filtered ? '#108ee9' : '#aaa' } });
    };
    DataTable.prototype.onFilterVisibleChangeWithFocus = function (stateObject) {
        var _this = this;
        return function (visible) {
            var stateCopy = __assign({}, stateObject);
            stateCopy.filterVisible = visible;
            _this.setState({ columnStates: _this.getUpdatedColumnStateList(stateCopy) }, function () { return _this.searchInputs[stateCopy.columnProp] && _this.searchInputs[stateCopy.columnProp].focus(); });
        };
    };
    DataTable.prototype.onFilterVisibleChange = function (stateObject) {
        var _this = this;
        return function (visible) {
            var stateCopy = __assign({}, stateObject);
            stateCopy.filterVisible = visible;
            _this.setState({
                columnStates: _this.getUpdatedColumnStateList(stateCopy)
            });
        };
    };
    DataTable.prototype.onDateRangePickerOpenChange = function (open, stateObject) {
        // return (status: boolean) => {
        // let picker = this.searchInputs[stateObject.columnProp];
        // let currentText = (picker.value[0] as moment.Moment).format(picker.format) +
        //     ' - ' + (picker.value[1] as moment.Moment).format(picker.format);
        console.log("date range picker " + (status ? 'opened' : 'closed'));
        // if (currentText !== stateObject.searchText) {
        //     console.log('date range filter changed');
        // }
        // var stateCopy = { ...stateObject };
        // stateCopy.filterVisible = visible;
        // this.setState(
        //     { columnStates: this.getUpdatedColumnStateList(stateCopy) },
        //     () => this.searchInputs[stateCopy.columnProp] && this.searchInputs[stateCopy.columnProp].focus());
        // };
    };
    DataTable.prototype.getColumnState = function (customColumnProps) {
        return this.state.columnStates.filter(function (cs) { return cs.columnProp ===
            customColumnProps.columnProps.dataIndex || customColumnProps.columnProps.key; })[0];
    };
    DataTable.prototype.getUpdatedColumnStateList = function (modifiedColumnState) {
        return this.state.columnStates.map(function (cs) { return cs.columnProp === modifiedColumnState.columnProp ? modifiedColumnState : cs; });
    };
    DataTable.prototype.renderShortDate = function (value) {
        if (!value) {
            return;
        }
        var date = __WEBPACK_IMPORTED_MODULE_21_moment___default.a.utc(value);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, date.format('M/D/YYYY')));
    };
    DataTable.prototype.renderShortDateTime = function (value) {
        if (!value) {
            return;
        }
        var date = __WEBPACK_IMPORTED_MODULE_21_moment___default.a.utc(value);
        date.local();
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, date.format('M/D/YYYY hh:mm:ss A')));
    };
    DataTable.prototype.renderCurrency = function (value) {
        if (!value) {
            return;
        }
        try {
            var num = parseFloat(value);
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                "$",
                num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')));
        }
        catch (error) {
            return;
        }
    };
    DataTable.prototype.renderNumber = function (value) {
        if (!value) {
            return;
        }
        try {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, ("" + value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')));
        }
        catch (error) {
            return;
        }
    };
    DataTable.prototype.renderNumberAllowZero = function (value) {
        try {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, ("" + value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')));
        }
        catch (error) {
            return;
        }
    };
    DataTable.prototype.renderBooleanYesNo = function (value) {
        return value ? 'Yes' : 'No';
    };
    DataTable.prototype.renderBooleanYesEmpty = function (value) {
        return value ? 'Yes' : '';
    };
    DataTable.prototype.renderBooleanCheckbox = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_checkbox__["a" /* default */], { defaultChecked: value, disabled: true });
    };
    DataTable.prototype.renderLinkButtons = function (links, toolTipText, icon) {
        var _this = this;
        if (!links || links.length === 0) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, this.renderDisabledLinkButton(toolTipText, icon)));
        }
        var isString = typeof links === 'string';
        var strVal = links;
        var arrVal = links;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, isString ?
            this.renderLinkButton(strVal, toolTipText, icon) :
            arrVal.map(function (link) { return _this.renderLinkButton(link, toolTipText, icon); })));
    };
    DataTable.prototype.renderLinkButton = function (link, toolTipText, icon) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: toolTipText, arrowPointAtCenter: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"], { to: link },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: icon }))));
    };
    DataTable.prototype.renderDisabledLinkButton = function (toolTipText, icon) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: toolTipText, arrowPointAtCenter: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"], { to: "" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: icon, disabled: true }))));
    };
    DataTable.DefaultPagination = {
        defaultPageSize: 10,
        defaultCurrent: 1
    };
    DataTable.StandardTotalsRenderer = function (total, range) { return ("Showing " + range[0] + " to " + range[1] + " of " + total + " total"); };
    DataTable.StandardColumns = {
        Number: function (translationId, dataIndex) {
            return {
                columnProps: {
                    title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: translationId }),
                    dataIndex: dataIndex,
                    sorter: true,
                },
                filterType: Filterer.Text,
                renderer: Renderer.Number,
            };
        },
        NumberAllowZero: function (translationId, dataIndex) {
            return {
                columnProps: {
                    title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: translationId }),
                    dataIndex: dataIndex,
                    sorter: true,
                },
                filterType: Filterer.Text,
                renderer: Renderer.NumberAllowZero,
            };
        },
        Text: function (translationId, dataIndex) {
            return {
                columnProps: {
                    title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: translationId }),
                    dataIndex: dataIndex,
                    sorter: true,
                },
                filterType: Filterer.Text
            };
        },
        Boolean: function (translationId, dataIndex) {
            return {
                columnProps: {
                    title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: translationId }),
                    dataIndex: dataIndex,
                    sorter: true,
                },
                renderer: Renderer.BooleanCheckbox,
                filterType: Filterer.BooleanCheckbox
            };
        },
        Date: function (translationId, dataIndex) {
            return {
                columnProps: {
                    title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: translationId }),
                    dataIndex: dataIndex,
                    sorter: true
                },
                filterType: Filterer.Date,
                renderer: Renderer.ShortDate
            };
        },
        DateTime: function (translationId, dataIndex) {
            return {
                columnProps: {
                    title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: translationId }),
                    dataIndex: dataIndex,
                    sorter: true
                },
                filterType: Filterer.Date,
                renderer: Renderer.ShortDateTime
            };
        },
        Link: function (translationId, key, transform, icon) {
            return {
                columnProps: {
                    key: key,
                    align: 'center',
                    width: 35
                },
                renderer: Renderer.LinkButtons,
                renderDataTransform: function (text, record) { return transform(text, record); },
                toolTipText: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["b" /* Translate */], { id: translationId }),
                icon: icon
            };
        },
    };
    /** Acts like the *StandardColumns* but with proper intellisense! */
    DataTable.AdvancedColumns = {
        Number: function (title, dataIndex, width) {
            if (width === void 0) { width = undefined; }
            return {
                columnProps: {
                    title: title,
                    dataIndex: dataIndex,
                    sorter: true,
                    width: width
                },
                filterType: Filterer.Text,
                renderer: Renderer.Number,
            };
        },
        Text: function (title, dataIndex, width) {
            if (width === void 0) { width = undefined; }
            return {
                columnProps: {
                    title: title,
                    dataIndex: dataIndex,
                    sorter: true,
                    width: width
                },
                filterType: Filterer.Text
            };
        },
        /** Text column but with better filtering */
        Enum: function (title, dataIndex, filterItems, width, render) {
            if (width === void 0) { width = undefined; }
            if (render === void 0) { render = undefined; }
            return {
                columnProps: {
                    title: title,
                    dataIndex: dataIndex,
                    sorter: true,
                    width: width,
                    render: render
                },
                filterType: Filterer.RadioSelect,
                filterItems: filterItems
            };
        },
        Boolean: function (title, dataIndex, width) {
            if (width === void 0) { width = undefined; }
            return {
                columnProps: {
                    title: title,
                    dataIndex: dataIndex,
                    sorter: true,
                    width: width
                },
                renderer: Renderer.BooleanCheckbox,
                filterType: Filterer.BooleanCheckbox
            };
        },
        DateTime: function (title, dataIndex, width) {
            if (width === void 0) { width = undefined; }
            return {
                columnProps: {
                    title: title,
                    dataIndex: dataIndex,
                    sorter: true,
                    width: width
                },
                renderer: Renderer.ShortDateTime,
                filterType: Filterer.Date
            };
        },
        Date: function (title, dataIndex, width) {
            if (width === void 0) { width = undefined; }
            return {
                columnProps: {
                    title: title,
                    dataIndex: dataIndex,
                    sorter: true,
                    width: width
                },
                renderer: Renderer.ShortDate,
                filterType: Filterer.Date
            };
        },
        /** Old, use normal Custom instead */
        CustomLegacy: function (title, dataIndex, width, renderer, filterer, render) {
            if (width === void 0) { width = undefined; }
            if (renderer === void 0) { renderer = "DEFAULT"; }
            if (filterer === void 0) { filterer = "Text"; }
            if (render === void 0) { render = undefined; }
            return {
                columnProps: {
                    title: title,
                    dataIndex: dataIndex,
                    sorter: true,
                    width: width,
                    render: render
                },
                renderer: Renderer[renderer],
                filterType: Filterer[filterer]
            };
        },
        Custom: function (title, dataIndex, width, render) {
            if (width === void 0) { width = undefined; }
            if (render === void 0) { render = undefined; }
            return {
                columnProps: {
                    title: title,
                    dataIndex: dataIndex,
                    sorter: true,
                    width: width,
                    render: function (text, record, index) { return render(record, index); }
                },
                renderer: Renderer.DEFAULT,
                filterType: Filterer.Text
            };
        }
    };
    /** The 3rd form of the columns. Better custom support and better optional params */
    DataTable.BetterColumns = {
        Custom: function (title, dataIndex, optional) {
            return {
                columnProps: {
                    title: title,
                    dataIndex: dataIndex,
                    sorter: (optional === null || optional === void 0 ? void 0 : optional.sorter) != null ? optional.sorter : true,
                    width: optional === null || optional === void 0 ? void 0 : optional.width,
                    render: (optional === null || optional === void 0 ? void 0 : optional.render) != null ? function (_, record, index) { return optional.render(record, index); } : undefined,
                    fixed: optional === null || optional === void 0 ? void 0 : optional.fixed,
                    align: optional === null || optional === void 0 ? void 0 : optional.align
                },
                renderer: Renderer[optional === null || optional === void 0 ? void 0 : optional.renderer] || Renderer.DEFAULT,
                filterType: Filterer[optional === null || optional === void 0 ? void 0 : optional.filterType] || Filterer.Text,
                filterItems: (optional === null || optional === void 0 ? void 0 : optional.filterItems) || undefined
            };
        },
        /**Last resort if you absolutely need full control */
        FullManual: function (title, dataIndex, optional) {
            return {
                columnProps: {
                    title: title,
                    dataIndex: dataIndex || "",
                    sorter: (optional === null || optional === void 0 ? void 0 : optional.sorter) != null ? optional.sorter : true,
                    width: optional === null || optional === void 0 ? void 0 : optional.width,
                    render: (optional === null || optional === void 0 ? void 0 : optional.render) != null ? function (_, record, index) { return optional.render(record, index); } : undefined,
                    fixed: optional === null || optional === void 0 ? void 0 : optional.fixed,
                    align: optional === null || optional === void 0 ? void 0 : optional.align
                },
                renderer: Renderer[optional === null || optional === void 0 ? void 0 : optional.renderer] || Renderer.DEFAULT,
                filterType: Filterer[optional === null || optional === void 0 ? void 0 : optional.filterType] || Filterer.Text,
                filterItems: (optional === null || optional === void 0 ? void 0 : optional.filterItems) || undefined
            };
        }
    };
    return DataTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["e"] = (DataTable);


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pixel.f2a86377.png";

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeInteractiveCursor;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateInteractiveCursor;
/**
 * Initializes all scene objects to have the appropriate cursor when interactive (pointer for something that should be clicked on, hand if it's draggable)
 */
function initializeInteractiveCursor(scene) {
    scene.input.setDefaultCursor("default");
    scene.children.list.forEach(function (ob) {
        if (ob.input != null && ob.input.enabled) {
            // Draggable objects
            if (ob.input.draggable) {
                if (ob.input.dragState === 2) { // Actively being dragged
                    ob.input.cursor = "-webkit-grabbing";
                }
                else {
                    ob.input.cursor = "-webkit-grab";
                }
            }
            // Normal objects
            else {
                ob.input.cursor = "pointer";
            }
        }
    });
}
/**
 * For an update loop
 */
function updateInteractiveCursor(scene) {
    scene.children.list.forEach(function (ob) {
        if (ob.input != null && ob.input.enabled) {
            // Draggable objects
            if (ob.input.draggable) {
                if (ob.input.dragState === 2 || ob.input.dragState === 1) { // Actively being dragged
                    ob.input.cursor = "-webkit-grabbing";
                }
                else {
                    ob.input.cursor = "-webkit-grab";
                }
            }
        }
    });
}


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dynamicProto; });
/*!
 * Microsoft Dynamic Proto Utility, 1.1.11
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a;
var UNDEFINED = "undefined";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */
var DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */
var DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */
var DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */
var DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */
var DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */
var DynAllowInstChkTag = DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */
var DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */
var UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * The polyfill version of __proto__ so that it doesn't cause issues for anyone not expecting it to exist
 */
var DynProtoBaseProto = "_dyn" + str__Proto;
/**
 * Runtime Global holder for dynamicProto settings
 */
var DynProtoGlobalSettings = "__dynProto$Gbl";
/**
 * Track the current prototype for IE8 as you can't look back to get the prototype
 */
var DynProtoCurrent = "_dynInstProto";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strSetInstFuncs = 'setInstFuncs';
var Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Obj["getPrototypeOf"];
/**
 * Pre-lookup to check for the existence of this function
 */
var _objGetOwnProps = Obj["getOwnPropertyNames"];
/**
 * Gets the runtime global reference
 * @returns
 */
function _getGlobal() {
    var result;
    if (typeof globalThis !== UNDEFINED) {
        result = globalThis;
    }
    if (!result && typeof self !== UNDEFINED) {
        result = self;
    }
    if (!result && typeof window !== UNDEFINED) {
        result = window;
    }
    if (!result && typeof global !== UNDEFINED) {
        result = global;
    }
    return result || {};
}
// Since 1.1.7 moving these to the runtime global to work around mixed version and module issues
// See Issue https://github.com/microsoft/DynamicProto-JS/issues/57 for details
var _gbl = _getGlobal();
var _gblInst = _gbl[DynProtoGlobalSettings] || (_gbl[DynProtoGlobalSettings] = {
    o: (_a = {},
        _a[strSetInstFuncs] = true,
        _a[strUseBaseInst] = true,
        _a),
    n: 1000 // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
/**
 * Helper to check if the object contains a property of the name
 * @ignore
 */
function _hasOwnProperty(obj, prop) {
    return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
}
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */
function _isObjectOrArrayPrototype(target) {
    return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */
function _isObjectArrayOrFunctionPrototype(target) {
    return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    var newProto;
    if (target) {
        // This method doesn't exist in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        var curProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
        // Using the pre-calculated value as IE8 doesn't support looking up the prototype of a prototype and thus fails for more than 1 base class
        newProto = target[DynProtoBaseProto] || curProto;
        if (!_hasOwnProperty(target, DynProtoBaseProto)) {
            // As this prototype doesn't have this property then this is from an inherited class so newProto is the base to return so save it
            // so we can look it up value (which for a multiple hierarchy dynamicProto will be the base class)
            delete target[DynProtoCurrent]; // Delete any current value allocated to this instance so we pick up the value from prototype hierarchy
            newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
            target[DynProtoCurrent] = curProto;
        }
    }
    return newProto;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */
function _forEachProp(target, func) {
    var props = [];
    if (_objGetOwnProps) {
        props = _objGetOwnProps(target);
    }
    else {
        for (var name_1 in target) {
            if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
                props.push(name_1);
            }
        }
    }
    if (props && props.length > 0) {
        for (var lp = 0; lp < props.length; lp++) {
            func(props[lp]);
        }
    }
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */
function _isDynamicCandidate(target, funcName, skipOwn) {
    return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || _hasOwnProperty(target, funcName)) && funcName !== str__Proto && funcName !== Prototype);
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */
function _throwTypeError(message) {
    throw new TypeError("DynamicProto: " + message);
}
function _newObject() {
    return Object.create ? (function(obj) { /* ai_es3_polyfil create */ var func = Object["create"]; if (func) { return func(obj); } if (obj == null) { return {}; } var type = typeof obj; if (type !== 'object' && type !== 'function') { throw new TypeError('Object prototype may only be an Object:' + obj); } function tmpFunc() {} tmpFunc.prototype = obj; return new tmpFunc(); })(null) : {};
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */
function _getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = _newObject();
    // Save any existing instance functions
    _forEachProp(thisTarget, function (name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
            // Create an instance callback for passing the base function to the caller
            instFuncs[name] = thisTarget[name];
        }
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */
function _hasVisited(values, value) {
    for (var lp = values.length - 1; lp >= 0; lp--) {
        if (values[lp] === value) {
            return true;
        }
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[DynInstFuncTable] || {};
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
            }
        }
        return function () {
            // eslint-disable-next-line prefer-rest-params
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = _newObject();
    _forEachProp(instFuncs, function (name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = _getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
        // look for prototype functions
        _forEachProp(baseProto, function (name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
                // Create an instance callback for passing the base function to the caller
                baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
            }
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = _getObjProto(baseProto);
    }
    return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && _hasOwnProperty(proto, DynClassName)) {
        var instFuncTable = target[DynInstFuncTable] || _newObject();
        instFunc = (instFuncTable[proto[DynClassName]] || _newObject())[funcName];
        if (!instFunc) {
            // Avoid stack overflow from recursive calling the same function
            _throwTypeError("Missing [" + funcName + "] " + strFunction);
        }
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !_hasOwnProperty(target, funcName);
            // Get current prototype
            var objProto = _getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = (protoFunc === currentDynProtoProxy);
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = _getObjProto(objProto);
            }
            try {
                if (canAddInst) {
                    // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                    // so it's safe to directly assign for any subsequent calls (for better performance)
                    target[funcName] = instFunc;
                }
                // Block further attempts to set the instance function for any
                instFunc[DynInstChkTag] = 1;
            }
            catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) {
        // It is so lookup the base prototype
        protoFunc = _getObjProto(proto)[funcName];
    }
    if (typeof protoFunc !== strFunction) {
        _throwTypeError("[" + funcName + "] is not a " + strFunction);
    }
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function () {
            // Use the instance or prototype function
            var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
            // eslint-disable-next-line prefer-rest-params
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || _newObject();
        if (!_isObjectOrArrayPrototype(instFuncTable)) {
            var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || _newObject()); // fetch and assign if as it may not exist yet
            // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
            }
            if (!_isObjectOrArrayPrototype(instFuncs_1)) {
                _forEachProp(target, function (name) {
                    // Only add overridden functions
                    if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                        // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                        instFuncs_1[name] = target[name];
                        delete target[name];
                        // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                        if (!_hasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
                            proto[name] = _createDynamicPrototype(proto, name);
                        }
                    }
                });
            }
        }
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */
function _checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if (_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = _getObjProto(thisTarget);
        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
            if (thisProto === classProto) {
                return true;
            }
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = _getObjProto(thisProto);
        }
        return false;
    }
    // If objGetPrototypeOf doesn't exist then just assume everything is ok.
    return true;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */
function _getObjName(target, unknownValue) {
    if (_hasOwnProperty(target, Prototype)) {
        // Look like a prototype
        return target.name || unknownValue || UnknownValue;
    }
    return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */
function dynamicProto(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!_hasOwnProperty(theClass, Prototype)) {
        _throwTypeError("theClass is an invalid class definition.");
    }
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[Prototype];
    if (!_checkPrototype(classProto, target)) {
        _throwTypeError("[" + _getObjName(theClass) + "] not in hierarchy of [" + _getObjName(target) + "]");
    }
    var className = null;
    if (_hasOwnProperty(classProto, DynClassName)) {
        // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
        className = classProto[DynClassName];
    }
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _gblInst.n;
        _gblInst.n++;
        classProto[DynClassName] = className;
    }
    var perfOptions = dynamicProto[DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[strUseBaseInst];
    if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
        useBaseInst = !!options[strUseBaseInst];
    }
    // Get the current instance functions
    var instFuncs = _getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
    if (setInstanceFunc && options) {
        setInstanceFunc = !!options[strSetInstFuncs];
    }
    // Populate the Prototype for any overridden instance functions
    _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */
dynamicProto[DynProtoDefaultOptions] = _gblInst.o;


//# sourceMappingURL=dynamicproto-js.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PropertiesPluginIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BreezeChannelIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnalyticsPluginIdentifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Util__ = __webpack_require__(760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ThrottleMgr__ = __webpack_require__(1893);
/* unused harmony reexport ThrottleMgr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConnectionStringParser__ = __webpack_require__(1894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_2__ConnectionStringParser__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__ConnectionStringParser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RequestResponseHeaders__ = __webpack_require__(769);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_3__RequestResponseHeaders__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_4__Constants__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_4__Constants__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_4__Constants__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__Constants__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__Constants__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__Constants__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_4__Constants__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Telemetry_Common_Envelope__ = __webpack_require__(1895);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__Telemetry_Common_Envelope__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Telemetry_Event__ = __webpack_require__(1896);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__Telemetry_Event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Telemetry_Exception__ = __webpack_require__(1897);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__Telemetry_Exception__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Telemetry_Metric__ = __webpack_require__(1899);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_8__Telemetry_Metric__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Telemetry_PageView__ = __webpack_require__(1901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__Telemetry_PageView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Telemetry_RemoteDependencyData__ = __webpack_require__(1902);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_10__Telemetry_RemoteDependencyData__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Telemetry_Trace__ = __webpack_require__(1903);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_11__Telemetry_Trace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Telemetry_PageViewPerformance__ = __webpack_require__(1904);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_12__Telemetry_PageViewPerformance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Telemetry_Common_Data__ = __webpack_require__(1905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_13__Telemetry_Common_Data__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Interfaces_Contracts_SeverityLevel__ = __webpack_require__(1906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_14__Interfaces_Contracts_SeverityLevel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Interfaces_IConfig__ = __webpack_require__(1907);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_15__Interfaces_IConfig__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Interfaces_Contracts_ContextTagKeys__ = __webpack_require__(774);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__Interfaces_Contracts_ContextTagKeys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Telemetry_Common_DataSanitizer__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_17__Telemetry_Common_DataSanitizer__["a"]; });
/* unused harmony reexport dataSanitizeKeyAndAddUniqueness */
/* unused harmony reexport dataSanitizeKey */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_17__Telemetry_Common_DataSanitizer__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_17__Telemetry_Common_DataSanitizer__["h"]; });
/* unused harmony reexport dataSanitizeMessage */
/* unused harmony reexport dataSanitizeException */
/* unused harmony reexport dataSanitizeProperties */
/* unused harmony reexport dataSanitizeMeasurements */
/* unused harmony reexport dataSanitizeId */
/* unused harmony reexport dataSanitizeInput */
/* unused harmony reexport dsPadNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TelemetryItemCreator__ = __webpack_require__(1908);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_18__TelemetryItemCreator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_18__TelemetryItemCreator__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Interfaces_PartAExtensions__ = __webpack_require__(1909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_19__Interfaces_PartAExtensions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_19__Interfaces_PartAExtensions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Enums__ = __webpack_require__(770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_20__Enums__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__HelperFuncs__ = __webpack_require__(344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_21__HelperFuncs__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_21__HelperFuncs__["c"]; });
/* unused harmony reexport getExtensionByName */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_21__HelperFuncs__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* unused harmony reexport isBeaconApiSupported */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_22__microsoft_applicationinsights_core_js__["y"]; });
/* unused harmony reexport parseTraceParent */
/* unused harmony reexport isValidTraceId */
/* unused harmony reexport isValidSpanId */
/* unused harmony reexport isValidTraceParent */
/* unused harmony reexport isSampledFlag */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_22__microsoft_applicationinsights_core_js__["J"]; });
/* unused harmony reexport findW3cTraceParent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DomHelperFuncs__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_23__DomHelperFuncs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__ = __webpack_require__(487);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["b"]; });
/* unused harmony reexport utlGetSessionStorageKeys */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_24__StorageHelperFuncs__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__UrlHelperFuncs__ = __webpack_require__(771);
/* unused harmony reexport urlParseUrl */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_25__UrlHelperFuncs__["a"]; });
/* unused harmony reexport urlGetPathName */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_25__UrlHelperFuncs__["b"]; });
/* unused harmony reexport urlParseHost */
/* unused harmony reexport urlParseFullHost */
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// Licensed under the


























var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
//# sourceMappingURL=applicationinsights-common.js.map

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getObjProto;
/* unused harmony export objToString */
/* harmony export (immutable) */ __webpack_exports__["x"] = isTypeof;
/* harmony export (immutable) */ __webpack_exports__["y"] = isUndefined;
/* unused harmony export isNotUndefined */
/* harmony export (immutable) */ __webpack_exports__["s"] = isNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["r"] = isNotNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["l"] = hasOwnProperty;
/* harmony export (immutable) */ __webpack_exports__["u"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["q"] = isFunction;
/* unused harmony export isPromiseLike */
/* harmony export (immutable) */ __webpack_exports__["z"] = normalizeJsName;
/* harmony export (immutable) */ __webpack_exports__["C"] = objForEachKey;
/* harmony export (immutable) */ __webpack_exports__["L"] = strEndsWith;
/* unused harmony export _strEndsWithPoly */
/* unused harmony export strStartsWith */
/* unused harmony export _strStartsWithPoly */
/* harmony export (immutable) */ __webpack_exports__["K"] = strContains;
/* harmony export (immutable) */ __webpack_exports__["o"] = isDate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isArray; });
/* harmony export (immutable) */ __webpack_exports__["p"] = isError;
/* harmony export (immutable) */ __webpack_exports__["v"] = isString;
/* harmony export (immutable) */ __webpack_exports__["t"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["n"] = isBoolean;
/* unused harmony export isSymbol */
/* unused harmony export isPlainObject */
/* harmony export (immutable) */ __webpack_exports__["O"] = toISOString;
/* unused harmony export _toISOStringPoly */
/* harmony export (immutable) */ __webpack_exports__["b"] = arrForEach;
/* harmony export (immutable) */ __webpack_exports__["c"] = arrIndexOf;
/* harmony export (immutable) */ __webpack_exports__["d"] = arrMap;
/* harmony export (immutable) */ __webpack_exports__["e"] = arrReduce;
/* harmony export (immutable) */ __webpack_exports__["M"] = strTrim;
/* harmony export (immutable) */ __webpack_exports__["E"] = objKeys;
/* harmony export (immutable) */ __webpack_exports__["A"] = objDefineAccessors;
/* harmony export (immutable) */ __webpack_exports__["h"] = deepFreeze;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return objFreeze; });
/* unused harmony export objSeal */
/* harmony export (immutable) */ __webpack_exports__["g"] = dateNow;
/* harmony export (immutable) */ __webpack_exports__["j"] = getExceptionName;
/* harmony export (immutable) */ __webpack_exports__["J"] = setValue;
/* harmony export (immutable) */ __webpack_exports__["k"] = getSetValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = getCfgValue;
/* unused harmony export isNotTruthy */
/* harmony export (immutable) */ __webpack_exports__["w"] = isTruthy;
/* harmony export (immutable) */ __webpack_exports__["N"] = throwError;
/* harmony export (immutable) */ __webpack_exports__["G"] = proxyAssign;
/* harmony export (immutable) */ __webpack_exports__["H"] = proxyFunctionAs;
/* harmony export (immutable) */ __webpack_exports__["I"] = proxyFunctions;
/* harmony export (immutable) */ __webpack_exports__["f"] = createClassFromInterface;
/* harmony export (immutable) */ __webpack_exports__["F"] = optimizeObject;
/* harmony export (immutable) */ __webpack_exports__["B"] = objExtend;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InternalConstants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minfication
var strToISOString = "toISOString";
var cStrEndsWith = "endsWith";
var cStrStartsWith = "startsWith";
var strIndexOf = "indexOf";
var strMap = "map";
var strReduce = "reduce";
var cStrTrim = "trim";
var strToString = "toString";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
  * Constant string defined to support minimization
  * @ignore
  */
var strConstructor = "constructor";
var _objDefineProperty = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["c" /* ObjDefineProperty */];
var _objFreeze = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */].freeze;
var _objSeal = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */].seal;
var _objKeys = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */].keys;
var StringProto = String[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]];
var _strTrim = StringProto[cStrTrim];
var _strEndsWith = StringProto[cStrEndsWith];
var _strStartsWith = StringProto[cStrStartsWith];
var DateProto = Date[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]];
var _dataToISOString = DateProto[strToISOString];
var _isArray = Array.isArray;
var _objToString = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["e" /* ObjProto */][strToString];
var _fnToString = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */][strToString];
// Cache what this browser reports as the object function constructor (as a string)
var _objFunctionString = _fnToString[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]);
var rCamelCase = /-([a-z])/g;
var rNormalizeInvalid = /([^\w\d_$])/g;
var rLeadingNumeric = /^(\d+[\w\d_$])/;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Object["getPrototypeOf"];
/**
  * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
  * @ignore
  */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]] || target[strConstructor];
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
function objToString(obj) {
    return _objToString[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](obj);
}
function isTypeof(value, theType) {
    return typeof value === theType;
}
function isUndefined(value) {
    return value === undefined || typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
}
function isNotUndefined(value) {
    return !isUndefined(value);
}
function isNullOrUndefined(value) {
    return (value === null || isUndefined(value));
}
function isNotNullOrUndefined(value) {
    return !isNullOrUndefined(value);
}
function hasOwnProperty(obj, prop) {
    return !!(obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */][__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](obj, prop));
}
function isObject(value) {
    // Changing to inline for performance
    return !!(value && typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */]);
}
function isFunction(value) {
    // Changing to inline for performance
    return !!(value && typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */]);
}
function isPromiseLike(value) {
    return value && isFunction(value.then);
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name The name to validate
 */
function normalizeJsName(name) {
    var value = name;
    if (value && isString(value)) {
        // CamelCase everything after the "-" and remove the dash
        value = value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["J" /* _DYN_REPLACE */] /* @min:%2ereplace */](rCamelCase, function (_all, letter) {
            return letter.toUpperCase();
        });
        value = value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["J" /* _DYN_REPLACE */] /* @min:%2ereplace */](rNormalizeInvalid, "_");
        value = value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["J" /* _DYN_REPLACE */] /* @min:%2ereplace */](rLeadingNumeric, function (_all, match) {
            return "_" + match;
        });
    }
    return value;
}
/**
 * This is a helper function for the equivalent of arForEach(objKeys(target), callbackFn), this is a
 * performance optimization to avoid the creation of a new array for large objects
 * @param target The target object to find and process the keys
 * @param callbackfn The function to call with the details
 */
function objForEachKey(target, callbackfn) {
    if (target) {
        for (var prop in target) {
            if (__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */][__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](target, prop)) {
                callbackfn[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](target, prop, target[prop]);
            }
        }
    }
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    var result = false;
    if (value && search && !(result = value === search)) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        result = _strEndsWith ? value[cStrEndsWith](search) : _strEndsWithPoly(value, search);
    }
    return result;
}
/**
 * The _strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function _strEndsWithPoly(value, search) {
    var result = false;
    var searchLen = search ? search[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] : 0;
    var valLen = value ? value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] : 0;
    if (searchLen && valLen && valLen >= searchLen && !(result = value === search)) {
        var pos = valLen - 1;
        for (var lp = searchLen - 1; lp >= 0; lp--) {
            if (value[pos] != search[lp]) {
                return false;
            }
            pos--;
        }
        result = true;
    }
    return result;
}
/**
 * The strStartsWith() method determines whether a string starts with the characters of the specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param checkValue - The characters to be searched for at the start of the value.
 * @returns true if the given search value is found at the start of the string, otherwise false.
 */
function strStartsWith(value, checkValue) {
    var result = false;
    if (value && checkValue && !(result = value === checkValue)) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        result = _strStartsWith ? value[cStrStartsWith](checkValue) : _strStartsWithPoly(value, checkValue);
    }
    return result;
}
/**
 * The strStartsWith() method determines whether a string starts with the characters of the specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param checkValue - The characters to be searched for at the start of the value.
 * @returns true if the given search value is found at the start of the string, otherwise false.
 */
function _strStartsWithPoly(value, checkValue) {
    // Using helper for performance and because string startsWith() is not available on IE
    var result = false;
    var chkLen = checkValue ? checkValue[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] : 0;
    if (value && chkLen && value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] >= chkLen && !(result = value === checkValue)) {
        for (var lp = 0; lp < chkLen; lp++) {
            if (value[lp] !== checkValue[lp]) {
                return false;
            }
        }
        result = true;
    }
    return result;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
function strContains(value, search) {
    if (value && search) {
        return value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["r" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */](search) !== -1;
    }
    return false;
}
/**
 * Check if an object is of type Date
 */
function isDate(obj) {
    return !!(obj && _objToString[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](obj) === "[object Date]");
}
/**
 * Check if an object is of type Array with optional generic T, the generic type is not validated
 * and exists to help with TypeScript validation only.
 */
var isArray = _isArray || _isArrayPoly;
function _isArrayPoly(obj) {
    return !!(obj && _objToString[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](obj) === "[object Array]");
}
/**
 * Check if an object is of type Error
 */
function isError(obj) {
    return !!(obj && _objToString[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](obj) === "[object Error]");
}
/**
 * Checks if the type of value is a string.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a string, false otherwise.
 */
function isString(value) {
    // Changing to inline for performance
    return typeof value === "string";
}
/**
 * Checks if the type of value is a number.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
function isNumber(value) {
    // Changing to inline for performance
    return typeof value === "number";
}
/**
 * Checks if the type of value is a boolean.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a boolean, false otherwise.
 */
function isBoolean(value) {
    // Changing to inline for performance
    return typeof value === "boolean";
}
/**
 * Checks if the type of value is a Symbol.
 * This only returns a boolean as returning value is Symbol will cause issues for older TypeScript consumers
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a Symbol, false otherwise.
 */
function isSymbol(value) {
    return typeof value === "symbol";
}
/**
 * Checks if the type of the value is a normal plain object (not a null or data)
 * @param value
 */
function isPlainObject(value) {
    var result = false;
    if (value && typeof value === "object") {
        // Inlining _objGetPrototypeOf for performance to avoid an additional function call
        var proto = _objGetPrototypeOf ? _objGetPrototypeOf(value) : _getObjProto(value);
        if (!proto) {
            // No prototype found so this is a plain Object eg. 'Object.create(null)'
            result = true;
        }
        else {
            // Objects that have a prototype are plain only if they were created using the Object global (native) function
            if (proto[strConstructor] && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */][__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](proto, strConstructor)) {
                proto = proto[strConstructor];
            }
            result = typeof proto === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */] && _fnToString[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](proto) === _objFunctionString;
        }
    }
    return result;
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function toISOString(date) {
    if (date) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        return _dataToISOString ? date[strToISOString]() : _toISOStringPoly(date);
    }
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function _toISOStringPoly(date) {
    if (date && date.getUTCFullYear) {
        var pad = function (num) {
            var r = String(num);
            if (r[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] === 1) {
                r = "0" + r;
            }
            return r;
        };
        return date.getUTCFullYear()
            + "-" + pad(date.getUTCMonth() + 1)
            + "-" + pad(date.getUTCDate())
            + "T" + pad(date.getUTCHours())
            + ":" + pad(date.getUTCMinutes())
            + ":" + pad(date.getUTCSeconds())
            + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
            + "Z";
    }
}
/**
 * Performs the specified action for each element in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array. It can return -1 to break out of the loop
 * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrForEach(arr, callbackfn, thisArg) {
    var len = arr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
    try {
        for (var idx = 0; idx < len; idx++) {
            if (idx in arr) {
                if (callbackfn[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](thisArg || arr, arr[idx], idx, arr) === -1) {
                    break;
                }
            }
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
}
/**
 * Returns the index of the first occurrence of a value in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param searchElement The value to locate in the array.
 * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
 */
function arrIndexOf(arr, searchElement, fromIndex) {
    if (arr) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        if (arr[strIndexOf]) {
            return arr[strIndexOf](searchElement, fromIndex);
        }
        var len = arr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
        var from = fromIndex || 0;
        try {
            for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
                if (lp in arr && arr[lp] === searchElement) {
                    return lp;
                }
            }
        }
        catch (e) {
            // This can happen with some native browser objects, but should not happen for the type we are checking for
        }
    }
    return -1;
}
/**
 * Calls a defined callback function on each element of an array, and returns an array that contains the results. This helper exists
 * to avoid adding a polyfil for older browsers that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page
 * checks for presence/absence of the prototype implementation. Note: For consistency this will not use the Array.prototype.xxxx
 * implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrMap(arr, callbackfn, thisArg) {
    var results;
    if (arr) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        if (arr[strMap]) {
            return arr[strMap](callbackfn, thisArg);
        }
        var len = arr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
        var _this = thisArg || arr;
        results = new Array(len);
        try {
            for (var lp = 0; lp < len; lp++) {
                if (lp in arr) {
                    results[lp] = callbackfn[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](_this, arr[lp], arr);
                }
            }
        }
        catch (e) {
            // This can happen with some native browser objects, but should not happen for the type we are checking for
        }
    }
    return results;
}
/**
 * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is
 * provided as an argument in the next call to the callback function. This helper exists to avoid adding a polyfil for older browsers that do not define
 * Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype implementation. Note: For consistency
 * this will not use the Array.prototype.xxxx implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
 * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
 */
function arrReduce(arr, callbackfn, initialValue) {
    var value;
    if (arr) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        if (arr[strReduce]) {
            return arr[strReduce](callbackfn, initialValue);
        }
        var len = arr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
        var lp = 0;
        // Specifically checking the number of passed arguments as the value could be anything
        if (arguments[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] >= 3) {
            value = arguments[2];
        }
        else {
            while (lp < len && !(lp in arr)) {
                lp++;
            }
            value = arr[lp++];
        }
        while (lp < len) {
            if (lp in arr) {
                value = callbackfn(value, arr[lp], lp, arr);
            }
            lp++;
        }
    }
    return value;
}
/**
 * helper method to trim strings (IE8 does not implement String.prototype.trim)
 */
function strTrim(str) {
    if (str) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        str = (_strTrim && str[cStrTrim]) ? str[cStrTrim]() : (str[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["J" /* _DYN_REPLACE */] /* @min:%2ereplace */] ? str[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["J" /* _DYN_REPLACE */] /* @min:%2ereplace */](/^\s+|(?=\s)\s+$/g, __WEBPACK_IMPORTED_MODULE_2__InternalConstants__["e" /* STR_EMPTY */]) : str);
    }
    return str;
}
var _objKeysHasDontEnumBug = !({ toString: null }).propertyIsEnumerable("toString");
var _objKeysDontEnums = [
    "toString",
    "toLocaleString",
    "valueOf",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "constructor"
];
/**
 * Returns the names of the enumerable string properties and methods of an object. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Object.keys eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.keys implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object that contains the properties and methods. This can be an object that you created or an existing Document Object Model (DOM) object.
 */
function objKeys(obj) {
    var objType = typeof obj;
    if (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */] && (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] || obj === null)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["n" /* throwTypeError */])("objKeys called on non-object");
    }
    // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    if (!_objKeysHasDontEnumBug && _objKeys) {
        return _objKeys(obj);
    }
    var result = [];
    for (var prop in obj) {
        if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */][__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](obj, prop)) {
            result[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](prop);
        }
    }
    if (_objKeysHasDontEnumBug) {
        var dontEnumsLength = _objKeysDontEnums[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
        for (var lp = 0; lp < dontEnumsLength; lp++) {
            if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */][__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](obj, _objKeysDontEnums[lp])) {
                result[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](_objKeysDontEnums[lp]);
            }
        }
    }
    return result;
}
/**
 * Try to define get/set object property accessors for the target object/prototype, this will provide compatibility with
 * existing API definition when run within an ES5+ container that supports accessors but still enable the code to be loaded
 * and executed in an ES3 container, providing basic IE8 compatibility.
 * @param target The object on which to define the property.
 * @param prop The name of the property to be defined or modified.
 * @param getProp The getter function to wire against the getter.
 * @param setProp The setter function to wire against the setter.
 * @returns True if it was able to create the accessors otherwise false
 */
function objDefineAccessors(target, prop, getProp, setProp) {
    if (_objDefineProperty) {
        try {
            var descriptor = {
                enumerable: true,
                configurable: true
            };
            if (getProp) {
                descriptor.get = getProp;
            }
            if (setProp) {
                descriptor.set = setProp;
            }
            _objDefineProperty(target, prop, descriptor);
            return true;
        }
        catch (e) {
            // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
            // We will just ignore this here.
        }
    }
    return false;
}
function _doNothing(value) {
    return value;
}
function deepFreeze(obj) {
    if (_objFreeze) {
        objForEachKey(obj, function (name, value) {
            if (isArray(value) || isObject(value)) {
                _objFreeze(value);
            }
        });
    }
    return objFreeze(obj);
}
var objFreeze = _objFreeze || _doNothing;
var objSeal = _objSeal || _doNothing;
/**
 * Return the current time via the Date now() function (if available) and falls back to (new Date()).getTime() if now() is unavailable (IE8 or less)
 * https://caniuse.com/#search=Date.now
 */
function dateNow() {
    var dt = Date;
    return dt.now ? dt.now() : new dt().getTime();
}
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
function getExceptionName(object) {
    if (isError(object)) {
        return object[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["D" /* _DYN_NAME */] /* @min:%2ename */];
    }
    return __WEBPACK_IMPORTED_MODULE_2__InternalConstants__["e" /* STR_EMPTY */];
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && isNullOrUndefined(theValue)) {
            // Supports having the default as null
            theValue = !isUndefined(defValue) ? defValue : {};
            target[field] = theValue;
        }
    }
    else {
        // Expanded for performance so we only check defValue if required
        theValue = !isUndefined(defValue) ? defValue : {};
    }
    return theValue;
}
/**
 * Get the mapped config value, if null or undefined any supplied defaultValue will be returned.
 * @param field - The name of the field as the named enum value (number) or the string name.
 * @param defaultValue - The default value to return if the config field is not present, null or undefined.
 */
function getCfgValue(theValue, defaultValue) {
    return !isNullOrUndefined(theValue) ? theValue : defaultValue;
}
function isNotTruthy(value) {
    return !value;
}
function isTruthy(value) {
    return !!value;
}
function throwError(message) {
    throw new Error(message);
}
function _createProxyFunction(source, funcName) {
    var srcFunc = null;
    var src = null;
    if (isFunction(source)) {
        srcFunc = source;
    }
    else {
        src = source;
    }
    return function () {
        // Capture the original arguments passed to the method
        var originalArguments = arguments;
        if (srcFunc) {
            src = srcFunc();
        }
        if (src) {
            return src[funcName][__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["b" /* _DYN_APPLY */] /* @min:%2eapply */](src, originalArguments);
        }
    };
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 => will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 */
function proxyAssign(target, source, chkSet) {
    if (target && source && isObject(target) && isObject(source)) {
        var _loop_1 = function (field) {
            if (isString(field)) {
                var value = source[field];
                if (isFunction(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) {
                        // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                        target[field] = _createProxyFunction(source, field);
                    }
                }
                else if (!chkSet || chkSet(field, false, source, target)) {
                    if (hasOwnProperty(target, field)) {
                        // Remove any previous instance property
                        delete target[field];
                    }
                    if (!objDefineAccessors(target, field, function () {
                        return source[field];
                    }, function (theValue) {
                        source[field] = theValue;
                    })) {
                        // Unable to create an accessor, so just assign the values as a fallback
                        // -- this will (mostly) work for objects
                        // -- but will fail for accessing primitives (if the source changes it) and all types of "setters" as the source won't be modified
                        target[field] = value;
                    }
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for (var field in source) {
            _loop_1(field);
        }
    }
    return target;
}
/**
 * Creates a proxy function on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param name - The function name that will be added on the target
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param theFunc - The function name on the source that will be proxied on the target
 * @param overwriteTarget - If `false` this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctionAs(target, name, source, theFunc, overwriteTarget) {
    if (target && name && source) {
        if (overwriteTarget !== false || isUndefined(target[name])) {
            target[name] = _createProxyFunction(source, theFunc);
        }
    }
}
/**
 * Creates proxy functions on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param functionsToProxy - An array of function names that will be proxied on the target
 * @param overwriteTarget - If false this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctions(target, source, functionsToProxy, overwriteTarget) {
    if (target && source && isObject(target) && isArray(functionsToProxy)) {
        arrForEach(functionsToProxy, function (theFuncName) {
            if (isString(theFuncName)) {
                proxyFunctionAs(target, theFuncName, source, theFuncName, overwriteTarget);
            }
        });
    }
    return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults Simple helper
 */
function createClassFromInterface(defaults) {
    return /** @class */ (function () {
        function class_1() {
            var _this_1 = this;
            if (defaults) {
                objForEachKey(defaults, function (field, value) {
                    _this_1[field] = value;
                });
            }
        }
        return class_1;
    }());
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
function optimizeObject(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */]) {
        theObject = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */])({}, theObject));
    }
    return theObject;
}
function objExtend(obj1, obj2, obj3, obj4, obj5, obj6) {
    // Variables
    var theArgs = arguments;
    var extended = theArgs[0] || {};
    var argLen = theArgs[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
    var deep = false;
    var idx = 1;
    // Check for "Deep" flag
    if (argLen > 0 && isBoolean(extended)) {
        deep = extended;
        extended = theArgs[idx] || {};
        idx++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if (!isObject(extended)) {
        extended = {};
    }
    // Loop through each remaining object and conduct a merge
    for (; idx < argLen; idx++) {
        var arg = theArgs[idx];
        var isArgArray = isArray(arg);
        var isArgObj = isObject(arg);
        for (var prop in arg) {
            var propOk = (isArgArray && (prop in arg)) || (isArgObj && (__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */][__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](arg, prop)));
            if (!propOk) {
                continue;
            }
            var newValue = arg[prop];
            var isNewArray = void 0;
            // If deep merge and property is an object, merge properties
            if (deep && newValue && ((isNewArray = isArray(newValue)) || isPlainObject(newValue))) {
                // Grab the current value of the extended object
                var clone = extended[prop];
                if (isNewArray) {
                    if (!isArray(clone)) {
                        // We can't "merge" an array with a non-array so overwrite the original
                        clone = [];
                    }
                }
                else if (!isPlainObject(clone)) {
                    // We can't "merge" an object with a non-object
                    clone = {};
                }
                // Never move the original objects always clone them
                newValue = objExtend(deep, clone, newValue);
            }
            // Assign the new (or previous) value (unless undefined)
            if (newValue !== undefined) {
                extended[prop] = newValue;
            }
        }
    }
    return extended;
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return _DYN_INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return _DYN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return _DYN_GET_NOTIFY_MGR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _DYN_IDENTIFIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return _DYN_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return _DYN_IS_INITIALIZED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _DYN_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return _DYN_INSTRUMENTATION_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return _DYN_LOGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return _DYN_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return _DYN_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return _DYN_PROCESS_NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _DYN_GET_PROCESS_TEL_CONT0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _DYN_ADD_NOTIFICATION_LIS1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return _DYN_REMOVE_NOTIFICATION_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return _DYN_STOP_POLLING_INTERNA3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return _DYN_ON_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _DYN_GET_PLUGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _DYN_FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return _DYN__EXTENSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return _DYN_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return _DYN_TEARDOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return _DYN_MESSAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return _DYN_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return _DYN_IS_ASYNC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return _DYN__DO_TEARDOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return _DYN_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _DYN_GET_NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _DYN_DIAG_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return _DYN_SET_NEXT_PLUGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _DYN_CREATE_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _DYN_COOKIE_CFG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _DYN_INDEX_OF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return _DYN_SUBSTRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return _DYN_USER_AGENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return _DYN_SPLIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return _DYN_SET_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return _DYN_SUBSTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return _DYN_NODE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _DYN_APPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return _DYN_REPLACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _DYN_ENABLE_DEBUG_EXCEPTI4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return _DYN_LOG_INTERNAL_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return _DYN_TO_LOWER_CASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _DYN_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return _DYN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return _DYN_HANDLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return _DYN_LISTENERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return _DYN_IS_CHILD_EVT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _DYN_GET_CTX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return _DYN_SET_CTX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _DYN_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return _DYN_TRACE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return _DYN_SPAN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return _DYN_TRACE_FLAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return _DYN_VERSION; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_INITIALIZE = "initialize"; // Count: 8
var _DYN_NAME = "name"; // Count: 11
var _DYN_GET_NOTIFY_MGR = "getNotifyMgr"; // Count: 3
var _DYN_IDENTIFIER = "identifier"; // Count: 8
var _DYN_PUSH = "push"; // Count: 30
var _DYN_IS_INITIALIZED = "isInitialized"; // Count: 10
var _DYN_CONFIG = "config"; // Count: 7
var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 3
var _DYN_LOGGER = "logger"; // Count: 10
var _DYN_LENGTH = "length"; // Count: 45
var _DYN_TIME = "time"; // Count: 5
var _DYN_PROCESS_NEXT = "processNext"; // Count: 21
var _DYN_GET_PROCESS_TEL_CONT0 = "getProcessTelContext"; // Count: 2
var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener"; // Count: 5
var _DYN_REMOVE_NOTIFICATION_2 = "removeNotificationListener"; // Count: 5
var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs"; // Count: 2
var _DYN_ON_COMPLETE = "onComplete"; // Count: 6
var _DYN_GET_PLUGIN = "getPlugin"; // Count: 5
var _DYN_FLUSH = "flush"; // Count: 5
var _DYN__EXTENSIONS = "_extensions"; // Count: 4
var _DYN_SPLICE = "splice"; // Count: 6
var _DYN_TEARDOWN = "teardown"; // Count: 10
var _DYN_MESSAGE_ID = "messageId"; // Count: 4
var _DYN_MESSAGE = "message"; // Count: 7
var _DYN_IS_ASYNC = "isAsync"; // Count: 7
var _DYN__DO_TEARDOWN = "_doTeardown"; // Count: 4
var _DYN_UPDATE = "update"; // Count: 7
var _DYN_GET_NEXT = "getNext"; // Count: 12
var _DYN_DIAG_LOG = "diagLog"; // Count: 8
var _DYN_SET_NEXT_PLUGIN = "setNextPlugin"; // Count: 5
var _DYN_CREATE_NEW = "createNew"; // Count: 6
var _DYN_COOKIE_CFG = "cookieCfg"; // Count: 3
var _DYN_INDEX_OF = "indexOf"; // Count: 7
var _DYN_SUBSTRING = "substring"; // Count: 10
var _DYN_USER_AGENT = "userAgent"; // Count: 5
var _DYN_SPLIT = "split"; // Count: 6
var _DYN_SET_ENABLED = "setEnabled"; // Count: 5
var _DYN_SUBSTR = "substr"; // Count: 6
var _DYN_NODE_TYPE = "nodeType"; // Count: 3
var _DYN_APPLY = "apply"; // Count: 6
var _DYN_REPLACE = "replace"; // Count: 10
var _DYN_ENABLE_DEBUG_EXCEPTI4 = "enableDebugExceptions"; // Count: 2
var _DYN_LOG_INTERNAL_MESSAGE = "logInternalMessage"; // Count: 2
var _DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 8
var _DYN_CALL = "call"; // Count: 18
var _DYN_TYPE = "type"; // Count: 14
var _DYN_HANDLER = "handler"; // Count: 5
var _DYN_LISTENERS = "listeners"; // Count: 6
var _DYN_IS_CHILD_EVT = "isChildEvt"; // Count: 3
var _DYN_GET_CTX = "getCtx"; // Count: 6
var _DYN_SET_CTX = "setCtx"; // Count: 10
var _DYN_COMPLETE = "complete"; // Count: 3
var _DYN_TRACE_ID = "traceId"; // Count: 5
var _DYN_SPAN_ID = "spanId"; // Count: 5
var _DYN_TRACE_FLAGS = "traceFlags"; // Count: 6
var _DYN_VERSION = "version"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalOption */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PhaserModalConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhaserModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_PhaserModalBase__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_KeyboardNumKeys__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ModalOption = /** @class */ (function (_super) {
    __extends(ModalOption, _super);
    function ModalOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModalOption;
}(__WEBPACK_IMPORTED_MODULE_3__components_common_PhaserModalBase__["a" /* ModalOptionBase */]));

var PhaserModalConfig = /** @class */ (function (_super) {
    __extends(PhaserModalConfig, _super);
    function PhaserModalConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonWidth = 200;
        _this.buttonConfig = new __WEBPACK_IMPORTED_MODULE_1__Button__["b" /* PhaserButtonConfig */]();
        _this.borderColor = 0xffffff;
        return _this;
    }
    return PhaserModalConfig;
}(__WEBPACK_IMPORTED_MODULE_3__components_common_PhaserModalBase__["c" /* PhaserModalConfigBase */]));

var PhaserModal = /** @class */ (function (_super) {
    __extends(PhaserModal, _super);
    function PhaserModal(scene, x, y, options, config) {
        var _this = _super.call(this, scene, x, y, config) || this;
        _this.columns = false;
        _this.padding = 10;
        _this.options = options;
        _this.config = config;
        if (config == null) {
            _this.config = new PhaserModalConfig();
        }
        _this.buttonHeight = 30;
        if (_this.options.length === 1) {
            _this.config.buttonConfig.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        }
        else {
            _this.config.buttonConfig.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserModal.prototype);
        _this.initialize();
        _this.setScrollFactor(0);
        return _this;
    }
    PhaserModal.preload = function (scene) {
        scene.load.image("pixel", __webpack_require__(60));
    };
    PhaserModal.prototype.initialize = function () {
        var height;
        var width;
        if (this.config.title != null) {
            this.createTitle();
            height = this.title.getBottomLeft().y + (this.buttonHeight + 10) * (this.options.length + 1);
            width = 800;
        }
        else {
            height = this.buttonHeight * (this.options.length + 2);
            width = this.config.buttonWidth * 2;
        }
        this.setSize(width, height);
        // Construct Objects
        this.constructObjects();
        this.type = "PhaserModal";
        // Add this modal to the scene
        this.scene.add.existing(this);
        this.bindNumKeys();
    };
    /**
     * Adjusts the modal's size based on the sizes of the title and buttons within
     * Also adjusts to two columns if needed.
     */
    PhaserModal.prototype.adjustModalSizeBasedOnItems = function () {
        var _this = this;
        var height;
        var width;
        if (this.options.length > 4) {
            this.columns = true;
        }
        if (this.config.buttonConfig.smartSize) {
            var maxButtonHeight = 0;
            var maxButtonWidth = 0;
            this.buttons.forEach(function (b) {
                if (b.getIdealButtonHeight() >= maxButtonHeight) {
                    maxButtonHeight = b.getIdealButtonHeight();
                }
                if (b.getIdealButtonWidth() >= maxButtonWidth) {
                    maxButtonWidth = b.getIdealButtonWidth();
                }
            });
            this.config.buttonWidth = maxButtonWidth;
            this.buttonHeight = maxButtonHeight;
            this.buttons.forEach(function (b) {
                b.setDisplaySize(_this.config.buttonWidth, _this.buttonHeight);
            });
        }
        // Set height and width to be sufficient to hold all options
        if (this.config.title != null) {
            var optionSpace;
            if (this.options.length === 1) {
                optionSpace = this.buttonHeight * 2.5;
                width = Math.max(this.config.buttonWidth * 2, 3 * this.title.width / 4);
            }
            else if (!this.columns) {
                optionSpace = (this.buttonHeight + this.padding) * (this.options.length + 1);
                width = Math.max(this.config.buttonWidth * 2, 3 * this.title.width / 4);
            }
            else {
                optionSpace = (this.buttonHeight + this.padding) * Math.ceil(this.options.length / 2 + 1);
                width = Math.max(this.config.buttonWidth * 3, 3 * this.title.width / 4);
            }
            height = this.title.getBottomLeft().y + optionSpace;
        }
        else {
            if (!this.columns) {
                height = (this.buttonHeight + this.padding) * (this.options.length + 2);
                width = this.config.buttonWidth * 2;
            }
            else {
                height = (this.buttonHeight + this.padding) * Math.ceil(this.options.length / 2 + 2);
                width = this.config.buttonWidth * 3;
            }
        }
        this.setSize(width, height);
        // Now reset background and title positions and sizes
        this.background.setDisplaySize(this.width - this.padding, this.height - this.padding);
        this.border.setDisplaySize(this.width, this.height);
        if (this.config.title != null) {
            this.title.setWordWrapWidth(width - 2 * this.padding, true);
            this.title.setX(width / 2 - this.title.width / 2);
        }
    };
    /**
     * Create the buttons and at the same time keep track of the maximum buttonHeight
    */
    PhaserModal.prototype.createButtons = function () {
        var _this = this;
        var buttons = [];
        var index = 0;
        this.options.forEach(function (op) {
            var button = new __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* PhaserButton */](_this.scene, 0, 0, _this.config.buttonWidth, _this.buttonHeight, __WEBPACK_IMPORTED_MODULE_4_src_constants_KeyboardNumKeys__["a" /* numKeys */][index].display + ': ' + op.displayText, _this.config.buttonConfig);
            button.on('buttonClicked', function (pointer, x, y) {
                if (_this.scene.sound != null) {
                    _this.scene.sound.stopAll();
                }
                _this.emit('optionClicked', op, button);
            });
            buttons.push(button);
            index++;
        });
        return buttons;
    };
    /**
    * Go through already created buttons and adjust their sizes and positions (because now we will use the correct buttonHeight)
    */
    PhaserModal.prototype.adjustButtons = function () {
        var _this = this;
        var y;
        if (this.config.title != null) {
            y = this.title.getBottomLeft().y;
        }
        else {
            y = this.buttonHeight + this.padding;
        }
        var buttonIndex = 0;
        this.buttons.forEach(function (button) {
            var buttonX = _this.getXCoordinate(buttonIndex, button);
            // Restart y value for second column
            if (_this.columns && buttonIndex === Math.ceil(_this.options.length / 2)) {
                if (_this.config.title != null) {
                    y = _this.title.getBottomLeft().y;
                }
                else {
                    y = _this.buttonHeight + _this.padding;
                }
            }
            // Adjust position
            button.setPosition(buttonX, y);
            button.setDisplaySize(_this.config.buttonWidth, _this.buttonHeight);
            button.height = _this.buttonHeight;
            _this.add(button);
            y += _this.buttonHeight + _this.padding;
            buttonIndex++;
        });
    };
    /**
    *  Helper method to get the x coordinate for the button based on if there are columns or not
    */
    PhaserModal.prototype.getXCoordinate = function (buttonIndex, button) {
        var buttonX;
        // First column
        if (this.columns && buttonIndex < Math.ceil(this.options.length / 2)) {
            buttonX = this.width / 4 - this.config.buttonWidth / 4;
        }
        // Second column
        else if (this.columns && buttonIndex >= Math.ceil(this.options.length / 2)) {
            buttonX = this.config.buttonWidth + this.padding + this.width / 4 - button.width / 4;
        }
        // No columns (in the middle)
        else {
            buttonX = this.width / 2 - this.config.buttonWidth / 2;
        }
        return buttonX;
    };
    PhaserModal.prototype.constructObjects = function () {
        // Border of the modal
        this.border = this.scene.add.image(-this.padding / 2, -this.padding / 2, "pixel");
        this.border.setOrigin(0);
        this.border.setTint(this.config.borderColor);
        this.border.setDisplaySize(this.width, this.height);
        this.add(this.border);
        // Background of the modal
        this.background = this.scene.add.image(0, 0, "pixel");
        this.background.setDisplaySize(this.width, this.height);
        this.background.setOrigin(0, 0);
        this.background.setTint(0x000000);
        this.add(this.background);
        // Size has changed so adjust title positioning
        if (this.config.title != null) {
            this.title.setWordWrapWidth(this.width, true);
            this.title.setX(this.width / 2 - this.title.width / 2);
            this.add(this.title);
        }
        this.buttons = this.createButtons();
        // Reset the modal size because buttonHeight was adjusted
        this.adjustModalSizeBasedOnItems();
        // Reset button positions and sizes
        this.adjustButtons();
    };
    PhaserModal.prototype.createTitle = function () {
        this.title = this.scene.add.text(0, 0, this.config.title);
        this.title.setOrigin(0, 0);
        this.title.setTint(0xffffff);
        this.title.setFontSize(20);
        this.title.setFontFamily('Russo One, Arial');
        this.title.setPadding(15, 15, 15, 15);
        this.title.setAlign('center');
        this.title.setWordWrapWidth(800 - 2 * this.padding, true);
        this.title.setX(this.width / 2 - this.title.width / 2);
    };
    return PhaserModal;
}(__WEBPACK_IMPORTED_MODULE_3__components_common_PhaserModalBase__["b" /* PhaserModalBase */]));



/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HttpApiRequestOptions */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var HttpApiRequestOptions = /** @class */ (function () {
    function HttpApiRequestOptions() {
        this.ignoreAuthenticationErrors = false;
        this.formData = null;
    }
    return HttpApiRequestOptions;
}());

var HttpApi = /** @class */ (function () {
    function HttpApi() {
    }
    HttpApi.Get = function (relativeUrl, requestOptions) {
        return HttpApi.baseRequest({}, relativeUrl, "GET", requestOptions);
    };
    HttpApi.Post = function (req, relativeUrl, requestOptions) {
        return HttpApi.baseRequest(req, relativeUrl, "POST", requestOptions);
    };
    HttpApi.Put = function (req, relativeUrl, requestOptions) {
        return HttpApi.baseRequest(req, relativeUrl, "PUT", requestOptions);
    };
    HttpApi.Delete = function (req, relativeUrl, requestOptions) {
        return HttpApi.baseRequest(req, relativeUrl, "DELETE", requestOptions);
    };
    HttpApi.baseInfo = function (req, method, requestOptions) {
        if (requestOptions.formData != null) {
            return {
                method: method,
                body: requestOptions.formData,
            };
        }
        var requestInfo = {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Cache': 'no-cache'
            },
            credentials: 'include'
        };
        requestInfo.headers = __assign(__assign({}, requestInfo.headers), requestOptions.additionalHeaders);
        if (method !== "GET") {
            requestInfo.body = JSON.stringify(req);
        }
        return requestInfo;
    };
    HttpApi.baseRequest = function (req, relativeUrl, method, requestOptions) {
        if (requestOptions === void 0) { requestOptions = new HttpApiRequestOptions(); }
        var info = HttpApi.baseInfo(req, method, requestOptions);
        var url = HttpApi.baseUrl + relativeUrl;
        return fetch(url, info)
            .then(function (response) {
            var headers = {};
            response.headers.forEach(function (value, key) { return headers[key] = value; });
            var actionResult = {
                headers: headers,
                ok: response.ok,
                redirected: response.redirected,
                status: response.status,
                statusText: response.statusText,
                data: {},
            };
            if (response.ok) {
                return response.text().then(function (text) {
                    if (text != null && text.length > 1) {
                        actionResult.data = JSON.parse(text);
                    }
                    return actionResult;
                });
            }
            if (response.status === 401) {
                if (!requestOptions.ignoreAuthenticationErrors) {
                    window.location.assign(location.protocol + "//" + location.host + "/login"); // Unauthorized!
                }
            }
            return actionResult;
        })
            .catch(function (e) {
            // Network errors popup here
            throw new Error(e.message);
        });
    };
    HttpApi.RestRequest = function (req, requestVerb, relativeUrl, requestOptions) {
        requestOptions = requestOptions || {};
        switch (requestVerb.toUpperCase()) {
            case "GET":
                return HttpApi.Get(relativeUrl, requestOptions);
            case "POST":
                return HttpApi.Post(req, relativeUrl, requestOptions);
            case "DELETE":
                return HttpApi.Delete(req, relativeUrl, requestOptions);
            case "PUT":
                return HttpApi.Put(req, relativeUrl, requestOptions);
            default:
                throw new Error("Verb '" + requestVerb + "' is not valid");
        }
    };
    HttpApi.baseUrl = "/";
    return HttpApi;
}());
/* harmony default export */ __webpack_exports__["a"] = (HttpApi);


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Grades; });
var Grades = /** @class */ (function () {
    function Grades() {
    }
    Grades.FindById = function (id) {
        return this.All.find(function (x) { return x.id === id; }) || this.Default;
    };
    Grades.FindNextGrade = function (grade) {
        var nextGrade = this.All.find(function (x) { return x.level === grade.level + 1; });
        return nextGrade;
    };
    Grades.GetCeremonyRewardsPath = function (id) {
        var nextGrade = this.FindNextGrade(this.FindById(id));
        if (nextGrade == null) {
            return __webpack_require__(2060);
        }
        return nextGrade.rewardsPath;
    };
    Grades.Default = { id: 0, level: -99, name: "Default", shortName: "", translationKey: "constants.gradeLevel.default", commander: "Default", commanderPath: "", rewardsPath: "" };
    Grades.PreK = { id: 1, level: -1, name: "Pre Kindergarten", shortName: "PK", translationKey: "constants.gradeLevel.preK", commander: "Traveler", commanderPath: __webpack_require__(2061), rewardsPath: __webpack_require__(2062) };
    Grades.K = { id: 2, level: 0, name: "Kindergarten", shortName: "K", translationKey: "constants.gradeLevel.k", commander: "Gazer", commanderPath: __webpack_require__(2063), rewardsPath: __webpack_require__(2064) };
    Grades.First = { id: 3, level: 1, name: "First", shortName: "1", translationKey: "constants.gradeLevel.first", commander: "Obe", commanderPath: __webpack_require__(2065), rewardsPath: __webpack_require__(2066) };
    Grades.Second = { id: 4, level: 2, name: "Second", shortName: "2", translationKey: "constants.gradeLevel.second", commander: "Rocket", commanderPath: __webpack_require__(2067), rewardsPath: __webpack_require__(2068) };
    Grades.Third = { id: 5, level: 3, name: "Third", shortName: "3", translationKey: "constants.gradeLevel.third", commander: "Voyager", commanderPath: __webpack_require__(2069), rewardsPath: __webpack_require__(2070) };
    Grades.Fourth = { id: 6, level: 4, name: "Fourth", shortName: "4", translationKey: "constants.gradeLevel.fourth", commander: "Pioneer", commanderPath: __webpack_require__(2071), rewardsPath: __webpack_require__(2072) };
    Grades.Fifth = { id: 7, level: 5, name: "Fifth", shortName: "5", translationKey: "constants.gradeLevel.fifth", commander: "Communicator", commanderPath: __webpack_require__(2073), rewardsPath: __webpack_require__(2074) };
    Grades.All = [
        Grades.PreK,
        Grades.K,
        Grades.First,
        Grades.Second,
        Grades.Third,
        Grades.Fourth,
        Grades.Fifth,
    ];
    return Grades;
}());



/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__ = __webpack_require__(12);

var Languages = /** @class */ (function () {
    function Languages() {
    }
    Languages.SetActiveLanguage = function (lang, translate) {
        var languageCode = (lang.code || "").toLowerCase();
        // Set all isActive to false first
        this.All.forEach(function (x) { return x.isActive = false; });
        // Get the one we want and activate it
        var foundLang = this.All.find(function (x) { return x.code === languageCode; });
        foundLang.isActive = true;
        // Update translate function
        __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate = function (key) { return translate(key).toString(); };
        __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].currentLanguage = foundLang;
    };
    Languages.GetActiveLanguage = function () {
        return this.All.find(function (x) { return !!x.isActive; });
    };
    Languages.FindById = function (id) {
        return this.All.find(function (x) { return x.id === id; }) || this.Default;
    };
    Languages.FindByCode = function (code) {
        return this.All.find(function (x) { return x.code.toLowerCase() === code.toLowerCase(); }) || this.Default;
    };
    Languages.Default = { id: 0, name: "None", code: "", isAvailable: false, isActive: false, url: "" };
    Languages.English = { id: 1, name: "English", code: "en-us", isAvailable: true, isActive: false, url: __webpack_require__(1858) };
    Languages.Spanish = { id: 2, name: "Español", code: "es-us", isAvailable: true, isActive: false, url: __webpack_require__(1859) };
    Languages.AustralianEnglish = { id: 3, name: "Australian English", code: "en-au", isAvailable: true, isActive: false, url: __webpack_require__(1860) };
    Languages.All = [
        Languages.English,
        Languages.Spanish,
        Languages.AustralianEnglish,
    ];
    return Languages;
}());
/* harmony default export */ __webpack_exports__["a"] = (Languages);


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STR_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STR_CHANNELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STR_CORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STR_CREATE_PERF_MGR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STR_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STR_EXTENSION_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STR_EXTENSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return STR_PROCESS_TELEMETRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return STR_PRIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return STR_EVENTS_SENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return STR_EVENTS_DISCARDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return STR_EVENTS_SEND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return STR_PERF_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STR_ERROR_TO_CONSOLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return STR_WARN_TO_CONSOLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return STR_GET_PERF_MGR; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// ###################################################################################################################################################
var STR_EMPTY = "";
var STR_CHANNELS = "channels";
var STR_CORE = "core";
var STR_CREATE_PERF_MGR = "createPerfMgr";
var STR_DISABLED = "disabled";
var STR_EXTENSION_CONFIG = "extensionConfig";
var STR_EXTENSIONS = "extensions";
var STR_PROCESS_TELEMETRY = "processTelemetry";
var STR_PRIORITY = "priority";
var STR_EVENTS_SENT = "eventsSent";
var STR_EVENTS_DISCARDED = "eventsDiscarded";
var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
var STR_PERF_EVENT = "perfEvent";
var STR_ERROR_TO_CONSOLE = "errorToConsole";
var STR_WARN_TO_CONSOLE = "warnToConsole";
var STR_GET_PERF_MGR = "getPerfMgr";
//# sourceMappingURL=InternalConstants.js.map

/***/ }),
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DebugUtil = /** @class */ (function () {
    function DebugUtil() {
    }
    /**
     * Checks if either the debug value is true or the host is local/dev and debug is no false
     */
    DebugUtil.isDebugEnabled = function () {
        var debugValue = this.DebugValueSet();
        var isDevHost = this.isDevHost();
        return debugValue === "set-true" || (debugValue !== "set-false" && isDevHost);
    };
    DebugUtil.DebugValueSet = function () {
        var item = localStorage.getItem("debug");
        if (item == null) {
            return "unset";
        }
        else if (item.toLowerCase() === "true") {
            return "set-true";
        }
        else {
            return "set-false";
        }
    };
    DebugUtil.isDevHost = function () {
        var currentShortUrl = (window.location.hostname || "").toLowerCase();
        var allowedUrls = ["localhost", "kudergalaxy-web-dev.azurewebsites.net"];
        return allowedUrls.some(function (x) { return x.toLowerCase() === currentShortUrl; });
    };
    return DebugUtil;
}());
/* harmony default export */ __webpack_exports__["a"] = (DebugUtil);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return _DYN_SPLIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _DYN_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return _DYN_TO_LOWER_CASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _DYN_INGESTIONENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return _DYN_TO_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return _DYN_REMOVE_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return _DYN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return _DYN_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _DYN_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return _DYN_PRE_TRIGGER_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _DYN_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _DYN_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _DYN_DAYS_OF_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _DYN_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _DYN_GET_UTCDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return _DYN_STRINGIFY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return _DYN_PATHNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _DYN_CORRELATION_HEADER_E0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return _DYN_INDEX_OF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _DYN_EXTENSION_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _DYN_EXCEPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return _DYN_PARSED_STACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return _DYN_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return _DYN_MEASUREMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return _DYN_SIZE_IN_BYTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return _DYN_TYPE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return _DYN_SEVERITY_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return _DYN_PROBLEM_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return _DYN_IS_MANUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return _DYN__CREATE_FROM_INTERFA1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _DYN_ASSEMBLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _DYN_FILE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _DYN_HAS_FULL_STACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _DYN_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return _DYN_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return _DYN_LINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _DYN_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return _DYN_RECEIVED_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return _DYN_SUBSTRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return _DYN_SANITIZE_KEY_AND_ADD2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return _DYN_SANITIZE_EXCEPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return _DYN_SANITIZE_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return _DYN_SANITIZE_MEASUREMENT3; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_SPLIT = "split"; // Count: 6
var _DYN_LENGTH = "length"; // Count: 41
var _DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 6
var _DYN_INGESTIONENDPOINT = "ingestionendpoint"; // Count: 6
var _DYN_TO_STRING = "toString"; // Count: 12
var _DYN_REMOVE_ITEM = "removeItem"; // Count: 3
var _DYN_NAME = "name"; // Count: 11
var _DYN_MESSAGE = "message"; // Count: 10
var _DYN_COUNT = "count"; // Count: 8
var _DYN_PRE_TRIGGER_DATE = "preTriggerDate"; // Count: 4
var _DYN_DISABLED = "disabled"; // Count: 3
var _DYN_INTERVAL = "interval"; // Count: 3
var _DYN_DAYS_OF_MONTH = "daysOfMonth"; // Count: 3
var _DYN_DATE = "date"; // Count: 5
var _DYN_GET_UTCDATE = "getUTCDate"; // Count: 3
var _DYN_STRINGIFY = "stringify"; // Count: 4
var _DYN_PATHNAME = "pathname"; // Count: 4
var _DYN_CORRELATION_HEADER_E0 = "correlationHeaderExcludePatterns"; // Count: 2
var _DYN_INDEX_OF = "indexOf"; // Count: 4
var _DYN_EXTENSION_CONFIG = "extensionConfig"; // Count: 4
var _DYN_EXCEPTIONS = "exceptions"; // Count: 6
var _DYN_PARSED_STACK = "parsedStack"; // Count: 13
var _DYN_PROPERTIES = "properties"; // Count: 9
var _DYN_MEASUREMENTS = "measurements"; // Count: 9
var _DYN_SIZE_IN_BYTES = "sizeInBytes"; // Count: 11
var _DYN_TYPE_NAME = "typeName"; // Count: 11
var _DYN_SEVERITY_LEVEL = "severityLevel"; // Count: 5
var _DYN_PROBLEM_GROUP = "problemGroup"; // Count: 3
var _DYN_IS_MANUAL = "isManual"; // Count: 3
var _DYN__CREATE_FROM_INTERFA1 = "CreateFromInterface"; // Count: 2
var _DYN_ASSEMBLY = "assembly"; // Count: 7
var _DYN_FILE_NAME = "fileName"; // Count: 8
var _DYN_HAS_FULL_STACK = "hasFullStack"; // Count: 6
var _DYN_LEVEL = "level"; // Count: 5
var _DYN_METHOD = "method"; // Count: 7
var _DYN_LINE = "line"; // Count: 6
var _DYN_DURATION = "duration"; // Count: 4
var _DYN_RECEIVED_RESPONSE = "receivedResponse"; // Count: 2
var _DYN_SUBSTRING = "substring"; // Count: 6
var _DYN_SANITIZE_KEY_AND_ADD2 = "sanitizeKeyAndAddUniqueness"; // Count: 2
var _DYN_SANITIZE_EXCEPTION = "sanitizeException"; // Count: 2
var _DYN_SANITIZE_PROPERTIES = "sanitizeProperties"; // Count: 2
var _DYN_SANITIZE_MEASUREMENT3 = "sanitizeMeasurements"; // Count: 2
//# sourceMappingURL=__DynamicConstants.js.map

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_style__ = __webpack_require__(19);


// style dependencies


/***/ }),
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Planets; });
var Planets = /** @class */ (function () {
    function Planets() {
    }
    /** Returns a list of planets with an Order value less than the planet passed in. Useful when calculating rewards */
    Planets.GetPlanetListByPlanetId = function (id) {
        var currentPlanet = this.FindById(id);
        return this.All.filter(function (x) { return x.order <= currentPlanet.order && x.order > 0; });
    };
    Planets.FindById = function (id) {
        return this.All.find(function (x) { return x.id === id; }) || this.Default;
    };
    Planets.GetNext = function (planet) {
        var order = planet.order + 1;
        return this.All.find(function (x) { return x.order === order; }) || this.Default;
    };
    Planets.GetPrevious = function (planet) {
        var order = planet.order - 1;
        return this.All.find(function (x) { return x.order === order; }) || this.Default;
    };
    Planets.Default = { id: 0, name: "Default", order: 0, color: 0xffffff, colorCode: "#ffffff", badgePath: "", iconPath: "" };
    Planets.R = { id: 1, name: "R", order: 1, color: 0x00de0e, colorCode: "#00de0e", badgePath: __webpack_require__(1863), iconPath: __webpack_require__(1864) };
    Planets.I = { id: 2, name: "I", order: 2, color: 0x0033cc, colorCode: "#0033cc", badgePath: __webpack_require__(1865), iconPath: __webpack_require__(1866) };
    Planets.A = { id: 3, name: "A", order: 3, color: 0x9500ca, colorCode: "#9500ca", badgePath: __webpack_require__(1867), iconPath: __webpack_require__(1868) };
    Planets.S = { id: 4, name: "S", order: 4, color: 0xff0700, colorCode: "#ff0700", badgePath: __webpack_require__(1869), iconPath: __webpack_require__(1870) };
    Planets.E = { id: 5, name: "E", order: 5, color: 0xffae00, colorCode: "#ffae00", badgePath: __webpack_require__(1871), iconPath: __webpack_require__(1872) };
    Planets.C = { id: 6, name: "C", order: 6, color: 0xedfd00, colorCode: "#edfd00", badgePath: __webpack_require__(1873), iconPath: __webpack_require__(1874) };
    Planets.All = [
        Planets.R,
        Planets.I,
        Planets.A,
        Planets.S,
        Planets.E,
        Planets.C,
    ];
    return Planets;
}());



/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = includes;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrayFrom;
/* harmony export (immutable) */ __webpack_exports__["f"] = find;
/* harmony export (immutable) */ __webpack_exports__["g"] = findLast;
/* harmony export (immutable) */ __webpack_exports__["h"] = forEach;
/* harmony export (immutable) */ __webpack_exports__["k"] = objectValues;
/* harmony export (immutable) */ __webpack_exports__["j"] = objectEntries;
/* harmony export (immutable) */ __webpack_exports__["l"] = startsWith;
/* harmony export (immutable) */ __webpack_exports__["e"] = endsWith;
/* harmony export (immutable) */ __webpack_exports__["d"] = elementMatches;
/* harmony export (immutable) */ __webpack_exports__["c"] = cssEscape;
/* harmony export (immutable) */ __webpack_exports__["b"] = assign;
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
function elementMatches(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    }
    // IE11 support
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return false;
}
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
    if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(str);
    }
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') {
                return '\uFFFD';
            }
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
function assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
//# sourceMappingURL=polyfills.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box_less__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var DialogBox = /** @class */ (function (_super) {
    __extends(DialogBox, _super);
    function DialogBox(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, DialogBox.prototype);
        return _this;
    }
    DialogBox.prototype.isNextButton = function () {
        return this.props.onNext != null && (this.props.buttonNextType == null || this.props.buttonNextType === "arrow");
    };
    DialogBox.prototype.isTraditionalButton = function () {
        return this.props.onNext != null && this.props.buttonTextKey != null && this.props.buttonTextKey.length > 0 && this.props.buttonNextType === "standard";
    };
    DialogBox.prototype.isBackButton = function () {
        return this.props.onBack != null && (this.props.buttonBackType == null || this.props.buttonBackType === "arrow");
    };
    /**
     * Simple next button (arrow)
     */
    DialogBox.prototype.renderNextButton = function () {
        if (!this.isNextButton()) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { autoFocus: true, tabIndex: 1, className: "ant-btn next-button", onClick: this.props.onNext, title: "next" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "common.next" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "button-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { width: "16", height: "11", viewBox: "0 0 16 11", xmlns: "http://www.w3.org/2000/svg" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M16 5.333L10 0v4H0v2.667h10v4z", fill: "#FFF", fillRule: "nonzero" }))));
    };
    DialogBox.prototype.renderBackButton = function () {
        if (!this.isBackButton()) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { tabIndex: 1, className: "ant-btn back-button", onClick: this.props.onBack, title: "back" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "button-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { width: "16", height: "11", viewBox: "0 0 16 11", xmlns: "http://www.w3.org/2000/svg" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { transform: "rotate(180 8, 5.333)", d: "M16 5.333L10 0v4H0v2.667h10v4z", fill: "#FFF", fillRule: "nonzero" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "common.back" })));
    };
    /**
     * Traditional button with some text
     */
    DialogBox.prototype.renderTraditionalButton = function () {
        if (!this.isTraditionalButton()) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { autoFocus: true, tabIndex: 1, id: "button", className: "ant-btn ant-btn-lg ant-btn-primary", onClick: this.props.onNext },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: this.props.buttonTextKey })));
    };
    DialogBox.prototype.render = function () {
        var className = ("box-component planet-" + (this.props.currentPlanet || { name: "" }).name).toLowerCase();
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "dialogBox", className: className },
            this.props.children,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { span: 6 }, this.renderBackButton()),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { span: 6, className: "super-button" }, this.renderNextButton()),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { span: 24 }, this.renderTraditionalButton())));
    };
    return DialogBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DialogBox);


/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ONE_SECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ONE_MINUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ONE_HOUR; });
/* unused harmony export ONE_DAY */
/* unused harmony export ONE_YEAR */
/* harmony export (immutable) */ __webpack_exports__["m"] = relativeToClocks;
/* harmony export (immutable) */ __webpack_exports__["g"] = currentDrift;
/* harmony export (immutable) */ __webpack_exports__["o"] = toServerDuration;
/* harmony export (immutable) */ __webpack_exports__["h"] = dateNow;
/* harmony export (immutable) */ __webpack_exports__["n"] = timeStampNow;
/* harmony export (immutable) */ __webpack_exports__["l"] = relativeNow;
/* harmony export (immutable) */ __webpack_exports__["e"] = clocksNow;
/* harmony export (immutable) */ __webpack_exports__["f"] = clocksOrigin;
/* harmony export (immutable) */ __webpack_exports__["i"] = elapsed;
/* harmony export (immutable) */ __webpack_exports__["d"] = addDuration;
/* harmony export (immutable) */ __webpack_exports__["j"] = getRelativeTime;
/* unused harmony export getTimeStamp */
/* harmony export (immutable) */ __webpack_exports__["k"] = looksLikeRelativeTime;
/* unused harmony export resetNavigationStart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__numberUtils__ = __webpack_require__(350);

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__numberUtils__["a" /* isNumber */])(duration)) {
        return duration;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__numberUtils__["d" /* round */])(duration * 1e6, 0);
}
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function timeStampNow() {
    return dateNow();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
function addDuration(a, b) {
    return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
    return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
//# sourceMappingURL=timeUtils.js.map

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = updateUserError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_redux_CheckpointActions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_redux_ConstantActions__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_providers_TelemetryService__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datadog_browser_rum__ = __webpack_require__(788);





var UserAction = /** @class */ (function () {
    function UserAction() {
        // Dont be that guy
        throw new Error("NOOOO");
    }
    UserAction.Register = function (dispatch, request) {
        var _this = this;
        if (request == null) {
            return;
        }
        dispatch({ type: "UPDATE_STATE_USER", data: "loading" });
        return __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].register(request, { ignoreAuthenticationErrors: true })
            .then(function (result) {
            // Check failure since there are 2 conditions for it and either one will cause failure of the login event
            if (!result.ok || !result.data.isSuccess) {
                return _this.RegisterOnError(dispatch, result);
            }
            return _this.RegisterOnSuccess(dispatch, result);
        });
    };
    UserAction.Login = function (dispatch, request) {
        var _this = this;
        if (request == null) {
            return;
        }
        dispatch({ type: "UPDATE_STATE_USER", data: "loading" });
        return __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].login(request, { ignoreAuthenticationErrors: true })
            .then(function (result) {
            // Check failure since there are 2 conditions for it and either one will cause failure of the login event
            if (!result.ok || !result.data.isSuccess) {
                return _this.LoginOnError(dispatch, result);
            }
            return _this.LoginOnSuccess(dispatch, result);
        });
    };
    /**
     * Login using the browser cookie. This will run through the login process as if we had logged in
     *
     * Returns a `Promise<bool>` indicating if the login was a success
     *
     * @param {Dispatch<ReduxStoreModel>} dispatch The dispatch object passed in from `mapDispatchToProps()`
     */
    UserAction.SoftLogin = function (dispatch) {
        var _this = this;
        dispatch({ type: "UPDATE_STATE_USER", data: "loading" });
        return __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].me({ ignoreAuthenticationErrors: true })
            .then(function (result) {
            // Check failure since there are 2 conditions for it and either one will cause failure of the login event
            if (!result.ok || !result.data.isSuccess) {
                return _this.LoginOnError(dispatch, result);
            }
            return _this.LoginOnSuccess(dispatch, result);
        });
    };
    UserAction.RegisterOnSuccess = function (dispatch, result) {
        // The only thing coming in here is going to be a success
        dispatch({ type: "UPDATE_USER", data: result.data.data });
        dispatch({ type: "UPDATE_ERROR_USER", data: "" });
        var checkpointPromise = __WEBPACK_IMPORTED_MODULE_1_src_redux_CheckpointActions__["a" /* default */].LoadUserStatus(dispatch);
        var constantsPromise = __WEBPACK_IMPORTED_MODULE_2_src_redux_ConstantActions__["a" /* default */].LoadConstants(dispatch);
        return Promise.all([checkpointPromise, constantsPromise]).then(function (x) {
            // Combine all results together into a single T/F answer
            var result = x.reduce(function (first, second) {
                return first && second;
            }, true);
            dispatch({ type: "UPDATE_STATE_USER", data: result ? "finished" : "failed" });
            return result;
        });
    };
    UserAction.RegisterOnError = function (dispatch, result) {
        // Failures in the http request or register request come here
        // Failed results have no error message, use default. Else, use the errorMessage provided defaulting to "" if null
        var errorMessage = !result.ok ? "account.register.registerUnknownFailure" : result.data.errorMessage || "";
        dispatch({ type: "UPDATE_USER", data: {} });
        dispatch({ type: "UPDATE_ERROR_USER", data: errorMessage });
        dispatch({ type: "UPDATE_STATE_USER", data: "failed" });
        return false;
    };
    UserAction.LoginOnSuccess = function (dispatch, result) {
        // The only thing coming in here is going to be a success
        dispatch({ type: "UPDATE_USER", data: result.data.data });
        dispatch({ type: "UPDATE_ERROR_USER", data: "" });
        var checkpointPromise = __WEBPACK_IMPORTED_MODULE_1_src_redux_CheckpointActions__["a" /* default */].LoadUserStatus(dispatch);
        var constantsPromise = __WEBPACK_IMPORTED_MODULE_2_src_redux_ConstantActions__["a" /* default */].LoadConstants(dispatch);
        var emulationPromise = __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].getCurrentEmulationInfo();
        if (result.data != null && result.data.data != null) {
            var userInfo = result.data.data;
            var customProperties = {
                clientId: userInfo.clientId,
                stateId: userInfo.stateId,
                districtId: userInfo.districtId,
                schoolId: userInfo.schoolId,
                clientName: userInfo.clientName,
                stateName: userInfo.stateName,
                districtName: userInfo.districtName,
                schoolName: userInfo.schoolName,
                userId: userInfo.userId,
                gradeId: userInfo.gradeId
            };
            __WEBPACK_IMPORTED_MODULE_4__datadog_browser_rum__["a" /* datadogRum */].setUser({
                id: userInfo.userId.toString(),
                userFullName: userInfo.firstName + " " + userInfo.lastName,
                email: userInfo.email,
                username: userInfo.email,
                organizationId: userInfo.schoolId != null ? userInfo.schoolId : userInfo.districtId != null ? userInfo.districtId : userInfo.stateId != null ? userInfo.stateId : null,
                organizationName: userInfo.schoolId != null ? userInfo.schoolName : userInfo.districtId != null ? userInfo.districtName : userInfo.stateId != null ? userInfo.stateName : null
            });
            Object(__WEBPACK_IMPORTED_MODULE_3_src_providers_TelemetryService__["b" /* addOtherDefaultTrackingProperties */])(customProperties);
        }
        return Promise.all([checkpointPromise, constantsPromise, emulationPromise]).then(function (x) {
            // Combine the first 2 results together into a single T/F answer
            var result = [x[0], x[1]].reduce(function (first, second) {
                return first && second;
            }, true);
            // Update emulation info
            dispatch({ type: "UPDATE_EMULATE_INFO_USER", data: x[2].data });
            dispatch({ type: "UPDATE_STATE_USER", data: result ? "finished" : "failed" });
            return result;
        });
    };
    UserAction.LoginOnError = function (dispatch, result) {
        // Failures in the http request or login request come here
        // Failed results have no error message, use default. Else, use the errorMessage provided defaulting to "" if null
        var errorMessage = !result.ok ? "account.login.loginUnknownFailure" : result.data.errorMessage || "";
        dispatch({ type: "UPDATE_USER", data: {} });
        dispatch({ type: "UPDATE_ERROR_USER", data: errorMessage });
        dispatch({ type: "UPDATE_STATE_USER", data: "failed" });
        return false;
    };
    UserAction.LogoutUser = function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].logout().then(function (result) {
            if (result.ok) {
                dispatch({ type: "RESET_USER" });
                dispatch({ type: "RESET_CONFIG" });
                dispatch({ type: "RESET_CHECKPOINT" });
            }
        });
    };
    /**
     * Emulates a user given the emulation type and ID. Returns a promise indicating success or failure.
     *
     * Does not redirect based on new role, that's up to you hombre. You must also properly handle messages which will be passed back in the `.then()` clause
     */
    UserAction.EmulateUser = function (dispatch, emulationType, id) {
        var _this = this;
        // Pick which api we need to hit
        var apiPromise;
        switch (emulationType) {
            case "school":
                apiPromise = __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].emulateSchool(id);
                break;
            case "state":
                apiPromise = __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].emulateState(id);
                break;
            case "district":
                apiPromise = __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].emulateDistrict(id);
                break;
            case "cancel":
                apiPromise = __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].stopEmulation();
                break;
            default:
                // JB - Clarification: The following line is fucking magic
                var exhaustiveCheck = emulationType;
        }
        // This is where the newness starts
        // Emulate only needs a few things, so lets just call them all from this Action
        dispatch({ type: "UPDATE_STATE_USER", data: "emulation-loading" });
        return apiPromise
            .then(function (result) { return __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].me({ ignoreAuthenticationErrors: true }); })
            .then(function (result) {
            // Check failure since there are 2 conditions for it and either one will cause failure of the login event
            if (!result.ok || !result.data.isSuccess) {
                return _this.LoginOnError(dispatch, result);
            }
            if (result.data != null && result.data.data != null) {
                var userInfo = result.data.data;
                var customProperties = {
                    clientId: userInfo.clientId,
                    stateId: userInfo.stateId,
                    districtId: userInfo.districtId,
                    schoolId: userInfo.schoolId,
                    clientName: userInfo.clientName,
                    stateName: userInfo.stateName,
                    districtName: userInfo.districtName,
                    schoolName: userInfo.schoolName,
                    userId: userInfo.userId,
                    gradeId: userInfo.gradeId
                };
                Object(__WEBPACK_IMPORTED_MODULE_3_src_providers_TelemetryService__["b" /* addOtherDefaultTrackingProperties */])(customProperties);
            }
            // The only thing coming in here is going to be a success
            dispatch({ type: "UPDATE_USER", data: result.data.data });
            dispatch({ type: "UPDATE_ERROR_USER", data: "" });
            var checkpointPromise = __WEBPACK_IMPORTED_MODULE_1_src_redux_CheckpointActions__["a" /* default */].LoadUserStatus(dispatch);
            var constantsPromise = __WEBPACK_IMPORTED_MODULE_2_src_redux_ConstantActions__["a" /* default */].LoadConstantsEmulation(dispatch);
            var emulationPromise = __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].getCurrentEmulationInfo();
            return Promise.all([checkpointPromise, constantsPromise, emulationPromise]).then(function (x) {
                // Combine the first 2 results together into a single T/F answer
                var result = [x[0], x[1]].reduce(function (first, second) {
                    return first && second;
                }, true);
                // Update emulation info
                dispatch({ type: "UPDATE_EMULATE_INFO_USER", data: x[2].data });
                dispatch({ type: "UPDATE_STATE_USER", data: result ? "finished" : "failed" });
                return result;
            });
        });
    };
    /**
     * Updated for up/down movement
     *
     * Emulates a user given the emulation type and ID. Returns a promise indicating success or failure.
     *
     * Does not redirect based on new role, that's up to you hombre. You must also properly handle messages which will be passed back in the `.then()` clause
     */
    UserAction.EmulateUserV2 = function (dispatch, id, emulationType) {
        var _this = this;
        // This is where the newness starts
        // Emulate only needs a few things, so lets just call them all from this Action
        dispatch({ type: "UPDATE_STATE_USER", data: "emulation-loading" });
        return __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].emulate(id, emulationType)
            .then(function (result) {
            // Check failure since there are 2 conditions for it and either one will cause failure of the login event
            if (!result.ok || !result.data.isSuccess) {
                return _this.LoginOnError(dispatch, result);
            }
            if (result.data != null && result.data.data != null) {
                var userInfo = result.data.data;
                var customProperties = {
                    clientId: userInfo.clientId,
                    stateId: userInfo.stateId,
                    districtId: userInfo.districtId,
                    schoolId: userInfo.schoolId,
                    clientName: userInfo.clientName,
                    stateName: userInfo.stateName,
                    districtName: userInfo.districtName,
                    schoolName: userInfo.schoolName,
                    userId: userInfo.userId,
                    gradeId: userInfo.gradeId
                };
                Object(__WEBPACK_IMPORTED_MODULE_3_src_providers_TelemetryService__["b" /* addOtherDefaultTrackingProperties */])(customProperties);
            }
            // The only thing coming in here is going to be a success
            dispatch({ type: "UPDATE_USER", data: result.data.data });
            dispatch({ type: "UPDATE_ERROR_USER", data: "" });
            var checkpointPromise = __WEBPACK_IMPORTED_MODULE_1_src_redux_CheckpointActions__["a" /* default */].LoadUserStatus(dispatch);
            var constantsPromise = __WEBPACK_IMPORTED_MODULE_2_src_redux_ConstantActions__["a" /* default */].LoadConstantsEmulation(dispatch);
            var emulationPromise = __WEBPACK_IMPORTED_MODULE_0_src_api_AccountApiController__["a" /* default */].getCurrentEmulationInfo();
            return Promise.all([checkpointPromise, constantsPromise, emulationPromise]).then(function (x) {
                // Combine the first 2 results together into a single T/F answer
                var result = [x[0], x[1]].reduce(function (first, second) {
                    return first && second;
                }, true);
                // Update emulation info
                dispatch({ type: "UPDATE_EMULATE_INFO_USER", data: x[2].data });
                dispatch({ type: "UPDATE_STATE_USER", data: result ? "finished" : "failed" });
                return result;
            });
        })
            .catch(function (error) {
            // I don't care right now
            return _this.LoginOnError(dispatch, { ok: false });
        });
    };
    /** Stops the user from emulating. You must redirect the user when completed */
    UserAction.StopEmulation = function (dispatch) {
        // Cancel is essentially just "emulate yourself"
        return this.EmulateUser(dispatch, "cancel");
    };
    UserAction.SetLogin = function (dispatch, request) {
        dispatch({ type: "UPDATE_USER", data: request });
    };
    return UserAction;
}());
/* harmony default export */ __webpack_exports__["a"] = (UserAction);
function updateUserError(dispatch, message) {
    dispatch({ type: "UPDATE_ERROR_USER", data: message });
}


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsoleApiName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return display; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return globalConsole; });
/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
var display = function (api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!Object.prototype.hasOwnProperty.call(ConsoleApiName, api)) {
        api = ConsoleApiName.log;
    }
    display[api].apply(display, args);
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
var globalConsole = console;
display.debug = globalConsole.debug.bind(globalConsole);
display.log = globalConsole.log.bind(globalConsole);
display.info = globalConsole.info.bind(globalConsole);
display.warn = globalConsole.warn.bind(globalConsole);
display.error = globalConsole.error.bind(globalConsole);
//# sourceMappingURL=display.js.map

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Roles; });
var Roles = /** @class */ (function () {
    function Roles() {
    }
    Roles.FindById = function (id) {
        return this.All.find(function (x) { return x.id === id; }) || this.None;
    };
    /**
     * Returns a list of **admin** Roles that can be selected from the current role. These are Roles at or 'below' the current role
     *
     * Example: A DistrictAdmin would return **[DistrictAdmin, Teacher]**
     */
    Roles.GetRoleSelectionsByRole = function (role) {
        return Roles.All.filter(function (x) { return x.order >= role.order && x.isAdmin && x !== Roles.KuderAdmin; });
    };
    Roles.None = { id: 0, name: "None", display: "None", isAdmin: false, order: 99 };
    Roles.KuderAdmin = { id: 1, name: "KuderAdmin", display: "Kuder Admin", isAdmin: true, order: 1 };
    Roles.StateAdmin = { id: 2, name: "StateAdmin", display: "State Admin", isAdmin: true, order: 2 };
    Roles.DistrictAdmin = { id: 3, name: "DistrictAdmin", display: "District Admin", isAdmin: true, order: 3 };
    Roles.SchoolAdmin = { id: 4, name: "SchoolAdmin", display: "School Admin / Counselor", isAdmin: true, order: 4 };
    Roles.TeacherCounselorAdmin = { id: 5, name: "TeacherCounselorAdmin", display: "Teacher", isAdmin: true, order: 5 };
    Roles.Student = { id: 6, name: "Student", display: "Student", isAdmin: false, order: 6 };
    Roles.All = [
        Roles.KuderAdmin,
        Roles.StateAdmin,
        Roles.DistrictAdmin,
        Roles.SchoolAdmin,
        Roles.TeacherCounselorAdmin,
        Roles.Student
    ];
    return Roles;
}());



/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Helpers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scenes_DrawBloodScene__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_SickCellInfoScene__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_SickCellsScene__ = __webpack_require__(2226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenes_BacteriaInfoScene__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scenes_CountBacteriaScene__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scenes_TestTubeInfoScene__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenes_TestTubeScene__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scenes_ColorChangerInfoScene__ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scenes_ColorChangerScene__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scenes_DiagnosisScene__ = __webpack_require__(2238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__scenes_GameOverScene__ = __webpack_require__(2240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_utils_TranslateHelper__ = __webpack_require__(12);















var Helpers = /** @class */ (function () {
    function Helpers() {
    }
    Helpers.createButton = function (scene, x, y, color, text) {
        var config = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.backgroundColor = color;
        var button = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__["a" /* PhaserButton */](scene, x, y, 200, 80, text, config);
        return button;
    };
    /**
     * Fades the target image out to invisible
     * Called before setting the new color to simulate changing colors
     */
    Helpers.fadeOut = function (scene, target, duration, start, end) {
        scene.tweens.add({
            targets: target,
            ease: "Power1",
            duration: duration,
            alpha: {
                getStart: function () { return start; },
                getEnd: function () { return end; }
            },
        });
    };
    Helpers.flashObject = function (scene, target) {
        scene.tweens.add({
            targets: target,
            alpha: {
                value: 0.3,
                duration: 600,
            },
            yoyo: true,
            repeat: -1,
        });
    };
    /**
     * Gets an array of unique random colors
     */
    Helpers.getRandomUniqueColors = function (count) {
        var actualColors = [
            __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("red"),
            __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("blue"),
            __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("green"),
            __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("yellow"),
            __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("orange"),
            __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("purple"),
            __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("teal"),
            __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("pink"),
        ];
        var colors = [];
        while (colors.length < count) {
            var randomIndex = Phaser.Math.Between(0, actualColors.length - 1);
            if (colors.indexOf(actualColors[randomIndex]) === -1) {
                colors.push(actualColors[randomIndex]);
            }
        }
        return colors;
    };
    /**
    * Shuffle the candidates so they're not in the same order every time
    * https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
    */
    Helpers.scrambleArray = function (array) {
        var j, x, i;
        for (i = array.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = array[i];
            array[i] = array[j];
            array[j] = x;
        }
        return array;
    };
    /**
     * Get next scene in the game
     */
    Helpers.getNextScene = function (sceneNumber) {
        var nextSceneObject = this.SCENE_ORDER[sceneNumber];
        return nextSceneObject;
    };
    Helpers.addNextButton = function (currentScene) {
        var text = __WEBPACK_IMPORTED_MODULE_14_src_utils_TranslateHelper__["a" /* default */].translate("common.next");
        var config = { backgroundColor: __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON, textColor: 0xffffff, textSize: 20, smartSize: true, keyMapping: "keydown_RIGHT" };
        var next = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__["a" /* PhaserButton */](currentScene, this.GAME_WIDTH - 150, this.GAME_HEIGHT - 75, 150, 50, text, config);
        next.setX(this.GAME_WIDTH - next.width - 50);
        next.on('buttonClicked', function () {
            currentScene.scene.setActive(false);
            currentScene.scene.remove(currentScene);
            var nextSceneObject = Helpers.getNextScene(__WEBPACK_IMPORTED_MODULE_10__GameState__["a" /* GameState */].current.sceneNumber);
            __WEBPACK_IMPORTED_MODULE_10__GameState__["a" /* GameState */].current.sceneNumber += 1;
            if (nextSceneObject != null) {
                currentScene.scene.add(nextSceneObject.key, nextSceneObject.scene, true);
            }
        });
    };
    Helpers.getPreviousScene = function (sceneNumber) {
        // Get previous scene number, offset by 1 because of 0 indexing
        var previousSceneObject = this.SCENE_ORDER[sceneNumber - 2];
        return previousSceneObject;
    };
    Helpers.addBackButton = function (currentScene) {
        var text = __WEBPACK_IMPORTED_MODULE_14_src_utils_TranslateHelper__["a" /* default */].translate("common.back");
        var config = { backgroundColor: __WEBPACK_IMPORTED_MODULE_11_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON, textColor: 0xffffff, textSize: 20, smartSize: true, keyMapping: "keydown_LEFT" };
        var back = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__["a" /* PhaserButton */](currentScene, 50, this.GAME_HEIGHT - 75, 100, 50, text, config);
        back.on('buttonClicked', function () {
            currentScene.scene.setActive(false);
            currentScene.scene.remove(currentScene);
            var previousSceneObject = Helpers.getPreviousScene(__WEBPACK_IMPORTED_MODULE_10__GameState__["a" /* GameState */].current.sceneNumber);
            __WEBPACK_IMPORTED_MODULE_10__GameState__["a" /* GameState */].current.sceneNumber -= 1;
            if (previousSceneObject != null) {
                currentScene.scene.add(previousSceneObject.key, previousSceneObject.scene, true);
            }
        });
    };
    Helpers.GAME_WIDTH = 1360;
    Helpers.GAME_HEIGHT = 768;
    Helpers.translateString = "Diagnosis.Phaser.Helpers.";
    /**
     * Defines the ordering of the game scenes for Lab Diagnosis game
     * Used for the next button
     */
    Helpers.SCENE_ORDER = [
        { key: "DrawBloodScene", scene: __WEBPACK_IMPORTED_MODULE_1__scenes_DrawBloodScene__["a" /* DrawBloodScene */] },
        { key: "ColorChangerInfoScene", scene: __WEBPACK_IMPORTED_MODULE_8__scenes_ColorChangerInfoScene__["a" /* ColorChangerInfoScene */] },
        { key: "ColorChangerScene", scene: __WEBPACK_IMPORTED_MODULE_9__scenes_ColorChangerScene__["a" /* ColorChangerScene */] },
        { key: "SickCellInfoScene", scene: __WEBPACK_IMPORTED_MODULE_2__scenes_SickCellInfoScene__["a" /* SickCellInfoScene */] },
        { key: "SickCellsScene", scene: __WEBPACK_IMPORTED_MODULE_3__scenes_SickCellsScene__["a" /* SickCellsScene */] },
        { key: "BacteriaInfoScene", scene: __WEBPACK_IMPORTED_MODULE_4__scenes_BacteriaInfoScene__["a" /* BacteriaInfoScene */] },
        { key: "CountBacteriaScene", scene: __WEBPACK_IMPORTED_MODULE_5__scenes_CountBacteriaScene__["a" /* CountBacteriaScene */] },
        { key: "TestTubeInfoScene", scene: __WEBPACK_IMPORTED_MODULE_6__scenes_TestTubeInfoScene__["a" /* TestTubeInfoScene */] },
        { key: "TestTubeScene", scene: __WEBPACK_IMPORTED_MODULE_7__scenes_TestTubeScene__["a" /* TestTubeScene */] },
        { key: "DiagnosisScene", scene: __WEBPACK_IMPORTED_MODULE_12__scenes_DiagnosisScene__["a" /* DiagnosisScene */] },
        { key: "GameOverScene", scene: __WEBPACK_IMPORTED_MODULE_13__scenes_GameOverScene__["a" /* GameOverScene */] },
    ];
    return Helpers;
}());



/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isObject = isObject;
exports.isEqual = isEqual;
exports.isMediaStream = isMediaStream;

var _loadScript = __webpack_require__(2704);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _deepmerge = __webpack_require__(2705);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _props = __webpack_require__(371);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/;

// Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds
function parseTimeParam(url, pattern) {
  var match = url.match(pattern);
  if (match) {
    var stamp = match[1];
    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }
    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }
  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);
  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }
  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
}

// http://stackoverflow.com/a/38622545
function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return key + '=' + object[key];
  }).join('&');
}

// Util function to load an external SDK
// or return the SDK if it is already loaded
var resolves = {};
function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript2['default'];

  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
    return Promise.resolve(window[sdkGlobal]);
  }
  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve
    // function to the existing array of resolve functions
    if (resolves[url]) {
      resolves[url].push(resolve);
      return;
    }
    resolves[url] = [resolve];
    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending promises
      resolves[url].forEach(function (resolve) {
        return resolve(sdk);
      });
    };
    if (sdkReady) {
      var previousOnReady = window[sdkReady];
      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(window[sdkGlobal]);
      };
    }
    fetchScript(url, function (err) {
      if (err) reject(err);
      if (!sdkReady) {
        onLoaded(window[sdkGlobal]);
      }
    });
  });
}

function getConfig(props, defaultProps, showWarning) {
  var config = (0, _deepmerge2['default'])(defaultProps.config, props.config);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _props.DEPRECATED_CONFIG_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var p = _step.value;

      if (props[p]) {
        var key = p.replace(/Config$/, '');
        config = (0, _deepmerge2['default'])(config, _defineProperty({}, key, props[p]));
        if (showWarning) {
          var link = 'https://github.com/CookPete/react-player#config-prop';
          var message = 'ReactPlayer: %c' + p + ' %cis deprecated, please use the config prop instead \u2013 ' + link;
          console.warn(message, 'font-weight: bold', '');
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return config;
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);
  var output = {};
  var keys = Object.keys(object);
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      if (omitKeys.indexOf(key) === -1) {
        output[key] = object[key];
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
        _iterator2['return']();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return output;
}

function callPlayer(method) {
  var _player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = 'ReactPlayer: ' + this.constructor.displayName + ' player could not call %c' + method + '%c \u2013 ';
    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }
    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_player = this.player)[method].apply(_player, args);
}

function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

// Deep comparison of two objects but ignoring
// functions, for use in shouldComponentUpdate
function isEqual(a, b) {
  if (typeof a === 'function' && typeof b === 'function') {
    return true;
  }
  if (a instanceof Array && b instanceof Array) {
    if (a.length !== b.length) {
      return false;
    }
    for (var i = 0; i !== a.length; i++) {
      if (!isEqual(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }
  if (isObject(a) && isObject(b)) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = Object.keys(a)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var key = _step3.value;

        if (!isEqual(a[key], b[key])) {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
          _iterator3['return']();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return true;
  }
  return a === b;
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkpoints; });
var Checkpoints = /** @class */ (function () {
    function Checkpoints() {
    }
    Checkpoints.FindById = function (id) {
        return this.All.find(function (x) { return x.id === id; }) || this.None;
    };
    Checkpoints.GetNext = function (checkpoint) {
        var order = checkpoint.order + 1;
        return this.All.find(function (x) { return x.order === order; }) || this.None;
    };
    Checkpoints.GetPrevious = function (checkpoint) {
        var order = checkpoint.order - 1;
        return this.All.find(function (x) { return x.order === order; }) || this.None;
    };
    Checkpoints.None = { id: 0, name: "None", order: 0, type: "SpaceStation" };
    Checkpoints.Onboarding = { id: 1, name: "Onboarding", order: 1, type: "SpaceStation" };
    Checkpoints.Landing = { id: 2, name: "Landing", order: 2, type: "Planet" };
    Checkpoints.Exploring = { id: 3, name: "Exploring", order: 3, type: "Planet" };
    Checkpoints.Video = { id: 4, name: "Video", order: 4, type: "Planet" };
    Checkpoints.PreGame = { id: 5, name: "PreGame", order: 5, type: "Planet" };
    Checkpoints.Game = { id: 6, name: "Game", order: 6, type: "Planet" };
    Checkpoints.PostGame = { id: 7, name: "PostGame", order: 7, type: "Planet" };
    Checkpoints.Activity = { id: 8, name: "Activity", order: 8, type: "Planet" };
    Checkpoints.Badge = { id: 9, name: "Badge", order: 9, type: "Planet" };
    Checkpoints.PlanetClose = { id: 10, name: "PlanetClose", order: 10, type: "Planet" };
    Checkpoints.Leaving = { id: 11, name: "Leaving", order: 11, type: "Planet" };
    Checkpoints.BetweenPlanets = { id: 12, name: "BetweenPlanets", order: 12, type: "SpaceStation" };
    Checkpoints.GalaxyCeremony = { id: 13, name: "GalaxyCeremony", order: 13, type: "SpaceStation" };
    Checkpoints.GalaxyComplete = { id: 14, name: "GalaxyComplete", order: 14, type: "SpaceStation" };
    Checkpoints.All = [
        Checkpoints.None,
        Checkpoints.Onboarding,
        Checkpoints.Landing,
        Checkpoints.Exploring,
        Checkpoints.Video,
        Checkpoints.PreGame,
        Checkpoints.Game,
        Checkpoints.PostGame,
        Checkpoints.Activity,
        Checkpoints.Badge,
        Checkpoints.PlanetClose,
        Checkpoints.Leaving,
        Checkpoints.BetweenPlanets,
        Checkpoints.GalaxyCeremony,
        Checkpoints.GalaxyComplete,
    ];
    return Checkpoints;
}());



/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setEnableEnvMocks */
/* harmony export (immutable) */ __webpack_exports__["g"] = getGlobalInst;
/* harmony export (immutable) */ __webpack_exports__["s"] = hasWindow;
/* harmony export (immutable) */ __webpack_exports__["o"] = getWindow;
/* harmony export (immutable) */ __webpack_exports__["p"] = hasDocument;
/* harmony export (immutable) */ __webpack_exports__["f"] = getDocument;
/* unused harmony export hasNavigator */
/* harmony export (immutable) */ __webpack_exports__["m"] = getNavigator;
/* harmony export (immutable) */ __webpack_exports__["q"] = hasHistory;
/* harmony export (immutable) */ __webpack_exports__["h"] = getHistory;
/* harmony export (immutable) */ __webpack_exports__["k"] = getLocation;
/* harmony export (immutable) */ __webpack_exports__["d"] = getConsole;
/* harmony export (immutable) */ __webpack_exports__["n"] = getPerformance;
/* harmony export (immutable) */ __webpack_exports__["r"] = hasJSON;
/* harmony export (immutable) */ __webpack_exports__["j"] = getJSON;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCrypto;
/* harmony export (immutable) */ __webpack_exports__["l"] = getMsCrypto;
/* harmony export (immutable) */ __webpack_exports__["w"] = isReactNative;
/* harmony export (immutable) */ __webpack_exports__["v"] = isIE;
/* harmony export (immutable) */ __webpack_exports__["i"] = getIEVersion;
/* harmony export (immutable) */ __webpack_exports__["a"] = dumpObj;
/* unused harmony export isSafari */
/* harmony export (immutable) */ __webpack_exports__["t"] = isBeaconsSupported;
/* harmony export (immutable) */ __webpack_exports__["u"] = isFetchSupported;
/* harmony export (immutable) */ __webpack_exports__["y"] = useXDomainRequest;
/* harmony export (immutable) */ __webpack_exports__["x"] = isXhrSupported;
/* harmony export (immutable) */ __webpack_exports__["b"] = findMetaTag;
/* harmony export (immutable) */ __webpack_exports__["c"] = findNamedServerTiming;
/* unused harmony export dispatchEvent */
/* unused harmony export createCustomDomEvent */
/* unused harmony export sendCustomEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalConstants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only use defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strWindow = "window";
var strDocument = "document";
var strDocumentMode = "documentMode";
var strNavigator = "navigator";
var strHistory = "history";
var strLocation = "location";
var strConsole = "console";
var strPerformance = "performance";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var strXMLHttpRequest = "XMLHttpRequest";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
var _useXDomainRequest = null;
var _beaconsSupported = null;
function _hasProperty(theClass, property) {
    var supported = false;
    if (theClass) {
        try {
            supported = property in theClass;
            if (!supported) {
                var proto = theClass[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]];
                if (proto) {
                    supported = property in proto;
                }
            }
        }
        catch (e) {
            // Do Nothing
        }
        if (!supported) {
            try {
                var tmp = new theClass();
                supported = !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(tmp[property]);
            }
            catch (e) {
                // Do Nothing
            }
        }
    }
    return supported;
}
/**
 * Enable the lookup of test mock objects if requested
 * @param enabled
 */
function setEnableEnvMocks(enabled) {
    _enableMocks = enabled;
}
/**
 * Return the named global object if available, will return null if the object is not available.
 * @param name The globally named object
 */
function getGlobalInst(name) {
    var gbl = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["h" /* getGlobal */])();
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === strWindow && hasWindow()) {
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        return window;
    }
    return null;
}
/**
 * Checks if window object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a window
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: window is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasWindow() {
    return Boolean(typeof window === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && window);
}
/**
 * Returns the global window object if it is present otherwise null.
 * This helper is used to access the window object without causing an exception
 * "Uncaught ReferenceError: window is not defined"
 */
function getWindow() {
    if (hasWindow()) {
        return window;
    }
    // Return the global instance or null
    return getGlobalInst(strWindow);
}
/**
 * Checks if document object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a document
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: document is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasDocument() {
    return Boolean(typeof document === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && document);
}
/**
 * Returns the global document object if it is present otherwise null.
 * This helper is used to access the document object without causing an exception
 * "Uncaught ReferenceError: document is not defined"
 */
function getDocument() {
    if (hasDocument()) {
        return document;
    }
    return getGlobalInst(strDocument);
}
/**
 * Checks if navigator object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a navigator
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: navigator is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasNavigator() {
    return Boolean(typeof navigator === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && navigator);
}
/**
 * Returns the global navigator object if it is present otherwise null.
 * This helper is used to access the navigator object without causing an exception
 * "Uncaught ReferenceError: navigator is not defined"
 */
function getNavigator() {
    if (hasNavigator()) {
        return navigator;
    }
    return getGlobalInst(strNavigator);
}
/**
 * Checks if history object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: history is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasHistory() {
    return Boolean(typeof history === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && history);
}
/**
 * Returns the global history object if it is present otherwise null.
 * This helper is used to access the history object without causing an exception
 * "Uncaught ReferenceError: history is not defined"
 */
function getHistory() {
    if (hasHistory()) {
        return history;
    }
    return getGlobalInst(strHistory);
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
function getLocation(checkForMock) {
    if (checkForMock && _enableMocks) {
        var mockLocation = getGlobalInst("__mockLocation");
        if (mockLocation) {
            return mockLocation;
        }
    }
    if (typeof location === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && location) {
        return location;
    }
    return getGlobalInst(strLocation);
}
/**
 * Returns the global console object
 */
function getConsole() {
    if (typeof console !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */]) {
        return console;
    }
    return getGlobalInst(strConsole);
}
/**
 * Returns the performance object if it is present otherwise null.
 * This helper is used to access the performance object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getPerformance() {
    return getGlobalInst(strPerformance);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasJSON() {
    return Boolean((typeof JSON === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && JSON) || getGlobalInst(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
function getJSON() {
    if (hasJSON()) {
        return JSON || getGlobalInst(strJSON);
    }
    return null;
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getCrypto() {
    return getGlobalInst(strCrypto);
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getMsCrypto() {
    return getGlobalInst(strMsCrypto);
}
/**
 * Returns whether the environment is reporting that we are running in a React Native Environment
 */
function isReactNative() {
    // If running in React Native, navigator.product will be populated
    var nav = getNavigator();
    if (nav && nav.product) {
        return nav.product === strReactNative;
    }
    return false;
}
/**
 * Identifies whether the current environment appears to be IE
 */
function isIE() {
    var nav = getNavigator();
    if (nav && (nav[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["_0" /* _DYN_USER_AGENT */] /* @min:%2euserAgent */] !== _navUserAgentCheck || _isTrident === null)) {
        // Added to support test mocking of the user agent
        _navUserAgentCheck = nav[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["_0" /* _DYN_USER_AGENT */] /* @min:%2euserAgent */];
        var userAgent = (_navUserAgentCheck || __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */])[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["V" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]();
        _isTrident = (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["K" /* strContains */])(userAgent, strMsie) || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["K" /* strContains */])(userAgent, strTrident));
    }
    return _isTrident;
}
/**
 * Gets IE version returning the document emulation mode if we are running on IE, or null otherwise
 */
function getIEVersion(userAgentStr) {
    if (userAgentStr === void 0) { userAgentStr = null; }
    if (!userAgentStr) {
        var navigator_1 = getNavigator() || {};
        userAgentStr = navigator_1 ? (navigator_1[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["_0" /* _DYN_USER_AGENT */] /* @min:%2euserAgent */] || __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */])[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["V" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]() : __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */];
    }
    var ua = (userAgentStr || __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */])[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["V" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]();
    // Also check for documentMode in case X-UA-Compatible meta tag was included in HTML.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["K" /* strContains */])(ua, strMsie)) {
        var doc = getDocument() || {};
        return Math.max(parseInt(ua[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["P" /* _DYN_SPLIT */] /* @min:%2esplit */](strMsie)[1]), (doc[strDocumentMode] || 0));
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["K" /* strContains */])(ua, strTrident)) {
        var tridentVer = parseInt(ua[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["P" /* _DYN_SPLIT */] /* @min:%2esplit */](strTrident)[1]);
        if (tridentVer) {
            return tridentVer + 4;
        }
    }
    return null;
}
/**
 * Returns string representation of an object suitable for diagnostics logging.
 */
function dumpObj(object) {
    var objectTypeDump = Object[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]].toString[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](object);
    var propertyValueDump = __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */];
    if (objectTypeDump === "[object Error]") {
        propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["D" /* _DYN_NAME */] /* @min:%2ename */] + "'";
    }
    else if (hasJSON()) {
        propertyValueDump = getJSON().stringify(object);
    }
    return objectTypeDump + propertyValueDump;
}
function isSafari(userAgentStr) {
    if (!userAgentStr || !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["v" /* isString */])(userAgentStr)) {
        var navigator_2 = getNavigator() || {};
        userAgentStr = navigator_2 ? (navigator_2[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["_0" /* _DYN_USER_AGENT */] /* @min:%2euserAgent */] || __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */])[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["V" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]() : __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */];
    }
    var ua = (userAgentStr || __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */])[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["V" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]();
    return (ua[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["r" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */]("safari") >= 0);
}
/**
 * Checks if HTML5 Beacons are supported in the current environment.
 * @returns True if supported, false otherwise.
 */
function isBeaconsSupported() {
    if (_beaconsSupported === null) {
        _beaconsSupported = hasNavigator() && Boolean(getNavigator().sendBeacon);
    }
    return _beaconsSupported;
}
/**
 * Checks if the Fetch API is supported in the current environment.
 * @param withKeepAlive - [Optional] If True, check if fetch is available and it supports the keepalive feature, otherwise only check if fetch is supported
 * @returns True if supported, otherwise false
 */
function isFetchSupported(withKeepAlive) {
    var isSupported = false;
    try {
        isSupported = !!getGlobalInst("fetch");
        var request = getGlobalInst("Request");
        if (isSupported && withKeepAlive && request) {
            isSupported = _hasProperty(request, "keepalive");
        }
    }
    catch (e) {
        // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function useXDomainRequest() {
    if (_useXDomainRequest === null) {
        _useXDomainRequest = (typeof XDomainRequest !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */]);
        if (_useXDomainRequest && isXhrSupported()) {
            _useXDomainRequest = _useXDomainRequest && !_hasProperty(getGlobalInst(strXMLHttpRequest), "withCredentials");
        }
    }
    return _useXDomainRequest;
}
/**
 * Checks if XMLHttpRequest is supported
 * @returns True if supported, otherwise false
 */
function isXhrSupported() {
    var isSupported = false;
    try {
        var xmlHttpRequest = getGlobalInst(strXMLHttpRequest);
        isSupported = !!xmlHttpRequest;
    }
    catch (e) {
        // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function _getNamedValue(values, name) {
    if (values) {
        for (var i = 0; i < values[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */]; i++) {
            var value = values[i];
            if (value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["D" /* _DYN_NAME */] /* @min:%2ename */]) {
                if (value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["D" /* _DYN_NAME */] /* @min:%2ename */] === name) {
                    return value;
                }
            }
        }
    }
    return {};
}
/**
 * Helper function to fetch the named meta-tag from the page.
 * @param name
 */
function findMetaTag(name) {
    var doc = getDocument();
    if (doc && name) {
        // Look for a meta-tag
        return _getNamedValue(doc.querySelectorAll("meta"), name).content;
    }
    return null;
}
/**
 * Helper function to fetch the named server timing value from the page response (first navigation event).
 * @param name
 */
function findNamedServerTiming(name) {
    var value;
    var perf = getPerformance();
    if (perf) {
        // Try looking for a server-timing header
        var navPerf = perf.getEntriesByType("navigation") || [];
        value = _getNamedValue((navPerf[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0 ? navPerf[0] : {}).serverTiming, name).description;
    }
    return value;
}
// TODO: should reuse this method for analytics plugin
function dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
        return true;
    }
    return false;
}
function createCustomDomEvent(eventName, details) {
    var event = null;
    var detail = { detail: details || null };
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(CustomEvent)) { // Use CustomEvent constructor when available
        event = new CustomEvent(eventName, detail);
    }
    else { // CustomEvent has no constructor in IE
        var doc = getDocument();
        if (doc && doc.createEvent) {
            event = doc.createEvent("CustomEvent");
            event.initCustomEvent(eventName, true, true, detail);
        }
    }
    return event;
}
function sendCustomEvent(evtName, cfg, customDetails) {
    var global = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["h" /* getGlobal */])();
    if (global && global.CustomEvent) {
        try {
            var details = { cfg: cfg || null, customDetails: customDetails || null };
            return dispatchEvent(global, createCustomDomEvent(evtName, details));
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
    }
    return false;
}
//# sourceMappingURL=EnvUtils.js.map

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = startMonitorErrorCollection;
/* harmony export (immutable) */ __webpack_exports__["d"] = setDebugMode;
/* unused harmony export resetMonitor */
/* unused harmony export monitored */
/* harmony export (immutable) */ __webpack_exports__["c"] = monitor;
/* harmony export (immutable) */ __webpack_exports__["a"] = callMonitored;
/* harmony export (immutable) */ __webpack_exports__["b"] = displayIfDebugEnabled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__display__ = __webpack_require__(109);
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(__WEBPACK_IMPORTED_MODULE_0__display__["a" /* ConsoleApiName */].error, e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(__WEBPACK_IMPORTED_MODULE_0__display__["a" /* ConsoleApiName */].error, e);
            }
        }
    }
}
function displayIfDebugEnabled(api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugMode) {
        __WEBPACK_IMPORTED_MODULE_0__display__["b" /* display */].apply(void 0, __spreadArray([api, '[MONITOR]'], args, false));
    }
}
//# sourceMappingURL=monitor.js.map

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ActivityApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var ActivityApiController = /** @class */ (function () {
    function ActivityApiController() {
        // get: Activity/GetActivity/${activityId}
        this.RouteGetActivity = function (activityId) { return "Activity/GetActivity/" + activityId; };
        // post: Activity/GetActivityTableData/${isSurvey}
        this.RouteGetActivityTableData = function (isSurvey) { return "Activity/GetActivityTableData/" + isSurvey; };
        // post: Activity/UpdateActivity
        this.RouteUpdateActivity = function () { return "Activity/UpdateActivity"; };
        // get: Activity/GetActivityQuestion/${activityQuestionId}
        this.RouteGetActivityQuestion = function (activityQuestionId) { return "Activity/GetActivityQuestion/" + activityQuestionId; };
        // post: Activity/AddActivityQuestion
        this.RouteAddActivityQuestion = function () { return "Activity/AddActivityQuestion"; };
        // post: Activity/UpdateActivityQuestion
        this.RouteUpdateActivityQuestion = function () { return "Activity/UpdateActivityQuestion"; };
        // post: Activity/DeleteActivityQuestion/${activityQuestionId}
        this.RouteDeleteActivityQuestion = function (activityQuestionId) { return "Activity/DeleteActivityQuestion/" + activityQuestionId; };
        // post: Activity/GetActivityQuestionTableData/${activityId}
        this.RouteGetActivityQuestionTableData = function (activityId) { return "Activity/GetActivityQuestionTableData/" + activityId; };
        // get: Activity/GetActivitySummary/${activitySummaryId}
        this.RouteGetActivitySummary = function (activitySummaryId) { return "Activity/GetActivitySummary/" + activitySummaryId; };
        // post: Activity/AddActivitySummary
        this.RouteAddActivitySummary = function () { return "Activity/AddActivitySummary"; };
        // post: Activity/UpdateActivitySummary
        this.RouteUpdateActivitySummary = function () { return "Activity/UpdateActivitySummary"; };
        // post: Activity/DeleteActivitySummary/${activitySummaryId}
        this.RouteDeleteActivitySummary = function (activitySummaryId) { return "Activity/DeleteActivitySummary/" + activitySummaryId; };
        // post: Activity/GetActivitySummaryTableData/${activityId}
        this.RouteGetActivitySummaryTableData = function (activityId) { return "Activity/GetActivitySummaryTableData/" + activityId; };
        // post: Activity/GetActivityQuestionCategories/${activityId}
        this.RouteGetActivityQuestionCategories = function (activityId) { return "Activity/GetActivityQuestionCategories/" + activityId; };
        // post: Activity/GetActivitySummaries/${activityId}
        this.RouteGetActivitySummaries = function (activityId) { return "Activity/GetActivitySummaries/" + activityId; };
        // get: Activity/GetActivityQuestionCategory/${activityQuestionCategoryId}
        this.RouteGetActivityQuestionCategory = function (activityQuestionCategoryId) { return "Activity/GetActivityQuestionCategory/" + activityQuestionCategoryId; };
        // post: Activity/AddActivityQuestionCategory
        this.RouteAddActivityQuestionCategory = function () { return "Activity/AddActivityQuestionCategory"; };
        // post: Activity/UpdateActivityQuestionCategory
        this.RouteUpdateActivityQuestionCategory = function () { return "Activity/UpdateActivityQuestionCategory"; };
        // post: Activity/DeleteActivityQuestionCategory/${activityQuestionCategoryId}
        this.RouteDeleteActivityQuestionCategory = function (activityQuestionCategoryId) { return "Activity/DeleteActivityQuestionCategory/" + activityQuestionCategoryId; };
        // post: Activity/GetActivityQuestionCategoryTableData/${activityId}
        this.RouteGetActivityQuestionCategoryTableData = function (activityId) { return "Activity/GetActivityQuestionCategoryTableData/" + activityId; };
        // get: Activity/GetActivityQuestionResponse/${activityQuestionResponseId}
        this.RouteGetActivityQuestionResponse = function (activityQuestionResponseId) { return "Activity/GetActivityQuestionResponse/" + activityQuestionResponseId; };
        // post: Activity/AddActivityQuestionResponse
        this.RouteAddActivityQuestionResponse = function () { return "Activity/AddActivityQuestionResponse"; };
        // post: Activity/UpdateActivityQuestionResponse
        this.RouteUpdateActivityQuestionResponse = function () { return "Activity/UpdateActivityQuestionResponse"; };
        // post: Activity/DeleteActivityQuestionResponse/${activityQuestionResponseId}
        this.RouteDeleteActivityQuestionResponse = function (activityQuestionResponseId) { return "Activity/DeleteActivityQuestionResponse/" + activityQuestionResponseId; };
        // post: Activity/GetActivityQuestionResponseTableData/${activityQuestionId}
        this.RouteGetActivityQuestionResponseTableData = function (activityQuestionId) { return "Activity/GetActivityQuestionResponseTableData/" + activityQuestionId; };
        // post: Activity/GetStudentActivities
        this.RouteGetStudentActivities = function () { return "Activity/GetStudentActivities"; };
        // get: Activity/GetStudentActivityResponses/${activityId}
        this.RouteGetStudentActivityResponses = function (activityId) { return "Activity/GetStudentActivityResponses/" + activityId; };
        // get: Activity/GetStudentActivitySummary/${activityId}
        this.RouteGetStudentActivitySummary = function (activityId) { return "Activity/GetStudentActivitySummary/" + activityId; };
        // post: Activity/SubmitStudentActivity
        this.RouteSubmitStudentActivity = function () { return "Activity/SubmitStudentActivity"; };
        // get: Activity/GetActivitiesForAcademicStandard
        this.RouteGetActivitiesForAcademicStandard = function () { return "Activity/GetActivitiesForAcademicStandard"; };
    }
    ActivityApiController.prototype.getActivity = function (activityId, requestOptions) {
        var url = this.RouteGetActivity(activityId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ActivityApiController.prototype.getActivityTableData = function (tableRequest, isSurvey, requestOptions) {
        var url = this.RouteGetActivityTableData(isSurvey);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.updateActivity = function (updateActivity, requestOptions) {
        var url = this.RouteUpdateActivity();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateActivity, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivityQuestion = function (activityQuestionId, requestOptions) {
        var url = this.RouteGetActivityQuestion(activityQuestionId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ActivityApiController.prototype.addActivityQuestion = function (addActivityQuestion, requestOptions) {
        var url = this.RouteAddActivityQuestion();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addActivityQuestion, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.updateActivityQuestion = function (updateActivityQuestionDTO, requestOptions) {
        var url = this.RouteUpdateActivityQuestion();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateActivityQuestionDTO, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.deleteActivityQuestion = function (activityQuestionId, requestOptions) {
        var url = this.RouteDeleteActivityQuestion(activityQuestionId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivityQuestionTableData = function (tableRequest, activityId, requestOptions) {
        var url = this.RouteGetActivityQuestionTableData(activityId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivitySummary = function (activitySummaryId, requestOptions) {
        var url = this.RouteGetActivitySummary(activitySummaryId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ActivityApiController.prototype.addActivitySummary = function (addActivitySummary, requestOptions) {
        var url = this.RouteAddActivitySummary();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addActivitySummary, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.updateActivitySummary = function (updateActivitySummary, requestOptions) {
        var url = this.RouteUpdateActivitySummary();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateActivitySummary, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.deleteActivitySummary = function (activitySummaryId, requestOptions) {
        var url = this.RouteDeleteActivitySummary(activitySummaryId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivitySummaryTableData = function (tableRequest, activityId, requestOptions) {
        var url = this.RouteGetActivitySummaryTableData(activityId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivityQuestionCategories = function (activityId, requestOptions) {
        var url = this.RouteGetActivityQuestionCategories(activityId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivitySummaries = function (activityId, requestOptions) {
        var url = this.RouteGetActivitySummaries(activityId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivityQuestionCategory = function (activityQuestionCategoryId, requestOptions) {
        var url = this.RouteGetActivityQuestionCategory(activityQuestionCategoryId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ActivityApiController.prototype.addActivityQuestionCategory = function (addActivityQuestionCategory, requestOptions) {
        var url = this.RouteAddActivityQuestionCategory();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addActivityQuestionCategory, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.updateActivityQuestionCategory = function (updateActivityQuestionCategory, requestOptions) {
        var url = this.RouteUpdateActivityQuestionCategory();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateActivityQuestionCategory, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.deleteActivityQuestionCategory = function (activityQuestionCategoryId, requestOptions) {
        var url = this.RouteDeleteActivityQuestionCategory(activityQuestionCategoryId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivityQuestionCategoryTableData = function (tableRequest, activityId, requestOptions) {
        var url = this.RouteGetActivityQuestionCategoryTableData(activityId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivityQuestionResponse = function (activityQuestionResponseId, requestOptions) {
        var url = this.RouteGetActivityQuestionResponse(activityQuestionResponseId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ActivityApiController.prototype.addActivityQuestionResponse = function (requestOptions) {
        var url = this.RouteAddActivityQuestionResponse();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.updateActivityQuestionResponse = function (requestOptions) {
        var url = this.RouteUpdateActivityQuestionResponse();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.deleteActivityQuestionResponse = function (activityQuestionResponseId, requestOptions) {
        var url = this.RouteDeleteActivityQuestionResponse(activityQuestionResponseId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivityQuestionResponseTableData = function (tableRequest, activityQuestionId, requestOptions) {
        var url = this.RouteGetActivityQuestionResponseTableData(activityQuestionId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getStudentActivities = function (model, requestOptions) {
        var url = this.RouteGetStudentActivities();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(model, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getStudentActivityResponses = function (activityId, requestOptions) {
        var url = this.RouteGetStudentActivityResponses(activityId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ActivityApiController.prototype.getStudentActivitySummary = function (activityId, requestOptions) {
        var url = this.RouteGetStudentActivitySummary(activityId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ActivityApiController.prototype.submitStudentActivity = function (submission, requestOptions) {
        var url = this.RouteSubmitStudentActivity();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(submission, 'post', url, requestOptions);
    };
    ActivityApiController.prototype.getActivitiesForAcademicStandard = function (requestOptions) {
        var url = this.RouteGetActivitiesForAcademicStandard();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    return ActivityApiController;
}());

var service = new ActivityApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagnosis__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Helpers__ = __webpack_require__(111);
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};



/**
 * Represents the game state, passed around from scene to scene
 * */
var GameState = /** @class */ (function () {
    function GameState() {
        this.hasSeenQuiz = false;
        this.numberOfDiagnosisOptions = 3;
        this.getDiagnosisOptions();
        this.sceneNumber = 0;
    }
    /**
     * Generate all diagnosis options (one will be picked for the game, the others will be used at the end for options in the quiz)
     */
    GameState.prototype.generateRandomDiagnosisOptions = function () {
        this.diagnosisOptions = [];
        while (this.diagnosisOptions.length < this.numberOfDiagnosisOptions + 1) {
            var diseaseName = __WEBPACK_IMPORTED_MODULE_0__Diagnosis__["a" /* Diagnosis */].getRandomDiseaseName();
            var diagnosisOption = new __WEBPACK_IMPORTED_MODULE_0__Diagnosis__["a" /* Diagnosis */](diseaseName);
            if (this.diagnosisOptions.length === 0) {
                this.diagnosisOptions.push(diagnosisOption);
            }
            else {
                // Ensure uniqueness of all diagnoses
                if (this.isUnique(diagnosisOption)) {
                    this.diagnosisOptions.push(diagnosisOption);
                }
            }
        }
        // Assign the last one as the correct diagnosis for this game
        this.correctDiagnosis = this.diagnosisOptions.pop();
        // Create an option that is almost the same as correct option to make the quiz harder
        var similarOption = this.diagnosisOptions[Phaser.Math.Between(0, this.diagnosisOptions.length - 1)];
        similarOption.bacteriaCount = this.correctDiagnosis.bacteriaCount + 1;
        similarOption.bacteriaColor = this.correctDiagnosis.bacteriaColor;
        similarOption.reactionAsset = this.correctDiagnosis.reactionAsset;
        similarOption.healthyCellColor = this.correctDiagnosis.healthyCellColor;
        similarOption.sickCellColor = this.correctDiagnosis.sickCellColor;
        // Force them to have different color changer colors
        similarOption.colorChangerColor = this.getUnusedColor(similarOption, this.correctDiagnosis.colorChangerColor);
    };
    GameState.prototype.getDiagnosisOptions = function () {
        var options = __WEBPACK_IMPORTED_MODULE_2__Helpers__["a" /* Helpers */].scrambleArray(__spreadArrays(__WEBPACK_IMPORTED_MODULE_0__Diagnosis__["a" /* Diagnosis */].DIAGNOSIS_OPTIONS));
        this.diagnosisOptions = options.slice(0, this.numberOfDiagnosisOptions + 1);
        this.correctDiagnosis = this.diagnosisOptions.pop();
        this.diagnosisOptions[0].bacteriaColor = this.correctDiagnosis.bacteriaColor;
        this.diagnosisOptions[0].bacteriaCount = this.correctDiagnosis.bacteriaCount + 1;
    };
    GameState.prototype.getUnusedColor = function (diagnosis, notThisColor) {
        var actualColors = [
            __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("red"),
            __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("blue"),
            __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("green"),
            __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("yellow"),
            __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("orange"),
            __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("purple"),
            __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("teal"),
            __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("pink"),
        ];
        // Grab a color that hasn't been used in the current diagnosis AND isn't the same as the correct diagnosis's color
        for (var _i = 0, actualColors_1 = actualColors; _i < actualColors_1.length; _i++) {
            var c = actualColors_1[_i];
            if (diagnosis.colorChangerColor !== c && diagnosis.bacteriaColor !== c && diagnosis.healthyCellColor !== c && diagnosis.sickCellColor !== c &&
                notThisColor !== c) {
                return c;
            }
        }
    };
    /**
     * Checks that the diagnosis is unique
     */
    GameState.prototype.isUnique = function (diagnosisOption) {
        for (var _i = 0, _a = this.diagnosisOptions; _i < _a.length; _i++) {
            var option = _a[_i];
            if (__WEBPACK_IMPORTED_MODULE_0__Diagnosis__["a" /* Diagnosis */].hasSameDiseaseName(diagnosisOption.diseaseName, option.diseaseName)) {
                // Disease names must be unique regardless of color
                return false;
            }
        }
        return true;
    };
    GameState.prototype.hasSameColors = function (colors1, colors2) {
        if (colors1.length !== colors2.length) {
            return false;
        }
        for (var i = colors1.length; i--;) {
            if (colors1[i].value !== colors2[i].value) {
                return false;
            }
        }
        return true;
    };
    return GameState;
}());



/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DisabledPropertyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SampleRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProcessLegacy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HttpMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_BREEZE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_BREEZE_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return strNotSpecified; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return strIkey; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var DEFAULT_BREEZE_PATH = "/v2/track";
var strNotSpecified = "not_specified";
var strIkey = "iKey";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataSanitizeKeyAndAddUniqueness */
/* unused harmony export dataSanitizeKey */
/* harmony export (immutable) */ __webpack_exports__["g"] = dataSanitizeString;
/* harmony export (immutable) */ __webpack_exports__["h"] = dataSanitizeUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = dataSanitizeMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = dataSanitizeException;
/* harmony export (immutable) */ __webpack_exports__["f"] = dataSanitizeProperties;
/* harmony export (immutable) */ __webpack_exports__["d"] = dataSanitizeMeasurements;
/* harmony export (immutable) */ __webpack_exports__["c"] = dataSanitizeId;
/* unused harmony export dataSanitizeInput */
/* unused harmony export dsPadNumber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataSanitizer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(88);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var _a;


function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
    var origLength = key[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */];
    var field = dataSanitizeKey(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] !== origLength) {
        var i = 0;
        var uniqueField = field;
        while (map[uniqueField] !== undefined) {
            i++;
            uniqueField = field[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["M" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
        }
        field = uniqueField;
    }
    return field;
}
function dataSanitizeKey(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitespace
        name = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_38" /* strTrim */])(name[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */]());
        // truncate the string to 150 chars
        if (name[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */) {
            nameTrunc = name[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["M" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */);
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 57 /* _eInternalMessageId.NameTooLong */, "name is too long.  It has been truncated to " + 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ + " characters.", { name: name }, true);
        }
    }
    return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
    if (maxLength === void 0) { maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; }
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; // in case default parameters dont work
        value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_38" /* strTrim */])(value);
        if (value.toString()[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > maxLength) {
            valueTrunc = value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */]()[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["M" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](0, maxLength);
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 61 /* _eInternalMessageId.StringValueTooLong */, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
        }
    }
    return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
    return dataSanitizeInput(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */, 66 /* _eInternalMessageId.UrlTooLong */);
}
function dataSanitizeMessage(logger, message) {
    var messageTrunc;
    if (message) {
        if (message[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */) {
            messageTrunc = message[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["M" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */);
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 56 /* _eInternalMessageId.MessageTruncated */, "message is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ + " characters.", { message: message }, true);
        }
    }
    return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */) {
            exceptionTrunc = value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["M" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */);
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 52 /* _eInternalMessageId.ExceptionTruncated */, "exception is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ + " characters.", { exception: exception }, true);
        }
    }
    return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(properties, function (prop, value) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_11" /* isObject */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_0" /* hasJSON */])()) {
                // Stringify any part C properties
                try {
                    value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["S" /* getJSON */])()[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["L" /* _DYN_STRINGIFY */] /* @min:%2estringify */](value);
                }
                catch (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "custom property is not valid", { exception: e }, true);
                }
            }
            value = dataSanitizeString(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */);
            prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(measurements, function (measure, value) {
            measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function dataSanitizeId(logger, id) {
    return id ? dataSanitizeInput(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */, 69 /* _eInternalMessageId.IdTooLong */)[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */]() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_38" /* strTrim */])(input);
        if (input[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > maxLength) {
            inputTrunc = input[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["M" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](0, maxLength);
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
        }
    }
    return inputTrunc || input;
}
function dsPadNumber(num) {
    var s = "00" + num;
    return s.substr(s[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] - 3);
}
/**
 * Provides the DataSanitizer functions within the previous namespace.
 */
var DataSanitizer = (_a = {
        MAX_NAME_LENGTH: 150 /* DataSanitizerValues.MAX_NAME_LENGTH */,
        MAX_ID_LENGTH: 128 /* DataSanitizerValues.MAX_ID_LENGTH */,
        MAX_PROPERTY_LENGTH: 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */,
        MAX_STRING_LENGTH: 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */,
        MAX_URL_LENGTH: 2048 /* DataSanitizerValues.MAX_URL_LENGTH */,
        MAX_MESSAGE_LENGTH: 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */,
        MAX_EXCEPTION_LENGTH: 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */
    },
    _a[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["F" /* _DYN_SANITIZE_KEY_AND_ADD2 */] /* @min:sanitizeKeyAndAddUniqueness */] = dataSanitizeKeyAndAddUniqueness,
    _a.sanitizeKey = dataSanitizeKey,
    _a.sanitizeString = dataSanitizeString,
    _a.sanitizeUrl = dataSanitizeUrl,
    _a.sanitizeMessage = dataSanitizeMessage,
    _a[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["E" /* _DYN_SANITIZE_EXCEPTION */] /* @min:sanitizeException */] = dataSanitizeException,
    _a[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_SANITIZE_PROPERTIES */] /* @min:sanitizeProperties */] = dataSanitizeProperties,
    _a[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["G" /* _DYN_SANITIZE_MEASUREMENT3 */] /* @min:sanitizeMeasurements */] = dataSanitizeMeasurements,
    _a.sanitizeId = dataSanitizeId,
    _a.sanitizeInput = dataSanitizeInput,
    _a.padNumber = dsPadNumber,
    _a.trim = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_38" /* strTrim */],
    _a);
//# sourceMappingURL=DataSanitizer.js.map

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PhaserGamePadConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhaserGamePad; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var GenericKey = /** @class */ (function (_super) {
    __extends(GenericKey, _super);
    function GenericKey(key) {
        var _this = _super.call(this) || this;
        _this.isPressed = false;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, GenericKey.prototype);
        _this.key = key.toUpperCase();
        return _this;
    }
    GenericKey.prototype.isDown = function () {
        return this.isPressed;
    };
    GenericKey.prototype.isUp = function () {
        return !this.isDown;
    };
    return GenericKey;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]));
var ImageKey = /** @class */ (function (_super) {
    __extends(ImageKey, _super);
    function ImageKey(inputPlugin, keyString, image) {
        var _this = _super.call(this, keyString) || this;
        _this.pointerId = 99;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ImageKey.prototype);
        image.on("pointerdown", function (pointer) {
            _this.pointerId = pointer.id;
            _this.isPressed = true;
            _this.emit("fancy_keydown", _this.key);
        });
        inputPlugin.on("pointerup", function (pointer) {
            if (pointer.id === _this.pointerId) {
                _this.isPressed = false;
                _this.pointerId = 99;
                _this.emit("fancy_keyup", _this.key);
            }
        });
        return _this;
    }
    return ImageKey;
}(GenericKey));
var KeyboardKey = /** @class */ (function (_super) {
    __extends(KeyboardKey, _super);
    // constructor(inputPlugin: Phaser.Input.InputPlugin, key: Phaser.Input.Keyboard.Key, keyString: string) {
    function KeyboardKey(inputPlugin, keyString) {
        var _this = _super.call(this, keyString) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, KeyboardKey.prototype);
        // This has to be done or the event will not fire... maybe
        // inputPlugin.keyboard.addKey(key);
        inputPlugin.keyboard.on("keydown_" + keyString.toUpperCase(), function () {
            _this.isPressed = true;
            _this.emit("fancy_keydown", _this.key);
        });
        inputPlugin.keyboard.on("keyup_" + keyString.toUpperCase(), function () {
            _this.isPressed = false;
            _this.emit("fancy_keyup", _this.key);
        });
        return _this;
    }
    return KeyboardKey;
}(GenericKey));
var KeyCollection = /** @class */ (function (_super) {
    __extends(KeyCollection, _super);
    function KeyCollection() {
        var _this = _super.call(this) || this;
        _this.collection = [];
        _this.isPressed = false;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, KeyCollection.prototype);
        return _this;
    }
    Object.defineProperty(KeyCollection.prototype, "isDown", {
        get: function () {
            return this.isPressed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeyCollection.prototype, "isUp", {
        get: function () {
            return !this.isPressed;
        },
        enumerable: false,
        configurable: true
    });
    KeyCollection.prototype.updatePressedState = function () {
        // This is purely an optimization function
        // Putting this into 'isDown()' would cause it to run atleast once every frame
        this.isPressed = this.collection.reduce(function (first, second) {
            return first || second.isDown();
        }, false);
    };
    KeyCollection.prototype.addKey = function (newKey) {
        newKey.on("fancy_keydown", this.handleKeyDown);
        newKey.on("fancy_keyup", this.handleKeyUp);
        this.collection.push(newKey);
    };
    KeyCollection.prototype.handleKeyDown = function () {
        if (!this.alreadyTriggered) {
            this.alreadyTriggered = true;
            this.updatePressedState();
            this.emit("keydown");
        }
    };
    KeyCollection.prototype.handleKeyUp = function () {
        // If we are still in the 'down' state, we do not want to trigger a 'keyup' event
        // The event *should* occur after the properties are set. Crossing my fingers on this one
        this.updatePressedState();
        if (this.isUp) {
            this.alreadyTriggered = false;
            this.emit("keyup");
        }
    };
    return KeyCollection;
}(__WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]));
var GamePadKeys = /** @class */ (function () {
    function GamePadKeys() {
        this.up = new KeyCollection();
        this.down = new KeyCollection();
        this.left = new KeyCollection();
        this.right = new KeyCollection();
        this.a = new KeyCollection();
        this.b = new KeyCollection();
    }
    return GamePadKeys;
}());
var PhaserGamePadConfig = /** @class */ (function () {
    function PhaserGamePadConfig() {
        this.scale = 1.25;
        this.texture = "normal";
        this.enableArrowKeys = true;
        this.enableButtons = true;
        this.showOnScreenDisplayOnDesktop = false;
    }
    return PhaserGamePadConfig;
}());

var GamePadTheme = /** @class */ (function () {
    function GamePadTheme() {
    }
    return GamePadTheme;
}());
var PhaserGamePad = /** @class */ (function (_super) {
    __extends(PhaserGamePad, _super);
    function PhaserGamePad(scene, config) {
        if (config === void 0) { config = new PhaserGamePadConfig(); }
        var _this = _super.call(this, scene, 0, 0) || this;
        _this.themes = {
            normal: { up: "up", down: "down", left: "left", right: "right", a: "a", b: "b", },
            inverted: { up: "up_inverted", down: "down_inverted", left: "left_inverted", right: "right_inverted", a: "a_inverted", b: "b_inverted", }
        };
        _this.ARROW_CONST = 64;
        _this.GAMEPAD_ALPHA = .66;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserGamePad.prototype);
        _this.config = config;
        _this.arrowSize = _this.ARROW_CONST * config.scale;
        _this.isTouchAvailable = _this.scene.sys.game.device.input.touch;
        // Multitouch support!
        if (_this.isTouchAvailable) {
            _this.scene.input.addPointer(6);
        }
        _this.keys = new GamePadKeys();
        _this.initialize();
        return _this;
    }
    PhaserGamePad.preload = function (scene) {
        scene.load.atlas("gamePad_assets", __webpack_require__(2210), __webpack_require__(2211));
    };
    PhaserGamePad.prototype.initialize = function () {
        // Setup the container
        this.setSize(this.scene.sys.canvas.width, this.arrowSize * 3.25);
        this.setPosition(0, this.scene.sys.canvas.height - this.height);
        this.setAlpha(this.GAMEPAD_ALPHA);
        this.setDepth(1000); // This solves overlay issues
        // Setup theme
        this.configureTheme();
        // Construct Objects
        this.createOnscreenKeyboard();
        this.bindPhysicalKeyboard();
        // Bind events
        this.bindEvents();
        // Add items to self and self to scene
        this.scene.add.existing(this);
    };
    PhaserGamePad.prototype.configureTheme = function () {
        switch (this.config.texture) {
            case "normal":
                this.theme = this.themes.normal;
                break;
            case "inverted":
                this.theme = this.themes.inverted;
                break;
            default:
                // The following line guarantees that every action is accounted for #magic
                var exhaustiveCheck = this.config.texture;
        }
    };
    PhaserGamePad.prototype.bindPhysicalKeyboard = function () {
        // Run through the set of 'keyboards' we want
        this.keys.up.addKey(new KeyboardKey(this.scene.input, "up"));
        this.keys.down.addKey(new KeyboardKey(this.scene.input, "down"));
        this.keys.left.addKey(new KeyboardKey(this.scene.input, "left"));
        this.keys.right.addKey(new KeyboardKey(this.scene.input, "right"));
        this.keys.a.addKey(new KeyboardKey(this.scene.input, "space"));
        this.keys.b.addKey(new KeyboardKey(this.scene.input, "enter"));
        this.keys.b.addKey(new KeyboardKey(this.scene.input, "e"));
        this.keys.up.addKey(new KeyboardKey(this.scene.input, "w"));
        this.keys.down.addKey(new KeyboardKey(this.scene.input, "s"));
        this.keys.left.addKey(new KeyboardKey(this.scene.input, "a"));
        this.keys.right.addKey(new KeyboardKey(this.scene.input, "d"));
    };
    PhaserGamePad.prototype.createOnscreenKeyboard = function () {
        // Dont bind onscreen keys if we are not showing them
        if (!this.isTouchAvailable && !this.config.showOnScreenDisplayOnDesktop) {
            return;
        }
        if (this.config.enableArrowKeys) {
            this.keys.up.addKey(new ImageKey(this.scene.input, "up", this.configureImage(this.theme.up, this.arrowSize * 1.5, 0)));
            this.keys.down.addKey(new ImageKey(this.scene.input, "down", this.configureImage(this.theme.down, this.arrowSize * 1.5, this.arrowSize * 2)));
            this.keys.left.addKey(new ImageKey(this.scene.input, "left", this.configureImage(this.theme.left, this.arrowSize * 0.5, this.arrowSize * 1)));
            this.keys.right.addKey(new ImageKey(this.scene.input, "right", this.configureImage(this.theme.right, this.arrowSize * 2.5, this.arrowSize * 1)));
        }
        if (this.config.enableButtons) {
            this.keys.a.addKey(new ImageKey(this.scene.input, "a", this.configureImage(this.theme.a, this.width - this.arrowSize * 1.5, this.arrowSize * 0.5)));
            this.keys.b.addKey(new ImageKey(this.scene.input, "b", this.configureImage(this.theme.b, this.width - this.arrowSize * 3, this.arrowSize * 1.75)));
        }
    };
    PhaserGamePad.prototype.configureImage = function (texture, x, y) {
        var gameObject = this.scene.add.image(x, y, "gamePad_assets", texture);
        gameObject.setOrigin(0);
        gameObject.setInteractive();
        gameObject.setScrollFactor(0);
        gameObject.setDisplaySize(this.arrowSize, this.arrowSize);
        gameObject.setDepth(2);
        this.add(gameObject);
        return gameObject;
    };
    PhaserGamePad.prototype.bindEvents = function () {
        var _this = this;
        this.keys.up.on("keydown", function () {
            _this.emit("keydown_up");
        });
        this.keys.up.on("keyup", function () {
            _this.emit("keyup_up");
        });
        this.keys.down.on("keydown", function () {
            _this.emit("keydown_down");
        });
        this.keys.down.on("keyup", function () {
            _this.emit("keyup_down");
        });
        this.keys.left.on("keydown", function () {
            _this.emit("keydown_left");
        });
        this.keys.left.on("keyup", function () {
            _this.emit("keyup_left");
        });
        this.keys.right.on("keydown", function () {
            _this.emit("keydown_right");
        });
        this.keys.right.on("keyup", function () {
            _this.emit("keyup_right");
        });
        this.keys.a.on("keydown", function () {
            _this.emit("keydown_a");
        });
        this.keys.a.on("keyup", function () {
            _this.emit("keyup_a");
        });
        this.keys.b.on("keydown", function () {
            _this.emit("keydown_b");
        });
        this.keys.b.on("keyup", function () {
            _this.emit("keyup_b");
        });
    };
    return PhaserGamePad;
}(Phaser.GameObjects.Container));



/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var UserApiController = /** @class */ (function () {
    function UserApiController() {
        // post: User/IsValidEmail
        this.RouteIsValidEmail = function () { return "User/IsValidEmail"; };
        // post: User/AddUser
        this.RouteAddUser = function () { return "User/AddUser"; };
        // post: User/UpdateUser
        this.RouteUpdateUser = function () { return "User/UpdateUser"; };
        // get: User/GetUser/${userId}
        this.RouteGetUser = function (userId) { return "User/GetUser/" + userId; };
        // post: User/GetUserTableData/${isAdminTable}/${classroomId}/${onlyClassroomUsers}
        this.RouteGetUserTableData = function (isAdminTable, classroomId, onlyClassroomUsers) { return "User/GetUserTableData/" + isAdminTable + "/" + classroomId + "/" + onlyClassroomUsers; };
        // post: User/GetUserTableData
        this.RouteGetUniversalUserSearchTableData = function () { return "User/GetUserTableData"; };
        // get: User/GetTeacherCounselorAdminsForSchool
        this.RouteGetTeacherCounselorAdminsForSchool = function () { return "User/GetTeacherCounselorAdminsForSchool"; };
        // get: User/AddUserToClassroom/${userId}/${classroomId}
        this.RouteAddUserToClassroom = function (userId, classroomId) { return "User/AddUserToClassroom/" + userId + "/" + classroomId; };
        // post: User/DeactivateUser/${userId}
        this.RouteDeactivateUser = function (userId) { return "User/DeactivateUser/" + userId; };
        // get: User/RemoveUserFromClassroom/${userId}/${classroomId}
        this.RouteRemoveUserFromClassroom = function (userId, classroomId) { return "User/RemoveUserFromClassroom/" + userId + "/" + classroomId; };
        // get: User/GetMassStudentUploadTemplate
        this.RouteGetMassStudentUploadTemplate = function () { return "User/GetMassStudentUploadTemplate"; };
        // get: User/GetAllActiveInactiveStudents/${isActive}
        this.RouteGetAllActiveInactiveStudents = function (isActive) { return "User/GetAllActiveInactiveStudents/" + isActive; };
        // post: User/MassStudentUploadV2
        this.RouteMassStudentUploadV2 = function () { return "User/MassStudentUploadV2"; };
        // get: User/GetUserStatus
        this.RouteGetUserStatus = function () { return "User/GetUserStatus"; };
        // get: User/GetFullUserStatus
        this.RouteGetFullUserStatus = function () { return "User/GetFullUserStatus"; };
        // post: User/UpdateUserStatus
        this.RouteUpdateUserStatus = function () { return "User/UpdateUserStatus"; };
        // get: User/GetCurrentUserProgression
        this.RouteGetCurrentUserProgression = function () { return "User/GetCurrentUserProgression"; };
        // post: User/UpdateUserProgression
        this.RouteUpdateUserProgression = function () { return "User/UpdateUserProgression"; };
        // get: User/GetUserCultures
        this.RouteGetUserCultures = function () { return "User/GetUserCultures"; };
        // post: User/MarkGameCompleted
        this.RouteMarkGameCompleted = function () { return "User/MarkGameCompleted"; };
        // post: User/MarkVideoWatched
        this.RouteMarkVideoWatched = function () { return "User/MarkVideoWatched"; };
        // post: User/ResetPassword
        this.RouteAdminPasswordReset = function () { return "User/ResetPassword"; };
    }
    UserApiController.prototype.isValidEmail = function (validEmail, requestOptions) {
        var url = this.RouteIsValidEmail();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(validEmail, 'post', url, requestOptions);
    };
    UserApiController.prototype.addUser = function (addUserDTO, requestOptions) {
        var url = this.RouteAddUser();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addUserDTO, 'post', url, requestOptions);
    };
    UserApiController.prototype.updateUser = function (updateUserDTO, requestOptions) {
        var url = this.RouteUpdateUser();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateUserDTO, 'post', url, requestOptions);
    };
    UserApiController.prototype.getUser = function (userId, requestOptions) {
        var url = this.RouteGetUser(userId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    UserApiController.prototype.getUserTableData = function (tableRequest, isAdminTable, classroomId, onlyClassroomUsers, requestOptions) {
        var url = this.RouteGetUserTableData(isAdminTable, classroomId, onlyClassroomUsers);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    UserApiController.prototype.getUniversalUserSearchTableData = function (tableRequest, requestOptions) {
        var url = this.RouteGetUniversalUserSearchTableData();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    UserApiController.prototype.getTeacherCounselorAdminsForSchool = function (requestOptions) {
        var url = this.RouteGetTeacherCounselorAdminsForSchool();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    UserApiController.prototype.addUserToClassroom = function (userId, classroomId, requestOptions) {
        var url = this.RouteAddUserToClassroom(userId, classroomId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    UserApiController.prototype.deactivateUser = function (userId, requestOptions) {
        var url = this.RouteDeactivateUser(userId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    UserApiController.prototype.removeUserFromClassroom = function (userId, classroomId, requestOptions) {
        var url = this.RouteRemoveUserFromClassroom(userId, classroomId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    UserApiController.prototype.getMassStudentUploadTemplate = function (requestOptions) {
        var url = this.RouteGetMassStudentUploadTemplate();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    UserApiController.prototype.getAllActiveInactiveStudents = function (isActive, requestOptions) {
        var url = this.RouteGetAllActiveInactiveStudents(isActive);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    UserApiController.prototype.massStudentUploadV2 = function (requestOptions) {
        var url = this.RouteMassStudentUploadV2();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    UserApiController.prototype.getUserStatus = function (requestOptions) {
        var url = this.RouteGetUserStatus();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    UserApiController.prototype.getFullUserStatus = function (requestOptions) {
        var url = this.RouteGetFullUserStatus();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    UserApiController.prototype.updateUserStatus = function (request, requestOptions) {
        var url = this.RouteUpdateUserStatus();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(request, 'post', url, requestOptions);
    };
    UserApiController.prototype.getCurrentUserProgression = function (requestOptions) {
        var url = this.RouteGetCurrentUserProgression();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    UserApiController.prototype.updateUserProgression = function (request, requestOptions) {
        var url = this.RouteUpdateUserProgression();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(request, 'post', url, requestOptions);
    };
    UserApiController.prototype.getUserCultures = function (requestOptions) {
        var url = this.RouteGetUserCultures();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    UserApiController.prototype.markGameCompleted = function (updateUserGame, requestOptions) {
        var url = this.RouteMarkGameCompleted();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateUserGame, 'post', url, requestOptions);
    };
    UserApiController.prototype.markVideoWatched = function (watched, requestOptions) {
        var url = this.RouteMarkVideoWatched();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(watched, 'post', url, requestOptions);
    };
    UserApiController.prototype.adminPasswordReset = function (resetPassword, requestOptions) {
        var url = this.RouteAdminPasswordReset();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(resetPassword, 'post', url, requestOptions);
    };
    return UserApiController;
}());

var service = new UserApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = addOtherDefaultTrackingProperties;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ai; });
/* unused harmony export getAppInsights */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Track; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_web__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_react_js__ = __webpack_require__(787);


var reactPlugin;
var appInsights;
/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
var createTelemetryService = function () {
    /**
     * Initialize the Application Insights class
     * @param {string} instrumentationKey - Application Insights Instrumentation Key
     * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
     * @return {void}
     */
    var initialize = function (instrumentationKey, browserHistory) {
        var _a;
        if (!browserHistory) {
            throw new Error('Could not initialize Telemetry Service');
        }
        if (!instrumentationKey) {
            throw new Error('Instrumentation key not provided in ./src/telemetry-provider.jsx');
        }
        reactPlugin = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_react_js__["a" /* ReactPlugin */]();
        appInsights = new __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_web__["a" /* ApplicationInsights */]({
            config: {
                instrumentationKey: instrumentationKey,
                maxBatchInterval: 0,
                disableFetchTracking: false,
                extensions: [reactPlugin],
                extensionConfig: (_a = {},
                    _a[reactPlugin.identifier] = {
                        history: browserHistory,
                    },
                    _a),
            },
        });
        appInsights.loadAppInsights();
        // Dev Note: Microsoft says we should do this: https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript#npm-based-setup
        appInsights.trackPageView();
    };
    return { reactPlugin: reactPlugin, appInsights: appInsights, initialize: initialize };
};
function addOtherDefaultTrackingProperties(customProperties) {
    appInsights.addTelemetryInitializer(function (envelope) {
        var telemetryItem = envelope.baseData;
        if (telemetryItem != null) {
            telemetryItem.properties = telemetryItem.properties || {};
            telemetryItem.properties = Object.assign(telemetryItem.properties, customProperties);
        }
    });
    return Promise.resolve();
}
var ai = createTelemetryService();
var getAppInsights = function () { return appInsights; };
var Track = {
    Exception: function (error) {
        appInsights.trackException({ error: error, severityLevel: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_web__["b" /* SeverityLevel */].Error });
    },
    Trace: function (message) {
        appInsights.trackTrace({ message: message, severityLevel: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_web__["b" /* SeverityLevel */].Information });
    },
    Event: function (event) {
        appInsights.trackEvent(event);
    },
    SpaceStation: function (checkpointName, checkpointId, stepId) {
        appInsights.trackEvent({ name: 'SpaceStation', properties: { checkpointName: checkpointName, checkpointId: checkpointId, stepId: stepId } });
    },
    Planet: function (planetName, planetId, checkpointName, checkpointId, stepId) {
        appInsights.trackEvent({ name: 'Planet', properties: { planetName: planetName, checkpointName: checkpointName, planetId: planetId, checkpointId: checkpointId, stepId: stepId } });
    },
    Activity: function (type, activityName, activityId, activityPart, stepNumber) {
        appInsights.trackEvent({ name: 'Activity', properties: { type: type, activityName: activityName, activityId: activityId, activityPart: activityPart, stepNumber: stepNumber } });
    },
    PlayGame: function (gameName, gameId, planetName, planetId) {
        appInsights.trackEvent({ name: 'PlayGame', properties: { gameName: gameName, gameId: gameId, planetName: planetName, planetId: planetId } });
    },
    CompleteGame: function (gameName, gameId, planetName, planetId) {
        appInsights.trackEvent({ name: 'CompleteGame', properties: { gameName: gameName, gameId: gameId, planetName: planetName, planetId: planetId } });
    },
    BrowseVideo: function (name, id) {
        appInsights.trackEvent({ name: 'BrowseVideo', properties: { videoName: name, videoId: id } });
    },
    CompletePlanet: function (name, id) {
        appInsights.trackEvent({ name: 'CompletePlanet', properties: { planetName: name, planetId: id } });
    },
    SkipGame: function (gameName, gameId, planetName, planetId) {
        appInsights.trackEvent({ name: 'SkipGame', properties: { gameName: gameName, gameId: gameId, planetName: planetName, planetId: planetId } });
    },
    OpenIntercom: function (userId) {
        appInsights.trackEvent({ name: 'OpenIntercom', properties: { userId: userId } });
    },
};


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["k"]; });
/* unused harmony reexport strShimHasOwnProperty */
/* unused harmony reexport strDefault */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["a"]; });
/* unused harmony reexport ObjCreate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__Helpers__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__Helpers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__Helpers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(761);
/* unused harmony reexport __assignFn */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c"]; });
/* unused harmony reexport __restFn */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["d"]; });
/* unused harmony reexport __spreadArraysFn */
/* unused harmony reexport __decorateFn */
/* unused harmony reexport __paramFn */
/* unused harmony reexport __metadataFn */
/* unused harmony reexport __createBindingFn */
/* unused harmony reexport __valuesFn */
/* unused harmony reexport __readFn */
/* unused harmony reexport __makeTemplateObjectFn */
/* unused harmony reexport __importDefaultFn */
/* unused harmony reexport __importStarFn */
/* unused harmony reexport __exportStarFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TsLibGlobals__ = __webpack_require__(1887);
/* unused harmony reexport __exposeGlobalTsLib */
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.




//# sourceMappingURL=applicationinsights-shims.js.map

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setTimeout;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearTimeout;
/* harmony export (immutable) */ __webpack_exports__["c"] = setInterval;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getZoneJsOriginalValue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getGlobalObject__ = __webpack_require__(352);



function setTimeout(callback, delay) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__getZoneJsOriginalValue__["a" /* getZoneJsOriginalValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__getGlobalObject__["a" /* getGlobalObject */])(), 'setTimeout')(Object(__WEBPACK_IMPORTED_MODULE_1__monitor__["c" /* monitor */])(callback), delay);
}
function clearTimeout(timeoutId) {
    Object(__WEBPACK_IMPORTED_MODULE_0__getZoneJsOriginalValue__["a" /* getZoneJsOriginalValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__getGlobalObject__["a" /* getGlobalObject */])(), 'clearTimeout')(timeoutId);
}
function setInterval(callback, delay) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__getZoneJsOriginalValue__["a" /* getZoneJsOriginalValue */])(window, 'setInterval')(Object(__WEBPACK_IMPORTED_MODULE_1__monitor__["c" /* monitor */])(callback), delay);
}
function clearInterval(timeoutId) {
    Object(__WEBPACK_IMPORTED_MODULE_0__getZoneJsOriginalValue__["a" /* getZoneJsOriginalValue */])(window, 'clearInterval')(timeoutId);
}
//# sourceMappingURL=timer.js.map

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__boot_rumPublicApi__ = __webpack_require__(1978);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__boot_rumPublicApi__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boot_startRum__ = __webpack_require__(1979);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__boot_startRum__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_lifeCycle__ = __webpack_require__(810);
/* unused harmony reexport LifeCycle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_domMutationObservable__ = __webpack_require__(806);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__browser_domMutationObservable__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_viewportObservable__ = __webpack_require__(809);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__browser_viewportObservable__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__browser_viewportObservable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_rumEventsCollection_action_getActionNameFromElement__ = __webpack_require__(500);
/* unused harmony reexport DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_rumEventsCollection_action_getSelectorFromElement__ = __webpack_require__(813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__domain_rumEventsCollection_action_getSelectorFromElement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__browser_htmlDomUtils__ = __webpack_require__(808);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__browser_htmlDomUtils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__browser_htmlDomUtils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__browser_htmlDomUtils__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__browser_htmlDomUtils__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__browser_htmlDomUtils__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__browser_htmlDomUtils__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_getSessionReplayUrl__ = __webpack_require__(2015);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__domain_getSessionReplayUrl__["a"]; });









//# sourceMappingURL=index.js.map

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NodePrivacyLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PRIVACY_ATTR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRIVACY_ATTR_VALUE_ALLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PRIVACY_ATTR_VALUE_MASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRIVACY_ATTR_VALUE_MASK_USER_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PRIVACY_ATTR_VALUE_HIDDEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PRIVACY_CLASS_ALLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PRIVACY_CLASS_MASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PRIVACY_CLASS_MASK_USER_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PRIVACY_CLASS_HIDDEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CENSORED_STRING_MARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CENSORED_IMG_MARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FORM_PRIVATE_TAG_NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["e" /* DefaultPrivacyLevel */].ALLOW,
    MASK: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["e" /* DefaultPrivacyLevel */].MASK,
    MASK_USER_INPUT: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["e" /* DefaultPrivacyLevel */].MASK_USER_INPUT,
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
var PRIVACY_ATTR_VALUE_MASK = 'mask';
var PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
var PRIVACY_CLASS_MASK = 'dd-privacy-mask';
var PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
//# sourceMappingURL=constants.js.map

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReportApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var ReportApiController = /** @class */ (function () {
    function ReportApiController() {
        // post: Report/GetAdminReport
        this.RouteGetAdminReport = function () { return "Report/GetAdminReport"; };
        // post: Report/GetClassroomReport
        this.RouteGetClassroomReport = function () { return "Report/GetClassroomReport"; };
        // get: Report/ExportClassroomReport/${classroomId}
        this.RouteExportClassroomReport = function (classroomId) { return "Report/ExportClassroomReport/" + classroomId; };
        // get: Report/GetStudentReport/${studentId}
        this.RouteGetStudentReport = function (studentId) { return "Report/GetStudentReport/" + studentId; };
        // post: Report/FilterByCountries
        this.RouteFilterByCountries = function () { return "Report/FilterByCountries"; };
        // post: Report/FilterByStates
        this.RouteFilterByStates = function () { return "Report/FilterByStates"; };
        // post: Report/FilterByDistricts
        this.RouteFilterByDistricts = function () { return "Report/FilterByDistricts"; };
        // get: Report/GetCountriesForSelect
        this.RouteGetCountryHavingStates = function () { return "Report/GetCountriesForSelect"; };
        // get: Report/GetPrincipalReport
        this.RouteGetPrincipalReport = function () { return "Report/GetPrincipalReport"; };
        // get: Report/ExportPrincipalReport
        this.RouteExportPrincipalReport = function () { return "Report/ExportPrincipalReport"; };
        // get: Report/GetSuperintendentReport
        this.RouteGetSuperintendentReport = function () { return "Report/GetSuperintendentReport"; };
        // get: Report/ExportSuperintendentReport
        this.RouteExportSuperintendentReport = function () { return "Report/ExportSuperintendentReport"; };
        // post: Report/GetStudentActivityReport
        this.RouteGetStudentActivityReport = function () { return "Report/GetStudentActivityReport"; };
        // post: Report/GetStudentStatementReport
        this.RouteGetStudentStatementReport = function () { return "Report/GetStudentStatementReport"; };
        // post: Report/GetStudentPlanetCompletionReport
        this.RouteGetStudentPlanetCompletionReport = function () { return "Report/GetStudentPlanetCompletionReport"; };
        // post: Report/GetStudentGameCompletionReport
        this.RouteGetStudentGameCompletionReport = function () { return "Report/GetStudentGameCompletionReport"; };
    }
    ReportApiController.prototype.getAdminReport = function (request, requestOptions) {
        var url = this.RouteGetAdminReport();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(request, 'post', url, requestOptions);
    };
    ReportApiController.prototype.getClassroomReport = function (request, requestOptions) {
        var url = this.RouteGetClassroomReport();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(request, 'post', url, requestOptions);
    };
    ReportApiController.prototype.exportClassroomReport = function (classroomId, requestOptions) {
        var url = this.RouteExportClassroomReport(classroomId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ReportApiController.prototype.getStudentReport = function (studentId, requestOptions) {
        var url = this.RouteGetStudentReport(studentId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ReportApiController.prototype.filterByCountries = function (countryIds, requestOptions) {
        var url = this.RouteFilterByCountries();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(countryIds, 'post', url, requestOptions);
    };
    ReportApiController.prototype.filterByStates = function (stateIds, requestOptions) {
        var url = this.RouteFilterByStates();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(stateIds, 'post', url, requestOptions);
    };
    ReportApiController.prototype.filterByDistricts = function (districtIds, requestOptions) {
        var url = this.RouteFilterByDistricts();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(districtIds, 'post', url, requestOptions);
    };
    ReportApiController.prototype.getCountryHavingStates = function (requestOptions) {
        var url = this.RouteGetCountryHavingStates();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ReportApiController.prototype.getPrincipalReport = function (requestOptions) {
        var url = this.RouteGetPrincipalReport();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ReportApiController.prototype.exportPrincipalReport = function (requestOptions) {
        var url = this.RouteExportPrincipalReport();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ReportApiController.prototype.getSuperintendentReport = function (requestOptions) {
        var url = this.RouteGetSuperintendentReport();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ReportApiController.prototype.exportSuperintendentReport = function (requestOptions) {
        var url = this.RouteExportSuperintendentReport();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ReportApiController.prototype.getStudentActivityReport = function (tableRequest, requestOptions) {
        var url = this.RouteGetStudentActivityReport();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    ReportApiController.prototype.getStudentStatementReport = function (tableRequest, requestOptions) {
        var url = this.RouteGetStudentStatementReport();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    ReportApiController.prototype.getStudentPlanetCompletionReport = function (tableRequest, requestOptions) {
        var url = this.RouteGetStudentPlanetCompletionReport();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    ReportApiController.prototype.getStudentGameCompletionReport = function (tableRequest, requestOptions) {
        var url = this.RouteGetStudentGameCompletionReport();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    return ReportApiController;
}());

var service = new ReportApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NameOf; });
function NameOf(key, instance) {
    return key;
}



/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/snib-normal.db0fd977.png";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = createSinglePlayer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(371);

var _utils = __webpack_require__(112);

var _Player = __webpack_require__(534);

var _Player2 = _interopRequireDefault(_Player);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SUPPORTED_PROPS = Object.keys(_props2.propTypes);

function createSinglePlayer(activePlayer) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(SinglePlayer, _Component);

    function SinglePlayer() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, SinglePlayer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SinglePlayer.__proto__ || Object.getPrototypeOf(SinglePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.getDuration = function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      }, _this.getCurrentTime = function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      }, _this.getSecondsLoaded = function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      }, _this.getInternalPlayer = function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';

        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      }, _this.seekTo = function (fraction, type) {
        if (!_this.player) return null;
        _this.player.seekTo(fraction, type);
      }, _this.ref = function (player) {
        _this.player = player;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SinglePlayer, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return !(0, _utils.isEqual)(this.props, nextProps);
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps) {
        this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
      }
    }, {
      key: 'render',
      value: function render() {
        var _config$file = this.config.file,
            forceVideo = _config$file.forceVideo,
            forceAudio = _config$file.forceAudio,
            forceHLS = _config$file.forceHLS,
            forceDASH = _config$file.forceDASH;

        var skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;
        if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
          return null;
        }
        var _props = this.props,
            style = _props.style,
            width = _props.width,
            height = _props.height,
            Wrapper = _props.wrapper;

        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
        return _react2['default'].createElement(
          Wrapper,
          _extends({ style: _extends({}, style, { width: width, height: height }) }, otherProps),
          _react2['default'].createElement(_Player2['default'], _extends({}, this.props, {
            ref: this.ref,
            activePlayer: activePlayer,
            config: this.config
          }))
        );
      }
    }]);

    return SinglePlayer;
  }(_react.Component), _class.displayName = activePlayer.displayName + 'Player', _class.propTypes = _props2.propTypes, _class.defaultProps = _props2.defaultProps, _class.canPlay = activePlayer.canPlay, _temp2;
}

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
/* harmony export (immutable) */ __webpack_exports__["b"] = mergeObservables;
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}
//# sourceMappingURL=observable.js.map

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sessionReplay__ = __webpack_require__(2019);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sessionReplayConstants__ = __webpack_require__(2020);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__sessionReplayConstants__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__sessionReplayConstants__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__sessionReplayConstants__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__sessionReplayConstants__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__sessionReplayConstants__["e"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__serializationUtils__ = __webpack_require__(501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__serializationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__serializationUtils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__serializationUtils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__serializationUtils__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serializeDocument__ = __webpack_require__(2021);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__serializeDocument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serializeNode__ = __webpack_require__(815);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__serializeNode__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__serializeAttribute__ = __webpack_require__(816);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__serializeAttribute__["a"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_ATTRIBUTE_VALUE_CHAR_LENGTH; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getNodePrivacyLevel;
/* harmony export (immutable) */ __webpack_exports__["e"] = reducePrivacyLevel;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNodeSelfPrivacyLevel;
/* harmony export (immutable) */ __webpack_exports__["f"] = shouldMaskNode;
/* unused harmony export censorText */
/* harmony export (immutable) */ __webpack_exports__["d"] = getTextContent;
/* unused harmony export shouldIgnoreElement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(152);


var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel) {
    var parentNode = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__["d" /* getParentNode */])(node);
    var parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel) : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].HIDDEN:
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].ALLOW:
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].MASK:
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].MASK_USER_INPUT:
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].HIDDEN:
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__["h" /* isElementNode */])(node)) {
        return;
    }
    var privAttr = node.getAttribute(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* PRIVACY_ATTR_NAME */]);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].MASK;
        }
        if (inputElement.type === 'hidden') {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PRIVACY_ATTR_VALUE_HIDDEN */] || node.classList.contains(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* PRIVACY_CLASS_HIDDEN */])) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].HIDDEN;
    }
    if (privAttr === __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* PRIVACY_ATTR_VALUE_MASK */] || node.classList.contains(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* PRIVACY_CLASS_MASK */])) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].MASK;
    }
    if (privAttr === __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* PRIVACY_ATTR_VALUE_MASK_USER_INPUT */] || node.classList.contains(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* PRIVACY_CLASS_MASK_USER_INPUT */])) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].MASK_USER_INPUT;
    }
    if (privAttr === __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* PRIVACY_ATTR_VALUE_ALLOW */] || node.classList.contains(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* PRIVACY_CLASS_ALLOW */])) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].MASK:
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].HIDDEN:
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].IGNORE:
            return true;
        case __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].MASK_USER_INPUT:
            return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__["k" /* isTextNode */])(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FORM_PRIVATE_TAG_NAMES */][element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isStyle = parentTagName === 'STYLE' ? true : undefined;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CENSORED_STRING_MARK */];
    }
    else if (nodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CENSORED_STRING_MARK */];
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel) &&
        // Style tags are `overruled` (Use `hide` to enforce privacy)
        !isStyle) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CENSORED_STRING_MARK */];
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Link as script - Ignore only when rel=preload, modulepreload or prefetch
        (/preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
//# sourceMappingURL=privacy.js.map

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/squeelo-normal.f5de6db7.png";

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return numKeys; });
var numKeys = [
    {
        index: 0,
        keyCode: 'ONE',
        altKeyCode: 'NUMPAD_ONE',
        display: '1'
    },
    {
        index: 1,
        keyCode: 'TWO',
        altKeyCode: 'NUMPAD_TWO',
        display: '2'
    },
    {
        index: 2,
        keyCode: 'THREE',
        altKeyCode: 'NUMPAD_THREE',
        display: '3'
    },
    {
        index: 3,
        keyCode: 'FOUR',
        altKeyCode: 'NUMPAD_FOUR',
        display: '4'
    },
    {
        index: 4,
        keyCode: 'FIVE',
        altKeyCode: 'NUMPAD_FIVE',
        display: '5'
    },
    {
        index: 5,
        keyCode: 'SIX',
        altKeyCode: 'NUMPAD_SIX',
        display: '6'
    },
    {
        index: 6,
        keyCode: 'SEVEN',
        altKeyCode: 'NUMPAD_SEVEN',
        display: '7'
    },
    {
        index: 7,
        keyCode: 'EIGHT',
        altKeyCode: 'NUMPAD_EIGHT',
        display: '8'
    },
    {
        index: 8,
        keyCode: 'NINE',
        altKeyCode: 'NUMPAD_NINE',
        display: '9'
    },
    {
        index: 9,
        keyCode: 'ZERO',
        altKeyCode: 'NUMPAD_ZERO',
        display: '0'
    },
    {
        index: 10,
        keyCode: 'MINUS',
        altKeyCode: 'NUMPAD_MINUS',
        display: '- '
    },
];



/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_UserApiController__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Checkpoints__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_DebugUtil__ = __webpack_require__(87);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var CheckpointAction = /** @class */ (function () {
    function CheckpointAction() {
        // Dont be that guy
        throw new Error("NOOOO");
    }
    CheckpointAction.LoadUserStatus = function (dispatch) {
        var _this = this;
        dispatch({ type: "UPDATE_STATE_CHECKPOINT", data: "loading" });
        return __WEBPACK_IMPORTED_MODULE_0_src_api_UserApiController__["a" /* default */].getFullUserStatus().then(function (result) {
            if (!result.ok) {
                dispatch({ type: "UPDATE_STATE_CHECKPOINT", data: "none" });
                return false;
            }
            var data = _this.UserStatusToCheckPointStatus(result.data);
            data.currentDirection = "forwards";
            dispatch({ type: "SET_CHECKPOINT", data: data });
            dispatch({ type: "UPDATE_STATE_CHECKPOINT", data: "fresh" });
            return true;
        });
    };
    /**
     * Updates the database with the new current location. Updates furthest as needed, previous is ***not*** affected
     */
    CheckpointAction.UpdateCurrentUserStatus = function (dispatch, request) {
        var _this = this;
        if (request == null) {
            return;
        }
        return dispatch(function (innerDispatch, reduxState) {
            var state = reduxState();
            // Patch for replay code start
            if (state.Mission.isReplayModeActive) {
                console.warn("% Replay mode Active %"); // JB - Remove this console.warn
                // Check if we are at the 'end' and set location accordingly
                var replay = state.Mission.replay;
                if (request.planetId >= replay.planetId && request.checkpointId >= replay.checkpointId && request.stepId >= replay.stepId) {
                    return _this.EndReplay(innerDispatch);
                }
                var data = {
                    current: {
                        planetId: request.planetId,
                        checkpointId: request.checkpointId,
                        stepId: request.stepId
                    },
                    currentDirection: request.currentDirection
                };
                return innerDispatch({ type: "UPDATE_CHECKPOINT", data: data });
            }
            // End Patch
            __WEBPACK_IMPORTED_MODULE_0_src_api_UserApiController__["a" /* default */].updateUserStatus(request).then(function (result) {
                var convertedResult = _this.UserStatusToCheckPointStatus(result.data);
                convertedResult.currentDirection = request.currentDirection;
                innerDispatch({ type: "UPDATE_CHECKPOINT", data: convertedResult });
                if (__WEBPACK_IMPORTED_MODULE_3_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
                    console.warn("Updated User Status in DB");
                }
            });
        });
    };
    /**
     * Enables replay mode and changes the 'Current' variable to the request. This value is then stored in 'Previous' and can be undone with the EndReplay() call
     */
    CheckpointAction.StartReplay = function (dispatch, start, end, previousLocation) {
        if (start == null || end == null) {
            return;
        }
        dispatch({ type: "UPDATE_STATE_CHECKPOINT", data: "not-fresh" });
        dispatch({ type: "SET_PREVIOUS_LOCATION_CONFIG", data: previousLocation });
        dispatch({ type: "ENABLE_REPLAY_CHECKPOINT", data: { start: start, end: end } });
    };
    /**
     * Disables replay mode and resets 'Current' to the 'Previous' value set when call from StartReplay()
     */
    CheckpointAction.EndReplay = function (dispatch) {
        return dispatch({ type: "DISABLE_REPLAY_CHECKPOINT" });
    };
    CheckpointAction.UserStatusToCheckPointStatus = function (input) {
        if (input == null || input.checkpointId === 0 || input.planetId === 0) {
            // Data is either new or malformed
            var newStatus = {
                checkpointId: __WEBPACK_IMPORTED_MODULE_1_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding.id,
                planetId: __WEBPACK_IMPORTED_MODULE_2_src_constants_Planets__["a" /* Planets */].R.id,
                stepId: 1,
            };
            return {
                // Use the expansion operator to ensure we have unique objects
                current: __assign({}, newStatus),
                furthest: __assign({}, newStatus),
                previous: null,
                replay: null,
                currentDirection: "forwards"
            };
        }
        return {
            current: {
                planetId: input.planetId,
                checkpointId: input.checkpointId,
                stepId: input.stepId,
            },
            furthest: {
                planetId: input.furthestPlanetId,
                checkpointId: input.furthestCheckpointId,
                stepId: input.furthestStepId,
            },
            previous: null,
            replay: null,
            currentDirection: "forwards"
        };
    };
    /**
     * Does not update the database
     */
    CheckpointAction.SetUserStatus = function (dispatch, request) {
        if (request == null) {
            return;
        }
        dispatch({ type: "SET_CHECKPOINT", data: request });
        dispatch({ type: "UPDATE_STATE_CHECKPOINT", data: "fresh" });
    };
    CheckpointAction.SetFreshnessStatus = function (dispatch, request) {
        if (request == null) {
            return;
        }
        dispatch({ type: "UPDATE_STATE_CHECKPOINT", data: request });
    };
    CheckpointAction.Logout = function (dispatch) {
        dispatch({ type: "RESET_CHECKPOINT" });
    };
    CheckpointAction.Debug_SetCheckpoint = function (dispatch, request) {
        dispatch({ type: "SET_CHECKPOINT", data: request });
        dispatch({ type: "UPDATE_STATE_CHECKPOINT", data: "not-fresh" });
    };
    return CheckpointAction;
}());
/* harmony default export */ __webpack_exports__["a"] = (CheckpointAction);


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return _DYN_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _DYN_DEVICE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _DYN_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return _DYN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return _DYN_TRACE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return _DYN_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return _DYN_STRINGIFY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return _DYN_MEASUREMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _DYN_DATA_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return _DYN_ENVELOPE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return _DYN_TO_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return _DYN_ON_LINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return _DYN_IS_ONLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return _DYN_ENQUEUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _DYN_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return _DYN_EVENTS_LIMIT_IN_MEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return _DYN_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return _DYN_EMIT_LINE_DELIMITED_0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _DYN_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _DYN_BATCH_PAYLOADS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return _DYN_MARK_AS_SENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _DYN_CLEAR_SENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _DYN_BUFFER_OVERRIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return _DYN__BUFFER__KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return _DYN__SENT__BUFFER__KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return _DYN__MAX__BUFFER__SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return _DYN_NAME_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return _DYN_MAX_BATCH_SIZE_IN_BY1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return _DYN_TRIGGER_SEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _DYN_DIAG_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return _DYN_ONUNLOAD_DISABLE_BEA2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return _DYN_IS_BEACON_API_DISABL3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return _DYN__SENDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return _DYN__SENDER_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _DYN_ENABLE_SESSION_STORA4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return _DYN__BUFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return _DYN_SAMPLING_PERCENTAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return _DYN_INSTRUMENTATION_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _DYN_ENDPOINT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _DYN_CUSTOM_HEADERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _DYN_DISABLE_XHR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return _DYN_ONUNLOAD_DISABLE_FET5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _DYN_DISABLE_TELEMETRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _DYN_BASE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return _DYN_SAMPLE_RATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _DYN_CONVERT_UNDEFINED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return _DYN__XHR_READY_STATE_CHA6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return _DYN__ON_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return _DYN__ON_PARTIAL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return _DYN__ON_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return _DYN_ITEMS_ACCEPTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return _DYN_ITEMS_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return _DYN_IS_RETRY_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return _DYN_SET_REQUEST_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return _DYN_MAX_BATCH_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return _DYN_EVENTS_SEND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return _DYN_DISABLE_INSTRUMENTAT7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return _DYN_GET_SAMPLING_SCORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return _DYN_GET_HASH_CODE_SCORE; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TAGS = "tags"; // Count: 17
var _DYN_DEVICE_TYPE = "deviceType"; // Count: 3
var _DYN_DATA = "data"; // Count: 13
var _DYN_NAME = "name"; // Count: 8
var _DYN_TRACE_ID = "traceID"; // Count: 5
var _DYN_LENGTH = "length"; // Count: 37
var _DYN_STRINGIFY = "stringify"; // Count: 5
var _DYN_MEASUREMENTS = "measurements"; // Count: 7
var _DYN_DATA_TYPE = "dataType"; // Count: 10
var _DYN_ENVELOPE_TYPE = "envelopeType"; // Count: 7
var _DYN_TO_STRING = "toString"; // Count: 7
var _DYN_ON_LINE = "onLine"; // Count: 4
var _DYN_IS_ONLINE = "isOnline"; // Count: 3
var _DYN_ENQUEUE = "enqueue"; // Count: 5
var _DYN_COUNT = "count"; // Count: 6
var _DYN_EVENTS_LIMIT_IN_MEM = "eventsLimitInMem"; // Count: 2
var _DYN_PUSH = "push"; // Count: 6
var _DYN_EMIT_LINE_DELIMITED_0 = "emitLineDelimitedJson"; // Count: 3
var _DYN_CLEAR = "clear"; // Count: 6
var _DYN_BATCH_PAYLOADS = "batchPayloads"; // Count: 5
var _DYN_MARK_AS_SENT = "markAsSent"; // Count: 6
var _DYN_CLEAR_SENT = "clearSent"; // Count: 5
var _DYN_BUFFER_OVERRIDE = "bufferOverride"; // Count: 3
var _DYN__BUFFER__KEY = "BUFFER_KEY"; // Count: 5
var _DYN__SENT__BUFFER__KEY = "SENT_BUFFER_KEY"; // Count: 7
var _DYN__MAX__BUFFER__SIZE = "MAX_BUFFER_SIZE"; // Count: 5
var _DYN_NAME_PREFIX = "namePrefix"; // Count: 6
var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes"; // Count: 3
var _DYN_TRIGGER_SEND = "triggerSend"; // Count: 6
var _DYN_DIAG_LOG = "diagLog"; // Count: 15
var _DYN_ONUNLOAD_DISABLE_BEA2 = "onunloadDisableBeacon"; // Count: 2
var _DYN_IS_BEACON_API_DISABL3 = "isBeaconApiDisabled"; // Count: 3
var _DYN__SENDER = "_sender"; // Count: 5
var _DYN__SENDER_CONFIG = "_senderConfig"; // Count: 4
var _DYN_ENABLE_SESSION_STORA4 = "enableSessionStorageBuffer"; // Count: 2
var _DYN__BUFFER = "_buffer"; // Count: 9
var _DYN_SAMPLING_PERCENTAGE = "samplingPercentage"; // Count: 2
var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 4
var _DYN_ENDPOINT_URL = "endpointUrl"; // Count: 8
var _DYN_CUSTOM_HEADERS = "customHeaders"; // Count: 4
var _DYN_DISABLE_XHR = "disableXhr"; // Count: 5
var _DYN_ONUNLOAD_DISABLE_FET5 = "onunloadDisableFetch"; // Count: 2
var _DYN_DISABLE_TELEMETRY = "disableTelemetry"; // Count: 2
var _DYN_BASE_TYPE = "baseType"; // Count: 4
var _DYN_SAMPLE_RATE = "sampleRate"; // Count: 4
var _DYN_CONVERT_UNDEFINED = "convertUndefined"; // Count: 2
var _DYN__XHR_READY_STATE_CHA6 = "_xhrReadyStateChange"; // Count: 2
var _DYN__ON_ERROR = "_onError"; // Count: 11
var _DYN__ON_PARTIAL_SUCCESS = "_onPartialSuccess"; // Count: 3
var _DYN__ON_SUCCESS = "_onSuccess"; // Count: 6
var _DYN_ITEMS_ACCEPTED = "itemsAccepted"; // Count: 5
var _DYN_ITEMS_RECEIVED = "itemsReceived"; // Count: 6
var _DYN_IS_RETRY_DISABLED = "isRetryDisabled"; // Count: 5
var _DYN_SET_REQUEST_HEADER = "setRequestHeader"; // Count: 3
var _DYN_MAX_BATCH_INTERVAL = "maxBatchInterval"; // Count: 2
var _DYN_EVENTS_SEND_REQUEST = "eventsSendRequest"; // Count: 2
var _DYN_DISABLE_INSTRUMENTAT7 = "disableInstrumentationKeyValidation"; // Count: 2
var _DYN_GET_SAMPLING_SCORE = "getSamplingScore"; // Count: 2
var _DYN_GET_HASH_CODE_SCORE = "getHashCodeScore"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = throttle;
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(150);

// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__timer__["d" /* setTimeout */])(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" /* clearTimeout */])(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
//# sourceMappingURL=functionUtils.js.map

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = jsonStringify;
/* harmony export (immutable) */ __webpack_exports__["a"] = detachToJsonMethod;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_functionUtils__ = __webpack_require__(185);

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils_functionUtils__["a" /* noop */];
}
//# sourceMappingURL=jsonStringify.js.map

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_style__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__time_picker_style__ = __webpack_require__(2110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tag_style__ = __webpack_require__(834);


// style dependencies




/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SchoolApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var SchoolApiController = /** @class */ (function () {
    function SchoolApiController() {
        // post: School/AddSchool
        this.RouteAddSchool = function () { return "School/AddSchool"; };
        // post: School/UpdateSchool
        this.RouteUpdateSchool = function () { return "School/UpdateSchool"; };
        // get: School/GetSchool/${schoolId}
        this.RouteGetSchool = function (schoolId) { return "School/GetSchool/" + schoolId; };
        // get: School/GetAllSchools
        this.RouteGetAllSchools = function () { return "School/GetAllSchools"; };
        // get: School/GetSchoolsForCurrentUser
        this.RouteGetSchoolsForCurrentUser = function () { return "School/GetSchoolsForCurrentUser"; };
        // get: School/GetAllSchoolsByClientId/${clientId}
        this.RouteGetAllSchoolsByClientId = function (clientId) { return "School/GetAllSchoolsByClientId/" + clientId; };
        // get: School/GetAllSchools/${districtId}
        this.RouteGetAllSchoolsByDistrict = function (districtId) { return "School/GetAllSchools/" + districtId; };
        // post: School/GetSchoolsByDistricts
        this.RouteGetSchoolsByDistricts = function () { return "School/GetSchoolsByDistricts"; };
        // post: School/GetAllSchoolsForSchoolClientType
        this.RouteGetAllSchoolsForSchoolClientType = function () { return "School/GetAllSchoolsForSchoolClientType"; };
        // get: School/GetAllSchoolsForDistrict
        this.RouteGetAllSchoolsForDistrict = function () { return "School/GetAllSchoolsForDistrict"; };
        // post: School/GetSchoolTableData
        this.RouteGetSchoolTableData = function () { return "School/GetSchoolTableData"; };
        // get: School/GetSchoolFullSyncByFullSync?fullSyncId=${fullSyncId}
        this.RouteGetFullSyncsByDistrictId = function (fullSyncId) { return "School/GetSchoolFullSyncByFullSync?fullSyncId=" + fullSyncId; };
        // post: School/GetSchoolFullSyncTableData?districtFullSyncId=${districtFullSyncId}
        this.RouteGetSchoolFullSyncTableData = function (districtFullSyncId) { return "School/GetSchoolFullSyncTableData?districtFullSyncId=" + districtFullSyncId; };
    }
    SchoolApiController.prototype.addSchool = function (addSchoolDTO, requestOptions) {
        var url = this.RouteAddSchool();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addSchoolDTO, 'post', url, requestOptions);
    };
    SchoolApiController.prototype.updateSchool = function (updateSchoolDTO, requestOptions) {
        var url = this.RouteUpdateSchool();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateSchoolDTO, 'post', url, requestOptions);
    };
    SchoolApiController.prototype.getSchool = function (schoolId, requestOptions) {
        var url = this.RouteGetSchool(schoolId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    SchoolApiController.prototype.getAllSchools = function (requestOptions) {
        var url = this.RouteGetAllSchools();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    SchoolApiController.prototype.getSchoolsForCurrentUser = function (requestOptions) {
        var url = this.RouteGetSchoolsForCurrentUser();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    SchoolApiController.prototype.getAllSchoolsByClientId = function (clientId, requestOptions) {
        var url = this.RouteGetAllSchoolsByClientId(clientId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    SchoolApiController.prototype.getAllSchoolsByDistrict = function (districtId, requestOptions) {
        var url = this.RouteGetAllSchoolsByDistrict(districtId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    SchoolApiController.prototype.getSchoolsByDistricts = function (districtIds, requestOptions) {
        var url = this.RouteGetSchoolsByDistricts();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(districtIds, 'post', url, requestOptions);
    };
    SchoolApiController.prototype.getAllSchoolsForSchoolClientType = function (requestOptions) {
        var url = this.RouteGetAllSchoolsForSchoolClientType();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    SchoolApiController.prototype.getAllSchoolsForDistrict = function (requestOptions) {
        var url = this.RouteGetAllSchoolsForDistrict();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    SchoolApiController.prototype.getSchoolTableData = function (tableRequest, requestOptions) {
        var url = this.RouteGetSchoolTableData();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    SchoolApiController.prototype.getFullSyncsByDistrictId = function (fullSyncId, requestOptions) {
        var url = this.RouteGetFullSyncsByDistrictId(fullSyncId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    SchoolApiController.prototype.getSchoolFullSyncTableData = function (tableRequest, districtFullSyncId, requestOptions) {
        var url = this.RouteGetSchoolFullSyncTableData(districtFullSyncId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    return SchoolApiController;
}());

var service = new SchoolApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/starPilotAll.bf8fc0a8.png";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/starPilotAll.cf671a48.json";

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box_less__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_SVGComponent__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder


var InfoBox = /** @class */ (function (_super) {
    __extends(InfoBox, _super);
    function InfoBox(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, InfoBox.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    InfoBox.prototype.renderRewards = function () {
        if (this.props.rewards == null || this.props.rewards.length === 0) {
            return;
        }
        return [
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { key: "rewardsLabel" }, "Rewards:")),
            this.props.rewards.map(function (reward, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_SVGComponent__["a" /* default */], { key: reward + index, path: reward, height: "50px", width: "50px" })); })
        ];
    };
    InfoBox.prototype.renderCurrentPlanet = function () {
        if (this.props.currentPlanet != null) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", { key: "currentPlanetLabel" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "common.currentPlanet" }),
                    ":"),
                " ",
                this.props.currentPlanet.name);
        }
        return null;
    };
    InfoBox.prototype.renderShipName = function () {
        if (this.props.currentGrade != null) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "common.shipName" }),
                    ":"),
                " ", this.props.currentGrade.commander + " 1");
        }
        return null;
    };
    InfoBox.prototype.render = function () {
        var className = ("box-component planet-" + (this.props.currentPlanet || { name: "" }).name).toLowerCase();
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "infoBox", className: className },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "info" },
                this.renderShipName(),
                this.renderCurrentPlanet(),
                this.renderRewards()));
    };
    return InfoBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (InfoBox);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/player.0ae90195.png";

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AccountApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var AccountApiController = /** @class */ (function () {
    function AccountApiController() {
        // post: Account/Login
        this.RouteLogin = function () { return "Account/Login"; };
        // post: Account/Register
        this.RouteRegister = function () { return "Account/Register"; };
        // get: Account/KeepAlive
        this.RouteKeepAlive = function () { return "Account/KeepAlive"; };
        // get: Account/Me
        this.RouteMe = function () { return "Account/Me"; };
        // post: Account/Logout
        this.RouteLogout = function () { return "Account/Logout"; };
        // get: Account/GetCurrentEmulationInfo
        this.RouteGetCurrentEmulationInfo = function () { return "Account/GetCurrentEmulationInfo"; };
        // post: Account/StopEmulation
        this.RouteStopEmulation = function () { return "Account/StopEmulation"; };
        // post: Account/Emulate?locationId=${locationId}&emulationType=${encodeURIComponent(emulationType)}
        this.RouteEmulate = function (locationId, emulationType) { return "Account/Emulate?locationId=" + locationId + "&emulationType=" + encodeURIComponent(emulationType); };
        // post: Account/EmulateState?stateId=${stateId}
        this.RouteEmulateState = function (stateId) { return "Account/EmulateState?stateId=" + stateId; };
        // post: Account/EmulateDistrict?districtId=${districtId}
        this.RouteEmulateDistrict = function (districtId) { return "Account/EmulateDistrict?districtId=" + districtId; };
        // post: Account/EmulateSchool?schoolId=${schoolId}
        this.RouteEmulateSchool = function (schoolId) { return "Account/EmulateSchool?schoolId=" + schoolId; };
        // post: Account/SendForgotPasswordEmail
        this.RouteSendForgotPasswordEmail = function () { return "Account/SendForgotPasswordEmail"; };
        // post: Account/ResetPassword
        this.RouteSelfServePasswordReset = function () { return "Account/ResetPassword"; };
        // post: Account/UpdateSelectedCulture
        this.RouteUpdateSelectedCulture = function (cultureId) { return "Account/UpdateSelectedCulture"; };
    }
    AccountApiController.prototype.login = function (request, requestOptions) {
        var url = this.RouteLogin();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(request, 'post', url, requestOptions);
    };
    AccountApiController.prototype.register = function (request, requestOptions) {
        var url = this.RouteRegister();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(request, 'post', url, requestOptions);
    };
    AccountApiController.prototype.keepAlive = function (requestOptions) {
        var url = this.RouteKeepAlive();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    AccountApiController.prototype.me = function (requestOptions) {
        var url = this.RouteMe();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    AccountApiController.prototype.logout = function (requestOptions) {
        var url = this.RouteLogout();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    AccountApiController.prototype.getCurrentEmulationInfo = function (requestOptions) {
        var url = this.RouteGetCurrentEmulationInfo();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    AccountApiController.prototype.stopEmulation = function (requestOptions) {
        var url = this.RouteStopEmulation();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    AccountApiController.prototype.emulate = function (locationId, emulationType, requestOptions) {
        var url = this.RouteEmulate(locationId, emulationType);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    AccountApiController.prototype.emulateState = function (stateId, requestOptions) {
        var url = this.RouteEmulateState(stateId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    AccountApiController.prototype.emulateDistrict = function (districtId, requestOptions) {
        var url = this.RouteEmulateDistrict(districtId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    AccountApiController.prototype.emulateSchool = function (schoolId, requestOptions) {
        var url = this.RouteEmulateSchool(schoolId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    AccountApiController.prototype.sendForgotPasswordEmail = function (forgotPassword, requestOptions) {
        var url = this.RouteSendForgotPasswordEmail();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(forgotPassword, 'post', url, requestOptions);
    };
    AccountApiController.prototype.selfServePasswordReset = function (resetPassword, requestOptions) {
        var url = this.RouteSelfServePasswordReset();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(resetPassword, 'post', url, requestOptions);
    };
    AccountApiController.prototype.updateSelectedCulture = function (cultureId, requestOptions) {
        var url = this.RouteUpdateSelectedCulture(cultureId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(cultureId, 'post', url, requestOptions);
    };
    return AccountApiController;
}());

var service = new AccountApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalLogMessage; });
/* harmony export (immutable) */ __webpack_exports__["f"] = safeGetLogger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagnosticLogger; });
/* harmony export (immutable) */ __webpack_exports__["d"] = _throwInternal;
/* harmony export (immutable) */ __webpack_exports__["e"] = _warnToConsole;
/* harmony export (immutable) */ __webpack_exports__["c"] = _logInternalMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DbgExtensionUtils__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnvUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalConstants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
function _sanitizeDiagnosticText(text) {
    if (text) {
        return "\"" + text[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["J" /* _DYN_REPLACE */] /* @min:%2ereplace */](/\"/g, __WEBPACK_IMPORTED_MODULE_5__InternalConstants__["e" /* STR_EMPTY */]) + "\"";
    }
    return __WEBPACK_IMPORTED_MODULE_5__InternalConstants__["e" /* STR_EMPTY */];
}
function _logToConsole(func, message) {
    var theConsole = Object(__WEBPACK_IMPORTED_MODULE_3__EnvUtils__["d" /* getConsole */])();
    if (!!theConsole) {
        var logFunc = "log";
        if (theConsole[func]) {
            logFunc = func;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["q" /* isFunction */])(theConsole[logFunc])) {
            theConsole[logFunc](message);
        }
    }
}
var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) { isUserAct = false; }
        var _self = this;
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["C" /* _DYN_MESSAGE_ID */] /* @min:%2emessageId */] = msgId;
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["B" /* _DYN_MESSAGE */] /* @min:%2emessage */] =
            (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                msgId;
        var strProps = __WEBPACK_IMPORTED_MODULE_5__InternalConstants__["e" /* STR_EMPTY */];
        if (Object(__WEBPACK_IMPORTED_MODULE_3__EnvUtils__["r" /* hasJSON */])()) {
            strProps = Object(__WEBPACK_IMPORTED_MODULE_3__EnvUtils__["j" /* getJSON */])().stringify(properties);
        }
        var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : __WEBPACK_IMPORTED_MODULE_5__InternalConstants__["e" /* STR_EMPTY */]) +
            (properties ? " props:" + _sanitizeDiagnosticText(strProps) : __WEBPACK_IMPORTED_MODULE_5__InternalConstants__["e" /* STR_EMPTY */]);
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["B" /* _DYN_MESSAGE */] /* @min:%2emessage */] += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}());

function safeGetLogger(core, config) {
    return (core || {})[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */] || new DiagnosticLogger(config);
}
var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        this.identifier = "DiagnosticLogger";
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         * Count of internal messages sent
         */
        var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        var _messageLogged = {};
        var _loggingLevelConsole;
        var _loggingLevelTelemetry;
        var _maxInternalMessageLimit;
        var _enableDebug;
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(DiagnosticLogger, this, function (_self) {
            _setDefaultsFromConfig(config || {});
            _self.consoleLoggingLevel = function () { return _loggingLevelConsole; };
            _self.telemetryLoggingLevel = function () { return _loggingLevelTelemetry; };
            _self.maxInternalMessageLimit = function () { return _maxInternalMessageLimit; };
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["i" /* _DYN_ENABLE_DEBUG_EXCEPTI4 */] /* @min:%2eenableDebugExceptions */] = function () { return _enableDebug; };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */
            _self.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) { isUserAct = false; }
                var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                if (_enableDebug) {
                    throw Object(__WEBPACK_IMPORTED_MODULE_3__EnvUtils__["a" /* dumpObj */])(message);
                }
                else {
                    // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
                    var logFunc = severity === 1 /* eLoggingSeverity.CRITICAL */ ? __WEBPACK_IMPORTED_MODULE_5__InternalConstants__["f" /* STR_ERROR_TO_CONSOLE */] : __WEBPACK_IMPORTED_MODULE_5__InternalConstants__["p" /* STR_WARN_TO_CONSOLE */];
                    if (!Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["y" /* isUndefined */])(message[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["B" /* _DYN_MESSAGE */] /* @min:%2emessage */])) {
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["C" /* _DYN_MESSAGE_ID */] /* @min:%2emessageId */];
                            if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                _self[logFunc](message[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["B" /* _DYN_MESSAGE */] /* @min:%2emessage */]);
                                _messageLogged[messageKey] = true;
                            }
                        }
                        else {
                            // Only log traces if the console Logging Level is >= the throwInternal severity level
                            if (_loggingLevelConsole >= severity) {
                                _self[logFunc](message[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["B" /* _DYN_MESSAGE */] /* @min:%2emessage */]);
                            }
                        }
                        _logInternalMessage(severity, message);
                    }
                    else {
                        _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */ ? "Critical" : "Warning"), message);
                    }
                }
            };
            /**
             * This will write a warning to the console if possible
             * @param message {string} - The warning message
             */
            _self[__WEBPACK_IMPORTED_MODULE_5__InternalConstants__["p" /* STR_WARN_TO_CONSOLE */] /* @min:%2ewarnToConsole */] = function (message) {
                _logToConsole("warn", message);
                _debugExtMsg("warning", message);
            };
            /**
             * This will write an error to the console if possible
             * @param message {string} - The error message
             */
            _self[__WEBPACK_IMPORTED_MODULE_5__InternalConstants__["f" /* STR_ERROR_TO_CONSOLE */] /* @min:%2eerrorToConsole */] = function (message) {
                _logToConsole("error", message);
                _debugExtMsg("error", message);
            };
            /**
             * Resets the internal message count
             */
            _self.resetInternalMessageCount = function () {
                _messageCount = 0;
                _messageLogged = {};
            };
            /**
             * Logs a message to the internal queue.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The message to log.
             */
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["A" /* _DYN_LOG_INTERNAL_MESSAGE */] /* @min:%2elogInternalMessage */] = _logInternalMessage;
            function _logInternalMessage(severity, message) {
                if (_areInternalMessagesThrottled()) {
                    return;
                }
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = AIInternalMessagePrefix + message[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["C" /* _DYN_MESSAGE_ID */] /* @min:%2emessageId */];
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) {
                    logMessage = false;
                }
                else {
                    _messageLogged[messageKey] = true;
                }
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _loggingLevelTelemetry) {
                        _self.queue[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](message);
                        _messageCount++;
                        _debugExtMsg((severity === 1 /* eLoggingSeverity.CRITICAL */ ? "error" : "warn"), message);
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _maxInternalMessageLimit) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new _InternalLogMessage(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */, throttleLimitMessage, false);
                        _self.queue[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](throttleMessage);
                        if (severity === 1 /* eLoggingSeverity.CRITICAL */) {
                            _self[__WEBPACK_IMPORTED_MODULE_5__InternalConstants__["f" /* STR_ERROR_TO_CONSOLE */] /* @min:%2eerrorToConsole */](throttleLimitMessage);
                        }
                        else {
                            _self[__WEBPACK_IMPORTED_MODULE_5__InternalConstants__["p" /* STR_WARN_TO_CONSOLE */] /* @min:%2ewarnToConsole */](throttleLimitMessage);
                        }
                    }
                }
            }
            function _setDefaultsFromConfig(config) {
                _loggingLevelConsole = Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["i" /* getCfgValue */])(config.loggingLevelConsole, 0);
                _loggingLevelTelemetry = Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["i" /* getCfgValue */])(config.loggingLevelTelemetry, 1);
                _maxInternalMessageLimit = Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["i" /* getCfgValue */])(config.maxMessageLimit, 25);
                _enableDebug = Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["i" /* getCfgValue */])(config.enableDebug, Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["i" /* getCfgValue */])(config[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["i" /* _DYN_ENABLE_DEBUG_EXCEPTI4 */] /* @min:%2eenableDebugExceptions */], false));
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _maxInternalMessageLimit;
            }
            function _debugExtMsg(name, data) {
                var dbgExt = Object(__WEBPACK_IMPORTED_MODULE_2__DbgExtensionUtils__["a" /* getDebugExt */])(config || {});
                if (dbgExt && dbgExt[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["h" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */]) {
                    dbgExt[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["h" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](name, data);
                }
            }
        });
    }
// Removed Stub for DiagnosticLogger.prototype.enableDebugExceptions.
// Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.telemetryLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.maxInternalMessageLimit.
// Removed Stub for DiagnosticLogger.prototype.throwInternal.
// Removed Stub for DiagnosticLogger.prototype.warnToConsole.
// Removed Stub for DiagnosticLogger.prototype.errorToConsole.
// Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
// Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    DiagnosticLogger.__ieDyn=1;

    return DiagnosticLogger;
}());

function _getLogger(logger) {
    return (logger || new DiagnosticLogger());
}
/**
 * This is a helper method which will call throwInternal on the passed logger, will throw exceptions in
 * debug mode or attempt to log the error as a console warning. This helper is provided mostly to better
 * support minification as logger.throwInternal() will not compress the publish "throwInternal" used throughout
 * the code.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity {LoggingSeverity} - The severity of the log message
 * @param message {_InternalLogMessage} - The log message.
 */
function _throwInternal(logger, severity, msgId, msg, properties, isUserAct) {
    if (isUserAct === void 0) { isUserAct = false; }
    _getLogger(logger).throwInternal(severity, msgId, msg, properties, isUserAct);
}
/**
 * This is a helper method which will call warnToConsole on the passed logger with the provided message.
 * @param logger - The Diagnostic Logger instance to use.
 * @param message {_InternalLogMessage} - The log message.
 */
function _warnToConsole(logger, message) {
    _getLogger(logger)[__WEBPACK_IMPORTED_MODULE_5__InternalConstants__["p" /* STR_WARN_TO_CONSOLE */] /* @min:%2ewarnToConsole */](message);
}
/**
 * Logs a message to the internal queue.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity {LoggingSeverity} - The severity of the log message
 * @param message {_InternalLogMessage} - The message to log.
 */
function _logInternalMessage(logger, severity, message) {
    _getLogger(logger)[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["A" /* _DYN_LOG_INTERNAL_MESSAGE */] /* @min:%2elogInternalMessage */](severity, message);
}
//# sourceMappingURL=DiagnosticLogger.js.map

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ONE_KIBI_BYTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ONE_MEBI_BYTE; });
/* harmony export (immutable) */ __webpack_exports__["c"] = computeBytesCount;
var ONE_KIBI_BYTE = 1024;
var ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
//# sourceMappingURL=byteUtils.js.map

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = generateUUID;
/* harmony export (immutable) */ __webpack_exports__["a"] = findCommaSeparatedValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = safeTruncate;
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
function findCommaSeparatedValue(rawString, name) {
    var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
    var matches = regex.exec(rawString);
    return matches ? matches[1] : undefined;
}
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
//# sourceMappingURL=stringUtils.js.map

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = addEventListeners;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_getZoneJsOriginalValue__ = __webpack_require__(497);


/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(eventTarget, eventName, listener, options) {
    return addEventListeners(eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrappedListener = Object(__WEBPACK_IMPORTED_MODULE_0__tools_monitor__["c" /* monitor */])(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = Object(__WEBPACK_IMPORTED_MODULE_1__tools_getZoneJsOriginalValue__["a" /* getZoneJsOriginalValue */])(eventTarget, 'addEventListener');
    eventNames.forEach(function (eventName) { return add.call(eventTarget, eventName, wrappedListener, options); });
    function stop() {
        var remove = Object(__WEBPACK_IMPORTED_MODULE_1__tools_getZoneJsOriginalValue__["a" /* getZoneJsOriginalValue */])(eventTarget, 'removeEventListener');
        eventNames.forEach(function (eventName) { return remove.call(eventTarget, eventName, wrappedListener, options); });
    }
    return {
        stop: stop,
    };
}
//# sourceMappingURL=addEventListener.js.map

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_style__ = __webpack_require__(52);


// style dependencies


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_dropdown__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_dropdown_style_index_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_menu__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_menu_style_index_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_alert__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_alert_style_index_js__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_mission_PlanetBox__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_common_LanguageToggle__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_redux_ConfigActions__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_common_FullscreenToggle__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_api_AccountApiController__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Header_less__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Header_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__Header_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

































var logo = __webpack_require__(827);
var Header = __WEBPACK_IMPORTED_MODULE_4_antd_es_layout__["a" /* default */].Header;
var GeneralHeader = /** @class */ (function (_super) {
    __extends(GeneralHeader, _super);
    function GeneralHeader(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_22_src_utils_BindThisHelper__["a" /* default */])(_this, GeneralHeader.prototype);
        _this.state = {
            emulationInfo: null
        };
        return _this;
    }
    GeneralHeader.prototype.componentWillMount = function () {
        this.updateEmulationInfo();
    };
    GeneralHeader.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.User.isEmulating !== this.props.User.isEmulating) {
            this.updateEmulationInfo();
        }
    };
    GeneralHeader.prototype.getRoleNameTranslation = function (roleId) {
        var role = __WEBPACK_IMPORTED_MODULE_31_src_constants_Roles__["a" /* Roles */].FindById(roleId);
        switch (role) {
            case __WEBPACK_IMPORTED_MODULE_31_src_constants_Roles__["a" /* Roles */].DistrictAdmin:
                {
                    return this.props.translate("report.admin.roleFilter.DistrictAdmin");
                }
            case __WEBPACK_IMPORTED_MODULE_31_src_constants_Roles__["a" /* Roles */].KuderAdmin:
                {
                    return this.props.translate("report.admin.roleFilter.KuderAdmin");
                }
            case __WEBPACK_IMPORTED_MODULE_31_src_constants_Roles__["a" /* Roles */].StateAdmin:
                {
                    return this.props.translate("report.admin.roleFilter.StateAdmin");
                }
            case __WEBPACK_IMPORTED_MODULE_31_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin:
                {
                    return this.props.translate("report.admin.roleFilter.TeacherCounselorAdmin");
                }
            case __WEBPACK_IMPORTED_MODULE_31_src_constants_Roles__["a" /* Roles */].SchoolAdmin:
                {
                    return this.props.translate("report.admin.roleFilter.SchoolAdmin");
                }
            default: {
                break;
            }
        }
        return "";
    };
    GeneralHeader.prototype.updateEmulationInfo = function () {
        var _this = this;
        if (this.props.renderEmulationBanner) {
            __WEBPACK_IMPORTED_MODULE_29_src_api_AccountApiController__["a" /* default */].getCurrentEmulationInfo().then(function (result) {
                _this.setState({ emulationInfo: result.data });
            });
        }
    };
    GeneralHeader.prototype.emulationBannerOnClose = function () {
        // Stop emulation and redirect to emulate user page
        this.props.stopEmulation();
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].ADMIN_EMULATE_USER);
    };
    GeneralHeader.prototype.handleEmulation = function (id, userType) {
        var _this = this;
        // Fire emulation request, which will take some time, and direct user to emulation loading page
        this.props.emulateUser(id, userType).then(function (result) {
            if (!result) {
                __WEBPACK_IMPORTED_MODULE_20_antd_es_message__["a" /* default */].error(_this.props.translate("admin.common.messageEmulateError"));
                return;
            }
        });
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].ADMIN_EMULATE_USER); // Show them a fancy page while we mess with their emulation info
    };
    GeneralHeader.prototype.renderEmulationBanner = function () {
        var _this = this;
        if (this.props.renderEmulationBanner && this.props.User.isEmulating && this.state.emulationInfo) {
            var currentlyEmulating = this.props.translate("admin.header.currentlyEmulating");
            var _a = this.state.emulationInfo, state = _a.state, district = _a.district, school = _a.school;
            // This next part is just messy. There are many ways to do this and I just wanted it to be somewhat readable
            var items = [
                state != null ? __assign(__assign({}, state), { type: "state" }) : null,
                district != null ? __assign(__assign({}, district), { type: "district" }) : null,
                school != null ? __assign(__assign({}, school), { type: "school" }) : null
            ];
            // Remove nulls
            items = items.filter(function (x) { return x; });
            // Pop last item to style it separately
            var lastItem = items.pop();
            // Turn objects into react elements
            var isomers = items.map(function (t) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { key: t.id, onClick: function () { return _this.handleEmulation(t.id, t.type); } }, t.name); });
            // Add out special last element
            isomers.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { key: lastItem.id }, lastItem.name));
            // Add additional stop section
            isomers.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { key: 65, onClick: function () { return _this.emulationBannerOnClose(); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "admin.header.stopEmulationButton" })));
            // Condense items down into one
            var emulationLine = isomers.reduce(function (prev, curr) { return [prev, " || ", curr]; });
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_alert__["a" /* default */], { key: "emulationBanner", type: "info", showIcon: false, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                    currentlyEmulating,
                    " - ",
                    emulationLine), closeText: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "admin.header.stopEmulationButton" }), onClose: this.emulationBannerOnClose });
        }
    };
    GeneralHeader.prototype.renderLanguageToggle = function () {
        if (this.props.renderLanguageToggle) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_src_components_common_LanguageToggle__["a" /* default */], null);
        }
        return null;
    };
    GeneralHeader.prototype.renderDebugMenuItem = function () {
        if (__WEBPACK_IMPORTED_MODULE_26_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_menu__["a" /* default */].Item, { tabIndex: -1 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].WHO_AM_I },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_button__["a" /* default */], { tabIndex: 2, key: "whoami-button", type: "primary" }, "Who Am I?")));
        }
        return null;
    };
    GeneralHeader.prototype.renderAudioMenuItem = function () {
        if (this.props.renderAudioToggle) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_menu__["a" /* default */].Item, { tabIndex: -1 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_button__["a" /* default */], { tabIndex: 2, key: "audio-toggle", type: "primary", onClick: this.props.toggleAudio }, this.props.Config.audioEnabled
                    ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "common.disableAudio" })
                    : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "common.enableAudio" })));
        }
        return null;
    };
    GeneralHeader.prototype.renderFullscreenMenuItem = function () {
        if (this.props.renderFullscreenToggle) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_menu__["a" /* default */].Item, { tabIndex: -1 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28_src_components_common_FullscreenToggle__["a" /* default */], null));
        }
        return null;
    };
    GeneralHeader.prototype.renderLoginOutMenuItem = function () {
        if (this.props.User.state === "finished") {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_menu__["a" /* default */].Item, null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].LOGOUT },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_button__["a" /* default */], { tabIndex: 2, key: "logout-button", type: "primary" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "common.logoutButton" }))));
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_menu__["a" /* default */].Item, { tabIndex: -1 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].LOGIN },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_button__["a" /* default */], { tabIndex: 2, key: "login-button", type: "primary" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "common.logoutButton" }))));
        }
    };
    GeneralHeader.prototype.renderBackToSpaceStationButton = function () {
        if (this.props.renderBackToSpaceStation && this.props.User.state === "finished" && this.props.User.roleID === __WEBPACK_IMPORTED_MODULE_31_src_constants_Roles__["a" /* Roles */].Student.id) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].STUDENT_HOME },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_button__["a" /* default */], { tabIndex: 2, className: "menuButtonsToggle", key: "back-to-space-station-toggle", type: "primary" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "common.spaceStation" })));
        }
    };
    GeneralHeader.prototype.renderUserType = function () {
        if (this.props.User.state === "finished" && __WEBPACK_IMPORTED_MODULE_31_src_constants_Roles__["a" /* Roles */].Student.id !== this.props.User.roleID) {
            var roleName = this.getRoleNameTranslation(this.props.User.roleID);
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "header-user-type" }, roleName);
        }
    };
    GeneralHeader.prototype.renderCenterColumns = function () {
        var menu = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_menu__["a" /* default */], { theme: "dark", className: "menuButtons" },
            this.renderDebugMenuItem(),
            this.renderAudioMenuItem(),
            this.renderFullscreenMenuItem(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_menu__["a" /* default */].Divider, null),
            this.renderLoginOutMenuItem());
        var isStudent = this.props.User.state === "finished" && this.props.User.roleID === __WEBPACK_IMPORTED_MODULE_31_src_constants_Roles__["a" /* Roles */].Student.id;
        var logoCol = isStudent
            ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { key: "logo-col", span: 4, className: "primary-nav" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: logo, alt: "Kuder Galaxy", className: "kuder-logo", height: "100%", width: "100%", tabIndex: -1 }))
            : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { key: "logo-col", span: 4, className: "primary-nav" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].BASE_ROUTE, className: "logo", tabIndex: -1 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: logo, alt: "Kuder Galaxy", className: "kuder-logo", height: "100%", width: "100%", tabIndex: -1 })));
        if (this.props.renderPlanetBox) {
            return [
                logoCol,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { key: "planetBox-col", xs: 0, md: 10, lg: { span: 11, push: 1 } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_src_components_mission_PlanetBox__["a" /* default */], null)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { key: "dropdown-col", xs: 20, md: 9, lg: 7, className: "util-nav" },
                    this.renderLanguageToggle(),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_dropdown__["a" /* default */], { overlay: menu, trigger: ['click'] },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_button__["a" /* default */], { tabIndex: 2, className: "menuButtonsToggle" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "common.menu" }),
                            " ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_icon__["a" /* default */], { type: "bars", theme: "outlined" }))))
            ];
        }
        else {
            return [
                logoCol,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { key: "userType-col", span: 8, className: "center-nav" }, this.renderUserType()),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { key: "dropdown-col", span: 10, className: "util-nav" },
                    this.renderBackToSpaceStationButton(),
                    this.renderLanguageToggle(),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_dropdown__["a" /* default */], { overlay: menu, trigger: ['click'] },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_button__["a" /* default */], { tabIndex: 2, className: "menuButtonsToggle" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "common.menu" }),
                            " ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_icon__["a" /* default */], { type: "bars", theme: "outlined" }))))
            ];
        }
    };
    GeneralHeader.prototype.render = function () {
        var hasEmulationBanner = this.props.renderEmulationBanner && this.props.User.isEmulating;
        if (hasEmulationBanner) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header, { className: "header general-header" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], { className: "header-top-row" }, this.renderEmulationBanner()),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], { className: "header-bottom-row", type: "flex", justify: "space-between" }, this.renderCenterColumns()));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header, { className: "header general-header" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], { className: "header-single-row", type: "flex", justify: "space-between" }, this.renderCenterColumns()));
    };
    return GeneralHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        toggleAudio: function () { return __WEBPACK_IMPORTED_MODULE_27_src_redux_ConfigActions__["a" /* default */].ToggleAudio(dispatch); },
        stopEmulation: function () { return __WEBPACK_IMPORTED_MODULE_30_src_redux_UserActions__["a" /* default */].StopEmulation(dispatch); },
        emulateUser: function (id, type) { return __WEBPACK_IMPORTED_MODULE_30_src_redux_UserActions__["a" /* default */].EmulateUserV2(dispatch, id, type); },
    });
}
function mapStateToProps(state) {
    return {
        User: state.User,
        Config: state.Config,
        Mission: state.Mission,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["withRouter"])(GeneralHeader))));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(11);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(28);

var _propTypes = __webpack_require__(6);

var PropTypes = _interopRequireWildcard(_propTypes);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _wave = __webpack_require__(836);

var _wave2 = _interopRequireDefault(_wave);

var _icon = __webpack_require__(837);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
    return typeof str === 'string';
}
// Insert one space between two chinese characters automatically.
function insertSpace(child, needInserted) {
    // Check the child if is undefined or null.
    if (child == null) {
        return;
    }
    var SPACE = needInserted ? ' ' : '';
    // strictNullChecks oops.
    if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
        return React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
    }
    if (typeof child === 'string') {
        if (isTwoCNChar(child)) {
            child = child.split('').join(SPACE);
        }
        return React.createElement(
            'span',
            null,
            child
        );
    }
    return child;
}

var Button = function (_React$Component) {
    (0, _inherits3['default'])(Button, _React$Component);

    function Button(props) {
        (0, _classCallCheck3['default'])(this, Button);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

        _this.handleClick = function (e) {
            var onClick = _this.props.onClick;

            if (onClick) {
                onClick(e);
            }
        };
        _this.state = {
            loading: props.loading,
            hasTwoCNChar: false
        };
        return _this;
    }

    (0, _createClass3['default'])(Button, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fixTwoCNChar();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var currentLoading = this.props.loading;
            var loading = nextProps.loading;
            if (currentLoading) {
                clearTimeout(this.delayTimeout);
            }
            if (typeof loading !== 'boolean' && loading && loading.delay) {
                this.delayTimeout = window.setTimeout(function () {
                    return _this2.setState({ loading: loading });
                }, loading.delay);
            } else {
                this.setState({ loading: loading });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.fixTwoCNChar();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
            }
        }
    }, {
        key: 'fixTwoCNChar',
        value: function fixTwoCNChar() {
            // Fix for HOC usage like <FormatMessage />
            var node = (0, _reactDom.findDOMNode)(this);
            var buttonText = node.textContent || node.innerText;
            if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
                if (!this.state.hasTwoCNChar) {
                    this.setState({
                        hasTwoCNChar: true
                    });
                }
            } else if (this.state.hasTwoCNChar) {
                this.setState({
                    hasTwoCNChar: false
                });
            }
        }
    }, {
        key: 'isNeedInserted',
        value: function isNeedInserted() {
            var _props = this.props,
                icon = _props.icon,
                children = _props.children;

            return React.Children.count(children) === 1 && !icon;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this3 = this;

            var _a = this.props,
                type = _a.type,
                shape = _a.shape,
                size = _a.size,
                className = _a.className,
                children = _a.children,
                icon = _a.icon,
                prefixCls = _a.prefixCls,
                ghost = _a.ghost,
                _loadingProp = _a.loading,
                block = _a.block,
                rest = __rest(_a, ["type", "shape", "size", "className", "children", "icon", "prefixCls", "ghost", "loading", "block"]);var _state = this.state,
                loading = _state.loading,
                hasTwoCNChar = _state.hasTwoCNChar;
            // large => lg
            // small => sm

            var sizeCls = '';
            switch (size) {
                case 'large':
                    sizeCls = 'lg';
                    break;
                case 'small':
                    sizeCls = 'sm';
                default:
                    break;
            }
            var classes = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, type), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + shape, shape), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + sizeCls, sizeCls), (0, _defineProperty3['default'])(_classNames, prefixCls + '-icon-only', !children && icon), (0, _defineProperty3['default'])(_classNames, prefixCls + '-loading', loading), (0, _defineProperty3['default'])(_classNames, prefixCls + '-background-ghost', ghost), (0, _defineProperty3['default'])(_classNames, prefixCls + '-two-chinese-chars', hasTwoCNChar), (0, _defineProperty3['default'])(_classNames, prefixCls + '-block', block), _classNames));
            var iconType = loading ? 'loading' : icon;
            var iconNode = iconType ? React.createElement(_icon2['default'], { type: iconType }) : null;
            var kids = children || children === 0 ? React.Children.map(children, function (child) {
                return insertSpace(child, _this3.isNeedInserted());
            }) : null;
            if ('href' in rest) {
                return React.createElement(
                    'a',
                    (0, _extends3['default'])({}, rest, { className: classes, onClick: this.handleClick }),
                    iconNode,
                    kids
                );
            } else {
                // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
                var htmlType = rest.htmlType,
                    otherProps = __rest(rest, ["htmlType"]);
                return React.createElement(
                    _wave2['default'],
                    null,
                    React.createElement(
                        'button',
                        (0, _extends3['default'])({}, otherProps, { type: htmlType || 'button', className: classes, onClick: this.handleClick }),
                        iconNode,
                        kids
                    )
                );
            }
        }
    }]);
    return Button;
}(React.Component);

exports['default'] = Button;

Button.__ANT_BUTTON = true;
Button.defaultProps = {
    prefixCls: 'ant-btn',
    loading: false,
    ghost: false,
    block: false
};
Button.propTypes = {
    type: PropTypes.string,
    shape: PropTypes.oneOf(['circle', 'circle-outline']),
    size: PropTypes.oneOf(['large', 'default', 'small']),
    htmlType: PropTypes.oneOf(['submit', 'button', 'reset']),
    onClick: PropTypes.func,
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    className: PropTypes.string,
    icon: PropTypes.string,
    block: PropTypes.bool
};
module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DistrictApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var DistrictApiController = /** @class */ (function () {
    function DistrictApiController() {
        // post: District/AddDistrict
        this.RouteAddDistrict = function () { return "District/AddDistrict"; };
        // post: District/UpdateDistrict
        this.RouteUpdateDistrict = function () { return "District/UpdateDistrict"; };
        // get: District/GetDistrict/${districtId}
        this.RouteGetDistrict = function (districtId) { return "District/GetDistrict/" + districtId; };
        // get: District/GetDistrictForSso/${districtId}
        this.RouteGetDistrictForSso = function (districtId) { return "District/GetDistrictForSso/" + districtId; };
        // get: District/GetAllDistricts
        this.RouteGetAllDistricts = function () { return "District/GetAllDistricts"; };
        // get: District/GetAllDistricts/${stateId}
        this.RouteGetAllDistrictsByState = function (stateId) { return "District/GetAllDistricts/" + stateId; };
        // post: District/GetDistrictTableData
        this.RouteGetDistrictTableData = function () { return "District/GetDistrictTableData"; };
        // post: District/GetDistrictFullSyncTableData?districtId=${districtId}
        this.RouteGetDistrictFullSyncTableData = function (districtId) { return "District/GetDistrictFullSyncTableData?districtId=" + districtId; };
        // get: District/GetFullSyncsByDistrictId?districtId=${districtId}
        this.RouteGetFullSyncsByDistrictId = function (districtId) { return "District/GetFullSyncsByDistrictId?districtId=" + districtId; };
        // get: District/GetAllDistrictsWithSyncStatus
        this.RouteGetAllDistrictsWithSyncStatus = function () { return "District/GetAllDistrictsWithSyncStatus"; };
        // post: District/BulkUpdateCleverSync
        this.RouteBulkUpdateCleverSync = function () { return "District/BulkUpdateCleverSync"; };
        // post: District/BulkUpdateClassLinkSync
        this.RouteBulkUpdateClassLinkSync = function () { return "District/BulkUpdateClassLinkSync"; };
        // post: District/BulkUpdateDistrictSync
        this.RouteBulkUpdateDistrictSync = function () { return "District/BulkUpdateDistrictSync"; };
    }
    DistrictApiController.prototype.addDistrict = function (addDistrictDTO, requestOptions) {
        var url = this.RouteAddDistrict();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addDistrictDTO, 'post', url, requestOptions);
    };
    DistrictApiController.prototype.updateDistrict = function (updateDistrictDTO, requestOptions) {
        var url = this.RouteUpdateDistrict();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateDistrictDTO, 'post', url, requestOptions);
    };
    DistrictApiController.prototype.getDistrict = function (districtId, requestOptions) {
        var url = this.RouteGetDistrict(districtId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    DistrictApiController.prototype.getDistrictForSso = function (districtId, requestOptions) {
        var url = this.RouteGetDistrictForSso(districtId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    DistrictApiController.prototype.getAllDistricts = function (requestOptions) {
        var url = this.RouteGetAllDistricts();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    DistrictApiController.prototype.getAllDistrictsByState = function (stateId, requestOptions) {
        var url = this.RouteGetAllDistrictsByState(stateId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    DistrictApiController.prototype.getDistrictTableData = function (tableRequest, requestOptions) {
        var url = this.RouteGetDistrictTableData();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    DistrictApiController.prototype.getDistrictFullSyncTableData = function (tableRequest, districtId, requestOptions) {
        var url = this.RouteGetDistrictFullSyncTableData(districtId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    DistrictApiController.prototype.getFullSyncsByDistrictId = function (districtId, requestOptions) {
        var url = this.RouteGetFullSyncsByDistrictId(districtId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    DistrictApiController.prototype.getAllDistrictsWithSyncStatus = function (requestOptions) {
        var url = this.RouteGetAllDistrictsWithSyncStatus();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    DistrictApiController.prototype.bulkUpdateCleverSync = function (dto, requestOptions) {
        var url = this.RouteBulkUpdateCleverSync();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(dto, 'post', url, requestOptions);
    };
    DistrictApiController.prototype.bulkUpdateClassLinkSync = function (dto, requestOptions) {
        var url = this.RouteBulkUpdateClassLinkSync();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(dto, 'post', url, requestOptions);
    };
    DistrictApiController.prototype.bulkUpdateDistrictSync = function (dto, requestOptions) {
        var url = this.RouteBulkUpdateDistrictSync();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(dto, 'post', url, requestOptions);
    };
    return DistrictApiController;
}());

var service = new DistrictApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ImageApi = /** @class */ (function () {
    function ImageApi() {
    }
    /**
     * Crops a given image to the given size and returns a DataURI of that image.
     *
     * @param image The Image used for the cropping
     * @param sx Source X coordinate
     * @param sy Source Y coordinate
     * @param sw Source Width
     * @param sh Source Height
     * @param dw _Optional_: Destination Width. Used to resize a given screenshot
     * @param dh _Optional_: Destination Height. Used to resize a given screenshot
     */
    ImageApi.CropImageToDataURI = function (image, sx, sy, sw, sh, dw, dh) {
        if (dw === void 0) { dw = sw; }
        if (dh === void 0) { dh = sh; }
        // Create a temp canvas we can use to render the image
        var tempCanvas = document.createElement("canvas");
        var ctx = tempCanvas.getContext('2d');
        // Resize canvas
        tempCanvas.width = sw;
        tempCanvas.height = sh;
        if (!image.complete) {
            // We can only work with a complete image
            console.warn("Image is not loaded, please run this function in the image.onload callback");
            return "";
        }
        // Get its context and use it to draw the image, cropping it in the process
        tempCanvas.getContext('2d').drawImage(image, sx, sy, // Starting location
        sw, sh, // Size of the current image
        0, 0, // Destination location, we use 0,0 for the start of the screenshot
        dw, dh); // Screenshot size
        return tempCanvas.toDataURL();
    };
    return ImageApi;
}());
/* harmony default export */ __webpack_exports__["a"] = (ImageApi);


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AudioPlayer_less__ = __webpack_require__(2686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AudioPlayer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AudioPlayer_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(38);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var AudioPlayer = /** @class */ (function (_super) {
    __extends(AudioPlayer, _super);
    function AudioPlayer(props) {
        var _this = _super.call(this, props) || this;
        _this.isLoading = false; // This changes too quickly for setState
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, AudioPlayer.prototype);
        var audioElement = new Audio();
        audioElement.autoplay = false;
        audioElement.preload = "auto";
        // Add watchers
        audioElement.addEventListener("timeupdate", _this.audio_timeupdate);
        audioElement.addEventListener("ended", _this.audio_ended);
        _this.audioElement = audioElement;
        _this.timer = null;
        _this.state = {
            currentTime: 0,
            isPlaying: _this.props.isEnabled,
            isMuted: false,
        };
        return _this;
    }
    AudioPlayer.prototype.componentDidMount = function () {
        this.reloadComponent(this.props);
    };
    AudioPlayer.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.audioURL !== nextProps.audioURL) {
            // URL changed, hard reload everything
            this.reloadComponent(nextProps);
        }
        else if (this.props.playRange !== nextProps.playRange) {
            // State changed, do what they asked
            this.updateStartLocation(nextProps);
            this.updatePlayback(nextProps);
        }
        else if (this.props.isPlaying !== nextProps.isPlaying || this.props.isEnabled !== nextProps.isEnabled) {
            // State changed, do what they asked
            this.updatePlayback(nextProps);
        }
    };
    AudioPlayer.prototype.componentWillUnmount = function () {
        this.audioElement.removeEventListener("timeupdate", this.audio_timeupdate);
        this.audioElement.removeEventListener("ended", this.audio_ended);
        if (this.audioElement != null) {
            this.audioElement.pause();
        }
    };
    AudioPlayer.prototype.audio_timeupdate = function () {
        var _this = this;
        if (__WEBPACK_IMPORTED_MODULE_9_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
            // This will update the time
            this.setState({ currentTime: this.audioElement.currentTime });
        }
        if (this.props.playRange == null || this.props.playRange.end == null) {
            return;
        }
        // Are we less than half a second from stopping?
        if (this.timer == null && this.audioElement.currentTime + .5 > this.props.playRange.end) {
            var timeout = Math.floor((this.props.playRange.end - this.audioElement.currentTime) * 100) * 10;
            this.timer = setTimeout(function () {
                _this.audioElement.pause();
                _this.setState({ currentTime: _this.audioElement.currentTime, isPlaying: false });
                if (_this.props.onComplete != null) {
                    _this.props.onComplete();
                }
                // Set timer object to null, but not too quickly
                setTimeout(function () { return _this.timer = null; }, 333);
            }, timeout);
        }
    };
    AudioPlayer.prototype.audio_ended = function () {
        // Indicates that the audio completed playing.
        // Does not indicate that the audio has paused, only that it completed
        if (this.props.onComplete != null) {
            this.props.onComplete();
        }
        this.setState({ currentTime: this.audioElement.currentTime, isPlaying: false });
    };
    AudioPlayer.prototype.reloadComponent = function (props) {
        // Load the audio and update playback status
        if (props.audioURL == null || props.audioURL.length < 8) { // http:// is 7 chars long
            this.audioElement.src = "";
            this.audioElement.currentTime = 0;
            this.pauseAudio();
            return;
        }
        this.changeSrc(props);
        this.updateStartLocation(props);
        this.updatePlayback(props);
    };
    AudioPlayer.prototype.changeSrc = function (props) {
        if (props.audioURL == null || props.audioURL.length < 1) {
            return;
        }
        this.audioElement.src = props.audioURL;
    };
    AudioPlayer.prototype.updateStartLocation = function (props) {
        // Set start time to the start time
        // We assume that most changes to this property will start at the beginning or beginning of a break
        if (props.playRange != null && props.playRange.start != null) {
            this.audioElement.currentTime = props.playRange.start;
        }
        else {
            this.audioElement.currentTime = 0;
        }
    };
    AudioPlayer.prototype.updatePlayback = function (props) {
        if (!props.isEnabled) {
            this.pauseAudio();
        }
        // Changing isPlaying or adding an end time should immediately pause the audio. Play otherwise
        else if (!props.isPlaying || (props.playRange != null && props.playRange.end != null && this.audioElement.currentTime >= props.playRange.end)) {
            this.pauseAudio();
        }
        else {
            this.playAudio();
        }
        this.setState({ currentTime: this.audioElement.currentTime, isPlaying: !this.audioElement.paused });
    };
    AudioPlayer.prototype.playAudio = function () {
        var _this = this;
        if (this.audioElement.src == null || this.audioElement.src.length < 1) {
            return;
        }
        this.isLoading = true;
        this.audioElement.play().then(function () {
            _this.isLoading = false;
            if (_this.props.onPlay != null) {
                _this.props.onPlay();
            }
            _this.setState({ currentTime: _this.audioElement.currentTime, isPlaying: !_this.audioElement.paused });
        });
    };
    AudioPlayer.prototype.pauseAudio = function () {
        this.audioElement.pause();
        this.setState({ currentTime: this.audioElement.currentTime, isPlaying: !this.audioElement.paused });
        if (this.props.onPause != null) {
            this.props.onPause();
        }
    };
    AudioPlayer.prototype.resetAudio = function () {
        this.audioElement.pause();
        this.reloadComponent(this.props);
    };
    AudioPlayer.prototype.muteAudio = function () {
        this.audioElement.muted = !this.state.isMuted;
        this.setState({ isMuted: !this.state.isMuted });
    };
    AudioPlayer.prototype.advanceTime = function (time) {
        this.audioElement.currentTime += time;
    };
    AudioPlayer.prototype.renderPlayRange = function () {
        if (this.props.playRange == null) {
            return null;
        }
        if (this.props.playRange.end != null) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                "Start: ",
                this.props.playRange.start,
                " | End: ",
                this.props.playRange.end);
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
            "Start: ",
            this.props.playRange.start);
    };
    AudioPlayer.prototype.render = function () {
        var _this = this;
        return null;
        if (__WEBPACK_IMPORTED_MODULE_9_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
            // Things!
            var splits = this.props.audioURL.split('/');
            var split = splits.find(function (x) { return x.includes(".mp3"); });
            var mp3String = "";
            if (split != null) {
                var mp3Index = split.indexOf(".mp3");
                var startIndex = split.indexOf('/', mp3Index);
                startIndex = startIndex < 0 ? 0 : startIndex;
                mp3String = split.substring(startIndex, mp3Index + 4);
            }
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "audio-player" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { span: 8 },
                        this.state.isPlaying
                            ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_icon__["a" /* default */], { type: "pause-circle", onClick: this.pauseAudio })
                            : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_icon__["a" /* default */], { type: "play-circle", onClick: this.playAudio }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_icon__["a" /* default */], { type: "sync", onClick: this.resetAudio }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_icon__["a" /* default */], { type: "stop", onClick: this.muteAudio, theme: "twoTone", twoToneColor: "#52c41a" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_icon__["a" /* default */], { type: "plus-circle", onClick: function () { return _this.advanceTime(5); }, theme: "twoTone", twoToneColor: "#52c41a" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_icon__["a" /* default */], { type: "minus-circle", onClick: function () { return _this.advanceTime(-5); }, theme: "twoTone", twoToneColor: "#52c41a" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { span: 16 },
                        "Audio File: ",
                        mp3String,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "current-time" },
                            "Current Time: ",
                            this.state.currentTime),
                        this.renderPlayRange())));
        }
        return null;
    };
    return AudioPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        isEnabled: state.Config.audioEnabled,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(mapStateToProps)(AudioPlayer));


/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INITIALIZE */
/* unused harmony export ADD_TRANSLATION */
/* unused harmony export ADD_TRANSLATION_FOR_LANGUAGE */
/* unused harmony export SET_ACTIVE_LANGUAGE */
/* unused harmony export TRANSLATE */
/* unused harmony export languages */
/* unused harmony export translations */
/* unused harmony export options */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultTranslateOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return localizeReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return initialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addTranslation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addTranslationForLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setActiveLanguage; });
/* unused harmony export getTranslations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getActiveLanguage; });
/* unused harmony export translationsEqualSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTranslationsForActiveLanguage; });
/* unused harmony export getTranslationsForSpecificLanguage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTranslate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flat__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(479);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







/**
 * TYPES
 */


// This is to get around the whole default options issue with Flow
// I tried using the $Diff approach, but with no luck so for now stuck with this terd.
// Because sometimes you just want flow to shut up!


/**
 * ACTIONS
 */
var INITIALIZE = '@@localize/INITIALIZE';
var ADD_TRANSLATION = '@@localize/ADD_TRANSLATION';
var ADD_TRANSLATION_FOR_LANGUAGE = '@@localize/ADD_TRANSLATION_FOR_LANGUAGE';
var SET_ACTIVE_LANGUAGE = '@@localize/SET_ACTIVE_LANGUAGE';
var TRANSLATE = '@@localize/TRANSLATE';

/**
 * REDUCERS
 */
function languages() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case INITIALIZE:
      var _options = action.payload.options || {};
      return action.payload.languages.map(function (language, index) {
        var isActive = function isActive(code) {
          return _options.defaultLanguage !== undefined ? code === _options.defaultLanguage : index === 0;
        };
        // check if it's using array of Language objects, or array of language codes
        return typeof language === 'string' ? { code: language, active: isActive(language) // language codes
        } : _extends({}, language, { active: isActive(language.code) }); // language objects
      });
    case SET_ACTIVE_LANGUAGE:
      return state.map(function (language) {
        return language.code === action.payload.languageCode ? _extends({}, language, { active: true }) : _extends({}, language, { active: false });
      });
    default:
      return state;
  }
}

function translations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var flattenedTranslations = void 0;
  var translationWithTransform = void 0;

  switch (action.type) {
    case INITIALIZE:
      if (!action.payload.translation) {
        return state;
      }

      flattenedTranslations = Object(__WEBPACK_IMPORTED_MODULE_2_flat__["flatten"])(action.payload.translation, {
        safe: true
      });
      var _options2 = action.payload.options || {};
      var firstLanguage = typeof action.payload.languages[0] === 'string' ? action.payload.languages[0] : action.payload.languages[0].code;
      var _defaultLanguage = _options2.defaultLanguage || firstLanguage;
      var isMultiLanguageTranslation = Object.keys(flattenedTranslations).some(function (item) {
        return Array.isArray(flattenedTranslations[item]);
      });

      // add translation based on whether it is single vs multi language translation data
      var newTranslation = isMultiLanguageTranslation ? flattenedTranslations : Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* getSingleToMultilanguageTranslation */])(_defaultLanguage, action.languageCodes, flattenedTranslations, state);

      return _extends({}, state, newTranslation);
    case ADD_TRANSLATION:
      translationWithTransform = action.payload.translationOptions && action.payload.translationOptions.translationTransform !== undefined ? action.payload.translationOptions.translationTransform(action.payload.translation || {}, action.languageCodes) : action.payload.translation;
      return _extends({}, state, Object(__WEBPACK_IMPORTED_MODULE_2_flat__["flatten"])(translationWithTransform, { safe: true }));
    case ADD_TRANSLATION_FOR_LANGUAGE:
      flattenedTranslations = Object(__WEBPACK_IMPORTED_MODULE_2_flat__["flatten"])(action.payload.translation, {
        safe: true
      });
      return _extends({}, state, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* getSingleToMultilanguageTranslation */])(action.payload.language, action.languageCodes, flattenedTranslations, state));
    default:
      return state;
  }
}

function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTranslateOptions;
  var action = arguments[1];

  switch (action.type) {
    case INITIALIZE:
      var _options3 = action.payload.options || {};
      var _defaultLanguage2 = _options3.defaultLanguage || action.languageCodes[0];
      return _extends({}, state, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* validateOptions */])(_options3), { defaultLanguage: _defaultLanguage2 });
    default:
      return state;
  }
}

var defaultTranslateOptions = {
  renderToStaticMarkup: false,
  renderInnerHtml: false,
  ignoreTranslateChildren: false,
  defaultLanguage: '',
  onMissingTranslation: function onMissingTranslation(_ref) {
    var translationId = _ref.translationId,
        languageCode = _ref.languageCode;
    return 'Missing translationId: ${ translationId } for language: ${ languageCode }';
  }
};

var initialState = {
  languages: [],
  translations: {},
  options: defaultTranslateOptions
};

var localizeReducer = function localizeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var languageCodes = state.languages.map(function (language) {
    return language.code;
  });
  return {
    languages: languages(state.languages, action),
    translations: translations(state.translations, _extends({}, action, {
      languageCodes: languageCodes
    })),
    options: options(state.options, _extends({}, action, { languageCodes: languageCodes }))
  };
};

/**
 * ACTION CREATORS
 */
var initialize = function initialize(payload) {
  return {
    type: INITIALIZE,
    payload: payload
  };
};

var addTranslation = function addTranslation(translation, options) {
  return {
    type: ADD_TRANSLATION,
    payload: {
      translation: translation,
      translationOptions: options
    }
  };
};

var addTranslationForLanguage = function addTranslationForLanguage(translation, language) {
  return {
    type: ADD_TRANSLATION_FOR_LANGUAGE,
    payload: { translation: translation, language: language }
  };
};

var setActiveLanguage = function setActiveLanguage(languageCode) {
  return {
    type: SET_ACTIVE_LANGUAGE,
    payload: { languageCode: languageCode }
  };
};

/**
 * SELECTORS
 */
var getTranslations = function getTranslations(state) {
  return state.translations;
};

var getLanguages = function getLanguages(state) {
  return state.languages;
};

var getOptions = function getOptions(state) {
  var options = Object.assign({}, state.options);
  var languages = void 0;

  // If there isn't a default language, grab the first languages from the
  // available languages as default

  if (!options.defaultLanguage) {
    languages = getLanguages(state) || [];
    options.defaultLanguage = languages[0] ? languages[0].code : '';
  }

  return options;
};

var getActiveLanguage = function getActiveLanguage(state) {
  var languages = getLanguages(state);
  return languages.filter(function (language) {
    return language.active === true;
  })[0];
};

/**
 * A custom equality checker that checker that compares an objects keys and values instead of === comparison
 * e.g. {name: 'Ted', sport: 'hockey'} would result in 'name,sport - Ted,hocker' which would be used for comparison
 *
 * NOTE: This works with activeLanguage, languages, and translations data types.
 * If a new data type is added to selector this would need to be updated to accomodate
 */
var translationsEqualSelector = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelectorCreator"])(__WEBPACK_IMPORTED_MODULE_3_reselect__["defaultMemoize"], function (prev, cur) {
  var prevKeys = (typeof prev === 'undefined' ? 'undefined' : _typeof(prev)) === 'object' ? Object.keys(prev).toString() : undefined;
  var curKeys = (typeof cur === 'undefined' ? 'undefined' : _typeof(cur)) === 'object' ? Object.keys(cur).toString() : undefined;

  var prevValues = (typeof prev === 'undefined' ? 'undefined' : _typeof(prev)) === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* objectValuesToString */])(prev) : undefined;
  var curValues = (typeof cur === 'undefined' ? 'undefined' : _typeof(cur)) === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* objectValuesToString */])(cur) : undefined;

  var prevCacheValue = prevKeys !== undefined && prevValues !== undefined ? prevKeys + ' - ' + prevValues : prev;

  var curCacheValue = curKeys !== undefined && curValues !== undefined ? curKeys + ' - ' + curValues : cur;

  return prevCacheValue === curCacheValue;
});

var getTranslationsForActiveLanguage = translationsEqualSelector(getActiveLanguage, getLanguages, getTranslations, __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* getTranslationsForLanguage */]);

var getTranslationsForSpecificLanguage = translationsEqualSelector(getLanguages, getTranslations, function (languages, translations) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["defaultMemoize"])(function (languageCode) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* getTranslationsForLanguage */])({ code: languageCode, active: false }, languages, translations);
  });
});

var getTranslate = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(getTranslationsForActiveLanguage, getTranslationsForSpecificLanguage, getActiveLanguage, getOptions, function (translationsForActiveLanguage, getTranslationsForLanguage, activeLanguage, initializeOptions) {
  return function (value) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var translateOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var defaultLanguage = initializeOptions.defaultLanguage,
        defaultOptions = _objectWithoutProperties(initializeOptions, ['defaultLanguage']);

    var overrideLanguage = translateOptions.language;

    var translations = overrideLanguage !== undefined ? getTranslationsForLanguage(overrideLanguage) : translationsForActiveLanguage;

    var defaultTranslations = activeLanguage && activeLanguage.code === defaultLanguage ? translationsForActiveLanguage : getTranslationsForLanguage(defaultLanguage);

    var languageCode = overrideLanguage !== undefined ? overrideLanguage : activeLanguage && activeLanguage.code;

    var mergedOptions = _extends({}, defaultOptions, translateOptions);

    var getTranslation = function getTranslation(translationId) {
      var hasValidTranslation = translations[translationId] !== undefined;
      var hasValidDefaultTranslation = defaultTranslations[translationId] !== undefined;

      var defaultTranslation = hasValidDefaultTranslation ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* getLocalizedElement */])({
        translation: defaultTranslations[translationId],
        data: data,
        renderInnerHtml: mergedOptions.renderInnerHtml
      }) : "No default translation found! Ensure you've added translations for your default langauge.";

      // if translation is not valid then generate the on missing translation message in it's place
      var translation = hasValidTranslation ? translations[translationId] : mergedOptions.onMissingTranslation({
        translationId: translationId,
        languageCode: languageCode,
        defaultTranslation: defaultTranslation
      });

      // if translations are missing than ovrride data to include translationId, languageCode
      // as these will be needed to render missing translations message
      var translationData = hasValidTranslation ? data : { translationId: translationId, languageCode: languageCode };

      return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* getLocalizedElement */])({
        translation: translation,
        data: translationData,
        languageCode: languageCode,
        renderInnerHtml: mergedOptions.renderInnerHtml
      });
    };

    if (typeof value === 'string') {
      return getTranslation(value);
    } else if (Array.isArray(value)) {
      return value.reduce(function (prev, cur) {
        return _extends({}, prev, _defineProperty({}, cur, getTranslation(cur)));
      }, {});
    } else {
      throw new Error('react-localize-redux: Invalid key passed to getTranslate.');
    }
  };
});


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatementApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var StatementApiController = /** @class */ (function () {
    function StatementApiController() {
        // post: Statement/AddStatement
        this.RouteAddStatement = function () { return "Statement/AddStatement"; };
        // post: Statement/UpdateStatement
        this.RouteUpdateStatement = function () { return "Statement/UpdateStatement"; };
        // get: Statement/AdminUpdateStudentStatementCompletion/${statementId}/${userId}/${gradeId}
        this.RouteAdminUpdateStudentStatementCompletion = function (statementId, userId, gradeId) { return "Statement/AdminUpdateStudentStatementCompletion/" + statementId + "/" + userId + "/" + gradeId; };
        // post: Statement/UpdateStudentStatement
        this.RouteUpdateStudentStatement = function () { return "Statement/UpdateStudentStatement"; };
        // get: Statement/GetStatement/${statementId}
        this.RouteGetStatement = function (statementId) { return "Statement/GetStatement/" + statementId; };
        // get: Statement/GetAllStudentIStatements
        this.RouteGetAllStudentIStatements = function () { return "Statement/GetAllStudentIStatements"; };
        // get: Statement/GetStudentIStatements
        this.RouteGetStudentIStatements = function () { return "Statement/GetStudentIStatements"; };
        // post: Statement/GetStudentStatementTableData/${userId}
        this.RouteGetStudentStatementTableData = function (userId) { return "Statement/GetStudentStatementTableData/" + userId; };
        // post: Statement/GetStatementTableData
        this.RouteGetStatementTableData = function () { return "Statement/GetStatementTableData"; };
        // get: Statement/GetStatementsForAcademicStandard
        this.RouteGetStatementsForAcademicStandard = function () { return "Statement/GetStatementsForAcademicStandard"; };
        // post: Statement/CopyKuderGenericIStatements
        this.RouteCopyKuderGenericIStatements = function () { return "Statement/CopyKuderGenericIStatements"; };
        // post: Statement/SoftDeleteStatement?statementId=${statementId}
        this.RouteSoftDeleteStatement = function (statementId) { return "Statement/SoftDeleteStatement?statementId=" + statementId; };
    }
    StatementApiController.prototype.addStatement = function (addStatementDTO, requestOptions) {
        var url = this.RouteAddStatement();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addStatementDTO, 'post', url, requestOptions);
    };
    StatementApiController.prototype.updateStatement = function (updateStatementDTO, requestOptions) {
        var url = this.RouteUpdateStatement();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateStatementDTO, 'post', url, requestOptions);
    };
    StatementApiController.prototype.adminUpdateStudentStatementCompletion = function (statementId, userId, gradeId, requestOptions) {
        var url = this.RouteAdminUpdateStudentStatementCompletion(statementId, userId, gradeId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    StatementApiController.prototype.updateStudentStatement = function (requestOptions) {
        var url = this.RouteUpdateStudentStatement();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    StatementApiController.prototype.getStatement = function (statementId, requestOptions) {
        var url = this.RouteGetStatement(statementId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    StatementApiController.prototype.getAllStudentIStatements = function (requestOptions) {
        var url = this.RouteGetAllStudentIStatements();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    StatementApiController.prototype.getStudentIStatements = function (requestOptions) {
        var url = this.RouteGetStudentIStatements();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    StatementApiController.prototype.getStudentStatementTableData = function (tableRequest, userId, requestOptions) {
        var url = this.RouteGetStudentStatementTableData(userId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    StatementApiController.prototype.getStatementTableData = function (tableRequest, requestOptions) {
        var url = this.RouteGetStatementTableData();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    StatementApiController.prototype.getStatementsForAcademicStandard = function (requestOptions) {
        var url = this.RouteGetStatementsForAcademicStandard();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    StatementApiController.prototype.copyKuderGenericIStatements = function (requestOptions) {
        var url = this.RouteCopyKuderGenericIStatements();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    StatementApiController.prototype.softDeleteStatement = function (statementId, requestOptions) {
        var url = this.RouteSoftDeleteStatement(statementId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    return StatementApiController;
}());

var service = new StatementApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_style__ = __webpack_require__(2097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tooltip_style__ = __webpack_require__(52);


// style dependencies



/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClientApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var ClientApiController = /** @class */ (function () {
    function ClientApiController() {
        // post: Client/AddClient
        this.RouteAddClient = function () { return "Client/AddClient"; };
        // post: Client/UpdateClient
        this.RouteUpdateClient = function () { return "Client/UpdateClient"; };
        // post: Client/AddClientSubscription
        this.RouteAddClientSubscription = function () { return "Client/AddClientSubscription"; };
        // post: Client/UpdateClientSubscription
        this.RouteUpdateClientSubscription = function () { return "Client/UpdateClientSubscription"; };
        // get: Client/GetClientSubscription/${clientSubscriptionId}
        this.RouteGetClientSubscription = function (clientSubscriptionId) { return "Client/GetClientSubscription/" + clientSubscriptionId; };
        // get: Client/GetClient/${clientId}
        this.RouteGetClient = function (clientId) { return "Client/GetClient/" + clientId; };
        // get: Client/GetClientTypes
        this.RouteGetClientTypes = function () { return "Client/GetClientTypes"; };
        // post: Client/GetClientTableData
        this.RouteGetClientTableData = function () { return "Client/GetClientTableData"; };
        // post: Client/GetClientSubscriptionTableData?clientId=${clientId}
        this.RouteGetClientSubscriptionTableData = function (clientId) { return "Client/GetClientSubscriptionTableData?clientId=" + clientId; };
        // get: Client/GetAllClients
        this.RouteGetAllClients = function () { return "Client/GetAllClients"; };
        // post: Client/CheckCleverId
        this.RouteIsDuplicateCleverDistrictId = function () { return "Client/CheckCleverId"; };
        // post: Client/CheckClassLinkTenantId
        this.RouteIsDuplicateClassLinkTenantId = function () { return "Client/CheckClassLinkTenantId"; };
        // post: Client/District/CheckCleverId
        this.RouteDistrictIsDuplicateCleverDistrictId = function () { return "Client/District/CheckCleverId"; };
        // post: Client/District/CheckClassLinkTenantId
        this.RouteDistrictIsDuplicateClassLinkTenantId = function () { return "Client/District/CheckClassLinkTenantId"; };
    }
    ClientApiController.prototype.addClient = function (addClientDTO, requestOptions) {
        var url = this.RouteAddClient();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addClientDTO, 'post', url, requestOptions);
    };
    ClientApiController.prototype.updateClient = function (updateClientDTO, requestOptions) {
        var url = this.RouteUpdateClient();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateClientDTO, 'post', url, requestOptions);
    };
    ClientApiController.prototype.addClientSubscription = function (addClientSubscriptionDTO, requestOptions) {
        var url = this.RouteAddClientSubscription();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addClientSubscriptionDTO, 'post', url, requestOptions);
    };
    ClientApiController.prototype.updateClientSubscription = function (updateClientSubscriptionDTO, requestOptions) {
        var url = this.RouteUpdateClientSubscription();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateClientSubscriptionDTO, 'post', url, requestOptions);
    };
    ClientApiController.prototype.getClientSubscription = function (clientSubscriptionId, requestOptions) {
        var url = this.RouteGetClientSubscription(clientSubscriptionId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ClientApiController.prototype.getClient = function (clientId, requestOptions) {
        var url = this.RouteGetClient(clientId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ClientApiController.prototype.getClientTypes = function (requestOptions) {
        var url = this.RouteGetClientTypes();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ClientApiController.prototype.getClientTableData = function (tableRequest, requestOptions) {
        var url = this.RouteGetClientTableData();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    ClientApiController.prototype.getClientSubscriptionTableData = function (tableRequest, clientId, requestOptions) {
        var url = this.RouteGetClientSubscriptionTableData(clientId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    ClientApiController.prototype.getAllClients = function (requestOptions) {
        var url = this.RouteGetAllClients();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ClientApiController.prototype.isDuplicateCleverDistrictId = function (updateClientDTO, requestOptions) {
        var url = this.RouteIsDuplicateCleverDistrictId();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateClientDTO, 'post', url, requestOptions);
    };
    ClientApiController.prototype.isDuplicateClassLinkTenantId = function (updateClientDTO, requestOptions) {
        var url = this.RouteIsDuplicateClassLinkTenantId();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateClientDTO, 'post', url, requestOptions);
    };
    ClientApiController.prototype.isDistrictDuplicateCleverDistrictId = function (updateDistrictDTO, requestOptions) {
        var url = this.RouteDistrictIsDuplicateCleverDistrictId();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateDistrictDTO, 'post', url, requestOptions);
    };
    ClientApiController.prototype.isDistrictDuplicateClassLinkTenantId = function (updateDistrictDTO, requestOptions) {
        var url = this.RouteDistrictIsDuplicateClassLinkTenantId();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateDistrictDTO, 'post', url, requestOptions);
    };
    return ClientApiController;
}());

var service = new ClientApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(11);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _omit = __webpack_require__(91);

var _omit2 = _interopRequireDefault(_omit);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _calculateNodeHeight = __webpack_require__(2135);

var _calculateNodeHeight2 = _interopRequireDefault(_calculateNodeHeight);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function onNextFrame(cb) {
    if (window.requestAnimationFrame) {
        return window.requestAnimationFrame(cb);
    }
    return window.setTimeout(cb, 1);
}
function clearNextFrameAction(nextFrameId) {
    if (window.cancelAnimationFrame) {
        window.cancelAnimationFrame(nextFrameId);
    } else {
        window.clearTimeout(nextFrameId);
    }
}

var TextArea = function (_React$Component) {
    (0, _inherits3['default'])(TextArea, _React$Component);

    function TextArea() {
        (0, _classCallCheck3['default'])(this, TextArea);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).apply(this, arguments));

        _this.state = {
            textareaStyles: {}
        };
        _this.resizeTextarea = function () {
            var autosize = _this.props.autosize;

            if (!autosize || !_this.textAreaRef) {
                return;
            }
            var minRows = autosize ? autosize.minRows : null;
            var maxRows = autosize ? autosize.maxRows : null;
            var textareaStyles = (0, _calculateNodeHeight2['default'])(_this.textAreaRef, false, minRows, maxRows);
            _this.setState({ textareaStyles: textareaStyles });
        };
        _this.handleTextareaChange = function (e) {
            if (!('value' in _this.props)) {
                _this.resizeTextarea();
            }
            var onChange = _this.props.onChange;

            if (onChange) {
                onChange(e);
            }
        };
        _this.handleKeyDown = function (e) {
            var _this$props = _this.props,
                onPressEnter = _this$props.onPressEnter,
                onKeyDown = _this$props.onKeyDown;

            if (e.keyCode === 13 && onPressEnter) {
                onPressEnter(e);
            }
            if (onKeyDown) {
                onKeyDown(e);
            }
        };
        _this.saveTextAreaRef = function (textArea) {
            _this.textAreaRef = textArea;
        };
        return _this;
    }

    (0, _createClass3['default'])(TextArea, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.resizeTextarea();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Re-render with the new content then recalculate the height as required.
            if (this.props.value !== nextProps.value) {
                if (this.nextFrameActionId) {
                    clearNextFrameAction(this.nextFrameActionId);
                }
                this.nextFrameActionId = onNextFrame(this.resizeTextarea);
            }
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.textAreaRef.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.textAreaRef.blur();
        }
    }, {
        key: 'getTextAreaClassName',
        value: function getTextAreaClassName() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                disabled = _props.disabled;

            return (0, _classnames2['default'])(prefixCls, className, (0, _defineProperty3['default'])({}, prefixCls + '-disabled', disabled));
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var otherProps = (0, _omit2['default'])(props, ['prefixCls', 'onPressEnter', 'autosize']);
            var style = (0, _extends3['default'])({}, props.style, this.state.textareaStyles);
            // Fix https://github.com/ant-design/ant-design/issues/6776
            // Make sure it could be reset when using form.getFieldDecorator
            if ('value' in otherProps) {
                otherProps.value = otherProps.value || '';
            }
            return React.createElement('textarea', (0, _extends3['default'])({}, otherProps, { className: this.getTextAreaClassName(), style: style, onKeyDown: this.handleKeyDown, onChange: this.handleTextareaChange, ref: this.saveTextAreaRef }));
        }
    }]);
    return TextArea;
}(React.Component);

exports['default'] = TextArea;

TextArea.defaultProps = {
    prefixCls: 'ant-input'
};
module.exports = exports['default'];

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return _DYN_SESSION_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return _DYN_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return _DYN_IS_USER_COOKIE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return _DYN_IS_NEW_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return _DYN_GET_TRACE_CTX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return _DYN_TELEMETRY_TRACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _DYN_APPLY_SESSION_CONTEX0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _DYN_APPLY_APPLICATION_CO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _DYN_APPLY_DEVICE_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _DYN_APPLY_OPERATION_CONT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _DYN_APPLY_USER_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _DYN_APPLY_OPERATING_SYST3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _DYN_APPLY_LOCATION_CONTE4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _DYN_APPLY_INTERNAL_CONTE5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _DYN_ACCOUNT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return _DYN_SDK_EXTENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _DYN_GET_SESSION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return _DYN_NAME_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return _DYN_SESSION_COOKIE_POSTF6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return _DYN_USER_COOKIE_POSTFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return _DYN_ID_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _DYN_GET_NEW_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return _DYN_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return _DYN_AUTOMATIC_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _DYN_AUTHENTICATED_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return _DYN_SESSION_EXPIRATION_M7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return _DYN_SESSION_RENEWAL_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _DYN_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _DYN_ACQUISITION_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return _DYN_RENEWAL_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _DYN_COOKIE_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return _DYN_JOIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return _DYN_COOKIE_SEPARATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _DYN_AUTH_USER_COOKIE_NAM8; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_SESSION_MANAGER = "sessionManager"; // Count: 3
var _DYN_UPDATE = "update"; // Count: 4
var _DYN_IS_USER_COOKIE_SET = "isUserCookieSet"; // Count: 4
var _DYN_IS_NEW_USER = "isNewUser"; // Count: 4
var _DYN_GET_TRACE_CTX = "getTraceCtx"; // Count: 3
var _DYN_TELEMETRY_TRACE = "telemetryTrace"; // Count: 3
var _DYN_APPLY_SESSION_CONTEX0 = "applySessionContext"; // Count: 2
var _DYN_APPLY_APPLICATION_CO1 = "applyApplicationContext"; // Count: 2
var _DYN_APPLY_DEVICE_CONTEXT = "applyDeviceContext"; // Count: 2
var _DYN_APPLY_OPERATION_CONT2 = "applyOperationContext"; // Count: 2
var _DYN_APPLY_USER_CONTEXT = "applyUserContext"; // Count: 2
var _DYN_APPLY_OPERATING_SYST3 = "applyOperatingSystemContxt"; // Count: 2
var _DYN_APPLY_LOCATION_CONTE4 = "applyLocationContext"; // Count: 2
var _DYN_APPLY_INTERNAL_CONTE5 = "applyInternalContext"; // Count: 2
var _DYN_ACCOUNT_ID = "accountId"; // Count: 8
var _DYN_SDK_EXTENSION = "sdkExtension"; // Count: 4
var _DYN_GET_SESSION_ID = "getSessionId"; // Count: 4
var _DYN_NAME_PREFIX = "namePrefix"; // Count: 7
var _DYN_SESSION_COOKIE_POSTF6 = "sessionCookiePostfix"; // Count: 4
var _DYN_USER_COOKIE_POSTFIX = "userCookiePostfix"; // Count: 4
var _DYN_ID_LENGTH = "idLength"; // Count: 5
var _DYN_GET_NEW_ID = "getNewId"; // Count: 6
var _DYN_LENGTH = "length"; // Count: 4
var _DYN_AUTOMATIC_SESSION = "automaticSession"; // Count: 5
var _DYN_AUTHENTICATED_ID = "authenticatedId"; // Count: 6
var _DYN_SESSION_EXPIRATION_M7 = "sessionExpirationMs"; // Count: 5
var _DYN_SESSION_RENEWAL_MS = "sessionRenewalMs"; // Count: 4
var _DYN_CONFIG = "config"; // Count: 4
var _DYN_ACQUISITION_DATE = "acquisitionDate"; // Count: 5
var _DYN_RENEWAL_DATE = "renewalDate"; // Count: 4
var _DYN_COOKIE_DOMAIN = "cookieDomain"; // Count: 3
var _DYN_JOIN = "join"; // Count: 5
var _DYN_COOKIE_SEPARATOR = "cookieSeparator"; // Count: 5
var _DYN_AUTH_USER_COOKIE_NAM8 = "authUserCookieName"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExperimentalFeature; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addExperimentalFeatures;
/* harmony export (immutable) */ __webpack_exports__["d"] = isExperimentalFeatureEnabled;
/* unused harmony export resetExperimentalFeatures */
/* harmony export (immutable) */ __webpack_exports__["c"] = getExperimentalFeatures;
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
    ExperimentalFeature["PAGEHIDE"] = "pagehide";
    ExperimentalFeature["FEATURE_FLAGS"] = "feature_flags";
    ExperimentalFeature["RESOURCE_PAGE_STATES"] = "resource_page_states";
    ExperimentalFeature["PAGE_STATES"] = "page_states";
    ExperimentalFeature["COLLECT_FLUSH_REASON"] = "collect_flush_reason";
    ExperimentalFeature["NO_RESOURCE_DURATION_FROZEN_STATE"] = "no_resource_duration_frozen_state";
})(ExperimentalFeature || (ExperimentalFeature = {}));
var enabledExperimentalFeatures = new Set();
function addExperimentalFeatures(enabledFeatures) {
    enabledFeatures.forEach(function (flag) {
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return enabledExperimentalFeatures.has(featureName);
}
function resetExperimentalFeatures() {
    enabledExperimentalFeatures.clear();
}
function getExperimentalFeatures() {
    return enabledExperimentalFeatures;
}
//# sourceMappingURL=experimentalFeatures.js.map

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SESSION_TIME_OUT_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SESSION_EXPIRATION_DELAY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_utils_timeUtils__ = __webpack_require__(101);

var SESSION_TIME_OUT_DELAY = 4 * __WEBPACK_IMPORTED_MODULE_0__tools_utils_timeUtils__["a" /* ONE_HOUR */];
var SESSION_EXPIRATION_DELAY = 15 * __WEBPACK_IMPORTED_MODULE_0__tools_utils_timeUtils__["b" /* ONE_MINUTE */];
//# sourceMappingURL=sessionConstants.js.map

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__computeStackTrace__ = __webpack_require__(792);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__computeStackTrace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(1952);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__tracekit__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NO_ERROR_STACK_PRESENT_MESSAGE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = computeRawError;
/* harmony export (immutable) */ __webpack_exports__["f"] = tryToGetFingerprint;
/* harmony export (immutable) */ __webpack_exports__["e"] = toStackTraceString;
/* unused harmony export getFileFromStackTraceString */
/* harmony export (immutable) */ __webpack_exports__["d"] = formatErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = createHandlingStack;
/* unused harmony export flattenErrorCauses */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracekit__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_serialisation_sanitize__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_utils_functionUtils__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_serialisation_jsonStringify__ = __webpack_require__(186);





var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = originalError instanceof Error;
    var message = computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = hasUsableStack(isErrorInstance, stackTrace)
        ? toStackTraceString(stackTrace)
        : NO_ERROR_STACK_PRESENT_MESSAGE;
    var causes = isErrorInstance ? flattenErrorCauses(originalError, source) : undefined;
    var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
    var fingerprint = tryToGetFingerprint(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint,
    };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name)
        ? stackTrace.message
        : !isErrorInstance
            ? "".concat(nonErrorPrefix, " ").concat(Object(__WEBPACK_IMPORTED_MODULE_4__tools_serialisation_jsonStringify__["b" /* jsonStringify */])(Object(__WEBPACK_IMPORTED_MODULE_2__tools_serialisation_sanitize__["a" /* sanitize */])(originalError)))
            : 'Empty message';
}
function hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) {
        return false;
    }
    if (isErrorInstance) {
        return true;
    }
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function tryToGetFingerprint(originalError) {
    return originalError instanceof Error && 'dd_fingerprint' in originalError
        ? String(originalError.dd_fingerprint)
        : undefined;
}
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_3__tools_utils_functionUtils__["a" /* noop */])();
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__tools_monitor__["a" /* callMonitored */])(function () {
        var stackTrace = Object(__WEBPACK_IMPORTED_MODULE_0__tracekit__["a" /* computeStackTrace */])(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
function flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = Object(__WEBPACK_IMPORTED_MODULE_0__tracekit__["a" /* computeStackTrace */])(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
//# sourceMappingURL=error.js.map

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isTouchEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = getEventTarget;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__ = __webpack_require__(151);

function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function getEventTarget(event) {
    if (event.composed === true && Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__["i" /* isNodeShadowHost */])(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
//# sourceMappingURL=eventsUtils.js.map

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_style__ = __webpack_require__(19);


// style dependencies


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var FullscreenApi = /** @class */ (function () {
    function FullscreenApi() {
    }
    FullscreenApi.RequestFullscreen = function (element) {
        var func = this.fullscreenFunctionNames.filter(function (x) { return element[x] != null; }).filter(function (x) { return x; }).shift();
        if (func == null) {
            console.error("Fullscreen mode is not supported on this browser");
            return;
        }
        element[func]();
    };
    FullscreenApi.CancelFullscreen = function () {
        var func = this.cancelFullscreenFunctionNames.filter(function (x) { return document[x] != null; }).filter(function (x) { return x; }).shift();
        if (func == null) {
            console.error("Fullscreen mode is not supported on this browser");
            return;
        }
        document[func]();
    };
    FullscreenApi.GetFullscreenValue = function () {
        var func = this.fullScreenValues.filter(function (x) { return document[x] != null; }).filter(function (x) { return x; }).shift();
        if (func == null) {
            // We might break the browser if we error on every render frame
            // console.error("Fullscreen mode is not supported on this browser");
            return false;
        }
        return document[func];
    };
    // Grabbed iPad from here: https://developer.apple.com/documentation/webkitjs/htmlvideoelement/1633500-webkitenterfullscreen
    FullscreenApi.fullscreenFunctionNames = [
        'requestFullscreen',
        'requestFullScreen',
        'webkitRequestFullscreen',
        'webkitRequestFullScreen',
        'webkitEnterFullscreen',
        'msRequestFullscreen',
        'msRequestFullScreen',
        'mozRequestFullScreen',
        'mozRequestFullscreen'
    ];
    FullscreenApi.cancelFullscreenFunctionNames = [
        'cancelFullScreen',
        'exitFullscreen',
        'webkitCancelFullScreen',
        'webkitExitFullscreen',
        'msCancelFullScreen',
        'msExitFullscreen',
        'mozCancelFullScreen',
        'mozExitFullscreen'
    ];
    FullscreenApi.fullScreenValues = [
        "fullscreen",
        "mozFullScreen",
        "webkitIsFullScreen",
        "msFullscreenElement"
    ];
    return FullscreenApi;
}());
/* harmony default export */ __webpack_exports__["a"] = (FullscreenApi);


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__radio_style__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkbox_style__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dropdown_style__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spin_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pagination_style__ = __webpack_require__(828);


// style dependencies






/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = downloadFile;
function downloadFile(fileData, fileName, fileType) {
    if (fileType === void 0) { fileType = 'application/octet-stream;charset=utf-8'; }
    if (fileData) {
        var blob = typeof fileData === 'string' ? new Blob([s2ab(atob(fileData))], { type: fileType }) : fileData;
        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, fileName);
        }
        else {
            var a = document.createElement('a');
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.hidden = true;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    }
}
function s2ab(str) {
    var buffer = new ArrayBuffer(str.length);
    var view = new Uint8Array(buffer);
    var length = str.length;
    for (var i = 0; i < length; ++i) {
        view[i] = str.charCodeAt(i);
    }
    return buffer;
}


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ArrayUtil = /** @class */ (function () {
    function ArrayUtil() {
    }
    /**
     * Gets the unique values from an array. Works best on primitives and objects.
     */
    ArrayUtil.Unique = function (array) {
        // This was made much easier with ES6
        // https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
        return Array.from(new Set(array));
    };
    return ArrayUtil;
}());
/* harmony default export */ __webpack_exports__["a"] = (ArrayUtil);


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};




var FieldDecorator = /** @class */ (function (_super) {
    __extends(FieldDecorator, _super);
    function FieldDecorator(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, FieldDecorator.prototype);
        return _this;
    }
    FieldDecorator.prototype.defaultGetValueFromEvent = function (e) {
        if (!e || !e.target) {
            return e;
        }
        var target = e.target;
        return target.type === 'checkbox' ? target.checked : target.value;
    };
    FieldDecorator.prototype.render = function () {
        var children = this.props.children;
        var visible = this.props.visible != null ? this.props.visible : true;
        if (!visible) {
            return null;
        }
        // Some fun defaults that I have had to use can be found here: https://github.com/react-component/form#option-object
        var fieldDecorator = this.props.form.getFieldDecorator(this.props.name, {
            initialValue: this.props.initialValue == null ? undefined : this.props.initialValue,
            valuePropName: this.props.valuePropName || "value",
            getValueFromEvent: this.props.getValueFromEvent || this.defaultGetValueFromEvent,
            rules: this.props.rules == null || this.props.rules.length === 0 ? undefined : this.props.rules
        });
        if (Array.isArray(children)) {
            console.warn("Form Item children must be a single react component, not an array. Rendering first element");
            children = children[0];
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { key: this.props.key, label: this.props.label, labelCol: this.props.labelCol, wrapperCol: this.props.wrapperCol }, fieldDecorator(this.props.children));
    };
    // I have absolutely no idea what this is for
    FieldDecorator.DefaultGetValueFromEventForUpload = function (e) {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    /**
     * Provides the standard 'Select All' event for the FieldDecorator's getValueFromEvent() function
     *
     * **This is designed for a `<Select>` component**
     *
     * @param {string} selectAllKey The key on the `<Select.Option>` for the Select All option
     * @param {((string | number)[])} allKeys The keys in the dropdown
     */
    FieldDecorator.StandardSelectAllEvent = function (selectAllKey, allKeys) {
        return function (value) {
            // 'all' comes from the 'All' value in the <Select.Option>
            if (value && value.length && value.includes(selectAllKey)) {
                // If all are selected, deselect everything
                if (value.length === allKeys.length + 1) {
                    return [];
                }
                var results = new Set(__spreadArrays(value, allKeys));
                results.delete(selectAllKey);
                return Array.from(results);
            }
            return value;
        };
    };
    return FieldDecorator;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FieldDecorator);


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Config = /** @class */ (function () {
    function Config() {
    }
    /**
     * Returns a complete Azure Url for a given file
     *
     * @param {string} fileKey A string for the given file. Extension is based on 'fileType' *except for static, which must have a extension attached*
     * @param {AzureFileType} fileType
     * @param {string} languageCode
     */
    Config.GetAzureUrl = function (fileKey, fileType, languageCode) {
        if (fileKey == null || fileKey.length < 1) {
            return "";
        }
        var folderPath = "";
        var fileKeyWithExtension = "";
        var lang = languageCode != null && languageCode.length > 1 ? "" + languageCode.toLowerCase() : "";
        switch (fileType) {
            case "audio":
                folderPath = "audio/" + lang;
                fileKeyWithExtension = fileKey + ".mp3";
                break;
            case "video":
                folderPath = "video/" + lang;
                fileKeyWithExtension = fileKey + ".mp4";
                break;
            case "subtitle":
                folderPath = "subtitles/" + lang;
                fileKeyWithExtension = fileKey + ".vtt";
                break;
            case "static":
                folderPath = "static/" + lang;
                fileKeyWithExtension = fileKey;
                break;
            case "lesson-plan":
                folderPath = "lesson-plans/" + lang;
                fileKeyWithExtension = fileKey;
                break;
            default:
                // JB - Clarification: The following line is fucking magic
                var exhaustiveCheck = fileType;
                break;
        }
        // Remove double '//'s: https://stackoverflow.com/questions/24381480/remove-duplicate-forward-slashes-from-the-url
        return (this.AzureUrl + "/" + folderPath + "/" + fileKeyWithExtension + this.AzureKey)
            .replace(/([^:])(\/\/+)/g, '$1/'); // Remove duplicate slashes
    };
    return Config;
}());
/* harmony default export */ __webpack_exports__["a"] = (Config);


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.722c3fe8.png";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sleb-normal.1c4095dc.png";

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhaserColorWheel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PhaserColorWheel = /** @class */ (function (_super) {
    __extends(PhaserColorWheel, _super);
    function PhaserColorWheel(scene, x, y, width, height) {
        var _this = _super.call(this, scene, x, y) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserColorWheel.prototype);
        _this.initialize(width, height);
        _this.registerEvents();
        return _this;
    }
    PhaserColorWheel.preload = function (scene) {
        // https://cdn.jsdelivr.net/gh/samme/phaser-examples-assets@1.0.0/pics/color-wheel.png
        scene.load.image("colorwheel-background", __webpack_require__(2311));
        // Construct a circle and make it a texture
        var tempGraphic = scene.add.graphics();
        tempGraphic.setDepth(0);
        tempGraphic.lineStyle(1, 0x000000);
        tempGraphic.fillStyle(0xbbbbbb);
        tempGraphic.fillEllipse(8, 8, 16, 16);
        tempGraphic.generateTexture("colorwheel-button-graphic", 16, 16);
        tempGraphic.clear();
        tempGraphic.destroy();
    };
    PhaserColorWheel.prototype.initialize = function (width, height) {
        // Set size to size of background image
        this.setSize(500, 500);
        // Construct Objects
        this.constructObjects();
        // Only after we have set size can we change our scale to fit what was passed in
        this.setDisplaySize(width, height);
        // Add items to self and self to scene
        this.add(this.background);
        this.add(this.pickerImage);
        this.scene.add.existing(this);
    };
    PhaserColorWheel.prototype.constructObjects = function () {
        this.background = this.scene.add.image(0, 0, "colorwheel-background");
        this.background.setSize(this.width, this.height);
        this.background.setDepth(0);
        this.background.setOrigin(0);
        this.pickerImage = this.scene.add.image(this.background.getCenter().x + 132, this.background.getCenter().y + 160, "colorwheel-button-graphic");
        this.pickerImage.setDepth(1);
        var ellipse = new Phaser.Geom.Ellipse(this.background.frame.realWidth / 2, this.background.frame.realHeight / 2, this.background.frame.realWidth, this.background.frame.realHeight);
        this.background.setInteractive({ shape: ellipse, callback: Phaser.Geom.Ellipse.Contains, cursor: "crosshair" });
    };
    PhaserColorWheel.prototype.registerEvents = function () {
        var _this = this;
        this.background.on("pointerdown", function (pointer, x, y) {
            _this.pickerImage.setPosition(x, y);
            var color = _this.scene.textures.getPixel(x, y, "colorwheel-background", null);
            _this.emit("colorChange", color);
        });
    };
    return PhaserColorWheel;
}(Phaser.GameObjects.Container));



/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameState; });
var GameState = /** @class */ (function () {
    function GameState(npc) {
        this.currentNPC = npc;
    }
    return GameState;
}());



/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_ShipPainting_scenes_EndGameScene__ = __webpack_require__(2468);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




// Paintbrush helper class to hold drawing attributes
var PaintBrush = /** @class */ (function () {
    // default color yellow, thickness 5
    function PaintBrush() {
        this.thickness = 12;
        this.color = 0x223e93;
        this.alpha = 1;
    }
    return PaintBrush;
}());
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        // Paintbrush holds draw stroke attributes
        _this.paintBrush = new PaintBrush();
        _this.div = document.createElement('div');
        _this.paintGunCursor = 'url(' + __webpack_require__(936) + '), pointer';
        _this.drawingMode = false;
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image("background", __webpack_require__(2469));
        this.load.image("art-board", __webpack_require__(2470));
        this.load.spritesheet('ship', __webpack_require__(2471), { frameWidth: 990, frameHeight: 550 });
        this.load.spritesheet('button', __webpack_require__(937), { frameWidth: 90, frameHeight: 90 });
        this.load.spritesheet('stickers', __webpack_require__(2472), { frameWidth: 100, frameHeight: 100 });
        __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__["a" /* PhaserColorWheel */].preload(this);
    };
    MainScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.input.setDefaultCursor(this.paintGunCursor);
        this.buildBackgroundContent();
        this.stickers = [];
        this.lineHistory = [];
        this.pastedImages = [];
        this.drawing = false;
        this.drawingMode = true;
        document.body.appendChild(this.div);
        // Register the click events
        this.registerEvents();
    };
    MainScene.prototype.buildBackgroundContent = function () {
        var background = this.add.image(0, 0, "background");
        background.setOrigin(0);
        var artBoard = this.add.image(0, 0, "art-board");
        artBoard.setOrigin(0);
        artBoard.setY(this.gameHeight - artBoard.height);
        this.easelControls = artBoard.getBounds();
        this.ship = this.add.sprite(this.gameWidth / 2, 275, "ship", 0);
        this.ship.setInteractive();
        // Animate the lights on the ship
        this.anims.create({
            key: "shipLights",
            frames: this.anims.generateFrameNumbers("ship", { start: 0, end: 1 }),
            frameRate: 3,
            repeat: -1
        });
        this.ship.anims.play("shipLights");
        this.buildEasel();
        this.buildButton();
        this.createStickers();
        this.buildColorWheel();
    };
    MainScene.prototype.buildEasel = function () {
        var _this = this;
        var json = __webpack_require__(2473);
        var points = json["polygon"];
        var topLeft = this.ship.getTopLeft();
        points.forEach(function (p) {
            p.x += topLeft.x;
            p.y += _this.ship.y - 5;
        });
        this.shipArea = new Phaser.Geom.Polygon(points);
        this.ship.on('pointerdown', function (pointer) {
            _this.pasteImage(pointer);
        });
        this.shipTexture = this.add.renderTexture(0, 0, this.gameWidth, this.gameHeight);
        this.shipTexture.setOrigin(0);
        this.shipTexture.setDepth(0);
        this.shipGraphic = this.add.graphics();
        this.shipGraphic.setDepth(0);
    };
    MainScene.prototype.canPaste = function () {
        // Don't even have a sticker right now
        if (!this.currentImage.visible) {
            return false;
        }
        return this.inShipArea();
    };
    MainScene.prototype.inShipArea = function () {
        var bounds = this.currentImage.getBounds();
        var center = this.currentImage.getCenter();
        bounds.width *= 0.1;
        bounds.height *= 0.1;
        bounds.centerX = center.x;
        bounds.centerY = center.y;
        if (this.shipArea.contains(center.x, center.y)) {
            return true;
        }
        // Check if it contains any of the 4 corners (polygons don't have an intersects method)
        if (this.shipArea.contains(bounds.left, bounds.bottom) ||
            this.shipArea.contains(bounds.right, bounds.bottom) ||
            this.shipArea.contains(bounds.left, bounds.top) ||
            this.shipArea.contains(bounds.right, bounds.top)) {
            return true;
        }
        return false;
    };
    MainScene.prototype.pasteImage = function (pointer) {
        if (this.canPaste()) {
            this.paste = this.add.image(pointer.x, pointer.y, "stickers", this.currentImage.frame.name);
            this.paste.setInteractive();
            this.input.setDraggable(this.paste);
            this.pastedImages.push(this.paste);
        }
    };
    MainScene.prototype.buildButton = function () {
        var _this = this;
        this.finishButton = this.add.sprite(0, 0, "button", 0);
        this.finishButton.setPosition(this.gameWidth - 80, this.gameHeight - this.finishButton.height);
        this.finishButton.setInteractive({ useHandCursor: true });
        this.finishButton.on('pointerover', function () {
            _this.finishButton.setFrame(1);
        });
        this.finishButton.on('pointerout', function () {
            _this.finishButton.setFrame(0);
        });
        this.finishButton.on("pointerdown", function () {
            _this.finishButton.setFrame(1);
            _this.drawingMode = false;
            _this.currentImage.setVisible(false);
            // Screenshot for later
            _this.registry.parent.renderer.snapshot(function (image) {
                image.onload = function () {
                    var croppedImage = __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__["a" /* default */].CropImageToDataURI(image, 0, 0, _this.sys.canvas.width - 300, _this.sys.canvas.height);
                    console.warn("Screenshot!", croppedImage); // JB - Remove this console.warn
                    _this.endGame(croppedImage);
                };
            });
        });
    };
    MainScene.prototype.buildColorWheel = function () {
        var _this = this;
        var colorWheel = new __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__["a" /* PhaserColorWheel */](this, 20, this.gameHeight - 190, 175, 175);
        colorWheel.on("colorChange", function (color) {
            _this.drawingMode = true;
            _this.paintBrush.color = color.color;
            _this.refreshPaintBrush();
            _this.input.setDefaultCursor(_this.paintGunCursor);
            _this.currentImage.setVisible(false);
        });
        colorWheel.setDepth(2);
    };
    MainScene.prototype.createStickers = function () {
        this.currentImage = this.add.image(0, 0, "stickers");
        this.currentImage.setDepth(1);
        this.currentImage.setVisible(false);
        this.stickers = [];
        for (var frame = 0; frame < 15; frame++) {
            this.createSticker(frame);
        }
        var row1 = this.stickers.slice(0, 8);
        var row2 = this.stickers.slice(8);
        Phaser.Actions.GridAlign(row1, {
            x: 300,
            y: this.gameHeight - 150,
            width: 8,
            height: 1,
            cellWidth: 115,
            cellHeight: 100,
            position: Phaser.Display.Align.CENTER,
        });
        Phaser.Actions.GridAlign(row2, {
            x: 375,
            y: this.gameHeight - 50,
            width: 7,
            height: 1,
            cellWidth: 115,
            cellHeight: 100,
            position: Phaser.Display.Align.CENTER,
        });
    };
    MainScene.prototype.createSticker = function (frame) {
        var _this = this;
        var sticker = this.add.image(0, 0, "stickers", frame);
        sticker.setDepth(2);
        sticker.setInteractive();
        sticker.on("pointerdown", function () {
            _this.drawingMode = false;
            _this.drawing = false;
            _this.currentImage.setFrame(sticker.frame.name);
            _this.currentImage.setVisible(true);
            _this.input.setDefaultCursor('none');
        });
        this.stickers.push(sticker);
    };
    MainScene.prototype.refreshPaintBrush = function () {
        this.shipGraphic.lineStyle(this.paintBrush.thickness, this.paintBrush.color, this.paintBrush.alpha);
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.on('pointerdown', this.pointerDown);
        this.input.on('pointerup', this.pointerUp);
        this.input.on('pointermove', this.pointerMove);
        this.input.on('dragstart', function (pointer, gameObject) {
            if (!_this.drawingMode) {
                _this.children.bringToTop(gameObject);
                _this.drawingMode = false;
                gameObject.x = pointer.downX;
                gameObject.y = pointer.downY;
            }
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            if (_this.drawingMode) {
                return;
            }
            gameObject.x = pointer.x;
            gameObject.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, gameObject) {
            // If we're drawing, no need to do anything
            if (_this.drawing || _this.drawingMode) {
                return;
            }
            if (!_this.inShipArea()) {
                gameObject.destroy();
            }
            else {
                _this.children.moveDown(gameObject);
            }
        });
    };
    MainScene.prototype.canDraw = function (pointer) {
        if (this.shipArea.contains(pointer.x, pointer.y)) {
            return true;
        }
        return false;
    };
    MainScene.prototype.pointerDown = function (pointer) {
        if (this.drawingMode && this.canDraw(pointer)) {
            this.drawing = true;
        }
        this.lineHistory = [];
    };
    MainScene.prototype.pointerUp = function (pointer) {
        this.drawing = false;
        // Capture the graphics as a texture
        this.shipGraphic.generateTexture("background-drawn", this.sys.canvas.width, this.sys.canvas.height);
        this.shipGraphic.clear();
        var tempImage = this.add.image(0, 0, "background-drawn");
        this.shipTexture.save();
        this.shipTexture.draw(tempImage.texture, tempImage.frame, 0, 0);
        this.shipTexture.restore();
        tempImage.destroy();
    };
    MainScene.prototype.pointerMove = function (pointer) {
        if (this.drawing && this.canDraw(pointer)) {
            this.shipGraphic.clear();
            this.refreshPaintBrush();
            this.lineHistory.push(new Phaser.Geom.Point(pointer.x, pointer.y));
            // Do the drawing
            this.shipGraphic.strokePoints(this.lineHistory);
        }
        this.currentImage.x = pointer.x;
        this.currentImage.y = pointer.y;
        if (this.drawingMode) {
            this.currentImage.setVisible(false);
            this.input.setDefaultCursor(this.paintGunCursor);
        }
        else {
            this.currentImage.setVisible(true);
            this.input.setDefaultCursor("none");
            if (this.isMovingExistingImage(pointer)) {
                this.currentImage.setVisible(false);
                this.input.setDefaultCursor('-webkit-grabbing');
            }
        }
        if (this.easelControls.contains(this.input.activePointer.x, this.input.activePointer.y)) {
            this.currentImage.setVisible(false);
            this.input.setDefaultCursor('pointer');
        }
    };
    MainScene.prototype.isMovingExistingImage = function (pointer) {
        for (var _i = 0, _a = this.pastedImages; _i < _a.length; _i++) {
            var i = _a[_i];
            if (i.getBounds().contains(pointer.x, pointer.y)) {
                return true;
            }
        }
        return false;
    };
    MainScene.prototype.endGame = function (image) {
        MainScene.CROPPED_IMAGE = image;
        this.input.setDefaultCursor("default");
        this.input.removeAllListeners();
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_3_src_games_ShipPainting_scenes_EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    MainScene.prototype.drawPolygonShipArea = function () {
        // Draw polygon and set it up
        var graphics = this.add.graphics();
        graphics.lineStyle(2, 0x000000);
        graphics.beginPath();
        graphics.moveTo(this.shipArea.points[0].x, this.shipArea.points[0].y);
        for (var i = 1; i < this.shipArea.points.length; i++) {
            graphics.lineTo(this.shipArea.points[i].x, this.shipArea.points[i].y);
        }
        graphics.closePath();
        graphics.strokePath();
    };
    MainScene.CROPPED_IMAGE = null;
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getContextPropsFromState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalizeContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_context__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__localize__ = __webpack_require__(247);






var dispatchInitialize = function dispatchInitialize(dispatch) {
  return function (payload) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__localize__["i" /* initialize */])(payload));
  };
};

var dispatchAddTranslation = function dispatchAddTranslation(dispatch) {
  return function (translation) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__localize__["a" /* addTranslation */])(translation));
  };
};

var dispatchAddTranslationForLanguage = function dispatchAddTranslationForLanguage(dispatch) {
  return function (translation, language) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__localize__["b" /* addTranslationForLanguage */])(translation, language));
  };
};

var dispatchSetActiveLanguage = function dispatchSetActiveLanguage(dispatch) {
  return function (languageCode) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__localize__["k" /* setActiveLanguage */])(languageCode));
  };
};

var getContextPropsFromState = function getContextPropsFromState(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3__localize__["g" /* getTranslate */], __WEBPACK_IMPORTED_MODULE_3__localize__["e" /* getLanguages */], __WEBPACK_IMPORTED_MODULE_3__localize__["d" /* getActiveLanguage */], __WEBPACK_IMPORTED_MODULE_3__localize__["f" /* getOptions */], function (translate, languages, activeLanguage, options) {
    var defaultLanguage = options.defaultLanguage || languages[0] && languages[0].code;
    var renderToStaticMarkup = options.renderToStaticMarkup;
    var ignoreTranslateChildren = options.ignoreTranslateChildren !== undefined ? options.ignoreTranslateChildren : __WEBPACK_IMPORTED_MODULE_3__localize__["c" /* defaultTranslateOptions */].ignoreTranslateChildren;

    return {
      translate: translate,
      languages: languages,
      defaultLanguage: defaultLanguage,
      activeLanguage: activeLanguage,
      initialize: dispatchInitialize(dispatch),
      addTranslation: dispatchAddTranslation(dispatch),
      addTranslationForLanguage: dispatchAddTranslationForLanguage(dispatch),
      setActiveLanguage: dispatchSetActiveLanguage(dispatch),
      renderToStaticMarkup: renderToStaticMarkup,
      ignoreTranslateChildren: ignoreTranslateChildren
    };
  });
};

var defaultLocalizeState = Object(__WEBPACK_IMPORTED_MODULE_3__localize__["j" /* localizeReducer */])(undefined, {});
var defaultContext = getContextPropsFromState(function () {})(defaultLocalizeState);

var LocalizeContext = __WEBPACK_IMPORTED_MODULE_1_create_react_context___default()(defaultContext);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(178);

// const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
// export default createBrowserHistory({ basename: baseUrl });
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_history__["createBrowserHistory"])());


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return strShimFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return strShimObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return strShimUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return strShimPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return strShimHasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return strDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObjClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjAssign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ObjDefineProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ObjHasOwnProperty; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var strShimHasOwnProperty = "hasOwnProperty";
var strDefault = "default";
var ObjClass = Object;
var ObjProto = ObjClass[strShimPrototype];
var ObjAssign = ObjClass["assign"];
var ObjCreate = ObjClass["create"];
var ObjDefineProperty = ObjClass["defineProperty"];
var ObjHasOwnProperty = ObjProto[strShimHasOwnProperty];
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return strShimFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return strShimObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return strShimUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return strShimPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return strShimHasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return strDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObjClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjAssign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ObjDefineProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ObjHasOwnProperty; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var strShimHasOwnProperty = "hasOwnProperty";
var strDefault = "default";
var ObjClass = Object;
var ObjProto = ObjClass[strShimPrototype];
var ObjAssign = ObjClass["assign"];
var ObjCreate = ObjClass["create"];
var ObjDefineProperty = ObjClass["defineProperty"];
var ObjHasOwnProperty = ObjProto[strShimHasOwnProperty];
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProcessTelemetryContext;
/* harmony export (immutable) */ __webpack_exports__["b"] = createProcessTelemetryUnloadContext;
/* harmony export (immutable) */ __webpack_exports__["c"] = createProcessTelemetryUpdateContext;
/* harmony export (immutable) */ __webpack_exports__["d"] = createTelemetryProxyChain;
/* unused harmony export createTelemetryPluginProxy */
/* unused harmony export ProcessTelemetryContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiagnosticLogger__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalConstants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PerfManager__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TelemetryHelpers__ = __webpack_require__(342);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










var strTelemetryPluginChain = "TelemetryPluginChain";
var strHasRunFlags = "_hasRun";
var strGetTelCtx = "_getTelCtx";
var _chainId = 0;
function _getNextProxyStart(proxy, core, startAt) {
    while (proxy) {
        if (proxy[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["n" /* _DYN_GET_PLUGIN */] /* @min:%2egetPlugin */]() === startAt) {
            return proxy;
        }
        proxy = proxy[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["l" /* _DYN_GET_NEXT */] /* @min:%2egetNext */]();
    }
    // This wasn't found in the existing chain so create an isolated one with just this plugin
    return createTelemetryProxyChain([startAt], core[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["e" /* _DYN_CONFIG */] /* @min:%2econfig */] || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param config
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */
function _createInternalContext(telemetryChain, config, core, startAt) {
    // We have a special case where we want to start execution from this specific plugin
    // or we simply reuse the existing telemetry plugin chain (normal execution case)
    var _nextProxy = null; // By Default set as no next plugin
    var _onComplete = [];
    if (startAt !== null) {
        // There is no next element (null) vs not defined (undefined) so use the full chain
        _nextProxy = startAt ? _getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
    }
    var context = {
        _next: _moveNext,
        ctx: {
            core: function () {
                return core;
            },
            diagLog: function () {
                return Object(__WEBPACK_IMPORTED_MODULE_1__DiagnosticLogger__["f" /* safeGetLogger */])(core, config);
            },
            getCfg: function () {
                return config;
            },
            getExtCfg: _getExtCfg,
            getConfig: _getConfig,
            hasNext: function () {
                return !!_nextProxy;
            },
            getNext: function () {
                return _nextProxy;
            },
            setNext: function (nextPlugin) {
                _nextProxy = nextPlugin;
            },
            iterate: _iterateChain,
            onComplete: _addOnComplete
        }
    };
    function _addOnComplete(onComplete, that) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (onComplete) {
            _onComplete[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */]({
                func: onComplete,
                self: !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(that) ? that : context.ctx,
                args: args
            });
        }
    }
    function _moveNext() {
        var nextProxy = _nextProxy;
        // Automatically move to the next plugin
        _nextProxy = nextProxy ? nextProxy[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["l" /* _DYN_GET_NEXT */] /* @min:%2egetNext */]() : null;
        if (!nextProxy) {
            var onComplete = _onComplete;
            if (onComplete && onComplete[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrForEach */])(onComplete, function (completeDetails) {
                    try {
                        completeDetails.func[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](completeDetails.self, completeDetails.args);
                    }
                    catch (e) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__DiagnosticLogger__["d" /* _throwInternal */])(core[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */], 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected Exception during onComplete - " + Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["a" /* dumpObj */])(e));
                    }
                });
                _onComplete = [];
            }
        }
        return nextProxy;
    }
    function _getExtCfg(identifier, defaultValue, mergeDefault) {
        if (defaultValue === void 0) { defaultValue = {}; }
        if (mergeDefault === void 0) { mergeDefault = 0 /* GetExtCfgMergeType.None */; }
        var theConfig;
        if (config) {
            var extConfig = config[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["k" /* STR_EXTENSION_CONFIG */] /* @min:%2eextensionConfig */];
            if (extConfig && identifier) {
                theConfig = extConfig[identifier];
            }
        }
        if (!theConfig) {
            // Just use the defaults
            theConfig = defaultValue;
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["u" /* isObject */])(defaultValue)) {
            if (mergeDefault !== 0 /* GetExtCfgMergeType.None */) {
                // Merge the defaults and configured values
                var newConfig_1 = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["B" /* objExtend */])(true, defaultValue, theConfig);
                if (config && mergeDefault === 2 /* GetExtCfgMergeType.MergeDefaultFromRootOrDefault */) {
                    // Enumerate over the defaultValues and if not already populated attempt to
                    // find a value from the root config
                    Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["C" /* objForEachKey */])(defaultValue, function (field) {
                        // for each unspecified field, set the default value
                        if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(newConfig_1[field])) {
                            var cfgValue = config[field];
                            if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(cfgValue)) {
                                newConfig_1[field] = cfgValue;
                            }
                        }
                    });
                }
                theConfig = newConfig_1;
            }
        }
        return theConfig;
    }
    function _getConfig(identifier, field, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var theValue;
        var extConfig = _getExtCfg(identifier, null);
        if (extConfig && !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(extConfig[field])) {
            theValue = extConfig[field];
        }
        else if (config && !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(config[field])) {
            theValue = config[field];
        }
        return !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? theValue : defaultValue;
    }
    function _iterateChain(cb) {
        // Keep processing until we reach the end of the chain
        var nextPlugin;
        while (!!(nextPlugin = context._next())) {
            var plugin = nextPlugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["n" /* _DYN_GET_PLUGIN */] /* @min:%2egetPlugin */]();
            if (plugin) {
                // callback with the current on
                cb(plugin);
            }
        }
    }
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryContext(telemetryChain, config, core, startAt) {
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(env) {
        var nextPlugin = internalContext._next();
        // Run the next plugin which will call "processNext()"
        nextPlugin && nextPlugin[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["o" /* STR_PROCESS_TELEMETRY */] /* @min:%2eprocessTelemetry */](env, context);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config, core, startAt);
        }
        return createProcessTelemetryContext(plugins || context[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["l" /* _DYN_GET_NEXT */] /* @min:%2egetNext */](), config, core, startAt);
    }
    context[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */] = _processNext;
    context[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["g" /* _DYN_CREATE_NEW */] /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for handling the unloading of the chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUnloadContext(telemetryChain, core, startAt) {
    var config = core[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["e" /* _DYN_CONFIG */] /* @min:%2econfig */] || {};
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(unloadState) {
        var nextPlugin = internalContext._next();
        nextPlugin && nextPlugin.unload(context, unloadState);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config, core, startAt);
        }
        return createProcessTelemetryUnloadContext(plugins || context[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["l" /* _DYN_GET_NEXT */] /* @min:%2egetNext */](), core, startAt);
    }
    context[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */] = _processNext;
    context[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["g" /* _DYN_CREATE_NEW */] /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for updating the configuration
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUpdateContext(telemetryChain, core, startAt) {
    var config = core[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["e" /* _DYN_CONFIG */] /* @min:%2econfig */] || {};
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(updateState) {
        return context.iterate(function (plugin) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["q" /* isFunction */])(plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Z" /* _DYN_UPDATE */] /* @min:%2eupdate */])) {
                plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Z" /* _DYN_UPDATE */] /* @min:%2eupdate */](context, updateState);
            }
        });
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) { plugins = null; }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config, core, startAt);
        }
        return createProcessTelemetryUpdateContext(plugins || context[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["l" /* _DYN_GET_NEXT */] /* @min:%2egetNext */](), core, startAt);
    }
    context[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */] = _processNext;
    context[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["g" /* _DYN_CREATE_NEW */] /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates an execution chain from the array of plugins
 * @param plugins - The array of plugins that will be executed in this order
 * @param defItemCtx - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 */
function createTelemetryProxyChain(plugins, config, core, startAt) {
    var firstProxy = null;
    var add = startAt ? false : true;
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(plugins) && plugins[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy_1 = null;
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrForEach */])(plugins, function (thePlugin) {
            if (!add && startAt === thePlugin) {
                add = true;
            }
            if (add && thePlugin && Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["q" /* isFunction */])(thePlugin[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["o" /* STR_PROCESS_TELEMETRY */] /* @min:%2eprocessTelemetry */])) {
                // Only add plugins that are processors
                var newProxy = createTelemetryPluginProxy(thePlugin, config, core);
                if (!firstProxy) {
                    firstProxy = newProxy;
                }
                if (lastProxy_1) {
                    // Set this new proxy as the next for the previous one
                    lastProxy_1._setNext(newProxy);
                }
                lastProxy_1 = newProxy;
            }
        });
    }
    if (startAt && !firstProxy) {
        // Special case where the "startAt" was not in the original list of plugins
        return createTelemetryProxyChain([startAt], config, core);
    }
    return firstProxy;
}
/**
 * Create the processing telemetry proxy instance, the proxy is used to abstract the current plugin to allow monitoring and
 * execution plugins while passing around the dynamic execution state (IProcessTelemetryContext), the proxy instance no longer
 * contains any execution state and can be reused between requests (this was not the case for 2.7.2 and earlier with the
 * TelemetryPluginChain class).
 * @param plugin - The plugin instance to proxy
 * @param config - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 * @returns
 */
function createTelemetryPluginProxy(plugin, config, core) {
    var nextProxy = null;
    var hasProcessTelemetry = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["q" /* isFunction */])(plugin[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["o" /* STR_PROCESS_TELEMETRY */] /* @min:%2eprocessTelemetry */]);
    var hasSetNext = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["q" /* isFunction */])(plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["M" /* _DYN_SET_NEXT_PLUGIN */] /* @min:%2esetNextPlugin */]);
    var chainId;
    if (plugin) {
        chainId = plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["q" /* _DYN_IDENTIFIER */] /* @min:%2eidentifier */] + "-" + plugin[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["n" /* STR_PRIORITY */] /* @min:%2epriority */] + "-" + _chainId++;
    }
    else {
        chainId = "Unknown-0-" + _chainId++;
    }
    var proxyChain = {
        getPlugin: function () {
            return plugin;
        },
        getNext: function () {
            return nextProxy;
        },
        processTelemetry: _processTelemetry,
        unload: _unloadPlugin,
        update: _updatePlugin,
        _id: chainId,
        _setNext: function (nextPlugin) {
            nextProxy = nextPlugin;
        }
    };
    function _getTelCtx() {
        var itemCtx;
        // Looks like a plugin didn't pass the (optional) context, so create a new one
        if (plugin && Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["q" /* isFunction */])(plugin[strGetTelCtx])) {
            // This plugin extends from the BaseTelemetryPlugin so lets use it
            itemCtx = plugin[strGetTelCtx]();
        }
        if (!itemCtx) {
            // Create a temporary one
            itemCtx = createProcessTelemetryContext(proxyChain, config, core);
        }
        return itemCtx;
    }
    function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
        var hasRun = false;
        var identifier = plugin ? plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["q" /* _DYN_IDENTIFIER */] /* @min:%2eidentifier */] : strTelemetryPluginChain;
        var hasRunContext = itemCtx[strHasRunFlags];
        if (!hasRunContext) {
            // Assign and populate
            hasRunContext = itemCtx[strHasRunFlags] = {};
        }
        // Ensure that we keep the context in sync
        itemCtx.setNext(nextProxy);
        if (plugin) {
            Object(__WEBPACK_IMPORTED_MODULE_5__PerfManager__["b" /* doPerf */])(itemCtx[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */](), function () { return identifier + ":" + name; }, function () {
                // Mark this component as having run
                hasRunContext[chainId] = true;
                try {
                    // Set a flag on the next plugin so we know if it was attempted to be executed
                    var nextId = nextProxy ? nextProxy._id : __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */];
                    if (nextId) {
                        hasRunContext[nextId] = false;
                    }
                    hasRun = processPluginFn(itemCtx);
                }
                catch (error) {
                    var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                    if (hasNextRun) {
                        // The next plugin after us has already run so set this one as complete
                        hasRun = true;
                    }
                    if (!nextProxy || !hasNextRun) {
                        // Either we have no next plugin or the current one did not attempt to call the next plugin
                        // Which means the current one is the root of the failure so log/report this failure
                        Object(__WEBPACK_IMPORTED_MODULE_1__DiagnosticLogger__["d" /* _throwInternal */])(itemCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["h" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 73 /* _eInternalMessageId.PluginException */, "Plugin [" + identifier + "] failed during " + name + " - " + Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["a" /* dumpObj */])(error) + ", run flags: " + Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["a" /* dumpObj */])(hasRunContext));
                    }
                }
            }, details, isAsync);
        }
        return hasRun;
    }
    function _processTelemetry(env, itemCtx) {
        itemCtx = itemCtx || _getTelCtx();
        function _callProcessTelemetry(itemCtx) {
            if (!plugin || !hasProcessTelemetry) {
                return false;
            }
            var pluginState = Object(__WEBPACK_IMPORTED_MODULE_6__TelemetryHelpers__["a" /* _getPluginState */])(plugin);
            if (pluginState[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["T" /* _DYN_TEARDOWN */] /* @min:%2eteardown */] || pluginState[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["d" /* STR_DISABLED */]]) {
                return false;
            }
            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
            // doesn't calls processTelemetry() instead of itemContext.processNext() or some
            // other form of error occurred
            if (hasSetNext) {
                // Backward compatibility setting the next plugin on the instance
                plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["M" /* _DYN_SET_NEXT_PLUGIN */] /* @min:%2esetNextPlugin */](nextProxy);
            }
            plugin[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["o" /* STR_PROCESS_TELEMETRY */] /* @min:%2eprocessTelemetry */](env, itemCtx);
            // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
            return true;
        }
        if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function () { return ({ item: env }); }, !(env.sync))) {
            // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
            // so we still want the next plugin to be executed.
            itemCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](env);
        }
    }
    function _unloadPlugin(unloadCtx, unloadState) {
        function _callTeardown() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = Object(__WEBPACK_IMPORTED_MODULE_6__TelemetryHelpers__["a" /* _getPluginState */])(plugin);
                var pluginCore = plugin[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["b" /* STR_CORE */]] || pluginState[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */];
                // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["T" /* _DYN_TEARDOWN */] /* @min:%2eteardown */]) {
                    // Handle plugins that don't extend from the BaseTelemetryPlugin
                    pluginState[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */] = null;
                    pluginState[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["T" /* _DYN_TEARDOWN */] /* @min:%2eteardown */] = true;
                    pluginState[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["w" /* _DYN_IS_INITIALIZED */] /* @min:%2eisInitialized */] = false;
                    if (plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["T" /* _DYN_TEARDOWN */] /* @min:%2eteardown */] && plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["T" /* _DYN_TEARDOWN */] /* @min:%2eteardown */](unloadCtx, unloadState) === true) {
                        // plugin told us that it was going to (or has) call unloadCtx.processNext()
                        hasRun = true;
                    }
                }
            }
            return hasRun;
        }
        if (!_processChain(unloadCtx, _callTeardown, "unload", function () { }, unloadState[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["u" /* _DYN_IS_ASYNC */] /* @min:%2eisAsync */])) {
            // Only called if we hasRun was not true
            unloadCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](unloadState);
        }
    }
    function _updatePlugin(updateCtx, updateState) {
        function _callUpdate() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = Object(__WEBPACK_IMPORTED_MODULE_6__TelemetryHelpers__["a" /* _getPluginState */])(plugin);
                var pluginCore = plugin[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["b" /* STR_CORE */]] || pluginState[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */];
                // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["T" /* _DYN_TEARDOWN */] /* @min:%2eteardown */]) {
                    if (plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Z" /* _DYN_UPDATE */] /* @min:%2eupdate */] && plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Z" /* _DYN_UPDATE */] /* @min:%2eupdate */](updateCtx, updateState) === true) {
                        // plugin told us that it was going to (or has) call unloadCtx.processNext()
                        hasRun = true;
                    }
                }
            }
            return hasRun;
        }
        if (!_processChain(updateCtx, _callUpdate, "update", function () { }, false)) {
            // Only called if we hasRun was not true
            updateCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](updateState);
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["D" /* objFreeze */])(proxyChain);
}
/**
 * This class will be removed!
 * @deprecated use createProcessTelemetryContext() instead
 */
var ProcessTelemetryContext = /** @class */ (function () {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */
    function ProcessTelemetryContext(pluginChain, config, core, startAt) {
        var _self = this;
        var context = createProcessTelemetryContext(pluginChain, config, core, startAt);
        // Proxy all functions of the context to this object
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["I" /* proxyFunctions */])(_self, context, Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["E" /* objKeys */])(context));
    }
    return ProcessTelemetryContext;
}());

//# sourceMappingURL=ProcessTelemetryContext.js.map

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PerfEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PerfManager; });
/* harmony export (immutable) */ __webpack_exports__["b"] = doPerf;
/* unused harmony export setGblPerfMgr */
/* harmony export (immutable) */ __webpack_exports__["c"] = getGblPerfMgr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalConstants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var strExecutionContextKey = "ctx";
var strParentContextKey = "ParentContextKey";
var strChildrenContextKey = "ChildrenContextKey";
var _defaultPerfManager = null;
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        var accessorDefined = false;
        _self.start = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["g" /* dateNow */])();
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["D" /* _DYN_NAME */] /* @min:%2ename */] = name;
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["u" /* _DYN_IS_ASYNC */] /* @min:%2eisAsync */] = isAsync;
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["v" /* _DYN_IS_CHILD_EVT */] /* @min:%2eisChildEvt */] = function () { return false; };
        if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            accessorDefined = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["A" /* objDefineAccessors */])(_self, "payload", function () {
                // Delay the execution of the payloadDetails until needed
                if (!theDetails_1 && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(payloadDetails)) {
                    theDetails_1 = payloadDetails();
                    // clear it out now so the referenced objects can be garbage collected
                    payloadDetails = null;
                }
                return theDetails_1;
            });
        }
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["k" /* _DYN_GET_CTX */] /* @min:%2egetCtx */] = function (key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[strParentContextKey] || key === PerfEvent[strChildrenContextKey]) {
                    return _self[key];
                }
                return (_self[strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["K" /* _DYN_SET_CTX */] /* @min:%2esetCtx */] = function (key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[strParentContextKey]) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) {
                        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["v" /* _DYN_IS_CHILD_EVT */] /* @min:%2eisChildEvt */] = function () { return true; };
                    }
                    _self[key] = value;
                }
                else if (key === PerfEvent[strChildrenContextKey]) {
                    _self[key] = value;
                }
                else {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["d" /* _DYN_COMPLETE */] /* @min:%2ecomplete */] = function () {
            var childTime = 0;
            var childEvts = _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["k" /* _DYN_GET_CTX */] /* @min:%2egetCtx */](PerfEvent[strChildrenContextKey]);
            if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["m" /* isArray */])(childEvts)) {
                for (var lp = 0; lp < childEvts[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */]; lp++) {
                    var childEvt = childEvts[lp];
                    if (childEvt) {
                        childTime += childEvt[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["U" /* _DYN_TIME */] /* @min:%2etime */];
                    }
                }
            }
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["U" /* _DYN_TIME */] /* @min:%2etime */] = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["g" /* dateNow */])() - _self.start;
            _self.exTime = _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["U" /* _DYN_TIME */] /* @min:%2etime */] - childTime;
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["d" /* _DYN_COMPLETE */] /* @min:%2ecomplete */] = function () { };
            if (!accessorDefined && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(payloadDetails)) {
                // If we couldn't define the property set during complete -- to minimize the perf impact until after the time
                _self.payload = payloadDetails();
            }
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}());

var PerfManager = /** @class */ (function () {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */
        this.ctx = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(PerfManager, this, function (_self) {
            _self.create = function (src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new PerfEvent(src, payloadDetails, isAsync);
            };
            _self.fire = function (perfEvent) {
                if (perfEvent) {
                    perfEvent[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["d" /* _DYN_COMPLETE */] /* @min:%2ecomplete */]();
                    if (manager && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(manager[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["m" /* STR_PERF_EVENT */] /* @min:%2eperfEvent */])) {
                        manager[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["m" /* STR_PERF_EVENT */] /* @min:%2eperfEvent */](perfEvent);
                    }
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["K" /* _DYN_SET_CTX */] /* @min:%2esetCtx */] = function (key, value) {
                if (key) {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["k" /* _DYN_GET_CTX */] /* @min:%2egetCtx */] = function (key) {
                return (_self[strExecutionContextKey] || {})[key];
            };
        });
    }
// Removed Stub for PerfManager.prototype.create.
// Removed Stub for PerfManager.prototype.fire.
// Removed Stub for PerfManager.prototype.setCtx.
// Removed Stub for PerfManager.prototype.getCtx.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PerfManager.__ieDyn=1;

    return PerfManager;
}());

var doPerfActiveKey = "CoreUtils.doPerf";
/**
 * Helper function to wrap a function with a perf event
 * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
 * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
 * @param func - The function to call and measure
 * @param details - A function to return the payload details
 * @param isAsync - Is the event / function being call asynchronously or synchronously
 */
function doPerf(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["l" /* STR_GET_PERF_MGR */]]) {
            // Looks like a perf manager provider object
            perfMgr = perfMgr[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["l" /* STR_GET_PERF_MGR */]]();
        }
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["k" /* _DYN_GET_CTX */] /* @min:%2egetCtx */](doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["K" /* _DYN_SET_CTX */] /* @min:%2esetCtx */]) {
                        perfEvt[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["K" /* _DYN_SET_CTX */] /* @min:%2esetCtx */](PerfEvent[strParentContextKey], currentActive);
                        if (currentActive[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["k" /* _DYN_GET_CTX */] /* @min:%2egetCtx */] && currentActive[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["K" /* _DYN_SET_CTX */] /* @min:%2esetCtx */]) {
                            var children = currentActive[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["k" /* _DYN_GET_CTX */] /* @min:%2egetCtx */](PerfEvent[strChildrenContextKey]);
                            if (!children) {
                                children = [];
                                currentActive[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["K" /* _DYN_SET_CTX */] /* @min:%2esetCtx */](PerfEvent[strChildrenContextKey], children);
                            }
                            children[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["K" /* _DYN_SET_CTX */] /* @min:%2esetCtx */](doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            }
            catch (ex) {
                if (perfEvt && perfEvt[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["K" /* _DYN_SET_CTX */] /* @min:%2esetCtx */]) {
                    perfEvt[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["K" /* _DYN_SET_CTX */] /* @min:%2esetCtx */]("exception", ex);
                }
            }
            finally {
                // fire the perf event
                if (perfEvt) {
                    perfMgr.fire(perfEvt);
                }
                // Reset the active event to the previous value
                perfMgr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["K" /* _DYN_SET_CTX */] /* @min:%2esetCtx */](doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
/**
 * Set the global performance manager to use when there is no core instance or it has not been initialized yet.
 * @param perfManager - The IPerfManager instance to use when no performance manager is supplied.
 */
function setGblPerfMgr(perfManager) {
    _defaultPerfManager = perfManager;
}
/**
 * Get the current global performance manager that will be used with no performance manager is supplied.
 * @returns - The current default manager
 */
function getGblPerfMgr() {
    return _defaultPerfManager;
}
//# sourceMappingURL=PerfManager.js.map

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPluginState;
/* harmony export (immutable) */ __webpack_exports__["c"] = initializePlugins;
/* harmony export (immutable) */ __webpack_exports__["d"] = sortPlugins;
/* unused harmony export unloadComponents */
/* harmony export (immutable) */ __webpack_exports__["b"] = createDistributedTraceContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataCacheHelper__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalConstants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__W3cTraceParent__ = __webpack_require__(763);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var pluginStateData = Object(__WEBPACK_IMPORTED_MODULE_1__DataCacheHelper__["a" /* createElmNodeData */])("plugin");
function _getPluginState(plugin) {
    return pluginStateData.get(plugin, "state", {}, true);
}
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config The current config for the instance
 * @param core THe current core instance
 * @param extensions The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["l" /* _DYN_GET_NEXT */] /* @min:%2egetNext */]();
    var pluginState;
    while (proxy) {
        var thePlugin = proxy[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["n" /* _DYN_GET_PLUGIN */] /* @min:%2egetPlugin */]();
        if (thePlugin) {
            if (lastPlugin &&
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(lastPlugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["M" /* _DYN_SET_NEXT_PLUGIN */] /* @min:%2esetNextPlugin */]) &&
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(thePlugin[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["o" /* STR_PROCESS_TELEMETRY */] /* @min:%2eprocessTelemetry */])) {
                // Set this plugin as the next for the previous one
                lastPlugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["M" /* _DYN_SET_NEXT_PLUGIN */] /* @min:%2esetNextPlugin */](thePlugin);
            }
            var isInitialized = false;
            if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(thePlugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["w" /* _DYN_IS_INITIALIZED */] /* @min:%2eisInitialized */])) {
                isInitialized = thePlugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["w" /* _DYN_IS_INITIALIZED */] /* @min:%2eisInitialized */]();
            }
            else {
                pluginState = _getPluginState(thePlugin);
                isInitialized = pluginState[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["w" /* _DYN_IS_INITIALIZED */] /* @min:%2eisInitialized */];
            }
            if (!isInitialized) {
                initPlugins[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["l" /* _DYN_GET_NEXT */] /* @min:%2egetNext */]();
        }
    }
    // Now initialize the plugins
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["b" /* arrForEach */])(initPlugins, function (thePlugin) {
        var core = processContext[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */]]();
        thePlugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["s" /* _DYN_INITIALIZE */] /* @min:%2einitialize */](processContext.getCfg(), core, extensions, processContext[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["l" /* _DYN_GET_NEXT */] /* @min:%2egetNext */]());
        pluginState = _getPluginState(thePlugin);
        // Only add the core to the state if the plugin didn't set it (doesn't extent from BaseTelemetryPlugin)
        if (!thePlugin[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */]] && !pluginState[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */]]) {
            pluginState[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */]] = core;
        }
        pluginState[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["w" /* _DYN_IS_INITIALIZED */] /* @min:%2eisInitialized */] = true;
        delete pluginState[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["T" /* _DYN_TEARDOWN */] /* @min:%2eteardown */];
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        if (extB) {
            var bHasProcess = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(extB[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["o" /* STR_PROCESS_TELEMETRY */]]);
            if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(extA[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["o" /* STR_PROCESS_TELEMETRY */]])) {
                result = bHasProcess ? extA[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["n" /* STR_PRIORITY */]] - extB[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["n" /* STR_PRIORITY */]] : 1;
            }
            else if (bHasProcess) {
                result = -1;
            }
        }
        else {
            result = extA ? 1 : -1;
        }
        return result;
    });
    // sort complete
}
/**
 * Teardown / Unload helper to perform teardown/unloading operations for the provided components synchronously or asynchronously, this will call any
 * _doTeardown() or _doUnload() functions on the provided components to allow them to finish removal.
 * @param components - The components you want to unload
 * @param unloadCtx - This is the context that should be used during unloading.
 * @param unloadState - The details / state of the unload process, it holds details like whether it should be unloaded synchronously or asynchronously and the reason for the unload.
 * @param asyncCallback - An optional callback that the plugin must call if it returns true to inform the caller that it has completed any async unload/teardown operations.
 * @returns boolean - true if the plugin has or will call asyncCallback, this allows the plugin to perform any asynchronous operations.
 */
function unloadComponents(components, unloadCtx, unloadState, asyncCallback) {
    var idx = 0;
    function _doUnload() {
        while (idx < components[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */]) {
            var component = components[idx++];
            if (component) {
                var func = component._doUnload || component[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["_2" /* _DYN__DO_TEARDOWN */] /* @min:%2e_doTeardown */];
                if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(func)) {
                    if (func[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["c" /* _DYN_CALL */] /* @min:%2ecall */](component, unloadCtx, unloadState, _doUnload) === true) {
                        return true;
                    }
                }
            }
        }
    }
    return _doUnload();
}
/**
 * Creates a IDistributedTraceContext which optionally also "sets" the value on a parent
 * @param parentCtx - An optional parent distributed trace instance
 * @returns A new IDistributedTraceContext instance that uses an internal temporary object
 */
function createDistributedTraceContext(parentCtx) {
    var trace = {};
    return {
        getName: function () {
            return trace[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["D" /* _DYN_NAME */] /* @min:%2ename */];
        },
        setName: function (newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["D" /* _DYN_NAME */] /* @min:%2ename */] = newValue;
        },
        getTraceId: function () {
            return trace[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["X" /* _DYN_TRACE_ID */] /* @min:%2etraceId */];
        },
        setTraceId: function (newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if (Object(__WEBPACK_IMPORTED_MODULE_4__W3cTraceParent__["d" /* isValidTraceId */])(newValue)) {
                trace[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["X" /* _DYN_TRACE_ID */] /* @min:%2etraceId */] = newValue;
            }
        },
        getSpanId: function () {
            return trace[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["N" /* _DYN_SPAN_ID */] /* @min:%2espanId */];
        },
        setSpanId: function (newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if (Object(__WEBPACK_IMPORTED_MODULE_4__W3cTraceParent__["c" /* isValidSpanId */])(newValue)) {
                trace[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["N" /* _DYN_SPAN_ID */] /* @min:%2espanId */] = newValue;
            }
        },
        getTraceFlags: function () {
            return trace[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["W" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */];
        },
        setTraceFlags: function (newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["W" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */] = newTraceFlags;
        }
    };
}
//# sourceMappingURL=TelemetryHelpers.js.map

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createUniqueNamespace;
/* harmony export (immutable) */ __webpack_exports__["a"] = createElmNodeData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalConstants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RandomHelper__ = __webpack_require__(484);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var _objDefineProperty = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["c" /* ObjDefineProperty */];
var version = '2.8.18';
var instanceName = "." + Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* newId */])(6);
var _dataUid = 0;
function _createAccessor(target, prop, value) {
    if (_objDefineProperty) {
        try {
            _objDefineProperty(target, prop, {
                value: value,
                enumerable: false,
                configurable: true
            });
            return true;
        }
        catch (e) {
            // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
            // We will just ignore this here.
        }
    }
    return false;
}
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function _canAcceptData(target) {
    return target[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["E" /* _DYN_NODE_TYPE */] /* @min:%2enodeType */] === 1 || target[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["E" /* _DYN_NODE_TYPE */] /* @min:%2enodeType */] === 9 || !(+target[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["E" /* _DYN_NODE_TYPE */] /* @min:%2enodeType */]);
}
function _getCache(data, target) {
    var theCache = target[data.id];
    if (!theCache) {
        theCache = {};
        try {
            if (_canAcceptData(target)) {
                if (!_createAccessor(target, data.id, theCache)) {
                    // Environment doesn't support accessor, so just use direct assignment
                    target[data.id] = theCache;
                }
            }
        }
        catch (e) {
            // Not all environments allow extending all objects, so just ignore the cache in those cases
        }
    }
    return theCache;
}
function createUniqueNamespace(name, includeVersion) {
    if (includeVersion === void 0) { includeVersion = false; }
    return Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["z" /* normalizeJsName */])(name + (_dataUid++) + (includeVersion ? "." + version : __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */]) + instanceName);
}
function createElmNodeData(name) {
    var data = {
        id: createUniqueNamespace("_aiData-" + (name || __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */]) + "." + version),
        accept: function (target) {
            return _canAcceptData(target);
        },
        get: function (target, name, defValue, addDefault) {
            var theCache = target[data.id];
            if (!theCache) {
                if (addDefault) {
                    // Side effect is adds the cache
                    theCache = _getCache(data, target);
                    theCache[Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["z" /* normalizeJsName */])(name)] = defValue;
                }
                return defValue;
            }
            return theCache[Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["z" /* normalizeJsName */])(name)];
        },
        kill: function (target, name) {
            if (target && target[name]) {
                try {
                    delete target[name];
                }
                catch (e) {
                    // Just cleaning up, so if this fails -- ignore
                }
            }
        }
    };
    return data;
}
//# sourceMappingURL=DataCacheHelper.js.map

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = stringToBoolOrDefault;
/* harmony export (immutable) */ __webpack_exports__["c"] = msToTimeSpan;
/* harmony export (immutable) */ __webpack_exports__["a"] = getExtensionByName;
/* harmony export (immutable) */ __webpack_exports__["b"] = isCrossOriginError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(88);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var strEmpty = "";
function stringToBoolOrDefault(str, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (str === undefined || str === null) {
        return defaultValue;
    }
    return str.toString()[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["N" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]() === "true";
}
/**
 * Convert ms to c# time span format
 */
function msToTimeSpan(totalms) {
    if (isNaN(totalms) || totalms < 0) {
        totalms = 0;
    }
    totalms = Math.round(totalms);
    var ms = strEmpty + totalms % 1000;
    var sec = strEmpty + Math.floor(totalms / 1000) % 60;
    var min = strEmpty + Math.floor(totalms / (1000 * 60)) % 60;
    var hour = strEmpty + Math.floor(totalms / (1000 * 60 * 60)) % 24;
    var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
    ms = ms[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] === 1 ? "00" + ms : ms[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] === 2 ? "0" + ms : ms;
    sec = sec[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] < 2 ? "0" + sec : sec;
    min = min[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] < 2 ? "0" + min : min;
    hour = hour[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function getExtensionByName(extensions, identifier) {
    var extension = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(extensions, function (value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
    return !error && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_13" /* isString */])(message) && (message === "Script error." || message === "Script error");
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return strShimFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return strShimObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return strShimUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return strShimPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return strShimHasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return strDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObjClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjAssign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ObjDefineProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ObjHasOwnProperty; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var strShimHasOwnProperty = "hasOwnProperty";
var strDefault = "default";
var ObjClass = Object;
var ObjProto = ObjClass[strShimPrototype];
var ObjAssign = ObjClass["assign"];
var ObjCreate = ObjClass["create"];
var ObjDefineProperty = ObjClass["defineProperty"];
var ObjHasOwnProperty = ObjProto[strShimHasOwnProperty];
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return _DYN_TO_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _DYN_DISABLE_EXCEPTION_TR0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _DYN_AUTO_TRACK_PAGE_VISI1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return _DYN_OVERRIDE_PAGE_VIEW_D2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _DYN_ENABLE_UNHANDLED_PRO3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return _DYN_SAMPLING_PERCENTAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return _DYN_IS_STORAGE_USE_DISAB4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return _DYN_IS_BROWSER_LINK_TRAC5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _DYN_ENABLE_AUTO_ROUTE_TR6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return _DYN_NAME_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _DYN_DISABLE_FLUSH_ON_BEF7; });
/* unused harmony export _DYN_DISABLE_FLUSH_ON_UNL8 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _DYN_CORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _DYN_DATA_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return _DYN_ENVELOPE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _DYN_DIAG_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return _DYN_TRACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return _DYN_TRACK_PAGE_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return _DYN_TRACK_PREVIOUS_PAGE_9; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return _DYN_SEND_PAGE_VIEW_INTER10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return _DYN_SEND_PAGE_VIEW_PERFO11; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return _DYN_POPULATE_PAGE_VIEW_P12; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return _DYN_HREF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return _DYN_SEND_EXCEPTION_INTER13; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return _DYN_EXCEPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _DYN_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return _DYN__ONERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _DYN_ERROR_SRC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return _DYN_LINE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _DYN_COLUMN_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return _DYN_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return _DYN__CREATE_AUTO_EXCEPTI14; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _DYN_ADD_TELEMETRY_INITIA15; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _DYN_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return _DYN_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return _DYN_IS_PERFORMANCE_TIMIN16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _DYN_GET_PERFORMANCE_TIMI17; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return _DYN_NAVIGATION_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return _DYN_SHOULD_COLLECT_DURAT18; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return _DYN_IS_PERFORMANCE_TIMIN19; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _DYN_GET_ENTRIES_BY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return _DYN_RESPONSE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return _DYN_REQUEST_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return _DYN_LOAD_EVENT_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return _DYN_RESPONSE_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _DYN_CONNECT_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return _DYN_PAGE_VISIT_START_TIM20; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TO_STRING = "toString"; // Count: 4
var _DYN_DISABLE_EXCEPTION_TR0 = "disableExceptionTracking"; // Count: 3
var _DYN_AUTO_TRACK_PAGE_VISI1 = "autoTrackPageVisitTime"; // Count: 4
var _DYN_OVERRIDE_PAGE_VIEW_D2 = "overridePageViewDuration"; // Count: 3
var _DYN_ENABLE_UNHANDLED_PRO3 = "enableUnhandledPromiseRejectionTracking"; // Count: 3
var _DYN_SAMPLING_PERCENTAGE = "samplingPercentage"; // Count: 4
var _DYN_IS_STORAGE_USE_DISAB4 = "isStorageUseDisabled"; // Count: 4
var _DYN_IS_BROWSER_LINK_TRAC5 = "isBrowserLinkTrackingEnabled"; // Count: 4
var _DYN_ENABLE_AUTO_ROUTE_TR6 = "enableAutoRouteTracking"; // Count: 3
var _DYN_NAME_PREFIX = "namePrefix"; // Count: 3
var _DYN_DISABLE_FLUSH_ON_BEF7 = "disableFlushOnBeforeUnload"; // Count: 3
var _DYN_DISABLE_FLUSH_ON_UNL8 = "disableFlushOnUnload"; // Count: 2
var _DYN_CORE = "core"; // Count: 7
var _DYN_DATA_TYPE = "dataType"; // Count: 8
var _DYN_ENVELOPE_TYPE = "envelopeType"; // Count: 7
var _DYN_DIAG_LOG = "diagLog"; // Count: 13
var _DYN_TRACK = "track"; // Count: 7
var _DYN_TRACK_PAGE_VIEW = "trackPageView"; // Count: 4
var _DYN_TRACK_PREVIOUS_PAGE_9 = "trackPreviousPageVisit"; // Count: 3
var _DYN_SEND_PAGE_VIEW_INTER10 = "sendPageViewInternal"; // Count: 7
var _DYN_SEND_PAGE_VIEW_PERFO11 = "sendPageViewPerformanceInternal"; // Count: 3
var _DYN_POPULATE_PAGE_VIEW_P12 = "populatePageViewPerformanceEvent"; // Count: 3
var _DYN_HREF = "href"; // Count: 6
var _DYN_SEND_EXCEPTION_INTER13 = "sendExceptionInternal"; // Count: 2
var _DYN_EXCEPTION = "exception"; // Count: 3
var _DYN_ERROR = "error"; // Count: 5
var _DYN__ONERROR = "_onerror"; // Count: 3
var _DYN_ERROR_SRC = "errorSrc"; // Count: 3
var _DYN_LINE_NUMBER = "lineNumber"; // Count: 5
var _DYN_COLUMN_NUMBER = "columnNumber"; // Count: 5
var _DYN_MESSAGE = "message"; // Count: 4
var _DYN__CREATE_AUTO_EXCEPTI14 = "CreateAutoException"; // Count: 3
var _DYN_ADD_TELEMETRY_INITIA15 = "addTelemetryInitializer"; // Count: 4
var _DYN_DURATION = "duration"; // Count: 10
var _DYN_LENGTH = "length"; // Count: 5
var _DYN_IS_PERFORMANCE_TIMIN16 = "isPerformanceTimingSupported"; // Count: 2
var _DYN_GET_PERFORMANCE_TIMI17 = "getPerformanceTiming"; // Count: 2
var _DYN_NAVIGATION_START = "navigationStart"; // Count: 4
var _DYN_SHOULD_COLLECT_DURAT18 = "shouldCollectDuration"; // Count: 3
var _DYN_IS_PERFORMANCE_TIMIN19 = "isPerformanceTimingDataReady"; // Count: 2
var _DYN_GET_ENTRIES_BY_TYPE = "getEntriesByType"; // Count: 3
var _DYN_RESPONSE_START = "responseStart"; // Count: 5
var _DYN_REQUEST_START = "requestStart"; // Count: 3
var _DYN_LOAD_EVENT_END = "loadEventEnd"; // Count: 4
var _DYN_RESPONSE_END = "responseEnd"; // Count: 5
var _DYN_CONNECT_END = "connectEnd"; // Count: 4
var _DYN_PAGE_VISIT_START_TIM20 = "pageVisitStartTime"; // Count: 2
//# sourceMappingURL=__DynamicConstants.js.map

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return strShimFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return strShimObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return strShimUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return strShimPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return strShimHasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return strDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObjClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjAssign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ObjDefineProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ObjHasOwnProperty; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var strShimHasOwnProperty = "hasOwnProperty";
var strDefault = "default";
var ObjClass = Object;
var ObjProto = ObjClass[strShimPrototype];
var ObjAssign = ObjClass["assign"];
var ObjCreate = ObjClass["create"];
var ObjDefineProperty = ObjClass["defineProperty"];
var ObjHasOwnProperty = ObjProto[strShimHasOwnProperty];
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return strShimFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return strShimObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return strShimUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return strShimPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return strShimHasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return strDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObjClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjAssign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ObjDefineProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ObjHasOwnProperty; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var strShimHasOwnProperty = "hasOwnProperty";
var strDefault = "default";
var ObjClass = Object;
var ObjProto = ObjClass[strShimPrototype];
var ObjAssign = ObjClass["assign"];
var ObjCreate = ObjClass["create"];
var ObjDefineProperty = ObjClass["defineProperty"];
var ObjHasOwnProperty = ObjProto[strShimHasOwnProperty];
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return strShimFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return strShimObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return strShimUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return strShimPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return strShimHasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return strDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObjClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjAssign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ObjDefineProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ObjHasOwnProperty; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var strShimHasOwnProperty = "hasOwnProperty";
var strDefault = "default";
var ObjClass = Object;
var ObjProto = ObjClass[strShimPrototype];
var ObjAssign = ObjClass["assign"];
var ObjCreate = ObjClass["create"];
var ObjDefineProperty = ObjClass["defineProperty"];
var ObjHasOwnProperty = ObjProto[strShimHasOwnProperty];
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = performDraw;
/* harmony export (immutable) */ __webpack_exports__["d"] = round;
/* harmony export (immutable) */ __webpack_exports__["b"] = isPercentage;
/* harmony export (immutable) */ __webpack_exports__["a"] = isNumber;
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=numberUtils.js.map

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = shallowClone;
/* harmony export (immutable) */ __webpack_exports__["c"] = objectHasValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = isEmptyObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapValues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills__ = __webpack_require__(93);

function shallowClone(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__polyfills__["b" /* assign */])({}, object);
}
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
//# sourceMappingURL=objectUtils.js.map

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobalObject;
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
//# sourceMappingURL=getGlobalObject.js.map

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteCookie;
/* harmony export (immutable) */ __webpack_exports__["a"] = areCookiesAuthorized;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCurrentSite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_display__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_utils_stringUtils__ = __webpack_require__(219);



function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
function getCookie(name) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_stringUtils__["a" /* findCommaSeparatedValue */])(document.cookie, name);
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat(Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_stringUtils__["b" /* generateUUID */])());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, __WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["b" /* ONE_MINUTE */], options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        __WEBPACK_IMPORTED_MODULE_0__tools_display__["b" /* display */].error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat(Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_stringUtils__["b" /* generateUUID */])());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, __WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["c" /* ONE_SECOND */], { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SESSION_STORE_KEY; });
var SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isSessionInExpiredState;
/* harmony export (immutable) */ __webpack_exports__["a"] = expandSessionState;
/* harmony export (immutable) */ __webpack_exports__["d"] = toSessionString;
/* harmony export (immutable) */ __webpack_exports__["c"] = toSessionState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_utils_objectUtils__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_utils_polyfills__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sessionConstants__ = __webpack_require__(273);




var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
function isSessionInExpiredState(session) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_objectUtils__["a" /* isEmptyObject */])(session);
}
function expandSessionState(session) {
    session.expire = String(Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__["h" /* dateNow */])() + __WEBPACK_IMPORTED_MODULE_3__sessionConstants__["a" /* SESSION_EXPIRATION_DELAY */]);
}
function toSessionString(session) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_polyfills__["j" /* objectEntries */])(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
function toSessionState(sessionString) {
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function isValidSessionString(sessionString) {
    return (!!sessionString &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
//# sourceMappingURL=sessionState.js.map

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizeUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = isValidUrl;
/* unused harmony export haveSameOrigin */
/* harmony export (immutable) */ __webpack_exports__["b"] = getOrigin;
/* harmony export (immutable) */ __webpack_exports__["c"] = getPathName;
/* unused harmony export getSearch */
/* unused harmony export getHash */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildUrl;
/* unused harmony export getLocationOrigin */
/* unused harmony export getLinkElementOrigin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__serialisation_jsonStringify__ = __webpack_require__(186);

function normalizeUrl(url) {
    return buildUrl(url, getLocationOrigin()).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function haveSameOrigin(url1, url2) {
    return getOrigin(url1) === getOrigin(url2);
}
function getOrigin(url) {
    return getLinkElementOrigin(buildUrl(url));
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function getSearch(url) {
    return buildUrl(url).search;
}
function getHash(url) {
    return buildUrl(url).hash;
}
function buildUrl(url, base) {
    var supportedURL = getSupportedUrl();
    if (supportedURL) {
        try {
            return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
        }
        catch (error) {
            throw new Error("Failed to construct URL: ".concat(String(error), " ").concat(Object(__WEBPACK_IMPORTED_MODULE_0__serialisation_jsonStringify__["b" /* jsonStringify */])({ url: url, base: base })));
        }
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var originalURL = URL;
var isURLSupported;
function getSupportedUrl() {
    if (isURLSupported === undefined) {
        try {
            var url = new originalURL('http://test/path');
            isURLSupported = url.href === 'http://test/path';
        }
        catch (_a) {
            isURLSupported = false;
        }
    }
    return isURLSupported ? originalURL : undefined;
}
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
/**
 * IE fallback
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 */
function getLinkElementOrigin(element) {
    if (element.origin) {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
//# sourceMappingURL=urlPolyfill.js.map

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = instrumentMethod;
/* harmony export (immutable) */ __webpack_exports__["b"] = instrumentMethodAndCallOriginal;
/* harmony export (immutable) */ __webpack_exports__["c"] = instrumentSetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_functionUtils__ = __webpack_require__(185);



function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        if (typeof instrumentation !== 'function') {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                Object(__WEBPACK_IMPORTED_MODULE_1__monitor__["a" /* callMonitored */])(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                Object(__WEBPACK_IMPORTED_MODULE_1__monitor__["a" /* callMonitored */])(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}
function instrumentSetter(object, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: __WEBPACK_IMPORTED_MODULE_2__utils_functionUtils__["a" /* noop */] };
    }
    var instrumentation = function (thisObject, value) {
        // put hooked setter into event loop to avoid of set latency
        Object(__WEBPACK_IMPORTED_MODULE_0__timer__["d" /* setTimeout */])(function () {
            after(thisObject, value);
        }, 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(object, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(object, property, originalDescriptor);
            }
            else {
                instrumentation = __WEBPACK_IMPORTED_MODULE_2__utils_functionUtils__["a" /* noop */];
            }
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sanitize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__display__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_byteUtils__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsonStringify__ = __webpack_require__(186);



// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * __WEBPACK_IMPORTED_MODULE_1__utils_byteUtils__["a" /* ONE_KIBI_BYTE */];
// Symbol for the root element of the JSONPath used for visited objects
var JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount) {
    var _a;
    if (maxCharacterCount === void 0) { maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT; }
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = Object(__WEBPACK_IMPORTED_MODULE_2__jsonStringify__["a" /* detachToJsonMethod */])(Object.prototype);
    var restoreArrayPrototypeToJson = Object(__WEBPACK_IMPORTED_MODULE_2__jsonStringify__["a" /* detachToJsonMethod */])(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) {
            for (var key = 0; key < containerToProcess.source.length; key++) {
                var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length;
                }
                else {
                    // When an element of an Array (targetData) is undefined, it is serialized as null:
                    // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
                    accumulatedCharacterCount += 4;
                }
                accumulatedCharacterCount += separatorLength;
                separatorLength = 1;
                if (accumulatedCharacterCount > maxCharacterCount) {
                    warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                ;
                containerToProcess.target[key] = targetData;
            }
        }
        else {
            for (var key in containerToProcess.source) {
                if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                    var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                    // When a property of an object has an undefined value, it will be dropped during serialization:
                    // JSON.stringify({a:undefined}) => '{}'
                    if (targetData !== undefined) {
                        accumulatedCharacterCount +=
                            JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
                        separatorLength = 1;
                    }
                    if (accumulatedCharacterCount > maxCharacterCount) {
                        warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                        break;
                    }
                    ;
                    containerToProcess.target[key] = targetData;
                }
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
        return sanitizePrimitivesAndFunctions(sourceToSanitize);
    }
    var sanitizedSource = sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
        return sanitizedSource;
    }
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) {
        return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    }
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({ source: sourceToSanitize, target: target, path: currentPath });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') {
        return "[BigInt] ".concat(value.toString());
    }
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') {
        return "[Function] ".concat(value.name || 'unknown');
    }
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') {
        return "[Symbol] ".concat(value.description || value.toString());
    }
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) {
            return {
                isTrusted: value.isTrusted,
            };
        }
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) {
            return "[".concat(match[1], "]");
        }
    }
    catch (_a) {
        // If the previous serialization attempts failed, and we cannot convert using
        // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === 'function') {
        try {
            return object.toJSON();
        }
        catch (_a) {
            // If toJSON fails, we continue by trying to serialize the value manually
        }
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    __WEBPACK_IMPORTED_MODULE_0__display__["b" /* display */].warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}
//# sourceMappingURL=sanitize.js.map

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorSource; });
var ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
//# sourceMappingURL=error.types.js.map

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getType;
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
//# sourceMappingURL=typeUtils.js.map

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FAKE_INITIAL_DOCUMENT; });
/* harmony export (immutable) */ __webpack_exports__["d"] = computeResourceKind;
/* harmony export (immutable) */ __webpack_exports__["g"] = isRequestKind;
/* harmony export (immutable) */ __webpack_exports__["c"] = computePerformanceResourceDuration;
/* harmony export (immutable) */ __webpack_exports__["b"] = computePerformanceResourceDetails;
/* harmony export (immutable) */ __webpack_exports__["h"] = toValidEntry;
/* harmony export (immutable) */ __webpack_exports__["e"] = computeSize;
/* harmony export (immutable) */ __webpack_exports__["f"] = isAllowedRequestUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* ResourceType.DOCUMENT */, function (initiatorType) { return FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* ResourceType.XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* ResourceType.FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* ResourceType.BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* ResourceType.CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* ResourceType.JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* ResourceType.IMAGE */,
        function (initiatorType, path) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_13" /* includes */])(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* ResourceType.FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* ResourceType.MEDIA */,
        function (initiatorType, path) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_13" /* includes */])(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_28" /* isValidUrl */])(url)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["v" /* addTelemetryDebug */])("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* ResourceType.OTHER */;
    }
    var path = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_7" /* getPathName */])(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* ResourceType.OTHER */;
}
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(startTime, responseEnd));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(duration);
}
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(start, end)),
        start: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
//# sourceMappingURL=resourceUtils.js.map

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertMouseEventToLayoutCoordinates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getVisualViewport; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getScrollX;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollY;
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
    return (Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visualViewport = window.visualViewport;
    var normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visualViewport) {
        // On old browsers, we cannot normalize, so fallback to clientX/Y
        return normalized;
    }
    else if (isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
var getVisualViewport = function (visualViewport) { return ({
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width,
}); };
function getScrollX() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) {
        scrollX = visual.pageLeft - visual.offsetLeft;
    }
    else if (window.scrollX !== undefined) {
        scrollX = window.scrollX;
    }
    else {
        scrollX = window.pageXOffset || 0;
    }
    return Math.round(scrollX);
}
function getScrollY() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) {
        scrollY = visual.pageTop - visual.offsetTop;
    }
    else if (window.scrollY !== undefined) {
        scrollY = window.scrollY;
    }
    else {
        scrollY = window.pageYOffset || 0;
    }
    return Math.round(scrollY);
}
//# sourceMappingURL=viewports.js.map

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ConfigAction = /** @class */ (function () {
    function ConfigAction() {
        // Dont be that guy
        throw new Error("NOOOO");
    }
    ConfigAction.ToggleAudio = function (dispatch) {
        return dispatch(function (innerDispatch, reduxState) {
            var state = reduxState();
            innerDispatch({ type: "TOGGLE_AUDIO_CONFIG", data: !state.Config.audioEnabled });
        });
    };
    ConfigAction.SetPreviousLocation = function (dispatch, value) {
        dispatch({ type: "SET_PREVIOUS_LOCATION_CONFIG", data: value });
    };
    return ConfigAction;
}());
/* harmony default export */ __webpack_exports__["a"] = (ConfigAction);


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var ObjectUtil = /** @class */ (function () {
    function ObjectUtil() {
    }
    ObjectUtil.ObjectToArray = function (theObject) {
        return Object.keys(theObject).map(function (x) {
            return {
                key: x,
                value: theObject[x]
            };
        });
    };
    // public static ObjectToArrayDeep(theObject: object): { key: string, value: object }[] {
    //     if (theObject == null) {
    //         return theObject;
    //     }
    //     return Object.keys(theObject).map(x => {
    //         return {
    //             key: x,
    //             value: theObject[x]
    //         } as { key: string, value: object };
    //     });
    // }
    ObjectUtil.DiagnosticInfo = function (obj) {
        var output = "";
        var objType = typeof obj;
        var keys = Object.keys(obj);
        var isArray = Array.isArray(obj);
        var isNumber = Number.isInteger(obj);
        var hasSubMembers = keys.some(function (x) { return x != null && typeof (x) === 'object' && !Array.isArray(x); });
        output =
            "## Object Diagnostic Info ##" + "\n" +
                ("Type: " + objType) + "\n" +
                ("IsNumber: " + isNumber) + "\n" +
                ("IsArray: " + isArray) + "\n" +
                ("HasSubMembers: " + hasSubMembers) + "\n" +
                ("Keys: \n" + keys.map(function (x) { return " " + x + ": " + typeof obj[x]; }).join("\n"));
        // output = output.split(" ").filter(x => x).join(" ");
        console.warn(output); // JB - Remove this console.warn
    };
    /**
     * Applies a second object onto the first, traversing the sub-objects to do the same.
     *
     * @param {T} left The source object. These params are overwritten if they exist in both.
     * @param {T} right The params from this object overwrite the params in the first object.
     * @param {boolean} [arrayRule=false] Indicates if arrays should be appended to one another. Default is to merge each array item based on index.
     */
    ObjectUtil.DeepMergeObjects = function (left, right, arrayRule) {
        var _this = this;
        if (arrayRule === void 0) { arrayRule = "default"; }
        var obj = __assign(__assign({}, (left || {})), (right || {}));
        var keys = Object.keys(obj);
        keys.forEach(function (key) {
            var _a, _b, _c, _d;
            var innerObj = obj[key];
            var isArray = Array.isArray(innerObj);
            var isObject = typeof (innerObj) === 'object';
            if (innerObj != null && isObject && !isArray) {
                var first = left == null ? (_a = {}, _a[key] = null, _a) : left;
                var second = right == null ? (_b = {}, _b[key] = null, _b) : right;
                // Recurse and put result back into merged object
                obj[key] = _this.DeepMergeObjects(first[key], second[key], arrayRule);
            }
            else if (isArray) {
                var arrayResult = [];
                var safeLeft = (left || (_c = {}, _c[key] = [], _c))[key] || [];
                var safeRight = (right || (_d = {}, _d[key] = [], _d))[key] || [];
                switch (arrayRule) {
                    case "take-left":
                        arrayResult = safeLeft;
                        break;
                    case "take-right":
                        arrayResult = safeRight;
                        break;
                    case "concat":
                        arrayResult = __spreadArrays(safeLeft, safeRight);
                        break;
                    case "default":
                    case "merge-index":
                        var minLength = Math.min(safeLeft.length, safeRight.length);
                        var maxLength = Math.max(safeLeft.length, safeRight.length);
                        for (var index = 0; index < minLength; index++) {
                            // Account for nulls, then account for non objects
                            if (safeLeft == null || safeRight == null) {
                                // Nothing to calculate, just return whatever is not null, or null, starting with the right
                                arrayResult.push(safeRight[index] || safeLeft[index]);
                            }
                            if (typeof safeLeft[index] !== 'object' || typeof safeRight[index] !== 'object') {
                                // One or both are primitives of some kind. Pick left if it's an object, else default to right
                                // Also, errors should only show when we are choosing this on purpose
                                arrayRule === "merge-index" && console.warn("Type error when merging array objects. Defaulting to rightmost object", safeLeft[index], safeRight[index]);
                                if (typeof safeLeft[index] === 'object') {
                                    arrayResult.push(safeLeft[index]);
                                }
                                else {
                                    arrayResult.push(safeRight[index]);
                                }
                                continue;
                            }
                            arrayResult.push(_this.DeepMergeObjects(safeLeft[index], safeRight[index], arrayRule));
                        }
                        if (minLength !== maxLength) {
                            // Add extras that have no match
                            var arr = safeLeft.length > minLength ? safeLeft : safeRight;
                            for (var index = minLength; index < maxLength; index++) {
                                arrayResult.push(arr[index]);
                            }
                        }
                        break;
                    default:
                        arrayResult = [];
                }
                // Put result back into merged object
                obj[key] = arrayResult;
            }
        });
        return obj;
    };
    return ObjectUtil;
}());
/* harmony default export */ __webpack_exports__["a"] = (ObjectUtil);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_tabs__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_tabs_style_index_js__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_popover__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_popover_style_index_js__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__form_FieldDecorator__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_utils_NameOf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__form_LetterRangeSelector__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_constants_ActivityType__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_utils_ObjectUtil__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_api_SchoolApiController__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ReportHeader_less__ = __webpack_require__(2174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ReportHeader_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__ReportHeader_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

 // Connecting to Redux






















 // 'this' binder








var ReportHeader = /** @class */ (function (_super) {
    __extends(ReportHeader, _super);
    function ReportHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.defaults = {
            defaultSchoolYears: "Previous 2",
            defaultShowSchoolSelection: false
        };
        Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_BindThisHelper__["a" /* default */])(_this, ReportHeader.prototype);
        var today = __WEBPACK_IMPORTED_MODULE_22_moment___default()(); // Leaving this here for easier testing
        var isStartOfSchoolYear = __WEBPACK_IMPORTED_MODULE_22_moment___default()(today).month(6).endOf('month').isBefore(today);
        var startOfCurrent = isStartOfSchoolYear ? __WEBPACK_IMPORTED_MODULE_22_moment___default()(today).month(7).startOf('month') : __WEBPACK_IMPORTED_MODULE_22_moment___default()(today).month(7).startOf('month').subtract(1, 'year');
        var current = { id: 1, lower: startOfCurrent, upper: __WEBPACK_IMPORTED_MODULE_22_moment___default()(startOfCurrent).add(1, 'year'), name: "Current" };
        var schoolYears = [
            current,
            { id: current.id + 1, lower: __WEBPACK_IMPORTED_MODULE_22_moment___default()(current.lower).subtract(1, 'year'), upper: __WEBPACK_IMPORTED_MODULE_22_moment___default()(current.upper).subtract(1, 'year'), name: "Previous 1" },
            { id: current.id + 2, lower: __WEBPACK_IMPORTED_MODULE_22_moment___default()(current.lower).subtract(2, 'year'), upper: __WEBPACK_IMPORTED_MODULE_22_moment___default()(current.upper).subtract(2, 'year'), name: "Previous 2" },
            { id: current.id + 3, lower: __WEBPACK_IMPORTED_MODULE_22_moment___default()(current.lower).subtract(3, 'year'), upper: __WEBPACK_IMPORTED_MODULE_22_moment___default()(current.upper).subtract(3, 'year'), name: "Previous 3" }
        ];
        // Generate the labels
        schoolYears.forEach(function (x) { return (x.label = x.lower.year() + " - " + x.upper.year() + " School Year"); });
        // Reduce school years to match what is selected
        switch (props.defaultSchoolYears) {
            case "Current":
                schoolYears = schoolYears.slice(0, 1);
                break;
            case "Previous 1":
                schoolYears = schoolYears.slice(0, 2);
                break;
            case "Previous 2":
                schoolYears = schoolYears.slice(0, 3);
                break;
            case "Previous 3":
                schoolYears = schoolYears.slice(0, 4);
                break;
            default:
                break;
        }
        _this.state = {
            isResetting: false,
            isSchoolLoading: true,
            showReportingPeriodPopup: false,
            showCurrentGradePopup: false,
            formValues: {
                eventTypeId: null,
                gradeIds: [],
                reportPeriod: null,
                reportPeriodType: null,
                firstName: { lower: "A", upper: "Z" },
                lastName: { lower: "A", upper: "Z" }
            },
            schoolYears: schoolYears,
            schools: []
        };
        return _this;
    }
    ReportHeader.prototype.componentDidMount = function () {
        this.getSchools();
    };
    ReportHeader.prototype.getProps = function (props) {
        if (props === void 0) { props = this.props; }
        return __WEBPACK_IMPORTED_MODULE_30_src_utils_ObjectUtil__["a" /* default */].DeepMergeObjects(this.defaults, props);
    };
    ReportHeader.prototype.getSchools = function () {
        var _this = this;
        var props = this.getProps();
        // Load schools for current user account
        if (!props.defaultShowSchoolSelection) {
            this.setState({ isSchoolLoading: false });
            return;
        }
        return __WEBPACK_IMPORTED_MODULE_31_src_api_SchoolApiController__["a" /* default */].getSchoolsForCurrentUser().then(function (result) {
            var schools = result.data.sort(function (a, b) { return a.value < b.value ? -1 : a.value > b.value ? 1 : 0; });
            _this.setState({ schools: schools, isSchoolLoading: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_18_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditSchool.messageRetrieveError'));
        });
    };
    ReportHeader.prototype.handleReset = function () {
        var _this = this;
        this.setState({
            isResetting: true
        }, function () { return _this.props.form.resetFields(); });
    };
    ReportHeader.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        // Don't validate on reset
        if (this.state.isResetting) {
            this.setState({ isResetting: false });
            if (this.props.onReset != null) {
                this.props.onReset();
            }
            return;
        }
        // Make sure all fields are valid
        this.props.form.validateFields(function (errors, values) {
            if (!!errors) {
                return;
            }
            // Reduce 'values' to just the values that have values
            var reducedValues = {};
            Object.keys(values).forEach(function (x) {
                var newVal = values[x];
                if ((newVal === null || newVal === void 0 ? void 0 : newVal.toString().length) > 0) {
                    reducedValues[x] = newVal;
                }
            });
            // Custom replacer since report period is now a select not another component
            if (reducedValues.reportPeriod != null) {
                // Antd puts the value, a number, into the reportPeriod slot so we will replace it with the proper value from state
                var schoolYear = _this.state.schoolYears.find(function (x) { return x.id === reducedValues.reportPeriod; });
                reducedValues.reportPeriod = schoolYear;
                reducedValues.reportPeriodType = schoolYear.name;
            }
            if (_this.props.onSubmit != null) {
                _this.props.onSubmit(reducedValues);
            }
        });
    };
    ReportHeader.prototype.renderSchoolSelection = function (breakpoints) {
        var _a;
        var props = this.getProps();
        var child = null;
        // Show schools for current role if we are allowed
        if (!!props.defaultShowSchoolSelection) {
            child = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__form_FieldDecorator__["a" /* default */], { form: this.props.form, label: "School", name: Object(__WEBPACK_IMPORTED_MODULE_26_src_utils_NameOf__["a" /* NameOf */])("schoolId"), initialValue: this.props.User.schoolId, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */], { disabled: this.state.isSchoolLoading || this.state.schools.length === 1 }, (_a = this.state.schools) === null || _a === void 0 ? void 0 : _a.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */].Option, { key: x.key, value: x.key, title: x.value }, x.value); }))));
        }
        return child != null ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], __assign({}, breakpoints), child) : null;
    };
    ReportHeader.prototype.renderReportingEvent = function (breakpoints) {
        var props = this.getProps();
        var data = this.state.formValues;
        var child = null;
        if (props.reportingEvent === "Activity") {
            child = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__form_FieldDecorator__["a" /* default */], { form: this.props.form, label: "Activity Type", name: Object(__WEBPACK_IMPORTED_MODULE_26_src_utils_NameOf__["a" /* NameOf */])("eventTypeId"), initialValue: data.eventTypeId, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */], __assign({ placeholder: "Select Activity type - Surveys or Quiz", allowClear: true, filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; } }, { showAction: ["focus", "click"] }), __WEBPACK_IMPORTED_MODULE_29_src_constants_ActivityType__["a" /* ActivityTypes */].All.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */].Option, { key: x.id, value: x.id, title: x.name }, x.name); }))));
        }
        return child != null ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], __assign({}, breakpoints), child) : null;
    };
    ReportHeader.prototype.renderReportingPeriod = function (breakpoints) {
        var _this = this;
        var props = this.getProps();
        var data = this.state.formValues;
        var child = null;
        if (["I Statement", "Planet Completion"].some(function (x) { return x === props.reportingEvent; })) {
            var popoverContent = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Report period is setup to use school years. School years start on August 1st and end on July 31st."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Available in a future release!"));
            child = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                    "Report Period",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_popover__["a" /* default */], { trigger: "click", title: "School Years", content: popoverContent },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_icon__["a" /* default */], { className: "info-icon", type: "info-circle", onClick: function () { return _this.setState({ showReportingPeriodPopup: true }); } }))), name: Object(__WEBPACK_IMPORTED_MODULE_26_src_utils_NameOf__["a" /* NameOf */])("reportPeriod"), initialValue: data.reportPeriod },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */], { disabled: true },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */].Option, { value: 1, title: "N/A" }, "N/A"))));
        }
        else {
            var popoverContent = "Report period is setup to use school years. School years start on August 1st and end on July 31st.";
            child = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                    "Report Period",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_popover__["a" /* default */], { trigger: "click", title: "School Years", content: popoverContent },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_icon__["a" /* default */], { className: "info-icon", type: "info-circle", onClick: function () { return _this.setState({ showReportingPeriodPopup: true }); } }))), name: Object(__WEBPACK_IMPORTED_MODULE_26_src_utils_NameOf__["a" /* NameOf */])("reportPeriod"), initialValue: data.reportPeriod, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */], __assign({ allowClear: true }, { showAction: ["focus", "click"] }), this.state.schoolYears.map(function (data) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */].Option, { key: data.id, value: data.id, title: data.label }, data.label);
                }))));
        }
        return child != null ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], __assign({}, breakpoints), child) : null;
    };
    ReportHeader.prototype.render = function () {
        var _this = this;
        var _a;
        var data = this.state.formValues;
        var breakpoints = {
            xs: 12,
            lg: 8
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "report-header" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { layout: "vertical", onSubmit: this.handleSubmit },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_row__["a" /* default */], { type: "flex", justify: "start" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 24 },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_row__["a" /* default */], { gutter: 16 },
                            this.renderSchoolSelection(breakpoints),
                            this.renderReportingEvent(breakpoints),
                            this.renderReportingPeriod(breakpoints),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], __assign({}, breakpoints),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                                        "Current Grade",
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_popover__["a" /* default */], { trigger: "click", title: "School Years", content: "Filter for the Current Grade Level of the students." },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_icon__["a" /* default */], { className: "info-icon", type: "info-circle", onClick: function () { return _this.setState({ showReportingPeriodPopup: true }); } }))), name: Object(__WEBPACK_IMPORTED_MODULE_26_src_utils_NameOf__["a" /* NameOf */])("gradeIds"), initialValue: data.gradeIds, getValueFromEvent: __WEBPACK_IMPORTED_MODULE_25__form_FieldDecorator__["a" /* default */].StandardSelectAllEvent("all", __WEBPACK_IMPORTED_MODULE_27_src_constants_Grades__["a" /* Grades */].All.map(function (x) { return x.id; })), rules: [
                                        { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                                    ] },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */], __assign({ mode: "multiple", placeholder: "Select grade between 'PK to Grade 5'", allowClear: true, filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; } }, { showAction: ["focus", "click"] }),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */].Option, { key: "all", value: "all" }, ((_a = this.props.form.getFieldValue(Object(__WEBPACK_IMPORTED_MODULE_26_src_utils_NameOf__["a" /* NameOf */])("gradeIds"))) === null || _a === void 0 ? void 0 : _a.length) < __WEBPACK_IMPORTED_MODULE_27_src_constants_Grades__["a" /* Grades */].All.length ? "All" : "None"),
                                        __WEBPACK_IMPORTED_MODULE_27_src_constants_Grades__["a" /* Grades */].All.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_select__["a" /* default */].Option, { key: x.id, value: x.id, title: x.shortName }, x.shortName); }))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_row__["a" /* default */], { gutter: 16, type: "flex", align: "bottom" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], __assign({}, breakpoints),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__form_FieldDecorator__["a" /* default */], { form: this.props.form, label: "First Name Starts With", name: Object(__WEBPACK_IMPORTED_MODULE_26_src_utils_NameOf__["a" /* NameOf */])("firstName"), initialValue: data.firstName },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__form_LetterRangeSelector__["a" /* default */], { renderMode: "Hidden" }))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], __assign({}, breakpoints),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__form_FieldDecorator__["a" /* default */], { form: this.props.form, label: "Last Name Starts With", name: Object(__WEBPACK_IMPORTED_MODULE_26_src_utils_NameOf__["a" /* NameOf */])("lastName"), initialValue: data.lastName },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__form_LetterRangeSelector__["a" /* default */], { renderMode: "Hidden" }))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 24, lg: 8 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_row__["a" /* default */], { className: "form-buttons", type: "flex", justify: "end" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_button__["a" /* default */], { type: "primary", icon: "download", loading: this.props.isLoading, htmlType: "submit" }, "Generate"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_button__["a" /* default */], { type: "default", onClick: this.handleReset, htmlType: "submit" }, "Clear")))))))));
    };
    return ReportHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_23_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create()(ReportHeader))));


/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/r.a6188bd1.png";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/i.2ab70d19.png";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/c.d40f40c9.png";

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_DesertTerraformGame_scenes_EndGameScene__ = __webpack_require__(2246);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






// Paintbrush helper class to hold drawing attributes
var PaintBrush = /** @class */ (function () {
    // default color yellow, thickness 5
    function PaintBrush() {
        this.thickness = 50;
        this.color = 0x00eded;
        this.alpha = 1;
    }
    return PaintBrush;
}());
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        // Paintbrush holds draw stroke attributes
        _this.paintBrush = new PaintBrush();
        _this.buttonPressed = false;
        _this.continueLine = false;
        _this.isDragging = false;
        _this.usingWaterTool = false;
        // Screenshot Variables
        _this.div = document.createElement('div');
        _this.currentImageFrame = "";
        _this.paintBrushCursor = 'url(' + __webpack_require__(518) + '), pointer';
        _this.DESERT_FLOOR_COLOR = 0xC8AD55;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image("pixel", __webpack_require__(60));
        this.load.atlas("assets", __webpack_require__(2247), __webpack_require__(2248));
        this.load.tilemapTiledJSON('map', __webpack_require__(2249));
    };
    MainScene.prototype.create = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        var easelArea = new Phaser.Geom.Rectangle(0, 0, this.sys.canvas.width - 400, this.sys.canvas.height);
        var controlArea = new Phaser.Geom.Rectangle(easelArea.width, 0, 400, this.sys.canvas.height);
        this.defaultButtonSize = new Phaser.Geom.Rectangle(0, 0, 100, 100);
        this.itemOptions = [];
        this.lineHistory = [];
        this.pastedImages = [];
        this.makeLine = false;
        this.buildControlArea(controlArea);
        this.buildControls(controlArea);
        this.buildEasel(easelArea);
        this.addResizeIcon();
        document.body.appendChild(this.div);
        // Register the click events
        this.registerEvents();
    };
    MainScene.prototype.addObjects = function () {
        var _this = this;
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "pilot") {
                var pilot = _this.add.image(ob.x, ob.y, "pilots", "a");
                pilot.setOrigin(0);
                pilot.setDepth(1);
                pilot.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "water") {
                _this.waterButton = _this.add.image(ob.x, ob.y, "assets", "tool-water");
                _this.waterButton.setOrigin(0);
                _this.waterButton.setDepth(1);
                _this.waterButton.setInteractive();
                _this.waterButton.setDisplaySize(ob.width, ob.height);
                _this.waterButton.on("pointerdown", function () {
                    _this.input.setDefaultCursor(_this.paintBrushCursor);
                    _this.resizing = false;
                    _this.usingWaterTool = true;
                    _this.buttonPressed = true;
                    _this.currentImageFrame = "";
                    _this.currentImage.setVisible(false);
                    _this.waterButton.setAlpha(1);
                    _this.eraseButton.setAlpha(0.5);
                    _this.greyOutOtherItems();
                    _this.paintBrush.color = 0x00eded;
                    _this.refreshPaintBrush();
                });
            }
            else if (ob.name === "erase") {
                _this.eraseButton = _this.add.image(ob.x, ob.y, "assets", "tool-erase");
                _this.eraseButton.setOrigin(0);
                _this.eraseButton.setDepth(1);
                _this.eraseButton.setTint(0xC8AD55);
                _this.eraseButton.setInteractive();
                _this.eraseButton.setDisplaySize(ob.width, ob.height);
                _this.eraseButton.on("pointerdown", function () {
                    _this.input.setDefaultCursor(_this.paintBrushCursor);
                    _this.resizing = false;
                    _this.usingWaterTool = true;
                    _this.buttonPressed = true;
                    _this.currentImageFrame = "";
                    _this.currentImage.setVisible(false);
                    _this.eraseButton.setAlpha(1);
                    _this.waterButton.setAlpha(0.5);
                    _this.greyOutOtherItems();
                    _this.paintBrush.color = _this.DESERT_FLOOR_COLOR;
                    _this.refreshPaintBrush();
                });
            }
            else if (ob.name === "done") {
                var config = new __WEBPACK_IMPORTED_MODULE_2__shared_Button__["b" /* PhaserButtonConfig */]();
                config.backgroundColor = __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
                config.smartSize = true;
                _this.finishButton = new __WEBPACK_IMPORTED_MODULE_2__shared_Button__["a" /* PhaserButton */](_this, ob.x, ob.y, 100, 50, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("common.done"), config);
                _this.finishButton.setDepth(1);
                _this.finishButton.on("buttonClicked", function () {
                    _this.buttonPressed = false;
                    _this.usingWaterTool = false;
                    _this.currentImageFrame = "";
                    // Screenshot for later
                    _this.registry.parent.renderer.snapshot(function (image) {
                        image.onload = function () {
                            var croppedImage = __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__["a" /* default */].CropImageToDataURI(image, 0, 0, _this.sys.canvas.width - 300, _this.sys.canvas.height);
                            console.warn("Screenshot!", croppedImage); // JB - Remove this console.warn
                            _this.endGame(croppedImage);
                        };
                    });
                });
            }
            else {
                var button = _this.add.image(ob.x, ob.y, "assets", ob.name);
                button.setOrigin(0);
                button.setDepth(1);
                button.setInteractive();
                button.setDisplaySize(button.width * 0.7, button.height * 0.7);
                button.on("pointerdown", function () {
                    _this.resizing = false;
                    _this.buttonPressed = false;
                    _this.usingWaterTool = false;
                    _this.currentImageFrame = ob.name;
                    _this.currentImage.setFrame(_this.currentImageFrame);
                    _this.currentImage.setVisible(false);
                    _this.waterButton.setAlpha(0.5);
                    _this.greyOutOtherItems();
                });
                _this.itemOptions.push(button);
            }
        });
        this.currentImage = this.add.image(this.easelControls.x + 170, this.easelControls.y + 625, "assets", "");
        this.currentImage.setOrigin(.5);
        this.currentImage.setDepth(1);
        this.currentImage.setVisible(false);
    };
    MainScene.prototype.buildEasel = function (easelArea) {
        var _this = this;
        this.easel = this.add.image(easelArea.x, easelArea.y, "pixel");
        this.easel.setOrigin(0, 0);
        this.easel.setDisplaySize(easelArea.width, easelArea.height);
        this.easel.setTint(this.DESERT_FLOOR_COLOR);
        this.easel.setDepth(-1);
        this.easel.setInteractive();
        this.easel.on('pointerdown', function (pointer) {
            _this.pasteImage(pointer);
        }, this);
        this.easelTexture = this.add.renderTexture(0, 0, this.sys.canvas.width - 300, this.sys.canvas.height);
        this.easelTexture.setOrigin(0);
        this.easelTexture.setDepth(0);
        this.easelGraphic = this.add.graphics();
        this.easelGraphic.setDepth(0);
    };
    MainScene.prototype.buildControlArea = function (controlArea) {
        this.easelControls = this.add.image(controlArea.x, controlArea.y, "pixel");
        this.easelControls.setTint(0x551A8B);
        this.easelControls.setOrigin(0, 0);
        this.easelControls.setDisplaySize(controlArea.width, controlArea.height);
        this.easelControls.setDepth(1);
    };
    MainScene.prototype.buildControls = function (controlArea) {
        this.addObjects();
    };
    MainScene.prototype.pasteImage = function (pointer) {
        if (this.currentImageFrame !== "") {
            this.paste = this.add.image(pointer.x, pointer.y, "assets", this.currentImageFrame);
            this.paste.setInteractive();
            this.paste.depth = this.easel.depth + 1;
            this.paste.setDisplaySize(this.defaultButtonSize.width / 1.5, this.defaultButtonSize.height / 1.5);
            this.input.setDraggable(this.paste);
            this.pastedImages.push(this.paste);
        }
    };
    MainScene.prototype.greyOutOtherItems = function () {
        var _this = this;
        this.itemOptions.forEach(function (i) {
            if (i.frame.name !== _this.currentImageFrame) {
                i.setAlpha(0.5);
            }
            else {
                i.setAlpha(1);
            }
        });
    };
    MainScene.prototype.refreshPaintBrush = function () {
        this.easelGraphic.lineStyle(this.paintBrush.thickness, this.paintBrush.color, this.paintBrush.alpha);
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.on('pointerdown', this.pointerDown);
        this.input.on('pointerup', this.pointerUp);
        this.input.on('pointermove', this.pointerMove);
        // If pointer goes up outside the canvas, stop drawing
        document.addEventListener('mouseup', this.pointerUp);
        this.input.on('dragstart', function (pointer, gameObject) {
            _this.children.bringToTop(gameObject);
            _this.isDragging = true;
            if (gameObject.name !== "resizeIcon") {
                _this.paste = gameObject;
            }
            else {
                gameObject.x = pointer.downX;
                gameObject.y = pointer.downY;
            }
            _this.buttonPressed = false;
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            if (_this.resizing) {
                var corner = _this.getBottomRightCorner();
                _this.resizeForBottomRightCorner(pointer, corner);
            }
            else {
                gameObject.x = pointer.x;
                gameObject.y = pointer.y;
            }
        });
        this.input.on('dragend', function (pointer, gameObject) {
            var doesIntersect = Phaser.Geom.Intersects.RectangleToRectangle(gameObject.getBounds(), _this.easelControls.getBounds());
            if (doesIntersect && !_this.resizing) {
                gameObject.destroy();
            }
            else {
                _this.children.moveDown(gameObject);
            }
            if (_this.usingWaterTool) {
                _this.buttonPressed = true;
                _this.resizing = false;
            }
            if (_this.resizing) {
                _this.buttonPressed = false;
                _this.resizing = false;
            }
            _this.isDragging = false;
        });
    };
    MainScene.prototype.addResizeIcon = function () {
        var _this = this;
        this.resizeIcon = this.add.image(-100, 0, "assets", "tool-resize");
        this.resizeIcon.setOrigin(0);
        this.resizeIcon.setTint(0x000000);
        this.resizeIcon.setDepth(10);
        this.resizeIcon.setName("resizeIcon");
        this.resizeIcon.setDisplaySize(30, 30);
        // Make the resize icon larger for touchscreens Gotta support fatter fingers :)
        if (this.sys.game.device.input.touch) {
            this.resizeIcon.setDisplaySize(75, 75);
        }
        this.resizeIcon.setInteractive();
        this.resizeIcon.on('pointerdown', function () {
            _this.resizing = true;
            _this.makeLine = false;
            _this.buttonPressed = false;
            _this.currentImage.setVisible(false);
            _this.children.bringToTop(_this.paste);
            _this.children.bringToTop(_this.resizeIcon);
        });
        this.input.setDraggable(this.resizeIcon);
    };
    MainScene.prototype.getBottomRightCorner = function () {
        return this.paste.getBottomRight();
    };
    MainScene.prototype.getDeltaWidth = function () {
        return this.paste.displayWidth * 0.03;
    };
    MainScene.prototype.getDeltaHeight = function () {
        return this.paste.displayHeight * 0.03;
    };
    MainScene.prototype.getMaxHeight = function () {
        return this.paste.height * 2;
    };
    MainScene.prototype.getMaxWidth = function () {
        return this.paste.width * 2;
    };
    MainScene.prototype.getMinHeight = function () {
        return this.paste.height * 0.1;
    };
    MainScene.prototype.getMinWidth = function () {
        return this.paste.width * 0.1;
    };
    MainScene.prototype.resizeForBottomRightCorner = function (pointer, corner) {
        // Dragging right and down (increase size)
        if (pointer.x > corner.x && pointer.y > corner.y) {
            if (((this.paste.displayWidth + this.getDeltaWidth()) <= this.getMaxWidth()) &&
                ((this.paste.displayHeight + this.getDeltaHeight()) <= this.getMaxHeight())) {
                this.paste.displayWidth += this.getDeltaWidth();
                this.paste.displayHeight += this.getDeltaHeight();
            }
        }
        // Dragging left and up (decrease size)
        if (pointer.x < corner.x && pointer.y < corner.y) {
            if (((this.paste.displayWidth - this.getDeltaWidth()) >= this.getMinWidth()) &&
                ((this.paste.displayHeight - this.getDeltaHeight()) >= this.getMinHeight())) {
                this.paste.displayWidth -= this.getDeltaWidth();
                this.paste.displayHeight -= this.getDeltaHeight();
            }
        }
    };
    MainScene.prototype.pointerDown = function (pointer) {
        if (this.buttonPressed && pointer.x <= this.easelControls.x) {
            this.makeLine = true;
            this.lineHistory = [];
        }
    };
    MainScene.prototype.pointerUp = function () {
        this.makeLine = false;
        // Capture the graphics as a texture
        this.easelGraphic.generateTexture("background-drawn", this.sys.canvas.width - 300, this.sys.canvas.height);
        this.easelGraphic.clear();
        var tempImage = this.add.image(0, 0, "background-drawn");
        this.easelTexture.save();
        this.easelTexture.draw(tempImage.texture, tempImage.frame, 0, 0);
        this.easelTexture.restore();
        tempImage.destroy();
    };
    MainScene.prototype.pointerMove = function (pointer) {
        if (this.makeLine) {
            // Show the shape being drawn as the mouse moves
            this.easelGraphic.clear();
            this.refreshPaintBrush();
            this.lineHistory.push(new Phaser.Geom.Point(pointer.x, pointer.y));
            // Do the drawing
            this.easelGraphic.strokePoints(this.lineHistory);
        }
        this.currentImage.x = pointer.x;
        this.currentImage.y = pointer.y;
        this.currentImage.setDisplaySize(48, 48);
        if (this.isMovingExistingImage(pointer) && !this.resizing) {
            this.currentImage.setVisible(false);
            if (this.isDragging) {
                this.input.setDefaultCursor('-webkit-grabbing');
            }
            else {
                this.input.setDefaultCursor('-webkit-grab');
            }
        }
        else if (this.isResizingImage(pointer) || this.resizing) {
            this.currentImage.setVisible(false);
            this.input.setDefaultCursor('nw-resize');
        }
        else if (this.currentImageFrame !== "") {
            this.currentImage.setVisible(true);
            this.input.setDefaultCursor('none');
        }
        else if (this.usingWaterTool) {
            this.currentImage.setVisible(false);
            this.input.setDefaultCursor(this.paintBrushCursor);
        }
    };
    MainScene.prototype.disableEverything = function () {
        this.itemOptions.forEach(function (i) {
            i.input.enabled = false;
        });
        this.waterButton.input.enabled = false;
        this.finishButton.setEnabled(false);
    };
    MainScene.prototype.endGame = function (image) {
        document.removeEventListener('mouseup', this.pointerUp);
        MainScene.CROPPED_IMAGE = image;
        this.input.setDefaultCursor("default");
        this.input.removeAllListeners();
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_5_src_games_DesertTerraformGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    MainScene.prototype.update = function () {
        if (!this.input.enabled) {
            return;
        }
        // only show resize icon if not drawing and it's not in the control area (just deleted something)
        this.resizeIcon.setVisible((this.currentImageFrame !== "" && !this.isOnControlArea()));
        if (this.paste != null) {
            var bottomCorner = this.getBottomRightCorner();
            this.resizeIcon.setPosition(bottomCorner.x, bottomCorner.y);
        }
        // If you go over to easel, change pointer
        if (this.input.activePointer.x > this.easelControls.x) {
            this.currentImage.setVisible(false);
            this.input.setDefaultCursor('pointer');
            this.children.bringToTop(this.resizeIcon);
        }
    };
    MainScene.prototype.isOnWater = function () {
        return this.waterButton.getBounds().contains(this.input.activePointer.x, this.input.activePointer.y);
    };
    MainScene.prototype.isOnControlArea = function () {
        return Phaser.Geom.Intersects.RectangleToRectangle(this.resizeIcon.getBounds(), this.easelControls.getBounds());
    };
    MainScene.prototype.isResizingImage = function (pointer) {
        return this.resizeIcon.getBounds().contains(pointer.x, pointer.y);
    };
    MainScene.prototype.isMovingExistingImage = function (pointer) {
        for (var _i = 0, _a = this.pastedImages; _i < _a.length; _i++) {
            var i = _a[_i];
            if (i.getBounds().contains(pointer.x, pointer.y)) {
                return true;
            }
        }
        return false;
    };
    MainScene.CROPPED_IMAGE = null;
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = undefined;

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var string = _propTypes2['default'].string,
    bool = _propTypes2['default'].bool,
    number = _propTypes2['default'].number,
    array = _propTypes2['default'].array,
    oneOfType = _propTypes2['default'].oneOfType,
    shape = _propTypes2['default'].shape,
    object = _propTypes2['default'].object,
    func = _propTypes2['default'].func;
var propTypes = exports.propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  light: oneOfType([bool, string]),
  wrapper: oneOfType([string, func, shape({ render: func.isRequired })]),
  config: shape({
    soundcloud: shape({
      options: object,
      preload: bool
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      preload: bool
    }),
    facebook: shape({
      appId: string
    }),
    dailymotion: shape({
      params: object,
      preload: bool
    }),
    vimeo: shape({
      playerOptions: object,
      preload: bool
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string
    }),
    wistia: shape({
      options: object
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onProgress: func,
  onEnablePIP: func,
  onDisablePIP: func
};

var defaultProps = exports.defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  light: false,
  wrapper: 'div',
  config: {
    soundcloud: {
      options: {
        visual: true, // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      preload: false
    },
    facebook: {
      appId: '1309697205772819'
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      },
      preload: false
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      preload: false
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      hlsOptions: {},
      hlsVersion: '0.10.1',
      dashVersion: '2.9.2'
    },
    wistia: {
      options: {}
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {}
    }
  },
  onReady: function onReady() {},
  onStart: function onStart() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onBuffer: function onBuffer() {},
  onEnded: function onEnded() {},
  onError: function onError() {},
  onDuration: function onDuration() {},
  onSeek: function onSeek() {},
  onProgress: function onProgress() {},
  onEnablePIP: function onEnablePIP() {},
  onDisablePIP: function onDisablePIP() {}
};

var DEPRECATED_CONFIG_PROPS = exports.DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/background.bf239437.png";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/coin.ac7304d5.png";

/***/ }),
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLocalizedElement; });
/* unused harmony export hasHtmlTags */
/* unused harmony export templater */
/* unused harmony export getIndexForLanguageCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return objectValuesToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return validateOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTranslationsForLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return storeDidChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSingleToMultilanguageTranslation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* unused harmony export warning */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flat__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__localize__ = __webpack_require__(247);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var getLocalizedElement = function getLocalizedElement(options) {
  var translation = options.translation,
      data = options.data,
      renderInnerHtml = options.renderInnerHtml;


  var translatedValueOrArray = templater(translation, data);

  // if result of templater is string, do the usual stuff
  if (typeof translatedValueOrArray === 'string') {
    return renderInnerHtml === true && hasHtmlTags(translatedValueOrArray) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
      dangerouslySetInnerHTML: { __html: translatedValueOrArray }
    }) : translatedValueOrArray;
  }

  // at this point we know we have react components;
  // check if there are HTMLTags in the translation (not allowed)
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = translatedValueOrArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var portion = _step.value;

      if (typeof portion === 'string' && hasHtmlTags(portion)) {
        warning('HTML tags in the translation string are not supported when passing React components as arguments to the translation.');
        return '';
      }
    }

    // return as Element
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement.apply(__WEBPACK_IMPORTED_MODULE_0_react___default.a, ['span', null].concat(_toConsumableArray(translatedValueOrArray)));
};

var hasHtmlTags = function hasHtmlTags(value) {
  var pattern = /(&[^\s]*;|<\/?\w+((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[\^'">\s]+))?)+\s*|\s*)\/?>)/;
  return value.search(pattern) >= 0;
};

/**
 * @func templater
 * @desc A poor mans template parser
 * @param {string} strings The template string
 * @param {object} data The data that should be inserted in template
 * @return {string} The template string with the data merged in
 */
var templater = function templater(strings) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!strings) return '';

  // ${**}
  // brackets to include it in the result of .split()
  var genericPlaceholderPattern = '(\\${\\s*[^\\s]+\\s*})';

  // split: from 'Hey ${name}' -> ['Hey', '${name}']
  // filter: clean empty strings
  // map: replace ${prop} with data[prop]
  var splitStrings = strings.split(new RegExp(genericPlaceholderPattern, 'gmi')).filter(function (str) {
    return !!str;
  }).map(function (templatePortion) {
    var matched = void 0;
    for (var prop in data) {
      if (matched) break;
      var pattern = '\\${\\s*' + prop + '\\s*}';
      var regex = new RegExp(pattern, 'gmi');
      if (regex.test(templatePortion)) matched = data[prop];
    }
    return matched || templatePortion;
  });

  // if there is a React element, return as array
  if (splitStrings.some(function (portion) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(portion);
  })) {
    return splitStrings;
  }

  // otherwise concatenate all portions into the translated value
  return splitStrings.reduce(function (translated, portion) {
    return translated + ('' + portion);
  }, '');
};

var getIndexForLanguageCode = function getIndexForLanguageCode(code, languages) {
  return languages.map(function (language) {
    return language.code;
  }).indexOf(code);
};

var objectValuesToString = function objectValuesToString(data) {
  return !Object.values ? Object.keys(data).map(function (key) {
    return data[key].toString();
  }).toString() : Object.values(data).toString();
};

var validateOptions = function validateOptions(options) {
  if (options.onMissingTranslation !== undefined && typeof options.onMissingTranslation !== 'function') {
    throw new Error('react-localize-redux: an invalid onMissingTranslation function was provided.');
  }

  if (options.renderToStaticMarkup !== false && typeof options.renderToStaticMarkup !== 'function') {
    throw new Error('\n      react-localize-redux: initialize option renderToStaticMarkup is invalid.\n      Please see https://ryandrewjohnson.github.io/react-localize-docs/#initialize.\n    ');
  }

  return options;
};

var getTranslationsForLanguage = function getTranslationsForLanguage(language, languages, translations) {
  // no language! return no translations
  if (!language) {
    return {};
  }

  var languageCode = language.code;

  var languageIndex = getIndexForLanguageCode(languageCode, languages);
  var keys = Object.keys(translations);
  var totalKeys = keys.length;
  var translationsForLanguage = {};

  for (var i = 0; i < totalKeys; i++) {
    var key = keys[i];
    translationsForLanguage[key] = translations[key][languageIndex];
  }

  return translationsForLanguage;
};

var storeDidChange = function storeDidChange(store, onChange) {
  var currentState = void 0;

  function handleChange() {
    var nextState = store.getState();
    if (nextState !== currentState) {
      onChange(currentState);
      currentState = nextState;
    }
  }

  var unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
};

var getSingleToMultilanguageTranslation = function getSingleToMultilanguageTranslation(language, languageCodes, flattenedTranslations, existingTranslations) {
  var languageIndex = languageCodes.indexOf(language);
  var translations = languageIndex >= 0 ? flattenedTranslations : {};
  var keys = Object.keys(translations);
  var totalKeys = keys.length;
  var singleLanguageTranslations = {};

  var _loop = function _loop(i) {
    var key = keys[i];
    // loop through each language, and for languages that don't match languageIndex
    // keep existing translation data, and for languageIndex store new translation data
    var translationValues = languageCodes.map(function (code, index) {
      var existingValues = existingTranslations[key] || [];

      return index === languageIndex ? flattenedTranslations[key] : existingValues[index];
    });

    singleLanguageTranslations[key] = translationValues;
  };

  for (var i = 0; i < totalKeys; i++) {
    _loop(i);
  }

  return singleLanguageTranslations;
};

var get = function get(obj, path) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  var pathArr = path.split('.').filter(Boolean);
  return pathArr.reduce(function (ret, key) {
    return ret && ret[key] ? ret[key] : defaultValue;
  }, obj);
};

// Thanks react-redux for utility function
// https://github.com/reactjs/react-redux/blob/master/src/utils/warning.js
var warning = function warning(message) {
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }

  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {}
};

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobal;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwTypeError;
/* harmony export (immutable) */ __webpack_exports__["b"] = objCreateFn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(338);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var _cachedGlobal = null;
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions.
 */
function getGlobal(useCached) {
    if (useCached === void 0) { useCached = true; }
    var result = useCached === false ? null : _cachedGlobal;
    if (!result) {
        if (typeof globalThis !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = globalThis;
        }
        if (!result && typeof self !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = self;
        }
        if (!result && typeof window !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = window;
        }
        if (!result && typeof global !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = global;
        }
        _cachedGlobal = result;
    }
    return result;
}
function throwTypeError(message) {
    throw new TypeError(message);
}
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object to use as a prototype. May be null
 */
function objCreateFn(obj) {
    var func = __WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */];
    // Use build in Object.create
    if (func) {
        // Use Object create method if it exists
        return func(obj);
    }
    if (obj == null) {
        return {};
    }
    var type = typeof obj;
    if (type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["j" /* strShimObject */] && type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        throwTypeError("Object prototype may only be an Object:" + obj);
    }
    function tmpFunc() { }
    tmpFunc[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = obj;
    return new tmpFunc();
}
//# sourceMappingURL=Helpers.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEnumStyle;
/* unused harmony export createEnumMap */
/* harmony export (immutable) */ __webpack_exports__["b"] = createValueMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_HelperFuncs__ = __webpack_require__(71);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Create an enum style object which has both the key => value and value => key mappings
 * @param values - The values to populate on the new object
 * @returns
 */
function createEnumStyle(values) {
    var enumClass = {};
    Object(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_HelperFuncs__["C" /* objForEachKey */])(values, function (field, value) {
        enumClass[field] = value;
        enumClass[value] = field;
    });
    return Object(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_HelperFuncs__["h" /* deepFreeze */])(enumClass);
}
/**
 * Create a 2 index map that maps an enum's key as both the key and value, X["key"] => "key" and X[0] => "keyof 0".
 * @param values - The values to populate on the new object
 * @returns
 */
function createEnumMap(values) {
    var mapClass = {};
    Object(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_HelperFuncs__["C" /* objForEachKey */])(values, function (field, value) {
        mapClass[field] = field;
        mapClass[value] = field;
    });
    return Object(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_HelperFuncs__["h" /* deepFreeze */])(mapClass);
}
/**
 * Create a 2 index map that maps an enum's key and value to the defined map value, X["key"] => mapValue and X[0] => mapValue.
 * Generic values
 * - E = the const enum type (typeof eRequestHeaders);
 * - V = Identifies the valid values for the keys, this should include both the enum numeric and string key of the type. The
 * resulting "Value" of each entry identifies the valid values withing the assignments.
 * @param values - The values to populate on the new object
 * @returns
 */
function createValueMap(values) {
    var mapClass = {};
    Object(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_HelperFuncs__["C" /* objForEachKey */])(values, function (field, value) {
        mapClass[field] = value[1];
        mapClass[value[0]] = value[1];
    });
    return Object(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_HelperFuncs__["h" /* deepFreeze */])(mapClass);
}
//# sourceMappingURL=EnumHelperFuncs.js.map

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobal;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwTypeError;
/* harmony export (immutable) */ __webpack_exports__["b"] = objCreateFn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(339);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var _cachedGlobal = null;
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions.
 */
function getGlobal(useCached) {
    if (useCached === void 0) { useCached = true; }
    var result = useCached === false ? null : _cachedGlobal;
    if (!result) {
        if (typeof globalThis !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = globalThis;
        }
        if (!result && typeof self !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = self;
        }
        if (!result && typeof window !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = window;
        }
        if (!result && typeof global !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = global;
        }
        _cachedGlobal = result;
    }
    return result;
}
function throwTypeError(message) {
    throw new TypeError(message);
}
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object to use as a prototype. May be null
 */
function objCreateFn(obj) {
    var func = __WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */];
    // Use build in Object.create
    if (func) {
        // Use Object create method if it exists
        return func(obj);
    }
    if (obj == null) {
        return {};
    }
    var type = typeof obj;
    if (type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["j" /* strShimObject */] && type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        throwTypeError("Object prototype may only be an Object:" + obj);
    }
    function tmpFunc() { }
    tmpFunc[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = obj;
    return new tmpFunc();
}
//# sourceMappingURL=Helpers.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDebugExt;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDebugListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(124);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var listenerFuncs = ["eventsSent", "eventsDiscarded", "eventsSendRequest", "perfEvent"];
var _aiNamespace = null;
var _debugListener;
function _listenerProxyFunc(name, config) {
    return function () {
        var args = arguments;
        var dbgExt = getDebugExt(config);
        if (dbgExt) {
            var listener = dbgExt.listener;
            if (listener && listener[name]) {
                listener[name][__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["b" /* _DYN_APPLY */] /* @min:%2eapply */](listener, args);
            }
        }
    };
}
function _getExtensionNamespace() {
    // Cache the lookup of the global namespace object
    var target = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["g" /* getGlobalInst */])("Microsoft");
    if (target) {
        _aiNamespace = target["ApplicationInsights"];
    }
    return _aiNamespace;
}
function getDebugExt(config) {
    var ns = _aiNamespace;
    if (!ns && config.disableDbgExt !== true) {
        ns = _aiNamespace || _getExtensionNamespace();
    }
    return ns ? ns["ChromeDbgExt"] : null;
}
function getDebugListener(config) {
    if (!_debugListener) {
        _debugListener = {};
        for (var lp = 0; lp < listenerFuncs[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */]; lp++) {
            _debugListener[listenerFuncs[lp]] = _listenerProxyFunc(listenerFuncs[lp], config);
        }
    }
    return _debugListener;
}
//# sourceMappingURL=DbgExtensionUtils.js.map

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = randomValue;
/* harmony export (immutable) */ __webpack_exports__["d"] = random32;
/* harmony export (immutable) */ __webpack_exports__["b"] = mwcRandomSeed;
/* harmony export (immutable) */ __webpack_exports__["a"] = mwcRandom32;
/* harmony export (immutable) */ __webpack_exports__["c"] = newId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalConstants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = 123456789;
var _mwcZ = 987654321;
// Takes any integer
function _mwcSeed(seedValue) {
    if (seedValue < 0) {
        // Make sure we end up with a positive number and not -ve one.
        seedValue >>>= 0;
    }
    _mwcW = (123456789 + seedValue) & MaxUInt32;
    _mwcZ = (987654321 - seedValue) & MaxUInt32;
    _mwcSeeded = true;
}
function _autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["g" /* dateNow */])() & 0x7fffffff;
        _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
    }
    catch (e) {
        // Don't crash if something goes wrong
    }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue
 */
function randomValue(maxValue) {
    if (maxValue > 0) {
        return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
    }
    return 0;
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
    var value = 0;
    var c = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["e" /* getCrypto */])() || Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["l" /* getMsCrypto */])();
    if (c && c.getRandomValues) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
    }
    if (value === 0 && Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["v" /* isIE */])()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!_mwcSeeded) {
            // Set the seed for the Mwc algorithm
            _autoSeedMwc();
        }
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mwcRandom32() & MaxUInt32;
    }
    if (value === 0) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = Math.floor((UInt32Mask * Math.random()) | 0);
    }
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Seed the MWC random number generator with the specified seed or a random value
 * @param value - optional the number to used as the seed, if undefined, null or zero a random value will be chosen
 */
function mwcRandomSeed(value) {
    if (!value) {
        _autoSeedMwc();
    }
    else {
        _mwcSeed(value);
    }
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
    _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
    _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
    var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
    if (maxLength === void 0) { maxLength = 22; }
    var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Start with an initial random number, consuming the value in reverse byte order
    var number = random32() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["e" /* STR_EMPTY */];
    while (result[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] < maxLength) {
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = (((random32() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}
//# sourceMappingURL=RandomHelper.js.map

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _gblCookieMgr;
/* harmony export (immutable) */ __webpack_exports__["c"] = safeGetCookieMgr;
/* harmony export (immutable) */ __webpack_exports__["b"] = createCookieMgr;
/* unused harmony export areCookiesSupported */
/* harmony export (immutable) */ __webpack_exports__["d"] = uaDisallowsSameSiteNone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiagnosticLogger__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalConstants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strEnabled = "enabled";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["f" /* getDocument */])();
var _cookieCache = {};
var _globalCookieConfig = {};
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */
function _gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
        _globalCookieConfig[strConfigCookieMgr] = inst;
    }
    return inst;
}
function _isMgrEnabled(cookieMgr) {
    if (cookieMgr) {
        return cookieMgr.isEnabled();
    }
    return true;
}
function _createCookieMgrConfig(rootConfig) {
    var cookieMgrCfg = rootConfig[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["f" /* _DYN_COOKIE_CFG */] /* @min:%2ecookieCfg */] = rootConfig[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["f" /* _DYN_COOKIE_CFG */] /* @min:%2ecookieCfg */] || {};
    // Sets the values from the root config if not already present on the cookieMgrCfg
    Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["J" /* setValue */])(cookieMgrCfg, "domain", rootConfig.cookieDomain, __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["r" /* isNotNullOrUndefined */], __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */]);
    Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["J" /* setValue */])(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(cookieMgrCfg[strEnabled])) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(rootConfig[strIsCookieUseDisabled])) {
            cookieEnabled = !rootConfig[strIsCookieUseDisabled];
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(rootConfig[strDisableCookiesUsage])) {
            cookieEnabled = !rootConfig[strDisableCookiesUsage];
        }
        cookieMgrCfg[strEnabled] = cookieEnabled;
    }
    return cookieMgrCfg;
}
function _isIgnoredCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(cookieMgrCfg.ignoreCookies)) {
        return cookieMgrCfg.ignoreCookies[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["r" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */](name) !== -1;
    }
    return false;
}
function _isBlockedCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(cookieMgrCfg.blockedCookies)) {
        if (cookieMgrCfg.blockedCookies[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["r" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */](name) !== -1) {
            return true;
        }
    }
    return _isIgnoredCookie(cookieMgrCfg, name);
}
/**
 * Helper to return the ICookieMgr from the core (if not null/undefined) or a default implementation
 * associated with the configuration or a legacy default.
 * @param core
 * @param config
 * @returns
 */
function safeGetCookieMgr(core, config) {
    var cookieMgr;
    if (core) {
        // Always returns an instance
        cookieMgr = core.getCookieMgr();
    }
    else if (config) {
        var cookieCfg = config[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["f" /* _DYN_COOKIE_CFG */] /* @min:%2ecookieCfg */];
        if (cookieCfg[strConfigCookieMgr]) {
            cookieMgr = cookieCfg[strConfigCookieMgr];
        }
        else {
            cookieMgr = createCookieMgr(config);
        }
    }
    if (!cookieMgr) {
        // Get or initialize the default global (legacy) cookie manager if we couldn't find one
        cookieMgr = _gblCookieMgr(config, (core || {})[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */]);
    }
    return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
    var _a;
    var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
    var _path = cookieMgrConfig.path || "/";
    var _domain = cookieMgrConfig.domain;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled = cookieMgrConfig[strEnabled] !== false;
    var cookieMgr = (_a = {
            isEnabled: function () {
                var enabled = _enabled && areCookiesSupported(logger);
                // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
                // that don't use the "applicationinsights-core" version of the default cookie function
                var gblManager = _globalCookieConfig[strConfigCookieMgr];
                if (enabled && gblManager && cookieMgr !== gblManager) {
                    // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
                    // As the global (deprecated) functions may have been called (for backward compatibility)
                    enabled = _isMgrEnabled(gblManager);
                }
                return enabled;
            }
        },
        _a[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["L" /* _DYN_SET_ENABLED */] /* @min:setEnabled */] = function (value) {
            // Explicitly checking against false, so that setting to undefined will === true
            _enabled = value !== false;
        },
        _a.set = function (name, value, maxAgeSec, domain, path) {
            var result = false;
            if (_isMgrEnabled(cookieMgr) && !_isBlockedCookie(cookieMgrConfig, name)) {
                var values = {};
                var theValue = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["M" /* strTrim */])(value || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */]);
                var idx = theValue[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["r" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */](";");
                if (idx !== -1) {
                    theValue = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["M" /* strTrim */])(value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["S" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](0, idx));
                    values = _extractParts(value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["S" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](idx + 1));
                }
                // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
                Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["J" /* setValue */])(values, "domain", domain || _domain, __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["w" /* isTruthy */], __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */]);
                if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(maxAgeSec)) {
                    var _isIE = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["v" /* isIE */])();
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(values[strExpires])) {
                        var nowMs = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */])();
                        // Only add expires if not already present
                        var expireMs = nowMs + (maxAgeSec * 1000);
                        // Sanity check, if zero or -ve then ignore
                        if (expireMs > 0) {
                            var expiry = new Date();
                            expiry.setTime(expireMs);
                            Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["J" /* setValue */])(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */], __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["w" /* isTruthy */]);
                        }
                    }
                    if (!_isIE) {
                        // Only replace if not already present
                        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["J" /* setValue */])(values, "max-age", __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */] + maxAgeSec, null, __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                var location_1 = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["k" /* getLocation */])();
                if (location_1 && location_1.protocol === "https:") {
                    Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["J" /* setValue */])(values, "secure", null, null, __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */]);
                    // Only set same site if not also secure
                    if (_allowUaSameSite === null) {
                        _allowUaSameSite = !uaDisallowsSameSiteNone((Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["m" /* getNavigator */])() || {})[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["_0" /* _DYN_USER_AGENT */] /* @min:%2euserAgent */]);
                    }
                    if (_allowUaSameSite) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["J" /* setValue */])(values, "SameSite", "None", null, __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["J" /* setValue */])(values, "path", path || _path, null, __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */]);
                var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                setCookieFn(name, _formatCookieValue(theValue, values));
                result = true;
            }
            return result;
        },
        _a.get = function (name) {
            var value = __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */];
            if (_isMgrEnabled(cookieMgr) && !_isIgnoredCookie(cookieMgrConfig, name)) {
                value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
            }
            return value;
        },
        _a.del = function (name, path) {
            var result = false;
            if (_isMgrEnabled(cookieMgr)) {
                // Only remove the cookie if the manager and cookie support has not been disabled
                result = cookieMgr.purge(name, path);
            }
            return result;
        },
        _a.purge = function (name, path) {
            var _a;
            var result = false;
            if (areCookiesSupported(logger)) {
                // Setting the expiration date in the past immediately removes the cookie
                var values = (_a = {},
                    _a["path"] = path ? path : "/",
                    _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
                    _a);
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["v" /* isIE */])()) {
                    // Set max age to expire now
                    values["max-age"] = "0";
                }
                var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                delCookie(name, _formatCookieValue(__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */], values));
                result = true;
            }
            return result;
        },
        _a);
    // Associated this cookie manager with the config
    cookieMgr[strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
/*
* Helper method to tell if document.cookie object is supported by the runtime
*/
function areCookiesSupported(logger) {
    if (_supportsCookies === null) {
        _supportsCookies = false;
        try {
            var doc = _doc || {};
            _supportsCookies = doc[strCookie] !== undefined;
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_1__DiagnosticLogger__["d" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 68 /* _eInternalMessageId.CannotAccessCookie */, "Cannot access document.cookie - " + Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["j" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["a" /* dumpObj */])(e) });
        }
    }
    return _supportsCookies;
}
function _extractParts(theValue) {
    var values = {};
    if (theValue && theValue[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */]) {
        var parts = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["M" /* strTrim */])(theValue)[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["P" /* _DYN_SPLIT */] /* @min:%2esplit */](";");
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrForEach */])(parts, function (thePart) {
            thePart = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["M" /* strTrim */])(thePart || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */]);
            if (thePart) {
                var idx = thePart[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["r" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */]("=");
                if (idx === -1) {
                    values[thePart] = null;
                }
                else {
                    values[Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["M" /* strTrim */])(thePart[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["S" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](0, idx))] = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["M" /* strTrim */])(thePart[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["S" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](idx + 1));
                }
            }
        });
    }
    return values;
}
function _formatDate(theDate, func) {
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["q" /* isFunction */])(theDate[func])) {
        return theDate[func]();
    }
    return null;
}
function _formatCookieValue(value, values) {
    var cookieValue = value || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */];
    Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["C" /* objForEachKey */])(values, function (name, theValue) {
        cookieValue += "; " + name + (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? "=" + theValue : __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */]);
    });
    return cookieValue;
}
function _getCookieValue(name) {
    var cookieValue = __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */];
    if (_doc) {
        var theCookie = _doc[strCookie] || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */];
        if (_parsedCookieValue !== theCookie) {
            _cookieCache = _extractParts(theCookie);
            _parsedCookieValue = theCookie;
        }
        cookieValue = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["M" /* strTrim */])(_cookieCache[name] || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */]);
    }
    return cookieValue;
}
function _setCookieValue(name, cookieValue) {
    if (_doc) {
        _doc[strCookie] = name + "=" + cookieValue;
    }
}
function uaDisallowsSameSiteNone(userAgent) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["v" /* isString */])(userAgent)) {
        return false;
    }
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "CPU iPhone OS 12") || Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "iPad; CPU OS 12")) {
        return true;
    }
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "Version/") && Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "Safari")) {
        return true;
    }
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["L" /* strEndsWith */])(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
        return true;
    }
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "Chrome/5") || Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "Chrome/6")) {
        return true;
    }
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "UnrealEngine") && !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "Chrome")) {
        return true;
    }
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "UCBrowser/12") || Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["K" /* strContains */])(userAgent, "UCBrowser/11")) {
        return true;
    }
    return false;
}
//# sourceMappingURL=CookieMgr.js.map

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createUnloadHandlerContainer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiagnosticLogger__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(71);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






function createUnloadHandlerContainer() {
    var handlers = [];
    function _addHandler(handler) {
        if (handler) {
            handlers[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](handler);
        }
    }
    function _runHandlers(unloadCtx, unloadState) {
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrForEach */])(handlers, function (handler) {
            try {
                handler(unloadCtx, unloadState);
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_1__DiagnosticLogger__["d" /* _throwInternal */])(unloadCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["h" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected error calling unload handler - " + Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["a" /* dumpObj */])(e));
            }
        });
        handlers = [];
    }
    return {
        add: _addHandler,
        run: _runHandlers
    };
}
//# sourceMappingURL=UnloadHandlerContainer.js.map

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = utlDisableStorage;
/* harmony export (immutable) */ __webpack_exports__["l"] = utlSetStoragePrefix;
/* harmony export (immutable) */ __webpack_exports__["d"] = utlEnableStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = utlCanUseLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["e"] = utlGetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["j"] = utlSetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["i"] = utlRemoveStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = utlCanUseSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["g"] = utlGetSessionStorageKeys;
/* harmony export (immutable) */ __webpack_exports__["f"] = utlGetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["k"] = utlSetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["h"] = utlRemoveSessionStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Enums__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(88);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
var _storagePrefix = "";
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getLocalStorageObject() {
    if (utlCanUseLocalStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].LocalStorage);
    }
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */
function _getVerifiedStorageObject(storageType) {
    try {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["O" /* getGlobal */])())) {
            return null;
        }
        var uid = (new Date)[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */]();
        var storage = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* getGlobalInst */])(storageType === __WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].LocalStorage ? "localStorage" : "sessionStorage");
        var name_1 = _storagePrefix + uid;
        storage.setItem(name_1, uid);
        var fail = storage.getItem(name_1) !== uid;
        storage[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["D" /* _DYN_REMOVE_ITEM */] /* @min:%2eremoveItem */](name_1);
        if (!fail) {
            return storage;
        }
    }
    catch (exception) {
        // eslint-disable-next-line no-empty
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getSessionStorageObject() {
    if (utlCanUseSessionStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].SessionStorage);
    }
    return null;
}
/**
 * Disables the global SDK usage of local or session storage if available
 */
function utlDisableStorage() {
    _canUseLocalStorage = false;
    _canUseSessionStorage = false;
}
function utlSetStoragePrefix(storagePrefix) {
    _storagePrefix = storagePrefix || "";
}
/**
 * Re-enables the global SDK usage of local or session storage if available
 */
function utlEnableStorage() {
    _canUseLocalStorage = utlCanUseLocalStorage(true);
    _canUseSessionStorage = utlCanUseSessionStorage(true);
}
/**
 * Returns whether LocalStorage can be used, if the reset parameter is passed a true this will override
 * any previous disable calls.
 * @param reset - Should the usage be reset and determined only based on whether LocalStorage is available
 */
function utlCanUseLocalStorage(reset) {
    if (reset || _canUseLocalStorage === undefined) {
        _canUseLocalStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].LocalStorage);
    }
    return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseLocalStorage = false;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */, "Browser failed read of local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetLocalStorage(logger, name, data) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */, "Browser failed write to local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["D" /* _DYN_REMOVE_ITEM */] /* @min:%2eremoveItem */](name);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */, "Browser failed removal of local storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlCanUseSessionStorage(reset) {
    if (reset || _canUseSessionStorage === undefined) {
        _canUseSessionStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].SessionStorage);
    }
    return _canUseSessionStorage;
}
function utlGetSessionStorageKeys() {
    var keys = [];
    if (utlCanUseSessionStorage()) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* getGlobalInst */])("sessionStorage"), function (key) {
            keys.push(key);
        });
    }
    return keys;
}
function utlGetSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseSessionStorage = false;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */, "Browser failed read of session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetSessionStorage(logger, name, data) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */, "Browser failed write to session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["D" /* _DYN_REMOVE_ITEM */] /* @min:%2eremoveItem */](name);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */, "Browser failed removal of session storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
        }
    }
    return false;
}
//# sourceMappingURL=StorageHelperFuncs.js.map

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobal;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwTypeError;
/* harmony export (immutable) */ __webpack_exports__["b"] = objCreateFn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(345);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var _cachedGlobal = null;
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions.
 */
function getGlobal(useCached) {
    if (useCached === void 0) { useCached = true; }
    var result = useCached === false ? null : _cachedGlobal;
    if (!result) {
        if (typeof globalThis !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = globalThis;
        }
        if (!result && typeof self !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = self;
        }
        if (!result && typeof window !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = window;
        }
        if (!result && typeof global !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = global;
        }
        _cachedGlobal = result;
    }
    return result;
}
function throwTypeError(message) {
    throw new TypeError(message);
}
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object to use as a prototype. May be null
 */
function objCreateFn(obj) {
    var func = __WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */];
    // Use build in Object.create
    if (func) {
        // Use Object create method if it exists
        return func(obj);
    }
    if (obj == null) {
        return {};
    }
    var type = typeof obj;
    if (type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["j" /* strShimObject */] && type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        throwTypeError("Object prototype may only be an Object:" + obj);
    }
    function tmpFunc() { }
    tmpFunc[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = obj;
    return new tmpFunc();
}
//# sourceMappingURL=Helpers.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(347);
/* unused harmony reexport strShimFunction */
/* unused harmony reexport strShimObject */
/* unused harmony reexport strShimUndefined */
/* unused harmony reexport strShimPrototype */
/* unused harmony reexport strShimHasOwnProperty */
/* unused harmony reexport strDefault */
/* unused harmony reexport ObjClass */
/* unused harmony reexport ObjProto */
/* unused harmony reexport ObjAssign */
/* unused harmony reexport ObjCreate */
/* unused harmony reexport ObjDefineProperty */
/* unused harmony reexport ObjHasOwnProperty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(490);
/* unused harmony reexport throwTypeError */
/* unused harmony reexport objCreateFn */
/* unused harmony reexport getGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(776);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c"]; });
/* unused harmony reexport __restFn */
/* unused harmony reexport __spreadArrayFn */
/* unused harmony reexport __spreadArraysFn */
/* unused harmony reexport __decorateFn */
/* unused harmony reexport __paramFn */
/* unused harmony reexport __metadataFn */
/* unused harmony reexport __createBindingFn */
/* unused harmony reexport __valuesFn */
/* unused harmony reexport __readFn */
/* unused harmony reexport __makeTemplateObjectFn */
/* unused harmony reexport __importDefaultFn */
/* unused harmony reexport __importStarFn */
/* unused harmony reexport __exportStarFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TsLibGlobals__ = __webpack_require__(1915);
/* unused harmony reexport __exposeGlobalTsLib */
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.




//# sourceMappingURL=applicationinsights-shims.js.map

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobal;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwTypeError;
/* harmony export (immutable) */ __webpack_exports__["b"] = objCreateFn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(347);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var _cachedGlobal = null;
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions.
 */
function getGlobal(useCached) {
    if (useCached === void 0) { useCached = true; }
    var result = useCached === false ? null : _cachedGlobal;
    if (!result) {
        if (typeof globalThis !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = globalThis;
        }
        if (!result && typeof self !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = self;
        }
        if (!result && typeof window !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = window;
        }
        if (!result && typeof global !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = global;
        }
        _cachedGlobal = result;
    }
    return result;
}
function throwTypeError(message) {
    throw new TypeError(message);
}
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object to use as a prototype. May be null
 */
function objCreateFn(obj) {
    var func = __WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */];
    // Use build in Object.create
    if (func) {
        // Use Object create method if it exists
        return func(obj);
    }
    if (obj == null) {
        return {};
    }
    var type = typeof obj;
    if (type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["j" /* strShimObject */] && type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        throwTypeError("Object prototype may only be an Object:" + obj);
    }
    function tmpFunc() { }
    tmpFunc[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = obj;
    return new tmpFunc();
}
//# sourceMappingURL=Helpers.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax__ = __webpack_require__(1924);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ajax__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ajax__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ajaxRecord__ = __webpack_require__(780);
/* unused harmony reexport ajaxRecord */
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




//# sourceMappingURL=applicationinsights-dependencies-js.js.map

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobal;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwTypeError;
/* harmony export (immutable) */ __webpack_exports__["b"] = objCreateFn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(348);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var _cachedGlobal = null;
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions.
 */
function getGlobal(useCached) {
    if (useCached === void 0) { useCached = true; }
    var result = useCached === false ? null : _cachedGlobal;
    if (!result) {
        if (typeof globalThis !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = globalThis;
        }
        if (!result && typeof self !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = self;
        }
        if (!result && typeof window !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = window;
        }
        if (!result && typeof global !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = global;
        }
        _cachedGlobal = result;
    }
    return result;
}
function throwTypeError(message) {
    throw new TypeError(message);
}
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object to use as a prototype. May be null
 */
function objCreateFn(obj) {
    var func = __WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */];
    // Use build in Object.create
    if (func) {
        // Use Object create method if it exists
        return func(obj);
    }
    if (obj == null) {
        return {};
    }
    var type = typeof obj;
    if (type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["j" /* strShimObject */] && type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        throwTypeError("Object prototype may only be an Object:" + obj);
    }
    function tmpFunc() { }
    tmpFunc[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = obj;
    return new tmpFunc();
}
//# sourceMappingURL=Helpers.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobal;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwTypeError;
/* harmony export (immutable) */ __webpack_exports__["b"] = objCreateFn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(349);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var _cachedGlobal = null;
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions.
 */
function getGlobal(useCached) {
    if (useCached === void 0) { useCached = true; }
    var result = useCached === false ? null : _cachedGlobal;
    if (!result) {
        if (typeof globalThis !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = globalThis;
        }
        if (!result && typeof self !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = self;
        }
        if (!result && typeof window !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = window;
        }
        if (!result && typeof global !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */]) {
            result = global;
        }
        _cachedGlobal = result;
    }
    return result;
}
function throwTypeError(message) {
    throw new TypeError(message);
}
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object to use as a prototype. May be null
 */
function objCreateFn(obj) {
    var func = __WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */];
    // Use build in Object.create
    if (func) {
        // Use Object create method if it exists
        return func(obj);
    }
    if (obj == null) {
        return {};
    }
    var type = typeof obj;
    if (type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["j" /* strShimObject */] && type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        throwTypeError("Object prototype may only be an Object:" + obj);
    }
    function tmpFunc() { }
    tmpFunc[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = obj;
    return new tmpFunc();
}
//# sourceMappingURL=Helpers.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return _DYN_UPDATE_SNIPPET_DEFIN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return _DYN_LOAD_APP_INSIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return _DYN_ENDPOINT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return _DYN_MAX_BATCH_SIZE_IN_BY1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return _DYN_MAX_BATCH_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _DYN_DISABLE_EXCEPTION_TR2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _DYN_DISABLE_TELEMETRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return _DYN_EMIT_LINE_DELIMITED_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _DYN_DIAGNOSTIC_LOG_INTER4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _DYN_AUTO_TRACK_PAGE_VISI5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return _DYN_SAMPLING_PERCENTAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _DYN_DISABLE_AJAX_TRACKIN6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return _DYN_MAX_AJAX_CALLS_PER_V7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return _DYN_IS_BEACON_API_DISABL8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _DYN_DISABLE_CORRELATION_9; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _DYN_CORRELATION_HEADER_E10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _DYN_DISABLE_FLUSH_ON_BEF11; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return _DYN_DISABLE_FLUSH_ON_UNL12; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _DYN_ENABLE_SESSION_STORA13; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return _DYN_IS_COOKIE_USE_DISABL14; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return _DYN_IS_STORAGE_USE_DISAB15; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return _DYN_IS_BROWSER_LINK_TRAC16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _DYN_ENABLE_CORS_CORRELAT17; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _DYN_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _DYN_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return _DYN_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return _DYN_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return _DYN_QUEUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _DYN_CONNECTION_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return _DYN_INSTRUMENTATION_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _DYN_APP_INSIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _DYN_DISABLE_IKEY_DEPRECA18; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return _DYN_GET_TRANSMISSION_CON19; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return _DYN_ONUNLOAD_FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _DYN_ADD_HOUSEKEEPING_BEF20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return _DYN_INDEX_OF; });
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_UPDATE_SNIPPET_DEFIN0 = "updateSnippetDefinitions"; // Count: 4
var _DYN_LOAD_APP_INSIGHTS = "loadAppInsights"; // Count: 4
var _DYN_ENDPOINT_URL = "endpointUrl"; // Count: 4
var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes"; // Count: 3
var _DYN_MAX_BATCH_INTERVAL = "maxBatchInterval"; // Count: 3
var _DYN_DISABLE_EXCEPTION_TR2 = "disableExceptionTracking"; // Count: 2
var _DYN_DISABLE_TELEMETRY = "disableTelemetry"; // Count: 2
var _DYN_EMIT_LINE_DELIMITED_3 = "emitLineDelimitedJson"; // Count: 2
var _DYN_DIAGNOSTIC_LOG_INTER4 = "diagnosticLogInterval"; // Count: 6
var _DYN_AUTO_TRACK_PAGE_VISI5 = "autoTrackPageVisitTime"; // Count: 2
var _DYN_SAMPLING_PERCENTAGE = "samplingPercentage"; // Count: 4
var _DYN_DISABLE_AJAX_TRACKIN6 = "disableAjaxTracking"; // Count: 2
var _DYN_MAX_AJAX_CALLS_PER_V7 = "maxAjaxCallsPerView"; // Count: 3
var _DYN_IS_BEACON_API_DISABL8 = "isBeaconApiDisabled"; // Count: 2
var _DYN_DISABLE_CORRELATION_9 = "disableCorrelationHeaders"; // Count: 2
var _DYN_CORRELATION_HEADER_E10 = "correlationHeaderExcludedDomains"; // Count: 2
var _DYN_DISABLE_FLUSH_ON_BEF11 = "disableFlushOnBeforeUnload"; // Count: 4
var _DYN_DISABLE_FLUSH_ON_UNL12 = "disableFlushOnUnload"; // Count: 3
var _DYN_ENABLE_SESSION_STORA13 = "enableSessionStorageBuffer"; // Count: 2
var _DYN_IS_COOKIE_USE_DISABL14 = "isCookieUseDisabled"; // Count: 2
var _DYN_IS_STORAGE_USE_DISAB15 = "isStorageUseDisabled"; // Count: 2
var _DYN_IS_BROWSER_LINK_TRAC16 = "isBrowserLinkTrackingEnabled"; // Count: 2
var _DYN_ENABLE_CORS_CORRELAT17 = "enableCorsCorrelation"; // Count: 2
var _DYN_CONFIG = "config"; // Count: 6
var _DYN_CONTEXT = "context"; // Count: 8
var _DYN_PUSH = "push"; // Count: 5
var _DYN_VERSION = "version"; // Count: 6
var _DYN_QUEUE = "queue"; // Count: 6
var _DYN_CONNECTION_STRING = "connectionString"; // Count: 3
var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 2
var _DYN_APP_INSIGHTS = "appInsights"; // Count: 3
var _DYN_DISABLE_IKEY_DEPRECA18 = "disableIkeyDeprecationMessage"; // Count: 2
var _DYN_GET_TRANSMISSION_CON19 = "getTransmissionControls"; // Count: 2
var _DYN_ONUNLOAD_FLUSH = "onunloadFlush"; // Count: 6
var _DYN_ADD_HOUSEKEEPING_BEF20 = "addHousekeepingBeforeUnload"; // Count: 2
var _DYN_INDEX_OF = "indexOf"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = catchUserErrors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__display__ = __webpack_require__(109);

function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_0__display__["b" /* display */].error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export STORAGE_POLL_DELAY */
/* harmony export (immutable) */ __webpack_exports__["a"] = selectSessionStoreStrategyType;
/* harmony export (immutable) */ __webpack_exports__["b"] = startSessionStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_timer__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_observable__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_utils_functionUtils__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_utils_stringUtils__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sessionConstants__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__storeStrategies_sessionInCookie__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__storeStrategies_sessionInLocalStorage__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sessionStoreOperations__ = __webpack_require__(1948);









/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
var STORAGE_POLL_DELAY = __WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__["c" /* ONE_SECOND */];
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function selectSessionStoreStrategyType(initConfiguration) {
    var sessionStoreStrategyType = Object(__WEBPACK_IMPORTED_MODULE_6__storeStrategies_sessionInCookie__["b" /* selectCookieStrategy */])(initConfiguration);
    if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
        sessionStoreStrategyType = Object(__WEBPACK_IMPORTED_MODULE_7__storeStrategies_sessionInLocalStorage__["b" /* selectLocalStorageStrategy */])();
    }
    return sessionStoreStrategyType;
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new __WEBPACK_IMPORTED_MODULE_1__tools_observable__["a" /* Observable */]();
    var expireObservable = new __WEBPACK_IMPORTED_MODULE_1__tools_observable__["a" /* Observable */]();
    var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie'
        ? Object(__WEBPACK_IMPORTED_MODULE_6__storeStrategies_sessionInCookie__["a" /* initCookieStrategy */])(sessionStoreStrategyType.cookieOptions)
        : Object(__WEBPACK_IMPORTED_MODULE_7__storeStrategies_sessionInLocalStorage__["a" /* initLocalStorageStrategy */])();
    var clearSession = sessionStoreStrategy.clearSession, retrieveSession = sessionStoreStrategy.retrieveSession;
    var watchSessionTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__tools_timer__["c" /* setInterval */])(watchSession, STORAGE_POLL_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        Object(__WEBPACK_IMPORTED_MODULE_8__sessionStoreOperations__["a" /* processSessionStoreOperations */])({
            process: function (sessionState) {
                var synchronizedSession = synchronizeSession(sessionState);
                isTracked = expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function (sessionState) {
                if (isTracked && !hasSessionInCache()) {
                    renewSessionInCache(sessionState);
                }
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }
    function expandSession() {
        Object(__WEBPACK_IMPORTED_MODULE_8__sessionStoreOperations__["a" /* processSessionStoreOperations */])({
            process: function (sessionState) { return (hasSessionInCache() ? synchronizeSession(sessionState) : undefined); },
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */
    function watchSession() {
        Object(__WEBPACK_IMPORTED_MODULE_8__sessionStoreOperations__["a" /* processSessionStoreOperations */])({
            process: function (sessionState) { return (!isActiveSession(sessionState) ? {} : undefined); },
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if (!isActiveSession(sessionState)) {
            sessionState = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) {
                expireSessionInCache();
            }
            else {
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function expandOrRenewSessionState(sessionState) {
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        if (isTracked && !sessionState.id) {
            sessionState.id = Object(__WEBPACK_IMPORTED_MODULE_4__tools_utils_stringUtils__["b" /* generateUUID */])();
            sessionState.created = String(Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__["h" /* dateNow */])());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(sessionState) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((sessionState.created === undefined || Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__["h" /* dateNow */])() - Number(sessionState.created) < __WEBPACK_IMPORTED_MODULE_5__sessionConstants__["b" /* SESSION_TIME_OUT_DELAY */]) &&
            (sessionState.expire === undefined || Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__["h" /* dateNow */])() < Number(sessionState.expire)));
    }
    return {
        expandOrRenewSession: Object(__WEBPACK_IMPORTED_MODULE_3__tools_utils_functionUtils__["b" /* throttle */])(expandOrRenewSession, STORAGE_POLL_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: function () {
            clearSession();
            synchronizeSession({});
        },
        stop: function () {
            Object(__WEBPACK_IMPORTED_MODULE_0__tools_timer__["a" /* clearInterval */])(watchSessionTimeoutId);
        },
    };
}
//# sourceMappingURL=sessionStore.js.map

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getZoneJsOriginalValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getGlobalObject__ = __webpack_require__(352);

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
    var browserWindow = Object(__WEBPACK_IMPORTED_MODULE_0__getGlobalObject__["a" /* getGlobalObject */])();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
//# sourceMappingURL=getZoneJsOriginalValue.js.map

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INTAKE_SITE_STAGING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INTAKE_SITE_US1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INTAKE_SITE_EU1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INTAKE_SITE_AP1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INTAKE_SITE_US1_FED; });
var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_EU1 = 'datadoghq.eu';
var INTAKE_SITE_AP1 = 'ap1.datadoghq.com';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
//# sourceMappingURL=intakeSites.js.map

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeInto */
/* harmony export (immutable) */ __webpack_exports__["b"] = deepClone;
/* harmony export (immutable) */ __webpack_exports__["a"] = combine;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_typeUtils__ = __webpack_require__(360);

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = Object(__WEBPACK_IMPORTED_MODULE_0__utils_typeUtils__["a" /* getType */])(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
//# sourceMappingURL=mergeInto.js.map

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getActionNameFromElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument &&
                Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["Z" /* find */])(element.ownerDocument.querySelectorAll('label'), function (label) { return label.htmlFor === element.id; });
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_44" /* safeTruncate */])(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_22" /* isIE */])();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}
//# sourceMappingURL=getActionNameFromElement.js.map

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = hasSerializedNode;
/* harmony export (immutable) */ __webpack_exports__["e"] = nodeAndAncestorsHaveSerializedNode;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSerializedNodeId;
/* harmony export (immutable) */ __webpack_exports__["f"] = setSerializedNodeId;
/* harmony export (immutable) */ __webpack_exports__["a"] = getElementInputValue;
/* unused harmony export URL_IN_CSS_REF */
/* unused harmony export ABSOLUTE_URL */
/* unused harmony export DATA_URI */
/* harmony export (immutable) */ __webpack_exports__["g"] = switchToAbsoluteUrl;
/* unused harmony export makeUrlAbsolute */
/* harmony export (immutable) */ __webpack_exports__["c"] = getValidTagName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__privacy__ = __webpack_require__(166);




var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current) && !Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["j" /* isNodeShadowRoot */])(current)) {
            return false;
        }
        current = Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["d" /* getParentNode */])(current);
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if (Object(__WEBPACK_IMPORTED_MODULE_3__privacy__["f" /* shouldMaskNode */])(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* CENSORED_STRING_MARK */];
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
var DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
    return cssText.replace(URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
            return matchingSubstring;
        }
        var quote = singleQuote || doubleQuote || '';
        return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
    });
}
function makeUrlAbsolute(url, baseUrl) {
    try {
        return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["z" /* buildUrl */])(url, baseUrl).href;
    }
    catch (_) {
        return url;
    }
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
//# sourceMappingURL=serializationUtils.js.map

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

 // 'this' binder

var GuideSection = /** @class */ (function (_super) {
    __extends(GuideSection, _super);
    function GuideSection(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, GuideSection.prototype);
        _this.state = {};
        return _this;
    }
    GuideSection.prototype.generateSecondLevelList = function () {
        if (!this.props.listBodyKeysSecondLevel) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: "sublist" }, typeof this.props.listBodyKeysSecondLevel === 'string'
            ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: this.props.listBodyKeysSecondLevel }))
            : this.props.listBodyKeysSecondLevel.map(function (bodyKey, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: bodyKey + index },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: bodyKey }));
            })));
    };
    GuideSection.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "guide-section" },
            this.props.headerKey &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: this.props.headerKey })),
            this.props.bodyKey &&
                (typeof this.props.bodyKey === 'string'
                    ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: this.props.bodyKey }))
                    : this.props.bodyKey.map(function (bodyKey, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { key: bodyKey + index },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: bodyKey }));
                    })),
            this.props.listBodyKeys &&
                (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null, typeof this.props.listBodyKeys === 'string'
                    ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: this.props.listBodyKeys }))
                    : this.props.listBodyKeys.map(function (bodyKey, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { key: bodyKey + index },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: bodyKey }));
                    }))),
            this.props.headerKeySecondLevel &&
                this.props.listBodyKeysSecondLevel &&
                (typeof this.props.listBodyKeysSecondLevel === 'string' ||
                    (Array.isArray(this.props.listBodyKeysSecondLevel) && this.props.listBodyKeysSecondLevel.length > 0)) &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: this.props.headerKeySecondLevel })),
            this.generateSecondLevelList(),
            this.props.children);
    };
    return GuideSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (GuideSection);


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__select_style__ = __webpack_require__(48);




/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AcademicApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var AcademicApiController = /** @class */ (function () {
    function AcademicApiController() {
        // post: Academic/AddAcademicStandardFramework
        this.RouteAddAcademicStandardFramework = function () { return "Academic/AddAcademicStandardFramework"; };
        // post: Academic/UpdateAcademicStandardFramework
        this.RouteUpdateAcademicStandardFramework = function () { return "Academic/UpdateAcademicStandardFramework"; };
        // post: Academic/DeleteAcademicStandardFramework/${academicStandardFrameworkId}
        this.RouteDeleteAcademicStandardFramework = function (academicStandardFrameworkId) { return "Academic/DeleteAcademicStandardFramework/" + academicStandardFrameworkId; };
        // get: Academic/GetAcademicStandardFramework/${academicStandardFrameworkId}
        this.RouteGetAcademicStandardFramework = function (academicStandardFrameworkId) { return "Academic/GetAcademicStandardFramework/" + academicStandardFrameworkId; };
        // post: Academic/GetAcademicStandardFrameworksForDatatable
        this.RouteGetAcademicStandardFrameworksForDatatable = function () { return "Academic/GetAcademicStandardFrameworksForDatatable"; };
        // get: Academic/GetAcademicStandardFrameworksForAcademicStandard
        this.RouteGetAcademicStandardFrameworksForAcademicStandard = function () { return "Academic/GetAcademicStandardFrameworksForAcademicStandard"; };
        // post: Academic/AddAcademicStandard
        this.RouteAddAcademicStandard = function () { return "Academic/AddAcademicStandard"; };
        // post: Academic/UpdateAcademicStandard
        this.RouteUpdateAcademicStandard = function () { return "Academic/UpdateAcademicStandard"; };
        // post: Academic/DeleteAcademicStandard/${academicStandardId}
        this.RouteDeleteAcademicStandard = function (academicStandardId) { return "Academic/DeleteAcademicStandard/" + academicStandardId; };
        // get: Academic/GetAcademicStandard/${academicStandardId}
        this.RouteGetAcademicStandard = function (academicStandardId) { return "Academic/GetAcademicStandard/" + academicStandardId; };
        // post: Academic/GetAcademicStandardsForDatatable
        this.RouteGetAcademicStandardsForDatatable = function () { return "Academic/GetAcademicStandardsForDatatable"; };
    }
    AcademicApiController.prototype.addAcademicStandardFramework = function (addAcademicStandardFramework, requestOptions) {
        var url = this.RouteAddAcademicStandardFramework();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addAcademicStandardFramework, 'post', url, requestOptions);
    };
    AcademicApiController.prototype.updateAcademicStandardFramework = function (updateAcademicStandardFramework, requestOptions) {
        var url = this.RouteUpdateAcademicStandardFramework();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateAcademicStandardFramework, 'post', url, requestOptions);
    };
    AcademicApiController.prototype.deleteAcademicStandardFramework = function (academicStandardFrameworkId, requestOptions) {
        var url = this.RouteDeleteAcademicStandardFramework(academicStandardFrameworkId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    AcademicApiController.prototype.getAcademicStandardFramework = function (academicStandardFrameworkId, requestOptions) {
        var url = this.RouteGetAcademicStandardFramework(academicStandardFrameworkId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    AcademicApiController.prototype.getAcademicStandardFrameworksForDatatable = function (tableRequest, requestOptions) {
        var url = this.RouteGetAcademicStandardFrameworksForDatatable();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    AcademicApiController.prototype.getAcademicStandardFrameworksForAcademicStandard = function (requestOptions) {
        var url = this.RouteGetAcademicStandardFrameworksForAcademicStandard();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    AcademicApiController.prototype.addAcademicStandard = function (addAcademicStandard, requestOptions) {
        var url = this.RouteAddAcademicStandard();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addAcademicStandard, 'post', url, requestOptions);
    };
    AcademicApiController.prototype.updateAcademicStandard = function (updateAcademicStandard, requestOptions) {
        var url = this.RouteUpdateAcademicStandard();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateAcademicStandard, 'post', url, requestOptions);
    };
    AcademicApiController.prototype.deleteAcademicStandard = function (academicStandardId, requestOptions) {
        var url = this.RouteDeleteAcademicStandard(academicStandardId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    AcademicApiController.prototype.getAcademicStandard = function (academicStandardId, requestOptions) {
        var url = this.RouteGetAcademicStandard(academicStandardId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    AcademicApiController.prototype.getAcademicStandardsForDatatable = function (tableRequest, requestOptions) {
        var url = this.RouteGetAcademicStandardsForDatatable();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    return AcademicApiController;
}());

var service = new AcademicApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(11);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(6);

var PropTypes = _interopRequireWildcard(_propTypes);

var _rcCheckbox = __webpack_require__(402);

var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__(79);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Radio = function (_React$Component) {
    (0, _inherits3['default'])(Radio, _React$Component);

    function Radio() {
        (0, _classCallCheck3['default'])(this, Radio);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));

        _this.saveCheckbox = function (node) {
            _this.rcCheckbox = node;
        };
        return _this;
    }

    (0, _createClass3['default'])(Radio, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
            return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState) || !(0, _shallowequal2['default'])(this.context.radioGroup, nextContext.radioGroup);
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.rcCheckbox.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.rcCheckbox.blur();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var props = this.props,
                context = this.context;

            var prefixCls = props.prefixCls,
                className = props.className,
                children = props.children,
                style = props.style,
                restProps = __rest(props, ["prefixCls", "className", "children", "style"]);

            var radioGroup = context.radioGroup;

            var radioProps = (0, _extends3['default'])({}, restProps);
            if (radioGroup) {
                radioProps.name = radioGroup.name;
                radioProps.onChange = radioGroup.onChange;
                radioProps.checked = props.value === radioGroup.value;
                radioProps.disabled = props.disabled || radioGroup.disabled;
            }
            var wrapperClassString = (0, _classnames2['default'])(className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper-checked', radioProps.checked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper-disabled', radioProps.disabled), _classNames));
            return React.createElement(
                'label',
                { className: wrapperClassString, style: style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave },
                React.createElement(_rcCheckbox2['default'], (0, _extends3['default'])({}, radioProps, { prefixCls: prefixCls, ref: this.saveCheckbox })),
                children !== undefined ? React.createElement(
                    'span',
                    null,
                    children
                ) : null
            );
        }
    }]);
    return Radio;
}(React.Component);

exports['default'] = Radio;

Radio.defaultProps = {
    prefixCls: 'ant-radio',
    type: 'radio'
};
Radio.contextTypes = {
    radioGroup: PropTypes.any
};
module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export roleRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ConfigureHistory__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_constants_Grades__ = __webpack_require__(78);




var RoleRedirect = /** @class */ (function () {
    function RoleRedirect() {
        // Dont be that guy
        throw new Error("NOOOO");
    }
    RoleRedirect.GetRoleRoute = function (roleId, gradeId) {
        var role = __WEBPACK_IMPORTED_MODULE_2_src_constants_Roles__["a" /* Roles */].FindById(roleId);
        var grade = __WEBPACK_IMPORTED_MODULE_3_src_constants_Grades__["a" /* Grades */].FindById(gradeId);
        var route = "";
        switch (role) {
            case __WEBPACK_IMPORTED_MODULE_2_src_constants_Roles__["a" /* Roles */].KuderAdmin:
                route = __WEBPACK_IMPORTED_MODULE_0__core_Routes__["a" /* default */].ADMIN_CLIENTS;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_src_constants_Roles__["a" /* Roles */].StateAdmin:
                route = __WEBPACK_IMPORTED_MODULE_0__core_Routes__["a" /* default */].ADMIN_DISTRICTS;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_src_constants_Roles__["a" /* Roles */].DistrictAdmin:
                route = __WEBPACK_IMPORTED_MODULE_0__core_Routes__["a" /* default */].ADMIN_SCHOOLS;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_src_constants_Roles__["a" /* Roles */].SchoolAdmin:
                var isAdminTable = true;
                route = __WEBPACK_IMPORTED_MODULE_0__core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_0__core_Routes__["a" /* default */].ADMIN_USERS, isAdminTable);
                break;
            case __WEBPACK_IMPORTED_MODULE_2_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin:
                route = __WEBPACK_IMPORTED_MODULE_0__core_Routes__["a" /* default */].ADMIN_CLASSROOMS;
                break;
            case __WEBPACK_IMPORTED_MODULE_2_src_constants_Roles__["a" /* Roles */].Student:
                switch (grade) {
                    case __WEBPACK_IMPORTED_MODULE_3_src_constants_Grades__["a" /* Grades */].Default:
                        console.error("Invalid grade \"" + gradeId + "\"");
                        break;
                    default:
                        route = __WEBPACK_IMPORTED_MODULE_0__core_Routes__["a" /* default */].STUDENT_HOME;
                        break;
                }
                break;
            default:
                console.error("Invalid role \"" + roleId + "\"");
                break;
        }
        if (route == null || route === "") {
            console.error("No Route selected, defaulting to login");
            route = __WEBPACK_IMPORTED_MODULE_0__core_Routes__["a" /* default */].BASE_ROUTE;
        }
        return route;
    };
    return RoleRedirect;
}());
/* harmony default export */ __webpack_exports__["a"] = (RoleRedirect);
function roleRedirect(roleId, gradeId) {
    var route = RoleRedirect.GetRoleRoute(roleId, gradeId);
    __WEBPACK_IMPORTED_MODULE_1__core_ConfigureHistory__["a" /* default */].push(route);
}


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A helper class to get/set values from the local store
 */
var ConfigUtil = /** @class */ (function () {
    function ConfigUtil() {
    }
    /** JB:
     * Might be useful to make a class for the config object. Then we can just load and save from that
     * Like, each item can be loaded from store, thats fine, but then we can have a better place for defaults
     */
    ConfigUtil.GetLocalStorageValue = function (key, defaultValue) {
        // JB: what am i doing with my life
        var valueAsString = localStorage.getItem(key);
        if (valueAsString == null) {
            return defaultValue.toString();
        }
        return valueAsString;
    };
    Object.defineProperty(ConfigUtil, "AudioEnabled", {
        /**
         * Gets or sets a value indicating that audio playback has been enabled/disabled
         */
        get: function () {
            return this.GetLocalStorageValue("config_audio_enabled", true).toLowerCase() === "true" ? true : false;
        },
        set: function (value) {
            localStorage.setItem("config_audio_enabled", value.toString());
        },
        enumerable: false,
        configurable: true
    });
    return ConfigUtil;
}());
/* harmony default export */ __webpack_exports__["a"] = (ConfigUtil);


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/blank_audio.fe0f4a81.mp3";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/s.357beb4d.png";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/planet_r_top.d156b489.jpg";

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_CollageGame_scenes_EndGameScene__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_Item__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene" + Math.random()
        }) || this;
        _this.resizing = false;
        _this.rotating = false;
        _this.rotation = 0;
        _this.gameOver = false;
        _this.NUMBER_OF_TEXT_ASSETS = 4;
        // Must be same length as above
        _this.textItemPositions = [
            { x: 150, y: 200 },
            { x: 400, y: 175 },
            { x: 150, y: 300 },
            { x: 400, y: 325 }
        ];
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        var _this = this;
        this.load.image("bg", __webpack_require__(2251));
        this.load.image("resize", __webpack_require__(2252));
        this.load.image("rotate", __webpack_require__(2253));
        this.load.image("reset", __webpack_require__(2254));
        this.load.image("delete", __webpack_require__(519));
        this.load.image("collage_1", __webpack_require__(2255));
        this.load.image("collage_2", __webpack_require__(2256));
        this.load.image("collage_3", __webpack_require__(2257));
        this.load.image("collage_4", __webpack_require__(2258));
        this.load.image("collage_5", __webpack_require__(2259));
        this.load.image("collage_6", __webpack_require__(2260));
        this.load.image("collage_7", __webpack_require__(2261));
        this.load.tilemapTiledJSON("map", __webpack_require__(2262));
        var keys = [];
        for (var i = 1; i < 21; i++) {
            keys.push('Collage.Phaser.CollageAssets.' + i);
        }
        keys.forEach(function (key) {
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    MainScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        this.registerEvents();
        Object(__WEBPACK_IMPORTED_MODULE_4_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "map" });
        this.items = [];
        this.textItems = [];
        this.textIds = new Set();
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.on('dragstart', function (pointer, gameObject) {
            if (!_this.gameOver) {
                _this.children.bringToTop(gameObject);
                // If they're touching the image itself, then the current item is the gameObject
                // Otherwise, we don't change the current item to the gameObject (resize icon in this case), because they're just trying to resize the image
                if (gameObject.name !== "resize") {
                    _this.currentItem = gameObject;
                }
                _this.setIconGroupVisible(false);
                var corner = new Phaser.Geom.Point(pointer.downX, pointer.downY);
                var center = _this.currentItem.getCenter();
                if (corner.x >= center.x && corner.y >= center.y) { // right and below center
                    _this.corner = "bottomRight";
                }
                else if (corner.x >= center.x && corner.y <= center.y) { // right and above center
                    _this.corner = "topRight";
                }
                else if (corner.x <= center.x && corner.y <= center.y) { // left and above center
                    _this.corner = "topLeft";
                }
                else if (corner.x <= center.x && corner.y >= center.y) { // left and below center
                    _this.corner = "bottomLeft";
                }
            }
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            if (!_this.gameOver) {
                if (_this.resizing) {
                    var corner = _this.getBottomRightCorner();
                    if (_this.corner === "bottomRight") {
                        _this.resizeForBottomRightCorner(pointer, corner);
                    }
                    else if (_this.corner === "topRight") {
                        _this.resizeForTopRightCorner(pointer, corner);
                    }
                    else if (_this.corner === "topLeft") {
                        _this.resizeForTopLeftCorner(pointer, corner);
                    }
                    else if (_this.corner === "bottomLeft") {
                        _this.resizeForBottomLeftCorner(pointer, corner);
                    }
                }
                else {
                    gameObject.x = dragX;
                    gameObject.y = dragY;
                }
            }
        });
        this.input.on('dragend', function (pointer, gameObject, dropped) {
            if (!_this.gameOver) {
                _this.resizing = false;
                _this.rotating = false;
                _this.setIconGroupVisible(true);
            }
        });
    };
    MainScene.prototype.generateScene = function () {
        this.background = this.add.image(0, 0, "bg");
        this.background.setOrigin(0);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.addObjects();
        this.addTextItems();
        this.iconGroup = this.add.group();
        this.addResizeIcon();
        this.addToolIcons();
        this.setIconGroupVisible(true);
    };
    MainScene.prototype.addResizeIcon = function () {
        var _this = this;
        this.resizeIcon = this.add.image(-100, 0, "resize");
        this.resizeIcon.setOrigin(0);
        this.resizeIcon.setDepth(10);
        this.resizeIcon.setName("resize");
        this.resizeIcon.setDisplaySize(30, 30);
        this.resizeIcon.setInteractive();
        this.resizeIcon.on('pointerdown', function () {
            if (!_this.gameOver) {
                _this.resizing = true;
                _this.children.bringToTop(_this.currentItem);
            }
        });
        this.input.setDraggable(this.resizeIcon);
    };
    MainScene.prototype.createIcon = function (texture, flip) {
        var container = this.add.container(-100, 50);
        var background = this.add.image(0, 0, "pixel");
        background.setTint(0xffffff);
        background.setDisplaySize(30, 30);
        container.add(background);
        var icon = this.add.image(0, 0, texture);
        icon.setDisplaySize(30, 30);
        icon.setDepth(2);
        if (flip) {
            icon.setFlipX(true);
        }
        container.add(icon);
        container.setSize(30, 30);
        container.setInteractive();
        return container;
    };
    MainScene.prototype.addToolIcons = function () {
        var _this = this;
        this.rotateCWIcon = this.createIcon("rotate");
        this.rotateCWIcon.on('pointerdown', function () {
            if (!_this.gameOver) {
                _this.rotating = true;
                _this.resizing = false;
                _this.children.bringToTop(_this.currentItem);
                _this.currentItem.angle += 10;
            }
        });
        this.rotateCCWIcon = this.createIcon("rotate", true);
        this.rotateCCWIcon.on('pointerdown', function () {
            if (!_this.gameOver) {
                _this.rotating = true;
                _this.resizing = false;
                _this.children.bringToTop(_this.currentItem);
                _this.currentItem.angle -= 10;
            }
        });
        this.resetIcon = this.createIcon("reset");
        this.resetIcon.on('pointerdown', function () {
            if (!_this.gameOver) {
                _this.resetImageInPlace();
            }
        });
        this.deleteIcon = this.createIcon("delete");
        this.deleteIcon.on('pointerdown', function () {
            if (!_this.gameOver) {
                var eases = [Phaser.Math.Easing.Back.InOut, Phaser.Math.Easing.Bounce.Out];
                _this.putImageBackOnRock(eases[Phaser.Math.Between(0, 1)]);
            }
        });
        this.iconGroup.add(this.rotateCCWIcon);
        this.iconGroup.add(this.rotateCWIcon);
        this.iconGroup.add(this.resetIcon);
        this.iconGroup.add(this.deleteIcon);
    };
    /**
     * Resets the image to the starting size and no rotation
     */
    MainScene.prototype.resetImageInPlace = function () {
        this.resizing = false;
        this.children.bringToTop(this.currentItem);
        this.currentItem.angle = 0;
        var startingSize = this.currentItem.startingSize;
        this.currentItem.setDisplaySize(startingSize.x, startingSize.y);
    };
    /**
     * Puts the image back on the rock the way it started (angle and size)
     */
    MainScene.prototype.putImageBackOnRock = function (ease) {
        this.resizing = false;
        if (this.currentItem != null) {
            this.throwImageToTheGround(this.currentItem, ease);
        }
    };
    MainScene.prototype.addObjects = function () {
        var _this = this;
        var index = 1;
        var config = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON,
            smartSize: true
        };
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "canvas") {
                _this.canvas = new Phaser.Geom.Rectangle(ob.x, ob.y, ob.width, ob.height);
            }
            else if (ob.type === "item") {
                _this.addItem(ob, index);
                index++;
            }
            else if (ob.name === "done") {
                var doneButton = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Button__["a" /* PhaserButton */](_this, _this.gameWidth - ob.width - 50, ob.y, ob.width, ob.height, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("common.done"), config).setDepth(1);
                doneButton.setX(_this.gameWidth - doneButton.width - 50);
                doneButton.on('buttonClicked', function () {
                    // Screenshot for later
                    _this.registry.parent.renderer.snapshot(function (image) {
                        image.onload = function () {
                            var croppedImage = __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__["a" /* default */].CropImageToDataURI(image, _this.canvas.x, _this.canvas.y, _this.canvas.width, _this.canvas.height);
                            console.warn("Screenshot!", croppedImage); // JB - Remove this console.warn
                            _this.endGame(croppedImage);
                        };
                    });
                });
            }
            else if (ob.name === "restart") {
                var restartButton = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Button__["a" /* PhaserButton */](_this, _this.gameWidth - ob.width - 50, ob.y, ob.width, ob.height, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("Collage.Phaser.reset"), config);
                restartButton.setX(_this.gameWidth - restartButton.width - 50);
                restartButton.on('buttonClicked', function () {
                    if (!_this.gameOver) {
                        _this.restartGame();
                    }
                });
            }
            else if (ob.name === "moreText") {
                var swapTextButton = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Button__["a" /* PhaserButton */](_this, ob.x, ob.y, ob.width, ob.height, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("Collage.Phaser.swapText"), config);
                swapTextButton.on('buttonClicked', function () {
                    if (!_this.gameOver) {
                        _this.swapTextItems();
                    }
                });
            }
            else if (ob.name === "rock") {
                _this.rock = new Phaser.Geom.Rectangle(ob.x, ob.y, ob.width, ob.height);
            }
            else if (ob.name === "textArea") {
                _this.textArea = new Phaser.Geom.Rectangle(ob.x, ob.y, ob.width, ob.height);
            }
        });
        this.map.getObjectLayer("Astro").objects.forEach(function (ob) {
            var astro = _this.add.image(ob.x, ob.y, "pilots", "a");
            astro.setOrigin(0);
            astro.setDisplaySize(ob.width, ob.height);
        });
    };
    MainScene.prototype.addItem = function (ob, index) {
        var x = ob.x + ob.width / 2;
        var y = ob.y + ob.height / 2;
        var item = new __WEBPACK_IMPORTED_MODULE_7__objects_Item__["a" /* ImageItem */](this, x, y, "collage_" + index);
        item.setDisplaySize(item.width * 0.25, item.height * 0.25);
        item.setAngle(ob.rotation);
        item.setInteractive();
        item.startingSize = new Phaser.Math.Vector2(item.displayWidth, item.displayHeight);
        item.startingPosition = item.getBounds();
        item.startingAngle = item.angle;
        this.items.push(item);
        this.input.setDraggable(item);
    };
    MainScene.prototype.swapTextItems = function () {
        var _this = this;
        // For items not on the canvas, swap them out with new ones
        this.textItems.filter(function (i) { return !_this.IsOnCanvas(i); }).forEach(function (textItem) {
            var currentId = textItem.textId;
            var center = textItem.getCenter();
            var currentPos = {
                x: center.x,
                y: center.y
            };
            // Destroy the current item
            _this.deleteTextItem(textItem);
            // Make sure get a unique id (textIds is a set)
            var newId = Phaser.Math.Between(1, 20);
            while (_this.textIds.has(newId)) {
                newId = Phaser.Math.Between(1, 20);
            }
            // Replace current id with new one
            _this.textIds.delete(currentId);
            _this.textIds.add(newId);
            var newTextItem = _this.createTextItem(newId, currentPos);
        });
    };
    MainScene.prototype.deleteTextItem = function (textItem) {
        // Remove from textItem array
        var index = this.textItems.findIndex(function (i) { return i.textId === textItem.textId; });
        this.textItems.splice(index, 1);
        // Remove from items array
        index = this.items.findIndex(function (i) { return i.type === "TextItem" && i.textId === textItem.textId; });
        this.items.splice(index, 1);
        // Destroy the actual text object
        textItem.destroy();
    };
    MainScene.prototype.createTextItem = function (id, position) {
        var textItem = new __WEBPACK_IMPORTED_MODULE_7__objects_Item__["b" /* TextItem */](this, 0, 0, id);
        textItem.setPosition(position.x, position.y);
        textItem.startingPosition = textItem.getBounds();
        this.textItems.push(textItem);
        this.items.push(textItem);
        return textItem;
    };
    MainScene.prototype.addTextItems = function () {
        var _this = this;
        // Choose random numbers corresponding to Kuder's text assets to use as collage items
        this.textIds = new Set();
        while (this.textIds.size < this.NUMBER_OF_TEXT_ASSETS) {
            this.textIds.add(Phaser.Math.Between(1, 20));
        }
        this.textIds.forEach(function (id) {
            var position = _this.textItemPositions.pop();
            var item = _this.createTextItem(id, position);
        });
    };
    MainScene.prototype.update = function () {
        if (!this.gameOver) {
            this.updateToolGroup();
        }
    };
    MainScene.prototype.updateToolGroup = function () {
        var _this = this;
        if (this.currentItem == null) {
            return;
        }
        var bottomRight = this.getBottomRightCorner();
        // Make sure that the resize icon doesn't overlap with the image (happens when rotating)
        this.resizeIcon.setPosition(bottomRight.x, bottomRight.y);
        if (Phaser.Geom.Intersects.RectangleToRectangle(this.resizeIcon.getBounds(), this.currentItem.getBounds())) {
            if (this.resizeIcon.x < this.currentItem.x) {
                this.resizeIcon.x -= 30;
                this.resizeIcon.y -= 30;
            }
        }
        var rightOfImageX = this.currentItem.getCenter().x + Math.max(this.currentItem.displayWidth / 2, this.currentItem.displayHeight / 2) + 40;
        var topOfImageY = this.currentItem.getCenter().y - Math.min(this.currentItem.displayWidth / 2, this.currentItem.displayHeight / 2);
        Phaser.Actions.GridAlign(this.iconGroup.getChildren(), {
            x: rightOfImageX,
            y: topOfImageY,
            width: 4,
            height: 1,
            cellWidth: 30,
            cellHeight: 30,
        });
        if (this.resizing) {
            this.resizeIcon.setAlpha(0.3);
        }
        else {
            this.resizeIcon.setAlpha(1);
        }
        this.children.bringToTop(this.resizeIcon);
        // Bring the icons to the top so you can always see them
        this.iconGroup.getChildren().forEach(function (element) {
            _this.children.bringToTop(element);
        });
    };
    MainScene.prototype.getBottomRightCorner = function () {
        return this.currentItem.getBottomRight();
    };
    MainScene.prototype.getMaxHeight = function () {
        return this.currentItem.type === "TextItem" ? 400 : this.currentItem.height * 0.8;
    };
    MainScene.prototype.getMaxWidth = function () {
        return this.currentItem.type === "TextItem" ? 400 : this.currentItem.width * 0.8;
    };
    MainScene.prototype.getMinHeight = function () {
        return this.currentItem.type === "TextItem" ? 10 : this.currentItem.height * 0.1;
    };
    MainScene.prototype.getMinWidth = function () {
        return this.currentItem.type === "TextItem" ? 10 : this.currentItem.width * 0.1;
    };
    MainScene.prototype.getDeltaWidth = function () {
        return this.currentItem.displayWidth * 0.03;
    };
    MainScene.prototype.getDeltaHeight = function () {
        return this.currentItem.displayHeight * 0.03;
    };
    MainScene.prototype.resizeForBottomRightCorner = function (pointer, corner) {
        // Dragging right and down (increase size)
        if (pointer.x > corner.x && pointer.y > corner.y) {
            if (((this.currentItem.displayWidth + this.getDeltaWidth()) <= this.getMaxWidth()) &&
                ((this.currentItem.displayHeight + this.getDeltaHeight()) <= this.getMaxHeight())) {
                this.currentItem.displayWidth += this.getDeltaWidth();
                this.currentItem.displayHeight += this.getDeltaHeight();
            }
        }
        // Dragging left and up (decrease size)
        if (pointer.x < corner.x && pointer.y < corner.y) {
            if (((this.currentItem.displayWidth - this.getDeltaWidth()) >= this.getMinWidth()) &&
                ((this.currentItem.displayHeight - this.getDeltaHeight()) >= this.getMinHeight())) {
                this.currentItem.displayWidth -= this.getDeltaWidth();
                this.currentItem.displayHeight -= this.getDeltaHeight();
            }
        }
    };
    MainScene.prototype.resizeForTopRightCorner = function (pointer, corner) {
        // Dragging right and up (increase size)
        if (pointer.x > corner.x && pointer.y < corner.y) {
            if (((this.currentItem.displayHeight + this.getDeltaHeight()) <= this.getMaxHeight()) &&
                ((this.currentItem.displayWidth + this.getDeltaWidth()) <= this.getMaxWidth())) {
                this.currentItem.displayWidth += this.getDeltaWidth();
                this.currentItem.displayHeight += this.getDeltaHeight();
            }
        }
        // Dragging left and down (decrease size)
        if (pointer.x < corner.x && pointer.y > corner.y) {
            if (((this.currentItem.displayHeight - this.getDeltaHeight()) >= this.getMinHeight()) &&
                ((this.currentItem.displayWidth - this.getDeltaWidth()) >= this.getMinWidth())) {
                this.currentItem.displayWidth -= this.getDeltaWidth();
                this.currentItem.displayHeight -= this.getDeltaHeight();
            }
        }
    };
    MainScene.prototype.resizeForTopLeftCorner = function (pointer, corner) {
        // Dragging left and up (increase size)
        if (pointer.x < corner.x && pointer.y < corner.y) {
            if (((this.currentItem.displayHeight + this.getDeltaHeight()) <= this.getMaxHeight()) &&
                ((this.currentItem.displayWidth + this.getDeltaWidth()) <= this.getMaxWidth())) {
                this.currentItem.displayWidth += this.getDeltaWidth();
                this.currentItem.displayHeight += this.getDeltaHeight();
            }
        }
        // Dragging right and down (decrease size)
        if (pointer.x > corner.x && pointer.y > corner.y) {
            if (((this.currentItem.displayHeight - this.getDeltaHeight()) >= this.getMinHeight()) &&
                ((this.currentItem.displayWidth - this.getDeltaWidth()) >= this.getMinWidth())) {
                this.currentItem.displayWidth -= this.getDeltaWidth();
                this.currentItem.displayHeight -= this.getDeltaHeight();
            }
        }
    };
    MainScene.prototype.resizeForBottomLeftCorner = function (pointer, corner) {
        // Dragging left and down (increase size)
        if (pointer.x < corner.x && pointer.y > corner.y) {
            if (((this.currentItem.displayWidth + this.getDeltaWidth()) <= this.getMaxWidth()) &&
                ((this.currentItem.displayHeight + this.getDeltaHeight()) <= this.getMaxHeight())) {
                this.currentItem.displayWidth += this.getDeltaWidth();
                this.currentItem.displayHeight += this.getDeltaHeight();
            }
        }
        // Dragging right and up (decrease size)
        if (pointer.x > corner.x && pointer.y < corner.y) {
            if (((this.currentItem.displayWidth - this.getDeltaWidth()) >= this.getMinWidth()) &&
                ((this.currentItem.displayHeight - this.getDeltaHeight()) >= this.getMinHeight())) {
                this.currentItem.displayWidth -= this.getDeltaWidth();
                this.currentItem.displayHeight -= this.getDeltaHeight();
            }
        }
    };
    MainScene.prototype.setIconGroupVisible = function (visible) {
        this.iconGroup.getChildren().forEach(function (im) {
            im.setVisible(visible);
        });
    };
    MainScene.prototype.endGame = function (image) {
        this.sound.stopAll();
        this.gameOver = true;
        MainScene.CROPPED_IMAGE = image;
        this.input.setDefaultCursor("default");
        this.input.removeAllListeners();
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_6_src_games_CollageGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    /**
     * Tween/animation to put image back to the rock
     */
    MainScene.prototype.throwImageToTheGround = function (target, ease) {
        var startingSize = target.startingSize;
        var startingPosition = target.startingPosition;
        var startingAngle = target.startingAngle;
        this.tweens.add({
            targets: target,
            duration: 1000,
            ease: ease,
            x: startingPosition.x + startingPosition.width / 2,
            y: startingPosition.y + startingPosition.height / 2,
            angle: startingAngle,
            displayWidth: startingSize.x,
            displayHeight: startingSize.y,
        });
    };
    MainScene.prototype.restartGame = function () {
        var _this = this;
        var eases = [Phaser.Math.Easing.Back.InOut, Phaser.Math.Easing.Bounce.Out];
        var ease = eases[Phaser.Math.Between(0, 1)];
        this.items.forEach(function (item) {
            _this.currentItem = item;
            _this.putImageBackOnRock(ease);
        });
        this.currentItem = null;
        this.resizeIcon.setX(-100);
        this.setIconGroupVisible(false);
    };
    MainScene.prototype.IsOnCanvas = function (item) {
        return Phaser.Geom.Intersects.RectangleToRectangle(this.canvas, item.getBounds());
    };
    MainScene.CROPPED_IMAGE = null;
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paint_brush.949e902c.cur";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/delete_icon.873475d2.png";

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/accountant.651bbb87.png";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assistant.f1cc8582.png";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hospital-orderly.85be79b1.png";

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hotel-receptionist.994d50d9.png";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/librarian.1df03f86.png";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pharmacy-tech.eecf1c2d.png";

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrganizeDeskGameConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameState; });
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var OrganizeDeskGameConfig = /** @class */ (function () {
    function OrganizeDeskGameConfig() {
    }
    return OrganizeDeskGameConfig;
}());

/**
 * Represents the game state, passed around from scene to scene
 */
var GameState = /** @class */ (function () {
    function GameState(options) {
        this.deskNumber = 1;
        var config = __assign(__assign({}, new OrganizeDeskGameConfig()), options);
        this.mapKey = config.mapKey;
        this.deskSupplies = config.deskSupplies;
        this.deskGarbageItems = config.deskGarbageItems;
        this.deskOrder = config.deskOrder;
        this.spill = config.spill;
    }
    GameState.NUMBER_OF_DESKS = 4;
    return GameState;
}());



/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NPC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Question; });
/* unused harmony export NPCResponse */
var NPC = /** @class */ (function () {
    function NPC(id, name, assetKey, backgroundAssetKey, job, feedback, dialog) {
        this.id = id;
        this.name = name;
        this.assetKey = assetKey;
        this.backgroundAssetKey = backgroundAssetKey;
        this.job = job;
        this.feedback = feedback;
        this.responses = dialog;
        this.object = null;
        this.enabled = true;
        this.talkedTo = false;
        this.picked = false;
    }
    /**
     * Translation keys stored instead of english
     */
    NPC.NPC_1 = new NPC(1, "FitFive.Phaser.NPCS.1.name", "astro-flares", "gym-zoomed-5", "FitFive.Phaser.NPCS.1.job", "FitFive.Phaser.NPCS.1.feedback", [
        { questionId: 0, textID: "FitFive.Phaser.NPCS.1.dialog.1" },
        { questionId: 1, textID: "FitFive.Phaser.NPCS.1.dialog.2" },
        { questionId: 2, textID: "FitFive.Phaser.NPCS.1.dialog.3" },
        { questionId: 3, textID: "FitFive.Phaser.NPCS.1.dialog.4" },
    ]);
    NPC.NPC_2 = new NPC(2, "FitFive.Phaser.NPCS.2.name", "pluto-tera", "gym-zoomed-4", "FitFive.Phaser.NPCS.2.job", "FitFive.Phaser.NPCS.2.feedback", [
        { questionId: 0, textID: "FitFive.Phaser.NPCS.2.dialog.1" },
        { questionId: 1, textID: "FitFive.Phaser.NPCS.2.dialog.2" },
        { questionId: 2, textID: "FitFive.Phaser.NPCS.2.dialog.3" },
        { questionId: 3, textID: "FitFive.Phaser.NPCS.2.dialog.4" },
    ]);
    NPC.NPC_3 = new NPC(3, "FitFive.Phaser.NPCS.3.name", "beta-borealis", "gym-zoomed-1", "FitFive.Phaser.NPCS.3.job", "FitFive.Phaser.NPCS.3.feedback", [
        { questionId: 0, textID: "FitFive.Phaser.NPCS.3.dialog.1" },
        { questionId: 1, textID: "FitFive.Phaser.NPCS.3.dialog.2" },
        { questionId: 2, textID: "FitFive.Phaser.NPCS.3.dialog.3" },
        { questionId: 3, textID: "FitFive.Phaser.NPCS.3.dialog.4" },
    ]);
    NPC.NPC_4 = new NPC(4, "FitFive.Phaser.NPCS.4.name", "neptuna-neutron", "gym-zoomed-2", "FitFive.Phaser.NPCS.4.job", "FitFive.Phaser.NPCS.4.feedback", [
        { questionId: 0, textID: "FitFive.Phaser.NPCS.4.dialog.1" },
        { questionId: 1, textID: "FitFive.Phaser.NPCS.4.dialog.2" },
        { questionId: 2, textID: "FitFive.Phaser.NPCS.4.dialog.3" },
        { questionId: 3, textID: "FitFive.Phaser.NPCS.4.dialog.4" },
    ]);
    NPC.NPC_5 = new NPC(5, "FitFive.Phaser.NPCS.5.name", "sunny-system", "gym-zoomed-3", "FitFive.Phaser.NPCS.5.job", "FitFive.Phaser.NPCS.5.feedback", [
        { questionId: 0, textID: "FitFive.Phaser.NPCS.5.dialog.1" },
        { questionId: 1, textID: "FitFive.Phaser.NPCS.5.dialog.2" },
        { questionId: 2, textID: "FitFive.Phaser.NPCS.5.dialog.3" },
        { questionId: 3, textID: "FitFive.Phaser.NPCS.5.dialog.4" },
    ]);
    NPC.ALL_NPCS = [
        NPC.NPC_1,
        NPC.NPC_2,
        NPC.NPC_3,
        NPC.NPC_4,
        NPC.NPC_5,
    ];
    return NPC;
}());

/**
 * Stores the question ID, the translation key, and whether it's been asked or not
 */
var Question = /** @class */ (function () {
    function Question() {
    }
    Question.HELLO = { id: 0, textID: "FitFive.Phaser.NPCS.%.dialog.1", asked: false }; // "Thank you for answering my three questions. Your answers will help me decide who will help Cosmos the most. I must return to the picture wall now."
    Question.QUESTIONS = [
        { id: 1, textID: "FitFive.Phaser.TalkToNPCScene.StudentQuestions.1", asked: false },
        { id: 2, textID: "FitFive.Phaser.TalkToNPCScene.StudentQuestions.2", asked: false },
        { id: 3, textID: "FitFive.Phaser.TalkToNPCScene.StudentQuestions.3", asked: false },
        { id: 4, textID: "FitFive.Phaser.TalkToNPCScene.studentGoodbye", asked: false } // "Thank you for answering my three questions. Your answers will help me decide who will help Cosmos the most. I must return to the picture wall now."
    ];
    return Question;
}());

/**
 * Stores the corresponding question ID and the translation key
 */
var NPCResponse = /** @class */ (function () {
    function NPCResponse() {
    }
    return NPCResponse;
}());



/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Response */
/* unused harmony export AlienStudentInteraction */
/* unused harmony export Dialog */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlienPatron; });
var Response = /** @class */ (function () {
    function Response() {
    }
    return Response;
}());

/**
 * Represents one interaction between the student and AlienPatron
 * Alien asks a question, student has two possible responses
 */
var AlienStudentInteraction = /** @class */ (function () {
    function AlienStudentInteraction() {
    }
    return AlienStudentInteraction;
}());

/**
 * Represents an AlienPatron's dialog with the student (sequence of interactions)
 */
var Dialog = /** @class */ (function () {
    /**
     * AnswerPatronQuestionScene translates using these keys
     */
    function Dialog() {
        this.translateString = "HotelAurora.Phaser.AlienStudentInteractions.";
        this.interactions = [
            {
                alienQuestion: this.translateString + "1.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "1.responses.1",
                        points: 2,
                    },
                    {
                        text: this.translateString + "1.responses.2",
                        points: 1,
                    },
                    {
                        text: this.translateString + "1.responses.3",
                        points: -1,
                    }
                ]
            },
            {
                alienQuestion: this.translateString + "2.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "2.responses.1",
                        points: -1,
                    },
                    {
                        text: this.translateString + "2.responses.2",
                        points: 1,
                    },
                    {
                        text: this.translateString + "2.responses.3",
                        points: 2,
                    }
                ]
            },
            {
                alienQuestion: this.translateString + "3.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "3.responses.1",
                        points: 1,
                    },
                    {
                        text: this.translateString + "3.responses.2",
                        points: 2,
                    },
                    {
                        text: this.translateString + "3.responses.3",
                        points: -1,
                    }
                ]
            },
            {
                alienQuestion: this.translateString + "4.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "4.responses.1",
                        points: 2,
                    },
                    {
                        text: this.translateString + "4.responses.2",
                        points: 0,
                    },
                    {
                        text: this.translateString + "4.responses.3",
                        points: -1,
                    }
                ]
            },
            {
                alienQuestion: this.translateString + "5.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "5.responses.1",
                        points: 1,
                    },
                    {
                        text: this.translateString + "5.responses.2",
                        points: -1,
                    },
                    {
                        text: this.translateString + "5.responses.3",
                        points: 2,
                    }
                ]
            },
            {
                alienQuestion: this.translateString + "6.alienQuestion",
                responses: [
                    {
                        text: this.translateString + "6.responses.1",
                        points: 2,
                    },
                    {
                        text: this.translateString + "6.responses.2",
                        points: -1,
                    },
                    {
                        text: this.translateString + "6.responses.3",
                        points: 0,
                    }
                ]
            }
        ];
    }
    return Dialog;
}());

var AlienPatron = /** @class */ (function () {
    function AlienPatron(id, assetKey) {
        this.id = id;
        this.assetKey = assetKey;
        this.object = null;
        this.dialog = new Dialog();
    }
    AlienPatron.ALL_PATRONS = [
        new AlienPatron(1, "alien_1"),
        new AlienPatron(2, "alien_2"),
        new AlienPatron(3, "alien_3"),
    ];
    return AlienPatron;
}());



/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Utils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__ = __webpack_require__(16);



/**
 * Helpers
 */
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.getButtonConfig = function () {
        var config = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.backgroundColor = this.E_COLOR;
        return config;
    };
    Utils.getModalConfig = function (title, buttonWidth) {
        var config = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
        config.title = title;
        config.buttonWidth = buttonWidth;
        config.buttonConfig = this.getButtonConfig();
        return config;
    };
    Utils.createPatronImage = function (scene, ob, assetKey) {
        var patronImage = scene.add.image(ob.x, ob.y, assetKey);
        patronImage.setOrigin(0);
        patronImage.setDisplaySize(ob.width, ob.height);
        patronImage.name = "patron";
        return patronImage;
    };
    Utils.createDialog = function (scene, ob, text) {
        var padding = 30;
        var textStyle = { fontSize: 22, color: "#F8E71C", fontFamily: 'Roboto Mono, Arial', padding: padding };
        var textObject = scene.add.text(ob.x, ob.y, text, textStyle);
        textObject.setOrigin(0);
        textObject.setWordWrapWidth(ob.width - 2 * padding, true);
        textObject.setDepth(10);
        textObject.name = "patronText";
        // Background for the dialog that spans across the scene
        var outline = scene.add.image(ob.x - 5, ob.y - 5, "pixel");
        outline.setOrigin(0);
        outline.setTint(this.E_COLOR);
        outline.setDisplaySize(ob.width + 10, ob.height + 10);
        var background = scene.add.image(ob.x, ob.y, "pixel");
        background.setOrigin(0);
        background.setDepth(0);
        background.setDisplaySize(ob.width, ob.height);
        background.setTint(0x000000);
        return textObject;
    };
    /**
     * Shuffle the responses so they're not in the same order every time
     * https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
     */
    Utils.scrambleResponses = function (patron) {
        patron.dialog.interactions.forEach(function (interaction) {
            var j, x, i;
            var responses = interaction.responses;
            for (i = responses.length - 1; i > 0; i--) {
                j = Math.floor(Math.random() * (i + 1));
                x = responses[i];
                responses[i] = responses[j];
                responses[j] = x;
            }
        });
    };
    // Planet E Color
    Utils.E_COLOR = __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("E");
    return Utils;
}());



/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameState; });
var GameState = /** @class */ (function () {
    function GameState() {
        this.alienIndex = 0;
        this.dialogIndex = 0;
        this.score = 0;
    }
    return GameState;
}());



/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FilterType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var NS = 'http://www.w3.org/2000/svg';
/**
 * All the possible SVG filters that can be applied
 */
var FilterType;
(function (FilterType) {
    FilterType["Blend"] = "feBlend";
    FilterType["ColorMatrix"] = "feColorMatrix";
    FilterType["ComponentTransfer"] = "feComponentTransfer";
    FilterType["Composite"] = "feComposite";
    FilterType["ConvolveMatrix"] = "feConvolveMatrix";
    FilterType["DiffuseLighting"] = "feDiffuseLighting";
    FilterType["DisplacementMap"] = "feDisplacementMap";
    FilterType["Flood"] = "feFlood";
    FilterType["GaussianBlur"] = "feGaussianBlur";
    FilterType["Image"] = "feImage";
    FilterType["Merge"] = "feMerge";
    FilterType["Morphology"] = "feMorphology";
    FilterType["Offset"] = "feOffset";
    FilterType["SpecularLighting"] = "feSpecularLighting";
    FilterType["Tile"] = "feTile";
    FilterType["Turbulence"] = "feTurbulence";
})(FilterType || (FilterType = {}));
var SVGComponent = /** @class */ (function (_super) {
    __extends(SVGComponent, _super);
    function SVGComponent(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, SVGComponent.prototype);
        return _this;
    }
    SVGComponent.prototype.componentDidUpdate = function (prevProps) {
        if (this.props !== prevProps && this.svg) {
            this.restyleSVG();
        }
    };
    SVGComponent.prototype.onLoad = function (e) {
        // If an onLoad function is specified, call it
        if (this.props.onLoad) {
            this.props.onLoad(e);
        }
        this.svg = e.currentTarget.contentDocument.rootElement;
        this.restyleSVG();
    };
    SVGComponent.prototype.restyleSVG = function () {
        if (this.svg != null) {
            var i = 0;
            // If a style was provided, then apply the attributes to the SVG
            var length = this.svg.children.length;
            if (this.props.style) {
                for (i = 0; i < length; ++i) {
                    for (var attribute in this.props.style) {
                        if (this.props.style[attribute]) {
                            this.svg.children[i].setAttribute(attribute, this.props.style[attribute]);
                        }
                    }
                }
            }
            // If a filter was provided, then create DOM elements to apply filter to SVG
            if (this.props.filter != null) {
                // Make sure the filter is referenced
                for (i = 0; i < length; ++i) {
                    this.svg.children[i].setAttribute('filter', 'url(#' + this.props.filter.id + ')');
                }
                // Create filter element
                var filter = document.createElementNS(NS, 'filter');
                filter.setAttribute('id', this.props.filter.id);
                // Add filter types to filter element
                length = this.props.filter.filters.length;
                for (i = 0; i < length; ++i) {
                    filter.appendChild(this.createFilter(this.props.filter.filters[i]));
                }
                if (this.svg.contains(this.filter)) {
                    this.svg.removeChild(this.filter);
                }
                this.filter = this.svg.appendChild(filter);
            }
        }
    };
    SVGComponent.prototype.createFilter = function (filter) {
        var filterType = filter.filterType, props = __rest(filter, ["filterType"]);
        // Create the filter type and set it's attributes
        var filterElement = document.createElementNS(NS, filterType);
        for (var attribute in props) {
            if (props[attribute]) {
                filterElement.setAttribute(attribute, props[attribute]);
            }
        }
        return filterElement;
    };
    SVGComponent.prototype.render = function () {
        var _a = this.props, data = _a.data, filter = _a.filter, onLoad = _a.onLoad, path = _a.path, type = _a.type, props = __rest(_a, ["data", "filter", "onLoad", "path", "type"]);
        if (!path && data) {
            path = data;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("object", __assign({}, props, { data: path, type: 'image/svg+xml', onLoad: this.onLoad }), this.props.children);
    };
    return SVGComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SVGComponent);


/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YouTube = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(112);

var _singlePlayer = __webpack_require__(156);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=/;
var MATCH_PLAYLIST = /list=([a-zA-Z0-9_-]+)/;

function parsePlaylist(url) {
  if (MATCH_PLAYLIST.test(url)) {
    var _url$match = url.match(MATCH_PLAYLIST),
        _url$match2 = _slicedToArray(_url$match, 2),
        playlistId = _url$match2[1];

    return {
      listType: 'playlist',
      list: playlistId
    };
  }
  return {};
}

var YouTube = exports.YouTube = function (_Component) {
  _inherits(YouTube, _Component);

  function YouTube() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onStateChange = function (_ref2) {
      var data = _ref2.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady,
          loop = _this$props.loop;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;

      if (data === PLAYING) onPlay();
      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();
      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer('getPlaylist');
        if (loop && !isPlaylist) {
          _this.play(); // Only loop manually if not playing a playlist
        }
        onEnded();
      }
      if (data === CUED) onReady();
    }, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unMute');
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(YouTube, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          muted = _props.muted,
          playsinline = _props.playsinline,
          controls = _props.controls,
          loop = _props.loop,
          config = _props.config,
          _onError = _props.onError;
      var _config$youtube = config.youtube,
          playerVars = _config$youtube.playerVars,
          embedOptions = _config$youtube.embedOptions;

      var id = url && url.match(MATCH_URL)[1];
      if (isReady) {
        if (MATCH_PLAYLIST.test(url)) {
          this.player.loadPlaylist(parsePlaylist(url));
          return;
        }
        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, _extends({
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _extends({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, _utils.parseStartTime)(url),
            end: (0, _utils.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline
          }, parsePlaylist(url), playerVars),
          events: {
            onReady: _this2.props.onReady,
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          }
        }, embedOptions));
        if (loop) {
          _this2.player.setLoop(true); // Enable playlist looping
        }
      }, _onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);
      if (!this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: 'setLoop',
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%'
      }, this.props.style);
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }]);

  return YouTube;
}(_react.Component);

YouTube.displayName = 'YouTube';

YouTube.canPlay = function (url) {
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(YouTube);

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(371);

var _utils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = function (_Component) {
  _inherits(Player, _Component);

  function Player() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Player.__proto__ || Object.getPrototypeOf(Player)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.isReady = false, _this.isPlaying = false, _this.isLoading = true, _this.loadOnReady = null, _this.startOnPlay = true, _this.seekOnPlay = null, _this.onDurationCalled = false, _this.getInternalPlayer = function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    }, _this.progress = function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;
        var loadedSeconds = _this.getSecondsLoaded();
        var duration = _this.getDuration();
        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };
          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          }
          // Only call onProgress if values have changed
          if (progress.played !== _this.prevPlayed || progress.loaded !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }
          _this.prevPlayed = progress.played;
          _this.prevLoaded = progress.loaded;
        }
      }
      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    }, _this.onReady = function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;

      onReady();
      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }
      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);
        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }
      _this.onDurationCheck();
    }, _this.onPlay = function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate) {
          _this.player.setPlaybackRate(playbackRate);
        }
        onStart();
        _this.startOnPlay = false;
      }
      onPlay();
      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);
        _this.seekOnPlay = null;
      }
      _this.onDurationCheck();
    }, _this.onPause = function (e) {
      _this.isPlaying = false;
      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    }, _this.onEnded = function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }
      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    }, _this.onError = function (e) {
      _this.isLoading = false;
      _this.props.onError(e);
    }, _this.onDurationCheck = function () {
      clearTimeout(_this.durationCheckTimeout);
      var duration = _this.getDuration();
      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);
          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.onDurationCheck, 100);
      }
    }, _this.onLoaded = function () {
      // Sometimes we know loading has stopped but onReady/onPlay are never called
      // so this provides a way for players to avoid getting stuck
      _this.isLoading = false;
    }, _this.ref = function (player) {
      if (player) {
        _this.player = player;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // Track playing state internally to prevent bugs
  // Use isLoading to prevent onPause when switching URL


  _createClass(Player, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.player.load(this.props.url);
      this.progress();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);
      if (this.isReady) {
        this.player.stop();
      }
      if (this.player.disablePIP) {
        this.player.disablePIP();
      }
      this.mounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // Invoke player methods based on incoming props
      var _props = this.props,
          url = _props.url,
          playing = _props.playing,
          volume = _props.volume,
          muted = _props.muted,
          playbackRate = _props.playbackRate,
          pip = _props.pip,
          loop = _props.loop;

      if (!(0, _utils.isEqual)(url, nextProps.url)) {
        if (this.isLoading) {
          console.warn('ReactPlayer: the attempt to load ' + nextProps.url + ' is being deferred until the player has loaded');
          this.loadOnReady = nextProps.url;
          return;
        }
        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(nextProps.url, this.isReady);
      }
      if (!playing && nextProps.playing && !this.isPlaying) {
        this.player.play();
      }
      if (playing && !nextProps.playing && this.isPlaying) {
        this.player.pause();
      }
      if (!pip && nextProps.pip && this.player.enablePIP) {
        this.player.enablePIP();
      } else if (pip && !nextProps.pip && this.player.disablePIP) {
        this.player.disablePIP();
      }
      if (volume !== nextProps.volume && nextProps.volume !== null) {
        this.player.setVolume(nextProps.volume);
      }
      if (muted !== nextProps.muted) {
        if (nextProps.muted) {
          this.player.mute();
        } else {
          this.player.unmute();
          if (nextProps.volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(nextProps.volume);
            });
          }
        }
      }
      if (playbackRate !== nextProps.playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(nextProps.playbackRate);
      }
      if (loop !== nextProps.loop && this.player.setLoop) {
        this.player.setLoop(nextProps.loop);
      }
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: 'seekTo',
    value: function seekTo(amount, type) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(function () {
          _this3.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
        return;
      }
      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';
      if (isFraction) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();
        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }
        this.player.seekTo(duration * amount);
        return;
      }
      this.player.seekTo(amount);
    }
  }, {
    key: 'render',
    value: function render() {
      var Player = this.props.activePlayer;
      if (!Player) {
        return null;
      }
      return _react2['default'].createElement(Player, _extends({}, this.props, {
        ref: this.ref,
        onReady: this.onReady,
        onPlay: this.onPlay,
        onPause: this.onPause,
        onEnded: this.onEnded,
        onLoaded: this.onLoaded,
        onError: this.onError
      }));
    }
  }]);

  return Player;
}(_react.Component);

Player.displayName = 'Player';
Player.propTypes = _props2.propTypes;
Player.defaultProps = _props2.defaultProps;
exports['default'] = Player;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundCloud = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(112);

var _singlePlayer = __webpack_require__(156);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';
var MATCH_URL = /(soundcloud\.com|snd\.sc)\/.+$/;

var SoundCloud = exports.SoundCloud = function (_Component) {
  _inherits(SoundCloud, _Component);

  function SoundCloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.fractionLoaded = null, _this.mute = function () {
      _this.setVolume(0);
    }, _this.unmute = function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SoundCloud, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
        if (!_this2.iframe) return;
        var _SC$Widget$Events = SC.Widget.Events,
            PLAY = _SC$Widget$Events.PLAY,
            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
            PAUSE = _SC$Widget$Events.PAUSE,
            FINISH = _SC$Widget$Events.FINISH,
            ERROR = _SC$Widget$Events.ERROR;

        if (!isReady) {
          _this2.player = SC.Widget(_this2.iframe);
          _this2.player.bind(PLAY, _this2.props.onPlay);
          _this2.player.bind(PAUSE, _this2.props.onPause);
          _this2.player.bind(PLAY_PROGRESS, function (e) {
            _this2.currentTime = e.currentPosition / 1000;
            _this2.fractionLoaded = e.loadedProgress;
          });
          _this2.player.bind(FINISH, function () {
            return _this2.props.onEnded();
          });
          _this2.player.bind(ERROR, function (e) {
            return _this2.props.onError(e);
          });
        }
        _this2.player.load(url, _extends({}, _this2.props.config.soundcloud.options, {
          callback: function callback() {
            _this2.player.getDuration(function (duration) {
              _this2.duration = duration / 1000;
              _this2.props.onReady();
            });
          }
        }));
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seekTo', seconds * 1000);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%'
      }, this.props.style);
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        src: 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(this.props.url),
        style: style,
        frameBorder: 0
      });
    }
  }]);

  return SoundCloud;
}(_react.Component);

SoundCloud.displayName = 'SoundCloud';

SoundCloud.canPlay = function (url) {
  return MATCH_URL.test(url);
};

SoundCloud.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(SoundCloud);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vimeo = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(112);

var _singlePlayer = __webpack_require__(156);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';
var MATCH_URL = /vimeo\.com\/.+/;
var MATCH_FILE_URL = /vimeo\.com\/external\/.+\.mp4/;

var Vimeo = exports.Vimeo = function (_Component) {
  _inherits(Vimeo, _Component);

  function Vimeo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      _this.setVolume(0);
    }, _this.unmute = function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Vimeo, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      this.duration = null;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
        if (!_this2.container) return;
        _this2.player = new Vimeo.Player(_this2.container, _extends({
          url: url,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          loop: _this2.props.loop,
          playsinline: _this2.props.playsinline
        }, _this2.props.config.vimeo.playerOptions));
        _this2.player.ready().then(function () {
          var iframe = _this2.container.querySelector('iframe');
          iframe.style.width = '100%';
          iframe.style.height = '100%';
        })['catch'](_this2.props.onError);
        _this2.player.on('loaded', function () {
          _this2.props.onReady();
          _this2.refreshDuration();
        });
        _this2.player.on('play', function () {
          _this2.props.onPlay();
          _this2.refreshDuration();
        });
        _this2.player.on('pause', _this2.props.onPause);
        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });
        _this2.player.on('ended', _this2.props.onEnded);
        _this2.player.on('error', _this2.props.onError);
        _this2.player.on('timeupdate', function (_ref2) {
          var seconds = _ref2.seconds;

          _this2.currentTime = seconds;
        });
        _this2.player.on('progress', function (_ref3) {
          var seconds = _ref3.seconds;

          _this2.secondsLoaded = seconds;
        });
      }, this.props.onError);
    }
  }, {
    key: 'refreshDuration',
    value: function refreshDuration() {
      var _this3 = this;

      this.player.getDuration().then(function (duration) {
        _this3.duration = duration;
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.callPlayer('unload');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'setLoop',
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: 'black'
      }, this.props.style);
      return _react2['default'].createElement('div', {
        key: this.props.url,
        ref: this.ref,
        style: style
      });
    }
  }]);

  return Vimeo;
}(_react.Component);

Vimeo.displayName = 'Vimeo';

Vimeo.canPlay = function (url) {
  if (MATCH_FILE_URL.test(url)) {
    return false;
  }
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(Vimeo);

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DailyMotion = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(112);

var _singlePlayer = __webpack_require__(156);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';
var MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;

var DailyMotion = exports.DailyMotion = function (_Component) {
  _inherits(DailyMotion, _Component);

  function DailyMotion() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DailyMotion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DailyMotion.__proto__ || Object.getPrototypeOf(DailyMotion)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onDurationChange = function () {
      var duration = _this.getDuration();
      _this.props.onDuration(duration);
    }, _this.mute = function () {
      _this.callPlayer('setMuted', true);
    }, _this.unmute = function () {
      _this.callPlayer('setMuted', false);
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DailyMotion, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props = this.props,
          controls = _props.controls,
          config = _props.config,
          onError = _props.onError,
          playing = _props.playing;

      var _url$match = url.match(MATCH_URL),
          _url$match2 = _slicedToArray(_url$match, 2),
          id = _url$match2[1];

      if (this.player) {
        this.player.load(id, {
          start: (0, _utils.parseStartTime)(url),
          autoplay: playing
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
        return DM.player;
      }).then(function (DM) {
        if (!_this2.container) return;
        var Player = DM.player;
        _this2.player = new Player(_this2.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: _extends({
            controls: controls,
            autoplay: _this2.props.playing,
            mute: _this2.props.muted,
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }, config.dailymotion.params),
          events: {
            apiready: _this2.props.onReady,
            seeked: function seeked() {
              return _this2.props.onSeek(_this2.player.currentTime);
            },
            video_end: _this2.props.onEnded,
            durationchange: _this2.onDurationChange,
            pause: _this2.props.onPause,
            playing: _this2.props.onPlay,
            waiting: _this2.props.onBuffer,
            error: function error(event) {
              return onError(event);
            }
          }
        });
      }, onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.player.duration || null;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.player.bufferedTime;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%',
        backgroundColor: 'black'
      }, this.props.style);
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }]);

  return DailyMotion;
}(_react.Component);

DailyMotion.displayName = 'DailyMotion';

DailyMotion.canPlay = function (url) {
  return MATCH_URL.test(url);
};

DailyMotion.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(DailyMotion);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UpdateScene__ = __webpack_require__(2755);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var EventScene = /** @class */ (function (_super) {
    __extends(EventScene, _super);
    function EventScene() {
        var _this = _super.call(this, {
            key: "EventScene"
        }) || this;
        _this.initialized = false;
        _this.speed = 100;
        _this.generalSize = 64;
        _this.xVel = 0;
        _this.yVel = 0;
        return _this;
    }
    EventScene.prototype.init = function (data) {
        console.warn("Running Init", EventScene.name, data); // JB - Remove this console.warn
        // this.scene.restart();
        if (data != null && this.initialized) {
            this.player.setPosition(data.x, data.y);
        }
    };
    EventScene.prototype.preload = function () {
        this.load.image("background", __webpack_require__(516));
        this.load.image("player", __webpack_require__(192));
        this.load.image("pixel", __webpack_require__(60));
        __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
    };
    EventScene.prototype.create = function () {
        if (this.initialized) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(this, EventScene.prototype);
        this.input.addPointer(6);
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.createObjects();
        this.bindEvents();
        this.initialized = true;
    };
    EventScene.prototype.createObjects = function () {
        var _this = this;
        var blackground = this.add.image(0, 0, "background")
            .setOrigin(0)
            .setTint(0xddffdd);
        var overlay = this.add.text(16, 16, "This demo uses an event driven approach to moving the player around", {
            fontSize: '24px',
            fill: '#ffffff'
        });
        var switcherButton = this.add.image(this.sys.canvas.width - 128 - 16, 16, "pixel");
        switcherButton.setTint(0x003355);
        switcherButton.setDisplaySize(128, 64);
        switcherButton.setInteractive();
        switcherButton.setDepth(2);
        switcherButton.on("pointerdown", function () {
            _this.scene.remove(_this);
            // GameState.current = new GameState();
            // var nextSceneObject = Helpers.getNextScene(GameState.current.sceneNumber);
            // GameState.current.sceneNumber += 1;
            _this.scene.remove(_this);
            _this.scene.add("UpdateScene", __WEBPACK_IMPORTED_MODULE_2__UpdateScene__["a" /* UpdateScene */], true);
            // this.scene.switch(UpdateScene.name);
            // this.scene.setActive(false, "BaseScene");
            // this.scene.setVisible(false, "BaseScene");
            // this.scene.start(UpdateScene.name, new Phaser.Geom.Rectangle(this.player.x, this.player.y));
            // this.scene.pause(EventScene.name);
        });
        var buttonText = this.add.text(switcherButton.x, switcherButton.y, "Flip!", {
            fontSize: '16px',
            fill: '#ffffff'
        });
        buttonText.setDepth(2);
        Phaser.Display.Align.In.Center(buttonText, switcherButton);
        this.player = this.physics.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "player");
        this.player.setOrigin(.5);
        this.player.setDisplaySize(this.generalSize, this.generalSize);
        // START DEBUG CODE
        // let coolPlayer = this.physics.add.image((this.sys.canvas.width / 2) + 90, (this.sys.canvas.height / 2), "player");
        // coolPlayer.setOrigin(.5);
        // coolPlayer.setDisplaySize(this.generalSize, this.generalSize);
        // coolPlayer.setInteractive();
        // this.input.keyboard.on("keydown_L", (a, b, c, d) => {
        //     console.warn("Getting A", a, b, c, d); // JB - Remove this console.warn
        // });
        // this.input.keyboard.on("keydown_J", (a, b, c, d) => {
        //     console.warn("Getting J", a, b, c, d); // JB - Remove this console.warn
        // });
        // this.player.setInteractive();
        // this.player.on("pointerdown", (a, b, c) => {
        //     console.warn("pointer down on player", a, b, c);
        // });
        // coolPlayer.on("pointerdown", (a, b, c) => {
        //     console.warn("pointer down on coolPlayer", a, b, c);
        // });
        // this.input.on("pointerup", (a: Phaser.Input.Pointer, b, c) => {
        //     console.warn("pointerup on input", a, b, c);
        // });
        // this.player.on("pointerup", (a, b, c) => {
        //     console.warn("pointerup on player", a, b, c);
        // });
        // coolPlayer.on("pointerup", (a, b, c) => {
        //     console.warn("pointerup on coolPlayer", a, b, c);
        // });
        // END DEBUG CODE
    };
    EventScene.prototype.bindEvents = function () {
        this.gamePad.on("keydown_up", this.moveUpStart);
        this.gamePad.on("keydown_down", this.moveDownStart);
        this.gamePad.on("keydown_left", this.moveLeftStart);
        this.gamePad.on("keydown_right", this.moveRightStart);
        this.gamePad.on("keydown_a", this.aDownStart);
        this.gamePad.on("keydown_b", this.bDownStart);
        this.gamePad.on("keyup_up", this.moveUpStop);
        this.gamePad.on("keyup_down", this.moveDownStop);
        this.gamePad.on("keyup_left", this.moveLeftStop);
        this.gamePad.on("keyup_right", this.moveRightStop);
        this.gamePad.on("keyup_a", this.stopAB);
        this.gamePad.on("keyup_b", this.stopAB);
    };
    EventScene.prototype.moveUpStart = function () {
        console.warn("Move up Received in scene"); // JB - Remove this console.warn
        this.yVel += -this.speed;
        this.updateVelocity();
    };
    EventScene.prototype.moveDownStart = function () {
        this.yVel += this.speed;
        this.updateVelocity();
    };
    EventScene.prototype.moveLeftStart = function () {
        this.xVel += -this.speed;
        this.updateVelocity();
    };
    EventScene.prototype.moveRightStart = function () {
        this.xVel += this.speed;
        this.updateVelocity();
    };
    EventScene.prototype.moveUpStop = function () {
        this.yVel -= -this.speed;
        this.updateVelocity();
    };
    EventScene.prototype.moveDownStop = function () {
        this.yVel -= this.speed;
        this.updateVelocity();
    };
    EventScene.prototype.moveLeftStop = function () {
        this.xVel -= -this.speed;
        this.updateVelocity();
    };
    EventScene.prototype.moveRightStop = function () {
        this.xVel -= this.speed;
        this.updateVelocity();
    };
    EventScene.prototype.aDownStart = function () {
        // this.player.setDisplaySize(this.generalSize / 2, this.generalSize / 2);
        this.updateVelocity();
    };
    EventScene.prototype.bDownStart = function () {
        // this.player.setDisplaySize(this.generalSize * 3, this.generalSize * 3);
        this.updateVelocity();
    };
    EventScene.prototype.stopAB = function () {
        // this.player.setDisplaySize(this.generalSize, this.generalSize);
        this.updateVelocity();
    };
    EventScene.prototype.updateVelocity = function () {
        console.log('updating in event scene');
        var scale = 1;
        if (this.gamePad.keys.a.isDown) {
            scale = .5;
        }
        else if (this.gamePad.keys.b.isDown) {
            scale = 3;
        }
        this.player.setDisplaySize(this.generalSize * scale, this.generalSize * scale);
        this.player.setVelocity(this.xVel * scale, this.yVel * scale);
        // Get flip
        if (this.xVel !== 0 && (this.gamePad.keys.left.isDown || this.gamePad.keys.right.isDown)) {
            this.player.setFlipX(this.xVel < 0);
        }
    };
    EventScene.prototype.update = function () {
        // NOOP
    };
    return EventScene;
}(Phaser.Scene));



/***/ }),
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(1850)

var flat = module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step(object, prev, currentDepth) {
    currentDepth = currentDepth ? currentDepth : 1
    Object.keys(object).forEach(function(key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey(key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1
    ) ? key
      : parsedKey
  }

  Object.keys(target).forEach(function(key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      if (key1 === '__proto__') { return }
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withLocalize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocalizeContext__ = __webpack_require__(336);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function withLocalize(WrappedComponent) {
  var LocalizedComponent = function LocalizedComponent(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__LocalizeContext__["a" /* LocalizeContext */].Consumer,
      null,
      function (context) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, context, props));
      }
    );
  };

  return LocalizedComponent;
}

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Telemetry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Initialization; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_analytics_js__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_channel_js__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_dependencies_js__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__microsoft_applicationinsights_properties_js__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InternalConstants__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DynamicConstants__ = __webpack_require__(494);
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */












var _internalSdkSrc;
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var _ignoreUpdateSnippetProperties = [
    __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["j" /* STR_SNIPPET */], "dependencies", "properties", "_snippetVersion", "appInsightsNew", "getSKUDefaults"
];
// Re-exposing the Common classes as Telemetry, the list was taken by reviewing the generated code for the build while using
// the previous configuration :-
// import * as Common from "@microsoft/applicationinsights-common"
// export const Telemetry = Common;
var fieldType = {
    Default: 0 /* FieldType.Default */,
    Required: 1 /* FieldType.Required */,
    Array: 2 /* FieldType.Array */,
    Hidden: 4 /* FieldType.Hidden */
};
/**
 * Telemetry type classes, e.g. PageView, Exception, etc
 */
var Telemetry = {
    __proto__: null,
    PropertiesPluginIdentifier: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["x" /* PropertiesPluginIdentifier */],
    BreezeChannelIdentifier: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["b" /* BreezeChannelIdentifier */],
    AnalyticsPluginIdentifier: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["a" /* AnalyticsPluginIdentifier */],
    Util: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["F" /* Util */],
    CorrelationIdHelper: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["f" /* CorrelationIdHelper */],
    UrlHelper: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["E" /* UrlHelper */],
    DateTimeUtils: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["l" /* DateTimeUtils */],
    ConnectionStringParser: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["d" /* ConnectionStringParser */],
    FieldType: fieldType,
    RequestHeaders: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["z" /* RequestHeaders */],
    DisabledPropertyName: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["m" /* DisabledPropertyName */],
    ProcessLegacy: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["w" /* ProcessLegacy */],
    SampleRate: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["A" /* SampleRate */],
    HttpMethod: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["s" /* HttpMethod */],
    DEFAULT_BREEZE_ENDPOINT: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["h" /* DEFAULT_BREEZE_ENDPOINT */],
    Envelope: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["o" /* Envelope */],
    Event: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["p" /* Event */],
    Exception: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["q" /* Exception */],
    Metric: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["t" /* Metric */],
    PageView: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["u" /* PageView */],
    RemoteDependencyData: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["y" /* RemoteDependencyData */],
    Trace: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["D" /* Trace */],
    PageViewPerformance: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["v" /* PageViewPerformance */],
    Data: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["j" /* Data */],
    SeverityLevel: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["B" /* SeverityLevel */],
    ConfigurationManager: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* ConfigurationManager */],
    ContextTagKeys: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["e" /* ContextTagKeys */],
    DataSanitizer: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["k" /* DataSanitizer */],
    TelemetryItemCreator: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["C" /* TelemetryItemCreator */],
    CtxTagKeys: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["g" /* CtxTagKeys */],
    Extensions: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["r" /* Extensions */],
    DistributedTracingModes: __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["n" /* DistributedTracingModes */]
};
/**
 * Application Insights API
 * @class Initialization
 * @implements {IApplicationInsights}
 */
var Initialization = /** @class */ (function () {
    function Initialization(snippet) {
        var _this = this;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var dependencies;
        var properties;
        var _sender;
        var _snippetVersion;
        var _evtNamespace;
        var _houseKeepingNamespace;
        var _core;
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(Initialization, this, function (_self) {
            _initDefaults();
            // initialize the queue and config in case they are undefined
            _snippetVersion = "" + (snippet.sv || snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["J" /* _DYN_VERSION */] /* @min:%2eversion */] || "");
            snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["G" /* _DYN_QUEUE */] /* @min:%2equeue */] = snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["G" /* _DYN_QUEUE */] /* @min:%2equeue */] || [];
            snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["J" /* _DYN_VERSION */] /* @min:%2eversion */] = snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["J" /* _DYN_VERSION */] /* @min:%2eversion */] || 2.0; // Default to new version
            var config = snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */] || {};
            if (config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["e" /* _DYN_CONNECTION_STRING */] /* @min:%2econnectionString */]) {
                var cs = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["S" /* parseConnectionString */])(config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["e" /* _DYN_CONNECTION_STRING */] /* @min:%2econnectionString */]);
                var ingest = cs.ingestionendpoint;
                config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["s" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */] = ingest ? (ingest + __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["i" /* DEFAULT_BREEZE_PATH */]) : config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["s" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */]; // only add /v2/track when from connectionstring
                config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["v" /* _DYN_INSTRUMENTATION_KEY */] /* @min:%2einstrumentationKey */] = cs.instrumentationkey || config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["v" /* _DYN_INSTRUMENTATION_KEY */] /* @min:%2einstrumentationKey */];
            }
            _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["b" /* _DYN_APP_INSIGHTS */] /* @min:%2eappInsights */] = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_analytics_js__["a" /* AnalyticsPlugin */]();
            properties = new __WEBPACK_IMPORTED_MODULE_6__microsoft_applicationinsights_properties_js__["a" /* PropertiesPlugin */]();
            dependencies = new __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_dependencies_js__["a" /* AjaxPlugin */]();
            _sender = new __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_channel_js__["a" /* Sender */]();
            _core = new __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["a" /* AppInsightsCore */]();
            _self.core = _core;
            var isErrMessageDisabled = Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["n" /* _DYN_DISABLE_IKEY_DEPRECA18 */] /* @min:%2edisableIkeyDeprecationMessage */]) ? true : config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["n" /* _DYN_DISABLE_IKEY_DEPRECA18 */] /* @min:%2edisableIkeyDeprecationMessage */];
            if (!config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["e" /* _DYN_CONNECTION_STRING */] /* @min:%2econnectionString */] && !isErrMessageDisabled) {
                Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_core.logger, 1 /* eLoggingSeverity.CRITICAL */, 106 /* _eInternalMessageId.InstrumentationKeyDeprecation */, "Instrumentation key support will end soon, see aka.ms/IkeyMigrate");
            }
            _self[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["j" /* STR_SNIPPET */] /* @min:%2esnippet */] = snippet;
            _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */] = config;
            _getSKUDefaults();
            _self[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["e" /* STR_FLUSH */] /* @min:%2eflush */] = function (async) {
                if (async === void 0) { async = true; }
                Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["F" /* doPerf */])(_core, function () { return "AISKU.flush"; }, function () {
                    Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(_core[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["t" /* _DYN_GET_TRANSMISSION_CON19 */] /* @min:%2egetTransmissionControls */](), function (channels) {
                        Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(channels, function (channel) {
                            channel[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["e" /* STR_FLUSH */] /* @min:%2eflush */](async);
                        });
                    });
                }, null, async);
            };
            _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["E" /* _DYN_ONUNLOAD_FLUSH */] /* @min:%2eonunloadFlush */] = function (async) {
                if (async === void 0) { async = true; }
                Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(_core[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["t" /* _DYN_GET_TRANSMISSION_CON19 */] /* @min:%2egetTransmissionControls */](), function (channels) {
                    Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(channels, function (channel) {
                        if (channel[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["E" /* _DYN_ONUNLOAD_FLUSH */] /* @min:%2eonunloadFlush */]) {
                            channel[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["E" /* _DYN_ONUNLOAD_FLUSH */] /* @min:%2eonunloadFlush */]();
                        }
                        else {
                            channel[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["e" /* STR_FLUSH */] /* @min:%2eflush */](async);
                        }
                    });
                });
            };
            _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["A" /* _DYN_LOAD_APP_INSIGHTS */] /* @min:%2eloadAppInsights */] = function (legacyMode, logger, notificationManager) {
                if (legacyMode === void 0) { legacyMode = false; }
                function _updateSnippetProperties(snippet) {
                    if (snippet) {
                        var snippetVer = "";
                        if (!Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(_snippetVersion)) {
                            snippetVer += _snippetVersion;
                        }
                        if (legacyMode) {
                            snippetVer += ".lg";
                        }
                        if (_self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */] && _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */].internal) {
                            _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */].internal.snippetVer = snippetVer || "-";
                        }
                        // apply updated properties to the global instance (snippet)
                        Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(_self, function (field, value) {
                            if (Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_13" /* isString */])(field) &&
                                !Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(value) &&
                                field && field[0] !== "_" && // Don't copy "internal" values
                                Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["q" /* arrIndexOf */])(_ignoreUpdateSnippetProperties, field) === -1) {
                                snippet[field] = value;
                            }
                        });
                    }
                }
                // dont allow additional channels/other extensions for legacy mode; legacy mode is only to allow users to switch with no code changes!
                if (legacyMode && _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */].extensions && _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */].extensions.length > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_40" /* throwError */])("Extensions not allowed in legacy mode");
                }
                Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["F" /* doPerf */])(_self.core, function () { return "AISKU.loadAppInsights"; }, function () {
                    var extensions = [];
                    extensions[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["F" /* _DYN_PUSH */] /* @min:%2epush */](_sender);
                    extensions[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["F" /* _DYN_PUSH */] /* @min:%2epush */](properties);
                    extensions[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["F" /* _DYN_PUSH */] /* @min:%2epush */](dependencies);
                    extensions[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["F" /* _DYN_PUSH */] /* @min:%2epush */](_self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["b" /* _DYN_APP_INSIGHTS */] /* @min:%2eappInsights */]);
                    // initialize core
                    _core.initialize(_self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */], extensions, logger, notificationManager);
                    _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */] = properties[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */];
                    if (_internalSdkSrc && _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */]) {
                        _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */].internal.sdkSrc = _internalSdkSrc;
                    }
                    _updateSnippetProperties(_self[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["j" /* STR_SNIPPET */] /* @min:%2esnippet */]);
                    // Empty queue of all api calls logged prior to sdk download
                    _self.emptyQueue();
                    _self[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["h" /* STR_POLL_INTERNAL_LOGS */] /* @min:%2epollInternalLogs */]();
                    _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["a" /* _DYN_ADD_HOUSEKEEPING_BEF20 */] /* @min:%2eaddHousekeepingBeforeUnload */](_self);
                });
                return _self;
            };
            _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["I" /* _DYN_UPDATE_SNIPPET_DEFIN0 */] /* @min:%2eupdateSnippetDefinitions */] = function (snippet) {
                // apply full appInsights to the global instance
                // Note: This must be called before loadAppInsights is called
                Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_26" /* proxyAssign */])(snippet, _self, function (name) {
                    // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
                    return name && Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["q" /* arrIndexOf */])(_ignoreUpdateSnippetProperties, name) === -1;
                });
            };
            _self.emptyQueue = function () {
                // call functions that were queued before the main script was loaded
                try {
                    if (Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_2" /* isArray */])(_self.snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["G" /* _DYN_QUEUE */] /* @min:%2equeue */])) {
                        // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
                        var length_1 = _self.snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["G" /* _DYN_QUEUE */] /* @min:%2equeue */].length;
                        for (var i = 0; i < length_1; i++) {
                            var call = _self.snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["G" /* _DYN_QUEUE */] /* @min:%2equeue */][i];
                            call();
                        }
                        _self.snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["G" /* _DYN_QUEUE */] /* @min:%2equeue */] = undefined;
                        delete _self.snippet[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["G" /* _DYN_QUEUE */] /* @min:%2equeue */];
                    }
                }
                catch (exception) {
                    var properties_1 = {};
                    if (exception && Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(exception.toString)) {
                        properties_1.exception = exception.toString();
                    }
                    // need from core
                    // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
                    //     eLoggingSeverity.WARNING,
                    //     _eInternalMessageId.FailedToSendQueuedTelemetry,
                    //     "Failed to send queued telemetry",
                    //     properties);
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["a" /* _DYN_ADD_HOUSEKEEPING_BEF20 */] /* @min:%2eaddHousekeepingBeforeUnload */] = function (appInsightsInstance) {
                // Add callback to push events when the user navigates away
                if (Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_1" /* hasWindow */])() || Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["Y" /* hasDocument */])()) {
                    var performHousekeeping = function () {
                        // Adds the ability to flush all data before the page unloads.
                        // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
                        // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
                        // Telemetry here will help us analyze how effective this approach is.
                        // Another approach would be to make this call sync with a acceptable timeout to reduce the
                        // impact on user experience.
                        // appInsightsInstance.context._sender.triggerSend();
                        appInsightsInstance[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["E" /* _DYN_ONUNLOAD_FLUSH */] /* @min:%2eonunloadFlush */](false);
                        // Back up the current session to local storage
                        // This lets us close expired sessions after the cookies themselves expire
                        if (Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(_this.core[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["g" /* STR_GET_PLUGIN */] /* @min:%2egetPlugin */])) {
                            var loadedPlugin = _this.core[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["g" /* STR_GET_PLUGIN */] /* @min:%2egetPlugin */](__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["x" /* PropertiesPluginIdentifier */]);
                            if (loadedPlugin) {
                                var propertiesPlugin = loadedPlugin.plugin;
                                if (propertiesPlugin && propertiesPlugin[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */] && propertiesPlugin[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */]._sessionManager) {
                                    propertiesPlugin[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */]._sessionManager.backup();
                                }
                            }
                        }
                    };
                    var added = false;
                    var excludePageUnloadEvents = appInsightsInstance.appInsights[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */].disablePageUnloadEvents;
                    if (!_houseKeepingNamespace) {
                        _houseKeepingNamespace = Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_19" /* mergeEvtNamespace */])(_evtNamespace, _core[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["d" /* STR_EVT_NAMESPACE */] /* @min:%2eevtNamespace */] && _core[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["d" /* STR_EVT_NAMESPACE */] /* @min:%2eevtNamespace */]());
                    }
                    if (!appInsightsInstance.appInsights.config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["l" /* _DYN_DISABLE_FLUSH_ON_BEF11 */] /* @min:%2edisableFlushOnBeforeUnload */]) {
                        // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
                        // As just hooking the window does not always fire (on chrome) for page navigation's.
                        if (Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["o" /* addPageUnloadEventListener */])(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) {
                            added = true;
                        }
                        // We also need to hook the pagehide and visibilitychange events as not all versions of Safari support load/unload events.
                        if (Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["n" /* addPageHideEventListener */])(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) {
                            added = true;
                        }
                        // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
                        // log the failure in this case
                        if (!added && !Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_12" /* isReactNative */])()) {
                            Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(appInsightsInstance[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["b" /* _DYN_APP_INSIGHTS */] /* @min:%2eappInsights */].core.logger, 1 /* eLoggingSeverity.CRITICAL */, 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */, "Could not add handler for beforeunload and pagehide");
                        }
                    }
                    if (!added && !appInsightsInstance.appInsights.config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["m" /* _DYN_DISABLE_FLUSH_ON_UNL12 */] /* @min:%2edisableFlushOnUnload */]) {
                        // If we didn't add the normal set then attempt to add the pagehide and visibilitychange only
                        Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["n" /* addPageHideEventListener */])(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace);
                    }
                }
            };
            _self.getSender = function () {
                return _sender;
            };
            _self.unload = function (isAsync, unloadComplete, cbTimeout) {
                _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["E" /* _DYN_ONUNLOAD_FLUSH */] /* @min:%2eonunloadFlush */](isAsync);
                // Remove any registered event handlers
                if (_houseKeepingNamespace) {
                    Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_31" /* removePageUnloadEventListener */])(null, _houseKeepingNamespace);
                    Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_30" /* removePageHideEventListener */])(null, _houseKeepingNamespace);
                }
                _core.unload && _core.unload(isAsync, unloadComplete, cbTimeout);
            };
            Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_27" /* proxyFunctions */])(_self, _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["b" /* _DYN_APP_INSIGHTS */] /* @min:%2eappInsights */], [
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["f" /* STR_GET_COOKIE_MGR */],
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["p" /* STR_TRACK_EVENT */],
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["s" /* STR_TRACK_PAGE_VIEW */],
                "trackPageViewPerformance",
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["q" /* STR_TRACK_EXCEPTION */],
                "_onerror",
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["t" /* STR_TRACK_TRACE */],
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["r" /* STR_TRACK_METRIC */],
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["l" /* STR_START_TRACK_PAGE */],
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["n" /* STR_STOP_TRACK_PAGE */],
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["k" /* STR_START_TRACK_EVENT */],
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["m" /* STR_STOP_TRACK_EVENT */]
            ]);
            Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_27" /* proxyFunctions */])(_self, _getCurrentDependencies, [
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["o" /* STR_TRACK_DEPENDENCY_DATA */],
                "addDependencyListener",
                "addDependencyInitializer"
            ]);
            Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_27" /* proxyFunctions */])(_self, _core, [
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["a" /* STR_ADD_TELEMETRY_INITIALIZER */],
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["h" /* STR_POLL_INTERNAL_LOGS */],
                "stopPollingInternalLogs",
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["g" /* STR_GET_PLUGIN */],
                "addPlugin",
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["d" /* STR_EVT_NAMESPACE */],
                "addUnloadCb",
                "getTraceCtx"
            ]);
            Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["_27" /* proxyFunctions */])(_self, function () {
                var context = properties[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */];
                return context ? context.user : null;
            }, [
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["i" /* STR_SET_AUTHENTICATED_USER_CONTEXT */],
                __WEBPACK_IMPORTED_MODULE_7__InternalConstants__["c" /* STR_CLEAR_AUTHENTICATED_USER_CONTEXT */]
            ]);
            function _getSKUDefaults() {
                _self.config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["h" /* _DYN_DIAGNOSTIC_LOG_INTER4 */] /* @min:%2ediagnosticLogInterval */] =
                    _self.config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["h" /* _DYN_DIAGNOSTIC_LOG_INTER4 */] /* @min:%2ediagnosticLogInterval */] && _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */][__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["h" /* _DYN_DIAGNOSTIC_LOG_INTER4 */] /* @min:%2ediagnosticLogInterval */] > 0 ? _self[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */][__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["h" /* _DYN_DIAGNOSTIC_LOG_INTER4 */] /* @min:%2ediagnosticLogInterval */] : 10000;
            }
            // Using a function to support the dynamic adding / removal of plugins, so this will always return the current value
            function _getCurrentDependencies() {
                return dependencies;
            }
            function _initDefaults() {
                _evtNamespace = Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_core_js__["z" /* createUniqueNamespace */])("AISKU");
                _houseKeepingNamespace = null;
                dependencies = null;
                properties = null;
                _sender = null;
                _snippetVersion = null;
            }
        });
    }
    // Analytics Plugin
// Removed Stub for Initialization.prototype.getCookieMgr.
// Removed Stub for Initialization.prototype.trackEvent.
// Removed Stub for Initialization.prototype.trackPageView.
// Removed Stub for Initialization.prototype.trackPageViewPerformance.
// Removed Stub for Initialization.prototype.trackException.
// Removed Stub for Initialization.prototype._onerror.
// Removed Stub for Initialization.prototype.trackTrace.
// Removed Stub for Initialization.prototype.trackMetric.
// Removed Stub for Initialization.prototype.startTrackPage.
// Removed Stub for Initialization.prototype.stopTrackPage.
// Removed Stub for Initialization.prototype.startTrackEvent.
// Removed Stub for Initialization.prototype.stopTrackEvent.
// Removed Stub for Initialization.prototype.addTelemetryInitializer.
    // Properties Plugin
// Removed Stub for Initialization.prototype.setAuthenticatedUserContext.
// Removed Stub for Initialization.prototype.clearAuthenticatedUserContext.
    // Dependencies Plugin
// Removed Stub for Initialization.prototype.trackDependencyData.
    // Misc
// Removed Stub for Initialization.prototype.flush.
// Removed Stub for Initialization.prototype.onunloadFlush.
// Removed Stub for Initialization.prototype.loadAppInsights.
// Removed Stub for Initialization.prototype.updateSnippetDefinitions.
// Removed Stub for Initialization.prototype.emptyQueue.
// Removed Stub for Initialization.prototype.pollInternalLogs.
// Removed Stub for Initialization.prototype.stopPollingInternalLogs.
// Removed Stub for Initialization.prototype.addHousekeepingBeforeUnload.
// Removed Stub for Initialization.prototype.getSender.
// Removed Stub for Initialization.prototype.unload.
// Removed Stub for Initialization.prototype.getPlugin.
// Removed Stub for Initialization.prototype.addPlugin.
// Removed Stub for Initialization.prototype.evtNamespace.
// Removed Stub for Initialization.prototype.addUnloadCb.
// Removed Stub for Initialization.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */
    Initialization.prototype.addDependencyInitializer = function (dependencyInitializer) {
        return null;
    };
// Removed Stub for Initialization.prototype.getTraceCtx.
    return Initialization;
}());

// tslint:disable-next-line
(function () {
    var sdkSrc = null;
    var isModule = false;
    var cdns = [
        "://js.monitor.azure.com/",
        "://az416426.vo.msecnd.net/"
    ];
    try {
        // Try and determine whether the sdk is being loaded from the CDN
        // currentScript is only valid during initial processing
        var scrpt = (document || {}).currentScript;
        if (scrpt) {
            sdkSrc = scrpt.src;
            // } else {
            //     // We need to update to at least typescript 2.9 for this to work :-(
            //     // Leaving as a stub for now so after we upgrade this breadcrumb is available
            //     let meta = import.meta;
            //     sdkSrc = (meta || {}).url;
            //     isModule = true;
        }
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    if (sdkSrc) {
        try {
            var url = sdkSrc.toLowerCase();
            if (url) {
                var src = "";
                for (var idx = 0; idx < cdns.length; idx++) {
                    if (url[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["u" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */](cdns[idx]) !== -1) {
                        src = "cdn" + (idx + 1);
                        if (url[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["u" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */]("/scripts/") === -1) {
                            if (url[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["u" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */]("/next/") !== -1) {
                                src += "-next";
                            }
                            else if (url[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["u" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */]("/beta/") !== -1) {
                                src += "-beta";
                            }
                        }
                        _internalSdkSrc = src + (isModule ? ".mod" : "");
                        break;
                    }
                }
            }
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
    }
})();
//# sourceMappingURL=Initialization.js.map

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_AnalyticsPlugin__ = __webpack_require__(1882);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_AnalyticsPlugin__["a"]; });
/* unused harmony reexport ApplicationInsights */
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



//# sourceMappingURL=applicationinsights-analytics-js.js.map

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SymbolObj */
/* unused harmony export ReflectObj */
/* unused harmony export __hasSymbol */
/* unused harmony export __hasReflect */
/* unused harmony export __objAssignFnImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assignFn; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __extendsFn;
/* unused harmony export __restFn */
/* unused harmony export __decorateFn */
/* unused harmony export __paramFn */
/* unused harmony export __metadataFn */
/* unused harmony export __exportStarFn */
/* harmony export (immutable) */ __webpack_exports__["b"] = __createBindingFn;
/* unused harmony export __valuesFn */
/* unused harmony export __readFn */
/* unused harmony export __spreadArraysFn */
/* unused harmony export __spreadArrayFn */
/* unused harmony export __makeTemplateObjectFn */
/* unused harmony export __importStarFn */
/* unused harmony export __importDefaultFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(480);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES3 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
var SymbolObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Symbol"];
var ReflectObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Reflect"];
var __hasSymbol = !!SymbolObj;
var __hasReflect = !!ReflectObj;
var strDecorate = "decorate";
var strMetadata = "metadata";
var strGetOwnPropertySymbols = "getOwnPropertySymbols";
var strIterator = "iterator";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (__WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */][__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && b !== null) {
        Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b === null ? Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["b" /* objCreateFn */])(b) : (__[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]], new __());
}
function __restFn(s, e) {
    var t = {};
    for (var k in s) {
        if (__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(s, k) && e.indexOf(k) < 0) {
            t[k] = s[k];
        }
    }
    if (s != null && typeof __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        for (var i = 0, p = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols](s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && __WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */]["propertyIsEnumerable"].call(s, p[i])) {
                t[p[i]] = s[p[i]];
            }
        }
    }
    return t;
}
function __decorateFn(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["getOwnPropertyDescriptor"](target, key) : desc, d;
    if (__hasReflect && typeof ReflectObj[strDecorate] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        r = ReflectObj[strDecorate](decorators, target, key, desc);
    }
    else {
        for (var i = decorators.length - 1; i >= 0; i--) {
            // eslint-disable-next-line no-cond-assign
            if (d = decorators[i]) {
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
            }
        }
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(target, key, r), r;
}
function __paramFn(paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadataFn(metadataKey, metadataValue) {
    if (__hasReflect && ReflectObj[strMetadata] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        return ReflectObj[strMetadata](metadataKey, metadataValue);
    }
}
function __exportStarFn(m, o) {
    for (var p in m) {
        if (p !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && !__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(o, p)) {
            __createBindingFn(o, m, p);
        }
    }
}
function __createBindingFn(o, m, k, k2) {
    if (k2 === undefined) {
        k2 = k;
    }
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(o, k2, {
            enumerable: true,
            get: function () {
                return m[k];
            }
        });
    }
    else {
        o[k2] = m[k];
    }
}
function __valuesFn(o) {
    var s = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && SymbolObj[strIterator], m = s && o[s], i = 0;
    if (m) {
        return m.call(o);
    }
    if (o && typeof o.length === "number") {
        return {
            next: function () {
                if (o && i >= o.length) {
                    o = void 0;
                }
                return { value: o && o[i++], done: !o };
            }
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __readFn(o, n) {
    var m = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && o[SymbolObj[strIterator]];
    if (!m) {
        return o;
    }
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    }
    catch (error) {
        e = {
            error: error
        };
    }
    finally {
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) {
                m.call(i);
            }
        }
        finally {
            if (e) {
                // eslint-disable-next-line no-unsafe-finally
                throw e.error;
            }
        }
    }
    return ar;
}
/** @deprecated */
function __spreadArraysFn() {
    var theArgs = arguments;
    // Calculate new total size
    for (var s = 0, i = 0, il = theArgs.length; i < il; i++) {
        s += theArgs[i].length;
    }
    // Create new full array
    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
        for (var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }
    return r;
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}
function __makeTemplateObjectFn(cooked, raw) {
    if (__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
}
function __importStarFn(mod) {
    if (mod && mod.__esModule) {
        return mod;
    }
    var result = {};
    if (mod != null) {
        for (var k in mod) {
            if (k !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && Object.prototype.hasOwnProperty.call(mod, k)) {
                __createBindingFn(result, mod, k);
            }
        }
    }
    // Set default module
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(result, __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */], { enumerable: true, value: mod });
    }
    else {
        result[__WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */]] = mod;
    }
    return result;
}
function __importDefaultFn(mod) {
    return (mod && mod.__esModule) ? mod : { strDefault: mod };
}
//# sourceMappingURL=TsLibShims.js.map

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = isInternalApplicationInsightsEndpoint;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Util; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UrlHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CorrelationIdHelper; });
/* harmony export (immutable) */ __webpack_exports__["a"] = AjaxHelperParseDependencyPath;
/* harmony export (immutable) */ __webpack_exports__["h"] = dateTimeUtilsNow;
/* harmony export (immutable) */ __webpack_exports__["g"] = dateTimeUtilsDuration;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DateTimeUtils; });
/* harmony export (immutable) */ __webpack_exports__["f"] = createDistributedTraceContextFromTrace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DomHelperFuncs__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RequestResponseHeaders__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Telemetry_Common_DataSanitizer__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DynamicConstants__ = __webpack_require__(88);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */











// listing only non-geo specific locations
var _internalEndpoints = [
    __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* DEFAULT_BREEZE_ENDPOINT */] + __WEBPACK_IMPORTED_MODULE_1__Constants__["b" /* DEFAULT_BREEZE_PATH */],
    "https://breeze.aimon.applicationinsights.io" + __WEBPACK_IMPORTED_MODULE_1__Constants__["b" /* DEFAULT_BREEZE_PATH */],
    "https://dc-int.services.visualstudio.com" + __WEBPACK_IMPORTED_MODULE_1__Constants__["b" /* DEFAULT_BREEZE_PATH */]
];
function isInternalApplicationInsightsEndpoint(endpointUrl) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* arrIndexOf */])(_internalEndpoints, endpointUrl[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["N" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]()) !== -1;
}
var Util = {
    NotSpecified: __WEBPACK_IMPORTED_MODULE_1__Constants__["h" /* strNotSpecified */],
    createDomEvent: __WEBPACK_IMPORTED_MODULE_2__DomHelperFuncs__["a" /* createDomEvent */],
    disableStorage: __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__["c" /* utlDisableStorage */],
    isInternalApplicationInsightsEndpoint: isInternalApplicationInsightsEndpoint,
    canUseLocalStorage: __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__["a" /* utlCanUseLocalStorage */],
    getStorage: __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__["e" /* utlGetLocalStorage */],
    setStorage: __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__["j" /* utlSetLocalStorage */],
    removeStorage: __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__["i" /* utlRemoveStorage */],
    canUseSessionStorage: __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__["b" /* utlCanUseSessionStorage */],
    getSessionStorageKeys: __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__["g" /* utlGetSessionStorageKeys */],
    getSessionStorage: __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__["f" /* utlGetSessionStorage */],
    setSessionStorage: __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__["k" /* utlSetSessionStorage */],
    removeSessionStorage: __WEBPACK_IMPORTED_MODULE_5__StorageHelperFuncs__["h" /* utlRemoveSessionStorage */],
    disableCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["E" /* disableCookies */],
    canUseCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["u" /* canUseCookies */],
    disallowsSameSiteNone: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_42" /* uaDisallowsSameSiteNone */],
    setCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_34" /* setCookie */],
    stringToBoolOrDefault: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* stringToBoolOrDefault */],
    getCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["L" /* getCookie */],
    deleteCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["D" /* deleteCookie */],
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_38" /* strTrim */],
    newId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_20" /* newId */],
    random32: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_28" /* random32 */])(true);
    },
    generateW3CId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* generateW3CId */],
    isArray: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_2" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_5" /* isError */],
    isDate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_4" /* isDate */],
    toISOStringForIE8: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_41" /* toISOString */],
    getIEVersion: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* getIEVersion */],
    msToTimeSpan: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["c" /* msToTimeSpan */],
    isCrossOriginError: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* isCrossOriginError */],
    dump: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* dumpObj */],
    getExceptionName: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["N" /* getExceptionName */],
    addEventHandler: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* attachEvent */],
    IsBeaconApiSupported: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_3" /* isBeaconsSupported */],
    getExtension: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* getExtensionByName */]
};
var UrlHelper = {
    parseUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */],
    getAbsoluteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["a" /* urlGetAbsoluteUrl */],
    getPathName: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["c" /* urlGetPathName */],
    getCompleteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["b" /* urlGetCompleteUrl */],
    parseHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["e" /* urlParseHost */],
    parseFullHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */]
};
var CorrelationIdHelper = {
    correlationIdPrefix: "cid-v1:",
    /**
     * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
     * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
     * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
     * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
     * manually supply domains to include correlation headers on. Else, no headers will be included at all.
     */
    canIncludeCorrelationHeader: function (config, requestUrl, currentHost) {
        if (!requestUrl || (config && config.disableCorrelationHeaders)) {
            return false;
        }
        if (config && config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["b" /* _DYN_CORRELATION_HEADER_E0 */] /* @min:%2ecorrelationHeaderExcludePatterns */]) {
            for (var i = 0; i < config.correlationHeaderExcludePatterns[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */]; i++) {
                if (config[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["b" /* _DYN_CORRELATION_HEADER_E0 */] /* @min:%2ecorrelationHeaderExcludePatterns */][i].test(requestUrl)) {
                    return false;
                }
            }
        }
        var requestHost = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(requestUrl).host[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["N" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]();
        if (requestHost && (requestHost[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["m" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */](":443") !== -1 || requestHost[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["m" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */](":80") !== -1)) {
            // [Bug #1260] IE can include the port even for http and https URLs so if present
            // try and parse it to remove if it matches the default protocol port
            requestHost = (Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */])(requestUrl, true) || "")[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["N" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]();
        }
        if ((!config || !config.enableCorsCorrelation) && (requestHost && requestHost !== currentHost)) {
            return false;
        }
        var includedDomains = config && config.correlationHeaderDomains;
        if (includedDomains) {
            var matchExists_1;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(includedDomains, function (domain) {
                var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
                matchExists_1 = matchExists_1 || regex.test(requestHost);
            });
            if (!matchExists_1) {
                return false;
            }
        }
        var excludedDomains = config && config.correlationHeaderExcludedDomains;
        if (!excludedDomains || excludedDomains[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] === 0) {
            return true;
        }
        for (var i = 0; i < excludedDomains[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */]; i++) {
            var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
            if (regex.test(requestHost)) {
                return false;
            }
        }
        // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
        // Previously we always returned false for a falsy requestHost
        return requestHost && requestHost[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 0;
    },
    /**
     * Combines target appId and target role name from response header.
     */
    getCorrelationContext: function (responseHeader) {
        if (responseHeader) {
            var correlationId = CorrelationIdHelper.getCorrelationContextValue(responseHeader, __WEBPACK_IMPORTED_MODULE_4__RequestResponseHeaders__["a" /* RequestHeaders */][1 /* eRequestHeaders.requestContextTargetKey */]);
            if (correlationId && correlationId !== CorrelationIdHelper.correlationIdPrefix) {
                return correlationId;
            }
        }
    },
    /**
     * Gets key from correlation response header
     */
    getCorrelationContextValue: function (responseHeader, key) {
        if (responseHeader) {
            var keyValues = responseHeader[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["K" /* _DYN_SPLIT */] /* @min:%2esplit */](",");
            for (var i = 0; i < keyValues[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */]; ++i) {
                var keyValue = keyValues[i][__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["K" /* _DYN_SPLIT */] /* @min:%2esplit */]("=");
                if (keyValue[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] === 2 && keyValue[0] === key) {
                    return keyValue[1];
                }
            }
        }
    }
};
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
        var parsedUrl = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["y" /* _DYN_PATHNAME */] /* @min:%2epathname */] != null) {
                var pathName = (parsedUrl.pathname[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] === 0) ? "/" : parsedUrl[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["y" /* _DYN_PATHNAME */] /* @min:%2epathname */];
                if (pathName.charAt(0) !== "/") {
                    pathName = "/" + pathName;
                }
                data = parsedUrl[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["y" /* _DYN_PATHNAME */] /* @min:%2epathname */];
                name = Object(__WEBPACK_IMPORTED_MODULE_6__Telemetry_Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = Object(__WEBPACK_IMPORTED_MODULE_6__Telemetry_Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function dateTimeUtilsNow() {
    // returns the window or webworker performance object
    var perf = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["V" /* getPerformance */])();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) {
            return now;
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["B" /* dateNow */])();
}
function dateTimeUtilsDuration(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(start) && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(end)) {
        result = end - start;
    }
    return result;
}
/**
 * A utility class that helps getting time related parameters
 */
var DateTimeUtils = {
    Now: dateTimeUtilsNow,
    GetDuration: dateTimeUtilsDuration
};
/**
 * Creates a IDistributedTraceContext from an optional telemetryTrace
 * @param telemetryTrace - The telemetryTrace instance that is being wrapped
 * @param parentCtx - An optional parent distributed trace instance, almost always undefined as this scenario is only used in the case of multiple property handlers.
 * @returns A new IDistributedTraceContext instance that is backed by the telemetryTrace or temporary object
 */
function createDistributedTraceContextFromTrace(telemetryTrace, parentCtx) {
    var trace = telemetryTrace || {};
    return {
        getName: function () {
            return trace[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["w" /* _DYN_NAME */] /* @min:%2ename */];
        },
        setName: function (newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[__WEBPACK_IMPORTED_MODULE_8__DynamicConstants__["w" /* _DYN_NAME */] /* @min:%2ename */] = newValue;
        },
        getTraceId: function () {
            return trace.traceID;
        },
        setTraceId: function (newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_17" /* isValidTraceId */])(newValue)) {
                trace.traceID = newValue;
            }
        },
        getSpanId: function () {
            return trace.parentID;
        },
        setSpanId: function (newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_16" /* isValidSpanId */])(newValue)) {
                trace.parentID = newValue;
            }
        },
        getTraceFlags: function () {
            return trace.traceFlags;
        },
        setTraceFlags: function (newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace.traceFlags = newTraceFlags;
        }
    };
}
//# sourceMappingURL=Util.js.map

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SymbolObj */
/* unused harmony export ReflectObj */
/* unused harmony export __hasSymbol */
/* unused harmony export __hasReflect */
/* unused harmony export __objAssignFnImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assignFn; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __extendsFn;
/* unused harmony export __restFn */
/* unused harmony export __decorateFn */
/* unused harmony export __paramFn */
/* unused harmony export __metadataFn */
/* unused harmony export __exportStarFn */
/* harmony export (immutable) */ __webpack_exports__["b"] = __createBindingFn;
/* unused harmony export __valuesFn */
/* unused harmony export __readFn */
/* unused harmony export __spreadArraysFn */
/* harmony export (immutable) */ __webpack_exports__["d"] = __spreadArrayFn;
/* unused harmony export __makeTemplateObjectFn */
/* unused harmony export __importStarFn */
/* unused harmony export __importDefaultFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(482);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES3 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
var SymbolObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Symbol"];
var ReflectObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Reflect"];
var __hasSymbol = !!SymbolObj;
var __hasReflect = !!ReflectObj;
var strDecorate = "decorate";
var strMetadata = "metadata";
var strGetOwnPropertySymbols = "getOwnPropertySymbols";
var strIterator = "iterator";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (__WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */][__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && b !== null) {
        Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b === null ? Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["b" /* objCreateFn */])(b) : (__[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]], new __());
}
function __restFn(s, e) {
    var t = {};
    for (var k in s) {
        if (__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(s, k) && e.indexOf(k) < 0) {
            t[k] = s[k];
        }
    }
    if (s != null && typeof __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        for (var i = 0, p = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols](s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && __WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */]["propertyIsEnumerable"].call(s, p[i])) {
                t[p[i]] = s[p[i]];
            }
        }
    }
    return t;
}
function __decorateFn(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["getOwnPropertyDescriptor"](target, key) : desc, d;
    if (__hasReflect && typeof ReflectObj[strDecorate] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        r = ReflectObj[strDecorate](decorators, target, key, desc);
    }
    else {
        for (var i = decorators.length - 1; i >= 0; i--) {
            // eslint-disable-next-line no-cond-assign
            if (d = decorators[i]) {
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
            }
        }
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(target, key, r), r;
}
function __paramFn(paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadataFn(metadataKey, metadataValue) {
    if (__hasReflect && ReflectObj[strMetadata] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        return ReflectObj[strMetadata](metadataKey, metadataValue);
    }
}
function __exportStarFn(m, o) {
    for (var p in m) {
        if (p !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && !__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(o, p)) {
            __createBindingFn(o, m, p);
        }
    }
}
function __createBindingFn(o, m, k, k2) {
    if (k2 === undefined) {
        k2 = k;
    }
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(o, k2, {
            enumerable: true,
            get: function () {
                return m[k];
            }
        });
    }
    else {
        o[k2] = m[k];
    }
}
function __valuesFn(o) {
    var s = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && SymbolObj[strIterator], m = s && o[s], i = 0;
    if (m) {
        return m.call(o);
    }
    if (o && typeof o.length === "number") {
        return {
            next: function () {
                if (o && i >= o.length) {
                    o = void 0;
                }
                return { value: o && o[i++], done: !o };
            }
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __readFn(o, n) {
    var m = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && o[SymbolObj[strIterator]];
    if (!m) {
        return o;
    }
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    }
    catch (error) {
        e = {
            error: error
        };
    }
    finally {
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) {
                m.call(i);
            }
        }
        finally {
            if (e) {
                // eslint-disable-next-line no-unsafe-finally
                throw e.error;
            }
        }
    }
    return ar;
}
/** @deprecated */
function __spreadArraysFn() {
    var theArgs = arguments;
    // Calculate new total size
    for (var s = 0, i = 0, il = theArgs.length; i < il; i++) {
        s += theArgs[i].length;
    }
    // Create new full array
    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
        for (var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }
    return r;
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}
function __makeTemplateObjectFn(cooked, raw) {
    if (__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
}
function __importStarFn(mod) {
    if (mod && mod.__esModule) {
        return mod;
    }
    var result = {};
    if (mod != null) {
        for (var k in mod) {
            if (k !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && Object.prototype.hasOwnProperty.call(mod, k)) {
                __createBindingFn(result, mod, k);
            }
        }
    }
    // Set default module
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(result, __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */], { enumerable: true, value: mod });
    }
    else {
        result[__WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */]] = mod;
    }
    return result;
}
function __importDefaultFn(mod) {
    return (mod && mod.__esModule) ? mod : { strDefault: mod };
}
//# sourceMappingURL=TsLibShims.js.map

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseCore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChannelController__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CookieMgr__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DataCacheHelper__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DbgExtensionUtils__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DiagnosticLogger__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InternalConstants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PerfManager__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProcessTelemetryContext__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TelemetryHelpers__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TelemetryInitializerPlugin__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UnloadHandlerContainer__ = __webpack_require__(486);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



















var strValidationError = "Plugins must provide initialize method";
var strNotificationManager = "_notificationManager";
var strSdkUnloadingError = "SDK is still unloading...";
var strSdkNotInitialized = "SDK is not initialized";
// const strPluginUnloadFailed = "Failed to unload plugin";
var defaultInitConfig = {
    // Have the Diagnostic Logger default to log critical errors to the console
    loggingLevelConsole: 1 /* eLoggingSeverity.CRITICAL */
};
/**
 * Helper to create the default performance manager
 * @param core
 * @param notificationMgr
 */
function _createPerfManager(core, notificationMgr) {
    return new __WEBPACK_IMPORTED_MODULE_10__PerfManager__["a" /* PerfManager */](notificationMgr);
}
function _validateExtensions(logger, channelPriority, allExtensions) {
    var _a;
    // Concat all available extensions
    var coreExtensions = [];
    // Check if any two extensions have the same priority, then warn to console
    // And extract the local extensions from the
    var extPriorities = {};
    // Extension validation
    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["b" /* arrForEach */])(allExtensions, function (ext) {
        // Check for ext.initialize
        if (Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["s" /* isNullOrUndefined */])(ext) || Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["s" /* isNullOrUndefined */])(ext[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["s" /* _DYN_INITIALIZE */] /* @min:%2einitialize */])) {
            Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["N" /* throwError */])(strValidationError);
        }
        var extPriority = ext[__WEBPACK_IMPORTED_MODULE_9__InternalConstants__["n" /* STR_PRIORITY */] /* @min:%2epriority */];
        var identifier = ext[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["q" /* _DYN_IDENTIFIER */] /* @min:%2eidentifier */];
        if (ext && extPriority) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["s" /* isNullOrUndefined */])(extPriorities[extPriority])) {
                Object(__WEBPACK_IMPORTED_MODULE_7__DiagnosticLogger__["e" /* _warnToConsole */])(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
            }
            else {
                // set a value
                extPriorities[extPriority] = identifier;
            }
        }
        // Split extensions to core and channelController
        if (!extPriority || extPriority < channelPriority) {
            // Add to core extension that will be managed by BaseCore
            coreExtensions[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](ext);
        }
    });
    return _a = {
            all: allExtensions
        },
        _a[__WEBPACK_IMPORTED_MODULE_9__InternalConstants__["b" /* STR_CORE */] /* @min:core */] = coreExtensions,
        _a;
}
function _isPluginPresent(thePlugin, plugins) {
    var exists = false;
    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["b" /* arrForEach */])(plugins, function (plugin) {
        if (plugin === thePlugin) {
            exists = true;
            return -1;
        }
    });
    return exists;
}
function _createDummyNotificationManager() {
    var _a;
    return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])((_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["a" /* _DYN_ADD_NOTIFICATION_LIS1 */] /* @min:addNotificationListener */] = function (listener) { },
        _a[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["I" /* _DYN_REMOVE_NOTIFICATION_2 */] /* @min:removeNotificationListener */] = function (listener) { },
        _a[__WEBPACK_IMPORTED_MODULE_9__InternalConstants__["i" /* STR_EVENTS_SENT */] /* @min:eventsSent */] = function (events) { },
        _a[__WEBPACK_IMPORTED_MODULE_9__InternalConstants__["g" /* STR_EVENTS_DISCARDED */] /* @min:eventsDiscarded */] = function (events, reason) { },
        _a[__WEBPACK_IMPORTED_MODULE_9__InternalConstants__["h" /* STR_EVENTS_SEND_REQUEST */] /* @min:eventsSendRequest */] = function (sendReason, isAsync) { },
        _a));
}
var BaseCore = /** @class */ (function () {
    function BaseCore() {
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _config;
        var _isInitialized;
        var _eventQueue;
        var _notificationManager;
        var _perfManager;
        var _cfgPerfManager;
        var _cookieManager;
        var _pluginChain;
        var _configExtensions;
        var _coreExtensions;
        var _channelControl;
        var _channelConfig;
        var _channelQueue;
        var _isUnloading;
        var _telemetryInitializerPlugin;
        var _internalLogsEventName;
        var _evtNamespace;
        var _unloadHandlers;
        var _debugListener;
        var _traceCtx;
        /**
         * Internal log poller
         */
        var _internalLogPoller = 0;
        var _forceStopInternalLogPoller = false;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(BaseCore, this, function (_self) {
            // Set the default values (also called during teardown)
            _initDefaults();
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["w" /* _DYN_IS_INITIALIZED */] /* @min:%2eisInitialized */] = function () { return _isInitialized; };
            // Creating the self.initialize = ()
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["s" /* _DYN_INITIALIZE */] /* @min:%2einitialize */] = function (config, extensions, logger, notificationManager) {
                if (_isUnloading) {
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["N" /* throwError */])(strSdkUnloadingError);
                }
                // Make sure core is only initialized once
                if (_self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["w" /* _DYN_IS_INITIALIZED */] /* @min:%2eisInitialized */]()) {
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["N" /* throwError */])("Core should not be initialized more than once");
                }
                _config = config || {};
                _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["e" /* _DYN_CONFIG */] /* @min:%2econfig */] = _config;
                if (Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["s" /* isNullOrUndefined */])(config[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["t" /* _DYN_INSTRUMENTATION_KEY */] /* @min:%2einstrumentationKey */])) {
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["N" /* throwError */])("Please provide instrumentation key");
                }
                _notificationManager = notificationManager;
                // For backward compatibility only
                _self[strNotificationManager] = notificationManager;
                _initDebugListener();
                _initPerfManager();
                // add notification to the extensions in the config so other plugins can access it
                _initExtConfig();
                if (logger) {
                    _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */] = logger;
                }
                var cfgExtensions = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["k" /* getSetValue */])(_config, __WEBPACK_IMPORTED_MODULE_9__InternalConstants__["j" /* STR_EXTENSIONS */], []);
                // Extension validation
                _configExtensions = [];
                _configExtensions[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */].apply(_configExtensions, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __spreadArrayFn */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __spreadArrayFn */])([], extensions, false), cfgExtensions, false));
                _channelConfig = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["k" /* getSetValue */])(_config, __WEBPACK_IMPORTED_MODULE_9__InternalConstants__["a" /* STR_CHANNELS */], []);
                _initPluginChain(null);
                if (!_channelQueue || _channelQueue[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] === 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["N" /* throwError */])("No " + __WEBPACK_IMPORTED_MODULE_9__InternalConstants__["a" /* STR_CHANNELS */] + " available");
                }
                _isInitialized = true;
                _self.releaseQueue();
            };
            _self.getTransmissionControls = function () {
                var controls = [];
                if (_channelQueue) {
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["b" /* arrForEach */])(_channelQueue, function (channels) {
                        controls[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](channels.queue);
                    });
                }
                return Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["D" /* objFreeze */])(controls);
            };
            _self.track = function (telemetryItem) {
                // setup default iKey if not passed in
                telemetryItem.iKey = telemetryItem.iKey || _config[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["t" /* _DYN_INSTRUMENTATION_KEY */] /* @min:%2einstrumentationKey */];
                // add default timestamp if not passed in
                telemetryItem[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["U" /* _DYN_TIME */] /* @min:%2etime */] = telemetryItem[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["U" /* _DYN_TIME */] /* @min:%2etime */] || Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["O" /* toISOString */])(new Date());
                // Common Schema 4.0
                telemetryItem.ver = telemetryItem.ver || "4.0";
                if (!_isUnloading && _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["w" /* _DYN_IS_INITIALIZED */] /* @min:%2eisInitialized */]()) {
                    // Process the telemetry plugin chain
                    _createTelCtx()[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](telemetryItem);
                }
                else {
                    // Queue events until all extensions are initialized
                    _eventQueue[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](telemetryItem);
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["o" /* _DYN_GET_PROCESS_TEL_CONT0 */] /* @min:%2egetProcessTelContext */] = _createTelCtx;
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["m" /* _DYN_GET_NOTIFY_MGR */] /* @min:%2egetNotifyMgr */] = function () {
                if (!_notificationManager) {
                    // Create Dummy notification manager
                    _notificationManager = _createDummyNotificationManager();
                    // For backward compatibility only
                    _self[strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param {INotificationListener} listener - An INotificationListener object.
             */
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["a" /* _DYN_ADD_NOTIFICATION_LIS1 */] /* @min:%2eaddNotificationListener */] = function (listener) {
                if (_notificationManager) {
                    _notificationManager[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["a" /* _DYN_ADD_NOTIFICATION_LIS1 */] /* @min:%2eaddNotificationListener */](listener);
                }
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - INotificationListener to remove.
             */
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["I" /* _DYN_REMOVE_NOTIFICATION_2 */] /* @min:%2eremoveNotificationListener */] = function (listener) {
                if (_notificationManager) {
                    _notificationManager[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["I" /* _DYN_REMOVE_NOTIFICATION_2 */] /* @min:%2eremoveNotificationListener */](listener);
                }
            };
            _self.getCookieMgr = function () {
                if (!_cookieManager) {
                    _cookieManager = Object(__WEBPACK_IMPORTED_MODULE_4__CookieMgr__["b" /* createCookieMgr */])(_config, _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */]);
                }
                return _cookieManager;
            };
            _self.setCookieMgr = function (cookieMgr) {
                _cookieManager = cookieMgr;
            };
            _self[__WEBPACK_IMPORTED_MODULE_9__InternalConstants__["l" /* STR_GET_PERF_MGR */] /* @min:%2egetPerfMgr */] = function () {
                if (!_perfManager && !_cfgPerfManager) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["i" /* getCfgValue */])(_config.enablePerfMgr)) {
                        var createPerfMgr = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["i" /* getCfgValue */])(_config[__WEBPACK_IMPORTED_MODULE_9__InternalConstants__["c" /* STR_CREATE_PERF_MGR */] /* @min:%2ecreatePerfMgr */]);
                        if (Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["q" /* isFunction */])(createPerfMgr)) {
                            _cfgPerfManager = createPerfMgr(_self, _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["m" /* _DYN_GET_NOTIFY_MGR */] /* @min:%2egetNotifyMgr */]());
                        }
                    }
                }
                return _perfManager || _cfgPerfManager || Object(__WEBPACK_IMPORTED_MODULE_10__PerfManager__["c" /* getGblPerfMgr */])();
            };
            _self.setPerfMgr = function (perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function () {
                return _eventQueue[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
            };
            _self.releaseQueue = function () {
                if (_isInitialized && _eventQueue[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    var eventQueue = _eventQueue;
                    _eventQueue = [];
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["b" /* arrForEach */])(eventQueue, function (event) {
                        _createTelCtx()[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](event);
                    });
                }
            };
            _self.pollInternalLogs = function (eventName) {
                _internalLogsEventName = eventName || null;
                _forceStopInternalLogPoller = false;
                if (_internalLogPoller) {
                    clearInterval(_internalLogPoller);
                    _internalLogPoller = null;
                }
                return _startInternalLogTimer(true);
            };
            function _startInternalLogTimer(alwaysStart) {
                if (!_internalLogPoller && !_forceStopInternalLogPoller) {
                    var shouldStart = alwaysStart || (_self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */] && _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */].queue[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0);
                    if (shouldStart) {
                        var interval = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["i" /* getCfgValue */])(_config.diagnosticLogInterval);
                        if (!interval || !(interval > 0)) {
                            interval = 10000;
                        }
                        // Keeping as an interval timer for backward compatibility as it returns the result
                        _internalLogPoller = setInterval(function () {
                            clearInterval(_internalLogPoller);
                            _internalLogPoller = 0;
                            _flushInternalLogs();
                        }, interval);
                    }
                }
                return _internalLogPoller;
            }
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["Q" /* _DYN_STOP_POLLING_INTERNA3 */] /* @min:%2estopPollingInternalLogs */] = function () {
                _forceStopInternalLogPoller = true;
                if (_internalLogPoller) {
                    clearInterval(_internalLogPoller);
                    _internalLogPoller = 0;
                    _flushInternalLogs();
                }
            };
            // Add addTelemetryInitializer
            Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["I" /* proxyFunctions */])(_self, function () { return _telemetryInitializerPlugin; }, ["addTelemetryInitializer"]);
            _self.unload = function (isAsync, unloadComplete, cbTimeout) {
                var _a;
                if (isAsync === void 0) { isAsync = true; }
                if (!_isInitialized) {
                    // The SDK is not initialized
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["N" /* throwError */])(strSdkNotInitialized);
                }
                // Check if the SDK still unloading so throw
                if (_isUnloading) {
                    // The SDK is already unloading
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["N" /* throwError */])(strSdkUnloadingError);
                }
                var unloadState = (_a = {
                        reason: 50 /* TelemetryUnloadReason.SdkUnload */
                    },
                    _a[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["u" /* _DYN_IS_ASYNC */] /* @min:isAsync */] = isAsync,
                    _a.flushComplete = false,
                    _a);
                var processUnloadCtx = Object(__WEBPACK_IMPORTED_MODULE_11__ProcessTelemetryContext__["b" /* createProcessTelemetryUnloadContext */])(_getPluginChain(), _self);
                processUnloadCtx[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["F" /* _DYN_ON_COMPLETE */] /* @min:%2eonComplete */](function () {
                    _initDefaults();
                    unloadComplete && unloadComplete(unloadState);
                }, _self);
                function _doUnload(flushComplete) {
                    unloadState.flushComplete = flushComplete;
                    _isUnloading = true;
                    // Run all of the unload handlers first (before unloading the plugins)
                    _unloadHandlers.run(processUnloadCtx, unloadState);
                    // Stop polling the internal logs
                    _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["Q" /* _DYN_STOP_POLLING_INTERNA3 */] /* @min:%2estopPollingInternalLogs */]();
                    // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
                    processUnloadCtx[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](unloadState);
                }
                _flushInternalLogs();
                if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */, cbTimeout)) {
                    _doUnload(false);
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["n" /* _DYN_GET_PLUGIN */] /* @min:%2egetPlugin */] = _getPlugin;
            _self.addPlugin = function (plugin, replaceExisting, isAsync, addCb) {
                if (!plugin) {
                    addCb && addCb(false);
                    _logOrThrowError(strValidationError);
                    return;
                }
                var existingPlugin = _getPlugin(plugin[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["q" /* _DYN_IDENTIFIER */] /* @min:%2eidentifier */]);
                if (existingPlugin && !replaceExisting) {
                    addCb && addCb(false);
                    _logOrThrowError("Plugin [" + plugin[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["q" /* _DYN_IDENTIFIER */] /* @min:%2eidentifier */] + "] is already loaded!");
                    return;
                }
                var updateState = {
                    reason: 16 /* TelemetryUpdateReason.PluginAdded */
                };
                function _addPlugin(removed) {
                    _configExtensions[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](plugin);
                    updateState.added = [plugin];
                    // Re-Initialize the plugin chain
                    _initPluginChain(updateState);
                    addCb && addCb(true);
                }
                if (existingPlugin) {
                    var removedPlugins_1 = [existingPlugin.plugin];
                    var unloadState = {
                        reason: 2 /* TelemetryUnloadReason.PluginReplace */,
                        isAsync: !!isAsync
                    };
                    _removePlugins(removedPlugins_1, unloadState, function (removed) {
                        if (!removed) {
                            // Previous plugin was successfully removed or was not installed
                            addCb && addCb(false);
                        }
                        else {
                            updateState.removed = removedPlugins_1;
                            updateState.reason |= 32 /* TelemetryUpdateReason.PluginRemoved */;
                            _addPlugin(true);
                        }
                    });
                }
                else {
                    _addPlugin(false);
                }
            };
            _self.evtNamespace = function () {
                return _evtNamespace;
            };
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["j" /* _DYN_FLUSH */] /* @min:%2eflush */] = _flushChannels;
            _self.getTraceCtx = function (createNew) {
                if (!_traceCtx) {
                    _traceCtx = Object(__WEBPACK_IMPORTED_MODULE_12__TelemetryHelpers__["b" /* createDistributedTraceContext */])();
                }
                return _traceCtx;
            };
            _self.setTraceCtx = function (traceCtx) {
                _traceCtx = traceCtx || null;
            };
            // Create the addUnloadCb
            Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["H" /* proxyFunctionAs */])(_self, "addUnloadCb", function () { return _unloadHandlers; }, "add");
            function _initDefaults() {
                _isInitialized = false;
                // Use a default logger so initialization errors are not dropped on the floor with full logging
                _config = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["B" /* objExtend */])(true, {}, defaultInitConfig);
                _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["e" /* _DYN_CONFIG */] /* @min:%2econfig */] = _config;
                _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */] = new __WEBPACK_IMPORTED_MODULE_7__DiagnosticLogger__["a" /* DiagnosticLogger */](_config);
                _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["_3" /* _DYN__EXTENSIONS */] /* @min:%2e_extensions */] = [];
                _telemetryInitializerPlugin = new __WEBPACK_IMPORTED_MODULE_13__TelemetryInitializerPlugin__["a" /* TelemetryInitializerPlugin */]();
                _eventQueue = [];
                _notificationManager = null;
                _perfManager = null;
                _cfgPerfManager = null;
                _cookieManager = null;
                _pluginChain = null;
                _coreExtensions = null;
                _configExtensions = [];
                _channelControl = null;
                _channelConfig = null;
                _channelQueue = null;
                _isUnloading = false;
                _internalLogsEventName = null;
                _evtNamespace = Object(__WEBPACK_IMPORTED_MODULE_5__DataCacheHelper__["b" /* createUniqueNamespace */])("AIBaseCore", true);
                _unloadHandlers = Object(__WEBPACK_IMPORTED_MODULE_14__UnloadHandlerContainer__["a" /* createUnloadHandlerContainer */])();
                _traceCtx = null;
            }
            function _createTelCtx() {
                var theCtx = Object(__WEBPACK_IMPORTED_MODULE_11__ProcessTelemetryContext__["a" /* createProcessTelemetryContext */])(_getPluginChain(), _config, _self);
                theCtx[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["F" /* _DYN_ON_COMPLETE */] /* @min:%2eonComplete */](_startInternalLogTimer);
                return theCtx;
            }
            // Initialize or Re-initialize the plugins
            function _initPluginChain(updateState) {
                // Extension validation
                var theExtensions = _validateExtensions(_self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */], __WEBPACK_IMPORTED_MODULE_3__ChannelController__["a" /* ChannelControllerPriority */], _configExtensions);
                _coreExtensions = theExtensions[__WEBPACK_IMPORTED_MODULE_9__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */];
                _pluginChain = null;
                // Sort the complete set of extensions by priority
                var allExtensions = theExtensions.all;
                // Initialize the Channel Queues and the channel plugins first
                _channelQueue = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["D" /* objFreeze */])(Object(__WEBPACK_IMPORTED_MODULE_3__ChannelController__["c" /* createChannelQueues */])(_channelConfig, allExtensions, _self));
                if (_channelControl) {
                    // During add / remove of a plugin this may get called again, so don't re-add if already present
                    // But we also want the controller as the last, so remove if already present
                    // And reusing the existing instance, just in case an installed plugin has a reference and
                    // is using it.
                    var idx = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["c" /* arrIndexOf */])(allExtensions, _channelControl);
                    if (idx !== -1) {
                        allExtensions[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["O" /* _DYN_SPLICE */] /* @min:%2esplice */](idx, 1);
                    }
                    idx = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["c" /* arrIndexOf */])(_coreExtensions, _channelControl);
                    if (idx !== -1) {
                        _coreExtensions[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["O" /* _DYN_SPLICE */] /* @min:%2esplice */](idx, 1);
                    }
                    _channelControl._setQueue(_channelQueue);
                }
                else {
                    _channelControl = Object(__WEBPACK_IMPORTED_MODULE_3__ChannelController__["b" /* createChannelControllerPlugin */])(_channelQueue, _self);
                }
                // Add on "channelController" as the last "plugin"
                allExtensions[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](_channelControl);
                _coreExtensions[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](_channelControl);
                // Required to allow plugins to call core.getPlugin() during their own initialization
                _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["_3" /* _DYN__EXTENSIONS */] /* @min:%2e_extensions */] = Object(__WEBPACK_IMPORTED_MODULE_12__TelemetryHelpers__["d" /* sortPlugins */])(allExtensions);
                // Initialize the controls
                _channelControl[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["s" /* _DYN_INITIALIZE */] /* @min:%2einitialize */](_config, _self, allExtensions);
                var initCtx = _createTelCtx();
                Object(__WEBPACK_IMPORTED_MODULE_12__TelemetryHelpers__["c" /* initializePlugins */])(initCtx, allExtensions);
                // Now reset the extensions to just those being managed by Basecore
                _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["_3" /* _DYN__EXTENSIONS */] /* @min:%2e_extensions */] = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["D" /* objFreeze */])(Object(__WEBPACK_IMPORTED_MODULE_12__TelemetryHelpers__["d" /* sortPlugins */])(_coreExtensions || [])).slice();
                if (updateState) {
                    _doUpdate(updateState);
                }
            }
            function _getPlugin(pluginIdentifier) {
                var _a;
                var theExt = null;
                var thePlugin = null;
                Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["b" /* arrForEach */])(_self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["_3" /* _DYN__EXTENSIONS */] /* @min:%2e_extensions */], function (ext) {
                    if (ext[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["q" /* _DYN_IDENTIFIER */] /* @min:%2eidentifier */] === pluginIdentifier && ext !== _channelControl && ext !== _telemetryInitializerPlugin) {
                        thePlugin = ext;
                        return -1;
                    }
                });
                if (!thePlugin && _channelControl) {
                    // Check the channel Controller
                    thePlugin = _channelControl.getChannel(pluginIdentifier);
                }
                if (thePlugin) {
                    theExt = (_a = {
                            plugin: thePlugin
                        },
                        _a[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["L" /* _DYN_SET_ENABLED */] /* @min:setEnabled */] = function (enabled) {
                            Object(__WEBPACK_IMPORTED_MODULE_12__TelemetryHelpers__["a" /* _getPluginState */])(thePlugin)[__WEBPACK_IMPORTED_MODULE_9__InternalConstants__["d" /* STR_DISABLED */]] = !enabled;
                        },
                        _a.isEnabled = function () {
                            var pluginState = Object(__WEBPACK_IMPORTED_MODULE_12__TelemetryHelpers__["a" /* _getPluginState */])(thePlugin);
                            return !pluginState[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["T" /* _DYN_TEARDOWN */] /* @min:%2eteardown */] && !pluginState[__WEBPACK_IMPORTED_MODULE_9__InternalConstants__["d" /* STR_DISABLED */]];
                        },
                        _a.remove = function (isAsync, removeCb) {
                            var _a;
                            if (isAsync === void 0) { isAsync = true; }
                            var pluginsToRemove = [thePlugin];
                            var unloadState = (_a = {
                                    reason: 1 /* TelemetryUnloadReason.PluginUnload */
                                },
                                _a[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["u" /* _DYN_IS_ASYNC */] /* @min:isAsync */] = isAsync,
                                _a);
                            _removePlugins(pluginsToRemove, unloadState, function (removed) {
                                if (removed) {
                                    // Re-Initialize the plugin chain
                                    _initPluginChain({
                                        reason: 32 /* TelemetryUpdateReason.PluginRemoved */,
                                        removed: pluginsToRemove
                                    });
                                }
                                removeCb && removeCb(removed);
                            });
                        },
                        _a);
                }
                return theExt;
            }
            function _getPluginChain() {
                if (!_pluginChain) {
                    // copy the collection of extensions
                    var extensions = (_coreExtensions || []).slice();
                    // During add / remove this may get called again, so don't readd if already present
                    if (Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["c" /* arrIndexOf */])(extensions, _telemetryInitializerPlugin) === -1) {
                        extensions[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](_telemetryInitializerPlugin);
                    }
                    _pluginChain = Object(__WEBPACK_IMPORTED_MODULE_11__ProcessTelemetryContext__["d" /* createTelemetryProxyChain */])(Object(__WEBPACK_IMPORTED_MODULE_12__TelemetryHelpers__["d" /* sortPlugins */])(extensions), _config, _self);
                }
                return _pluginChain;
            }
            function _removePlugins(thePlugins, unloadState, removeComplete) {
                if (thePlugins && thePlugins[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    var unloadChain = Object(__WEBPACK_IMPORTED_MODULE_11__ProcessTelemetryContext__["d" /* createTelemetryProxyChain */])(thePlugins, _config, _self);
                    var unloadCtx = Object(__WEBPACK_IMPORTED_MODULE_11__ProcessTelemetryContext__["b" /* createProcessTelemetryUnloadContext */])(unloadChain, _self);
                    unloadCtx[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["F" /* _DYN_ON_COMPLETE */] /* @min:%2eonComplete */](function () {
                        var removed = false;
                        // Remove the listed config extensions
                        var newConfigExtensions = [];
                        Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["b" /* arrForEach */])(_configExtensions, function (plugin, idx) {
                            if (!_isPluginPresent(plugin, thePlugins)) {
                                newConfigExtensions[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](plugin);
                            }
                            else {
                                removed = true;
                            }
                        });
                        _configExtensions = newConfigExtensions;
                        // Re-Create the channel config
                        var newChannelConfig = [];
                        if (_channelConfig) {
                            Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["b" /* arrForEach */])(_channelConfig, function (queue, idx) {
                                var newQueue = [];
                                Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["b" /* arrForEach */])(queue, function (channel) {
                                    if (!_isPluginPresent(channel, thePlugins)) {
                                        newQueue[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](channel);
                                    }
                                    else {
                                        removed = true;
                                    }
                                });
                                newChannelConfig[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](newQueue);
                            });
                            _channelConfig = newChannelConfig;
                        }
                        removeComplete && removeComplete(removed);
                        _startInternalLogTimer();
                    });
                    unloadCtx[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](unloadState);
                }
                else {
                    removeComplete(false);
                }
            }
            function _flushInternalLogs() {
                if (_self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */] && _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */].queue) {
                    var queue = _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */].queue.slice(0);
                    _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */].queue[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] = 0;
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["b" /* arrForEach */])(queue, function (logMessage) {
                        var _a;
                        var item = (_a = {},
                            _a[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["D" /* _DYN_NAME */] /* @min:name */] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["C" /* _DYN_MESSAGE_ID */] /* @min:%2emessageId */],
                            _a.iKey = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["i" /* getCfgValue */])(_config[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["t" /* _DYN_INSTRUMENTATION_KEY */] /* @min:%2einstrumentationKey */]),
                            _a.time = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["O" /* toISOString */])(new Date()),
                            _a.baseType = __WEBPACK_IMPORTED_MODULE_7__DiagnosticLogger__["b" /* _InternalLogMessage */].dataType,
                            _a.baseData = { message: logMessage[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["B" /* _DYN_MESSAGE */] /* @min:%2emessage */] },
                            _a);
                        _self.track(item);
                    });
                }
            }
            function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                if (_channelControl) {
                    return _channelControl[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["j" /* _DYN_FLUSH */] /* @min:%2eflush */](isAsync, callBack, sendReason || 6 /* SendRequestReason.SdkUnload */, cbTimeout);
                }
                callBack && callBack(false);
                return true;
            }
            function _initDebugListener() {
                var disableDbgExt = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["i" /* getCfgValue */])(_config.disableDbgExt);
                if (disableDbgExt === true && _debugListener) {
                    // Remove any previously loaded debug listener
                    _notificationManager[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["I" /* _DYN_REMOVE_NOTIFICATION_2 */] /* @min:%2eremoveNotificationListener */](_debugListener);
                    _debugListener = null;
                }
                if (_notificationManager && !_debugListener && disableDbgExt !== true) {
                    _debugListener = Object(__WEBPACK_IMPORTED_MODULE_6__DbgExtensionUtils__["b" /* getDebugListener */])(_config);
                    _notificationManager[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["a" /* _DYN_ADD_NOTIFICATION_LIS1 */] /* @min:%2eaddNotificationListener */](_debugListener);
                }
            }
            function _initPerfManager() {
                var enablePerfMgr = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["i" /* getCfgValue */])(_config.enablePerfMgr);
                if (!enablePerfMgr && _cfgPerfManager) {
                    // Remove any existing config based performance manager
                    _cfgPerfManager = null;
                }
                if (enablePerfMgr) {
                    // Set the performance manager creation function if not defined
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["k" /* getSetValue */])(_config, __WEBPACK_IMPORTED_MODULE_9__InternalConstants__["c" /* STR_CREATE_PERF_MGR */], _createPerfManager);
                }
            }
            function _initExtConfig() {
                var extConfig = Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["k" /* getSetValue */])(_config, __WEBPACK_IMPORTED_MODULE_9__InternalConstants__["k" /* STR_EXTENSION_CONFIG */], {});
                extConfig.NotificationManager = _notificationManager;
            }
            function _doUpdate(updateState) {
                var updateCtx = Object(__WEBPACK_IMPORTED_MODULE_11__ProcessTelemetryContext__["c" /* createProcessTelemetryUpdateContext */])(_getPluginChain(), _self);
                updateCtx[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["F" /* _DYN_ON_COMPLETE */] /* @min:%2eonComplete */](_startInternalLogTimer);
                if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) {
                    updateCtx[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](updateState);
                }
            }
            function _logOrThrowError(message) {
                var logger = _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_LOGGER */] /* @min:%2elogger */];
                if (logger) {
                    // there should always be a logger
                    Object(__WEBPACK_IMPORTED_MODULE_7__DiagnosticLogger__["d" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, message);
                    _startInternalLogTimer();
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_8__HelperFuncs__["N" /* throwError */])(message);
                }
            }
        });
    }
// Removed Stub for BaseCore.prototype.initialize.
// Removed Stub for BaseCore.prototype.getTransmissionControls.
// Removed Stub for BaseCore.prototype.track.
// Removed Stub for BaseCore.prototype.getProcessTelContext.
// Removed Stub for BaseCore.prototype.getNotifyMgr.
// Removed Stub for BaseCore.prototype.addNotificationListener.
// Removed Stub for BaseCore.prototype.removeNotificationListener.
// Removed Stub for BaseCore.prototype.getCookieMgr.
// Removed Stub for BaseCore.prototype.setCookieMgr.
// Removed Stub for BaseCore.prototype.getPerfMgr.
// Removed Stub for BaseCore.prototype.setPerfMgr.
// Removed Stub for BaseCore.prototype.eventCnt.
// Removed Stub for BaseCore.prototype.pollInternalLogs.
// Removed Stub for BaseCore.prototype.stopPollingInternalLogs.
// Removed Stub for BaseCore.prototype.addTelemetryInitializer.
// Removed Stub for BaseCore.prototype.unload.
// Removed Stub for BaseCore.prototype.getPlugin.
// Removed Stub for BaseCore.prototype.addPlugin.
// Removed Stub for BaseCore.prototype.evtNamespace.
// Removed Stub for BaseCore.prototype.addUnloadCb.
// Removed Stub for BaseCore.prototype.flush.
// Removed Stub for BaseCore.prototype.getTraceCtx.
// Removed Stub for BaseCore.prototype.setTraceCtx.
// Removed Stub for BaseCore.prototype.releaseQueue.
// Removed Stub for BaseCore.prototype._updateHook.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    BaseCore.__ieDyn=1;

    return BaseCore;
}());

//# sourceMappingURL=BaseCore.js.map

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTraceParent;
/* unused harmony export parseTraceParent */
/* harmony export (immutable) */ __webpack_exports__["d"] = isValidTraceId;
/* harmony export (immutable) */ __webpack_exports__["c"] = isValidSpanId;
/* unused harmony export isValidTraceParent */
/* unused harmony export isSampledFlag */
/* harmony export (immutable) */ __webpack_exports__["b"] = formatTraceParent;
/* unused harmony export findW3cTraceParent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CoreUtils__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalConstants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





// using {0,16} for leading and trailing whitespace just to constrain the possible runtime of a random string
var TRACE_PARENT_REGEX = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})(-[^\s]{1,64})?$/i;
var DEFAULT_VERSION = "00";
var INVALID_VERSION = "ff";
var INVALID_TRACE_ID = "00000000000000000000000000000000";
var INVALID_SPAN_ID = "0000000000000000";
var SAMPLED_FLAG = 0x01;
function _isValid(value, len, invalidValue) {
    if (value && value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] === len && value !== invalidValue) {
        return !!value.match(/^[\da-f]*$/i);
    }
    return false;
}
function _formatValue(value, len, defValue) {
    if (_isValid(value, len)) {
        return value;
    }
    return defValue;
}
function _formatFlags(value) {
    if (isNaN(value) || value < 0 || value > 255) {
        value = 0x01;
    }
    var result = value.toString(16);
    while (result[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] < 2) {
        result = "0" + result;
    }
    return result;
}
/**
 * Create a new ITraceParent instance using the provided values.
 * @param traceId - The traceId to use, when invalid a new random W3C id will be generated.
 * @param spanId - The parent/span id to use, a new random value will be generated if it is invalid.
 * @param flags - The traceFlags to use, defaults to zero (0) if not supplied or invalid
 * @param version - The version to used, defaults to version "01" if not supplied or invalid.
 * @returns
 */
function createTraceParent(traceId, spanId, flags, version) {
    var _a;
    return _a = {},
        _a[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["_1" /* _DYN_VERSION */] /* @min:version */] = _isValid(version, 2, INVALID_VERSION) ? version : DEFAULT_VERSION,
        _a[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["X" /* _DYN_TRACE_ID */] /* @min:traceId */] = isValidTraceId(traceId) ? traceId : Object(__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["f" /* generateW3CId */])(),
        _a.spanId = isValidSpanId(spanId) ? spanId : Object(__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["f" /* generateW3CId */])()[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["R" /* _DYN_SUBSTR */] /* @min:%2esubstr */](0, 16),
        _a.traceFlags = flags >= 0 && flags <= 0xFF ? flags : 1,
        _a;
}
/**
 * Attempt to parse the provided string as a W3C TraceParent header value (https://www.w3.org/TR/trace-context/#traceparent-header)
 *
 * @param value - The value to be parsed
 * @param selectIdx - If the found value is comma separated which is the preferred entry to select, defaults to the first
 * @returns
 */
function parseTraceParent(value, selectIdx) {
    var _a;
    if (!value) {
        // Don't pass a null/undefined or empty string
        return null;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(value)) {
        // The value may have been encoded on the page into an array so handle this automatically
        value = value[0] || "";
    }
    if (!value || !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["v" /* isString */])(value) || value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 8192) {
        // limit potential processing based on total length
        return null;
    }
    if (value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["r" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */](",") !== -1) {
        var values = value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["P" /* _DYN_SPLIT */] /* @min:%2esplit */](",");
        value = values[selectIdx > 0 && values[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > selectIdx ? selectIdx : 0];
    }
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    var match = TRACE_PARENT_REGEX.exec(Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["M" /* strTrim */])(value));
    if (!match || // No match
        match[1] === INVALID_VERSION || // version ff is forbidden
        match[2] === INVALID_TRACE_ID || // All zeros is considered to be invalid
        match[3] === INVALID_SPAN_ID) { // All zeros is considered to be invalid
        return null;
    }
    return _a = {
            version: (match[1] || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */])[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["V" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */](),
            traceId: (match[2] || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */])[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["V" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */](),
            spanId: (match[3] || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */])[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["V" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]()
        },
        _a[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["W" /* _DYN_TRACE_FLAGS */] /* @min:traceFlags */] = parseInt(match[4], 16),
        _a;
}
/**
 * Is the provided W3c Trace Id a valid string representation, it must be a 32-character string
 * of lowercase hexadecimal characters for example, 4bf92f3577b34da6a3ce929d0e0e4736.
 * If all characters as zero (00000000000000000000000000000000) it will be considered an invalid value.
 * @param value - The W3c trace Id to be validated
 * @returns true if valid otherwise false
 */
function isValidTraceId(value) {
    return _isValid(value, 32, INVALID_TRACE_ID);
}
/**
 * Is the provided W3c span id (aka. parent id) a valid string representation, it must be a 16-character
 * string of lowercase hexadecimal characters, for example, 00f067aa0ba902b7.
 * If all characters are zero (0000000000000000) this is considered an invalid value.
 * @param value - The W3c span id to be validated
 * @returns true if valid otherwise false
 */
function isValidSpanId(value) {
    return _isValid(value, 16, INVALID_SPAN_ID);
}
/**
 * Validates that the provided ITraceParent instance conforms to the currently supported specifications
 * @param value
 * @returns
 */
function isValidTraceParent(value) {
    if (!value ||
        !_isValid(value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["_1" /* _DYN_VERSION */] /* @min:%2eversion */], 2, INVALID_VERSION) ||
        !_isValid(value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["X" /* _DYN_TRACE_ID */] /* @min:%2etraceId */], 32, INVALID_TRACE_ID) ||
        !_isValid(value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["N" /* _DYN_SPAN_ID */] /* @min:%2espanId */], 16, INVALID_SPAN_ID) ||
        !_isValid(_formatFlags(value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["W" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */]), 2)) {
        // Each known field must contain a valid value
        return false;
    }
    return true;
}
/**
 * Is the parsed traceParent indicating that the trace is currently sampled.
 * @param value - The parsed traceParent value
 * @returns
 */
function isSampledFlag(value) {
    if (isValidTraceParent(value)) {
        return (value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["W" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */] & SAMPLED_FLAG) === SAMPLED_FLAG;
    }
    return false;
}
/**
 * Format the ITraceParent value as a string using the supported and know version formats.
 * So even if the passed traceParent is a later version the string value returned from this
 * function will convert it to only the known version formats.
 * This currently only supports version "00" and invalid "ff"
 * @param value - The parsed traceParent value
 * @returns
 */
function formatTraceParent(value) {
    if (value) {
        // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
        // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
        var flags = _formatFlags(value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["W" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */]);
        if (!_isValid(flags, 2)) {
            flags = "01";
        }
        var version = value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["_1" /* _DYN_VERSION */] /* @min:%2eversion */] || DEFAULT_VERSION;
        if (version !== "00" && version !== "ff") {
            // Reduce version to "00"
            version = DEFAULT_VERSION;
        }
        // Format as version 00
        return "".concat(version.toLowerCase(), "-").concat(_formatValue(value.traceId, 32, INVALID_TRACE_ID).toLowerCase(), "-").concat(_formatValue(value.spanId, 16, INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
    }
    return "";
}
/**
 * Helper function to fetch the passed traceparent from the page, looking for it as a meta-tag or a Server-Timing header.
 * @param selectIdx - If the found value is comma separated which is the preferred entry to select, defaults to the first
 * @returns
 */
function findW3cTraceParent(selectIdx) {
    var name = "traceparent";
    var traceParent = parseTraceParent(Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["b" /* findMetaTag */])(name), selectIdx);
    if (!traceParent) {
        traceParent = parseTraceParent(Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["c" /* findNamedServerTiming */])(name), selectIdx);
    }
    return traceParent;
}
//# sourceMappingURL=W3cTraceParent.js.map

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Undefined */
/* unused harmony export newGuid */
/* unused harmony export perfNow */
/* unused harmony export strEndsWith */
/* harmony export (immutable) */ __webpack_exports__["f"] = generateW3CId;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CoreUtils; });
/* unused harmony export EventHelper */
/* harmony export (immutable) */ __webpack_exports__["b"] = _legacyCookieMgr;
/* harmony export (immutable) */ __webpack_exports__["e"] = disableCookies;
/* harmony export (immutable) */ __webpack_exports__["c"] = canUseCookies;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["h"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CookieMgr__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnvUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventHelpers__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InternalConstants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RandomHelper__ = __webpack_require__(484);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */











var _cookieMgrs = null;
var _canUseCookies; // legacy supported config
// Added to help with minfication
var Undefined = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
function newGuid() {
    var uuid = generateW3CId();
    return uuid[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["S" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](0, 8) + "-" + uuid[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["S" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](8, 12) + "-" + uuid[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["S" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](12, 16) + "-" + uuid[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["S" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](16, 20) + "-" + uuid[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["S" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](20);
}
/**
 * Return the current value of the Performance Api now() function (if available) and fallback to dateNow() if it is unavailable (IE9 or less)
 * https://caniuse.com/#search=performance.now
 */
function perfNow() {
    var perf = Object(__WEBPACK_IMPORTED_MODULE_3__EnvUtils__["n" /* getPerformance */])();
    if (perf && perf.now) {
        return perf.now();
    }
    return Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["g" /* dateNow */])();
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var len = value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
        var start = len - search[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
        return value[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["S" /* _DYN_SUBSTRING */] /* @min:%2esubstring */](start >= 0 ? start : 0, len) === search;
    }
    return false;
}
/**
 * generate W3C trace id
 */
function generateW3CId() {
    var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = __WEBPACK_IMPORTED_MODULE_6__InternalConstants__["e" /* STR_EMPTY */], tmp;
    for (var a = 0; a < 4; a++) {
        tmp = Object(__WEBPACK_IMPORTED_MODULE_7__RandomHelper__["d" /* random32 */])();
        oct +=
            hexValues[tmp & 0xF] +
                hexValues[tmp >> 4 & 0xF] +
                hexValues[tmp >> 8 & 0xF] +
                hexValues[tmp >> 12 & 0xF] +
                hexValues[tmp >> 16 & 0xF] +
                hexValues[tmp >> 20 & 0xF] +
                hexValues[tmp >> 24 & 0xF] +
                hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + (Object(__WEBPACK_IMPORTED_MODULE_7__RandomHelper__["d" /* random32 */])() & 0x03) | 0];
    return oct[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["R" /* _DYN_SUBSTR */] /* @min:%2esubstr */](0, 8) + oct[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["R" /* _DYN_SUBSTR */] /* @min:%2esubstr */](9, 4) + "4" + oct[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["R" /* _DYN_SUBSTR */] /* @min:%2esubstr */](13, 3) + clockSequenceHi + oct[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["R" /* _DYN_SUBSTR */] /* @min:%2esubstr */](16, 3) + oct[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["R" /* _DYN_SUBSTR */] /* @min:%2esubstr */](19, 12);
}
/**
 * Provides a collection of utility functions, included for backward compatibility with previous releases.
 * @deprecated Marking this instance as deprecated in favor of direct usage of the helper functions
 * as direct usage provides better tree-shaking and minification by avoiding the inclusion of the unused items
 * in your resulting code.
 */
var CoreUtils = {
    _canUseCookies: undefined,
    isTypeof: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["x" /* isTypeof */],
    isUndefined: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["y" /* isUndefined */],
    isNullOrUndefined: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["s" /* isNullOrUndefined */],
    hasOwnProperty: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["l" /* hasOwnProperty */],
    isFunction: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["q" /* isFunction */],
    isObject: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["u" /* isObject */],
    isDate: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["o" /* isDate */],
    isArray: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["m" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["p" /* isError */],
    isString: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["v" /* isString */],
    isNumber: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["t" /* isNumber */],
    isBoolean: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["n" /* isBoolean */],
    toISOString: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["O" /* toISOString */],
    arrForEach: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["b" /* arrForEach */],
    arrIndexOf: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["c" /* arrIndexOf */],
    arrMap: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["d" /* arrMap */],
    arrReduce: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["e" /* arrReduce */],
    strTrim: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["M" /* strTrim */],
    objCreate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */],
    objKeys: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["E" /* objKeys */],
    objDefineAccessors: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["A" /* objDefineAccessors */],
    addEventHandler: __WEBPACK_IMPORTED_MODULE_4__EventHelpers__["a" /* addEventHandler */],
    dateNow: __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["g" /* dateNow */],
    isIE: __WEBPACK_IMPORTED_MODULE_3__EnvUtils__["v" /* isIE */],
    disableCookies: disableCookies,
    newGuid: newGuid,
    perfNow: perfNow,
    newId: __WEBPACK_IMPORTED_MODULE_7__RandomHelper__["c" /* newId */],
    randomValue: __WEBPACK_IMPORTED_MODULE_7__RandomHelper__["e" /* randomValue */],
    random32: __WEBPACK_IMPORTED_MODULE_7__RandomHelper__["d" /* random32 */],
    mwcRandomSeed: __WEBPACK_IMPORTED_MODULE_7__RandomHelper__["b" /* mwcRandomSeed */],
    mwcRandom32: __WEBPACK_IMPORTED_MODULE_7__RandomHelper__["a" /* mwcRandom32 */],
    generateW3CId: generateW3CId
};
var GuidRegex = /[xy]/g;
var EventHelper = {
    Attach: __WEBPACK_IMPORTED_MODULE_4__EventHelpers__["d" /* attachEvent */],
    AttachEvent: __WEBPACK_IMPORTED_MODULE_4__EventHelpers__["d" /* attachEvent */],
    Detach: __WEBPACK_IMPORTED_MODULE_4__EventHelpers__["e" /* detachEvent */],
    DetachEvent: __WEBPACK_IMPORTED_MODULE_4__EventHelpers__["e" /* detachEvent */]
};
/**
 * Helper to support backward compatibility for users that use the legacy cookie handling functions and the use the internal
 * CoreUtils._canUseCookies global flag to enable/disable cookies usage.
 * Note: This has the following deliberate side-effects
 * - Creates the global (legacy) cookie manager if it does not already exist
 * - Attempts to add "listeners" to the CoreUtils._canUseCookies property to support the legacy usage
 * @param config
 * @param logger
 * @returns
 */
function _legacyCookieMgr(config, logger) {
    var cookieMgr = Object(__WEBPACK_IMPORTED_MODULE_2__CookieMgr__["a" /* _gblCookieMgr */])(config, logger);
    var legacyCanUseCookies = CoreUtils._canUseCookies;
    if (_cookieMgrs === null) {
        _cookieMgrs = [];
        _canUseCookies = legacyCanUseCookies;
        // Dynamically create get/set property accessors for backward compatibility for enabling / disabling cookies
        // this WILL NOT work for ES3 browsers (< IE8)
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["A" /* objDefineAccessors */])(CoreUtils, "_canUseCookies", function () {
            return _canUseCookies;
        }, function (value) {
            _canUseCookies = value;
            Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["b" /* arrForEach */])(_cookieMgrs, function (mgr) {
                mgr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["L" /* _DYN_SET_ENABLED */] /* @min:%2esetEnabled */](value);
            });
        });
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["c" /* arrIndexOf */])(_cookieMgrs, cookieMgr) === -1) {
        _cookieMgrs[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](cookieMgr);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["n" /* isBoolean */])(legacyCanUseCookies)) {
        cookieMgr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["L" /* _DYN_SET_ENABLED */] /* @min:%2esetEnabled */](legacyCanUseCookies);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["n" /* isBoolean */])(_canUseCookies)) {
        cookieMgr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["L" /* _DYN_SET_ENABLED */] /* @min:%2esetEnabled */](_canUseCookies);
    }
    return cookieMgr;
}
/**
 * @deprecated - Use the core.getCookieMgr().disable()
 * Force the SDK not to store and read any data from cookies.
 */
function disableCookies() {
    _legacyCookieMgr()[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["L" /* _DYN_SET_ENABLED */] /* @min:%2esetEnabled */](false);
}
/**
 * @deprecated - Use the core.getCookieMgr().isEnabled()
 * Helper method to tell if document.cookie object is available and whether it can be used.
 */
function canUseCookies(logger) {
    return _legacyCookieMgr(null, logger).isEnabled();
}
/**
 * @deprecated - Use the core.getCookieMgr().get()
 * helper method to access userId and sessionId cookie
 */
function getCookie(logger, name) {
    return _legacyCookieMgr(null, logger).get(name);
}
/**
 * @deprecated - Use the core.getCookieMgr().set()
 * helper method to set userId and sessionId cookie
 */
function setCookie(logger, name, value, domain) {
    _legacyCookieMgr(null, logger).set(name, value, null, domain);
}
/**
 * @deprecated - Use the core.getCookieMgr().del()
 * Deletes a cookie by setting it's expiration time in the past.
 * @param name - The name of the cookie to delete.
 */
function deleteCookie(logger, name) {
    return _legacyCookieMgr(null, logger).del(name);
}
//# sourceMappingURL=CoreUtils.js.map

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __getRegisteredEvents */
/* harmony export (immutable) */ __webpack_exports__["h"] = mergeEvtNamespace;
/* harmony export (immutable) */ __webpack_exports__["g"] = eventOn;
/* harmony export (immutable) */ __webpack_exports__["f"] = eventOff;
/* harmony export (immutable) */ __webpack_exports__["d"] = attachEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = detachEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventHandler;
/* unused harmony export removeEventHandler */
/* unused harmony export addEventListeners */
/* unused harmony export removeEventListeners */
/* harmony export (immutable) */ __webpack_exports__["c"] = addPageUnloadEventListener;
/* harmony export (immutable) */ __webpack_exports__["j"] = removePageUnloadEventListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = addPageHideEventListener;
/* harmony export (immutable) */ __webpack_exports__["i"] = removePageHideEventListener;
/* unused harmony export addPageShowEventListener */
/* unused harmony export removePageShowEventListener */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataCacheHelper__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalConstants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var strEvents = "events";
var strVisibilityChangeEvt = "visibilitychange";
var strPageHide = "pagehide";
var strPageShow = "pageshow";
var strUnload = "unload";
var strBeforeUnload = "beforeunload";
var strPageHideNamespace = Object(__WEBPACK_IMPORTED_MODULE_1__DataCacheHelper__["b" /* createUniqueNamespace */])("aiEvtPageHide");
var strPageShowNamespace = Object(__WEBPACK_IMPORTED_MODULE_1__DataCacheHelper__["b" /* createUniqueNamespace */])("aiEvtPageShow");
var rRemoveEmptyNs = /\.[\.]+/g;
var rRemoveTrailingEmptyNs = /[\.]+$/;
var _guid = 1;
var elmNodeData = Object(__WEBPACK_IMPORTED_MODULE_1__DataCacheHelper__["a" /* createElmNodeData */])("events");
var eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function _normalizeNamespace(name) {
    if (name && name[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["J" /* _DYN_REPLACE */] /* @min:%2ereplace */]) {
        return name[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["J" /* _DYN_REPLACE */] /* @min:%2ereplace */](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */]);
    }
    return name;
}
function _getEvtNamespace(eventName, evtNamespace) {
    var _a;
    if (evtNamespace) {
        var theNamespace_1 = __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */];
        if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(evtNamespace)) {
            theNamespace_1 = __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */];
            Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrForEach */])(evtNamespace, function (name) {
                name = _normalizeNamespace(name);
                if (name) {
                    if (name[0] !== ".") {
                        name = "." + name;
                    }
                    theNamespace_1 += name;
                }
            });
        }
        else {
            theNamespace_1 = _normalizeNamespace(evtNamespace);
        }
        if (theNamespace_1) {
            if (theNamespace_1[0] !== ".") {
                theNamespace_1 = "." + theNamespace_1;
            }
            // We may only have the namespace and not an eventName
            eventName = (eventName || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */]) + theNamespace_1;
        }
    }
    var parsedEvent = (eventNamespace.exec(eventName || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */]) || []);
    return _a = {},
        _a[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:type */] = parsedEvent[1],
        _a.ns = ((parsedEvent[2] || __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */]).replace(rRemoveEmptyNs, ".").replace(rRemoveTrailingEmptyNs, __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */])[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["P" /* _DYN_SPLIT */] /* @min:%2esplit */](".").sort()).join("."),
        _a;
}
/**
 * Get all of the registered events on the target object, this is primarily used for testing cleanup but may also be used by
 * applications to remove their own events
 * @param target - The EventTarget that has registered events
 * @param eventName - [Optional] The name of the event to return the registered handlers and full name (with namespaces)
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 */
function __getRegisteredEvents(target, eventName, evtNamespace) {
    var theEvents = [];
    var eventCache = elmNodeData.get(target, strEvents, {}, false);
    var evtName = _getEvtNamespace(eventName, evtNamespace);
    Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["C" /* objForEachKey */])(eventCache, function (evtType, registeredEvents) {
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrForEach */])(registeredEvents, function (value) {
            var _a;
            if (!evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */] || evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */] === value.evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */]) {
                if (!evtName.ns || evtName.ns === evtName.ns) {
                    theEvents[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */]((_a = {},
                        _a[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["D" /* _DYN_NAME */] /* @min:name */] = value.evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */] + (value.evtName.ns ? "." + value.evtName.ns : __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_EMPTY */]),
                        _a.handler = value[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["p" /* _DYN_HANDLER */] /* @min:%2ehandler */],
                        _a));
                }
            }
        });
    });
    return theEvents;
}
// Exported for internal unit testing only
function _getRegisteredEvents(target, evtName, addDefault) {
    if (addDefault === void 0) { addDefault = true; }
    var aiEvts = elmNodeData.get(target, strEvents, {}, addDefault);
    var registeredEvents = aiEvts[evtName];
    if (!registeredEvents) {
        registeredEvents = aiEvts[evtName] = [];
    }
    return registeredEvents;
}
function _doDetach(obj, evtName, handlerRef, useCapture) {
    if (obj && evtName && evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */]) {
        if (obj[strRemoveEventListener]) {
            obj[strRemoveEventListener](evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */], handlerRef, useCapture);
        }
        else if (obj[strDetachEvent]) {
            obj[strDetachEvent](strOnPrefix + evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */], handlerRef);
        }
    }
}
function _doAttach(obj, evtName, handlerRef, useCapture) {
    var result = false;
    if (obj && evtName && evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */] && handlerRef) {
        if (obj[strAddEventHelper]) {
            // all browsers except IE before version 9
            obj[strAddEventHelper](evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */], handlerRef, useCapture);
            result = true;
        }
        else if (obj[strAttachEvent]) {
            // IE before version 9
            obj[strAttachEvent](strOnPrefix + evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */], handlerRef);
            result = true;
        }
    }
    return result;
}
function _doUnregister(target, events, evtName, unRegFn) {
    var idx = events[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
    while (idx--) {
        var theEvent = events[idx];
        if (theEvent) {
            if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
                if (!unRegFn || unRegFn(theEvent)) {
                    _doDetach(target, theEvent.evtName, theEvent[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["p" /* _DYN_HANDLER */] /* @min:%2ehandler */], theEvent.capture);
                    // Remove the registered event
                    events[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["O" /* _DYN_SPLICE */] /* @min:%2esplice */](idx, 1);
                }
            }
        }
    }
}
function _unregisterEvents(target, evtName, unRegFn) {
    if (evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */]) {
        _doUnregister(target, _getRegisteredEvents(target, evtName[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["Y" /* _DYN_TYPE */] /* @min:%2etype */]), evtName, unRegFn);
    }
    else {
        var eventCache = elmNodeData.get(target, strEvents, {});
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["C" /* objForEachKey */])(eventCache, function (evtType, events) {
            _doUnregister(target, events, evtName, unRegFn);
        });
        // Cleanup
        if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["E" /* objKeys */])(eventCache)[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] === 0) {
            elmNodeData.kill(target, strEvents);
        }
    }
}
function mergeEvtNamespace(theNamespace, namespaces) {
    var newNamespaces;
    if (namespaces) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(namespaces)) {
            newNamespaces = [theNamespace].concat(namespaces);
        }
        else {
            newNamespaces = [theNamespace, namespaces];
        }
        // resort the namespaces so they are always in order
        newNamespaces = (_getEvtNamespace("xx", newNamespaces).ns)[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["P" /* _DYN_SPLIT */] /* @min:%2esplit */](".");
    }
    else {
        newNamespaces = theNamespace;
    }
    return newNamespaces;
}
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj Object to add the event too.
 * @param eventName String that specifies any of the standard DHTML Events without "on" prefix, if may also include an optional (dot "." prefixed)
 * namespaces "click" "click.mynamespace" in addition to specific namespaces.
 * @param handlerRef Pointer that specifies the function to call when event fires
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function eventOn(target, eventName, handlerRef, evtNamespace, useCapture) {
    var _a;
    if (useCapture === void 0) { useCapture = false; }
    var result = false;
    if (target) {
        try {
            var evtName = _getEvtNamespace(eventName, evtNamespace);
            result = _doAttach(target, evtName, handlerRef, useCapture);
            if (result && elmNodeData.accept(target)) {
                var registeredEvent = (_a = {
                        guid: _guid++,
                        evtName: evtName
                    },
                    _a[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["p" /* _DYN_HANDLER */] /* @min:handler */] = handlerRef,
                    _a.capture = useCapture,
                    _a);
                _getRegisteredEvents(target, evtName.type)[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](registeredEvent);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object to remove the event from
 * @param eventName {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param handlerRef {any} - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture [Optional] Defaults to false
 */
function eventOff(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (target) {
        try {
            var evtName_1 = _getEvtNamespace(eventName, evtNamespace);
            var found_1 = false;
            _unregisterEvents(target, evtName_1, function (regEvent) {
                if ((evtName_1.ns && !handlerRef) || regEvent[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["p" /* _DYN_HANDLER */] /* @min:%2ehandler */] === handlerRef) {
                    found_1 = true;
                    return true;
                }
                return false;
            });
            if (!found_1) {
                // fallback to try and remove as requested
                _doDetach(target, evtName_1, handlerRef, useCapture);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj Object to add the event too.
 * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix and optional (dot "." prefixed) namespaces "click" "click.mynamespace".
 * @param handlerRef Pointer that specifies the function to call when event fires
 * @param useCapture [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    return eventOn(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
/**
 * Removes an event handler for the specified event
 * @param Object to remove the event from
 * @param eventNameWithoutOn {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param handlerRef {any} - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param useCapture [Optional] Defaults to false
 */
function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    eventOff(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName {string} - The name of the event
 * @param callback {any} - The callback function that needs to be executed for the given event
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @return {boolean} - true if the handler was successfully added
 */
function addEventHandler(eventName, callback, evtNamespace) {
    var result = false;
    var w = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["o" /* getWindow */])();
    if (w) {
        result = eventOn(w, eventName, callback, evtNamespace);
        result = eventOn(w["body"], eventName, callback, evtNamespace) || result;
    }
    var doc = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["f" /* getDocument */])();
    if (doc) {
        result = eventOn(doc, eventName, callback, evtNamespace) || result;
    }
    return result;
}
/**
 * Trys to remove event handler(s) for the specified event/namespace to the window, body and document
 * @param eventName {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param callback {any} - - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventHandler(eventName, callback, evtNamespace) {
    var w = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["o" /* getWindow */])();
    if (w) {
        eventOff(w, eventName, callback, evtNamespace);
        eventOff(w["body"], eventName, callback, evtNamespace);
    }
    var doc = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["f" /* getDocument */])();
    if (doc) {
        eventOff(doc, eventName, callback, evtNamespace);
    }
}
/**
 * Bind the listener to the array of events
 * @param events An string array of event names to bind the listener to
 * @param listener The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function _addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && events[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrForEach */])(events, function (name) {
            if (name) {
                if (!excludeEvents || Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["c" /* arrIndexOf */])(excludeEvents, name) === -1) {
                    added = addEventHandler(name, listener, evtNamespace) || added;
                }
            }
        });
    }
    return added;
}
/**
 * Bind the listener to the array of events
 * @param events An string array of event names to bind the listener to
 * @param listener The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(events)) {
        added = _addEventListeners(events, listener, excludeEvents, evtNamespace);
        if (!added && excludeEvents && excludeEvents[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
            // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
            added = _addEventListeners(events, listener, null, evtNamespace);
        }
    }
    return added;
}
/**
 * Remove the listener from the array of events
 * @param events An string array of event names to bind the listener to
 * @param listener The event callback to call when the event is triggered
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventListeners(events, listener, evtNamespace) {
    if (events && Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isArray */])(events)) {
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrForEach */])(events, function (name) {
            if (name) {
                removeEventHandler(name, listener, evtNamespace);
            }
        });
    }
}
/**
 * Listen to the 'beforeunload', 'unload' and 'pagehide' events which indicates a page unload is occurring,
 * this does NOT listen to the 'visibilitychange' event as while it does indicate that the page is being hidden
 * it does not *necessarily* mean that the page is being completely unloaded, it can mean that the user is
 * just navigating to a different Tab and may come back (without unloading the page). As such you may also
 * need to listen to the 'addPageHideEventListener' and 'addPageShowEventListener' events.
 * @param listener - The event callback to call when a page unload event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked, unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageUnloadEventListener(listener, excludeEvents, evtNamespace) {
    // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
    // As just hooking the window does not always fire (on chrome) for page navigation's.
    return addEventListeners([strBeforeUnload, strUnload, strPageHide], listener, excludeEvents, evtNamespace);
}
/**
 * Remove any matching 'beforeunload', 'unload' and 'pagehide' events that may have been added via addEventListener,
 * addEventListeners, addPageUnloadEventListener or addPageHideEventListener.
 * @param listener - The specific event callback to to be removed
 * @param evtNamespace - [Optional] Namespace(s) uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function removePageUnloadEventListener(listener, evtNamespace) {
    removeEventListeners([strBeforeUnload, strUnload, strPageHide], listener, evtNamespace);
}
/**
 * Listen to the pagehide and visibility changing to 'hidden' events, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when if you plan to call
 * removePageShowEventListener as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The event callback to call when a page hide event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] A Namespace to append to the event listeners so they can be uniquely identified and removed
 * based on this namespace. This call also adds an additional unique "pageshow" namespace to the events
 * so that only the matching "removePageHideEventListener" can remove these events.
 * Suggestion: pass as true if you are also calling addPageUnloadEventListener as that also hooks pagehide
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageHideEventListener(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["f" /* getDocument */])();
        if (listener && doc && doc.visibilityState === "hidden") {
            listener(evt);
        }
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
    var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
    var pageUnloadAdded = _addEventListeners([strPageHide], listener, excludeEvents, newNamespaces);
    if (!excludeEvents || Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["c" /* arrIndexOf */])(excludeEvents, strVisibilityChangeEvt) === -1) {
        pageUnloadAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
    }
    if (!pageUnloadAdded && excludeEvents) {
        // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
        pageUnloadAdded = addPageHideEventListener(listener, null, evtNamespace);
    }
    return pageUnloadAdded;
}
/**
 * Removes the pageHide event listeners added by addPageHideEventListener, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when calling addPageHideEventListener
 * as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The specific listener to remove for the 'pageshow' event only (ignored for 'visibilitychange')
 * @param evtNamespace - The unique namespace used when calling addPageShowEventListener
 */
function removePageHideEventListener(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
    var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
    removeEventListeners([strPageHide], listener, newNamespaces);
    removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
}
/**
 * Listen to the pageshow and visibility changing to 'visible' events, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when if you plan to call
 * removePageShowEventListener as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The event callback to call when a page is show event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional/Recommended] A Namespace to append to the event listeners so they can be uniquely
 * identified and removed based on this namespace. This call also adds an additional unique "pageshow" namespace to the events
 * so that only the matching "removePageShowEventListener" can remove these events.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageShowEventListener(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["f" /* getDocument */])();
        if (listener && doc && doc.visibilityState === "visible") {
            listener(evt);
        }
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pageshow"
    var newNamespaces = mergeEvtNamespace(strPageShowNamespace, evtNamespace);
    var pageShowAdded = _addEventListeners([strPageShow], listener, excludeEvents, newNamespaces);
    pageShowAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageShowAdded;
    if (!pageShowAdded && excludeEvents) {
        // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
        pageShowAdded = addPageShowEventListener(listener, null, evtNamespace);
    }
    return pageShowAdded;
}
/**
 * Removes the pageShow event listeners added by addPageShowEventListener, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when calling addPageShowEventListener
 * as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The specific listener to remove for the 'pageshow' event only (ignored for 'visibilitychange')
 * @param evtNamespace - The unique namespace used when calling addPageShowEventListener
 */
function removePageShowEventListener(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pageshow"
    var newNamespaces = mergeEvtNamespace(strPageShowNamespace, evtNamespace);
    removeEventListeners([strPageShow], listener, newNamespaces);
    removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
}
//# sourceMappingURL=EventHelpers.js.map

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTelemetryPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalConstants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProcessTelemetryContext__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UnloadHandlerContainer__ = __webpack_require__(486);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var strGetPlugin = "getPlugin";
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _isinitialized;
        var _rootCtx; // Used as the root context, holding the current config and initialized core
        var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
        var _unloadHandlerContainer;
        var _hooks;
        _initDefaults();
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(BaseTelemetryPlugin, _self, function (_self) {
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["s" /* _DYN_INITIALIZE */] /* @min:%2einitialize */] = function (config, core, extensions, pluginChain) {
                _setDefaults(config, core, pluginChain);
                _isinitialized = true;
            };
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["T" /* _DYN_TEARDOWN */] /* @min:%2eteardown */] = function (unloadCtx, unloadState) {
                var _a;
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */];
                if (!core || (unloadCtx && core !== unloadCtx[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */]())) {
                    // Do Nothing as either the plugin is not initialized or was not initialized by the current core
                    return;
                }
                var result;
                var unloadDone = false;
                var theUnloadCtx = unloadCtx || Object(__WEBPACK_IMPORTED_MODULE_4__ProcessTelemetryContext__["b" /* createProcessTelemetryUnloadContext */])(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                var theUnloadState = unloadState || (_a = {
                        reason: 0 /* TelemetryUnloadReason.ManualTeardown */
                    },
                    _a[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["u" /* _DYN_IS_ASYNC */] /* @min:isAsync */] = false,
                    _a);
                function _unloadCallback() {
                    if (!unloadDone) {
                        unloadDone = true;
                        _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                        var oldHooks = _hooks;
                        _hooks = [];
                        // Remove all instrumentation hooks
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["b" /* arrForEach */])(oldHooks, function (fn) {
                            fn.rm();
                        });
                        if (result === true) {
                            theUnloadCtx[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](theUnloadState);
                        }
                        _initDefaults();
                    }
                }
                if (!_self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["_2" /* _DYN__DO_TEARDOWN */] /* @min:%2e_doTeardown */] || _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["_2" /* _DYN__DO_TEARDOWN */] /* @min:%2e_doTeardown */](theUnloadCtx, theUnloadState, _unloadCallback) !== true) {
                    _unloadCallback();
                }
                else {
                    // Tell the caller that we will be calling processNext()
                    result = true;
                }
                return result;
            };
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["Z" /* _DYN_UPDATE */] /* @min:%2eupdate */] = function (updateCtx, updateState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */];
                if (!core || (updateCtx && core !== updateCtx[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */]())) {
                    // Do Nothing
                    return;
                }
                var result;
                var updateDone = false;
                var theUpdateCtx = updateCtx || Object(__WEBPACK_IMPORTED_MODULE_4__ProcessTelemetryContext__["c" /* createProcessTelemetryUpdateContext */])(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                var theUpdateState = updateState || {
                    reason: 0 /* TelemetryUpdateReason.Unknown */
                };
                function _updateCallback() {
                    if (!updateDone) {
                        updateDone = true;
                        _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["l" /* _DYN_GET_NEXT */] /* @min:%2egetNext */]());
                    }
                }
                if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) {
                    _updateCallback();
                }
                else {
                    result = true;
                }
                return result;
            };
            _self._addHook = function (hooks) {
                if (hooks) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["m" /* isArray */])(hooks)) {
                        _hooks = _hooks.concat(hooks);
                    }
                    else {
                        _hooks[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](hooks);
                    }
                }
            };
            Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["H" /* proxyFunctionAs */])(_self, "_addUnloadCb", function () { return _unloadHandlerContainer; }, "add");
        });
        // These are added after the dynamicProto so that are not moved to the prototype
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["h" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */] = function (itemCtx) {
            return _getTelCtx(itemCtx)[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["h" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */]();
        };
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["w" /* _DYN_IS_INITIALIZED */] /* @min:%2eisInitialized */] = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["M" /* _DYN_SET_NEXT_PLUGIN */] /* @min:%2esetNextPlugin */] = function (next) {
            _nextPlugin = next;
        };
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */] = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](env);
            }
            else if (_nextPlugin && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isFunction */])(_nextPlugin[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["o" /* STR_PROCESS_TELEMETRY */] /* @min:%2eprocessTelemetry */])) {
                // Looks like backward compatibility or out of band processing. And as it looks
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["o" /* STR_PROCESS_TELEMETRY */] /* @min:%2eprocessTelemetry */](env, null);
            }
        };
        _self._getTelCtx = _getTelCtx;
        function _getTelCtx(currentCtx) {
            if (currentCtx === void 0) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || Object(__WEBPACK_IMPORTED_MODULE_4__ProcessTelemetryContext__["a" /* createProcessTelemetryContext */])(null, {}, _self[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */]);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["g" /* _DYN_CREATE_NEW */] /* @min:%2ecreateNew */](null, _nextPlugin[strGetPlugin]);
                }
                else {
                    itemCtx = rootCtx[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["g" /* _DYN_CREATE_NEW */] /* @min:%2ecreateNew */](null, _nextPlugin);
                }
            }
            return itemCtx;
        }
        function _setDefaults(config, core, pluginChain) {
            if (config) {
                // Make sure the extensionConfig exists
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["J" /* setValue */])(config, __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["k" /* STR_EXTENSION_CONFIG */], [], null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
            }
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["o" /* _DYN_GET_PROCESS_TEL_CONT0 */] /* @min:%2egetProcessTelContext */]()[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["l" /* _DYN_GET_NEXT */] /* @min:%2egetNext */]();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[strGetPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */] = core;
            _rootCtx = Object(__WEBPACK_IMPORTED_MODULE_4__ProcessTelemetryContext__["a" /* createProcessTelemetryContext */])(pluginChain, config, core, nextPlugin);
        }
        function _initDefaults() {
            _isinitialized = false;
            _self[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_CORE */] /* @min:%2ecore */] = null;
            _rootCtx = null;
            _nextPlugin = null;
            _hooks = [];
            _unloadHandlerContainer = Object(__WEBPACK_IMPORTED_MODULE_5__UnloadHandlerContainer__["a" /* createUnloadHandlerContainer */])();
        }
    }
// Removed Stub for BaseTelemetryPlugin.prototype.initialize.
// Removed Stub for BaseTelemetryPlugin.prototype.teardown.
// Removed Stub for BaseTelemetryPlugin.prototype.update.
// Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
// Removed Stub for BaseTelemetryPlugin.prototype._addHook.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    BaseTelemetryPlugin.__ieDyn=1;

    return BaseTelemetryPlugin;
}());

//# sourceMappingURL=BaseTelemetryPlugin.js.map

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalConstants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






function _runListeners(listeners, name, isAsync, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["b" /* arrForEach */])(listeners, function (listener) {
        if (listener && listener[name]) {
            if (isAsync) {
                setTimeout(function () { return callback(listener); }, 0);
            }
            else {
                try {
                    callback(listener);
                }
                catch (e) {
                    // Catch errors to ensure we don't block sending the requests
                }
            }
        }
    });
}
/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(NotificationManager, this, function (_self) {
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["a" /* _DYN_ADD_NOTIFICATION_LIS1 */] /* @min:%2eaddNotificationListener */] = function (listener) {
                _self.listeners[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - AWTNotificationListener to remove.
             */
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["I" /* _DYN_REMOVE_NOTIFICATION_2 */] /* @min:%2eremoveNotificationListener */] = function (listener) {
                var index = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["c" /* arrIndexOf */])(_self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["y" /* _DYN_LISTENERS */] /* @min:%2elisteners */], listener);
                while (index > -1) {
                    _self.listeners[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["O" /* _DYN_SPLICE */] /* @min:%2esplice */](index, 1);
                    index = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["c" /* arrIndexOf */])(_self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["y" /* _DYN_LISTENERS */] /* @min:%2elisteners */], listener);
                }
            };
            /**
             * Notification for events sent.
             * @param {ITelemetryItem[]} events - The array of events that have been sent.
             */
            _self[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["i" /* STR_EVENTS_SENT */] /* @min:%2eeventsSent */] = function (events) {
                _runListeners(_self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["y" /* _DYN_LISTENERS */] /* @min:%2elisteners */], __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["i" /* STR_EVENTS_SENT */], true, function (listener) {
                    listener[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["i" /* STR_EVENTS_SENT */] /* @min:%2eeventsSent */](events);
                });
            };
            /**
             * Notification for events being discarded.
             * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
             * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */
            _self[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["g" /* STR_EVENTS_DISCARDED */] /* @min:%2eeventsDiscarded */] = function (events, reason) {
                _runListeners(_self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["y" /* _DYN_LISTENERS */] /* @min:%2elisteners */], __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["g" /* STR_EVENTS_DISCARDED */], true, function (listener) {
                    listener[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["g" /* STR_EVENTS_DISCARDED */] /* @min:%2eeventsDiscarded */](events, reason);
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param {number} sendReason - The reason why the event batch is being sent.
             * @param {boolean} isAsync   - A flag which identifies whether the requests are being sent in an async or sync manner.
             */
            _self[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["h" /* STR_EVENTS_SEND_REQUEST */] /* @min:%2eeventsSendRequest */] = function (sendReason, isAsync) {
                _runListeners(_self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["y" /* _DYN_LISTENERS */] /* @min:%2elisteners */], __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["h" /* STR_EVENTS_SEND_REQUEST */], isAsync, function (listener) {
                    listener[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["h" /* STR_EVENTS_SEND_REQUEST */] /* @min:%2eeventsSendRequest */](sendReason, isAsync);
                });
            };
            _self[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["m" /* STR_PERF_EVENT */] /* @min:%2eperfEvent */] = function (perfEvent) {
                if (perfEvent) {
                    // Send all events or only parent events
                    if (perfEvtsSendAll || !perfEvent[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["v" /* _DYN_IS_CHILD_EVT */] /* @min:%2eisChildEvt */]()) {
                        _runListeners(_self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["y" /* _DYN_LISTENERS */] /* @min:%2elisteners */], __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["m" /* STR_PERF_EVENT */], false, function (listener) {
                            if (perfEvent[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["u" /* _DYN_IS_ASYNC */] /* @min:%2eisAsync */]) {
                                setTimeout(function () { return listener[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["m" /* STR_PERF_EVENT */] /* @min:%2eperfEvent */](perfEvent); }, 0);
                            }
                            else {
                                listener[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["m" /* STR_PERF_EVENT */] /* @min:%2eperfEvent */](perfEvent);
                            }
                        });
                    }
                }
            };
        });
    }
// Removed Stub for NotificationManager.prototype.addNotificationListener.
// Removed Stub for NotificationManager.prototype.removeNotificationListener.
// Removed Stub for NotificationManager.prototype.eventsSent.
// Removed Stub for NotificationManager.prototype.eventsDiscarded.
// Removed Stub for NotificationManager.prototype.eventsSendRequest.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    NotificationManager.__ieDyn=1;

    return NotificationManager;
}());

//# sourceMappingURL=NotificationManager.js.map

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDomEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function createDomEvent(eventName) {
    var event = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(Event)) { // Use Event constructor when available
        event = new Event(eventName);
    }
    else { // Event has no constructor in IE
        var doc = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* getDocument */])();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}
//# sourceMappingURL=DomHelperFuncs.js.map

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestHeaders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var RequestHeaders = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["A" /* createValueMap */])({
    requestContextHeader: [0 /* eRequestHeaders.requestContextHeader */, "Request-Context"],
    requestContextTargetKey: [1 /* eRequestHeaders.requestContextTargetKey */, "appId"],
    requestContextAppIdFormat: [2 /* eRequestHeaders.requestContextAppIdFormat */, "appId=cid-v1:"],
    requestIdHeader: [3 /* eRequestHeaders.requestIdHeader */, "Request-Id"],
    traceParentHeader: [4 /* eRequestHeaders.traceParentHeader */, "traceparent"],
    traceStateHeader: [5 /* eRequestHeaders.traceStateHeader */, "tracestate"],
    sdkContextHeader: [6 /* eRequestHeaders.sdkContextHeader */, "Sdk-Context"],
    sdkContextHeaderAppIdRequest: [7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */, "appId"],
    requestContextHeaderLowerCase: [8 /* eRequestHeaders.requestContextHeaderLowerCase */, "request-context"]
});
//# sourceMappingURL=RequestResponseHeaders.js.map

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StorageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DistributedTracingModes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var StorageType = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["w" /* createEnumStyle */])({
    LocalStorage: 0 /* eStorageType.LocalStorage */,
    SessionStorage: 1 /* eStorageType.SessionStorage */
});
var DistributedTracingModes = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["w" /* createEnumStyle */])({
    AI: 0 /* eDistributedTracingModes.AI */,
    AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */,
    W3C: 2 /* eDistributedTracingModes.W3C */
});
//# sourceMappingURL=Enums.js.map

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = urlParseUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = urlGetAbsoluteUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = urlGetPathName;
/* harmony export (immutable) */ __webpack_exports__["b"] = urlGetCompleteUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = urlParseHost;
/* harmony export (immutable) */ __webpack_exports__["d"] = urlParseFullHost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(88);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _document = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* getDocument */])() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
    var anchorIdx = _htmlAnchorIdx;
    var anchorCache = _htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!_document.createElement) {
        // Always create the temp instance if createElement is not available
        tempAnchor = { host: urlParseHost(url, true) };
    }
    else if (!anchorCache[anchorIdx]) {
        // Create and cache the unattached anchor instance
        tempAnchor = anchorCache[anchorIdx] = _document.createElement("a");
    }
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */]) {
        anchorIdx = 0;
    }
    _htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.href;
    }
    return result;
}
function urlGetPathName(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["y" /* _DYN_PATHNAME */] /* @min:%2epathname */];
    }
    return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
    if (method) {
        return method.toUpperCase() + " " + absoluteUrl;
    }
    return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
    var fullHost = urlParseFullHost(url, inclPort) || "";
    if (fullHost) {
        var match = fullHost.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 3 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_13" /* isString */])(match[2]) && match[2][__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
            return match[2] + (match[3] || "");
        }
    }
    return fullHost;
}
function urlParseFullHost(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 2 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_13" /* isString */])(match[2]) && match[2][__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
            result = match[2] || "";
            if (inclPort && match[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 2) {
                var protocol = (match[1] || "")[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["N" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") {
                    port = "";
                }
                else if (protocol === "https" && port === ":443") {
                    port = "";
                }
                result += port;
            }
        }
    }
    return result;
}
//# sourceMappingURL=UrlHelperFuncs.js.map

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(345);
/* unused harmony reexport strShimFunction */
/* unused harmony reexport strShimObject */
/* unused harmony reexport strShimUndefined */
/* unused harmony reexport strShimPrototype */
/* unused harmony reexport strShimHasOwnProperty */
/* unused harmony reexport strDefault */
/* unused harmony reexport ObjClass */
/* unused harmony reexport ObjProto */
/* unused harmony reexport ObjAssign */
/* unused harmony reexport ObjCreate */
/* unused harmony reexport ObjDefineProperty */
/* unused harmony reexport ObjHasOwnProperty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(488);
/* unused harmony reexport throwTypeError */
/* unused harmony reexport objCreateFn */
/* unused harmony reexport getGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(773);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c"]; });
/* unused harmony reexport __restFn */
/* unused harmony reexport __spreadArrayFn */
/* unused harmony reexport __spreadArraysFn */
/* unused harmony reexport __decorateFn */
/* unused harmony reexport __paramFn */
/* unused harmony reexport __metadataFn */
/* unused harmony reexport __createBindingFn */
/* unused harmony reexport __valuesFn */
/* unused harmony reexport __readFn */
/* unused harmony reexport __makeTemplateObjectFn */
/* unused harmony reexport __importDefaultFn */
/* unused harmony reexport __importStarFn */
/* unused harmony reexport __exportStarFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TsLibGlobals__ = __webpack_require__(1898);
/* unused harmony reexport __exposeGlobalTsLib */
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.




//# sourceMappingURL=applicationinsights-shims.js.map

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SymbolObj */
/* unused harmony export ReflectObj */
/* unused harmony export __hasSymbol */
/* unused harmony export __hasReflect */
/* unused harmony export __objAssignFnImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assignFn; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __extendsFn;
/* unused harmony export __restFn */
/* unused harmony export __decorateFn */
/* unused harmony export __paramFn */
/* unused harmony export __metadataFn */
/* unused harmony export __exportStarFn */
/* harmony export (immutable) */ __webpack_exports__["b"] = __createBindingFn;
/* unused harmony export __valuesFn */
/* unused harmony export __readFn */
/* unused harmony export __spreadArraysFn */
/* unused harmony export __spreadArrayFn */
/* unused harmony export __makeTemplateObjectFn */
/* unused harmony export __importStarFn */
/* unused harmony export __importDefaultFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(488);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES3 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
var SymbolObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Symbol"];
var ReflectObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Reflect"];
var __hasSymbol = !!SymbolObj;
var __hasReflect = !!ReflectObj;
var strDecorate = "decorate";
var strMetadata = "metadata";
var strGetOwnPropertySymbols = "getOwnPropertySymbols";
var strIterator = "iterator";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (__WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */][__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && b !== null) {
        Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b === null ? Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["b" /* objCreateFn */])(b) : (__[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]], new __());
}
function __restFn(s, e) {
    var t = {};
    for (var k in s) {
        if (__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(s, k) && e.indexOf(k) < 0) {
            t[k] = s[k];
        }
    }
    if (s != null && typeof __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        for (var i = 0, p = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols](s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && __WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */]["propertyIsEnumerable"].call(s, p[i])) {
                t[p[i]] = s[p[i]];
            }
        }
    }
    return t;
}
function __decorateFn(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["getOwnPropertyDescriptor"](target, key) : desc, d;
    if (__hasReflect && typeof ReflectObj[strDecorate] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        r = ReflectObj[strDecorate](decorators, target, key, desc);
    }
    else {
        for (var i = decorators.length - 1; i >= 0; i--) {
            // eslint-disable-next-line no-cond-assign
            if (d = decorators[i]) {
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
            }
        }
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(target, key, r), r;
}
function __paramFn(paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadataFn(metadataKey, metadataValue) {
    if (__hasReflect && ReflectObj[strMetadata] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        return ReflectObj[strMetadata](metadataKey, metadataValue);
    }
}
function __exportStarFn(m, o) {
    for (var p in m) {
        if (p !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && !__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(o, p)) {
            __createBindingFn(o, m, p);
        }
    }
}
function __createBindingFn(o, m, k, k2) {
    if (k2 === undefined) {
        k2 = k;
    }
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(o, k2, {
            enumerable: true,
            get: function () {
                return m[k];
            }
        });
    }
    else {
        o[k2] = m[k];
    }
}
function __valuesFn(o) {
    var s = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && SymbolObj[strIterator], m = s && o[s], i = 0;
    if (m) {
        return m.call(o);
    }
    if (o && typeof o.length === "number") {
        return {
            next: function () {
                if (o && i >= o.length) {
                    o = void 0;
                }
                return { value: o && o[i++], done: !o };
            }
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __readFn(o, n) {
    var m = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && o[SymbolObj[strIterator]];
    if (!m) {
        return o;
    }
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    }
    catch (error) {
        e = {
            error: error
        };
    }
    finally {
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) {
                m.call(i);
            }
        }
        finally {
            if (e) {
                // eslint-disable-next-line no-unsafe-finally
                throw e.error;
            }
        }
    }
    return ar;
}
/** @deprecated */
function __spreadArraysFn() {
    var theArgs = arguments;
    // Calculate new total size
    for (var s = 0, i = 0, il = theArgs.length; i < il; i++) {
        s += theArgs[i].length;
    }
    // Create new full array
    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
        for (var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }
    return r;
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}
function __makeTemplateObjectFn(cooked, raw) {
    if (__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
}
function __importStarFn(mod) {
    if (mod && mod.__esModule) {
        return mod;
    }
    var result = {};
    if (mod != null) {
        for (var k in mod) {
            if (k !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && Object.prototype.hasOwnProperty.call(mod, k)) {
                __createBindingFn(result, mod, k);
            }
        }
    }
    // Set default module
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(result, __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */], { enumerable: true, value: mod });
    }
    else {
        result[__WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */]] = mod;
    }
    return result;
}
function __importDefaultFn(mod) {
    return (mod && mod.__esModule) ? mod : { strDefault: mod };
}
//# sourceMappingURL=TsLibShims.js.map

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextTagKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




function _aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function (name) {
        return aiName + name;
    };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* __extendsFn */])(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["v" /* createClassFromInterface */])({
    applicationVersion: _aiApplication("ver"),
    applicationBuild: _aiApplication("build"),
    applicationTypeId: _aiApplication("typeId"),
    applicationId: _aiApplication("applicationId"),
    applicationLayer: _aiApplication("layer"),
    deviceId: _aiDevice("id"),
    deviceIp: _aiDevice("ip"),
    deviceLanguage: _aiDevice("language"),
    deviceLocale: _aiDevice("locale"),
    deviceModel: _aiDevice("model"),
    deviceFriendlyName: _aiDevice("friendlyName"),
    deviceNetwork: _aiDevice("network"),
    deviceNetworkName: _aiDevice("networkName"),
    deviceOEMName: _aiDevice("oemName"),
    deviceOS: _aiDevice("os"),
    deviceOSVersion: _aiDevice("osVersion"),
    deviceRoleInstance: _aiDevice("roleInstance"),
    deviceRoleName: _aiDevice("roleName"),
    deviceScreenResolution: _aiDevice("screenResolution"),
    deviceType: _aiDevice("type"),
    deviceMachineName: _aiDevice("machineName"),
    deviceVMName: _aiDevice("vmName"),
    deviceBrowser: _aiDevice("browser"),
    deviceBrowserVersion: _aiDevice("browserVersion"),
    locationIp: _aiLocation("ip"),
    locationCountry: _aiLocation("country"),
    locationProvince: _aiLocation("province"),
    locationCity: _aiLocation("city"),
    operationId: _aiOperation("id"),
    operationName: _aiOperation("name"),
    operationParentId: _aiOperation("parentId"),
    operationRootId: _aiOperation("rootId"),
    operationSyntheticSource: _aiOperation("syntheticSource"),
    operationCorrelationVector: _aiOperation("correlationVector"),
    sessionId: _aiSession("id"),
    sessionIsFirst: _aiSession("isFirst"),
    sessionIsNew: _aiSession("isNew"),
    userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
    userAccountId: _aiUser("accountId"),
    userAgent: _aiUser("userAgent"),
    userId: _aiUser("id"),
    userStoreRegion: _aiUser("storeRegion"),
    userAuthUserId: _aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
    cloudName: _aiCloud("name"),
    cloudRole: _aiCloud("role"),
    cloudRoleVer: _aiCloud("roleVer"),
    cloudRoleInstance: _aiCloud("roleInstance"),
    cloudEnvironment: _aiCloud("environment"),
    cloudLocation: _aiCloud("location"),
    cloudDeploymentUnit: _aiCloud("deploymentUnit"),
    internalNodeName: _aiInternal("nodeName"),
    internalSdkVersion: _aiInternal("sdkVersion"),
    internalAgentVersion: _aiInternal("agentVersion"),
    internalSnippet: _aiInternal("snippet"),
    internalSdkSrc: _aiInternal("sdkSrc")
})));

//# sourceMappingURL=ContextTagKeys.js.map

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sender__ = __webpack_require__(1914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sender__["a"]; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

//# sourceMappingURL=applicationinsights-channel-js.js.map

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SymbolObj */
/* unused harmony export ReflectObj */
/* unused harmony export __hasSymbol */
/* unused harmony export __hasReflect */
/* unused harmony export __objAssignFnImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assignFn; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __extendsFn;
/* unused harmony export __restFn */
/* unused harmony export __decorateFn */
/* unused harmony export __paramFn */
/* unused harmony export __metadataFn */
/* unused harmony export __exportStarFn */
/* harmony export (immutable) */ __webpack_exports__["b"] = __createBindingFn;
/* unused harmony export __valuesFn */
/* unused harmony export __readFn */
/* unused harmony export __spreadArraysFn */
/* unused harmony export __spreadArrayFn */
/* unused harmony export __makeTemplateObjectFn */
/* unused harmony export __importStarFn */
/* unused harmony export __importDefaultFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(490);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES3 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
var SymbolObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Symbol"];
var ReflectObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Reflect"];
var __hasSymbol = !!SymbolObj;
var __hasReflect = !!ReflectObj;
var strDecorate = "decorate";
var strMetadata = "metadata";
var strGetOwnPropertySymbols = "getOwnPropertySymbols";
var strIterator = "iterator";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (__WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */][__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && b !== null) {
        Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b === null ? Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["b" /* objCreateFn */])(b) : (__[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]], new __());
}
function __restFn(s, e) {
    var t = {};
    for (var k in s) {
        if (__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(s, k) && e.indexOf(k) < 0) {
            t[k] = s[k];
        }
    }
    if (s != null && typeof __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        for (var i = 0, p = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols](s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && __WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */]["propertyIsEnumerable"].call(s, p[i])) {
                t[p[i]] = s[p[i]];
            }
        }
    }
    return t;
}
function __decorateFn(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["getOwnPropertyDescriptor"](target, key) : desc, d;
    if (__hasReflect && typeof ReflectObj[strDecorate] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        r = ReflectObj[strDecorate](decorators, target, key, desc);
    }
    else {
        for (var i = decorators.length - 1; i >= 0; i--) {
            // eslint-disable-next-line no-cond-assign
            if (d = decorators[i]) {
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
            }
        }
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(target, key, r), r;
}
function __paramFn(paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadataFn(metadataKey, metadataValue) {
    if (__hasReflect && ReflectObj[strMetadata] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        return ReflectObj[strMetadata](metadataKey, metadataValue);
    }
}
function __exportStarFn(m, o) {
    for (var p in m) {
        if (p !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && !__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(o, p)) {
            __createBindingFn(o, m, p);
        }
    }
}
function __createBindingFn(o, m, k, k2) {
    if (k2 === undefined) {
        k2 = k;
    }
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(o, k2, {
            enumerable: true,
            get: function () {
                return m[k];
            }
        });
    }
    else {
        o[k2] = m[k];
    }
}
function __valuesFn(o) {
    var s = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && SymbolObj[strIterator], m = s && o[s], i = 0;
    if (m) {
        return m.call(o);
    }
    if (o && typeof o.length === "number") {
        return {
            next: function () {
                if (o && i >= o.length) {
                    o = void 0;
                }
                return { value: o && o[i++], done: !o };
            }
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __readFn(o, n) {
    var m = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && o[SymbolObj[strIterator]];
    if (!m) {
        return o;
    }
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    }
    catch (error) {
        e = {
            error: error
        };
    }
    finally {
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) {
                m.call(i);
            }
        }
        finally {
            if (e) {
                // eslint-disable-next-line no-unsafe-finally
                throw e.error;
            }
        }
    }
    return ar;
}
/** @deprecated */
function __spreadArraysFn() {
    var theArgs = arguments;
    // Calculate new total size
    for (var s = 0, i = 0, il = theArgs.length; i < il; i++) {
        s += theArgs[i].length;
    }
    // Create new full array
    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
        for (var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }
    return r;
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}
function __makeTemplateObjectFn(cooked, raw) {
    if (__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
}
function __importStarFn(mod) {
    if (mod && mod.__esModule) {
        return mod;
    }
    var result = {};
    if (mod != null) {
        for (var k in mod) {
            if (k !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && Object.prototype.hasOwnProperty.call(mod, k)) {
                __createBindingFn(result, mod, k);
            }
        }
    }
    // Set default module
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(result, __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */], { enumerable: true, value: mod });
    }
    else {
        result[__WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */]] = mod;
    }
    return result;
}
function __importDefaultFn(mod) {
    return (mod && mod.__esModule) ? mod : { strDefault: mod };
}
//# sourceMappingURL=TsLibShims.js.map

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SymbolObj */
/* unused harmony export ReflectObj */
/* unused harmony export __hasSymbol */
/* unused harmony export __hasReflect */
/* unused harmony export __objAssignFnImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assignFn; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __extendsFn;
/* unused harmony export __restFn */
/* unused harmony export __decorateFn */
/* unused harmony export __paramFn */
/* unused harmony export __metadataFn */
/* unused harmony export __exportStarFn */
/* harmony export (immutable) */ __webpack_exports__["b"] = __createBindingFn;
/* unused harmony export __valuesFn */
/* unused harmony export __readFn */
/* unused harmony export __spreadArraysFn */
/* unused harmony export __spreadArrayFn */
/* unused harmony export __makeTemplateObjectFn */
/* unused harmony export __importStarFn */
/* unused harmony export __importDefaultFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(492);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES3 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
var SymbolObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Symbol"];
var ReflectObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Reflect"];
var __hasSymbol = !!SymbolObj;
var __hasReflect = !!ReflectObj;
var strDecorate = "decorate";
var strMetadata = "metadata";
var strGetOwnPropertySymbols = "getOwnPropertySymbols";
var strIterator = "iterator";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (__WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */][__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && b !== null) {
        Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b === null ? Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["b" /* objCreateFn */])(b) : (__[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]], new __());
}
function __restFn(s, e) {
    var t = {};
    for (var k in s) {
        if (__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(s, k) && e.indexOf(k) < 0) {
            t[k] = s[k];
        }
    }
    if (s != null && typeof __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        for (var i = 0, p = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols](s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && __WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */]["propertyIsEnumerable"].call(s, p[i])) {
                t[p[i]] = s[p[i]];
            }
        }
    }
    return t;
}
function __decorateFn(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["getOwnPropertyDescriptor"](target, key) : desc, d;
    if (__hasReflect && typeof ReflectObj[strDecorate] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        r = ReflectObj[strDecorate](decorators, target, key, desc);
    }
    else {
        for (var i = decorators.length - 1; i >= 0; i--) {
            // eslint-disable-next-line no-cond-assign
            if (d = decorators[i]) {
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
            }
        }
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(target, key, r), r;
}
function __paramFn(paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadataFn(metadataKey, metadataValue) {
    if (__hasReflect && ReflectObj[strMetadata] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        return ReflectObj[strMetadata](metadataKey, metadataValue);
    }
}
function __exportStarFn(m, o) {
    for (var p in m) {
        if (p !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && !__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(o, p)) {
            __createBindingFn(o, m, p);
        }
    }
}
function __createBindingFn(o, m, k, k2) {
    if (k2 === undefined) {
        k2 = k;
    }
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(o, k2, {
            enumerable: true,
            get: function () {
                return m[k];
            }
        });
    }
    else {
        o[k2] = m[k];
    }
}
function __valuesFn(o) {
    var s = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && SymbolObj[strIterator], m = s && o[s], i = 0;
    if (m) {
        return m.call(o);
    }
    if (o && typeof o.length === "number") {
        return {
            next: function () {
                if (o && i >= o.length) {
                    o = void 0;
                }
                return { value: o && o[i++], done: !o };
            }
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __readFn(o, n) {
    var m = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && o[SymbolObj[strIterator]];
    if (!m) {
        return o;
    }
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    }
    catch (error) {
        e = {
            error: error
        };
    }
    finally {
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) {
                m.call(i);
            }
        }
        finally {
            if (e) {
                // eslint-disable-next-line no-unsafe-finally
                throw e.error;
            }
        }
    }
    return ar;
}
/** @deprecated */
function __spreadArraysFn() {
    var theArgs = arguments;
    // Calculate new total size
    for (var s = 0, i = 0, il = theArgs.length; i < il; i++) {
        s += theArgs[i].length;
    }
    // Create new full array
    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
        for (var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }
    return r;
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}
function __makeTemplateObjectFn(cooked, raw) {
    if (__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
}
function __importStarFn(mod) {
    if (mod && mod.__esModule) {
        return mod;
    }
    var result = {};
    if (mod != null) {
        for (var k in mod) {
            if (k !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && Object.prototype.hasOwnProperty.call(mod, k)) {
                __createBindingFn(result, mod, k);
            }
        }
    }
    // Set default module
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(result, __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */], { enumerable: true, value: mod });
    }
    else {
        result[__WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */]] = mod;
    }
    return result;
}
function __importDefaultFn(mod) {
    return (mod && mod.__esModule) ? mod : { strDefault: mod };
}
//# sourceMappingURL=TsLibShims.js.map

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STR_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STR_PROPERTIES; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var STR_DURATION = "duration";
var STR_PROPERTIES = "properties";
//# sourceMappingURL=InternalConstants.js.map

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return _DYN_REQUEST_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return _DYN_INST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return _DYN_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return _DYN_TRACE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return _DYN_SPAN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return _DYN_TRACE_FLAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _DYN_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _DYN_ABORTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return _DYN_TRACE_ID0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return _DYN_SPAN_ID1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _DYN_CORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return _DYN_INCLUDE_CORRELATION_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _DYN_CAN_INCLUDE_CORRELAT3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return _DYN_GET_ABSOLUTE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return _DYN_HEADERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return _DYN_REQUEST_HEADERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _DYN_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return _DYN_SET_REQUEST_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return _DYN_TRACK_DEPENDENCY_DAT4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return _DYN_DISTRIBUTED_TRACING_5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return _DYN_START_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return _DYN_TO_LOWER_CASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return _DYN_ENABLE_REQUEST_HEADE6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _DYN_ENABLE_AJAX_ERROR_ST7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _DYN_ENABLE_AJAX_PERF_TRA8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return _DYN_MAX_AJAX_CALLS_PER_V9; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _DYN_ENABLE_RESPONSE_HEAD10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return _DYN_EXCLUDE_REQUEST_FROM11; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _DYN_ADD_REQUEST_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _DYN_DISABLE_AJAX_TRACKIN12; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _DYN_DISABLE_FETCH_TRACKI13; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return _DYN_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return _DYN_STATUS_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return _DYN_HEADER_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return _DYN_OPEN_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return _DYN_SEND_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return _DYN_REQUEST_SENT_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _DYN_ABORT_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return _DYN_GET_TRACE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return _DYN_GET_TRACE_FLAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return _DYN_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _DYN_ERROR_STATUS_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return _DYN_STATE_CHANGE_ATTACHE14; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return _DYN_RESPONSE_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return _DYN_RESPONSE_FINISHED_TI15; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return _DYN__CREATE_TRACK_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return _DYN_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return _DYN_GET_ALL_RESPONSE_HEA16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return _DYN_GET_PART_APROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return _DYN_GET_CORRELATION_CONT17; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return _DYN_PERF_MARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _DYN_AJAX_PERF_LOOKUP_DEL18; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return _DYN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return _DYN_PERF_TIMING; });
/* unused harmony export _DYN_AJAX_DIAGNOSTICS_MES19 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _DYN_CORRELATION_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _DYN_AJAX_TOTAL_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return _DYN_EVENT_TRACE_CTX; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_REQUEST_URL = "requestUrl"; // Count: 12
var _DYN_INST = "inst"; // Count: 5
var _DYN_LENGTH = "length"; // Count: 10
var _DYN_TRACE_ID = "traceID"; // Count: 9
var _DYN_SPAN_ID = "spanID"; // Count: 8
var _DYN_TRACE_FLAGS = "traceFlags"; // Count: 13
var _DYN_CONTEXT = "context"; // Count: 7
var _DYN_ABORTED = "aborted"; // Count: 7
var _DYN_TRACE_ID0 = "traceId"; // Count: 5
var _DYN_SPAN_ID1 = "spanId"; // Count: 5
var _DYN_CORE = "core"; // Count: 8
var _DYN_INCLUDE_CORRELATION_2 = "includeCorrelationHeaders"; // Count: 4
var _DYN_CAN_INCLUDE_CORRELAT3 = "canIncludeCorrelationHeader"; // Count: 2
var _DYN_GET_ABSOLUTE_URL = "getAbsoluteUrl"; // Count: 3
var _DYN_HEADERS = "headers"; // Count: 6
var _DYN_REQUEST_HEADERS = "requestHeaders"; // Count: 13
var _DYN_APP_ID = "appId"; // Count: 5
var _DYN_SET_REQUEST_HEADER = "setRequestHeader"; // Count: 3
var _DYN_TRACK_DEPENDENCY_DAT4 = "trackDependencyDataInternal"; // Count: 2
var _DYN_DISTRIBUTED_TRACING_5 = "distributedTracingMode"; // Count: 3
var _DYN_START_TIME = "startTime"; // Count: 6
var _DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 6
var _DYN_ENABLE_REQUEST_HEADE6 = "enableRequestHeaderTracking"; // Count: 2
var _DYN_ENABLE_AJAX_ERROR_ST7 = "enableAjaxErrorStatusText"; // Count: 2
var _DYN_ENABLE_AJAX_PERF_TRA8 = "enableAjaxPerfTracking"; // Count: 2
var _DYN_MAX_AJAX_CALLS_PER_V9 = "maxAjaxCallsPerView"; // Count: 2
var _DYN_ENABLE_RESPONSE_HEAD10 = "enableResponseHeaderTracking"; // Count: 2
var _DYN_EXCLUDE_REQUEST_FROM11 = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var _DYN_ADD_REQUEST_CONTEXT = "addRequestContext"; // Count: 2
var _DYN_DISABLE_AJAX_TRACKIN12 = "disableAjaxTracking"; // Count: 2
var _DYN_DISABLE_FETCH_TRACKI13 = "disableFetchTracking"; // Count: 2
var _DYN_STATUS = "status"; // Count: 11
var _DYN_STATUS_TEXT = "statusText"; // Count: 9
var _DYN_HEADER_MAP = "headerMap"; // Count: 8
var _DYN_OPEN_DONE = "openDone"; // Count: 3
var _DYN_SEND_DONE = "sendDone"; // Count: 3
var _DYN_REQUEST_SENT_TIME = "requestSentTime"; // Count: 9
var _DYN_ABORT_DONE = "abortDone"; // Count: 3
var _DYN_GET_TRACE_ID = "getTraceId"; // Count: 3
var _DYN_GET_TRACE_FLAGS = "getTraceFlags"; // Count: 3
var _DYN_METHOD = "method"; // Count: 8
var _DYN_ERROR_STATUS_TEXT = "errorStatusText"; // Count: 3
var _DYN_STATE_CHANGE_ATTACHE14 = "stateChangeAttached"; // Count: 2
var _DYN_RESPONSE_TEXT = "responseText"; // Count: 6
var _DYN_RESPONSE_FINISHED_TI15 = "responseFinishedTime"; // Count: 7
var _DYN__CREATE_TRACK_ITEM = "CreateTrackItem"; // Count: 3
var _DYN_RESPONSE = "response"; // Count: 4
var _DYN_GET_ALL_RESPONSE_HEA16 = "getAllResponseHeaders"; // Count: 2
var _DYN_GET_PART_APROPS = "getPartAProps"; // Count: 3
var _DYN_GET_CORRELATION_CONT17 = "getCorrelationContext"; // Count: 2
var _DYN_PERF_MARK = "perfMark"; // Count: 4
var _DYN_AJAX_PERF_LOOKUP_DEL18 = "ajaxPerfLookupDelay"; // Count: 2
var _DYN_NAME = "name"; // Count: 6
var _DYN_PERF_TIMING = "perfTiming"; // Count: 3
var _DYN_AJAX_DIAGNOSTICS_MES19 = "ajaxDiagnosticsMessage"; // Count: 3
var _DYN_CORRELATION_CONTEXT = "correlationContext"; // Count: 3
var _DYN_AJAX_TOTAL_DURATION = "ajaxTotalDuration"; // Count: 3
var _DYN_EVENT_TRACE_CTX = "eventTraceCtx"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export XHRMonitoringState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ajaxRecord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalConstants__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DynamicConstants__ = __webpack_require__(779);
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/** @ignore */
function _calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) {
        result = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(from, to);
    }
    return result;
}
/** @ignore */
function _setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = _calcPerfDuration(resourceEntry, start, end);
    if (value) {
        result = _setPerfValue(props, name, Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["R" /* msToTimeSpan */])(value));
    }
    return result;
}
/** @ignore */
function _setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = (props[strPerf] || {});
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */
function _populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */
    var resourceEntry = ajaxData[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["K" /* _DYN_PERF_TIMING */] /* @min:%2eperfTiming */];
    var props = dependency[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_PROPERTIES */] /* @min:%2eproperties */] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["a" /* STR_DURATION */] /* @min:%2eduration */];
        if (!duration) {
            duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        }
        propsSet |= _setPerfValue(props, __WEBPACK_IMPORTED_MODULE_3__InternalConstants__["a" /* STR_DURATION */], duration);
        propsSet |= _setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(serverTiming, function (value, idx) {
                var name = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_21" /* normalizeJsName */])(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(value, function (key, val) {
                    if (key !== strName && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */])(val) || Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_10" /* isNumber */])(val)) {
                        if (newValue[key]) {
                            val = newValue[key] + ";" + val;
                        }
                        if (val || !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */])(val)) {
                            // Only set the value if it has a value and it's not an empty string
                            newValue[key] = val;
                        }
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= _setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    }
    else {
        if (ajaxData[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_PERF_MARK */] /* @min:%2eperfMark */]) {
            propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
        }
    }
    if (propsSet) {
        dependency[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_PROPERTIES */] /* @min:%2eproperties */] = props;
    }
}
var XHRMonitoringState = /** @class */ (function () {
    function XHRMonitoringState() {
        var self = this;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["I" /* _DYN_OPEN_DONE */] /* @min:%2eopenDone */] = false;
        self.setRequestHeaderDone = false;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["R" /* _DYN_SEND_DONE */] /* @min:%2esendDone */] = false;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["b" /* _DYN_ABORT_DONE */] /* @min:%2eabortDone */] = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["W" /* _DYN_STATE_CHANGE_ATTACHE14 */] /* @min:%2estateChangeAttached */] = false;
    }
    return XHRMonitoringState;
}());

var ajaxRecord = /** @class */ (function () {
    function ajaxRecord(traceId, spanId, logger, traceCtx) {
        var _a;
        var self = this;
        var _logger = logger;
        var strResponseText = "responseText";
        // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
        // this.XXXX = null
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_PERF_MARK */] /* @min:%2eperfMark */] = null;
        self.completed = false;
        self.requestHeadersSize = null;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */] = null;
        self.responseReceivingDuration = null;
        self.callbackDuration = null;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_AJAX_TOTAL_DURATION */] /* @min:%2eajaxTotalDuration */] = null;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["a" /* _DYN_ABORTED */] /* @min:%2eaborted */] = 0;
        self.pageUrl = null;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */] = null;
        self.requestSize = 0;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["G" /* _DYN_METHOD */] /* @min:%2emethod */] = null;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */] = null;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["M" /* _DYN_REQUEST_SENT_TIME */] /* @min:%2erequestSentTime */] = null;
        self.responseStartedTime = null;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["P" /* _DYN_RESPONSE_FINISHED_TI15 */] /* @min:%2eresponseFinishedTime */] = null;
        self.callbackFinishedTime = null;
        self.endTime = null;
        self.xhrMonitoringState = new XHRMonitoringState();
        self.clientFailure = 0;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_1" /* _DYN_TRACE_ID */] /* @min:%2etraceID */] = traceId;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN_SPAN_ID */] /* @min:%2espanID */] = spanId;
        self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
        if (traceCtx) {
            self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_EVENT_TRACE_CTX */] /* @min:%2eeventTraceCtx */] = (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_2" /* _DYN_TRACE_ID0 */] /* @min:traceId */] = traceCtx[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["z" /* _DYN_GET_TRACE_ID */] /* @min:%2egetTraceId */](),
                _a[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["U" /* _DYN_SPAN_ID1 */] /* @min:spanId */] = traceCtx.getSpanId(),
                _a[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:traceFlags */] = traceCtx[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["y" /* _DYN_GET_TRACE_FLAGS */] /* @min:%2egetTraceFlags */](),
                _a);
        }
        else {
            self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_EVENT_TRACE_CTX */] /* @min:%2eeventTraceCtx */] = null;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(ajaxRecord, self, function (self) {
            self.getAbsoluteUrl = function () {
                return self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */] ? Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["V" /* urlGetAbsoluteUrl */])(self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */]) : null;
            };
            self.getPathName = function () {
                return self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */] ? Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["L" /* dataSanitizeUrl */])(_logger, Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["W" /* urlGetCompleteUrl */])(self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["G" /* _DYN_METHOD */] /* @min:%2emethod */], self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */])) : null;
            };
            self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_4" /* _DYN__CREATE_TRACK_ITEM */] /* @min:%2eCreateTrackItem */] = function (ajaxType, enableRequestHeaderTracking, getResponse) {
                var _a;
                // round to 3 decimal points
                self.ajaxTotalDuration = Math.round(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                if (self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_AJAX_TOTAL_DURATION */] /* @min:%2eajaxTotalDuration */] < 0) {
                    return null;
                }
                var dependency = (_a = {
                        id: "|" + self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_1" /* _DYN_TRACE_ID */] /* @min:%2etraceID */] + "." + self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN_SPAN_ID */] /* @min:%2espanID */],
                        target: self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["u" /* _DYN_GET_ABSOLUTE_URL */] /* @min:%2egetAbsoluteUrl */]()
                    },
                    _a[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["H" /* _DYN_NAME */] /* @min:name */] = self.getPathName(),
                    _a.type = ajaxType,
                    _a[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["V" /* _DYN_START_TIME */] /* @min:startTime */] = null,
                    _a.duration = self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_AJAX_TOTAL_DURATION */] /* @min:%2eajaxTotalDuration */],
                    _a.success = (+(self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */])) >= 200 && (+(self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */])) < 400,
                    _a.responseCode = (+(self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */])),
                    _a[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_PROPERTIES */]] = { HttpMethod: self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["G" /* _DYN_METHOD */] /* @min:%2emethod */] },
                    _a);
                var props = dependency[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["b" /* STR_PROPERTIES */]];
                if (self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["a" /* _DYN_ABORTED */] /* @min:%2eaborted */]) {
                    props[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["a" /* _DYN_ABORTED */] /* @min:%2eaborted */] = true;
                }
                if (self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["M" /* _DYN_REQUEST_SENT_TIME */] /* @min:%2erequestSentTime */]) {
                    // Set the correct dependency start time
                    dependency[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["V" /* _DYN_START_TIME */] /* @min:%2estartTime */] = new Date();
                    dependency[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["V" /* _DYN_START_TIME */] /* @min:%2estartTime */].setTime(self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["M" /* _DYN_REQUEST_SENT_TIME */] /* @min:%2erequestSentTime */]);
                }
                // Add Ajax perf details if available
                _populatePerfData(self, dependency);
                if (enableRequestHeaderTracking) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_24" /* objKeys */])(self.requestHeaders)[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                        props[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */] = self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */];
                    }
                }
                if (getResponse) {
                    var response = getResponse();
                    if (response) {
                        // enrich dependency target with correlation context from the server
                        var correlationContext = response[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["j" /* _DYN_CORRELATION_CONTEXT */] /* @min:%2ecorrelationContext */];
                        if (correlationContext) {
                            dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                        }
                        if (response[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["B" /* _DYN_HEADER_MAP */] /* @min:%2eheaderMap */]) {
                            if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_24" /* objKeys */])(response.headerMap)[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                                props.responseHeaders = response[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["B" /* _DYN_HEADER_MAP */] /* @min:%2eheaderMap */];
                            }
                        }
                        if (self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["r" /* _DYN_ERROR_STATUS_TEXT */] /* @min:%2eerrorStatusText */]) {
                            if (self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */] >= 400) {
                                var responseType = response.type;
                                if (responseType === "" || responseType === "text") {
                                    props.responseText = response.responseText ? response[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Y" /* _DYN_STATUS_TEXT */] /* @min:%2estatusText */] + " - " + response[strResponseText] : response[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Y" /* _DYN_STATUS_TEXT */] /* @min:%2estatusText */];
                                }
                                if (responseType === "json") {
                                    props.responseText = response.response ? response[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Y" /* _DYN_STATUS_TEXT */] /* @min:%2estatusText */] + " - " + JSON.stringify(response[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["O" /* _DYN_RESPONSE */] /* @min:%2eresponse */]) : response[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Y" /* _DYN_STATUS_TEXT */] /* @min:%2estatusText */];
                                }
                            }
                            else if (self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */] === 0) {
                                props.responseText = response[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Y" /* _DYN_STATUS_TEXT */] /* @min:%2estatusText */] || "";
                            }
                        }
                    }
                }
                return dependency;
            };
            self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["x" /* _DYN_GET_PART_APROPS */] /* @min:%2egetPartAProps */] = function () {
                var _a;
                var partA = null;
                var traceCtx = self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_EVENT_TRACE_CTX */] /* @min:%2eeventTraceCtx */];
                if (traceCtx && (traceCtx[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_2" /* _DYN_TRACE_ID0 */] /* @min:%2etraceId */] || traceCtx[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["U" /* _DYN_SPAN_ID1 */] /* @min:%2espanId */])) {
                    partA = {};
                    var traceExt = partA[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].TraceExt] = (_a = {},
                        _a[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_1" /* _DYN_TRACE_ID */] /* @min:traceID */] = traceCtx[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_2" /* _DYN_TRACE_ID0 */] /* @min:%2etraceId */],
                        _a.parentID = traceCtx[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["U" /* _DYN_SPAN_ID1 */] /* @min:%2espanId */],
                        _a);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(traceCtx[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */])) {
                        traceExt[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */] = traceCtx[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */];
                    }
                }
                return partA;
            };
        });
    }
// Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
// Removed Stub for ajaxRecord.prototype.getPathName.
// Removed Stub for ajaxRecord.prototype.CreateTrackItem.
// Removed Stub for ajaxRecord.prototype.getPartAProps.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    ajaxRecord.__ieDyn=1;

    return ajaxRecord;
}());

//# sourceMappingURL=ajaxRecord.js.map

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PropertiesPlugin__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Context_Session__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context_TelemetryTrace__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TelemetryContext__ = __webpack_require__(783);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PropertiesPlugin__["a"]; });
/* unused harmony reexport TelemetryTrace */
/* unused harmony reexport TelemetryContext */
/* unused harmony reexport Session */
/* unused harmony reexport SessionManager */
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







//# sourceMappingURL=applicationinsights-properties-js.js.map

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SymbolObj */
/* unused harmony export ReflectObj */
/* unused harmony export __hasSymbol */
/* unused harmony export __hasReflect */
/* unused harmony export __objAssignFnImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assignFn; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __extendsFn;
/* unused harmony export __restFn */
/* unused harmony export __decorateFn */
/* unused harmony export __paramFn */
/* unused harmony export __metadataFn */
/* unused harmony export __exportStarFn */
/* harmony export (immutable) */ __webpack_exports__["b"] = __createBindingFn;
/* unused harmony export __valuesFn */
/* unused harmony export __readFn */
/* unused harmony export __spreadArraysFn */
/* unused harmony export __spreadArrayFn */
/* unused harmony export __makeTemplateObjectFn */
/* unused harmony export __importStarFn */
/* unused harmony export __importDefaultFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(493);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES3 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
var SymbolObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Symbol"];
var ReflectObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Reflect"];
var __hasSymbol = !!SymbolObj;
var __hasReflect = !!ReflectObj;
var strDecorate = "decorate";
var strMetadata = "metadata";
var strGetOwnPropertySymbols = "getOwnPropertySymbols";
var strIterator = "iterator";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (__WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */][__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && b !== null) {
        Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b === null ? Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["b" /* objCreateFn */])(b) : (__[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]], new __());
}
function __restFn(s, e) {
    var t = {};
    for (var k in s) {
        if (__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(s, k) && e.indexOf(k) < 0) {
            t[k] = s[k];
        }
    }
    if (s != null && typeof __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        for (var i = 0, p = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols](s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && __WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */]["propertyIsEnumerable"].call(s, p[i])) {
                t[p[i]] = s[p[i]];
            }
        }
    }
    return t;
}
function __decorateFn(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["getOwnPropertyDescriptor"](target, key) : desc, d;
    if (__hasReflect && typeof ReflectObj[strDecorate] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        r = ReflectObj[strDecorate](decorators, target, key, desc);
    }
    else {
        for (var i = decorators.length - 1; i >= 0; i--) {
            // eslint-disable-next-line no-cond-assign
            if (d = decorators[i]) {
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
            }
        }
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(target, key, r), r;
}
function __paramFn(paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadataFn(metadataKey, metadataValue) {
    if (__hasReflect && ReflectObj[strMetadata] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        return ReflectObj[strMetadata](metadataKey, metadataValue);
    }
}
function __exportStarFn(m, o) {
    for (var p in m) {
        if (p !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && !__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(o, p)) {
            __createBindingFn(o, m, p);
        }
    }
}
function __createBindingFn(o, m, k, k2) {
    if (k2 === undefined) {
        k2 = k;
    }
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(o, k2, {
            enumerable: true,
            get: function () {
                return m[k];
            }
        });
    }
    else {
        o[k2] = m[k];
    }
}
function __valuesFn(o) {
    var s = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && SymbolObj[strIterator], m = s && o[s], i = 0;
    if (m) {
        return m.call(o);
    }
    if (o && typeof o.length === "number") {
        return {
            next: function () {
                if (o && i >= o.length) {
                    o = void 0;
                }
                return { value: o && o[i++], done: !o };
            }
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __readFn(o, n) {
    var m = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && o[SymbolObj[strIterator]];
    if (!m) {
        return o;
    }
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    }
    catch (error) {
        e = {
            error: error
        };
    }
    finally {
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) {
                m.call(i);
            }
        }
        finally {
            if (e) {
                // eslint-disable-next-line no-unsafe-finally
                throw e.error;
            }
        }
    }
    return ar;
}
/** @deprecated */
function __spreadArraysFn() {
    var theArgs = arguments;
    // Calculate new total size
    for (var s = 0, i = 0, il = theArgs.length; i < il; i++) {
        s += theArgs[i].length;
    }
    // Create new full array
    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
        for (var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }
    return r;
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}
function __makeTemplateObjectFn(cooked, raw) {
    if (__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
}
function __importStarFn(mod) {
    if (mod && mod.__esModule) {
        return mod;
    }
    var result = {};
    if (mod != null) {
        for (var k in mod) {
            if (k !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && Object.prototype.hasOwnProperty.call(mod, k)) {
                __createBindingFn(result, mod, k);
            }
        }
    }
    // Set default module
    if (!!__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(result, __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */], { enumerable: true, value: mod });
    }
    else {
        result[__WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */]] = mod;
    }
    return result;
}
function __importDefaultFn(mod) {
    return (mod && mod.__esModule) ? mod : { strDefault: mod };
}
//# sourceMappingURL=TsLibShims.js.map

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Context_Application__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Context_Device__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Context_Internal__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Context_Location__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context_Session__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Context_TelemetryTrace__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Context_User__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DynamicConstants__ = __webpack_require__(271);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* TelemetryContext.ts
* @copyright Microsoft 2018
*/











var strExt = "ext";
var strTags = "tags";
function _removeEmpty(target, name) {
    if (target && target[name] && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_24" /* objKeys */])(target[name])[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] === 0) {
        delete target[name];
    }
}
var TelemetryContext = /** @class */ (function () {
    function TelemetryContext(core, defaultConfig, previousTraceCtx) {
        var _this = this;
        var logger = core.logger;
        this.appId = function () { return null; };
        this[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["r" /* _DYN_GET_SESSION_ID */] /* @min:%2egetSessionId */] = function () { return null; };
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(TelemetryContext, this, function (_self) {
            _self.application = new __WEBPACK_IMPORTED_MODULE_3__Context_Application__["a" /* Application */]();
            _self.internal = new __WEBPACK_IMPORTED_MODULE_5__Context_Internal__["a" /* Internal */](defaultConfig);
            if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_1" /* hasWindow */])()) {
                _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["D" /* _DYN_SESSION_MANAGER */] /* @min:%2esessionManager */] = new __WEBPACK_IMPORTED_MODULE_7__Context_Session__["b" /* _SessionManager */](defaultConfig, core);
                _self.device = new __WEBPACK_IMPORTED_MODULE_4__Context_Device__["a" /* Device */]();
                _self.location = new __WEBPACK_IMPORTED_MODULE_6__Context_Location__["a" /* Location */]();
                _self.user = new __WEBPACK_IMPORTED_MODULE_9__Context_User__["a" /* User */](defaultConfig, core);
                var traceId = void 0;
                var parentId = void 0;
                var name_1;
                if (previousTraceCtx) {
                    traceId = previousTraceCtx.getTraceId();
                    parentId = previousTraceCtx.getSpanId();
                    name_1 = previousTraceCtx.getName();
                }
                _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["F" /* _DYN_TELEMETRY_TRACE */] /* @min:%2etelemetryTrace */] = new __WEBPACK_IMPORTED_MODULE_8__Context_TelemetryTrace__["a" /* TelemetryTrace */](traceId, parentId, name_1, logger);
                _self.session = new __WEBPACK_IMPORTED_MODULE_7__Context_Session__["a" /* Session */]();
            }
            _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["r" /* _DYN_GET_SESSION_ID */] /* @min:%2egetSessionId */] = function () {
                var session = _self.session;
                var sesId = null;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */])(session.id)) {
                    sesId = session.id;
                }
                else {
                    // Gets the automatic session if it exists or an empty object
                    var autoSession = (_self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["D" /* _DYN_SESSION_MANAGER */] /* @min:%2esessionManager */] || {})[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["m" /* _DYN_AUTOMATIC_SESSION */] /* @min:%2eautomaticSession */];
                    sesId = autoSession && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */])(autoSession.id) ? autoSession.id : null;
                }
                return sesId;
            };
            _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["i" /* _DYN_APPLY_SESSION_CONTEX0 */] /* @min:%2eapplySessionContext */] = function (evt, itemCtx) {
                Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt.ext, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].AppExt), "sesId", _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["r" /* _DYN_GET_SESSION_ID */] /* @min:%2egetSessionId */](), __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
            };
            _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["g" /* _DYN_APPLY_OPERATING_SYST3 */] /* @min:%2eapplyOperatingSystemContxt */] = function (evt, itemCtx) {
                Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(evt.ext, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].OSExt, _self.os);
            };
            _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["c" /* _DYN_APPLY_APPLICATION_CO1 */] /* @min:%2eapplyApplicationContext */] = function (evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt, strTags);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].applicationVersion, application.ver, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].applicationBuild, application.build, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["d" /* _DYN_APPLY_DEVICE_CONTEXT */] /* @min:%2eapplyDeviceContext */] = function (evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt, strExt), __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].DeviceExt);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(extDevice, "localId", device.id, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(extDevice, "ip", device.ip, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(extDevice, "model", device.model, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(extDevice, "deviceClass", device.deviceClass, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["e" /* _DYN_APPLY_INTERNAL_CONTE5 */] /* @min:%2eapplyInternalContext */] = function (evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt, strTags);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].internalAgentVersion, internal.agentVersion, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]); // not mapped in CS 4.0
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].internalSdkVersion, Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["K" /* dataSanitizeString */])(logger, internal.sdkVersion, 64), __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                    if (evt.baseType === __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["h" /* _InternalLogMessage */].dataType || evt.baseType === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["u" /* PageView */].dataType) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].internalSnippet, internal.snippetVer, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].internalSdkSrc, internal.sdkSrc, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                    }
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["f" /* _DYN_APPLY_LOCATION_CONTE4 */] /* @min:%2eapplyLocationContext */] = function (evt, itemCtx) {
                var location = _this.location;
                if (location) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt, strTags, []), __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].locationIp, location.ip, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["h" /* _DYN_APPLY_OPERATION_CONT2 */] /* @min:%2eapplyOperationContext */] = function (evt, itemCtx) {
                var telemetryTrace = _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["F" /* _DYN_TELEMETRY_TRACE */] /* @min:%2etelemetryTrace */];
                if (telemetryTrace) {
                    var extTrace = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt, strExt), __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].TraceExt, { traceID: undefined, parentID: undefined });
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(extTrace, "traceID", telemetryTrace.traceID, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */]);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(extTrace, "name", telemetryTrace.name, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */]);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(extTrace, "parentID", telemetryTrace.parentID, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */]);
                }
            };
            _self.applyWebContext = function (evt, itemCtx) {
                var web = _this.web;
                if (web) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt, strExt), __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].WebExt, web);
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["j" /* _DYN_APPLY_USER_CONTEXT */] /* @min:%2eapplyUserContext */] = function (evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt, strTags, []);
                    // stays in tags
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].userAccountId, user[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["a" /* _DYN_ACCOUNT_ID */] /* @min:%2eaccountId */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                    // CS 4.0
                    var extUser = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt, strExt), __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].UserExt);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(extUser, "id", user.id, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(extUser, "authId", user[__WEBPACK_IMPORTED_MODULE_10__DynamicConstants__["k" /* _DYN_AUTHENTICATED_ID */] /* @min:%2eauthenticatedId */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */]);
                }
            };
            _self.cleanUp = function (evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].DeviceExt);
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].UserExt);
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].WebExt);
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].OSExt);
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].AppExt);
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["r" /* Extensions */].TraceExt);
                }
            };
        });
    }
// Removed Stub for TelemetryContext.prototype.applySessionContext.
// Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
// Removed Stub for TelemetryContext.prototype.applyApplicationContext.
// Removed Stub for TelemetryContext.prototype.applyDeviceContext.
// Removed Stub for TelemetryContext.prototype.applyInternalContext.
// Removed Stub for TelemetryContext.prototype.applyLocationContext.
// Removed Stub for TelemetryContext.prototype.applyOperationContext.
// Removed Stub for TelemetryContext.prototype.applyWebContext.
// Removed Stub for TelemetryContext.prototype.applyUserContext.
// Removed Stub for TelemetryContext.prototype.cleanUp.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    TelemetryContext.__ieDyn=1;

    return TelemetryContext;
}());

//# sourceMappingURL=TelemetryContext.js.map

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Session; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _SessionManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DynamicConstants__ = __webpack_require__(271);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var cookieNameConst = "ai_session";
var Session = /** @class */ (function () {
    function Session() {
    }
    return Session;
}());

var _SessionManager = /** @class */ (function () {
    function _SessionManager(config, core) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_33" /* safeGetLogger */])(core);
        var _cookieManager = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_32" /* safeGetCookieMgr */])(core);
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(_SessionManager, self, function (_self) {
            if (!config) {
                config = {};
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["C" /* _DYN_SESSION_EXPIRATION_M7 */] /* @min:%2esessionExpirationMs */])) {
                config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["C" /* _DYN_SESSION_EXPIRATION_M7 */] /* @min:%2esessionExpirationMs */] = function () { return _SessionManager.acquisitionSpan; };
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["E" /* _DYN_SESSION_RENEWAL_MS */] /* @min:%2esessionRenewalMs */])) {
                config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["E" /* _DYN_SESSION_RENEWAL_MS */] /* @min:%2esessionRenewalMs */] = function () { return _SessionManager.renewalSpan; };
            }
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["n" /* _DYN_CONFIG */] /* @min:%2econfig */] = config;
            // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
            var sessionCookiePostfix = (_self.config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["B" /* _DYN_SESSION_COOKIE_POSTF6 */] /* @min:%2esessionCookiePostfix */] && _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["n" /* _DYN_CONFIG */] /* @min:%2econfig */][__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["B" /* _DYN_SESSION_COOKIE_POSTF6 */] /* @min:%2esessionCookiePostfix */]()) ?
                _self.config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["B" /* _DYN_SESSION_COOKIE_POSTF6 */] /* @min:%2esessionCookiePostfix */]() :
                ((_self.config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["y" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */] && _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["n" /* _DYN_CONFIG */] /* @min:%2econfig */][__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["y" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */]()) ? _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["n" /* _DYN_CONFIG */] /* @min:%2econfig */][__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["y" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */]() : "");
            _storageNamePrefix = function () { return cookieNameConst + sessionCookiePostfix; };
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["m" /* _DYN_AUTOMATIC_SESSION */] /* @min:%2eautomaticSession */] = new Session();
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["G" /* _DYN_UPDATE */] /* @min:%2eupdate */] = function () {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["B" /* dateNow */])();
                var isExpired = false;
                var session = _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["m" /* _DYN_AUTOMATIC_SESSION */] /* @min:%2eautomaticSession */];
                if (!session.id) {
                    isExpired = !_initializeAutomaticSession(session, nowMs);
                }
                var sessionExpirationMs = _self.config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["C" /* _DYN_SESSION_EXPIRATION_M7 */] /* @min:%2esessionExpirationMs */]();
                if (!isExpired && sessionExpirationMs > 0) {
                    var sessionRenewalMs = _self.config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["E" /* _DYN_SESSION_RENEWAL_MS */] /* @min:%2esessionRenewalMs */]();
                    var timeSinceAcqMs = nowMs - session[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["b" /* _DYN_ACQUISITION_DATE */] /* @min:%2eacquisitionDate */];
                    var timeSinceRenewalMs = nowMs - session[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["z" /* _DYN_RENEWAL_DATE */] /* @min:%2erenewalDate */];
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) {
                    // update automaticSession so session state has correct id
                    _renew(nowMs);
                }
                else {
                    // do not update the cookie more often than cookieUpdateInterval
                    if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > _SessionManager.cookieUpdateInterval) {
                        _setCookie(session, nowMs);
                    }
                }
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */
            _self.backup = function () {
                var session = _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["m" /* _DYN_AUTOMATIC_SESSION */] /* @min:%2eautomaticSession */];
                _setStorage(session.id, session[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["b" /* _DYN_ACQUISITION_DATE */] /* @min:%2eacquisitionDate */], session[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["z" /* _DYN_RENEWAL_DATE */] /* @min:%2erenewalDate */]);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix());
                if (cookieValue && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(cookieValue.split)) {
                    isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                }
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["_1" /* utlGetLocalStorage */])(_logger, _storageNamePrefix());
                    if (storageValue) {
                        isValid = _initializeAutomaticSessionWithData(session, storageValue);
                    }
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param {string} sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] >= 2) {
                    try {
                        var acqMs = +tokens[1] || 0;
                        var renewalMs = +tokens[2] || 0;
                        if (isNaN(acqMs) || acqMs <= 0) {
                            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session acquisition date is 0" + sessionReset);
                        }
                        else if (isNaN(renewalMs) || renewalMs <= 0) {
                            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session renewal date is 0" + sessionReset);
                        }
                        else if (tokens[0]) {
                            // Everything looks valid so set the values
                            session.id = tokens[0];
                            session[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["b" /* _DYN_ACQUISITION_DATE */] /* @min:%2eacquisitionDate */] = acqMs;
                            session[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["z" /* _DYN_RENEWAL_DATE */] /* @min:%2erenewalDate */] = renewalMs;
                            isValid = true;
                        }
                    }
                    catch (e) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_logger, 1 /* eLoggingSeverity.CRITICAL */, 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */, "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                    }
                }
                return isValid;
            }
            function _renew(nowMs) {
                var theConfig = (_self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["n" /* _DYN_CONFIG */] /* @min:%2econfig */] || {});
                var getNewId = (theConfig[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_GET_NEW_ID */] /* @min:%2egetNewId */] ? theConfig[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_GET_NEW_ID */] /* @min:%2egetNewId */]() : null) || __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_20" /* newId */];
                _self.automaticSession.id = getNewId(theConfig[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["t" /* _DYN_ID_LENGTH */] /* @min:%2eidLength */] ? theConfig[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["t" /* _DYN_ID_LENGTH */] /* @min:%2eidLength */]() : 22);
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["m" /* _DYN_AUTOMATIC_SESSION */] /* @min:%2eautomaticSession */][__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["b" /* _DYN_ACQUISITION_DATE */] /* @min:%2eacquisitionDate */] = nowMs;
                _setCookie(_self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["m" /* _DYN_AUTOMATIC_SESSION */] /* @min:%2eautomaticSession */], nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["X" /* utlCanUseLocalStorage */])()) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_logger, 2 /* eLoggingSeverity.WARNING */, 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */, "Browser does not support local storage. Session durations will be inaccurate.");
                }
            }
            function _setCookie(session, nowMs) {
                var acq = session[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["b" /* _DYN_ACQUISITION_DATE */] /* @min:%2eacquisitionDate */];
                session[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["z" /* _DYN_RENEWAL_DATE */] /* @min:%2erenewalDate */] = nowMs;
                var config = _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["n" /* _DYN_CONFIG */] /* @min:%2econfig */];
                var renewalPeriodMs = config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["E" /* _DYN_SESSION_RENEWAL_MS */] /* @min:%2esessionRenewalMs */]();
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = (acq + config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["C" /* _DYN_SESSION_EXPIRATION_M7 */] /* @min:%2esessionExpirationMs */]()) - nowMs;
                var cookie = [session.id, acq, nowMs];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) {
                    maxAgeSec = acqTimeLeftMs / 1000;
                }
                else {
                    maxAgeSec = renewalPeriodMs / 1000;
                }
                var cookieDomain = config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["o" /* _DYN_COOKIE_DOMAIN */] /* @min:%2ecookieDomain */] ? config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["o" /* _DYN_COOKIE_DOMAIN */] /* @min:%2ecookieDomain */]() : null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix(), cookie.join("|"), config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["C" /* _DYN_SESSION_EXPIRATION_M7 */] /* @min:%2esessionExpirationMs */]() > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["_5" /* utlSetLocalStorage */])(_logger, _storageNamePrefix(), [guid, acq, renewal][__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["w" /* _DYN_JOIN */] /* @min:%2ejoin */]("|"));
            }
        });
    }
// Removed Stub for _SessionManager.prototype.update.
// Removed Stub for _SessionManager.prototype.backup.
    _SessionManager.acquisitionSpan = 86400000; // 24 hours in ms
    _SessionManager.renewalSpan = 1800000; // 30 minutes in ms
    _SessionManager.cookieUpdateInterval = 60000; // 1 minute in ms
    return _SessionManager;
}());

//# sourceMappingURL=Session.js.map

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryTrace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var TelemetryTrace = /** @class */ (function () {
    function TelemetryTrace(id, parentId, name, logger) {
        var _self = this;
        _self.traceID = id || Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["K" /* generateW3CId */])();
        _self.parentID = parentId;
        var location = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["T" /* getLocation */])();
        if (!name && location && location.pathname) {
            name = location.pathname;
        }
        _self.name = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["K" /* dataSanitizeString */])(logger, name);
    }
    return TelemetryTrace;
}());

//# sourceMappingURL=TelemetryTrace.js.map

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export STR_EMPTY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STR_SNIPPET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STR_GET_COOKIE_MGR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return STR_START_TRACK_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return STR_STOP_TRACK_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STR_FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STR_START_TRACK_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return STR_STOP_TRACK_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STR_ADD_TELEMETRY_INITIALIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STR_ADD_TELEMETRY_INITIALIZERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return STR_POLL_INTERNAL_LOGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return STR_GET_PLUGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STR_EVT_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return STR_TRACK_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return STR_TRACK_TRACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return STR_TRACK_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return STR_TRACK_PAGE_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return STR_TRACK_EXCEPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return STR_TRACK_DEPENDENCY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return STR_SET_AUTHENTICATED_USER_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STR_CLEAR_AUTHENTICATED_USER_CONTEXT; });
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var _AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var _TRACK = "track";
var STR_EMPTY = "";
var STR_SNIPPET = "snippet";
var STR_GET_COOKIE_MGR = "getCookieMgr";
var STR_START_TRACK_PAGE = "startTrackPage";
var STR_STOP_TRACK_PAGE = "stopTrackPage";
var STR_FLUSH = "flush";
var STR_START_TRACK_EVENT = "startTrackEvent";
var STR_STOP_TRACK_EVENT = "stopTrackEvent";
var STR_ADD_TELEMETRY_INITIALIZER = "addTelemetryInitializer";
var STR_ADD_TELEMETRY_INITIALIZERS = STR_ADD_TELEMETRY_INITIALIZER + "s";
var STR_POLL_INTERNAL_LOGS = "pollInternalLogs";
var STR_GET_PLUGIN = "getPlugin";
var STR_EVT_NAMESPACE = "evtNamespace";
var STR_TRACK_EVENT = _TRACK + "Event";
var STR_TRACK_TRACE = _TRACK + "Trace";
var STR_TRACK_METRIC = _TRACK + "Metric";
var STR_TRACK_PAGE_VIEW = _TRACK + "PageView";
var STR_TRACK_EXCEPTION = _TRACK + "Exception";
var STR_TRACK_DEPENDENCY_DATA = _TRACK + "DependencyData";
var STR_SET_AUTHENTICATED_USER_CONTEXT = "set" + _AUTHENTICATED_USER_CONTEXT;
var STR_CLEAR_AUTHENTICATED_USER_CONTEXT = "clear" + _AUTHENTICATED_USER_CONTEXT;
//# sourceMappingURL=InternalConstants.js.map

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReactPlugin__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withAITracking__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppInsightsErrorBoundary__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppInsightsContext__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useTrackEvent__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTrackMetric__ = __webpack_require__(1943);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ReactPlugin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__withAITracking__["a"]; });
/* unused harmony reexport AppInsightsErrorBoundary */
/* unused harmony reexport AppInsightsContext */
/* unused harmony reexport useAppInsightsContext */
/* unused harmony reexport useTrackEvent */
/* unused harmony reexport useTrackMetric */
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.








//# sourceMappingURL=applicationinsights-react-js.js.map

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return datadogRum; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__boot_startRecording__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boot_recorderApi__ = __webpack_require__(2039);
/* unused harmony reexport DefaultPrivacyLevel */
// Keep the following in sync with packages/rum-slim/src/entries/main.ts





var recorderApi = Object(__WEBPACK_IMPORTED_MODULE_3__boot_recorderApi__["a" /* makeRecorderApi */])(__WEBPACK_IMPORTED_MODULE_2__boot_startRecording__["a" /* startRecording */]);
var datadogRum = Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["l" /* makeRumPublicApi */])(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["m" /* startRum */], recorderApi);
Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["V" /* defineGlobal */])(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_5" /* getGlobalObject */])(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(1944);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__configuration__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__configuration__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__configuration__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__endpointBuilder__ = __webpack_require__(791);
/* unused harmony reexport createEndpointBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intakeSites__ = __webpack_require__(498);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__intakeSites__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__intakeSites__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__intakeSites__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__intakeSites__["e"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isIE;
/* harmony export (immutable) */ __webpack_exports__["a"] = isChromium;
function isIE() {
    return Boolean(document.documentMode);
}
function isChromium() {
    return !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent);
}
//# sourceMappingURL=browserDetection.js.map

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENDPOINTS */
/* harmony export (immutable) */ __webpack_exports__["a"] = createEndpointBuilder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_utils_urlPolyfill__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_experimentalFeatures__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_utils_stringUtils__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intakeSites__ = __webpack_require__(498);





var ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
function createEndpointBuilder(initConfiguration, endpointType, configurationTags) {
    var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, endpointType);
    return {
        build: function (api, flushReason, retry) {
            var parameters = buildEndpointParameters(initConfiguration, endpointType, configurationTags, api, flushReason, retry);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        endpointType: endpointType,
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, endpointType) {
    var path = "/api/v2/".concat(INTAKE_TRACKS[endpointType]);
    var proxy = initConfiguration.proxy, proxyUrl = initConfiguration.proxyUrl;
    if (proxy) {
        var normalizedProxyUrl_1 = Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_urlPolyfill__["e" /* normalizeUrl */])(proxy);
        return function (parameters) { return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters))); };
    }
    var host = buildEndpointHost(initConfiguration, endpointType);
    if (proxy === undefined && proxyUrl) {
        // TODO: remove this in a future major.
        var normalizedProxyUrl_2 = Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_urlPolyfill__["e" /* normalizeUrl */])(proxyUrl);
        return function (parameters) {
            return "".concat(normalizedProxyUrl_2, "?ddforward=").concat(encodeURIComponent("https://".concat(host).concat(path, "?").concat(parameters)));
        };
    }
    return function (parameters) { return "https://".concat(host).concat(path, "?").concat(parameters); };
}
function buildEndpointHost(initConfiguration, endpointType) {
    var _a = initConfiguration.site, site = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_4__intakeSites__["d" /* INTAKE_SITE_US1 */] : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (internalAnalyticsSubdomain && site === __WEBPACK_IMPORTED_MODULE_4__intakeSites__["d" /* INTAKE_SITE_US1 */]) {
        return "".concat(internalAnalyticsSubdomain, ".").concat(__WEBPACK_IMPORTED_MODULE_4__intakeSites__["d" /* INTAKE_SITE_US1 */]);
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var subdomain = site !== __WEBPACK_IMPORTED_MODULE_4__intakeSites__["a" /* INTAKE_SITE_AP1 */] ? "".concat(ENDPOINTS[endpointType], ".") : '';
    return "".concat(subdomain, "browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, endpointType, configurationTags, api, flushReason, retry) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var tags = ["sdk_version:".concat("4.43.0"), "api:".concat(api)].concat(configurationTags);
    if (flushReason && Object(__WEBPACK_IMPORTED_MODULE_2__tools_experimentalFeatures__["d" /* isExperimentalFeatureEnabled */])(__WEBPACK_IMPORTED_MODULE_2__tools_experimentalFeatures__["a" /* ExperimentalFeature */].COLLECT_FLUSH_REASON)) {
        tags.push("flush_reason:".concat(flushReason));
    }
    if (retry) {
        tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    }
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("4.43.0")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat(Object(__WEBPACK_IMPORTED_MODULE_3__tools_utils_stringUtils__["b" /* generateUUID */])()),
    ];
    if (endpointType === 'rum') {
        parameters.push("batch_time=".concat(Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_timeUtils__["n" /* timeStampNow */])()));
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}
//# sourceMappingURL=endpointBuilder.js.map

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeStackTrace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_utils_polyfills__ = __webpack_require__(93);

var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_polyfills__["l" /* startsWith */])(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
    var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=computeStackTrace.js.map

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__telemetry__ = __webpack_require__(1955);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__telemetry__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__telemetry__["c"]; });
/* unused harmony reexport startFakeTelemetry */
/* unused harmony reexport resetTelemetry */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__telemetry__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__telemetry__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__telemetry__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rawTelemetryEvent_types__ = __webpack_require__(795);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__telemetryEvent_types__ = __webpack_require__(1956);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendToExtension;
function sendToExtension(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type: type, payload: payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryType; });
var TelemetryType = {
    log: 'log',
    configuration: 'configuration',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLEAR_OLD_VALUES_INTERVAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValueHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_timeUtils__ = __webpack_require__(101);


var END_OF_TIMES = Infinity;
var CLEAR_OLD_VALUES_INTERVAL = __WEBPACK_IMPORTED_MODULE_1__utils_timeUtils__["b" /* ONE_MINUTE */];
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ValueHistory = /** @class */ (function () {
    function ValueHistory(expireDelay, maxEntries) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.maxEntries = maxEntries;
        this.entries = [];
        this.clearOldValuesInterval = Object(__WEBPACK_IMPORTED_MODULE_0__timer__["c" /* setInterval */])(function () { return _this.clearOldValues(); }, CLEAR_OLD_VALUES_INTERVAL);
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ValueHistory.prototype.add = function (value, startTime) {
        var _this = this;
        var entry = {
            value: value,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                var index = _this.entries.indexOf(entry);
                if (index >= 0) {
                    _this.entries.splice(index, 1);
                }
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        if (this.maxEntries && this.entries.length >= this.maxEntries) {
            this.entries.pop();
        }
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ValueHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.value;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */
    ValueHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */
    ValueHistory.prototype.findAll = function (startTime, duration) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        if (duration === void 0) { duration = 0; }
        var endTime = Object(__WEBPACK_IMPORTED_MODULE_1__utils_timeUtils__["d" /* addDuration */])(startTime, duration);
        return this.entries
            .filter(function (entry) { return entry.startTime <= endTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.value; });
    };
    /**
     * Remove all entries from this collection.
     */
    ValueHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ValueHistory.prototype.stop = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__timer__["a" /* clearInterval */])(this.clearOldValuesInterval);
    };
    ValueHistory.prototype.clearOldValues = function () {
        var oldTimeThreshold = Object(__WEBPACK_IMPORTED_MODULE_1__utils_timeUtils__["l" /* relativeNow */])() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ValueHistory;
}());

//# sourceMappingURL=valueHistory.js.map

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createHttpRequest;
/* unused harmony export fetchKeepAliveStrategy */
/* unused harmony export sendXHR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_telemetry__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_addEventListener__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sendWithRetryStrategy__ = __webpack_require__(1959);




function createHttpRequest(endpointBuilder, bytesLimit, reportError) {
    var retryState = Object(__WEBPACK_IMPORTED_MODULE_3__sendWithRetryStrategy__["a" /* newRetryState */])();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sendWithRetryStrategy__["b" /* sendWithRetryStrategy */])(payload, retryState, sendStrategyForRetry, endpointBuilder.endpointType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        },
    };
}
function sendBeaconStrategy(endpointBuilder, bytesLimit, _a) {
    var data = _a.data, bytesCount = _a.bytesCount, flushReason = _a.flushReason;
    var canUseBeacon = !!navigator.sendBeacon && bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon', flushReason);
            var isQueued = navigator.sendBeacon(beaconUrl, data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr', flushReason);
    sendXHR(xhrUrl, data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        Object(__WEBPACK_IMPORTED_MODULE_0__domain_telemetry__["c" /* addTelemetryError */])(e);
    }
}
function fetchKeepAliveStrategy(endpointBuilder, bytesLimit, _a, onResponse) {
    var data = _a.data, bytesCount = _a.bytesCount, flushReason = _a.flushReason, retry = _a.retry;
    var canUseKeepAlive = isKeepAliveSupported() && bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', flushReason, retry);
        fetch(fetchUrl, { method: 'POST', body: data, keepalive: true, mode: 'cors' }).then(Object(__WEBPACK_IMPORTED_MODULE_1__tools_monitor__["c" /* monitor */])(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type }); }), Object(__WEBPACK_IMPORTED_MODULE_1__tools_monitor__["c" /* monitor */])(function () {
            var xhrUrl = endpointBuilder.build('xhr', flushReason, retry);
            // failed to queue the request
            sendXHR(xhrUrl, data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', flushReason, retry);
        sendXHR(xhrUrl, data, onResponse);
    }
}
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    Object(__WEBPACK_IMPORTED_MODULE_2__browser_addEventListener__["a" /* addEventListener */])(request, 'loadend', function () {
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true,
    });
    request.send(data);
}
//# sourceMappingURL=httpRequest.js.map

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isServerError;
/* harmony export (immutable) */ __webpack_exports__["b"] = tryToClone;
function isServerError(status) {
    return status >= 500;
}
function tryToClone(response) {
    try {
        return response.clone();
    }
    catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
//# sourceMappingURL=responseUtils.js.map

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Batch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_display__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_utils_polyfills__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_pageExitObservable__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_utils_byteUtils__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_serialisation_jsonStringify__ = __webpack_require__(186);





var Batch = /** @class */ (function () {
    function Batch(request, flushController, messageBytesLimit) {
        var _this = this;
        this.request = request;
        this.flushController = flushController;
        this.messageBytesLimit = messageBytesLimit;
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.flushController.flushObservable.subscribe(function (event) { return _this.flush(event); });
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.flush = function (event) {
        var messages = this.pushOnlyBuffer.concat(Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_polyfills__["k" /* objectValues */])(this.upsertBuffer));
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        var payload = { data: messages.join('\n'), bytesCount: event.bytesCount, flushReason: event.reason };
        if (Object(__WEBPACK_IMPORTED_MODULE_2__browser_pageExitObservable__["c" /* isPageExitReason */])(event.reason)) {
            this.request.sendOnExit(payload);
        }
        else {
            this.request.send(payload);
        }
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesCount = _a.messageBytesCount;
        if (messageBytesCount >= this.messageBytesLimit) {
            __WEBPACK_IMPORTED_MODULE_0__tools_display__["b" /* display */].warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        this.push(processedMessage, messageBytesCount, key);
    };
    Batch.prototype.process = function (message) {
        var processedMessage = Object(__WEBPACK_IMPORTED_MODULE_4__tools_serialisation_jsonStringify__["b" /* jsonStringify */])(message);
        var messageBytesCount = Object(__WEBPACK_IMPORTED_MODULE_3__tools_utils_byteUtils__["c" /* computeBytesCount */])(processedMessage);
        return { processedMessage: processedMessage, messageBytesCount: messageBytesCount };
    };
    Batch.prototype.push = function (processedMessage, messageBytesCount, key) {
        // If there are other messages, a '\n' will be added at serialization
        var separatorBytesCount = this.flushController.messagesCount > 0 ? 1 : 0;
        this.flushController.notifyBeforeAddMessage(messageBytesCount + separatorBytesCount);
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.flushController.notifyAfterAddMessage();
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = Object(__WEBPACK_IMPORTED_MODULE_3__tools_utils_byteUtils__["c" /* computeBytesCount */])(removedMessage);
        // If there are other messages, a '\n' will be added at serialization
        var separatorBytesCount = this.flushController.messagesCount > 1 ? 1 : 0;
        this.flushController.notifyAfterRemoveMessage(messageBytesCount + separatorBytesCount);
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    return Batch;
}());

//# sourceMappingURL=batch.js.map

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageExitReason; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createPageExitObservable;
/* harmony export (immutable) */ __webpack_exports__["c"] = isPageExitReason;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_experimentalFeatures__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_observable__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_utils_polyfills__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_utils_functionUtils__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addEventListener__ = __webpack_require__(220);





var PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen',
};
function createPageExitObservable() {
    var observable = new __WEBPACK_IMPORTED_MODULE_1__tools_observable__["a" /* Observable */](function () {
        var pagehideEnabled = Object(__WEBPACK_IMPORTED_MODULE_0__tools_experimentalFeatures__["d" /* isExperimentalFeatureEnabled */])(__WEBPACK_IMPORTED_MODULE_0__tools_experimentalFeatures__["a" /* ExperimentalFeature */].PAGEHIDE);
        var stopListeners = Object(__WEBPACK_IMPORTED_MODULE_4__addEventListener__["b" /* addEventListeners */])(window, ["visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, "freeze" /* DOM_EVENT.FREEZE */, "pagehide" /* DOM_EVENT.PAGE_HIDE */], function (event) {
            if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ && pagehideEnabled) {
                /**
                 * Only event that detect page unload events while being compatible with the back/forward cache (bfcache)
                 */
                observable.notify({ reason: PageExitReason.PAGEHIDE });
            }
            else if (event.type === "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: PageExitReason.HIDDEN });
            }
            else if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: PageExitReason.FROZEN });
            }
        }, { capture: true }).stop;
        var stopBeforeUnloadListener = __WEBPACK_IMPORTED_MODULE_3__tools_utils_functionUtils__["a" /* noop */];
        if (!pagehideEnabled) {
            stopBeforeUnloadListener = Object(__WEBPACK_IMPORTED_MODULE_4__addEventListener__["a" /* addEventListener */])(window, "beforeunload" /* DOM_EVENT.BEFORE_UNLOAD */, function () {
                observable.notify({ reason: PageExitReason.UNLOADING });
            }).stop;
        }
        return function () {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
    return observable;
}
function isPageExitReason(reason) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_polyfills__["i" /* includes */])(Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_polyfills__["k" /* objectValues */])(PageExitReason), reason);
}
//# sourceMappingURL=pageExitObservable.js.map

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createFlushController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_observable__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_timer__ = __webpack_require__(150);


/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var flushObservable = new __WEBPACK_IMPORTED_MODULE_0__tools_observable__["a" /* Observable */]();
    pageExitObservable.subscribe(function (event) { return flush(event.reason); });
    sessionExpireObservable.subscribe(function () { return flush('session_expire'); });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) {
            return;
        }
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount,
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) {
            durationLimitTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_1__tools_timer__["d" /* setTimeout */])(function () {
                flush('duration_limit');
            }, durationLimit);
        }
    }
    function cancelDurationLimitTimeout() {
        Object(__WEBPACK_IMPORTED_MODULE_1__tools_timer__["b" /* clearTimeout */])(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount() {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         */
        notifyBeforeAddMessage: function (messageBytesCount) {
            if (currentBytesCount + messageBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += messageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         */
        notifyAfterAddMessage: function () {
            if (currentMessagesCount >= messagesLimit) {
                flush('messages_limit');
            }
            else if (currentBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         */
        notifyAfterRemoveMessage: function (messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) {
                cancelDurationLimitTimeout();
            }
        },
    };
}
//# sourceMappingURL=flushController.js.map

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CUSTOMER_DATA_BYTES_LIMIT */
/* harmony export (immutable) */ __webpack_exports__["a"] = warnIfCustomerDataLimitReached;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_byteUtils__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__display__ = __webpack_require__(109);


// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
var CUSTOMER_DATA_BYTES_LIMIT = 3 * __WEBPACK_IMPORTED_MODULE_0__utils_byteUtils__["a" /* ONE_KIBI_BYTE */];
function warnIfCustomerDataLimitReached(bytesCount, customerDataType) {
    if (bytesCount > CUSTOMER_DATA_BYTES_LIMIT) {
        __WEBPACK_IMPORTED_MODULE_1__display__["b" /* display */].warn("The ".concat(customerDataType, " data is over ").concat(CUSTOMER_DATA_BYTES_LIMIT / __WEBPACK_IMPORTED_MODULE_0__utils_byteUtils__["a" /* ONE_KIBI_BYTE */], "KiB. On low connectivity, the SDK has the potential to exhaust the user's upload bandwidth."));
        return true;
    }
    return false;
}
//# sourceMappingURL=heavyCustomerDataWarning.js.map

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = validateAndBuildRumConfiguration;
/* harmony export (immutable) */ __webpack_exports__["a"] = serializeRumConfiguration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracing_tracer__ = __webpack_require__(804);


function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b, _c, _d, _e, _f;
    if (!initConfiguration.applicationId) {
        __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (initConfiguration.sessionReplaySampleRate !== undefined &&
        !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_26" /* isPercentage */])(initConfiguration.sessionReplaySampleRate)) {
        __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Session Replay Sample Rate should be a number between 0 and 100');
        return;
    }
    // TODO remove fallback in next major
    var premiumSampleRate = (_a = initConfiguration.premiumSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.replaySampleRate;
    if (premiumSampleRate !== undefined && initConfiguration.sessionReplaySampleRate !== undefined) {
        __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].warn('Ignoring Premium Sample Rate because Session Replay Sample Rate is set');
        premiumSampleRate = undefined;
    }
    if (premiumSampleRate !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_26" /* isPercentage */])(premiumSampleRate)) {
        __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Premium Sample Rate should be a number between 0 and 100');
        return;
    }
    var traceSampleRate = (_b = initConfiguration.traceSampleRate) !== null && _b !== void 0 ? _b : initConfiguration.tracingSampleRate;
    if (traceSampleRate !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_26" /* isPercentage */])(traceSampleRate)) {
        __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Trace Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Excluded Activity Urls should be an array');
        return;
    }
    var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) {
        return;
    }
    var baseConfiguration = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_60" /* validateAndBuildConfiguration */])(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    var trackUserInteractions = !!((_c = initConfiguration.trackUserInteractions) !== null && _c !== void 0 ? _c : initConfiguration.trackInteractions);
    var trackFrustrations = !!initConfiguration.trackFrustrations;
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: (_e = (_d = initConfiguration.sessionReplaySampleRate) !== null && _d !== void 0 ? _d : premiumSampleRate) !== null && _e !== void 0 ? _e : 100,
        oldPlansBehavior: initConfiguration.sessionReplaySampleRate === undefined,
        traceSampleRate: traceSampleRate,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_f = initConfiguration.excludedActivityUrls) !== null && _f !== void 0 ? _f : [],
        trackUserInteractions: trackUserInteractions || trackFrustrations,
        trackFrustrations: trackFrustrations,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: initConfiguration.trackResources,
        trackLongTasks: initConfiguration.trackLongTasks,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_37" /* objectHasValue */])(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["e" /* DefaultPrivacyLevel */], initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["e" /* DefaultPrivacyLevel */].MASK_USER_INPUT,
        customerDataTelemetrySampleRate: 1,
    }, baseConfiguration);
}
/**
 * Handles allowedTracingUrls and processes legacy allowedTracingOrigins
 */
function validateAndBuildTracingOptions(initConfiguration) {
    // Advise about parameters precedence.
    if (initConfiguration.allowedTracingUrls !== undefined && initConfiguration.allowedTracingOrigins !== undefined) {
        __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].warn('Both allowedTracingUrls and allowedTracingOrigins (deprecated) have been defined. The parameter allowedTracingUrls will override allowedTracingOrigins.');
    }
    // Handle allowedTracingUrls first
    if (initConfiguration.allowedTracingUrls !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
            __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Allowed Tracing URLs should be an array');
            return;
        }
        if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
            __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Service needs to be configured when tracing is enabled');
            return;
        }
        // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
        var tracingOptions_1 = [];
        initConfiguration.allowedTracingUrls.forEach(function (option) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_23" /* isMatchOption */])(option)) {
                tracingOptions_1.push({ match: option, propagatorTypes: ['datadog'] });
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_1__tracing_tracer__["a" /* isTracingOption */])(option)) {
                tracingOptions_1.push(option);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
            }
        });
        return tracingOptions_1;
    }
    // Handle conversion of allowedTracingOrigins to allowedTracingUrls
    if (initConfiguration.allowedTracingOrigins !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingOrigins)) {
            __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Allowed Tracing Origins should be an array');
            return;
        }
        if (initConfiguration.allowedTracingOrigins.length !== 0 && initConfiguration.service === undefined) {
            __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Service needs to be configured when tracing is enabled');
            return;
        }
        var tracingOptions_2 = [];
        initConfiguration.allowedTracingOrigins.forEach(function (legacyMatchOption) {
            var tracingOption = convertLegacyMatchOptionToTracingOption(legacyMatchOption);
            if (tracingOption) {
                tracingOptions_2.push(tracingOption);
            }
        });
        return tracingOptions_2;
    }
    return [];
}
/**
 * Converts parameters from the deprecated allowedTracingOrigins
 * to allowedTracingUrls. Handles the change from origin to full URLs.
 */
function convertLegacyMatchOptionToTracingOption(item) {
    var match;
    if (typeof item === 'string') {
        match = item;
    }
    else if (item instanceof RegExp) {
        match = function (url) { return item.test(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_6" /* getOrigin */])(url)); };
    }
    else if (typeof item === 'function') {
        match = function (url) { return item(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_6" /* getOrigin */])(url)); };
    }
    if (match === undefined) {
        __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].warn('Allowed Tracing Origins parameters should be a string, RegExp or function. Ignoring parameter', item);
        return undefined;
    }
    return { match: match, propagatorTypes: ['datadog'] };
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls,
 * and assumes 'datadog' has been selected when using allowedTracingOrigins
 */
function getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
        configuration.allowedTracingUrls.forEach(function (option) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_23" /* isMatchOption */])(option)) {
                usedTracingPropagators.add('datadog');
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_11" /* getType */])(option) === 'object' && Array.isArray(option.propagatorTypes)) {
                // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
                option.propagatorTypes.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
        });
    }
    if (Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0) {
        usedTracingPropagators.add('datadog');
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["x" /* arrayFrom */])(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
    var _a, _b;
    var baseSerializedConfiguration = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_48" /* serializeConfiguration */])(configuration);
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
        premium_sample_rate: configuration.premiumSampleRate,
        replay_sample_rate: configuration.replaySampleRate,
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        trace_sample_rate: (_a = configuration.traceSampleRate) !== null && _a !== void 0 ? _a : configuration.tracingSampleRate,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_origins: Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
        track_frustrations: configuration.trackFrustrations,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: (_b = configuration.trackUserInteractions) !== null && _b !== void 0 ? _b : configuration.trackInteractions,
    }, baseSerializedConfiguration);
}
//# sourceMappingURL=configuration.js.map

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTracingOption;
/* unused harmony export clearTracingIfNeeded */
/* harmony export (immutable) */ __webpack_exports__["b"] = startTracer;
/* unused harmony export isTracingSupported */
/* unused harmony export TraceIdentifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function isTracingOption(item) {
    var expectedItem = item;
    return (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_11" /* getType */])(expectedItem) === 'object' &&
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_23" /* isMatchOption */])(expectedItem.match) &&
        Array.isArray(expectedItem.propagatorTypes));
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_51" /* shallowClone */])(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_36" /* objectEntries */])(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
        return;
    }
    var tracingOption = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["Z" /* find */])(configuration.allowedTracingUrls, function (tracingOption) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_33" /* matchList */])([tracingOption.match], context.url, true);
    });
    if (!tracingOption) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    context.traceSampled = !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_24" /* isNumber */])(configuration.traceSampleRate) || Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_38" /* performDraw */])(configuration.traceSampleRate);
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
function getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function (propagatorType) {
        switch (propagatorType) {
            case 'datadog': {
                Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toDecimalString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toDecimalString(),
                });
                break;
            }
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext': {
                Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            // https://github.com/openzipkin/b3-propagation
            case 'b3': {
                Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])(tracingHeaders, {
                    b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            case 'b3multi': {
                Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])(tracingHeaders, {
                    'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
                    'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
                    'X-B3-Sampled': traceSampled ? '1' : '0',
                });
                break;
            }
        }
    });
    return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    /**
     * Format used by OTel headers
     */
    TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
        var traceId = this.toString(16);
        return Array(17 - traceId.length).join('0') + traceId;
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());

/* eslint-enable no-bitwise */
//# sourceMappingURL=tracer.js.map

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildCommonContext;
function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
//# sourceMappingURL=commonContext.js.map

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDOMMutationObservable;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMutationObserverConstructor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    var observable = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["m" /* Observable */](function () {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
    return observable;
}
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_12" /* getZoneJsOriginalValue */])(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */]);
            var originalInstance = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_12" /* getZoneJsOriginalValue */])(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
//# sourceMappingURL=domMutationObservable.js.map

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = supportPerformanceTimingEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = startPerformanceCollection;
/* unused harmony export retrieveInitialDocumentResourceTiming */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_rumEventsCollection_resource_resourceUtils__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_tracing_getDocumentTraceId__ = __webpack_require__(1980);



function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function startPerformanceCollection(lifeCycle, configuration) {
    retrieveInitialDocumentResourceTiming(function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_50" /* setTimeout */])(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); });
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = ['resource', 'navigation', 'longtask', 'paint'];
        var experimentalEntries = ['largest-contentful-paint', 'first-input', 'layout-shift'];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({ type: type, buffered: true });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver.observe({ entryTypes: mainEntries });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(performance, 'resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            });
        }
    }
    if (!supportPerformanceTimingEvent('navigation')) {
        retrieveNavigationTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent('first-input')) {
        retrieveFirstInputTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
}
function retrieveInitialDocumentResourceTiming(callback) {
    Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_43" /* runOnReadyState */])('interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: 'resource',
            initiatorType: __WEBPACK_IMPORTED_MODULE_1__domain_rumEventsCollection_resource_resourceUtils__["a" /* FAKE_INITIAL_DOCUMENT */],
            traceId: Object(__WEBPACK_IMPORTED_MODULE_2__domain_tracing_getDocumentTraceId__["a" /* getDocumentTraceId */])(document),
        };
        if (supportPerformanceTimingEvent('navigation') && performance.getEntriesByType('navigation').length > 0) {
            var navigationEntry = performance.getEntriesByType('navigation')[0];
            timing = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
function retrieveNavigationTiming(callback) {
    function sendFakeTiming() {
        callback(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])(computeRelativePerformanceTiming(), {
            entryType: 'navigation',
        }));
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_43" /* runOnReadyState */])('complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_50" /* setTimeout */])(sendFakeTiming);
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(callback) {
    var startTimeStamp = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["T" /* dateNow */])();
    var timingSent = false;
    var removeEventListeners = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(window, ["click" /* DOM_EVENT.CLICK */, "mousedown" /* DOM_EVENT.MOUSE_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */, "touchstart" /* DOM_EVENT.TOUCH_START */, "pointerdown" /* DOM_EVENT.POINTER_DOWN */], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: 'first-input',
            processingStart: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_40" /* relativeNow */])(),
            startTime: evt.timeStamp,
        };
        if (evt.type === "pointerdown" /* DOM_EVENT.POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(timing) {
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(window, ["pointerup" /* DOM_EVENT.POINTER_UP */, "pointercancel" /* DOM_EVENT.POINTER_CANCEL */], function (event) {
            if (event.type === "pointerup" /* DOM_EVENT.POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["T" /* dateNow */])() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_24" /* isNumber */])(timing[key])) {
            var numberKey = key;
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_8" /* getRelativeTime */])(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return entry.entryType === 'resource' ||
            entry.entryType === 'navigation' ||
            entry.entryType === 'paint' ||
            entry.entryType === 'longtask' ||
            entry.entryType === 'largest-contentful-paint' ||
            entry.entryType === 'first-input' ||
            entry.entryType === 'layout-shift';
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === 'navigation' && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === 'resource' && !Object(__WEBPACK_IMPORTED_MODULE_1__domain_rumEventsCollection_resource_resourceUtils__["f" /* isAllowedRequestUrl */])(configuration, entry.name);
}
//# sourceMappingURL=performanceCollection.js.map

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isTextNode;
/* harmony export (immutable) */ __webpack_exports__["c"] = isCommentNode;
/* harmony export (immutable) */ __webpack_exports__["d"] = isElementNode;
/* harmony export (immutable) */ __webpack_exports__["e"] = isNodeShadowHost;
/* harmony export (immutable) */ __webpack_exports__["f"] = isNodeShadowRoot;
/* harmony export (immutable) */ __webpack_exports__["a"] = getChildNodes;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParentNode;
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function getChildNodes(node) {
    return isNodeShadowHost(node) ? node.shadowRoot.childNodes : node.childNodes;
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
//# sourceMappingURL=htmlDomUtils.js.map

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initViewportObservable;
/* unused harmony export createViewportObservable */
/* harmony export (immutable) */ __webpack_exports__["a"] = getViewportDimension;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var viewportObservable;
function initViewportObservable() {
    if (!viewportObservable) {
        viewportObservable = createViewportObservable();
    }
    return viewportObservable;
}
function createViewportObservable() {
    var observable = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["m" /* Observable */](function () {
        var updateDimension = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_55" /* throttle */])(function () {
            observable.notify(getViewportDimension());
        }, 200).throttled;
        return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(window, "resize" /* DOM_EVENT.RESIZE */, updateDimension, { capture: true, passive: true }).stop;
    });
    return observable;
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
    var visual = window.visualViewport;
    if (visual) {
        return {
            width: Number(visual.width * visual.scale),
            height: Number(visual.height * visual.scale),
        };
    }
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0),
    };
}
//# sourceMappingURL=viewportObservable.js.map

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LifeCycle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var LifeCycle = (__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["a" /* AbstractLifeCycle */]);
//# sourceMappingURL=lifeCycle.js.map

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackEventCounts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function trackEventCounts(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */] : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    var subscription = lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        if (event.type === 'view' || !isChildEvent(event)) {
            return;
        }
        switch (event.type) {
            case "error" /* RumEventType.ERROR */:
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* RumEventType.ACTION */:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback();
                break;
            case "long_task" /* RumEventType.LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RumEventType.RESOURCE */:
                eventCounts.resourceCount += 1;
                callback();
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAGE_ACTIVITY_VALIDATION_DELAY; });
/* unused harmony export PAGE_ACTIVITY_END_DELAY */
/* harmony export (immutable) */ __webpack_exports__["b"] = waitPageActivityEnd;
/* unused harmony export doWaitPageActivityEnd */
/* unused harmony export createPageActivityObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_50" /* setTimeout */])(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function () { return complete({ hadActivity: false }); }), PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration !== undefined
        ? Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_50" /* setTimeout */])(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function () { return complete({ hadActivity: true, end: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])() }); }), maxDuration)
        : undefined;
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["E" /* clearTimeout */])(validationTimeoutId);
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["E" /* clearTimeout */])(pageActivityEndTimeoutId);
        var lastChangeTime = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])();
        if (!isBusy) {
            pageActivityEndTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_50" /* setTimeout */])(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["E" /* clearTimeout */])(validationTimeoutId);
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["E" /* clearTimeout */])(pageActivityEndTimeoutId);
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["E" /* clearTimeout */])(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop: stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
    var observable = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["m" /* Observable */](function () {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (entry) { return entry.entryType === 'resource' && !isExcludedUrl(configuration, entry.name); })) {
                notifyPageActivity();
            }
        }), lifeCycle.subscribe(5 /* LifeCycleEventType.REQUEST_STARTED */, function (startEvent) {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(6 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
        return function () {
            stopTrackingWindowOpen();
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        };
        function notifyPageActivity() {
            observable.notify({ isBusy: pendingRequestsCount > 0 });
        }
    });
    return observable;
}
function isExcludedUrl(configuration, requestUrl) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_33" /* matchList */])(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_18" /* instrumentMethodAndCallOriginal */])(window, 'open', { before: callback });
}
//# sourceMappingURL=waitPageActivityEnd.js.map

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STABLE_ATTRIBUTES; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getSelectorFromElement;
/* unused harmony export supportScopeSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getActionNameFromElement__ = __webpack_require__(500);


/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
var STABLE_ATTRIBUTES = [
    __WEBPACK_IMPORTED_MODULE_1__getActionNameFromElement__["a" /* DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE */],
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file',
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    getStableAttributeSelector,
    getClassSelector,
    getTagNameSelector,
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
    var targetElementSelector = '';
    var element = targetElement;
    while (element && element.nodeName !== 'HTML') {
        var globallyUniqueSelector = findSelector(element, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) {
            return globallyUniqueSelector;
        }
        var uniqueSelectorAmongChildren = findSelector(element, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector =
            uniqueSelectorAmongChildren || combineSelector(getPositionSelector(element), targetElementSelector);
        element = element.parentElement;
    }
    return targetElementSelector;
}
function isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if a the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time. We might want to allow customers to
    // provide their own `isGeneratedValue` at some point.
    return /[0-9]/.test(value);
}
function getIDSelector(element) {
    if (element.id && !isGeneratedValue(element.id)) {
        return "#".concat(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["R" /* cssEscape */])(element.id));
    }
}
function getClassSelector(element) {
    if (element.tagName === 'BODY') {
        return;
    }
    if (element.classList.length > 0) {
        for (var i = 0; i < element.classList.length; i += 1) {
            var className = element.classList[i];
            if (isGeneratedValue(className)) {
                continue;
            }
            return "".concat(element.tagName, ".").concat(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["R" /* cssEscape */])(className));
        }
    }
}
function getTagNameSelector(element) {
    return element.tagName;
}
function getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) {
            return selector;
        }
    }
    for (var _i = 0, STABLE_ATTRIBUTES_1 = STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) {
            return selector;
        }
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) {
            return "".concat(element.tagName, "[").concat(attributeName, "=\"").concat(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["R" /* cssEscape */])(element.getAttribute(attributeName)), "\"]");
        }
    }
}
function getPositionSelector(element) {
    var sibling = element.parentElement.firstElementChild;
    var elementIndex = 1;
    while (sibling && sibling !== element) {
        if (sibling.tagName === element.tagName) {
            elementIndex += 1;
        }
        sibling = sibling.nextElementSibling;
    }
    return "".concat(element.tagName, ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) {
            continue;
        }
        var fullSelector = combineSelector(elementSelector, childSelector);
        if (predicate(element, fullSelector)) {
            return fullSelector;
        }
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, selector) {
    return element.ownerDocument.querySelectorAll(selector).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > SELECTOR" returns a single element.
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT SELECTOR" returns a single element), regardless of whether the selector is a
 * direct descendent of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 */
function isSelectorUniqueAmongSiblings(element, selector) {
    return (element.parentElement.querySelectorAll(supportScopeSelector() ? combineSelector(':scope', selector) : selector)
        .length === 1);
}
function combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
    if (supportScopeSelectorCache === undefined) {
        try {
            document.querySelector(':scope');
            supportScopeSelectorCache = true;
        }
        catch (_a) {
            supportScopeSelectorCache = false;
        }
    }
    return supportScopeSelectorCache;
}
//# sourceMappingURL=getSelectorFromElement.js.map

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assembleIncrementalSnapshot;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(164);


function assembleIncrementalSnapshot(source, data) {
    return {
        data: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
            source: source,
        }, data),
        type: __WEBPACK_IMPORTED_MODULE_1__types__["e" /* RecordType */].IncrementalSnapshot,
        timestamp: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])(),
    };
}
//# sourceMappingURL=assembly.js.map

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = serializeNodeWithId;
/* unused harmony export generateNextId */
/* unused harmony export serializeChildNodes */
/* unused harmony export serializeDocumentNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__privacy__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__serializationUtils__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__serializeStyleSheets__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__serializeAttributes__ = __webpack_require__(2023);








function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = Object(__WEBPACK_IMPORTED_MODULE_5__serializationUtils__["b" /* getSerializedNodeId */])(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    Object(__WEBPACK_IMPORTED_MODULE_5__serializationUtils__["f" /* setSerializedNodeId */])(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
function serializeChildNodes(node, options) {
    var result = [];
    node.childNodes.forEach(function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_2__types__["d" /* NodeType */].Document,
        childNodes: serializeChildNodes(document, options),
        adoptedStyleSheets: Object(__WEBPACK_IMPORTED_MODULE_6__serializeStyleSheets__["a" /* serializeStyleSheets */])(document.adoptedStyleSheets),
    };
}
function serializeDocumentFragmentNode(element, options) {
    var childNodes = [];
    if (element.childNodes.length) {
        childNodes = serializeChildNodes(element, options);
    }
    var isShadowRoot = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__["j" /* isNodeShadowRoot */])(element);
    if (isShadowRoot) {
        options.serializationContext.shadowRootsController.addShadowRoot(element);
    }
    return {
        type: __WEBPACK_IMPORTED_MODULE_2__types__["d" /* NodeType */].DocumentFragment,
        childNodes: childNodes,
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? Object(__WEBPACK_IMPORTED_MODULE_6__serializeStyleSheets__["a" /* serializeStyleSheets */])(element.adoptedStyleSheets) : undefined,
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_2__types__["d" /* NodeType */].DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = Object(__WEBPACK_IMPORTED_MODULE_5__serializationUtils__["c" /* getValidTagName */])(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = Object(__WEBPACK_IMPORTED_MODULE_4__privacy__["e" /* reducePrivacyLevel */])(Object(__WEBPACK_IMPORTED_MODULE_4__privacy__["c" /* getNodeSelfPrivacyLevel */])(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* NodePrivacyLevel */].HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: __WEBPACK_IMPORTED_MODULE_2__types__["d" /* NodeType */].Element,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* PRIVACY_ATTR_NAME */]] = __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* PRIVACY_ATTR_VALUE_HIDDEN */],
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* NodePrivacyLevel */].IGNORE) {
        return;
    }
    var attributes = Object(__WEBPACK_IMPORTED_MODULE_7__serializeAttributes__["a" /* serializeAttributes */])(element, nodePrivacyLevel, options);
    var childNodes = [];
    if (element.childNodes.length) {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_core__["y" /* assign */])({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__["i" /* isNodeShadowHost */])(element)) {
        var shadowRoot = serializeNodeWithId(element.shadowRoot, options);
        if (shadowRoot !== null) {
            childNodes.push(shadowRoot);
        }
    }
    return {
        type: __WEBPACK_IMPORTED_MODULE_2__types__["d" /* NodeType */].Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = Object(__WEBPACK_IMPORTED_MODULE_4__privacy__["d" /* getTextContent */])(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) {
        return;
    }
    return {
        type: __WEBPACK_IMPORTED_MODULE_2__types__["d" /* NodeType */].Text,
        textContent: textContent,
        isStyle: parentTagName === 'STYLE' ? true : undefined,
    };
}
function serializeCDataNode() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_2__types__["d" /* NodeType */].CDATA,
        textContent: '',
    };
}
//# sourceMappingURL=serializeNode.js.map

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = serializeAttribute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__privacy__ = __webpack_require__(166);




function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* NodePrivacyLevel */].HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* NodePrivacyLevel */].MASK &&
        attributeName !== __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PRIVACY_ATTR_NAME */] &&
        !__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["a" /* STABLE_ATTRIBUTES */].includes(attributeName) &&
        attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* CENSORED_STRING_MARK */];
        }
        // mask image URLs
        if (tagName === 'IMG' || tagName === 'SOURCE') {
            if (attributeName === 'src' || attributeName === 'srcset') {
                return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CENSORED_IMG_MARK */];
            }
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* CENSORED_STRING_MARK */];
        }
        // mask data-* attributes
        if (attributeValue && Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_54" /* startsWith */])(attributeName, 'data-')) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* CENSORED_STRING_MARK */];
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > __WEBPACK_IMPORTED_MODULE_3__privacy__["a" /* MAX_ATTRIBUTE_VALUE_CHAR_LENGTH */] && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
//# sourceMappingURL=serializeAttribute.js.map

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observers__ = __webpack_require__(2024);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__observers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputObserver__ = __webpack_require__(819);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__inputObserver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutationObserver__ = __webpack_require__(820);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__mutationObserver__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initMoveObserver;
/* harmony export (immutable) */ __webpack_exports__["b"] = tryToComputeCoordinates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serialization__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventsUtils__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__viewports__ = __webpack_require__(362);





var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function initMoveObserver(cb) {
    var updatePosition = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_55" /* throttle */])(function (event) {
        var target = Object(__WEBPACK_IMPORTED_MODULE_3__eventsUtils__["a" /* getEventTarget */])(event);
        if (Object(__WEBPACK_IMPORTED_MODULE_1__serialization__["c" /* hasSerializedNode */])(target)) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            var position = {
                id: Object(__WEBPACK_IMPORTED_MODULE_1__serialization__["b" /* getSerializedNodeId */])(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y,
            };
            cb([position], Object(__WEBPACK_IMPORTED_MODULE_3__eventsUtils__["b" /* isTouchEvent */])(event) ? __WEBPACK_IMPORTED_MODULE_2__types__["a" /* IncrementalSource */].TouchMove : __WEBPACK_IMPORTED_MODULE_2__types__["a" /* IncrementalSource */].MouseMove);
        }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }).throttled;
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(document, ["mousemove" /* DOM_EVENT.MOUSE_MOVE */, "touchmove" /* DOM_EVENT.TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
}
function tryToComputeCoordinates(event) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_3__eventsUtils__["b" /* isTouchEvent */])(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = Object(__WEBPACK_IMPORTED_MODULE_4__viewports__["a" /* convertMouseEventToLayoutCoordinates */])(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) {
            Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["v" /* addTelemetryDebug */])('mouse/touch event without x/y');
        }
        return undefined;
    }
    return { x: x, y: y };
}
//# sourceMappingURL=moveObserver.js.map

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initInputObserver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventsUtils__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__privacy__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__serialization__ = __webpack_require__(165);





function initInputObserver(cb, defaultPrivacyLevel, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.domEvents, domEvents = _c === void 0 ? ["input" /* DOM_EVENT.INPUT */, "change" /* DOM_EVENT.CHANGE */] : _c, _d = _b.target, target = _d === void 0 ? document : _d;
    var lastInputStateMap = new WeakMap();
    function onElementChange(target) {
        var nodePrivacyLevel = Object(__WEBPACK_IMPORTED_MODULE_3__privacy__["b" /* getNodePrivacyLevel */])(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__privacy__["f" /* shouldMaskNode */])(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["a" /* getElementInputValue */])(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_2" /* forEach */])(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["c" /* hasSerializedNode */])(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
                id: Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["b" /* getSerializedNodeId */])(target),
            }, inputState));
        }
    }
    var stopEventListeners = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(target, domEvents, function (event) {
        var target = Object(__WEBPACK_IMPORTED_MODULE_2__eventsUtils__["a" /* getEventTarget */])(event);
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            onElementChange(target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var instrumentationStoppers = [
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_19" /* instrumentSetter */])(HTMLInputElement.prototype, 'value', onElementChange),
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_19" /* instrumentSetter */])(HTMLInputElement.prototype, 'checked', onElementChange),
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_19" /* instrumentSetter */])(HTMLSelectElement.prototype, 'value', onElementChange),
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_19" /* instrumentSetter */])(HTMLTextAreaElement.prototype, 'value', onElementChange),
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_19" /* instrumentSetter */])(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
    ];
    return function () {
        instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); });
        stopEventListeners();
    };
}
//# sourceMappingURL=inputObserver.js.map

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initMutationObserver;
/* unused harmony export sortAddedAndMovedNodes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__privacy__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__serialization__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutationBatch__ = __webpack_require__(2031);






/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function initMutationObserver(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["c" /* getMutationObserverConstructor */])();
    if (!MutationObserver) {
        return { stop: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */], flush: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */] };
    }
    var mutationBatch = Object(__WEBPACK_IMPORTED_MODULE_5__mutationBatch__["a" /* createMutationBatch */])(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController, target);
    });
    var observer = new MutationObserver(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function () {
            mutationBatch.flush();
        },
    };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController, target) {
    mutations
        .filter(function (mutation) { return mutation.type === 'childList'; })
        .forEach(function (mutation) {
        mutation.removedNodes.forEach(function (removedNode) {
            traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return target.contains(mutation.target) &&
            Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["d" /* nodeAndAncestorsHaveSerializedNode */])(mutation.target) &&
            Object(__WEBPACK_IMPORTED_MODULE_3__privacy__["b" /* getNodePrivacyLevel */])(mutation.target, configuration.defaultPrivacyLevel) !== __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* NodePrivacyLevel */].HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), configuration, shadowRootsController), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), configuration);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), configuration);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, configuration, shadowRootsController) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        mutation.addedNodes.forEach(function (node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = Object(__WEBPACK_IMPORTED_MODULE_3__privacy__["b" /* getNodePrivacyLevel */])(node.parentNode, configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* NodePrivacyLevel */].HIDDEN || parentNodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* NodePrivacyLevel */].IGNORE) {
            continue;
        }
        var serializedNode = Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["g" /* serializeNodeWithId */])(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: { status: 2 /* SerializationContextStatus.MUTATION */, shadowRootsController: shadowRootsController },
            configuration: configuration,
        });
        if (!serializedNode) {
            continue;
        }
        var parentNode = Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["d" /* getParentNode */])(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["b" /* getSerializedNodeId */])(parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["c" /* hasSerializedNode */])(node)) {
            removedNodeMutations.push({
                parentId: Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["b" /* getSerializedNodeId */])(parent),
                id: Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["b" /* getSerializedNodeId */])(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["c" /* hasSerializedNode */])(node) && serializedNodeIds.has(Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["b" /* getSerializedNodeId */])(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if (Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["c" /* hasSerializedNode */])(nextSibling)) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["b" /* getSerializedNodeId */])(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, configuration) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = Object(__WEBPACK_IMPORTED_MODULE_3__privacy__["b" /* getNodePrivacyLevel */])(Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["d" /* getParentNode */])(mutation.target), configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* NodePrivacyLevel */].HIDDEN || parentNodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* NodePrivacyLevel */].IGNORE) {
            continue;
        }
        textMutations.push({
            id: Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["b" /* getSerializedNodeId */])(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = Object(__WEBPACK_IMPORTED_MODULE_3__privacy__["d" /* getTextContent */])(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, configuration) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = Object(__WEBPACK_IMPORTED_MODULE_3__privacy__["b" /* getNodePrivacyLevel */])(mutation.target, configuration.defaultPrivacyLevel);
        var attributeValue = Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["e" /* serializeAttribute */])(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["a" /* getElementInputValue */])(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["b" /* getSerializedNodeId */])(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["i" /* isNodeShadowHost */])(removedNode)) {
        shadowDomRemovedCallback(removedNode.shadowRoot);
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["b" /* getChildNodes */])(removedNode).forEach(function (child) { return traverseRemovedShadowDom(child, shadowDomRemovedCallback); });
}
//# sourceMappingURL=mutationObserver.js.map

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createElementsScrollPositions;
function createElementsScrollPositions() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function (element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function (element) {
            return scrollPositionsByElement.get(element);
        },
        has: function (element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
//# sourceMappingURL=elementsScrollPositions.js.map

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__segmentCollection__ = __webpack_require__(823);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__segmentCollection__["b"]; });
/* unused harmony reexport setSegmentBytesLimit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startDeflateWorker__ = __webpack_require__(2037);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__startDeflateWorker__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__segmentCollection__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SEGMENT_DURATION_LIMIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEGMENT_BYTES_LIMIT; });
/* harmony export (immutable) */ __webpack_exports__["b"] = startSegmentCollection;
/* unused harmony export doStartSegmentCollection */
/* unused harmony export computeSegmentContext */
/* unused harmony export setSegmentBytesLimit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buildReplayPayload__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__segment__ = __webpack_require__(2036);



var SEGMENT_DURATION_LIMIT = 30 * __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["l" /* ONE_SECOND */];
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, applicationId, sessionManager, viewContexts, httpRequest, worker) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(applicationId, sessionManager, viewContexts); }, httpRequest, worker);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, worker) {
    var state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(9 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
            state.segment.flush(flushReason);
            Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["E" /* clearTimeout */])(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') {
            state = {
                status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
                nextSegmentCreationReason: flushReason,
            };
        }
        else {
            state = {
                status: 2 /* SegmentCollectionStatus.Stopped */,
            };
        }
    }
    function createNewSegment(creationReason, initialRecord) {
        var context = getSegmentContext();
        if (!context) {
            return;
        }
        var segment = new __WEBPACK_IMPORTED_MODULE_2__segment__["a" /* Segment */](worker, context, creationReason, initialRecord, function (compressedSegmentBytesCount) {
            if (!segment.flushReason && compressedSegmentBytesCount > SEGMENT_BYTES_LIMIT) {
                flushSegment('segment_bytes_limit');
            }
        }, function (data, rawSegmentBytesCount) {
            var payload = Object(__WEBPACK_IMPORTED_MODULE_1__buildReplayPayload__["a" /* buildReplayPayload */])(data, segment.metadata, rawSegmentBytesCount);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_25" /* isPageExitReason */])(segment.flushReason)) {
                httpRequest.sendOnExit(payload);
            }
            else {
                httpRequest.send(payload);
            }
        });
        state = {
            status: 1 /* SegmentCollectionStatus.SegmentPending */,
            segment: segment,
            expirationTimeoutId: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_50" /* setTimeout */])(function () {
                flushSegment('segment_duration_limit');
            }, SEGMENT_DURATION_LIMIT),
        };
    }
    return {
        addRecord: function (record) {
            switch (state.status) {
                case 0 /* SegmentCollectionStatus.WaitingForInitialRecord */:
                    createNewSegment(state.nextSegmentCreationReason, record);
                    break;
                case 1 /* SegmentCollectionStatus.SegmentPending */:
                    state.segment.addRecord(record);
                    break;
            }
        },
        stop: function () {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageExited();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.id,
        },
    };
}
function setSegmentBytesLimit(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) { newSegmentBytesLimit = 60000; }
    SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
//# sourceMappingURL=segmentCollection.js.map

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MAX_STATS_HISTORY */
/* harmony export (immutable) */ __webpack_exports__["e"] = getSegmentsCount;
/* harmony export (immutable) */ __webpack_exports__["b"] = addSegment;
/* harmony export (immutable) */ __webpack_exports__["a"] = addRecord;
/* harmony export (immutable) */ __webpack_exports__["c"] = addWroteData;
/* harmony export (immutable) */ __webpack_exports__["d"] = getReplayStats;
/* unused harmony export resetReplayStats */
var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function resetReplayStats() {
    statsPerView = undefined;
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}
//# sourceMappingURL=replayStats.js.map

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isBrowserSupported;
/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
    return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' &&
        typeof CSSSupportsRule === 'function' &&
        typeof URL.createObjectURL === 'function' &&
        'forEach' in NodeList.prototype);
}
//# sourceMappingURL=isBrowserSupported.js.map

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(696);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(699);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(448);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(320);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(701);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(702);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(449);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(321);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-small-white.b5f2a306.png";

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__select_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input_style__ = __webpack_require__(32);


// style dependencies



/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/r.f11169f1.png";

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Users_less__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Users_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Users_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_api_UserApiController__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_api_ReportApiController__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_upload__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_upload_style_index_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_dropdown__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_dropdown_style_index_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_menu__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_menu_style_index_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_DownloadUtil__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__UsersUploadErrorModal__ = __webpack_require__(835);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};







































var Users = /** @class */ (function (_super) {
    __extends(Users, _super);
    function Users(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, Users.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            isAdminTable: _this.props.match && _this.props.match.params.isAdminTable === 'true' ? true : false,
            classroomId: _this.props.classroomId ? _this.props.classroomId : 0,
            onlyClassroomUsers: _this.props.onlyClassroomUsers ? _this.props.onlyClassroomUsers : false,
            uploading: false,
            uploadMode: "",
            uploadStatus: "none",
            massUploadErrorMessage: "",
            massUploadFileName: "",
            massUploadTableData: [],
            showModal: false,
        };
        return _this;
    }
    Users.prototype.getStudentReport = function (userId, reportName) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_8_src_api_ReportApiController__["a" /* default */].getStudentReport(userId).then(function (result) {
            __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].success(_this.props.translate('admin.users.messageReport'));
            Object(__WEBPACK_IMPORTED_MODULE_35__utils_DownloadUtil__["a" /* downloadFile */])(result.data, reportName);
        });
    };
    Users.prototype.deactivateUser = function (userId) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_7_src_api_UserApiController__["a" /* default */].deactivateUser(userId).then(function (result) {
            __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].success(_this.props.translate('admin.users.messageDeactivate'));
            _this.dataTableRef.refresh();
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].error(_this.props.translate('admin.users.messageDeactivateError'));
        });
    };
    Users.prototype.removeUserFromClassroom = function (userId, classroomId) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_7_src_api_UserApiController__["a" /* default */].removeUserFromClassroom(userId, classroomId).then(function (result) {
            __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].success(_this.props.translate('admin.users.messageRemove'));
            _this.props.updateShouldRefreshTable();
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].error(_this.props.translate('admin.users.messageRemoveError'));
        });
    };
    Users.prototype.addUserToClassroom = function (userId, classroomId) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_7_src_api_UserApiController__["a" /* default */].addUserToClassroom(userId, classroomId).then(function (result) {
            if (result.data.isSuccess) {
                __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].success(_this.props.translate('admin.users.messageAdd'));
                _this.props.updateShouldRefreshTable();
            }
            else {
                __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].error(result.data.errorMessage);
            }
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].error(_this.props.translate('admin.users.messageAddError'));
        });
    };
    Users.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({
            loading: true
        });
        __WEBPACK_IMPORTED_MODULE_7_src_api_UserApiController__["a" /* default */].getUserTableData(requestState, this.state.isAdminTable, this.state.classroomId, this.state.onlyClassroomUsers)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            tableRecords.forEach(function (z) { return z.userType = _this.props.translate("report.admin.roleFilter." + z.userType).toString(); });
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    Users.prototype.customTableColumns = function () {
        var _this = this;
        var statementsLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_STUDENT_STATEMENTS, _this.state.classroomId, record.userId); };
        var editLink = function (text, record) {
            if ((record.isCleverEnabledDistrict || record.isClassLinkEnabledDistrict) && !record.allowEditChangePassword) {
                return "";
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_USER, _this.state.classroomId, record.userId, _this.state.isAdminTable);
            }
        };
        var changePasswordLink = function (text, record) {
            if ((record.isCleverEnabledDistrict || record.isClassLinkEnabledDistrict) && !record.allowEditChangePassword) {
                return "";
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_RESET_PASSWORD, _this.state.classroomId, record.userId, _this.state.isAdminTable);
            }
        };
        // Base columns
        var columns = [
            __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.users.columnHeader1', 'firstName'),
            __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.users.columnHeader2', 'lastName')
        ];
        if (this.state.isAdminTable) {
            columns.push(__WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.users.columnHeader4', 'email'));
            columns.push(__WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.users.columnHeader10', 'userType'));
            columns.push(__WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Enum(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader8' }), 'isActive', ['Active', 'Inactive'], undefined, function (text, record, index) { return (record.isActive ? "Active" : "Inactive"); }));
        }
        else {
            // student table
            columns.push(__WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.users.columnHeader11', 'grade'));
            // always allow searching by isActive
            columns.push(__WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Enum(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader8' }), 'isActive', ['Active', 'Inactive'], undefined, function (text, record, index) { return (record.isActive ? "Active" : "Inactive"); }));
            // Only district admin will see school name
            if (this.props.User.roleID === __WEBPACK_IMPORTED_MODULE_37_src_constants_Roles__["a" /* Roles */].DistrictAdmin.id) {
                columns.push(__WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.users.columnHeader9', 'schoolName'));
            }
            columns.push(__WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.users.columnHeader3', 'iStatements', statementsLink, 'profile'));
        }
        if (!this.state.isAdminTable) {
            columns.push({
                columnProps: {
                    key: 'report',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        var reportName = record.firstName + record.lastName + '.xlsx';
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: _this.props.translate('admin.users.columnHeader8'), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_button__["a" /* default */], { shape: "circle", icon: "download", onClick: function () { return _this.getStudentReport(record.userId, reportName); } })));
                    }
                }
            });
        }
        var defaultTooltipProps = {
            mouseLeaveDelay: 0.5,
            mouseEnterDelay: 0.2
        };
        columns.push({
            columnProps: {
                key: 'password',
                align: 'center',
                width: 35,
                render: function (text, record, index) {
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__["a" /* default */], __assign({ placement: "bottom", title: _this.props.translate('admin.users.columnHeader7'), arrowPointAtCenter: true, mouseEnterDelay: true }, defaultTooltipProps),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"], { to: { pathname: changePasswordLink(text, record) } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_button__["a" /* default */], { shape: "circle", icon: "lock", disabled: (record.isCleverEnabledDistrict || record.isClassLinkEnabledDistrict) && !record.allowEditChangePassword }))));
                }
            }
        }, {
            columnProps: {
                key: 'edit',
                align: 'center',
                width: 35,
                render: function (text, record, index) {
                    var state = { previousLocation: _this.props.location.pathname };
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__["a" /* default */], __assign({ placement: "bottom", title: _this.props.translate('admin.common.editColumnHeader'), arrowPointAtCenter: true }, defaultTooltipProps),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"], { to: { pathname: editLink(text, record), state: state } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_button__["a" /* default */], { shape: "circle", icon: "edit", disabled: (record.isCleverEnabledDistrict || record.isClassLinkEnabledDistrict) && !record.allowEditChangePassword }))));
                }
            }
        });
        if (this.state.onlyClassroomUsers && this.state.classroomId) {
            // Only first name, last name, and minus button
            columns.splice(2, 4, {
                columnProps: {
                    key: 'remove',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__["a" /* default */], __assign({ placement: "bottom", title: _this.props.translate('admin.users.columnHeader5'), arrowPointAtCenter: true }, defaultTooltipProps),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_button__["a" /* default */], { shape: "circle", icon: "minus", onClick: function () { return _this.removeUserFromClassroom(record.userId, _this.state.classroomId); } })));
                    }
                }
            });
        }
        else if (this.state.classroomId) {
            // Only first name, last name, and add button
            columns.splice(2, 4, {
                columnProps: {
                    key: 'add',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__["a" /* default */], __assign({ placement: "bottom", title: _this.props.translate('admin.users.addToClass'), arrowPointAtCenter: true }, defaultTooltipProps),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_button__["a" /* default */], { shape: "circle", icon: "plus", onClick: function () { return _this.addUserToClassroom(record.userId, _this.state.classroomId); } })));
                    }
                }
            });
        }
        return columns;
    };
    Users.prototype.getDataTableButtons = function () {
        var addButtonTranslationId = this.state.isAdminTable ? "admin.users.addButton2" : "admin.users.addButton1";
        var addButton = new __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["a" /* DataTableButton */](addButtonTranslationId, this.handleRedirect);
        var resetButton = new __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["c" /* DataTableButtonReset */]();
        var downloadActiveButton = new __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["a" /* DataTableButton */]("admin.users.downloadActiveStudentsButtonText", this.handleDownloadActiveStudents);
        var downloadInactiveButton = new __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["a" /* DataTableButton */]("admin.users.downloadInActiveStudentsButtonText", this.handleDownloadInActiveStudents);
        var currentUserRole = __WEBPACK_IMPORTED_MODULE_37_src_constants_Roles__["a" /* Roles */].FindById(this.props.User.roleID);
        var isAdmin = this.state.isAdminTable;
        var isClever = this.props.User.isSsoEnabled;
        var isClassroom = this.state.classroomId > 0;
        var isInClassroom = this.state.onlyClassroomUsers;
        var hasAdd = false;
        var hasDownloadActive = false;
        var hasDownloadInactive = false;
        var hasReset = true; // There is no instance where reset is not available
        switch (currentUserRole) {
            case __WEBPACK_IMPORTED_MODULE_37_src_constants_Roles__["a" /* Roles */].KuderAdmin:
                hasAdd = true;
                hasDownloadActive = false;
                hasDownloadInactive = false;
                break;
            case __WEBPACK_IMPORTED_MODULE_37_src_constants_Roles__["a" /* Roles */].StateAdmin:
                hasAdd = true;
                hasDownloadActive = false;
                hasDownloadInactive = false;
                break;
            case __WEBPACK_IMPORTED_MODULE_37_src_constants_Roles__["a" /* Roles */].DistrictAdmin:
                if (isClever) {
                    hasAdd = isAdmin;
                    hasDownloadActive = !isAdmin;
                    hasDownloadInactive = !isAdmin;
                }
                else {
                    hasAdd = true;
                    hasDownloadActive = !isAdmin;
                    hasDownloadInactive = !isAdmin;
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_37_src_constants_Roles__["a" /* Roles */].SchoolAdmin:
                if (isClever) {
                    hasAdd = isAdmin && (isInClassroom && isClassroom || !isInClassroom && !isClassroom);
                    hasDownloadActive = !isAdmin && (isInClassroom && isClassroom || !isInClassroom && !isClassroom);
                    hasDownloadInactive = !isAdmin && (isInClassroom && isClassroom || !isInClassroom && !isClassroom);
                }
                else {
                    hasAdd = isInClassroom && isClassroom || !isInClassroom && !isClassroom;
                    hasDownloadActive = !isAdmin && (isInClassroom && isClassroom || !isInClassroom && !isClassroom);
                    hasDownloadInactive = !isAdmin && (isInClassroom && isClassroom || !isInClassroom && !isClassroom);
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_37_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin:
                if (isClever) {
                    hasAdd = false;
                    hasDownloadActive = !isAdmin && (isInClassroom && isClassroom || !isInClassroom && !isClassroom);
                    hasDownloadInactive = !isAdmin && (isInClassroom && isClassroom || !isInClassroom && !isClassroom);
                }
                else {
                    hasAdd = true;
                    hasDownloadActive = !isAdmin && (isInClassroom && isClassroom || !isInClassroom && !isClassroom);
                    hasDownloadInactive = !isAdmin && (isInClassroom && isClassroom || !isInClassroom && !isClassroom);
                }
                break;
            default:
                break;
        }
        return [
            hasAdd ? addButton : null,
            hasDownloadActive ? downloadActiveButton : null,
            hasDownloadInactive ? downloadInactiveButton : null,
            hasReset ? resetButton : null,
        ].filter(function (x) { return x; }); // This removes nulls
    };
    Users.prototype.handleDownloadActiveStudents = function () {
        window.location.href = "/" + __WEBPACK_IMPORTED_MODULE_7_src_api_UserApiController__["a" /* default */].RouteGetAllActiveInactiveStudents(true);
    };
    Users.prototype.handleDownloadInActiveStudents = function () {
        window.location.href = "/" + __WEBPACK_IMPORTED_MODULE_7_src_api_UserApiController__["a" /* default */].RouteGetAllActiveInactiveStudents(false);
    };
    Users.prototype.handleRedirect = function () {
        var redirectUrl = __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_USER, this.state.classroomId, 0, this.state.isAdminTable);
        var state = { previousLocation: this.props.location.pathname };
        this.props.history.push(redirectUrl, state);
    };
    Users.prototype.downloadMassStudentUploadTemplate = function () {
        window.location.href = "/" + __WEBPACK_IMPORTED_MODULE_7_src_api_UserApiController__["a" /* default */].RouteGetMassStudentUploadTemplate();
    };
    Users.prototype.handleBeforeUpload = function (file, fileList) {
        this.setState({ uploading: true, uploadStatus: "none", massUploadErrorMessage: "" });
        return true;
    };
    Users.prototype.handleUploadOnChange = function (info) {
        if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
            this.setState({ uploading: false, uploadMode: "" });
        }
        else {
            return;
        }
        var response = (info.file.response || {});
        // Get error from response. If it's a really bad error (500), then response will actually have a message attached to it rather than a proper response
        var error = info.file.response != null && info.file.response.message != null ? info.file.response.message : response.errorMessage;
        if (info.file.status === 'done' && response.isSuccess) {
            __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].success(info.file.name + " - " + this.props.translate('admin.users.messageUpload'));
            this.setState({
                uploadStatus: "success",
                massUploadFileName: info.file.name,
                massUploadErrorMessage: error,
                massUploadTableData: response.data
            });
            this.dataTableRef.refresh();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].error(info.file.name + " - " + this.props.translate('admin.users.messageUploadError'));
            this.setState({
                uploadStatus: "failed",
                massUploadFileName: info.file.name,
                massUploadErrorMessage: error,
                massUploadTableData: response.data
            });
        }
    };
    Users.prototype.showErrorsModal = function () {
        // Super simple method, yes, but react likes 'constant' functions like this when trying to determine if it should re-render or not
        this.setState({ showModal: true });
    };
    Users.prototype.handleModelClose = function () {
        this.setState({ showModal: false });
    };
    Users.prototype.handleUploadModeChange = function (value) {
        this.setState({
            uploadMode: value,
            uploadStatus: "none"
        });
    };
    Users.prototype.renderUploadCompleteIcon = function () {
        if (this.state.uploadStatus === "success") {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_icon__["a" /* default */], { type: "check-circle", theme: "twoTone", twoToneColor: "#52c41a" }));
        }
        if (this.state.uploadStatus === "failed") {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_button__["a" /* default */], { onClick: this.showErrorsModal },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_icon__["a" /* default */], { type: "exclamation-circle", theme: "twoTone", twoToneColor: "#c41a1a" }),
                " View Upload Errors");
        }
    };
    Users.prototype.renderMassStudentUpload = function () {
        var _this = this;
        var uploadProps = {
            name: 'file',
            showUploadList: false,
            action: "/" + __WEBPACK_IMPORTED_MODULE_7_src_api_UserApiController__["a" /* default */].RouteMassStudentUploadV2(),
            disabled: this.state.uploadMode === "",
            beforeUpload: this.handleBeforeUpload,
            onChange: this.handleUploadOnChange,
            data: { isCompleteMode: this.state.uploadMode === "complete" }
        };
        if (!this.state.isAdminTable && !this.state.classroomId && !this.props.User.isSsoEnabled) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mass-upload-buttons" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.users.massStudentUploadStep" }),
                        " 1:"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_button__["a" /* default */], { onClick: this.downloadMassStudentUploadTemplate },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_icon__["a" /* default */], { type: "download" }),
                        " ",
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.users.massStudentUploadTemplate" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.users.massStudentUploadStep" }),
                        " 2:"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.users.massStudentUploadStep2Content" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.users.massStudentUploadStep" }),
                        " 3:"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_antd_es_select__["a" /* default */], { ref: function (ref) { return _this.selectRef = ref; }, placeholder: this.props.translate('admin.users.uploadMode'), onChange: this.handleUploadModeChange, value: this.state.uploadMode, style: { width: 200 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_antd_es_select__["a" /* default */].Option, { value: "incremental" }, this.props.translate('admin.users.incremental')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_antd_es_select__["a" /* default */].Option, { value: "complete" }, this.props.translate('admin.users.complete')))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.users.massStudentUploadStep" }),
                        " 4:"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_upload__["a" /* default */], __assign({}, uploadProps),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_button__["a" /* default */], { disabled: this.state.uploadMode === "" || this.state.uploading },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_icon__["a" /* default */], { type: "upload" }),
                            " ",
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.users.massStudentUpload" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27_antd_es_spin__["a" /* default */], { spinning: this.state.uploading }),
                    this.renderUploadCompleteIcon())));
        }
    };
    Users.prototype.renderTableTitle = function () {
        var headerTranslationId = this.state.isAdminTable ?
            'admin.users.tableHeader1' : this.state.onlyClassroomUsers ?
            'admin.users.tableHeader3' :
            'admin.users.tableHeader2';
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { key: "table-title", id: headerTranslationId }));
    };
    Users.prototype.renderTextForCleverEnabledDistrict = function () {
        if (this.props.User.isSsoEnabled && !this.state.isAdminTable) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { key: "clever-text", id: "admin.users.cleverEnabledDistrictText" }));
        }
    };
    Users.prototype.render = function () {
        var _this = this;
        if (this.props.shouldRefreshTable) {
            this.dataTableRef.refresh();
            this.props.updateShouldRefreshTable();
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "admin-student" },
            this.renderTableTitle(),
            this.renderTextForCleverEnabledDistrict(),
            this.renderMassStudentUpload(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_38__UsersUploadErrorModal__["a" /* default */], { errorMessage: this.state.massUploadErrorMessage, fileName: this.state.massUploadFileName, tableData: this.state.massUploadTableData, visible: this.state.showModal, onOkay: this.handleModelClose }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'userId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: this.getDataTableButtons() })));
    };
    return Users;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_36_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(Users)));


/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Users_less__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Users_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Users_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_common_DataTable__ = __webpack_require__(58);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var UsersUploadErrorModal = /** @class */ (function (_super) {
    __extends(UsersUploadErrorModal, _super);
    function UsersUploadErrorModal(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, UsersUploadErrorModal.prototype);
        _this.state = {};
        return _this;
    }
    UsersUploadErrorModal.prototype.componentDidUpdate = function (prevProps, prevState) {
        // Force update if we are going to be visible
        if (!prevProps.visible && this.props.visible) {
            this.dataTableRef && this.dataTableRef.refresh();
        }
    };
    UsersUploadErrorModal.prototype.handleOkayClick = function () {
        this.props.onOkay && this.props.onOkay();
    };
    UsersUploadErrorModal.prototype.handleCancelClick = function () {
        // Dev Note: (11/15/20) removed onCancel since it doesn't make sense
        this.props.onOkay && this.props.onOkay();
    };
    UsersUploadErrorModal.prototype.renderValidationMessage = function () {
        if (this.props.errorMessage == null || this.props.errorMessage.length < 1) {
            return null;
        }
        var messages = this.props.errorMessage.split('\n')
            .map(function (t) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { key: t }, t); })
            .reduce(function (prev, curr) { return [prev, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null), curr]; });
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, messages);
    };
    UsersUploadErrorModal.prototype.renderStudentsDataTable = function () {
        var _this = this;
        if (this.props.tableData == null || this.props.tableData.length < 1) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, "Student Errors"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: false, tableProps: { rowKey: 'rowNumber' }, data: this.props.tableData, columns: [
                    __WEBPACK_IMPORTED_MODULE_8_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text('Row Number', 'rowNumber', 150),
                    __WEBPACK_IMPORTED_MODULE_8_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Custom('Error', 'errorMessages', undefined, function (record) {
                        if (record.errorMessages.length === 0) {
                            return null;
                        }
                        return record.errorMessages
                            .map(function (t) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { key: t }, t); })
                            .reduce(function (prev, curr) { return [prev, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null), curr]; });
                    })
                ] })));
    };
    UsersUploadErrorModal.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_modal__["a" /* default */], { maskClosable: false, width: 900, centered: true, visible: this.props.visible, onCancel: this.handleCancelClick, title: "File Validation Errors", footer: [
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_button__["a" /* default */], { type: "primary", key: "okay", onClick: this.handleOkayClick },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "common.ok" }))
            ] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, "File Name"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, this.props.fileName),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, "File Validation Error"),
            this.renderValidationMessage(),
            this.renderStudentsDataTable()));
    };
    return UsersUploadErrorModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(UsersUploadErrorModal));


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(28);

var _Event = __webpack_require__(2119);

var _Event2 = _interopRequireDefault(_Event);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styleForPesudo = void 0;

var Wave = function (_React$Component) {
    (0, _inherits3['default'])(Wave, _React$Component);

    function Wave() {
        (0, _classCallCheck3['default'])(this, Wave);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Wave.__proto__ || Object.getPrototypeOf(Wave)).apply(this, arguments));

        _this.onClick = function (node, waveColor) {
            if (node.className.indexOf('-leave') >= 0) {
                return;
            }
            var insertExtraNode = _this.props.insertExtraNode;

            _this.extraNode = document.createElement('div');
            var extraNode = _this.extraNode;
            extraNode.className = 'ant-click-animating-node';
            var attributeName = _this.getAttributeName();
            node.removeAttribute(attributeName);
            node.setAttribute(attributeName, 'true');
            // Not white or transparnt or grey
            styleForPesudo = styleForPesudo || document.createElement('style');
            if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && _this.isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
            waveColor !== 'transparent') {
                extraNode.style.borderColor = waveColor;
                styleForPesudo.innerHTML = '[ant-click-animating-without-extra-node]:after { border-color: ' + waveColor + '; }';
                if (!document.body.contains(styleForPesudo)) {
                    document.body.appendChild(styleForPesudo);
                }
            }
            if (insertExtraNode) {
                node.appendChild(extraNode);
            }
            _Event2['default'].addEndEventListener(node, _this.onTransitionEnd);
        };
        _this.bindAnimationEvent = function (node) {
            if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
                return;
            }
            var onClick = function onClick(e) {
                // Fix radio button click twice
                if (e.target.tagName === 'INPUT') {
                    return;
                }
                _this.resetEffect(node);
                // Get wave color from target
                var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
                getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
                _this.clickWaveTimeoutId = window.setTimeout(function () {
                    return _this.onClick(node, waveColor);
                }, 0);
            };
            node.addEventListener('click', onClick, true);
            return {
                cancel: function cancel() {
                    node.removeEventListener('click', onClick, true);
                }
            };
        };
        _this.onTransitionEnd = function (e) {
            if (!e || e.animationName !== 'fadeEffect') {
                return;
            }
            _this.resetEffect(e.target);
        };
        return _this;
    }

    (0, _createClass3['default'])(Wave, [{
        key: 'isNotGrey',
        value: function isNotGrey(color) {
            var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);
            if (match && match[1] && match[2] && match[3]) {
                return !(match[1] === match[2] && match[2] === match[3]);
            }
            return true;
        }
    }, {
        key: 'getAttributeName',
        value: function getAttributeName() {
            var insertExtraNode = this.props.insertExtraNode;

            return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
        }
    }, {
        key: 'resetEffect',
        value: function resetEffect(node) {
            if (!node || node === this.extraNode) {
                return;
            }
            var insertExtraNode = this.props.insertExtraNode;

            var attributeName = this.getAttributeName();
            node.removeAttribute(attributeName);
            this.removeExtraStyleNode();
            if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
                node.removeChild(this.extraNode);
            }
            _Event2['default'].removeEndEventListener(node, this.onTransitionEnd);
        }
    }, {
        key: 'removeExtraStyleNode',
        value: function removeExtraStyleNode() {
            if (styleForPesudo) {
                styleForPesudo.innerHTML = '';
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.instance = this.bindAnimationEvent((0, _reactDom.findDOMNode)(this));
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.instance) {
                this.instance.cancel();
            }
            if (this.clickWaveTimeoutId) {
                clearTimeout(this.clickWaveTimeoutId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);
    return Wave;
}(React.Component);

exports['default'] = Wave;
module.exports = exports['default'];

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(11);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(86);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _dist = __webpack_require__(570);

var allIcons = _interopRequireWildcard(_dist);

var _iconsReact = __webpack_require__(300);

var _iconsReact2 = _interopRequireDefault(_iconsReact);

var _IconFont = __webpack_require__(2120);

var _IconFont2 = _interopRequireDefault(_IconFont);

var _utils = __webpack_require__(2121);

var _warning = __webpack_require__(838);

var _warning2 = _interopRequireDefault(_warning);

var _twoTonePrimaryColor = __webpack_require__(2122);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

// Initial setting
_iconsReact2['default'].add.apply(_iconsReact2['default'], (0, _toConsumableArray3['default'])(Object.keys(allIcons).map(function (key) {
    return allIcons[key];
})));
(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
var defaultTheme = 'outlined';
var dangerousTheme = undefined;
var Icon = function Icon(props) {
    var _classNames;

    var className = props.className,
        type = props.type,
        Component = props.component,
        viewBox = props.viewBox,
        spin = props.spin,
        children = props.children,
        theme = props.theme,
        twoToneColor = props.twoToneColor,
        restProps = __rest(props, ["className", "type", "component", "viewBox", "spin", "children", "theme", "twoToneColor"]);

    (0, _warning2['default'])(Boolean(type || Component || children), 'Icon should have `type` prop or `component` prop or `children`.');
    var classString = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, 'anticon', true), (0, _defineProperty3['default'])(_classNames, 'anticon-' + type, Boolean(type)), _classNames), className);
    var svgClassString = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, 'anticon-spin', !!spin || type === 'loading'));
    var innerNode = void 0;
    // component > children > type
    if (Component) {
        var innerSvgProps = (0, _extends3['default'])({}, _utils.svgBaseProps, { className: svgClassString, viewBox: viewBox });
        if (!viewBox) {
            delete innerSvgProps.viewBox;
        }
        innerNode = React.createElement(
            Component,
            innerSvgProps,
            children
        );
    }
    if (children) {
        (0, _warning2['default'])(Boolean(viewBox) || React.Children.count(children) === 1 && React.isValidElement(children) && React.Children.only(children).type === 'use', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
        var _innerSvgProps = (0, _extends3['default'])({}, _utils.svgBaseProps, { className: svgClassString });
        innerNode = React.createElement(
            'svg',
            (0, _extends3['default'])({}, _innerSvgProps, { viewBox: viewBox }),
            children
        );
    }
    if (typeof type === 'string') {
        var computedType = type;
        if (theme) {
            var alreadyHaveTheme = (0, _utils.getThemeFromTypeName)(type);
            (0, _warning2['default'])(!alreadyHaveTheme, 'This icon already has a theme \'' + alreadyHaveTheme + '\'.' + (' The prop \'theme\' ' + theme + ' will be ignored.'));
        }
        computedType = (0, _utils.withThemeSuffix)((0, _utils.removeTypeTheme)(type), dangerousTheme || theme || defaultTheme);
        innerNode = React.createElement(_iconsReact2['default'], { className: svgClassString, type: computedType, primaryColor: twoToneColor });
    }
    return React.createElement(
        'i',
        (0, _extends3['default'])({}, restProps, { className: classString }),
        innerNode
    );
};
function unstable_ChangeThemeOfIconsDangerously(theme) {
    (0, _warning2['default'])(false, 'You are using the unstable method \'Icon.unstable_ChangeThemeOfAllIconsDangerously\', ' + ('make sure that all the icons with theme \'' + theme + '\' display correctly.'));
    dangerousTheme = theme;
}
function unstable_ChangeDefaultThemeOfIcons(theme) {
    (0, _warning2['default'])(false, 'You are using the unstable method \'Icon.unstable_ChangeDefaultThemeOfIcons\', ' + ('make sure that all the icons with theme \'' + theme + '\' display correctly.'));
    defaultTheme = theme;
}
Icon.displayName = 'Icon';
Icon.createFromIconfontCN = _IconFont2['default'];
Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
exports['default'] = Icon;
module.exports = exports['default'];

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _warning = __webpack_require__(74);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var warned = {};

exports['default'] = function (valid, message) {
    if (!valid && !warned[message]) {
        (0, _warning2['default'])(false, message);
        warned[message] = true;
    }
};

module.exports = exports['default'];

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/keyboard-press-long.b302c39e.mp3";

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_radio__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_es_radio_style_index_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_api_DistrictApiController__ = __webpack_require__(224);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

 // 'this' binder

























var AdminFullSyncReports = /** @class */ (function (_super) {
    __extends(AdminFullSyncReports, _super);
    function AdminFullSyncReports(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, AdminFullSyncReports.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            pageRedirect: false
        };
        return _this;
    }
    AdminFullSyncReports.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_26_src_api_DistrictApiController__["a" /* default */].getDistrictFullSyncTableData(requestState, this.props.districtId)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    AdminFullSyncReports.prototype.customTableColumns = function () {
        var viewLInk = function (text, record) { return __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].ADMIN_SYNC_RESULTS, record.id, record.districtId); };
        return [
            __WEBPACK_IMPORTED_MODULE_25_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.adminFullSyncReports.columnHeader1', 'districtName'),
            __WEBPACK_IMPORTED_MODULE_25_src_components_common_DataTable__["e" /* default */].StandardColumns.Date('admin.adminFullSyncReports.columnHeader2', 'startTime'),
            __WEBPACK_IMPORTED_MODULE_25_src_components_common_DataTable__["e" /* default */].StandardColumns.Date('admin.adminFullSyncReports.columnHeader3', 'endTime'),
            __WEBPACK_IMPORTED_MODULE_25_src_components_common_DataTable__["e" /* default */].StandardColumns.Number('admin.adminFullSyncReports.columnHeader4', 'numberOfSchoolsSynced'),
            __WEBPACK_IMPORTED_MODULE_25_src_components_common_DataTable__["e" /* default */].StandardColumns.Link("admin.common.emulateColumnHeader", 'search', viewLInk, 'search')
        ];
    };
    AdminFullSyncReports.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_divider__["a" /* default */], { type: "horizontal" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, this.props.translate("admin.adminFullSyncReports.fullSyncReport")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "bold-text" },
                this.props.translate("admin.addEditClient.fullSyncEndTimeStudents"),
                ": ",
                this.props.fullSyncCompletionEndDateStudents.toLocaleString()),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "bold-text" },
                this.props.translate("admin.addEditClient.fullSyncEndTimeTeachers"),
                ": ",
                this.props.fullSyncCompletionEndDateTeachers.toLocaleString()),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "bold-text" },
                this.props.translate("admin.addEditClient.lastFullSyncUpdatedBy"),
                ": ",
                this.props.lastSyncModifiedBy),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "bold-text" },
                this.props.translate("admin.addEditClient.lastFullSyncUpdatedOn"),
                ": ",
                this.props.lastSyncModifiedDate.toLocaleString()),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_src_components_common_DataTable__["e" /* default */], { serverSide: true, tableProps: { rowKey: 'id', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_25_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return AdminFullSyncReports;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["d" /* withLocalize */])(AdminFullSyncReports));


/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StateApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var StateApiController = /** @class */ (function () {
    function StateApiController() {
        // get: State/GetCountries
        this.RouteGetCountries = function () { return "State/GetCountries"; };
        // get: State/GetStates
        this.RouteGetAllStates = function () { return "State/GetStates"; };
        // get: State/GetStatesByCountry/${countryId}/${includeClientStates}
        this.RouteGetStatesByCountry = function (countryId, includeClientStates) { return "State/GetStatesByCountry/" + countryId + "/" + includeClientStates; };
    }
    StateApiController.prototype.getCountries = function (requestOptions) {
        var url = this.RouteGetCountries();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    StateApiController.prototype.getAllStates = function (requestOptions) {
        var url = this.RouteGetAllStates();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    StateApiController.prototype.getStatesByCountry = function (countryId, includeClientStates, requestOptions) {
        var url = this.RouteGetStatesByCountry(countryId, includeClientStates);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    return StateApiController;
}());

var service = new StateApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericFormItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};





var GenericFormItemInternal = /** @class */ (function (_super) {
    __extends(GenericFormItemInternal, _super);
    function GenericFormItemInternal(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, GenericFormItemInternal.prototype);
        return _this;
    }
    GenericFormItemInternal.prototype.render = function () {
        var rules = [];
        var translatedLabel;
        var children = this.props.children;
        if (this.props.visible != null && this.props.visible === false) {
            return null;
        }
        // Debugging and catch statements
        if (this.props.form == null) {
            console.warn("Form is null. Please pass in the antd form");
            return null;
        }
        if (Array.isArray(children)) {
            console.warn("Form Item children must be a single react component, not an array. Rendering first element");
            children = children[0];
        }
        // Rules
        if (this.props.required == null || this.props.required === true) {
            rules.push({ required: true, message: this.props.translate('admin.common.requiredRule') });
        }
        if (this.props.rules != null && this.props.rules.length > 0) {
            rules = __spreadArrays(rules, this.props.rules);
        }
        // Translations
        if (this.props.labelId != null && this.props.labelId.length > 0) {
            translatedLabel = this.props.translate(this.props.labelId).toString();
        }
        // Create our fancy field decorator function
        var fieldDecorator = this.props.form.getFieldDecorator(this.props.id, {
            initialValue: this.props.initialValue,
            rules: rules
        });
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, fieldDecorator(children));
    };
    return GenericFormItemInternal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/**
 * Obsolete: Please use the `FieldDecorator` component instead. It is located in the `components/common/form` folder
 */
var GenericFormItem = Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(GenericFormItemInternal);



/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_upload__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_upload_style_index_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_icon_style_index_js__ = __webpack_require__(54);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


 // 'this' binder










var ViewStatementModal = /** @class */ (function (_super) {
    __extends(ViewStatementModal, _super);
    function ViewStatementModal(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, ViewStatementModal.prototype);
        _this.state = {};
        return _this;
    }
    ViewStatementModal.prototype.onClose = function () {
        this.props.onClose && this.props.onClose();
    };
    ViewStatementModal.prototype.render = function () {
        if (this.props.statement == null) {
            return null;
        }
        var userCompletion = this.props.statement.userCompletion || {};
        var statementFiles = userCompletion.statementFiles || [];
        var fileList = statementFiles.map(function (x) {
            var newFile = undefined;
            if (x != null) {
                newFile = {
                    uid: x.id.toString(),
                    name: x.fileName,
                    status: 'done',
                    thumbUrl: x.azureFileUrl,
                };
            }
            return newFile;
        });
        var uploadProps = {
            action: "",
            // onChange: this.handleFileChange,
            beforeUpload: function (file) {
                // Stop the actual file upload process, we will do that later
                return false;
            },
            fileList: fileList,
            listType: "picture",
            multiple: true
        };
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_modal__["a" /* default */], { maskClosable: false, visible: this.props.visible, onCancel: this.onClose, footer: [
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { key: "done", onClick: this.onClose },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "common.done" })),
            ] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, this.props.statement.statementText),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null,
                    this.props.translate("public.studentStatements.notesHeader"),
                    ":"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_input__["a" /* default */].TextArea, { key: "studentNotes", rows: 3, autoComplete: "off", value: userCompletion.statementNotes }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_upload__["a" /* default */], __assign({}, uploadProps))));
    };
    return ViewStatementModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(ViewStatementModal));


/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AntFormSimple; });
/* unused harmony export AntForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormItems__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Rules__ = __webpack_require__(2156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__FormItems__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__Rules__["a"]; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var AntFormInternal = /** @class */ (function (_super) {
    __extends(AntFormInternal, _super);
    function AntFormInternal(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, AntFormInternal.prototype);
        return _this;
    }
    AntFormInternal.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        this.props.form.validateFields({ force: true }, function (errors, values) {
            // Make sure all fields are filled out
            if (!errors && _this.props.onSubmit != null) {
                _this.props.onSubmit(values);
            }
        });
    };
    AntFormInternal.prototype.internalOnChange = function (child, value) {
        var _this = this;
        var childOnChange = child.onChange;
        if (childOnChange != null) {
            childOnChange(value);
        }
        if (this.props.requireOnChangeValidation === true) {
            window.setTimeout(function () {
                _this.props.form.validateFields({ force: true });
            }, 1);
        }
    };
    AntFormInternal.prototype.internalOnBlur = function (child, value) {
        var _this = this;
        var childOnBlur = child.onBlur;
        if (childOnBlur != null) {
            childOnBlur(value);
        }
        if (this.props.requireOnChangeValidation !== true) {
            window.setTimeout(function () {
                _this.props.form.validateFields({ force: true });
            }, 1);
        }
    };
    AntFormInternal.prototype.renderChildren = function (children) {
        var _this = this;
        var arr = [];
        __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child) {
            // Escape for non-node elements (eg. pure text)
            if (!child.props) {
                return arr.push(child);
            }
            var namedChild = child;
            if (namedChild.type === __WEBPACK_IMPORTED_MODULE_4__FormItems__["a" /* AntFormItems */].Input) {
                return arr.push(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](namedChild, {
                    form: _this.props.form,
                    onChange: function (value) { return _this.internalOnChange(namedChild, value); },
                    onBlur: function (value) { return _this.internalOnBlur(namedChild, value); },
                }));
            }
            else if (namedChild.type === __WEBPACK_IMPORTED_MODULE_4__FormItems__["a" /* AntFormItems */].Custom) {
                return arr.push(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](namedChild, {
                    form: _this.props.form,
                    onChange: function (value) { return _this.internalOnChange(namedChild, value); },
                    onBlur: function (value) { return _this.internalOnBlur(namedChild, value); },
                }));
            }
            else if (namedChild.type === __WEBPACK_IMPORTED_MODULE_4__FormItems__["a" /* AntFormItems */].SubmitButton) {
                return arr.push(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](namedChild, {
                    form: _this.props.form,
                    onChange: function (value) { return _this.internalOnChange(namedChild, value); },
                    onBlur: function (value) { return _this.internalOnBlur(namedChild, value); },
                }));
                // } else if (child.type === 'div' && child.props.children) {
                //     return React.cloneElement(child, {
                //         children: this.renderChildren(child.props.children),
                //     });
            }
            else if (child.props.children) {
                return arr.push(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child, undefined, _this.renderChildren(child.props.children)));
            }
            return arr.push(child);
        });
        return arr;
    };
    AntFormInternal.prototype.render = function () {
        var hideRequiredMark = this.props.hideRequiredMark == null ? undefined : this.props.hideRequiredMark;
        var className = this.props.className == null ? undefined : this.props.className;
        var layout = this.props.layout == null ? undefined : this.props.layout;
        // Give children the form prop
        var children = this.renderChildren(this.props.children);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */], { hideRequiredMark: hideRequiredMark, onSubmit: this.onSubmit, className: className, layout: layout }, children);
    };
    return AntFormInternal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var AntFormSimple = __WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].create({
    onValuesChange: function (props, changedValues, allValues) {
        if (props.onChange != null) {
            props.onChange(changedValues);
        }
    }
})(AntFormInternal);
// Exporting everything from here, as the form is 'usually' the first to be imported, making the import statement block just a few lines shorter



/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClassroomApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var ClassroomApiController = /** @class */ (function () {
    function ClassroomApiController() {
        // post: Classroom/AddClassroom
        this.RouteAddClassroom = function () { return "Classroom/AddClassroom"; };
        // post: Classroom/UpdateClassroom
        this.RouteUpdateClassroom = function () { return "Classroom/UpdateClassroom"; };
        // post: Classroom/DeleteClassroom/${classroomId}
        this.RouteDeleteClassroom = function (classroomId) { return "Classroom/DeleteClassroom/" + classroomId; };
        // get: Classroom/GetClassroom/${classroomId}
        this.RouteGetClassroom = function (classroomId) { return "Classroom/GetClassroom/" + classroomId; };
        // post: Classroom/GetClassroomTableData
        this.RouteGetClassroomTableData = function () { return "Classroom/GetClassroomTableData"; };
    }
    ClassroomApiController.prototype.addClassroom = function (addClassroomDTO, requestOptions) {
        var url = this.RouteAddClassroom();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(addClassroomDTO, 'post', url, requestOptions);
    };
    ClassroomApiController.prototype.updateClassroom = function (updateClassroomDTO, requestOptions) {
        var url = this.RouteUpdateClassroom();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(updateClassroomDTO, 'post', url, requestOptions);
    };
    ClassroomApiController.prototype.deleteClassroom = function (classroomId, requestOptions) {
        var url = this.RouteDeleteClassroom(classroomId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    ClassroomApiController.prototype.getClassroom = function (classroomId, requestOptions) {
        var url = this.RouteGetClassroom(classroomId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    ClassroomApiController.prototype.getClassroomTableData = function (tableRequest, requestOptions) {
        var url = this.RouteGetClassroomTableData();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    return ClassroomApiController;
}());

var service = new ClassroomApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OccupationApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var OccupationApiController = /** @class */ (function () {
    function OccupationApiController() {
        // get: OccupationDb/GetOccupationDetails/${occupationId}
        this.RouteGetOccupationDetails = function (occupationId) { return "OccupationDb/GetOccupationDetails/" + occupationId; };
        // post: OccupationDb/GetOccupationsTableData
        this.RouteGetOccupationsTableData = function () { return "OccupationDb/GetOccupationsTableData"; };
    }
    OccupationApiController.prototype.getOccupationDetails = function (occupationId, requestOptions) {
        var url = this.RouteGetOccupationDetails(occupationId);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    OccupationApiController.prototype.getOccupationsTableData = function (tableRequest, requestOptions) {
        var url = this.RouteGetOccupationsTableData();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    return OccupationApiController;
}());

var service = new OccupationApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MatchmakerApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var MatchmakerApiController = /** @class */ (function () {
    function MatchmakerApiController() {
        // post: Matchmaker/GetUserDetails
        this.RouteGetUserDetails = function () { return "Matchmaker/GetUserDetails"; };
        // post: Matchmaker/MatchmakerDataUpload
        this.RouteMatchmakerDataUpload = function () { return "Matchmaker/MatchmakerDataUpload"; };
        // post: Matchmaker/GetSyncMatchmakerDataLogTableData
        this.RouteGetSyncMatchmakerDataLogTableData = function () { return "Matchmaker/GetSyncMatchmakerDataLogTableData"; };
    }
    MatchmakerApiController.prototype.getUserDetails = function (request, requestOptions) {
        var url = this.RouteGetUserDetails();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(request, 'post', url, requestOptions);
    };
    MatchmakerApiController.prototype.matchmakerDataUpload = function (requestOptions) {
        var url = this.RouteMatchmakerDataUpload();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    MatchmakerApiController.prototype.getSyncMatchmakerDataLogTableData = function (tableRequest, requestOptions) {
        var url = this.RouteGetSyncMatchmakerDataLogTableData();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(tableRequest, 'post', url, requestOptions);
    };
    return MatchmakerApiController;
}());

var service = new MatchmakerApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_LandscapingGame_scenes_GameIntro__ = __webpack_require__(852);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Landscaping Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#d3d3d3"
};
var PhaserLandscapeGame = /** @class */ (function (_super) {
    __extends(PhaserLandscapeGame, _super);
    function PhaserLandscapeGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserLandscapeGame.prototype);
        return _this;
    }
    PhaserLandscapeGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_LandscapingGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete });
    };
    return PhaserLandscapeGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserLandscapeGame);


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2206);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Landscaping;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "Landscaping.Phaser.IntroductionScene.1",
            "Landscaping.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/a.7bdeda8d.png";

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/e.3ecc435c.png";

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/intro_scene.08f64aff.json";

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/starPodAll.d21e2240.png";

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/starPodAll.1b33432a.json";

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalOptionBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PhaserModalConfigBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PhaserModalBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_constants_KeyboardNumKeys__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ModalOptionBase = /** @class */ (function () {
    function ModalOptionBase() {
    }
    return ModalOptionBase;
}());

var PhaserModalConfigBase = /** @class */ (function () {
    function PhaserModalConfigBase() {
    }
    return PhaserModalConfigBase;
}());

var PhaserModalBase = /** @class */ (function (_super) {
    __extends(PhaserModalBase, _super);
    function PhaserModalBase(scene, x, y, config) {
        var _this = _super.call(this, scene, x, y) || this;
        _this.config = config;
        return _this;
    }
    PhaserModalBase.prototype.selectOption = function (index) {
        if (index >= this.options.length) {
            return;
        }
        var op = this.options[index];
        this.emit('optionClicked', op);
        this.destroy();
    };
    PhaserModalBase.prototype.selectLastOption = function () {
        var op = this.options[this.options.length - 1];
        this.emit('optionClicked', op);
        this.destroy();
    };
    PhaserModalBase.prototype.onKeydown = function (event) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        keys.forEach(function (key) {
            _this.scene.input.keyboard.on('keydown_' + key, event);
        });
    };
    PhaserModalBase.prototype.bindNumKeys = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_0_src_constants_KeyboardNumKeys__["a" /* numKeys */].forEach(function (key) {
            _this.onKeydown(function () { _this.selectOption(key.index); }, key.keyCode, key.altKeyCode);
        });
        if (!this.config.forceResponse) {
            this.onKeydown(function () { _this.destroy(); }, 'DELETE', 'BACKSPACE', 'ESC');
        }
    };
    return PhaserModalBase;
}(Phaser.GameObjects.Container));



/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/grade_5_landscaping_1.df9f01a5.json";

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/help_icon.b47399c6.png";

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameLandscape.5f14d2e5.png";

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameLandscape.0e4f34e5.json";

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/student_spritemap-42x64.1999233c.png";

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__ = __webpack_require__(2220);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Diagnosis Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 200 }
        }
    },
    backgroundColor: "#000000",
};
var PhaserDiagnosisGame = /** @class */ (function (_super) {
    __extends(PhaserDiagnosisGame, _super);
    function PhaserDiagnosisGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserDiagnosisGame.prototype);
        return _this;
    }
    PhaserDiagnosisGame.prototype.render = function () {
        // JB: Yes, there is only a HowToPlay Scene. This is a game from the first round did not have the love the other games had
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__["a" /* HowToPlayScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserDiagnosisGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserDiagnosisGame);


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/circle.bbbd9bd2.png";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/lab_diagnosis_analyze_blood.87d7ed4e.json";

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_CollageGame_scenes_GameIntro__ = __webpack_require__(868);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Collage Game",
    version: "0.9.3",
    backgroundColor: "#000000",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 },
        }
    },
};
var PhaserCollageGame = /** @class */ (function (_super) {
    __extends(PhaserCollageGame, _super);
    function PhaserCollageGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserCollageGame.prototype);
        return _this;
    }
    // This game is different than the others, it has an interview before the HowToPlayScene and game
    PhaserCollageGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_CollageGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserCollageGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserCollageGame);


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InterviewScene__ = __webpack_require__(869);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Collage;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__InterviewScene__["a" /* InterviewScene */];
        _this.introTextKeys = [
            "Collage.Phaser.IntroductionScene.3",
            "Collage.Phaser.IntroductionScene.4",
            "Collage.Phaser.IntroductionScene.5",
            "Collage.Phaser.IntroductionScene.1",
            "Collage.Phaser.IntroductionScene.2",
            "Collage.Phaser.IntroductionScene.6",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InterviewScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainScene__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_CollageGame_scenes_IntroductionScene__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GameIntro__ = __webpack_require__(868);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var InterviewScene = /** @class */ (function (_super) {
    __extends(InterviewScene, _super);
    function InterviewScene() {
        var _this = _super.call(this, {
            key: "InterviewScene"
        }) || this;
        _this.index = 1;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "a";
        _this.gameScene = __WEBPACK_IMPORTED_MODULE_4__MainScene__["a" /* MainScene */];
        return _this;
    }
    InterviewScene.prototype.preload = function () {
        var _this = this;
        this.load.tilemapTiledJSON('interview-map', __webpack_require__(2264));
        this.load.image("studentPilot", __webpack_require__(2265));
        var keys = [
            "Collage.Phaser.Interview.1.Architect",
            "Collage.Phaser.Interview.1.Student",
            "Collage.Phaser.Interview.2.Architect",
            "Collage.Phaser.Interview.2.Student",
            "Collage.Phaser.Interview.3.Architect",
            "Collage.Phaser.Interview.3.Student",
            "Collage.Phaser.Interview.4.Architect",
            "Collage.Phaser.Interview.4.Student",
            "Collage.Phaser.Interview.5.Architect",
            "Collage.Phaser.Interview.5.Student",
            "Collage.Phaser.Interview.6.Architect",
            "Collage.Phaser.Interview.6.Student",
            "Collage.Phaser.Interview.7.Architect",
            "Collage.Phaser.Interview.7.Student",
        ];
        keys.forEach(function (key) {
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_6_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    InterviewScene.prototype.create = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, InterviewScene.prototype);
        this.index = 1;
        // Start the audio
        var studentAudio = this.sound.add("Collage.Phaser.Interview." + this.index + ".Student");
        studentAudio.play();
        var architectAudio = this.sound.add("Collage.Phaser.Interview." + this.index + ".Architect");
        architectAudio.play("", {
            delay: studentAudio.totalDuration
        });
        this.map = this.make.tilemap({ key: "interview-map" });
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.addObjects();
    };
    InterviewScene.prototype.addObjects = function () {
        var _this = this;
        var buttonConfig = {
            smartSize: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON,
            keyMapping: "keydown_RIGHT"
        };
        this.map.getObjectLayer("Layout").objects.forEach(function (ob) {
            if (ob.name === "question") {
                _this.box1 = ob;
                // One text box for the game objective and how to play instructions
                _this.studentDialog = _this.createDialogBox(ob, "Collage.Phaser.Interview." + _this.index + ".Student");
            }
            else if (ob.name === "response") {
                _this.box2 = ob;
                // One text box for the game objective and how to play instructions
                _this.architectDialog = _this.createDialogBox(ob, "Collage.Phaser.Interview." + _this.index + ".Architect");
            }
            else if (ob.name === "architect") {
                _this.architect = _this.add.image(ob.x, ob.y, "npc");
                _this.architect.setOrigin(0);
                _this.architect.setDepth(2);
                _this.architect.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "student") {
                _this.student = _this.add.image(ob.x, ob.y, "studentPilot");
                _this.student.setOrigin(0);
                _this.student.setDisplaySize(ob.width, ob.height);
                _this.student.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
            else if (ob.name === "next") {
                _this.nextButton = __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */].createQuickNextButton(_this, ob.x, ob.y);
                _this.nextButton.setX(_this.gameWidth - _this.nextButton.width - 50);
                _this.nextButton.setDepth(2);
                _this.nextButton.on('buttonClicked', function () {
                    _this.sound.stopAll();
                    if (_this.index === 7) {
                        // Now start game with the how to play scene
                        _this.input.removeAllListeners();
                        _this.scene.add("HowToPlay", __WEBPACK_IMPORTED_MODULE_5_src_games_CollageGame_scenes_IntroductionScene__["a" /* HowToPlayScene */], true);
                        _this.scene.remove(_this);
                    }
                    else {
                        // Update textboxes with next section of interview
                        _this.index++;
                        _this.updateTextboxes();
                    }
                });
            }
        });
        this.studentDialog.setY(this.student.y - this.studentDialog.displayHeight - 20);
        this.architectDialog.setY(this.architect.y - this.architectDialog.displayHeight - 20);
        this.addBackButton();
    };
    InterviewScene.prototype.updateTextboxes = function () {
        this.studentDialog.destroy();
        this.architectDialog.destroy();
        this.studentDialog = this.createDialogBox(this.box1, "Collage.Phaser.Interview." + this.index + ".Student");
        this.architectDialog = this.createDialogBox(this.box2, "Collage.Phaser.Interview." + this.index + ".Architect");
        this.studentDialog.setY(this.student.y - this.studentDialog.displayHeight - 10);
        this.architectDialog.setY(this.architect.y - this.architectDialog.displayHeight - 10);
        // Start the audio
        var studentAudio = this.sound.add("Collage.Phaser.Interview." + this.index + ".Student");
        studentAudio.play();
        var architectAudio = this.sound.add("Collage.Phaser.Interview." + this.index + ".Architect");
        architectAudio.play("", {
            delay: studentAudio.totalDuration
        });
    };
    InterviewScene.prototype.createDialogBox = function (ob, translationKey) {
        var padding = 5;
        var fontSize = 17;
        var borderWidth = 5;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("A");
        var textBox = this.add.container(ob.x, ob.y);
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10, align: "justified" };
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translationKey);
        var text = this.add.text(padding + borderWidth, padding + borderWidth, translatedText, textStyle);
        text.setWordWrapWidth(ob.width, true);
        textBox.setSize(text.width + padding + textStyle.padding, text.height + padding + textStyle.padding);
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(text);
        textBox.setDepth(2);
        return textBox;
    };
    InterviewScene.prototype.addBackButton = function () {
        var _this = this;
        this.backButton = __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */].createQuickBackButton(this, 50, this.nextButton.y);
        this.backButton.setDepth(2);
        this.backButton.on('buttonClicked', function () {
            _this.sound.stopAll();
            if (_this.index === 1) {
                _this.input.enabled = false;
                _this.scene.remove(_this);
                __WEBPACK_IMPORTED_MODULE_7__GameIntro__["a" /* GameIntroScene */].StartFromEnd = true;
                _this.scene.add("GameIntroScene", __WEBPACK_IMPORTED_MODULE_7__GameIntro__["a" /* GameIntroScene */], true);
                return;
            }
            else {
                // Update textboxes with previous section of interview
                _this.index--;
                _this.updateTextboxes();
            }
        });
    };
    return InterviewScene;
}(Phaser.Scene));



/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_JobMatchingGame_scenes_GameIntro__ = __webpack_require__(871);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var templateConfig = {
    title: "Navigation Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 400 }
        }
    },
    backgroundColor: "#000000"
};
var PhaserJobMatchingGame = /** @class */ (function (_super) {
    __extends(PhaserJobMatchingGame, _super);
    function PhaserJobMatchingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserJobMatchingGame.prototype);
        return _this;
    }
    PhaserJobMatchingGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_JobMatchingGame_scenes_GameIntro__["a" /* GameIntroScene */], config: templateConfig, onComplete: this.props.onComplete })));
    };
    return PhaserJobMatchingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserJobMatchingGame);


/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2266);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].JobMatching;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "JobMatching.Phaser.IntroductionScene.1",
            "JobMatching.Phaser.IntroductionScene.2",
            "JobMatching.Phaser.IntroductionScene.3",
            "JobMatching.Phaser.IntroductionScene.4",
            "JobMatching.Phaser.IntroductionScene.5",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HollandCode; });
var HollandCode = /** @class */ (function () {
    function HollandCode(code, actualCode, name) {
        this.code = code;
        this.actualCode = actualCode;
        this.planetDescription = name;
    }
    HollandCode.R = new HollandCode("JobMatching.Phaser.hollandCodes.R", "R", "JobMatching.Phaser.hollandCodes.descriptionR");
    HollandCode.I = new HollandCode("JobMatching.Phaser.hollandCodes.I", "I", "JobMatching.Phaser.hollandCodes.descriptionI");
    HollandCode.A = new HollandCode("JobMatching.Phaser.hollandCodes.A", "A", "JobMatching.Phaser.hollandCodes.descriptionA");
    HollandCode.S = new HollandCode("JobMatching.Phaser.hollandCodes.S", "S", "JobMatching.Phaser.hollandCodes.descriptionS");
    HollandCode.E = new HollandCode("JobMatching.Phaser.hollandCodes.E", "E", "JobMatching.Phaser.hollandCodes.descriptionE");
    HollandCode.C = new HollandCode("JobMatching.Phaser.hollandCodes.C", "C", "JobMatching.Phaser.hollandCodes.descriptionC");
    return HollandCode;
}());



/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/drawtiles.9da5f143.png";

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/smallAliens.dcc3a45f.png";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/smallAliens.0917521a.json";

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hollandCodes.13fa51d2.png";

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_ColonyGame_scenes_GameIntro__ = __webpack_require__(878);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Colony Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};
var PhaserColonyGame = /** @class */ (function (_super) {
    __extends(PhaserColonyGame, _super);
    function PhaserColonyGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserColonyGame.prototype);
        return _this;
    }
    PhaserColonyGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_ColonyGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserColonyGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserColonyGame);


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2274);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Colony;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "Colony.Phaser.IntroductionScene",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DialogOption */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__ = __webpack_require__(12);

/**
 * Represents an option in the game (a button)
 * Each option can take you to a different scene and will change what's going to happen in the game later on
 */
var DialogOption = /** @class */ (function () {
    function DialogOption() {
    }
    return DialogOption;
}());

var GameState = /** @class */ (function () {
    function GameState(character, dialogKey, options) {
        this.currentSlideID = 1;
        this.slideCharacter = character;
        this.slideDialog = __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate(dialogKey);
        this.slideOptions = options;
        this.isLoaded = false;
    }
    return GameState;
}());



/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Character; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__ = __webpack_require__(16);

var Character = /** @class */ (function () {
    function Character() {
    }
    Character.EEBOT = {
        id: "eebot",
        assetNames: ["robot1", "robot2", "robot3", "robot4"],
        color: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("E"),
        backgroundAsset: "terrain",
        scale: 1.3
    };
    Character.LIBRARIUS = {
        id: "librarius",
        assetNames: ["librarius"],
        color: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("C"),
        backgroundAsset: "terrain_c",
        scale: 0.9
    };
    Character.MAJOR_SLJEM = {
        id: "major-sljem",
        assetNames: ["mayor1", "mayor2"],
        color: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("R"),
        backgroundAsset: "terrain_r",
        scale: 1.1
    };
    Character.SQUEELO = {
        id: "squeelo",
        assetNames: ["squeelo"],
        color: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("R"),
        backgroundAsset: "terrain_r",
        scale: 0.8
    };
    Character.PBJ17 = {
        id: "pbj-17",
        assetNames: ["pbj1"],
        color: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("I"),
        backgroundAsset: "terrain_i",
        scale: 1.1
    };
    Character.TUF = {
        id: "2-tuf-2",
        assetNames: ["bandit1"],
        color: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("S"),
        backgroundAsset: "terrain_s",
        scale: 1.1
    };
    Character.CHARACTERS = [
        Character.EEBOT,
        Character.LIBRARIUS,
        Character.MAJOR_SLJEM,
        Character.SQUEELO,
        Character.PBJ17,
        Character.TUF,
    ];
    return Character;
}());



/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"dialogKey":"colonySlides.slide1.dialog","characterAssetKey":"robot1","options":[{"id":1,"nextSlideID":2,"textKey":"colonySlides.slide1.options.1"}]},{"id":2,"dialogKey":"colonySlides.slide2.dialog","characterAssetKey":"robot2","options":[{"id":1,"nextSlideID":3,"textKey":"colonySlides.slide2.options.1"},{"id":2,"nextSlideID":3,"textKey":"colonySlides.slide2.options.2"}]},{"id":3,"dialogKey":"colonySlides.slide3.dialog","characterAssetKey":"robot3","options":[{"id":1,"nextSlideID":4,"textKey":"colonySlides.slide3.options.1"}]},{"id":4,"dialogKey":"colonySlides.slide4.dialog","characterAssetKey":"robot4","options":[{"id":1,"nextSlideID":5,"textKey":"colonySlides.slide4.options.1"}]},{"id":5,"dialogKey":"colonySlides.slide5.dialog","characterAssetKey":"robot1","options":[{"id":1,"nextSlideID":6,"textKey":"colonySlides.slide5.options.1"}]},{"id":6,"dialogKey":"colonySlides.slide6.dialog","characterAssetKey":"robot2","options":[{"id":1,"nextSlideID":7,"textKey":"colonySlides.slide6.options.1"}]},{"id":7,"dialogKey":"colonySlides.slide7.dialog","characterAssetKey":"robot3","options":[{"id":1,"nextSlideID":8,"textKey":"colonySlides.slide7.options.1"}]},{"id":8,"dialogKey":"colonySlides.slide8.dialog","characterAssetKey":"robot4","options":[{"id":1,"nextSlideID":9,"textKey":"colonySlides.slide8.options.1"}]},{"id":9,"dialogKey":"colonySlides.slide9.dialog","characterAssetKey":"robot1","options":[{"id":1,"nextSlideID":10,"textKey":"colonySlides.slide9.options.1"}]},{"id":10,"dialogKey":"colonySlides.slide10.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":11,"textKey":"colonySlides.slide10.options.1"}]},{"id":11,"dialogKey":"colonySlides.slide11.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":12,"textKey":"colonySlides.slide11.options.1"},{"id":2,"nextSlideID":13,"textKey":"colonySlides.slide11.options.2"}]},{"id":12,"dialogKey":"colonySlides.slide12.dialog","characterAssetKey":"robot1","options":[{"id":1,"nextSlideID":13,"textKey":"colonySlides.slide12.options.1"}]},{"id":13,"dialogKey":"colonySlides.slide13.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":14,"textKey":"colonySlides.slide13.options.1"},{"id":2,"nextSlideID":15,"textKey":"colonySlides.slide13.options.2"}]},{"id":14,"dialogKey":"colonySlides.slide14.dialog","characterAssetKey":"robot2","options":[{"id":1,"nextSlideID":15,"textKey":"colonySlides.slide14.options.1"}]},{"id":15,"dialogKey":"colonySlides.slide15.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":17,"textKey":"colonySlides.slide15.options.1"},{"id":2,"nextSlideID":16,"textKey":"colonySlides.slide15.options.2"}]},{"id":16,"dialogKey":"colonySlides.slide16.dialog","characterAssetKey":"robot3","options":[{"id":1,"nextSlideID":17,"textKey":"colonySlides.slide16.options.1"}]},{"id":17,"dialogKey":"colonySlides.slide17.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":18,"textKey":"colonySlides.slide17.options.1"},{"id":2,"nextSlideID":19,"textKey":"colonySlides.slide17.options.2"}]},{"id":18,"dialogKey":"colonySlides.slide18.dialog","characterAssetKey":"robot4","options":[{"id":1,"nextSlideID":19,"textKey":"colonySlides.slide18.options.1"}]},{"id":19,"dialogKey":"colonySlides.slide19.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":20,"textKey":"colonySlides.slide19.options.1"}]},{"id":20,"dialogKey":"colonySlides.slide20.dialog","characterAssetKey":"robot1","options":[{"id":1,"nextSlideID":21,"textKey":"colonySlides.slide20.options.1"},{"id":2,"nextSlideID":22,"textKey":"colonySlides.slide20.options.2"}]},{"id":21,"dialogKey":"colonySlides.slide21.dialog","characterAssetKey":"robot2","options":[{"id":1,"nextSlideID":22,"textKey":"colonySlides.slide21.options.1"}]},{"id":22,"dialogKey":"colonySlides.slide22.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":23,"textKey":"colonySlides.slide22.options.1"}]},{"id":23,"dialogKey":"colonySlides.slide23.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":24,"textKey":"colonySlides.slide23.options.1"},{"id":2,"nextSlideID":25,"textKey":"colonySlides.slide23.options.2"}]},{"id":24,"dialogKey":"colonySlides.slide24.dialog","characterAssetKey":"robot3","options":[{"id":1,"nextSlideID":23,"textKey":"colonySlides.slide24.options.1"}]},{"id":25,"dialogKey":"colonySlides.slide25.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":26,"textKey":"colonySlides.slide25.options.1"},{"id":2,"nextSlideID":27,"textKey":"colonySlides.slide25.options.2"}]},{"id":26,"dialogKey":"colonySlides.slide26.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":27,"textKey":"colonySlides.slide26.options.1"}]},{"id":27,"dialogKey":"colonySlides.slide27.dialog","characterAssetKey":"librarius","options":[{"id":1,"nextSlideID":28,"textKey":"colonySlides.slide27.options.1"},{"id":2,"nextSlideID":29,"textKey":"colonySlides.slide27.options.2"}]},{"id":28,"dialogKey":"colonySlides.slide28.dialog","characterAssetKey":"robot1","options":[{"id":1,"nextSlideID":29,"textKey":"colonySlides.slide28.options.1"}]},{"id":29,"dialogKey":"colonySlides.slide29.dialog","characterAssetKey":"robot2","options":[{"id":1,"nextSlideID":30,"textKey":"colonySlides.slide29.options.1"},{"id":2,"nextSlideID":31,"textKey":"colonySlides.slide29.options.2"}]},{"id":30,"dialogKey":"colonySlides.slide30.dialog","characterAssetKey":"robot3","options":[{"id":1,"nextSlideID":31,"textKey":"colonySlides.slide30.options.1"}]},{"id":31,"dialogKey":"colonySlides.slide31.dialog","characterAssetKey":"robot4","options":[{"id":1,"nextSlideID":32,"textKey":"colonySlides.slide31.options.1"}]},{"id":32,"dialogKey":"colonySlides.slide32.dialog","characterAssetKey":"mayor1","options":[{"id":1,"nextSlideID":33,"textKey":"colonySlides.slide32.options.1"}]},{"id":33,"dialogKey":"colonySlides.slide33.dialog","characterAssetKey":"mayor1","options":[{"id":1,"nextSlideID":34,"textKey":"colonySlides.slide33.options.1"}]},{"id":34,"dialogKey":"colonySlides.slide34.dialog","characterAssetKey":"mayor1","options":[{"id":1,"nextSlideID":35,"textKey":"colonySlides.slide34.options.1"},{"id":2,"nextSlideID":36,"textKey":"colonySlides.slide34.options.2"}]},{"id":35,"dialogKey":"colonySlides.slide35.dialog","characterAssetKey":"robot1","options":[{"id":1,"nextSlideID":36,"textKey":"colonySlides.slide35.options.1"}]},{"id":36,"dialogKey":"colonySlides.slide36.dialog","characterAssetKey":"robot2","options":[{"id":1,"nextSlideID":37,"textKey":"colonySlides.slide36.options.1"}]},{"id":37,"dialogKey":"colonySlides.slide37.dialog","characterAssetKey":"mayor2","options":[{"id":1,"nextSlideID":38,"textKey":"colonySlides.slide37.options.1"},{"id":2,"nextSlideID":40,"textKey":"colonySlides.slide37.options.2"}]},{"id":38,"dialogKey":"colonySlides.slide38.dialog","characterAssetKey":"robot3","options":[{"id":1,"nextSlideID":39,"textKey":"colonySlides.slide38.options.1"}]},{"id":39,"dialogKey":"colonySlides.slide39.dialog","characterAssetKey":"squeelo","options":[{"id":1,"nextSlideID":40,"textKey":"colonySlides.slide39.options.1"}]},{"id":40,"dialogKey":"colonySlides.slide40.dialog","characterAssetKey":"squeelo","options":[{"id":1,"nextSlideID":41,"textKey":"colonySlides.slide40.options.1"}]},{"id":41,"dialogKey":"colonySlides.slide41.dialog","characterAssetKey":"squeelo","options":[{"id":1,"nextSlideID":42,"textKey":"colonySlides.slide41.options.1"}]},{"id":42,"dialogKey":"colonySlides.slide42.dialog","characterAssetKey":"squeelo","options":[{"id":1,"nextSlideID":43,"textKey":"colonySlides.slide42.options.1"},{"id":2,"nextSlideID":44,"textKey":"colonySlides.slide42.options.2"}]},{"id":43,"dialogKey":"colonySlides.slide43.dialog","characterAssetKey":"robot4","options":[{"id":1,"nextSlideID":44,"textKey":"colonySlides.slide43.options.1"}]},{"id":44,"dialogKey":"colonySlides.slide44.dialog","characterAssetKey":"squeelo","options":[{"id":1,"nextSlideID":46,"textKey":"colonySlides.slide44.options.1"},{"id":2,"nextSlideID":45,"textKey":"colonySlides.slide44.options.2"}]},{"id":45,"dialogKey":"colonySlides.slide45.dialog","characterAssetKey":"robot1","options":[{"id":1,"nextSlideID":46,"textKey":"colonySlides.slide45.options.1"}]},{"id":46,"dialogKey":"colonySlides.slide46.dialog","characterAssetKey":"robot2","options":[{"id":1,"nextSlideID":47,"textKey":"colonySlides.slide46.options.1"},{"id":2,"nextSlideID":48,"textKey":"colonySlides.slide46.options.2"}]},{"id":47,"dialogKey":"colonySlides.slide47.dialog","characterAssetKey":"robot3","options":[{"id":1,"nextSlideID":46,"textKey":"colonySlides.slide47.options.1"}]},{"id":48,"dialogKey":"colonySlides.slide48.dialog","characterAssetKey":"squeelo","options":[{"id":1,"nextSlideID":49,"textKey":"colonySlides.slide48.options.1"}]},{"id":49,"dialogKey":"colonySlides.slide49.dialog","characterAssetKey":"pbj1","options":[{"id":1,"nextSlideID":50,"textKey":"colonySlides.slide49.options.1"},{"id":2,"nextSlideID":51,"textKey":"colonySlides.slide49.options.2"}]},{"id":50,"dialogKey":"colonySlides.slide50.dialog","characterAssetKey":"pbj1","options":[{"id":1,"nextSlideID":51,"textKey":"colonySlides.slide50.options.1"}]},{"id":51,"dialogKey":"colonySlides.slide51.dialog","characterAssetKey":"pbj1","options":[{"id":1,"nextSlideID":52,"textKey":"colonySlides.slide51.options.1"}]},{"id":52,"dialogKey":"colonySlides.slide52.dialog","characterAssetKey":"pbj1","options":[{"id":1,"nextSlideID":53,"textKey":"colonySlides.slide52.options.1"},{"id":2,"nextSlideID":53,"textKey":"colonySlides.slide52.options.2"}]},{"id":53,"dialogKey":"colonySlides.slide53.dialog","characterAssetKey":"pbj1","options":[{"id":1,"nextSlideID":54,"textKey":"colonySlides.slide53.options.1"}]},{"id":54,"dialogKey":"colonySlides.slide54.dialog","characterAssetKey":"pbj1","options":[{"id":1,"nextSlideID":55,"textKey":"colonySlides.slide54.options.1"}]},{"id":55,"dialogKey":"colonySlides.slide55.dialog","characterAssetKey":"pbj1","options":[{"id":1,"nextSlideID":56,"textKey":"colonySlides.slide55.options.1"}]},{"id":56,"dialogKey":"colonySlides.slide56.dialog","characterAssetKey":"pbj1","options":[{"id":1,"nextSlideID":57,"textKey":"colonySlides.slide56.options.1"}]},{"id":57,"dialogKey":"colonySlides.slide57.dialog","characterAssetKey":"pbj1","options":[{"id":1,"nextSlideID":58,"textKey":"colonySlides.slide57.options.1"}]},{"id":58,"dialogKey":"colonySlides.slide58.dialog","characterAssetKey":"robot1","options":[{"id":1,"nextSlideID":59,"textKey":"colonySlides.slide58.options.1"},{"id":2,"nextSlideID":59,"textKey":"colonySlides.slide58.options.2"}]},{"id":59,"dialogKey":"colonySlides.slide59.dialog","characterAssetKey":"robot2","options":[{"id":1,"nextSlideID":60,"textKey":"colonySlides.slide59.options.1"}]},{"id":60,"dialogKey":"colonySlides.slide60.dialog","characterAssetKey":"bandit1","options":[{"id":1,"nextSlideID":61,"textKey":"colonySlides.slide60.options.1"},{"id":2,"nextSlideID":61,"textKey":"colonySlides.slide60.options.2"}]},{"id":61,"dialogKey":"colonySlides.slide61.dialog","characterAssetKey":"robot3","options":[{"id":1,"nextSlideID":62,"textKey":"colonySlides.slide61.options.1"}]},{"id":62,"dialogKey":"colonySlides.slide62.dialog","characterAssetKey":"bandit1","options":[{"id":1,"nextSlideID":63,"textKey":"colonySlides.slide62.options.1"}]},{"id":63,"dialogKey":"colonySlides.slide63.dialog","characterAssetKey":"bandit1","options":[{"id":1,"nextSlideID":64,"textKey":"colonySlides.slide63.options.1"}]},{"id":64,"dialogKey":"colonySlides.slide64.dialog","characterAssetKey":"bandit1","options":[{"id":1,"nextSlideID":66,"textKey":"colonySlides.slide64.options.1"},{"id":2,"nextSlideID":65,"textKey":"colonySlides.slide64.options.2"}]},{"id":65,"dialogKey":"colonySlides.slide65.dialog","characterAssetKey":"bandit1","options":[{"id":1,"nextSlideID":66,"textKey":"colonySlides.slide65.options.1"}]},{"id":66,"dialogKey":"colonySlides.slide66.dialog","characterAssetKey":"bandit1","options":[{"id":1,"nextSlideID":67,"textKey":"colonySlides.slide66.options.1"},{"id":2,"nextSlideID":68,"textKey":"colonySlides.slide66.options.2"}]},{"id":67,"dialogKey":"colonySlides.slide67.dialog","characterAssetKey":"bandit1","options":[{"id":1,"nextSlideID":68,"textKey":"colonySlides.slide67.options.1"}]},{"id":68,"dialogKey":"colonySlides.slide68.dialog","characterAssetKey":"bandit1","options":[{"id":1,"nextSlideID":69,"textKey":"colonySlides.slide68.options.1"}]},{"id":69,"dialogKey":"colonySlides.slide69.dialog","characterAssetKey":"bandit1","options":[{"id":1,"nextSlideID":70,"textKey":"colonySlides.slide69.options.1"}]},{"id":70,"dialogKey":"colonySlides.slide70.dialog","characterAssetKey":"bandit1","options":[{"id":1,"nextSlideID":71,"textKey":"colonySlides.slide70.options.1"},{"id":2,"nextSlideID":71,"textKey":"colonySlides.slide70.options.2"}]},{"id":71,"dialogKey":"colonySlides.slide71.dialog","characterAssetKey":"robot1","options":[{"id":1,"nextSlideID":72,"textKey":"colonySlides.slide71.options.1"},{"id":2,"nextSlideID":72,"textKey":"colonySlides.slide71.options.2"}]},{"id":72,"dialogKey":"colonySlides.slide72.dialog","characterAssetKey":"robot2","options":[{"id":1,"nextSlideID":73,"textKey":"colonySlides.slide72.options.1"},{"id":2,"nextSlideID":73,"textKey":"colonySlides.slide72.options.2"}]},{"id":73,"dialogKey":"colonySlides.slide73.dialog","characterAssetKey":"robot3","options":[{"id":1,"nextSlideID":74,"textKey":"colonySlides.slide73.options.1"}]},{"id":74,"dialogKey":"colonySlides.slide74.dialog","characterAssetKey":"robot4","options":[{"id":1,"nextSlideID":null,"textKey":"colonySlides.slide74.options.1"}]}]

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_PuzzleSlider_scenes_GameIntro__ = __webpack_require__(883);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Sliding Puzzle Demo - Phaser",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserPuzzleSlider = /** @class */ (function (_super) {
    __extends(PhaserPuzzleSlider, _super);
    function PhaserPuzzleSlider(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserPuzzleSlider.prototype);
        return _this;
    }
    PhaserPuzzleSlider.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_PuzzleSlider_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserPuzzleSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserPuzzleSlider);


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2284);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].PuzzleSlider;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "PuzzleSlider.Phaser.IntroductionScene.1",
            "PuzzleSlider.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/white.24e3572b.png";

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_PlumbingGame_scenes_GameIntro__ = __webpack_require__(886);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Plumbing Game",
    version: "0.9.3",
    backgroundColor: "#000000",
    "render.pixelArt": false,
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 400 }
        }
    },
};
var PhaserPlumbingGame = /** @class */ (function (_super) {
    __extends(PhaserPlumbingGame, _super);
    function PhaserPlumbingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserPlumbingGame.prototype);
        return _this;
    }
    PhaserPlumbingGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_PlumbingGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserPlumbingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserPlumbingGame);


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2286);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Plumbing;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "Plumbing.Phaser.IntroductionScene.1",
            "Plumbing.Phaser.IntroductionScene.2",
            "Plumbing.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/student_spritemap-64x96.31134e3d.png";

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_UniversityGame_scenes_GameIntro__ = __webpack_require__(889);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var phaserConfig = {
    title: "Planet I: Grade 4 University Game",
    version: "1.1",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000",
    "render.pixelArt": true // 'Anti-Aliasing' when off
};
var PhaserUniversityGame = /** @class */ (function (_super) {
    __extends(PhaserUniversityGame, _super);
    function PhaserUniversityGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserUniversityGame.prototype);
        return _this;
    }
    PhaserUniversityGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_UniversityGame_scenes_GameIntro__["a" /* GameIntroScene */], config: phaserConfig, onComplete: this.props.onComplete })));
    };
    return PhaserUniversityGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserUniversityGame);


/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2296);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].University;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "University.Phaser.IntroductionScene.1",
            "University.Phaser.IntroductionScene.2",
            "University.Phaser.IntroductionScene.3",
            "University.Phaser.IntroductionScene.4",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/student_spritemap.66cb9179.png";

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_PaintGame_scenes_GameIntro__ = __webpack_require__(892);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Painting Game",
    version: "0.9.0",
    backgroundColor: "#000000",
    "render.pixelArt": true
};
var PhaserPaintGame = /** @class */ (function (_super) {
    __extends(PhaserPaintGame, _super);
    function PhaserPaintGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserPaintGame.prototype);
        return _this;
    }
    PhaserPaintGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_PaintGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserPaintGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserPaintGame);


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2307);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Paint;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "Paint.Phaser.IntroductionScene.1",
            "Paint.Phaser.IntroductionScene.2",
            "Paint.Phaser.IntroductionScene.3",
            "Paint.Phaser.IntroductionScene.4",
            "Paint.Phaser.IntroductionScene.5",
            "Paint.Phaser.IntroductionScene.6",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(894);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var templateConfig = {
    title: "Navigation Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000"
};
var PhaserDinerGame = /** @class */ (function (_super) {
    __extends(PhaserDinerGame, _super);
    function PhaserDinerGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserDinerGame.prototype);
        return _this;
    }
    PhaserDinerGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: templateConfig, onComplete: this.props.onComplete })));
    };
    return PhaserDinerGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserDinerGame);


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2319);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Diner;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "Diner.Phaser.IntroductionScene.1",
            "Diner.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/star.532e2138.png";

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_CareerFairGame_scenes_GameIntro__ = __webpack_require__(897);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var templateConfig = {
    title: "Career Fair Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 400 }
        }
    },
    backgroundColor: "#000000",
    "render.pixelArt": true // 'Anti-Aliasing' when off
};
var PhaserCareerFairGame = /** @class */ (function (_super) {
    __extends(PhaserCareerFairGame, _super);
    function PhaserCareerFairGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserCareerFairGame.prototype);
        return _this;
    }
    PhaserCareerFairGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_CareerFairGame_scenes_GameIntro__["a" /* GameIntroScene */], config: templateConfig, onComplete: this.props.onComplete })));
    };
    return PhaserCareerFairGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserCareerFairGame);


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2333);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].CareerFair;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "CareerFair.Phaser.IntroductionScene.1",
            "CareerFair.Phaser.IntroductionScene.2",
            "CareerFair.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NPCResponse */
/* unused harmony export InterviewDialogue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Career; });
var NPCResponse = /** @class */ (function () {
    function NPCResponse(text, isCorrect) {
        this.text = text;
        this.isCorrect = isCorrect;
    }
    return NPCResponse;
}());

var InterviewDialogue = /** @class */ (function () {
    function InterviewDialogue(question, responses) {
        this.question = question;
        this.responses = responses;
    }
    return InterviewDialogue;
}());

var Career = /** @class */ (function () {
    function Career(id, title, boothText, interviewDialog) {
        this.id = id;
        this.title = title;
        this.boothText = boothText;
        this.interviewDialog = interviewDialog;
    }
    /**
     * Using translation keys instead of strings
     */
    Career.CAREERS = [
        new Career("telemarketer", "CareerFair.Phaser.Careers.1.title", "CareerFair.Phaser.Careers.1.boothText", [
            new InterviewDialogue("CareerFair.Phaser.Careers.1.question1", [
                new NPCResponse("CareerFair.Phaser.Careers.1.responses1.1", true),
                new NPCResponse("CareerFair.Phaser.Careers.1.responses1.2", false),
                new NPCResponse("CareerFair.Phaser.Careers.1.responses1.3", null),
            ]),
            new InterviewDialogue("CareerFair.Phaser.Careers.1.question2", [
                new NPCResponse("CareerFair.Phaser.Careers.1.responses2.1", true),
                new NPCResponse("CareerFair.Phaser.Careers.1.responses2.2", false),
                new NPCResponse("CareerFair.Phaser.Careers.1.responses2.3", null),
            ]),
        ]),
        new Career("it_project_manager", "CareerFair.Phaser.Careers.2.title", "CareerFair.Phaser.Careers.2.boothText", [
            new InterviewDialogue("CareerFair.Phaser.Careers.2.question1", [
                new NPCResponse("CareerFair.Phaser.Careers.2.responses1.1", true),
                new NPCResponse("CareerFair.Phaser.Careers.2.responses1.2", false),
                new NPCResponse("CareerFair.Phaser.Careers.2.responses1.3", null),
            ]),
            new InterviewDialogue("CareerFair.Phaser.Careers.2.question2", [
                new NPCResponse("CareerFair.Phaser.Careers.2.responses2.1", false),
                new NPCResponse("CareerFair.Phaser.Careers.2.responses2.2", true),
                new NPCResponse("CareerFair.Phaser.Careers.2.responses2.3", null),
            ]),
        ]), new Career("public_relations", "CareerFair.Phaser.Careers.3.title", "CareerFair.Phaser.Careers.3.boothText", [
            new InterviewDialogue("CareerFair.Phaser.Careers.3.question1", [
                new NPCResponse("CareerFair.Phaser.Careers.3.responses1.1", false),
                new NPCResponse("CareerFair.Phaser.Careers.3.responses1.2", true),
                new NPCResponse("CareerFair.Phaser.Careers.3.responses1.3", null),
            ]),
            new InterviewDialogue("CareerFair.Phaser.Careers.3.question2", [
                new NPCResponse("CareerFair.Phaser.Careers.3.responses2.1", true),
                new NPCResponse("CareerFair.Phaser.Careers.3.responses2.2", false),
                new NPCResponse("CareerFair.Phaser.Careers.3.responses2.3", null),
            ]),
        ]), new Career("construction_manager", "CareerFair.Phaser.Careers.4.title", "CareerFair.Phaser.Careers.4.boothText", [
            new InterviewDialogue("CareerFair.Phaser.Careers.4.question1", [
                new NPCResponse("CareerFair.Phaser.Careers.4.responses1.1", true),
                new NPCResponse("CareerFair.Phaser.Careers.4.responses1.2", false),
                new NPCResponse("CareerFair.Phaser.Careers.4.responses1.3", null),
            ]),
            new InterviewDialogue("CareerFair.Phaser.Careers.4.question2", [
                new NPCResponse("CareerFair.Phaser.Careers.4.responses2.1", false),
                new NPCResponse("CareerFair.Phaser.Careers.4.responses2.2", true),
                new NPCResponse("CareerFair.Phaser.Careers.4.responses2.3", null),
            ]),
        ]),
    ];
    return Career;
}());



/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalTitleOption */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PhaserModalTitleConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhaserModalTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_PhaserModalBase__ = __webpack_require__(858);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ModalTitleOption = /** @class */ (function (_super) {
    __extends(ModalTitleOption, _super);
    function ModalTitleOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModalTitleOption;
}(__WEBPACK_IMPORTED_MODULE_5__components_common_PhaserModalBase__["a" /* ModalOptionBase */]));

var PhaserModalTitleConfig = /** @class */ (function (_super) {
    __extends(PhaserModalTitleConfig, _super);
    function PhaserModalTitleConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonWidth = 200;
        _this.buttonConfig = new __WEBPACK_IMPORTED_MODULE_1__Button__["b" /* PhaserButtonConfig */]();
        return _this;
    }
    return PhaserModalTitleConfig;
}(__WEBPACK_IMPORTED_MODULE_5__components_common_PhaserModalBase__["c" /* PhaserModalConfigBase */]));

var PhaserModalTitle = /** @class */ (function (_super) {
    __extends(PhaserModalTitle, _super);
    function PhaserModalTitle(scene, x, y, config, options) {
        var _this = _super.call(this, scene, x, y, config) || this;
        _this.columns = false;
        _this.padding = 20;
        _this.options = options;
        _this.config = config;
        if (config == null) {
            _this.config = new PhaserModalTitleConfig();
        }
        _this.buttonHeight = 30;
        _this.config.buttonConfig.backgroundColor = __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserModalTitle.prototype);
        _this.initialize();
        _this.setScrollFactor(0);
        return _this;
    }
    PhaserModalTitle.preload = function (scene) {
        scene.load.image("pixel", __webpack_require__(60));
    };
    PhaserModalTitle.prototype.initialize = function () {
        var height;
        var width;
        if (this.config.title != null && this.config.bodyText != null) {
            this.createTitle();
            this.createBodyText();
            height = this.bodyText.getBottomLeft().y + (this.buttonHeight + this.padding) * (this.options.length + 1);
            width = 800;
        }
        else {
            height = this.buttonHeight * (this.options.length + 2);
            width = this.config.buttonWidth * 2;
        }
        this.setSize(width, height);
        // Construct Objects
        this.constructObjects();
        this.type = "PhaserModal";
        // Add this modal to the scene
        this.scene.add.existing(this);
    };
    /**
     * Adjusts the modal's size based on the sizes of the title and buttons within
     * Also adjusts to two columns if needed.
     */
    PhaserModalTitle.prototype.adjustModalSizeBasedOnItems = function () {
        var height;
        var width;
        // Set height and width to be sufficient to hold all options (assuming one column)
        if (this.config.title != null) {
            var optionSpace;
            if (this.options.length === 1) {
                optionSpace = Math.min(this.title.height, this.buttonHeight * 3) + this.padding / 2;
            }
            else {
                optionSpace = (this.buttonHeight + this.padding) * (this.options.length + 1);
            }
            height = this.bodyText.getBottomLeft().y + optionSpace + 2 * this.padding;
            width = Math.max(this.config.buttonWidth * 3, this.bodyText.width);
        }
        else {
            height = (this.buttonHeight + this.padding) * (this.options.length + 2);
            width = this.config.buttonWidth * 3;
        }
        this.setSize(width, height);
        // Now reset background and title positions and sizes
        this.border.setDisplaySize(this.width, this.height);
        this.background.setDisplaySize(this.width - this.padding, this.height - this.padding);
        if (this.config.title != null) {
            this.title.setWordWrapWidth(width - 2 * this.padding, true);
            this.title.setX(width / 2 - this.title.width / 2);
            this.bodyText.setWordWrapWidth(width - 2 * this.padding, true);
        }
    };
    /**
     * Create the buttons and at the same time keep track of the maximum buttonHeight
    */
    PhaserModalTitle.prototype.createButtons = function () {
        var _this = this;
        var buttons = [];
        this.options.forEach(function (op) {
            var button = new __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* PhaserButton */](_this.scene, 0, 0, _this.config.buttonWidth, _this.buttonHeight, op.displayText, _this.config.buttonConfig);
            if (button.getIdealButtonHeight() >= _this.buttonHeight) {
                _this.buttonHeight = button.getIdealButtonHeight();
            }
            button.on('buttonClicked', function (pointer, x, y) {
                if (_this.scene.sound != null) {
                    _this.scene.sound.stopAll();
                }
                _this.emit('optionClicked', op, button);
            });
            buttons.push(button);
        });
        return buttons;
    };
    /**
    * Go through already created buttons and adjust their sizes and positions (because now we will use the correct buttonHeight)
    */
    PhaserModalTitle.prototype.adjustButtons = function () {
        var _this = this;
        var y;
        if (this.config.title != null && this.config.bodyText != null) {
            y = this.bodyText.getBottomLeft().y;
        }
        else if (this.config.title != null) {
            y = this.title.getBottomLeft().y;
        }
        else if (this.config.bodyText != null) {
            y = this.bodyText.getBottomLeft().y;
        }
        else {
            y = this.buttonHeight + this.padding;
        }
        var buttonIndex = 0;
        this.buttons.forEach(function (button) {
            var buttonX = _this.getXCoordinate(buttonIndex, button);
            // Restart y value for second column
            if (_this.columns && buttonIndex === Math.ceil(_this.options.length / 2)) {
                if (_this.config.title != null) {
                    y = _this.title.getBottomLeft().y;
                }
                else {
                    y = _this.buttonHeight + _this.padding;
                }
            }
            // Adjust position
            button.setPosition(buttonX, y);
            button.setDisplaySize(_this.config.buttonWidth, _this.buttonHeight);
            button.height = _this.buttonHeight;
            _this.add(button);
            y += _this.buttonHeight + _this.padding;
            buttonIndex++;
        });
    };
    /**
    *  Helper method to get the x coordinate for the button based on if there are columns or not
    */
    PhaserModalTitle.prototype.getXCoordinate = function (buttonIndex, button) {
        var buttonX;
        // First column
        if (this.columns && buttonIndex < Math.ceil(this.options.length / 2)) {
            buttonX = this.width / 4 - this.config.buttonWidth / 4;
        }
        // Second column
        else if (this.columns && buttonIndex >= Math.ceil(this.options.length / 2)) {
            buttonX = this.config.buttonWidth + this.padding + this.width / 4 - button.width / 4;
        }
        // No columns (in the middle)
        else {
            buttonX = this.width / 2 - this.config.buttonWidth / 2;
        }
        return buttonX;
    };
    PhaserModalTitle.prototype.constructObjects = function () {
        this.border = this.scene.add.image(-this.padding / 2, -this.padding / 2, "pixel");
        this.border.setOrigin(0);
        this.border.setTint(this.config.borderColor);
        this.border.setDisplaySize(this.width, this.height);
        this.add(this.border);
        // Background of the modal
        this.background = this.scene.add.image(0, 0, "pixel");
        this.background.setOrigin(0);
        this.background.setDisplaySize(this.width - this.padding, this.height - this.padding);
        this.background.setTint(0x000000);
        this.add(this.background);
        // Size has changed so adjust text positioning
        if (this.config.title != null) {
            this.title.setWordWrapWidth(this.width - 2 * this.padding, true);
            this.title.setX((this.width - this.padding / 2) / 2 - this.title.width / 2);
            this.add(this.title);
        }
        if (this.config.bodyText != null) {
            this.bodyText.setWordWrapWidth(this.width - 2 * this.padding, true);
            this.bodyText.setX(0);
            this.add(this.bodyText);
        }
        this.buttons = this.createButtons();
        // Reset the modal size because buttonHeight was adjusted
        this.adjustModalSizeBasedOnItems();
        // Reset button positions and sizes
        this.adjustButtons();
    };
    PhaserModalTitle.prototype.createTitle = function () {
        this.title = this.scene.add.text(0, 0, this.config.title);
        this.title.setOrigin(0, 0);
        this.title.setTint(0xffffff);
        this.title.setFontSize(24);
        this.title.setFontFamily('Russo One, Roboto Mono, Arial');
        this.title.setPadding(15, 15, 15, 15);
        this.title.setAlign('center');
        this.title.setWordWrapWidth(this.width, true);
        this.title.setX(this.width / 2 - this.title.width / 2);
    };
    PhaserModalTitle.prototype.createBodyText = function () {
        this.bodyText = this.scene.add.text(0, 0, this.config.bodyText);
        this.bodyText.setOrigin(0, 0);
        this.bodyText.setTint(0xffffff);
        this.bodyText.setFontSize(20);
        this.bodyText.setFontFamily('Russo One, Roboto Mono, Arial');
        this.bodyText.setPadding(20, 20, 20, 20);
        this.bodyText.setAlign('center');
        this.bodyText.setWordWrapWidth(this.width, true);
        this.bodyText.setX(this.width / 2);
        this.bodyText.setY(this.title.getBottomLeft().y + this.padding / 2);
    };
    return PhaserModalTitle;
}(__WEBPACK_IMPORTED_MODULE_5__components_common_PhaserModalBase__["b" /* PhaserModalBase */]));



/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/exclamation-point-icon.17a4e289.png";

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_OrganizeDeskGame_scenes_GameIntro__ = __webpack_require__(902);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Desk Cleaning Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 200 }
        }
    },
    backgroundColor: "#000000",
};
var PhaserOrganizeDeskGame = /** @class */ (function (_super) {
    __extends(PhaserOrganizeDeskGame, _super);
    function PhaserOrganizeDeskGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserOrganizeDeskGame.prototype);
        return _this;
    }
    PhaserOrganizeDeskGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_OrganizeDeskGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserOrganizeDeskGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserOrganizeDeskGame);


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2343);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].OrganizeDesk;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "OrganizeDesk.Phaser.IntroductionScene.1",
            "OrganizeDesk.Phaser.IntroductionScene.2",
            "OrganizeDesk.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DropZoneConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropZone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropZoneUtil__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropZoneUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DropZoneUtil__);
/* unused harmony reexport DropZoneType */
/* unused harmony reexport TiledDropZone */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var DropZoneConfig = /** @class */ (function () {
    function DropZoneConfig() {
        this.width = 64;
        this.height = 64;
        this.backgroundTexture = null;
        this.backgroundFrame = null;
        // Default is no hotspot outline (lineColor), grey outline for dragLineColor (correct drop zone), and no outline for droppedLineColor
        this.showBorder = true;
        this.lineColor = null;
        this.dragLineColor = 0xa1b2a0;
        this.droppedLineColor = null;
        this.allowRedrop = false; // Don't allow picking up the item after dropping it
        this.allowStacking = false; // Don't allow more than one item to be dropped on dropzone
        this.allowResize = true; // When dropping an item in dropzone, the item will be resized to fit the dropzone
        this.allowSnapToCenter = true; // When dropping an item in dropzone, the item will be snapped to the center of the dropzone
        this.allowDropzoneDisappear = true; // When dropping an item in dropzone, the dropzone image will disappear
        this.allowSnapToAngle = true; // When dropping an item in dropzone, item angle will snap to dropzone angle
        this.acceptedKeys = [];
        this.debug = false;
    }
    return DropZoneConfig;
}());

var DropZone = /** @class */ (function (_super) {
    __extends(DropZone, _super);
    function DropZone(scene, x, y, options) {
        var _this = this;
        // Options can be passed in not completely defined
        var config = __assign(__assign({}, new DropZoneConfig()), options);
        // Guard against null and capital letters
        if (config.acceptedKeys == null) {
            config.acceptedKeys = [];
        }
        else {
            config.acceptedKeys = config.acceptedKeys.map(function (x) { return x.trim().toLowerCase(); });
        }
        if ((config.square && config.ellipse) || (!config.square && !config.ellipse)) {
            if (config.square) {
                // Throw error if 'both' were true
                console.warn("DropZone: Square and ellipse are provided, defaulting to square");
            }
            config.square = true;
            config.ellipse = false;
        }
        // Okay, NOW we can initialize
        _this = _super.call(this, scene, x, y, config.width, config.height) || this;
        // Finish our initialization
        _this.initialize(config);
        _this.registerEvents();
        return _this;
    }
    DropZone.prototype.initialize = function (config) {
        this.scene.add.existing(this);
        if (config.square) {
            // Square dropzones are generated from the top left
            var shape = new Phaser.Geom.Rectangle(-(this.width / 2), -(this.height / 2), this.width, this.height);
            this.setDropZone(shape, Phaser.Geom.Rectangle.Contains);
        }
        else if (config.ellipse) {
            // Circle dropzones are generated from a point in the center
            var shape = new Phaser.Geom.Ellipse(0, 0, this.width, this.height);
            this.setDropZone(shape, Phaser.Geom.Ellipse.Contains);
        }
        // We were passed an image for the dropzones (hotspot image)
        if (config.backgroundTexture) {
            var hotspot = this.scene.add.image(this.x - this.width / 2, this.y - this.height / 2, config.backgroundTexture, config.backgroundFrame);
            hotspot.setOrigin(0);
            //hotspot.setDepth(1);
            hotspot.setDisplaySize(config.width, config.height);
            this.hotspot = hotspot;
        }
        // For plain dropzones
        this.graphics = this.scene.add.graphics();
        this.config = config;
        this.children = [];
        this.setAngle(this.angle);
        this.setDepth(this.depth);
    };
    DropZone.prototype.registerEvents = function () {
        var _this = this;
        // Grab the object that was dropped onto us
        this.scene.input.on('drop', function (pointer, gameObject, dropZone) {
            // Check if this is the selected dropzone
            if (dropZone !== _this) {
                return;
            }
            var accepted = _this.acceptDrop(gameObject);
            if (!accepted) {
                _this.emit('drop', _this, gameObject, false);
                return;
            }
            if (_this.config.allowSnapToCenter) {
                gameObject.x = _this.x;
                gameObject.y = _this.y;
            }
            _this.children.push(gameObject);
            _this.updateChildren();
            _this.emit('drop', _this, gameObject, true);
            // Make hotspot image disappear
            if (_this.hotspot != null && _this.config.allowDropzoneDisappear) {
                _this.hotspot.setVisible(false);
            }
            _this.updateOutline(_this.config.droppedLineColor);
        });
    };
    /**
     * Check if we accept the drop
     */
    DropZone.prototype.acceptDrop = function (gameObject) {
        var _this = this;
        // Do we have key checking enabled?
        var dropKeys = (gameObject.dropZoneKeys || []).map(function (x) { return x.toLowerCase(); }); // This also checks if object is of type DropZoneType
        if (this.config.acceptedKeys.length > 0 && !dropKeys.some(function (x) { return _this.config.acceptedKeys.some(function (y) { return y === x; }); })) {
            // Key not accepted
            return false;
        }
        // Do we allow stacking?
        if (this.children.length > 0 && !this.config.allowStacking) {
            return false;
        }
        return true;
    };
    // Updates the color of outline of the dropzones
    DropZone.prototype.updateOutline = function (lineColor) {
        this.graphics.clear();
        this.graphics.lineStyle(2, lineColor);
        if (!this.config.showBorder || lineColor == null) {
            return;
        }
        if (this.config.square) {
            var topLeft = this.getTopLeft();
            var topRight = this.getTopRight();
            var bottomLeft = this.getBottomLeft();
            var bottomRight = this.getBottomRight();
            this.graphics.strokeRect(topLeft.x, topLeft.y, topRight.x - topLeft.x, bottomLeft.y - topLeft.y);
        }
        else if (this.config.ellipse) {
            this.graphics.strokeEllipse(this.x, this.y, this.width, this.height);
        }
    };
    DropZone.prototype.updateChildren = function () {
        var _this = this;
        if (this.children.length === 0) { // || !this.config.allowResize) {
            return;
        }
        this.children.forEach(function (x) {
            if (_this.config.allowSnapToAngle) {
                x.setAngle(_this.angle);
            }
            x.setDepth(_this.depth);
            if (_this.config.allowResize) {
                x.setDisplaySize(_this.displayWidth, _this.displayHeight);
            }
            // Disallow moving it again if configured
            x.input.enabled = _this.config.allowRedrop;
        });
    };
    DropZone.prototype.setAngle = function (degrees) {
        _super.prototype.setAngle.call(this, degrees);
        this.updateOutline(this.config.lineColor);
        this.updateChildren();
        return this;
    };
    DropZone.prototype.setDepth = function (value) {
        _super.prototype.setDepth.call(this, value);
        this.graphics.setDepth(value);
        return this;
    };
    return DropZone;
}(Phaser.GameObjects.Zone));



/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DropZoneSprite = /** @class */ (function (_super) {
    __extends(DropZoneSprite, _super);
    function DropZoneSprite(scene, dropZoneKeys, x, y, texture, frame) {
        var _this = _super.call(this, scene, x, y, texture, frame) || this;
        _this.dropZoneKeys = [];
        _this.scene.add.existing(_this);
        _this.dropZoneKeys = Array.isArray(dropZoneKeys) ? dropZoneKeys : [dropZoneKeys];
        return _this;
    }
    return DropZoneSprite;
}(Phaser.GameObjects.Sprite));
/* harmony default export */ __webpack_exports__["a"] = (DropZoneSprite);


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeskItem; });
/**
 * Represents an item that is used in the DeskScene
 * This includes school supplies such as pencils and books, garbage like a wad of paper, a spill, and a sponge to clean the spill
 */
var DeskItem = /** @class */ (function () {
    function DeskItem() {
    }
    DeskItem.SUPPLIES = [
        { id: 0, name: "pencil", quantity: 2, display_width: 13, display_height: 90, angle: -10 },
        { id: 1, name: "pen", quantity: 2, display_width: 20, display_height: 90, angle: 10 },
        { id: 2, name: "book", quantity: 1, display_width: 80, display_height: 100, angle: 10 },
        { id: 3, name: "notebook", quantity: 2, display_width: 90, display_height: 100, angle: -10 },
        { id: 4, name: "eraser", quantity: 1, display_width: 25, display_height: 35, angle: 20 },
    ];
    DeskItem.GARBAGE_ITEMS = [
        { id: 5, name: "plane", quantity: 1, display_width: 120, display_height: 70, angle: 0 },
        { id: 6, name: "paper_wad", quantity: 2, display_width: 60, display_height: 60, angle: 0 },
    ];
    DeskItem.SPILL = { id: 7, name: "spill", quantity: 1, display_width: 90, display_height: 40, angle: 0 };
    DeskItem.CLEANING_ITEM = { id: 8, name: "sponge", quantity: 1, display_width: 40, display_height: 60, angle: 10 };
    DeskItem.ALL_ITEMS = DeskItem.SUPPLIES.concat(DeskItem.GARBAGE_ITEMS);
    return DeskItem;
}());



/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Utilities; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeskItem__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DiagnosisGame_objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_OrganizeDeskGame_objects_GameState__ = __webpack_require__(526);
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};






var Utilities = /** @class */ (function () {
    function Utilities() {
    }
    /**
    * Returns a random point between minX, minY (inclusive) and maxX, maxY (exclusive)
    */
    Utilities.getRandomPoint = function (minX, maxX, minY, maxY) {
        var x = Math.floor(Math.random() * (maxX - minX) + minX);
        var y = Math.floor(Math.random() * (maxY - minY) + minY);
        return new Phaser.Geom.Point(x, y);
    };
    /**
     * Returns the total number of items in the array (have to count the quantities)
     */
    Utilities.getNumberOfItems = function (items) {
        var count = 0;
        items.forEach(function (item) {
            count += item.quantity;
        });
        return count;
    };
    /**
     * Initializes an array of desk supplies with random quantities
     */
    Utilities.initializeDeskSupplies = function () {
        var deskSupplies = [];
        var supplies = __spreadArrays(__WEBPACK_IMPORTED_MODULE_0__DeskItem__["a" /* DeskItem */].SUPPLIES);
        supplies.forEach(function (item) {
            item.quantity = Math.floor(Math.random() * (3 - 0));
            deskSupplies.push(item);
        });
        return deskSupplies;
    };
    /**
     * Initializes an array of desk garbage with random quantities
     */
    Utilities.initializeGarbageItems = function () {
        var deskGarbage = [];
        var garbageItems = __spreadArrays(__WEBPACK_IMPORTED_MODULE_0__DeskItem__["a" /* DeskItem */].GARBAGE_ITEMS);
        garbageItems.forEach(function (item) {
            item.quantity = Math.floor(Math.random() * (3 - 1) + 1);
            deskGarbage.push(item);
        });
        return deskGarbage;
    };
    /**
     * Checks if the sponge is overlapping with the spill (the player is trying to clean the spill)
     */
    Utilities.isPlayerCleaningSpill = function (sponge, spill) {
        var spongeBounds = sponge.getBounds();
        var spillBounds = spill.getBounds();
        return Phaser.Geom.Intersects.RectangleToRectangle(spongeBounds, spillBounds);
    };
    /**
     * Returns true only if there are some items on the desk that are not supposed to be there
     */
    Utilities.checkIfExtraItemsOnDesk = function (deskTop, allDeskItems) {
        var deskTopBounds = deskTop.getBounds();
        var rect = new Phaser.Geom.Rectangle(deskTop.x, deskTop.y, deskTopBounds.width, deskTopBounds.height);
        for (var _i = 0, allDeskItems_1 = allDeskItems; _i < allDeskItems_1.length; _i++) {
            var i = allDeskItems_1[_i];
            if (rect.contains(i.x, i.y) && !i.getData('dropped')) {
                return true;
            }
        }
        return false;
    };
    Utilities.getRandomDeskOrder = function () {
        var order = [1, 2, 3, 4, 5, 6];
        order = __WEBPACK_IMPORTED_MODULE_4__DiagnosisGame_objects_Helpers__["a" /* Helpers */].scrambleArray(order);
        return order.slice(0, __WEBPACK_IMPORTED_MODULE_5_src_games_OrganizeDeskGame_objects_GameState__["a" /* GameState */].NUMBER_OF_DESKS);
    };
    /**
    * Shuffle the candidates so they're not in the same order every time
    * https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
    */
    Utilities.scrambleArray = function (array) {
        var j, x, i;
        for (i = array.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = array[i];
            array[i] = array[j];
            array[j] = x;
        }
        return array;
    };
    Utilities.getRandomArrayIndex = function (arrayLength) {
        return Math.floor(Math.random() * arrayLength);
    };
    Utilities.getModalConfig = function () {
        var modalConfig = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
        modalConfig.buttonWidth = 150;
        modalConfig.buttonConfig = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        modalConfig.buttonConfig.smartSize = true;
        modalConfig.buttonConfig.backgroundColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("light grey");
        return modalConfig;
    };
    return Utilities;
}());



/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_DiseasedTreesGame_scenes_GameIntro__ = __webpack_require__(908);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Diseased Trees Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};
var PhaserDiseasedTreesGame = /** @class */ (function (_super) {
    __extends(PhaserDiseasedTreesGame, _super);
    function PhaserDiseasedTreesGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserDiseasedTreesGame.prototype);
        return _this;
    }
    PhaserDiseasedTreesGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_DiseasedTreesGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserDiseasedTreesGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserDiseasedTreesGame);


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(909);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].DiseasedTrees;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "DiseasedTrees.Phaser.IntroductionScene.1",
            "DiseasedTrees.Phaser.IntroductionScene.2",
            "DiseasedTrees.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GameIntro__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InstructionScene__ = __webpack_require__(2356);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].DiseasedTrees;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_3__InstructionScene__["a" /* InstructionScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_2__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "DiseasedTrees.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "DiseasedTrees.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "DiseasedTrees.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameState; });
var GameState = /** @class */ (function () {
    function GameState(sceneIndex, mapKey) {
        this.sceneIndex = sceneIndex;
        this.mapKey = mapKey;
    }
    GameState.GAME_STATES = [
        {
            sceneIndex: 1,
            mapKey: "map1",
            hasSnow: false,
            hasRain: false,
            hasClouds: false,
            hasFog: false,
        },
        {
            sceneIndex: 2,
            mapKey: "map2",
            hasSnow: true,
            hasRain: false,
            hasClouds: false,
            hasFog: false,
        },
        {
            sceneIndex: 3,
            mapKey: "map3",
            hasSnow: false,
            hasRain: true,
            hasClouds: true,
            hasFog: true,
        },
    ];
    return GameState;
}());



/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameDiseasedTrees.c33eb803.png";

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameDiseasedTrees.675edfa5.json";

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_XraySlider_scenes_GameIntro__ = __webpack_require__(914);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Sliding Xray Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserXraySlider = /** @class */ (function (_super) {
    __extends(PhaserXraySlider, _super);
    function PhaserXraySlider(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserXraySlider.prototype);
        return _this;
    }
    PhaserXraySlider.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_XraySlider_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserXraySlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserXraySlider);


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2363);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].XRay;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "XRay.Phaser.IntroductionScene.1",
            "XRay.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xray__complete.86655c48.png";

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_DesertTerraformGame_scenes_GameIntro__ = __webpack_require__(917);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Landscaping Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};
var PhaserTerraformGame = /** @class */ (function (_super) {
    __extends(PhaserTerraformGame, _super);
    function PhaserTerraformGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserTerraformGame.prototype);
        return _this;
    }
    PhaserTerraformGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_DesertTerraformGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserTerraformGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserTerraformGame);


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2369);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].DesertTerraform;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "DesertTerraform.Phaser.IntroductionScene.1",
            "DesertTerraform.Phaser.IntroductionScene.2",
            "DesertTerraform.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_FitFiveGame_scenes_GameIntro__ = __webpack_require__(919);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Fit Five Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};
var PhaserFitFiveGame = /** @class */ (function (_super) {
    __extends(PhaserFitFiveGame, _super);
    function PhaserFitFiveGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserFitFiveGame.prototype);
        return _this;
    }
    PhaserFitFiveGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_FitFiveGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserFitFiveGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserFitFiveGame);


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2370);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].FitFive;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "FitFive.Phaser.IntroductionScene.1",
            "FitFive.Phaser.IntroductionScene.2",
            "FitFive.Phaser.IntroductionScene.3",
            "FitFive.Phaser.IntroductionScene.4",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_HotelAuroraGame_scenes_GameIntro__ = __webpack_require__(921);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Landscaping Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};
var PhaserHotelAuroraGame = /** @class */ (function (_super) {
    __extends(PhaserHotelAuroraGame, _super);
    function PhaserHotelAuroraGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserHotelAuroraGame.prototype);
        return _this;
    }
    PhaserHotelAuroraGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_HotelAuroraGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserHotelAuroraGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserHotelAuroraGame);


/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2389);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].HotelAurora;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "HotelAurora.Phaser.IntroductionScene.1",
            "HotelAurora.Phaser.IntroductionScene.2",
            "HotelAurora.Phaser.IntroductionScene.3",
            "HotelAurora.Phaser.IntroductionScene.4",
            "HotelAurora.Phaser.IntroductionScene.5",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnswerPatronQuestionScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_AlienPatron__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Utils__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultsScene__ = __webpack_require__(2390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_GameState__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_constants_KeyboardNumKeys__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var AnswerPatronQuestionScene = /** @class */ (function (_super) {
    __extends(AnswerPatronQuestionScene, _super);
    function AnswerPatronQuestionScene() {
        return _super.call(this, {
            key: "AnswerPatronQuestionScene" + Math.random(),
        }) || this;
    }
    AnswerPatronQuestionScene.prototype.preload = function () {
        var _this = this;
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON("map", __webpack_require__(923));
        this.load.image('lobby', __webpack_require__(2392));
        this.load.image('desk', __webpack_require__(2393));
        this.load.image('star', __webpack_require__(895));
        // Alien Patrons
        this.load.image('alien_1', __webpack_require__(287));
        this.load.image('alien_2', __webpack_require__(155));
        this.load.image('alien_3', __webpack_require__(168));
        var keys = [
            "HotelAurora.Phaser.alienIntro1", "HotelAurora.Phaser.alienIntro2", "HotelAurora.Phaser.alienIntro3",
            "HotelAurora.Phaser.AlienStudentInteractions.1.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.1.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.1.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.1.responses.3",
            "HotelAurora.Phaser.AlienStudentInteractions.2.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.2.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.2.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.2.responses.3",
            "HotelAurora.Phaser.AlienStudentInteractions.3.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.3.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.3.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.3.responses.3",
            "HotelAurora.Phaser.AlienStudentInteractions.4.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.4.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.4.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.4.responses.3",
            "HotelAurora.Phaser.AlienStudentInteractions.5.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.5.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.5.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.5.responses.3",
            "HotelAurora.Phaser.AlienStudentInteractions.6.alienQuestion", "HotelAurora.Phaser.AlienStudentInteractions.6.responses.1", "HotelAurora.Phaser.AlienStudentInteractions.6.responses.2", "HotelAurora.Phaser.AlienStudentInteractions.6.responses.3",
        ];
        keys.forEach(function (key) {
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_9_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    AnswerPatronQuestionScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_6_src_utils_BindThisHelper__["a" /* default */])(this, AnswerPatronQuestionScene.prototype);
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_7_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    AnswerPatronQuestionScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
    };
    AnswerPatronQuestionScene.prototype.generateScene = function () {
        this.background = this.add.image(0, 0, "lobby");
        this.background.setOrigin(0);
        this.background.setDepth(0);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.answerPatronQuestion();
    };
    /**
     * Scene: AlienPatron is asking student a question, the student has three buttons to choose from to answer positively/negatively
     */
    AnswerPatronQuestionScene.prototype.answerPatronQuestion = function () {
        var _this = this;
        var patronText;
        var i = 0;
        var responses = [];
        var audio1, audio2;
        var patron = __WEBPACK_IMPORTED_MODULE_0__objects_AlienPatron__["a" /* AlienPatron */].ALL_PATRONS[__WEBPACK_IMPORTED_MODULE_5__objects_GameState__["a" /* GameState */].current.alienIndex];
        if (__WEBPACK_IMPORTED_MODULE_5__objects_GameState__["a" /* GameState */].current.dialogIndex < patron.dialog.interactions.length) {
            var interaction = patron.dialog.interactions[__WEBPACK_IMPORTED_MODULE_5__objects_GameState__["a" /* GameState */].current.dialogIndex];
            this.map.getObjectLayer("Patron Layer").objects.forEach(function (ob) {
                if (ob.name === "patron") {
                    var patronImage = __WEBPACK_IMPORTED_MODULE_1__objects_Utils__["a" /* Utils */].createPatronImage(_this, ob, patron.assetKey);
                    patron.object = patronImage;
                    var deskLayer = _this.add.image(0, 0, "desk");
                    deskLayer.setOrigin(0);
                    deskLayer.setDisplaySize(_this.gameWidth, _this.gameHeight);
                }
                else if (ob.name === "dialog") {
                    var translatedText = __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].translate(interaction.alienQuestion);
                    // If it's the first interaction, add the patron's name
                    if (__WEBPACK_IMPORTED_MODULE_5__objects_GameState__["a" /* GameState */].current.dialogIndex === 0) {
                        translatedText = __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].translate("HotelAurora.Phaser.alienIntro" + patron.id) + " " + translatedText;
                        audio1 = _this.sound.add("HotelAurora.Phaser.alienIntro" + patron.id);
                        audio1.play();
                    }
                    audio2 = _this.sound.add(interaction.alienQuestion);
                    audio2.play("", {
                        delay: audio1 != null ? audio1.totalDuration : 0.5,
                    });
                    patronText = __WEBPACK_IMPORTED_MODULE_1__objects_Utils__["a" /* Utils */].createDialog(_this, ob, translatedText);
                }
                else if (ob.name.startsWith("button")) {
                    var responseObj = interaction.responses[i];
                    responses.push(interaction.responses[i].text);
                    _this.createResponseButton(ob, responseObj, i);
                    i++;
                }
                else if (ob.name === "score") {
                    _this.stars = ob;
                    _this.showScore();
                }
            });
        }
        else {
            this.sound.stopAll();
            // Dialog is over, patron decides if they want to stay or not
            this.scene.add("ResultsScene", __WEBPACK_IMPORTED_MODULE_2__ResultsScene__["a" /* ResultsScene */], true);
            return;
        }
        var delay = audio1 != null ? audio1.totalDuration + audio2.totalDuration : audio2.totalDuration + 1.2;
        responses.forEach(function (r) {
            var audioResponse = _this.sound.add(r);
            audioResponse.play("", {
                delay: delay
            });
            delay += audioResponse.totalDuration + 1;
        });
    };
    AnswerPatronQuestionScene.prototype.createResponseButton = function (ob, response, index) {
        var _this = this;
        if (ob.name === "button_1") {
            this.buttonYCoordinate = ob.y;
        }
        var config = __WEBPACK_IMPORTED_MODULE_1__objects_Utils__["a" /* Utils */].getButtonConfig();
        config.backgroundColor = __WEBPACK_IMPORTED_MODULE_8_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON;
        config.smartHeight = true;
        var translatedText = (index + 1) + ': ' + __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].translate(response.text);
        var button = new __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Button__["a" /* PhaserButton */](this, ob.x, ob.y, ob.width, ob.height, translatedText, config);
        button.setDisplaySize(button.width, button.getIdealButtonHeight());
        if (ob.name !== "button_1") {
            button.setY(this.buttonYCoordinate);
        }
        this.buttonYCoordinate += button.displayHeight + 30;
        button.name = name;
        button.on('buttonClicked', function () {
            _this.calculateResponseChoice(response.points);
        });
        var numKey = __WEBPACK_IMPORTED_MODULE_10_src_constants_KeyboardNumKeys__["a" /* numKeys */][index];
        this.onKeydown(function () { _this.calculateResponseChoice(response.points); }, numKey.keyCode, numKey.altKeyCode);
    };
    AnswerPatronQuestionScene.prototype.calculateResponseChoice = function (points) {
        this.sound.stopAll();
        __WEBPACK_IMPORTED_MODULE_5__objects_GameState__["a" /* GameState */].current.dialogIndex += 1;
        __WEBPACK_IMPORTED_MODULE_5__objects_GameState__["a" /* GameState */].current.score += points;
        // Don't allow score to be negative
        __WEBPACK_IMPORTED_MODULE_5__objects_GameState__["a" /* GameState */].current.score = Math.max(0, __WEBPACK_IMPORTED_MODULE_5__objects_GameState__["a" /* GameState */].current.score);
        this.scene.remove(this);
        this.scene.add("AnswerPatronQuestionScene", AnswerPatronQuestionScene, true);
    };
    /**
     * Show score as stars in top right corner
     */
    AnswerPatronQuestionScene.prototype.showScore = function () {
        var score = this.add.group();
        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_5__objects_GameState__["a" /* GameState */].current.score; i++) {
            var star = this.add.image(0, 0, "star");
            star.setOrigin(0);
            star.setDisplaySize(20, 20);
            star.setTint(0xf4dc42);
            score.add(star);
        }
        Phaser.Actions.GridAlign(score.getChildren(), {
            x: this.stars.x,
            y: this.stars.y,
            width: __WEBPACK_IMPORTED_MODULE_5__objects_GameState__["a" /* GameState */].current.score,
            height: 1,
            cellHeight: 30,
            cellWidth: 30,
        });
    };
    AnswerPatronQuestionScene.prototype.onKeydown = function (event) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        keys.forEach(function (key) {
            _this.input.keyboard.on('keydown_' + key, event);
        });
    };
    return AnswerPatronQuestionScene;
}(Phaser.Scene));



/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/hotel_aurora_1.5fcaeb82.json";

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_WarehouseGame_scenes_GameIntro__ = __webpack_require__(925);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Landscaping Game",
    version: "0.9.3",
    backgroundColor: "#000000",
};
var PhaserWarehouseGame = /** @class */ (function (_super) {
    __extends(PhaserWarehouseGame, _super);
    function PhaserWarehouseGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserWarehouseGame.prototype);
        return _this;
    }
    PhaserWarehouseGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_WarehouseGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserWarehouseGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserWarehouseGame);


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2394);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Warehouse;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "Warehouse.Phaser.IntroductionScene.1",
            "Warehouse.Phaser.IntroductionScene.2",
            "Warehouse.Phaser.IntroductionScene.3",
            "Warehouse.Phaser.IntroductionScene.4",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_RocketRepairGame_scenes_GameIntro__ = __webpack_require__(927);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Rocket Repair Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};
var PhaserRocketRepairGame = /** @class */ (function (_super) {
    __extends(PhaserRocketRepairGame, _super);
    function PhaserRocketRepairGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserRocketRepairGame.prototype);
        return _this;
    }
    PhaserRocketRepairGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_RocketRepairGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserRocketRepairGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserRocketRepairGame);


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2403);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].RocketRepair;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "RocketRepair.Phaser.IntroductionScene.1",
            "RocketRepair.Phaser.IntroductionScene.2",
            "RocketRepair.Phaser.IntroductionScene.3",
            "RocketRepair.Phaser.IntroductionScene.4",
            "RocketRepair.Phaser.IntroductionScene.5",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RocketPartConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RocketPart; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var RocketPartConfig = /** @class */ (function () {
    function RocketPartConfig() {
    }
    return RocketPartConfig;
}());

var RocketPart = /** @class */ (function (_super) {
    __extends(RocketPart, _super);
    function RocketPart(scene, x, y, config) {
        var _this = _super.call(this, scene, x, y, config.name, 1) || this;
        _this.id = config.id;
        _this.name = config.name;
        _this.screws = config.screws || 0;
        _this.bolts = config.bolts || 0;
        _this.setOrigin(0);
        _this.setDepth(2);
        // Big wings - flip them so they don't cover other stuff
        if (_this.id === 12) {
            _this.setAngle(-90);
        }
        scene.children.bringToTop(_this);
        scene.add.existing(_this);
        return _this;
    }
    RocketPart.ROCKET_PARTS = [
        { id: 1, name: "component1", screws: 4, bolts: 1, src: __webpack_require__(2405), frameWidth: 277, frameHeight: 208 },
        { id: 2, name: "component2", screws: 3, bolts: 2, src: __webpack_require__(2406), frameWidth: 206, frameHeight: 150 },
        { id: 3, name: "component3", screws: 6, bolts: 0, src: __webpack_require__(2407), frameWidth: 127, frameHeight: 143 },
        { id: 4, name: "component4", screws: 4, bolts: 0, src: __webpack_require__(2408), frameWidth: 192, frameHeight: 160 },
        { id: 5, name: "component5", screws: 2, bolts: 0, src: __webpack_require__(2409), frameWidth: 160, frameHeight: 170 },
        { id: 6, name: "component6", screws: 0, bolts: 1, src: __webpack_require__(2410), frameWidth: 162, frameHeight: 125 },
        { id: 7, name: "component7", screws: 4, bolts: 1, src: __webpack_require__(2411), frameWidth: 395, frameHeight: 91 },
        { id: 8, name: "component8", screws: 3, bolts: 0, src: __webpack_require__(2412), frameWidth: 425, frameHeight: 112 },
        { id: 9, name: "component9", screws: 5, bolts: 0, src: __webpack_require__(2413), frameWidth: 425, frameHeight: 170 },
        { id: 10, name: "component10", screws: 3, bolts: 0, src: __webpack_require__(2414), frameWidth: 191, frameHeight: 116 },
        { id: 11, name: "component11", screws: 0, bolts: 1, src: __webpack_require__(2415), frameWidth: 191, frameHeight: 78 },
        { id: 12, name: "component12", screws: 8, bolts: 0, src: __webpack_require__(2416), frameWidth: 330, frameHeight: 441 },
    ];
    return RocketPart;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RocketPart__ = __webpack_require__(928);

var GameState = /** @class */ (function () {
    function GameState() {
        this.index = 0;
        this.partConfig = __WEBPACK_IMPORTED_MODULE_0__RocketPart__["a" /* RocketPart */].ROCKET_PARTS[this.index];
        this.shipTexture = "assembly" + (this.index + 1);
    }
    /**
     * Updates the game state by adding to the index and setting the next part
     * Also returns boolean whether or not the game is over
     */
    GameState.getNextPart = function () {
        GameState.current.index = GameState.current.index + 1;
        GameState.current.shipTexture = "assembly" + (GameState.current.index + 1);
        if (GameState.current.index === __WEBPACK_IMPORTED_MODULE_0__RocketPart__["a" /* RocketPart */].ROCKET_PARTS.length) {
            // Game Is Over!
            return true;
        }
        else {
            GameState.current.partConfig = __WEBPACK_IMPORTED_MODULE_0__RocketPart__["a" /* RocketPart */].ROCKET_PARTS[GameState.current.index];
            return false;
        }
    };
    return GameState;
}());



/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_ProgramRobotGame_scenes_GameIntro__ = __webpack_require__(931);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Program Robot Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};
var PhaserProgramRobotGame = /** @class */ (function (_super) {
    __extends(PhaserProgramRobotGame, _super);
    function PhaserProgramRobotGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserProgramRobotGame.prototype);
        return _this;
    }
    PhaserProgramRobotGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_ProgramRobotGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserProgramRobotGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserProgramRobotGame);


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2440);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].ProgramRobot;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "ProgramRobot.Phaser.IntroductionScene.1",
            "ProgramRobot.Phaser.IntroductionScene.2",
            "ProgramRobot.Phaser.IntroductionScene.3",
            "ProgramRobot.Phaser.IntroductionScene.4",
            "ProgramRobot.Phaser.IntroductionScene.5",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_JigsawPuzzleGame_scenes_GameIntro__ = __webpack_require__(933);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var templateConfig = {
    title: "Jigsaw Puzzle Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 600 }
        }
    },
    backgroundColor: "#000000"
};
var PhaserJigsawPuzzleGame = /** @class */ (function (_super) {
    __extends(PhaserJigsawPuzzleGame, _super);
    function PhaserJigsawPuzzleGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserJigsawPuzzleGame.prototype);
        return _this;
    }
    PhaserJigsawPuzzleGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_JigsawPuzzleGame_scenes_GameIntro__["a" /* GameIntroScene */], config: templateConfig, onComplete: this.props.onComplete })));
    };
    return PhaserJigsawPuzzleGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserJigsawPuzzleGame);


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2454);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].JigsawPuzzle;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "JigsawPuzzle.Phaser.IntroductionScene.1",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_SpacePortGame_scenes_GameIntro__ = __webpack_require__(935);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Space Port Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserSpacePortGame = /** @class */ (function (_super) {
    __extends(PhaserSpacePortGame, _super);
    function PhaserSpacePortGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserSpacePortGame.prototype);
        return _this;
    }
    PhaserSpacePortGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_SpacePortGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserSpacePortGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserSpacePortGame);


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2465);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].SpacePort;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "SpacePort.Phaser.IntroductionScene.1",
            "SpacePort.Phaser.IntroductionScene.2",
            "SpacePort.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paint_gun.76e6218b.cur";

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/button.71aac6ca.png";

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LandingPad; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Size = /** @class */ (function () {
    function Size() {
    }
    Size.SMALL = {
        id: "small",
        weight: 1
    };
    Size.MEDIUM = {
        id: "medium",
        weight: 2
    };
    Size.LARGE = {
        id: "large",
        weight: 3
    };
    Size.Sizes = [
        Size.LARGE,
        Size.MEDIUM,
        Size.SMALL
    ];
    return Size;
}());

var LandingPad = /** @class */ (function (_super) {
    __extends(LandingPad, _super);
    function LandingPad(scene, x, y, texture, frame, size) {
        var _this = _super.call(this, scene, x, y, texture, frame) || this;
        _this.size = size;
        _this.state = "empty";
        _this.setInteractive();
        _this.scene.add.existing(_this);
        return _this;
    }
    return LandingPad;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_MailDeliveryGame_scenes_GameIntro__ = __webpack_require__(940);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var templateConfig = {
    title: "Mail Delivery Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000"
};
var PhaserMailDeliveryGame = /** @class */ (function (_super) {
    __extends(PhaserMailDeliveryGame, _super);
    function PhaserMailDeliveryGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserMailDeliveryGame.prototype);
        return _this;
    }
    PhaserMailDeliveryGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_MailDeliveryGame_scenes_GameIntro__["a" /* GameIntroScene */], config: templateConfig, onComplete: this.props.onComplete })));
    };
    return PhaserMailDeliveryGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserMailDeliveryGame);


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2486);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].MailDelivery;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "MailDelivery.Phaser.IntroductionScene.1",
            "MailDelivery.Phaser.IntroductionScene.2",
            "MailDelivery.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_GameIntro__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Space Ship Painting Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserShipPaintingGame = /** @class */ (function (_super) {
    __extends(PhaserShipPaintingGame, _super);
    function PhaserShipPaintingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserShipPaintingGame.prototype);
        return _this;
    }
    PhaserShipPaintingGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_2__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserShipPaintingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserShipPaintingGame);


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2500);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].ShipPainting;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "ShipPainting.Phaser.IntroductionScene.1",
            "ShipPainting.Phaser.IntroductionScene.2",
            "ShipPainting.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(944);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Space Pets Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserSpacePetsGame = /** @class */ (function (_super) {
    __extends(PhaserSpacePetsGame, _super);
    function PhaserSpacePetsGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserSpacePetsGame.prototype);
        return _this;
    }
    PhaserSpacePetsGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserSpacePetsGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserSpacePetsGame);


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2501);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].SpacePets;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "SpacePets.Phaser.IntroductionScene.1",
            "SpacePets.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(946);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Waiter Memory Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserWaiterMemoryGame = /** @class */ (function (_super) {
    __extends(PhaserWaiterMemoryGame, _super);
    function PhaserWaiterMemoryGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserWaiterMemoryGame.prototype);
        return _this;
    }
    PhaserWaiterMemoryGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserWaiterMemoryGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserWaiterMemoryGame);


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2509);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].WaiterMemory;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "WaiterMemory.Phaser.IntroductionScene.1",
            "WaiterMemory.Phaser.IntroductionScene.2",
            "WaiterMemory.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(948);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Zoo Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserZooGame = /** @class */ (function (_super) {
    __extends(PhaserZooGame, _super);
    function PhaserZooGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserZooGame.prototype);
        return _this;
    }
    PhaserZooGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserZooGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserZooGame);


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2517);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Zoo;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "Zoo.Phaser.IntroductionScene.1",
            "Zoo.Phaser.IntroductionScene.2",
            "Zoo.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(950);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Librarian Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserLibrarianGame = /** @class */ (function (_super) {
    __extends(PhaserLibrarianGame, _super);
    function PhaserLibrarianGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserLibrarianGame.prototype);
        return _this;
    }
    PhaserLibrarianGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserLibrarianGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserLibrarianGame);


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2525);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Librarian;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "Librarian.Phaser.IntroductionScene.1",
            "Librarian.Phaser.IntroductionScene.2",
            "Librarian.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(952);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Uniform Design Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserUniformDesignGame = /** @class */ (function (_super) {
    __extends(PhaserUniformDesignGame, _super);
    function PhaserUniformDesignGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserUniformDesignGame.prototype);
        return _this;
    }
    PhaserUniformDesignGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserUniformDesignGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserUniformDesignGame);


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2533);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].UniformDesign;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "UniformDesign.Phaser.IntroductionScene.1",
            "UniformDesign.Phaser.IntroductionScene.2",
            "UniformDesign.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(954);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Ocean Cleanup Game",
    version: "0.2",
    backgroundColor: "#000000",
    physics: {
        default: "arcade",
        arcade: {
            debug: false,
            gravity: { x: 0, y: 0 }
        }
    },
};
var PhaserOceanCleanupGame = /** @class */ (function (_super) {
    __extends(PhaserOceanCleanupGame, _super);
    function PhaserOceanCleanupGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserOceanCleanupGame.prototype);
        return _this;
    }
    PhaserOceanCleanupGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserOceanCleanupGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserOceanCleanupGame);


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2547);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].OceanCleanup;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "OceanCleanup.Phaser.IntroductionScene.1",
            "OceanCleanup.Phaser.IntroductionScene.2",
            "OceanCleanup.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(956);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Construction Maze Game",
    version: "0.2",
    backgroundColor: "#000000",
    physics: {
        default: "matter",
        matter: {
            debug: false,
            gravity: { x: 0, y: 0 }
        }
    },
};
var PhaserConstructionMazeGame = /** @class */ (function (_super) {
    __extends(PhaserConstructionMazeGame, _super);
    function PhaserConstructionMazeGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserConstructionMazeGame.prototype);
        return _this;
    }
    PhaserConstructionMazeGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserConstructionMazeGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserConstructionMazeGame);


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2564);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].ConstructionMaze;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "ConstructionMaze.Phaser.IntroductionScene.1",
            "ConstructionMaze.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(958);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Vending Machine Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserVendingMachine = /** @class */ (function (_super) {
    __extends(PhaserVendingMachine, _super);
    function PhaserVendingMachine(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserVendingMachine.prototype);
        return _this;
    }
    PhaserVendingMachine.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserVendingMachine;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserVendingMachine);


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2572);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].VendingMachine;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "VendingMachine.Phaser.IntroductionScene.1",
            "VendingMachine.Phaser.IntroductionScene.2",
            "VendingMachine.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_SeekAndFindGame_scenes_GameIntro__ = __webpack_require__(960);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Seek and Find Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserSeekAndFindGame = /** @class */ (function (_super) {
    __extends(PhaserSeekAndFindGame, _super);
    function PhaserSeekAndFindGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserSeekAndFindGame.prototype);
        return _this;
    }
    PhaserSeekAndFindGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3_src_games_SeekAndFindGame_scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserSeekAndFindGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserSeekAndFindGame);


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2581);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].SeekAndFind;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "SeekAndFind.Phaser.IntroductionScene.1",
            "SeekAndFind.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(962);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Find Helpers Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserFindHelpersGame = /** @class */ (function (_super) {
    __extends(PhaserFindHelpersGame, _super);
    function PhaserFindHelpersGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserFindHelpersGame.prototype);
        return _this;
    }
    PhaserFindHelpersGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserFindHelpersGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserFindHelpersGame);


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2589);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].FindHelpers;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "FindHelpers.Phaser.IntroductionScene.1",
            "FindHelpers.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(964);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Ticket Taker Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserTicketTakerGame = /** @class */ (function (_super) {
    __extends(PhaserTicketTakerGame, _super);
    function PhaserTicketTakerGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserTicketTakerGame.prototype);
        return _this;
    }
    PhaserTicketTakerGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserTicketTakerGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserTicketTakerGame);


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2597);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].TicketTaker;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "TicketTaker.Phaser.IntroductionScene.1",
            "TicketTaker.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(966);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Fossil Finder Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserFossilFinderGame = /** @class */ (function (_super) {
    __extends(PhaserFossilFinderGame, _super);
    function PhaserFossilFinderGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserFossilFinderGame.prototype);
        return _this;
    }
    PhaserFossilFinderGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserFossilFinderGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserFossilFinderGame);


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2605);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].FossilFinder;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "FossilFinder.Phaser.IntroductionScene.1",
            "FossilFinder.Phaser.IntroductionScene.2",
            "FossilFinder.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(968);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Grocery Bagger Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserGroceryBaggerGame = /** @class */ (function (_super) {
    __extends(PhaserGroceryBaggerGame, _super);
    function PhaserGroceryBaggerGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserGroceryBaggerGame.prototype);
        return _this;
    }
    PhaserGroceryBaggerGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserGroceryBaggerGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserGroceryBaggerGame);


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2614);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].GroceryBagger;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "GroceryBagger.Phaser.IntroductionScene.1",
            "GroceryBagger.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(970);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Cake Decorating Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserCakeDecoratingGame = /** @class */ (function (_super) {
    __extends(PhaserCakeDecoratingGame, _super);
    function PhaserCakeDecoratingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserCakeDecoratingGame.prototype);
        return _this;
    }
    PhaserCakeDecoratingGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserCakeDecoratingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserCakeDecoratingGame);


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2622);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].CakeDecorating;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "CakeDecorating.Phaser.IntroductionScene.1",
            "CakeDecorating.Phaser.IntroductionScene.2",
            "CakeDecorating.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(972);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Ride Mechanic Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserRideMechanicGame = /** @class */ (function (_super) {
    __extends(PhaserRideMechanicGame, _super);
    function PhaserRideMechanicGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserRideMechanicGame.prototype);
        return _this;
    }
    PhaserRideMechanicGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserRideMechanicGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserRideMechanicGame);


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2630);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].RideMechanic;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "RideMechanic.Phaser.IntroductionScene.1",
            "RideMechanic.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(974);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Starball Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserStarballGame = /** @class */ (function (_super) {
    __extends(PhaserStarballGame, _super);
    function PhaserStarballGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserStarballGame.prototype);
        return _this;
    }
    PhaserStarballGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserStarballGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserStarballGame);


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2638);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Starball;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "Starball.Phaser.IntroductionScene.1",
            "Starball.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__ = __webpack_require__(976);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "City Builder Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserCityBuilderGame = /** @class */ (function (_super) {
    __extends(PhaserCityBuilderGame, _super);
    function PhaserCityBuilderGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserCityBuilderGame.prototype);
        return _this;
    }
    PhaserCityBuilderGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserCityBuilderGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserCityBuilderGame);


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2646);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].CityBuilder;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "CityBuilder.Phaser.IntroductionScene.1",
            "CityBuilder.Phaser.IntroductionScene.2",
            "CityBuilder.Phaser.IntroductionScene.3",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrayState; });
var TrayState = /** @class */ (function () {
    function TrayState() {
    }
    TrayState.ROADS = {
        color: 0x5cffa2,
        type: "roads"
    };
    TrayState.COMMERCIAL = {
        color: 0x7fffff,
        type: "commercial"
    };
    TrayState.INDUSTRIAL = {
        color: 0xe3ca31,
        type: "industrial"
    };
    TrayState.RESIDENTIAL = {
        color: 0xca3f52,
        type: "residential"
    };
    TrayState.TRAYSTATES = [TrayState.ROADS, TrayState.COMMERCIAL, TrayState.INDUSTRIAL, TrayState.RESIDENTIAL];
    return TrayState;
}());



/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_GameIntro__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Face Painting Game",
    version: "0.2",
    backgroundColor: "#000000",
};
var PhaserFacePaintingGame = /** @class */ (function (_super) {
    __extends(PhaserFacePaintingGame, _super);
    function PhaserFacePaintingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserFacePaintingGame.prototype);
        return _this;
    }
    PhaserFacePaintingGame.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_2__scenes_GameIntro__["a" /* GameIntroScene */], config: gameConfig, onComplete: this.props.onComplete })));
    };
    return PhaserFacePaintingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserFacePaintingGame);


/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__ = __webpack_require__(2654);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GameIntroScene = /** @class */ (function (_super) {
    __extends(GameIntroScene, _super);
    function GameIntroScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].FacePainting;
        _this.howToPlayScene = __WEBPACK_IMPORTED_MODULE_2__IntroductionScene__["a" /* HowToPlayScene */];
        _this.introTextKeys = [
            "FacePainting.Phaser.IntroductionScene.1",
            "FacePainting.Phaser.IntroductionScene.2",
        ];
        return _this;
    }
    return GameIntroScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_GameIntroBase__["a" /* GameIntroBaseScene */]));



/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LevelConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_pages_student_scenes_Exploring1__ = __webpack_require__(2676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_pages_student_scenes_SpaceStation1__ = __webpack_require__(2677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_student_scenes_SpaceStation2__ = __webpack_require__(2678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_student_scenes_SpaceStation3__ = __webpack_require__(2679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_pages_student_scenes_SpaceStation4__ = __webpack_require__(2680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_pages_student_scenes_SpaceStation5__ = __webpack_require__(2681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_student_scenes_StudentPostGame__ = __webpack_require__(2682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_student_scenes_StudentPreGame__ = __webpack_require__(2683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_student_scenes_StudentActivity__ = __webpack_require__(2684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_student_scenes_StudentReward__ = __webpack_require__(2691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_pages_student_scenes_SpaceStationComplete__ = __webpack_require__(2692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_student_scenes_Landing1__ = __webpack_require__(2693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_pages_student_scenes_Landing2__ = __webpack_require__(2694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_pages_student_scenes_Leaving1__ = __webpack_require__(2696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_pages_student_scenes_Leaving2__ = __webpack_require__(2698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_pages_student_scenes_StudentGame__ = __webpack_require__(2699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_pages_student_scenes_PlanetClose__ = __webpack_require__(2700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_pages_student_scenes_StudentVideo__ = __webpack_require__(2701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_student_scenes_MissionLog__ = __webpack_require__(2710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_pages_student_scenes_SpaceStationCeremony__ = __webpack_require__(2711);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};






















var LevelConfig = /** @class */ (function () {
    function LevelConfig() {
    }
    return LevelConfig;
}());

var SceneManager = /** @class */ (function () {
    function SceneManager() {
    }
    SceneManager.FindByIds = function (checkpointId, stepId) {
        return this.All.find(function (x) { return x.checkpoint.id === checkpointId && x.step === stepId; });
    };
    SceneManager.CompileLevelState = function () {
        var _this = this;
        // Need to make a list of all of the possible steps
        // This will need to know about the planets, checkpoints and where the loops are
        var masterCounter = 1;
        var levels = [];
        // Pre loop levels
        this.PrePlanetLevels.forEach(function (x) {
            levels.push(__assign(__assign({}, x), { planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R, order: masterCounter++ }));
        });
        // Loop levels
        __spreadArrays(__WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].All).sort(function (a, b) { return a.order - b.order; }).forEach(function (planet) {
            _this.PlanetLevels.forEach(function (level) {
                levels.push(__assign(__assign({}, level), { planet: planet, order: masterCounter++ }));
            });
        });
        // Post loop levels
        this.PostPlanetLevels.forEach(function (x) {
            levels.push(__assign(__assign({}, x), { planet: __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C, order: masterCounter++ }));
        });
        this.Levels = levels;
    };
    SceneManager.GetCurrentLevel = function (checkpointId, stepNumber, planetId) {
        if (this.Levels == null || this.Levels.length === 0) {
            this.CompileLevelState();
        }
        /** First Planet */
        var _minPlanet = __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R;
        /** Last Planet */
        var _maxPlanet = __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C;
        var _planetId = planetId;
        var _checkpointId = checkpointId;
        var _step = stepNumber;
        // Get current level
        var currentLevel = this.Levels.find(function (x) { return x.planet.id === _planetId && x.checkpoint.id === _checkpointId && x.step === _step; });
        if (currentLevel == null) {
            // Failed. Sanity checking time!
            // JB: Given the changes on the backend, this should literally never happen
            console.warn("Broken level", { planetId: planetId, checkpointId: checkpointId, stepId: stepNumber });
            if (__WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].FindById(_planetId) === __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].Default) {
                // Broken planet
                _planetId = _planetId < _minPlanet.id ? _minPlanet.id : _maxPlanet.id;
            }
            if (__WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(_checkpointId) === __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].None) {
                // Broken checkpoint
                _checkpointId = _checkpointId < __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding.id ? __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding.id : __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Landing.id;
            }
            // Reset step
            _step = 1;
            currentLevel = this.Levels.find(function (x) { return x.planet.id === _planetId && x.checkpoint.id === _checkpointId && x.step === _step; });
            if (currentLevel == null) {
                // Well shit, this shouldn't happen
                console.error("Error when handling scene transition");
                currentLevel = this.Levels[0];
            }
        }
        return currentLevel;
    };
    SceneManager.GetNextStep = function (checkpointId, stepNumber, planetId) {
        var currentLevel = this.GetCurrentLevel(checkpointId, stepNumber, planetId);
        var nextLevel = this.Levels.find(function (x) { return x.order === currentLevel.order + 1; });
        nextLevel = nextLevel || this.Levels[this.Levels.length - 1];
        return { planetId: nextLevel.planet.id, checkpointId: nextLevel.checkpoint.id, stepId: nextLevel.step };
    };
    SceneManager.GetPreviousStep = function (checkpointId, stepNumber, planetId) {
        var currentLevel = this.GetCurrentLevel(checkpointId, stepNumber, planetId);
        var nextLevel = this.Levels.find(function (x) { return x.order === currentLevel.order - 1; });
        nextLevel = nextLevel || this.Levels[0];
        return { planetId: nextLevel.planet.id, checkpointId: nextLevel.checkpoint.id, stepId: nextLevel.step };
    };
    SceneManager.GetNextStepOld = function (checkpointId, stepNumber, planetId) {
        var nextLevel = null;
        var _stepNumber = stepNumber;
        var _planet = __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].FindById(planetId);
        var _checkpoint = __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(checkpointId);
        var _maxStep = 5;
        /** Start of the loop */
        var _minCheckpoint = __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Landing;
        /** End of the loop */
        var _maxCheckpoint = __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].BetweenPlanets;
        /** First Planet */
        var _minPlanet = __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R;
        /** Last Planet */
        var _maxPlanet = __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C;
        // Special considerations
        // Sanity checks
        _planet = _planet == null || _planet.order < 1 ? __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R : _planet;
        _checkpoint = _checkpoint == null || _checkpoint.order < 1 ? __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding : _checkpoint;
        _stepNumber = _stepNumber == null || _stepNumber < 1 ? 0 : _stepNumber; // Default to 0 because steps are incremented
        // Leaving last planet, or are completely passed it for some reason
        if ((_planet.order > _maxPlanet.order) ||
            (_planet.order === _maxPlanet.order && _checkpoint.order >= _maxCheckpoint.order)) {
            // Send to GalaxyComplete
            return { checkpointId: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].GalaxyComplete.id, stepId: 1, planetId: _maxPlanet.id };
        }
        do {
            _stepNumber++;
            if (_stepNumber > _maxStep) {
                _checkpoint = __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].GetNext(_checkpoint);
                _stepNumber = 1;
                if (_checkpoint.order > _maxCheckpoint.order) {
                    _planet = __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].GetNext(_planet);
                    _checkpoint = _minCheckpoint;
                    if (_planet.order > _maxPlanet.order) {
                        // If we make it here, something really broke, like a broken checkpoint or a step that got mangled
                        // Send to GalaxyComplete
                        return { checkpointId: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].GalaxyComplete.id, stepId: 1, planetId: _maxPlanet.id };
                    }
                }
            }
            nextLevel = this.FindByIds(_checkpoint.id, _stepNumber);
        } while (nextLevel == null);
        return { checkpointId: _checkpoint.id, stepId: _stepNumber, planetId: _planet.id };
    };
    SceneManager.GetPreviousStepOld = function (checkpointId, stepNumber, planetId) {
        var nextLevel = null;
        var _stepNumber = stepNumber;
        var _planet = __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].FindById(planetId);
        var _checkpoint = __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(checkpointId);
        var _maxStep = 5;
        /** Start of the loop */
        var _minCheckpoint = __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Landing;
        /** End of the loop */
        var _maxCheckpoint = __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].BetweenPlanets;
        /** First Planet */
        var _minPlanet = __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R;
        /** Last Planet */
        var _maxPlanet = __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].C;
        // Special considerations
        // Sanity checks
        _planet = _planet == null || _planet.order < 1 ? __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].R : _planet;
        _checkpoint = _checkpoint == null || _checkpoint.order < 1 ? __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding : _checkpoint;
        _stepNumber = _stepNumber == null || _stepNumber < 1 ? 0 : _stepNumber; // Default to 0 because steps are incremented
        // Previous on low level items doesnt make sense last planet, or are completely passed it for some reason
        if (_planet.order < _minPlanet.order) {
            // Send to start
            return { checkpointId: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding.id, stepId: 1, planetId: _minPlanet.id };
        }
        do {
            _stepNumber--;
            if (_stepNumber < 1) {
                _checkpoint = __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].GetPrevious(_checkpoint);
                _stepNumber = _maxStep;
                if (_checkpoint.order < _minCheckpoint.order) {
                    _planet = __WEBPACK_IMPORTED_MODULE_1_src_constants_Planets__["a" /* Planets */].GetPrevious(_planet);
                    _checkpoint = _maxCheckpoint;
                    if (_planet.order < _minPlanet.order) {
                        // If we make it here, something really broke, like a broken checkpoint or a step that got mangled
                        // Send to GalaxyComplete
                        return { checkpointId: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding.id, stepId: 1, planetId: _minPlanet.id };
                    }
                }
            }
            nextLevel = this.FindByIds(_checkpoint.id, _stepNumber);
        } while (nextLevel == null);
        return { checkpointId: _checkpoint.id, stepId: _stepNumber, planetId: _planet.id };
    };
    SceneManager.Levels = [];
    SceneManager.Default = { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].None, step: 0, component: null };
    SceneManager.PrePlanetLevels = [
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding, step: 1, component: __WEBPACK_IMPORTED_MODULE_3_src_pages_student_scenes_SpaceStation1__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding, step: 2, component: __WEBPACK_IMPORTED_MODULE_4_src_pages_student_scenes_SpaceStation2__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding, step: 3, component: __WEBPACK_IMPORTED_MODULE_5_src_pages_student_scenes_SpaceStation3__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding, step: 4, component: __WEBPACK_IMPORTED_MODULE_6_src_pages_student_scenes_SpaceStation4__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding, step: 5, component: __WEBPACK_IMPORTED_MODULE_7_src_pages_student_scenes_SpaceStation5__["a" /* default */] },
    ];
    SceneManager.PlanetLevels = [
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Landing, step: 1, component: __WEBPACK_IMPORTED_MODULE_13__pages_student_scenes_Landing1__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Landing, step: 2, component: __WEBPACK_IMPORTED_MODULE_14_src_pages_student_scenes_Landing2__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Exploring, step: 1, component: __WEBPACK_IMPORTED_MODULE_2_src_pages_student_scenes_Exploring1__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Video, step: 1, component: __WEBPACK_IMPORTED_MODULE_19_src_pages_student_scenes_StudentVideo__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].PreGame, step: 1, component: __WEBPACK_IMPORTED_MODULE_9__pages_student_scenes_StudentPreGame__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Game, step: 1, component: __WEBPACK_IMPORTED_MODULE_17_src_pages_student_scenes_StudentGame__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].PostGame, step: 1, component: __WEBPACK_IMPORTED_MODULE_8__pages_student_scenes_StudentPostGame__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Activity, step: 1, component: __WEBPACK_IMPORTED_MODULE_10__pages_student_scenes_StudentActivity__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Badge, step: 1, component: __WEBPACK_IMPORTED_MODULE_11__pages_student_scenes_StudentReward__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].PlanetClose, step: 1, component: __WEBPACK_IMPORTED_MODULE_18_src_pages_student_scenes_PlanetClose__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Leaving, step: 1, component: __WEBPACK_IMPORTED_MODULE_15_src_pages_student_scenes_Leaving1__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].Leaving, step: 2, component: __WEBPACK_IMPORTED_MODULE_16_src_pages_student_scenes_Leaving2__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].BetweenPlanets, step: 1, component: __WEBPACK_IMPORTED_MODULE_20__pages_student_scenes_MissionLog__["a" /* default */] },
    ];
    SceneManager.PostPlanetLevels = [
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].GalaxyCeremony, step: 1, component: __WEBPACK_IMPORTED_MODULE_21_src_pages_student_scenes_SpaceStationCeremony__["a" /* default */] },
        { checkpoint: __WEBPACK_IMPORTED_MODULE_0_src_constants_Checkpoints__["a" /* Checkpoints */].GalaxyComplete, step: 1, component: __WEBPACK_IMPORTED_MODULE_12_src_pages_student_scenes_SpaceStationComplete__["a" /* default */] },
    ];
    SceneManager.All = __spreadArrays(SceneManager.PrePlanetLevels, SceneManager.PlanetLevels, SceneManager.PostPlanetLevels);
    return SceneManager;
}());
/* harmony default export */ __webpack_exports__["a"] = (SceneManager);


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Facebook = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(112);

var _singlePlayer = __webpack_require__(156);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var MATCH_URL = /facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/;
var PLAYER_ID_PREFIX = 'facebook-player-';

var Facebook = exports.Facebook = function (_Component) {
  _inherits(Facebook, _Component);

  function Facebook() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Facebook.__proto__ || Object.getPrototypeOf(Facebook)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Facebook, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      if (isReady) {
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          return FB.XFBML.parse();
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
        FB.init({
          appId: _this2.props.config.facebook.appId,
          xfbml: true,
          version: 'v2.5'
        });
        FB.Event.subscribe('xfbml.render', function (msg) {
          // Here we know the SDK has loaded, even if onReady/onPlay
          // is not called due to a video that cannot be embedded
          _this2.props.onLoaded();
        });
        FB.Event.subscribe('xfbml.ready', function (msg) {
          if (msg.type === 'video' && msg.id === _this2.playerID) {
            _this2.player = msg.instance;
            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);
            _this2.player.subscribe('paused', _this2.props.onPause);
            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);
            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
            _this2.player.subscribe('error', _this2.props.onError);
            if (!_this2.props.muted) {
              // Player is muted by default
              _this2.callPlayer('unmute');
            }
            _this2.props.onReady();

            // For some reason Facebook have added `visibility: hidden`
            // to the iframe when autoplay fails, so here we set it back
            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
          }
        });
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentPosition');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%',
        backgroundColor: 'black'
      };
      return _react2['default'].createElement('div', {
        style: style,
        id: this.playerID,
        className: 'fb-video',
        'data-href': this.props.url,
        'data-autoplay': this.props.playing ? 'true' : 'false',
        'data-allowfullscreen': 'true',
        'data-controls': this.props.controls ? 'true' : 'false'
      });
    }
  }]);

  return Facebook;
}(_react.Component);

Facebook.displayName = 'Facebook';

Facebook.canPlay = function (url) {
  return MATCH_URL.test(url);
};

Facebook.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Facebook);

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Streamable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(112);

var _singlePlayer = __webpack_require__(156);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';
var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;

var Streamable = exports.Streamable = function (_Component) {
  _inherits(Streamable, _Component);

  function Streamable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Streamable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Streamable.__proto__ || Object.getPrototypeOf(Streamable)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Streamable, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);
        _this2.player.setLoop(_this2.props.loop);
        _this2.player.on('ready', _this2.props.onReady);
        _this2.player.on('play', _this2.props.onPlay);
        _this2.player.on('pause', _this2.props.onPause);
        _this2.player.on('seeked', _this2.props.onSeek);
        _this2.player.on('ended', _this2.props.onEnded);
        _this2.player.on('error', _this2.props.onError);
        _this2.player.on('timeupdate', function (_ref2) {
          var duration = _ref2.duration,
              seconds = _ref2.seconds;

          _this2.duration = duration;
          _this2.currentTime = seconds;
        });
        _this2.player.on('buffered', function (_ref3) {
          var percent = _ref3.percent;

          if (_this2.duration) {
            _this2.secondsLoaded = _this2.duration * percent;
          }
        });
        if (_this2.props.muted) {
          _this2.player.mute();
        }
      }, this.props.onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'setLoop',
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: 'render',
    value: function render() {
      var id = this.props.url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        src: 'https://streamable.com/o/' + id,
        frameBorder: '0',
        scrolling: 'no',
        style: style,
        allowFullScreen: true
      });
    }
  }]);

  return Streamable;
}(_react.Component);

Streamable.displayName = 'Streamable';

Streamable.canPlay = function (url) {
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(Streamable);

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wistia = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(112);

var _singlePlayer = __webpack_require__(156);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;

var Wistia = exports.Wistia = function (_Component) {
  _inherits(Wistia, _Component);

  function Wistia() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Wistia);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Wistia.__proto__ || Object.getPrototypeOf(Wistia)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Wistia, [{
    key: 'getID',
    value: function getID(url) {
      return url && url.match(MATCH_URL)[1];
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          muted = _props.muted,
          controls = _props.controls,
          _onReady = _props.onReady,
          onPlay = _props.onPlay,
          onPause = _props.onPause,
          onSeek = _props.onSeek,
          onEnded = _props.onEnded,
          config = _props.config;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
        window._wq = window._wq || [];
        window._wq.push({
          id: _this2.getID(url),
          options: _extends({
            autoPlay: playing,
            silentAutoPlay: 'allow',
            muted: muted,
            controlsVisibleOnLoad: controls
          }, config.wistia.options),
          onReady: function onReady(player) {
            _this2.player = player;
            _this2.unbind();
            _this2.player.bind('play', onPlay);
            _this2.player.bind('pause', onPause);
            _this2.player.bind('seek', onSeek);
            _this2.player.bind('end', onEnded);
            _onReady();
          }
        });
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'unbind',
    value: function unbind() {
      var _props2 = this.props,
          onPlay = _props2.onPlay,
          onPause = _props2.onPause,
          onSeek = _props2.onSeek,
          onEnded = _props2.onEnded;

      this.player.unbind('play', onPlay);
      this.player.unbind('pause', onPause);
      this.player.unbind('seek', onSeek);
      this.player.unbind('end', onEnded);
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.unbind();
      this.callPlayer('remove');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('time', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('volume', fraction);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.callPlayer('playbackRate', rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('duration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('time');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var id = this.getID(this.props.url);
      var className = 'wistia_embed wistia_async_' + id;
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('div', { key: id, className: className, style: style });
    }
  }]);

  return Wistia;
}(_react.Component);

Wistia.displayName = 'Wistia';

Wistia.canPlay = function (url) {
  return MATCH_URL.test(url);
};

Wistia.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Wistia);

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(112);

var _singlePlayer = __webpack_require__(156);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
var PLAYER_ID_PREFIX = 'twitch-player-';

var Twitch = exports.Twitch = function (_Component) {
  _inherits(Twitch, _Component);

  function Twitch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Twitch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Twitch.__proto__ || Object.getPrototypeOf(Twitch)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
      _this.callPlayer('setMuted', true);
    }, _this.unmute = function () {
      _this.callPlayer('setMuted', false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Twitch, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      var _props = this.props,
          playsinline = _props.playsinline,
          onError = _props.onError,
          config = _props.config;

      var isChannel = MATCH_CHANNEL_URL.test(url);
      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];
      if (isReady) {
        if (isChannel) {
          this.player.setChannel(id);
        } else {
          this.player.setVideo('v' + id);
        }
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
        _this2.player = new Twitch.Player(_this2.playerID, _extends({
          video: isChannel ? '' : id,
          channel: isChannel ? id : '',
          height: '100%',
          width: '100%',
          playsinline: playsinline,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted
        }, config.twitch.options));
        var _Twitch$Player = Twitch.Player,
            READY = _Twitch$Player.READY,
            PLAYING = _Twitch$Player.PLAYING,
            PAUSE = _Twitch$Player.PAUSE,
            ENDED = _Twitch$Player.ENDED;

        _this2.player.addEventListener(READY, _this2.props.onReady);
        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);
        _this2.player.addEventListener(PAUSE, _this2.props.onPause);
        _this2.player.addEventListener(ENDED, _this2.props.onEnded);
      }, onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.callPlayer('pause');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('div', { style: style, id: this.playerID });
    }
  }]);

  return Twitch;
}(_react.Component);

Twitch.displayName = 'Twitch';

Twitch.canPlay = function (url) {
  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
};

Twitch.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Twitch);

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mixcloud = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(112);

var _singlePlayer = __webpack_require__(156);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';
var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;

var Mixcloud = exports.Mixcloud = function (_Component) {
  _inherits(Mixcloud, _Component);

  function Mixcloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Mixcloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Mixcloud.__proto__ || Object.getPrototypeOf(Mixcloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      // No volume support
    }, _this.unmute = function () {
      // No volume support
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Mixcloud, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);
        _this2.player.ready.then(function () {
          _this2.player.events.play.on(_this2.props.onPlay);
          _this2.player.events.pause.on(_this2.props.onPause);
          _this2.player.events.ended.on(_this2.props.onEnded);
          _this2.player.events.error.on(_this2.props.error);
          _this2.player.events.progress.on(function (seconds, duration) {
            _this2.currentTime = seconds;
            _this2.duration = duration;
          });
          _this2.props.onReady();
        });
      }, this.props.onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      // No volume support
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          config = _props.config;

      var id = url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      var query = (0, _utils.queryString)(_extends({}, config.mixcloud.options, {
        feed: '/' + id + '/'
      }));
      // We have to give the iframe a key here to prevent a
      // weird dialog appearing when loading a new track
      return _react2['default'].createElement('iframe', {
        key: id,
        ref: this.ref,
        style: style,
        src: 'https://www.mixcloud.com/widget/iframe/?' + query,
        frameBorder: '0'
      });
    }
  }]);

  return Mixcloud;
}(_react.Component);

Mixcloud.displayName = 'Mixcloud';

Mixcloud.canPlay = function (url) {
  return MATCH_URL.test(url);
};

Mixcloud.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Mixcloud);

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePlayer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(112);

var _singlePlayer = __webpack_require__(156);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
var HLS_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/VERSION/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;

function canPlay(url) {
  if (url instanceof Array) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = url[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        if (typeof item === 'string' && canPlay(item)) {
          return true;
        }
        if (canPlay(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  }
  if ((0, _utils.isMediaStream)(url)) {
    return true;
  }
  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
}

function canEnablePIP(url) {
  return canPlay(url) && !!document.pictureInPictureEnabled && !AUDIO_EXTENSIONS.test(url);
}

var FilePlayer = exports.FilePlayer = function (_Component) {
  _inherits(FilePlayer, _Component);

  function FilePlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.onDisablePIP = function (e) {
      var _this$props = _this.props,
          onDisablePIP = _this$props.onDisablePIP,
          playing = _this$props.playing;

      onDisablePIP(e);
      if (playing) {
        _this.play();
      }
    }, _this.onSeek = function (e) {
      _this.props.onSeek(e.target.currentTime);
    }, _this.mute = function () {
      _this.player.muted = true;
    }, _this.unmute = function () {
      _this.player.muted = false;
    }, _this.renderSourceElement = function (source, index) {
      if (typeof source === 'string') {
        return _react2['default'].createElement('source', { key: index, src: source });
      }
      return _react2['default'].createElement('source', _extends({ key: index }, source));
    }, _this.renderTrack = function (track, index) {
      return _react2['default'].createElement('track', _extends({ key: index }, track));
    }, _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilePlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
      if (IOS) {
        this.player.load();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(nextProps)) {
        this.removeListeners();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
        this.addListeners();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      var _props = this.props,
          onReady = _props.onReady,
          onPlay = _props.onPlay,
          onPause = _props.onPause,
          onEnded = _props.onEnded,
          onError = _props.onError,
          playsinline = _props.playsinline,
          onEnablePIP = _props.onEnablePIP;

      this.player.addEventListener('canplay', onReady);
      this.player.addEventListener('play', onPlay);
      this.player.addEventListener('pause', onPause);
      this.player.addEventListener('seeked', this.onSeek);
      this.player.addEventListener('ended', onEnded);
      this.player.addEventListener('error', onError);
      this.player.addEventListener('enterpictureinpicture', onEnablePIP);
      this.player.addEventListener('leavepictureinpicture', this.onDisablePIP);
      if (playsinline) {
        this.player.setAttribute('playsinline', '');
        this.player.setAttribute('webkit-playsinline', '');
        this.player.setAttribute('x5-playsinline', '');
      }
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      var _props2 = this.props,
          onReady = _props2.onReady,
          onPlay = _props2.onPlay,
          onPause = _props2.onPause,
          onEnded = _props2.onEnded,
          onError = _props2.onError,
          onEnablePIP = _props2.onEnablePIP;

      this.player.removeEventListener('canplay', onReady);
      this.player.removeEventListener('play', onPlay);
      this.player.removeEventListener('pause', onPause);
      this.player.removeEventListener('seeked', this.onSeek);
      this.player.removeEventListener('ended', onEnded);
      this.player.removeEventListener('error', onError);
      this.player.removeEventListener('enterpictureinpicture', onEnablePIP);
      this.player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
    }
  }, {
    key: 'shouldUseAudio',
    value: function shouldUseAudio(props) {
      if (props.config.file.forceVideo) {
        return false;
      }
      if (props.config.file.attributes.poster) {
        return false; // Use <video> so that poster is shown
      }
      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
    }
  }, {
    key: 'shouldUseHLS',
    value: function shouldUseHLS(url) {
      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
    }
  }, {
    key: 'shouldUseDASH',
    value: function shouldUseDASH(url) {
      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props$config$file = this.props.config.file,
          hlsVersion = _props$config$file.hlsVersion,
          dashVersion = _props$config$file.dashVersion;

      if (this.shouldUseHLS(url)) {
        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);
          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.hls, Hls);
          });
          _this2.hls.loadSource(url);
          _this2.hls.attachMedia(_this2.player);
        });
      }
      if (this.shouldUseDASH(url)) {
        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
          _this2.dash = dashjs.MediaPlayer().create();
          _this2.dash.initialize(_this2.player, url, _this2.props.playing);
          _this2.dash.getDebug().setLogToBrowserConsole(false);
        });
      }

      if (url instanceof Array) {
        // When setting new urls (<source>) on an already loaded video,
        // HTMLMediaElement.load() is needed to reset the media element
        // and restart the media resource. Just replacing children source
        // dom nodes is not enough
        this.player.load();
      } else if ((0, _utils.isMediaStream)(url)) {
        try {
          this.player.srcObject = url;
        } catch (e) {
          this.player.src = window.URL.createObjectURL(url);
        }
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var promise = this.player.play();
      if (promise) {
        promise['catch'](this.props.onError);
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.player.removeAttribute('src');
      if (this.hls) {
        this.hls.destroy();
      }
      if (this.dash) {
        this.dash.reset();
      }
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.player.currentTime = seconds;
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: 'enablePIP',
    value: function enablePIP() {
      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
        this.player.requestPictureInPicture();
      }
    }
  }, {
    key: 'disablePIP',
    value: function disablePIP() {
      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
        document.exitPictureInPicture();
      }
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.player) return null;
      var _player = this.player,
          duration = _player.duration,
          seekable = _player.seekable;
      // on iOS, live streams return Infinity for the duration
      // so instead we use the end of the seekable timerange

      if (duration === Infinity && seekable.length > 0) {
        return seekable.end(seekable.length - 1);
      }
      return duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      if (!this.player) return null;
      return this.player.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      if (!this.player) return null;
      var buffered = this.player.buffered;

      if (buffered.length === 0) {
        return 0;
      }
      var end = buffered.end(buffered.length - 1);
      var duration = this.getDuration();
      if (end > duration) {
        return duration;
      }
      return end;
    }
  }, {
    key: 'getSource',
    value: function getSource(url) {
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);
      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
        return undefined;
      }
      if (MATCH_DROPBOX_URL.test(url)) {
        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
      }
      return url;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          url = _props3.url,
          playing = _props3.playing,
          loop = _props3.loop,
          controls = _props3.controls,
          muted = _props3.muted,
          config = _props3.config,
          width = _props3.width,
          height = _props3.height;

      var useAudio = this.shouldUseAudio(this.props);
      var Element = useAudio ? 'audio' : 'video';
      var style = {
        width: width === 'auto' ? width : '100%',
        height: height === 'auto' ? height : '100%'
      };
      return _react2['default'].createElement(
        Element,
        _extends({
          ref: this.ref,
          src: this.getSource(url),
          style: style,
          preload: 'auto',
          autoPlay: playing || undefined,
          controls: controls,
          muted: muted,
          loop: loop
        }, config.file.attributes),
        url instanceof Array && url.map(this.renderSourceElement),
        config.file.tracks.map(this.renderTrack)
      );
    }
  }]);

  return FilePlayer;
}(_react.Component);

FilePlayer.displayName = 'FilePlayer';
FilePlayer.canPlay = canPlay;
FilePlayer.canEnablePIP = canEnablePIP;
exports['default'] = (0, _singlePlayer2['default'])(FilePlayer);

/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_coin__ = __webpack_require__(2715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_player__ = __webpack_require__(2716);
/**
 * @author       Digitsensitive <digit.sensitivee@gmail.com>
 * @copyright    2018 Digitsensitive
 * @description  Coin Runner: Game Scene
 * @license      Digitsensitive
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var GameScene = /** @class */ (function (_super) {
    __extends(GameScene, _super);
    function GameScene() {
        var _this = _super.call(this, {
            key: "GameScene"
        }) || this;
        _this.collectedCoins = 0;
        return _this;
    }
    GameScene.prototype.preload = function () {
        this.load.image("background", __webpack_require__(372));
        this.load.image("player", __webpack_require__(192));
        this.load.image("coin", __webpack_require__(373));
    };
    GameScene.prototype.create = function () {
        // create background
        this.background = this.add.image(0, 0, "background");
        this.background.setOrigin(0, 0);
        // create objects
        this.coin = new __WEBPACK_IMPORTED_MODULE_0__objects_coin__["a" /* Coin */]({
            scene: this,
            x: Phaser.Math.RND.integerInRange(100, 700),
            y: Phaser.Math.RND.integerInRange(100, 500),
            key: "coin"
        });
        // Create Keyboards
        var cursors1 = this.input.keyboard.createCursorKeys();
        var cursors2 = this.input.keyboard.addKeys({
            up: Phaser.Input.Keyboard.KeyCodes.W,
            down: Phaser.Input.Keyboard.KeyCodes.S,
            left: Phaser.Input.Keyboard.KeyCodes.A,
            right: Phaser.Input.Keyboard.KeyCodes.D,
        });
        this.player = new __WEBPACK_IMPORTED_MODULE_1__objects_player__["a" /* Player */]({ scene: this, x: 150, y: 300, key: "player", keyboard: cursors1 });
        this.player2 = new __WEBPACK_IMPORTED_MODULE_1__objects_player__["a" /* Player */]({ scene: this, x: 150, y: 300, key: "player", keyboard: cursors2 });
        // var logo = this.physics.add.image(400, 100, 'player');
        // logo.setVelocity(100, 200);
        // logo.setBounce(1, 1);
        // logo.setCollideWorldBounds(true);
        var particles = this.add.particles("player");
        var emitter = particles.createEmitter({
            lifespan: 2000,
            angle: { min: 230, max: 310 },
            gravityY: 115,
            speed: { min: 85, max: 200 },
            scale: { start: .3, end: 0 },
            quantity: 0.5,
            blendMode: 'ADD'
        });
        // emitter.startFollow(logo);
        emitter.startFollow(this.player, 0, -20);
        // create texts
        this.coinsCollectedText = this.add.text(this.sys.canvas.width / 2, this.sys.canvas.height - 50, this.collectedCoins + "", {
            fontFamily: "Connection",
            fontSize: 38,
            stroke: "#fff",
            strokeThickness: 6,
            fill: "#000000"
        });
    };
    GameScene.prototype.update = function () {
        // update player and coin
        this.player.update();
        this.player2.update();
        this.coin.update();
        // do the collision check
        if (Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), this.coin.getBounds()) || Phaser.Geom.Intersects.RectangleToRectangle(this.player2.getBounds(), this.coin.getBounds())) {
            this.updateCoinStatus();
        }
    };
    GameScene.prototype.updateCoinStatus = function () {
        this.collectedCoins++;
        this.coinsCollectedText.setText(this.collectedCoins + "");
        this.coin.changePosition();
    };
    GameScene.prototype.gameover = function () {
        this.scene.start("GameScene");
    };
    return GameScene;
}(Phaser.Scene));



/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wood_by_EricHart3d.a61a0d2d.png";

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ground_1x1.46547157.png";

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/tile-collision-testv2.12c8a36f.json";

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/coin.695c294d.png";

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dude.8615288f.png";

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/square-button-red.90b3ee0b.png";

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/background2.8ba5a083.png";

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/player2.ab0f7331.png";

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/box.dc6073e0.png";

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/astronaut.d31777b1.png";

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_alert__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_alert_style_index_js__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_core_registerServiceWorker__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_core_MultilingualLoader__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_core_ConfigureRouter__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_core_ConfigureRedux__ = __webpack_require__(2818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_core_ConfigureHistory__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_providers_TelemetryProvider__ = __webpack_require__(2823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__datadog_browser_rum__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_core_ConfigureFonts__ = __webpack_require__(2824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__App_less__ = __webpack_require__(2826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__App_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__App_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
















 // Generates a default history state


 // This will run the fonts configurator

/** This class is VERY special. It handles loading react, the routes and any 'on startup' logic */
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_9_src_utils_BindThisHelper__["a" /* default */])(_this, App.prototype);
        _this.state = {
            multiLingualLoading: true,
            reduxLoading: true,
            isUserLoggedIn: false,
            isLandscape: true,
        };
        if (__WEBPACK_IMPORTED_MODULE_13_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
            __WEBPACK_IMPORTED_MODULE_16_src_core_ConfigureHistory__["a" /* default */].listen(function (location, action) {
                console.log('Route has changed', location);
            });
        }
        return _this;
    }
    App.prototype.componentDidMount = function () {
        __WEBPACK_IMPORTED_MODULE_18__datadog_browser_rum__["a" /* datadogRum */].init({
            applicationId: 'cce3256f-2f55-4655-b1f6-05e5f8a351c8',
            clientToken: 'pub33e256446f1b36b7b80047baf5fdf569',
            site: 'datadoghq.com',
            service: 'galaxy',
            env: "galaxy-" + deploymentEnvironment,
            // Specify a version number to identify the deployed version of your application in Datadog
            // version: '1.0.0',
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input'
        });
        __WEBPACK_IMPORTED_MODULE_18__datadog_browser_rum__["a" /* datadogRum */].startSessionReplayRecording();
        window.addEventListener("resize", this.toggleOrientation);
        // Have to manually call it the first time
        this.toggleOrientation();
    };
    App.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.toggleOrientation);
    };
    App.prototype.toggleOrientation = function () {
        this.setState({ isLandscape: window.matchMedia("(orientation:landscape)").matches });
    };
    App.prototype.componentDidCatch = function (e) {
        // Errors are stupid and wont stringify properly
        var error = JSON.stringify({
            name: e.name,
            message: e.message,
            stack: e.stack
        });
        __WEBPACK_IMPORTED_MODULE_16_src_core_ConfigureHistory__["a" /* default */].push({
            pathname: __WEBPACK_IMPORTED_MODULE_13_src_utils_DebugUtil__["a" /* default */].isDebugEnabled() ? __WEBPACK_IMPORTED_MODULE_11_src_core_Routes__["a" /* default */].ERROR_PAGE : __WEBPACK_IMPORTED_MODULE_11_src_core_Routes__["a" /* default */].PROD_ERROR_PAGE,
            state: { errors: error }
        });
    };
    App.prototype.multiLingualComplete = function () {
        this.setState({
            multiLingualLoading: false
        });
    };
    App.prototype.reduxComplete = function (result) {
        this.setState({
            reduxLoading: false,
            isUserLoggedIn: result
        });
    };
    App.prototype.renderAlert = function () {
        if (this.state.isLandscape != null && !this.state.isLandscape) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_alert__["a" /* default */], { key: "Banner", banner: true, closable: true, type: "warning", message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "common.orientationWarningHeader" })), description: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "common.orientationWarningBody" })) });
        }
        return null;
    };
    App.prototype.render = function () {
        if (this.state.multiLingualLoading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "App" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_src_core_MultilingualLoader__["a" /* default */], { onComplete: this.multiLingualComplete }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_spin__["a" /* default */], { className: "centered very-large-spinner" }));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "App" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_src_core_MultilingualLoader__["a" /* default */], null),
            this.renderAlert(),
            __WEBPACK_IMPORTED_MODULE_14_src_core_ConfigureRouter__["a" /* default */]);
    };
    return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"], { store: __WEBPACK_IMPORTED_MODULE_15_src_core_ConfigureRedux__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["a" /* LocalizeProvider */], { store: __WEBPACK_IMPORTED_MODULE_15_src_core_ConfigureRedux__["a" /* default */] },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Router"], { history: __WEBPACK_IMPORTED_MODULE_16_src_core_ConfigureHistory__["a" /* default */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_src_providers_TelemetryProvider__["a" /* default */], { instrumentationKey: applicationInsightsKey },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](App, null))))), document.getElementById('root'));
Object(__WEBPACK_IMPORTED_MODULE_10_src_core_registerServiceWorker__["a" /* default */])();


/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Translate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__localize__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocalizeContext__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withLocalize__ = __webpack_require__(756);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var WrappedTranslate = function (_React$Component) {
  _inherits(WrappedTranslate, _React$Component);

  function WrappedTranslate() {
    _classCallCheck(this, WrappedTranslate);

    return _possibleConstructorReturn(this, (WrappedTranslate.__proto__ || Object.getPrototypeOf(WrappedTranslate)).apply(this, arguments));
  }

  _createClass(WrappedTranslate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addDefaultTranslation();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var idChanged = this.props.id && prevProps.id !== this.props.id;

      var noDefaultLanguage = !Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* get */])(prevProps, 'context.defaultLanguage') && !Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* get */])(prevProps, 'options.language');
      var incomingLanguage = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* get */])(this.props, 'context.defaultLanguage') || Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* get */])(this.props, 'options.language');

      var defaultLanguageSet = noDefaultLanguage && incomingLanguage;

      if (idChanged || defaultLanguageSet) {
        this.addDefaultTranslation();
      }
    }
  }, {
    key: 'addDefaultTranslation',
    value: function addDefaultTranslation() {
      var _props = this.props,
          context = _props.context,
          id = _props.id,
          children = _props.children,
          _props$options = _props.options,
          options = _props$options === undefined ? {} : _props$options;

      var defaultLanguage = options.language || context.defaultLanguage;
      var fallbackRenderToStaticMarkup = function fallbackRenderToStaticMarkup(value) {
        return value;
      };
      var renderToStaticMarkup = context.renderToStaticMarkup || fallbackRenderToStaticMarkup;
      var hasId = id !== undefined;
      var hasDefaultLanguage = defaultLanguage !== undefined;
      var hasChildren = children !== undefined;
      var hasFunctionAsChild = typeof children === 'function';

      var ignoreTranslateChildren = options.ignoreTranslateChildren !== undefined ? options.ignoreTranslateChildren : context.ignoreTranslateChildren;

      var isValidDefaultTranslation = hasChildren && hasId && hasDefaultLanguage;

      var shouldAddDefaultTranslation = isValidDefaultTranslation && !hasFunctionAsChild && !ignoreTranslateChildren;

      if (shouldAddDefaultTranslation) {
        var translation = renderToStaticMarkup(children);
        context.addTranslationForLanguage && context.addTranslationForLanguage(_defineProperty({}, id, translation), defaultLanguage);
      }
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props2 = this.props,
          context = _props2.context,
          _props2$id = _props2.id,
          id = _props2$id === undefined ? '' : _props2$id,
          options = _props2.options,
          data = _props2.data;


      return typeof this.props.children === 'function' ? this.props.children(context) : context.translate && context.translate(id, data, options);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.renderChildren();
    }
  }]);

  return WrappedTranslate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var Translate = function Translate(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    __WEBPACK_IMPORTED_MODULE_4__LocalizeContext__["a" /* LocalizeContext */].Consumer,
    null,
    function (context) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedTranslate, _extends({}, props, { context: context }));
    }
  );
};

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalizeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__localize__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocalizeContext__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(479);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LocalizeProvider = function (_Component) {
  _inherits(LocalizeProvider, _Component);

  function LocalizeProvider(props) {
    _classCallCheck(this, LocalizeProvider);

    var _this = _possibleConstructorReturn(this, (LocalizeProvider.__proto__ || Object.getPrototypeOf(LocalizeProvider)).call(this, props));

    var dispatch = _this.props.store ? _this.props.store.dispatch : _this.dispatch.bind(_this);

    _this.getContextPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_3__LocalizeContext__["b" /* getContextPropsFromState */])(dispatch);

    _this.state = {
      localize: Object(__WEBPACK_IMPORTED_MODULE_2__localize__["j" /* localizeReducer */])(undefined, {})
    };
    return _this;
  }

  _createClass(LocalizeProvider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.store) {
        this.unsubscribeFromStore = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* storeDidChange */])(this.props.store, this.onStateDidChange.bind(this));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
  }, {
    key: 'onStateDidChange',
    value: function onStateDidChange(prevState) {
      if (!this.props.store) {
        return;
      }

      var prevLocalizeState = prevState && prevState.localize;
      var curLocalizeState = this.props.store.getState().localize;

      var prevActiveLanguage = prevState && Object(__WEBPACK_IMPORTED_MODULE_2__localize__["d" /* getActiveLanguage */])(prevLocalizeState);
      var curActiveLanguage = Object(__WEBPACK_IMPORTED_MODULE_2__localize__["d" /* getActiveLanguage */])(curLocalizeState);

      var prevOptions = prevState && Object(__WEBPACK_IMPORTED_MODULE_2__localize__["f" /* getOptions */])(prevLocalizeState);
      var curOptions = Object(__WEBPACK_IMPORTED_MODULE_2__localize__["f" /* getOptions */])(curLocalizeState);

      var prevTranslations = prevState && Object(__WEBPACK_IMPORTED_MODULE_2__localize__["h" /* getTranslationsForActiveLanguage */])(prevLocalizeState);
      var curTranslations = Object(__WEBPACK_IMPORTED_MODULE_2__localize__["h" /* getTranslationsForActiveLanguage */])(curLocalizeState);

      var hasActiveLangaugeChanged = (prevActiveLanguage && prevActiveLanguage.code) !== (curActiveLanguage && curActiveLanguage.code);
      var hasOptionsChanged = prevOptions !== curOptions;
      var hasTranslationsChanged = prevTranslations !== curTranslations;

      if (hasActiveLangaugeChanged || hasOptionsChanged || hasTranslationsChanged) {
        this.setState({ localize: curLocalizeState });
      }
    }
  }, {
    key: 'dispatch',
    value: function dispatch(action) {
      this.setState(function (prevState) {
        return {
          localize: Object(__WEBPACK_IMPORTED_MODULE_2__localize__["j" /* localizeReducer */])(prevState.localize, action)
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      this.contextProps = this.getContextPropsSelector(this.state.localize);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__LocalizeContext__["a" /* LocalizeContext */].Provider,
        { value: this.contextProps },
        this.props.children
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, nextState) {
      return null;
    }
  }]);

  return LocalizeProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// tslint:disable:no-console
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the 'N+1' visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function register() {
    if ('serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        var publicUrl = new URL(undefined, window.location.toString());
        if (publicUrl.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
            return;
        }
        window.addEventListener('load', function () {
            var swUrl = '/dist/service-worker.js';
            if (!isLocalhost) {
                // Is not local host. Just register service worker
                registerValidSW(swUrl);
            }
            else {
                // This is running on localhost. Lets check if a service worker still exists or not.
                checkValidServiceWorker(swUrl);
            }
        });
    }
}
function registerValidSW(swUrl) {
    navigator.serviceWorker
        .register(swUrl)
        .then(function (registration) {
        registration.onupdatefound = function () {
            var installingWorker = registration.installing;
            if (installingWorker) {
                installingWorker.onstatechange = function () {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            // At this point, the old content will have been purged and
                            // the fresh content will have been added to the cache.
                            // It's the perfect time to display a 'New content is
                            // available; please refresh.' message in your web app.
                            console.log('New content is available; please refresh.');
                        }
                        else {
                            // At this point, everything has been precached.
                            // It's the perfect time to display a
                            // 'Content is cached for offline use.' message.
                            console.log('Content is cached for offline use.');
                        }
                    }
                };
            }
        };
    })
        .catch(function (error) {
        console.error('Error during service worker registration:', error);
    });
}
function checkValidServiceWorker(swUrl) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl)
        .then(function (response) {
        // Ensure service worker exists, and that we really are getting a JS file.
        if (response.status === 404 ||
            response.headers.get('content-type').indexOf('javascript') === -1) {
            // No service worker found. Probably a different app. Reload the page.
            navigator.serviceWorker.ready.then(function (registration) {
                registration.unregister().then(function () {
                    window.location.reload();
                });
            });
        }
        else {
            // Service worker found. Proceed as normal.
            registerValidSW(swUrl);
        }
    })
        .catch(function () {
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(function (registration) {
            registration.unregister();
        });
    }
}


/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_utils_DebugUtil__ = __webpack_require__(87);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var MultilingualLoader = /** @class */ (function (_super) {
    __extends(MultilingualLoader, _super);
    function MultilingualLoader(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, MultilingualLoader.prototype);
        var languages = __WEBPACK_IMPORTED_MODULE_4__constants_Languages__["a" /* default */].All.map(function (x) { return { name: x.name, code: x.code }; });
        // I had a little too much fun doing javascript things here
        var defaultLanguage = (languages.filter(function (x) { return x.name.toLowerCase() === "english"; }) || [languages[0]]).shift().code;
        // Initialize the multilingual module
        _this.props.initialize({
            languages: languages,
            options: {
                renderToStaticMarkup: __WEBPACK_IMPORTED_MODULE_1_react_dom_server__["renderToStaticMarkup"],
                renderInnerHtml: true,
                defaultLanguage: defaultLanguage,
                onMissingTranslation: _this.missingTranslationHandler
            }
        });
        // Updated language logic
        fetch(__WEBPACK_IMPORTED_MODULE_4__constants_Languages__["a" /* default */].English.url).then(function (data) {
            data.json().then(function (result) {
                // Note for JB - Load the english first as adding additional keys does NOT seem to work properly
                // English is the most complete and will have all of the keys
                _this.props.addTranslationForLanguage(result, __WEBPACK_IMPORTED_MODULE_4__constants_Languages__["a" /* default */].English.code);
                if (__WEBPACK_IMPORTED_MODULE_6_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
                    console.log("English Language Loaded: " + __WEBPACK_IMPORTED_MODULE_4__constants_Languages__["a" /* default */].English.name);
                    console.log("Fetching remaining languages");
                }
                var fetches = __WEBPACK_IMPORTED_MODULE_4__constants_Languages__["a" /* default */].All
                    .filter(function (x) { return x !== __WEBPACK_IMPORTED_MODULE_4__constants_Languages__["a" /* default */].English; })
                    .map(function (lang) {
                    return fetch(lang.url).then(function (data) {
                        return data.json().then(function (jsonResult) {
                            _this.props.addTranslationForLanguage(jsonResult, lang.code);
                            if (__WEBPACK_IMPORTED_MODULE_6_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
                                console.log("Language Loaded: " + lang.name);
                            }
                        });
                    });
                });
                Promise.all(fetches).then(function (x) {
                    // JB: When we finally get a ticket that asks why the login page is in english, we can change it here
                    // JB: We also do not want to use Languages.SetActiveLanguage here. It will be set either on login or in layoutComponent
                    _this.props.setActiveLanguage(__WEBPACK_IMPORTED_MODULE_4__constants_Languages__["a" /* default */].English.code);
                    if (__WEBPACK_IMPORTED_MODULE_6_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
                        console.warn("Loaded all langs, completing multilingual loader");
                    }
                    if (_this.props.onComplete != null) {
                        _this.props.onComplete();
                    }
                    else {
                        if (__WEBPACK_IMPORTED_MODULE_6_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
                            console.warn("What happened to my onComplete function?!");
                        }
                    }
                });
            });
        });
        // **DO NOT TOUCH**
        __WEBPACK_IMPORTED_MODULE_5__utils_TranslateHelper__["a" /* default */].translate = function (key) { return _this.props.translate(key).toString(); };
        return _this;
    }
    MultilingualLoader.prototype.missingTranslationHandler = function (options) {
        console.warn("Missing translation: Lang: " + options.languageCode + " | ID: " + options.translationId);
        return options.defaultTranslation || "";
    };
    MultilingualLoader.prototype.render = function () {
        return null;
    };
    return MultilingualLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(MultilingualLoader));


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1857);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(81),l=__webpack_require__(0);function q(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,u=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,v=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,B=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
60116,ka=t?Symbol.for("react.block"):60121,la=t?Symbol.for("react.fundamental"):60117,ma=t?Symbol.for("react.scope"):60119;function na(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c)},function(c){0===a._status&&(a._status=2,a._result=c)})}}
function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case u:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case B:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case v:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ia:return C(a.type);case ka:return C(a.render);case ja:if(a=1===a._status?a._result:null)return C(a)}return null}var D=l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;D.hasOwnProperty("ReactCurrentDispatcher")||(D.ReactCurrentDispatcher={current:null});D.hasOwnProperty("ReactCurrentBatchConfig")||(D.ReactCurrentBatchConfig={suspense:null});var oa={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}
function pa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=oa;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
var qa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ra=Object.prototype.hasOwnProperty,sa={},ta={};
function ua(a){if(ra.call(ta,a))return!0;if(ra.call(sa,a))return!1;if(qa.test(a))return ta[a]=!0;sa[a]=!0;return!1}function va(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function wa(a,b,c,d){if(null===b||"undefined"===typeof b||va(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=g}var K={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1)});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
M);K[b]=new J(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1)});
K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0)});var xa=/["'&<>]/;
function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=xa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
function ya(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||wa(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(N(b)+'"')}return ua(a)?a+'="'+(N(b)+'"'):""}function za(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var Aa="function"===typeof Object.is?Object.is:za,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(q(321));return O}function Ba(){if(0<V)throw Error(q(312));return{memoizedState:null,queue:null,next:null}}function Ca(){null===Q?null===P?(R=!1,P=Q=Ba()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Ba()):(R=!0,Q=Q.next);return Q}function Da(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Ea(a,b){return"function"===typeof b?b(a):b}
function Fa(a,b,c){O=W();Q=Ca();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Ea?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Ga.bind(null,O,a);return[Q.memoizedState,a]}
function Ga(a,b,c){if(!(25>V))throw Error(q(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ha(){}
var X=0,Ia={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Ca();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!Aa(b[f],d[f])){d=!1;break a}d=!0}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Fa,useRef:function(a){O=W();Q=Ca();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
a):b},useState:function(a){return Fa(Ea,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ha,useEffect:Ha,useDebugValue:Ha,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a()},!1]}},Ja={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ka(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var La={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Ma=k({menuitem:!0},La),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Na=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Na.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Oa=/([A-Z])/g,Pa=/^ms-/,Z=l.Children.toArray,Qa=D.ReactCurrentDispatcher,Ra={listing:!0,pre:!0,textarea:!0},Sa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Ta={},Ua={};function Va(a){if(void 0===a||null===a)return a;var b="";l.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Wa=Object.prototype.hasOwnProperty,Xa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Ya(a,b){if(void 0===a)throw Error(q(152,C(b)||"Component"));}
function Za(a,b,c){function d(d,g){var e=g.prototype&&g.prototype.isReactComponent,f=pa(g,b,c,e),x=[],h=!1,m={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===x)return null},enqueueReplaceState:function(a,c){h=!0;x=[c]},enqueueSetState:function(a,c){if(null===x)return null;x.push(c)}};if(e){if(e=new g(d.props,f,m),"function"===typeof g.getDerivedStateFromProps){var w=g.getDerivedStateFromProps.call(null,d.props,e.state);null!=w&&(e.state=k({},e.state,w))}}else if(O={},e=g(d.props,
f,m),e=Da(g,d.props,e,f),null==e||null==e.render){a=e;Ya(a,g);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),x.length){m=x;var r=
h;x=null;h=!1;if(r&&1===m.length)e.state=m[0];else{w=r?m[0]:e.state;var y=!0;for(r=r?1:0;r<m.length;r++){var p=m[r];p="function"===typeof p?p.call(e,w,d.props,f):p;null!=p&&(y?(y=!1,w=k({},w,p)):k(w,p))}e.state=w}}else x=null;a=e.render();Ya(a,g);if("function"===typeof e.getChildContext&&(d=g.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(q(108,C(g)||"Unknown",T));}A&&(b=k({},b,A))}for(;l.isValidElement(a);){var f=a,g=f.type;if("function"!==
typeof g)break;d(f,g)}return{child:a,context:b}}
var $a=function(){function a(a,b){l.isValidElement(a)?a.type!==u?a=[a]:(a=a.props.children,a=l.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ja.html,children:a,childIndex:0,context:oa,footer:""};var c=F[0];if(0===c){var g=F;c=g.length;var d=2*c;if(!(65536>=d))throw Error(q(304));var h=new Uint16Array(d);h.set(g);F=h;F[0]=c+1;for(g=c;g<d-1;g++)F[g]=g+1;F[d-1]=0}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a}};b.pushProvider=function(a){var c=++this.contextIndex,b=a.type._context,g=this.threadID;E(b,g);var x=b[g];this.contextStack[c]=b;this.contextValueStack[c]=x;b[g]=a.props.value};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Qa.current;Qa.current=Ia;try{for(var g=[""],x=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;F[h]=F[0];F[0]=h;break}var e=this.stack[this.stack.length-1];if(x||e.childIndex>=
e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===v)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=g.pop();if(x){x=!1;var n=e.fallbackFrame;if(!n)throw Error(q(303));this.stack.push(n);g[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else g[this.suspenseDepth]+=G}g[this.suspenseDepth]+=I}else{var m=e.children[e.childIndex++],
w="";try{w+=this.render(m,e.context,e.domNamespace)}catch(r){if(null!=r&&"function"===typeof r.then)throw Error(q(294));throw r;}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=w}}return g[0]}finally{Qa.current=c,X=b}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=Za(a,b,this.threadID);a=b.child;
b=b.context;if(null===a||!1===a)return"";if(!l.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===aa)throw Error(q(257));throw Error(q(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ba:case ea:case ca:case ha:case u:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:throw Error(q(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case fa:O={};var d=c.render(a.props,a.ref);d=Da(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ia:return a=[l.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case v:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case da:c=a.type;d=a.props;var h=this.threadID;E(c,h);c=Z(d.children(c[h]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case la:throw Error(q(338));case ja:switch(c=a.type,na(c),c._status){case 1:return a=[l.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(q(295));
}case ma:throw Error(q(343));}throw Error(q(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===Ja.html&&Ka(c);if(!Ta.hasOwnProperty(c)){if(!Sa.test(c))throw Error(q(65,c));Ta[c]=!0}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var h=d.value;if(null==h){h=d.defaultValue;var e=d.children;if(null!=e){if(null!=
h)throw Error(q(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(q(93));e=e[0]}h=""+e}null==h&&(h="")}d=k({},d,{value:void 0,children:""+h})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Va(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;h=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){h=!0;break}}else h=""+e===G;d=k({selected:void 0,children:void 0},
d,{selected:h,children:I})}}if(h=d){if(Ma[c]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw Error(q(137,c,""));if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw Error(q(60));if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw Error(q(61));}if(null!=h.style&&"object"!==typeof h.style)throw Error(q(62,""));}h=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in h)if(Wa.call(h,z)){var m=h[z];if(null!=m){if("style"===
z){n=void 0;var w="",r="";for(n in m)if(m.hasOwnProperty(n)){var y=0===n.indexOf("--"),p=m[n];if(null!=p){if(y)var A=n;else if(A=n,Ua.hasOwnProperty(A))A=Ua[A];else{var T=A.replace(Oa,"-$1").toLowerCase().replace(Pa,"-ms-");A=Ua[A]=T}w+=r+A+":";r=n;y=null==p||"boolean"===typeof p||""===p?"":y||"number"!==typeof p||0===p||Y.hasOwnProperty(r)&&Y[r]?(""+p).trim():p+"px";w+=y;r=";"}}m=w||null}n=null;b:if(y=c,p=h,-1===y.indexOf("-"))y="string"===typeof p.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
!1;break b;default:y=!0}y?Xa.hasOwnProperty(z)||(n=z,n=ua(n)&&null!=m?n+'="'+(N(m)+'"'):""):n=ya(z,m);n&&(G+=" "+n)}}e||I&&(G+=' data-reactroot=""');var z=G;h="";La.hasOwnProperty(c)?z+="/>":(z+=">",h="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null}null!=e?(d=[],Ra.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
f?Ka(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:h});this.previousWasTextNode=!1;return z};return a}(),ab={renderToString:function(a){a=new $a(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new $a(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw Error(q(207));},renderToStaticNodeStream:function(){throw Error(q(208));
},version:"16.14.0"};module.exports=ab.default||ab;


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/en-US.f2e08d45.json";

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/es-US.73daa13e.json";

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/en-AU.cd4926a1.json";

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LayoutComponent__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__ = __webpack_require__(2075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__ = __webpack_require__(2084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_layouts_spacestation_SpaceStationLayout__ = __webpack_require__(2086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_layouts_planet_PlanetLayout__ = __webpack_require__(2087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_layouts_clean_CleanLayout__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_public_ViewStatements__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_pages_public_Parents__ = __webpack_require__(2100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_pages_public_ParentsPlanet__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_pages_public_ParentsObjectives__ = __webpack_require__(2102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_pages_public_ParentsHome__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_pages_public_PageNotFound__ = __webpack_require__(2104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_pages_public_ErrorPage__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_pages_public_ProdErrorPage__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_pages_admin_Users__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_pages_admin_AddEditUser__ = __webpack_require__(2116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_admin_AudioTest__ = __webpack_require__(2124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_pages_admin_Clients__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_pages_admin_AddEditClient__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_pages_admin_AddEditClientSubscription__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_pages_admin_Statements__ = __webpack_require__(2132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_pages_admin_StudentStatements__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_pages_admin_AddEditStatement__ = __webpack_require__(2134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_pages_admin_Districts__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_pages_admin_AddEditDistrict__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_pages_admin_SyncManagement__ = __webpack_require__(2138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_pages_admin_Schools__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_pages_admin_AddEditSchool__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_pages_admin_Activities__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_pages_admin_AddEditActivity__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_pages_admin_AddEditActivityQuestion__ = __webpack_require__(2149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_pages_admin_AddEditActivityQuestionCategory__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_pages_admin_AddEditActivityQuestionResponse__ = __webpack_require__(2152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_pages_admin_AddEditActivitySummary__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_pages_admin_Classrooms__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_pages_admin_AddEditClassroom__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_pages_admin_Academics__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_pages_admin_AddEditAcademicStandard__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_pages_admin_AddEditAcademicStandardFramework__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_pages_admin_ResetPassword__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_pages_admin_AdminReports__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_src_pages_admin_reports_StudentActivityDetailReport__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_src_pages_admin_StudentViews__ = __webpack_require__(2175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_src_pages_admin_DownloadableResources__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_src_pages_admin_LessonPlans__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_src_pages_admin_EmulateUser__ = __webpack_require__(2182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_src_pages_public_OccupationDb__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_src_pages_public_Occupation__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_src_pages_admin_AdminSyncResults__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_src_pages_admin_Matchmaker__ = __webpack_require__(2186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_src_pages_admin_SyncMatchmakerData__ = __webpack_require__(2188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_src_pages_account_Login__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_src_pages_account_Logout__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_src_pages_account_ForgotPassword__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_src_pages_account_ResetPassword__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_src_pages_examples_ReduxTest__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_src_pages_examples_MultilingualTest__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_src_pages_examples_Video__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_src_pages_examples_FormTest__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_src_pages_developer_WhoAmI__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_src_pages_developer_Diagnostics__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_src_pages_admin_ClassroomReport__ = __webpack_require__(2662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_src_pages_admin_PrincipalReport__ = __webpack_require__(2663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_src_pages_admin_SuperintendentReport__ = __webpack_require__(2664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_src_pages_account_Register__ = __webpack_require__(2665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_src_pages_admin_UniversalUserSearch__ = __webpack_require__(2666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_src_pages_admin_universalSearch_USStudentStatements__ = __webpack_require__(2668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_src_pages_admin_universalSearch_USResetPassword__ = __webpack_require__(2669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_src_pages_account_Register_AFL__ = __webpack_require__(2671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_src_pages_admin_reports_StudentPlanetCompletionReport__ = __webpack_require__(2672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_src_pages_admin_reports_StudentGameCompletionReport__ = __webpack_require__(2673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_src_pages_admin_reports_StudentStatementReport__ = __webpack_require__(2674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_src_pages_student_PlanetHome__ = __webpack_require__(2675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_src_pages_student_SpaceStationHome__ = __webpack_require__(2712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_src_pages_game_demos_PhaserGameDemo__ = __webpack_require__(2713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_src_pages_game_demos_DragDropDemo__ = __webpack_require__(2717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_src_pages_game_demos_ComplexPaintDemo__ = __webpack_require__(2721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_src_pages_game_demos_PlatformerDemo__ = __webpack_require__(2724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_src_pages_game_demos_AnimationDemo__ = __webpack_require__(2728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_src_pages_game_demos_MultiSceneDemo__ = __webpack_require__(2731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_src_pages_game_demos_PathFindingDemo__ = __webpack_require__(2742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_src_pages_game_demos_ImagePasteDemo__ = __webpack_require__(2745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_src_pages_game_demos_GamePadDemo__ = __webpack_require__(2753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_src_pages_game_demos_CameraAnimationsDemo__ = __webpack_require__(2756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_src_pages_game_demos_ModalButtonDemo__ = __webpack_require__(2759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_src_pages_game_demos_NPCFollowingDemo__ = __webpack_require__(2762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_src_pages_game_demos_LandscapingDemo__ = __webpack_require__(2766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_src_pages_game_demos_HowToPlaySceneDemo__ = __webpack_require__(2769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_src_pages_game_Home__ = __webpack_require__(2772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_src_pages_game_PaintGame__ = __webpack_require__(2773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_src_pages_game_LandscapingGame__ = __webpack_require__(2774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_src_pages_game_PlatformerGame__ = __webpack_require__(2775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_src_pages_game_PuzzleSliderGame__ = __webpack_require__(2776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_src_pages_game_DiseasedTreesGame__ = __webpack_require__(2777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_src_pages_game_UniversityGame__ = __webpack_require__(2778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_src_pages_game_OrganizeDeskGame__ = __webpack_require__(2779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_src_pages_game_CareerFairGame__ = __webpack_require__(2780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_src_pages_game_ColonyGame__ = __webpack_require__(2781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_src_pages_game_DiagnosisGame__ = __webpack_require__(2782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_src_pages_game_DinerGame__ = __webpack_require__(2783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_src_pages_game_WarehouseGame__ = __webpack_require__(2784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_src_pages_game_FitFiveGame__ = __webpack_require__(2785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_src_pages_game_HotelAuroraGame__ = __webpack_require__(2786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_src_pages_game_DesertTerraformGame__ = __webpack_require__(2787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_src_pages_game_PlumbingGame__ = __webpack_require__(2788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110_src_pages_game_CollageGame__ = __webpack_require__(2789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111_src_pages_game_XraySliderGame__ = __webpack_require__(2790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112_src_pages_game_ShipPaintingGame__ = __webpack_require__(2791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113_src_pages_student_scenes_SpaceStationReturn__ = __webpack_require__(2792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114_src_pages_game_ProgramRobotGame__ = __webpack_require__(2793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115_src_pages_game_RocketRepairGame__ = __webpack_require__(2794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__pages_game_JigsawPuzzleGame__ = __webpack_require__(2795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117_src_pages_game_SpacePortGame__ = __webpack_require__(2796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118_src_pages_game_MailDeliveryGame__ = __webpack_require__(2797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119_src_pages_game_CityBuilderGame__ = __webpack_require__(2798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120_src_pages_public_HollandAreasGuide__ = __webpack_require__(2799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121_src_pages_public_TrainingAndEducationGuide__ = __webpack_require__(2800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122_src_pages_game_VendingMachineGame__ = __webpack_require__(2801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123_src_pages_game_SeekAndFindGame__ = __webpack_require__(2802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124_src_pages_game_SpacePetsGame__ = __webpack_require__(2803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125_src_pages_game_OceanCleanupGame__ = __webpack_require__(2804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126_src_pages_game_WaiterMemoryGame__ = __webpack_require__(2805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127_src_pages_game_CakeDecoratingGame__ = __webpack_require__(2806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128_src_pages_game_LibrarianGame__ = __webpack_require__(2807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129_src_pages_game_ZooGame__ = __webpack_require__(2808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130_src_pages_game_UniformDesignGame__ = __webpack_require__(2809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131_src_pages_game_TicketTakerGame__ = __webpack_require__(2810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132_src_pages_game_FindHelpersGame__ = __webpack_require__(2811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133_src_pages_game_GroceryBaggerGame__ = __webpack_require__(2812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134_src_pages_game_ConstructionMazeGame__ = __webpack_require__(2813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135_src_pages_game_StarballGame__ = __webpack_require__(2814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136_src_pages_game_RideMechanicGame__ = __webpack_require__(2815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137_src_pages_game_FossilFinderGame__ = __webpack_require__(2816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138_src_pages_game_FacePaintingGame__ = __webpack_require__(2817);




/* Layouts */







/* Pages/Routes/Components */


































































/* Student */


/* Game Demos */














/* Real Games */














































var RouteLoader = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"], null,
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].BASE_ROUTE, component: __WEBPACK_IMPORTED_MODULE_56_src_pages_account_Login__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].LOGIN, component: __WEBPACK_IMPORTED_MODULE_56_src_pages_account_Login__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].LOGOUT, component: __WEBPACK_IMPORTED_MODULE_57_src_pages_account_Logout__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].FORGOT_PASSWORD, component: __WEBPACK_IMPORTED_MODULE_58_src_pages_account_ForgotPassword__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].RESET_PASSWORD, component: __WEBPACK_IMPORTED_MODULE_59_src_pages_account_ResetPassword__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].TRAINING_AND_EDUCATION_GUIDE, component: __WEBPACK_IMPORTED_MODULE_121_src_pages_public_TrainingAndEducationGuide__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].HOLLAND_AREAS_GUIDE, component: __WEBPACK_IMPORTED_MODULE_120_src_pages_public_HollandAreasGuide__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].OCCUPATIONDB, component: __WEBPACK_IMPORTED_MODULE_51_src_pages_public_OccupationDb__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].OCCUPATION, component: __WEBPACK_IMPORTED_MODULE_52_src_pages_public_Occupation__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].REGISTER, component: __WEBPACK_IMPORTED_MODULE_69_src_pages_account_Register__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].REGISTERAFL, component: __WEBPACK_IMPORTED_MODULE_73_src_pages_account_Register_AFL__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].STATEMENTS, component: __WEBPACK_IMPORTED_MODULE_11__pages_public_ViewStatements__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_10_src_layouts_clean_CleanLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].PARENTS, component: __WEBPACK_IMPORTED_MODULE_12_src_pages_public_Parents__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].PARENTS_OBJECTIVES, component: __WEBPACK_IMPORTED_MODULE_14_src_pages_public_ParentsObjectives__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].PARENTS_PLANET, component: __WEBPACK_IMPORTED_MODULE_13_src_pages_public_ParentsPlanet__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].PARENTS_HOME, component: __WEBPACK_IMPORTED_MODULE_15_src_pages_public_ParentsHome__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_OCCUPATIONDB, component: __WEBPACK_IMPORTED_MODULE_51_src_pages_public_OccupationDb__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_OCCUPATION, component: __WEBPACK_IMPORTED_MODULE_52_src_pages_public_Occupation__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_USERS, component: __WEBPACK_IMPORTED_MODULE_19_src_pages_admin_Users__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_USER, component: __WEBPACK_IMPORTED_MODULE_20_src_pages_admin_AddEditUser__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_AUDIO, component: __WEBPACK_IMPORTED_MODULE_21__pages_admin_AudioTest__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_CLIENTS, component: __WEBPACK_IMPORTED_MODULE_22_src_pages_admin_Clients__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_MATCHMAKER, component: __WEBPACK_IMPORTED_MODULE_54_src_pages_admin_Matchmaker__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_SYNC_MATCHMAKER_DATA, component: __WEBPACK_IMPORTED_MODULE_55_src_pages_admin_SyncMatchmakerData__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_CLIENT, component: __WEBPACK_IMPORTED_MODULE_23_src_pages_admin_AddEditClient__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_CLIENT_SUBSCRIPTION, component: __WEBPACK_IMPORTED_MODULE_24_src_pages_admin_AddEditClientSubscription__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_STATEMENTS, component: __WEBPACK_IMPORTED_MODULE_25_src_pages_admin_Statements__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_STUDENT_STATEMENTS, component: __WEBPACK_IMPORTED_MODULE_26_src_pages_admin_StudentStatements__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_STATEMENT, component: __WEBPACK_IMPORTED_MODULE_27_src_pages_admin_AddEditStatement__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_DISTRICTS, component: __WEBPACK_IMPORTED_MODULE_28_src_pages_admin_Districts__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_DISTRICT, component: __WEBPACK_IMPORTED_MODULE_29_src_pages_admin_AddEditDistrict__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_SYNC_MANAGEMENT, component: __WEBPACK_IMPORTED_MODULE_30_src_pages_admin_SyncManagement__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_SCHOOLS, component: __WEBPACK_IMPORTED_MODULE_31_src_pages_admin_Schools__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_SCHOOL, component: __WEBPACK_IMPORTED_MODULE_32_src_pages_admin_AddEditSchool__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ACTIVITIES, component: __WEBPACK_IMPORTED_MODULE_33_src_pages_admin_Activities__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY, component: __WEBPACK_IMPORTED_MODULE_34_src_pages_admin_AddEditActivity__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION, component: __WEBPACK_IMPORTED_MODULE_35_src_pages_admin_AddEditActivityQuestion__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION_CATEGORY, component: __WEBPACK_IMPORTED_MODULE_36_src_pages_admin_AddEditActivityQuestionCategory__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION_RESPONSE, component: __WEBPACK_IMPORTED_MODULE_37_src_pages_admin_AddEditActivityQuestionResponse__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_CLASSROOMS, component: __WEBPACK_IMPORTED_MODULE_39_src_pages_admin_Classrooms__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_CLASSROOM, component: __WEBPACK_IMPORTED_MODULE_40_src_pages_admin_AddEditClassroom__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ACADEMICS, component: __WEBPACK_IMPORTED_MODULE_41_src_pages_admin_Academics__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_ACADEMIC_STANDARD, component: __WEBPACK_IMPORTED_MODULE_42_src_pages_admin_AddEditAcademicStandard__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_ACADEMIC_STANDARD_FRAMEWORK, component: __WEBPACK_IMPORTED_MODULE_43_src_pages_admin_AddEditAcademicStandardFramework__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_RESET_PASSWORD, component: __WEBPACK_IMPORTED_MODULE_44_src_pages_admin_ResetPassword__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_REPORTS, component: __WEBPACK_IMPORTED_MODULE_45_src_pages_admin_AdminReports__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_REPORT_STUDENT_ACTIVITY_DETAIL, component: __WEBPACK_IMPORTED_MODULE_46_src_pages_admin_reports_StudentActivityDetailReport__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_REPORT_STUDENT_PLANET_COMPLETION, component: __WEBPACK_IMPORTED_MODULE_74_src_pages_admin_reports_StudentPlanetCompletionReport__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_REPORT_STUDENT_GAME_COMPLETION, component: __WEBPACK_IMPORTED_MODULE_75_src_pages_admin_reports_StudentGameCompletionReport__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_REPORT_STUDENT_STATEMENT, component: __WEBPACK_IMPORTED_MODULE_76_src_pages_admin_reports_StudentStatementReport__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_SUMMARY, component: __WEBPACK_IMPORTED_MODULE_38_src_pages_admin_AddEditActivitySummary__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_STUDENT_VIEWS, component: __WEBPACK_IMPORTED_MODULE_47_src_pages_admin_StudentViews__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_RESOURCES, component: __WEBPACK_IMPORTED_MODULE_48_src_pages_admin_DownloadableResources__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_LESSON_PLANS, component: __WEBPACK_IMPORTED_MODULE_49_src_pages_admin_LessonPlans__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_EMULATE_USER, component: __WEBPACK_IMPORTED_MODULE_50_src_pages_admin_EmulateUser__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_SYNC_RESULTS, component: __WEBPACK_IMPORTED_MODULE_53_src_pages_admin_AdminSyncResults__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_REPORT_CLASSROOM, component: __WEBPACK_IMPORTED_MODULE_66_src_pages_admin_ClassroomReport__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_REPORT_PRINCIPAL, component: __WEBPACK_IMPORTED_MODULE_67_src_pages_admin_PrincipalReport__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_REPORT_SUPERINTENDENT, component: __WEBPACK_IMPORTED_MODULE_68_src_pages_admin_SuperintendentReport__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_HOLLAND_AREAS_GUIDE, component: __WEBPACK_IMPORTED_MODULE_120_src_pages_public_HollandAreasGuide__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_UNIVERSAL_USER_SEARCH, component: __WEBPACK_IMPORTED_MODULE_70_src_pages_admin_UniversalUserSearch__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_UNIVERSAL_USER_SEARCH_STUDENT_STATEMENTS, component: __WEBPACK_IMPORTED_MODULE_71_src_pages_admin_universalSearch_USStudentStatements__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ADMIN_UNIVERSAL_USER_SEARCH_RESET_PASSWORD, component: __WEBPACK_IMPORTED_MODULE_72_src_pages_admin_universalSearch_USResetPassword__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].STUDENT_HOME, component: __WEBPACK_IMPORTED_MODULE_78_src_pages_student_SpaceStationHome__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_8_src_layouts_spacestation_SpaceStationLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].STUDENT_PLANET, component: __WEBPACK_IMPORTED_MODULE_77_src_pages_student_PlanetHome__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_9_src_layouts_planet_PlanetLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].STUDENT_RETURN, component: __WEBPACK_IMPORTED_MODULE_113_src_pages_student_scenes_SpaceStationReturn__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_8_src_layouts_spacestation_SpaceStationLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAME_HOME, component: __WEBPACK_IMPORTED_MODULE_93_src_pages_game_Home__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAME_GRADE_5_R, component: __WEBPACK_IMPORTED_MODULE_95_src_pages_game_LandscapingGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].DIAGNOSIS_GAME, component: __WEBPACK_IMPORTED_MODULE_103_src_pages_game_DiagnosisGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].COLLAGE_GAME, component: __WEBPACK_IMPORTED_MODULE_110_src_pages_game_CollageGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAME_GRADE_5_S, component: __WEBPACK_IMPORTED_MODULE_96_src_pages_game_PlatformerGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].COLONY_GAME, component: __WEBPACK_IMPORTED_MODULE_102_src_pages_game_ColonyGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].PUZZLE_SLIDER, component: __WEBPACK_IMPORTED_MODULE_97_src_pages_game_PuzzleSliderGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].PLUMBING_PLATFORMER, component: __WEBPACK_IMPORTED_MODULE_109_src_pages_game_PlumbingGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAME_GRADE_4_I, component: __WEBPACK_IMPORTED_MODULE_99_src_pages_game_UniversityGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].PHASER_PAINT_GAME, component: __WEBPACK_IMPORTED_MODULE_94_src_pages_game_PaintGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAME_GRADE_4_S, component: __WEBPACK_IMPORTED_MODULE_104_src_pages_game_DinerGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAME_GRADE_4_E, component: __WEBPACK_IMPORTED_MODULE_101_src_pages_game_CareerFairGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ORGANIZE_DESK_GAME, component: __WEBPACK_IMPORTED_MODULE_100_src_pages_game_OrganizeDeskGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].DISEASED_TREES_GAME, component: __WEBPACK_IMPORTED_MODULE_98_src_pages_game_DiseasedTreesGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].XRAY_SLIDER, component: __WEBPACK_IMPORTED_MODULE_111_src_pages_game_XraySliderGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAME_GRADE_3_A, component: __WEBPACK_IMPORTED_MODULE_108_src_pages_game_DesertTerraformGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].FIT_FIVE_GAME, component: __WEBPACK_IMPORTED_MODULE_106_src_pages_game_FitFiveGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].HOTEL_AURORA_GAME, component: __WEBPACK_IMPORTED_MODULE_107_src_pages_game_HotelAuroraGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].WAREHOUSE_GAME, component: __WEBPACK_IMPORTED_MODULE_105_src_pages_game_WarehouseGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].MAIL_DELIVERY, component: __WEBPACK_IMPORTED_MODULE_118_src_pages_game_MailDeliveryGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].JIGSAW_PUZZLE, component: __WEBPACK_IMPORTED_MODULE_116__pages_game_JigsawPuzzleGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].PROGRAM_ROBOT, component: __WEBPACK_IMPORTED_MODULE_114_src_pages_game_ProgramRobotGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ROCKET_REPAIR, component: __WEBPACK_IMPORTED_MODULE_115_src_pages_game_RocketRepairGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].SHIP_PAINTING, component: __WEBPACK_IMPORTED_MODULE_112_src_pages_game_ShipPaintingGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].SPACE_PORT, component: __WEBPACK_IMPORTED_MODULE_117_src_pages_game_SpacePortGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].CITY_BUILDER, component: __WEBPACK_IMPORTED_MODULE_119_src_pages_game_CityBuilderGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].VENDING_MACHINE, component: __WEBPACK_IMPORTED_MODULE_122_src_pages_game_VendingMachineGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].SEEK_AND_FIND, component: __WEBPACK_IMPORTED_MODULE_123_src_pages_game_SeekAndFindGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].SPACE_PETS, component: __WEBPACK_IMPORTED_MODULE_124_src_pages_game_SpacePetsGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].OCEAN_CLEANUP, component: __WEBPACK_IMPORTED_MODULE_125_src_pages_game_OceanCleanupGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].CAKE_DECORATING, component: __WEBPACK_IMPORTED_MODULE_127_src_pages_game_CakeDecoratingGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].LIBRARIAN, component: __WEBPACK_IMPORTED_MODULE_128_src_pages_game_LibrarianGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ZOO, component: __WEBPACK_IMPORTED_MODULE_129_src_pages_game_ZooGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].WAITER_MEMORY, component: __WEBPACK_IMPORTED_MODULE_126_src_pages_game_WaiterMemoryGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].UNIFORM_DESIGN, component: __WEBPACK_IMPORTED_MODULE_130_src_pages_game_UniformDesignGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].FIND_HELPERS, component: __WEBPACK_IMPORTED_MODULE_132_src_pages_game_FindHelpersGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].TICKET_TAKER, component: __WEBPACK_IMPORTED_MODULE_131_src_pages_game_TicketTakerGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GROCERY_BAGGER, component: __WEBPACK_IMPORTED_MODULE_133_src_pages_game_GroceryBaggerGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].CONSTRUCTION_MAZE, component: __WEBPACK_IMPORTED_MODULE_134_src_pages_game_ConstructionMazeGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].STARBALL, component: __WEBPACK_IMPORTED_MODULE_135_src_pages_game_StarballGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].RIDE_MECHANIC, component: __WEBPACK_IMPORTED_MODULE_136_src_pages_game_RideMechanicGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].FOSSIL_FINDER, component: __WEBPACK_IMPORTED_MODULE_137_src_pages_game_FossilFinderGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].FACE_PAINTING, component: __WEBPACK_IMPORTED_MODULE_138_src_pages_game_FacePaintingGame__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_PHASER_DEMO, component: __WEBPACK_IMPORTED_MODULE_79_src_pages_game_demos_PhaserGameDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_PHASER_DRAGDROP_DEMO, component: __WEBPACK_IMPORTED_MODULE_80_src_pages_game_demos_DragDropDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_PHASER_PAINT_DEMO, component: __WEBPACK_IMPORTED_MODULE_81_src_pages_game_demos_ComplexPaintDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_PHASER_PLATFORMER_DEMO, component: __WEBPACK_IMPORTED_MODULE_82_src_pages_game_demos_PlatformerDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_PHASER_ANIMATION_DEMO, component: __WEBPACK_IMPORTED_MODULE_83_src_pages_game_demos_AnimationDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_MULTI_SCENE_DEMO, component: __WEBPACK_IMPORTED_MODULE_84_src_pages_game_demos_MultiSceneDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_GAMEPAD_TEST, component: __WEBPACK_IMPORTED_MODULE_87_src_pages_game_demos_GamePadDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_PATH_FINDING_DEMO, component: __WEBPACK_IMPORTED_MODULE_85_src_pages_game_demos_PathFindingDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_IMAGE_PASTING_DEMO, component: __WEBPACK_IMPORTED_MODULE_86_src_pages_game_demos_ImagePasteDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_CAMERA_ANIMATION_DEMO, component: __WEBPACK_IMPORTED_MODULE_88_src_pages_game_demos_CameraAnimationsDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_MODAL_BUTTON_DEMO, component: __WEBPACK_IMPORTED_MODULE_89_src_pages_game_demos_ModalButtonDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_NPC_FOLLOWING_DEMO, component: __WEBPACK_IMPORTED_MODULE_90_src_pages_game_demos_NPCFollowingDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_LANDSCAPING, component: __WEBPACK_IMPORTED_MODULE_91_src_pages_game_demos_LandscapingDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].GAMEDEMO_HOW_TO_PLAY_SCENE, component: __WEBPACK_IMPORTED_MODULE_92_src_pages_game_demos_HowToPlaySceneDemo__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].EXAMPLE_REDUX, component: __WEBPACK_IMPORTED_MODULE_60_src_pages_examples_ReduxTest__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].EXAMPLE_MULTILINGUAL, component: __WEBPACK_IMPORTED_MODULE_61_src_pages_examples_MultilingualTest__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_4_src_layouts_admin_AdminLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].EXAMPLES_VIDEO, component: __WEBPACK_IMPORTED_MODULE_62_src_pages_examples_Video__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].EXAMPLES_FORM, component: __WEBPACK_IMPORTED_MODULE_63_src_pages_examples_FormTest__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_7_src_layouts_game_GameLayout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].WHO_AM_I, component: __WEBPACK_IMPORTED_MODULE_64_src_pages_developer_WhoAmI__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].DIAGNOSTICS, component: __WEBPACK_IMPORTED_MODULE_65_src_pages_developer_Diagnostics__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_5_src_layouts_user_UserLayout__["a" /* default */], requireLogin: true }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].ERROR_PAGE, component: __WEBPACK_IMPORTED_MODULE_17_src_pages_public_ErrorPage__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */], requireLogin: false }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].PROD_ERROR_PAGE, component: __WEBPACK_IMPORTED_MODULE_18_src_pages_public_ProdErrorPage__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */], requireLogin: false }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { exact: true, path: __WEBPACK_IMPORTED_MODULE_2__Routes__["a" /* default */].PAGE_NOT_FOUND, component: __WEBPACK_IMPORTED_MODULE_16_src_pages_public_PageNotFound__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */], requireLogin: false }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__LayoutComponent__["a" /* default */], { path: undefined, component: __WEBPACK_IMPORTED_MODULE_16_src_pages_public_PageNotFound__["a" /* default */], layout: __WEBPACK_IMPORTED_MODULE_6_src_layouts_public_PublicLayout__["a" /* default */] }));
/* harmony default export */ __webpack_exports__["a"] = (RouteLoader);


/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_alert__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_alert_style_index_js__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_core_ConfigureHistory__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_api_AccountApiController__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_providers_TelemetryService__ = __webpack_require__(148);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

















var LayoutComponent = /** @class */ (function (_super) {
    __extends(LayoutComponent, _super);
    function LayoutComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.interval = null;
        Object(__WEBPACK_IMPORTED_MODULE_9_src_utils_BindThisHelper__["a" /* default */])(_this, LayoutComponent.prototype);
        _this.state = {
            isLoading: true,
            isIntercomStarted: false
        };
        __WEBPACK_IMPORTED_MODULE_10_src_core_ConfigureHistory__["a" /* default */].listen(function (location, action) {
            if (!_this.state.isIntercomStarted) {
                return;
            }
            // Update intercom since we "changed pages". Yay single page apps
            _this.updateIntercom();
        });
        return _this;
    }
    LayoutComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.activeLanguage !== this.props.activeLanguage) {
            // JB: This will capture all language changes! This is used to set the Languages and TranslateApi with a fresh translate()
            if (__WEBPACK_IMPORTED_MODULE_12_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
                console.warn("Layout: Language changed");
            }
            // This has to be here, otherwise the translate() function will not have the proper active language
            var language = __WEBPACK_IMPORTED_MODULE_14_src_constants_Languages__["a" /* default */].FindByCode(nextProps.activeLanguage.code);
            __WEBPACK_IMPORTED_MODULE_14_src_constants_Languages__["a" /* default */].SetActiveLanguage(language, nextProps.translate);
        }
        // Start and stop intercom
        if (nextProps.User.roleID !== __WEBPACK_IMPORTED_MODULE_15_src_constants_Roles__["a" /* Roles */].Student.id) {
            if (nextProps.User.state === "finished" && !this.state.isIntercomStarted) {
                // Start intercom
                this.startIntercom();
                this.setState({ isIntercomStarted: true });
            }
            else if (nextProps.User.state === "none" && this.state.isIntercomStarted) {
                this.stopIntercom();
                this.setState({ isIntercomStarted: false });
            }
        }
    };
    LayoutComponent.prototype.componentDidMount = function () {
        // Note to self: Component is only mounted once and never re-mounted in pretty much any situation
        var _this = this;
        // Start the keep alive. In debug mode because kuder has not indicated otherwise. Might also want to have this be 5 or even 10 minutes
        if (__WEBPACK_IMPORTED_MODULE_12_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
            // Include some insanity checking
            if (this.interval != null) {
                clearInterval(this.interval);
            }
            this.interval = setInterval(function () {
                if (_this.props.User.state === "failed") {
                    // Nothing to KeepAlive, skip
                    return;
                }
                // No need to log a success and failures just redirect automagically to login
                __WEBPACK_IMPORTED_MODULE_13_src_api_AccountApiController__["a" /* default */].keepAlive();
            }, 180000);
        }
        if (this.props.User.state === "none") {
            this.props.softLogin().then(function (result) {
                // Set the users language
                if (_this.props.User.cultureCode != null) {
                    // JB: This will set the language when this component is first rendered and not after that
                    // JB: This is hit on refresh and not on the login page, since it handles its own stuff
                    var language = __WEBPACK_IMPORTED_MODULE_14_src_constants_Languages__["a" /* default */].FindByCode(_this.props.User.cultureCode);
                    _this.props.setActiveLanguage(language.code);
                }
                _this.setState({
                    isLoading: false
                });
            });
        }
        else {
            this.setState({
                isLoading: false
            });
        }
    };
    LayoutComponent.prototype.getIntercomUserData = function () {
        var _a, _b, _c, _d;
        var isEmulating = this.props.User.isEmulating;
        var roleId = isEmulating ? (_a = this.props.User.emulationInfo) === null || _a === void 0 ? void 0 : _a.roleId : (_b = this.props.User) === null || _b === void 0 ? void 0 : _b.roleID;
        var userRole = __WEBPACK_IMPORTED_MODULE_15_src_constants_Roles__["a" /* Roles */].FindById(roleId);
        var isKuderAdmin = userRole === __WEBPACK_IMPORTED_MODULE_15_src_constants_Roles__["a" /* Roles */].KuderAdmin;
        var clientId = isKuderAdmin ? 0 : isEmulating ? (_c = this.props.User.emulationInfo) === null || _c === void 0 ? void 0 : _c.clientId : this.props.User.clientId;
        var clientName = isKuderAdmin ? "N/A" : isEmulating ? (_d = this.props.User.emulationInfo) === null || _d === void 0 ? void 0 : _d.clientName : this.props.User.clientName;
        var schoolLevel = this.props.User.schoolName;
        var districtName = this.props.User.districtName;
        var stateName = this.props.User.stateName;
        return {
            app_id: "u0ob3l49",
            name: this.props.User.firstName + " " + this.props.User.lastName,
            email: this.props.User.email,
            // created_at: Date.now(), // Signup date as a Unix timestamp
            user_id: this.props.User.userId,
            School_Level: schoolLevel,
            District_Level: districtName,
            State_Level: stateName,
            application: "Galaxy",
            company: {
                id: clientId,
                name: clientName
            },
            user_role: userRole.display
        };
    };
    LayoutComponent.prototype.startIntercom = function () {
        var _this = this;
        var w = window;
        var userData = this.getIntercomUserData();
        w.Intercom('boot', userData);
        w.Intercom('onShow', function () {
            __WEBPACK_IMPORTED_MODULE_16_src_providers_TelemetryService__["a" /* Track */].OpenIntercom(_this.props.User.userId);
        });
    };
    LayoutComponent.prototype.updateIntercom = function () {
        var w = window;
        var userData = this.getIntercomUserData();
        w.Intercom('update', userData);
    };
    LayoutComponent.prototype.stopIntercom = function () {
        var w = window;
        w.Intercom('shutdown');
    };
    LayoutComponent.prototype.getComponent = function (routerContext) {
        var spinner = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_spin__["a" /* default */], { key: "fancySpinnerOfDoom", className: "centered very-large-spinner" });
        if (this.state.isLoading) {
            return spinner;
        }
        if (this.props.requireLogin) {
            if (this.props.User.state === "failed" || this.props.Constants.state === "error") {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Redirect"], { push: true, to: __WEBPACK_IMPORTED_MODULE_8__Routes__["a" /* default */].LOGIN, from: routerContext.location.pathname });
            }
            else if (this.props.User.state === "none" || this.props.User.state === "loading") {
                // JB (12/7/18): Removed other redux checks as login will now load all before switching to complete
                return spinner;
            }
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](this.props.layout, __assign({}, routerContext),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](this.props.component, __assign({}, routerContext, { key: location.href }))));
    };
    LayoutComponent.prototype.render = function () {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { key: "routeKey", exact: true, path: this.props.path, render: function (routerContext) { return _this.getComponent(routerContext); } });
    };
    return LayoutComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        softLogin: function () { return __WEBPACK_IMPORTED_MODULE_11_src_redux_UserActions__["a" /* default */].SoftLogin(dispatch); },
    });
}
function mapStateToProps(state) {
    return {
        User: state.User,
        Constants: state.Constants,
        Mission: state.Mission,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["d" /* withLocalize */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(LayoutComponent)));


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/reward-r.dbe1a475.png";

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/r-small.a8f3fcf2.png";

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/reward-i.ff530e3f.png";

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/i-small.0436b83b.png";

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/reward-a.a3ff645a.png";

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/a-small.ae903afa.png";

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/reward-s.7941e04e.png";

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/s-small.0cc4008e.png";

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/reward-e.35fae371.png";

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/e-small.c35b0444.png";

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/reward-c.dee65b0c.png";

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/c-small.059ca445.png";

/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_api_UserApiController__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_RoleApiController__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_api_GradeApiController__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_api_CultureApiController__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_api_FileApiController__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_CheckpointApiController__ = __webpack_require__(1880);






var ConstantAction = /** @class */ (function () {
    function ConstantAction() {
        // Dont be that guy
        throw new Error("NOOOO");
    }
    ConstantAction.GetRolesPromise = function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_1_src_api_RoleApiController__["a" /* default */].getAllRoles().then(function (result) {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_ROLES_CONSTANTS", data: result.data });
            return true;
        });
    };
    ConstantAction.GetGradesPromise = function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_2_src_api_GradeApiController__["a" /* default */].getAllGrades().then(function (result) {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_GRADES_CONSTANTS", data: result.data });
            return true;
        });
    };
    ConstantAction.GetCheckpointsPromise = function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_5_src_api_CheckpointApiController__["a" /* default */].getAllCheckpoints().then(function (result) {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_CHECKPOINTS_CONSTANTS", data: result.data });
            return true;
        });
    };
    ConstantAction.GetLanguagesPromise = function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_3_src_api_CultureApiController__["a" /* default */].getAllCultures().then(function (result) {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_LANGUAGES_CONSTANTS", data: result.data });
            return true;
        });
    };
    ConstantAction.GetCulturePromise = function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_0_src_api_UserApiController__["a" /* default */].getUserCultures().then(function (result) {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_CULTURE_CONSTANTS", data: result.data });
            return true;
        });
    };
    ConstantAction.GetConfigPromise = function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_4_src_api_FileApiController__["a" /* default */].getContentUri().then(function (result) {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_CONFIG_CONSTANTS", data: result.data });
            return true;
        });
    };
    ConstantAction.LoadConstants = function (dispatch) {
        dispatch({ type: "UPDATE_STATE_CONSTANTS", data: "loading" });
        // Roles
        var rolesFetch = this.GetRolesPromise(dispatch);
        // Grades
        var gradesFetch = this.GetGradesPromise(dispatch);
        // Grades
        var checkpointsFetch = this.GetCheckpointsPromise(dispatch);
        // Languages
        var languagesFetch = this.GetLanguagesPromise(dispatch);
        // User Cultures!
        var culturesFetch = this.GetCulturePromise(dispatch);
        // App Config
        var configFetch = this.GetConfigPromise(dispatch);
        return Promise.all([rolesFetch, gradesFetch, checkpointsFetch, languagesFetch, culturesFetch, configFetch]).then(function (x) {
            var result = x.reduce(function (first, second) {
                return first && second;
            }, true);
            dispatch({ type: "UPDATE_STATE_CONSTANTS", data: result ? "finished" : "error" });
            return result;
        });
    };
    /** Because emulation hates you and is complicated */
    ConstantAction.LoadConstantsEmulation = function (dispatch) {
        // User Cultures!
        var culturesFetch = this.GetCulturePromise(dispatch);
        // Not 100% necessary but its consistent with the other related methods
        return Promise.all([culturesFetch]).then(function (x) {
            var result = x.reduce(function (first, second) {
                return first && second;
            }, true);
            dispatch({ type: "UPDATE_STATE_CONSTANTS", data: result ? "finished" : "error" });
            return result;
        });
    };
    return ConstantAction;
}());
/* harmony default export */ __webpack_exports__["a"] = (ConstantAction);


/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RoleApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var RoleApiController = /** @class */ (function () {
    function RoleApiController() {
        // get: Role/GetAllRoles
        this.RouteGetAllRoles = function () { return "Role/GetAllRoles"; };
    }
    RoleApiController.prototype.getAllRoles = function (requestOptions) {
        var url = this.RouteGetAllRoles();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    return RoleApiController;
}());

var service = new RoleApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GradeApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var GradeApiController = /** @class */ (function () {
    function GradeApiController() {
        // get: Grade/GetAllGrades
        this.RouteGetAllGrades = function () { return "Grade/GetAllGrades"; };
    }
    GradeApiController.prototype.getAllGrades = function (requestOptions) {
        var url = this.RouteGetAllGrades();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    return GradeApiController;
}());

var service = new GradeApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CultureApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var CultureApiController = /** @class */ (function () {
    function CultureApiController() {
        // get: Culture/GetAllCultures
        this.RouteGetAllCultures = function () { return "Culture/GetAllCultures"; };
    }
    CultureApiController.prototype.getAllCultures = function (requestOptions) {
        var url = this.RouteGetAllCultures();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    return CultureApiController;
}());

var service = new CultureApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FileApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var FileApiController = /** @class */ (function () {
    function FileApiController() {
        // get: File/GetVideoPath?fileName=${encodeURIComponent(fileName)}
        this.RouteGetVideoPath = function (fileName) { return "File/GetVideoPath?fileName=" + encodeURIComponent(fileName); };
        // get: File/GetAudioPath?fileName=${encodeURIComponent(fileName)}
        this.RouteGetAudioPath = function (fileName) { return "File/GetAudioPath?fileName=" + encodeURIComponent(fileName); };
        // get: File/GetContentSas
        this.RouteGetContentUri = function () { return "File/GetContentSas"; };
    }
    FileApiController.prototype.getVideoPath = function (fileName, requestOptions) {
        var url = this.RouteGetVideoPath(fileName);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    FileApiController.prototype.getAudioPath = function (fileName, requestOptions) {
        var url = this.RouteGetAudioPath(fileName);
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    FileApiController.prototype.getContentUri = function (requestOptions) {
        var url = this.RouteGetContentUri();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    return FileApiController;
}());

var service = new FileApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckpointApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var CheckpointApiController = /** @class */ (function () {
    function CheckpointApiController() {
        // get: Checkpoint/GetAllCheckpoints
        this.RouteGetAllCheckpoints = function () { return "Checkpoint/GetAllCheckpoints"; };
    }
    CheckpointApiController.prototype.getAllCheckpoints = function (requestOptions) {
        var url = this.RouteGetAllCheckpoints();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    return CheckpointApiController;
}());

var service = new CheckpointApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Initialization__ = __webpack_require__(757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Initialization__["a"]; });
/* unused harmony reexport Telemetry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApplicationInsightsContainer__ = __webpack_require__(1935);
/* unused harmony reexport ApplicationInsightsContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* unused harmony reexport AppInsightsCore */
/* unused harmony reexport LoggingSeverity */
/* unused harmony reexport _InternalMessageId */
/* unused harmony reexport PerfEvent */
/* unused harmony reexport PerfManager */
/* unused harmony reexport doPerf */
/* unused harmony reexport NotificationManager */
/* unused harmony reexport BaseTelemetryPlugin */
/* unused harmony reexport BaseCore */
/* unused harmony reexport CoreUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* unused harmony reexport Util */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["B"]; });
/* unused harmony reexport Event */
/* unused harmony reexport Exception */
/* unused harmony reexport Metric */
/* unused harmony reexport PageView */
/* unused harmony reexport PageViewPerformance */
/* unused harmony reexport RemoteDependencyData */
/* unused harmony reexport Trace */
/* unused harmony reexport DistributedTracingModes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_channel_js__ = __webpack_require__(775);
/* unused harmony reexport Sender */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_analytics_js__ = __webpack_require__(758);
/* unused harmony reexport ApplicationAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__microsoft_applicationinsights_properties_js__ = __webpack_require__(781);
/* unused harmony reexport PropertiesPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__microsoft_applicationinsights_dependencies_js__ = __webpack_require__(491);
/* unused harmony reexport DependenciesPlugin */
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// Re-exports






//# sourceMappingURL=applicationinsights-web.js.map

/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnalyticsPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DynamicConstants__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Telemetry_PageViewManager__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Telemetry_PageViewPerformanceManager__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Telemetry_PageVisitTimeManager__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Timing__ = __webpack_require__(1913);
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/









var strEvent = "event";
function _dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
    }
}
function _getReason(error) {
    if (error && error.reason) {
        var reason = error.reason;
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_13" /* isString */])(reason) && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(reason[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */])) {
            return reason[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */]();
        }
        return Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(reason);
    }
    // Pass the original object down which will eventually get evaluated for any message or description
    return error || "";
}
var MinMilliSeconds = 60000;
function _configMilliseconds(value, defValue) {
    value = value || defValue;
    if (value < MinMilliSeconds) {
        value = MinMilliSeconds;
    }
    return value;
}
function _getDefaultConfig(config) {
    if (!config) {
        config = {};
    }
    // set default values
    config.sessionRenewalMs = _configMilliseconds(config.sessionRenewalMs, 30 * 60 * 1000);
    config.sessionExpirationMs = _configMilliseconds(config.sessionExpirationMs, 24 * 60 * 60 * 1000);
    config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["h" /* _DYN_DISABLE_EXCEPTION_TR0 */] /* @min:%2edisableExceptionTracking */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["h" /* _DYN_DISABLE_EXCEPTION_TR0 */] /* @min:%2edisableExceptionTracking */]);
    config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["b" /* _DYN_AUTO_TRACK_PAGE_VISI1 */] /* @min:%2eautoTrackPageVisitTime */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["b" /* _DYN_AUTO_TRACK_PAGE_VISI1 */] /* @min:%2eautoTrackPageVisitTime */]);
    config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["D" /* _DYN_OVERRIDE_PAGE_VIEW_D2 */] /* @min:%2eoverridePageViewDuration */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["D" /* _DYN_OVERRIDE_PAGE_VIEW_D2 */] /* @min:%2eoverridePageViewDuration */]);
    config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["l" /* _DYN_ENABLE_UNHANDLED_PRO3 */] /* @min:%2eenableUnhandledPromiseRejectionTracking */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["l" /* _DYN_ENABLE_UNHANDLED_PRO3 */] /* @min:%2eenableUnhandledPromiseRejectionTracking */]);
    if (isNaN(config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_SAMPLING_PERCENTAGE */] /* @min:%2esamplingPercentage */]) || config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_SAMPLING_PERCENTAGE */] /* @min:%2esamplingPercentage */] <= 0 || config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_SAMPLING_PERCENTAGE */] /* @min:%2esamplingPercentage */] >= 100) {
        config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_SAMPLING_PERCENTAGE */] /* @min:%2esamplingPercentage */] = 100;
    }
    config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["w" /* _DYN_IS_STORAGE_USE_DISAB4 */] /* @min:%2eisStorageUseDisabled */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["w" /* _DYN_IS_STORAGE_USE_DISAB4 */] /* @min:%2eisStorageUseDisabled */]);
    config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_IS_BROWSER_LINK_TRAC5 */] /* @min:%2eisBrowserLinkTrackingEnabled */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_IS_BROWSER_LINK_TRAC5 */] /* @min:%2eisBrowserLinkTrackingEnabled */]);
    config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["k" /* _DYN_ENABLE_AUTO_ROUTE_TR6 */] /* @min:%2eenableAutoRouteTracking */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["k" /* _DYN_ENABLE_AUTO_ROUTE_TR6 */] /* @min:%2eenableAutoRouteTracking */]);
    config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["B" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */] = config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["B" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */] || "";
    config.enableDebug = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config.enableDebug);
    config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DISABLE_FLUSH_ON_BEF7 */] /* @min:%2edisableFlushOnBeforeUnload */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DISABLE_FLUSH_ON_BEF7 */] /* @min:%2edisableFlushOnBeforeUnload */]);
    config.disableFlushOnUnload = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config.disableFlushOnUnload, config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DISABLE_FLUSH_ON_BEF7 */] /* @min:%2edisableFlushOnBeforeUnload */]);
    return config;
}
function _updateStorageUsage(extConfig) {
    // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
    // reset based if the configuration option is provided
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_15" /* isUndefined */])(extConfig[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["w" /* _DYN_IS_STORAGE_USE_DISAB4 */] /* @min:%2eisStorageUseDisabled */])) {
        if (extConfig[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["w" /* _DYN_IS_STORAGE_USE_DISAB4 */] /* @min:%2eisStorageUseDisabled */]) {
            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["Z" /* utlDisableStorage */])();
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["_0" /* utlEnableStorage */])();
        }
    }
}
var AnalyticsPlugin = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* __extendsFn */])(AnalyticsPlugin, _super);
    function AnalyticsPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["a" /* AnalyticsPluginIdentifier */]; // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _pageViewManager;
        var _pageViewPerformanceManager;
        var _pageVisitTimeManager;
        var _preInitTelemetryInitializers;
        var _isBrowserLinkTrackingEnabled;
        var _browserLinkInitializerAdded;
        var _enableAutoRouteTracking;
        var _historyListenerAdded;
        var _disableExceptionTracking;
        var _autoExceptionInstrumented;
        var _enableUnhandledPromiseRejectionTracking;
        var _autoUnhandledPromiseInstrumented;
        // Counts number of trackAjax invocations.
        // By default we only monitor X ajax call per view to avoid too much load.
        // Default value is set in config.
        // This counter keeps increasing even after the limit is reached.
        var _trackAjaxAttempts = 0;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        var _evtNamespace;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(AnalyticsPlugin, _this, function (_self, _base) {
            var _addHook = _base._addHook;
            _initDefaults();
            _self.getCookieMgr = function () {
                return Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_32" /* safeGetCookieMgr */])(_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */]);
            };
            _self.processTelemetry = function (env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
            _self.trackEvent = function (event, customProperties) {
                try {
                    var telemetryItem = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["I" /* createTelemetryItem */])(event, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["p" /* Event */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["f" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["p" /* Event */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["m" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), customProperties);
                    _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["P" /* _DYN_TRACK */] /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param   name    A string that identifies this event uniquely within the document.
             */
            _self.startTrackEvent = function (name) {
                try {
                    _eventTracking.start(name);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 29 /* _eInternalMessageId.StartTrackEventFailed */, "startTrackEvent failed, event will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param   name    The string you used to identify this event in `startTrackEvent`.
             * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackEvent = function (name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties, measurements);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 30 /* _eInternalMessageId.StopTrackEventFailed */, "stopTrackEvent failed, event will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param {ITraceTelemetry} trace
             * @param ICustomProperties.
             * @memberof ApplicationInsights
             */
            _self.trackTrace = function (trace, customProperties) {
                try {
                    var telemetryItem = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["I" /* createTelemetryItem */])(trace, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["D" /* Trace */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["f" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["D" /* Trace */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["m" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), customProperties);
                    _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["P" /* _DYN_TRACK */] /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param {IMetricTelemetry} metric input object argument. Only name and average are mandatory.
             * @param {{[key: string]: any}} customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             * @memberof ApplicationInsights
             */
            _self.trackMetric = function (metric, customProperties) {
                try {
                    var telemetryItem = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["I" /* createTelemetryItem */])(metric, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["t" /* Metric */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["f" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["t" /* Metric */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["m" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), customProperties);
                    _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["P" /* _DYN_TRACK */] /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 36 /* _eInternalMessageId.TrackMetricFailed */, "trackMetric failed, metric will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Q" /* _DYN_TRACK_PAGE_VIEW */] /* @min:%2etrackPageView */] = function (pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    _pageViewManager[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Q" /* _DYN_TRACK_PAGE_VIEW */] /* @min:%2etrackPageView */](inPv, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])({}, inPv.properties), inPv.measurements), customProperties));
                    if (_self.config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["b" /* _DYN_AUTO_TRACK_PAGE_VISI1 */] /* @min:%2eautoTrackPageVisitTime */]) {
                        _pageVisitTimeManager[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["R" /* _DYN_TRACK_PREVIOUS_PAGE_9 */] /* @min:%2etrackPreviousPageVisit */](inPv.name, inPv.uri);
                    }
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageView failed, page view will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView Page view item to be sent
             * @param properties Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties System level properties (Part A) that a user can add to the telemetry item
             */
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["L" /* _DYN_SEND_PAGE_VIEW_INTER10 */] /* @min:%2esendPageViewInternal */] = function (pageView, properties, systemProperties) {
                var doc = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["M" /* getDocument */])();
                if (doc) {
                    pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
                }
                var telemetryItem = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["I" /* createTelemetryItem */])(pageView, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["u" /* PageView */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["f" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["u" /* PageView */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["m" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), properties, systemProperties);
                _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["P" /* _DYN_TRACK */] /* @min:%2etrack */](telemetryItem);
                // reset ajaxes counter
                _trackAjaxAttempts = 0;
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["M" /* _DYN_SEND_PAGE_VIEW_PERFO11 */] /* @min:%2esendPageViewPerformanceInternal */] = function (pageViewPerformance, properties, systemProperties) {
                var telemetryItem = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["I" /* createTelemetryItem */])(pageViewPerformance, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["v" /* PageViewPerformance */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["f" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["v" /* PageViewPerformance */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["m" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), properties, systemProperties);
                _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["P" /* _DYN_TRACK */] /* @min:%2etrack */](telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */
            _self.trackPageViewPerformance = function (pageViewPerformance, customProperties) {
                var inPvp = pageViewPerformance || {};
                try {
                    _pageViewPerformanceManager[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["F" /* _DYN_POPULATE_PAGE_VIEW_P12 */] /* @min:%2epopulatePageViewPerformanceEvent */](inPvp);
                    _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["M" /* _DYN_SEND_PAGE_VIEW_PERFO11 */] /* @min:%2esendPageViewPerformanceInternal */](inPvp, customProperties);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageViewPerformance failed, page view will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */
            _self.startTrackPage = function (name) {
                try {
                    if (typeof name !== "string") {
                        var doc = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["M" /* getDocument */])();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 31 /* _eInternalMessageId.StartTrackFailed */, "startTrackPage failed, page view may not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
             * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackPage = function (name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["M" /* getDocument */])();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["T" /* getLocation */])();
                        url = loc && loc[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_HREF */] /* @min:%2ehref */] || "";
                    }
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_self.config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["b" /* _DYN_AUTO_TRACK_PAGE_VISI1 */] /* @min:%2eautoTrackPageVisitTime */]) {
                        _pageVisitTimeManager[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["R" /* _DYN_TRACK_PREVIOUS_PAGE_9 */] /* @min:%2etrackPreviousPageVisit */](name, url);
                    }
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 32 /* _eInternalMessageId.StopTrackFailed */, "stopTrackPage failed, page view will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            };
            /**
            * @ignore INTERNAL ONLY
            * @param exception
            * @param properties
            * @param systemProperties
            */
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["K" /* _DYN_SEND_EXCEPTION_INTER13 */] /* @min:%2esendExceptionInternal */] = function (exception, customProperties, systemProperties) {
                // Adding additional edge cases to handle
                // - Not passing anything (null / undefined)
                var theError = (exception && (exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["p" /* _DYN_EXCEPTION */] /* @min:%2eexception */] || exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["n" /* _DYN_ERROR */] /* @min:%2eerror */])) ||
                    // - Handle someone calling trackException based of v1 API where the exception was the Error
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_5" /* isError */])(exception) && exception ||
                    // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
                    //   is preserved and does not list ApplicationInsights code as the source
                    { name: (exception && typeof exception), message: exception || __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["T" /* strNotSpecified */] };
                // If no exception object was passed assign to an empty object to avoid internal exceptions
                exception = exception || {};
                var exceptionPartB = new __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["q" /* Exception */](_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), theError, exception.properties || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var telemetryItem = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["I" /* createTelemetryItem */])(exceptionPartB, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["q" /* Exception */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["f" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["q" /* Exception */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["m" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), customProperties, systemProperties);
                _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["P" /* _DYN_TRACK */] /* @min:%2etrack */](telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param {IExceptionTelemetry} exception   Object which contains exception to be sent
             * @param {{[key: string]: any}} customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             * @memberof ApplicationInsights
             */
            _self.trackException = function (exception, customProperties) {
                if (exception && !exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["p" /* _DYN_EXCEPTION */] /* @min:%2eexception */] && exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["n" /* _DYN_ERROR */] /* @min:%2eerror */]) {
                    exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["p" /* _DYN_EXCEPTION */] /* @min:%2eexception */] = exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["n" /* _DYN_ERROR */] /* @min:%2eerror */];
                }
                try {
                    _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["K" /* _DYN_SEND_EXCEPTION_INTER13 */] /* @min:%2esendExceptionInternal */](exception, customProperties);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 35 /* _eInternalMessageId.TrackExceptionFailed */, "trackException failed, exception will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param {IAutoExceptionTelemetry} exception
             * @memberof ApplicationInsights
             */
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN__ONERROR */] /* @min:%2e_onerror */] = function (exception) {
                var error = exception && exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["n" /* _DYN_ERROR */] /* @min:%2eerror */];
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["X" /* getWindow */])();
                        if (_window) {
                            evt = _window[strEvent];
                        }
                    }
                    var url = (exception && exception.url) || (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["M" /* getDocument */])() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["o" /* _DYN_ERROR_SRC */] /* @min:%2eerrorSrc */] || "window.onerror@" + url + ":" + (exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["y" /* _DYN_LINE_NUMBER */] /* @min:%2elineNumber */] || 0) + ":" + (exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["c" /* _DYN_COLUMN_NUMBER */] /* @min:%2ecolumnNumber */] || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["y" /* _DYN_LINE_NUMBER */] /* @min:%2elineNumber */] || 0,
                        columnNumber: exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["c" /* _DYN_COLUMN_NUMBER */] /* @min:%2ecolumnNumber */] || 0,
                        message: exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["A" /* _DYN_MESSAGE */] /* @min:%2emessage */]
                    };
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["P" /* isCrossOriginError */])(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["n" /* _DYN_ERROR */] /* @min:%2eerror */])) {
                        _sendCORSException(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["q" /* Exception */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["S" /* _DYN__CREATE_AUTO_EXCEPTI14 */] /* @min:%2eCreateAutoException */]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["y" /* _DYN_LINE_NUMBER */] /* @min:%2elineNumber */] || 0, exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["c" /* _DYN_COLUMN_NUMBER */] /* @min:%2ecolumnNumber */] || 0, error, evt, null, errorSrc), properties);
                    }
                    else {
                        if (!exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["o" /* _DYN_ERROR_SRC */] /* @min:%2eerrorSrc */]) {
                            exception[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["o" /* _DYN_ERROR_SRC */] /* @min:%2eerrorSrc */] = errorSrc;
                        }
                        _self.trackException({ exception: exception, severityLevel: 3 /* eSeverityLevel.Error */ }, properties);
                    }
                }
                catch (e) {
                    var errorString = error ? (error.name + ", " + error[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["A" /* _DYN_MESSAGE */] /* @min:%2emessage */]) : "null";
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 11 /* _eInternalMessageId.ExceptionWhileLoggingError */, "_onError threw exception while logging error, error will not be collected: "
                        + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e), errorString: errorString });
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["a" /* _DYN_ADD_TELEMETRY_INITIA15 */] /* @min:%2eaddTelemetryInitializer */] = function (telemetryInitializer) {
                if (_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */]) {
                    // Just add to the core
                    return _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["a" /* _DYN_ADD_TELEMETRY_INITIA15 */] /* @min:%2eaddTelemetryInitializer */](telemetryInitializer);
                }
                // Handle "pre-initialization" telemetry initializers (for backward compatibility)
                if (!_preInitTelemetryInitializers) {
                    _preInitTelemetryInitializers = [];
                }
                _preInitTelemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    return;
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(core)) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_40" /* throwError */])("Error initializing");
                }
                _base.initialize(config, core, extensions, pluginChain);
                if (config.storagePrefix) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["_7" /* utlSetStoragePrefix */])(config.storagePrefix);
                }
                try {
                    _evtNamespace = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_19" /* mergeEvtNamespace */])(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["z" /* createUniqueNamespace */])(_self.identifier), core.evtNamespace && core.evtNamespace());
                    if (_preInitTelemetryInitializers) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(_preInitTelemetryInitializers, function (initializer) {
                            core[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["a" /* _DYN_ADD_TELEMETRY_INITIA15 */] /* @min:%2eaddTelemetryInitializer */](initializer);
                        });
                        _preInitTelemetryInitializers = null;
                    }
                    var extConfig = _populateDefaults(config);
                    _updateStorageUsage(extConfig);
                    _pageViewPerformanceManager = new __WEBPACK_IMPORTED_MODULE_6__Telemetry_PageViewPerformanceManager__["a" /* PageViewPerformanceManager */](_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */]);
                    _pageViewManager = new __WEBPACK_IMPORTED_MODULE_5__Telemetry_PageViewManager__["a" /* PageViewManager */](_self, extConfig[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["D" /* _DYN_OVERRIDE_PAGE_VIEW_D2 */] /* @min:%2eoverridePageViewDuration */], _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */], _pageViewPerformanceManager);
                    _pageVisitTimeManager = new __WEBPACK_IMPORTED_MODULE_7__Telemetry_PageVisitTimeManager__["a" /* PageVisitTimeManager */](_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), function (pageName, pageUrl, pageVisitTime) { return trackPageVisitTime(pageName, pageUrl, pageVisitTime); });
                    _updateBrowserLinkTracking(extConfig, config);
                    _eventTracking = new __WEBPACK_IMPORTED_MODULE_8__Timing__["a" /* Timing */](_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), "trackEvent");
                    _eventTracking.action =
                        function (name, url, duration, properties, measurements) {
                            if (!properties) {
                                properties = {};
                            }
                            if (!measurements) {
                                measurements = {};
                            }
                            properties.duration = duration[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */]();
                            _self.trackEvent({ name: name, properties: properties, measurements: measurements });
                        };
                    // initialize page view timing
                    _pageTracking = new __WEBPACK_IMPORTED_MODULE_8__Timing__["a" /* Timing */](_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), "trackPageView");
                    _pageTracking.action = function (name, url, duration, properties, measurements) {
                        // duration must be a custom property in order for the collector to extract it
                        if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(properties)) {
                            properties = {};
                        }
                        properties.duration = duration[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */]();
                        var pageViewItem = {
                            name: name,
                            uri: url,
                            properties: properties,
                            measurements: measurements
                        };
                        _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["L" /* _DYN_SEND_PAGE_VIEW_INTER10 */] /* @min:%2esendPageViewInternal */](pageViewItem, properties);
                    };
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_1" /* hasWindow */])()) {
                        _updateExceptionTracking(extConfig);
                        _updateLocationChange(extConfig);
                    }
                }
                catch (e) {
                    // resetting the initialized state because of failure
                    _self.setInitialized(false);
                    throw e;
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                // Just register to remove all events associated with this namespace
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["H" /* eventOff */])(window, null, null, _evtNamespace);
                _initDefaults();
            };
            function _populateDefaults(config) {
                var ctx = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["x" /* createProcessTelemetryContext */])(null, config, _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */]);
                var identifier = _self.identifier;
                // load default values if specified
                var defaults = _getDefaultConfig(config);
                var extConfig = _self.config = ctx.getExtCfg(identifier);
                if (defaults !== undefined) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(defaults, function (field, value) {
                        // for each unspecified field, set the default value
                        extConfig[field] = ctx.getConfig(identifier, field, value);
                        if (extConfig[field] === undefined) {
                            extConfig = value;
                        }
                    });
                }
                return extConfig;
            }
            function _updateBrowserLinkTracking(extConfig, config) {
                _isBrowserLinkTrackingEnabled = extConfig[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_IS_BROWSER_LINK_TRAC5 */] /* @min:%2eisBrowserLinkTrackingEnabled */] || config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_IS_BROWSER_LINK_TRAC5 */] /* @min:%2eisBrowserLinkTrackingEnabled */];
                _addDefaultTelemetryInitializers();
            }
            /**
             * Log a page visit time
             * @param    pageName    Name of page
             * @param    pageVisitDuration Duration of visit to the page in milleseconds
             */
            function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = { PageName: pageName, PageUrl: pageUrl };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers() {
                if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                    var browserLinkPaths_1 = ["/browserLinkSignalR/", "/__browserLink/"];
                    var dropBrowserLinkRequests = function (envelope) {
                        if (_isBrowserLinkTrackingEnabled && envelope.baseType === __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["y" /* RemoteDependencyData */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["f" /* _DYN_DATA_TYPE */] /* @min:%2edataType */]) {
                            var remoteData = envelope.baseData;
                            if (remoteData) {
                                for (var i = 0; i < browserLinkPaths_1[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */]; i++) {
                                    if (remoteData.target && remoteData.target.indexOf(browserLinkPaths_1[i]) >= 0) {
                                        return false;
                                    }
                                }
                            }
                        }
                        return true;
                    };
                    _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["a" /* _DYN_ADD_TELEMETRY_INITIA15 */] /* @min:%2eaddTelemetryInitializer */](dropBrowserLinkRequests);
                    _browserLinkInitializerAdded = true;
                }
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["I" /* createTelemetryItem */])(exception, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["q" /* Exception */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["f" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["q" /* Exception */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["m" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), properties);
                _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["P" /* _DYN_TRACK */] /* @min:%2etrack */](telemetryItem);
            }
            function _updateExceptionTracking(extConfig) {
                var _window = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["X" /* getWindow */])();
                var locn = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["T" /* getLocation */])(true);
                _disableExceptionTracking = extConfig[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["h" /* _DYN_DISABLE_EXCEPTION_TR0 */] /* @min:%2edisableExceptionTracking */];
                if (!_disableExceptionTracking && !_autoExceptionInstrumented && !extConfig.autoExceptionInstrumented) {
                    // We want to enable exception auto collection and it has not been done so yet
                    _addHook(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["d" /* InstrumentEvent */])(_window, "onerror", {
                        ns: _evtNamespace,
                        rsp: function (callDetails, message, url, lineNumber, columnNumber, error) {
                            if (!_disableExceptionTracking && callDetails.rslt !== true) {
                                _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN__ONERROR */] /* @min:%2e_onerror */](__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["q" /* Exception */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["S" /* _DYN__CREATE_AUTO_EXCEPTI14 */] /* @min:%2eCreateAutoException */](message, url, lineNumber, columnNumber, error, callDetails.evt));
                            }
                        }
                    }, false));
                    _autoExceptionInstrumented = true;
                }
                _addUnhandledPromiseRejectionTracking(extConfig, _window, locn);
            }
            function _updateLocationChange(extConfig) {
                var win = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["X" /* getWindow */])();
                var locn = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["T" /* getLocation */])(true);
                _enableAutoRouteTracking = extConfig[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["k" /* _DYN_ENABLE_AUTO_ROUTE_TR6 */] /* @min:%2eenableAutoRouteTracking */] === true;
                /**
                 * Create a custom "locationchange" event which is triggered each time the history object is changed
                 */
                if (win && _enableAutoRouteTracking && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["Z" /* hasHistory */])()) {
                    var _history = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["Q" /* getHistory */])();
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(_history.pushState) && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(_history.replaceState) && typeof Event !== __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_39" /* strUndefined */]) {
                        _addHistoryListener(extConfig, win, _history, locn);
                    }
                }
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */] && _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */].getTraceCtx) {
                    distributedTraceCtx = _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */].getTraceCtx(false);
                }
                if (!distributedTraceCtx) {
                    // Fallback when using an older Core and PropertiesPlugin
                    var properties = _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CORE */] /* @min:%2ecore */].getPlugin(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["x" /* PropertiesPluginIdentifier */]);
                    if (properties) {
                        var context = properties.plugin.context;
                        if (context) {
                            distributedTraceCtx = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["G" /* createDistributedTraceContextFromTrace */])(context.telemetryTrace);
                        }
                    }
                }
                return distributedTraceCtx;
            }
            /**
             * Create a custom "locationchange" event which is triggered each time the history object is changed
             */
            function _addHistoryListener(extConfig, win, history, locn) {
                var namePrefix = extConfig[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["B" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */] || "";
                function _popstateHandler() {
                    if (_enableAutoRouteTracking) {
                        _dispatchEvent(win, Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["H" /* createDomEvent */])(namePrefix + "locationchange"));
                    }
                }
                function _locationChangeHandler() {
                    // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
                    if (_currUri) {
                        _prevUri = _currUri;
                        _currUri = locn && locn[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_HREF */] /* @min:%2ehref */] || "";
                    }
                    else {
                        _currUri = locn && locn[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_HREF */] /* @min:%2ehref */] || "";
                    }
                    if (_enableAutoRouteTracking) {
                        var distributedTraceCtx = _getDistributedTraceCtx();
                        if (distributedTraceCtx) {
                            distributedTraceCtx.setTraceId(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["K" /* generateW3CId */])());
                            var traceLocationName = "_unknown_";
                            if (locn && locn.pathname) {
                                traceLocationName = locn.pathname + (locn.hash || "");
                            }
                            // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
                            distributedTraceCtx.setName(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["K" /* dataSanitizeString */])(_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), traceLocationName));
                        }
                        setTimeout((function (uri) {
                            // todo: override start time so that it is not affected by autoRoutePVDelay
                            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Q" /* _DYN_TRACK_PAGE_VIEW */] /* @min:%2etrackPageView */]({ refUri: uri, properties: { duration: 0 } }); // SPA route change loading durations are undefined, so send 0
                        }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                    }
                }
                if (!_historyListenerAdded) {
                    _addHook(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["d" /* InstrumentEvent */])(history, "pushState", {
                        ns: _evtNamespace,
                        rsp: function () {
                            if (_enableAutoRouteTracking) {
                                _dispatchEvent(win, Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["H" /* createDomEvent */])(namePrefix + "pushState"));
                                _dispatchEvent(win, Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["H" /* createDomEvent */])(namePrefix + "locationchange"));
                            }
                        }
                    }, true));
                    _addHook(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["d" /* InstrumentEvent */])(history, "replaceState", {
                        ns: _evtNamespace,
                        rsp: function () {
                            if (_enableAutoRouteTracking) {
                                _dispatchEvent(win, Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["H" /* createDomEvent */])(namePrefix + "replaceState"));
                                _dispatchEvent(win, Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["H" /* createDomEvent */])(namePrefix + "locationchange"));
                            }
                        }
                    }, true));
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["I" /* eventOn */])(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["I" /* eventOn */])(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                    _historyListenerAdded = true;
                }
            }
            function _addUnhandledPromiseRejectionTracking(extConfig, _window, _location) {
                _enableUnhandledPromiseRejectionTracking = extConfig[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["l" /* _DYN_ENABLE_UNHANDLED_PRO3 */] /* @min:%2eenableUnhandledPromiseRejectionTracking */] === true;
                if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                    // We want to enable exception auto collection and it has not been done so yet
                    _addHook(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["d" /* InstrumentEvent */])(_window, "onunhandledrejection", {
                        ns: _evtNamespace,
                        rsp: function (callDetails, error) {
                            if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) { // handled could be typeof function
                                _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN__ONERROR */] /* @min:%2e_onerror */](__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["q" /* Exception */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["S" /* _DYN__CREATE_AUTO_EXCEPTI14 */] /* @min:%2eCreateAutoException */](_getReason(error), _location ? _location[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_HREF */] /* @min:%2ehref */] : "", 0, 0, error, callDetails.evt));
                            }
                        }
                    }, false));
                    _autoUnhandledPromiseInstrumented = true;
                    extConfig.autoUnhandledPromiseInstrumented = _autoUnhandledPromiseInstrumented;
                }
            }
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {eLoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */
            function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */]().throwInternal(severity, msgId, msg, properties, isUserAct);
            }
            function _initDefaults() {
                _eventTracking = null;
                _pageTracking = null;
                _pageViewManager = null;
                _pageViewPerformanceManager = null;
                _pageVisitTimeManager = null;
                _preInitTelemetryInitializers = null;
                _isBrowserLinkTrackingEnabled = false;
                _browserLinkInitializerAdded = false;
                _enableAutoRouteTracking = false;
                _historyListenerAdded = false;
                _disableExceptionTracking = false;
                _autoExceptionInstrumented = false;
                _enableUnhandledPromiseRejectionTracking = false;
                _autoUnhandledPromiseInstrumented = false;
                // Counts number of trackAjax invocations.
                // By default we only monitor X ajax call per view to avoid too much load.
                // Default value is set in config.
                // This counter keeps increasing even after the limit is reached.
                _trackAjaxAttempts = 0;
                // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
                var location = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["T" /* getLocation */])(true);
                _prevUri = location && location[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_HREF */] /* @min:%2ehref */] || "";
                _currUri = null;
                _evtNamespace = null;
            }
            // For backward compatibility
            Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_22" /* objDefineAccessors */])(_self, "_pageViewManager", function () { return _pageViewManager; });
            Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_22" /* objDefineAccessors */])(_self, "_pageViewPerformanceManager", function () { return _pageViewPerformanceManager; });
            Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_22" /* objDefineAccessors */])(_self, "_pageVisitTimeManager", function () { return _pageVisitTimeManager; });
            Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_22" /* objDefineAccessors */])(_self, "_evtNamespace", function () { return "." + _evtNamespace; });
        });
        return _this;
    }
// Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
// Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
// Removed Stub for AnalyticsPlugin.prototype.trackEvent.
// Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
// Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
// Removed Stub for AnalyticsPlugin.prototype.trackTrace.
// Removed Stub for AnalyticsPlugin.prototype.trackMetric.
// Removed Stub for AnalyticsPlugin.prototype.trackPageView.
// Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
// Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
// Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
// Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
// Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
// Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
// Removed Stub for AnalyticsPlugin.prototype.trackException.
// Removed Stub for AnalyticsPlugin.prototype._onerror.
// Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
// Removed Stub for AnalyticsPlugin.prototype.initialize.
    AnalyticsPlugin.Version = '2.8.18'; // Not currently used anywhere
    AnalyticsPlugin.getDefaultConfig = _getDefaultConfig;
    return AnalyticsPlugin;
}(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["b" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=AnalyticsPlugin.js.map

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(338);
/* unused harmony reexport strShimFunction */
/* unused harmony reexport strShimObject */
/* unused harmony reexport strShimUndefined */
/* unused harmony reexport strShimPrototype */
/* unused harmony reexport strShimHasOwnProperty */
/* unused harmony reexport strDefault */
/* unused harmony reexport ObjClass */
/* unused harmony reexport ObjProto */
/* unused harmony reexport ObjAssign */
/* unused harmony reexport ObjCreate */
/* unused harmony reexport ObjDefineProperty */
/* unused harmony reexport ObjHasOwnProperty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(480);
/* unused harmony reexport throwTypeError */
/* unused harmony reexport objCreateFn */
/* unused harmony reexport getGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(759);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c"]; });
/* unused harmony reexport __restFn */
/* unused harmony reexport __spreadArrayFn */
/* unused harmony reexport __spreadArraysFn */
/* unused harmony reexport __decorateFn */
/* unused harmony reexport __paramFn */
/* unused harmony reexport __metadataFn */
/* unused harmony reexport __createBindingFn */
/* unused harmony reexport __valuesFn */
/* unused harmony reexport __readFn */
/* unused harmony reexport __makeTemplateObjectFn */
/* unused harmony reexport __importDefaultFn */
/* unused harmony reexport __importStarFn */
/* unused harmony reexport __exportStarFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TsLibGlobals__ = __webpack_require__(1884);
/* unused harmony reexport __exposeGlobalTsLib */
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.




//# sourceMappingURL=applicationinsights-shims.js.map

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __exposeGlobalTsLib */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(759);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.



function __exposeGlobalTsLib() {
    var globalObj = Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {};
    // tslint:disable: only-arrow-functions
    (function (root, assignFn, extendsFn, createBindingFn) {
        // Assign the globally scoped versions of the functions -- used when consuming individual ts files
        // If check is to support NativeScript where these are marked as readonly
        if (!root.__assign) {
            root.__assign = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || assignFn;
        }
        if (!root.__extends) {
            root.__extends = extendsFn;
        }
        if (!root.__createBinding) {
            root.__createBinding = createBindingFn;
        }
    })(globalObj, __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a" /* __assignFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c" /* __extendsFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["b" /* __createBindingFn */]);
    // Assign local variables that will be used for embedded scenarios, if check is to support NativeScript where these are marked as readonly
    if (!__assign) {
        __assign = globalObj.__assign;
    }
    if (!__extends) {
        __extends = globalObj.__extends;
    }
    if (!__createBinding) {
        __createBinding = globalObj.__createBinding;
    }
}
//# sourceMappingURL=TsLibGlobals.js.map

/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MinChannelPriorty */
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EventsDiscardedReason */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_EnumHelperFuncs__ = __webpack_require__(481);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * The EventsDiscardedReason enumeration contains a set of values that specify the reason for discarding an event.
 */
var EventsDiscardedReason = Object(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_EnumHelperFuncs__["a" /* createEnumStyle */])({
    /**
     * Unknown.
     */
    Unknown: 0 /* eEventsDiscardedReason.Unknown */,
    /**
     * Status set to non-retryable.
     */
    NonRetryableStatus: 1 /* eEventsDiscardedReason.NonRetryableStatus */,
    /**
     * The event is invalid.
     */
    InvalidEvent: 2 /* eEventsDiscardedReason.InvalidEvent */,
    /**
     * The size of the event is too large.
     */
    SizeLimitExceeded: 3 /* eEventsDiscardedReason.SizeLimitExceeded */,
    /**
     * The server is not accepting events from this instrumentation key.
     */
    KillSwitch: 4 /* eEventsDiscardedReason.KillSwitch */,
    /**
     * The event queue is full.
     */
    QueueFull: 5 /* eEventsDiscardedReason.QueueFull */
});
//# sourceMappingURL=EventsDiscardedReason.js.map

/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __exposeGlobalTsLib */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(761);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.



function __exposeGlobalTsLib() {
    var globalObj = Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {};
    // tslint:disable: only-arrow-functions
    (function (root, assignFn, extendsFn, createBindingFn) {
        // Assign the globally scoped versions of the functions -- used when consuming individual ts files
        // If check is to support NativeScript where these are marked as readonly
        if (!root.__assign) {
            root.__assign = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || assignFn;
        }
        if (!root.__extends) {
            root.__extends = extendsFn;
        }
        if (!root.__createBinding) {
            root.__createBinding = createBindingFn;
        }
    })(globalObj, __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a" /* __assignFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c" /* __extendsFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["b" /* __createBindingFn */]);
    // Assign local variables that will be used for embedded scenarios, if check is to support NativeScript where these are marked as readonly
    if (!__assign) {
        __assign = globalObj.__assign;
    }
    if (!__extends) {
        __extends = globalObj.__extends;
    }
    if (!__createBinding) {
        __createBinding = globalObj.__createBinding;
    }
}
//# sourceMappingURL=TsLibGlobals.js.map

/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppInsightsCore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseCore__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DiagnosticLogger__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InternalConstants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotificationManager__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PerfManager__ = __webpack_require__(341);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */











var AppInsightsCore = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __extendsFn */])(AppInsightsCore, _super);
    function AppInsightsCore() {
        var _this = _super.call(this) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(AppInsightsCore, _this, function (_self, _base) {
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["s" /* _DYN_INITIALIZE */] /* @min:%2einitialize */] = function (config, extensions, logger, notificationManager) {
                _base[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["s" /* _DYN_INITIALIZE */] /* @min:%2einitialize */](config, extensions, logger || new __WEBPACK_IMPORTED_MODULE_4__DiagnosticLogger__["a" /* DiagnosticLogger */](config), notificationManager || new __WEBPACK_IMPORTED_MODULE_7__NotificationManager__["a" /* NotificationManager */](config));
            };
            _self.track = function (telemetryItem) {
                Object(__WEBPACK_IMPORTED_MODULE_8__PerfManager__["b" /* doPerf */])(_self[__WEBPACK_IMPORTED_MODULE_6__InternalConstants__["l" /* STR_GET_PERF_MGR */] /* @min:%2egetPerfMgr */](), function () { return "AppInsightsCore:track"; }, function () {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["N" /* throwError */])("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    _validateTelemetryItem(telemetryItem);
                    _base.track(telemetryItem);
                }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
            };
            function _validateTelemetryItem(telemetryItem) {
                if (Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["s" /* isNullOrUndefined */])(telemetryItem[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["D" /* _DYN_NAME */] /* @min:%2ename */])) {
                    _notifyInvalidEvent(telemetryItem);
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["N" /* throwError */])("telemetry name required");
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["m" /* _DYN_GET_NOTIFY_MGR */] /* @min:%2egetNotifyMgr */]();
                if (manager) {
                    manager[__WEBPACK_IMPORTED_MODULE_6__InternalConstants__["g" /* STR_EVENTS_DISCARDED */] /* @min:%2eeventsDiscarded */]([telemetryItem], 2 /* eEventsDiscardedReason.InvalidEvent */);
                }
            }
        });
        return _this;
    }
// Removed Stub for AppInsightsCore.prototype.initialize.
// Removed Stub for AppInsightsCore.prototype.track.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    AppInsightsCore.__ieDyn=1;

    return AppInsightsCore;
}(__WEBPACK_IMPORTED_MODULE_3__BaseCore__["a" /* BaseCore */]));

//# sourceMappingURL=AppInsightsCore.js.map

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelControllerPriority; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createChannelControllerPlugin;
/* harmony export (immutable) */ __webpack_exports__["c"] = createChannelQueues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InternalConstants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(342);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// 





var ChannelControllerPriority = 500;
var ChannelValidationMessage = "Channel has invalid priority - ";
function _addChannelQueue(channelQueue, queue, core) {
    if (queue && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["m" /* isArray */])(queue) && queue[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
        queue = queue.sort(function (a, b) {
            return a[__WEBPACK_IMPORTED_MODULE_2__InternalConstants__["n" /* STR_PRIORITY */] /* @min:%2epriority */] - b[__WEBPACK_IMPORTED_MODULE_2__InternalConstants__["n" /* STR_PRIORITY */] /* @min:%2epriority */];
        });
        Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrForEach */])(queue, function (queueItem) {
            if (queueItem[__WEBPACK_IMPORTED_MODULE_2__InternalConstants__["n" /* STR_PRIORITY */] /* @min:%2epriority */] < ChannelControllerPriority) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["N" /* throwError */])(ChannelValidationMessage + queueItem[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["q" /* _DYN_IDENTIFIER */] /* @min:%2eidentifier */]);
            }
        });
        channelQueue[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */]({
            queue: Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* objFreeze */])(queue),
            chain: Object(__WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["d" /* createTelemetryProxyChain */])(queue, core[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["e" /* _DYN_CONFIG */] /* @min:%2econfig */], core)
        });
    }
}
function createChannelControllerPlugin(channelQueue, core) {
    function _getTelCtx() {
        return Object(__WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* createProcessTelemetryContext */])(null, core[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["e" /* _DYN_CONFIG */] /* @min:%2econfig */], core, null);
    }
    function _processChannelQueue(theChannels, itemCtx, processFn, onComplete) {
        var waiting = theChannels ? (theChannels[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] + 1) : 1;
        function _runChainOnComplete() {
            waiting--;
            if (waiting === 0) {
                onComplete && onComplete();
                onComplete = null;
            }
        }
        if (waiting > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrForEach */])(theChannels, function (channels) {
                // pass on to first item in queue
                if (channels && channels.queue[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    var channelChain = channels.chain;
                    var chainCtx = itemCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["g" /* _DYN_CREATE_NEW */] /* @min:%2ecreateNew */](channelChain);
                    chainCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["F" /* _DYN_ON_COMPLETE */] /* @min:%2eonComplete */](_runChainOnComplete);
                    // Cause this chain to start processing
                    processFn(chainCtx);
                }
                else {
                    waiting--;
                }
            });
        }
        _runChainOnComplete();
    }
    function _doUpdate(updateCtx, updateState) {
        var theUpdateState = updateState || {
            reason: 0 /* TelemetryUpdateReason.Unknown */
        };
        _processChannelQueue(channelQueue, updateCtx, function (chainCtx) {
            chainCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](theUpdateState);
        }, function () {
            updateCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](theUpdateState);
        });
        return true;
    }
    function _doTeardown(unloadCtx, unloadState) {
        var theUnloadState = unloadState || {
            reason: 0 /* TelemetryUnloadReason.ManualTeardown */,
            isAsync: false
        };
        _processChannelQueue(channelQueue, unloadCtx, function (chainCtx) {
            chainCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](theUnloadState);
        }, function () {
            unloadCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](theUnloadState);
            isInitialized = false;
        });
        return true;
    }
    function _getChannel(pluginIdentifier) {
        var thePlugin = null;
        if (channelQueue && channelQueue[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrForEach */])(channelQueue, function (channels) {
                // pass on to first item in queue
                if (channels && channels.queue[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrForEach */])(channels.queue, function (ext) {
                        if (ext[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["q" /* _DYN_IDENTIFIER */] /* @min:%2eidentifier */] === pluginIdentifier) {
                            thePlugin = ext;
                            // Cause arrForEach to stop iterating
                            return -1;
                        }
                    });
                    if (thePlugin) {
                        // Cause arrForEach to stop iterating
                        return -1;
                    }
                }
            });
        }
        return thePlugin;
    }
    var isInitialized = false;
    var channelController = {
        identifier: "ChannelControllerPlugin",
        priority: ChannelControllerPriority,
        initialize: function (config, core, extensions, pluginChain) {
            isInitialized = true;
            Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrForEach */])(channelQueue, function (channels) {
                if (channels && channels.queue[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["c" /* initializePlugins */])(Object(__WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* createProcessTelemetryContext */])(channels.chain, config, core), extensions);
                }
            });
        },
        isInitialized: function () {
            return isInitialized;
        },
        processTelemetry: function (item, itemCtx) {
            _processChannelQueue(channelQueue, itemCtx || _getTelCtx(), function (chainCtx) {
                chainCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](item);
            }, function () {
                itemCtx[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](item);
            });
        },
        update: _doUpdate,
        pause: function () {
            _processChannelQueue(channelQueue, _getTelCtx(), function (chainCtx) {
                chainCtx.iterate(function (plugin) {
                    plugin.pause && plugin.pause();
                });
            }, null);
        },
        resume: function () {
            _processChannelQueue(channelQueue, _getTelCtx(), function (chainCtx) {
                chainCtx.iterate(function (plugin) {
                    plugin.resume && plugin.resume();
                });
            }, null);
        },
        teardown: _doTeardown,
        getChannel: _getChannel,
        flush: function (isAsync, callBack, sendReason, cbTimeout) {
            // Setting waiting to one so that we don't call the callBack until we finish iterating
            var waiting = 1;
            var doneIterating = false;
            var cbTimer = null;
            cbTimeout = cbTimeout || 5000;
            function doCallback() {
                waiting--;
                if (doneIterating && waiting === 0) {
                    if (cbTimer) {
                        clearTimeout(cbTimer);
                        cbTimer = null;
                    }
                    callBack && callBack(doneIterating);
                    callBack = null;
                }
            }
            _processChannelQueue(channelQueue, _getTelCtx(), function (chainCtx) {
                chainCtx.iterate(function (plugin) {
                    if (plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["j" /* _DYN_FLUSH */] /* @min:%2eflush */]) {
                        waiting++;
                        var handled_1 = false;
                        // Not all channels will call this callback for every scenario
                        if (!plugin[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["j" /* _DYN_FLUSH */] /* @min:%2eflush */](isAsync, function () {
                            handled_1 = true;
                            doCallback();
                        }, sendReason)) {
                            if (!handled_1) {
                                // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                                // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                                // followup function (such as unloading)
                                if (isAsync && cbTimer == null) {
                                    cbTimer = setTimeout(function () {
                                        cbTimer = null;
                                        doCallback();
                                    }, cbTimeout);
                                }
                                else {
                                    doCallback();
                                }
                            }
                        }
                    }
                });
            }, function () {
                doneIterating = true;
                doCallback();
            });
            return true;
        },
        _setQueue: function (queue) {
            channelQueue = queue;
        }
    };
    return channelController;
}
function createChannelQueues(channels, extensions, core) {
    var channelQueue = [];
    if (channels) {
        // Add and sort the configuration channel queues
        Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrForEach */])(channels, function (queue) { return _addChannelQueue(channelQueue, queue, core); });
    }
    if (extensions) {
        // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
        var extensionQueue_1 = [];
        Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrForEach */])(extensions, function (plugin) {
            if (plugin[__WEBPACK_IMPORTED_MODULE_2__InternalConstants__["n" /* STR_PRIORITY */] /* @min:%2epriority */] > ChannelControllerPriority) {
                extensionQueue_1[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](plugin);
            }
        });
        _addChannelQueue(channelQueue, extensionQueue_1, core);
    }
    return channelQueue;
}
//# sourceMappingURL=ChannelController.js.map

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryInitializerPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseTelemetryPlugin__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DiagnosticLogger__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EnvUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HelperFuncs__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InternalConstants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// 
// 








var TelemetryInitializerPlugin = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __extendsFn */])(TelemetryInitializerPlugin, _super);
    function TelemetryInitializerPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "TelemetryInitializerPlugin";
        _this.priority = 199;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _id;
        var _initializers;
        _initDefaults();
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(TelemetryInitializerPlugin, _this, function (_self, _base) {
            _self.addTelemetryInitializer = function (telemetryInitializer) {
                var theInitializer = {
                    id: _id++,
                    fn: telemetryInitializer
                };
                _initializers[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](theInitializer);
                var handler = {
                    remove: function () {
                        Object(__WEBPACK_IMPORTED_MODULE_6__HelperFuncs__["b" /* arrForEach */])(_initializers, function (initializer, idx) {
                            if (initializer.id === theInitializer.id) {
                                _initializers[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["O" /* _DYN_SPLICE */] /* @min:%2esplice */](idx, 1);
                                return -1;
                            }
                        });
                    }
                };
                return handler;
            };
            _self[__WEBPACK_IMPORTED_MODULE_7__InternalConstants__["o" /* STR_PROCESS_TELEMETRY */] /* @min:%2eprocessTelemetry */] = function (item, itemCtx) {
                var doNotSendItem = false;
                var telemetryInitializersCount = _initializers[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */];
                for (var i = 0; i < telemetryInitializersCount; ++i) {
                    var telemetryInitializer = _initializers[i];
                    if (telemetryInitializer) {
                        try {
                            if (telemetryInitializer.fn[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["b" /* _DYN_APPLY */] /* @min:%2eapply */](null, [item]) === false) {
                                doNotSendItem = true;
                                break;
                            }
                        }
                        catch (e) {
                            // log error but dont stop executing rest of the telemetry initializers
                            // doNotSendItem = true;
                            Object(__WEBPACK_IMPORTED_MODULE_4__DiagnosticLogger__["d" /* _throwInternal */])(itemCtx[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["h" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "One of telemetry initializers failed, telemetry item will not be sent: " + Object(__WEBPACK_IMPORTED_MODULE_6__HelperFuncs__["j" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_5__EnvUtils__["a" /* dumpObj */])(e) }, true);
                        }
                    }
                }
                if (!doNotSendItem) {
                    _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["G" /* _DYN_PROCESS_NEXT */] /* @min:%2eprocessNext */](item, itemCtx);
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["_2" /* _DYN__DO_TEARDOWN */] /* @min:%2e_doTeardown */] = function () {
                _initDefaults();
            };
        });
        function _initDefaults() {
            _id = 0;
            _initializers = [];
        }
        return _this;
    }
// Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
// Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    TelemetryInitializerPlugin.__ieDyn=1;

    return TelemetryInitializerPlugin;
}(__WEBPACK_IMPORTED_MODULE_3__BaseTelemetryPlugin__["a" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=TelemetryInitializerPlugin.js.map

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoggingSeverity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalMessageId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_EnumHelperFuncs__ = __webpack_require__(481);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


//  @skip-file-minify
var _a;

var FAILED = "Failed";
var FAILED_MONITOR_AJAX = FAILED + "MonitorAjax";
var TRACK = "Track";
var START = "Start";
var STOP = "Stop";
var EVENT = "Event";
var AUTH_CONTEXT = "AuthContext";
var EXCEPTION = "Exception";
var LOCAL = "Local";
var SESSION = "Session";
var STORAGE = "Storage";
var BROWSER = "Browser";
var CANNOT = "Cannot";
var BUFFER = "Buffer";
var INSTRUMENTATION_KEY = "InstrumentationKey";
var LoggingSeverity = Object(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_EnumHelperFuncs__["a" /* createEnumStyle */])({
    CRITICAL: 1 /* eLoggingSeverity.CRITICAL */,
    WARNING: 2 /* eLoggingSeverity.WARNING */
});
/**
 * Internal message ID. Please create a new one for every conceptually different message. Please keep alphabetically ordered
 */
var _InternalMessageId = Object(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_EnumHelperFuncs__["a" /* createEnumStyle */])((_a = {},
    // Non user actionable
    _a[BROWSER + "DoesNotSupport" + LOCAL + STORAGE] = 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */,
    _a[BROWSER + CANNOT + "Read" + LOCAL + STORAGE] = 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */,
    _a[BROWSER + CANNOT + "Read" + SESSION + STORAGE] = 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */,
    _a[BROWSER + CANNOT + "Write" + LOCAL + STORAGE] = 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */,
    _a[BROWSER + CANNOT + "Write" + SESSION + STORAGE] = 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */,
    _a[BROWSER + FAILED + "RemovalFrom" + LOCAL + STORAGE] = 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */,
    _a[BROWSER + FAILED + "RemovalFrom" + SESSION + STORAGE] = 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */,
    _a[CANNOT + "SendEmptyTelemetry"] = 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */,
    _a.ClientPerformanceMathError = 8 /* _eInternalMessageId.ClientPerformanceMathError */,
    _a["ErrorParsingAI" + SESSION + "Cookie"] = 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */,
    _a.ErrorPVCalc = 10 /* _eInternalMessageId.ErrorPVCalc */,
    _a[EXCEPTION + "WhileLoggingError"] = 11 /* _eInternalMessageId.ExceptionWhileLoggingError */,
    _a[FAILED + "AddingTelemetryTo" + BUFFER] = 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */,
    _a[FAILED_MONITOR_AJAX + "Abort"] = 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */,
    _a[FAILED_MONITOR_AJAX + "Dur"] = 14 /* _eInternalMessageId.FailedMonitorAjaxDur */,
    _a[FAILED_MONITOR_AJAX + "Open"] = 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */,
    _a[FAILED_MONITOR_AJAX + "RSC"] = 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */,
    _a[FAILED_MONITOR_AJAX + "Send"] = 17 /* _eInternalMessageId.FailedMonitorAjaxSend */,
    _a[FAILED_MONITOR_AJAX + "GetCorrelationHeader"] = 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */,
    _a[FAILED + "ToAddHandlerForOnBeforeUnload"] = 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */,
    _a[FAILED + "ToSendQueuedTelemetry"] = 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */,
    _a[FAILED + "ToReportDataLoss"] = 21 /* _eInternalMessageId.FailedToReportDataLoss */,
    _a["Flush" + FAILED] = 22 /* _eInternalMessageId.FlushFailed */,
    _a.MessageLimitPerPVExceeded = 23 /* _eInternalMessageId.MessageLimitPerPVExceeded */,
    _a.MissingRequiredFieldSpecification = 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */,
    _a.NavigationTimingNotSupported = 25 /* _eInternalMessageId.NavigationTimingNotSupported */,
    _a.OnError = 26 /* _eInternalMessageId.OnError */,
    _a[SESSION + "RenewalDateIsZero"] = 27 /* _eInternalMessageId.SessionRenewalDateIsZero */,
    _a.SenderNotInitialized = 28 /* _eInternalMessageId.SenderNotInitialized */,
    _a[START + TRACK + EVENT + FAILED] = 29 /* _eInternalMessageId.StartTrackEventFailed */,
    _a[STOP + TRACK + EVENT + FAILED] = 30 /* _eInternalMessageId.StopTrackEventFailed */,
    _a[START + TRACK + FAILED] = 31 /* _eInternalMessageId.StartTrackFailed */,
    _a[STOP + TRACK + FAILED] = 32 /* _eInternalMessageId.StopTrackFailed */,
    _a.TelemetrySampledAndNotSent = 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */,
    _a[TRACK + EVENT + FAILED] = 34 /* _eInternalMessageId.TrackEventFailed */,
    _a[TRACK + EXCEPTION + FAILED] = 35 /* _eInternalMessageId.TrackExceptionFailed */,
    _a[TRACK + "Metric" + FAILED] = 36 /* _eInternalMessageId.TrackMetricFailed */,
    _a[TRACK + "PV" + FAILED] = 37 /* _eInternalMessageId.TrackPVFailed */,
    _a[TRACK + "PV" + FAILED + "Calc"] = 38 /* _eInternalMessageId.TrackPVFailedCalc */,
    _a[TRACK + "Trace" + FAILED] = 39 /* _eInternalMessageId.TrackTraceFailed */,
    _a["Transmission" + FAILED] = 40 /* _eInternalMessageId.TransmissionFailed */,
    _a[FAILED + "ToSet" + STORAGE + BUFFER] = 41 /* _eInternalMessageId.FailedToSetStorageBuffer */,
    _a[FAILED + "ToRestore" + STORAGE + BUFFER] = 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */,
    _a.InvalidBackendResponse = 43 /* _eInternalMessageId.InvalidBackendResponse */,
    _a[FAILED + "ToFixDepricatedValues"] = 44 /* _eInternalMessageId.FailedToFixDepricatedValues */,
    _a.InvalidDurationValue = 45 /* _eInternalMessageId.InvalidDurationValue */,
    _a.TelemetryEnvelopeInvalid = 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */,
    _a.CreateEnvelopeError = 47 /* _eInternalMessageId.CreateEnvelopeError */,
    // User actionable
    _a[CANNOT + "SerializeObject"] = 48 /* _eInternalMessageId.CannotSerializeObject */,
    _a[CANNOT + "SerializeObjectNonSerializable"] = 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */,
    _a.CircularReferenceDetected = 50 /* _eInternalMessageId.CircularReferenceDetected */,
    _a["Clear" + AUTH_CONTEXT + FAILED] = 51 /* _eInternalMessageId.ClearAuthContextFailed */,
    _a[EXCEPTION + "Truncated"] = 52 /* _eInternalMessageId.ExceptionTruncated */,
    _a.IllegalCharsInName = 53 /* _eInternalMessageId.IllegalCharsInName */,
    _a.ItemNotInArray = 54 /* _eInternalMessageId.ItemNotInArray */,
    _a.MaxAjaxPerPVExceeded = 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */,
    _a.MessageTruncated = 56 /* _eInternalMessageId.MessageTruncated */,
    _a.NameTooLong = 57 /* _eInternalMessageId.NameTooLong */,
    _a.SampleRateOutOfRange = 58 /* _eInternalMessageId.SampleRateOutOfRange */,
    _a["Set" + AUTH_CONTEXT + FAILED] = 59 /* _eInternalMessageId.SetAuthContextFailed */,
    _a["Set" + AUTH_CONTEXT + FAILED + "AccountName"] = 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */,
    _a.StringValueTooLong = 61 /* _eInternalMessageId.StringValueTooLong */,
    _a.StartCalledMoreThanOnce = 62 /* _eInternalMessageId.StartCalledMoreThanOnce */,
    _a.StopCalledWithoutStart = 63 /* _eInternalMessageId.StopCalledWithoutStart */,
    _a["TelemetryInitializer" + FAILED] = 64 /* _eInternalMessageId.TelemetryInitializerFailed */,
    _a.TrackArgumentsNotSpecified = 65 /* _eInternalMessageId.TrackArgumentsNotSpecified */,
    _a.UrlTooLong = 66 /* _eInternalMessageId.UrlTooLong */,
    _a[SESSION + STORAGE + BUFFER + "Full"] = 67 /* _eInternalMessageId.SessionStorageBufferFull */,
    _a[CANNOT + "AccessCookie"] = 68 /* _eInternalMessageId.CannotAccessCookie */,
    _a.IdTooLong = 69 /* _eInternalMessageId.IdTooLong */,
    _a.InvalidEvent = 70 /* _eInternalMessageId.InvalidEvent */,
    _a[FAILED_MONITOR_AJAX + "SetRequestHeader"] = 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */,
    _a["Send" + BROWSER + "InfoOnUserInit"] = 72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */,
    _a["Plugin" + EXCEPTION] = 73 /* _eInternalMessageId.PluginException */,
    _a["Notification" + EXCEPTION] = 74 /* _eInternalMessageId.NotificationException */,
    _a.SnippetScriptLoadFailure = 99 /* _eInternalMessageId.SnippetScriptLoadFailure */,
    _a["Invalid" + INSTRUMENTATION_KEY] = 100 /* _eInternalMessageId.InvalidInstrumentationKey */,
    _a[CANNOT + "ParseAiBlobValue"] = 101 /* _eInternalMessageId.CannotParseAiBlobValue */,
    _a.InvalidContentBlob = 102 /* _eInternalMessageId.InvalidContentBlob */,
    _a[TRACK + "PageAction" + EVENT + FAILED] = 103 /* _eInternalMessageId.TrackPageActionEventFailed */,
    _a[FAILED + "AddingCustomDefinedRequestContext"] = 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */,
    _a["InMemory" + STORAGE + BUFFER + "Full"] = 105 /* _eInternalMessageId.InMemoryStorageBufferFull */,
    _a[INSTRUMENTATION_KEY + "Deprecation"] = 106 /* _eInternalMessageId.InstrumentationKeyDeprecation */,
    _a));
//# sourceMappingURL=LoggingEnums.js.map

/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = InstrumentProto;
/* unused harmony export InstrumentProtos */
/* harmony export (immutable) */ __webpack_exports__["b"] = InstrumentFunc;
/* unused harmony export InstrumentFuncs */
/* harmony export (immutable) */ __webpack_exports__["a"] = InstrumentEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(71);
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var aiInstrumentHooks = "_aiHooks";
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */]; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* CallbackType.Request */ && type <= 2 /* CallbackType.HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["b" /* _DYN_APPLY */] /* @min:%2eapply */](callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* CallbackType.HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["b" /* _DYN_APPLY */] /* @min:%2eapply */](callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var _a;
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["D" /* _DYN_NAME */] /* @min:name */] = aiHook.n,
            _a.inst = funcThis,
            _a.ctx = null,
            _a.set = _replaceArg,
            _a);
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        funcArgs.evt = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["g" /* getGlobalInst */])("event");
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        if (theFunc) {
            try {
                funcArgs.rslt = theFunc[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["b" /* _DYN_APPLY */] /* @min:%2eapply */](funcThis, orgArgs);
            }
            catch (err) {
                // Report the request callback
                funcArgs.err = err;
                _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */);
                // rethrow the original exception so anyone listening for it can catch the exception
                throw err;
            }
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */);
        return funcArgs.rslt;
    };
}
/** @ignore */
function _getOwner(target, name, checkPrototype, checkParentProto) {
    var owner = null;
    if (target) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["l" /* hasOwnProperty */])(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* _getObjProto */])(target), name, checkParentProto, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcName, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProtos(target, funcNames, callbacks) {
    if (target) {
        return InstrumentFuncs(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcNames, callbacks, false);
    }
    return null;
}
function _createInstrumentHook(owner, funcName, fn, callbacks) {
    var aiHook = fn && fn[aiInstrumentHooks];
    if (!aiHook) {
        // Only hook the function once
        aiHook = {
            i: 0,
            n: funcName,
            f: fn,
            h: []
        };
        // Override (hook) the original function
        var newFunc = _createFunctionHook(aiHook);
        newFunc[aiInstrumentHooks] = aiHook; // Tag and store the function hooks
        owner[funcName] = newFunc;
    }
    var theHook = {
        // tslint:disable:object-literal-shorthand
        id: aiHook.i,
        cbks: callbacks,
        rm: function () {
            // DO NOT Use () => { shorthand for the function as the this gets replaced
            // with the outer this and not the this for theHook instance.
            var id = this.id;
            _arrLoop(aiHook.h, function (hook, idx) {
                if (hook.id === id) {
                    aiHook.h[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["O" /* _DYN_SPLICE */] /* @min:%2esplice */](idx, 1);
                    return 1;
                }
            });
        }
        // tslint:enable:object-literal-shorthand
    };
    aiHook.i++;
    aiHook.h[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](theHook);
    return theHook;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype, checkParentProto);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */]) {
                return _createInstrumentHook(owner, funcName, fn, callbacks);
            }
        }
    }
    return null;
}
/**
 * Intercept the named functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentFuncs(target, funcNames, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    var hooks = null;
    _arrLoop(funcNames, function (funcName) {
        var hook = InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto);
        if (hook) {
            if (!hooks) {
                hooks = [];
            }
            hooks[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["H" /* _DYN_PUSH */] /* @min:%2epush */](hook);
        }
    });
    return hooks;
}
/**
 * Add an instrumentation hook to the provided named "event" for the target class / object, this doesn't check whether the
 * named "event" is in fact a function and just assigns the instrumentation hook to the target[evtName]
 * @param target - The target object
 * @param evtName - The name of the event
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentEvent(target, evtName, callbacks, checkPrototype, checkParentProto) {
    if (target && evtName && callbacks) {
        var owner = _getOwner(target, evtName, checkPrototype, checkParentProto) || target;
        if (owner) {
            return _createInstrumentHook(owner, evtName, owner[evtName], callbacks);
        }
    }
    return null;
}
//# sourceMappingURL=InstrumentHooks.js.map

/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThrottleMgr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StorageHelperFuncs__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(88);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var THROTTLE_STORAGE_PREFIX = "appInsightsThrottle";
var ThrottleMgr = /** @class */ (function () {
    function ThrottleMgr(throttleMgr, core, namePrefix) {
        var _self = this;
        var _canUseLocalStorage;
        var _logger;
        var _config;
        var _localStorageName;
        var _localStorageObj;
        var _isTriggered; //_isTriggered is to make sure that we only trigger throttle once a day
        var _namePrefix;
        var _queue;
        var _isReady = false;
        var _isSpecificDaysGiven = false;
        _initConfig();
        _self.getConfig = function () {
            return _config;
        };
        /**
         * Check if it is the correct day to send message.
         * If _isTriggered is true, even if canThrottle returns true, message will not be sent,
         * because we only allow triggering sendMessage() once a day.
         * @returns if the current date is the valid date to send message
         */
        _self.canThrottle = function () {
            return _canThrottle(_config, _canUseLocalStorage, _localStorageObj);
        };
        /**
         * Check if throttle is triggered on current day(UTC)
         * if canThrottle returns false, isTriggered will return false
         * @returns if throttle is triggered on current day(UTC)
         */
        _self.isTriggered = function () {
            return _isTriggered;
        };
        /**
         * Before isReady set to true, all message will be stored in queue.
         * Message will only be sent out after isReady set to true.
         * Initial and default value: false
         * @returns isReady state
         */
        _self.isReady = function () {
            return _isReady;
        };
        /**
         * Flush all message in queue with isReady state set to true.
         * @returns if message queue is flushed
         */
        _self.flush = function () {
            try {
                if (_isReady && _queue[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(_queue, function (item) {
                        _self.sendMessage(item.msgID, item[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["u" /* _DYN_MESSAGE */] /* @min:%2emessage */], item.severity);
                    });
                    return true;
                }
            }
            catch (err) {
                // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Set isReady State
         * if isReady set to true, message queue will be flushed automatically.
         * @param isReady isReady State
         * @returns if message queue is flushed
         */
        _self.onReadyState = function (isReady) {
            _isReady = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(isReady) ? true : isReady;
            return _self.flush();
        };
        _self.sendMessage = function (msgID, message, severity) {
            if (_isReady) {
                var isSampledIn = _canSampledIn();
                if (!isSampledIn) {
                    return;
                }
                var canThrottle = _canThrottle(_config, _canUseLocalStorage, _localStorageObj);
                var throttled = false;
                var number = 0;
                try {
                    if (canThrottle && !_isTriggered) {
                        number = Math.min(_config.limit.maxSendNumber, _localStorageObj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["c" /* _DYN_COUNT */] /* @min:%2ecount */] + 1);
                        _localStorageObj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["c" /* _DYN_COUNT */] /* @min:%2ecount */] = 0;
                        throttled = true;
                        _isTriggered = true;
                        _localStorageObj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_PRE_TRIGGER_DATE */] /* @min:%2epreTriggerDate */] = new Date();
                    }
                    else {
                        _isTriggered = canThrottle;
                        _localStorageObj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["c" /* _DYN_COUNT */] /* @min:%2ecount */] += 1;
                    }
                    _resetLocalStorage(_logger, _localStorageName, _localStorageObj);
                    for (var i = 0; i < number; i++) {
                        _sendMessage(msgID, _logger, message, severity);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return {
                    isThrottled: throttled,
                    throttleNum: number
                };
            }
            else {
                _queue.push({
                    msgID: msgID,
                    message: message,
                    severity: severity
                });
            }
            return null;
        };
        function _initConfig() {
            var _a, _b;
            _canUseLocalStorage = Object(__WEBPACK_IMPORTED_MODULE_1__StorageHelperFuncs__["a" /* utlCanUseLocalStorage */])();
            _logger = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_33" /* safeGetLogger */])(core);
            _isTriggered = false;
            _namePrefix = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_8" /* isNotNullOrUndefined */])(namePrefix) ? namePrefix : "";
            _queue = [];
            var configMgr = throttleMgr;
            _config = {};
            _config[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["f" /* _DYN_DISABLED */] /* @min:%2edisabled */] = !!configMgr[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["f" /* _DYN_DISABLED */] /* @min:%2edisabled */];
            _config.msgKey = configMgr.msgKey;
            var configInterval = configMgr[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["o" /* _DYN_INTERVAL */] /* @min:%2einterval */] || {};
            _isSpecificDaysGiven = (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth) && (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */]) > 0;
            _config[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["o" /* _DYN_INTERVAL */] /* @min:%2einterval */] = _getIntervalConfig(configInterval);
            var limit = {
                samplingRate: ((_a = configMgr.limit) === null || _a === void 0 ? void 0 : _a.samplingRate) || 100,
                // dafault: every time sent only 1 event
                maxSendNumber: ((_b = configMgr.limit) === null || _b === void 0 ? void 0 : _b.maxSendNumber) || 1
            };
            _config.limit = limit;
            _localStorageName = _getLocalStorageName(_config.msgKey, _namePrefix);
            if (_canUseLocalStorage && _localStorageName) {
                _localStorageObj = _getLocalStorageObj(Object(__WEBPACK_IMPORTED_MODULE_1__StorageHelperFuncs__["e" /* utlGetLocalStorage */])(_logger, _localStorageName), _logger, _localStorageName);
            }
            if (_localStorageObj) {
                _isTriggered = _isTriggeredOnCurDate(_localStorageObj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_PRE_TRIGGER_DATE */] /* @min:%2epreTriggerDate */]);
            }
        }
        function _getIntervalConfig(interval) {
            interval = interval || {};
            var monthInterval = interval === null || interval === void 0 ? void 0 : interval.monthInterval;
            var dayInterval = interval === null || interval === void 0 ? void 0 : interval.dayInterval;
            // default: send data every 3 month each year
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(monthInterval) && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(dayInterval)) {
                interval.monthInterval = 3;
                if (!_isSpecificDaysGiven) {
                    // default: send data on 28th
                    interval[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["e" /* _DYN_DAYS_OF_MONTH */] /* @min:%2edaysOfMonth */] = [28];
                    _isSpecificDaysGiven = true;
                }
            }
            interval = {
                // dafault: sent every three months
                monthInterval: interval === null || interval === void 0 ? void 0 : interval.monthInterval,
                dayInterval: interval === null || interval === void 0 ? void 0 : interval.dayInterval,
                daysOfMonth: interval === null || interval === void 0 ? void 0 : interval.daysOfMonth
            };
            return interval;
        }
        function _canThrottle(config, canUseLocalStorage, localStorageObj) {
            if (!config[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["f" /* _DYN_DISABLED */] /* @min:%2edisabled */] && canUseLocalStorage && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_8" /* isNotNullOrUndefined */])(localStorageObj)) {
                var curDate = _getThrottleDate();
                var date = localStorageObj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["d" /* _DYN_DATE */] /* @min:%2edate */];
                var interval = config[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["o" /* _DYN_INTERVAL */] /* @min:%2einterval */];
                var monthCheck = 1;
                if (interval === null || interval === void 0 ? void 0 : interval.monthInterval) {
                    var monthExpand = (curDate.getUTCFullYear() - date.getUTCFullYear()) * 12 + curDate.getUTCMonth() - date.getUTCMonth();
                    monthCheck = _checkInterval(interval.monthInterval, 0, monthExpand);
                }
                var dayCheck = 1;
                if (_isSpecificDaysGiven) {
                    dayCheck = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* arrIndexOf */])(interval[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["e" /* _DYN_DAYS_OF_MONTH */] /* @min:%2edaysOfMonth */], curDate[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["k" /* _DYN_GET_UTCDATE */] /* @min:%2egetUTCDate */]());
                }
                else if (interval === null || interval === void 0 ? void 0 : interval.dayInterval) {
                    var daySpan = Math.floor((curDate.getTime() - date.getTime()) / 86400000);
                    dayCheck = _checkInterval(interval.dayInterval, 0, daySpan);
                }
                return monthCheck >= 0 && dayCheck >= 0;
            }
            return false;
        }
        function _getLocalStorageName(msgKey, prefix) {
            var fix = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_8" /* isNotNullOrUndefined */])(prefix) ? prefix : "";
            if (msgKey) {
                return THROTTLE_STORAGE_PREFIX + fix + "-" + msgKey;
            }
            return null;
        }
        // returns if throttle is triggered on current Date
        function _isTriggeredOnCurDate(preTriggerDate) {
            try {
                if (preTriggerDate) {
                    var curDate = new Date();
                    return preTriggerDate.getUTCFullYear() === curDate.getUTCFullYear() &&
                        preTriggerDate.getUTCMonth() === curDate.getUTCMonth() &&
                        preTriggerDate[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["k" /* _DYN_GET_UTCDATE */] /* @min:%2egetUTCDate */]() === curDate[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["k" /* _DYN_GET_UTCDATE */] /* @min:%2egetUTCDate */]();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        // transfer local storage string value to object that identifies start date, current count and preTriggerDate
        function _getLocalStorageObj(value, logger, storageName) {
            try {
                var storageObj = {
                    date: _getThrottleDate(),
                    count: 0
                };
                if (value) {
                    var obj = JSON.parse(value);
                    return {
                        date: _getThrottleDate(obj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["d" /* _DYN_DATE */] /* @min:%2edate */]) || storageObj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["d" /* _DYN_DATE */] /* @min:%2edate */],
                        count: obj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["c" /* _DYN_COUNT */] /* @min:%2ecount */] || storageObj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["c" /* _DYN_COUNT */] /* @min:%2ecount */],
                        preTriggerDate: obj.preTriggerDate ? _getThrottleDate(obj[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["z" /* _DYN_PRE_TRIGGER_DATE */] /* @min:%2epreTriggerDate */]) : undefined
                    };
                }
                else {
                    _resetLocalStorage(logger, storageName, storageObj);
                    return storageObj;
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        // if datestr is not defined, current date will be returned
        function _getThrottleDate(dateStr) {
            // if new Date() can't be created through the provided dateStr, null will be returned.
            try {
                if (dateStr) {
                    var date = new Date(dateStr);
                    //make sure it is a valid Date Object
                    if (!isNaN(date.getDate())) {
                        return date;
                    }
                }
                else {
                    return new Date();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _resetLocalStorage(logger, storageName, obj) {
            try {
                return Object(__WEBPACK_IMPORTED_MODULE_1__StorageHelperFuncs__["j" /* utlSetLocalStorage */])(logger, storageName, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_38" /* strTrim */])(JSON[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["L" /* _DYN_STRINGIFY */] /* @min:%2estringify */](obj)));
            }
            catch (e) {
                //     // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _checkInterval(interval, start, current) {
            // count from start year
            return (current >= start) && (current - start) % interval == 0 ? Math.floor((current - start) / interval) + 1 : -1;
        }
        function _sendMessage(msgID, logger, message, severity) {
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, severity || 1 /* eLoggingSeverity.CRITICAL */, msgID, message);
        }
        // NOTE: config.limit.samplingRate is set to 4 decimal places,
        // so config.limit.samplingRate = 1 means 0.0001%
        function _canSampledIn() {
            return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_29" /* randomValue */])(1000000) <= _config.limit.samplingRate;
        }
    }
    return ThrottleMgr;
}());

//# sourceMappingURL=ThrottleMgr.js.map

/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseConnectionString;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectionStringParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(88);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
    if (!connectionString) {
        return {};
    }
    var kvPairs = connectionString[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["K" /* _DYN_SPLIT */] /* @min:%2esplit */](_FIELDS_SEPARATOR);
    var result = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* arrReduce */])(kvPairs, function (fields, kv) {
        var kvParts = kv[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["K" /* _DYN_SPLIT */] /* @min:%2esplit */](_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] === 2) { // only save fields with valid formats
            var key = kvParts[0][__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["N" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_24" /* objKeys */])(result)[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // use endpoint suffix where overrides are not provided
            var locationPrefix = result.location ? result.location + "." : "";
            result[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["n" /* _DYN_INGESTIONENDPOINT */] /* @min:%2eingestionendpoint */] = result[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["n" /* _DYN_INGESTIONENDPOINT */] /* @min:%2eingestionendpoint */] || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_36" /* strEndsWith */])(result[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["n" /* _DYN_INGESTIONENDPOINT */] /* @min:%2eingestionendpoint */], "/")) {
                result[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["n" /* _DYN_INGESTIONENDPOINT */] /* @min:%2eingestionendpoint */] = result[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["n" /* _DYN_INGESTIONENDPOINT */] /* @min:%2eingestionendpoint */].slice(0, -1);
            }
        }
        // apply the default endpoints
        result[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["n" /* _DYN_INGESTIONENDPOINT */] /* @min:%2eingestionendpoint */] = result[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["n" /* _DYN_INGESTIONENDPOINT */] /* @min:%2eingestionendpoint */] || __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* DEFAULT_BREEZE_ENDPOINT */];
    }
    return result;
}
var ConnectionStringParser = {
    parse: parseConnectionString
};
//# sourceMappingURL=ConnectionStringParser.js.map

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Envelope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DataSanitizer__ = __webpack_require__(138);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Envelope = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Envelope(logger, data, name) {
        var _this = this;
        var _self = this;
        _self.ver = 1;
        _self.sampleRate = 100.0;
        _self.tags = {};
        _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["w" /* _DYN_NAME */] /* @min:%2ename */] = Object(__WEBPACK_IMPORTED_MODULE_3__DataSanitizer__["g" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_1__Constants__["h" /* strNotSpecified */];
        _self.data = data;
        _self.time = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_41" /* toISOString */])(new Date());
        _self.aiDataContract = {
            time: 1 /* FieldType.Required */,
            iKey: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            sampleRate: function () {
                return (_this.sampleRate === 100) ? 4 /* FieldType.Hidden */ : 1 /* FieldType.Required */;
            },
            tags: 1 /* FieldType.Required */,
            data: 1 /* FieldType.Required */
        };
    }
    return Envelope;
}());

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Event; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(138);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var Event = /** @class */ (function () {
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["w" /* _DYN_NAME */] /* @min:%2ename */] = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strNotSpecified */];
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["B" /* _DYN_PROPERTIES */] /* @min:%2eproperties */] = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["t" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}());

//# sourceMappingURL=Event.js.map

/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _formatErrorCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Exception; });
/* unused harmony export _ExceptionDetails */
/* unused harmony export _StackFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DynamicConstants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__ = __webpack_require__(138);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
    var result = value;
    if (result && !Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_13" /* isString */])(result)) {
        if (JSON && JSON[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["L" /* _DYN_STRINGIFY */] /* @min:%2estringify */]) {
            result = JSON[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["L" /* _DYN_STRINGIFY */] /* @min:%2estringify */](value);
            if (convertToString && (!result || result === "{}")) {
                if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(value[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */])) {
                    result = value[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */]();
                }
                else {
                    result = "" + value;
                }
            }
        }
        else {
            result = "" + value + " - (Missing JSON.stringify)";
        }
    }
    return result || "";
}
function _formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        if (evtMessage && !Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_13" /* isString */])(evtMessage)) {
            evtMessage = theEvent[strMessage] || theEvent[strDescription] || evtMessage;
        }
        // Make sure the message is a string
        if (evtMessage && !Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_13" /* isString */])(evtMessage)) {
            // tslint:disable-next-line: prefer-conditional-expression
            evtMessage = _stringify(evtMessage, true);
        }
        if (theEvent["filename"]) {
            // Looks like an event object with filename
            evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
        }
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "")[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["m" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */](errorType) === -1) {
        evtMessage = errorType + ": " + evtMessage;
    }
    return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
    try {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_11" /* isObject */])(value)) {
            return "hasFullStack" in value && "typeName" in value;
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function _isExceptionInternal(value) {
    try {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_11" /* isObject */])(value)) {
            return ("ver" in value && "exceptions" in value && "properties" in value);
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function _isStackDetails(details) {
    return details && details.src && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_13" /* isString */])(details.src) && details.obj && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_2" /* isArray */])(details.obj);
}
function _convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_13" /* isString */])(src)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_13" /* isString */])(src[strStack])) {
            src = src[strStack];
        }
        else {
            src = "" + src;
        }
    }
    var items = src[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["K" /* _DYN_SPLIT */] /* @min:%2esplit */]("\n");
    return {
        src: src,
        obj: items
    };
}
function _getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["K" /* _DYN_SPLIT */] /* @min:%2esplit */]("\n");
    for (var lp = 0; lp < lines[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */]; lp++) {
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function _getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) {
        try {
            /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */
            if (errorObj[strStack]) {
                // Chrome/Firefox
                details = _convertStackObj(errorObj[strStack]);
            }
            else if (errorObj[strError] && errorObj[strError][strStack]) {
                // Edge error event provides the stack and error object
                details = _convertStackObj(errorObj[strError][strStack]);
            }
            else if (errorObj["exception"] && errorObj.exception[strStack]) {
                details = _convertStackObj(errorObj.exception[strStack]);
            }
            else if (_isStackDetails(errorObj)) {
                details = errorObj;
            }
            else if (_isStackDetails(errorObj[strStackDetails])) {
                details = errorObj[strStackDetails];
            }
            else if (window && window["opera"] && errorObj[strMessage]) {
                // Opera
                details = _getOperaStack(errorObj[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["u" /* _DYN_MESSAGE */] /* @min:%2emessage */]);
            }
            else if (errorObj["reason"] && errorObj.reason[strStack]) {
                // UnhandledPromiseRejection
                details = _convertStackObj(errorObj.reason[strStack]);
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_13" /* isString */])(errorObj)) {
                details = _convertStackObj(errorObj);
            }
            else {
                var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_13" /* isString */])(errorObj[strErrorSrc])) {
                    if (evtMessage) {
                        evtMessage += "\n";
                    }
                    evtMessage += " from " + errorObj[strErrorSrc];
                }
                if (evtMessage) {
                    details = _convertStackObj(evtMessage);
                }
            }
        }
        catch (e) {
            // something unexpected happened so to avoid failing to report any error lets swallow the exception
            // and fallback to the callee/caller method
            details = _convertStackObj(e);
        }
    }
    return details || {
        src: "",
        obj: null
    };
}
function _formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) {
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(stackDetails.obj, function (entry) {
                stack += entry + "\n";
            });
        }
        else {
            stack = stackDetails.src || "";
        }
    }
    return stack;
}
function _parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(frames, function (frame) {
            var theFrame = frame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */]();
            if (_StackFrame.regex.test(theFrame)) {
                var parsedFrame = new _StackFrame(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["J" /* _DYN_SIZE_IN_BYTES */] /* @min:%2esizeInBytes */];
                parsedStack.push(parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32 * 1024;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while (left < right) {
                // check size
                var lSize = parsedStack[left][__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["J" /* _DYN_SIZE_IN_BYTES */] /* @min:%2esizeInBytes */];
                var rSize = parsedStack[right][__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["J" /* _DYN_SIZE_IN_BYTES */] /* @min:%2esizeInBytes */];
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function _getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["w" /* _DYN_NAME */] /* @min:%2ename */] || "";
        if (!typeName) {
            try {
                var funcNameRegex = /function (.{1,200})\(/;
                var results = (funcNameRegex).exec((errorType).constructor[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["O" /* _DYN_TO_STRING */] /* @min:%2etoString */]());
                typeName = (results && results[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 1) ? results[1] : "";
            }
            catch (e) {
                // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
            }
        }
    }
    return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj The supplied errorObj
 */
function _formatErrorCode(errorObj) {
    if (errorObj) {
        try {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_13" /* isString */])(errorObj)) {
                var errorType = _getErrorType(errorObj);
                var result = _stringify(errorObj, false);
                if (!result || result === "{}") {
                    if (errorObj[strError]) {
                        // Looks like an MS Error Event
                        errorObj = errorObj[strError];
                        errorType = _getErrorType(errorObj);
                    }
                    result = _stringify(errorObj, true);
                }
                if (result[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["m" /* _DYN_INDEX_OF */] /* @min:%2eindexOf */](errorType) !== 0 && errorType !== "String") {
                    return errorType + ":" + result;
                }
                return result;
            }
        }
        catch (e) {
            // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
        }
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var Exception = /** @class */ (function () {
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */
    function Exception(logger, exception, properties, measurements, severityLevel, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            exceptions: 1 /* FieldType.Required */,
            severityLevel: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
        if (!_isExceptionInternal(exception)) {
            if (!properties) {
                properties = {};
            }
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["h" /* _DYN_EXCEPTIONS */] /* @min:%2eexceptions */] = [new _ExceptionDetails(logger, exception, properties)];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["B" /* _DYN_PROPERTIES */] /* @min:%2eproperties */] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["t" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
            if (severityLevel) {
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_SEVERITY_LEVEL */] /* @min:%2eseverityLevel */] = severityLevel;
            }
            if (id) {
                _self.id = id;
            }
        }
        else {
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["h" /* _DYN_EXCEPTIONS */] /* @min:%2eexceptions */] = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["h" /* _DYN_EXCEPTIONS */] /* @min:%2eexceptions */] || [];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["B" /* _DYN_PROPERTIES */] /* @min:%2eproperties */] = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["B" /* _DYN_PROPERTIES */] /* @min:%2eproperties */];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["t" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["t" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */];
            if (exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_SEVERITY_LEVEL */] /* @min:%2eseverityLevel */]) {
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_SEVERITY_LEVEL */] /* @min:%2eseverityLevel */] = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_SEVERITY_LEVEL */] /* @min:%2eseverityLevel */];
            }
            if (exception.id) {
                _self.id = exception.id;
            }
            if (exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["A" /* _DYN_PROBLEM_GROUP */] /* @min:%2eproblemGroup */]) {
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["A" /* _DYN_PROBLEM_GROUP */] /* @min:%2eproblemGroup */] = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["A" /* _DYN_PROBLEM_GROUP */] /* @min:%2eproblemGroup */];
            }
            // bool/int types, use isNullOrUndefined
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["p" /* _DYN_IS_MANUAL */] /* @min:%2eisManual */])) {
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["p" /* _DYN_IS_MANUAL */] /* @min:%2eisManual */] = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["p" /* _DYN_IS_MANUAL */] /* @min:%2eisManual */];
            }
        }
    }
    Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var _a;
        var errorType = _getErrorType(error || evt || message);
        return _a = {},
            _a[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["u" /* _DYN_MESSAGE */] /* @min:message */] = _formatMessage(message, errorType),
            _a.url = url,
            _a.lineNumber = lineNumber,
            _a.columnNumber = columnNumber,
            _a.error = _formatErrorCode(error || evt || message),
            _a.evt = _formatErrorCode(evt || message),
            _a[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["P" /* _DYN_TYPE_NAME */] /* @min:typeName */] = errorType,
            _a.stackDetails = _getStackFromErrorObj(stack || error || evt),
            _a.errorSrc = errorSrc,
            _a;
    };
    Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
        var exceptions = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["h" /* _DYN_EXCEPTIONS */] /* @min:%2eexceptions */]
            && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["r" /* arrMap */])(exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["h" /* _DYN_EXCEPTIONS */] /* @min:%2eexceptions */], function (ex) { return _ExceptionDetails[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["Q" /* _DYN__CREATE_FROM_INTERFA1 */] /* @min:%2eCreateFromInterface */](logger, ex); });
        var exceptionData = new Exception(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])({}, exception), { exceptions: exceptions }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function () {
        var _a;
        var _b = this, exceptions = _b.exceptions, properties = _b.properties, measurements = _b.measurements, severityLevel = _b.severityLevel, problemGroup = _b.problemGroup, id = _b.id, isManual = _b.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["r" /* arrMap */])(exceptions, function (exception) { return exception.toInterface(); })
            || undefined;
        return _a = {
                ver: "4.0"
            },
            _a[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["h" /* _DYN_EXCEPTIONS */] /* @min:exceptions */] = exceptionDetailsInterface,
            _a.severityLevel = severityLevel,
            _a.properties = properties,
            _a.measurements = measurements,
            _a.problemGroup = problemGroup,
            _a.id = id,
            _a.isManual = isManual,
            _a;
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */
    Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
        var _a;
        return {
            exceptions: [
                (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["l" /* _DYN_HAS_FULL_STACK */] /* @min:hasFullStack */] = true,
                    _a.message = message,
                    _a.stack = details,
                    _a.typeName = typeName,
                    _a)
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = _formatErrorCode;
    return Exception;
}());

var _ExceptionDetails = /** @class */ (function () {
    function _ExceptionDetails(logger, exception, properties) {
        this.aiDataContract = {
            id: 0 /* FieldType.Default */,
            outerId: 0 /* FieldType.Default */,
            typeName: 1 /* FieldType.Required */,
            message: 1 /* FieldType.Required */,
            hasFullStack: 0 /* FieldType.Default */,
            stack: 0 /* FieldType.Default */,
            parsedStack: 2 /* FieldType.Array */
        };
        var _self = this;
        if (!_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_5" /* isError */])(error)) {
                error = error[strError] || evt || error;
            }
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["P" /* _DYN_TYPE_NAME */] /* @min:%2etypeName */] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, _getErrorType(error)) || __WEBPACK_IMPORTED_MODULE_2__Constants__["h" /* strNotSpecified */];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["u" /* _DYN_MESSAGE */] /* @min:%2emessage */] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["e" /* dataSanitizeMessage */])(logger, _formatMessage(exception || error, _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["P" /* _DYN_TYPE_NAME */] /* @min:%2etypeName */])) || __WEBPACK_IMPORTED_MODULE_2__Constants__["h" /* strNotSpecified */];
            var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:%2eparsedStack */] = _parseStack(stack);
            // after parsedStack is inited, iterate over each frame object, sanitize its assembly field
            if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_2" /* isArray */])(_self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:%2eparsedStack */])) {
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["r" /* arrMap */])(_self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:%2eparsedStack */], function (frame) {
                    frame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ASSEMBLY */] /* @min:%2eassembly */] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, frame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ASSEMBLY */] /* @min:%2eassembly */]);
                    frame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_FILE_NAME */] /* @min:%2efileName */] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, frame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_FILE_NAME */] /* @min:%2efileName */]);
                });
            }
            _self[strStack] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["b" /* dataSanitizeException */])(logger, _formatStackTrace(stack));
            _self.hasFullStack = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_2" /* isArray */])(_self.parsedStack) && _self.parsedStack[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] > 0;
            if (properties) {
                properties[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["P" /* _DYN_TYPE_NAME */] /* @min:%2etypeName */] = properties[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["P" /* _DYN_TYPE_NAME */] /* @min:%2etypeName */] || _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["P" /* _DYN_TYPE_NAME */] /* @min:%2etypeName */];
            }
        }
        else {
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["P" /* _DYN_TYPE_NAME */] /* @min:%2etypeName */] = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["P" /* _DYN_TYPE_NAME */] /* @min:%2etypeName */];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["u" /* _DYN_MESSAGE */] /* @min:%2emessage */] = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["u" /* _DYN_MESSAGE */] /* @min:%2emessage */];
            _self[strStack] = exception[strStack];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:%2eparsedStack */] = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:%2eparsedStack */] || [];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["l" /* _DYN_HAS_FULL_STACK */] /* @min:%2ehasFullStack */] = exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["l" /* _DYN_HAS_FULL_STACK */] /* @min:%2ehasFullStack */];
        }
    }
    _ExceptionDetails.prototype.toInterface = function () {
        var _a;
        var _self = this;
        var parsedStack = _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:%2eparsedStack */] instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["r" /* arrMap */])(_self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:%2eparsedStack */], function (frame) { return frame.toInterface(); });
        var exceptionDetailsInterface = (_a = {
                id: _self.id,
                outerId: _self.outerId,
                typeName: _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["P" /* _DYN_TYPE_NAME */] /* @min:%2etypeName */],
                message: _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["u" /* _DYN_MESSAGE */] /* @min:%2emessage */],
                hasFullStack: _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["l" /* _DYN_HAS_FULL_STACK */] /* @min:%2ehasFullStack */],
                stack: _self[strStack]
            },
            _a[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:parsedStack */] = parsedStack || undefined,
            _a);
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function (logger, exception) {
        var parsedStack = (exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:%2eparsedStack */] instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["r" /* arrMap */])(exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:%2eparsedStack */], function (frame) { return _StackFrame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["Q" /* _DYN__CREATE_FROM_INTERFA1 */] /* @min:%2eCreateFromInterface */](frame); }))
            || exception[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_PARSED_STACK */] /* @min:%2eparsedStack */];
        var exceptionDetails = new _ExceptionDetails(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])({}, exception), { parsedStack: parsedStack }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}());

var _StackFrame = /** @class */ (function () {
    function _StackFrame(sourceFrame, level) {
        this.aiDataContract = {
            level: 1 /* FieldType.Required */,
            method: 1 /* FieldType.Required */,
            assembly: 0 /* FieldType.Default */,
            fileName: 0 /* FieldType.Default */,
            line: 0 /* FieldType.Default */
        };
        var _self = this;
        _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["J" /* _DYN_SIZE_IN_BYTES */] /* @min:%2esizeInBytes */] = 0;
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["r" /* _DYN_LEVEL */] /* @min:%2elevel */] = level;
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_METHOD */] /* @min:%2emethod */] = NoMethod;
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ASSEMBLY */] /* @min:%2eassembly */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_38" /* strTrim */])(frame);
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_FILE_NAME */] /* @min:%2efileName */] = "";
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["s" /* _DYN_LINE */] /* @min:%2eline */] = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */] >= 5) {
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_METHOD */] /* @min:%2emethod */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_38" /* strTrim */])(matches[2]) || _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_METHOD */] /* @min:%2emethod */];
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_FILE_NAME */] /* @min:%2efileName */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_38" /* strTrim */])(matches[4]);
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["s" /* _DYN_LINE */] /* @min:%2eline */] = parseInt(matches[5]) || 0;
            }
        }
        else {
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["r" /* _DYN_LEVEL */] /* @min:%2elevel */] = sourceFrame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["r" /* _DYN_LEVEL */] /* @min:%2elevel */];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_METHOD */] /* @min:%2emethod */] = sourceFrame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_METHOD */] /* @min:%2emethod */];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ASSEMBLY */] /* @min:%2eassembly */] = sourceFrame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ASSEMBLY */] /* @min:%2eassembly */];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_FILE_NAME */] /* @min:%2efileName */] = sourceFrame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_FILE_NAME */] /* @min:%2efileName */];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["s" /* _DYN_LINE */] /* @min:%2eline */] = sourceFrame[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["s" /* _DYN_LINE */] /* @min:%2eline */];
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["J" /* _DYN_SIZE_IN_BYTES */] /* @min:%2esizeInBytes */] = 0;
        }
        _self.sizeInBytes += _self.method[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */];
        _self.sizeInBytes += _self.fileName[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */];
        _self.sizeInBytes += _self.assembly[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */];
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["J" /* _DYN_SIZE_IN_BYTES */] /* @min:%2esizeInBytes */] += _StackFrame.baseSize;
        _self.sizeInBytes += _self.level.toString()[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */];
        _self.sizeInBytes += _self.line.toString()[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_LENGTH */] /* @min:%2elength */];
    }
    _StackFrame.CreateFromInterface = function (frame) {
        return new _StackFrame(frame, null /* level is available in frame interface */);
    };
    _StackFrame.prototype.toInterface = function () {
        var _self = this;
        return {
            level: _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["r" /* _DYN_LEVEL */] /* @min:%2elevel */],
            method: _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_METHOD */] /* @min:%2emethod */],
            assembly: _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ASSEMBLY */] /* @min:%2eassembly */],
            fileName: _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_FILE_NAME */] /* @min:%2efileName */],
            line: _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["s" /* _DYN_LINE */] /* @min:%2eline */]
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}());

//# sourceMappingURL=Exception.js.map

/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __exposeGlobalTsLib */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(773);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.



function __exposeGlobalTsLib() {
    var globalObj = Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {};
    // tslint:disable: only-arrow-functions
    (function (root, assignFn, extendsFn, createBindingFn) {
        // Assign the globally scoped versions of the functions -- used when consuming individual ts files
        // If check is to support NativeScript where these are marked as readonly
        if (!root.__assign) {
            root.__assign = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || assignFn;
        }
        if (!root.__extends) {
            root.__extends = extendsFn;
        }
        if (!root.__createBinding) {
            root.__createBinding = createBindingFn;
        }
    })(globalObj, __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a" /* __assignFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c" /* __extendsFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["b" /* __createBindingFn */]);
    // Assign local variables that will be used for embedded scenarios, if check is to support NativeScript where these are marked as readonly
    if (!__assign) {
        __assign = globalObj.__assign;
    }
    if (!__extends) {
        __extends = globalObj.__extends;
    }
    if (!__createBinding) {
        __createBinding = globalObj.__createBinding;
    }
}
//# sourceMappingURL=TsLibGlobals.js.map

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Metric; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataPoint__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__ = __webpack_require__(138);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Metric = /** @class */ (function () {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            metrics: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new __WEBPACK_IMPORTED_MODULE_2__Common_DataPoint__["a" /* DataPoint */]();
        dataPoint[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["c" /* _DYN_COUNT */] /* @min:%2ecount */] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["w" /* _DYN_NAME */] /* @min:%2ename */] = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strNotSpecified */];
        dataPoint.value = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [dataPoint];
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["B" /* _DYN_PROPERTIES */] /* @min:%2eproperties */] = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["t" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}());

//# sourceMappingURL=Metric.js.map

/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var DataPoint = /** @class */ (function () {
    function DataPoint() {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            name: 1 /* FieldType.Required */,
            kind: 0 /* FieldType.Default */,
            value: 1 /* FieldType.Required */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */
        };
        /**
         * Metric type. Single measurement or the aggregated value.
         */
        this.kind = 0 /* DataPointType.Measurement */;
    }
    return DataPoint;
}());

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__ = __webpack_require__(138);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var PageView = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            id: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.id = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["c" /* dataSanitizeId */])(logger, id);
        _self.url = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["h" /* dataSanitizeUrl */])(logger, url);
        _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["w" /* _DYN_NAME */] /* @min:%2ename */] = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strNotSpecified */];
        if (!isNaN(durationMs)) {
            _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["g" /* _DYN_DURATION */] /* @min:%2eduration */] = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["c" /* msToTimeSpan */])(durationMs);
        }
        _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["B" /* _DYN_PROPERTIES */] /* @min:%2eproperties */] = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["t" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}());

//# sourceMappingURL=PageView.js.map

/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteDependencyData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelperFuncs__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__ = __webpack_require__(138);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var RemoteDependencyData = /** @class */ (function () {
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */
    function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) { requestAPI = "Ajax"; }
        this.aiDataContract = {
            id: 1 /* FieldType.Required */,
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            resultCode: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            success: 0 /* FieldType.Default */,
            data: 0 /* FieldType.Default */,
            target: 0 /* FieldType.Default */,
            type: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            kind: 0 /* FieldType.Default */,
            value: 0 /* FieldType.Default */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */,
            dependencyKind: 0 /* FieldType.Default */,
            dependencySource: 0 /* FieldType.Default */,
            commandName: 0 /* FieldType.Default */,
            dependencyTypeName: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.id = id;
        _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["g" /* _DYN_DURATION */] /* @min:%2eduration */] = Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["c" /* msToTimeSpan */])(value);
        _self.success = success;
        _self.resultCode = resultCode + "";
        _self.type = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, requestAPI);
        var dependencyFields = Object(__WEBPACK_IMPORTED_MODULE_1__Util__["a" /* AjaxHelperParseDependencyPath */])(logger, absoluteUrl, method, commandName);
        _self.data = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["h" /* dataSanitizeUrl */])(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _self.target = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, dependencyFields.target);
        if (correlationContext) {
            _self.target = "".concat(_self.target, " | ").concat(correlationContext);
        }
        _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["w" /* _DYN_NAME */] /* @min:%2ename */] = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, dependencyFields[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["w" /* _DYN_NAME */] /* @min:%2ename */]);
        _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["B" /* _DYN_PROPERTIES */] /* @min:%2eproperties */] = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _self[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["t" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] = Object(__WEBPACK_IMPORTED_MODULE_3__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}());

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Trace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(138);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var Trace = /** @class */ (function () {
    /**
     * Constructs a new instance of the TraceTelemetry object
     */
    function Trace(logger, message, severityLevel, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            message: 1 /* FieldType.Required */,
            severityLevel: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        message = message || __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strNotSpecified */];
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["u" /* _DYN_MESSAGE */] /* @min:%2emessage */] = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeMessage */])(logger, message);
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["B" /* _DYN_PROPERTIES */] /* @min:%2eproperties */] = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["t" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
        if (severityLevel) {
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["I" /* _DYN_SEVERITY_LEVEL */] /* @min:%2eseverityLevel */] = severityLevel;
        }
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}());

//# sourceMappingURL=Trace.js.map

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerformance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(138);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var PageViewPerformance = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            perfTotal: 0 /* FieldType.Default */,
            networkConnect: 0 /* FieldType.Default */,
            sentRequest: 0 /* FieldType.Default */,
            receivedResponse: 0 /* FieldType.Default */,
            domProcessing: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["h" /* dataSanitizeUrl */])(logger, url);
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["w" /* _DYN_NAME */] /* @min:%2ename */] = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strNotSpecified */];
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["B" /* _DYN_PROPERTIES */] /* @min:%2eproperties */] = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["t" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
        if (cs4BaseData) {
            _self.domProcessing = cs4BaseData.domProcessing;
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["g" /* _DYN_DURATION */] /* @min:%2eduration */] = cs4BaseData[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["g" /* _DYN_DURATION */] /* @min:%2eduration */];
            _self.networkConnect = cs4BaseData.networkConnect;
            _self.perfTotal = cs4BaseData.perfTotal;
            _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["C" /* _DYN_RECEIVED_RESPONSE */] /* @min:%2ereceivedResponse */] = cs4BaseData[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["C" /* _DYN_RECEIVED_RESPONSE */] /* @min:%2ereceivedResponse */];
            _self.sentRequest = cs4BaseData.sentRequest;
        }
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}());

//# sourceMappingURL=PageViewPerformance.js.map

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Data; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Data = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            baseType: 1 /* FieldType.Required */,
            baseData: 1 /* FieldType.Required */
        };
        this.baseType = baseType;
        this.baseData = data;
    }
    return Data;
}());

//# sourceMappingURL=Data.js.map

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SeverityLevel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Defines the level of severity for the event.
 */
var SeverityLevel = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["w" /* createEnumStyle */])({
    Verbose: 0 /* eSeverityLevel.Verbose */,
    Information: 1 /* eSeverityLevel.Information */,
    Warning: 2 /* eSeverityLevel.Warning */,
    Error: 3 /* eSeverityLevel.Error */,
    Critical: 4 /* eSeverityLevel.Critical */
});
//# sourceMappingURL=SeverityLevel.js.map

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigurationManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(88);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var ConfigurationManager = /** @class */ (function () {
    function ConfigurationManager() {
    }
    ConfigurationManager.getConfig = function (config, field, identifier, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var configValue;
        if (identifier && config[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["i" /* _DYN_EXTENSION_CONFIG */] /* @min:%2eextensionConfig */] && config[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["i" /* _DYN_EXTENSION_CONFIG */] /* @min:%2eextensionConfig */][identifier] && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(config[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["i" /* _DYN_EXTENSION_CONFIG */] /* @min:%2eextensionConfig */][identifier][field])) {
            configValue = config[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["i" /* _DYN_EXTENSION_CONFIG */] /* @min:%2eextensionConfig */][identifier][field];
        }
        else {
            configValue = config[field];
        }
        return !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(configValue) ? configValue : defaultValue;
    };
    return ConfigurationManager;
}());

//# sourceMappingURL=IConfig.js.map

/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createTelemetryItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryItemCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DynamicConstants__ = __webpack_require__(88);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/**
 * Create a telemetry item that the 1DS channel understands
 * @param item domain specific properties; part B
 * @param baseType telemetry item type. ie PageViewData
 * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
 * @param customProperties user defined custom properties; part C
 * @param systemProperties system properties that are added to the context; part A
 * @returns ITelemetryItem that is sent to channel
 */
function createTelemetryItem(item, baseType, envelopeName, logger, customProperties, systemProperties) {
    var _a;
    envelopeName = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, envelopeName) || __WEBPACK_IMPORTED_MODULE_1__Constants__["h" /* strNotSpecified */];
    if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(item) ||
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(baseType) ||
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(envelopeName)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_40" /* throwError */])("Input doesn't contain all required fields");
    }
    var iKey = "";
    if (item[__WEBPACK_IMPORTED_MODULE_1__Constants__["g" /* strIkey */]]) {
        iKey = item[__WEBPACK_IMPORTED_MODULE_1__Constants__["g" /* strIkey */]];
        delete item[__WEBPACK_IMPORTED_MODULE_1__Constants__["g" /* strIkey */]];
    }
    var telemetryItem = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["w" /* _DYN_NAME */] /* @min:name */] = envelopeName,
        _a.time = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_41" /* toISOString */])(new Date()),
        _a.iKey = iKey,
        _a.ext = systemProperties ? systemProperties : {},
        _a.tags = [],
        _a.data = {},
        _a.baseType = baseType,
        _a.baseData = item // Part B
    ,
        _a);
    // Part C
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(customProperties)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(customProperties, function (prop, value) {
            telemetryItem.data[prop] = value;
        });
    }
    return telemetryItem;
}
var TelemetryItemCreator = /** @class */ (function () {
    function TelemetryItemCreator() {
    }
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item domain specific properties; part B
     * @param baseType telemetry item type. ie PageViewData
     * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
     * @param customProperties user defined custom properties; part C
     * @param systemProperties system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */
    TelemetryItemCreator.create = createTelemetryItem;
    return TelemetryItemCreator;
}());

//# sourceMappingURL=TelemetryItemCreator.js.map

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Extensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CtxTagKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contracts_ContextTagKeys__ = __webpack_require__(774);
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var CtxTagKeys = new __WEBPACK_IMPORTED_MODULE_0__Contracts_ContextTagKeys__["a" /* ContextTagKeys */]();
//# sourceMappingURL=PartAExtensions.js.map

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DynamicConstants__ = __webpack_require__(346);
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var _isWebWorker = null;
function isWebWorker() {
    if (_isWebWorker == null) {
        try {
            _isWebWorker = !!(self && self instanceof WorkerGlobalScope);
        }
        catch (e) {
            _isWebWorker = false;
        }
    }
    return _isWebWorker;
}
/**
 * Class encapsulates sending page views and page view performance telemetry.
 */
var PageViewManager = /** @class */ (function () {
    function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(PageViewManager, this, function (_self) {
            var queueTimer = null;
            var itemQueue = [];
            var pageViewPerformanceSent = false;
            var _logger;
            if (core) {
                _logger = core.logger;
            }
            function _flushChannels(isAsync) {
                if (core) {
                    core.flush(isAsync);
                }
            }
            function _startTimer() {
                if (!queueTimer) {
                    queueTimer = setTimeout((function () {
                        queueTimer = null;
                        var allItems = itemQueue.slice(0);
                        var doFlush = false;
                        itemQueue = [];
                        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(allItems, function (item) {
                            if (!item()) {
                                // Not processed so rescheduled
                                itemQueue.push(item);
                            }
                            else {
                                doFlush = true;
                            }
                        });
                        if (itemQueue[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                            _startTimer();
                        }
                        if (doFlush) {
                            // We process at least one item so flush the queue
                            _flushChannels(true);
                        }
                    }), 100);
                }
            }
            function _addQueue(cb) {
                itemQueue.push(cb);
                _startTimer();
            }
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["Q" /* _DYN_TRACK_PAGE_VIEW */] /* @min:%2etrackPageView */] = function (pageView, customProperties) {
                var name = pageView.name;
                if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(name) || typeof name !== "string") {
                    var doc = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["M" /* getDocument */])();
                    name = pageView.name = doc && doc.title || "";
                }
                var uri = pageView.uri;
                if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(uri) || typeof uri !== "string") {
                    var location_1 = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["T" /* getLocation */])();
                    uri = pageView.uri = location_1 && location_1[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["s" /* _DYN_HREF */] /* @min:%2ehref */] || "";
                }
                // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
                // do not provide the duration, set duration to undefined
                // Also this is case 4
                if (!pageViewPerformanceManager[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["u" /* _DYN_IS_PERFORMANCE_TIMIN16 */] /* @min:%2eisPerformanceTimingSupported */]()) {
                    appInsights[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["L" /* _DYN_SEND_PAGE_VIEW_INTER10 */] /* @min:%2esendPageViewInternal */](pageView, customProperties);
                    _flushChannels(true);
                    if (!isWebWorker()) {
                        // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_logger, 2 /* eLoggingSeverity.WARNING */, 25 /* _eInternalMessageId.NavigationTimingNotSupported */, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                    }
                    return;
                }
                var pageViewSent = false;
                var customDuration;
                // if the performance timing is supported by the browser, calculate the custom duration
                var start = pageViewPerformanceManager[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["r" /* _DYN_GET_PERFORMANCE_TIMI17 */] /* @min:%2egetPerformanceTiming */]()[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["C" /* _DYN_NAVIGATION_START */] /* @min:%2enavigationStart */];
                if (start > 0) {
                    customDuration = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(start, +new Date);
                    if (!pageViewPerformanceManager[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["N" /* _DYN_SHOULD_COLLECT_DURAT18 */] /* @min:%2eshouldCollectDuration */](customDuration)) {
                        customDuration = undefined;
                    }
                }
                // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
                // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
                var duration;
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(customProperties) &&
                    !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(customProperties[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_DURATION */] /* @min:%2eduration */])) {
                    duration = customProperties[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_DURATION */] /* @min:%2eduration */];
                }
                if (overridePageViewDuration || !isNaN(duration)) {
                    if (isNaN(duration)) {
                        // case 3
                        if (!customProperties) {
                            customProperties = {};
                        }
                        customProperties[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_DURATION */] /* @min:%2eduration */] = customDuration;
                    }
                    // case 2
                    appInsights[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["L" /* _DYN_SEND_PAGE_VIEW_INTER10 */] /* @min:%2esendPageViewInternal */](pageView, customProperties);
                    _flushChannels(true);
                    pageViewSent = true;
                }
                // now try to send the page view performance telemetry
                var maxDurationLimit = 60000;
                if (!customProperties) {
                    customProperties = {};
                }
                // Queue the event for processing
                _addQueue(function () {
                    var processed = false;
                    try {
                        if (pageViewPerformanceManager[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_IS_PERFORMANCE_TIMIN19 */] /* @min:%2eisPerformanceTimingDataReady */]()) {
                            processed = true;
                            var pageViewPerformance = {
                                name: name,
                                uri: uri
                            };
                            pageViewPerformanceManager[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["F" /* _DYN_POPULATE_PAGE_VIEW_P12 */] /* @min:%2epopulatePageViewPerformanceEvent */](pageViewPerformance);
                            if (!pageViewPerformance.isValid && !pageViewSent) {
                                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                                // That's the best value we can get that makes sense.
                                customProperties[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_DURATION */] /* @min:%2eduration */] = customDuration;
                                appInsights[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["L" /* _DYN_SEND_PAGE_VIEW_INTER10 */] /* @min:%2esendPageViewInternal */](pageView, customProperties);
                            }
                            else {
                                if (!pageViewSent) {
                                    customProperties[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_DURATION */] /* @min:%2eduration */] = pageViewPerformance.durationMs;
                                    appInsights[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["L" /* _DYN_SEND_PAGE_VIEW_INTER10 */] /* @min:%2esendPageViewInternal */](pageView, customProperties);
                                }
                                if (!pageViewPerformanceSent) {
                                    appInsights[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["M" /* _DYN_SEND_PAGE_VIEW_PERFO11 */] /* @min:%2esendPageViewPerformanceInternal */](pageViewPerformance, customProperties);
                                    pageViewPerformanceSent = true;
                                }
                            }
                        }
                        else if (start > 0 && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(start, +new Date) > maxDurationLimit) {
                            // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                            // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                            processed = true;
                            if (!pageViewSent) {
                                customProperties[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_DURATION */] /* @min:%2eduration */] = maxDurationLimit;
                                appInsights[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["L" /* _DYN_SEND_PAGE_VIEW_INTER10 */] /* @min:%2esendPageViewInternal */](pageView, customProperties);
                            }
                        }
                    }
                    catch (e) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_logger, 1 /* eLoggingSeverity.CRITICAL */, 38 /* _eInternalMessageId.TrackPVFailedCalc */, "trackPageView failed on page load calculation: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                    }
                    return processed;
                });
            };
            _self.teardown = function (unloadCtx, unloadState) {
                if (queueTimer) {
                    clearTimeout(queueTimer);
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush_1 = false;
                    itemQueue = [];
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(allItems, function (item) {
                        if (item()) {
                            doFlush_1 = true;
                        }
                    });
                }
            };
        });
    }
// Removed Stub for PageViewManager.prototype.trackPageView.
// Removed Stub for PageViewManager.prototype.teardown.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PageViewManager.__ieDyn=1;

    return PageViewManager;
}());

//# sourceMappingURL=PageViewManager.js.map

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerformanceManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DynamicConstants__ = __webpack_require__(346);
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var MAX_DURATION_ALLOWED = 3600000; // 1h
var botAgentNames = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
function _isPerformanceTimingSupported() {
    var perf = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["V" /* getPerformance */])();
    return perf && !!perf.timing;
}
function _isPerformanceNavigationTimingSupported() {
    var perf = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["V" /* getPerformance */])();
    return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0;
}
function _isPerformanceTimingDataReady() {
    var perf = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["V" /* getPerformance */])();
    var timing = perf ? perf.timing : 0;
    return timing
        && timing.domainLookupStart > 0
        && timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["C" /* _DYN_NAVIGATION_START */] /* @min:%2enavigationStart */] > 0
        && timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_RESPONSE_START */] /* @min:%2eresponseStart */] > 0
        && timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["G" /* _DYN_REQUEST_START */] /* @min:%2erequestStart */] > 0
        && timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["z" /* _DYN_LOAD_EVENT_END */] /* @min:%2eloadEventEnd */] > 0
        && timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["H" /* _DYN_RESPONSE_END */] /* @min:%2eresponseEnd */] > 0
        && timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["d" /* _DYN_CONNECT_END */] /* @min:%2econnectEnd */] > 0
        && timing.domLoading > 0;
}
function _getPerformanceTiming() {
    if (_isPerformanceTimingSupported()) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["V" /* getPerformance */])().timing;
    }
    return null;
}
function _getPerformanceNavigationTiming() {
    if (_isPerformanceNavigationTimingSupported()) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["V" /* getPerformance */])()[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_GET_ENTRIES_BY_TYPE */] /* @min:%2egetEntriesByType */]("navigation")[0];
    }
    return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/
function _shouldCollectDuration() {
    var durations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        durations[_i] = arguments[_i];
    }
    var _navigator = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["U" /* getNavigator */])() || {};
    // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
    var userAgent = _navigator.userAgent;
    var isGoogleBot = false;
    if (userAgent) {
        for (var i = 0; i < botAgentNames[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */]; i++) {
            isGoogleBot = isGoogleBot || userAgent.toLowerCase().indexOf(botAgentNames[i]) !== -1;
        }
    }
    if (isGoogleBot) {
        // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
        return false;
    }
    else {
        // for other page views, don't report if it's outside of a reasonable range
        for (var i = 0; i < durations[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */]; i++) {
            if (durations[i] < 0 || durations[i] >= MAX_DURATION_ALLOWED) {
                return false;
            }
        }
    }
    return true;
}
/**
 * Class encapsulates sending page view performance telemetry.
 */
var PageViewPerformanceManager = /** @class */ (function () {
    function PageViewPerformanceManager(core) {
        var _logger = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_33" /* safeGetLogger */])(core);
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(PageViewPerformanceManager, this, function (_self) {
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["F" /* _DYN_POPULATE_PAGE_VIEW_P12 */] /* @min:%2epopulatePageViewPerformanceEvent */] = function (pageViewPerformance) {
                pageViewPerformance.isValid = false;
                /*
                 * http://www.w3.org/TR/navigation-timing/#processing-model
                 *  |-navigationStart
                 *  |             |-connectEnd
                 *  |             ||-requestStart
                 *  |             ||             |-responseStart
                 *  |             ||             |              |-responseEnd
                 *  |             ||             |              |
                 *  |             ||             |              |         |-loadEventEnd
                 *  |---network---||---request---|---response---|---dom---|
                 *  |--------------------------total----------------------|
                 *
                 *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
                 *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
                 *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
                 *  response = Response time
                 *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
                 *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
                 *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
                 */
                var navigationTiming = _getPerformanceNavigationTiming();
                var timing = _getPerformanceTiming();
                var total = 0;
                var network = 0;
                var request = 0;
                var response = 0;
                var dom = 0;
                if (navigationTiming || timing) {
                    if (navigationTiming) {
                        total = navigationTiming[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_DURATION */] /* @min:%2eduration */];
                        /**
                         * support both cases:
                         * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                         * - for older browsers where the startTime is not zero
                         */
                        network = navigationTiming.startTime === 0 ? navigationTiming[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["d" /* _DYN_CONNECT_END */] /* @min:%2econnectEnd */] : Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(navigationTiming.startTime, navigationTiming[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["d" /* _DYN_CONNECT_END */] /* @min:%2econnectEnd */]);
                        request = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(navigationTiming.requestStart, navigationTiming[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_RESPONSE_START */] /* @min:%2eresponseStart */]);
                        response = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(navigationTiming[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_RESPONSE_START */] /* @min:%2eresponseStart */], navigationTiming[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["H" /* _DYN_RESPONSE_END */] /* @min:%2eresponseEnd */]);
                        dom = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(navigationTiming.responseEnd, navigationTiming[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["z" /* _DYN_LOAD_EVENT_END */] /* @min:%2eloadEventEnd */]);
                    }
                    else {
                        total = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["C" /* _DYN_NAVIGATION_START */] /* @min:%2enavigationStart */], timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["z" /* _DYN_LOAD_EVENT_END */] /* @min:%2eloadEventEnd */]);
                        network = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["C" /* _DYN_NAVIGATION_START */] /* @min:%2enavigationStart */], timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["d" /* _DYN_CONNECT_END */] /* @min:%2econnectEnd */]);
                        request = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(timing.requestStart, timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_RESPONSE_START */] /* @min:%2eresponseStart */]);
                        response = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_RESPONSE_START */] /* @min:%2eresponseStart */], timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["H" /* _DYN_RESPONSE_END */] /* @min:%2eresponseEnd */]);
                        dom = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(timing.responseEnd, timing[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["z" /* _DYN_LOAD_EVENT_END */] /* @min:%2eloadEventEnd */]);
                    }
                    if (total === 0) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_logger, 2 /* eLoggingSeverity.WARNING */, 10 /* _eInternalMessageId.ErrorPVCalc */, "error calculating page view performance.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else if (!_self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["N" /* _DYN_SHOULD_COLLECT_DURAT18 */] /* @min:%2eshouldCollectDuration */](total, network, request, response, dom)) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_logger, 2 /* eLoggingSeverity.WARNING */, 45 /* _eInternalMessageId.InvalidDurationValue */, "Invalid page load duration value. Browser perf data won't be sent.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) {
                        // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                        // in this case, don't report client performance from this page
                        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_logger, 2 /* eLoggingSeverity.WARNING */, 8 /* _eInternalMessageId.ClientPerformanceMathError */, "client performance math error.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else {
                        pageViewPerformance.durationMs = total;
                        // // convert to timespans
                        pageViewPerformance.perfTotal = pageViewPerformance[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["j" /* _DYN_DURATION */] /* @min:%2eduration */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["R" /* msToTimeSpan */])(total);
                        pageViewPerformance.networkConnect = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["R" /* msToTimeSpan */])(network);
                        pageViewPerformance.sentRequest = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["R" /* msToTimeSpan */])(request);
                        pageViewPerformance.receivedResponse = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["R" /* msToTimeSpan */])(response);
                        pageViewPerformance.domProcessing = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["R" /* msToTimeSpan */])(dom);
                        pageViewPerformance.isValid = true;
                    }
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["r" /* _DYN_GET_PERFORMANCE_TIMI17 */] /* @min:%2egetPerformanceTiming */] = _getPerformanceTiming;
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["u" /* _DYN_IS_PERFORMANCE_TIMIN16 */] /* @min:%2eisPerformanceTimingSupported */] = _isPerformanceTimingSupported;
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_IS_PERFORMANCE_TIMIN19 */] /* @min:%2eisPerformanceTimingDataReady */] = _isPerformanceTimingDataReady;
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["N" /* _DYN_SHOULD_COLLECT_DURAT18 */] /* @min:%2eshouldCollectDuration */] = _shouldCollectDuration;
        });
    }
// Removed Stub for PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent.
// Removed Stub for PageViewPerformanceManager.prototype.getPerformanceTiming.
// Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingSupported.
// Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingDataReady.
// Removed Stub for PageViewPerformanceManager.prototype.shouldCollectDuration.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PageViewPerformanceManager.__ieDyn=1;

    return PageViewPerformanceManager;
}());

//# sourceMappingURL=PageViewPerformanceManager.js.map

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageVisitTimeManager; });
/* unused harmony export PageVisitData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DynamicConstants__ = __webpack_require__(346);
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/**
 * Used to track page visit durations
 */
var PageVisitTimeManager = /** @class */ (function () {
    /**
     * Creates a new instance of PageVisitTimeManager
     * @param pageVisitTimeTrackingHandler Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
     * @returns {}
     */
    function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
        var prevPageVisitDataKeyName = "prevPageVisitData";
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(PageVisitTimeManager, this, function (_self) {
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["R" /* _DYN_TRACK_PREVIOUS_PAGE_9 */] /* @min:%2etrackPreviousPageVisit */] = function (currentPageName, currentPageUrl) {
                try {
                    // Restart timer for new page view
                    var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                    // If there was a page already being timed, track the visit time for it now.
                    if (prevPageVisitTimeData) {
                        pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
                    }
                }
                catch (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["m" /* _warnToConsole */])(logger, "Auto track page visit time failed, metric will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e));
                }
            };
            /**
             * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
             * @param pageName Name of page to begin timing visit duration
             * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
             */
            function restartPageVisitTimer(pageName, pageUrl) {
                var prevPageVisitData = null;
                try {
                    prevPageVisitData = stopPageVisitTimer();
                    startPageVisitTimer(pageName, pageUrl);
                }
                catch (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["m" /* _warnToConsole */])(logger, "Call to restart failed: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            /**
             * Starts timing visit duration of pageName
             * @param pageName
             * @returns {}
             */
            function startPageVisitTimer(pageName, pageUrl) {
                try {
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["Y" /* utlCanUseSessionStorage */])()) {
                        if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["_2" /* utlGetSessionStorage */])(logger, prevPageVisitDataKeyName) != null) {
                            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_40" /* throwError */])("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                        }
                        var currPageVisitData = new PageVisitData(pageName, pageUrl);
                        var currPageVisitDataStr = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["S" /* getJSON */])().stringify(currPageVisitData);
                        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["_6" /* utlSetSessionStorage */])(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
                    }
                }
                catch (e) {
                    // TODO: Remove this catch in next phase, since if start is called twice in a row the exception needs to be propagated out
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["m" /* _warnToConsole */])(logger, "Call to start failed: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e));
                }
            }
            /**
             * Stops timing of current page, if exists.
             * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
             */
            function stopPageVisitTimer() {
                var prevPageVisitData = null;
                try {
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["Y" /* utlCanUseSessionStorage */])()) {
                        // Define end time of page's visit
                        var pageVisitEndTime = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["B" /* dateNow */])();
                        // Try to retrieve  page name and start time from session storage
                        var pageVisitDataJsonStr = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["_2" /* utlGetSessionStorage */])(logger, prevPageVisitDataKeyName);
                        if (pageVisitDataJsonStr && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_0" /* hasJSON */])()) {
                            // if previous page data exists, set end time of visit
                            prevPageVisitData = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["S" /* getJSON */])().parse(pageVisitDataJsonStr);
                            prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["E" /* _DYN_PAGE_VISIT_START_TIM20 */] /* @min:%2epageVisitStartTime */];
                            // Remove data from storage since we already used it
                            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["_3" /* utlRemoveSessionStorage */])(logger, prevPageVisitDataKeyName);
                        }
                    }
                }
                catch (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["m" /* _warnToConsole */])(logger, "Stop page visit timer failed: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            // For backward compatibility
            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_22" /* objDefineAccessors */])(_self, "_logger", function () { return logger; });
            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_22" /* objDefineAccessors */])(_self, "pageVisitTimeTrackingHandler", function () { return pageVisitTimeTrackingHandler; });
        });
    }
// Removed Stub for PageVisitTimeManager.prototype.trackPreviousPageVisit.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PageVisitTimeManager.__ieDyn=1;

    return PageVisitTimeManager;
}());

var PageVisitData = /** @class */ (function () {
    function PageVisitData(pageName, pageUrl) {
        this[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["E" /* _DYN_PAGE_VISIT_START_TIM20 */] /* @min:%2epageVisitStartTime */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["B" /* dateNow */])();
        this.pageName = pageName;
        this.pageUrl = pageUrl;
    }
    return PageVisitData;
}());

//# sourceMappingURL=PageVisitTimeManager.js.map

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Timing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




/**
 * Used to record timed events and page views.
 */
var Timing = /** @class */ (function () {
    function Timing(logger, name) {
        var _self = this;
        var _events = {};
        _self.start = function (name) {
            if (typeof _events[name] !== "undefined") {
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 62 /* _eInternalMessageId.StartCalledMoreThanOnce */, "start was called more than once for this event without calling stop.", { name: name, key: name }, true);
            }
            _events[name] = +new Date;
        };
        _self.stop = function (name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) {
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 63 /* _eInternalMessageId.StopCalledWithoutStart */, "stop was called without a corresponding start.", { name: name, key: name }, true);
            }
            else {
                var end = +new Date;
                var duration = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["M" /* dateTimeUtilsDuration */])(start, end);
                _self.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        };
    }
    return Timing;
}());

//# sourceMappingURL=Timing.js.map

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EnvelopeCreator__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Offline__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SendBuffer__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Serializer__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TelemetryProcessors_Sample__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DynamicConstants__ = __webpack_require__(184);
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a;










var FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function _getResponseText(xhr) {
    try {
        return xhr.responseText;
    }
    catch (e) {
        // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function _getDefaultAppInsightsChannelConfig() {
    var _a;
    var defaultValue;
    var defaultCustomHeaders;
    // set default values
    return _a = {
            endpointUrl: function () { return __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["h" /* DEFAULT_BREEZE_ENDPOINT */] + __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["i" /* DEFAULT_BREEZE_PATH */]; }
        },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["p" /* _DYN_EMIT_LINE_DELIMITED_0 */] /* @min:emitLineDelimitedJson */] = function () { return false; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["G" /* _DYN_MAX_BATCH_INTERVAL */] /* @min:maxBatchInterval */] = function () { return 15000; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["H" /* _DYN_MAX_BATCH_SIZE_IN_BY1 */] /* @min:maxBatchSizeInBytes */] = function () { return 102400; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["n" /* _DYN_DISABLE_TELEMETRY */] /* @min:disableTelemetry */] = function () { return false; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["q" /* _DYN_ENABLE_SESSION_STORA4 */] /* @min:enableSessionStorageBuffer */] = function () { return true; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["c" /* _DYN_BUFFER_OVERRIDE */] /* @min:bufferOverride */] = function () { return false; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["B" /* _DYN_IS_RETRY_DISABLED */] /* @min:isRetryDisabled */] = function () { return false; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["z" /* _DYN_IS_BEACON_API_DISABL3 */] /* @min:isBeaconApiDisabled */] = function () { return true; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["o" /* _DYN_DISABLE_XHR */] /* @min:disableXhr */] = function () { return false; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["M" /* _DYN_ONUNLOAD_DISABLE_FET5 */] /* @min:onunloadDisableFetch */] = function () { return false; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["L" /* _DYN_ONUNLOAD_DISABLE_BEA2 */] /* @min:onunloadDisableBeacon */] = function () { return false; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["y" /* _DYN_INSTRUMENTATION_KEY */] /* @min:instrumentationKey */] = function () { return defaultValue; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["K" /* _DYN_NAME_PREFIX */] /* @min:namePrefix */] = function () { return defaultValue; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["Q" /* _DYN_SAMPLING_PERCENTAGE */] /* @min:samplingPercentage */] = function () { return 100; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["h" /* _DYN_CUSTOM_HEADERS */] /* @min:customHeaders */] = function () { return defaultCustomHeaders; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["f" /* _DYN_CONVERT_UNDEFINED */] /* @min:convertUndefined */] = function () { return defaultValue; },
        _a[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["u" /* _DYN_EVENTS_LIMIT_IN_MEM */] /* @min:eventsLimitInMem */] = function () { return 10000; },
        _a.retryCodes = function () { return null; },
        _a;
}
var EnvelopeTypeCreator = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["p" /* Event */].dataType] = __WEBPACK_IMPORTED_MODULE_4__EnvelopeCreator__["b" /* EventEnvelopeCreator */],
    _a[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["D" /* Trace */].dataType] = __WEBPACK_IMPORTED_MODULE_4__EnvelopeCreator__["g" /* TraceEnvelopeCreator */],
    _a[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["u" /* PageView */].dataType] = __WEBPACK_IMPORTED_MODULE_4__EnvelopeCreator__["e" /* PageViewEnvelopeCreator */],
    _a[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["v" /* PageViewPerformance */].dataType] = __WEBPACK_IMPORTED_MODULE_4__EnvelopeCreator__["f" /* PageViewPerformanceEnvelopeCreator */],
    _a[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["q" /* Exception */].dataType] = __WEBPACK_IMPORTED_MODULE_4__EnvelopeCreator__["c" /* ExceptionEnvelopeCreator */],
    _a[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["t" /* Metric */].dataType] = __WEBPACK_IMPORTED_MODULE_4__EnvelopeCreator__["d" /* MetricEnvelopeCreator */],
    _a[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["y" /* RemoteDependencyData */].dataType] = __WEBPACK_IMPORTED_MODULE_4__EnvelopeCreator__["a" /* DependencyEnvelopeCreator */],
    _a);
var Sender = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* __extendsFn */])(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["b" /* BreezeChannelIdentifier */];
        /**
         * The configuration for this sender instance
         */
        _this._senderConfig = _getDefaultAppInsightsChannelConfig();
        // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
        var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
        var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
        var _lastSend; // The time of the last send operation.
        var _paused; // Flag indicating that the sending should be paused
        var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
        var _serializer;
        var _stamp_specific_redirects;
        var _headers;
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _fallbackSender; // The sender to use if the payload size is too large
        var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
        var _offlineListener;
        var _evtNamespace;
        var _retryCodes;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(Sender, _this, function (_self, _base) {
            _initDefaults();
            _self.pause = function () {
                _clearScheduledTimer();
                _paused = true;
            };
            _self.resume = function () {
                if (_paused) {
                    _paused = false;
                    _retryAt = null;
                    // flush if we have exceeded the max-size already
                    if (_self._buffer.size() > _self._senderConfig[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["H" /* _DYN_MAX_BATCH_SIZE_IN_BY1 */] /* @min:%2emaxBatchSizeInBytes */]()) {
                        _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["W" /* _DYN_TRIGGER_SEND */] /* @min:%2etriggerSend */](true, null, 10 /* SendRequestReason.MaxBatchSize */);
                    }
                    _setupTimer();
                }
            };
            _self.flush = function (isAsync, callBack, sendReason) {
                if (isAsync === void 0) { isAsync = true; }
                if (!_paused) {
                    // Clear the normal schedule timer as we are going to try and flush ASAP
                    _clearScheduledTimer();
                    try {
                        _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["W" /* _DYN_TRIGGER_SEND */] /* @min:%2etriggerSend */](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */);
                    }
                    catch (e) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 22 /* _eInternalMessageId.FlushFailed */, "flush failed, telemetry will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                    }
                }
            };
            _self.onunloadFlush = function () {
                if (!_paused) {
                    if ((_self._senderConfig[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["L" /* _DYN_ONUNLOAD_DISABLE_BEA2 */] /* @min:%2eonunloadDisableBeacon */]() === false || _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["z" /* _DYN_IS_BEACON_API_DISABL3 */] /* @min:%2eisBeaconApiDisabled */]() === false) && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_3" /* isBeaconsSupported */])()) {
                        try {
                            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["W" /* _DYN_TRIGGER_SEND */] /* @min:%2etriggerSend */](true, _doUnloadSend, 2 /* SendRequestReason.Unload */);
                        }
                        catch (e) {
                            Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                        }
                    }
                    else {
                        _self.flush();
                    }
                }
            };
            _self.addHeader = function (name, value) {
                _headers[name] = value;
            };
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender is already initialized");
                }
                _base.initialize(config, core, extensions, pluginChain);
                var ctx = _self._getTelCtx();
                var identifier = _self.identifier;
                _serializer = new __WEBPACK_IMPORTED_MODULE_7__Serializer__["a" /* Serializer */](core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = 0;
                _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_3" /* _DYN__SENDER */] /* @min:%2e_sender */] = null;
                _stamp_specific_redirects = 0;
                var diagLog = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */]();
                _evtNamespace = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_19" /* mergeEvtNamespace */])(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["z" /* createUniqueNamespace */])("Sender"), core.evtNamespace && core.evtNamespace());
                _offlineListener = Object(__WEBPACK_IMPORTED_MODULE_5__Offline__["a" /* createOfflineListener */])(_evtNamespace);
                // TODO v3.x: Change the ISenderConfig to not be function calls
                var defaultConfig = _getDefaultAppInsightsChannelConfig();
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(defaultConfig, function (field, value) {
                    _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][field] = function () {
                        var theValue = ctx.getConfig(identifier, field, value());
                        if (!theValue && field === "endpointUrl") {
                            // Use the default value (handles empty string in the configuration)
                            theValue = value();
                        }
                        return theValue;
                    };
                });
                _retryCodes = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */].retryCodes();
                if (config.storagePrefix) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["_7" /* utlSetStoragePrefix */])(config.storagePrefix);
                }
                var useSessionStorage = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["q" /* _DYN_ENABLE_SESSION_STORA4 */] /* @min:%2eenableSessionStorageBuffer */]() &&
                    !!(_self._senderConfig[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["c" /* _DYN_BUFFER_OVERRIDE */] /* @min:%2ebufferOverride */]() || Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["Y" /* utlCanUseSessionStorage */])());
                _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["X" /* _DYN__BUFFER */] /* @min:%2e_buffer */] = useSessionStorage
                    ? new __WEBPACK_IMPORTED_MODULE_6__SendBuffer__["b" /* SessionStorageSendBuffer */](diagLog, _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */])
                    : new __WEBPACK_IMPORTED_MODULE_6__SendBuffer__["a" /* ArraySendBuffer */](diagLog, _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */]);
                _self._sample = new __WEBPACK_IMPORTED_MODULE_8__TelemetryProcessors_Sample__["a" /* Sample */](_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["Q" /* _DYN_SAMPLING_PERCENTAGE */] /* @min:%2esamplingPercentage */](), diagLog);
                if (!_validateInstrumentationKey(config)) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(diagLog, 1 /* eLoggingSeverity.CRITICAL */, 100 /* _eInternalMessageId.InvalidInstrumentationKey */, "Invalid Instrumentation key " + config[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["y" /* _DYN_INSTRUMENTATION_KEY */] /* @min:%2einstrumentationKey */]);
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["Q" /* isInternalApplicationInsightsEndpoint */])(_self._senderConfig.endpointUrl()) && _self._senderConfig.customHeaders() && _self._senderConfig.customHeaders()[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["h" /* _DYN_CUSTOM_HEADERS */] /* @min:%2ecustomHeaders */](), function (customHeader) {
                        _this.addHeader(customHeader.header, customHeader.value);
                    });
                }
                var senderConfig = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */];
                var sendPostFunc = null;
                if (!senderConfig[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["o" /* _DYN_DISABLE_XHR */] /* @min:%2edisableXhr */]() && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_43" /* useXDomainRequest */])()) {
                    sendPostFunc = _xdrSender; // IE 8 and 9
                }
                else if (!senderConfig[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["o" /* _DYN_DISABLE_XHR */] /* @min:%2edisableXhr */]() && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_18" /* isXhrSupported */])()) {
                    sendPostFunc = _xhrSender;
                }
                if (!sendPostFunc && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_6" /* isFetchSupported */])()) {
                    sendPostFunc = _fetchSender;
                }
                // always fallback to XHR
                _fallbackSender = sendPostFunc || _xhrSender;
                if (!senderConfig[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["z" /* _DYN_IS_BEACON_API_DISABL3 */] /* @min:%2eisBeaconApiDisabled */]() && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_3" /* isBeaconsSupported */])()) {
                    // Config is set to always used beacon sending
                    sendPostFunc = _beaconSender;
                }
                _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_3" /* _DYN__SENDER */] /* @min:%2e_sender */] = sendPostFunc || _xhrSender;
                if (!senderConfig[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["M" /* _DYN_ONUNLOAD_DISABLE_FET5 */] /* @min:%2eonunloadDisableFetch */]() && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_6" /* isFetchSupported */])(true)) {
                    // Try and use the fetch with keepalive
                    _syncUnloadSender = _fetchKeepAliveSender;
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_3" /* isBeaconsSupported */])()) {
                    // Try and use sendBeacon
                    _syncUnloadSender = _beaconSender;
                }
                else if (!senderConfig[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["o" /* _DYN_DISABLE_XHR */] /* @min:%2edisableXhr */]() && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_43" /* useXDomainRequest */])()) {
                    _syncUnloadSender = _xdrSender; // IE 8 and 9
                }
                else if (!senderConfig[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["o" /* _DYN_DISABLE_XHR */] /* @min:%2edisableXhr */]() && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_18" /* isXhrSupported */])()) {
                    _syncUnloadSender = _xhrSender;
                }
                else {
                    _syncUnloadSender = _fallbackSender;
                }
            };
            _self.processTelemetry = function (telemetryItem, itemCtx) {
                itemCtx = _self._getTelCtx(itemCtx);
                var diagLogger = itemCtx[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */]();
                try {
                    // if master off switch is set, don't send any data
                    if (_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["n" /* _DYN_DISABLE_TELEMETRY */] /* @min:%2edisableTelemetry */]()) {
                        // Do not send/save data
                        return;
                    }
                    // validate input
                    if (!telemetryItem) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */, "Cannot send empty telemetry");
                        return;
                    }
                    // validate event
                    if (telemetryItem.baseData && !telemetryItem[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["a" /* _DYN_BASE_TYPE */] /* @min:%2ebaseType */]) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 70 /* _eInternalMessageId.InvalidEvent */, "Cannot send telemetry without baseData and baseType");
                        return;
                    }
                    if (!telemetryItem[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["a" /* _DYN_BASE_TYPE */] /* @min:%2ebaseType */]) {
                        // Default
                        telemetryItem[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["a" /* _DYN_BASE_TYPE */] /* @min:%2ebaseType */] = "EventData";
                    }
                    // ensure a sender was constructed
                    if (!_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_3" /* _DYN__SENDER */] /* @min:%2e_sender */]) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender was not initialized");
                        return;
                    }
                    // check if this item should be sampled in, else add sampleRate tag
                    if (!_isSampledIn(telemetryItem)) {
                        // Item is sampled out, do not send it
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(diagLogger, 2 /* eLoggingSeverity.WARNING */, 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */, "Telemetry item was sampled out and not sent", { SampleRate: _self._sample[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["P" /* _DYN_SAMPLE_RATE */] /* @min:%2esampleRate */] });
                        return;
                    }
                    else {
                        telemetryItem[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["A" /* SampleRate */]] = _self._sample[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["P" /* _DYN_SAMPLE_RATE */] /* @min:%2esampleRate */];
                    }
                    var convertUndefined = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["f" /* _DYN_CONVERT_UNDEFINED */] /* @min:%2econvertUndefined */]() || undefined;
                    // construct an envelope that Application Insights endpoint can understand
                    // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
                    var defaultEnvelopeIkey = telemetryItem.iKey || _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["y" /* _DYN_INSTRUMENTATION_KEY */] /* @min:%2einstrumentationKey */]();
                    var aiEnvelope_1 = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, convertUndefined);
                    if (!aiEnvelope_1) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 47 /* _eInternalMessageId.CreateEnvelopeError */, "Unable to create an AppInsights envelope");
                        return;
                    }
                    var doNotSendItem_1 = false;
                    // this is for running in legacy mode, where customer may already have a custom initializer present
                    if (telemetryItem[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */] && telemetryItem[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */][__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["w" /* ProcessLegacy */]]) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(telemetryItem[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */][__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["w" /* ProcessLegacy */]], function (callBack) {
                            try {
                                if (callBack && callBack(aiEnvelope_1) === false) {
                                    doNotSendItem_1 = true;
                                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["m" /* _warnToConsole */])(diagLogger, "Telemetry processor check returns false");
                                }
                            }
                            catch (e) {
                                // log error but dont stop executing rest of the telemetry initializers
                                // doNotSendItem = true;
                                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "One of telemetry initializers failed, telemetry item will not be sent: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) }, true);
                            }
                        });
                        delete telemetryItem[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */][__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["w" /* ProcessLegacy */]];
                    }
                    if (doNotSendItem_1) {
                        return; // do not send, no need to execute next plugin
                    }
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer.serialize(aiEnvelope_1);
                    // flush if we would exceed the max-size limit by adding this item
                    var buffer = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["X" /* _DYN__BUFFER */] /* @min:%2e_buffer */];
                    var bufferSize = buffer.size();
                    if ((bufferSize + payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */]) > _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["H" /* _DYN_MAX_BATCH_SIZE_IN_BY1 */] /* @min:%2emaxBatchSizeInBytes */]()) {
                        if (!_offlineListener || _offlineListener[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["A" /* _DYN_IS_ONLINE */] /* @min:%2eisOnline */]()) { // only trigger send when currently online
                            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["W" /* _DYN_TRIGGER_SEND */] /* @min:%2etriggerSend */](true, null, 10 /* SendRequestReason.MaxBatchSize */);
                        }
                    }
                    // enqueue the payload
                    buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["s" /* _DYN_ENQUEUE */] /* @min:%2eenqueue */](payload);
                    // ensure an invocation timeout is set
                    _setupTimer();
                }
                catch (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(diagLogger, 2 /* eLoggingSeverity.WARNING */, 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            /**
             * xhr state changes
             */
            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_6" /* _DYN__XHR_READY_STATE_CHA6 */] /* @min:%2e_xhrReadyStateChange */] = function (xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) {
                    _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, _formatErrorMessageXhr(xhr), _getResponseText(xhr) || xhr.response);
                }
            };
            /**
             * Immediately send buffered data
             * @param async {boolean} - Indicates if the events should be sent asynchronously
             * @param forcedSender {SenderFunction} - Indicates the forcedSender, undefined if not passed
             */
            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["W" /* _DYN_TRIGGER_SEND */] /* @min:%2etriggerSend */] = function (async, forcedSender, sendReason) {
                if (async === void 0) { async = true; }
                if (!_paused) {
                    try {
                        var buffer = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["X" /* _DYN__BUFFER */] /* @min:%2e_buffer */];
                        // Send data only if disableTelemetry is false
                        if (!_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["n" /* _DYN_DISABLE_TELEMETRY */] /* @min:%2edisableTelemetry */]()) {
                            if (buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["g" /* _DYN_COUNT */] /* @min:%2ecount */]() > 0) {
                                var payload = buffer.getItems();
                                _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */, async);
                                // invoke send
                                if (forcedSender) {
                                    forcedSender.call(_self, payload, async);
                                }
                                else {
                                    _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_3" /* _DYN__SENDER */] /* @min:%2e_sender */](payload, async);
                                }
                            }
                            // update lastSend time to enable throttling
                            _lastSend = +new Date;
                        }
                        else {
                            buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["d" /* _DYN_CLEAR */] /* @min:%2eclear */]();
                        }
                        _clearScheduledTimer();
                    }
                    catch (e) {
                        /* Ignore this error for IE under v10 */
                        var ieVer = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["R" /* getIEVersion */])();
                        if (!ieVer || ieVer > 9) {
                            Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 40 /* _eInternalMessageId.TransmissionFailed */, "Telemetry transmission failed, some telemetry will be lost: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                        }
                    }
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _self.onunloadFlush();
                _offlineListener.unload();
                _initDefaults();
            };
            /**
             * error handler
             */
            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */] = function (payload, message, event) {
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 26 /* _eInternalMessageId.OnError */, "Failed to send telemetry.", { message: message });
                _self._buffer && _self._buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["e" /* _DYN_CLEAR_SENT */] /* @min:%2eclearSent */](payload);
            };
            /**
             * partial success handler
             */
            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_1" /* _DYN__ON_PARTIAL_SUCCESS */] /* @min:%2e_onPartialSuccess */] = function (payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) {
                        retry[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["O" /* _DYN_PUSH */] /* @min:%2epush */](extracted);
                    }
                    else {
                        // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                        failed[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["O" /* _DYN_PUSH */] /* @min:%2epush */](extracted);
                    }
                }
                if (payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_2" /* _DYN__ON_SUCCESS */] /* @min:%2e_onSuccess */](payload, results[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["C" /* _DYN_ITEMS_ACCEPTED */] /* @min:%2eitemsAccepted */]);
                }
                if (failed[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */](failed, _formatErrorMessageXhr(null, ["partial success", results[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["C" /* _DYN_ITEMS_ACCEPTED */] /* @min:%2eitemsAccepted */], "of", results.itemsReceived].join(" ")));
                }
                if (retry[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    _resendPayload(retry);
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, "Partial success. " +
                        "Delivered: " + payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] + ", Failed: " + failed[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] +
                        ". Will retry to send " + retry[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] + " our of " + results[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["D" /* _DYN_ITEMS_RECEIVED */] /* @min:%2eitemsReceived */] + " items");
                }
            };
            /**
             * success handler
             */
            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_2" /* _DYN__ON_SUCCESS */] /* @min:%2e_onSuccess */] = function (payload, countOfItemsInPayload) {
                _self._buffer && _self._buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["e" /* _DYN_CLEAR_SENT */] /* @min:%2eclearSent */](payload);
            };
            /**
             * xdr state changes
             */
            _self._xdrOnLoad = function (xdr, payload) {
                var responseText = _getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_2" /* _DYN__ON_SUCCESS */] /* @min:%2e_onSuccess */](payload, 0);
                }
                else {
                    var results = _parseResponse(responseText);
                    if (results && results.itemsReceived && results.itemsReceived > results[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["C" /* _DYN_ITEMS_ACCEPTED */] /* @min:%2eitemsAccepted */]
                        && !_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["B" /* _DYN_IS_RETRY_DISABLED */] /* @min:%2eisRetryDisabled */]()) {
                        _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_1" /* _DYN__ON_PARTIAL_SUCCESS */] /* @min:%2e_onPartialSuccess */](payload, results);
                    }
                    else {
                        _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */](payload, _formatErrorMessageXdr(xdr));
                    }
                }
            };
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = _parseResponse(res);
                    if (response && response.appId) {
                        _self._appId = response.appId;
                    }
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 307 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */](payload, errorMessage);
                            return;
                        }
                    }
                    if (!_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["B" /* _DYN_IS_RETRY_DISABLED */] /* @min:%2eisRetryDisabled */]() && _isRetriable(status)) {
                        _resendPayload(payload);
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " +
                            "Response code " + status + ". Will retry to send " + payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] + " items.");
                    }
                    else {
                        _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */](payload, errorMessage);
                    }
                }
                else if (_offlineListener && !_offlineListener[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["A" /* _DYN_IS_ONLINE */] /* @min:%2eisOnline */]()) { // offline
                    // Note: Don't check for status == 0, since adblock gives this code
                    if (!_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["B" /* _DYN_IS_RETRY_DISABLED */] /* @min:%2eisRetryDisabled */]()) {
                        var offlineBackOffMultiplier = 10; // arbritrary number
                        _resendPayload(payload, offlineBackOffMultiplier);
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                    }
                }
                else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) {
                            response = _parseResponse(res);
                        }
                        if (response && !_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["B" /* _DYN_IS_RETRY_DISABLED */] /* @min:%2eisRetryDisabled */]()) {
                            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_1" /* _DYN__ON_PARTIAL_SUCCESS */] /* @min:%2e_onPartialSuccess */](payload, response);
                        }
                        else {
                            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */](payload, errorMessage);
                        }
                    }
                    else {
                        _consecutiveErrors = 0;
                        _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_2" /* _DYN__ON_SUCCESS */] /* @min:%2e_onSuccess */](payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) {
                    //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                    //  _stamp_specific_redirects = 0;
                    return false;
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(responseUrl) && responseUrl !== "") {
                    if (responseUrl !== _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["r" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */]()) {
                        _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["r" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */] = function () { return responseUrl; };
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            function _doUnloadSend(payload, isAsync) {
                if (_syncUnloadSender) {
                    // We are unloading so always call the sender with sync set to false
                    _syncUnloadSender(payload, false);
                }
                else {
                    // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
                    _beaconSender(payload, isAsync);
                }
            }
            function _doBeaconSend(payload) {
                var nav = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["U" /* getNavigator */])();
                var buffer = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["X" /* _DYN__BUFFER */] /* @min:%2e_buffer */];
                var url = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["r" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */]();
                var batch = _self._buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["b" /* _DYN_BATCH_PAYLOADS */] /* @min:%2ebatchPayloads */](payload);
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = new Blob([batch], { type: "text/plain;charset=UTF-8" });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = nav.sendBeacon(url, plainTextBatch);
                if (queued) {
                    buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["F" /* _DYN_MARK_AS_SENT */] /* @min:%2emarkAsSent */](payload);
                    // no response from beaconSender, clear buffer
                    _self._onSuccess(payload, payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */]);
                }
                return queued;
            }
            /**
             * Send Beacon API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _beaconSender(payload, isAsync) {
                if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_2" /* isArray */])(payload) && payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                    if (!_doBeaconSend(payload)) {
                        // Failed to send entire payload so try and split data and try to send as much events as possible
                        var droppedPayload = [];
                        for (var lp = 0; lp < payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */]; lp++) {
                            var thePayload = payload[lp];
                            if (!_doBeaconSend([thePayload])) {
                                // Can't send anymore, so split the batch and drop the rest
                                droppedPayload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["O" /* _DYN_PUSH */] /* @min:%2epush */](thePayload);
                            }
                        }
                        if (droppedPayload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                            _fallbackSender && _fallbackSender(droppedPayload, true);
                            Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                        }
                    }
                }
            }
            /**
             * Send XMLHttpRequest
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - Indicates if the request should be sent asynchronously
             */
            function _xhrSender(payload, isAsync) {
                var xhr = new XMLHttpRequest();
                var endPointUrl = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["r" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */]();
                try {
                    xhr[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["m" /* DisabledPropertyName */]] = true;
                }
                catch (e) {
                    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                    // cause the request to fail and we no telemetry would be sent
                }
                xhr.open("POST", endPointUrl, isAsync);
                xhr[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["R" /* _DYN_SET_REQUEST_HEADER */] /* @min:%2esetRequestHeader */]("Content-type", "application/json");
                // append Sdk-Context request header only in case of breeze endpoint
                if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["Q" /* isInternalApplicationInsightsEndpoint */])(endPointUrl)) {
                    xhr[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["R" /* _DYN_SET_REQUEST_HEADER */] /* @min:%2esetRequestHeader */](__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][6 /* eRequestHeaders.sdkContextHeader */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */]);
                }
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_24" /* objKeys */])(_headers), function (headerName) {
                    xhr[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["R" /* _DYN_SET_REQUEST_HEADER */] /* @min:%2esetRequestHeader */](headerName, _headers[headerName]);
                });
                xhr.onreadystatechange = function () { return _self._xhrReadyStateChange(xhr, payload, payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */]); };
                xhr.onerror = function (event) { return _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */](payload, _formatErrorMessageXhr(xhr), event); };
                // compose an array of payloads
                var batch = _self._buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["b" /* _DYN_BATCH_PAYLOADS */] /* @min:%2ebatchPayloads */](payload);
                xhr.send(batch);
                _self._buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["F" /* _DYN_MARK_AS_SENT */] /* @min:%2emarkAsSent */](payload);
            }
            function _fetchKeepAliveSender(payload, isAsync) {
                if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_2" /* isArray */])(payload)) {
                    var payloadSize = payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */];
                    for (var lp = 0; lp < payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */]; lp++) {
                        payloadSize += payload[lp][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */];
                    }
                    if ((_syncFetchPayload + payloadSize) <= FetchSyncRequestSizeLimitBytes) {
                        _doFetchSender(payload, false);
                    }
                    else if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_3" /* isBeaconsSupported */])()) {
                        // Fallback to beacon sender as we at least get told which events can't be scheduled
                        _beaconSender(payload, isAsync);
                    }
                    else {
                        // Payload is going to be too big so just try and send via XHR
                        _fallbackSender && _fallbackSender(payload, true);
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with xhrSender.");
                    }
                }
            }
            /**
             * Send fetch API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - not used
             */
            function _fetchSender(payload, isAsync) {
                _doFetchSender(payload, true);
            }
            /**
             * Send fetch API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - For fetch this identifies whether we are "unloading" (false) or a normal request
             */
            function _doFetchSender(payload, isAsync) {
                var _a;
                var endPointUrl = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["r" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */]();
                var batch = _self._buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["b" /* _DYN_BATCH_PAYLOADS */] /* @min:%2ebatchPayloads */](payload);
                var plainTextBatch = new Blob([batch], { type: "application/json" });
                var requestHeaders = new Headers();
                var batchLength = batch[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */];
                var ignoreResponse = false;
                var responseHandled = false;
                // append Sdk-Context request header only in case of breeze endpoint
                if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["Q" /* isInternalApplicationInsightsEndpoint */])(endPointUrl)) {
                    requestHeaders.append(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][6 /* eRequestHeaders.sdkContextHeader */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */]);
                }
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_24" /* objKeys */])(_headers), function (headerName) {
                    requestHeaders.append(headerName, _headers[headerName]);
                });
                var init = (_a = {
                        method: "POST",
                        headers: requestHeaders,
                        body: plainTextBatch
                    },
                    _a[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["m" /* DisabledPropertyName */]] = true // Mark so we don't attempt to track this request
                ,
                    _a);
                if (!isAsync) {
                    init.keepalive = true;
                    // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
                    // just like beacon send assume that the events have been accepted and processed
                    ignoreResponse = true;
                    _syncFetchPayload += batchLength;
                }
                var request = new Request(endPointUrl, init);
                try {
                    // Also try and tag the request (just in case the value in init is not copied over)
                    request[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["m" /* DisabledPropertyName */]] = true;
                }
                catch (e) {
                    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                    // cause the request to fail and we no telemetry would be sent
                }
                _self._buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["F" /* _DYN_MARK_AS_SENT */] /* @min:%2emarkAsSent */](payload);
                try {
                    fetch(request).then(function (response) {
                        if (!isAsync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            /**
                             * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                             * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                             * or if anything prevented the request from completing.
                             */
                            if (!response.ok) {
                                _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */](payload, response.statusText);
                            }
                            else {
                                response.text().then(function (text) {
                                    _checkResponsStatus(response.status, payload, response.url, payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */], response.statusText, text);
                                });
                            }
                        }
                    })["catch"](function (error) {
                        if (!isAsync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */](payload, error.message);
                        }
                    });
                }
                catch (e) {
                    if (!responseHandled) {
                        _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */](payload, Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e));
                    }
                }
                if (ignoreResponse && !responseHandled) {
                    // Assume success during unload processing as we most likely won't get the response
                    responseHandled = true;
                    _self._onSuccess(payload, payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */]);
                }
            }
            /**
             * Parses the response from the backend.
             * @param response - XMLHttpRequest or XDomainRequest response
             */
            function _parseResponse(response) {
                try {
                    if (response && response !== "") {
                        var result = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["S" /* getJSON */])().parse(response);
                        if (result && result.itemsReceived && result.itemsReceived >= result[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["C" /* _DYN_ITEMS_ACCEPTED */] /* @min:%2eitemsAccepted */] &&
                            result.itemsReceived - result.itemsAccepted === result.errors[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */]) {
                            return result;
                        }
                    }
                }
                catch (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 43 /* _eInternalMessageId.InvalidBackendResponse */, "Cannot parse the response. " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), {
                        response: response
                    });
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */
            function _resendPayload(payload, linearFactor) {
                if (linearFactor === void 0) { linearFactor = 1; }
                if (!payload || payload[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] === 0) {
                    return;
                }
                var buffer = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["X" /* _DYN__BUFFER */] /* @min:%2e_buffer */];
                buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["e" /* _DYN_CLEAR_SENT */] /* @min:%2eclearSent */](payload);
                _consecutiveErrors++;
                for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
                    var item = payload_1[_i];
                    buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["s" /* _DYN_ENQUEUE */] /* @min:%2eenqueue */](item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */
            function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) {
                    delayInSeconds = SlotDelayInSeconds;
                }
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["B" /* dateNow */])() + (delayInSeconds * 1000);
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */
            function _setupTimer() {
                if (!_timeoutHandle && !_paused) {
                    var retryInterval = _retryAt ? Math.max(0, _retryAt - Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["B" /* dateNow */])()) : 0;
                    var timerValue = Math.max(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["G" /* _DYN_MAX_BATCH_INTERVAL */] /* @min:%2emaxBatchInterval */](), retryInterval);
                    _timeoutHandle = setTimeout(function () {
                        _timeoutHandle = null;
                        _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["W" /* _DYN_TRIGGER_SEND */] /* @min:%2etriggerSend */](true, null, 1 /* SendRequestReason.NormalSchedule */);
                    }, timerValue);
                }
            }
            function _clearScheduledTimer() {
                clearTimeout(_timeoutHandle);
                _timeoutHandle = null;
                _retryAt = null;
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */
            function _isRetriable(statusCode) {
                // retryCodes = [] means should not retry
                if (!Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(_retryCodes)) {
                    return _retryCodes[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["q" /* arrIndexOf */])(_retryCodes, statusCode) > -1;
                }
                return statusCode === 401 // Unauthorized
                    // Removing as private links can return a 403 which causes excessive retries and session storage usage
                    //|| statusCode === 403 // Forbidden
                    || statusCode === 408 // Timeout
                    || statusCode === 429 // Too many requests.
                    || statusCode === 500 // Internal server error.
                    || statusCode === 502 // Bad Gateway.
                    || statusCode === 503 // Service unavailable.
                    || statusCode === 504; // Gateway timeout.
            }
            function _formatErrorMessageXhr(xhr, message) {
                if (xhr) {
                    return "XMLHttpRequest,Status:" + xhr.status + ",Response:" + _getResponseText(xhr) || xhr.response || "";
                }
                return message;
            }
            /**
             * Send XDomainRequest
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - Indicates if the request should be sent asynchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _xdrSender(payload, isAsync) {
                var buffer = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["X" /* _DYN__BUFFER */] /* @min:%2e_buffer */];
                var _window = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["X" /* getWindow */])();
                var xdr = new XDomainRequest();
                xdr.onload = function () { return _self._xdrOnLoad(xdr, payload); };
                xdr.onerror = function (event) { return _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_0" /* _DYN__ON_ERROR */] /* @min:%2e_onError */](payload, _formatErrorMessageXdr(xdr), event); };
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location.protocol || "";
                if (_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["r" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */]().lastIndexOf(hostingProtocol, 0) !== 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " +
                        "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.");
                    buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["d" /* _DYN_CLEAR */] /* @min:%2eclear */]();
                    return;
                }
                var endpointUrl = _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_4" /* _DYN__SENDER_CONFIG */] /* @min:%2e_senderConfig */][__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["r" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */]().replace(/^(https?:)/, "");
                xdr.open("POST", endpointUrl);
                // compose an array of payloads
                var batch = buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["b" /* _DYN_BATCH_PAYLOADS */] /* @min:%2ebatchPayloads */](payload);
                xdr.send(batch);
                buffer[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["F" /* _DYN_MARK_AS_SENT */] /* @min:%2emarkAsSent */](payload);
            }
            function _formatErrorMessageXdr(xdr, message) {
                if (xdr) {
                    return "XDomainRequest,Response:" + _getResponseText(xdr) || "";
                }
                return message;
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = "getNotifyMgr";
                if (_self.core[func]) {
                    return _self.core[func]();
                }
                // using _self.core['_notificationManager'] for backward compatibility
                return _self.core["_notificationManager"];
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["v" /* _DYN_EVENTS_SEND_REQUEST */] /* @min:%2eeventsSendRequest */]) {
                    try {
                        manager[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["v" /* _DYN_EVENTS_SEND_REQUEST */] /* @min:%2eeventsSendRequest */](sendRequest, isAsync);
                    }
                    catch (e) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["l" /* _DYN_DIAG_LOG */] /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 74 /* _eInternalMessageId.NotificationException */, "send request notification failed: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                    }
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */
            function _validateInstrumentationKey(config) {
                var disableIKeyValidationFlag = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(config[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["m" /* _DYN_DISABLE_INSTRUMENTAT7 */] /* @min:%2edisableInstrumentationKeyValidation */]) ? false : config[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["m" /* _DYN_DISABLE_INSTRUMENTAT7 */] /* @min:%2edisableInstrumentationKeyValidation */];
                if (disableIKeyValidationFlag) {
                    return true;
                }
                var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(config[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["y" /* _DYN_INSTRUMENTATION_KEY */] /* @min:%2einstrumentationKey */]);
            }
            function _initDefaults() {
                _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["_3" /* _DYN__SENDER */] /* @min:%2e_sender */] = null;
                _self[__WEBPACK_IMPORTED_MODULE_9__DynamicConstants__["X" /* _DYN__BUFFER */] /* @min:%2e_buffer */] = null;
                _self._appId = null;
                _self._sample = null;
                _headers = {};
                _offlineListener = null;
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = null;
                _paused = false;
                _timeoutHandle = null;
                _serializer = null;
                _stamp_specific_redirects = 0;
                _syncFetchPayload = 0;
                _fallbackSender = null;
                _syncUnloadSender = null;
                _evtNamespace = null;
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function (orig, iKey, logger, convertUndefined) {
        var envelope;
        if (iKey !== orig.iKey && !Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(iKey)) {
            envelope = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])({}, orig), { iKey: iKey });
        }
        else {
            envelope = orig;
        }
        var creator = EnvelopeTypeCreator[envelope.baseType] || __WEBPACK_IMPORTED_MODULE_4__EnvelopeCreator__["b" /* EventEnvelopeCreator */];
        return creator(logger, envelope, convertUndefined);
    };
// Removed Stub for Sender.prototype.pause.
// Removed Stub for Sender.prototype.resume.
// Removed Stub for Sender.prototype.flush.
// Removed Stub for Sender.prototype.onunloadFlush.
// Removed Stub for Sender.prototype.initialize.
// Removed Stub for Sender.prototype.processTelemetry.
// Removed Stub for Sender.prototype._xhrReadyStateChange.
// Removed Stub for Sender.prototype.triggerSend.
// Removed Stub for Sender.prototype._onError.
// Removed Stub for Sender.prototype._onPartialSuccess.
// Removed Stub for Sender.prototype._onSuccess.
// Removed Stub for Sender.prototype._xdrOnLoad.
// Removed Stub for Sender.prototype.addHeader.
    return Sender;
}(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["b" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=Sender.js.map

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __exposeGlobalTsLib */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(776);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.



function __exposeGlobalTsLib() {
    var globalObj = Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {};
    // tslint:disable: only-arrow-functions
    (function (root, assignFn, extendsFn, createBindingFn) {
        // Assign the globally scoped versions of the functions -- used when consuming individual ts files
        // If check is to support NativeScript where these are marked as readonly
        if (!root.__assign) {
            root.__assign = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || assignFn;
        }
        if (!root.__extends) {
            root.__extends = extendsFn;
        }
        if (!root.__createBinding) {
            root.__createBinding = createBindingFn;
        }
    })(globalObj, __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a" /* __assignFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c" /* __extendsFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["b" /* __createBindingFn */]);
    // Assign local variables that will be used for embedded scenarios, if check is to support NativeScript where these are marked as readonly
    if (!__assign) {
        __assign = globalObj.__assign;
    }
    if (!__extends) {
        __extends = globalObj.__extends;
    }
    if (!__createBinding) {
        __createBinding = globalObj.__createBinding;
    }
}
//# sourceMappingURL=TsLibGlobals.js.map

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EnvelopeCreator */
/* harmony export (immutable) */ __webpack_exports__["a"] = DependencyEnvelopeCreator;
/* harmony export (immutable) */ __webpack_exports__["b"] = EventEnvelopeCreator;
/* harmony export (immutable) */ __webpack_exports__["c"] = ExceptionEnvelopeCreator;
/* harmony export (immutable) */ __webpack_exports__["d"] = MetricEnvelopeCreator;
/* harmony export (immutable) */ __webpack_exports__["e"] = PageViewEnvelopeCreator;
/* harmony export (immutable) */ __webpack_exports__["f"] = PageViewPerformanceEnvelopeCreator;
/* harmony export (immutable) */ __webpack_exports__["g"] = TraceEnvelopeCreator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InternalConstants__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DynamicConstants__ = __webpack_require__(184);
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var strBaseType = "baseType";
var strBaseData = "baseData";
var strProperties = "properties";
var strTrue = "true";
function _setValueIf(target, field, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_35" /* setValue */])(target, field, value, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_14" /* isTruthy */]);
}
/*
 * Maps Part A data from CS 4.0
 */
function _extractPartAExtensions(logger, item, env) {
    // todo: switch to keys from common in this method
    var envTags = env[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */] = env[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */] || {};
    var itmExt = item.ext = item.ext || {};
    var itmTags = item[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */] = item[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */] || [];
    var extUser = itmExt.user;
    if (extUser) {
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].userAuthUserId, extUser.authId);
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].userId, extUser.id || extUser.localId);
    }
    var extApp = itmExt.app;
    if (extApp) {
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].sessionId, extApp.sesId);
    }
    var extDevice = itmExt.device;
    if (extDevice) {
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].deviceId, extDevice.id || extDevice.localId);
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["k" /* _DYN_DEVICE_TYPE */] /* @min:%2edeviceType */], extDevice.deviceClass);
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].deviceIp, extDevice.ip);
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].deviceModel, extDevice.model);
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["k" /* _DYN_DEVICE_TYPE */] /* @min:%2edeviceType */], extDevice[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["k" /* _DYN_DEVICE_TYPE */] /* @min:%2edeviceType */]);
    }
    var web = item.ext.web;
    if (web) {
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].deviceLanguage, web.browserLang);
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].deviceBrowserVersion, web.browserVer);
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].deviceBrowser, web.browser);
        var envData = env[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */] = env[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */] || {};
        var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
        var envProps = envBaseData[strProperties] = envBaseData[strProperties] || {};
        _setValueIf(envProps, "domain", web.domain);
        _setValueIf(envProps, "isManual", web.isManual ? strTrue : null);
        _setValueIf(envProps, "screenRes", web.screenRes);
        _setValueIf(envProps, "userConsent", web.userConsent ? strTrue : null);
    }
    var extOs = itmExt.os;
    if (extOs) {
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].deviceOS, extOs[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_NAME */] /* @min:%2ename */]);
    }
    // No support for mapping Trace.traceState to 2.0 as it is currently empty
    var extTrace = itmExt.trace;
    if (extTrace) {
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].operationParentId, extTrace.parentID);
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].operationName, Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["K" /* dataSanitizeString */])(logger, extTrace[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_NAME */] /* @min:%2ename */]));
        _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].operationId, extTrace[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["V" /* _DYN_TRACE_ID */] /* @min:%2etraceID */]);
    }
    // Sample 4.0 schema
    //  {
    //     "time" : "2018-09-05T22:51:22.4936Z",
    //     "name" : "MetricWithNamespace",
    //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
    //     "ext": {  "cloud": {
    //          "role": "WATSON3",
    //          "roleInstance": "CO4AEAP00000260"
    //      },
    //      "device": {}, "correlation": {} },
    //      "tags": [
    //        { "amazon.region" : "east2" },
    //        { "os.expid" : "wp:02df239" }
    //     ]
    //   }
    var tgs = {};
    // deals with tags.push({object})
    for (var i = itmTags[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] - 1; i >= 0; i--) {
        var tg = itmTags[i];
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(tg, function (key, value) {
            tgs[key] = value;
        });
        itmTags.splice(i, 1);
    }
    // deals with tags[key]=value (and handles hasOwnProperty)
    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(itmTags, function (tg, value) {
        tgs[tg] = value;
    });
    var theTags = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])({}, envTags), tgs);
    if (!theTags[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].internalSdkVersion]) {
        // Append a version in case it is not already set
        theTags[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* CtxTagKeys */].internalSdkVersion] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["K" /* dataSanitizeString */])(logger, "javascript:".concat(EnvelopeCreator.Version), 64);
    }
    env[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_25" /* optimizeObject */])(theTags);
}
function _extractPropsAndMeasurements(data, properties, measurements) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(data)) {
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(data, function (key, value) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_10" /* isNumber */])(value)) {
                measurements[key] = value;
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_13" /* isString */])(value)) {
                properties[key] = value;
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_0" /* hasJSON */])()) {
                properties[key] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["S" /* getJSON */])()[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["S" /* _DYN_STRINGIFY */] /* @min:%2estringify */](value);
            }
        });
    }
}
function _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(properties)) {
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(properties, function (key, value) {
            properties[key] = value || customUndefinedValue;
        });
    }
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function _createEnvelope(logger, envelopeType, telemetryItem, data) {
    var envelope = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["o" /* Envelope */](logger, data, envelopeType);
    _setValueIf(envelope, "sampleRate", telemetryItem[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["A" /* SampleRate */]]);
    if ((telemetryItem[strBaseData] || {}).startTime) {
        envelope.time = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_41" /* toISOString */])(telemetryItem[strBaseData].startTime);
    }
    envelope.iKey = telemetryItem.iKey;
    var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
    envelope[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_NAME */] /* @min:%2ename */] = envelope[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_NAME */] /* @min:%2ename */].replace("{0}", iKeyNoDashes);
    // extract all extensions from ctx
    _extractPartAExtensions(logger, telemetryItem, envelope);
    // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
    telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */] = telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */] || [];
    return Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_25" /* optimizeObject */])(envelope);
}
function EnvelopeCreatorInit(logger, telemetryItem) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(telemetryItem[strBaseData])) {
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 1 /* eLoggingSeverity.CRITICAL */, 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */, "telemetryItem.baseData cannot be null.");
    }
}
var EnvelopeCreator = {
    Version: '2.8.18'
};
function DependencyEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[strBaseData][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["I" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */], customProperties, customMeasurements);
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(bd)) {
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["m" /* _warnToConsole */])(logger, "Invalid input for dependency data");
        return null;
    }
    var method = bd[strProperties] && bd[strProperties][__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["s" /* HttpMethod */]] ? bd[strProperties][__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["s" /* HttpMethod */]] : "GET";
    var remoteDepData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["y" /* RemoteDependencyData */](logger, bd.id, bd.target, bd[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_NAME */] /* @min:%2ename */], bd[__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["a" /* STR_DURATION */] /* @min:%2eduration */], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
    var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["y" /* RemoteDependencyData */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["j" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], remoteDepData);
    return _createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["y" /* RemoteDependencyData */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], telemetryItem, data);
}
function EventEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customProperties = {};
    var customMeasurements = {};
    if (telemetryItem[strBaseType] !== __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["p" /* Event */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["j" /* _DYN_DATA_TYPE */] /* @min:%2edataType */]) {
        customProperties["baseTypeSource"] = telemetryItem[strBaseType]; // save the passed in base type as a property
    }
    if (telemetryItem[strBaseType] === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["p" /* Event */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["j" /* _DYN_DATA_TYPE */] /* @min:%2edataType */]) { // take collection
        customProperties = telemetryItem[strBaseData][strProperties] || {};
        customMeasurements = telemetryItem[strBaseData][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["I" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] || {};
    }
    else { // if its not a known type, convert to custom event
        if (telemetryItem[strBaseData]) {
            _extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
        }
    }
    // Extract root level properties from part C telemetryItem.data
    _extractPropsAndMeasurements(telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */], customProperties, customMeasurements);
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var eventName = telemetryItem[strBaseData][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_NAME */] /* @min:%2ename */];
    var eventData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["p" /* Event */](logger, eventName, customProperties, customMeasurements);
    var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["p" /* Event */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["j" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], eventData);
    return _createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["p" /* Event */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], telemetryItem, data);
}
function ExceptionEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    // Extract root level properties from part C telemetryItem.data
    var customMeasurements = telemetryItem[strBaseData][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["I" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */], customProperties, customMeasurements);
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    var exData = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* Exception */].CreateFromInterface(logger, bd, customProperties, customMeasurements);
    var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* Exception */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["j" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], exData);
    return _createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* Exception */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], telemetryItem, data);
}
function MetricEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var baseData = telemetryItem[strBaseData];
    var props = baseData[strProperties] || {};
    var measurements = baseData[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["I" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */], props, measurements);
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    }
    var baseMetricData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["t" /* Metric */](logger, baseData[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_NAME */] /* @min:%2ename */], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
    var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["t" /* Metric */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["j" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], baseMetricData);
    return _createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["t" /* Metric */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], telemetryItem, data);
}
function PageViewEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    // Since duration is not part of the domain properties in Common Schema, extract it from part C
    var duration;
    var baseData = telemetryItem[strBaseData];
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(baseData) &&
        !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(baseData[strProperties]) &&
        !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(baseData[strProperties][__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["a" /* STR_DURATION */]])) { // from part B properties
        duration = baseData[strProperties][__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["a" /* STR_DURATION */]];
        delete baseData[strProperties][__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["a" /* STR_DURATION */]];
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */]) &&
        !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */][__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["a" /* STR_DURATION */]])) { // from custom properties
        duration = telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */][__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["a" /* STR_DURATION */]];
        delete telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */][__WEBPACK_IMPORTED_MODULE_3__InternalConstants__["a" /* STR_DURATION */]];
    }
    var bd = telemetryItem[strBaseData];
    // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
    var currentContextId;
    if (((telemetryItem.ext || {}).trace || {})[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["V" /* _DYN_TRACE_ID */] /* @min:%2etraceID */]) {
        currentContextId = telemetryItem.ext.trace[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["V" /* _DYN_TRACE_ID */] /* @min:%2etraceID */];
    }
    var id = bd.id || currentContextId;
    var name = bd[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_NAME */] /* @min:%2ename */];
    var url = bd.uri;
    var properties = bd[strProperties] || {};
    var measurements = bd[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["I" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] || {};
    // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(bd.refUri)) {
        properties["refUri"] = bd.refUri;
    }
    // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(bd.pageType)) {
        properties["pageType"] = bd.pageType;
    }
    // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(bd.isLoggedIn)) {
        properties["isLoggedIn"] = bd.isLoggedIn[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["U" /* _DYN_TO_STRING */] /* @min:%2etoString */]();
    }
    // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(bd[strProperties])) {
        var pageTags = bd[strProperties];
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(pageTags, function (key, value) {
            properties[key] = value;
        });
    }
    _extractPropsAndMeasurements(telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */], properties, measurements);
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    }
    var pageViewData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["u" /* PageView */](logger, name, url, duration, properties, measurements, id);
    var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["u" /* PageView */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["j" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], pageViewData);
    return _createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["u" /* PageView */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], telemetryItem, data);
}
function PageViewPerformanceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var bd = telemetryItem[strBaseData];
    var name = bd[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["J" /* _DYN_NAME */] /* @min:%2ename */];
    var url = bd.uri || bd.url;
    var properties = bd[strProperties] || {};
    var measurements = bd[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["I" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */], properties, measurements);
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    }
    var baseData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["v" /* PageViewPerformance */](logger, name, url, undefined, properties, measurements, bd);
    var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["v" /* PageViewPerformance */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["j" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], baseData);
    return _createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["v" /* PageViewPerformance */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], telemetryItem, data);
}
function TraceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var message = telemetryItem[strBaseData].message;
    var severityLevel = telemetryItem[strBaseData].severityLevel;
    var props = telemetryItem[strBaseData][strProperties] || {};
    var measurements = telemetryItem[strBaseData][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["I" /* _DYN_MEASUREMENTS */] /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["i" /* _DYN_DATA */] /* @min:%2edata */], props, measurements);
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    }
    var baseData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["D" /* Trace */](logger, message, severityLevel, props, measurements);
    var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["D" /* Trace */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["j" /* _DYN_DATA_TYPE */] /* @min:%2edataType */], baseData);
    return _createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["D" /* Trace */][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["t" /* _DYN_ENVELOPE_TYPE */] /* @min:%2eenvelopeType */], telemetryItem, data);
}
//# sourceMappingURL=EnvelopeCreator.js.map

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STR_DURATION; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var STR_DURATION = "duration";
//# sourceMappingURL=InternalConstants.js.map

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createOfflineListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(184);
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


function _disableEvents(target, evtNamespace) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* eventOff */])(target, null, null, evtNamespace);
}
/**
 * Create a new OfflineListener instance to monitor browser online / offline events
 * @param parentEvtNamespace - The parent event namespace to append to any specific events for this instance
 */
function createOfflineListener(parentEvtNamespace) {
    var _a;
    var _document = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* getDocument */])();
    var _navigator = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["U" /* getNavigator */])(); // Gets the window.navigator or workerNavigator depending on the global
    var _isListening = false;
    var _onlineStatus = true;
    var _evtNamespace = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_19" /* mergeEvtNamespace */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["z" /* createUniqueNamespace */])("OfflineListener"), parentEvtNamespace);
    try {
        if (_enableEvents(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["X" /* getWindow */])())) {
            _isListening = true;
        }
        if (_document) {
            // Also attach to the document.body or document
            var target = _document.body || _document;
            if (target.ononline) {
                if (_enableEvents(target)) {
                    _isListening = true;
                }
            }
        }
        if (_isListening) {
            // We are listening to events so lets set the current status rather than assuming we are online #1538
            if (_navigator && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(_navigator[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["N" /* _DYN_ON_LINE */] /* @min:%2eonLine */])) { // navigator.onLine is undefined in react-native
                _onlineStatus = _navigator[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["N" /* _DYN_ON_LINE */] /* @min:%2eonLine */];
            }
        }
    }
    catch (e) {
        // this makes react-native less angry
        _isListening = false;
    }
    function _enableEvents(target) {
        var enabled = false;
        if (target) {
            enabled = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* eventOn */])(target, "online", _setOnline, _evtNamespace);
            if (enabled) {
                Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* eventOn */])(target, "offline", _setOffline, _evtNamespace);
            }
        }
        return enabled;
    }
    function _setOnline() {
        _onlineStatus = true;
    }
    function _setOffline() {
        _onlineStatus = false;
    }
    function _isOnline() {
        var result = true;
        if (_isListening) {
            result = _onlineStatus;
        }
        else if (_navigator && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(_navigator[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["N" /* _DYN_ON_LINE */] /* @min:%2eonLine */])) { // navigator.onLine is undefined in react-native
            result = _navigator[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["N" /* _DYN_ON_LINE */] /* @min:%2eonLine */];
        }
        return result;
    }
    function _unload() {
        var win = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["X" /* getWindow */])();
        if (win && _isListening) {
            _disableEvents(win, _evtNamespace);
            if (_document) {
                // Also attach to the document.body or document
                var target = _document.body || _document;
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["_15" /* isUndefined */])(target.ononline)) {
                    _disableEvents(target, _evtNamespace);
                }
            }
            _isListening = false;
        }
    }
    return _a = {},
        _a[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["A" /* _DYN_IS_ONLINE */] /* @min:isOnline */] = _isOnline,
        _a.isListening = function () { return _isListening; },
        _a.unload = _unload,
        _a;
}
//# sourceMappingURL=Offline.js.map

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArraySendBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SessionStorageSendBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DynamicConstants__ = __webpack_require__(184);
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var BaseSendBuffer = /** @class */ (function () {
    function BaseSendBuffer(logger, config) {
        var _buffer = [];
        var _bufferFullMessageSent = false;
        this._get = function () {
            return _buffer;
        };
        this._set = function (buffer) {
            _buffer = buffer;
            return _buffer;
        };
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(BaseSendBuffer, this, function (_self) {
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_ENQUEUE */] /* @min:%2eenqueue */] = function (payload) {
                if (_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_COUNT */] /* @min:%2ecount */]() >= config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["u" /* _DYN_EVENTS_LIMIT_IN_MEM */] /* @min:%2eeventsLimitInMem */]()) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 105 /* _eInternalMessageId.InMemoryStorageBufferFull */, "Maximum in-memory buffer size reached: " + _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_COUNT */] /* @min:%2ecount */](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _buffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["O" /* _DYN_PUSH */] /* @min:%2epush */](payload);
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_COUNT */] /* @min:%2ecount */] = function () {
                return _buffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */];
            };
            _self.size = function () {
                var size = _buffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */];
                for (var lp = 0; lp < _buffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */]; lp++) {
                    size += _buffer[lp][__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */];
                }
                if (!config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["p" /* _DYN_EMIT_LINE_DELIMITED_0 */] /* @min:%2eemitLineDelimitedJson */]()) {
                    size += 2;
                }
                return size;
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["d" /* _DYN_CLEAR */] /* @min:%2eclear */] = function () {
                _buffer = [];
                _bufferFullMessageSent = false;
            };
            _self.getItems = function () {
                return _buffer.slice(0);
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["b" /* _DYN_BATCH_PAYLOADS */] /* @min:%2ebatchPayloads */] = function (payload) {
                if (payload && payload[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    var batch = config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["p" /* _DYN_EMIT_LINE_DELIMITED_0 */] /* @min:%2eemitLineDelimitedJson */]() ?
                        payload.join("\n") :
                        "[" + payload.join(",") + "]";
                    return batch;
                }
                return null;
            };
        });
    }
// Removed Stub for BaseSendBuffer.prototype.enqueue.
// Removed Stub for BaseSendBuffer.prototype.count.
// Removed Stub for BaseSendBuffer.prototype.size.
// Removed Stub for BaseSendBuffer.prototype.clear.
// Removed Stub for BaseSendBuffer.prototype.getItems.
// Removed Stub for BaseSendBuffer.prototype.batchPayloads.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    BaseSendBuffer.__ieDyn=1;

    return BaseSendBuffer;
}());
/*
 * An array based send buffer.
 */
var ArraySendBuffer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* __extendsFn */])(ArraySendBuffer, _super);
    function ArraySendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(ArraySendBuffer, _this, function (_self, _base) {
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["F" /* _DYN_MARK_AS_SENT */] /* @min:%2emarkAsSent */] = function (payload) {
                _base[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["d" /* _DYN_CLEAR */] /* @min:%2eclear */]();
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CLEAR_SENT */] /* @min:%2eclearSent */] = function (payload) {
                // not supported
            };
        });
        return _this;
    }
// Removed Stub for ArraySendBuffer.prototype.markAsSent.
// Removed Stub for ArraySendBuffer.prototype.clearSent.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    ArraySendBuffer.__ieDyn=1;

    return ArraySendBuffer;
}(BaseSendBuffer));

/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */
var SessionStorageSendBuffer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* __extendsFn */])(SessionStorageSendBuffer, _super);
    function SessionStorageSendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        var _bufferFullMessageSent = false;
        var _a = config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["c" /* _DYN_BUFFER_OVERRIDE */] /* @min:%2ebufferOverride */]() || { getItem: __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["_2" /* utlGetSessionStorage */], setItem: __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["_6" /* utlSetSessionStorage */] }, getItem = _a.getItem, setItem = _a.setItem;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(SessionStorageSendBuffer, _this, function (_self, _base) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Y" /* _DYN__BUFFER__KEY */] /* @min:%2eBUFFER_KEY */]);
            var notDeliveredItems = _getBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_5" /* _DYN__SENT__BUFFER__KEY */] /* @min:%2eSENT_BUFFER_KEY */]);
            var buffer = _self._set(bufferItems.concat(notDeliveredItems));
            // If the buffer has too many items, drop items from the end.
            if (buffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Z" /* _DYN__MAX__BUFFER__SIZE */] /* @min:%2eMAX_BUFFER_SIZE */]) {
                buffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] = SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Z" /* _DYN__MAX__BUFFER__SIZE */] /* @min:%2eMAX_BUFFER_SIZE */];
            }
            _setBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_5" /* _DYN__SENT__BUFFER__KEY */] /* @min:%2eSENT_BUFFER_KEY */], []);
            _setBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Y" /* _DYN__BUFFER__KEY */] /* @min:%2eBUFFER_KEY */], buffer);
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_ENQUEUE */] /* @min:%2eenqueue */] = function (payload) {
                if (_self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_COUNT */] /* @min:%2ecount */]() >= SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Z" /* _DYN__MAX__BUFFER__SIZE */] /* @min:%2eMAX_BUFFER_SIZE */]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Maximum buffer size reached: " + _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["g" /* _DYN_COUNT */] /* @min:%2ecount */](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _base[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["s" /* _DYN_ENQUEUE */] /* @min:%2eenqueue */](payload);
                _setBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Y" /* _DYN__BUFFER__KEY */] /* @min:%2eBUFFER_KEY */], _self._get());
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["d" /* _DYN_CLEAR */] /* @min:%2eclear */] = function () {
                _base[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["d" /* _DYN_CLEAR */] /* @min:%2eclear */]();
                _setBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Y" /* _DYN__BUFFER__KEY */] /* @min:%2eBUFFER_KEY */], _self._get());
                _setBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_5" /* _DYN__SENT__BUFFER__KEY */] /* @min:%2eSENT_BUFFER_KEY */], []);
                _bufferFullMessageSent = false;
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["F" /* _DYN_MARK_AS_SENT */] /* @min:%2emarkAsSent */] = function (payload) {
                _setBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Y" /* _DYN__BUFFER__KEY */] /* @min:%2eBUFFER_KEY */], _self._set(_removePayloadsFromBuffer(payload, _self._get())));
                var sentElements = _getBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_5" /* _DYN__SENT__BUFFER__KEY */] /* @min:%2eSENT_BUFFER_KEY */]);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements.concat(payload);
                    if (sentElements[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Z" /* _DYN__MAX__BUFFER__SIZE */] /* @min:%2eMAX_BUFFER_SIZE */]) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 1 /* eLoggingSeverity.CRITICAL */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Sent buffer reached its maximum size: " + sentElements[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */], true);
                        sentElements[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] = SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["Z" /* _DYN__MAX__BUFFER__SIZE */] /* @min:%2eMAX_BUFFER_SIZE */];
                    }
                    _setBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_5" /* _DYN__SENT__BUFFER__KEY */] /* @min:%2eSENT_BUFFER_KEY */], sentElements);
                }
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["e" /* _DYN_CLEAR_SENT */] /* @min:%2eclearSent */] = function (payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_5" /* _DYN__SENT__BUFFER__KEY */] /* @min:%2eSENT_BUFFER_KEY */]);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["_5" /* _DYN__SENT__BUFFER__KEY */] /* @min:%2eSENT_BUFFER_KEY */], sentElements);
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(buffer, function (value) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(value) && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["q" /* arrIndexOf */])(payloads, value) === -1) {
                        remaining[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["O" /* _DYN_PUSH */] /* @min:%2epush */](value);
                    }
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                try {
                    prefixedKey = config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["K" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */] && config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["K" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */]() ? config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["K" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */]() + "_" + prefixedKey : prefixedKey;
                    var bufferJson = getItem(logger, prefixedKey);
                    if (bufferJson) {
                        var buffer_1 = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["S" /* getJSON */])().parse(bufferJson);
                        if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_13" /* isString */])(buffer_1)) {
                            // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                            buffer_1 = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["S" /* getJSON */])().parse(buffer_1);
                        }
                        if (buffer_1 && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_2" /* isArray */])(buffer_1)) {
                            return buffer_1;
                        }
                    }
                }
                catch (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 1 /* eLoggingSeverity.CRITICAL */, 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */, " storage key: " + prefixedKey + ", " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["K" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */] && config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["K" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */]() ? config[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["K" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */]() + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["S" /* _DYN_STRINGIFY */] /* @min:%2estringify */](buffer);
                    setItem(logger, prefixedKey, bufferJson);
                }
                catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    setItem(logger, prefixedKey, JSON[__WEBPACK_IMPORTED_MODULE_4__DynamicConstants__["S" /* _DYN_STRINGIFY */] /* @min:%2estringify */]([]));
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 41 /* _eInternalMessageId.FailedToSetStorageBuffer */, " storage key: " + prefixedKey + ", " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e) + ". Buffer cleared", { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
            }
        });
        return _this;
    }
// Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
// Removed Stub for SessionStorageSendBuffer.prototype.clear.
// Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
// Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}(BaseSendBuffer));

//# sourceMappingURL=SendBuffer.js.map

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Serializer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(184);
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var Serializer = /** @class */ (function () {
    function Serializer(logger) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(Serializer, this, function (_self) {
            /**
             * Serializes the current object to a JSON string.
             */
            _self.serialize = function (input) {
                var output = _serializeObject(input, "root");
                try {
                    return Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["S" /* getJSON */])()[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["S" /* _DYN_STRINGIFY */] /* @min:%2estringify */](output);
                }
                catch (e) {
                    // if serialization fails return an empty string
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(e[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["U" /* _DYN_TO_STRING */] /* @min:%2etoString */])) ? e[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["U" /* _DYN_TO_STRING */] /* @min:%2etoString */]() : "Error serializing object", null, true);
                }
            };
            function _serializeObject(source, name) {
                var circularReferenceCheck = "__aiCircularRefCheck";
                var output = {};
                if (!source) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, "cannot serialize object because it is null or undefined", { name: name }, true);
                    return output;
                }
                if (source[circularReferenceCheck]) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 50 /* _eInternalMessageId.CircularReferenceDetected */, "Circular reference detected while serializing object", { name: name }, true);
                    return output;
                }
                if (!source.aiDataContract) {
                    // special case for measurements/properties/tags
                    if (name === "measurements") {
                        output = _serializeStringMap(source, "number", name);
                    }
                    else if (name === "properties") {
                        output = _serializeStringMap(source, "string", name);
                    }
                    else if (name === "tags") {
                        output = _serializeStringMap(source, "string", name);
                    }
                    else if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_2" /* isArray */])(source)) {
                        output = _serializeArray(source, name);
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "Attempting to serialize an object which does not implement ISerializable", { name: name }, true);
                        try {
                            // verify that the object can be stringified
                            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["S" /* getJSON */])()[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["S" /* _DYN_STRINGIFY */] /* @min:%2estringify */](source);
                            output = source;
                        }
                        catch (e) {
                            // if serialization fails return an empty string
                            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(e[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["U" /* _DYN_TO_STRING */] /* @min:%2etoString */])) ? e[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["U" /* _DYN_TO_STRING */] /* @min:%2etoString */]() : "Error serializing object", null, true);
                        }
                    }
                    return output;
                }
                source[circularReferenceCheck] = true;
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(source.aiDataContract, function (field, contract) {
                    var isRequired = (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(contract)) ? (contract() & 1 /* FieldType.Required */) : (contract & 1 /* FieldType.Required */);
                    var isHidden = (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(contract)) ? (contract() & 4 /* FieldType.Hidden */) : (contract & 4 /* FieldType.Hidden */);
                    var isArray = contract & 2 /* FieldType.Array */;
                    var isPresent = source[field] !== undefined;
                    var isObj = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_11" /* isObject */])(source[field]) && source[field] !== null;
                    if (isRequired && !isPresent && !isArray) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 1 /* eLoggingSeverity.CRITICAL */, 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */, "Missing required field specification. The field is required but not present on source", { field: field, name: name });
                        // If not in debug mode, continue and hope the error is permissible
                    }
                    else if (!isHidden) { // Don't serialize hidden fields
                        var value = void 0;
                        if (isObj) {
                            if (isArray) {
                                // special case; recurse on each object in the source array
                                value = _serializeArray(source[field], field);
                            }
                            else {
                                // recurse on the source object in this field
                                value = _serializeObject(source[field], field);
                            }
                        }
                        else {
                            // assign the source field to the output even if undefined or required
                            value = source[field];
                        }
                        // only emit this field if the value is defined
                        if (value !== undefined) {
                            output[field] = value;
                        }
                    }
                });
                delete source[circularReferenceCheck];
                return output;
            }
            function _serializeArray(sources, name) {
                var output;
                if (!!sources) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_2" /* isArray */])(sources)) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 1 /* eLoggingSeverity.CRITICAL */, 54 /* _eInternalMessageId.ItemNotInArray */, "This field was specified as an array in the contract but the item is not an array.\r\n", { name: name }, true);
                    }
                    else {
                        output = [];
                        for (var i = 0; i < sources[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */]; i++) {
                            var source = sources[i];
                            var item = _serializeObject(source, name + "[" + i + "]");
                            output[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["O" /* _DYN_PUSH */] /* @min:%2epush */](item);
                        }
                    }
                }
                return output;
            }
            function _serializeStringMap(map, expectedType, name) {
                var output;
                if (map) {
                    output = {};
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(map, function (field, value) {
                        if (expectedType === "string") {
                            if (value === undefined) {
                                output[field] = "undefined";
                            }
                            else if (value === null) {
                                output[field] = "null";
                            }
                            else if (!value[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["U" /* _DYN_TO_STRING */] /* @min:%2etoString */]) {
                                output[field] = "invalid field: toString() is not defined.";
                            }
                            else {
                                output[field] = value[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["U" /* _DYN_TO_STRING */] /* @min:%2etoString */]();
                            }
                        }
                        else if (expectedType === "number") {
                            if (value === undefined) {
                                output[field] = "undefined";
                            }
                            else if (value === null) {
                                output[field] = "null";
                            }
                            else {
                                var num = parseFloat(value);
                                if (isNaN(num)) {
                                    output[field] = "NaN";
                                }
                                else {
                                    output[field] = num;
                                }
                            }
                        }
                        else {
                            output[field] = "invalid field: " + name + " is of unknown type.";
                            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(logger, 1 /* eLoggingSeverity.CRITICAL */, output[field], null, true);
                        }
                    });
                }
                return output;
            }
        });
    }
// Removed Stub for Serializer.prototype.serialize.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    Serializer.__ieDyn=1;

    return Serializer;
}());

//# sourceMappingURL=Serializer.js.map

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sample; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicConstants__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SamplingScoreGenerators_SamplingScoreGenerator__ = __webpack_require__(1922);
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Sample = /** @class */ (function () {
    function Sample(sampleRate, logger) {
        // We're using 32 bit math, hence max value is (2^31 - 1)
        this.INT_MAX_VALUE = 2147483647;
        var _logger = logger || Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["_33" /* safeGetLogger */])(null);
        if (sampleRate > 100 || sampleRate < 0) {
            _logger.throwInternal(2 /* eLoggingSeverity.WARNING */, 58 /* _eInternalMessageId.SampleRateOutOfRange */, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
            sampleRate = 100;
        }
        this[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["P" /* _DYN_SAMPLE_RATE */] /* @min:%2esampleRate */] = sampleRate;
        this.samplingScoreGenerator = new __WEBPACK_IMPORTED_MODULE_3__SamplingScoreGenerators_SamplingScoreGenerator__["a" /* SamplingScoreGenerator */]();
    }
    /**
    * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
    */
    Sample.prototype.isSampledIn = function (envelope) {
        var samplingPercentage = this[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["P" /* _DYN_SAMPLE_RATE */] /* @min:%2esampleRate */]; // 0 - 100
        var isSampledIn = false;
        if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) {
            return true;
        }
        else if (envelope.baseType === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["t" /* Metric */][__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["j" /* _DYN_DATA_TYPE */] /* @min:%2edataType */]) {
            // exclude MetricData telemetry from sampling
            return true;
        }
        isSampledIn = this.samplingScoreGenerator[__WEBPACK_IMPORTED_MODULE_2__DynamicConstants__["x" /* _DYN_GET_SAMPLING_SCORE */] /* @min:%2egetSamplingScore */](envelope) < samplingPercentage;
        return isSampledIn;
    };
    return Sample;
}());

//# sourceMappingURL=Sample.js.map

/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SamplingScoreGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DynamicConstants__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HashCodeScoreGenerator__ = __webpack_require__(1923);
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var SamplingScoreGenerator = /** @class */ (function () {
    function SamplingScoreGenerator() {
        var _self = this;
        var hashCodeGenerator = new __WEBPACK_IMPORTED_MODULE_2__HashCodeScoreGenerator__["a" /* HashCodeScoreGenerator */]();
        var keys = new __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["e" /* ContextTagKeys */]();
        _self[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["x" /* _DYN_GET_SAMPLING_SCORE */] /* @min:%2egetSamplingScore */] = function (item) {
            var score = 0;
            if (item[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */] && item[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */][keys.userId]) { // search in tags first, then ext
                score = hashCodeGenerator.getHashCodeScore(item[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */][keys.userId]);
            }
            else if (item.ext && item.ext.user && item.ext.user.id) {
                score = hashCodeGenerator[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["w" /* _DYN_GET_HASH_CODE_SCORE */] /* @min:%2egetHashCodeScore */](item.ext.user.id);
            }
            else if (item[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */] && item[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */][keys.operationId]) { // search in tags first, then ext
                score = hashCodeGenerator.getHashCodeScore(item[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["T" /* _DYN_TAGS */] /* @min:%2etags */][keys.operationId]);
            }
            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["V" /* _DYN_TRACE_ID */] /* @min:%2etraceID */]) {
                score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[__WEBPACK_IMPORTED_MODULE_1__DynamicConstants__["V" /* _DYN_TRACE_ID */] /* @min:%2etraceID */]);
            }
            else {
                // tslint:disable-next-line:insecure-random
                score = (Math.random() * 100);
            }
            return score;
        };
    }
    return SamplingScoreGenerator;
}());

//# sourceMappingURL=SamplingScoreGenerator.js.map

/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HashCodeScoreGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(184);
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var MIN_INPUT_LENGTH = 8;
var HashCodeScoreGenerator = /** @class */ (function () {
    function HashCodeScoreGenerator() {
    }
    HashCodeScoreGenerator.prototype.getHashCodeScore = function (key) {
        var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
        return score * 100;
    };
    HashCodeScoreGenerator.prototype.getHashCode = function (input) {
        if (input === "") {
            return 0;
        }
        while (input[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] < MIN_INPUT_LENGTH) {
            input = input.concat(input);
        }
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for (var i = 0; i < input[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */]; ++i) {
            hash = ((hash << 5) + hash) + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        return Math.abs(hash);
    };
    // We're using 32 bit math, hence max value is (2^31 - 1)
    HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
    return HashCodeScoreGenerator;
}());

//# sourceMappingURL=HashCodeScoreGenerator.js.map

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DfltAjaxCorrelationHeaderExDomains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AjaxMonitor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalConstants__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DynamicConstants__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ajaxRecord__ = __webpack_require__(780);
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var strDiagLog = "diagLog";
var AJAX_DATA_CONTAINER = "_ajaxData";
var STR_FETCH = "fetch";
var ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var ERROR_PREFIX = ", monitoring data for this ajax call ";
var ERROR_POSTFIX = ERROR_PREFIX + "may be incorrect.";
var ERROR_NOT_SENT = ERROR_PREFIX + "won't be sent.";
var CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var _markCount = 0;
/** @Ignore */
function _supportsFetch() {
    var _global = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["O" /* getGlobal */])();
    if (!_global ||
        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(_global.Request) ||
        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(_global.Request[__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_37" /* strPrototype */]]) ||
        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(_global[STR_FETCH])) {
        return null;
    }
    return _global[STR_FETCH];
}
var _isWebWorker = null;
function isWebWorker() {
    if (_isWebWorker == null) {
        try {
            _isWebWorker = !!(self && self instanceof WorkerGlobalScope);
        }
        catch (e) {
            _isWebWorker = false;
        }
    }
    return _isWebWorker;
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */
function _supportsAjaxMonitoring(ajaxMonitorInstance, ajaxDataId) {
    var _a;
    var result = false;
    if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_18" /* isXhrSupported */])()) {
        var proto = XMLHttpRequest[__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_37" /* strPrototype */]];
        result = !Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(proto) &&
            !Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(proto.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
            !Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(proto.send) &&
            !Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(proto.abort);
    }
    var ieVer = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["R" /* getIEVersion */])();
    if (ieVer && ieVer < 9) {
        result = false;
    }
    if (result) {
        // Disable if the XmlHttpRequest can't be extended or hooked
        try {
            var xhr = new XMLHttpRequest();
            var xhrData = {
                xh: [],
                i: (_a = {},
                    _a[ajaxDataId] = {},
                    _a)
            };
            xhr[AJAX_DATA_CONTAINER] = xhrData;
            // Check that we can update the prototype
            var theOpen = XMLHttpRequest[__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_37" /* strPrototype */]].open;
            XMLHttpRequest[__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_37" /* strPrototype */]].open = theOpen;
        }
        catch (e) {
            // We can't decorate the xhr object so disable monitoring
            result = false;
            _throwInternalCritical(ajaxMonitorInstance, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
                exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e)
            });
        }
    }
    return result;
}
/**
 * Internal helper to fetch the SDK instance tracking data for this XHR request
 * @param xhr
 * @param ajaxDataId
 * @returns
 */
var _getAjaxData = function (xhr, ajaxDataId) {
    if (xhr && ajaxDataId && xhr[AJAX_DATA_CONTAINER]) {
        return (xhr[AJAX_DATA_CONTAINER].i || {})[ajaxDataId];
    }
    return null;
};
/**
 * @ignore
 * Internal helper to track the singleton shared tracking headers, so we can attempt to not create headers
 * that might cause an issue if multiple values are populated.
 * @param xhr - The instrumented XHR instance
 */
var _addSharedXhrHeaders = function (xhr, name, value) {
    if (xhr) {
        var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) {
            headers.push({
                n: name,
                v: value
            });
        }
    }
};
var _isHeaderSet = function (xhr, name) {
    var isPresent = false;
    if (xhr) {
        var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) {
            Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(headers, function (header) {
                if (header.n === name) {
                    isPresent = true;
                    return -1;
                }
            });
        }
    }
    return isPresent;
};
/** @Ignore */
function _getFailedAjaxDiagnosticsMessage(xhr, ajaxDataId) {
    var result = "";
    try {
        var ajaxData = _getAjaxData(xhr, ajaxDataId);
        if (ajaxData && ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */]) {
            result += "(url: '" + ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */] + "')";
        }
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    return result;
}
/** @ignore */
function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(ajaxMonitorInstance[strDiagLog](), 1 /* eLoggingSeverity.CRITICAL */, msgId, message, properties, isUserAct);
}
/** @ignore */
function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(ajaxMonitorInstance[strDiagLog](), 2 /* eLoggingSeverity.WARNING */, msgId, message, properties, isUserAct);
}
/** @Ignore */
function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
    // tslint:disable-next-line
    return function (callDetails) {
        _throwInternalCritical(ajaxMonitorInstance, internalMessage, message, {
            ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(callDetails[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["D" /* _DYN_INST */] /* @min:%2einst */], ajaxMonitorInstance._ajaxDataId),
            exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(callDetails.err)
        });
    };
}
function _indexOf(value, match) {
    if (value && match) {
        return value.indexOf(match);
    }
    return -1;
}
function _addHandler(container, id, theFunc) {
    var theHandler = {
        id: id,
        fn: theFunc
    };
    container.push(theHandler);
    return {
        remove: function () {
            Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(container, function (initializer, idx) {
                if (initializer.id === theHandler.id) {
                    container.splice(idx, 1);
                    return -1;
                }
            });
        }
    };
}
function _processDependencyContainer(core, container, details, message) {
    var result = true;
    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(container, function (theFunc, idx) {
        try {
            if (theFunc.fn.call(null, details) === false) {
                result = false;
            }
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(core && core.logger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Dependency " + message + " [#" + idx + "] failed: " + Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["N" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) }, true);
        }
    });
    return result;
}
function _processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
    var initializersCount = listeners[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */];
    if (initializersCount > 0) {
        var details = {
            core: core,
            xhr: xhr,
            input: input,
            init: init,
            traceId: ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_1" /* _DYN_TRACE_ID */] /* @min:%2etraceID */],
            spanId: ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["T" /* _DYN_SPAN_ID */] /* @min:%2espanID */],
            traceFlags: ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */],
            context: ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["h" /* _DYN_CONTEXT */] /* @min:%2econtext */] || {},
            aborted: !!ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["a" /* _DYN_ABORTED */] /* @min:%2eaborted */]
        };
        _processDependencyContainer(core, listeners, details, "listener");
        ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_1" /* _DYN_TRACE_ID */] /* @min:%2etraceID */] = details[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_2" /* _DYN_TRACE_ID0 */] /* @min:%2etraceId */];
        ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["T" /* _DYN_SPAN_ID */] /* @min:%2espanID */] = details[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["U" /* _DYN_SPAN_ID1 */] /* @min:%2espanId */];
        ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */] = details[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */];
        ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["h" /* _DYN_CONTEXT */] /* @min:%2econtext */] = details[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["h" /* _DYN_CONTEXT */] /* @min:%2econtext */];
    }
}
var BLOB_CORE = "*.blob.core.";
var DfltAjaxCorrelationHeaderExDomains = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["C" /* deepFreeze */])([
    BLOB_CORE + "windows.net",
    BLOB_CORE + "chinacloudapi.cn",
    BLOB_CORE + "cloudapi.de",
    BLOB_CORE + "usgovcloudapi.net"
]);
var _internalExcludeEndpoints = [
    /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
function _getDefaultConfig() {
    var config = {
        maxAjaxCallsPerView: 500,
        disableAjaxTracking: false,
        disableFetchTracking: false,
        excludeRequestFromAutoTrackingPatterns: undefined,
        disableCorrelationHeaders: false,
        distributedTracingMode: 1 /* eDistributedTracingModes.AI_AND_W3C */,
        correlationHeaderExcludedDomains: DfltAjaxCorrelationHeaderExDomains,
        correlationHeaderDomains: undefined,
        correlationHeaderExcludePatterns: undefined,
        appId: undefined,
        enableCorsCorrelation: false,
        enableRequestHeaderTracking: false,
        enableResponseHeaderTracking: false,
        enableAjaxErrorStatusText: false,
        enableAjaxPerfTracking: false,
        maxAjaxPerfLookupAttempts: 3,
        ajaxPerfLookupDelay: 25,
        ignoreHeaders: [
            "Authorization",
            "X-API-Key",
            "WWW-Authenticate"
        ],
        addRequestContext: undefined,
        addIntEndpoints: true
    };
    return config;
}
function _getEmptyConfig() {
    var emptyConfig = _getDefaultConfig();
    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(emptyConfig, function (value) {
        emptyConfig[value] = undefined;
    });
    return emptyConfig;
}
var AjaxMonitor = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* __extendsFn */])(AjaxMonitor, _super);
    function AjaxMonitor() {
        var _this = _super.call(this) || this;
        _this.identifier = AjaxMonitor.identifier;
        _this.priority = 120;
        var _fetchInitialized; // fetch monitoring initialized
        var _xhrInitialized; // XHR monitoring initialized
        var _currentWindowHost;
        var _config;
        var _enableRequestHeaderTracking;
        var _enableAjaxErrorStatusText;
        var _trackAjaxAttempts;
        var _context;
        var _isUsingW3CHeaders;
        var _isUsingAIHeaders;
        var _markPrefix;
        var _enableAjaxPerfTracking;
        var _maxAjaxCallsPerView;
        var _enableResponseHeaderTracking;
        var _disabledUrls;
        var _disableAjaxTracking;
        var _disableFetchTracking;
        var _excludeRequestFromAutoTrackingPatterns;
        var _addRequestContext;
        var _evtNamespace;
        var _ajaxDataId;
        var _dependencyHandlerId;
        var _dependencyListeners;
        var _dependencyInitializers;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(AjaxMonitor, _this, function (_self, _base) {
            var _addHook = _base._addHook;
            _initDefaults();
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (!_self.isInitialized()) {
                    _base.initialize(config, core, extensions, pluginChain);
                    _evtNamespace = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_19" /* mergeEvtNamespace */])(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["z" /* createUniqueNamespace */])("ajax"), core && core.evtNamespace && core.evtNamespace());
                    _populateDefaults(config);
                    _instrumentXhr();
                    _instrumentFetch();
                    _populateContext();
                }
            };
            _self._doTeardown = function () {
                _initDefaults();
            };
            _self.trackDependencyData = function (dependency, properties) {
                _reportDependencyInternal(_dependencyInitializers, _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_CORE */] /* @min:%2ecore */], null, dependency, properties);
            };
            _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["C" /* _DYN_INCLUDE_CORRELATION_2 */] /* @min:%2eincludeCorrelationHeaders */] = function (ajaxData, input, init, xhr) {
                // Test Hook to allow the overriding of the location host
                var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                _processDependencyListeners(_dependencyListeners, _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_CORE */] /* @min:%2ecore */], ajaxData, xhr, input, init);
                if (input || input === "") { // Fetch
                    if (__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["f" /* CorrelationIdHelper */][__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["g" /* _DYN_CAN_INCLUDE_CORRELAT3 */] /* @min:%2ecanIncludeCorrelationHeader */](_config, ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["u" /* _DYN_GET_ABSOLUTE_URL */] /* @min:%2egetAbsoluteUrl */](), currentWindowHost)) {
                        if (!init) {
                            init = {};
                        }
                        // init headers override original request headers
                        // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
                        // not using original request headers will result in them being lost
                        var headers = new Headers(init[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["A" /* _DYN_HEADERS */] /* @min:%2eheaders */] || (input instanceof Request ? (input[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["A" /* _DYN_HEADERS */] /* @min:%2eheaders */] || {}) : {}));
                        if (_isUsingAIHeaders) {
                            var id = "|" + ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_1" /* _DYN_TRACE_ID */] /* @min:%2etraceID */] + "." + ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["T" /* _DYN_SPAN_ID */] /* @min:%2espanID */];
                            headers.set(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][3 /* eRequestHeaders.requestIdHeader */], id);
                            if (_enableRequestHeaderTracking) {
                                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */][__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][3 /* eRequestHeaders.requestIdHeader */]] = id;
                            }
                        }
                        var appId = _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["f" /* _DYN_APP_ID */] /* @min:%2eappId */] || (_context && _context[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["f" /* _DYN_APP_ID */] /* @min:%2eappId */]());
                        if (appId) {
                            headers.set(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][0 /* eRequestHeaders.requestContextHeader */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][2 /* eRequestHeaders.requestContextAppIdFormat */] + appId);
                            if (_enableRequestHeaderTracking) {
                                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */][__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][0 /* eRequestHeaders.requestContextHeader */]] = __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][2 /* eRequestHeaders.requestContextAppIdFormat */] + appId;
                            }
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */];
                            if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(traceFlags)) {
                                traceFlags = 0x01;
                            }
                            var traceParent = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["O" /* formatTraceParent */])(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["J" /* createTraceParent */])(ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_1" /* _DYN_TRACE_ID */] /* @min:%2etraceID */], ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["T" /* _DYN_SPAN_ID */] /* @min:%2espanID */], traceFlags));
                            headers.set(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][4 /* eRequestHeaders.traceParentHeader */], traceParent);
                            if (_enableRequestHeaderTracking) {
                                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */][__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][4 /* eRequestHeaders.traceParentHeader */]] = traceParent;
                            }
                        }
                        init[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["A" /* _DYN_HEADERS */] /* @min:%2eheaders */] = headers;
                    }
                    return init;
                }
                else if (xhr) { // XHR
                    if (__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["f" /* CorrelationIdHelper */][__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["g" /* _DYN_CAN_INCLUDE_CORRELAT3 */] /* @min:%2ecanIncludeCorrelationHeader */](_config, ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["u" /* _DYN_GET_ABSOLUTE_URL */] /* @min:%2egetAbsoluteUrl */](), currentWindowHost)) {
                        if (_isUsingAIHeaders) {
                            if (!_isHeaderSet(xhr, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][3 /* eRequestHeaders.requestIdHeader */])) {
                                var id = "|" + ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_1" /* _DYN_TRACE_ID */] /* @min:%2etraceID */] + "." + ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["T" /* _DYN_SPAN_ID */] /* @min:%2espanID */];
                                xhr[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["S" /* _DYN_SET_REQUEST_HEADER */] /* @min:%2esetRequestHeader */](__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][3 /* eRequestHeaders.requestIdHeader */], id);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */][__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][3 /* eRequestHeaders.requestIdHeader */]] = id;
                                }
                            }
                            else {
                                _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][3 /* eRequestHeaders.requestIdHeader */] + "] as it has already been set by another instance");
                            }
                        }
                        var appId = _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["f" /* _DYN_APP_ID */] /* @min:%2eappId */] || (_context && _context[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["f" /* _DYN_APP_ID */] /* @min:%2eappId */]());
                        if (appId) {
                            if (!_isHeaderSet(xhr, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][0 /* eRequestHeaders.requestContextHeader */])) {
                                xhr[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["S" /* _DYN_SET_REQUEST_HEADER */] /* @min:%2esetRequestHeader */](__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][0 /* eRequestHeaders.requestContextHeader */], __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][2 /* eRequestHeaders.requestContextAppIdFormat */] + appId);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */][__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][0 /* eRequestHeaders.requestContextHeader */]] = __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][2 /* eRequestHeaders.requestContextAppIdFormat */] + appId;
                                }
                            }
                            else {
                                _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][0 /* eRequestHeaders.requestContextHeader */] + "] as it has already been set by another instance");
                            }
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */];
                            if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(traceFlags)) {
                                traceFlags = 0x01;
                            }
                            if (!_isHeaderSet(xhr, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][4 /* eRequestHeaders.traceParentHeader */])) {
                                var traceParent = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["O" /* formatTraceParent */])(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["J" /* createTraceParent */])(ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_1" /* _DYN_TRACE_ID */] /* @min:%2etraceID */], ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["T" /* _DYN_SPAN_ID */] /* @min:%2espanID */], traceFlags));
                                xhr[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["S" /* _DYN_SET_REQUEST_HEADER */] /* @min:%2esetRequestHeader */](__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][4 /* eRequestHeaders.traceParentHeader */], traceParent);
                                if (_enableRequestHeaderTracking) {
                                    ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */][__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][4 /* eRequestHeaders.traceParentHeader */]] = traceParent;
                                }
                            }
                            else {
                                _throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, "Unable to set [" + __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][4 /* eRequestHeaders.traceParentHeader */] + "] as it has already been set by another instance");
                            }
                        }
                    }
                    return xhr;
                }
                return undefined;
            };
            _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_3" /* _DYN_TRACK_DEPENDENCY_DAT4 */] /* @min:%2etrackDependencyDataInternal */] = function (dependency, properties, systemProperties) {
                if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                    // Hack since expected format in w3c mode is |abc.def.
                    // Non-w3c format is |abc.def
                    // @todo Remove if better solution is available, e.g. handle in portal
                    if ((_config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["m" /* _DYN_DISTRIBUTED_TRACING_5 */] /* @min:%2edistributedTracingMode */] === 2 /* eDistributedTracingModes.W3C */
                        || _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["m" /* _DYN_DISTRIBUTED_TRACING_5 */] /* @min:%2edistributedTracingMode */] === 1 /* eDistributedTracingModes.AI_AND_W3C */)
                        && typeof dependency.id === "string" && dependency.id[dependency.id[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] - 1] !== ".") {
                        dependency.id += ".";
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(dependency[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["V" /* _DYN_START_TIME */] /* @min:%2estartTime */])) {
                        dependency[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["V" /* _DYN_START_TIME */] /* @min:%2estartTime */] = new Date();
                    }
                    var item = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["I" /* createTelemetryItem */])(dependency, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["y" /* RemoteDependencyData */].dataType, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["y" /* RemoteDependencyData */].envelopeType, _self[strDiagLog](), properties, systemProperties);
                    _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_CORE */] /* @min:%2ecore */].track(item);
                }
                else if (_trackAjaxAttempts === _maxAjaxCallsPerView) {
                    _throwInternalCritical(_self, 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                }
                ++_trackAjaxAttempts;
            };
            _self.addDependencyListener = function (dependencyListener) {
                return _addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
            };
            _self.addDependencyInitializer = function (dependencyInitializer) {
                return _addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
            };
            function _initDefaults() {
                var location = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["T" /* getLocation */])();
                _fetchInitialized = false; // fetch monitoring initialized
                _xhrInitialized = false; // XHR monitoring initialized
                _currentWindowHost = location && location.host && location.host[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["Z" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]();
                _config = AjaxMonitor.getEmptyConfig();
                _enableRequestHeaderTracking = false;
                _enableAjaxErrorStatusText = false;
                _trackAjaxAttempts = 0;
                _context = null;
                _isUsingW3CHeaders = false;
                _isUsingAIHeaders = false;
                _markPrefix = null;
                _enableAjaxPerfTracking = false;
                _maxAjaxCallsPerView = 0;
                _enableResponseHeaderTracking = false;
                _disabledUrls = {};
                _disableAjaxTracking = false;
                _disableFetchTracking = false;
                _excludeRequestFromAutoTrackingPatterns = null;
                _addRequestContext = null;
                _evtNamespace = null;
                _dependencyHandlerId = 0;
                _dependencyListeners = [];
                _dependencyInitializers = [];
                _ajaxDataId = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["z" /* createUniqueNamespace */])("ajaxData");
                _self._ajaxDataId = _ajaxDataId;
            }
            function _populateDefaults(config) {
                var ctx = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["x" /* createProcessTelemetryContext */])(null, config, _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_CORE */] /* @min:%2ecore */]);
                // Reset to the empty config
                _config = _getEmptyConfig();
                var defaultConfig = _getDefaultConfig();
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(defaultConfig, function (field, value) {
                    _config[field] = ctx.getConfig(AjaxMonitor.identifier, field, value);
                });
                var distributedTracingMode = _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["m" /* _DYN_DISTRIBUTED_TRACING_5 */] /* @min:%2edistributedTracingMode */];
                _enableRequestHeaderTracking = _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["p" /* _DYN_ENABLE_REQUEST_HEADE6 */] /* @min:%2eenableRequestHeaderTracking */];
                _enableAjaxErrorStatusText = _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["n" /* _DYN_ENABLE_AJAX_ERROR_ST7 */] /* @min:%2eenableAjaxErrorStatusText */];
                _enableAjaxPerfTracking = _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["o" /* _DYN_ENABLE_AJAX_PERF_TRA8 */] /* @min:%2eenableAjaxPerfTracking */];
                _maxAjaxCallsPerView = _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["F" /* _DYN_MAX_AJAX_CALLS_PER_V9 */] /* @min:%2emaxAjaxCallsPerView */];
                _enableResponseHeaderTracking = _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["q" /* _DYN_ENABLE_RESPONSE_HEAD10 */] /* @min:%2eenableResponseHeaderTracking */];
                _excludeRequestFromAutoTrackingPatterns = [].concat(_config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["t" /* _DYN_EXCLUDE_REQUEST_FROM11 */] /* @min:%2eexcludeRequestFromAutoTrackingPatterns */] || [], _config.addIntEndpoints !== false ? _internalExcludeEndpoints : []);
                _addRequestContext = _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["c" /* _DYN_ADD_REQUEST_CONTEXT */] /* @min:%2eaddRequestContext */];
                _isUsingAIHeaders = distributedTracingMode === 0 /* eDistributedTracingModes.AI */ || distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */;
                _isUsingW3CHeaders = distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ || distributedTracingMode === 2 /* eDistributedTracingModes.W3C */;
                if (_enableAjaxPerfTracking) {
                    var iKey = config.instrumentationKey || "unkwn";
                    if (iKey[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] > 5) {
                        _markPrefix = AJAX_MONITOR_PREFIX + iKey.substring(iKey[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] - 5) + ".";
                    }
                    else {
                        _markPrefix = AJAX_MONITOR_PREFIX + iKey + ".";
                    }
                }
                _disableAjaxTracking = !!_config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["k" /* _DYN_DISABLE_AJAX_TRACKIN12 */] /* @min:%2edisableAjaxTracking */];
                _disableFetchTracking = !!_config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["l" /* _DYN_DISABLE_FETCH_TRACKI13 */] /* @min:%2edisableFetchTracking */];
            }
            function _populateContext() {
                var propExt = _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_CORE */] /* @min:%2ecore */].getPlugin(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["x" /* PropertiesPluginIdentifier */]);
                if (propExt) {
                    _context = propExt.plugin[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["h" /* _DYN_CONTEXT */] /* @min:%2econtext */]; // we could move IPropertiesPlugin to common as well
                }
            }
            // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
            function _canIncludeHeaders(header) {
                var rlt = true;
                if (header || _config.ignoreHeaders) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(_config.ignoreHeaders, (function (key) {
                        if (key[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["Z" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]() === header[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["Z" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]()) {
                            rlt = false;
                            return -1;
                        }
                    }));
                }
                return rlt;
            }
            // Fetch Stuff
            function _instrumentFetch() {
                var fetch = _supportsFetch();
                if (!fetch) {
                    return;
                }
                var global = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["O" /* getGlobal */])();
                var isPolyfill = fetch.polyfill;
                if (!_disableFetchTracking && !_fetchInitialized) {
                    _addHook(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["e" /* InstrumentFunc */])(global, STR_FETCH, {
                        ns: _evtNamespace,
                        // Add request hook
                        req: function (callDetails, input, init) {
                            var fetchData;
                            if (!_disableFetchTracking && _fetchInitialized &&
                                !_isDisabledRequest(null, input, init) &&
                                // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                                !(isPolyfill && _xhrInitialized)) {
                                var ctx = callDetails.ctx();
                                fetchData = _createFetchRecord(input, init);
                                var newInit = _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["C" /* _DYN_INCLUDE_CORRELATION_2 */] /* @min:%2eincludeCorrelationHeaders */](fetchData, input, init);
                                if (newInit !== init) {
                                    callDetails.set(1, newInit);
                                }
                                ctx.data = fetchData;
                            }
                        },
                        rsp: function (callDetails, input) {
                            if (!_disableFetchTracking) {
                                var fetchData_1 = callDetails.ctx().data;
                                if (fetchData_1) {
                                    // Replace the result with the new promise from this code
                                    callDetails.rslt = callDetails.rslt.then(function (response) {
                                        _reportFetchMetrics(callDetails, (response || {})[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */], input, response, fetchData_1, function () {
                                            var ajaxResponse = {
                                                statusText: (response || {})[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["Y" /* _DYN_STATUS_TEXT */] /* @min:%2estatusText */],
                                                headerMap: null,
                                                correlationContext: _getFetchCorrelationContext(response)
                                            };
                                            if (_enableResponseHeaderTracking && response) {
                                                var responseHeaderMap_1 = {};
                                                response.headers.forEach(function (value, name) {
                                                    if (_canIncludeHeaders(name)) {
                                                        responseHeaderMap_1[name] = value;
                                                    }
                                                });
                                                ajaxResponse[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["B" /* _DYN_HEADER_MAP */] /* @min:%2eheaderMap */] = responseHeaderMap_1;
                                            }
                                            return ajaxResponse;
                                        });
                                        return response;
                                    })["catch"](function (reason) {
                                        _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, { error: reason.message || Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(reason) });
                                        throw reason;
                                    });
                                }
                            }
                        },
                        // Create an error callback to report any hook errors
                        hkErr: _createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to monitor Window.fetch" + ERROR_POSTFIX)
                    }, true, isWebWorker()));
                    _fetchInitialized = true;
                }
                else if (isPolyfill) {
                    // If fetch is a polyfill we need to capture the request to ensure that we correctly track
                    // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
                    // of reporting ourselves, for example React Native uses a polyfill for fetch
                    // Note: Polyfill implementations that don't support the "poyyfill" tag are not supported
                    // the workaround is to add a polyfill property to your fetch implementation before initializing
                    // App Insights
                    _addHook(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["e" /* InstrumentFunc */])(global, STR_FETCH, {
                        ns: _evtNamespace,
                        req: function (callDetails, input, init) {
                            // Just call so that we record any disabled URL
                            _isDisabledRequest(null, input, init);
                        }
                    }));
                }
                if (isPolyfill) {
                    // retag the instrumented fetch with the same polyfill settings this is mostly for testing
                    // But also supports multiple App Insights usages
                    global[STR_FETCH].polyfill = isPolyfill;
                }
            }
            function _hookProto(target, funcName, callbacks) {
                _addHook(Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["f" /* InstrumentProto */])(target, funcName, callbacks));
            }
            function _instrumentXhr() {
                if (_supportsAjaxMonitoring(_self, _ajaxDataId) && !_disableAjaxTracking && !_xhrInitialized) {
                    // Instrument open
                    _hookProto(XMLHttpRequest, "open", {
                        ns: _evtNamespace,
                        req: function (callDetails, method, url, async) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["D" /* _DYN_INST */] /* @min:%2einst */];
                                var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, ajaxData, true)) {
                                    if (!ajaxData || !ajaxData.xhrMonitoringState[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["I" /* _DYN_OPEN_DONE */] /* @min:%2eopenDone */]) {
                                        // Only create a single ajaxData (even when multiple AI instances are running)
                                        ajaxData = _openHandler(xhr, method, url, async);
                                    }
                                    // always attach to the on ready state change (required for handling multiple instances)
                                    _attachToOnReadyStateChange(xhr, ajaxData);
                                }
                            }
                        },
                        hkErr: _createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, ERROR_HEADER + ".open" + ERROR_POSTFIX)
                    });
                    // Instrument send
                    _hookProto(XMLHttpRequest, "send", {
                        ns: _evtNamespace,
                        req: function (callDetails, context) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["D" /* _DYN_INST */] /* @min:%2einst */];
                                var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["R" /* _DYN_SEND_DONE */] /* @min:%2esendDone */]) {
                                    _createMarkId("xhr", ajaxData);
                                    ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["M" /* _DYN_REQUEST_SENT_TIME */] /* @min:%2erequestSentTime */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["N" /* dateTimeUtilsNow */])();
                                    _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["C" /* _DYN_INCLUDE_CORRELATION_2 */] /* @min:%2eincludeCorrelationHeaders */](ajaxData, undefined, undefined, xhr);
                                    ajaxData.xhrMonitoringState[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["R" /* _DYN_SEND_DONE */] /* @min:%2esendDone */] = true;
                                }
                            }
                        },
                        hkErr: _createErrorCallbackFunc(_self, 17 /* _eInternalMessageId.FailedMonitorAjaxSend */, ERROR_HEADER + ERROR_POSTFIX)
                    });
                    // Instrument abort
                    _hookProto(XMLHttpRequest, "abort", {
                        ns: _evtNamespace,
                        req: function (callDetails) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["D" /* _DYN_INST */] /* @min:%2einst */];
                                var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["b" /* _DYN_ABORT_DONE */] /* @min:%2eabortDone */]) {
                                    ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["a" /* _DYN_ABORTED */] /* @min:%2eaborted */] = 1;
                                    ajaxData.xhrMonitoringState[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["b" /* _DYN_ABORT_DONE */] /* @min:%2eabortDone */] = true;
                                }
                            }
                        },
                        hkErr: _createErrorCallbackFunc(_self, 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */, ERROR_HEADER + ".abort" + ERROR_POSTFIX)
                    });
                    // Instrument setRequestHeader
                    _hookProto(XMLHttpRequest, "setRequestHeader", {
                        ns: _evtNamespace,
                        req: function (callDetails, header, value) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["D" /* _DYN_INST */] /* @min:%2einst */];
                                var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                                if (ajaxData && _isMonitoredXhrInstance(xhr, ajaxData)) {
                                    _addSharedXhrHeaders(xhr, header, value);
                                    if (_enableRequestHeaderTracking && _canIncludeHeaders(header)) {
                                        if (ajaxData) {
                                            ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */][header] = value;
                                        }
                                    }
                                }
                            }
                        },
                        hkErr: _createErrorCallbackFunc(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */, ERROR_HEADER + ".setRequestHeader" + ERROR_POSTFIX)
                    });
                    _xhrInitialized = true;
                }
            }
            function _isDisabledRequest(xhr, request, init) {
                var isDisabled = false;
                var theUrl = ((!Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_13" /* isString */])(request) ? (request || {}).url || "" : request) || "")[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["Z" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */]();
                // check excludeRequestFromAutoTrackingPatterns before stripping off any query string
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(_excludeRequestFromAutoTrackingPatterns, function (regex) {
                    var theRegex = regex;
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_13" /* isString */])(regex)) {
                        theRegex = new RegExp(regex);
                    }
                    if (!isDisabled) {
                        isDisabled = theRegex.test(theUrl);
                    }
                });
                // if request url matches with exclude regex pattern, return true and no need to check for headers
                if (isDisabled) {
                    return isDisabled;
                }
                var idx = _indexOf(theUrl, "?");
                var idx2 = _indexOf(theUrl, "#");
                if (idx === -1 || (idx2 !== -1 && idx2 < idx)) {
                    idx = idx2;
                }
                if (idx !== -1) {
                    // Strip off any Query string
                    theUrl = theUrl.substring(0, idx);
                }
                // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
                if (!Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(xhr)) {
                    // Look on the XMLHttpRequest of the URL string value
                    isDisabled = xhr[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["m" /* DisabledPropertyName */]] === true || theUrl[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["m" /* DisabledPropertyName */]] === true;
                }
                else if (!Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(request)) { // fetch
                    // Look for DisabledPropertyName in either Request or RequestInit
                    isDisabled = (typeof request === "object" ? request[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["m" /* DisabledPropertyName */]] === true : false) ||
                        (init ? init[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["m" /* DisabledPropertyName */]] === true : false);
                }
                // Also add extra check just in case the XHR or fetch objects where not decorated with the DisableProperty due to sealing or freezing
                if (!isDisabled && theUrl && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["Q" /* isInternalApplicationInsightsEndpoint */])(theUrl)) {
                    isDisabled = true;
                }
                if (isDisabled) {
                    // Add the disabled url if not present
                    if (!_disabledUrls[theUrl]) {
                        _disabledUrls[theUrl] = 1;
                    }
                }
                else {
                    // Check to see if the url is listed as disabled
                    if (_disabledUrls[theUrl]) {
                        isDisabled = true;
                    }
                }
                return isDisabled;
            }
            /// <summary>Verifies that particular instance of XMLHttpRequest needs to be monitored</summary>
            /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
            /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
            function _isMonitoredXhrInstance(xhr, ajaxData, excludeAjaxDataValidation) {
                var ajaxValidation = true;
                var initialized = _xhrInitialized;
                if (!Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(xhr)) {
                    ajaxValidation = excludeAjaxDataValidation === true || !Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(ajaxData);
                }
                // checking to see that all interested functions on xhr were instrumented
                return initialized
                    // checking on ajaxData to see that it was not removed in user code
                    && ajaxValidation;
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_CORE */] /* @min:%2ecore */] && _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_CORE */] /* @min:%2ecore */].getTraceCtx) {
                    distributedTraceCtx = _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_CORE */] /* @min:%2ecore */].getTraceCtx(false);
                }
                // Fall back
                if (!distributedTraceCtx && _context && _context.telemetryTrace) {
                    distributedTraceCtx = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["G" /* createDistributedTraceContextFromTrace */])(_context.telemetryTrace);
                }
                return distributedTraceCtx;
            }
            function _openHandler(xhr, method, url, async) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = (distributedTraceCtx && distributedTraceCtx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["z" /* _DYN_GET_TRACE_ID */] /* @min:%2egetTraceId */]()) || Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["K" /* generateW3CId */])();
                var spanID = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["K" /* generateW3CId */])().substr(0, 16);
                var xhrRequestData = xhr[AJAX_DATA_CONTAINER] = (xhr[AJAX_DATA_CONTAINER] || { xh: [], i: {} });
                var ajaxDataCntr = xhrRequestData.i = (xhrRequestData.i || {});
                var ajaxData = ajaxDataCntr[_ajaxDataId] = (ajaxDataCntr[_ajaxDataId] || new __WEBPACK_IMPORTED_MODULE_6__ajaxRecord__["a" /* ajaxRecord */](traceID, spanID, _self[strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx()));
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */] = distributedTraceCtx && distributedTraceCtx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["y" /* _DYN_GET_TRACE_FLAGS */] /* @min:%2egetTraceFlags */]();
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["G" /* _DYN_METHOD */] /* @min:%2emethod */] = method;
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */] = url;
                ajaxData.xhrMonitoringState[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["I" /* _DYN_OPEN_DONE */] /* @min:%2eopenDone */] = true;
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */] = {};
                ajaxData.async = async;
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["r" /* _DYN_ERROR_STATUS_TEXT */] /* @min:%2eerrorStatusText */] = _enableAjaxErrorStatusText;
                return ajaxData;
            }
            function _attachToOnReadyStateChange(xhr, ajaxData) {
                ajaxData.xhrMonitoringState[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["W" /* _DYN_STATE_CHANGE_ATTACHE14 */] /* @min:%2estateChangeAttached */] = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["I" /* eventOn */])(xhr, "readystatechange", function () {
                    try {
                        if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr, ajaxData)) {
                            _onAjaxComplete(xhr);
                        }
                    }
                    catch (e) {
                        var exceptionText = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e);
                        // ignore messages with c00c023f, as this a known IE9 XHR abort issue
                        if (!exceptionText || _indexOf(exceptionText[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["Z" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */](), "c00c023f") === -1) {
                            _throwInternalCritical(_self, 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */, ERROR_HEADER + " 'readystatechange' event handler" + ERROR_POSTFIX, {
                                ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                                exception: exceptionText
                            });
                        }
                    }
                }, _evtNamespace);
            }
            function _getResponseText(xhr) {
                try {
                    var responseType = xhr.responseType;
                    if (responseType === "" || responseType === "text") {
                        // As per the specification responseText is only valid if the type is an empty string or "text"
                        return xhr[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["Q" /* _DYN_RESPONSE_TEXT */] /* @min:%2eresponseText */];
                    }
                }
                catch (e) {
                    // This shouldn't happen because of the above check -- but just in case, so just ignore
                }
                return null;
            }
            function _onAjaxComplete(xhr) {
                var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["P" /* _DYN_RESPONSE_FINISHED_TI15 */] /* @min:%2eresponseFinishedTime */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["N" /* dateTimeUtilsNow */])();
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */] = xhr[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */];
                function _reportXhrError(e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId);
                    if (e) {
                        errorProps["exception"] = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e);
                    }
                    _throwInternalWarning(_self, 14 /* _eInternalMessageId.FailedMonitorAjaxDur */, FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + ERROR_NOT_SENT, errorProps);
                }
                _findPerfResourceEntry("xmlhttprequest", ajaxData, function () {
                    try {
                        var dependency = ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_4" /* _DYN__CREATE_TRACK_ITEM */] /* @min:%2eCreateTrackItem */]("Ajax", _enableRequestHeaderTracking, function () {
                            var ajaxResponse = {
                                statusText: xhr[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["Y" /* _DYN_STATUS_TEXT */] /* @min:%2estatusText */],
                                headerMap: null,
                                correlationContext: _getAjaxCorrelationContext(xhr),
                                type: xhr.responseType,
                                responseText: _getResponseText(xhr),
                                response: xhr[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["O" /* _DYN_RESPONSE */] /* @min:%2eresponse */]
                            };
                            if (_enableResponseHeaderTracking) {
                                var headers = xhr[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["v" /* _DYN_GET_ALL_RESPONSE_HEA16 */] /* @min:%2egetAllResponseHeaders */]();
                                if (headers) {
                                    // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                                    // the regex converts the header string into an array of individual headers
                                    var arr = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_38" /* strTrim */])(headers).split(/[\r\n]+/);
                                    var responseHeaderMap_2 = {};
                                    Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["p" /* arrForEach */])(arr, function (line) {
                                        var parts = line.split(": ");
                                        var header = parts.shift();
                                        var value = parts.join(": ");
                                        if (_canIncludeHeaders(header)) {
                                            responseHeaderMap_2[header] = value;
                                        }
                                    });
                                    ajaxResponse[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["B" /* _DYN_HEADER_MAP */] /* @min:%2eheaderMap */] = responseHeaderMap_2;
                                }
                            }
                            return ajaxResponse;
                        });
                        var properties = void 0;
                        try {
                            if (!!_addRequestContext) {
                                properties = _addRequestContext({ status: xhr[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */], xhr: xhr });
                            }
                        }
                        catch (e) {
                            _throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */, CUSTOM_REQUEST_CONTEXT_ERROR);
                        }
                        if (dependency) {
                            if (properties !== undefined) {
                                dependency[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["b" /* STR_PROPERTIES */] /* @min:%2eproperties */] = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])({}, dependency.properties), properties);
                            }
                            var sysProperties = ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["x" /* _DYN_GET_PART_APROPS */] /* @min:%2egetPartAProps */]();
                            _reportDependencyInternal(_dependencyInitializers, _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_CORE */] /* @min:%2ecore */], ajaxData, dependency, null, sysProperties);
                        }
                        else {
                            _reportXhrError(null, {
                                requestSentTime: ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["M" /* _DYN_REQUEST_SENT_TIME */] /* @min:%2erequestSentTime */],
                                responseFinishedTime: ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["P" /* _DYN_RESPONSE_FINISHED_TI15 */] /* @min:%2eresponseFinishedTime */]
                            });
                        }
                    }
                    finally {
                        // cleanup telemetry data
                        try {
                            var xhrRequestData = (xhr[AJAX_DATA_CONTAINER] || { i: {} });
                            var ajaxDataCntr = (xhrRequestData.i || {});
                            if (ajaxDataCntr[_ajaxDataId]) {
                                ajaxDataCntr[_ajaxDataId] = null;
                            }
                        }
                        catch (e) {
                            // May throw in environments that prevent extension or freeze xhr
                        }
                    }
                }, function (e) {
                    _reportXhrError(e, null);
                });
            }
            function _getAjaxCorrelationContext(xhr) {
                try {
                    var responseHeadersString = xhr[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["v" /* _DYN_GET_ALL_RESPONSE_HEA16 */] /* @min:%2egetAllResponseHeaders */]();
                    if (responseHeadersString !== null) {
                        var index = _indexOf(responseHeadersString[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["Z" /* _DYN_TO_LOWER_CASE */] /* @min:%2etoLowerCase */](), __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][8 /* eRequestHeaders.requestContextHeaderLowerCase */]);
                        if (index !== -1) {
                            var responseHeader = xhr.getResponseHeader(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][0 /* eRequestHeaders.requestContextHeader */]);
                            return __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["f" /* CorrelationIdHelper */][__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["w" /* _DYN_GET_CORRELATION_CONT17 */] /* @min:%2egetCorrelationContext */](responseHeader);
                        }
                    }
                }
                catch (e) {
                    _throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, CORRELATION_HEADER_ERROR, {
                        ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                        exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e)
                    });
                }
            }
            function _createMarkId(type, ajaxData) {
                if (ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */] && _markPrefix && _enableAjaxPerfTracking) {
                    var performance_1 = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["V" /* getPerformance */])();
                    if (performance_1 && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(performance_1.mark)) {
                        _markCount++;
                        var markId = _markPrefix + type + "#" + _markCount;
                        performance_1.mark(markId);
                        var entries = performance_1.getEntriesByName(markId);
                        if (entries && entries[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] === 1) {
                            ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["J" /* _DYN_PERF_MARK */] /* @min:%2eperfMark */] = entries[0];
                        }
                    }
                }
            }
            function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                var perfMark = ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["J" /* _DYN_PERF_MARK */] /* @min:%2eperfMark */];
                var performance = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["V" /* getPerformance */])();
                var maxAttempts = _config.maxAjaxPerfLookupAttempts;
                var retryDelay = _config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["d" /* _DYN_AJAX_PERF_LOOKUP_DEL18 */] /* @min:%2eajaxPerfLookupDelay */];
                var requestUrl = ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */];
                var attempt = 0;
                (function locateResourceTiming() {
                    try {
                        if (performance && perfMark) {
                            attempt++;
                            var perfTiming = null;
                            var entries = performance.getEntries();
                            for (var lp = entries[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */] - 1; lp >= 0; lp--) {
                                var entry = entries[lp];
                                if (entry) {
                                    if (entry.entryType === "resource") {
                                        if (entry.initiatorType === initiatorType &&
                                            (_indexOf(entry[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["H" /* _DYN_NAME */] /* @min:%2ename */], requestUrl) !== -1 || _indexOf(requestUrl, entry[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["H" /* _DYN_NAME */] /* @min:%2ename */]) !== -1)) {
                                            perfTiming = entry;
                                        }
                                    }
                                    else if (entry.entryType === "mark" && entry[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["H" /* _DYN_NAME */] /* @min:%2ename */] === perfMark[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["H" /* _DYN_NAME */] /* @min:%2ename */]) {
                                        // We hit the start event
                                        ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["K" /* _DYN_PERF_TIMING */] /* @min:%2eperfTiming */] = perfTiming;
                                        break;
                                    }
                                    if (entry[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["V" /* _DYN_START_TIME */] /* @min:%2estartTime */] < perfMark[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["V" /* _DYN_START_TIME */] /* @min:%2estartTime */] - 1000) {
                                        // Fallback to try and reduce the time spent looking for the perf entry
                                        break;
                                    }
                                }
                            }
                        }
                        if (!perfMark || // - we don't have a perfMark or
                            ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["K" /* _DYN_PERF_TIMING */] /* @min:%2eperfTiming */] || // - we have not found the perf entry or
                            attempt >= maxAttempts || // - we have tried too many attempts or
                            ajaxData.async === false) { // - this is a sync request
                            if (perfMark && Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(performance.clearMarks)) {
                                // Remove the mark so we don't fill up the performance resources too much
                                performance.clearMarks(perfMark[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["H" /* _DYN_NAME */] /* @min:%2ename */]);
                            }
                            ajaxData.perfAttempts = attempt;
                            // just continue and report the track event
                            trackCallback();
                        }
                        else {
                            // We need to wait for the browser to populate the window.performance entry
                            // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
                            // this is a scheduling issue for the browser implementation
                            setTimeout(locateResourceTiming, retryDelay);
                        }
                    }
                    catch (e) {
                        reportError(e);
                    }
                })();
            }
            function _createFetchRecord(input, init) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = (distributedTraceCtx && distributedTraceCtx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["z" /* _DYN_GET_TRACE_ID */] /* @min:%2egetTraceId */]()) || Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["K" /* generateW3CId */])();
                var spanID = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["K" /* generateW3CId */])().substr(0, 16);
                var ajaxData = new __WEBPACK_IMPORTED_MODULE_6__ajaxRecord__["a" /* ajaxRecord */](traceID, spanID, _self[strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_0" /* _DYN_TRACE_FLAGS */] /* @min:%2etraceFlags */] = distributedTraceCtx && distributedTraceCtx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["y" /* _DYN_GET_TRACE_FLAGS */] /* @min:%2egetTraceFlags */]();
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["M" /* _DYN_REQUEST_SENT_TIME */] /* @min:%2erequestSentTime */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["N" /* dateTimeUtilsNow */])();
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["r" /* _DYN_ERROR_STATUS_TEXT */] /* @min:%2eerrorStatusText */] = _enableAjaxErrorStatusText;
                if (input instanceof Request) {
                    ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */] = input ? input.url : "";
                }
                else {
                    ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["N" /* _DYN_REQUEST_URL */] /* @min:%2erequestUrl */] = input;
                }
                var method = "GET";
                if (init && init[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["G" /* _DYN_METHOD */] /* @min:%2emethod */]) {
                    method = init[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["G" /* _DYN_METHOD */] /* @min:%2emethod */];
                }
                else if (input && input instanceof Request) {
                    method = input[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["G" /* _DYN_METHOD */] /* @min:%2emethod */];
                }
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["G" /* _DYN_METHOD */] /* @min:%2emethod */] = method;
                var requestHeaders = {};
                if (_enableRequestHeaderTracking) {
                    var headers = new Headers((init ? init[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["A" /* _DYN_HEADERS */] /* @min:%2eheaders */] : 0) || (input instanceof Request ? (input[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["A" /* _DYN_HEADERS */] /* @min:%2eheaders */] || {}) : {}));
                    headers.forEach(function (value, key) {
                        if (_canIncludeHeaders(key)) {
                            requestHeaders[key] = value;
                        }
                    });
                }
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["L" /* _DYN_REQUEST_HEADERS */] /* @min:%2erequestHeaders */] = requestHeaders;
                _createMarkId(STR_FETCH, ajaxData);
                return ajaxData;
            }
            function _getFailedFetchDiagnosticsMessage(input) {
                var result = "";
                try {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(input)) {
                        if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_13" /* isString */])(input)) {
                            result += "(url: '".concat(input, "')");
                        }
                        else {
                            result += "(url: '".concat(input.url, "')");
                        }
                    }
                }
                catch (e) {
                    _throwInternalCritical(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */, "Failed to grab failed fetch diagnostics message", { exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e) });
                }
                return result;
            }
            function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
                if (!ajaxData) {
                    return;
                }
                function _reportFetchError(msgId, e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                    if (e) {
                        errorProps["exception"] = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e);
                    }
                    _throwInternalWarning(_self, msgId, FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + ERROR_NOT_SENT, errorProps);
                }
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["P" /* _DYN_RESPONSE_FINISHED_TI15 */] /* @min:%2eresponseFinishedTime */] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["N" /* dateTimeUtilsNow */])();
                ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["X" /* _DYN_STATUS */] /* @min:%2estatus */] = status;
                _findPerfResourceEntry(STR_FETCH, ajaxData, function () {
                    var dependency = ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_4" /* _DYN__CREATE_TRACK_ITEM */] /* @min:%2eCreateTrackItem */]("Fetch", _enableRequestHeaderTracking, getResponse);
                    var properties;
                    try {
                        if (!!_addRequestContext) {
                            properties = _addRequestContext({ status: status, request: input, response: response });
                        }
                    }
                    catch (e) {
                        _throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */, CUSTOM_REQUEST_CONTEXT_ERROR);
                    }
                    if (dependency) {
                        if (properties !== undefined) {
                            dependency[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["b" /* STR_PROPERTIES */] /* @min:%2eproperties */] = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __assignFn */])({}, dependency.properties), properties);
                        }
                        var sysProperties = ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["x" /* _DYN_GET_PART_APROPS */] /* @min:%2egetPartAProps */]();
                        _reportDependencyInternal(_dependencyInitializers, _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_CORE */] /* @min:%2ecore */], ajaxData, dependency, null, sysProperties);
                    }
                    else {
                        _reportFetchError(14 /* _eInternalMessageId.FailedMonitorAjaxDur */, null, {
                            requestSentTime: ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["M" /* _DYN_REQUEST_SENT_TIME */] /* @min:%2erequestSentTime */],
                            responseFinishedTime: ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["P" /* _DYN_RESPONSE_FINISHED_TI15 */] /* @min:%2eresponseFinishedTime */]
                        });
                    }
                }, function (e) {
                    _reportFetchError(18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, e, null);
                });
            }
            function _getFetchCorrelationContext(response) {
                if (response && response[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["A" /* _DYN_HEADERS */] /* @min:%2eheaders */]) {
                    try {
                        var responseHeader = response[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["A" /* _DYN_HEADERS */] /* @min:%2eheaders */].get(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["z" /* RequestHeaders */][0 /* eRequestHeaders.requestContextHeader */]);
                        return __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["f" /* CorrelationIdHelper */][__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["w" /* _DYN_GET_CORRELATION_CONT17 */] /* @min:%2egetCorrelationContext */](responseHeader);
                    }
                    catch (e) {
                        _throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */, CORRELATION_HEADER_ERROR, {
                            fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
                            exception: Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["G" /* dumpObj */])(e)
                        });
                    }
                }
            }
            function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
                var result = true;
                var initializersCount = initializers[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["E" /* _DYN_LENGTH */] /* @min:%2elength */];
                if (initializersCount > 0) {
                    var details = {
                        item: dependency,
                        properties: properties,
                        sysProperties: systemProperties,
                        context: ajaxData ? ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["h" /* _DYN_CONTEXT */] /* @min:%2econtext */] : null,
                        aborted: ajaxData ? !!ajaxData[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["a" /* _DYN_ABORTED */] /* @min:%2eaborted */] : false
                    };
                    result = _processDependencyContainer(core, initializers, details, "initializer");
                }
                if (result) {
                    _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["_3" /* _DYN_TRACK_DEPENDENCY_DAT4 */] /* @min:%2etrackDependencyDataInternal */](dependency, properties, systemProperties);
                }
            }
        });
        return _this;
    }
// Removed Stub for AjaxMonitor.prototype.initialize.
    AjaxMonitor.prototype.processTelemetry = function (item, itemCtx) {
        this.processNext(item, itemCtx);
    };
// Removed Stub for AjaxMonitor.prototype.trackDependencyData.
// Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
// Removed Stub for AjaxMonitor.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */
    AjaxMonitor.prototype.addDependencyInitializer = function (dependencyInitializer) {
        return null;
    };
// Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
    AjaxMonitor.identifier = "AjaxDependencyPlugin";
    AjaxMonitor.getDefaultConfig = _getDefaultConfig;
    AjaxMonitor.getEmptyConfig = _getEmptyConfig;
    return AjaxMonitor;
}(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["b" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=ajax.js.map

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(348);
/* unused harmony reexport strShimFunction */
/* unused harmony reexport strShimObject */
/* unused harmony reexport strShimUndefined */
/* unused harmony reexport strShimPrototype */
/* unused harmony reexport strShimHasOwnProperty */
/* unused harmony reexport strDefault */
/* unused harmony reexport ObjClass */
/* unused harmony reexport ObjProto */
/* unused harmony reexport ObjAssign */
/* unused harmony reexport ObjCreate */
/* unused harmony reexport ObjDefineProperty */
/* unused harmony reexport ObjHasOwnProperty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(492);
/* unused harmony reexport throwTypeError */
/* unused harmony reexport objCreateFn */
/* unused harmony reexport getGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(777);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c"]; });
/* unused harmony reexport __restFn */
/* unused harmony reexport __spreadArrayFn */
/* unused harmony reexport __spreadArraysFn */
/* unused harmony reexport __decorateFn */
/* unused harmony reexport __paramFn */
/* unused harmony reexport __metadataFn */
/* unused harmony reexport __createBindingFn */
/* unused harmony reexport __valuesFn */
/* unused harmony reexport __readFn */
/* unused harmony reexport __makeTemplateObjectFn */
/* unused harmony reexport __importDefaultFn */
/* unused harmony reexport __importStarFn */
/* unused harmony reexport __exportStarFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TsLibGlobals__ = __webpack_require__(1926);
/* unused harmony reexport __exposeGlobalTsLib */
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.




//# sourceMappingURL=applicationinsights-shims.js.map

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __exposeGlobalTsLib */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(777);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.



function __exposeGlobalTsLib() {
    var globalObj = Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {};
    // tslint:disable: only-arrow-functions
    (function (root, assignFn, extendsFn, createBindingFn) {
        // Assign the globally scoped versions of the functions -- used when consuming individual ts files
        // If check is to support NativeScript where these are marked as readonly
        if (!root.__assign) {
            root.__assign = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || assignFn;
        }
        if (!root.__extends) {
            root.__extends = extendsFn;
        }
        if (!root.__createBinding) {
            root.__createBinding = createBindingFn;
        }
    })(globalObj, __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a" /* __assignFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c" /* __extendsFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["b" /* __createBindingFn */]);
    // Assign local variables that will be used for embedded scenarios, if check is to support NativeScript where these are marked as readonly
    if (!__assign) {
        __assign = globalObj.__assign;
    }
    if (!__extends) {
        __extends = globalObj.__extends;
    }
    if (!__createBinding) {
        __createBinding = globalObj.__createBinding;
    }
}
//# sourceMappingURL=TsLibGlobals.js.map

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryContext__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DynamicConstants__ = __webpack_require__(271);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/






var PropertiesPlugin = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* __extendsFn */])(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["x" /* PropertiesPluginIdentifier */];
        var _extensionConfig;
        var _distributedTraceCtx;
        var _previousTraceCtx;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(PropertiesPlugin, _this, function (_self, _base) {
            _initDefaults();
            _self.initialize = function (config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _populateDefaults(config);
            };
            /**
             * Add Part A fields to the event
             * @param event The event that needs to be processed
             */
            _self.processTelemetry = function (event, itemCtx) {
                if (Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_9" /* isNullOrUndefined */])(event)) {
                    // TODO(barustum): throw an internal event once we have support for internal logging
                }
                else {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["u" /* PageView */].envelopeType) {
                        itemCtx.diagLog().resetInternalMessageCount();
                    }
                    var theContext = (_self.context || {});
                    if (theContext.session) {
                        // If customer did not provide custom session id update the session manager
                        if (typeof _self.context.session.id !== "string" && theContext[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["D" /* _DYN_SESSION_MANAGER */] /* @min:%2esessionManager */]) {
                            theContext[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["D" /* _DYN_SESSION_MANAGER */] /* @min:%2esessionManager */][__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["G" /* _DYN_UPDATE */] /* @min:%2eupdate */]();
                        }
                    }
                    var userCtx = theContext.user;
                    if (userCtx && !userCtx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["v" /* _DYN_IS_USER_COOKIE_SET */] /* @min:%2eisUserCookieSet */]) {
                        userCtx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["G" /* _DYN_UPDATE */] /* @min:%2eupdate */](theContext.user.id);
                    }
                    _processTelemetryInternal(event, itemCtx);
                    if (userCtx && userCtx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["u" /* _DYN_IS_NEW_USER */] /* @min:%2eisNewUser */]) {
                        userCtx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["u" /* _DYN_IS_NEW_USER */] /* @min:%2eisNewUser */] = false;
                        var message = new __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["h" /* _InternalLogMessage */](72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */, ((Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["U" /* getNavigator */])() || {}).userAgent || ""));
                        Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["k" /* _logInternalMessage */])(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */, message);
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                var core = (unloadCtx || {}).core();
                if (core && core[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["s" /* _DYN_GET_TRACE_CTX */] /* @min:%2egetTraceCtx */]) {
                    var traceCtx = core[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["s" /* _DYN_GET_TRACE_CTX */] /* @min:%2egetTraceCtx */](false);
                    if (traceCtx === _distributedTraceCtx) {
                        core.setTraceCtx(_previousTraceCtx);
                    }
                }
                _initDefaults();
            };
            function _initDefaults() {
                _extensionConfig = null;
                _distributedTraceCtx = null;
                _previousTraceCtx = null;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                var ctx = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["x" /* createProcessTelemetryContext */])(null, config, core);
                var defaultConfig = PropertiesPlugin.getDefaultConfig();
                _extensionConfig = _extensionConfig || {};
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["_23" /* objForEachKey */])(defaultConfig, function (field, value) {
                    _extensionConfig[field] = function () { return ctx.getConfig(identifier, field, value()); };
                });
                if (config.storagePrefix) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["_7" /* utlSetStoragePrefix */])(config.storagePrefix);
                }
                _previousTraceCtx = core[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["s" /* _DYN_GET_TRACE_CTX */] /* @min:%2egetTraceCtx */](false);
                _self.context = new __WEBPACK_IMPORTED_MODULE_4__TelemetryContext__["a" /* TelemetryContext */](core, _extensionConfig, _previousTraceCtx);
                _distributedTraceCtx = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["G" /* createDistributedTraceContextFromTrace */])(_self.context[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["F" /* _DYN_TELEMETRY_TRACE */] /* @min:%2etelemetryTrace */], _previousTraceCtx);
                core.setTraceCtx(_distributedTraceCtx);
                _self.context.appId = function () {
                    var breezeChannel = core.getPlugin(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_common__["b" /* BreezeChannelIdentifier */]);
                    return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                };
                // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                _self["_extConfig"] = _extensionConfig;
            }
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt, "tags", []);
                Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["W" /* getSetValue */])(evt, "ext", {});
                var ctx = _self.context;
                ctx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_APPLY_SESSION_CONTEX0 */] /* @min:%2eapplySessionContext */](evt, itemCtx);
                ctx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["c" /* _DYN_APPLY_APPLICATION_CO1 */] /* @min:%2eapplyApplicationContext */](evt, itemCtx);
                ctx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["d" /* _DYN_APPLY_DEVICE_CONTEXT */] /* @min:%2eapplyDeviceContext */](evt, itemCtx);
                ctx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["h" /* _DYN_APPLY_OPERATION_CONT2 */] /* @min:%2eapplyOperationContext */](evt, itemCtx);
                ctx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["j" /* _DYN_APPLY_USER_CONTEXT */] /* @min:%2eapplyUserContext */](evt, itemCtx);
                ctx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["g" /* _DYN_APPLY_OPERATING_SYST3 */] /* @min:%2eapplyOperatingSystemContxt */](evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["f" /* _DYN_APPLY_LOCATION_CONTE4 */] /* @min:%2eapplyLocationContext */](evt, itemCtx); // legacy tags
                ctx[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["e" /* _DYN_APPLY_INTERNAL_CONTE5 */] /* @min:%2eapplyInternalContext */](evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
    PropertiesPlugin.getDefaultConfig = function () {
        var _a;
        var defaultValue;
        var nullValue = null;
        var defaultConfig = (_a = {
                instrumentationKey: function () { return defaultValue; }
            },
            _a[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["a" /* _DYN_ACCOUNT_ID */] /* @min:accountId */] = function () { return nullValue; },
            _a.sessionRenewalMs = function () { return 30 * 60 * 1000; },
            _a.samplingPercentage = function () { return 100; },
            _a.sessionExpirationMs = function () { return 24 * 60 * 60 * 1000; },
            _a[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["o" /* _DYN_COOKIE_DOMAIN */] /* @min:cookieDomain */] = function () { return nullValue; },
            _a[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["A" /* _DYN_SDK_EXTENSION */] /* @min:sdkExtension */] = function () { return nullValue; },
            _a.isBrowserLinkTrackingEnabled = function () { return false; },
            _a.appId = function () { return nullValue; },
            _a[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["r" /* _DYN_GET_SESSION_ID */] /* @min:getSessionId */] = function () { return nullValue; },
            _a[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["y" /* _DYN_NAME_PREFIX */] /* @min:namePrefix */] = function () { return defaultValue; },
            _a[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["B" /* _DYN_SESSION_COOKIE_POSTF6 */] /* @min:sessionCookiePostfix */] = function () { return defaultValue; },
            _a[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["H" /* _DYN_USER_COOKIE_POSTFIX */] /* @min:userCookiePostfix */] = function () { return defaultValue; },
            _a[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["t" /* _DYN_ID_LENGTH */] /* @min:idLength */] = function () { return 22; },
            _a[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["q" /* _DYN_GET_NEW_ID */] /* @min:getNewId */] = function () { return nullValue; },
            _a);
        return defaultConfig;
    };
// Removed Stub for PropertiesPlugin.prototype.initialize.
// Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    return PropertiesPlugin;
}(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["b" /* BaseTelemetryPlugin */]));
/* harmony default export */ __webpack_exports__["a"] = (PropertiesPlugin);
//# sourceMappingURL=PropertiesPlugin.js.map

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(349);
/* unused harmony reexport strShimFunction */
/* unused harmony reexport strShimObject */
/* unused harmony reexport strShimUndefined */
/* unused harmony reexport strShimPrototype */
/* unused harmony reexport strShimHasOwnProperty */
/* unused harmony reexport strDefault */
/* unused harmony reexport ObjClass */
/* unused harmony reexport ObjProto */
/* unused harmony reexport ObjAssign */
/* unused harmony reexport ObjCreate */
/* unused harmony reexport ObjDefineProperty */
/* unused harmony reexport ObjHasOwnProperty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(493);
/* unused harmony reexport throwTypeError */
/* unused harmony reexport objCreateFn */
/* unused harmony reexport getGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(782);
/* unused harmony reexport __assignFn */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c"]; });
/* unused harmony reexport __restFn */
/* unused harmony reexport __spreadArrayFn */
/* unused harmony reexport __spreadArraysFn */
/* unused harmony reexport __decorateFn */
/* unused harmony reexport __paramFn */
/* unused harmony reexport __metadataFn */
/* unused harmony reexport __createBindingFn */
/* unused harmony reexport __valuesFn */
/* unused harmony reexport __readFn */
/* unused harmony reexport __makeTemplateObjectFn */
/* unused harmony reexport __importDefaultFn */
/* unused harmony reexport __importStarFn */
/* unused harmony reexport __exportStarFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TsLibGlobals__ = __webpack_require__(1929);
/* unused harmony reexport __exposeGlobalTsLib */
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.




//# sourceMappingURL=applicationinsights-shims.js.map

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __exposeGlobalTsLib */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(782);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.



function __exposeGlobalTsLib() {
    var globalObj = Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {};
    // tslint:disable: only-arrow-functions
    (function (root, assignFn, extendsFn, createBindingFn) {
        // Assign the globally scoped versions of the functions -- used when consuming individual ts files
        // If check is to support NativeScript where these are marked as readonly
        if (!root.__assign) {
            root.__assign = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || assignFn;
        }
        if (!root.__extends) {
            root.__extends = extendsFn;
        }
        if (!root.__createBinding) {
            root.__createBinding = createBindingFn;
        }
    })(globalObj, __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a" /* __assignFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c" /* __extendsFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["b" /* __createBindingFn */]);
    // Assign local variables that will be used for embedded scenarios, if check is to support NativeScript where these are marked as readonly
    if (!__assign) {
        __assign = globalObj.__assign;
    }
    if (!__extends) {
        __extends = globalObj.__extends;
    }
    if (!__createBinding) {
        __createBinding = globalObj.__createBinding;
    }
}
//# sourceMappingURL=TsLibGlobals.js.map

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Application; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Application = /** @class */ (function () {
    function Application() {
    }
    return Application;
}());

//# sourceMappingURL=Application.js.map

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Device; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Device = /** @class */ (function () {
    /**
     * Constructs a new instance of the Device class
     */
    function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}());

//# sourceMappingURL=Device.js.map

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Internal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DynamicConstants__ = __webpack_require__(271);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var Version = '2.8.18';
var Internal = /** @class */ (function () {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */
    function Internal(config) {
        this.sdkVersion = (config[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["A" /* _DYN_SDK_EXTENSION */] /* @min:%2esdkExtension */] && config[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["A" /* _DYN_SDK_EXTENSION */] /* @min:%2esdkExtension */]() ? config[__WEBPACK_IMPORTED_MODULE_0__DynamicConstants__["A" /* _DYN_SDK_EXTENSION */] /* @min:%2esdkExtension */]() + "_" : "") + "javascript:" + Version;
    }
    return Internal;
}());

//# sourceMappingURL=Internal.js.map

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Location; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());

//# sourceMappingURL=Location.js.map

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return User; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DynamicConstants__ = __webpack_require__(271);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






function _validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== "string" ||
        !id ||
        id.match(/,|;|=| |\|/)) {
        return false;
    }
    return true;
}
var User = /** @class */ (function () {
    function User(config, core) {
        /**
         * A flag indicating whether this represents a new user
         */
        this.isNewUser = false;
        /**
         * A flag indicating whether the user cookie has been set
         */
        this.isUserCookieSet = false;
        var _logger = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_33" /* safeGetLogger */])(core);
        var _cookieManager = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_32" /* safeGetCookieMgr */])(core);
        var _storageNamePrefix;
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(User, this, function (_self) {
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["n" /* _DYN_CONFIG */] /* @min:%2econfig */] = config;
            var userCookiePostfix = (_self.config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["H" /* _DYN_USER_COOKIE_POSTFIX */] /* @min:%2euserCookiePostfix */] && _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["n" /* _DYN_CONFIG */] /* @min:%2econfig */][__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["H" /* _DYN_USER_COOKIE_POSTFIX */] /* @min:%2euserCookiePostfix */]()) ? _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["n" /* _DYN_CONFIG */] /* @min:%2econfig */][__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["H" /* _DYN_USER_COOKIE_POSTFIX */] /* @min:%2euserCookiePostfix */]() : "";
            _storageNamePrefix = function () { return User.userCookieName + userCookiePostfix; };
            // get userId or create new one if none exists
            var cookie = _cookieManager.get(_storageNamePrefix());
            if (cookie) {
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["u" /* _DYN_IS_NEW_USER */] /* @min:%2eisNewUser */] = false;
                var params = cookie.split(User[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["p" /* _DYN_COOKIE_SEPARATOR */] /* @min:%2ecookieSeparator */]);
                if (params[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 0) {
                    _self.id = params[0];
                    // we already have a cookie
                    _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_IS_USER_COOKIE_SET */] /* @min:%2eisUserCookieSet */] = !!_self.id;
                }
            }
            function _generateNewId() {
                var theConfig = (config || {});
                var getNewId = (theConfig[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_GET_NEW_ID */] /* @min:%2egetNewId */] ? theConfig[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["q" /* _DYN_GET_NEW_ID */] /* @min:%2egetNewId */]() : null) || __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_20" /* newId */];
                var id = getNewId(theConfig[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["t" /* _DYN_ID_LENGTH */] /* @min:%2eidLength */] ? config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["t" /* _DYN_ID_LENGTH */] /* @min:%2eidLength */]() : 22);
                return id;
            }
            function _generateNewCookie(userId) {
                var acqStr = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_41" /* toISOString */])(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["u" /* _DYN_IS_NEW_USER */] /* @min:%2eisNewUser */] = true;
                var newCookie = [userId, acqStr];
                return newCookie;
            }
            function _setUserCookie(cookie) {
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000
                var oneYear = 31536000;
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_IS_USER_COOKIE_SET */] /* @min:%2eisUserCookieSet */] = _cookieManager.set(_storageNamePrefix(), cookie, oneYear);
            }
            if (!_self.id) {
                _self.id = _generateNewId();
                var newCookie = _generateNewCookie(_self.id);
                _setUserCookie(newCookie[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["w" /* _DYN_JOIN */] /* @min:%2ejoin */](User[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["p" /* _DYN_COOKIE_SEPARATOR */] /* @min:%2ecookieSeparator */]));
                // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                // We should respect their wishes and clear ourselves from local storage
                var name_1 = config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["y" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */] && config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["y" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */]() ? config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["y" /* _DYN_NAME_PREFIX */] /* @min:%2enamePrefix */]() + "ai_session" : "ai_session";
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["_4" /* utlRemoveStorage */])(_logger, name_1);
            }
            // We still take the account id from the ctor param for backward compatibility.
            // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ACCOUNT_ID */] /* @min:%2eaccountId */] = config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ACCOUNT_ID */] /* @min:%2eaccountId */] ? config[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ACCOUNT_ID */] /* @min:%2eaccountId */]() : undefined;
            // Get the auth user id and account id from the cookie if exists
            // Cookie is in the pattern: <authenticatedId>|<accountId>
            var authCookie = _cookieManager.get(User[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["l" /* _DYN_AUTH_USER_COOKIE_NAM8 */] /* @min:%2eauthUserCookieName */]);
            if (authCookie) {
                authCookie = decodeURI(authCookie);
                var authCookieString = authCookie.split(User[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["p" /* _DYN_COOKIE_SEPARATOR */] /* @min:%2ecookieSeparator */]);
                if (authCookieString[0]) {
                    _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["k" /* _DYN_AUTHENTICATED_ID */] /* @min:%2eauthenticatedId */] = authCookieString[0];
                }
                if (authCookieString[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["x" /* _DYN_LENGTH */] /* @min:%2elength */] > 1 && authCookieString[1]) {
                    _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ACCOUNT_ID */] /* @min:%2eaccountId */] = authCookieString[1];
                }
            }
            _self.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === void 0) { storeInCookie = false; }
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !_validateUserInput(authenticatedUserId) || (accountId && !_validateUserInput(accountId));
                if (isInvalidInput) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["l" /* _throwInternal */])(_logger, 2 /* eLoggingSeverity.WARNING */, 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */, "Setting auth user context failed. " +
                        "User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["k" /* _DYN_AUTHENTICATED_ID */] /* @min:%2eauthenticatedId */] = authenticatedUserId;
                var authCookie = _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["k" /* _DYN_AUTHENTICATED_ID */] /* @min:%2eauthenticatedId */];
                if (accountId) {
                    _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ACCOUNT_ID */] /* @min:%2eaccountId */] = accountId;
                    authCookie = [_self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["k" /* _DYN_AUTHENTICATED_ID */] /* @min:%2eauthenticatedId */], _self.accountId][__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["w" /* _DYN_JOIN */] /* @min:%2ejoin */](User[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["p" /* _DYN_COOKIE_SEPARATOR */] /* @min:%2ecookieSeparator */]);
                }
                if (storeInCookie) {
                    // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                    // Encoding the cookie to handle unexpected unicode characters.
                    _cookieManager.set(User[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["l" /* _DYN_AUTH_USER_COOKIE_NAM8 */] /* @min:%2eauthUserCookieName */], encodeURI(authCookie));
                }
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */
            _self.clearAuthenticatedUserContext = function () {
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["k" /* _DYN_AUTHENTICATED_ID */] /* @min:%2eauthenticatedId */] = null;
                _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["a" /* _DYN_ACCOUNT_ID */] /* @min:%2eaccountId */] = null;
                _cookieManager.del(User[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["l" /* _DYN_AUTH_USER_COOKIE_NAM8 */] /* @min:%2eauthUserCookieName */]);
            };
            _self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["G" /* _DYN_UPDATE */] /* @min:%2eupdate */] = function (userId) {
                // Optimizations to avoid setting and processing the cookie when not needed
                if (_self.id !== userId || !_self[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["v" /* _DYN_IS_USER_COOKIE_SET */] /* @min:%2eisUserCookieSet */]) {
                    var user_id = userId ? userId : _generateNewId();
                    var user_cookie = _generateNewCookie(user_id);
                    _setUserCookie(user_cookie[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["w" /* _DYN_JOIN */] /* @min:%2ejoin */](User[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["p" /* _DYN_COOKIE_SEPARATOR */] /* @min:%2ecookieSeparator */]));
                }
            };
        });
    }
// Removed Stub for User.prototype.setAuthenticatedUserContext.
// Removed Stub for User.prototype.clearAuthenticatedUserContext.
// Removed Stub for User.prototype.update.
    User.cookieSeparator = "|";
    User.userCookieName = "ai_user";
    User.authUserCookieName = "ai_authUser";
    return User;
}());

//# sourceMappingURL=User.js.map

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ApplicationInsightsContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApplicationInsightsDeprecated__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Initialization__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DynamicConstants__ = __webpack_require__(494);
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var ApplicationInsightsContainer = /** @class */ (function () {
    function ApplicationInsightsContainer() {
    }
    ApplicationInsightsContainer.getAppInsights = function (snippet, version) {
        var initialization = new __WEBPACK_IMPORTED_MODULE_2__Initialization__["a" /* Initialization */](snippet);
        var legacyMode = version >= 2 ? false : true;
        // Side effect is to create, initialize and listen to the CoreUtils._canUseCookies changes
        // Called here to support backward compatibility
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["j" /* _legacyCookieMgr */])();
        // Two target scenarios:
        // 1. Customer runs v1 snippet + runtime. If customer updates just cdn location to new SDK, it will run in compat mode so old apis work
        // 2. Customer updates to new snippet (that uses cdn location to new SDK. This is same as a new customer onboarding
        // and all api signatures are expected to map to new SDK. Note new snippet specifies version
        if (!legacyMode) {
            initialization[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_UPDATE_SNIPPET_DEFIN0 */] /* @min:%2eupdateSnippetDefinitions */](snippet);
            initialization[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["A" /* _DYN_LOAD_APP_INSIGHTS */] /* @min:%2eloadAppInsights */](legacyMode);
            return initialization; // default behavior with new snippet
        }
        else {
            var legacy = new __WEBPACK_IMPORTED_MODULE_1__ApplicationInsightsDeprecated__["a" /* AppInsightsDeprecated */](snippet, initialization); // target scenario old snippet + updated endpoint
            legacy[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["I" /* _DYN_UPDATE_SNIPPET_DEFIN0 */] /* @min:%2eupdateSnippetDefinitions */](snippet);
            initialization[__WEBPACK_IMPORTED_MODULE_3__DynamicConstants__["A" /* _DYN_LOAD_APP_INSIGHTS */] /* @min:%2eloadAppInsights */](legacyMode);
            return legacy;
        }
    };
    return ApplicationInsightsContainer;
}());

//# sourceMappingURL=ApplicationInsightsContainer.js.map

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppInsightsDeprecated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_dependencies_js__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalConstants__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DynamicConstants__ = __webpack_require__(494);
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var _ignoreUpdateSnippetProperties = [
    __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["j" /* STR_SNIPPET */], "getDefaultConfig", "_hasLegacyInitializers", "_queue", "_processLegacyInitializers"
];
function getDefaultConfig(config) {
    if (!config) {
        config = {};
    }
    // set default values
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["s" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */] = config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["s" /* _DYN_ENDPOINT_URL */] /* @min:%2eendpointUrl */] || __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["h" /* DEFAULT_BREEZE_ENDPOINT */] + __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["i" /* DEFAULT_BREEZE_PATH */];
    config.sessionRenewalMs = 30 * 60 * 1000;
    config.sessionExpirationMs = 24 * 60 * 60 * 1000;
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["D" /* _DYN_MAX_BATCH_SIZE_IN_BY1 */] /* @min:%2emaxBatchSizeInBytes */] = config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["D" /* _DYN_MAX_BATCH_SIZE_IN_BY1 */] /* @min:%2emaxBatchSizeInBytes */] > 0 ? config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["D" /* _DYN_MAX_BATCH_SIZE_IN_BY1 */] /* @min:%2emaxBatchSizeInBytes */] : 102400; // 100kb
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["C" /* _DYN_MAX_BATCH_INTERVAL */] /* @min:%2emaxBatchInterval */] = !isNaN(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["C" /* _DYN_MAX_BATCH_INTERVAL */] /* @min:%2emaxBatchInterval */]) ? config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["C" /* _DYN_MAX_BATCH_INTERVAL */] /* @min:%2emaxBatchInterval */] : 15000;
    config.enableDebug = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config.enableDebug);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["k" /* _DYN_DISABLE_EXCEPTION_TR2 */] /* @min:%2edisableExceptionTracking */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["k" /* _DYN_DISABLE_EXCEPTION_TR2 */] /* @min:%2edisableExceptionTracking */]);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["o" /* _DYN_DISABLE_TELEMETRY */] /* @min:%2edisableTelemetry */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["o" /* _DYN_DISABLE_TELEMETRY */] /* @min:%2edisableTelemetry */]);
    config.verboseLogging = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config.verboseLogging);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["p" /* _DYN_EMIT_LINE_DELIMITED_3 */] /* @min:%2eemitLineDelimitedJson */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["p" /* _DYN_EMIT_LINE_DELIMITED_3 */] /* @min:%2eemitLineDelimitedJson */]);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["h" /* _DYN_DIAGNOSTIC_LOG_INTER4 */] /* @min:%2ediagnosticLogInterval */] = config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["h" /* _DYN_DIAGNOSTIC_LOG_INTER4 */] /* @min:%2ediagnosticLogInterval */] || 10000;
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["c" /* _DYN_AUTO_TRACK_PAGE_VISI5 */] /* @min:%2eautoTrackPageVisitTime */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["c" /* _DYN_AUTO_TRACK_PAGE_VISI5 */] /* @min:%2eautoTrackPageVisitTime */]);
    if (isNaN(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["H" /* _DYN_SAMPLING_PERCENTAGE */] /* @min:%2esamplingPercentage */]) || config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["H" /* _DYN_SAMPLING_PERCENTAGE */] /* @min:%2esamplingPercentage */] <= 0 || config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["H" /* _DYN_SAMPLING_PERCENTAGE */] /* @min:%2esamplingPercentage */] >= 100) {
        config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["H" /* _DYN_SAMPLING_PERCENTAGE */] /* @min:%2esamplingPercentage */] = 100;
    }
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_DISABLE_AJAX_TRACKIN6 */] /* @min:%2edisableAjaxTracking */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["i" /* _DYN_DISABLE_AJAX_TRACKIN6 */] /* @min:%2edisableAjaxTracking */]);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["B" /* _DYN_MAX_AJAX_CALLS_PER_V7 */] /* @min:%2emaxAjaxCallsPerView */] = !isNaN(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["B" /* _DYN_MAX_AJAX_CALLS_PER_V7 */] /* @min:%2emaxAjaxCallsPerView */]) ? config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["B" /* _DYN_MAX_AJAX_CALLS_PER_V7 */] /* @min:%2emaxAjaxCallsPerView */] : 500;
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["w" /* _DYN_IS_BEACON_API_DISABL8 */] /* @min:%2eisBeaconApiDisabled */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["w" /* _DYN_IS_BEACON_API_DISABL8 */] /* @min:%2eisBeaconApiDisabled */], true);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["j" /* _DYN_DISABLE_CORRELATION_9 */] /* @min:%2edisableCorrelationHeaders */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["j" /* _DYN_DISABLE_CORRELATION_9 */] /* @min:%2edisableCorrelationHeaders */]);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["g" /* _DYN_CORRELATION_HEADER_E10 */] /* @min:%2ecorrelationHeaderExcludedDomains */] = config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["g" /* _DYN_CORRELATION_HEADER_E10 */] /* @min:%2ecorrelationHeaderExcludedDomains */] || __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_dependencies_js__["b" /* DfltAjaxCorrelationHeaderExDomains */];
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["l" /* _DYN_DISABLE_FLUSH_ON_BEF11 */] /* @min:%2edisableFlushOnBeforeUnload */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["l" /* _DYN_DISABLE_FLUSH_ON_BEF11 */] /* @min:%2edisableFlushOnBeforeUnload */]);
    config.disableFlushOnUnload = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config.disableFlushOnUnload, config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["l" /* _DYN_DISABLE_FLUSH_ON_BEF11 */] /* @min:%2edisableFlushOnBeforeUnload */]);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["r" /* _DYN_ENABLE_SESSION_STORA13 */] /* @min:%2eenableSessionStorageBuffer */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["r" /* _DYN_ENABLE_SESSION_STORA13 */] /* @min:%2eenableSessionStorageBuffer */], true);
    config.isRetryDisabled = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config.isRetryDisabled);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["y" /* _DYN_IS_COOKIE_USE_DISABL14 */] /* @min:%2eisCookieUseDisabled */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["y" /* _DYN_IS_COOKIE_USE_DISABL14 */] /* @min:%2eisCookieUseDisabled */]);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["z" /* _DYN_IS_STORAGE_USE_DISAB15 */] /* @min:%2eisStorageUseDisabled */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["z" /* _DYN_IS_STORAGE_USE_DISAB15 */] /* @min:%2eisStorageUseDisabled */]);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["x" /* _DYN_IS_BROWSER_LINK_TRAC16 */] /* @min:%2eisBrowserLinkTrackingEnabled */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["x" /* _DYN_IS_BROWSER_LINK_TRAC16 */] /* @min:%2eisBrowserLinkTrackingEnabled */]);
    config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["q" /* _DYN_ENABLE_CORS_CORRELAT17 */] /* @min:%2eenableCorsCorrelation */] = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["U" /* stringToBoolOrDefault */])(config[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["q" /* _DYN_ENABLE_CORS_CORRELAT17 */] /* @min:%2eenableCorsCorrelation */]);
    return config;
}
var AppInsightsDeprecated = /** @class */ (function () {
    function AppInsightsDeprecated(snippet, appInsightsNew) {
        var _this = this;
        var _hasLegacyInitializers = false;
        var _queue = [];
        var _config;
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(AppInsightsDeprecated, this, function (_self) {
            _config = getDefaultConfig(snippet[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */]);
            _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */] = _config;
            _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["j" /* STR_SNIPPET */] /* @min:%2esnippet */] = snippet;
            _self.appInsightsNew = appInsightsNew;
            _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */] = { addTelemetryInitializer: _addTelemetryInitializers.bind(_self) };
            _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["b" /* STR_ADD_TELEMETRY_INITIALIZERS */] /* @min:%2eaddTelemetryInitializers */] = _addTelemetryInitializers;
            function _addTelemetryInitializers(callBack) {
                // Add initializer to current processing only if there is any old telemetry initializer
                if (!_hasLegacyInitializers) {
                    appInsightsNew[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["a" /* STR_ADD_TELEMETRY_INITIALIZER */] /* @min:%2eaddTelemetryInitializer */](function (item) {
                        _processLegacyInitializers(item); // setup call back for each legacy processor
                    });
                    _hasLegacyInitializers = true;
                }
                _queue[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["F" /* _DYN_PUSH */] /* @min:%2epush */](callBack);
            }
            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_27" /* proxyFunctions */])(_self, appInsightsNew, [
                __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["f" /* STR_GET_COOKIE_MGR */],
                __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["l" /* STR_START_TRACK_PAGE */],
                __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["n" /* STR_STOP_TRACK_PAGE */],
                __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["e" /* STR_FLUSH */],
                __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["k" /* STR_START_TRACK_EVENT */],
                __WEBPACK_IMPORTED_MODULE_4__InternalConstants__["m" /* STR_STOP_TRACK_EVENT */]
            ]);
            _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["s" /* STR_TRACK_PAGE_VIEW */] /* @min:%2etrackPageView */] = function (name, url, properties, measurements, duration) {
                var telemetry = {
                    name: name,
                    uri: url,
                    properties: properties,
                    measurements: measurements
                };
                // fix for props, measurements, duration
                appInsightsNew[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["s" /* STR_TRACK_PAGE_VIEW */] /* @min:%2etrackPageView */](telemetry);
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["p" /* STR_TRACK_EVENT */] /* @min:%2etrackEvent */] = function (name, properties, measurements) {
                appInsightsNew[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["p" /* STR_TRACK_EVENT */] /* @min:%2etrackEvent */]({ name: name });
            };
            _self.trackDependency = function (id, method, absoluteUrl, pathName, totalTime, success, resultCode) {
                appInsightsNew[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["o" /* STR_TRACK_DEPENDENCY_DATA */] /* @min:%2etrackDependencyData */]({
                    id: id,
                    target: absoluteUrl,
                    type: pathName,
                    duration: totalTime,
                    properties: { HttpMethod: method },
                    success: success,
                    responseCode: resultCode
                });
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["q" /* STR_TRACK_EXCEPTION */] /* @min:%2etrackException */] = function (exception, handledAt, properties, measurements, severityLevel) {
                appInsightsNew[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["q" /* STR_TRACK_EXCEPTION */] /* @min:%2etrackException */]({
                    exception: exception
                });
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["r" /* STR_TRACK_METRIC */] /* @min:%2etrackMetric */] = function (name, average, sampleCount, min, max, properties) {
                appInsightsNew[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["r" /* STR_TRACK_METRIC */] /* @min:%2etrackMetric */]({ name: name, average: average, sampleCount: sampleCount, min: min, max: max });
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["t" /* STR_TRACK_TRACE */] /* @min:%2etrackTrace */] = function (message, properties, severityLevel) {
                appInsightsNew[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["t" /* STR_TRACK_TRACE */] /* @min:%2etrackTrace */]({ message: message, severityLevel: severityLevel });
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["i" /* STR_SET_AUTHENTICATED_USER_CONTEXT */] /* @min:%2esetAuthenticatedUserContext */] = function (authenticatedUserId, accountId, storeInCookie) {
                appInsightsNew[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */].user[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["i" /* STR_SET_AUTHENTICATED_USER_CONTEXT */] /* @min:%2esetAuthenticatedUserContext */](authenticatedUserId, accountId, storeInCookie);
            };
            _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["c" /* STR_CLEAR_AUTHENTICATED_USER_CONTEXT */] /* @min:%2eclearAuthenticatedUserContext */] = function () {
                appInsightsNew[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["f" /* _DYN_CONTEXT */] /* @min:%2econtext */].user[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["c" /* STR_CLEAR_AUTHENTICATED_USER_CONTEXT */] /* @min:%2eclearAuthenticatedUserContext */]();
            };
            _self._onerror = function (message, url, lineNumber, columnNumber, error) {
                appInsightsNew._onerror({ message: message, url: url, lineNumber: lineNumber, columnNumber: columnNumber, error: error });
            };
            _self.downloadAndSetup = function (config) {
                Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_40" /* throwError */])("downloadAndSetup not implemented in web SKU");
            };
            _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["I" /* _DYN_UPDATE_SNIPPET_DEFIN0 */] /* @min:%2eupdateSnippetDefinitions */] = function (snippet) {
                // apply full appInsights to the global instance
                // Note: This must be called before loadAppInsights is called
                Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_26" /* proxyAssign */])(snippet, _this, function (name) {
                    // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
                    return name && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["q" /* arrIndexOf */])(_ignoreUpdateSnippetProperties, name) === -1;
                });
            };
            // note: these are split into methods to enable unit tests
            _self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["A" /* _DYN_LOAD_APP_INSIGHTS */] /* @min:%2eloadAppInsights */] = function () {
                // initialize global instance of appInsights
                // var appInsights = new Microsoft.ApplicationInsights.AppInsights(_self.config);
                // implement legacy version of trackPageView for 0.10<
                if (_self[__WEBPACK_IMPORTED_MODULE_5__DynamicConstants__["d" /* _DYN_CONFIG */] /* @min:%2econfig */]["iKey"]) {
                    var originalTrackPageView_1 = _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["s" /* STR_TRACK_PAGE_VIEW */] /* @min:%2etrackPageView */];
                    _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["s" /* STR_TRACK_PAGE_VIEW */] /* @min:%2etrackPageView */] = function (pagePath, properties, measurements) {
                        originalTrackPageView_1.apply(_self, [null, pagePath, properties, measurements]);
                    };
                }
                // implement legacy pageView interface if it is present in the snippet
                var legacyPageView = "logPageView";
                if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(_self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["j" /* STR_SNIPPET */] /* @min:%2esnippet */][legacyPageView])) {
                    _this[legacyPageView] = function (pagePath, properties, measurements) {
                        _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["s" /* STR_TRACK_PAGE_VIEW */] /* @min:%2etrackPageView */](null, pagePath, properties, measurements);
                    };
                }
                // implement legacy event interface if it is present in the snippet
                var legacyEvent = "logEvent";
                if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["_7" /* isFunction */])(_self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["j" /* STR_SNIPPET */] /* @min:%2esnippet */][legacyEvent])) {
                    _this[legacyEvent] = function (name, props, measurements) {
                        _self[__WEBPACK_IMPORTED_MODULE_4__InternalConstants__["p" /* STR_TRACK_EVENT */] /* @min:%2etrackEvent */](name, props, measurements);
                    };
                }
                return _this;
            };
            function _processLegacyInitializers(item) {
                // instead of mapping new to legacy and then back again and repeating in channel, attach callback for channel to call
                item.tags[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["w" /* ProcessLegacy */]] = _queue;
                return item;
            }
        });
    }
// Removed Stub for AppInsightsDeprecated.prototype.addTelemetryInitializers.
// Removed Stub for AppInsightsDeprecated.prototype.getCookieMgr.
// Removed Stub for AppInsightsDeprecated.prototype.startTrackPage.
// Removed Stub for AppInsightsDeprecated.prototype.stopTrackPage.
// Removed Stub for AppInsightsDeprecated.prototype.trackPageView.
// Removed Stub for AppInsightsDeprecated.prototype.trackEvent.
// Removed Stub for AppInsightsDeprecated.prototype.trackDependency.
// Removed Stub for AppInsightsDeprecated.prototype.trackException.
// Removed Stub for AppInsightsDeprecated.prototype.trackMetric.
// Removed Stub for AppInsightsDeprecated.prototype.trackTrace.
// Removed Stub for AppInsightsDeprecated.prototype.flush.
// Removed Stub for AppInsightsDeprecated.prototype.setAuthenticatedUserContext.
// Removed Stub for AppInsightsDeprecated.prototype.clearAuthenticatedUserContext.
// Removed Stub for AppInsightsDeprecated.prototype._onerror.
// Removed Stub for AppInsightsDeprecated.prototype.startTrackEvent.
// Removed Stub for AppInsightsDeprecated.prototype.stopTrackEvent.
// Removed Stub for AppInsightsDeprecated.prototype.downloadAndSetup.
// Removed Stub for AppInsightsDeprecated.prototype.updateSnippetDefinitions.
    // note: these are split into methods to enable unit tests
// Removed Stub for AppInsightsDeprecated.prototype.loadAppInsights.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    AppInsightsDeprecated.__ieDyn=1;

    return AppInsightsDeprecated;
}());

//# sourceMappingURL=ApplicationInsightsDeprecated.js.map

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export strShimFunction */
/* unused harmony export strShimObject */
/* unused harmony export strShimUndefined */
/* unused harmony export strShimPrototype */
/* unused harmony export strShimHasOwnProperty */
/* unused harmony export getGlobal */
/* unused harmony export objCreateFn */
/* unused harmony export __assignFn */
/* unused harmony export __extendsFn */
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var strShimHasOwnProperty = "hasOwnProperty";
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions.
 */
function getGlobal() {
    if (typeof globalThis !== strShimUndefined && globalThis) {
        return globalThis;
    }
    if (typeof self !== strShimUndefined && self) {
        return self;
    }
    if (typeof window !== strShimUndefined && window) {
        return window;
    }
    if (typeof global !== strShimUndefined && global) {
        return global;
    }
    return null;
}
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object to use as a prototype. May be null
 */
function objCreateFn(obj) {
    var func = Object["create"];
    // Use build in Object.create
    if (func) {
        // Use Object create method if it exists
        return func(obj);
    }
    if (obj == null) {
        return {};
    }
    var type = typeof obj;
    if (type !== strShimObject && type !== strShimFunction) {
        throw new TypeError('Object prototype may only be an Object:' + obj);
    }
    function tmpFunc() { }
    tmpFunc[strShimPrototype] = obj;
    return new tmpFunc();
}
function __assignFn(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object[strShimPrototype][strShimHasOwnProperty].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
}
// tslint:disable-next-line: only-arrow-functions
var __extendStaticsFn = function (d, b) {
    __extendStaticsFn = Object["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[strShimHasOwnProperty](p)) {
                    d[p] = b[p];
                }
            }
        };
    return __extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    __extendStaticsFn(d, b);
    function __() { this.constructor = d; }
    // tslint:disable-next-line: ban-comma-operator
    d[strShimPrototype] = b === null ? objCreateFn(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
}
var globalObj = getGlobal() || {};
// tslint:disable: only-arrow-functions
(function (root, assignFn, extendsFn) {
    // Assign the globally scoped versions of the functions -- used when consuming individual ts files
    // If check is to support NativeScript where these are marked as readonly
    if (!root.__assign) {
        root.__assign = Object.assign || assignFn;
    }
    if (!root.__extends) {
        root.__extends = extendsFn;
    }
})(globalObj, __assignFn, __extendsFn);
// Assign local variables that will be used for embedded scenarios, if check is to support NativeScript where these are marked as readonly
if (!__assign) {
    __assign = globalObj.__assign;
}
if (!__extends) {
    __extends = globalObj.__extends;
}
//# sourceMappingURL=applicationinsights-shims.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(37);
/**
 * ReactPlugin.ts
 * @copyright Microsoft 2019
 */

var ReactPlugin = /** @class */ (function (_super) {
    __extends(ReactPlugin, _super);
    function ReactPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.priority = 185;
        _this.identifier = 'ReactPlugin';
        return _this;
    }
    ReactPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
        var _this = this;
        _super.prototype.initialize.call(this, config, core, extensions, pluginChain);
        this._extensionConfig =
            config.extensionConfig && config.extensionConfig[this.identifier]
                ? config.extensionConfig[this.identifier]
                : { history: null };
        __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* CoreUtils */].arrForEach(extensions, function (ext) {
            var identifier = ext.identifier;
            if (identifier === 'ApplicationInsightsAnalytics') {
                _this._analyticsPlugin = ext;
            }
        });
        if (this._extensionConfig.history) {
            this.addHistoryListener(this._extensionConfig.history);
            var pageViewTelemetry = {
                uri: this._extensionConfig.history.location.pathname
            };
            this.trackPageView(pageViewTelemetry);
        }
    };
    /**
     * Add Part A fields to the event
     * @param event The event that needs to be processed
     */
    ReactPlugin.prototype.processTelemetry = function (event, itemCtx) {
        this.processNext(event, itemCtx);
    };
    ReactPlugin.prototype.trackMetric = function (metric, customProperties) {
        if (this._analyticsPlugin) {
            this._analyticsPlugin.trackMetric(metric, customProperties);
        }
        else {
            this.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["g" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["i" /* _InternalMessageId */].TelemetryInitializerFailed, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
        }
    };
    ReactPlugin.prototype.trackPageView = function (pageView) {
        if (this._analyticsPlugin) {
            this._analyticsPlugin.trackPageView(pageView);
        }
        else {
            this.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["g" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["i" /* _InternalMessageId */].TelemetryInitializerFailed, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
        }
    };
    ReactPlugin.prototype.trackEvent = function (event, customProperties) {
        if (this._analyticsPlugin) {
            this._analyticsPlugin.trackEvent(event, customProperties);
        }
        else {
            this.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["g" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["i" /* _InternalMessageId */].TelemetryInitializerFailed, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
        }
    };
    ReactPlugin.prototype.trackException = function (exception, customProperties) {
        if (this._analyticsPlugin) {
            this._analyticsPlugin.trackException(exception, customProperties);
        }
        else {
            this.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["g" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["i" /* _InternalMessageId */].TelemetryInitializerFailed, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
        }
    };
    ;
    ReactPlugin.prototype.addHistoryListener = function (history) {
        var _this = this;
        var locationListener = function (location, action) {
            // Timeout to ensure any changes to the DOM made by route changes get included in pageView telemetry
            setTimeout(function () {
                var pageViewTelemetry = { uri: location.pathname };
                _this.trackPageView(pageViewTelemetry);
            }, 500);
        };
        history.listen(locationListener);
    };
    return ReactPlugin;
}(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* BaseTelemetryPlugin */]));
/* harmony default export */ __webpack_exports__["a"] = (ReactPlugin);
//# sourceMappingURL=ReactPlugin.js.map

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withAITracking;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

/**
 * Higher-order component function to hook Application Insights tracking
 * in a React component's lifecycle.
 *
 * @param reactPlugin ReactPlugin instance
 * @param Component the React component to be instrumented
 * @param componentName (optional) component name
 * @param className (optional) className of the HOC div
 */
function withAITracking(reactPlugin, Component, componentName, className) {
    if (componentName === undefined || componentName === null || typeof componentName !== 'string') {
        componentName = Component.prototype &&
            Component.prototype.constructor &&
            Component.prototype.constructor.name ||
            'Unknown';
    }
    if (className === undefined || className === null || typeof className !== 'string') {
        className = '';
    }
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._mountTimestamp = 0;
            _this._firstActiveTimestamp = 0;
            _this._idleStartTimestamp = 0;
            _this._lastActiveTimestamp = 0;
            _this._totalIdleTime = 0;
            _this._idleCount = 0;
            _this._idleTimeout = 5000;
            _this.trackActivity = function (e) {
                if (_this._firstActiveTimestamp === 0) {
                    _this._firstActiveTimestamp = Date.now();
                    _this._lastActiveTimestamp = _this._firstActiveTimestamp;
                }
                else {
                    _this._lastActiveTimestamp = Date.now();
                }
                if (_this._idleStartTimestamp > 0) {
                    var lastIdleTime = _this._lastActiveTimestamp - _this._idleStartTimestamp;
                    _this._totalIdleTime += lastIdleTime;
                    _this._idleStartTimestamp = 0;
                }
            };
            return _this;
        }
        class_1.prototype.componentDidMount = function () {
            var _this = this;
            this._mountTimestamp = Date.now();
            this._firstActiveTimestamp = 0;
            this._totalIdleTime = 0;
            this._lastActiveTimestamp = 0;
            this._idleStartTimestamp = 0;
            this._idleCount = 0;
            this._intervalId = setInterval(function () {
                if (_this._lastActiveTimestamp > 0 && _this._idleStartTimestamp === 0 && Date.now() - _this._lastActiveTimestamp >= _this._idleTimeout) {
                    _this._idleStartTimestamp = Date.now();
                    _this._idleCount++;
                }
            }, 100);
        };
        class_1.prototype.componentWillUnmount = function () {
            if (this._mountTimestamp === 0) {
                throw new Error('withAITracking:componentWillUnmount: mountTimestamp is not initialized.');
            }
            if (this._intervalId) {
                clearInterval(this._intervalId);
            }
            if (this._firstActiveTimestamp === 0) {
                return;
            }
            var engagementTime = this.getEngagementTimeSeconds();
            var metricData = {
                average: engagementTime,
                name: 'React Component Engaged Time (seconds)',
                sampleCount: 1
            };
            var additionalProperties = { 'Component Name': componentName };
            reactPlugin.trackMetric(metricData, additionalProperties);
        };
        class_1.prototype.render = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onKeyDown: this.trackActivity, onMouseMove: this.trackActivity, onScroll: this.trackActivity, onMouseDown: this.trackActivity, onTouchStart: this.trackActivity, onTouchMove: this.trackActivity, className: className },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component, __assign({}, this.props))));
        };
        class_1.prototype.getEngagementTimeSeconds = function () {
            return (Date.now() - this._firstActiveTimestamp - this._totalIdleTime - this._idleCount * this._idleTimeout) / 1000;
        };
        return class_1;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
}
//# sourceMappingURL=withAITracking.js.map

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(70);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


var AppInsightsErrorBoundary = /** @class */ (function (_super) {
    __extends(AppInsightsErrorBoundary, _super);
    function AppInsightsErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hasError: false };
        return _this;
    }
    AppInsightsErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ hasError: true });
        this.props.appInsights.trackException({
            error: error,
            exception: error,
            severityLevel: __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["B" /* SeverityLevel */].Error,
            properties: errorInfo
        });
    };
    AppInsightsErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            var onError = this.props.onError;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(onError);
        }
        return this.props.children;
    };
    return AppInsightsErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (AppInsightsErrorBoundary);
//# sourceMappingURL=AppInsightsErrorBoundary.js.map

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppInsightsContext */
/* unused harmony export useAppInsightsContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var AppInsightsContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(undefined);
var useAppInsightsContext = function () { return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(AppInsightsContext); };

//# sourceMappingURL=AppInsightsContext.js.map

/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/**
 * ReactPlugin.ts
 * @copyright Microsoft 2019
 */

function useCustomEvent(reactPlugin, eventName, eventData, skipFirstRun) {
    if (skipFirstRun === void 0) { skipFirstRun = true; }
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(eventData), data = _a[0], setData = _a[1];
    var firstRun = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(skipFirstRun);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (firstRun.current) {
            firstRun.current = false;
            return;
        }
        reactPlugin.trackEvent({ name: eventName }, data);
    }, [reactPlugin, data, eventName]);
    return setData;
}
//# sourceMappingURL=useTrackEvent.js.map

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function getEngagementTimeSeconds(trackedData) {
    return ((Date.now() -
        trackedData.firstActiveTimestamp -
        trackedData.totalIdleTime -
        trackedData.idleCount * trackedData.idleTimeout) /
        1000);
}
var useComponentTracking = function (reactPlugin, componentName) {
    var tracking = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({
        hookTimestamp: Date.now(),
        firstActiveTimestamp: 0,
        totalIdleTime: 0,
        lastActiveTimestamp: 0,
        idleStartTimestamp: 0,
        idleCount: 0,
        idleTimeout: 5000
    });
    var savedCallback = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    var callback = function () {
        var trackedData = tracking.current;
        if (trackedData.lastActiveTimestamp > 0 &&
            trackedData.idleStartTimestamp === 0 &&
            Date.now() - trackedData.lastActiveTimestamp >= trackedData.idleTimeout) {
            trackedData.idleStartTimestamp = Date.now();
            trackedData.idleCount++;
        }
    };
    var delay = 100;
    savedCallback.current = callback;
    // Set up the interval.
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var id = setInterval(savedCallback.current, delay);
        return function () {
            clearInterval(id);
            var trackedData = tracking.current;
            if (trackedData.hookTimestamp === 0) {
                throw new Error("useAppInsights:unload hook: hookTimestamp is not initialized.");
            }
            if (trackedData.firstActiveTimestamp === 0) {
                return;
            }
            var engagementTime = getEngagementTimeSeconds(trackedData);
            var metricData = {
                average: engagementTime,
                name: "React Component Engaged Time (seconds)",
                sampleCount: 1
            };
            var additionalProperties = { "Component Name": componentName };
            reactPlugin.trackMetric(metricData, additionalProperties);
        };
    }, []);
    var trackActivity = function () {
        var trackedData = tracking.current;
        if (trackedData.firstActiveTimestamp === 0) {
            trackedData.firstActiveTimestamp = Date.now();
            trackedData.lastActiveTimestamp = trackedData.firstActiveTimestamp;
        }
        else {
            trackedData.lastActiveTimestamp = Date.now();
        }
        if (trackedData.idleStartTimestamp > 0) {
            var lastIdleTime = trackedData.lastActiveTimestamp - trackedData.idleStartTimestamp;
            trackedData.totalIdleTime += lastIdleTime;
            trackedData.idleStartTimestamp = 0;
        }
    };
    return trackActivity;
};
/* unused harmony default export */ var _unused_webpack_default_export = (useComponentTracking);
//# sourceMappingURL=useTrackMetric.js.map

/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultPrivacyLevel; });
/* harmony export (immutable) */ __webpack_exports__["c"] = validateAndBuildConfiguration;
/* harmony export (immutable) */ __webpack_exports__["b"] = serializeConfiguration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_catchUserErrors__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_display__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_experimentalFeatures__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_utils_numberUtils__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_utils_byteUtils__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_utils_objectUtils__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_utils_polyfills__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__session_sessionStore__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__transportConfiguration__ = __webpack_require__(1949);










var DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c;
    if (!initConfiguration || !initConfiguration.clientToken) {
        __WEBPACK_IMPORTED_MODULE_1__tools_display__["b" /* display */].error('Client Token is not configured, we will not send any data.');
        return;
    }
    var sessionSampleRate = (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.sampleRate;
    if (sessionSampleRate !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_4__tools_utils_numberUtils__["b" /* isPercentage */])(sessionSampleRate)) {
        __WEBPACK_IMPORTED_MODULE_1__tools_display__["b" /* display */].error('Session Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_4__tools_utils_numberUtils__["b" /* isPercentage */])(initConfiguration.telemetrySampleRate)) {
        __WEBPACK_IMPORTED_MODULE_1__tools_display__["b" /* display */].error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined &&
        !Object(__WEBPACK_IMPORTED_MODULE_4__tools_utils_numberUtils__["b" /* isPercentage */])(initConfiguration.telemetryConfigurationSampleRate)) {
        __WEBPACK_IMPORTED_MODULE_1__tools_display__["b" /* display */].error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    if (Array.isArray(initConfiguration.enableExperimentalFeatures)) {
        Object(__WEBPACK_IMPORTED_MODULE_2__tools_experimentalFeatures__["b" /* addExperimentalFeatures */])(initConfiguration.enableExperimentalFeatures.filter(function (flag) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__tools_utils_objectUtils__["c" /* objectHasValue */])(__WEBPACK_IMPORTED_MODULE_2__tools_experimentalFeatures__["a" /* ExperimentalFeature */], flag);
        }));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_7__tools_utils_polyfills__["b" /* assign */])({
        beforeSend: initConfiguration.beforeSend && Object(__WEBPACK_IMPORTED_MODULE_0__tools_catchUserErrors__["a" /* catchUserErrors */])(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: Object(__WEBPACK_IMPORTED_MODULE_8__session_sessionStore__["a" /* selectSessionStoreStrategyType */])(initConfiguration),
        sessionSampleRate: sessionSampleRate !== null && sessionSampleRate !== void 0 ? sessionSampleRate : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * __WEBPACK_IMPORTED_MODULE_5__tools_utils_byteUtils__["a" /* ONE_KIBI_BYTE */],
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: (30 * __WEBPACK_IMPORTED_MODULE_3__tools_utils_timeUtils__["c" /* ONE_SECOND */]),
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * __WEBPACK_IMPORTED_MODULE_5__tools_utils_byteUtils__["a" /* ONE_KIBI_BYTE */],
    }, Object(__WEBPACK_IMPORTED_MODULE_9__transportConfiguration__["a" /* computeTransportConfiguration */])(initConfiguration));
}
function serializeConfiguration(initConfiguration) {
    var _a, _b;
    var proxy = (_a = initConfiguration.proxy) !== null && _a !== void 0 ? _a : initConfiguration.proxyUrl;
    return {
        session_sample_rate: (_b = initConfiguration.sessionSampleRate) !== null && _b !== void 0 ? _b : initConfiguration.sampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: proxy !== undefined ? !!proxy : undefined,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        track_resources: initConfiguration.trackResources,
        track_long_task: initConfiguration.trackLongTasks,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
    };
}
//# sourceMappingURL=configuration.js.map

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = selectCookieStrategy;
/* harmony export (immutable) */ __webpack_exports__["a"] = initCookieStrategy;
/* unused harmony export buildCookieOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser_cookie__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__oldCookiesMigration__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sessionConstants__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sessionState__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sessionStoreStrategy__ = __webpack_require__(354);





function selectCookieStrategy(initConfiguration) {
    var cookieOptions = buildCookieOptions(initConfiguration);
    return Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["a" /* areCookiesAuthorized */])(cookieOptions) ? { type: 'Cookie', cookieOptions: cookieOptions } : undefined;
}
function initCookieStrategy(cookieOptions) {
    var cookieStore = {
        persistSession: persistSessionCookie(cookieOptions),
        retrieveSession: retrieveSessionCookie,
        clearSession: deleteSessionCookie(cookieOptions),
    };
    Object(__WEBPACK_IMPORTED_MODULE_1__oldCookiesMigration__["a" /* tryOldCookiesMigration */])(cookieStore);
    return cookieStore;
}
function persistSessionCookie(options) {
    return function (session) {
        Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["e" /* setCookie */])(__WEBPACK_IMPORTED_MODULE_4__sessionStoreStrategy__["a" /* SESSION_STORE_KEY */], Object(__WEBPACK_IMPORTED_MODULE_3__sessionState__["d" /* toSessionString */])(session), __WEBPACK_IMPORTED_MODULE_2__sessionConstants__["a" /* SESSION_EXPIRATION_DELAY */], options);
    };
}
function retrieveSessionCookie() {
    var sessionString = Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["c" /* getCookie */])(__WEBPACK_IMPORTED_MODULE_4__sessionStoreStrategy__["a" /* SESSION_STORE_KEY */]);
    return Object(__WEBPACK_IMPORTED_MODULE_3__sessionState__["c" /* toSessionState */])(sessionString);
}
function deleteSessionCookie(options) {
    return function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["b" /* deleteCookie */])(__WEBPACK_IMPORTED_MODULE_4__sessionStoreStrategy__["a" /* SESSION_STORE_KEY */], options);
    };
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["d" /* getCurrentSite */])();
    }
    return cookieOptions;
}
//# sourceMappingURL=sessionInCookie.js.map

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OLD_SESSION_COOKIE_NAME */
/* unused harmony export OLD_RUM_COOKIE_NAME */
/* unused harmony export OLD_LOGS_COOKIE_NAME */
/* unused harmony export RUM_SESSION_KEY */
/* unused harmony export LOGS_SESSION_KEY */
/* harmony export (immutable) */ __webpack_exports__["a"] = tryOldCookiesMigration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser_cookie__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storeStrategies_sessionStoreStrategy__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sessionState__ = __webpack_require__(355);



var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
    var sessionString = Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["c" /* getCookie */])(__WEBPACK_IMPORTED_MODULE_1__storeStrategies_sessionStoreStrategy__["a" /* SESSION_STORE_KEY */]);
    if (!sessionString) {
        var oldSessionId = Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["c" /* getCookie */])(OLD_SESSION_COOKIE_NAME);
        var oldRumType = Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["c" /* getCookie */])(OLD_RUM_COOKIE_NAME);
        var oldLogsType = Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["c" /* getCookie */])(OLD_LOGS_COOKIE_NAME);
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__sessionState__["b" /* isSessionInExpiredState */])(session)) {
            Object(__WEBPACK_IMPORTED_MODULE_2__sessionState__["a" /* expandSessionState */])(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = selectLocalStorageStrategy;
/* harmony export (immutable) */ __webpack_exports__["a"] = initLocalStorageStrategy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_utils_stringUtils__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sessionState__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sessionStoreStrategy__ = __webpack_require__(354);



var LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
    try {
        var id = Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_stringUtils__["b" /* generateUUID */])();
        var testKey = "".concat(LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? { type: 'LocalStorage' } : undefined;
    }
    catch (e) {
        return undefined;
    }
}
function initLocalStorageStrategy() {
    return {
        persistSession: persistInLocalStorage,
        retrieveSession: retrieveSessionFromLocalStorage,
        clearSession: clearSessionFromLocalStorage,
    };
}
function persistInLocalStorage(sessionState) {
    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__sessionStoreStrategy__["a" /* SESSION_STORE_KEY */], Object(__WEBPACK_IMPORTED_MODULE_1__sessionState__["d" /* toSessionString */])(sessionState));
}
function retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__sessionStoreStrategy__["a" /* SESSION_STORE_KEY */]);
    return Object(__WEBPACK_IMPORTED_MODULE_1__sessionState__["c" /* toSessionState */])(sessionString);
}
function clearSessionFromLocalStorage() {
    localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__sessionStoreStrategy__["a" /* SESSION_STORE_KEY */]);
}
//# sourceMappingURL=sessionInLocalStorage.js.map

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOCK_RETRY_DELAY */
/* unused harmony export LOCK_MAX_TRIES */
/* harmony export (immutable) */ __webpack_exports__["a"] = processSessionStoreOperations;
/* unused harmony export isLockEnabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_timer__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_utils_stringUtils__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_utils_browserDetection__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sessionState__ = __webpack_require__(355);




var LOCK_RETRY_DELAY = 10;
var LOCK_MAX_TRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    var retrieveSession = sessionStoreStrategy.retrieveSession, persistSession = sessionStoreStrategy.persistSession, clearSession = sessionStoreStrategy.clearSession;
    var lockEnabled = isLockEnabled();
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (lockEnabled && numberOfRetries >= LOCK_MAX_TRIES) {
        next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (lockEnabled) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_stringUtils__["b" /* generateUUID */])();
        currentSession.lock = currentLock;
        persistSession(currentSession);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (lockEnabled) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sessionState__["b" /* isSessionInExpiredState */])(processedSession)) {
            clearSession();
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_3__sessionState__["a" /* expandSessionState */])(processedSession);
            persistSession(processedSession);
        }
    }
    if (lockEnabled) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && Object(__WEBPACK_IMPORTED_MODULE_3__sessionState__["b" /* isSessionInExpiredState */])(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            persistSession(currentSession);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next(sessionStoreStrategy);
}
/**
 * Lock strategy allows mitigating issues due to concurrent access to cookie.
 * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
 */
var isLockEnabled = function () { return Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_browserDetection__["a" /* isChromium */])(); };
function retryLater(operations, sessionStore, currentNumberOfRetries) {
    Object(__WEBPACK_IMPORTED_MODULE_0__tools_timer__["d" /* setTimeout */])(function () {
        processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
    }, LOCK_RETRY_DELAY);
}
function next(sessionStore) {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        processSessionStoreOperations(nextOperations, sessionStore);
    }
}
//# sourceMappingURL=sessionStoreOperations.js.map

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeTransportConfiguration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_utils_polyfills__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__endpointBuilder__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tags__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intakeSites__ = __webpack_require__(498);




function computeTransportConfiguration(initConfiguration) {
    var tags = Object(__WEBPACK_IMPORTED_MODULE_2__tags__["a" /* buildTags */])(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_polyfills__["k" /* objectValues */])(endpointBuilders).map(function (builder) { return builder.urlPrefix; });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_polyfills__["b" /* assign */])({
        isIntakeUrl: function (url) { return intakeUrlPrefixes.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: initConfiguration.site || __WEBPACK_IMPORTED_MODULE_3__intakeSites__["d" /* INTAKE_SITE_US1 */],
    }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: Object(__WEBPACK_IMPORTED_MODULE_1__endpointBuilder__["a" /* createEndpointBuilder */])(initConfiguration, 'logs', tags),
        rumEndpointBuilder: Object(__WEBPACK_IMPORTED_MODULE_1__endpointBuilder__["a" /* createEndpointBuilder */])(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: Object(__WEBPACK_IMPORTED_MODULE_1__endpointBuilder__["a" /* createEndpointBuilder */])(initConfiguration, 'sessionReplay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_polyfills__["b" /* assign */])({}, initConfiguration, {
        site: __WEBPACK_IMPORTED_MODULE_3__intakeSites__["d" /* INTAKE_SITE_US1 */],
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: Object(__WEBPACK_IMPORTED_MODULE_1__endpointBuilder__["a" /* createEndpointBuilder */])(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: Object(__WEBPACK_IMPORTED_MODULE_1__endpointBuilder__["a" /* createEndpointBuilder */])(replicaConfiguration, 'rum', tags),
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_polyfills__["k" /* objectValues */])(replicaEndpointBuilders).map(function (builder) { return builder.urlPrefix; }));
    return Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_polyfills__["b" /* assign */])({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
//# sourceMappingURL=transportConfiguration.js.map

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TAG_SIZE_LIMIT */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTags;
/* unused harmony export buildTag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_display__ = __webpack_require__(109);

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        __WEBPACK_IMPORTED_MODULE_0__tools_display__["b" /* display */].warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
//# sourceMappingURL=tags.js.map

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackRuntimeError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_types__ = __webpack_require__(359);




function trackRuntimeError(errorObservable) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__tracekit__["b" /* startUnhandledErrorCollection */])(function (stackTrace, originalError) {
        errorObservable.notify(Object(__WEBPACK_IMPORTED_MODULE_2__error__["b" /* computeRawError */])({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_timeUtils__["e" /* clocksNow */])(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
            source: __WEBPACK_IMPORTED_MODULE_3__error_types__["a" /* ErrorSource */].SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        }));
    });
}
//# sourceMappingURL=trackRuntimeError.js.map

/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startUnhandledErrorCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_instrumentMethod__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeStackTrace__ = __webpack_require__(792);


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
function startUnhandledErrorCollection(callback) {
    var stopInstrumentingOnError = instrumentOnError(callback).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
/**
 * Install a global onerror handler
 */
function instrumentOnError(callback) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__tools_instrumentMethod__["b" /* instrumentMethodAndCallOriginal */])(window, 'onerror', {
        before: function (messageObj, url, line, column, errorObj) {
            var stackTrace;
            if (errorObj instanceof Error) {
                stackTrace = Object(__WEBPACK_IMPORTED_MODULE_1__computeStackTrace__["a" /* computeStackTrace */])(errorObj);
            }
            else {
                var stack = [{ url: url, column: column, line: line }];
                var _a = tryToParseMessage(messageObj), name_1 = _a.name, message = _a.message;
                stackTrace = {
                    name: name_1,
                    message: message,
                    stack: stack,
                };
            }
            callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
        },
    });
}
function tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if ({}.toString.call(messageObj) === '[object String]') {
        ;
        _a = ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    }
    return { name: name, message: message };
}
/**
 * Install a global onunhandledrejection handler
 */
function instrumentUnhandledRejection(callback) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__tools_instrumentMethod__["b" /* instrumentMethodAndCallOriginal */])(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = Object(__WEBPACK_IMPORTED_MODULE_1__computeStackTrace__["a" /* computeStackTrace */])(reason);
            callback(stack, reason);
        },
    });
}
//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = makePublicApi;
/* harmony export (immutable) */ __webpack_exports__["a"] = defineGlobal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_catchUserErrors__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_utils_polyfills__ = __webpack_require__(93);



function makePublicApi(stub) {
    var publicApi = Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_polyfills__["b" /* assign */])({
        version: "4.43.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_1__tools_monitor__["d" /* setDebugMode */];
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return Object(__WEBPACK_IMPORTED_MODULE_0__tools_catchUserErrors__["a" /* catchUserErrors */])(fn, 'onReady callback threw an error:')(); });
    }
}
//# sourceMappingURL=init.js.map

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RawReportType; });
/* harmony export (immutable) */ __webpack_exports__["b"] = initReportObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_error__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_observable__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_addEventListener__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_utils_polyfills__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_utils_stringUtils__ = __webpack_require__(219);






var RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(apis) {
    var observables = [];
    if (Object(__WEBPACK_IMPORTED_MODULE_4__tools_utils_polyfills__["i" /* includes */])(apis, RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable());
    }
    var reportTypes = apis.filter(function (api) { return api !== RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return __WEBPACK_IMPORTED_MODULE_2__tools_observable__["b" /* mergeObservables */].apply(void 0, observables);
}
function createReportObservable(reportTypes) {
    var observable = new __WEBPACK_IMPORTED_MODULE_2__tools_observable__["a" /* Observable */](function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = Object(__WEBPACK_IMPORTED_MODULE_1__tools_monitor__["c" /* monitor */])(function (reports) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable() {
    var observable = new __WEBPACK_IMPORTED_MODULE_2__tools_observable__["a" /* Observable */](function () {
        var stop = Object(__WEBPACK_IMPORTED_MODULE_3__browser_addEventListener__["a" /* addEventListener */])(document, "securitypolicyviolation" /* DOM_EVENT.SECURITY_POLICY_VIOLATION */, function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        }).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat(Object(__WEBPACK_IMPORTED_MODULE_5__tools_utils_stringUtils__["c" /* safeTruncate */])(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return (sourceFile &&
        Object(__WEBPACK_IMPORTED_MODULE_0__error_error__["e" /* toStackTraceString */])({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber,
                    column: columnNumber,
                },
            ],
        }));
}
//# sourceMappingURL=reportObservable.js.map

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = startTelemetry;
/* unused harmony export startFakeTelemetry */
/* unused harmony export resetTelemetry */
/* harmony export (immutable) */ __webpack_exports__["d"] = isTelemetryReplicationAllowed;
/* harmony export (immutable) */ __webpack_exports__["b"] = addTelemetryDebug;
/* harmony export (immutable) */ __webpack_exports__["c"] = addTelemetryError;
/* harmony export (immutable) */ __webpack_exports__["a"] = addTelemetryConfiguration;
/* unused harmony export formatError */
/* unused harmony export scrubCustomerFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_display__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_error__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_experimentalFeatures__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configuration__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracekit__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_observable__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tools_sendToExtension__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tools_utils_polyfills__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tools_utils_numberUtils__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tools_serialisation_jsonStringify__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tools_mergeInto__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rawTelemetryEvent_types__ = __webpack_require__(795);














var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [__WEBPACK_IMPORTED_MODULE_3__configuration__["e" /* INTAKE_SITE_US1_FED */]];
var telemetryConfiguration = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: false, telemetryConfigurationEnabled: false };
var onRawTelemetryEventCollected;
function startTelemetry(telemetryService, configuration) {
    var contextProvider;
    var observable = new __WEBPACK_IMPORTED_MODULE_5__tools_observable__["a" /* Observable */]();
    telemetryConfiguration.telemetryEnabled =
        !Object(__WEBPACK_IMPORTED_MODULE_9__tools_utils_polyfills__["i" /* includes */])(TELEMETRY_EXCLUDED_SITES, configuration.site) && Object(__WEBPACK_IMPORTED_MODULE_10__tools_utils_numberUtils__["c" /* performDraw */])(configuration.telemetrySampleRate);
    telemetryConfiguration.telemetryConfigurationEnabled =
        telemetryConfiguration.telemetryEnabled && Object(__WEBPACK_IMPORTED_MODULE_10__tools_utils_numberUtils__["c" /* performDraw */])(configuration.telemetryConfigurationSampleRate);
    onRawTelemetryEventCollected = function (rawEvent) {
        if (telemetryConfiguration.telemetryEnabled) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent);
            observable.notify(event_1);
            Object(__WEBPACK_IMPORTED_MODULE_8__tools_sendToExtension__["a" /* sendToExtension */])('telemetry', event_1);
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_7__tools_monitor__["e" /* startMonitorErrorCollection */])(addTelemetryError);
    Object(__WEBPACK_IMPORTED_MODULE_9__tools_utils_polyfills__["b" /* assign */])(telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0,
    });
    function toTelemetryEvent(telemetryService, event) {
        return Object(__WEBPACK_IMPORTED_MODULE_12__tools_mergeInto__["a" /* combine */])({
            type: 'telemetry',
            date: Object(__WEBPACK_IMPORTED_MODULE_6__tools_utils_timeUtils__["n" /* timeStampNow */])(),
            service: telemetryService,
            version: "4.43.0",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: event,
            experimental_features: Object(__WEBPACK_IMPORTED_MODULE_9__tools_utils_polyfills__["a" /* arrayFrom */])(Object(__WEBPACK_IMPORTED_MODULE_2__tools_experimentalFeatures__["c" /* getExperimentalFeatures */])()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryConfiguration.telemetryEnabled,
    };
}
function startFakeTelemetry() {
    var events = [];
    Object(__WEBPACK_IMPORTED_MODULE_9__tools_utils_polyfills__["b" /* assign */])(telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0,
    });
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
function resetTelemetry() {
    onRawTelemetryEventCollected = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === __WEBPACK_IMPORTED_MODULE_3__configuration__["c" /* INTAKE_SITE_STAGING */];
}
function addTelemetryDebug(message, context) {
    Object(__WEBPACK_IMPORTED_MODULE_7__tools_monitor__["b" /* displayIfDebugEnabled */])(__WEBPACK_IMPORTED_MODULE_0__tools_display__["a" /* ConsoleApiName */].debug, message, context);
    addTelemetry(Object(__WEBPACK_IMPORTED_MODULE_9__tools_utils_polyfills__["b" /* assign */])({
        type: __WEBPACK_IMPORTED_MODULE_13__rawTelemetryEvent_types__["a" /* TelemetryType */].log,
        message: message,
        status: "debug" /* StatusType.debug */,
    }, context));
}
function addTelemetryError(e) {
    addTelemetry(Object(__WEBPACK_IMPORTED_MODULE_9__tools_utils_polyfills__["b" /* assign */])({
        type: __WEBPACK_IMPORTED_MODULE_13__rawTelemetryEvent_types__["a" /* TelemetryType */].log,
        status: "error" /* StatusType.error */,
    }, formatError(e)));
}
function addTelemetryConfiguration(configuration) {
    if (telemetryConfiguration.telemetryConfigurationEnabled) {
        addTelemetry({
            type: __WEBPACK_IMPORTED_MODULE_13__rawTelemetryEvent_types__["a" /* TelemetryType */].configuration,
            configuration: configuration,
        });
    }
}
function addTelemetry(event) {
    if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
        telemetryConfiguration.sentEventCount += 1;
        onRawTelemetryEventCollected(event);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = Object(__WEBPACK_IMPORTED_MODULE_4__tracekit__["a" /* computeStackTrace */])(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: Object(__WEBPACK_IMPORTED_MODULE_1__error_error__["e" /* toStackTraceString */])(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: __WEBPACK_IMPORTED_MODULE_1__error_error__["a" /* NO_ERROR_STACK_PRESENT_MESSAGE */],
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat(Object(__WEBPACK_IMPORTED_MODULE_11__tools_serialisation_jsonStringify__["b" /* jsonStringify */])(e)),
    };
}
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return Object(__WEBPACK_IMPORTED_MODULE_9__tools_utils_polyfills__["l" /* startsWith */])(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
//# sourceMappingURL=telemetry.js.map

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
/**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */

//# sourceMappingURL=telemetryEvent.types.js.map

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VISIBILITY_CHECK_DELAY */
/* harmony export (immutable) */ __webpack_exports__["a"] = startSessionManager;
/* unused harmony export stopSessionManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_valueHistory__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_addEventListener__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_timer__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sessionConstants__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sessionStore__ = __webpack_require__(496);






var VISIBILITY_CHECK_DELAY = __WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["b" /* ONE_MINUTE */];
var SESSION_CONTEXT_TIMEOUT_DELAY = __WEBPACK_IMPORTED_MODULE_4__sessionConstants__["b" /* SESSION_TIME_OUT_DELAY */];
var stopCallbacks = [];
function startSessionManager(sessionStoreStrategyType, productKey, computeSessionState) {
    var sessionStore = Object(__WEBPACK_IMPORTED_MODULE_5__sessionStore__["b" /* startSessionStore */])(sessionStoreStrategyType, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new __WEBPACK_IMPORTED_MODULE_0__tools_valueHistory__["a" /* ValueHistory */](SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["l" /* relativeNow */])());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeActive(Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["l" /* relativeNow */])());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["f" /* clocksOrigin */])().relative);
    trackActivity(function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
        expire: sessionStore.expire,
    };
}
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
function trackActivity(expandOrRenewSession) {
    var stop = Object(__WEBPACK_IMPORTED_MODULE_2__browser_addEventListener__["b" /* addEventListeners */])(window, ["click" /* DOM_EVENT.CLICK */, "touchstart" /* DOM_EVENT.TOUCH_START */, "keydown" /* DOM_EVENT.KEY_DOWN */, "scroll" /* DOM_EVENT.SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(expandSession) {
    var expandSessionWhenVisible = function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    };
    var stop = Object(__WEBPACK_IMPORTED_MODULE_2__browser_addEventListener__["a" /* addEventListener */])(document, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = Object(__WEBPACK_IMPORTED_MODULE_3__tools_timer__["c" /* setInterval */])(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__tools_timer__["a" /* clearInterval */])(visibilityCheckInterval);
    });
}
//# sourceMappingURL=sessionManager.js.map

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpRequest__ = __webpack_require__(797);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__httpRequest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__batch__ = __webpack_require__(799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__batch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventBridge__ = __webpack_require__(1960);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__eventBridge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__eventBridge__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__startBatchWithReplica__ = __webpack_require__(1961);
/* unused harmony reexport startBatchWithReplica */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flushController__ = __webpack_require__(801);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__flushController__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MAX_ONGOING_BYTES_COUNT */
/* unused harmony export MAX_ONGOING_REQUESTS */
/* unused harmony export MAX_QUEUE_BYTES_COUNT */
/* unused harmony export MAX_BACKOFF_TIME */
/* unused harmony export INITIAL_BACKOFF_TIME */
/* harmony export (immutable) */ __webpack_exports__["b"] = sendWithRetryStrategy;
/* harmony export (immutable) */ __webpack_exports__["a"] = newRetryState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_timer__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_utils_byteUtils__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_utils_responseUtils__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_error_error_types__ = __webpack_require__(359);





var MAX_ONGOING_BYTES_COUNT = 80 * __WEBPACK_IMPORTED_MODULE_2__tools_utils_byteUtils__["a" /* ONE_KIBI_BYTE */];
var MAX_ONGOING_REQUESTS = 32;
var MAX_QUEUE_BYTES_COUNT = 3 * __WEBPACK_IMPORTED_MODULE_2__tools_utils_byteUtils__["b" /* ONE_MEBI_BYTE */];
var MAX_BACKOFF_TIME = __WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["b" /* ONE_MINUTE */];
var INITIAL_BACKOFF_TIME = __WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["c" /* ONE_SECOND */];
function sendWithRetryStrategy(payload, state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, {
            onSuccess: function () { return retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, endpointType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
function scheduleRetry(state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__tools_timer__["d" /* setTimeout */])(function () {
        var payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, endpointType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, endpointType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(endpointType, " events size queued for upload: ").concat(MAX_QUEUE_BYTES_COUNT / __WEBPACK_IMPORTED_MODULE_2__tools_utils_byteUtils__["b" /* ONE_MEBI_BYTE */], "MiB"),
            source: __WEBPACK_IMPORTED_MODULE_4__domain_error_error_types__["a" /* ErrorSource */].AGENT,
            startClocks: Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["e" /* clocksNow */])(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, endpointType, reportError);
    }
}
function shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            Object(__WEBPACK_IMPORTED_MODULE_3__tools_utils_responseUtils__["a" /* isServerError */])(response.status)));
}
function newRetryState() {
    return {
        transportStatus: 0 /* TransportStatus.UP */,
        currentBackoffTime: INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
function newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}
//# sourceMappingURL=sendWithRetryStrategy.js.map

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getEventBridge;
/* harmony export (immutable) */ __webpack_exports__["a"] = canUseEventBridge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_utils_polyfills__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_getGlobalObject__ = __webpack_require__(352);


function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = Object(__WEBPACK_IMPORTED_MODULE_1__tools_getGlobalObject__["a" /* getGlobalObject */])().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || Object(__WEBPACK_IMPORTED_MODULE_0__tools_utils_polyfills__["e" /* endsWith */])(currentHost, ".".concat(allowedHost)); }));
}
function getEventBridgeGlobal() {
    return Object(__WEBPACK_IMPORTED_MODULE_1__tools_getGlobalObject__["a" /* getGlobalObject */])().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export startBatchWithReplica */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__httpRequest__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flushController__ = __webpack_require__(801);



function startBatchWithReplica(configuration, endpoint, reportError, pageExitObservable, sessionExpireObservable, replicaEndpoint) {
    var primaryBatch = createBatch(endpoint);
    var replicaBatch;
    if (replicaEndpoint) {
        replicaBatch = createBatch(replicaEndpoint);
    }
    function createBatch(endpointBuilder) {
        return new __WEBPACK_IMPORTED_MODULE_0__batch__["a" /* Batch */](Object(__WEBPACK_IMPORTED_MODULE_1__httpRequest__["a" /* createHttpRequest */])(endpointBuilder, configuration.batchBytesLimit, reportError), Object(__WEBPACK_IMPORTED_MODULE_2__flushController__["a" /* createFlushController */])({
            messagesLimit: configuration.batchMessagesLimit,
            bytesLimit: configuration.batchBytesLimit,
            durationLimit: configuration.flushTimeout,
            pageExitObservable: pageExitObservable,
            sessionExpireObservable: sessionExpireObservable,
        }), configuration.messageBytesLimit);
    }
    return {
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(message);
            }
        },
    };
}
//# sourceMappingURL=startBatchWithReplica.js.map

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDuplicates */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills__ = __webpack_require__(93);

function removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return Object(__WEBPACK_IMPORTED_MODULE_0__polyfills__["a" /* arrayFrom */])(set);
}
//# sourceMappingURL=arrayUtils.js.map

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractLifeCycle; });
var AbstractLifeCycle = /** @class */ (function () {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return AbstractLifeCycle;
}());

//# sourceMappingURL=abstractLifeCycle.js.map

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEventRateLimiter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_timer__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_error_types__ = __webpack_require__(359);



function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                Object(__WEBPACK_IMPORTED_MODULE_0__tools_timer__["d" /* setTimeout */])(function () {
                    eventCount = 0;
                }, __WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["b" /* ONE_MINUTE */]);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: __WEBPACK_IMPORTED_MODULE_2__error_error_types__["a" /* ErrorSource */].AGENT,
                        startClocks: Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_timeUtils__["e" /* clocksNow */])(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runOnReadyState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addEventListener__ = __webpack_require__(220);

function runOnReadyState(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* DOM_EVENT.LOAD */ : "DOMContentLoaded" /* DOM_EVENT.DOM_CONTENT_LOADED */;
        Object(__WEBPACK_IMPORTED_MODULE_0__addEventListener__["a" /* addEventListener */])(window, eventName, callback, { once: true });
    }
}
//# sourceMappingURL=runOnReadyState.js.map

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initXhrObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_instrumentMethod__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_observable__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_utils_urlPolyfill__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_utils_objectUtils__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addEventListener__ = __webpack_require__(220);






var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable() {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable();
    }
    return xhrObservable;
}
function createXhrObservable() {
    var observable = new __WEBPACK_IMPORTED_MODULE_1__tools_observable__["a" /* Observable */](function () {
        var stopInstrumentingStart = Object(__WEBPACK_IMPORTED_MODULE_0__tools_instrumentMethod__["b" /* instrumentMethodAndCallOriginal */])(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = Object(__WEBPACK_IMPORTED_MODULE_0__tools_instrumentMethod__["b" /* instrumentMethodAndCallOriginal */])(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, observable);
            },
        }).stop;
        var stopInstrumentingAbort = Object(__WEBPACK_IMPORTED_MODULE_0__tools_instrumentMethod__["b" /* instrumentMethodAndCallOriginal */])(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method,
        url: Object(__WEBPACK_IMPORTED_MODULE_3__tools_utils_urlPolyfill__["e" /* normalizeUrl */])(String(url)),
    });
}
function sendXhr(observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startTime = Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__["l" /* relativeNow */])();
    startContext.startClocks = Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__["e" /* clocksNow */])();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = Object(__WEBPACK_IMPORTED_MODULE_0__tools_instrumentMethod__["b" /* instrumentMethodAndCallOriginal */])(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during a onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = function () {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__["i" /* elapsed */])(startContext.startClocks.timeStamp, Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_timeUtils__["n" /* timeStampNow */])());
        completeContext.status = _this.status;
        observable.notify(Object(__WEBPACK_IMPORTED_MODULE_4__tools_utils_objectUtils__["d" /* shallowClone */])(completeContext));
    };
    var unsubscribeLoadEndListener = Object(__WEBPACK_IMPORTED_MODULE_5__addEventListener__["a" /* addEventListener */])(this, 'loadend', onEnd).stop;
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initFetchObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_instrumentMethod__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_observable__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_utils_timeUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_utils_urlPolyfill__ = __webpack_require__(356);





var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function createFetchObservable() {
    var observable = new __WEBPACK_IMPORTED_MODULE_2__tools_observable__["a" /* Observable */](function () {
        if (!window.fetch) {
            return;
        }
        var stop = Object(__WEBPACK_IMPORTED_MODULE_0__tools_instrumentMethod__["a" /* instrumentMethod */])(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = Object(__WEBPACK_IMPORTED_MODULE_1__tools_monitor__["a" /* callMonitored */])(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    Object(__WEBPACK_IMPORTED_MODULE_1__tools_monitor__["a" /* callMonitored */])(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (input instanceof Request && input.method) || 'GET';
    var url = input instanceof Request ? input.url : Object(__WEBPACK_IMPORTED_MODULE_4__tools_utils_urlPolyfill__["e" /* normalizeUrl */])(String(input));
    var startClocks = Object(__WEBPACK_IMPORTED_MODULE_3__tools_utils_timeUtils__["e" /* clocksNow */])();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'resolve';
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then(Object(__WEBPACK_IMPORTED_MODULE_1__tools_monitor__["c" /* monitor */])(reportFetch), Object(__WEBPACK_IMPORTED_MODULE_1__tools_monitor__["c" /* monitor */])(reportFetch));
}
//# sourceMappingURL=fetchObservable.js.map

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initConsoleObservable;
/* unused harmony export resetConsoleObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracekit__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_error__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_observable__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_display__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_serialisation_sanitize__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_utils_polyfills__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_serialisation_jsonStringify__ = __webpack_require__(186);








var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return __WEBPACK_IMPORTED_MODULE_2__tools_observable__["b" /* mergeObservables */].apply(void 0, consoleObservables);
}
function resetConsoleObservable() {
    consoleObservablesByApi = {};
}
function createConsoleObservable(api) {
    var observable = new __WEBPACK_IMPORTED_MODULE_2__tools_observable__["a" /* Observable */](function () {
        var originalConsoleApi = __WEBPACK_IMPORTED_MODULE_3__tools_display__["c" /* globalConsole */][api];
        __WEBPACK_IMPORTED_MODULE_3__tools_display__["c" /* globalConsole */][api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = Object(__WEBPACK_IMPORTED_MODULE_1__error_error__["c" /* createHandlingStack */])();
            Object(__WEBPACK_IMPORTED_MODULE_4__tools_monitor__["a" /* callMonitored */])(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            __WEBPACK_IMPORTED_MODULE_3__tools_display__["c" /* globalConsole */][api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    // Todo: remove console error prefix in the next major version
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    var fingerprint;
    if (api === __WEBPACK_IMPORTED_MODULE_3__tools_display__["a" /* ConsoleApiName */].error) {
        var firstErrorParam = Object(__WEBPACK_IMPORTED_MODULE_6__tools_utils_polyfills__["f" /* find */])(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? Object(__WEBPACK_IMPORTED_MODULE_1__error_error__["e" /* toStackTraceString */])(Object(__WEBPACK_IMPORTED_MODULE_0__tracekit__["a" /* computeStackTrace */])(firstErrorParam)) : undefined;
        fingerprint = Object(__WEBPACK_IMPORTED_MODULE_1__error_error__["f" /* tryToGetFingerprint */])(firstErrorParam);
        message = "console error: ".concat(message);
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
        fingerprint: fingerprint,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return Object(__WEBPACK_IMPORTED_MODULE_5__tools_serialisation_sanitize__["a" /* sanitize */])(param);
    }
    if (param instanceof Error) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__error_error__["d" /* formatErrorMessage */])(Object(__WEBPACK_IMPORTED_MODULE_0__tracekit__["a" /* computeStackTrace */])(param));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_7__tools_serialisation_jsonStringify__["b" /* jsonStringify */])(Object(__WEBPACK_IMPORTED_MODULE_5__tools_serialisation_sanitize__["a" /* sanitize */])(param), undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoundedBuffer; });
var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());

//# sourceMappingURL=boundedBuffer.js.map

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BYTES_COMPUTATION_THROTTLING_DELAY */
/* harmony export (immutable) */ __webpack_exports__["a"] = createContextManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_byteUtils__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_functionUtils__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mergeInto__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsonStringify__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sanitize__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__heavyCustomerDataWarning__ = __webpack_require__(802);






var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function createContextManager(customerDataType, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = __WEBPACK_IMPORTED_MODULE_0__utils_byteUtils__["c" /* computeBytesCount */]; }
    var context = {};
    var bytesCountCache;
    var alreadyWarned = false;
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var computeBytesCountThrottled = Object(__WEBPACK_IMPORTED_MODULE_1__utils_functionUtils__["b" /* throttle */])(function (context) {
        bytesCountCache = computeBytesCountImpl(Object(__WEBPACK_IMPORTED_MODULE_3__jsonStringify__["b" /* jsonStringify */])(context));
        if (!alreadyWarned) {
            alreadyWarned = Object(__WEBPACK_IMPORTED_MODULE_5__heavyCustomerDataWarning__["a" /* warnIfCustomerDataLimitReached */])(bytesCountCache, customerDataType);
        }
    }, BYTES_COMPUTATION_THROTTLING_DELAY).throttled;
    return {
        getBytesCount: function () { return bytesCountCache; },
        /** @deprecated use getContext instead */
        get: function () { return context; },
        /** @deprecated use setContextProperty instead */
        add: function (key, value) {
            context[key] = value;
            computeBytesCountThrottled(context);
        },
        /** @deprecated renamed to removeContextProperty */
        remove: function (key) {
            delete context[key];
            computeBytesCountThrottled(context);
        },
        /** @deprecated use setContext instead */
        set: function (newContext) {
            context = newContext;
            computeBytesCountThrottled(context);
        },
        getContext: function () { return Object(__WEBPACK_IMPORTED_MODULE_2__mergeInto__["b" /* deepClone */])(context); },
        setContext: function (newContext) {
            context = Object(__WEBPACK_IMPORTED_MODULE_4__sanitize__["a" /* sanitize */])(newContext);
            computeBytesCountThrottled(context);
        },
        setContextProperty: function (key, property) {
            context[key] = Object(__WEBPACK_IMPORTED_MODULE_4__sanitize__["a" /* sanitize */])(property);
            computeBytesCountThrottled(context);
        },
        removeContextProperty: function (key) {
            delete context[key];
            computeBytesCountThrottled(context);
        },
        clearContext: function () {
            context = {};
            bytesCountCache = 0;
        },
    };
}
//# sourceMappingURL=contextManager.js.map

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = readBytesFromStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__monitor__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_functionUtils__ = __webpack_require__(185);


/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then(Object(__WEBPACK_IMPORTED_MODULE_0__monitor__["c" /* monitor */])(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) {
                chunks.push(result.value);
            }
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_0__monitor__["c" /* monitor */])(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        __WEBPACK_IMPORTED_MODULE_1__utils_functionUtils__["a" /* noop */]);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
//# sourceMappingURL=readBytesFromStream.js.map

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SYNTHETICS_TEST_ID_COOKIE_NAME */
/* unused harmony export SYNTHETICS_RESULT_ID_COOKIE_NAME */
/* unused harmony export SYNTHETICS_INJECTS_RUM_COOKIE_NAME */
/* harmony export (immutable) */ __webpack_exports__["c"] = willSyntheticsInjectRum;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSyntheticsTestId;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSyntheticsResultId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser_cookie__ = __webpack_require__(353);

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["c" /* getCookie */])(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["c" /* getCookie */])(SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || Object(__WEBPACK_IMPORTED_MODULE_0__browser_cookie__["c" /* getCookie */])(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=syntheticsWorkerValues.js.map

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_types__ = __webpack_require__(1974);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user__ = __webpack_require__(1975);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__user__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__user__["b"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=user.types.js.map

/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sanitizeUser;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_display__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_utils_typeUtils__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_utils_polyfills__ = __webpack_require__(93);



/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = Object(__WEBPACK_IMPORTED_MODULE_2__tools_utils_polyfills__["b" /* assign */])({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_1__tools_utils_typeUtils__["a" /* getType */])(newUser) === 'object';
    if (!isValid) {
        __WEBPACK_IMPORTED_MODULE_0__tools_display__["b" /* display */].error('Unsupported user:', newUser);
    }
    return isValid;
}
//# sourceMappingURL=user.js.map

/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=resourceUtils.js.map

/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatchOption;
/* harmony export (immutable) */ __webpack_exports__["b"] = matchList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_polyfills__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__display__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_typeUtils__ = __webpack_require__(360);



function isMatchOption(item) {
    var itemType = Object(__WEBPACK_IMPORTED_MODULE_2__utils_typeUtils__["a" /* getType */])(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
    if (useStartsWith === void 0) { useStartsWith = false; }
    return list.some(function (item) {
        try {
            if (typeof item === 'function') {
                return item(value);
            }
            else if (item instanceof RegExp) {
                return item.test(value);
            }
            else if (typeof item === 'string') {
                return useStartsWith ? Object(__WEBPACK_IMPORTED_MODULE_0__utils_polyfills__["l" /* startsWith */])(value, item) : item === value;
            }
        }
        catch (e) {
            __WEBPACK_IMPORTED_MODULE_1__display__["b" /* display */].error(e);
        }
        return false;
    });
}
//# sourceMappingURL=matchOption.js.map

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRumPublicApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_configuration__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_contexts_commonContext__ = __webpack_require__(805);



function makeRumPublicApi(startRumImpl, recorderApi, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ignoreInitIfSyntheticsWillInjectRum, ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c;
    var isAlreadyInitialized = false;
    var globalContextManager = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["L" /* createContextManager */])("global context" /* CustomerDataType.GlobalContext */);
    var userContextManager = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["L" /* createContextManager */])("user" /* CustomerDataType.User */);
    var getInternalContextStrategy = function () { return undefined; };
    var getInitConfigurationStrategy = function () { return undefined; };
    var stopSessionStrategy = __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */];
    var getSessionReplayLinkStrategy = function () { return undefined; };
    var bufferApiCalls = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["c" /* BoundedBuffer */]();
    var addTimingStrategy = function (name, time) {
        if (time === void 0) { time = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])(); }
        bufferApiCalls.add(function () { return addTimingStrategy(name, time); });
    };
    var startViewStrategy = function (options, startClocks) {
        if (startClocks === void 0) { startClocks = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["F" /* clocksNow */])(); }
        bufferApiCalls.add(function () { return startViewStrategy(options, startClocks); });
    };
    var addActionStrategy = function (action, commonContext) {
        if (commonContext === void 0) { commonContext = Object(__WEBPACK_IMPORTED_MODULE_2__domain_contexts_commonContext__["a" /* buildCommonContext */])(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addActionStrategy(action, commonContext); });
    };
    var addErrorStrategy = function (providedError, commonContext) {
        if (commonContext === void 0) { commonContext = Object(__WEBPACK_IMPORTED_MODULE_2__domain_contexts_commonContext__["a" /* buildCommonContext */])(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addErrorStrategy(providedError, commonContext); });
    };
    var addFeatureFlagEvaluationStrategy = function (key, value) {
        bufferApiCalls.add(function () { return addFeatureFlagEvaluationStrategy(key, value); });
    };
    function initRum(initConfiguration) {
        // This function should be available, regardless of initialization success.
        getInitConfigurationStrategy = function () { return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["U" /* deepClone */])(initConfiguration); };
        // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
        // completely discard the customer application RUM instance by ignoring their init() call.  But,
        // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
        // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
        if (ignoreInitIfSyntheticsWillInjectRum && Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_62" /* willSyntheticsInjectRum */])()) {
            return;
        }
        var eventBridgeAvailable = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["B" /* canUseEventBridge */])();
        if (eventBridgeAvailable) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        if (!canInitRum(initConfiguration)) {
            return;
        }
        var configuration = Object(__WEBPACK_IMPORTED_MODULE_1__domain_configuration__["b" /* validateAndBuildRumConfiguration */])(initConfiguration);
        if (!configuration) {
            return;
        }
        if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
            __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].warn('No storage available for session. We will not send any data.');
            return;
        }
        if (!configuration.trackViewsManually) {
            doStartRum(initConfiguration, configuration);
        }
        else {
            // drain beforeInitCalls by buffering them until we start RUM
            // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
            // in order to ensure that calls are processed in order
            var beforeInitCalls = bufferApiCalls;
            bufferApiCalls = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["c" /* BoundedBuffer */]();
            startViewStrategy = function (options) {
                doStartRum(initConfiguration, configuration, options);
            };
            beforeInitCalls.drain();
        }
        isAlreadyInitialized = true;
    }
    function doStartRum(initConfiguration, configuration, initialViewOptions) {
        var startRumResults = startRumImpl(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions);
        getSessionReplayLinkStrategy = function () {
            return recorderApi.getSessionReplayLink(configuration, startRumResults.session, startRumResults.viewContexts);
        };
        (startViewStrategy = startRumResults.startView, addActionStrategy = startRumResults.addAction, addErrorStrategy = startRumResults.addError, addTimingStrategy = startRumResults.addTiming, addFeatureFlagEvaluationStrategy = startRumResults.addFeatureFlagEvaluation, getInternalContextStrategy = startRumResults.getInternalContext, stopSessionStrategy = startRumResults.stopSession);
        bufferApiCalls.drain();
        recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.viewContexts);
    }
    var startView = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        startViewStrategy(sanitizedOptions);
    });
    var rumPublicApi = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_31" /* makePublicApi */])({
        init: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(initRum),
        /** @deprecated: use setGlobalContextProperty instead */
        addRumGlobalContext: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(globalContextManager.add),
        setGlobalContextProperty: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(globalContextManager.setContextProperty),
        /** @deprecated: use removeGlobalContextProperty instead */
        removeRumGlobalContext: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(globalContextManager.remove),
        removeGlobalContextProperty: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(globalContextManager.removeContextProperty),
        /** @deprecated: use getGlobalContext instead */
        getRumGlobalContext: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(globalContextManager.get),
        getGlobalContext: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(globalContextManager.getContext),
        /** @deprecated: use setGlobalContext instead */
        setRumGlobalContext: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(globalContextManager.set),
        setGlobalContext: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(globalContextManager.setContext),
        clearGlobalContext: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(globalContextManager.clearContext),
        getInternalContext: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function (startTime) { return getInternalContextStrategy(startTime); }),
        getInitConfiguration: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function () { return getInitConfigurationStrategy(); }),
        addAction: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function (name, context) {
            addActionStrategy({
                name: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_45" /* sanitize */])(name),
                context: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_45" /* sanitize */])(context),
                startClocks: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["F" /* clocksNow */])(),
                type: "custom" /* ActionType.CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["O" /* createHandlingStack */])();
            Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["A" /* callMonitored */])(function () {
                addErrorStrategy({
                    error: error,
                    handlingStack: handlingStack,
                    context: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_45" /* sanitize */])(context),
                    startClocks: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["F" /* clocksNow */])(),
                });
            });
        },
        addTiming: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function (name, time) {
            addTimingStrategy(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_45" /* sanitize */])(name), time);
        }),
        setUser: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function (newUser) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["C" /* checkUser */])(newUser)) {
                userContextManager.setContext(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_46" /* sanitizeUser */])(newUser));
            }
        }),
        getUser: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(userContextManager.getContext),
        setUserProperty: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function (key, property) {
            var _a;
            var sanitizedProperty = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_46" /* sanitizeUser */])((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(userContextManager.removeContextProperty),
        /** @deprecated: renamed to clearUser */
        removeUser: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(userContextManager.clearContext),
        clearUser: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(userContextManager.clearContext),
        startView: startView,
        stopSession: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function () {
            stopSessionStrategy();
        }),
        startSessionReplayRecording: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(recorderApi.start),
        stopSessionReplayRecording: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(recorderApi.stop),
        /**
         * This feature is currently in beta. For more information see the full [feature flag tracking guide](https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/).
         */
        addFeatureFlagEvaluation: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function (key, value) {
            addFeatureFlagEvaluationStrategy(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_45" /* sanitize */])(key), Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_45" /* sanitize */])(value));
        }),
        getSessionReplayLink: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(function () { return getSessionReplayLinkStrategy(); }),
    });
    return rumPublicApi;
    function canInitRum(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('DD_RUM is already initialized.');
            }
            return false;
        }
        return true;
    }
    function overrideInitConfigurationForBridge(initConfiguration) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({}, initConfiguration, {
            applicationId: '00000000-aaaa-0000-aaaa-000000000000',
            clientToken: 'empty',
            sessionSampleRate: 100,
        });
    }
}
//# sourceMappingURL=rumPublicApi.js.map

/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startRum;
/* unused harmony export startRumEventCollection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_domMutationObservable__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_performanceCollection__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_assembly__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_contexts_foregroundContexts__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__domain_contexts_internalContext__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_lifeCycle__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_contexts_viewContexts__ = __webpack_require__(1988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_requestCollection__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_rumEventsCollection_action_actionCollection__ = __webpack_require__(1990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_rumEventsCollection_error_errorCollection__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__domain_rumEventsCollection_longTask_longTaskCollection__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__domain_rumEventsCollection_resource_resourceCollection__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__domain_rumEventsCollection_view_viewCollection__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__domain_rumSessionManager__ = __webpack_require__(2007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__transport_startRumBatch__ = __webpack_require__(2008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__transport_startRumEventBridge__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__domain_contexts_urlContexts__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__browser_locationChangeObservable__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__domain_configuration__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__domain_contexts_featureFlagContext__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__domain_startCustomerDataTelemetry__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__domain_contexts_pageStateHistory__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__domain_contexts_commonContext__ = __webpack_require__(805);
























function startRum(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions) {
    var lifeCycle = new __WEBPACK_IMPORTED_MODULE_6__domain_lifeCycle__["a" /* LifeCycle */]();
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) { return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_47" /* sendToExtension */])('rum', event); });
    var telemetry = startRumTelemetry(configuration);
    telemetry.setContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    var reportError = function (error) {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
    };
    var featureFlagContexts = Object(__WEBPACK_IMPORTED_MODULE_20__domain_contexts_featureFlagContext__["a" /* startFeatureFlagContexts */])(lifeCycle);
    var pageExitObservable = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["Q" /* createPageExitObservable */])();
    pageExitObservable.subscribe(function (event) {
        lifeCycle.notify(9 /* LifeCycleEventType.PAGE_EXITED */, event);
    });
    var session = !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["B" /* canUseEventBridge */])() ? Object(__WEBPACK_IMPORTED_MODULE_14__domain_rumSessionManager__["a" /* startRumSessionManager */])(configuration, lifeCycle) : Object(__WEBPACK_IMPORTED_MODULE_14__domain_rumSessionManager__["b" /* startRumSessionManagerStub */])();
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["B" /* canUseEventBridge */])()) {
        var batch = Object(__WEBPACK_IMPORTED_MODULE_15__transport_startRumBatch__["a" /* startRumBatch */])(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable);
        Object(__WEBPACK_IMPORTED_MODULE_21__domain_startCustomerDataTelemetry__["a" /* startCustomerDataTelemetry */])(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batch.flushObservable);
    }
    else {
        Object(__WEBPACK_IMPORTED_MODULE_16__transport_startRumEventBridge__["a" /* startRumEventBridge */])(lifeCycle);
    }
    var domMutationObservable = Object(__WEBPACK_IMPORTED_MODULE_1__browser_domMutationObservable__["a" /* createDOMMutationObservable */])();
    var locationChangeObservable = Object(__WEBPACK_IMPORTED_MODULE_18__browser_locationChangeObservable__["a" /* createLocationChangeObservable */])(location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, function () { return Object(__WEBPACK_IMPORTED_MODULE_23__domain_contexts_commonContext__["a" /* buildCommonContext */])(globalContextManager, userContextManager, recorderApi); }, reportError), viewContexts = _a.viewContexts, foregroundContexts = _a.foregroundContexts, pageStateHistory = _a.pageStateHistory, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction;
    Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["u" /* addTelemetryConfiguration */])(Object(__WEBPACK_IMPORTED_MODULE_19__domain_configuration__["a" /* serializeRumConfiguration */])(initConfiguration));
    Object(__WEBPACK_IMPORTED_MODULE_11__domain_rumEventsCollection_longTask_longTaskCollection__["a" /* startLongTaskCollection */])(lifeCycle, session);
    Object(__WEBPACK_IMPORTED_MODULE_12__domain_rumEventsCollection_resource_resourceCollection__["a" /* startResourceCollection */])(lifeCycle, configuration, session, pageStateHistory);
    var _b = Object(__WEBPACK_IMPORTED_MODULE_13__domain_rumEventsCollection_view_viewCollection__["a" /* startViewCollection */])(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView;
    var addError = Object(__WEBPACK_IMPORTED_MODULE_10__domain_rumEventsCollection_error_errorCollection__["a" /* startErrorCollection */])(lifeCycle, foregroundContexts, featureFlagContexts).addError;
    Object(__WEBPACK_IMPORTED_MODULE_8__domain_requestCollection__["a" /* startRequestCollection */])(lifeCycle, configuration, session);
    Object(__WEBPACK_IMPORTED_MODULE_2__browser_performanceCollection__["a" /* startPerformanceCollection */])(lifeCycle, configuration);
    var internalContext = Object(__WEBPACK_IMPORTED_MODULE_5__domain_contexts_internalContext__["a" /* startInternalContext */])(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        stopSession: function () { return session.expire(); },
        getInternalContext: internalContext.get,
    };
}
function startRumTelemetry(configuration) {
    var telemetry = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_53" /* startTelemetry */])("browser-rum-sdk" /* TelemetryService.RUM */, configuration);
    if (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["B" /* canUseEventBridge */])()) {
        var bridge_1 = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_4" /* getEventBridge */])();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, buildCommonContext, reportError) {
    var viewContexts = Object(__WEBPACK_IMPORTED_MODULE_7__domain_contexts_viewContexts__["a" /* startViewContexts */])(lifeCycle);
    var urlContexts = Object(__WEBPACK_IMPORTED_MODULE_17__domain_contexts_urlContexts__["a" /* startUrlContexts */])(lifeCycle, locationChangeObservable, location);
    var foregroundContexts = Object(__WEBPACK_IMPORTED_MODULE_4__domain_contexts_foregroundContexts__["a" /* startForegroundContexts */])();
    var pageStateHistory = Object(__WEBPACK_IMPORTED_MODULE_22__domain_contexts_pageStateHistory__["a" /* startPageStateHistory */])();
    var _a = Object(__WEBPACK_IMPORTED_MODULE_9__domain_rumEventsCollection_action_actionCollection__["a" /* startActionCollection */])(lifeCycle, domMutationObservable, configuration, foregroundContexts), addAction = _a.addAction, actionContexts = _a.actionContexts;
    Object(__WEBPACK_IMPORTED_MODULE_3__domain_assembly__["a" /* startRumAssembly */])(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, buildCommonContext, reportError);
    return {
        viewContexts: viewContexts,
        foregroundContexts: foregroundContexts,
        pageStateHistory: pageStateHistory,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            viewContexts.stop();
            foregroundContexts.stop();
        },
    };
}
//# sourceMappingURL=startRum.js.map

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD */
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocumentTraceId;
/* unused harmony export getDocumentTraceDataFromMeta */
/* unused harmony export getDocumentTraceDataFromComment */
/* unused harmony export createDocumentTraceData */
/* unused harmony export findTraceComment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_htmlDomUtils__ = __webpack_require__(808);


var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["k" /* ONE_MINUTE */];
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["T" /* dateNow */])() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_0" /* findCommaSeparatedValue */])(comment, 'trace-id'), Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_0" /* findCommaSeparatedValue */])(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__browser_htmlDomUtils__["g" /* isTextNode */])(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && Object(__WEBPACK_IMPORTED_MODULE_1__browser_htmlDomUtils__["c" /* isCommentNode */])(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
//# sourceMappingURL=getDocumentTraceId.js.map

/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startRumAssembly;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contexts_syntheticsContext__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contexts_ciTestContext__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contexts_displayContext__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__limitModification__ = __webpack_require__(1985);





var VIEW_MODIFIABLE_FIELD_PATHS = {
    'view.url': 'string',
    'view.referrer': 'string',
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: 'object',
};
var modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, buildCommonContext, reportError) {
    var _a, _b;
    modifiableFieldPathsByEvent = (_a = {},
        _a["view" /* RumEventType.VIEW */] = VIEW_MODIFIABLE_FIELD_PATHS,
        _a["error" /* RumEventType.ERROR */] = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
            'error.message': 'string',
            'error.stack': 'string',
            'error.resource.url': 'string',
            'error.fingerprint': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["resource" /* RumEventType.RESOURCE */] = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
            'resource.url': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["action" /* RumEventType.ACTION */] = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
            'action.target.name': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["long_task" /* RumEventType.LONG_TASK */] = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a);
    var eventRateLimiters = (_b = {},
        _b["error" /* RumEventType.ERROR */] = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["M" /* createEventRateLimiter */])("error" /* RumEventType.ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _b["action" /* RumEventType.ACTION */] = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["M" /* createEventRateLimiter */])("action" /* RumEventType.ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _b);
    var syntheticsContext = Object(__WEBPACK_IMPORTED_MODULE_1__contexts_syntheticsContext__["a" /* getSyntheticsContext */])();
    var ciTestContext = Object(__WEBPACK_IMPORTED_MODULE_2__contexts_ciTestContext__["a" /* getCiTestContext */])();
    lifeCycle.subscribe(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        var session = sessionManager.findTrackedSession(startTime);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || buildCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["S" /* currentDrift */])(),
                    session: {
                        plan: session.plan,
                    },
                    browser_sdk_version: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["B" /* canUseEventBridge */])() ? "4.43.0" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])(),
                service: viewContext.service || configuration.service,
                version: viewContext.version || configuration.version,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */ : ciTestContext ? "ci_test" /* SessionType.CI_TEST */ : "user" /* SessionType.USER */,
                },
                view: {
                    id: viewContext.id,
                    name: viewContext.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer,
                },
                action: needToAssembleWithAction(rawRumEvent) && actionId ? { id: actionId } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
                display: Object(__WEBPACK_IMPORTED_MODULE_3__contexts_displayContext__["a" /* getDisplayContext */])(),
            };
            var serverRumEvent = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["H" /* combine */])(rumContext, rawRumEvent);
            serverRumEvent.context = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["H" /* combine */])(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_20" /* isEmptyObject */])(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_20" /* isEmptyObject */])(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = Object(__WEBPACK_IMPORTED_MODULE_4__limitModification__["a" /* limitModification */])(event, modifiableFieldPathsByEvent[event.type], function (event) {
            return beforeSend(event, domainContext);
        });
        if (result === false && event.type !== "view" /* RumEventType.VIEW */) {
            return false;
        }
        if (result === false) {
            __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* RumEventType.ERROR */, "resource" /* RumEventType.RESOURCE */, "long_task" /* RumEventType.LONG_TASK */].indexOf(event.type) !== -1;
}
//# sourceMappingURL=assembly.js.map

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSyntheticsContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function getSyntheticsContext() {
    var testId = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_10" /* getSyntheticsTestId */])();
    var resultId = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_9" /* getSyntheticsResultId */])();
    if (testId && resultId) {
        return {
            test_id: testId,
            result_id: resultId,
            injected: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_62" /* willSyntheticsInjectRum */])(),
        };
    }
}
//# sourceMappingURL=syntheticsContext.js.map

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCiTestContext;
function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}
//# sourceMappingURL=ciTestContext.js.map

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDisplayContext;
/* unused harmony export resetDisplayContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser_viewportObservable__ = __webpack_require__(809);

var viewport;
var stopListeners;
function getDisplayContext() {
    if (!viewport) {
        viewport = Object(__WEBPACK_IMPORTED_MODULE_0__browser_viewportObservable__["a" /* getViewportDimension */])();
        stopListeners = Object(__WEBPACK_IMPORTED_MODULE_0__browser_viewportObservable__["b" /* initViewportObservable */])().subscribe(function (viewportDimension) {
            viewport = viewportDimension;
        }).unsubscribe;
    }
    return {
        viewport: viewport,
    };
}
function resetDisplayContext() {
    if (stopListeners) {
        stopListeners();
    }
    viewport = undefined;
}
//# sourceMappingURL=displayContext.js.map

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = limitModification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["U" /* deepClone */])(object);
    var result = modifier(clone);
    Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_36" /* objectEntries */])(modifiableFieldPaths).forEach(function (_a) {
        var fieldPath = _a[0], fieldType = _a[1];
        var newValue = get(clone, fieldPath);
        var newType = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_11" /* getType */])(newValue);
        if (newType === fieldType) {
            set(object, fieldPath, Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_45" /* sanitize */])(newValue));
        }
        else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, fieldPath, {});
        }
    });
    return result;
}
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObject(current)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObject(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_11" /* getType */])(object) === 'object';
}
function isValidObjectContaining(object, field) {
    return isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}
//# sourceMappingURL=limitModification.js.map

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS */
/* unused harmony export MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS */
/* harmony export (immutable) */ __webpack_exports__["a"] = startForegroundContexts;
/* unused harmony export addNewForegroundPeriod */
/* unused harmony export closeForegroundPeriod */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

// Arbitrary value to cap number of element mostly for backend & to save bandwidth
var MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS = 500;
// Arbitrary value to cap number of element mostly for memory consumption in the browser
var MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS = 2500;
var foregroundPeriods = [];
function startForegroundContexts() {
    if (document.hasFocus()) {
        addNewForegroundPeriod();
    }
    var stopForegroundTracking = trackFocus(addNewForegroundPeriod).stop;
    var stopBlurTracking = trackBlur(closeForegroundPeriod).stop;
    return {
        isInForegroundAt: isInForegroundAt,
        selectInForegroundPeriodsFor: selectInForegroundPeriodsFor,
        stop: function () {
            foregroundPeriods = [];
            stopForegroundTracking();
            stopBlurTracking();
        },
    };
}
function addNewForegroundPeriod() {
    if (foregroundPeriods.length > MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_40" /* relativeNow */])();
    if (currentForegroundPeriod !== undefined && currentForegroundPeriod.end === undefined) {
        return;
    }
    foregroundPeriods.push({
        start: now,
    });
}
function closeForegroundPeriod() {
    if (foregroundPeriods.length === 0) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_40" /* relativeNow */])();
    if (currentForegroundPeriod.end !== undefined) {
        return;
    }
    currentForegroundPeriod.end = now;
}
function trackFocus(onFocusChange) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(window, "focus" /* DOM_EVENT.FOCUS */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onFocusChange();
    });
}
function trackBlur(onBlurChange) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(window, "blur" /* DOM_EVENT.BLUR */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onBlurChange();
    });
}
function isInForegroundAt(startTime) {
    for (var i = foregroundPeriods.length - 1; i >= 0; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && startTime > foregroundPeriod.end) {
            break;
        }
        if (startTime > foregroundPeriod.start &&
            (foregroundPeriod.end === undefined || startTime < foregroundPeriod.end)) {
            return true;
        }
    }
    return false;
}
function selectInForegroundPeriodsFor(eventStartTime, duration) {
    var eventEndTime = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["r" /* addDuration */])(eventStartTime, duration);
    var filteredForegroundPeriods = [];
    var earliestIndex = Math.max(0, foregroundPeriods.length - MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS);
    for (var i = foregroundPeriods.length - 1; i >= earliestIndex; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && eventStartTime > foregroundPeriod.end) {
            // event starts after the end of the current focus period
            // since the array is sorted, we can stop looking for foreground periods
            break;
        }
        if (eventEndTime < foregroundPeriod.start) {
            // event ends before the start of the current focus period
            // continue to previous one
            continue;
        }
        var startTime = eventStartTime > foregroundPeriod.start ? eventStartTime : foregroundPeriod.start;
        var startDuration = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(eventStartTime, startTime);
        var endTime = foregroundPeriod.end === undefined || eventEndTime < foregroundPeriod.end ? eventEndTime : foregroundPeriod.end;
        var endDuration = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(startTime, endTime);
        filteredForegroundPeriods.unshift({
            start: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(startDuration),
            duration: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(endDuration),
        });
    }
    return filteredForegroundPeriods;
}
//# sourceMappingURL=foregroundContexts.js.map

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startInternalContext;
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: { id: viewContext.id, name: viewContext.name, referrer: urlContext.referrer, url: urlContext.url },
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map

/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VIEW_CONTEXT_TIME_OUT_DELAY */
/* harmony export (immutable) */ __webpack_exports__["a"] = startViewContexts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var VIEW_CONTEXT_TIME_OUT_DELAY = __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["p" /* SESSION_TIME_OUT_DELAY */];
function startViewContexts(lifeCycle) {
    var viewContextHistory = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["q" /* ValueHistory */](VIEW_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks,
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
//# sourceMappingURL=viewContexts.js.map

/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startRequestCollection;
/* unused harmony export trackXhr */
/* unused harmony export trackFetch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rumEventsCollection_resource_resourceUtils__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracing_tracer__ = __webpack_require__(804);



var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = Object(__WEBPACK_IMPORTED_MODULE_2__tracing_tracer__["b" /* startTracer */])(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_17" /* initXhrObservable */])().subscribe(function (rawContext) {
        var context = rawContext;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__rumEventsCollection_resource_resourceUtils__["f" /* isAllowedRequestUrl */])(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* RequestType.XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_15" /* initFetchObservable */])().subscribe(function (rawContext) {
        var context = rawContext;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__rumEventsCollection_resource_resourceUtils__["f" /* isAllowedRequestUrl */])(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'resolve':
                waitForResponseToComplete(context, function (duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(6 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* RequestType.FETCH */,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                    });
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
function waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_59" /* tryToClone */])(context.response);
    if (!clonedResponse || !clonedResponse.body) {
        // do not try to wait for the response if the clone failed, fetch error or null body
        callback(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(context.startClocks.timeStamp, Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])()));
    }
    else {
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_39" /* readBytesFromStream */])(clonedResponse.body, function () {
            callback(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(context.startClocks.timeStamp, Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])()));
        }, {
            bytesLimit: Number.POSITIVE_INFINITY,
            collectStreamBody: false,
        });
    }
}
//# sourceMappingURL=requestCollection.js.map

/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startActionCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trackClickActions__ = __webpack_require__(1991);


function startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts) {
    lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action, foregroundContexts));
    });
    var actionContexts = { findActionId: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */] };
    if (configuration.trackUserInteractions) {
        actionContexts = Object(__WEBPACK_IMPORTED_MODULE_1__trackClickActions__["a" /* trackClickActions */])(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
                savedCommonContext: savedCommonContext,
            }, processAction(action, foregroundContexts)));
        },
        actionContexts: actionContexts,
    };
}
function processAction(action, foregroundContexts) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(action.duration),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
            _dd: {
                action: {
                    target: action.target,
                    position: action.position,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["H" /* combine */])({
        action: {
            id: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_3" /* generateUUID */])(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* RumEventType.ACTION */,
    }, autoActionProperties);
    var inForeground = foregroundContexts.isInForegroundAt(action.startClocks.relative);
    if (inForeground !== undefined) {
        actionEvent.view = { in_foreground: inForeground };
    }
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { event: action.event, events: action.events } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* ActionType.CUSTOM */;
}
//# sourceMappingURL=actionCollection.js.map

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLICK_ACTION_MAX_DURATION */
/* unused harmony export ACTION_CONTEXT_TIME_OUT_DELAY */
/* harmony export (immutable) */ __webpack_exports__["a"] = trackClickActions;
/* unused harmony export finalizeClicks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trackEventCounts__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__waitPageActivityEnd__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clickChain__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getActionNameFromElement__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getSelectorFromElement__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__listenActionEvents__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__computeFrustration__ = __webpack_require__(1994);








// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["l" /* ONE_SECOND */];
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["k" /* ONE_MINUTE */]; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
    var history = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["q" /* ValueHistory */](ACTION_CONTEXT_TIME_OUT_DELAY);
    var stopObservable = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["m" /* Observable */]();
    var currentClickChain;
    lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        history.reset();
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
    var stopActionEventsListener = Object(__WEBPACK_IMPORTED_MODULE_6__listenActionEvents__["a" /* listenActionEvents */])({
        onPointerDown: function (pointerDownEvent) {
            return processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent);
        },
        onPointerUp: function (_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            return startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        },
    }).stop;
    var actionContexts = {
        findActionId: function (startTime) {
            return configuration.trackFrustrations ? history.findAll(startTime) : history.find(startTime);
        },
    };
    return {
        stop: function () {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts,
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = Object(__WEBPACK_IMPORTED_MODULE_3__clickChain__["a" /* createClickChain */])(click, function (clicks) {
                finalizeClicks(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) {
            currentClickChain.stop();
        }
    }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent) {
    if (!configuration.trackFrustrations && history.find()) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any new
        // action if another one is already occurring.
        return;
    }
    var clickActionBase = computeClickActionBase(pointerDownEvent, configuration.actionNameAttribute);
    if (!configuration.trackFrustrations && !clickActionBase.name) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any action
        // with a blank name
        return;
    }
    var hadActivityOnPointerDown = false;
    Object(__WEBPACK_IMPORTED_MODULE_2__waitPageActivityEnd__["b" /* waitPageActivityEnd */])(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    __WEBPACK_IMPORTED_MODULE_2__waitPageActivityEnd__["a" /* PAGE_ACTIVITY_VALIDATION_DELAY */]);
    return { clickActionBase: clickActionBase, hadActivityOnPointerDown: function () { return hadActivityOnPointerDown; } };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    if (configuration.trackFrustrations) {
        appendClickToClickChain(click);
    }
    var stopWaitPageActivityEnd = Object(__WEBPACK_IMPORTED_MODULE_2__waitPageActivityEnd__["b" /* waitPageActivityEnd */])(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
            // If the clock is looking weird, just discard the click
            click.discard();
        }
        else {
            if (pageActivityEndEvent.hadActivity) {
                click.stop(pageActivityEndEvent.end);
            }
            else if (hadActivityOnPointerDown()) {
                click.stop(
                // using the click start as activity end, so the click will have some activity but its
                // duration will be 0 (as the activity started before the click start)
                click.startClocks.timeStamp);
            }
            else {
                click.stop();
            }
            // Validate or discard the click only if we don't track frustrations. It'll be done when
            // the click chain is finalized.
            if (!configuration.trackFrustrations) {
                if (!pageActivityEndEvent.hadActivity) {
                    // If we are not tracking frustrations, we should discard the click to keep backward
                    // compatibility.
                    click.discard();
                }
                else {
                    click.validate();
                }
            }
        }
    }, CLICK_ACTION_MAX_DURATION).stop;
    var viewEndedSubscription = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function () {
        click.stop();
    });
    click.stopObservable.subscribe(function () {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function computeClickActionBase(event, actionNameAttribute) {
    var rect = event.target.getBoundingClientRect();
    return {
        type: "click" /* ActionType.CLICK */,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: Object(__WEBPACK_IMPORTED_MODULE_5__getSelectorFromElement__["b" /* getSelectorFromElement */])(event.target, actionNameAttribute),
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top),
        },
        name: Object(__WEBPACK_IMPORTED_MODULE_4__getActionNameFromElement__["b" /* getActionNameFromElement */])(event.target, actionNameAttribute),
    };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_3" /* generateUUID */])();
    var startClocks = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["F" /* clocksNow */])();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = Object(__WEBPACK_IMPORTED_MODULE_1__trackEventCounts__["a" /* trackEventCounts */])({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) {
            return event.action !== undefined &&
                (Array.isArray(event.action.id) ? Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_13" /* includes */])(event.action.id, id) : event.action.id === id);
        },
    });
    var status = 0 /* ClickStatus.ONGOING */;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["m" /* Observable */]();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */) {
            return;
        }
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */;
        if (activityEndTime) {
            historyEntry.close(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_8" /* getRelativeTime */])(activityEndTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError() {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity() {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function (frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function () { return status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */; },
        clone: function () { return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent); },
        validate: function (domEvents) {
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */) {
                return;
            }
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
                type: "click" /* ActionType.CLICK */,
                duration: activityEndTime && Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount,
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
                event: startEvent,
            }, clickActionBase);
            lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
            status = 2 /* ClickStatus.FINALIZED */;
        },
        discard: function () {
            stop();
            status = 2 /* ClickStatus.FINALIZED */;
        },
    };
}
function finalizeClicks(clicks, rageClick) {
    var isRage = Object(__WEBPACK_IMPORTED_MODULE_7__computeFrustration__["a" /* computeFrustration */])(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function (click) { return click.discard(); });
        rageClick.stop(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])());
        rageClick.validate(clicks.map(function (click) { return click.event; }));
    }
    else {
        rageClick.discard();
        clicks.forEach(function (click) { return click.validate(); });
    }
}
//# sourceMappingURL=trackClickActions.js.map

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MAX_DURATION_BETWEEN_CLICKS */
/* unused harmony export MAX_DISTANCE_BETWEEN_CLICKS */
/* harmony export (immutable) */ __webpack_exports__["a"] = createClickChain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var MAX_DURATION_BETWEEN_CLICKS = __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["l" /* ONE_SECOND */];
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
    var maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["E" /* clearTimeout */])(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_50" /* setTimeout */])(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every(function (click) { return click.isStopped(); })) {
            status = 2 /* ClickChainStatus.Finalized */;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["E" /* clearTimeout */])(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: function (click) {
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function () {
            dontAcceptMoreClick();
        },
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
//# sourceMappingURL=clickChain.js.map

/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listenActionEvents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function listenActionEvents(_a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
    };
    var clickContext;
    var listeners = [
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(window, "pointerdown" /* DOM_EVENT.POINTER_DOWN */, function (event) {
            if (isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(window, "selectionchange" /* DOM_EVENT.SELECTION_CHANGE */, function () {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(window, "pointerup" /* DOM_EVENT.POINTER_UP */, function (event) {
            if (isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function () { return localUserActivity_1; });
                clickContext = undefined;
            }
        }, { capture: true }),
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(window, "input" /* DOM_EVENT.INPUT */, function () {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: function () {
            listeners.forEach(function (listener) { return listener.stop(); });
        },
    };
}
function isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        event.isPrimary !== false);
}
//# sourceMappingURL=listenActionEvents.js.map

/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeFrustration;
/* unused harmony export isRage */
/* unused harmony export isDead */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
    if (isRage(clicks)) {
        rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */);
        if (clicks.some(isDead)) {
            rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
        if (rageClick.hasError) {
            rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        return { isRage: true };
    }
    var hasSelectionChanged = clicks.some(function (click) { return click.getUserActivity().selection; });
    clicks.forEach(function (click) {
        if (click.hasError) {
            click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        if (isDead(click) &&
            // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
            !hasSelectionChanged) {
            click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
    });
    return { isRage: false };
}
function isRage(clicks) {
    if (clicks.some(function (click) { return click.getUserActivity().selection; })) {
        return false;
    }
    for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["l" /* ONE_SECOND */]) {
            return true;
        }
    }
    return false;
}
var DEAD_CLICK_EXCLUDE_SELECTOR = 
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' +
    'textarea,' +
    'select,' +
    // contenteditable and their descendants don't always trigger meaningful changes when manipulated
    '[contenteditable],' +
    '[contenteditable] *,' +
    // canvas, as there is no good way to detect activity occurring on them
    'canvas,' +
    // links that are interactive (have an href attribute) or any of their descendants, as they can
    // open a new tab or navigate to a hash without triggering a meaningful event
    'a[href],' +
    'a[href] *';
function isDead(click) {
    if (click.hasPageActivity || click.getUserActivity().input) {
        return false;
    }
    return !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["Y" /* elementMatches */])(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}
//# sourceMappingURL=computeFrustration.js.map

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startErrorCollection;
/* unused harmony export doStartErrorCollection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trackConsoleError__ = __webpack_require__(1996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trackReportError__ = __webpack_require__(1997);



function startErrorCollection(lifeCycle, foregroundContexts, featureFlagContexts) {
    var errorObservable = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["m" /* Observable */]();
    Object(__WEBPACK_IMPORTED_MODULE_1__trackConsoleError__["a" /* trackConsoleError */])(errorObservable);
    Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_58" /* trackRuntimeError */])(errorObservable);
    Object(__WEBPACK_IMPORTED_MODULE_2__trackReportError__["a" /* trackReportError */])(errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, foregroundContexts, featureFlagContexts);
}
function doStartErrorCollection(lifeCycle, foregroundContexts, featureFlagContexts) {
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, foregroundContexts, featureFlagContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = error instanceof Error ? Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["K" /* computeStackTrace */])(error) : undefined;
            var rawError = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["J" /* computeRawError */])({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["f" /* ErrorSource */].CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */,
            });
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function processError(error, foregroundContexts, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_3" /* generateUUID */])(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
        },
        type: "error" /* RumEventType.ERROR */,
    };
    var inForeground = foregroundContexts.isInForegroundAt(error.startClocks.relative);
    if (inForeground) {
        rawRumEvent.view = { in_foreground: inForeground };
    }
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_20" /* isEmptyObject */])(featureFlagContext)) {
        rawRumEvent.feature_flags = featureFlagContext;
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}
//# sourceMappingURL=errorCollection.js.map

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackConsoleError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function trackConsoleError(errorObservable) {
    var subscription = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_14" /* initConsoleObservable */])([__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["d" /* ConsoleApiName */].error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["F" /* clocksNow */])(),
            message: consoleError.message,
            stack: consoleError.stack,
            fingerprint: consoleError.fingerprint,
            source: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["f" /* ErrorSource */].CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackReportError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function trackReportError(errorObservable) {
    var subscription = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_16" /* initReportObservable */])([__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["o" /* RawReportType */].cspViolation, __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["o" /* RawReportType */].intervention]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["F" /* clocksNow */])(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["f" /* ErrorSource */].REPORT,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map

/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startLongTaskCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function startLongTaskCollection(lifeCycle, sessionManager) {
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== 'longtask') {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || !session.longTaskAllowed) {
                break;
            }
            var startClocks = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_41" /* relativeToClocks */])(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_3" /* generateUUID */])(),
                    duration: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(entry.duration),
                },
                type: "long_task" /* RumEventType.LONG_TASK */,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry.toJSON() },
            });
        }
    });
}
//# sourceMappingURL=longTaskCollection.js.map

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startResourceCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchRequestTiming__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resourceUtils__ = __webpack_require__(361);



function startResourceCollection(lifeCycle, configuration, sessionManager, pageStateHistory) {
    lifeCycle.subscribe(6 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
        lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processRequest(request, configuration, sessionManager, pageStateHistory));
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'resource' && !Object(__WEBPACK_IMPORTED_MODULE_2__resourceUtils__["g" /* isRequestKind */])(entry)) {
                lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processResourceEntry(entry, configuration, sessionManager, pageStateHistory));
            }
        }
    });
}
function processRequest(request, configuration, sessionManager, pageStateHistory) {
    var _a;
    var type = request.type === "xhr" /* RequestType.XHR */ ? "xhr" /* ResourceType.XHR */ : "fetch" /* ResourceType.FETCH */;
    var matchingTiming = Object(__WEBPACK_IMPORTED_MODULE_1__matchRequestTiming__["a" /* matchRequestTiming */])(request);
    var startClocks = matchingTiming ? Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_41" /* relativeToClocks */])(matchingTiming.startTime) : request.startClocks;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var tracingInfo = computeRequestTracingInfo(request, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var duration = computeRequestDuration(pageStateHistory, startClocks, request.duration);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, (_a = matchingTiming === null || matchingTiming === void 0 ? void 0 : matchingTiming.duration) !== null && _a !== void 0 ? _a : request.duration);
    var resourceEvent = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["H" /* combine */])({
        date: startClocks.timeStamp,
        resource: {
            id: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_3" /* generateUUID */])(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RumEventType.RESOURCE */,
    }, tracingInfo, correspondingTimingOverrides, indexingInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming && toPerformanceEntryRepresentation(matchingTiming),
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry, configuration, sessionManager, pageStateHistory) {
    var type = Object(__WEBPACK_IMPORTED_MODULE_2__resourceUtils__["d" /* computeResourceKind */])(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var startClocks = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_41" /* relativeToClocks */])(entry.startTime);
    var tracingInfo = computeEntryTracingInfo(entry, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, entry.duration);
    var resourceEvent = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["H" /* combine */])({
        date: startClocks.timeStamp,
        resource: {
            id: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_3" /* generateUUID */])(),
            type: type,
            url: entry.name,
        },
        type: "resource" /* RumEventType.RESOURCE */,
    }, tracingInfo, entryMetrics, indexingInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: toPerformanceEntryRepresentation(entry),
        },
    };
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
            duration: Object(__WEBPACK_IMPORTED_MODULE_2__resourceUtils__["c" /* computePerformanceResourceDuration */])(timing),
            size: Object(__WEBPACK_IMPORTED_MODULE_2__resourceUtils__["e" /* computeSize */])(timing),
        }, Object(__WEBPACK_IMPORTED_MODULE_2__resourceUtils__["b" /* computePerformanceResourceDetails */])(timing)),
    };
}
function computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            trace_id: entry.traceId,
            rule_psr: getRulePsr(configuration),
        },
    };
}
// TODO next major: use directly PerformanceEntry type in domain context
function toPerformanceEntryRepresentation(entry) {
    return entry;
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_24" /* isNumber */])(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computeIndexingInfo(sessionManager, resourceStart) {
    var session = sessionManager.findTrackedSession(resourceStart.relative);
    return {
        _dd: {
            discarded: !session || !session.resourceAllowed,
        },
    };
}
function computePageStateInfo(pageStateHistory, startClocks, duration) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_21" /* isExperimentalFeatureEnabled */])(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["g" /* ExperimentalFeature */].RESOURCE_PAGE_STATES)) {
        return;
    }
    return {
        _dd: {
            page_states: pageStateHistory.findAll(startClocks.relative, duration),
            page_was_discarded: String(document.wasDiscarded),
        },
    };
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
    var _a;
    // TODO remove FF in next major
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_21" /* isExperimentalFeatureEnabled */])(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["g" /* ExperimentalFeature */].NO_RESOURCE_DURATION_FROZEN_STATE)) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(duration);
    }
    var requestCrossedFrozenState = (_a = pageStateHistory
        .findAll(startClocks.relative, duration)) === null || _a === void 0 ? void 0 : _a.some(function (pageState) { return pageState.state === "frozen" /* PageState.FROZEN */; });
    return !requestCrossedFrozenState ? Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(duration) : undefined;
}
//# sourceMappingURL=resourceCollection.js.map

/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRequestTiming;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resourceUtils__ = __webpack_require__(361);


/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(__WEBPACK_IMPORTED_MODULE_1__resourceUtils__["h" /* toValidEntry */])
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    return;
}
function endTime(timing) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["r" /* addDuration */])(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && endTime(timing) <= Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["r" /* addDuration */])(end, errorMargin);
}
//# sourceMappingURL=matchRequestTiming.js.map

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startViewCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trackViews__ = __webpack_require__(2002);


function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, foregroundContexts, featureFlagContexts, recorderApi, pageStateHistory));
    });
    var trackViewResult = Object(__WEBPACK_IMPORTED_MODULE_1__trackViews__["a" /* trackViews */])(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
    return trackViewResult;
}
function processViewUpdate(view, foregroundContexts, featureFlagContexts, recorderApi, pageStateHistory) {
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var pageStatesEnabled = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_21" /* isExperimentalFeatureEnabled */])(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["g" /* ExperimentalFeature */].PAGE_STATES);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            page_states: pageStatesEnabled ? pageStateHistory.findAll(view.startClocks.relative, view.duration) : undefined,
        },
        date: view.startClocks.timeStamp,
        type: "view" /* RumEventType.VIEW */,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: view.cumulativeLayoutShift,
            first_byte: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.timings.firstByte),
            dom_complete: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.timings.domComplete),
            dom_content_loaded: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.timings.domContentLoaded),
            dom_interactive: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.timings.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.timings.firstContentfulPaint),
            first_input_delay: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.timings.firstInputDelay),
            first_input_time: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.timings.firstInputTime),
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.timings.largestContentfulPaint),
            load_event: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.timings.loadEvent),
            loading_time: discardNegativeDuration(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(view.duration),
            in_foreground_periods: !pageStatesEnabled
                ? foregroundContexts.selectInForegroundPeriodsFor(view.startClocks.relative, view.duration)
                : undefined,
        },
        feature_flags: featureFlagContext && !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_20" /* isEmptyObject */])(featureFlagContext) ? featureFlagContext : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
            is_active: view.sessionIsActive ? undefined : false,
        },
    };
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_20" /* isEmptyObject */])(view.customTimings)) {
        viewEvent.view.custom_timings = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_32" /* mapValues */])(view.customTimings, __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */]);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_24" /* isNumber */])(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=viewCollection.js.map

/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export THROTTLE_VIEW_UPDATE_PERIOD */
/* unused harmony export SESSION_KEEP_ALIVE_INTERVAL */
/* harmony export (immutable) */ __webpack_exports__["a"] = trackViews;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trackInitialViewTimings__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trackViewMetrics__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trackViewEventCounts__ = __webpack_require__(2006);




var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["k" /* ONE_MINUTE */];
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */, Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["G" /* clocksOrigin */])(), initialViewOptions);
    startViewLifeCycle();
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        return newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
            // Renew view on session renewal
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        lifeCycle.subscribe(7 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
            currentView.end({ sessionIsActive: false });
        });
        // End the current view on page unload
        lifeCycle.subscribe(9 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
            if (pageExitEvent.reason === __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["n" /* PageExitReason */].UNLOADING || pageExitEvent.reason === __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["n" /* PageExitReason */].PAGEHIDE) {
                currentView.end();
            }
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */);
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])(); }
            currentView.addTiming(name, time);
        },
        startView: function (options, startClocks) {
            currentView.end({ endClocks: startClocks });
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, startClocks, options);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            currentView.end();
        },
    };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["F" /* clocksNow */])(); }
    // Setup initial values
    var id = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_3" /* generateUUID */])();
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_51" /* shallowClone */])(initialLocation);
    var sessionIsActive = true;
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    lifeCycle.notify(2 /* LifeCycleEventType.VIEW_CREATED */, {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
    });
    // Update the view every time the measures are changing
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_55" /* throttle */])(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_2__trackViewMetrics__["a" /* trackViewMetrics */])(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, stopViewMetricsTracking = _b.stop, viewMetrics = _b.viewMetrics;
    var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */
        ? Object(__WEBPACK_IMPORTED_MODULE_1__trackInitialViewTimings__["a" /* trackInitialViewTimings */])(lifeCycle, setLoadEvent, scheduleViewUpdate)
        : { scheduleStop: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */], timings: {} }, scheduleStopInitialViewTimingsTracking = _c.scheduleStop, timings = _c.timings;
    var _d = Object(__WEBPACK_IMPORTED_MODULE_3__trackViewEventCounts__["a" /* trackViewEventCounts */])(lifeCycle, id, scheduleViewUpdate), scheduleStopEventCountsTracking = _d.scheduleStop, eventCounts = _d.eventCounts;
    // Session keep alive
    var keepAliveIntervalId = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_49" /* setInterval */])(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])() : endClocks.timeStamp;
        lifeCycle.notify(3 /* LifeCycleEventType.VIEW_UPDATED */, Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            timings: timings,
            duration: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts,
        }, viewMetrics));
    }
    return {
        name: name,
        service: service,
        version: version,
        end: function (options) {
            var _a, _b;
            if (options === void 0) { options = {}; }
            if (endClocks) {
                // view already ended
                return;
            }
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["F" /* clocksNow */])();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(4 /* LifeCycleEventType.VIEW_ENDED */, { endClocks: endClocks });
            Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["D" /* clearInterval */])(keepAliveIntervalId);
            stopViewMetricsTracking();
            scheduleStopInitialViewTimingsTracking();
            scheduleStopEventCountsTracking();
            triggerViewUpdate();
        },
        addTiming: function (name, time) {
            if (endClocks) {
                return;
            }
            var relativeTime = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_30" /* looksLikeRelativeTime */])(time) ? time : Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substr(1);
    return !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map

/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TIMING_MAXIMUM_DELAY */
/* unused harmony export KEEP_TRACKING_TIMINGS_AFTER_VIEW_DELAY */
/* harmony export (immutable) */ __webpack_exports__["a"] = trackInitialViewTimings;
/* unused harmony export trackNavigationTimings */
/* unused harmony export trackFirstContentfulPaintTiming */
/* unused harmony export trackLargestContentfulPaintTiming */
/* unused harmony export trackFirstInputTimings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trackFirstHidden__ = __webpack_require__(2004);


// Discard LCP and FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var TIMING_MAXIMUM_DELAY = 10 * __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["k" /* ONE_MINUTE */];
/**
 * The initial view can finish quickly, before some metrics can be produced (ex: before the page load
 * event, or the first input). Also, we don't want to trigger a view update indefinitely, to avoid
 * updates on views that ended a long time ago. Keep watching for metrics after the view ends for a
 * limited amount of time.
 */
var KEEP_TRACKING_TIMINGS_AFTER_VIEW_DELAY = 5 * __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["k" /* ONE_MINUTE */];
function trackInitialViewTimings(lifeCycle, setLoadEvent, scheduleViewUpdate) {
    var timings = {};
    function setTimings(newTimings) {
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])(timings, newTimings);
        scheduleViewUpdate();
    }
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, function (newTimings) {
        setLoadEvent(newTimings.loadEvent);
        setTimings(newTimings);
    }).stop;
    var stopFCPTracking = trackFirstContentfulPaintTiming(lifeCycle, function (firstContentfulPaint) {
        return setTimings({ firstContentfulPaint: firstContentfulPaint });
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaintTiming(lifeCycle, window, function (largestContentfulPaint) {
        setTimings({
            largestContentfulPaint: largestContentfulPaint,
        });
    }).stop;
    var stopFIDTracking = trackFirstInputTimings(lifeCycle, function (_a) {
        var firstInputDelay = _a.firstInputDelay, firstInputTime = _a.firstInputTime;
        setTimings({
            firstInputDelay: firstInputDelay,
            firstInputTime: firstInputTime,
        });
    }).stop;
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
    }
    return {
        stop: stop,
        timings: timings,
        scheduleStop: function () {
            Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_50" /* setTimeout */])(stop, KEEP_TRACKING_TIMINGS_AFTER_VIEW_DELAY);
        },
    };
}
function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'navigation') {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                    // In some cases the value reported is negative or is larger
                    // than the current page time. Ignore these cases:
                    // https://github.com/GoogleChrome/web-vitals/issues/137
                    // https://github.com/GoogleChrome/web-vitals/issues/162
                    firstByte: entry.responseStart >= 0 && entry.responseStart <= Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_40" /* relativeNow */])() ? entry.responseStart : undefined,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
function trackFirstContentfulPaintTiming(lifeCycle, callback) {
    var firstHidden = Object(__WEBPACK_IMPORTED_MODULE_1__trackFirstHidden__["a" /* trackFirstHidden */])();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["Z" /* find */])(entries, function (entry) {
            return entry.entryType === 'paint' &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return { stop: stop };
}
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getLCP.ts
 */
function trackLargestContentfulPaintTiming(lifeCycle, eventTarget, callback) {
    var firstHidden = Object(__WEBPACK_IMPORTED_MODULE_1__trackFirstHidden__["a" /* trackFirstHidden */])();
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(eventTarget, ["pointerdown" /* DOM_EVENT.POINTER_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_1" /* findLast */])(entries, function (entry) {
            return entry.entryType === 'largest-contentful-paint' &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (lcpEntry) {
            callback(lcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInputTimings(lifeCycle, callback) {
    var firstHidden = Object(__WEBPACK_IMPORTED_MODULE_1__trackFirstHidden__["a" /* trackFirstHidden */])();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["Z" /* find */])(entries, function (entry) {
            return entry.entryType === 'first-input' && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(firstInputEntry.startTime, firstInputEntry.processingStart);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                firstInputDelay: firstInputDelay >= 0 ? firstInputDelay : 0,
                firstInputTime: firstInputEntry.startTime,
            });
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
//# sourceMappingURL=trackInitialViewTimings.js.map

/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackFirstHidden;
/* unused harmony export resetFirstHidden */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var trackFirstHiddenSingleton;
var stopListeners;
function trackFirstHidden(eventTarget) {
    if (eventTarget === void 0) { eventTarget = window; }
    if (!trackFirstHiddenSingleton) {
        if (document.visibilityState === 'hidden') {
            trackFirstHiddenSingleton = {
                timeStamp: 0,
            };
        }
        else {
            trackFirstHiddenSingleton = {
                timeStamp: Infinity,
            };
            (stopListeners = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(eventTarget, ["pagehide" /* DOM_EVENT.PAGE_HIDE */, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */], function (event) {
                if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
                    trackFirstHiddenSingleton.timeStamp = event.timeStamp;
                    stopListeners();
                }
            }, { capture: true }).stop);
        }
    }
    return trackFirstHiddenSingleton;
}
function resetFirstHidden() {
    if (stopListeners) {
        stopListeners();
    }
    trackFirstHiddenSingleton = undefined;
}
//# sourceMappingURL=trackFirstHidden.js.map

/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackViewMetrics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_performanceCollection__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__waitPageActivityEnd__ = __webpack_require__(812);



function trackViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var viewMetrics = {};
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
        viewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopCLSTracking;
    if (isLayoutShiftSupported()) {
        viewMetrics.cumulativeLayoutShift = 0;
        (stopCLSTracking = trackCumulativeLayoutShift(lifeCycle, function (cumulativeLayoutShift) {
            viewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
            scheduleViewUpdate();
        }).stop);
    }
    else {
        stopCLSTracking = __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */];
    }
    return {
        stop: function () {
            stopLoadingTimeTracking();
            stopCLSTracking();
        },
        setLoadEvent: setLoadEvent,
        viewMetrics: viewMetrics,
    };
}
function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = Object(__WEBPACK_IMPORTED_MODULE_2__waitPageActivityEnd__["b" /* waitPageActivityEnd */])(lifeCycle, domMutationObservable, configuration, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(lifeCycle, callback) {
    var maxClsValue = 0;
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    callback(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_42" /* round */])(maxClsValue, 4));
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    return {
        update: function (entry) {
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["l" /* ONE_SECOND */] ||
                entry.startTime - startTime >= 5 * __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["l" /* ONE_SECOND */];
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
        },
        value: function () { return value; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return Object(__WEBPACK_IMPORTED_MODULE_1__browser_performanceCollection__["b" /* supportPerformanceTimingEvent */])('layout-shift');
}
//# sourceMappingURL=trackViewMetrics.js.map

/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KEEP_TRACKING_EVENT_COUNTS_AFTER_VIEW_DELAY */
/* harmony export (immutable) */ __webpack_exports__["a"] = trackViewEventCounts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trackEventCounts__ = __webpack_require__(811);


// Some events are not being counted as they transcend views. To reduce the occurrence;
// an arbitrary delay is added for stopping event counting after the view ends.
//
// Ideally, we would not stop and keep counting events until the end of the session.
// But this might have a small performance impact if there are many many views:
// we would need to go through each event to see if the related view matches.
// So let's have a fairly short delay to avoid impacting performances too much.
//
// In the future, we could have views stored in a data structure similar to ContextHistory. Whenever
// a child event is collected, we could look into this history to find the matching view and
// increase the associated and increase its counter. Having a centralized data structure for it
// would allow us to look for views more efficiently.
//
// For now, having a small cleanup delay will already improve the situation in most cases.
var KEEP_TRACKING_EVENT_COUNTS_AFTER_VIEW_DELAY = 5 * __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["k" /* ONE_MINUTE */];
function trackViewEventCounts(lifeCycle, viewId, onChange) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__trackEventCounts__["a" /* trackEventCounts */])({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) { return event.view.id === viewId; },
        onChange: onChange,
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        scheduleStop: function () {
            Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_50" /* setTimeout */])(stop, KEEP_TRACKING_EVENT_COUNTS_AFTER_VIEW_DELAY);
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackViewEventCounts.js.map

/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RUM_SESSION_KEY */
/* harmony export (immutable) */ __webpack_exports__["a"] = startRumSessionManager;
/* harmony export (immutable) */ __webpack_exports__["b"] = startRumSessionManagerStub;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle) {
    var sessionManager = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_52" /* startSessionManager */])(
    // TODO - Improve configuration type and remove assertion
    configuration.sessionStoreStrategyType, RUM_SESSION_KEY, function (rawTrackingType) { return computeSessionState(configuration, rawTrackingType); });
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(7 /* LifeCycleEventType.SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(8 /* LifeCycleEventType.SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            var plan = session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */
                ? 2 /* RumSessionPlan.WITH_SESSION_REPLAY */
                : 1 /* RumSessionPlan.WITHOUT_SESSION_REPLAY */;
            return {
                id: session.id,
                plan: plan,
                sessionReplayAllowed: plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
                longTaskAllowed: configuration.trackLongTasks !== undefined
                    ? configuration.trackLongTasks
                    : configuration.oldPlansBehavior && plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
                resourceAllowed: configuration.trackResources !== undefined
                    ? configuration.trackResources
                    : configuration.oldPlansBehavior && plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
    };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        plan: 1 /* RumSessionPlan.WITHOUT_SESSION_REPLAY */,
        sessionReplayAllowed: false,
        longTaskAllowed: true,
        resourceAllowed: true,
    };
    return {
        findTrackedSession: function () { return session; },
        expire: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */],
        expireObservable: new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["m" /* Observable */](),
    };
}
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_38" /* performDraw */])(configuration.sessionSampleRate)) {
        trackingType = "0" /* RumTrackingType.NOT_TRACKED */;
    }
    else if (!Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_38" /* performDraw */])(configuration.sessionReplaySampleRate)) {
        trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
    }
    else {
        trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* RumTrackingType.NOT_TRACKED */ ||
        trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ||
        trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */);
}
function isTypeTracked(rumSessionType) {
    return (rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ||
        rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */);
}
//# sourceMappingURL=rumSessionManager.js.map

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startRumBatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable) {
    var batch = makeRumBatch(configuration, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* RumEventType.VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event, Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_27" /* isTelemetryReplicationAllowed */])(configuration)); });
    return batch;
}
function makeRumBatch(configuration, reportError, pageExitObservable, sessionExpireObservable) {
    var _a = createRumBatch(configuration.rumEndpointBuilder), primaryBatch = _a.batch, primaryFlushController = _a.flushController;
    var replicaBatch;
    var replica = configuration.replica;
    if (replica !== undefined) {
        replicaBatch = createRumBatch(replica.rumEndpointBuilder).batch;
    }
    function createRumBatch(endpointBuilder) {
        var flushController = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["N" /* createFlushController */])({
            messagesLimit: configuration.batchMessagesLimit,
            bytesLimit: configuration.batchBytesLimit,
            durationLimit: configuration.flushTimeout,
            pageExitObservable: pageExitObservable,
            sessionExpireObservable: sessionExpireObservable,
        });
        var batch = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["b" /* Batch */](Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["P" /* createHttpRequest */])(endpointBuilder, configuration.batchBytesLimit, reportError), flushController, configuration.messageBytesLimit);
        return {
            batch: batch,
            flushController: flushController,
        };
    }
    function withReplicaApplicationId(message) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["H" /* combine */])(message, { application: { id: replica.applicationId } });
    }
    return {
        flushObservable: primaryFlushController.flushObservable,
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(withReplicaApplicationId(message));
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(withReplicaApplicationId(message), key);
            }
        },
    };
}
//# sourceMappingURL=startRumBatch.js.map

/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startRumEventBridge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function startRumEventBridge(lifeCycle) {
    var bridge = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_4" /* getEventBridge */])();
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map

/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export URL_CONTEXT_TIME_OUT_DELAY */
/* harmony export (immutable) */ __webpack_exports__["a"] = startUrlContexts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["p" /* SESSION_TIME_OUT_DELAY */];
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["q" /* ValueHistory */](URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_40" /* relativeNow */])();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer,
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
//# sourceMappingURL=urlContexts.js.map

/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLocationChangeObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function createLocationChangeObservable(location) {
    var currentLocation = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_51" /* shallowClone */])(location);
    var observable = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["m" /* Observable */](function () {
        var stopHistoryTracking = trackHistory(onLocationChange).stop;
        var stopHashTracking = trackHash(onLocationChange).stop;
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
    function onLocationChange() {
        if (currentLocation.href === location.href) {
            return;
        }
        var newLocation = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_51" /* shallowClone */])(location);
        observable.notify({
            newLocation: newLocation,
            oldLocation: currentLocation,
        });
        currentLocation = newLocation;
    }
    return observable;
}
function trackHistory(onHistoryChange) {
    var stopInstrumentingPushState = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_18" /* instrumentMethodAndCallOriginal */])(history, 'pushState', {
        after: onHistoryChange,
    }).stop;
    var stopInstrumentingReplaceState = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_18" /* instrumentMethodAndCallOriginal */])(history, 'replaceState', {
        after: onHistoryChange,
    }).stop;
    var removeListener = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(window, "popstate" /* DOM_EVENT.POP_STATE */, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(onHashChange) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(window, "hashchange" /* DOM_EVENT.HASH_CHANGE */, onHashChange);
}
//# sourceMappingURL=locationChangeObservable.js.map

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY */
/* unused harmony export BYTES_COMPUTATION_THROTTLING_DELAY */
/* harmony export (immutable) */ __webpack_exports__["a"] = startFeatureFlagContexts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["p" /* SESSION_TIME_OUT_DELAY */];
var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["I" /* computeBytesCount */]; }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_21" /* isExperimentalFeatureEnabled */])(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["g" /* ExperimentalFeature */].FEATURE_FLAGS)) {
        return {
            findFeatureFlagEvaluations: function () { return undefined; },
            getFeatureFlagBytesCount: function () { return 0; },
            addFeatureFlagEvaluation: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */],
            stop: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */],
        };
    }
    var featureFlagContexts = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["q" /* ValueHistory */](FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
    var bytesCountCache = 0;
    var alreadyWarned = false;
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        bytesCountCache = 0;
    });
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call addFeatureFlagEvaluation API synchronously multiple times in a row
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_55" /* throttle */])(function (context) {
        bytesCountCache = computeBytesCountImpl(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_29" /* jsonStringify */])(context));
        if (!alreadyWarned) {
            alreadyWarned = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_61" /* warnIfCustomerDataLimitReached */])(bytesCountCache, "feature flag evaluation" /* CustomerDataType.FeatureFlag */);
        }
    }, BYTES_COMPUTATION_THROTTLING_DELAY), computeBytesCountThrottled = _a.throttled, cancelPendingComputation = _a.cancel;
    return {
        findFeatureFlagEvaluations: function (startTime) { return featureFlagContexts.find(startTime); },
        getFeatureFlagBytesCount: function () {
            var currentContext = featureFlagContexts.find();
            if (!currentContext) {
                return 0;
            }
            return bytesCountCache;
        },
        addFeatureFlagEvaluation: function (key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = value;
                computeBytesCountThrottled(currentContext);
            }
        },
        stop: cancelPendingComputation,
    };
}
//# sourceMappingURL=featureFlagContext.js.map

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MEASURES_PERIOD_DURATION */
/* harmony export (immutable) */ __webpack_exports__["a"] = startCustomerDataTelemetry;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

var MEASURES_PERIOD_DURATION = 10 * __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["l" /* ONE_SECOND */];
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_38" /* performDraw */])(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) {
        return;
    }
    initCurrentPeriodMeasures();
    initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        batchHasRumEvent = true;
        updateMeasure(currentBatchMeasures.globalContextBytes, !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_20" /* isEmptyObject */])(globalContextManager.get()) ? globalContextManager.getBytesCount() : 0);
        updateMeasure(currentBatchMeasures.userContextBytes, !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_20" /* isEmptyObject */])(userContextManager.get()) ? userContextManager.getBytesCount() : 0);
        var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations();
        var hasFeatureFlagContext = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_13" /* includes */])(["view" /* RumEventType.VIEW */, "error" /* RumEventType.ERROR */], event.type) &&
            featureFlagContext &&
            !Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_20" /* isEmptyObject */])(featureFlagContext);
        updateMeasure(currentBatchMeasures.featureFlagBytes, hasFeatureFlagContext ? featureFlagContexts.getFeatureFlagBytesCount() : 0);
    });
    batchFlushObservable.subscribe(function (_a) {
        var bytesCount = _a.bytesCount, messagesCount = _a.messagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!batchHasRumEvent) {
            return;
        }
        currentPeriodMeasures.batchCount += 1;
        updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
        updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
        mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
        mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
        mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
        initCurrentBatchMeasures();
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_49" /* setInterval */])(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
    if (currentPeriodMeasures.batchCount === 0) {
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["v" /* addTelemetryDebug */])('Customer data measures', currentPeriodMeasures);
    initCurrentPeriodMeasures();
}
function createMeasure() {
    return { min: Infinity, max: 0, sum: 0 };
}
function updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
    currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: createMeasure(),
        batchMessagesCount: createMeasure(),
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
function initCurrentBatchMeasures() {
    batchHasRumEvent = false;
    currentBatchMeasures = {
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
//# sourceMappingURL=startCustomerDataTelemetry.js.map

/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MAX_PAGE_STATE_ENTRIES */
/* unused harmony export MAX_PAGE_STATE_ENTRIES_SELECTABLE */
/* unused harmony export PAGE_STATE_CONTEXT_TIME_OUT_DELAY */
/* harmony export (immutable) */ __webpack_exports__["a"] = startPageStateHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

// Arbitrary value to cap number of element for memory consumption in the browser
var MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
var MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
var PAGE_STATE_CONTEXT_TIME_OUT_DELAY = __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["p" /* SESSION_TIME_OUT_DELAY */];
function startPageStateHistory(maxPageStateEntriesSelectable) {
    if (maxPageStateEntriesSelectable === void 0) { maxPageStateEntriesSelectable = MAX_PAGE_STATE_ENTRIES_SELECTABLE; }
    var pageStateHistory = new __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["q" /* ValueHistory */](PAGE_STATE_CONTEXT_TIME_OUT_DELAY, MAX_PAGE_STATE_ENTRIES);
    var currentPageState;
    addPageState(getPageState(), Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_40" /* relativeNow */])());
    var stopEventListeners = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(window, [
        "pageshow" /* DOM_EVENT.PAGE_SHOW */,
        "focus" /* DOM_EVENT.FOCUS */,
        "blur" /* DOM_EVENT.BLUR */,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */,
        "resume" /* DOM_EVENT.RESUME */,
        "freeze" /* DOM_EVENT.FREEZE */,
        "pagehide" /* DOM_EVENT.PAGE_HIDE */,
    ], function (event) {
        // Only get events fired by the browser to avoid false currentPageState changes done with custom events
        // cf: developer extension auto flush: https://github.com/DataDog/browser-sdk/blob/2f72bf05a672794c9e33965351964382a94c72ba/developer-extension/src/panel/flushEvents.ts#L11-L12
        if (event.isTrusted) {
            addPageState(computePageState(event), event.timeStamp);
        }
    }, { capture: true }).stop;
    function addPageState(nextPageState, startTime) {
        if (startTime === void 0) { startTime = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_40" /* relativeNow */])(); }
        if (nextPageState === currentPageState) {
            return;
        }
        currentPageState = nextPageState;
        pageStateHistory.closeActive(startTime);
        pageStateHistory.add({ state: currentPageState, startTime: startTime }, startTime);
    }
    return {
        findAll: function (eventStartTime, duration) {
            var pageStateEntries = pageStateHistory.findAll(eventStartTime, duration);
            if (pageStateEntries.length === 0) {
                return;
            }
            var pageStateServerEntries = [];
            // limit the number of entries to return
            var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
            // loop page state entries backward to return the selected ones in desc order
            for (var index = pageStateEntries.length - 1; index >= limit; index--) {
                var pageState = pageStateEntries[index];
                // compute the start time relative to the event start time (ex: to be relative to the view start time)
                var relativeStartTime = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["X" /* elapsed */])(eventStartTime, pageState.startTime);
                pageStateServerEntries.push({
                    state: pageState.state,
                    start: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_57" /* toServerDuration */])(relativeStartTime),
                });
            }
            return pageStateServerEntries;
        },
        addPageState: addPageState,
        stop: function () {
            stopEventListeners();
            pageStateHistory.stop();
        },
    };
}
function computePageState(event) {
    if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
        return "frozen" /* PageState.FROZEN */;
    }
    else if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */) {
        return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
    }
    return getPageState();
}
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* PageState.HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* PageState.ACTIVE */;
    }
    return "passive" /* PageState.PASSIVE */;
}
//# sourceMappingURL=pageStateHistory.js.map

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSessionReplayUrl;
/* unused harmony export getDatadogSiteUrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function getSessionReplayUrl(configuration, _a) {
    var session = _a.session, viewContext = _a.viewContext, errorType = _a.errorType;
    var sessionId = session ? session.id : 'no-session-id';
    var parameters = [];
    if (errorType !== undefined) {
        parameters.push("error-type=".concat(errorType));
    }
    if (viewContext) {
        parameters.push("seed=".concat(viewContext.id));
        parameters.push("from=".concat(viewContext.startClocks.timeStamp));
    }
    var origin = getDatadogSiteUrl(configuration);
    var path = "/rum/replay/sessions/".concat(sessionId);
    return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
function getDatadogSiteUrl(rumConfiguration) {
    var site = rumConfiguration.site;
    var subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
    return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
function getSiteDefaultSubdomain(configuration) {
    switch (configuration.site) {
        case __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["j" /* INTAKE_SITE_US1 */]:
        case __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["h" /* INTAKE_SITE_EU1 */]:
            return 'app';
        case __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["i" /* INTAKE_SITE_STAGING */]:
            return 'dd';
        default:
            return undefined;
    }
}
//# sourceMappingURL=getSessionReplayUrl.js.map

/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startRecording;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_record__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_segmentCollection__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(164);




function startRecording(lifeCycle, configuration, sessionManager, viewContexts, worker, httpRequest) {
    var reportError = function (error) {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
    };
    var replayRequest = httpRequest || Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["P" /* createHttpRequest */])(configuration.sessionReplayEndpointBuilder, __WEBPACK_IMPORTED_MODULE_2__domain_segmentCollection__["a" /* SEGMENT_BYTES_LIMIT */], reportError);
    var _a = Object(__WEBPACK_IMPORTED_MODULE_2__domain_segmentCollection__["c" /* startSegmentCollection */])(lifeCycle, configuration.applicationId, sessionManager, viewContexts, replayRequest, worker), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1__domain_record__["a" /* record */])({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
    }), stopRecording = _b.stop, takeSubsequentFullSnapshot = _b.takeSubsequentFullSnapshot, flushMutations = _b.flushMutations;
    var unsubscribeViewEnded = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function () {
        flushMutations();
        addRecord({
            timestamp: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])(),
            type: __WEBPACK_IMPORTED_MODULE_3__types__["e" /* RecordType */].ViewEnd,
        });
    }).unsubscribe;
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        takeSubsequentFullSnapshot(view.startClocks.timeStamp);
    }).unsubscribe;
    return {
        stop: function () {
            unsubscribeViewEnded();
            unsubscribeViewCreated();
            stopRecording();
            stopSegmentCollection();
        },
    };
}
//# sourceMappingURL=startRecording.js.map

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__record__ = __webpack_require__(2018);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__record__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serialization__ = __webpack_require__(165);
/* unused harmony reexport serializeNodeWithId */
/* unused harmony reexport serializeDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elementsScrollPositions__ = __webpack_require__(821);
/* unused harmony reexport createElementsScrollPositions */



//# sourceMappingURL=index.js.map

/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = record;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assembly__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__serialization__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__observers__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__viewports__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elementsScrollPositions__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shadowRootsController__ = __webpack_require__(2034);









function record(options) {
    var emit = options.emit;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var elementsScrollPositions = Object(__WEBPACK_IMPORTED_MODULE_7__elementsScrollPositions__["a" /* createElementsScrollPositions */])();
    var mutationCb = function (mutation) {
        emit(Object(__WEBPACK_IMPORTED_MODULE_3__assembly__["a" /* assembleIncrementalSnapshot */])(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* IncrementalSource */].Mutation, mutation));
    };
    var inputCb = function (s) { return emit(Object(__WEBPACK_IMPORTED_MODULE_3__assembly__["a" /* assembleIncrementalSnapshot */])(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* IncrementalSource */].Input, s)); };
    var shadowRootsController = Object(__WEBPACK_IMPORTED_MODULE_8__shadowRootsController__["a" /* initShadowRootsController */])(options.configuration, { mutationCb: mutationCb, inputCb: inputCb });
    var takeFullSnapshot = function (timestamp, serializationContext) {
        if (timestamp === void 0) { timestamp = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])(); }
        if (serializationContext === void 0) { serializationContext = {
            status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController,
        }; }
        var _a = Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["f" /* getViewportDimension */])(), width = _a.width, height = _a.height;
        emit({
            data: {
                height: height,
                href: window.location.href,
                width: width,
            },
            type: __WEBPACK_IMPORTED_MODULE_2__types__["e" /* RecordType */].Meta,
            timestamp: timestamp,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: __WEBPACK_IMPORTED_MODULE_2__types__["e" /* RecordType */].Focus,
            timestamp: timestamp,
        });
        emit({
            data: {
                node: Object(__WEBPACK_IMPORTED_MODULE_4__serialization__["f" /* serializeDocument */])(document, options.configuration, serializationContext),
                initialOffset: {
                    left: Object(__WEBPACK_IMPORTED_MODULE_6__viewports__["b" /* getScrollX */])(),
                    top: Object(__WEBPACK_IMPORTED_MODULE_6__viewports__["c" /* getScrollY */])(),
                },
            },
            type: __WEBPACK_IMPORTED_MODULE_2__types__["e" /* RecordType */].FullSnapshot,
            timestamp: timestamp,
        });
        if (window.visualViewport) {
            emit({
                data: Object(__WEBPACK_IMPORTED_MODULE_6__viewports__["d" /* getVisualViewport */])(window.visualViewport),
                type: __WEBPACK_IMPORTED_MODULE_2__types__["e" /* RecordType */].VisualViewport,
                timestamp: timestamp,
            });
        }
    };
    takeFullSnapshot();
    var _a = Object(__WEBPACK_IMPORTED_MODULE_5__observers__["c" /* initObservers */])({
        lifeCycle: options.lifeCycle,
        configuration: options.configuration,
        elementsScrollPositions: elementsScrollPositions,
        inputCb: inputCb,
        mediaInteractionCb: function (p) {
            return emit(Object(__WEBPACK_IMPORTED_MODULE_3__assembly__["a" /* assembleIncrementalSnapshot */])(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* IncrementalSource */].MediaInteraction, p));
        },
        mouseInteractionCb: function (mouseInteractionRecord) { return emit(mouseInteractionRecord); },
        mousemoveCb: function (positions, source) { return emit(Object(__WEBPACK_IMPORTED_MODULE_3__assembly__["a" /* assembleIncrementalSnapshot */])(source, { positions: positions })); },
        mutationCb: mutationCb,
        scrollCb: function (p) { return emit(Object(__WEBPACK_IMPORTED_MODULE_3__assembly__["a" /* assembleIncrementalSnapshot */])(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* IncrementalSource */].Scroll, p)); },
        styleSheetCb: function (r) { return emit(Object(__WEBPACK_IMPORTED_MODULE_3__assembly__["a" /* assembleIncrementalSnapshot */])(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* IncrementalSource */].StyleSheetRule, r)); },
        viewportResizeCb: function (d) { return emit(Object(__WEBPACK_IMPORTED_MODULE_3__assembly__["a" /* assembleIncrementalSnapshot */])(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* IncrementalSource */].ViewportResize, d)); },
        frustrationCb: function (frustrationRecord) { return emit(frustrationRecord); },
        focusCb: function (data) {
            return emit({
                data: data,
                type: __WEBPACK_IMPORTED_MODULE_2__types__["e" /* RecordType */].Focus,
                timestamp: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])(),
            });
        },
        visualViewportResizeCb: function (data) {
            emit({
                data: data,
                type: __WEBPACK_IMPORTED_MODULE_2__types__["e" /* RecordType */].VisualViewport,
                timestamp: Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_56" /* timeStampNow */])(),
            });
        },
        shadowRootsController: shadowRootsController,
    }), stopObservers = _a.stop, flushMutationsFromObservers = _a.flush;
    function flushMutations() {
        shadowRootsController.flush();
        flushMutationsFromObservers();
    }
    return {
        stop: function () {
            shadowRootsController.stop();
            stopObservers();
        },
        takeSubsequentFullSnapshot: function (timestamp) {
            flushMutations();
            takeFullSnapshot(timestamp, {
                shadowRootsController: shadowRootsController,
                status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */,
                elementsScrollPositions: elementsScrollPositions,
            });
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController,
    };
}
//# sourceMappingURL=record.js.map

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
/**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */

//# sourceMappingURL=sessionReplay.js.map

/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RecordType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NodeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IncrementalSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MouseInteractionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MediaInteractionType; });
var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9,
};
var NodeType = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11,
};
var IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
var MouseInteractionType = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
var MediaInteractionType = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=sessionReplayConstants.js.map

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = serializeDocument;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__serializeNode__ = __webpack_require__(815);

function serializeDocument(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return Object(__WEBPACK_IMPORTED_MODULE_0__serializeNode__["a" /* serializeNodeWithId */])(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration,
    });
}
//# sourceMappingURL=serializeDocument.js.map

/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = serializeStyleSheets;
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map(function (cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function (cssRule) { return cssRule.cssText; });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
//# sourceMappingURL=serializeStyleSheets.js.map

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = serializeAttributes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__privacy__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serializationUtils__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__serializeAttribute__ = __webpack_require__(816);




function serializeAttributes(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* NodePrivacyLevel */].HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = Object(__WEBPACK_IMPORTED_MODULE_2__serializationUtils__["c" /* getValidTagName */])(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = Object(__WEBPACK_IMPORTED_MODULE_3__serializeAttribute__["a" /* serializeAttribute */])(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = Object(__WEBPACK_IMPORTED_MODULE_2__serializationUtils__["a" /* getElementInputValue */])(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* NodePrivacyLevel */].ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet) {
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' &&
        element.sheet &&
        // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
        !(element.innerText || element.textContent || '').trim().length) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* NodePrivacyLevel */].ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_1__privacy__["f" /* shouldMaskNode */])(inputElement, nodePrivacyLevel)) {
            delete safeAttrs.checked;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */
    var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch (serializationContext.status) {
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) {
                serializationContext.elementsScrollPositions.set(element, { scrollTop: scrollTop, scrollLeft: scrollLeft });
            }
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
            if (serializationContext.elementsScrollPositions.has(element)) {
                ;
                (_a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft);
            }
            break;
    }
    if (scrollLeft) {
        safeAttrs.rr_scrollLeft = scrollLeft;
    }
    if (scrollTop) {
        safeAttrs.rr_scrollTop = scrollTop;
    }
    return safeAttrs;
}
function getCssRulesString(cssStyleSheet) {
    if (!cssStyleSheet) {
        return null;
    }
    var rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    }
    catch (_a) {
        // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) {
        return null;
    }
    var styleSheetCssText = Array.from(rules, getCssRuleString).join('');
    return Object(__WEBPACK_IMPORTED_MODULE_2__serializationUtils__["g" /* switchToAbsoluteUrl */])(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleString(rule) {
    return isCSSImportRule(rule) ? getCssRulesString(rule.styleSheet) || '' : rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
//# sourceMappingURL=serializeAttributes.js.map

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initObservers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moveObserver__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scrollObserver__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mouseInteractionObserver__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inputObserver__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styleSheetObserver__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mediaInteractionObserver__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__frustrationObserver__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__viewportResizeObserver__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mutationObserver__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__focusObserver__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__recordIds__ = __webpack_require__(2033);











function initObservers(o) {
    var recordIds = Object(__WEBPACK_IMPORTED_MODULE_10__recordIds__["a" /* initRecordIds */])();
    var mutationHandler = Object(__WEBPACK_IMPORTED_MODULE_8__mutationObserver__["a" /* initMutationObserver */])(o.mutationCb, o.configuration, o.shadowRootsController, document);
    var mousemoveHandler = Object(__WEBPACK_IMPORTED_MODULE_0__moveObserver__["a" /* initMoveObserver */])(o.mousemoveCb);
    var mouseInteractionHandler = Object(__WEBPACK_IMPORTED_MODULE_2__mouseInteractionObserver__["a" /* initMouseInteractionObserver */])(o.mouseInteractionCb, o.configuration.defaultPrivacyLevel, recordIds);
    var scrollHandler = Object(__WEBPACK_IMPORTED_MODULE_1__scrollObserver__["a" /* initScrollObserver */])(o.scrollCb, o.configuration.defaultPrivacyLevel, o.elementsScrollPositions);
    var viewportResizeHandler = Object(__WEBPACK_IMPORTED_MODULE_7__viewportResizeObserver__["a" /* initViewportResizeObserver */])(o.viewportResizeCb);
    var inputHandler = Object(__WEBPACK_IMPORTED_MODULE_3__inputObserver__["a" /* initInputObserver */])(o.inputCb, o.configuration.defaultPrivacyLevel);
    var mediaInteractionHandler = Object(__WEBPACK_IMPORTED_MODULE_5__mediaInteractionObserver__["a" /* initMediaInteractionObserver */])(o.mediaInteractionCb, o.configuration.defaultPrivacyLevel);
    var styleSheetObserver = Object(__WEBPACK_IMPORTED_MODULE_4__styleSheetObserver__["a" /* initStyleSheetObserver */])(o.styleSheetCb);
    var focusHandler = Object(__WEBPACK_IMPORTED_MODULE_9__focusObserver__["a" /* initFocusObserver */])(o.focusCb);
    var visualViewportResizeHandler = Object(__WEBPACK_IMPORTED_MODULE_7__viewportResizeObserver__["b" /* initVisualViewportResizeObserver */])(o.visualViewportResizeCb);
    var frustrationHandler = Object(__WEBPACK_IMPORTED_MODULE_6__frustrationObserver__["a" /* initFrustrationObserver */])(o.lifeCycle, o.frustrationCb, recordIds);
    return {
        flush: function () {
            mutationHandler.flush();
        },
        stop: function () {
            mutationHandler.stop();
            mousemoveHandler();
            mouseInteractionHandler();
            scrollHandler();
            viewportResizeHandler();
            inputHandler();
            mediaInteractionHandler();
            styleSheetObserver();
            focusHandler();
            visualViewportResizeHandler();
            frustrationHandler();
        },
    };
}
//# sourceMappingURL=observers.js.map

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initScrollObserver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventsUtils__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__privacy__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__serialization__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__viewports__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(152);






var SCROLL_OBSERVER_THRESHOLD = 100;
function initScrollObserver(cb, defaultPrivacyLevel, elementsScrollPositions) {
    var updatePosition = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_55" /* throttle */])(function (event) {
        var target = Object(__WEBPACK_IMPORTED_MODULE_1__eventsUtils__["a" /* getEventTarget */])(event);
        if (!target ||
            Object(__WEBPACK_IMPORTED_MODULE_2__privacy__["b" /* getNodePrivacyLevel */])(target, defaultPrivacyLevel) === __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NodePrivacyLevel */].HIDDEN ||
            !Object(__WEBPACK_IMPORTED_MODULE_3__serialization__["c" /* hasSerializedNode */])(target)) {
            return;
        }
        var id = Object(__WEBPACK_IMPORTED_MODULE_3__serialization__["b" /* getSerializedNodeId */])(target);
        var scrollPositions = target === document
            ? {
                scrollTop: Object(__WEBPACK_IMPORTED_MODULE_4__viewports__["c" /* getScrollY */])(),
                scrollLeft: Object(__WEBPACK_IMPORTED_MODULE_4__viewports__["b" /* getScrollX */])(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        cb({
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        });
    }, SCROLL_OBSERVER_THRESHOLD).throttled;
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(document, "scroll" /* DOM_EVENT.SCROLL */, updatePosition, { capture: true, passive: true }).stop;
}
//# sourceMappingURL=scrollObserver.js.map

/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initMouseInteractionObserver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assembly__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventsUtils__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__privacy__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__serialization__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__moveObserver__ = __webpack_require__(818);
var _a;








var eventTypeToMouseInteraction = (_a = {},
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    _a["pointerup" /* DOM_EVENT.POINTER_UP */] = __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].MouseUp,
    _a["mousedown" /* DOM_EVENT.MOUSE_DOWN */] = __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].MouseDown,
    _a["click" /* DOM_EVENT.CLICK */] = __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].Click,
    _a["contextmenu" /* DOM_EVENT.CONTEXT_MENU */] = __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].ContextMenu,
    _a["dblclick" /* DOM_EVENT.DBL_CLICK */] = __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].DblClick,
    _a["focus" /* DOM_EVENT.FOCUS */] = __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].Focus,
    _a["blur" /* DOM_EVENT.BLUR */] = __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].Blur,
    _a["touchstart" /* DOM_EVENT.TOUCH_START */] = __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].TouchStart,
    _a["touchend" /* DOM_EVENT.TOUCH_END */] = __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].TouchEnd,
    _a);
function initMouseInteractionObserver(cb, defaultPrivacyLevel, recordIds) {
    var handler = function (event) {
        var target = Object(__WEBPACK_IMPORTED_MODULE_4__eventsUtils__["a" /* getEventTarget */])(event);
        if (Object(__WEBPACK_IMPORTED_MODULE_5__privacy__["b" /* getNodePrivacyLevel */])(target, defaultPrivacyLevel) === __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].HIDDEN || !Object(__WEBPACK_IMPORTED_MODULE_6__serialization__["c" /* hasSerializedNode */])(target)) {
            return;
        }
        var id = Object(__WEBPACK_IMPORTED_MODULE_6__serialization__["b" /* getSerializedNodeId */])(target);
        var type = eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].Blur && type !== __WEBPACK_IMPORTED_MODULE_2__types__["c" /* MouseInteractionType */].Focus) {
            var coordinates = Object(__WEBPACK_IMPORTED_MODULE_7__moveObserver__["b" /* tryToComputeCoordinates */])(event);
            if (!coordinates) {
                return;
            }
            interaction = { id: id, type: type, x: coordinates.x, y: coordinates.y };
        }
        else {
            interaction = { id: id, type: type };
        }
        var record = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({ id: recordIds.getIdForEvent(event) }, Object(__WEBPACK_IMPORTED_MODULE_3__assembly__["a" /* assembleIncrementalSnapshot */])(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* IncrementalSource */].MouseInteraction, interaction));
        cb(record);
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
//# sourceMappingURL=mouseInteractionObserver.js.map

/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initStyleSheetObserver;
/* unused harmony export getPathToNestedCSSRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serialization__ = __webpack_require__(165);


function initStyleSheetObserver(cb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && Object(__WEBPACK_IMPORTED_MODULE_1__serialization__["c" /* hasSerializedNode */])(styleSheet.ownerNode)) {
            callback(Object(__WEBPACK_IMPORTED_MODULE_1__serialization__["b" /* getSerializedNodeId */])(styleSheet.ownerNode));
        }
    }
    var instrumentationStoppers = [
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_18" /* instrumentMethodAndCallOriginal */])(CSSStyleSheet.prototype, 'insertRule', {
            before: function (rule, index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, adds: [{ rule: rule, index: index }] }); });
            },
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_18" /* instrumentMethodAndCallOriginal */])(CSSStyleSheet.prototype, 'deleteRule', {
            before: function (index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, removes: [{ index: index }] }); });
            },
        }),
    ];
    if (typeof CSSGroupingRule !== 'undefined') {
        instrumentGroupingCSSRuleClass(CSSGroupingRule);
    }
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_18" /* instrumentMethodAndCallOriginal */])(cls.prototype, 'insertRule', {
            before: function (rule, index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index || 0);
                        cb({ id: id, adds: [{ rule: rule, index: path }] });
                    }
                });
            },
        }), Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_18" /* instrumentMethodAndCallOriginal */])(cls.prototype, 'deleteRule', {
            before: function (index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index);
                        cb({ id: id, removes: [{ index: path }] });
                    }
                });
            },
        }));
    }
    return function () { return instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); }); };
}
function getPathToNestedCSSRule(rule) {
    var path = [];
    var currentRule = rule;
    while (currentRule.parentRule) {
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) {
        return;
    }
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}
//# sourceMappingURL=styleSheetObserver.js.map

/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initMediaInteractionObserver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventsUtils__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__privacy__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__serialization__ = __webpack_require__(165);






function initMediaInteractionObserver(mediaInteractionCb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = Object(__WEBPACK_IMPORTED_MODULE_3__eventsUtils__["a" /* getEventTarget */])(event);
        if (!target ||
            Object(__WEBPACK_IMPORTED_MODULE_4__privacy__["b" /* getNodePrivacyLevel */])(target, defaultPrivacyLevel) === __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NodePrivacyLevel */].HIDDEN ||
            !Object(__WEBPACK_IMPORTED_MODULE_5__serialization__["c" /* hasSerializedNode */])(target)) {
            return;
        }
        mediaInteractionCb({
            id: Object(__WEBPACK_IMPORTED_MODULE_5__serialization__["b" /* getSerializedNodeId */])(target),
            type: event.type === "play" /* DOM_EVENT.PLAY */ ? __WEBPACK_IMPORTED_MODULE_2__types__["b" /* MediaInteractionType */].Play : __WEBPACK_IMPORTED_MODULE_2__types__["b" /* MediaInteractionType */].Pause,
        });
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(document, ["play" /* DOM_EVENT.PLAY */, "pause" /* DOM_EVENT.PAUSE */], handler, { capture: true, passive: true }).stop;
}
//# sourceMappingURL=mediaInteractionObserver.js.map

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initFrustrationObserver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(164);

function initFrustrationObserver(lifeCycle, frustrationCb, recordIds) {
    return lifeCycle.subscribe(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (data) {
        var _a, _b, _c;
        if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */ &&
            data.rawRumEvent.action.type === "click" /* ActionType.CLICK */ &&
            ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) &&
            'events' in data.domainContext &&
            ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
            frustrationCb({
                timestamp: data.rawRumEvent.date,
                type: __WEBPACK_IMPORTED_MODULE_0__types__["e" /* RecordType */].FrustrationRecord,
                data: {
                    frustrationTypes: data.rawRumEvent.action.frustration.type,
                    recordIds: data.domainContext.events.map(function (e) { return recordIds.getIdForEvent(e); }),
                },
            });
        }
    }).unsubscribe;
}
//# sourceMappingURL=frustrationObserver.js.map

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initViewportResizeObserver;
/* harmony export (immutable) */ __webpack_exports__["b"] = initVisualViewportResizeObserver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__viewports__ = __webpack_require__(362);



var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function initViewportResizeObserver(cb) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__datadog_browser_rum_core__["g" /* initViewportObservable */])().subscribe(cb).unsubscribe;
}
function initVisualViewportResizeObserver(cb) {
    var visualViewport = window.visualViewport;
    if (!visualViewport) {
        return __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */];
    }
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_55" /* throttle */])(function () {
        cb(Object(__WEBPACK_IMPORTED_MODULE_2__viewports__["d" /* getVisualViewport */])(visualViewport));
    }, VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(visualViewport, ["resize" /* DOM_EVENT.RESIZE */, "scroll" /* DOM_EVENT.SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}
//# sourceMappingURL=viewportResizeObserver.js.map

/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMutationBatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */];
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = requestIdleCallback(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        var id_1 = window.requestIdleCallback(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame(Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_34" /* monitor */])(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
//# sourceMappingURL=mutationBatch.js.map

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initFocusObserver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function initFocusObserver(focusCb) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["t" /* addEventListeners */])(window, ["focus" /* DOM_EVENT.FOCUS */, "blur" /* DOM_EVENT.BLUR */], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
//# sourceMappingURL=focusObserver.js.map

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initRecordIds;
function initRecordIds() {
    var recordIds = new WeakMap();
    var nextId = 1;
    return {
        getIdForEvent: function (event) {
            if (!recordIds.has(event)) {
                recordIds.set(event, nextId++);
            }
            return recordIds.get(event);
        },
    };
}
//# sourceMappingURL=recordIds.js.map

/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initShadowRootsController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observers__ = __webpack_require__(817);

var initShadowRootsController = function (configuration, _a) {
    var mutationCb = _a.mutationCb, inputCb = _a.inputCb;
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function (shadowRoot) {
            var _a = Object(__WEBPACK_IMPORTED_MODULE_0__observers__["b" /* initMutationObserver */])(mutationCb, configuration, shadowRootsController, shadowRoot), stopMutationObserver = _a.stop, flush = _a.flush;
            // the change event no do bubble up across the shadow root, we have to listen on the shadow root
            var stopInputObserver = Object(__WEBPACK_IMPORTED_MODULE_0__observers__["a" /* initInputObserver */])(inputCb, configuration.defaultPrivacyLevel, {
                target: shadowRoot,
                domEvents: ["change" /* DOM_EVENT.CHANGE */],
            });
            controllerByShadowRoot.set(shadowRoot, {
                flush: flush,
                stop: function () {
                    stopMutationObserver();
                    stopInputObserver();
                },
            });
        },
        removeShadowRoot: function (shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var flush = _a.flush;
                return flush();
            });
        },
    };
    return shadowRootsController;
};
//# sourceMappingURL=shadowRootsController.js.map

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildReplayPayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);

function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    var metadataAndSegmentSizes = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength,
    }, metadata);
    var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append('event', new Blob([serializedMetadataAndSegmentSizes], { type: 'application/json' }));
    return { data: formData, bytesCount: data.byteLength };
}
//# sourceMappingURL=buildReplayPayload.js.map

/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Segment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__replayStats__ = __webpack_require__(824);



var nextId = 0;
var Segment = /** @class */ (function () {
    function Segment(worker, context, creationReason, initialRecord, onWrote, onFlushed) {
        var _this = this;
        this.worker = worker;
        this.id = nextId++;
        var viewId = context.view.id;
        this.metadata = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["y" /* assign */])({
            start: initialRecord.timestamp,
            end: initialRecord.timestamp,
            creation_reason: creationReason,
            records_count: 1,
            has_full_snapshot: initialRecord.type === __WEBPACK_IMPORTED_MODULE_1__types__["e" /* RecordType */].FullSnapshot,
            index_in_view: __WEBPACK_IMPORTED_MODULE_2__replayStats__["e" /* getSegmentsCount */](viewId),
            source: 'browser',
        }, context);
        __WEBPACK_IMPORTED_MODULE_2__replayStats__["b" /* addSegment */](viewId);
        __WEBPACK_IMPORTED_MODULE_2__replayStats__["a" /* addRecord */](viewId);
        var removeMessageListener = Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(worker, 'message', function (_a) {
            var data = _a.data;
            if (data.type === 'errored' || data.type === 'initialized') {
                return;
            }
            if (data.id === _this.id) {
                __WEBPACK_IMPORTED_MODULE_2__replayStats__["c" /* addWroteData */](viewId, data.additionalBytesCount);
                if (data.type === 'flushed') {
                    onFlushed(data.result, data.rawBytesCount);
                    removeMessageListener();
                }
                else {
                    onWrote(data.compressedBytesCount);
                }
            }
            else if (data.id > _this.id) {
                // Messages should be received in the same order as they are sent, so if we receive a
                // message with an id superior to this Segment instance id, we know that another, more
                // recent Segment instance is being used.
                //
                // In theory, a "flush" response should have been received at this point, so the listener
                // should already have been removed. But if something goes wrong and we didn't receive a
                // "flush" response, remove the listener to avoid any leak, and send a monitor message to
                // help investigate the issue.
                removeMessageListener();
                Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["v" /* addTelemetryDebug */])("Segment did not receive a 'flush' response before being replaced.");
            }
        }).stop;
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_47" /* sendToExtension */])('record', { record: initialRecord, segment: this.metadata });
        this.worker.postMessage({ data: "{\"records\":[".concat(JSON.stringify(initialRecord)), id: this.id, action: 'write' });
    }
    Segment.prototype.addRecord = function (record) {
        var _a;
        this.metadata.start = Math.min(this.metadata.start, record.timestamp);
        this.metadata.end = Math.max(this.metadata.end, record.timestamp);
        this.metadata.records_count += 1;
        __WEBPACK_IMPORTED_MODULE_2__replayStats__["a" /* addRecord */](this.metadata.view.id);
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === __WEBPACK_IMPORTED_MODULE_1__types__["e" /* RecordType */].FullSnapshot);
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_47" /* sendToExtension */])('record', { record: record, segment: this.metadata });
        this.worker.postMessage({ data: ",".concat(JSON.stringify(record)), id: this.id, action: 'write' });
    };
    Segment.prototype.flush = function (reason) {
        this.worker.postMessage({
            data: "],".concat(JSON.stringify(this.metadata).slice(1), "\n"),
            id: this.id,
            action: 'flush',
        });
        this.flushReason = reason;
    };
    return Segment;
}());

//# sourceMappingURL=segment.js.map

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startDeflateWorker;
/* unused harmony export resetDeflateWorkerState */
/* unused harmony export doStartDeflateWorker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deflateWorker__ = __webpack_require__(2038);


var state = { status: 0 /* DeflateWorkerStatus.Nil */ };
function startDeflateWorker(callback, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = __WEBPACK_IMPORTED_MODULE_1__deflateWorker__["a" /* createDeflateWorker */]; }
    switch (state.status) {
        case 0 /* DeflateWorkerStatus.Nil */:
            state = { status: 1 /* DeflateWorkerStatus.Loading */, callbacks: [callback] };
            doStartDeflateWorker(createDeflateWorkerImpl);
            break;
        case 1 /* DeflateWorkerStatus.Loading */:
            state.callbacks.push(callback);
            break;
        case 2 /* DeflateWorkerStatus.Error */:
            callback();
            break;
        case 3 /* DeflateWorkerStatus.Initialized */:
            callback(state.worker);
            break;
    }
}
function resetDeflateWorkerState() {
    state = { status: 0 /* DeflateWorkerStatus.Nil */ };
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = __WEBPACK_IMPORTED_MODULE_1__deflateWorker__["a" /* createDeflateWorker */]; }
    try {
        var worker_1 = createDeflateWorkerImpl();
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(worker_1, 'error', onError);
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["s" /* addEventListener */])(worker_1, 'message', function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(data.error);
            }
            else if (data.type === 'initialized') {
                onInitialized(worker_1);
            }
        });
        worker_1.postMessage({ action: 'init' });
        return worker_1;
    }
    catch (error) {
        onError(error);
    }
}
function onInitialized(worker) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state.callbacks.forEach(function (callback) { return callback(worker); });
        state = { status: 3 /* DeflateWorkerStatus.Initialized */, worker: worker };
    }
}
function onError(error) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Session Replay recording failed to start: an error occurred while creating the Worker:', error);
        if (error instanceof Event || (error instanceof Error && isMessageCspRelated(error.message))) {
            __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["W" /* display */].error('Please make sure CSP is correctly configured ' +
                'https://docs.datadoghq.com/real_user_monitoring/faq/content_security_policy');
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["w" /* addTelemetryError */])(error);
        }
        state.callbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
    else {
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["w" /* addTelemetryError */])(error);
    }
}
function isMessageCspRelated(message) {
    return (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_13" /* includes */])(message, 'Content Security Policy') ||
        // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
        Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_13" /* includes */])(message, "requires 'TrustedScriptURL'"));
}
//# sourceMappingURL=startDeflateWorker.js.map

/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDeflateWorker;
var workerURL;
function createDeflateWorker() {
    // Lazily compute the worker URL to allow importing the SDK in NodeJS
    if (!workerURL) {
        workerURL = URL.createObjectURL(new Blob(["(".concat(workerCodeFn, ")(self)")]));
    }
    return new Worker(workerURL);
}
function workerCodeFn() {
    monitor(function () {
        var _a = makePakoDeflate(), Deflate = _a.Deflate, constants = _a.constants, string2buf = _a.string2buf;
        var deflate = new Deflate();
        var rawBytesCount = 0;
        self.addEventListener('message', monitor(function (event) {
            var data = event.data;
            switch (data.action) {
                case 'init':
                    self.postMessage({
                        type: 'initialized',
                    });
                    break;
                case 'write': {
                    var additionalBytesCount = pushData(data.data);
                    self.postMessage({
                        type: 'wrote',
                        id: data.id,
                        compressedBytesCount: deflate.chunks.reduce(function (total, chunk) { return total + chunk.length; }, 0),
                        additionalBytesCount: additionalBytesCount,
                    });
                    break;
                }
                case 'flush': {
                    var additionalBytesCount = data.data ? pushData(data.data) : 0;
                    deflate.push('', constants.Z_FINISH);
                    self.postMessage({
                        type: 'flushed',
                        id: data.id,
                        result: deflate.result,
                        additionalBytesCount: additionalBytesCount,
                        rawBytesCount: rawBytesCount,
                    });
                    deflate = new Deflate();
                    rawBytesCount = 0;
                    break;
                }
            }
        }));
        function pushData(data) {
            // TextEncoder is not supported on old browser version like Edge 18, therefore we use string2buf
            var binaryData = string2buf(data);
            deflate.push(binaryData, constants.Z_SYNC_FLUSH);
            rawBytesCount += binaryData.length;
            return binaryData.length;
        }
    })();
    function monitor(fn) {
        return function () {
            try {
                return fn.apply(this, arguments);
            }
            catch (e) {
                try {
                    self.postMessage({
                        type: 'errored',
                        error: e,
                    });
                }
                catch (_) {
                    // DATA_CLONE_ERR, cf https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
                    self.postMessage({
                        type: 'errored',
                        error: "".concat(e),
                    });
                }
            }
        };
    }
    // https://github.com/nodeca/pako/blob/034669ba0f1a4c0590e45f7c2820128200f972b3/dist/pako_deflate.es5.js
    function makePakoDeflate() {
        /* eslint-disable camelcase, no-bitwise */
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        /* Public constants ========================================================== */
        /* =========================================================================== */
        // const Z_FILTERED          = 1;
        // const Z_HUFFMAN_ONLY      = 2;
        // const Z_RLE               = 3;
        var Z_FIXED = 4; // const Z_DEFAULT_STRATEGY  = 0;
        /* Possible values of the data_type field (though see inflate()) */
        var Z_BINARY = 0;
        var Z_TEXT = 1; // const Z_ASCII             = 1; // = Z_TEXT
        var Z_UNKNOWN = 2;
        /* ============================================================================ */
        function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        } // From zutil.h
        var STORED_BLOCK = 0;
        var STATIC_TREES = 1;
        var DYN_TREES = 2;
        /* The three kinds of block type */
        var MIN_MATCH = 3;
        var MAX_MATCH = 258;
        /* The minimum and maximum match lengths */
        // From deflate.h
        /* ===========================================================================
         * Internal compression state.
         */
        var LENGTH_CODES = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS = 256;
        /* number of literal bytes 0..255 */
        var L_CODES = LITERALS + 1 + LENGTH_CODES;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES = 30;
        /* number of distance codes */
        var BL_CODES = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE = 2 * L_CODES + 1;
        /* maximum heap size */
        var MAX_BITS = 15;
        /* All codes must not exceed MAX_BITS bits */
        var Buf_size = 16;
        /* size of bit buffer in bi_buf */
        /* ===========================================================================
         * Constants
         */
        var MAX_BL_BITS = 7;
        /* Bit length codes must not exceed MAX_BL_BITS bits */
        var END_BLOCK = 256;
        /* end of block literal code */
        var REP_3_6 = 16;
        /* repeat previous bit length 3-6 times (2 bits of repeat count) */
        var REPZ_3_10 = 17;
        /* repeat a zero length 3-10 times  (3 bits of repeat count) */
        var REPZ_11_138 = 18;
        /* repeat a zero length 11-138 times  (7 bits of repeat count) */
        var extra_lbits = 
        /* extra bits for each length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]);
        var extra_dbits = 
        /* extra bits for each distance code */
        new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
        var extra_blbits = 
        /* extra bits for each bit length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]);
        var bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
        /* eslint-enable comma-spacing,array-bracket-spacing */
        /* The lengths of the bit length codes are sent in order of decreasing
         * probability, to avoid transmitting the lengths for unused bit length codes.
         */
        /* ===========================================================================
         * Local data. These are initialized only once.
         */
        // We pre-fill arrays with 0 to avoid uninitialized gaps
        var DIST_CODE_LEN = 512;
        /* see definition of array dist_code below */
        // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
        var static_ltree = new Array((L_CODES + 2) * 2);
        zero(static_ltree);
        /* The static literal tree. Since the bit lengths are imposed, there is no
         * need for the L_CODES extra codes used during heap construction. However
         * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
         * below).
         */
        var static_dtree = new Array(D_CODES * 2);
        zero(static_dtree);
        /* The static distance tree. (Actually a trivial tree since all codes use
         * 5 bits.)
         */
        var _dist_code = new Array(DIST_CODE_LEN);
        zero(_dist_code);
        /* Distance codes. The first 256 values correspond to the distances
         * 3 .. 258, the last 256 values correspond to the top 8 bits of
         * the 15 bit distances.
         */
        var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
        zero(_length_code);
        /* length code for each normalized match length (0 == MIN_MATCH) */
        var base_length = new Array(LENGTH_CODES);
        zero(base_length);
        /* First normalized length for each code (0 = MIN_MATCH) */
        var base_dist = new Array(D_CODES);
        zero(base_dist);
        /* First normalized distance for each code (0 = distance of 1) */
        function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
            this.static_tree = static_tree;
            /* static tree or NULL */
            this.extra_bits = extra_bits;
            /* extra bits for each code or NULL */
            this.extra_base = extra_base;
            /* base index for extra_bits */
            this.elems = elems;
            /* max number of elements in the tree */
            this.max_length = max_length;
            /* max bit length for the codes */
            // show if `static_tree` has data or dummy - needed for monomorphic objects
            this.has_stree = static_tree && static_tree.length;
        }
        var static_l_desc;
        var static_d_desc;
        var static_bl_desc;
        function TreeDesc(dyn_tree, stat_desc) {
            this.dyn_tree = dyn_tree;
            /* the dynamic tree */
            this.max_code = 0;
            /* largest code with non zero frequency */
            this.stat_desc = stat_desc;
            /* the corresponding static tree */
        }
        var d_code = function d_code(dist) {
            return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
        };
        /* ===========================================================================
         * Output a short LSB first on the stream.
         * IN assertion: there is enough room in pendingBuf.
         */
        var put_short = function put_short(s, w) {
            //    put_byte(s, (uch)((w) & 0xff));
            //    put_byte(s, (uch)((ush)(w) >> 8));
            s.pending_buf[s.pending++] = w & 0xff;
            s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
        };
        /* ===========================================================================
         * Send a value on a given number of bits.
         * IN assertion: length <= 16 and value fits in length bits.
         */
        var send_bits = function send_bits(s, value, length) {
            if (s.bi_valid > Buf_size - length) {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                put_short(s, s.bi_buf);
                s.bi_buf = value >> (Buf_size - s.bi_valid);
                s.bi_valid += length - Buf_size;
            }
            else {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                s.bi_valid += length;
            }
        };
        var send_code = function send_code(s, c, tree) {
            send_bits(s, tree[c * 2], 
            /* .Code */
            tree[c * 2 + 1]
            /* .Len */
            );
        };
        /* ===========================================================================
         * Reverse the first len bits of a code, using straightforward code (a faster
         * method would use a table)
         * IN assertion: 1 <= len <= 15
         */
        var bi_reverse = function bi_reverse(code, len) {
            var res = 0;
            do {
                res |= code & 1;
                code >>>= 1;
                res <<= 1;
            } while (--len > 0);
            return res >>> 1;
        };
        /* ===========================================================================
         * Flush the bit buffer, keeping at most 7 bits in it.
         */
        var bi_flush = function bi_flush(s) {
            if (s.bi_valid === 16) {
                put_short(s, s.bi_buf);
                s.bi_buf = 0;
                s.bi_valid = 0;
            }
            else if (s.bi_valid >= 8) {
                s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                s.bi_buf >>= 8;
                s.bi_valid -= 8;
            }
        };
        /* ===========================================================================
         * Compute the optimal bit lengths for a tree and update the total bit length
         * for the current block.
         * IN assertion: the fields freq and dad are set, heap[heap_max] and
         *    above are the tree nodes sorted by increasing frequency.
         * OUT assertions: the field len is set to the optimal bit length, the
         *     array bl_count contains the frequencies for each bit length.
         *     The length opt_len is updated; static_len is also updated if stree is
         *     not null.
         */
        var gen_bitlen = function gen_bitlen(s, desc //    deflate_state *s; //    tree_desc *desc;    /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var max_code = desc.max_code;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var extra = desc.stat_desc.extra_bits;
            var base = desc.stat_desc.extra_base;
            var max_length = desc.stat_desc.max_length;
            var h;
            /* heap index */
            var n;
            var m;
            /* iterate over the tree elements */
            var bits;
            /* bit length */
            var xbits;
            /* extra bits */
            var f;
            /* frequency */
            var overflow = 0;
            /* number of elements with bit length too large */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                s.bl_count[bits] = 0;
            }
            /* In a first pass, compute the optimal bit lengths (which may
             * overflow in the case of the bit length tree).
             */
            tree[s.heap[s.heap_max] * 2 + 1] =
                /* .Len */
                0;
            /* root of the heap */
            for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
                n = s.heap[h];
                bits =
                    tree[tree[n * 2 + 1] *
                        /* .Dad */
                        2 +
                        1] +
                        /* .Len */
                        1;
                if (bits > max_length) {
                    bits = max_length;
                    overflow++;
                }
                tree[n * 2 + 1] =
                    /* .Len */
                    bits;
                /* We overwrite tree[n].Dad which is no longer needed */
                if (n > max_code) {
                    continue;
                }
                /* not a leaf node */
                s.bl_count[bits]++;
                xbits = 0;
                if (n >= base) {
                    xbits = extra[n - base];
                }
                f = tree[n * 2];
                /* .Freq */
                s.opt_len += f * (bits + xbits);
                if (has_stree) {
                    s.static_len +=
                        f *
                            (stree[n * 2 + 1] +
                                /* .Len */
                                xbits);
                }
            }
            if (overflow === 0) {
                return;
            } // Trace((stderr,"\nbit length overflow\n"));
            /* This happens for example on obj2 and pic of the Calgary corpus */
            /* Find the first bit length which could increase: */
            do {
                bits = max_length - 1;
                while (s.bl_count[bits] === 0) {
                    bits--;
                }
                s.bl_count[bits]--;
                /* move one leaf down the tree */
                s.bl_count[bits + 1] += 2;
                /* move one overflow item as its brother */
                s.bl_count[max_length]--;
                /* The brother of the overflow item also moves one step up,
                 * but this does not affect bl_count[max_length]
                 */
                overflow -= 2;
            } while (overflow > 0);
            /* Now recompute all bit lengths, scanning in increasing frequency.
             * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
             * lengths instead of fixing only the wrong ones. This idea is taken
             * from 'ar' written by Haruhiko Okumura.)
             */
            for (bits = max_length; bits !== 0; bits--) {
                n = s.bl_count[bits];
                while (n !== 0) {
                    m = s.heap[--h];
                    if (m > max_code) {
                        continue;
                    }
                    if (tree[m * 2 + 1] !==
                        /* .Len */
                        bits) {
                        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                        s.opt_len +=
                            (bits - tree[m * 2 + 1]) *
                                /* .Len */
                                tree[m * 2];
                        /* .Freq */
                        tree[m * 2 + 1] =
                            /* .Len */
                            bits;
                    }
                    n--;
                }
            }
        };
        /* ===========================================================================
         * Generate the codes for a given tree and bit counts (which need not be
         * optimal).
         * IN assertion: the array bl_count contains the bit length statistics for
         * the given tree and the field len is set for all tree elements.
         * OUT assertion: the field code is set for all tree elements of non
         *     zero code length.
         */
        var gen_codes = function gen_codes(tree, max_code, bl_count
        //    ct_data *tree;             /* the tree to decorate */
        //    int max_code;              /* largest code with non zero frequency */
        //    ushf *bl_count;            /* number of codes at each bit length */
        ) {
            var next_code = new Array(MAX_BITS + 1);
            /* next code value for each bit length */
            var code = 0;
            /* running code value */
            var bits;
            /* bit index */
            var n;
            /* code index */
            /* The distribution counts are first used to generate the code values
             * without bit reversal.
             */
            for (bits = 1; bits <= MAX_BITS; bits++) {
                next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
            }
            /* Check that the bit counts in bl_count are consistent. The last code
             * must be all ones.
             */
            // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
            //        "inconsistent bit counts");
            // Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
            for (n = 0; n <= max_code; n++) {
                var len = tree[n * 2 + 1];
                /* .Len */
                if (len === 0) {
                    continue;
                }
                /* Now reverse the bits */
                tree[n * 2] =
                    /* .Code */
                    bi_reverse(next_code[len]++, len); // Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
            }
        };
        /* ===========================================================================
         * Initialize the various 'constant' tables.
         */
        var tr_static_init = function tr_static_init() {
            var n;
            /* iterates over tree elements */
            var bits;
            /* bit counter */
            var length;
            /* length value */
            var code;
            /* code value */
            var dist;
            /* distance index */
            var bl_count = new Array(MAX_BITS + 1);
            /* number of codes at each bit length for an optimal tree */
            // do check in _tr_init()
            // if (static_init_done) return;
            /* For some embedded targets, global variables are not initialized: */
            /* #ifdef NO_INIT_GLOBAL_POINTERS
            static_l_desc.static_tree = static_ltree;
            static_l_desc.extra_bits = extra_lbits;
            static_d_desc.static_tree = static_dtree;
            static_d_desc.extra_bits = extra_dbits;
            static_bl_desc.extra_bits = extra_blbits;
          #endif */
            /* Initialize the mapping length (0..255) -> length code (0..28) */
            length = 0;
            for (code = 0; code < LENGTH_CODES - 1; code++) {
                base_length[code] = length;
                for (n = 0; n < 1 << extra_lbits[code]; n++) {
                    _length_code[length++] = code;
                }
            } // Assert (length == 256, "tr_static_init: length != 256");
            /* Note that the length 255 (match length 258) can be represented
             * in two different ways: code 284 + 5 bits or code 285, so we
             * overwrite length_code[255] to use the best encoding:
             */
            _length_code[length - 1] = code;
            /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
            dist = 0;
            for (code = 0; code < 16; code++) {
                base_dist[code] = dist;
                for (n = 0; n < 1 << extra_dbits[code]; n++) {
                    _dist_code[dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: dist != 256");
            dist >>= 7;
            /* from now on, all distances are divided by 128 */
            for (; code < D_CODES; code++) {
                base_dist[code] = dist << 7;
                for (n = 0; n < 1 << (extra_dbits[code] - 7); n++) {
                    _dist_code[256 + dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: 256+dist != 512");
            /* Construct the codes of the static literal tree */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                bl_count[bits] = 0;
            }
            n = 0;
            while (n <= 143) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            while (n <= 255) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    9;
                n++;
                bl_count[9]++;
            }
            while (n <= 279) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    7;
                n++;
                bl_count[7]++;
            }
            while (n <= 287) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            /* Codes 286 and 287 do not exist, but we must include them in the
             * tree construction to get a canonical Huffman tree (longest code
             * all ones)
             */
            gen_codes(static_ltree, L_CODES + 1, bl_count);
            /* The static distance tree is trivial: */
            for (n = 0; n < D_CODES; n++) {
                static_dtree[n * 2 + 1] =
                    /* .Len */
                    5;
                static_dtree[n * 2] =
                    /* .Code */
                    bi_reverse(n, 5);
            } // Now data ready and we can init static trees
            static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
            static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
            static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
            // static_init_done = true;
        };
        /* ===========================================================================
         * Initialize a new block.
         */
        var init_block = function init_block(s) {
            var n;
            /* iterates over tree elements */
            /* Initialize the trees. */
            for (n = 0; n < L_CODES; n++) {
                s.dyn_ltree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < D_CODES; n++) {
                s.dyn_dtree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < BL_CODES; n++) {
                s.bl_tree[n * 2] =
                    /* .Freq */
                    0;
            }
            s.dyn_ltree[END_BLOCK * 2] =
                /* .Freq */
                1;
            s.opt_len = s.static_len = 0;
            s.last_lit = s.matches = 0;
        };
        /* ===========================================================================
         * Flush the bit buffer and align the output on a byte boundary
         */
        var bi_windup = function bi_windup(s) {
            if (s.bi_valid > 8) {
                put_short(s, s.bi_buf);
            }
            else if (s.bi_valid > 0) {
                // put_byte(s, (Byte)s->bi_buf);
                s.pending_buf[s.pending++] = s.bi_buf;
            }
            s.bi_buf = 0;
            s.bi_valid = 0;
        };
        /* ===========================================================================
         * Copy a stored block, storing first the length and its
         * one's complement if requested.
         */
        var copy_block = function copy_block(s, buf, len, header
        // DeflateState *s;
        // charf    *buf;    /* the input data */
        // unsigned len;     /* its length */
        // int      header;  /* true if block header must be written */
        ) {
            bi_windup(s);
            /* align on byte boundary */
            if (header) {
                put_short(s, len);
                put_short(s, ~len);
            }
            //  while (len--) {
            //    put_byte(s, *buf++);
            //  }
            s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
            s.pending += len;
        };
        /* ===========================================================================
         * Compares to subtrees, using the tree depth as tie breaker when
         * the subtrees have equal frequency. This minimizes the worst case length.
         */
        var smaller = function smaller(tree, n, m, depth) {
            var _n2 = n * 2;
            var _m2 = m * 2;
            return (tree[_n2] <
                /* .Freq */
                tree[_m2] ||
                /* .Freq */
                (tree[_n2] ===
                    /* .Freq */
                    tree[_m2] &&
                    /* .Freq */
                    depth[n] <= depth[m]));
        };
        /* ===========================================================================
         * Restore the heap property by moving down the tree starting at node k,
         * exchanging a node with the smallest of its two sons if necessary, stopping
         * when the heap property is re-established (each father smaller than its
         * two sons).
         */
        var pqdownheap = function pqdownheap(s, tree, k
        //    deflate_state *s;
        //    ct_data *tree;  /* the tree to restore */
        //    int k;               /* node to move down */
        ) {
            var v = s.heap[k];
            var j = k << 1;
            /* left son of k */
            while (j <= s.heap_len) {
                /* Set j to the smallest of the two sons: */
                if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
                    j++;
                }
                /* Exit if v is smaller than both sons */
                if (smaller(tree, v, s.heap[j], s.depth)) {
                    break;
                }
                /* Exchange v with the smallest son */
                s.heap[k] = s.heap[j];
                k = j;
                /* And continue down the tree, setting j to the left son of k */
                j <<= 1;
            }
            s.heap[k] = v;
        }; // inlined manually
        // const SMALLEST = 1;
        /* ===========================================================================
         * Send the block data compressed using the given Huffman trees
         */
        var compress_block = function compress_block(s, ltree, dtree
        //    deflate_state *s;
        //    const ct_data *ltree; /* literal tree */
        //    const ct_data *dtree; /* distance tree */
        ) {
            var dist;
            /* distance of matched string */
            var lc;
            /* match length or unmatched char (if dist == 0) */
            var lx = 0;
            /* running index in l_buf */
            var code;
            /* the code to send */
            var extra;
            /* number of extra bits to send */
            if (s.last_lit !== 0) {
                do {
                    dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | s.pending_buf[s.d_buf + lx * 2 + 1];
                    lc = s.pending_buf[s.l_buf + lx];
                    lx++;
                    if (dist === 0) {
                        send_code(s, lc, ltree);
                        /* send a literal byte */
                        // Tracecv(isgraph(lc), (stderr," '%c' ", lc));
                    }
                    else {
                        /* Here, lc is the match length - MIN_MATCH */
                        code = _length_code[lc];
                        send_code(s, code + LITERALS + 1, ltree);
                        /* send the length code */
                        extra = extra_lbits[code];
                        if (extra !== 0) {
                            lc -= base_length[code];
                            send_bits(s, lc, extra);
                            /* send the extra length bits */
                        }
                        dist--;
                        /* dist is now the match distance - 1 */
                        code = d_code(dist); // Assert (code < D_CODES, "bad d_code");
                        send_code(s, code, dtree);
                        /* send the distance code */
                        extra = extra_dbits[code];
                        if (extra !== 0) {
                            dist -= base_dist[code];
                            send_bits(s, dist, extra);
                            /* send the extra distance bits */
                        }
                    }
                    /* literal or match pair ? */
                    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
                    // Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                    //       "pendingBuf overflow");
                } while (lx < s.last_lit);
            }
            send_code(s, END_BLOCK, ltree);
        };
        /* ===========================================================================
         * Construct one Huffman tree and assigns the code bit strings and lengths.
         * Update the total bit length for the current block.
         * IN assertion: the field freq is set for all tree elements.
         * OUT assertions: the fields len and code are set to the optimal bit length
         *     and corresponding code. The length opt_len is updated; static_len is
         *     also updated if stree is not null. The field max_code is set.
         */
        var build_tree = function build_tree(s, desc //    deflate_state *s; //    tree_desc *desc; /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var elems = desc.stat_desc.elems;
            var n;
            var m;
            /* iterate over heap elements */
            var max_code = -1;
            /* largest code with non zero frequency */
            var node;
            /* new node being created */
            /* Construct the initial heap, with least frequent element in
             * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
             * heap[0] is not used.
             */
            s.heap_len = 0;
            s.heap_max = HEAP_SIZE;
            for (n = 0; n < elems; n++) {
                if (tree[n * 2] !==
                    /* .Freq */
                    0) {
                    s.heap[++s.heap_len] = max_code = n;
                    s.depth[n] = 0;
                }
                else {
                    tree[n * 2 + 1] =
                        /* .Len */
                        0;
                }
            }
            /* The pkzip format requires that at least one distance code exists,
             * and that at least one bit should be sent even if there is only one
             * possible code. So to avoid special checks later on we force at least
             * two codes of non zero frequency.
             */
            while (s.heap_len < 2) {
                node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                tree[node * 2] =
                    /* .Freq */
                    1;
                s.depth[node] = 0;
                s.opt_len--;
                if (has_stree) {
                    s.static_len -= stree[node * 2 + 1];
                    /* .Len */
                }
                /* node is 0 or 1 so it does not have extra bits */
            }
            desc.max_code = max_code;
            /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
             * establish sub-heaps of increasing lengths:
             */
            for (n = s.heap_len >> 1; 
            /* int /2 */
            n >= 1; n--) {
                pqdownheap(s, tree, n);
            }
            /* Construct the Huffman tree by repeatedly combining the least two
             * frequent nodes.
             */
            node = elems;
            /* next internal node of the tree */
            do {
                // pqremove(s, tree, n);  /* n = node of least frequency */
                /** * pqremove ** */
                n = s.heap[1];
                /* SMALLEST */
                s.heap[1] = s.heap[s.heap_len--];
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
                /***/
                m = s.heap[1];
                /* SMALLEST */
                /* m = node of next least frequency */
                s.heap[--s.heap_max] = n;
                /* keep the nodes sorted by frequency */
                s.heap[--s.heap_max] = m;
                /* Create a new node father of n and m */
                tree[node * 2] =
                    /* .Freq */
                    tree[n * 2] +
                        /* .Freq */
                        tree[m * 2];
                /* .Freq */
                s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                tree[n * 2 + 1] =
                    /* .Dad */
                    tree[m * 2 + 1] =
                        /* .Dad */
                        node;
                /* and insert the new node in the heap */
                s.heap[1] = node++;
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
            } while (s.heap_len >= 2);
            s.heap[--s.heap_max] = s.heap[1];
            /* SMALLEST */
            /* At this point, the fields freq and dad are set. We can now
             * generate the bit lengths.
             */
            gen_bitlen(s, desc);
            /* The field len is now set, we can generate the bit codes */
            gen_codes(tree, max_code, s.bl_count);
        };
        /* ===========================================================================
         * Scan a literal or distance tree to determine the frequencies of the codes
         * in the bit length tree.
         */
        var scan_tree = function scan_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree;   /* the tree to be scanned */
        //    int max_code;    /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            tree[(max_code + 1) * 2 + 1] =
                /* .Len */
                0xffff;
            /* guard */
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    s.bl_tree[curlen * 2] +=
                        /* .Freq */
                        count;
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        s.bl_tree[curlen * 2] /* .Freq */++;
                    }
                    s.bl_tree[REP_3_6 * 2] /* .Freq */++;
                }
                else if (count <= 10) {
                    s.bl_tree[REPZ_3_10 * 2] /* .Freq */++;
                }
                else {
                    s.bl_tree[REPZ_11_138 * 2] /* .Freq */++;
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Send a literal or distance tree in compressed form, using the codes in
         * bl_tree.
         */
        var send_tree = function send_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree; /* the tree to be scanned */
        //    int max_code;       /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            /* tree[max_code+1].Len = -1; */
            /* guard already set */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    do {
                        send_code(s, curlen, s.bl_tree);
                    } while (--count !== 0);
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        send_code(s, curlen, s.bl_tree);
                        count--;
                    } // Assert(count >= 3 && count <= 6, " 3_6?");
                    send_code(s, REP_3_6, s.bl_tree);
                    send_bits(s, count - 3, 2);
                }
                else if (count <= 10) {
                    send_code(s, REPZ_3_10, s.bl_tree);
                    send_bits(s, count - 3, 3);
                }
                else {
                    send_code(s, REPZ_11_138, s.bl_tree);
                    send_bits(s, count - 11, 7);
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Construct the Huffman tree for the bit lengths and return the index in
         * bl_order of the last bit length code to send.
         */
        var build_bl_tree = function build_bl_tree(s) {
            var max_blindex;
            /* index of last bit length code of non zero freq */
            /* Determine the bit length frequencies for literal and distance trees */
            scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
            scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
            /* Build the bit length tree: */
            build_tree(s, s.bl_desc);
            /* opt_len now includes the length of the tree representations, except
             * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
             */
            /* Determine the number of bit length codes to send. The pkzip format
             * requires that at least 4 bit length codes be sent. (appnote.txt says
             * 3 but the actual value used is 4.)
             */
            for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
                if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !==
                    /* .Len */
                    0) {
                    break;
                }
            }
            /* Update opt_len to include the bit length tree and counts */
            s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; // Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
            //        s->opt_len, s->static_len));
            return max_blindex;
        };
        /* ===========================================================================
         * Send the header for a block using dynamic Huffman trees: the counts, the
         * lengths of the bit length codes, the literal tree and the distance tree.
         * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
         */
        var send_all_trees = function send_all_trees(s, lcodes, dcodes, blcodes //    deflate_state *s; //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
        ) {
            var rank;
            /* index in bl_order */
            // Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
            // Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
            //        "too many codes");
            // Tracev((stderr, "\nbl counts: "));
            send_bits(s, lcodes - 257, 5);
            /* not +255 as stated in appnote.txt */
            send_bits(s, dcodes - 1, 5);
            send_bits(s, blcodes - 4, 4);
            /* not -3 as stated in appnote.txt */
            for (rank = 0; rank < blcodes; rank++) {
                // Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 
                /* .Len */
                3);
            } // Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_ltree, lcodes - 1);
            /* literal tree */
            // Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_dtree, dcodes - 1);
            /* distance tree */
            // Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
        };
        /* ===========================================================================
         * Check if the data type is TEXT or BINARY, using the following algorithm:
         * - TEXT if the two conditions below are satisfied:
         *    a) There are no non-portable control characters belonging to the
         *       "black list" (0..6, 14..25, 28..31).
         *    b) There is at least one printable character belonging to the
         *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
         * - BINARY otherwise.
         * - The following partially-portable control characters form a
         *   "gray list" that is ignored in this detection algorithm:
         *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
         * IN assertion: the fields Freq of dyn_ltree are set.
         */
        var detect_data_type = function detect_data_type(s) {
            /* black_mask is the bit mask of black-listed bytes
             * set bits 0..6, 14..25, and 28..31
             * 0xf3ffc07f = binary 11110011111111111100000001111111
             */
            var black_mask = 0xf3ffc07f;
            var n;
            /* Check for non-textual ("black-listed") bytes. */
            for (n = 0; n <= 31; n++, black_mask >>>= 1) {
                if (black_mask & 1 &&
                    s.dyn_ltree[n * 2] !==
                        /* .Freq */
                        0) {
                    return Z_BINARY;
                }
            }
            /* Check for textual ("white-listed") bytes. */
            if (s.dyn_ltree[9 * 2] !==
                /* .Freq */
                0 ||
                s.dyn_ltree[10 * 2] !==
                    /* .Freq */
                    0 ||
                s.dyn_ltree[13 * 2] !==
                    /* .Freq */
                    0) {
                return Z_TEXT;
            }
            for (n = 32; n < LITERALS; n++) {
                if (s.dyn_ltree[n * 2] !==
                    /* .Freq */
                    0) {
                    return Z_TEXT;
                }
            }
            /* There are no "black-listed" or "white-listed" bytes:
             * this stream either is empty or has tolerated ("gray-listed") bytes only.
             */
            return Z_BINARY;
        };
        var static_init_done = false;
        /* ===========================================================================
         * Initialize the tree data structures for a new zlib stream.
         */
        var _tr_init = function _tr_init(s) {
            if (!static_init_done) {
                tr_static_init();
                static_init_done = true;
            }
            s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
            s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
            s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
            s.bi_buf = 0;
            s.bi_valid = 0;
            /* Initialize the first block of the first file: */
            init_block(s);
        };
        /* ===========================================================================
         * Send a stored block
         */
        var _tr_stored_block = function _tr_stored_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
            /* send block type */
            copy_block(s, buf, stored_len, true);
            /* with header */
        };
        /* ===========================================================================
         * Send one empty static block to give enough lookahead for inflate.
         * This takes 10 bits, of which 7 may remain in the bit buffer.
         */
        var _tr_align = function _tr_align(s) {
            send_bits(s, STATIC_TREES << 1, 3);
            send_code(s, END_BLOCK, static_ltree);
            bi_flush(s);
        };
        /* ===========================================================================
         * Determine the best encoding for the current block: dynamic trees, static
         * trees or store, and output the encoded block to the zip file.
         */
        var _tr_flush_block = function _tr_flush_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block, or NULL if too old */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            var opt_lenb;
            var static_lenb;
            /* opt_len and static_len in bytes */
            var max_blindex = 0;
            /* index of last bit length code of non zero freq */
            /* Build the Huffman trees unless a stored block is forced */
            if (s.level > 0) {
                /* Check if the file is binary or text */
                if (s.strm.data_type === Z_UNKNOWN) {
                    s.strm.data_type = detect_data_type(s);
                }
                /* Construct the literal and distance trees */
                build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                /* At this point, opt_len and static_len are the total bit lengths of
                 * the compressed block data, excluding the tree representations.
                 */
                /* Build the bit length tree for the above two trees, and get the index
                 * in bl_order of the last bit length code to send.
                 */
                max_blindex = build_bl_tree(s);
                /* Determine the best encoding. Compute the block lengths in bytes. */
                opt_lenb = (s.opt_len + 3 + 7) >>> 3;
                static_lenb = (s.static_len + 3 + 7) >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                //        s->last_lit));
                if (static_lenb <= opt_lenb) {
                    opt_lenb = static_lenb;
                }
            }
            else {
                // Assert(buf != (char*)0, "lost buf");
                opt_lenb = static_lenb = stored_len + 5;
                /* force a stored block */
            }
            if (stored_len + 4 <= opt_lenb && buf !== -1) {
                /* 4: two words for the lengths */
                /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
                 * Otherwise we can't have processed more than WSIZE input bytes since
                 * the last block flush, because compression would have been
                 * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
                 * transform a block into a stored block.
                 */
                _tr_stored_block(s, buf, stored_len, last);
            }
            else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                compress_block(s, static_ltree, static_dtree);
            }
            else {
                send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                compress_block(s, s.dyn_ltree, s.dyn_dtree);
            } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
            /* The above check is made mod 2^32, for files larger than 512 MB
             * and uLong implemented on 32 bits.
             */
            init_block(s);
            if (last) {
                bi_windup(s);
            } // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
            //       s->compressed_len-7*last));
        };
        /* ===========================================================================
         * Save the match info and tally the frequency counts. Return true if
         * the current block must be flushed.
         */
        var _tr_tally = function _tr_tally(s, dist, lc
        //    deflate_state *s;
        //    unsigned dist;  /* distance of matched string */
        //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
        ) {
            // let out_length, in_length, dcode;
            s.pending_buf[s.d_buf + s.last_lit * 2] = (dist >>> 8) & 0xff;
            s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
            s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
            s.last_lit++;
            if (dist === 0) {
                /* lc is the unmatched char */
                s.dyn_ltree[lc * 2] /* .Freq */++;
            }
            else {
                s.matches++;
                /* Here, lc is the match length - MIN_MATCH */
                dist--;
                /* dist = match distance - 1 */
                // Assert((ush)dist < (ush)MAX_DIST(s) &&
                //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /* .Freq */++;
                s.dyn_dtree[d_code(dist) * 2] /* .Freq */++;
            } // (!) This block is disabled in zlib defaults,
            // don't enable it for binary compatibility
            // #ifdef TRUNCATE_BLOCK
            //  /* Try to guess if it is profitable to stop the current block here */
            //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
            //    /* Compute an upper bound for the compressed length */
            //    out_length = s.last_lit*8;
            //    in_length = s.strstart - s.block_start;
            //
            //    for (dcode = 0; dcode < D_CODES; dcode++) {
            //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
            //    }
            //    out_length >>>= 3;
            //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
            //    //       s->last_lit, in_length, out_length,
            //    //       100L - out_length*100L/in_length));
            //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
            //      return true;
            //    }
            //  }
            // #endif
            return s.last_lit === s.lit_bufsize - 1;
            /* We avoid equality with lit_bufsize because of wraparound at 64K
             * on 16 bit machines and because stored blocks are restricted to
             * 64K-1 bytes.
             */
        };
        var _tr_init_1 = _tr_init;
        var _tr_stored_block_1 = _tr_stored_block;
        var _tr_flush_block_1 = _tr_flush_block;
        var _tr_tally_1 = _tr_tally;
        var _tr_align_1 = _tr_align;
        var trees = {
            _tr_init: _tr_init_1,
            _tr_stored_block: _tr_stored_block_1,
            _tr_flush_block: _tr_flush_block_1,
            _tr_tally: _tr_tally_1,
            _tr_align: _tr_align_1,
        };
        // It isn't worth it to make additional optimizations as in original.
        // Small size is preferable.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var adler32 = function adler32(adler, buf, len, pos) {
            var s1 = (adler & 0xffff) | 0;
            var s2 = ((adler >>> 16) & 0xffff) | 0;
            var n = 0;
            while (len !== 0) {
                // Set limit ~ twice less than 5552, to keep
                // s2 in 31-bits, because we force signed ints.
                // in other case %= will fail.
                n = len > 2000 ? 2000 : len;
                len -= n;
                do {
                    s1 = (s1 + buf[pos++]) | 0;
                    s2 = (s2 + s1) | 0;
                } while (--n);
                s1 %= 65521;
                s2 %= 65521;
            }
            return s1 | (s2 << 16) | 0;
        };
        var adler32_1 = adler32;
        // So write code to minimize size - no pregenerated tables
        // and array tools dependencies.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        // Use ordinary array, since untyped makes no boost here
        var makeTable = function makeTable() {
            var c;
            var table = [];
            for (var n = 0; n < 256; n++) {
                c = n;
                for (var k = 0; k < 8; k++) {
                    c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
                }
                table[n] = c;
            }
            return table;
        }; // Create table on load. Just 255 signed longs. Not a problem.
        var crcTable = new Uint32Array(makeTable());
        var crc32 = function crc32(crc, buf, len, pos) {
            var t = crcTable;
            var end = pos + len;
            crc ^= -1;
            for (var i = pos; i < end; i++) {
                crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xff];
            }
            return crc ^ -1; // >>> 0;
        };
        var crc32_1 = crc32;
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var messages = {
            2: 'need dictionary',
            /* Z_NEED_DICT       2  */
            1: 'stream end',
            /* Z_STREAM_END      1  */
            0: '',
            /* Z_OK              0  */
            '-1': 'file error',
            /* Z_ERRNO         (-1) */
            '-2': 'stream error',
            /* Z_STREAM_ERROR  (-2) */
            '-3': 'data error',
            /* Z_DATA_ERROR    (-3) */
            '-4': 'insufficient memory',
            /* Z_MEM_ERROR     (-4) */
            '-5': 'buffer error',
            /* Z_BUF_ERROR     (-5) */
            '-6': 'incompatible version',
            /* Z_VERSION_ERROR (-6) */
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var constants = {
            /* Allowed flush values; see deflate() and inflate() below for details */
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            /* Return codes for the compression/decompression functions. Negative values
             * are errors, positive values are used for special but normal events.
             */
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_MEM_ERROR: -4,
            Z_BUF_ERROR: -5,
            // Z_VERSION_ERROR: -6,
            /* compression levels */
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            /* Possible values of the data_type field (though see inflate()) */
            Z_BINARY: 0,
            Z_TEXT: 1,
            // Z_ASCII:                1, // = Z_TEXT (deprecated)
            Z_UNKNOWN: 2,
            /* The deflate compression method */
            Z_DEFLATED: 8, // Z_NULL:                 null // Use -1 or null inline, depending on var type
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var _tr_init$1 = trees._tr_init;
        var _tr_stored_block$1 = trees._tr_stored_block;
        var _tr_flush_block$1 = trees._tr_flush_block;
        var _tr_tally$1 = trees._tr_tally;
        var _tr_align$1 = trees._tr_align;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH = constants.Z_NO_FLUSH;
        var Z_PARTIAL_FLUSH = constants.Z_PARTIAL_FLUSH;
        var Z_FULL_FLUSH = constants.Z_FULL_FLUSH;
        var Z_FINISH = constants.Z_FINISH;
        var Z_BLOCK = constants.Z_BLOCK;
        var Z_OK = constants.Z_OK;
        var Z_STREAM_END = constants.Z_STREAM_END;
        var Z_STREAM_ERROR = constants.Z_STREAM_ERROR;
        var Z_DATA_ERROR = constants.Z_DATA_ERROR;
        var Z_BUF_ERROR = constants.Z_BUF_ERROR;
        var Z_DEFAULT_COMPRESSION = constants.Z_DEFAULT_COMPRESSION;
        var Z_FILTERED = constants.Z_FILTERED;
        var Z_HUFFMAN_ONLY = constants.Z_HUFFMAN_ONLY;
        var Z_RLE = constants.Z_RLE;
        var Z_FIXED$1 = constants.Z_FIXED;
        var Z_DEFAULT_STRATEGY = constants.Z_DEFAULT_STRATEGY;
        var Z_UNKNOWN$1 = constants.Z_UNKNOWN;
        var Z_DEFLATED = constants.Z_DEFLATED;
        /* ============================================================================ */
        var MAX_MEM_LEVEL = 9;
        /* Maximum value for memLevel in deflateInit2 */
        var MAX_WBITS = 15;
        /* 32K LZ77 window */
        var DEF_MEM_LEVEL = 8;
        var LENGTH_CODES$1 = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS$1 = 256;
        /* number of literal bytes 0..255 */
        var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES$1 = 30;
        /* number of distance codes */
        var BL_CODES$1 = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
        /* maximum heap size */
        var MAX_BITS$1 = 15;
        /* All codes must not exceed MAX_BITS bits */
        var MIN_MATCH$1 = 3;
        var MAX_MATCH$1 = 258;
        var MIN_LOOKAHEAD = MAX_MATCH$1 + MIN_MATCH$1 + 1;
        var PRESET_DICT = 0x20;
        var INIT_STATE = 42;
        var EXTRA_STATE = 69;
        var NAME_STATE = 73;
        var COMMENT_STATE = 91;
        var HCRC_STATE = 103;
        var BUSY_STATE = 113;
        var FINISH_STATE = 666;
        var BS_NEED_MORE = 1;
        /* block not completed, need more input or more output */
        var BS_BLOCK_DONE = 2;
        /* block flush performed */
        var BS_FINISH_STARTED = 3;
        /* finish started, need only more output at next deflate */
        var BS_FINISH_DONE = 4;
        /* finish done, accept no more input or output */
        var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
        var err = function err(strm, errorCode) {
            strm.msg = messages[errorCode];
            return errorCode;
        };
        var rank = function rank(f) {
            return (f << 1) - (f > 4 ? 9 : 0);
        };
        var zero$1 = function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        };
        var HASH_ZLIB = function HASH_ZLIB(s, prev, data) {
            return ((prev << s.hash_shift) ^ data) & s.hash_mask;
        }; // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
        // But breaks binary compatibility
        // let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
        var HASH = HASH_ZLIB;
        /* =========================================================================
         * Flush as much pending output as possible. All deflate() output goes
         * through this function so some applications may wish to modify it
         * to avoid allocating a large strm->output buffer and copying into it.
         * (See also read_buf()).
         */
        var flush_pending = function flush_pending(strm) {
            var s = strm.state; // _tr_flush_bits(s);
            var len = s.pending;
            if (len > strm.avail_out) {
                len = strm.avail_out;
            }
            if (len === 0) {
                return;
            }
            strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
            strm.next_out += len;
            s.pending_out += len;
            strm.total_out += len;
            strm.avail_out -= len;
            s.pending -= len;
            if (s.pending === 0) {
                s.pending_out = 0;
            }
        };
        var flush_block_only = function flush_block_only(s, last) {
            _tr_flush_block$1(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
            s.block_start = s.strstart;
            flush_pending(s.strm);
        };
        var put_byte = function put_byte(s, b) {
            s.pending_buf[s.pending++] = b;
        };
        /* =========================================================================
         * Put a short in the pending buffer. The 16-bit value is put in MSB order.
         * IN assertion: the stream state is correct and there is enough room in
         * pending_buf.
         */
        var putShortMSB = function putShortMSB(s, b) {
            //  put_byte(s, (Byte)(b >> 8));
            //  put_byte(s, (Byte)(b & 0xff));
            s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
            s.pending_buf[s.pending++] = b & 0xff;
        };
        /* ===========================================================================
         * Read a new buffer from the current input stream, update the adler32
         * and total number of bytes read.  All deflate() input goes through
         * this function so some applications may wish to modify it to avoid
         * allocating a large strm->input buffer and copying from it.
         * (See also flush_pending()).
         */
        var read_buf = function read_buf(strm, buf, start, size) {
            var len = strm.avail_in;
            if (len > size) {
                len = size;
            }
            if (len === 0) {
                return 0;
            }
            strm.avail_in -= len; // zmemcpy(buf, strm->next_in, len);
            buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
            if (strm.state.wrap === 1) {
                strm.adler = adler32_1(strm.adler, buf, len, start);
            }
            else if (strm.state.wrap === 2) {
                strm.adler = crc32_1(strm.adler, buf, len, start);
            }
            strm.next_in += len;
            strm.total_in += len;
            return len;
        };
        /* ===========================================================================
         * Set match_start to the longest match starting at the given string and
         * return its length. Matches shorter or equal to prev_length are discarded,
         * in which case the result is equal to prev_length and match_start is
         * garbage.
         * IN assertions: cur_match is the head of the hash chain for the current
         *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
         * OUT assertion: the match length is not greater than s->lookahead.
         */
        var longest_match = function longest_match(s, cur_match) {
            var chain_length = s.max_chain_length;
            /* max hash chain length */
            var scan = s.strstart;
            /* current string */
            var match;
            /* matched string */
            var len;
            /* length of current match */
            var best_len = s.prev_length;
            /* best match length so far */
            var nice_match = s.nice_match;
            /* stop if match long enough */
            var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
            /* NIL */
            var _win = s.window; // shortcut
            var wmask = s.w_mask;
            var prev = s.prev;
            /* Stop when cur_match becomes <= limit. To simplify the code,
             * we prevent matches with the string of window index 0.
             */
            var strend = s.strstart + MAX_MATCH$1;
            var scan_end1 = _win[scan + best_len - 1];
            var scan_end = _win[scan + best_len];
            /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
             * It is easy to get rid of this optimization if necessary.
             */
            // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
            /* Do not waste too much time if we already have a good match: */
            if (s.prev_length >= s.good_match) {
                chain_length >>= 2;
            }
            /* Do not look for matches beyond the end of the input. This is necessary
             * to make deflate deterministic.
             */
            if (nice_match > s.lookahead) {
                nice_match = s.lookahead;
            } // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
            do {
                // Assert(cur_match < s->strstart, "no future");
                match = cur_match;
                /* Skip to next match if the match length cannot increase
                 * or if the match length is less than 2.  Note that the checks below
                 * for insufficient lookahead only occur occasionally for performance
                 * reasons.  Therefore uninitialized memory will be accessed, and
                 * conditional jumps will be made that depend on those values.
                 * However the length of the match is limited to the lookahead, so
                 * the output of deflate is not affected by the uninitialized values.
                 */
                if (_win[match + best_len] !== scan_end ||
                    _win[match + best_len - 1] !== scan_end1 ||
                    _win[match] !== _win[scan] ||
                    _win[++match] !== _win[scan + 1]) {
                    continue;
                }
                /* The check at best_len-1 can be removed because it will be made
                 * again later. (This heuristic is not always a win.)
                 * It is not necessary to compare scan[2] and match[2] since they
                 * are always equal when the other bytes match, given that
                 * the hash keys are equal and that HASH_BITS >= 8.
                 */
                scan += 2;
                match++; // Assert(*scan == *match, "match[2]?");
                /* We check for insufficient lookahead only every 8th comparison;
                 * the 256th check will be made at strstart+258.
                 */
                do {
                    /* jshint noempty:false */
                } while (_win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                len = MAX_MATCH$1 - (strend - scan);
                scan = strend - MAX_MATCH$1;
                if (len > best_len) {
                    s.match_start = cur_match;
                    best_len = len;
                    if (len >= nice_match) {
                        break;
                    }
                    scan_end1 = _win[scan + best_len - 1];
                    scan_end = _win[scan + best_len];
                }
            } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
            if (best_len <= s.lookahead) {
                return best_len;
            }
            return s.lookahead;
        };
        /* ===========================================================================
         * Fill the window when the lookahead becomes insufficient.
         * Updates strstart and lookahead.
         *
         * IN assertion: lookahead < MIN_LOOKAHEAD
         * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
         *    At least one byte has been read, or avail_in == 0; reads are
         *    performed for at least two bytes (required for the zip translate_eol
         *    option -- not supported here).
         */
        var fill_window = function fill_window(s) {
            var _w_size = s.w_size;
            var p;
            var n;
            var m;
            var more;
            var str; // Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
            do {
                more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed
                /* Deal with !@#$% 64K limit: */
                // if (sizeof(int) <= 2) {
                //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                //        more = wsize;
                //
                //  } else if (more == (unsigned)(-1)) {
                //        /* Very unlikely, but possible on 16 bit machine if
                //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                //         */
                //        more--;
                //    }
                // }
                /* If the window is almost full and there is insufficient lookahead,
                 * move the upper half to the lower one to make room in the upper half.
                 */
                if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                    s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
                    s.match_start -= _w_size;
                    s.strstart -= _w_size;
                    /* we now have strstart >= MAX_DIST */
                    s.block_start -= _w_size;
                    /* Slide the hash table (could be avoided with 32 bit values
                   at the expense of memory usage). We slide even when level == 0
                   to keep the hash table consistent if we switch back to level > 0
                   later. (Using level 0 permanently is not an optimal usage of
                   zlib, so we don't care about this pathological case.)
                   */
                    n = s.hash_size;
                    p = n;
                    do {
                        m = s.head[--p];
                        s.head[p] = m >= _w_size ? m - _w_size : 0;
                    } while (--n);
                    n = _w_size;
                    p = n;
                    do {
                        m = s.prev[--p];
                        s.prev[p] = m >= _w_size ? m - _w_size : 0;
                        /* If n is not on any hash chain, prev[n] is garbage but
                         * its value will never be used.
                         */
                    } while (--n);
                    more += _w_size;
                }
                if (s.strm.avail_in === 0) {
                    break;
                }
                /* If there was no sliding:
                 *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
                 *    more == window_size - lookahead - strstart
                 * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
                 * => more >= window_size - 2*WSIZE + 2
                 * In the BIG_MEM or MMAP case (not yet supported),
                 *   window_size == input_size + MIN_LOOKAHEAD  &&
                 *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
                 * Otherwise, window_size == 2*WSIZE so more >= 2.
                 * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
                 */
                // Assert(more >= 2, "more < 2");
                n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                s.lookahead += n;
                /* Initialize the hash value now that we have some input: */
                if (s.lookahead + s.insert >= MIN_MATCH$1) {
                    str = s.strstart - s.insert;
                    s.ins_h = s.window[str];
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + 1]); // #if MIN_MATCH != 3
                    //        Call update_hash() MIN_MATCH-3 more times
                    // #endif
                    while (s.insert) {
                        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                        s.prev[str & s.w_mask] = s.head[s.ins_h];
                        s.head[s.ins_h] = str;
                        str++;
                        s.insert--;
                        if (s.lookahead + s.insert < MIN_MATCH$1) {
                            break;
                        }
                    }
                }
                /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
                 * but this is not important since only literal bytes will be emitted.
                 */
            } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
            /* If the WIN_INIT bytes after the end of the current data have never been
             * written, then zero those bytes in order to avoid memory check reports of
             * the use of uninitialized (or uninitialised as Julian writes) bytes by
             * the longest match routines.  Update the high water mark for the next
             * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
             * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
             */
            //  if (s.high_water < s.window_size) {
            //    const curr = s.strstart + s.lookahead;
            //    let init = 0;
            //
            //    if (s.high_water < curr) {
            //      /* Previous high water mark below current data -- zero WIN_INIT
            //       * bytes or up to end of window, whichever is less.
            //       */
            //      init = s.window_size - curr;
            //      if (init > WIN_INIT)
            //        init = WIN_INIT;
            //      zmemzero(s->window + curr, (unsigned)init);
            //      s->high_water = curr + init;
            //    }
            //    else if (s->high_water < (ulg)curr + WIN_INIT) {
            //      /* High water mark at or above current data, but below current data
            //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
            //       * to end of window, whichever is less.
            //       */
            //      init = (ulg)curr + WIN_INIT - s->high_water;
            //      if (init > s->window_size - s->high_water)
            //        init = s->window_size - s->high_water;
            //      zmemzero(s->window + s->high_water, (unsigned)init);
            //      s->high_water += init;
            //    }
            //  }
            //
            //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
            //    "not enough room for search");
        };
        /* ===========================================================================
         * Copy without compression as much as possible from the input stream, return
         * the current block state.
         * This function does not insert new strings in the dictionary since
         * uncompressible data is probably not useful. This function is used
         * only for the level=0 compression option.
         * NOTE: this function should be optimized to avoid extra copying from
         * window to pending_buf.
         */
        var deflate_stored = function deflate_stored(s, flush) {
            /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
             * to pending_buf_size, and each stored block has a 5 byte header:
             */
            var max_block_size = 0xffff;
            if (max_block_size > s.pending_buf_size - 5) {
                max_block_size = s.pending_buf_size - 5;
            }
            /* Copy as much as possible from input to output: */
            for (;;) {
                /* Fill the window as much as possible: */
                if (s.lookahead <= 1) {
                    // Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                    //  s->block_start >= (long)s->w_size, "slide too late");
                    //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                    //        s.block_start >= s.w_size)) {
                    //        throw  new Error("slide too late");
                    //      }
                    fill_window(s);
                    if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                } // Assert(s->block_start >= 0L, "block gone");
                //    if (s.block_start < 0) throw new Error("block gone");
                s.strstart += s.lookahead;
                s.lookahead = 0;
                /* Emit a stored block if pending_buf will be full: */
                var max_start = s.block_start + max_block_size;
                if (s.strstart === 0 || s.strstart >= max_start) {
                    /* strstart == 0 is possible when wraparound on 16-bit machine */
                    s.lookahead = s.strstart - max_start;
                    s.strstart = max_start;
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
                /* Flush if we may have to slide, otherwise block_start may become
                 * negative and the data will be gone:
                 */
                if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.strstart > s.block_start) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_NEED_MORE;
        };
        /* ===========================================================================
         * Compress as much as possible from the input stream, return the current
         * block state.
         * This function does not perform lazy evaluation of matches and inserts
         * new strings in the dictionary only for unmatched strings or for short
         * matches. It is used only for the fast compression options.
         */
        var deflate_fast = function deflate_fast(s, flush) {
            var hash_head;
            /* head of the hash chain */
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                        /* flush the current block */
                    }
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 * At this point we have always match_length < MIN_MATCH
                 */
                if (hash_head !== 0 &&
                    /* NIL */
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                }
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                    /** * _tr_tally_dist(s, s.strstart - s.match_start,
                                 s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    /* Insert new strings in the hash table only if the match length
                     * is not too large. This saves time but degrades compression.
                     */
                    if (s.match_length <= s.max_lazy_match &&
                        /* max_insert_length */
                        s.lookahead >= MIN_MATCH$1) {
                        s.match_length--;
                        /* string at strstart already in table */
                        do {
                            s.strstart++;
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                            /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                             * always MIN_MATCH bytes ahead.
                             */
                        } while (--s.match_length !== 0);
                        s.strstart++;
                    }
                    else {
                        s.strstart += s.match_length;
                        s.match_length = 0;
                        s.ins_h = s.window[s.strstart];
                        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]); // #if MIN_MATCH != 3
                        //                Call UPDATE_HASH() MIN_MATCH-3 more times
                        // #endif
                        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
                         * matter since it will be recomputed at next deflate call.
                         */
                    }
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s.window[s.strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * Same as above, but achieves better compression. We use a lazy
         * evaluation for matches: a match is finally adopted only if there is
         * no better match at the next window position.
         */
        var deflate_slow = function deflate_slow(s, flush) {
            var hash_head;
            /* head of hash chain */
            var bflush;
            /* set if current block must be flushed */
            var max_insert;
            /* Process the input block. */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 */
                s.prev_length = s.match_length;
                s.prev_match = s.match_start;
                s.match_length = MIN_MATCH$1 - 1;
                if (hash_head !== 0 &&
                    /* NIL */
                    s.prev_length < s.max_lazy_match &&
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
                /* MAX_DIST(s) */
                ) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                    if (s.match_length <= 5 &&
                        (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096))
                    /* TOO_FAR */
                    ) {
                        /* If prev_match is also MIN_MATCH, match_start is garbage
                         * but we will ignore the current match anyway.
                         */
                        s.match_length = MIN_MATCH$1 - 1;
                    }
                }
                /* If there was a match at the previous step and the current
                 * match is not better, output the previous match:
                 */
                if (s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
                    max_insert = s.strstart + s.lookahead - MIN_MATCH$1;
                    /* Do not insert strings in hash table beyond this. */
                    // check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                    /** *_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                                 s.prev_length - MIN_MATCH, bflush);** */
                    bflush = _tr_tally$1(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1);
                    /* Insert in hash table all strings up to the end of the match.
                     * strstart-1 and strstart are already inserted. If there is not
                     * enough lookahead, the last two strings are not inserted in
                     * the hash table.
                     */
                    s.lookahead -= s.prev_length - 1;
                    s.prev_length -= 2;
                    do {
                        if (++s.strstart <= max_insert) {
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                        }
                    } while (--s.prev_length !== 0);
                    s.match_available = 0;
                    s.match_length = MIN_MATCH$1 - 1;
                    s.strstart++;
                    if (bflush) {
                        /** * FLUSH_BLOCK(s, 0); ** */
                        flush_block_only(s, false);
                        if (s.strm.avail_out === 0) {
                            return BS_NEED_MORE;
                        }
                        /***/
                    }
                }
                else if (s.match_available) {
                    /* If there was no match at the previous position, output a
                     * single literal. If there was a match but the current match
                     * is longer, truncate the previous match to a single literal.
                     */
                    // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                    /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                    if (bflush) {
                        /** * FLUSH_BLOCK_ONLY(s, 0) ** */
                        flush_block_only(s, false);
                        /***/
                    }
                    s.strstart++;
                    s.lookahead--;
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                }
                else {
                    /* There is no previous match to compare with, wait for
                     * the next step to decide.
                     */
                    s.match_available = 1;
                    s.strstart++;
                    s.lookahead--;
                }
            } // Assert (flush != Z_NO_FLUSH, "no flush?");
            if (s.match_available) {
                // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                s.match_available = 0;
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_RLE, simply look for runs of bytes, generate matches only of distance
         * one.  Do not maintain a hash table.  (It will be regenerated if this run of
         * deflate switches away from Z_RLE.)
         */
        var deflate_rle = function deflate_rle(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            var prev;
            /* byte at distance one to match */
            var scan;
            var strend;
            /* scan goes up to strend for length of run */
            var _win = s.window;
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the longest run, plus one for the unrolled loop.
                 */
                if (s.lookahead <= MAX_MATCH$1) {
                    fill_window(s);
                    if (s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* See how many times the previous byte repeats */
                s.match_length = 0;
                if (s.lookahead >= MIN_MATCH$1 && s.strstart > 0) {
                    scan = s.strstart - 1;
                    prev = _win[scan];
                    if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                        strend = s.strstart + MAX_MATCH$1;
                        do {
                            /* jshint noempty:false */
                        } while (prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            scan < strend);
                        s.match_length = MAX_MATCH$1 - (strend - scan);
                        if (s.match_length > s.lookahead) {
                            s.match_length = s.lookahead;
                        }
                    } // Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                }
                /* Emit match if have run of MIN_MATCH or longer, else emit literal */
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.strstart - 1, s.match_length);
                    /** * _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, 1, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    s.strstart += s.match_length;
                    s.match_length = 0;
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s->window[s->strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
         * (It will be regenerated if this run of deflate switches away from Huffman.)
         */
        var deflate_huff = function deflate_huff(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we have a literal to write. */
                if (s.lookahead === 0) {
                    fill_window(s);
                    if (s.lookahead === 0) {
                        if (flush === Z_NO_FLUSH) {
                            return BS_NEED_MORE;
                        }
                        break;
                        /* flush the current block */
                    }
                }
                /* Output a literal byte */
                s.match_length = 0; // Tracevv((stderr,"%c", s->window[s->strstart]));
                /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                s.lookahead--;
                s.strstart++;
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* Values for max_lazy_match, good_match and max_chain_length, depending on
         * the desired pack level (0..9). The values given below have been tuned to
         * exclude worst case performance for pathological files. Better values may be
         * found for specific files.
         */
        function Config(good_length, max_lazy, nice_length, max_chain, func) {
            this.good_length = good_length;
            this.max_lazy = max_lazy;
            this.nice_length = nice_length;
            this.max_chain = max_chain;
            this.func = func;
        }
        var configuration_table = [
            /*      good lazy nice chain */
            new Config(0, 0, 0, 0, deflate_stored),
            /* 0 store only */
            new Config(4, 4, 8, 4, deflate_fast),
            /* 1 max speed, no lazy matches */
            new Config(4, 5, 16, 8, deflate_fast),
            /* 2 */
            new Config(4, 6, 32, 32, deflate_fast),
            /* 3 */
            new Config(4, 4, 16, 16, deflate_slow),
            /* 4 lazy matches */
            new Config(8, 16, 32, 32, deflate_slow),
            /* 5 */
            new Config(8, 16, 128, 128, deflate_slow),
            /* 6 */
            new Config(8, 32, 128, 256, deflate_slow),
            /* 7 */
            new Config(32, 128, 258, 1024, deflate_slow),
            /* 8 */
            new Config(32, 258, 258, 4096, deflate_slow),
            /* 9 max compression */
        ];
        /* ===========================================================================
         * Initialize the "longest match" routines for a new zlib stream
         */
        var lm_init = function lm_init(s) {
            s.window_size = 2 * s.w_size;
            /** * CLEAR_HASH(s); ** */
            zero$1(s.head); // Fill with NIL (= 0);
            /* Set the default configuration parameters:
             */
            s.max_lazy_match = configuration_table[s.level].max_lazy;
            s.good_match = configuration_table[s.level].good_length;
            s.nice_match = configuration_table[s.level].nice_length;
            s.max_chain_length = configuration_table[s.level].max_chain;
            s.strstart = 0;
            s.block_start = 0;
            s.lookahead = 0;
            s.insert = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            s.ins_h = 0;
        };
        function DeflateState() {
            this.strm = null;
            /* pointer back to this zlib stream */
            this.status = 0;
            /* as the name implies */
            this.pending_buf = null;
            /* output still pending */
            this.pending_buf_size = 0;
            /* size of pending_buf */
            this.pending_out = 0;
            /* next pending byte to output to the stream */
            this.pending = 0;
            /* nb of bytes in the pending buffer */
            this.wrap = 0;
            /* bit 0 true for zlib, bit 1 true for gzip */
            this.gzhead = null;
            /* gzip header information to write */
            this.gzindex = 0;
            /* where in extra, name, or comment */
            this.method = Z_DEFLATED;
            /* can only be DEFLATED */
            this.last_flush = -1;
            /* value of flush param for previous deflate call */
            this.w_size = 0;
            /* LZ77 window size (32K by default) */
            this.w_bits = 0;
            /* log2(w_size)  (8..16) */
            this.w_mask = 0;
            /* w_size - 1 */
            this.window = null;
            /* Sliding window. Input bytes are read into the second half of the window,
             * and move to the first half later to keep a dictionary of at least wSize
             * bytes. With this organization, matches are limited to a distance of
             * wSize-MAX_MATCH bytes, but this ensures that IO is always
             * performed with a length multiple of the block size.
             */
            this.window_size = 0;
            /* Actual size of window: 2*wSize, except when the user input buffer
             * is directly used as sliding window.
             */
            this.prev = null;
            /* Link to older string with same hash index. To limit the size of this
             * array to 64K, this link is maintained only for the last 32K strings.
             * An index in this array is thus a window index modulo 32K.
             */
            this.head = null;
            /* Heads of the hash chains or NIL. */
            this.ins_h = 0;
            /* hash index of string to be inserted */
            this.hash_size = 0;
            /* number of elements in hash table */
            this.hash_bits = 0;
            /* log2(hash_size) */
            this.hash_mask = 0;
            /* hash_size-1 */
            this.hash_shift = 0;
            /* Number of bits by which ins_h must be shifted at each input
             * step. It must be such that after MIN_MATCH steps, the oldest
             * byte no longer takes part in the hash key, that is:
             *   hash_shift * MIN_MATCH >= hash_bits
             */
            this.block_start = 0;
            /* Window position at the beginning of the current output block. Gets
             * negative when the window is moved backwards.
             */
            this.match_length = 0;
            /* length of best match */
            this.prev_match = 0;
            /* previous match */
            this.match_available = 0;
            /* set if previous match exists */
            this.strstart = 0;
            /* start of string to insert */
            this.match_start = 0;
            /* start of matching string */
            this.lookahead = 0;
            /* number of valid bytes ahead in window */
            this.prev_length = 0;
            /* Length of the best match at previous step. Matches not greater than this
             * are discarded. This is used in the lazy match evaluation.
             */
            this.max_chain_length = 0;
            /* To speed up deflation, hash chains are never searched beyond this
             * length.  A higher limit improves compression ratio but degrades the
             * speed.
             */
            this.max_lazy_match = 0;
            /* Attempt to find a better match only when the current match is strictly
             * smaller than this value. This mechanism is used only for compression
             * levels >= 4.
             */
            // That's alias to max_lazy_match, don't use directly
            // this.max_insert_length = 0;
            /* Insert new strings in the hash table only if the match length is not
             * greater than this length. This saves time but degrades compression.
             * max_insert_length is used only for compression levels <= 3.
             */
            this.level = 0;
            /* compression level (1..9) */
            this.strategy = 0;
            /* favor or force Huffman coding */
            this.good_match = 0;
            /* Use a faster search when the previous match is longer than this */
            this.nice_match = 0;
            /* Stop searching when current match exceeds this */
            /* used by trees.c: */
            /* Didn't use ct_data typedef below to suppress compiler warning */
            // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
            // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
            // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
            // Use flat array of DOUBLE size, with interleaved fata,
            // because JS does not support effective
            this.dyn_ltree = new Uint16Array(HEAP_SIZE$1 * 2);
            this.dyn_dtree = new Uint16Array((2 * D_CODES$1 + 1) * 2);
            this.bl_tree = new Uint16Array((2 * BL_CODES$1 + 1) * 2);
            zero$1(this.dyn_ltree);
            zero$1(this.dyn_dtree);
            zero$1(this.bl_tree);
            this.l_desc = null;
            /* desc. for literal tree */
            this.d_desc = null;
            /* desc. for distance tree */
            this.bl_desc = null;
            /* desc. for bit length tree */
            // ush bl_count[MAX_BITS+1];
            this.bl_count = new Uint16Array(MAX_BITS$1 + 1);
            /* number of codes at each bit length for an optimal tree */
            // int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
            this.heap = new Uint16Array(2 * L_CODES$1 + 1);
            /* heap used to build the Huffman trees */
            zero$1(this.heap);
            this.heap_len = 0;
            /* number of elements in the heap */
            this.heap_max = 0;
            /* element of largest frequency */
            /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
             * The same heap array is used to build all trees.
             */
            this.depth = new Uint16Array(2 * L_CODES$1 + 1); // uch depth[2*L_CODES+1];
            zero$1(this.depth);
            /* Depth of each subtree used as tie breaker for trees of equal frequency
             */
            this.l_buf = 0;
            /* buffer index for literals or lengths */
            this.lit_bufsize = 0;
            /* Size of match buffer for literals/lengths.  There are 4 reasons for
             * limiting lit_bufsize to 64K:
             *   - frequencies can be kept in 16 bit counters
             *   - if compression is not successful for the first block, all input
             *     data is still in the window so we can still emit a stored block even
             *     when input comes from standard input.  (This can also be done for
             *     all blocks if lit_bufsize is not greater than 32K.)
             *   - if compression is not successful for a file smaller than 64K, we can
             *     even emit a stored file instead of a stored block (saving 5 bytes).
             *     This is applicable only for zip (not gzip or zlib).
             *   - creating new Huffman trees less frequently may not provide fast
             *     adaptation to changes in the input data statistics. (Take for
             *     example a binary file with poorly compressible code followed by
             *     a highly compressible string table.) Smaller buffer sizes give
             *     fast adaptation but have of course the overhead of transmitting
             *     trees more frequently.
             *   - I can't count above 4
             */
            this.last_lit = 0;
            /* running index in l_buf */
            this.d_buf = 0;
            /* Buffer index for distances. To simplify the code, d_buf and l_buf have
             * the same number of elements. To use different lengths, an extra flag
             * array would be necessary.
             */
            this.opt_len = 0;
            /* bit length of current block with optimal trees */
            this.static_len = 0;
            /* bit length of current block with static trees */
            this.matches = 0;
            /* number of string matches in current block */
            this.insert = 0;
            /* bytes at end of window left to insert */
            this.bi_buf = 0;
            /* Output buffer. bits are inserted starting at the bottom (least
             * significant bits).
             */
            this.bi_valid = 0;
            /* Number of valid bits in bi_buf.  All bits above the last valid bit
             * are always zero.
             */
            // Used for window memory init. We safely ignore it for JS. That makes
            // sense only for pointers and memory check tools.
            // this.high_water = 0;
            /* High water mark offset in window for initialized bytes -- bytes above
             * this are set to zero in order to avoid memory check warnings when
             * longest match routines access bytes past the input.  This is then
             * updated to the new high water mark.
             */
        }
        var deflateResetKeep = function deflateResetKeep(strm) {
            if (!strm || !strm.state) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.total_in = strm.total_out = 0;
            strm.data_type = Z_UNKNOWN$1;
            var s = strm.state;
            s.pending = 0;
            s.pending_out = 0;
            if (s.wrap < 0) {
                s.wrap = -s.wrap;
                /* was made negative by deflate(..., Z_FINISH); */
            }
            s.status = s.wrap ? INIT_STATE : BUSY_STATE;
            strm.adler =
                s.wrap === 2
                    ? 0 // crc32(0, Z_NULL, 0)
                    : 1; // adler32(0, Z_NULL, 0)
            s.last_flush = Z_NO_FLUSH;
            _tr_init$1(s);
            return Z_OK;
        };
        var deflateReset = function deflateReset(strm) {
            var ret = deflateResetKeep(strm);
            if (ret === Z_OK) {
                lm_init(strm.state);
            }
            return ret;
        };
        var deflateSetHeader = function deflateSetHeader(strm, head) {
            if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
            }
            if (strm.state.wrap !== 2) {
                return Z_STREAM_ERROR;
            }
            strm.state.gzhead = head;
            return Z_OK;
        };
        var deflateInit2 = function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
            if (!strm) {
                // === Z_NULL
                return Z_STREAM_ERROR;
            }
            var wrap = 1;
            if (level === Z_DEFAULT_COMPRESSION) {
                level = 6;
            }
            if (windowBits < 0) {
                /* suppress zlib wrapper */
                wrap = 0;
                windowBits = -windowBits;
            }
            else if (windowBits > 15) {
                wrap = 2;
                /* write gzip wrapper instead */
                windowBits -= 16;
            }
            if (memLevel < 1 ||
                memLevel > MAX_MEM_LEVEL ||
                method !== Z_DEFLATED ||
                windowBits < 8 ||
                windowBits > 15 ||
                level < 0 ||
                level > 9 ||
                strategy < 0 ||
                strategy > Z_FIXED$1) {
                return err(strm, Z_STREAM_ERROR);
            }
            if (windowBits === 8) {
                windowBits = 9;
            }
            /* until 256-byte window bug fixed */
            var s = new DeflateState();
            strm.state = s;
            s.strm = strm;
            s.wrap = wrap;
            s.gzhead = null;
            s.w_bits = windowBits;
            s.w_size = 1 << s.w_bits;
            s.w_mask = s.w_size - 1;
            s.hash_bits = memLevel + 7;
            s.hash_size = 1 << s.hash_bits;
            s.hash_mask = s.hash_size - 1;
            s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1);
            s.window = new Uint8Array(s.w_size * 2);
            s.head = new Uint16Array(s.hash_size);
            s.prev = new Uint16Array(s.w_size); // Don't need mem init magic for JS.
            // s.high_water = 0;  /* nothing written to s->window yet */
            s.lit_bufsize = 1 << (memLevel + 6);
            /* 16K elements by default */
            s.pending_buf_size = s.lit_bufsize * 4;
            // overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
            // s->pending_buf = (uchf *) overlay;
            // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
            s.pending_buf = new Uint8Array(s.pending_buf_size);
            // s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
            s.d_buf = 1 * s.lit_bufsize; // s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
            s.l_buf = (1 + 2) * s.lit_bufsize;
            s.level = level;
            s.strategy = strategy;
            s.method = method;
            return deflateReset(strm);
        };
        var deflateInit = function deflateInit(strm, level) {
            return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
        };
        var deflate = function deflate(strm, flush) {
            var beg;
            var val; // for gzip header write only
            if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
                return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
            }
            var s = strm.state;
            if (!strm.output || (!strm.input && strm.avail_in !== 0) || (s.status === FINISH_STATE && flush !== Z_FINISH)) {
                return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
            }
            s.strm = strm;
            /* just in case */
            var old_flush = s.last_flush;
            s.last_flush = flush;
            /* Write the header */
            if (s.status === INIT_STATE) {
                if (s.wrap === 2) {
                    // GZIP header
                    strm.adler = 0; // crc32(0L, Z_NULL, 0);
                    put_byte(s, 31);
                    put_byte(s, 139);
                    put_byte(s, 8);
                    if (!s.gzhead) {
                        // s->gzhead == Z_NULL
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, OS_CODE);
                        s.status = BUSY_STATE;
                    }
                    else {
                        put_byte(s, (s.gzhead.text ? 1 : 0) +
                            (s.gzhead.hcrc ? 2 : 0) +
                            (!s.gzhead.extra ? 0 : 4) +
                            (!s.gzhead.name ? 0 : 8) +
                            (!s.gzhead.comment ? 0 : 16));
                        put_byte(s, s.gzhead.time & 0xff);
                        put_byte(s, (s.gzhead.time >> 8) & 0xff);
                        put_byte(s, (s.gzhead.time >> 16) & 0xff);
                        put_byte(s, (s.gzhead.time >> 24) & 0xff);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, s.gzhead.os & 0xff);
                        if (s.gzhead.extra && s.gzhead.extra.length) {
                            put_byte(s, s.gzhead.extra.length & 0xff);
                            put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
                        }
                        if (s.gzhead.hcrc) {
                            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
                        }
                        s.gzindex = 0;
                        s.status = EXTRA_STATE;
                    }
                } // DEFLATE header
                else {
                    var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
                    var level_flags = -1;
                    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                        level_flags = 0;
                    }
                    else if (s.level < 6) {
                        level_flags = 1;
                    }
                    else if (s.level === 6) {
                        level_flags = 2;
                    }
                    else {
                        level_flags = 3;
                    }
                    header |= level_flags << 6;
                    if (s.strstart !== 0) {
                        header |= PRESET_DICT;
                    }
                    header += 31 - (header % 31);
                    s.status = BUSY_STATE;
                    putShortMSB(s, header);
                    /* Save the adler32 of the preset dictionary: */
                    if (s.strstart !== 0) {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    strm.adler = 1; // adler32(0L, Z_NULL, 0);
                }
            } // #ifdef GZIP
            if (s.status === EXTRA_STATE) {
                if (s.gzhead.extra
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                break;
                            }
                        }
                        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                        s.gzindex++;
                    }
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (s.gzindex === s.gzhead.extra.length) {
                        s.gzindex = 0;
                        s.status = NAME_STATE;
                    }
                }
                else {
                    s.status = NAME_STATE;
                }
            }
            if (s.status === NAME_STATE) {
                if (s.gzhead.name
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.name.length) {
                            val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.gzindex = 0;
                        s.status = COMMENT_STATE;
                    }
                }
                else {
                    s.status = COMMENT_STATE;
                }
            }
            if (s.status === COMMENT_STATE) {
                if (s.gzhead.comment
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.comment.length) {
                            val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.status = HCRC_STATE;
                    }
                }
                else {
                    s.status = HCRC_STATE;
                }
            }
            if (s.status === HCRC_STATE) {
                if (s.gzhead.hcrc) {
                    if (s.pending + 2 > s.pending_buf_size) {
                        flush_pending(strm);
                    }
                    if (s.pending + 2 <= s.pending_buf_size) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, (strm.adler >> 8) & 0xff);
                        strm.adler = 0; // crc32(0L, Z_NULL, 0);
                        s.status = BUSY_STATE;
                    }
                }
                else {
                    s.status = BUSY_STATE;
                }
            } // #endif
            /* Flush as much pending output as possible */
            if (s.pending !== 0) {
                flush_pending(strm);
                if (strm.avail_out === 0) {
                    /* Since avail_out is 0, deflate will be called again with
                     * more output space, but possibly with both pending and
                     * avail_in equal to zero. There won't be anything to do,
                     * but this is not an error situation so make sure we
                     * return OK instead of BUF_ERROR at next call of deflate:
                     */
                    s.last_flush = -1;
                    return Z_OK;
                }
                /* Make sure there is something to do and avoid duplicate consecutive
                 * flushes. For repeated and useless calls with Z_FINISH, we keep
                 * returning Z_STREAM_END instead of Z_BUF_ERROR.
                 */
            }
            else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
                return err(strm, Z_BUF_ERROR);
            }
            /* User must not provide more input after the first FINISH: */
            if (s.status === FINISH_STATE && strm.avail_in !== 0) {
                return err(strm, Z_BUF_ERROR);
            }
            /* Start a new block or continue the current one.
             */
            if (strm.avail_in !== 0 || s.lookahead !== 0 || (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
                var bstate = s.strategy === Z_HUFFMAN_ONLY
                    ? deflate_huff(s, flush)
                    : s.strategy === Z_RLE
                        ? deflate_rle(s, flush)
                        : configuration_table[s.level].func(s, flush);
                if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
                    s.status = FINISH_STATE;
                }
                if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR next call, see above */
                    }
                    return Z_OK;
                    /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
                     * of deflate should use the same flush parameter to make sure
                     * that the flush is complete. So we don't have to output an
                     * empty block here, this will be done at next call. This also
                     * ensures that for a very small output buffer, we emit at most
                     * one empty block.
                     */
                }
                if (bstate === BS_BLOCK_DONE) {
                    if (flush === Z_PARTIAL_FLUSH) {
                        _tr_align$1(s);
                    }
                    else if (flush !== Z_BLOCK) {
                        /* FULL_FLUSH or SYNC_FLUSH */
                        _tr_stored_block$1(s, 0, 0, false);
                        /* For a full flush, this empty block will be recognized
                         * as a special marker by inflate_sync().
                         */
                        if (flush === Z_FULL_FLUSH) {
                            /** * CLEAR_HASH(s); ** */
                            /* forget history */
                            zero$1(s.head); // Fill with NIL (= 0);
                            if (s.lookahead === 0) {
                                s.strstart = 0;
                                s.block_start = 0;
                                s.insert = 0;
                            }
                        }
                    }
                    flush_pending(strm);
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR at next call, see above */
                        return Z_OK;
                    }
                }
            } // Assert(strm->avail_out > 0, "bug2");
            // if (strm.avail_out <= 0) { throw new Error("bug2");}
            if (flush !== Z_FINISH) {
                return Z_OK;
            }
            if (s.wrap <= 0) {
                return Z_STREAM_END;
            }
            /* Write the trailer */
            if (s.wrap === 2) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, (strm.adler >> 8) & 0xff);
                put_byte(s, (strm.adler >> 16) & 0xff);
                put_byte(s, (strm.adler >> 24) & 0xff);
                put_byte(s, strm.total_in & 0xff);
                put_byte(s, (strm.total_in >> 8) & 0xff);
                put_byte(s, (strm.total_in >> 16) & 0xff);
                put_byte(s, (strm.total_in >> 24) & 0xff);
            }
            else {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            flush_pending(strm);
            /* If avail_out is zero, the application will call deflate again
             * to flush the rest.
             */
            if (s.wrap > 0) {
                s.wrap = -s.wrap;
            }
            /* write the trailer only once! */
            return s.pending !== 0 ? Z_OK : Z_STREAM_END;
        };
        var deflateEnd = function deflateEnd(strm) {
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var status = strm.state.status;
            if (status !== INIT_STATE &&
                status !== EXTRA_STATE &&
                status !== NAME_STATE &&
                status !== COMMENT_STATE &&
                status !== HCRC_STATE &&
                status !== BUSY_STATE &&
                status !== FINISH_STATE) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.state = null;
            return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
        };
        /* =========================================================================
         * Initializes the compression dictionary from the given byte
         * sequence without producing any compressed output.
         */
        var deflateSetDictionary = function deflateSetDictionary(strm, dictionary) {
            var dictLength = dictionary.length;
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var s = strm.state;
            var wrap = s.wrap;
            if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
                return Z_STREAM_ERROR;
            }
            /* when using zlib wrappers, compute Adler-32 for provided dictionary */
            if (wrap === 1) {
                /* adler32(strm->adler, dictionary, dictLength); */
                strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
            }
            s.wrap = 0;
            /* avoid computing Adler-32 in read_buf */
            /* if dictionary would fill window, just replace the history */
            if (dictLength >= s.w_size) {
                if (wrap === 0) {
                    /* already empty otherwise */
                    /** * CLEAR_HASH(s); ** */
                    zero$1(s.head); // Fill with NIL (= 0);
                    s.strstart = 0;
                    s.block_start = 0;
                    s.insert = 0;
                }
                /* use the tail */
                // dictionary = dictionary.slice(dictLength - s.w_size);
                var tmpDict = new Uint8Array(s.w_size);
                tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
                dictionary = tmpDict;
                dictLength = s.w_size;
            }
            /* insert dictionary into window and hash */
            var avail = strm.avail_in;
            var next = strm.next_in;
            var input = strm.input;
            strm.avail_in = dictLength;
            strm.next_in = 0;
            strm.input = dictionary;
            fill_window(s);
            while (s.lookahead >= MIN_MATCH$1) {
                var str = s.strstart;
                var n = s.lookahead - (MIN_MATCH$1 - 1);
                do {
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                    s.prev[str & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = str;
                    str++;
                } while (--n);
                s.strstart = str;
                s.lookahead = MIN_MATCH$1 - 1;
                fill_window(s);
            }
            s.strstart += s.lookahead;
            s.block_start = s.strstart;
            s.insert = s.lookahead;
            s.lookahead = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            strm.next_in = next;
            strm.input = input;
            strm.avail_in = avail;
            s.wrap = wrap;
            return Z_OK;
        };
        var deflateInit_1 = deflateInit;
        var deflateInit2_1 = deflateInit2;
        var deflateReset_1 = deflateReset;
        var deflateResetKeep_1 = deflateResetKeep;
        var deflateSetHeader_1 = deflateSetHeader;
        var deflate_2 = deflate;
        var deflateEnd_1 = deflateEnd;
        var deflateSetDictionary_1 = deflateSetDictionary;
        var deflateInfo = 'pako deflate (from Nodeca project)';
        /* Not implemented
      module.exports.deflateBound = deflateBound;
      module.exports.deflateCopy = deflateCopy;
      module.exports.deflateParams = deflateParams;
      module.exports.deflatePending = deflatePending;
      module.exports.deflatePrime = deflatePrime;
      module.exports.deflateTune = deflateTune;
      */
        var deflate_1 = {
            deflateInit: deflateInit_1,
            deflateInit2: deflateInit2_1,
            deflateReset: deflateReset_1,
            deflateResetKeep: deflateResetKeep_1,
            deflateSetHeader: deflateSetHeader_1,
            deflate: deflate_2,
            deflateEnd: deflateEnd_1,
            deflateSetDictionary: deflateSetDictionary_1,
            deflateInfo: deflateInfo,
        };
        // Join array of chunks to single array.
        function flattenChunks(chunks) {
            // calculate data length
            var len = 0;
            for (var i = 0, l = chunks.length; i < l; i++) {
                len += chunks[i].length;
            } // join chunks
            var result = new Uint8Array(len);
            for (var _i = 0, pos = 0, _l = chunks.length; _i < _l; _i++) {
                var chunk = chunks[_i];
                result.set(chunk, pos);
                pos += chunk.length;
            }
            return result;
        }
        // String encode/decode helpers
        //
        // - apply(Array) can fail on Android 2.2
        // - apply(Uint8Array) can fail on iOS 5.1 Safari
        //
        // Table with utf8 lengths (calculated by first byte of sequence)
        // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
        // because max possible codepoint is 0x10ffff
        var _utf8len = new Uint8Array(256);
        for (var q = 0; q < 256; q++) {
            _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
        }
        _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
        // convert string to array (typed, when possible)
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        function ZStream() {
            /* next input byte */
            this.input = null; // JS specific, because we have no pointers
            this.next_in = 0;
            /* number of bytes available at input */
            this.avail_in = 0;
            /* total number of input bytes read so far */
            this.total_in = 0;
            /* next output byte should be put there */
            this.output = null; // JS specific, because we have no pointers
            this.next_out = 0;
            /* remaining free space at output */
            this.avail_out = 0;
            /* total number of bytes output so far */
            this.total_out = 0;
            /* last error message, NULL if no error */
            this.msg = '';
            /* Z_NULL */
            /* not visible by applications */
            this.state = null;
            /* best guess about the data type: binary or text */
            this.data_type = 2;
            /* Z_UNKNOWN */
            /* adler32 value of the uncompressed data */
            this.adler = 0;
        }
        var zstream = ZStream;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var toString = Object.prototype.toString;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH$1 = constants.Z_NO_FLUSH;
        var Z_SYNC_FLUSH = constants.Z_SYNC_FLUSH;
        var Z_FULL_FLUSH$1 = constants.Z_FULL_FLUSH;
        var Z_FINISH$1 = constants.Z_FINISH;
        var Z_OK$1 = constants.Z_OK;
        var Z_STREAM_END$1 = constants.Z_STREAM_END;
        var Z_DEFAULT_COMPRESSION$1 = constants.Z_DEFAULT_COMPRESSION;
        var Z_DEFAULT_STRATEGY$1 = constants.Z_DEFAULT_STRATEGY;
        var Z_DEFLATED$1 = constants.Z_DEFLATED;
        /* =========================================================================== */
        /**
         * class Deflate
         *
         * Generic JS-style wrapper for zlib calls. If you don't need
         * streaming behaviour - use more simple functions: [[deflate]],
         * [[deflateRaw]] and [[gzip]].
         * */
        /* internal
         * Deflate.chunks -> Array
         *
         * Chunks of output data, if [[Deflate#onData]] not overridden.
         * */
        /**
         * Deflate.result -> Uint8Array
         *
         * Compressed result, generated by default [[Deflate#onData]]
         * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
         * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
         * */
        /**
         * Deflate.err -> Number
         *
         * Error code after deflate finished. 0 (Z_OK) on success.
         * You will not need it in real life, because deflate errors
         * are possible only on wrong options or bad `onData` / `onEnd`
         * custom handlers.
         * */
        /**
         * Deflate.msg -> String
         *
         * Error message, if [[Deflate.err]] != 0
         * */
        /**
         * new Deflate(options)
         * - options (Object): zlib deflate options.
         *
         * Creates new deflator instance with specified params. Throws exception
         * on bad params. Supported options:
         *
         * - `level`
         * - `windowBits`
         * - `memLevel`
         * - `strategy`
         * - `dictionary`
         *
         * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
         * for more information on these.
         *
         * Additional options, for internal needs:
         *
         * * `chunkSize` - size of generated data chunks (16K by default)
         * * `raw` (Boolean) - do raw deflate
         * * `gzip` (Boolean) - create gzip wrapper
         * * `header` (Object) - custom header for gzip
         * ** `text` (Boolean) - true if compressed data believed to be text
         * ** `time` (Number) - modification time, unix timestamp
         * ** `os` (Number) - operation system code
         * ** `extra` (Array) - array of bytes with extra data (max 65536)
         * ** `name` (String) - file name (binary string)
         * ** `comment` (String) - comment (binary string)
         * ** `hcrc` (Boolean) - true if header crc should be added
         *
         * ##### Example:
         *
         * ```javascript
         * const pako = require('pako')
         *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
         *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
         *
         * const deflate = new pako.Deflate({ level: 3});
         *
         * deflate.push(chunk1, false);
         * deflate.push(chunk2, true);  // true -> last chunk
         *
         * if (deflate.err) { throw new Error(deflate.err); }
         *
         * console.log(deflate.result);
         * ```
         * */
        function Deflate() {
            this.options = {
                level: Z_DEFAULT_COMPRESSION$1,
                method: Z_DEFLATED$1,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: Z_DEFAULT_STRATEGY$1,
            };
            var opt = this.options;
            if (opt.raw && opt.windowBits > 0) {
                opt.windowBits = -opt.windowBits;
            }
            else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
                opt.windowBits += 16;
            }
            this.err = 0; // error code, if happens (0 = Z_OK)
            this.msg = ''; // error message
            this.ended = false; // used to avoid multiple onEnd() calls
            this.chunks = []; // chunks of compressed data
            this.strm = new zstream();
            this.strm.avail_out = 0;
            var status = deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
            if (status !== Z_OK$1) {
                throw new Error(messages[status]);
            }
            if (opt.header) {
                deflate_1.deflateSetHeader(this.strm, opt.header);
            }
            if (opt.dictionary) {
                var dict; // Convert data if needed
                if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
                    dict = new Uint8Array(opt.dictionary);
                }
                else {
                    dict = opt.dictionary;
                }
                status = deflate_1.deflateSetDictionary(this.strm, dict);
                if (status !== Z_OK$1) {
                    throw new Error(messages[status]);
                }
                this._dict_set = true;
            }
        }
        /**
         * Deflate#push(data[, flush_mode]) -> Boolean
         * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
         * converted to utf8 byte sequence.
         * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
         * See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
         *
         * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
         * new compressed chunks. Returns `true` on success. The last data block must
         * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
         * buffers and call [[Deflate#onEnd]].
         *
         * On fail call [[Deflate#onEnd]] with error code and return false.
         *
         * ##### Example
         *
         * ```javascript
         * push(chunk, false); // push one of data chunks
         * ...
         * push(chunk, true);  // push last chunk
         * ```
         * */
        Deflate.prototype.push = function (data, flush_mode) {
            var strm = this.strm;
            var chunkSize = this.options.chunkSize;
            var status;
            var _flush_mode;
            if (this.ended) {
                return false;
            }
            if (flush_mode === ~~flush_mode) {
                _flush_mode = flush_mode;
            }
            else {
                _flush_mode = flush_mode === true ? Z_FINISH$1 : Z_NO_FLUSH$1;
            } // Convert data if needed
            if (toString.call(data) === '[object ArrayBuffer]') {
                strm.input = new Uint8Array(data);
            }
            else {
                strm.input = data;
            }
            strm.next_in = 0;
            strm.avail_in = strm.input.length;
            for (;;) {
                if (strm.avail_out === 0) {
                    strm.output = new Uint8Array(chunkSize);
                    strm.next_out = 0;
                    strm.avail_out = chunkSize;
                } // Make sure avail_out > 6 to avoid repeating markers
                if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH$1) && strm.avail_out <= 6) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                status = deflate_1.deflate(strm, _flush_mode); // Ended => flush and finish
                if (status === Z_STREAM_END$1) {
                    if (strm.next_out > 0) {
                        this.onData(strm.output.subarray(0, strm.next_out));
                    }
                    status = deflate_1.deflateEnd(this.strm);
                    this.onEnd(status);
                    this.ended = true;
                    return status === Z_OK$1;
                } // Flush if out buffer full
                if (strm.avail_out === 0) {
                    this.onData(strm.output);
                    continue;
                } // Flush if requested and has data
                if (_flush_mode > 0 && strm.next_out > 0) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                if (strm.avail_in === 0) {
                    break;
                }
            }
            return true;
        };
        /**
         * Deflate#onData(chunk) -> Void
         * - chunk (Uint8Array): output data.
         *
         * By default, stores data blocks in `chunks[]` property and glue
         * those in `onEnd`. Override this handler, if you need another behaviour.
         * */
        Deflate.prototype.onData = function (chunk) {
            this.chunks.push(chunk);
        };
        /**
         * Deflate#onEnd(status) -> Void
         * - status (Number): deflate status. 0 (Z_OK) on success,
         * other if not.
         *
         * Called once after you tell deflate that the input stream is
         * complete (Z_FINISH). By default - join collected chunks,
         * free memory and fill `results` / `err` properties.
         * */
        Deflate.prototype.onEnd = function (status) {
            // On success - join
            if (status === Z_OK$1) {
                this.result = flattenChunks(this.chunks);
            }
            this.chunks = [];
            this.err = status;
            this.msg = this.strm.msg;
        };
        // https://github.com/nodeca/pako/blob/26dff4fb3472c5532b3bd8856421146d35ab7592/lib/utils/strings.js#L26
        function string2buf(str) {
            if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
                return new TextEncoder().encode(str);
            }
            var buf;
            var c;
            var c2;
            var m_pos;
            var i;
            var str_len = str.length;
            var buf_len = 0;
            // count binary size
            for (m_pos = 0; m_pos < str_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
            }
            // allocate buffer
            buf = new Uint8Array(buf_len);
            // convert
            for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                if (c < 0x80) {
                    /* one byte */
                    buf[i++] = c;
                }
                else if (c < 0x800) {
                    /* two bytes */
                    buf[i++] = 0xc0 | (c >>> 6);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else if (c < 0x10000) {
                    /* three bytes */
                    buf[i++] = 0xe0 | (c >>> 12);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else {
                    /* four bytes */
                    buf[i++] = 0xf0 | (c >>> 18);
                    buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
            }
            return buf;
        }
        return { Deflate: Deflate, constants: constants, string2buf: string2buf };
    }
}
//# sourceMappingURL=deflateWorker.js.map

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRecorderApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_replayStats__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_getSessionReplayLink__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_segmentCollection__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isBrowserSupported__ = __webpack_require__(825);





function makeRecorderApi(startRecordingImpl, startDeflateWorkerImpl) {
    if (startDeflateWorkerImpl === void 0) { startDeflateWorkerImpl = __WEBPACK_IMPORTED_MODULE_3__domain_segmentCollection__["b" /* startDeflateWorker */]; }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["B" /* canUseEventBridge */])() || !Object(__WEBPACK_IMPORTED_MODULE_4__isBrowserSupported__["a" /* isBrowserSupported */])()) {
        return {
            start: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */],
            stop: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */],
            getReplayStats: function () { return undefined; },
            onRumStart: __WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_35" /* noop */],
            isRecording: function () { return false; },
            getSessionReplayLink: function () { return undefined; },
        };
    }
    var state = {
        status: 0 /* RecorderStatus.Stopped */,
    };
    var startStrategy = function () {
        state = { status: 1 /* RecorderStatus.IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* RecorderStatus.Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getReplayStats: __WEBPACK_IMPORTED_MODULE_1__domain_replayStats__["d" /* getReplayStats */],
        getSessionReplayLink: function (configuration, sessionManager, viewContexts) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__domain_getSessionReplayLink__["a" /* getSessionReplayLink */])(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */);
        },
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts) {
            lifeCycle.subscribe(7 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    stopStrategy();
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                }
            });
            lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
                if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.sessionReplayAllowed) {
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    return;
                }
                state = { status: 2 /* RecorderStatus.Starting */ };
                Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_core__["_43" /* runOnReadyState */])('interactive', function () {
                    if (state.status !== 2 /* RecorderStatus.Starting */) {
                        return;
                    }
                    startDeflateWorkerImpl(function (worker) {
                        if (state.status !== 2 /* RecorderStatus.Starting */) {
                            return;
                        }
                        if (!worker) {
                            state = {
                                status: 0 /* RecorderStatus.Stopped */,
                            };
                            return;
                        }
                        var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, worker).stop;
                        state = {
                            status: 3 /* RecorderStatus.Started */,
                            stopRecording: stopRecording,
                        };
                    });
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* RecorderStatus.Stopped */) {
                    return;
                }
                if (state.status === 3 /* RecorderStatus.Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* RecorderStatus.Stopped */,
                };
            };
            if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () { return state.status === 3 /* RecorderStatus.Started */; },
    };
}
//# sourceMappingURL=recorderApi.js.map

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSessionReplayLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boot_isBrowserSupported__ = __webpack_require__(825);


function getSessionReplayLink(configuration, sessionManager, viewContexts, isRecordingStarted) {
    var session = sessionManager.findTrackedSession();
    var errorType = getErrorType(session, isRecordingStarted);
    var viewContext = viewContexts.findView();
    return Object(__WEBPACK_IMPORTED_MODULE_0__datadog_browser_rum_core__["e" /* getSessionReplayUrl */])(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session,
    });
}
function getErrorType(session, isRecordingStarted) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__boot_isBrowserSupported__["a" /* isBrowserSupported */])()) {
        return 'browser-not-supported';
    }
    if (!session) {
        // possibilities:
        // - rum sampled out
        // - session expired (edge case)
        return 'rum-not-tracked';
    }
    if (!session.sessionReplayAllowed) {
        // possibilities
        // - replay sampled out
        return 'incorrect-session-plan';
    }
    if (!isRecordingStarted) {
        return 'replay-not-started';
    }
}
//# sourceMappingURL=getSessionReplayLink.js.map

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_alert__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_alert_style_index_js__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AdminSideNav__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout_less__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Layout_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_layouts_GeneralHeader__ = __webpack_require__(222);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var Content = __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Content;
var AdminLayout = /** @class */ (function (_super) {
    __extends(AdminLayout, _super);
    function AdminLayout(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_9_src_utils_BindThisHelper__["a" /* default */])(_this, AdminLayout.prototype);
        _this.state = {
            emulationInfo: null
        };
        return _this;
    }
    AdminLayout.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */], { className: "admin" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_src_layouts_GeneralHeader__["a" /* default */], { renderEmulationBanner: true, renderFullscreenToggle: true, renderLanguageToggle: true, renderAudioToggle: false, renderPlanetBox: false, renderBackToSpaceStation: false }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */], { className: "has-side-nav" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__AdminSideNav__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, null, this.props.children)));
    };
    return AdminLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        isEmulating: state.User.isEmulating,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_10_react_localize_redux__["d" /* withLocalize */])(AdminLayout)));


/***/ }),
/* 2042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_menu__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_menu_style_index_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SideNav_less__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SideNav_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__SideNav_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

 // Connecting to Redux














var Sider = __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Sider;
var AdminSideNav = /** @class */ (function (_super) {
    __extends(AdminSideNav, _super);
    function AdminSideNav(props) {
        var _this = _super.call(this, props) || this;
        _this.kuderAdminMenuConfig = [
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_CLIENTS, iconClass: "fas fa-users", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.clientsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_USERS, true), iconClass: "far fa-id-badge", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.adminsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_UNIVERSAL_USER_SEARCH, iconClass: "fas fa-fingerprint", text: "Universal User Search" },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_REPORTS, iconClass: "fas fa-scroll", text: "Reports", subConfigs: [
                    { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_REPORTS, iconClass: "fas fa-scroll", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.reportsText" }) },
                ] },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_MATCHMAKER, iconClass: "fas fa-file-alt", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.matchmakerText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_SYNC_MATCHMAKER_DATA, iconClass: "fas fa-sync-alt", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.syncMatchmakerDataText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_SYNC_MANAGEMENT, iconClass: "fas fa-sync", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.syncManagement.pageTitle" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_ACTIVITIES, iconClass: "fas fa-pencil-alt", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.activitiesText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_STATEMENTS, iconClass: "fas fa-comment-dots", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.iStatementsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].GAME_HOME, iconClass: "fab fa-nintendo-switch", text: "Game Home" },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_STUDENT_VIEWS, iconClass: "fas fa-binoculars", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.studentViews.header" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_RESOURCES, iconClass: "far fa-copy", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.resources.header" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_LESSON_PLANS, iconClass: "far fa-copy", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.lessonPlans.title" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_HOLLAND_AREAS_GUIDE, iconClass: "far fa-id-card", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "common.hollandAreas" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_OCCUPATIONDB, iconClass: "far fa-id-card", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "public.occupationdb.title" }) }
        ];
        _this.stateAdminMenuConfig = [
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_DISTRICTS, iconClass: "fas fa-network-wired", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.districtsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_USERS, true), iconClass: "far fa-id-badge", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.adminsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_ACADEMICS, iconClass: "fas fa-graduation-cap", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.academicsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_STATEMENTS, iconClass: "fas fa-comment-dots", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.iStatementsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_STUDENT_VIEWS, iconClass: "fas fa-binoculars", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.studentViews.header" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_RESOURCES, iconClass: "far fa-copy", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.resources.header" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_LESSON_PLANS, iconClass: "far fa-copy", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.lessonPlans.title" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_HOLLAND_AREAS_GUIDE, iconClass: "far fa-id-card", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "common.hollandAreas" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_OCCUPATIONDB, iconClass: "far fa-id-card", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "public.occupationdb.title" }) }
        ];
        _this.districtAdminMenuConfig = [
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_SCHOOLS, iconClass: "fas fa-school", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.schoolsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_USERS, true), iconClass: "far fa-id-badge", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.adminsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_USERS, false), iconClass: "fas fa-child", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.studentsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_REPORTS, iconClass: "fas fa-scroll", text: "Reports", subConfigs: [
                    { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_REPORT_SUPERINTENDENT, iconClass: "fas fa-file-alt", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.superintendentReport" }) },
                ] },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_ACADEMICS, iconClass: "fas fa-graduation-cap", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.academicsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_STATEMENTS, iconClass: "fas fa-comment-dots", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.iStatementsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_STUDENT_VIEWS, iconClass: "fas fa-binoculars", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.studentViews.header" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_RESOURCES, iconClass: "far fa-copy", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.resources.header" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_LESSON_PLANS, iconClass: "far fa-copy", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.lessonPlans.title" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_HOLLAND_AREAS_GUIDE, iconClass: "far fa-id-card", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "common.hollandAreas" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_OCCUPATIONDB, iconClass: "far fa-id-card", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "public.occupationdb.title" }) }
        ];
        _this.schoolAdminMenuConfig = [
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_CLASSROOMS, iconClass: "fas fa-bell", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.classroomsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_USERS, true), iconClass: "far fa-id-badge", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.adminsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_USERS, false), iconClass: "fas fa-child", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.studentsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_REPORTS, iconClass: "fas fa-scroll", text: "Reports", subConfigs: [
                    { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_REPORT_PRINCIPAL, iconClass: "fas fa-file-alt", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.principalReport" }) },
                    { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_REPORT_STUDENT_ACTIVITY_DETAIL, iconClass: "fas fa-chart-bar", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.activityDetailReport" }) },
                    { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_REPORT_STUDENT_PLANET_COMPLETION, iconClass: "fas fa-globe", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.planetCompletionReport" }) },
                    { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_REPORT_STUDENT_GAME_COMPLETION, iconClass: "fas fa-gamepad", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.gameCompletionReport" }) },
                    { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_REPORT_STUDENT_STATEMENT, iconClass: "fas fa-info", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.statementReport" }) },
                ] },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_ACADEMICS, iconClass: "fas fa-graduation-cap", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.academicsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_STATEMENTS, iconClass: "fas fa-comment-dots", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.iStatementsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_STUDENT_VIEWS, iconClass: "fas fa-binoculars", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.studentViews.header" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_RESOURCES, iconClass: "far fa-copy", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.resources.header" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_LESSON_PLANS, iconClass: "far fa-copy", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.lessonPlans.title" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_HOLLAND_AREAS_GUIDE, iconClass: "far fa-id-card", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "common.hollandAreas" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_OCCUPATIONDB, iconClass: "far fa-id-card", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "public.occupationdb.title" }) }
        ];
        _this.teacherCounselorAdminMenuConfig = [
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_CLASSROOMS, iconClass: "fas fa-bell", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.classroomsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_USERS, false), iconClass: "fas fa-child", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.studentsText" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_STUDENT_VIEWS, iconClass: "fas fa-binoculars", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.studentViews.header" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_RESOURCES, iconClass: "far fa-copy", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.resources.header" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_LESSON_PLANS, iconClass: "far fa-copy", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.lessonPlans.title" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_HOLLAND_AREAS_GUIDE, iconClass: "far fa-id-card", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "common.hollandAreas" }) },
            { route: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_OCCUPATIONDB, iconClass: "far fa-id-card", text: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "public.occupationdb.title" }) }
        ];
        Object(__WEBPACK_IMPORTED_MODULE_12_src_utils_BindThisHelper__["a" /* default */])(_this, AdminSideNav.prototype);
        _this.state = {
            selectedKey: "home"
        };
        return _this;
    }
    AdminSideNav.prototype.componentWillMount = function () {
        var role = __WEBPACK_IMPORTED_MODULE_14_src_constants_Roles__["a" /* Roles */].FindById(this.props.User.roleID);
        var pathname = this.props.location.pathname;
        this.coolUpdate(role, pathname);
    };
    AdminSideNav.prototype.findRouteConfig = function (routeConfigs, route) {
        var getRouteRecursive = function (route, routeConfigs) {
            var _a, _b;
            for (var _i = 0, routeConfigs_1 = routeConfigs; _i < routeConfigs_1.length; _i++) {
                var routeConfig = routeConfigs_1[_i];
                if (((_a = routeConfig.subConfigs) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    var q = getRouteRecursive(route, routeConfig.subConfigs);
                    if (q != null) {
                        return { selectedKey: q.selectedKey, openKeys: __spreadArrays([routeConfig.route], q.openKeys) };
                    }
                }
                if (((_b = routeConfig.route) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === route.toLowerCase()) {
                    return { selectedKey: routeConfig.route, openKeys: [] };
                }
            }
            return null;
        };
        return getRouteRecursive(route, routeConfigs);
    };
    AdminSideNav.prototype.getConfigByRole = function (role) {
        switch (role) {
            case __WEBPACK_IMPORTED_MODULE_14_src_constants_Roles__["a" /* Roles */].KuderAdmin:
                return { menuConfigs: this.kuderAdminMenuConfig, defaultRoute: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_CLIENTS };
            case __WEBPACK_IMPORTED_MODULE_14_src_constants_Roles__["a" /* Roles */].StateAdmin:
                return { menuConfigs: this.stateAdminMenuConfig, defaultRoute: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_DISTRICTS };
            case __WEBPACK_IMPORTED_MODULE_14_src_constants_Roles__["a" /* Roles */].DistrictAdmin:
                return { menuConfigs: this.districtAdminMenuConfig, defaultRoute: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_SCHOOLS };
            case __WEBPACK_IMPORTED_MODULE_14_src_constants_Roles__["a" /* Roles */].SchoolAdmin:
                return { menuConfigs: this.schoolAdminMenuConfig, defaultRoute: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_USERS, true) };
            case __WEBPACK_IMPORTED_MODULE_14_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin:
                return { menuConfigs: this.teacherCounselorAdminMenuConfig, defaultRoute: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].ADMIN_CLASSROOMS };
            default:
                console.error("Invalid role \"" + ((role === null || role === void 0 ? void 0 : role.name) || "unknown") + "\".");
                return null;
        }
    };
    AdminSideNav.prototype.coolUpdate = function (role, route) {
        var configByRoute = this.getConfigByRole(role);
        var routeConfig = this.findRouteConfig(configByRoute.menuConfigs, route || configByRoute.defaultRoute);
        // Update the selection
        this.setState(__assign({}, routeConfig));
    };
    AdminSideNav.prototype.updateSelection = function (selectedKey) {
        var role = __WEBPACK_IMPORTED_MODULE_14_src_constants_Roles__["a" /* Roles */].FindById(this.props.User.roleID);
        this.coolUpdate(role, selectedKey);
    };
    AdminSideNav.prototype.renderHome = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].BASE_ROUTE },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "home" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "common.home" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].BASE_ROUTE },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "home", className: "fas fa-home", "aria-label": "Home" }),
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "common.home" })));
    };
    AdminSideNav.prototype.renderContactUs = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_menu__["a" /* default */].Item, { key: "contact" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "http://kuder.com/contact-us" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "far fa-address-book" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "public.footer.contact" })));
    };
    AdminSideNav.prototype.renderMenuItems = function (routeConfig) {
        var _this = this;
        var _a;
        if (((_a = routeConfig.subConfigs) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_menu__["a" /* default */].SubMenu, { key: routeConfig.route, title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: routeConfig.iconClass }),
                    " ",
                    routeConfig.text) }, routeConfig.subConfigs.map(function (subConfig) { return (_this.renderMenuItems(subConfig)); }));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_menu__["a" /* default */].Item, { key: routeConfig.route },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["NavLink"], { to: routeConfig.route },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: routeConfig.iconClass }),
                " ",
                routeConfig.text));
    };
    AdminSideNav.prototype.render = function () {
        var _this = this;
        var role = __WEBPACK_IMPORTED_MODULE_14_src_constants_Roles__["a" /* Roles */].FindById(this.props.User.roleID);
        var config = this.getConfigByRole(role);
        var elements = config.menuConfigs.map(function (x) { return (_this.renderMenuItems(x)); });
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Sider, { width: "328px", breakpoint: "md", collapsedWidth: "0", className: "side-nav" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_menu__["a" /* default */], { mode: "inline", onSelect: function (param) { return _this.updateSelection(param.key); }, selectedKeys: [this.state.selectedKey], defaultOpenKeys: this.state.openKeys },
                this.renderHome(),
                elements,
                this.renderContactUs()));
    };
    return AdminSideNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["withRouter"])(AdminSideNav)));


/***/ }),
/* 2045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_steps__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_steps_style_index_js__ = __webpack_require__(2052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_dropdown__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_dropdown_style_index_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_menu__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_menu_style_index_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Box_less__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Box_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Box_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_constants_Checkpoints__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_redux_CheckpointActions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

















var Step = __WEBPACK_IMPORTED_MODULE_2_antd_es_steps__["a" /* default */].Step;
var IncompletePlanetPath = __webpack_require__(2054);
var PlanetBox = /** @class */ (function (_super) {
    __extends(PlanetBox, _super);
    function PlanetBox(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PlanetBox.prototype);
        _this.sortedPlanets = __spreadArrays(__WEBPACK_IMPORTED_MODULE_8_src_constants_Planets__["a" /* Planets */].All.sort(function (a, b) { return a.order - b.order; })); // Ensure order
        _this.state = {
            currentPlanet: null,
            furthestPlanet: null,
            requireRedirect: false,
            keyboardSelectedPlanet: null
        };
        return _this;
    }
    PlanetBox.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    PlanetBox.prototype.componentWillUnmount = function () {
        document.removeEventListener("keydown", this.handleKeyPress);
    };
    PlanetBox.prototype.handleKeyPress = function (event) {
        var selectedPlanet = __WEBPACK_IMPORTED_MODULE_8_src_constants_Planets__["a" /* Planets */].All.find(function (planet) { return planet.name === event.key.toUpperCase(); });
        if (selectedPlanet) {
            this.handlePlanetKeyPress(selectedPlanet);
        }
        else if (this.state.keyboardSelectedPlanet && ["1", "2", "3", "4"].includes(event.key)) {
            this.planetMenuSelected(event.key, this.state.keyboardSelectedPlanet.id);
        }
    };
    PlanetBox.prototype.handlePlanetKeyPress = function (selectedPlanet) {
        this.setState({ keyboardSelectedPlanet: selectedPlanet });
        var planetImg = document.getElementById('planet' + selectedPlanet.name);
        planetImg.click();
        var planetUL = document.getElementById('menu' + selectedPlanet.name);
        var menu = planetUL.parentElement;
        menu.style.left = planetImg.getBoundingClientRect().left + 10 + 'px';
        menu.style.top = '34px';
    };
    PlanetBox.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.Mission.current.planetId !== nextProps.Mission.current.planetId ||
            this.props.Mission.furthest.planetId !== nextProps.Mission.furthest.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    PlanetBox.prototype.deriveStateFromProps = function (newProps) {
        var currentPlanet = __WEBPACK_IMPORTED_MODULE_8_src_constants_Planets__["a" /* Planets */].FindById(newProps.Mission.current.planetId);
        var furthestPlanet = __WEBPACK_IMPORTED_MODULE_8_src_constants_Planets__["a" /* Planets */].FindById(newProps.Mission.furthest.planetId);
        this.setState({
            currentPlanet: currentPlanet,
            furthestPlanet: furthestPlanet,
        });
    };
    PlanetBox.prototype.planetMenuOnClick = function (e, selectedPlanet) {
        this.planetMenuSelected(e.key, selectedPlanet.id);
    };
    PlanetBox.prototype.planetMenuSelected = function (selection, selectedPlanetId) {
        var replayStart = {
            planetId: selectedPlanetId,
            checkpointId: 1,
            stepId: 1
        };
        var replayEnd = {
            planetId: selectedPlanetId,
            checkpointId: 2,
            stepId: 1
        };
        switch (selection) {
            case "1":
                replayStart.checkpointId = __WEBPACK_IMPORTED_MODULE_11_src_constants_Checkpoints__["a" /* Checkpoints */].Landing.id;
                replayEnd.checkpointId = __WEBPACK_IMPORTED_MODULE_11_src_constants_Checkpoints__["a" /* Checkpoints */].BetweenPlanets.id;
                break;
            case "2":
                replayStart.checkpointId = __WEBPACK_IMPORTED_MODULE_11_src_constants_Checkpoints__["a" /* Checkpoints */].Game.id;
                replayEnd.checkpointId = __WEBPACK_IMPORTED_MODULE_11_src_constants_Checkpoints__["a" /* Checkpoints */].PostGame.id;
                break;
            case "3":
                replayStart.checkpointId = __WEBPACK_IMPORTED_MODULE_11_src_constants_Checkpoints__["a" /* Checkpoints */].Video.id;
                replayEnd.checkpointId = __WEBPACK_IMPORTED_MODULE_11_src_constants_Checkpoints__["a" /* Checkpoints */].PreGame.id;
                break;
            case "4":
                replayStart.checkpointId = __WEBPACK_IMPORTED_MODULE_11_src_constants_Checkpoints__["a" /* Checkpoints */].Activity.id;
                replayEnd.checkpointId = __WEBPACK_IMPORTED_MODULE_11_src_constants_Checkpoints__["a" /* Checkpoints */].Badge.id;
                break;
            default:
                break;
        }
        this.props.startReplay(replayStart, replayEnd, __WEBPACK_IMPORTED_MODULE_14_src_core_Routes__["a" /* default */].STUDENT_HOME);
        this.setState({
            requireRedirect: true
        });
    };
    PlanetBox.prototype.addClass = function () {
    };
    PlanetBox.prototype.stepsProgress = function (iconDot, _a) {
        var _this = this;
        var index = _a.index, status = _a.status, title = _a.title, description = _a.description;
        var selectedPlanet = this.sortedPlanets[index];
        var isComplete = this.state.furthestPlanet.id - 1 >= index;
        if (isComplete) {
            var menu = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_menu__["a" /* default */], { id: "menu" + selectedPlanet.name, onClick: function (e) { return _this.planetMenuOnClick(e, selectedPlanet); }, onOpenChange: function (e) { return console.warn(e); }, onSelect: function (e) { return console.warn(e); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_menu__["a" /* default */].Item, { tabIndex: 2, key: "1" },
                    "1: ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_react_localize_redux__["b" /* Translate */], { id: "student.planetBox.restart" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_menu__["a" /* default */].Item, { tabIndex: 2, key: "2" },
                    "2: ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_react_localize_redux__["b" /* Translate */], { id: "student.planetBox.game" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_menu__["a" /* default */].Item, { tabIndex: 2, key: "3" },
                    "3: ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_react_localize_redux__["b" /* Translate */], { id: "student.planetBox.video" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_menu__["a" /* default */].Item, { tabIndex: 2, key: "4" },
                    "4: ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_react_localize_redux__["b" /* Translate */], { id: "student.planetBox.activity" })));
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_dropdown__["a" /* default */], { overlay: menu, trigger: ['click', 'contextMenu'] },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { id: "planet" + selectedPlanet.name, tabIndex: 2, className: "planet-icon", alt: "Planet " + selectedPlanet.name, src: selectedPlanet.iconPath, height: "100%", width: "100%" })));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "planet-icon", alt: "Planet " + selectedPlanet.name, src: IncompletePlanetPath, height: "100%", width: "100%" });
    };
    PlanetBox.prototype.renderPlanets = function () {
        if (this.state.currentPlanet == null) {
            return null;
        }
        var planetTranslation = __WEBPACK_IMPORTED_MODULE_16_src_utils_TranslateHelper__["a" /* default */].translate("common.planet"); //HACK: shouldn't use TranslateAPI, revisit and reconfigure to use LocalizeContextProps w/ this.props.translate
        // Notes: Will need to have some sort of index. I think i can get a list of selected planets in the plants constants file
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_steps__["a" /* default */], { size: "small", current: this.state.currentPlanet.id - 1, progressDot: this.stepsProgress }, this.sortedPlanets.map(function (planet, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Step, { key: planet.name + index, icon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null), title: planetTranslation + " " + planet.name });
        }));
    };
    PlanetBox.prototype.render = function () {
        var planetCode = (this.state.currentPlanet || { name: "" }).name.toLowerCase();
        var className = ("box-component planet-" + planetCode).toLowerCase();
        if (this.state.requireRedirect) {
            // I am mostly sure this is reverted, but i cannot be sure anymore with this application
            this.setState({
                requireRedirect: false
            });
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "planetBox", className: className },
            this.renderPlanets(),
            this.state.requireRedirect ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_router__["a" /* Redirect */], { to: __WEBPACK_IMPORTED_MODULE_14_src_core_Routes__["a" /* default */].STUDENT_HOME }) : null);
    };
    return PlanetBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return {
        updateMissionStatus: function (request) { return __WEBPACK_IMPORTED_MODULE_12_src_redux_CheckpointActions__["a" /* default */].UpdateCurrentUserStatus(dispatch, request); },
        startReplay: function (start, end, returnLocation) { return __WEBPACK_IMPORTED_MODULE_12_src_redux_CheckpointActions__["a" /* default */].StartReplay(dispatch, start, end, returnLocation); },
    };
}
function mapStateToProps(state) {
    return {
        Mission: state.Mission,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PlanetBox));


/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 2053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/incomplete-small.d8e0b0f1.png";

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_menu__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_menu_style_index_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_dropdown__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_dropdown_style_index_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_api_AccountApiController__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_constants_Languages__ = __webpack_require__(80);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var LanguageToggle = /** @class */ (function (_super) {
    __extends(LanguageToggle, _super);
    function LanguageToggle(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_10_src_utils_BindThisHelper__["a" /* default */])(_this, LanguageToggle.prototype);
        return _this;
    }
    LanguageToggle.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.activeLanguage !== this.props.activeLanguage) {
            // This has to be here, otherwise the translate() function will not have the proper active language
            var language = __WEBPACK_IMPORTED_MODULE_12_src_constants_Languages__["a" /* default */].FindByCode(nextProps.activeLanguage.code);
            __WEBPACK_IMPORTED_MODULE_12_src_constants_Languages__["a" /* default */].SetActiveLanguage(language, nextProps.translate);
        }
    };
    LanguageToggle.prototype.changeCurrentLanguage = function (lang) {
        this.props.setActiveLanguage(lang.code);
        __WEBPACK_IMPORTED_MODULE_11_src_api_AccountApiController__["a" /* default */].updateSelectedCulture(lang.id);
    };
    LanguageToggle.prototype.renderMenuItems = function (currentLanguage) {
        var _this = this;
        // Load available languages
        var languages = __WEBPACK_IMPORTED_MODULE_12_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable; });
        if (languages == null || languages.length < 1) {
            languages.push({ id: -1, code: currentLanguage.code, name: currentLanguage.name });
        }
        return languages.map(function (lang) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_menu__["a" /* default */].Item, { tabIndex: 2, key: lang.code, disabled: lang.code === currentLanguage.code, onClick: function () { return _this.changeCurrentLanguage(lang); } }, lang.name)); });
    };
    LanguageToggle.prototype.renderMenu = function (currentLanguage) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_menu__["a" /* default */], null, this.renderMenuItems(currentLanguage));
    };
    LanguageToggle.prototype.render = function () {
        // Have to do this for defaults. Language comes in initially unset
        var currentLanguage = (this.props.activeLanguage || { name: "Language", code: "ln" });
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_dropdown__["a" /* default */], { className: "language-dropdown", overlay: this.renderMenu(currentLanguage), trigger: ["click"] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { tabIndex: 2, type: "primary" },
                currentLanguage.name,
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_icon__["a" /* default */], { type: "down" })));
    };
    return LanguageToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(LanguageToggle));


/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_FullscreenHelper__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_localize_redux__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var FullscreenToggle = /** @class */ (function (_super) {
    __extends(FullscreenToggle, _super);
    function FullscreenToggle(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, FullscreenToggle.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {
            isFullscreen: false
        };
        return _this;
    }
    FullscreenToggle.prototype.componentDidMount = function () {
        document.addEventListener("fullscreenchange", this.fullscreenEventListener);
        document.addEventListener("mozfullscreenchange", this.fullscreenEventListener);
        document.addEventListener("webkitfullscreenchange", this.fullscreenEventListener);
        document.addEventListener("msfullscreenchange", this.fullscreenEventListener);
        this.fullscreenEventListener();
    };
    FullscreenToggle.prototype.componentWillUnmount = function () {
        document.removeEventListener("fullscreenchange", this.fullscreenEventListener);
        document.removeEventListener("mozfullscreenchange", this.fullscreenEventListener);
        document.removeEventListener("webkitfullscreenchange", this.fullscreenEventListener);
        document.removeEventListener("msfullscreenchange", this.fullscreenEventListener);
    };
    // componentWillReceiveProps() {
    //     this.fullscreenEventListener();
    // }
    FullscreenToggle.prototype.fullscreenEventListener = function () {
        var isFullscreen = __WEBPACK_IMPORTED_MODULE_4_src_utils_FullscreenHelper__["a" /* default */].GetFullscreenValue();
        this.setState({
            isFullscreen: isFullscreen
        });
    };
    FullscreenToggle.prototype.toggleFullscreen = function (e) {
        if (this.state.isFullscreen) {
            __WEBPACK_IMPORTED_MODULE_4_src_utils_FullscreenHelper__["a" /* default */].CancelFullscreen();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_4_src_utils_FullscreenHelper__["a" /* default */].RequestFullscreen(document.body);
        }
    };
    FullscreenToggle.prototype.renderButtonText = function () {
        if (this.state.isFullscreen) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_localize_redux__["b" /* Translate */], { id: "admin.header.exitFullscreenButton" });
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_localize_redux__["b" /* Translate */], { id: "admin.header.enterFullscreenButton" });
    };
    FullscreenToggle.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_button__["a" /* default */], { tabIndex: 2, type: "primary", onClick: this.toggleFullscreen }, this.renderButtonText());
    };
    return FullscreenToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_localize_redux__["d" /* withLocalize */])(FullscreenToggle));


/***/ }),
/* 2057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserSideNav__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_less__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Layout_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_public_Public_less__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_public_Public_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_src_pages_public_Public_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_layouts_GeneralHeader__ = __webpack_require__(222);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var Content = __WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */].Content;
var UserLayout = /** @class */ (function (_super) {
    __extends(UserLayout, _super);
    function UserLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserLayout.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_src_layouts_GeneralHeader__["a" /* default */], { renderEmulationBanner: false, renderFullscreenToggle: true, renderLanguageToggle: true, renderAudioToggle: false, renderPlanetBox: false, renderBackToSpaceStation: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */], { className: "has-side-nav" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__UserSideNav__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, null, this.props.children)));
    };
    return UserLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (UserLayout);


/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_menu__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_menu_style_index_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SideNav_less__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SideNav_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__SideNav_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_constants_Grades__ = __webpack_require__(78);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var Sider = __WEBPACK_IMPORTED_MODULE_5_antd_es_layout__["a" /* default */].Sider;
var UserSideNav = /** @class */ (function (_super) {
    __extends(UserSideNav, _super);
    function UserSideNav(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedKey: 'menu'
        };
        return _this;
    }
    UserSideNav.prototype.componentWillMount = function () {
        this.selectMenuItem(this.props.location.pathname);
    };
    UserSideNav.prototype.selectMenuItem = function (key) {
        this.setState({
            selectedKey: key
        });
    };
    UserSideNav.prototype.isParentUser = function (gradeId) {
        return this.props.gradeId === __WEBPACK_IMPORTED_MODULE_12_src_constants_Grades__["a" /* Grades */].Default.id || this.props.gradeId == null;
    };
    /**
     * Visible for grades 3+ and parents
     */
    UserSideNav.prototype.renderHollandGuideLink = function () {
        if (this.props.gradeId >= __WEBPACK_IMPORTED_MODULE_12_src_constants_Grades__["a" /* Grades */].Third.id || this.isParentUser(this.props.gradeId)) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].HOLLAND_AREAS_GUIDE) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].HOLLAND_AREAS_GUIDE) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "book" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "common.hollandAreas" })));
        }
    };
    UserSideNav.prototype.renderOccupationDbLink = function () {
        if (this.props.gradeId >= __WEBPACK_IMPORTED_MODULE_12_src_constants_Grades__["a" /* Grades */].Third.id || this.isParentUser(this.props.gradeId)) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].OCCUPATIONDB) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].OCCUPATIONDB) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "book" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "public.occupationdb.title" })));
        }
    };
    /**
     * Visible for grades 4+ and parents
     */
    UserSideNav.prototype.renderTrainingAndEducationGuideLink = function () {
        if (this.props.gradeId === __WEBPACK_IMPORTED_MODULE_12_src_constants_Grades__["a" /* Grades */].Fourth.id || this.props.gradeId === __WEBPACK_IMPORTED_MODULE_12_src_constants_Grades__["a" /* Grades */].Fifth.id || this.isParentUser(this.props.gradeId)) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].TRAINING_AND_EDUCATION_GUIDE) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].TRAINING_AND_EDUCATION_GUIDE) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "book" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "common.trainingAndEducation" })));
        }
    };
    UserSideNav.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Sider, { width: "300px", breakpoint: "md", collapsedWidth: "0", className: "side-nav" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */], { className: "parentSideNav", mode: "inline" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].LOGIN) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].LOGIN) },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "home" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "common.home" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS_HOME) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS_HOME) },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "home" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "public.parents.home" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, "PK") },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, "PK") },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "star" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "public.parents.PK" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, "K") },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, "K") },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "star" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "public.parents.K" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, 1) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, 1) },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "star" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "public.parents.1st" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, 2) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, 2) },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "star" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "public.parents.2nd" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, 3) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, 3) },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "star" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "public.parents.3rd" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, 4) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, 4) },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "star" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "public.parents.4th" }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_menu__["a" /* default */].Item, { key: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, 5) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PARENTS, 5) },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "star" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "public.parents.5th" }))),
                this.renderTrainingAndEducationGuideLink(),
                this.renderHollandGuideLink(),
                this.renderOccupationDbLink()));
    };
    return UserSideNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        gradeId: state.User.gradeId
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(UserSideNav)));


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6.88d57c5a.png";

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/traveler.38499b0d.png";

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PK.7c72f8bd.png";

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gazer.b250c4f8.png";

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/K.19dc8368.png";

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/observer.4128d750.png";

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.1a6a05e8.png";

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/builder.778b293a.png";

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.634d7efd.png";

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/voyager.5f3e4454.png";

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.cf397d33.png";

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pioneer.f3fcc210.png";

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4.3b56d2d4.png";

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/communicator.7df0cf38.png";

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/5.a192f9c2.png";

/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PublicFooter__ = __webpack_require__(2076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_less__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Layout_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_public_Public_less__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_pages_public_Public_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_src_pages_public_Public_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_layouts_GeneralHeader__ = __webpack_require__(222);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var Content = __WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */].Content;
var PublicLayout = /** @class */ (function (_super) {
    __extends(PublicLayout, _super);
    function PublicLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PublicLayout.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */], { className: "public" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_src_layouts_GeneralHeader__["a" /* default */], { renderEmulationBanner: false, renderFullscreenToggle: true, renderLanguageToggle: true, renderAudioToggle: false, renderPlanetBox: false, renderBackToSpaceStation: false }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, null, this.props.children)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__PublicFooter__["a" /* default */], null));
    };
    return PublicLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PublicLayout);


/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_list__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_list_style_index_js__ = __webpack_require__(2077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Footer_less__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Footer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__Footer_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




















var logo = __webpack_require__(827);
var Footer = __WEBPACK_IMPORTED_MODULE_0_antd_es_layout__["a" /* default */].Footer;
var PublicFooter = /** @class */ (function (_super) {
    __extends(PublicFooter, _super);
    function PublicFooter(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_17_src_utils_BindThisHelper__["a" /* default */])(_this, Footer.prototype);
        return _this;
    }
    PublicFooter.prototype.renderLinks = function () {
        var links = [
            { id: "contact-us", text: this.props.translate("public.footer.contact"), link: "contact-us" },
            { id: "help", text: this.props.translate("public.footer.help"), link: "help" },
            { id: "privacy-policy", text: this.props.translate("public.footer.privacy"), link: "privacy-policy" },
            { id: "terms-of-use", text: this.props.translate("public.footer.tou"), link: "terms-of-use" }
        ];
        return (__WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("ul", { id: "kuder-links", className: "kuder-links" }, links.map(function (link) { return (__WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("li", { tabIndex: -1, key: link.id },
            __WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("a", { tabIndex: 3, href: "http://kuder.com/" + link.link, target: "_blank" }, link.text))); })));
    };
    PublicFooter.prototype.renderIcons = function () {
        var icons = [
            { id: "linkedin", name: "LinkedIn", className: "fab fa-linkedin-in", link: "http://us.linkedin.com/company/kuder" },
            { id: "youtube", name: "YouTube", className: "fab fa-youtube", link: "http://www.youtube.com/user/kuder" },
            { id: "blog", name: "Kuder Blog", className: "fas fa-rss", link: "http://www.kuder.com/blog" },
            { id: "facebook", name: "Facebook", className: "fab fa-facebook", link: "http://www.facebook.com/KuderCareerPlanningSystem" },
            { id: "twitter", name: "Twitter", className: "fab fa-twitter-square", link: "https://twitter.com/kuder" },
        ];
        return (__WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("ul", { id: "kuder-icons", className: "kuder-icons" }, icons.map(function (icon) { return (__WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("li", { tabIndex: -1, id: icon.id, key: icon.id },
            __WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("a", { tabIndex: 3, href: icon.link, title: icon.name, className: "footerIcon", target: "_blank" },
                __WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("p", { className: "screen-reader-hidden" }, "SOMETHING"),
                __WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("div", { className: icon.className })))); })));
    };
    PublicFooter.prototype.renderYear = function () {
        var d = new Date();
        return d.getFullYear();
    };
    PublicFooter.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_18_react__["createElement"](Footer, { className: "footer" },
            __WEBPACK_IMPORTED_MODULE_18_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                __WEBPACK_IMPORTED_MODULE_18_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_col__["a" /* default */], { xs: { span: 11, push: 1 }, sm: 6, md: { span: 6, push: 1 }, lg: { span: 5, push: 2 } },
                    __WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("a", { tabIndex: -1, href: "http://www.kuder.com/", className: "logo", target: "_blank" },
                        __WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("img", { src: logo, alt: "Kuder", height: "33", width: "148" })),
                    __WEBPACK_IMPORTED_MODULE_18_react__["createElement"]("p", null,
                        "\u00A9 ",
                        this.renderYear(),
                        " ",
                        this.props.translate("public.footer.inc")),
                    this.props.children),
                __WEBPACK_IMPORTED_MODULE_18_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_col__["a" /* default */], { xs: { span: 11, pull: 1 }, sm: { span: 6, pull: 0 }, md: 8, lg: 6 }, this.renderLinks()),
                __WEBPACK_IMPORTED_MODULE_18_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_col__["a" /* default */], { xs: { span: 22, push: 1, pull: 1 }, sm: { span: 6, push: 0, pull: 1 }, md: { span: 6, push: 0, pull: 1 }, lg: { span: 5, push: 0, pull: 2 } }, this.renderIcons())));
    };
    return PublicFooter;
}(__WEBPACK_IMPORTED_MODULE_18_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_react_localize_redux__["d" /* withLocalize */])(PublicFooter));


/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spin_style__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagination_style__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__grid_style__ = __webpack_require__(829);


// style dependencies




/***/ }),
/* 2078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameSideNav__ = __webpack_require__(2085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_less__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Layout_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_layouts_GeneralHeader__ = __webpack_require__(222);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var Content = __WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */].Content;
var GameLayout = /** @class */ (function (_super) {
    __extends(GameLayout, _super);
    function GameLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameLayout.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_layouts_GeneralHeader__["a" /* default */], { renderEmulationBanner: true, renderFullscreenToggle: true, renderLanguageToggle: true, renderAudioToggle: false, renderPlanetBox: false, renderBackToSpaceStation: false }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */], { className: "has-side-nav" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__GameSideNav__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, { style: { overflowX: 'hidden' } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { height: 'calc(100vh - 100px)' } }, this.props.children))));
    };
    return GameLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (GameLayout);


/***/ }),
/* 2085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_menu__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_menu_style_index_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SideNav_less__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SideNav_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__SideNav_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var SubMenu = __WEBPACK_IMPORTED_MODULE_6_antd_es_menu__["a" /* default */].SubMenu;
var Sider = __WEBPACK_IMPORTED_MODULE_4_antd_es_layout__["a" /* default */].Sider;
var NavClass = /** @class */ (function () {
    function NavClass() {
    }
    return NavClass;
}());
var GameSideNav = /** @class */ (function (_super) {
    __extends(GameSideNav, _super);
    function GameSideNav(props) {
        var _this = _super.call(this, props) || this;
        _this.menuItems = [];
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, GameSideNav.prototype);
        _this.menuItems = [
            { display: "Home", menuKey: "home", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].BASE_ROUTE, iconName: "home" },
            {
                display: "Grade 5", menuKey: "grade5", iconName: "minus", subItems: [
                    { display: "R - Landscaping", menuKey: "grade5R", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].GAME_GRADE_5_R },
                    { display: "I - Diagnosis", menuKey: "grade5I", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].DIAGNOSIS_GAME },
                    { display: "A - Collage", menuKey: "grade5A", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].COLLAGE_GAME },
                    { display: "S - Job Matching", menuKey: "grade5S", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].GAME_GRADE_5_S },
                    { display: "E - Colony Story", menuKey: "grade5E", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].COLONY_GAME },
                    { display: "C - Sliding Puzzle", menuKey: "grade5C", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PUZZLE_SLIDER },
                ]
            }, {
                display: "Grade 4", menuKey: "grade4", iconName: "minus", subItems: [
                    { display: "R - Plumbing", menuKey: "grade4R", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PLUMBING_PLATFORMER },
                    { display: "I - University", menuKey: "grade4I", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].GAME_GRADE_4_I },
                    { display: "A - Paint", menuKey: "grade4A", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PHASER_PAINT_GAME },
                    { display: "S - Diner", menuKey: "grade4S", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].GAME_GRADE_4_S },
                    { display: "E - Career Fair", menuKey: "grade4E", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].GAME_GRADE_4_E },
                    { display: "C - Organize Desk", menuKey: "grade4C", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].ORGANIZE_DESK_GAME },
                ]
            }, {
                display: "Grade 3", menuKey: "grade3", iconName: "minus", subItems: [
                    { display: "R - Diseased Trees", menuKey: "diseasedTrees", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].DISEASED_TREES_GAME },
                    { display: "I - X-Ray", menuKey: "xray", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].XRAY_SLIDER },
                    { display: "A - Desert Terraform", menuKey: "grade3A", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].GAME_GRADE_3_A },
                    { display: "S - Fit Five", menuKey: "fitFiveGame", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].FIT_FIVE_GAME },
                    { display: "E - Hotel Aurora", menuKey: "grade3E", iconName: "tablet", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].HOTEL_AURORA_GAME },
                    { display: "C - Warehouse", menuKey: "warehouseGame", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].WAREHOUSE_GAME },
                ]
            },
            {
                display: "Grade 2", menuKey: "grade2", iconName: "minus", subItems: [
                    { display: "R - Rocket Repair", menuKey: "rocketRepair", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].ROCKET_REPAIR },
                    { display: "I - Program Robot", menuKey: "robot", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].PROGRAM_ROBOT },
                    { display: "A - Ship Painting", menuKey: "shipPaint", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].SHIP_PAINTING },
                    { display: "S - Jigsaw Puzzle", menuKey: "jigsawPuzzle", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].JIGSAW_PUZZLE },
                    { display: "E - Space Port", menuKey: "spacePort", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].SPACE_PORT },
                    { display: "C - Mail Delivery", menuKey: "mailDelivery", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].MAIL_DELIVERY },
                ]
            }, {
                display: "Grade 1", menuKey: "grade1", iconName: "minus", subItems: [
                    { display: "R - Ocean Cleanup", menuKey: "oceanCleanup", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].OCEAN_CLEANUP },
                    { display: "I - City Builder", menuKey: "cityBuilder", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].CITY_BUILDER },
                    { display: "A - Uniform Design", menuKey: "uniformDesign", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].UNIFORM_DESIGN },
                    { display: "S - Seek and Find", menuKey: "seekAndFind", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].SEEK_AND_FIND },
                    { display: "E - Vending Machine", menuKey: "vendingMachine", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].VENDING_MACHINE },
                    { display: "C - Space Pets", menuKey: "spacePets", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].SPACE_PETS },
                ]
            }, {
                display: "Grade K", menuKey: "gradeK", iconName: "minus", subItems: [
                    { display: "R - Construction Maze", menuKey: "constructionMaze", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].CONSTRUCTION_MAZE },
                    { display: "I - Zoo", menuKey: "zoo", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].ZOO },
                    { display: "A - Cake Decorating", menuKey: "cakeDecorating", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].CAKE_DECORATING },
                    { display: "S - Waiter Memory", menuKey: "waiterMemory", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].WAITER_MEMORY },
                    { display: "E - Starball", menuKey: "starball", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].STARBALL },
                    { display: "C - Librarian", menuKey: "librarian", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].LIBRARIAN },
                ]
            }, {
                display: "Grade PK", menuKey: "gradePK", iconName: "minus", subItems: [
                    { display: "R - Ride Mechanic", menuKey: "rideMechanic", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].RIDE_MECHANIC },
                    { display: "I - Fossil Finder", menuKey: "fossilFinder", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].FOSSIL_FINDER },
                    { display: "A - Face Painting", menuKey: "facePainting", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].FACE_PAINTING },
                    { display: "S - Find Helpers", menuKey: "findHelpers", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].FIND_HELPERS },
                    { display: "E - Ticket Taker", menuKey: "ticketTaker", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].TICKET_TAKER },
                    { display: "C - Grocery Bagger", menuKey: "groceryBagger", iconName: "check", navTo: __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].GROCERY_BAGGER },
                ]
            },
        ];
        _this.state = {
            selectedKey: "menu",
            selectedParent: "menu",
            openKeys: ["menu"],
        };
        return _this;
    }
    GameSideNav.prototype.componentWillMount = function () {
        this.updateSelection();
    };
    GameSideNav.prototype.updateSelection = function (newSelectedKey) {
        if (newSelectedKey === void 0) { newSelectedKey = this.props.location.pathname; }
        var parent = this.findParent(newSelectedKey);
        this.setState({
            selectedKey: newSelectedKey,
            selectedParent: (parent || { menuKey: "" }).menuKey
        });
    };
    GameSideNav.prototype.onOpenChange = function (openKeys) {
        var _this = this;
        var latestOpenKey = openKeys.find(function (key) { return _this.state.openKeys.indexOf(key) === -1; });
        var rootSubmenuKeys = ["grade5", "grade4", "grade3", "grade2", "grade1", "gradeK", "gradePK"];
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({ openKeys: openKeys });
        }
        else {
            this.setState({
                openKeys: latestOpenKey ? [latestOpenKey] : [],
            });
        }
    };
    GameSideNav.prototype.findParent = function (menuKey, items) {
        if (items === void 0) { items = this.menuItems; }
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.subItems != null && item.subItems.find(function (x) { return x.navTo === menuKey; }) != null) {
                return item;
            }
            if (item.navTo === menuKey) {
                return item;
            }
        }
        return null;
    };
    GameSideNav.prototype.generateLayout = function (input) {
        var _this = this;
        if (Array.isArray(input)) {
            return input.map(function (x) { return _this.generateLayout(x); });
        }
        if (input.subItems != null && input.subItems.length > 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SubMenu, { key: input.menuKey, title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_icon__["a" /* default */], { type: input.iconName }),
                    " ",
                    input.display) }, this.generateLayout(input.subItems));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_menu__["a" /* default */].Item, { key: input.navTo },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: input.navTo },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_icon__["a" /* default */], { type: input.iconName }),
                " ",
                input.display));
    };
    GameSideNav.prototype.render = function () {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Sider, { width: "300px", breakpoint: "md", collapsedWidth: "0", className: "side-nav" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_menu__["a" /* default */], { mode: "inline", style: { height: '100%' }, onSelect: function (param) { return _this.updateSelection(param.key); }, openKeys: this.state.openKeys, onOpenChange: function (keys) { return _this.onOpenChange(keys); }, selectedKeys: [this.state.selectedKey], defaultOpenKeys: [this.state.selectedParent] }, this.generateLayout(this.menuItems)));
    };
    return GameSideNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(GameSideNav));


/***/ }),
/* 2086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_layouts_GeneralHeader__ = __webpack_require__(222);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

 // Connecting to Redux








var Header = __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Header, Footer = __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Footer, Sider = __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Sider, Content = __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Content;
var SpaceStationLayout = /** @class */ (function (_super) {
    __extends(SpaceStationLayout, _super);
    function SpaceStationLayout(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_8_src_utils_BindThisHelper__["a" /* default */])(_this, SpaceStationLayout.prototype);
        return _this;
    }
    SpaceStationLayout.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */], { className: "space-station", style: { height: '100vh' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_src_layouts_GeneralHeader__["a" /* default */], { renderEmulationBanner: false, renderFullscreenToggle: true, renderLanguageToggle: true, renderAudioToggle: true, renderPlanetBox: true, renderBackToSpaceStation: false }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, null, this.props.children));
    };
    return SpaceStationLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        missionStatus: state.Mission,
        userStatus: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(SpaceStationLayout));


/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_mission_Mission_less__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_mission_Mission_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_src_components_mission_Mission_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_layouts_GeneralHeader__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__ = __webpack_require__(123);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var Content = __WEBPACK_IMPORTED_MODULE_3_antd_es_layout__["a" /* default */].Content;
var PlanetLayout = /** @class */ (function (_super) {
    __extends(PlanetLayout, _super);
    function PlanetLayout(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, PlanetLayout.prototype);
        return _this;
    }
    PlanetLayout.prototype.render = function () {
        var renderLanguageToggle = this.props.missionStatus.current.checkpointId !== __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__["a" /* Checkpoints */].Game.id &&
            this.props.missionStatus.current.checkpointId !== __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__["a" /* Checkpoints */].Activity.id;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_layout__["a" /* default */], { className: "planet-mission", style: { height: '100vh' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_src_layouts_GeneralHeader__["a" /* default */], { renderEmulationBanner: false, renderFullscreenToggle: true, renderLanguageToggle: renderLanguageToggle, renderAudioToggle: true, renderPlanetBox: false, renderBackToSpaceStation: false }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, null, this.props.children));
    };
    return PlanetLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        missionStatus: state.Mission,
        userStatus: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(PlanetLayout));


/***/ }),
/* 2088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/i.0b78009b.png";

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/a.42f3f462.png";

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_less__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Layout_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_public_Public_less__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_pages_public_Public_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_src_pages_public_Public_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_layouts_GeneralHeader__ = __webpack_require__(222);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var Content = __WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */].Content;
var CleanLayout = /** @class */ (function (_super) {
    __extends(CleanLayout, _super);
    function CleanLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CleanLayout.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */], { className: "clean" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_layouts_GeneralHeader__["a" /* default */], { renderEmulationBanner: true, renderFullscreenToggle: true, renderLanguageToggle: true, renderAudioToggle: false, renderPlanetBox: false, renderBackToSpaceStation: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, null, this.props.children)));
    };
    return CleanLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CleanLayout);


/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_student_StudentStatements__ = __webpack_require__(2093);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

 // Connecting to Redux
 // 'this' binder

var ViewStatements = /** @class */ (function (_super) {
    __extends(ViewStatements, _super);
    function ViewStatements(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, ViewStatements.prototype);
        return _this;
    }
    ViewStatements.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_src_components_student_StudentStatements__["a" /* default */], null));
    };
    return ViewStatements;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(ViewStatements));


/***/ }),
/* 2093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_api_StatementApiController__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__EditStatementNotesModal__ = __webpack_require__(2095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__StudentStatements_less__ = __webpack_require__(2099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__StudentStatements_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__StudentStatements_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




















var StudentStatements = /** @class */ (function (_super) {
    __extends(StudentStatements, _super);
    function StudentStatements(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, StudentStatements.prototype);
        _this.state = {
            statements: [],
            selectedStatement: null,
            isLoading: true,
            isInitialized: false,
        };
        return _this;
    }
    StudentStatements.prototype.componentDidMount = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_17_src_api_StatementApiController__["a" /* default */].getStudentIStatements().then(function (response) {
            if (response.ok) {
                return _this.setState({
                    statements: response.data.items,
                    isLoading: false,
                    isInitialized: true,
                });
            }
            console.error("Error with getStudentIStatements()");
            _this.setState({
                isLoading: false,
                isInitialized: true,
            });
        });
    };
    StudentStatements.prototype.closeModal = function () {
        this.setState({
            selectedStatement: null
        });
    };
    StudentStatements.prototype.openModal = function (statement) {
        this.setState({
            selectedStatement: statement,
        });
    };
    /**
     * Update DB with new notes/completed state for statement
     */
    StudentStatements.prototype.handleSubmit = function (values) {
        var _this = this;
        this.setState({ isLoading: true });
        var updateStudentStatementDTO = {
            statementId: values.statementId,
            userId: values.userId,
            gradeId: values.gradeId,
            completed: values.userCompletion.isCompleted,
            notes: values.userCompletion.statementNotes,
            removedFileIds: values.removedFileIds
        };
        var fileList = values.fileList;
        var formData = new FormData();
        var json = JSON.stringify(updateStudentStatementDTO);
        formData.append('jsonStringifiedObject', json);
        // Filter by status as it is null on a new UploadFile object
        fileList.filter(function (file) { return file != null && file.status == null; }).forEach(function (file) {
            if (file.originFileObj == null) {
                formData.append('Files[]', file);
            }
            else {
                formData.append('Files[]', file.originFileObj);
            }
        });
        // Update statement in DB
        __WEBPACK_IMPORTED_MODULE_17_src_api_StatementApiController__["a" /* default */].updateStudentStatement({ formData: formData }).then(function (result) {
            if (result.ok) {
                // Get statements from DB again to ensure have the updated info
                __WEBPACK_IMPORTED_MODULE_17_src_api_StatementApiController__["a" /* default */].getStudentIStatements().then(function (response) {
                    if (response.ok) {
                        _this.setState({
                            statements: response.data.items,
                            selectedStatement: null,
                            isLoading: false,
                        });
                        __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].success(_this.props.translate("public.studentStatements.successMessage"));
                    }
                    else {
                        console.error(response.statusText);
                        __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].error(_this.props.translate("public.studentStatements.errorMessage"));
                    }
                });
            }
            else if (result.status === 415) {
                console.error(result.statusText);
                __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].error(_this.props.translate("public.studentStatements.unsupportedMedia"));
            }
            else {
                console.error(result.statusText);
                __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].error(_this.props.translate("public.studentStatements.errorMessage"));
            }
        });
    };
    StudentStatements.prototype.handleCheckboxChange = function (statement, value) {
        var userCompletion = __assign(__assign({}, statement.userCompletion), { isCompleted: value });
        var studentStatementModalReturn = __assign(__assign({}, statement), { userCompletion: userCompletion, fileList: [], removedFileIds: [] });
        this.handleSubmit(studentStatementModalReturn);
    };
    StudentStatements.prototype.renderAllStatements = function () {
        var _this = this;
        return this.state.statements.map(function (statement) {
            var isChecked = statement.userCompletion != null && statement.userCompletion.isCompleted;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: "statement" + statement.statementId },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_row__["a" /* default */], { gutter: 48, align: "top", justify: "center", type: "flex" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_col__["a" /* default */], { span: 5, offset: 3 },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "admin.studentStatements.columnHeader2" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_checkbox__["a" /* default */], { className: "checkbox", defaultChecked: isChecked, disabled: _this.state.isLoading, onChange: function (e) { return _this.handleCheckboxChange(statement, e.target.checked); } }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_col__["a" /* default */], { span: 8 },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, statement.statementText)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_col__["a" /* default */], { span: 5 },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "notes" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_button__["a" /* default */], { type: "default", className: "ant-btn", disabled: _this.state.isLoading, onClick: function () { return _this.openModal(statement); } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.studentStatements.notesHeader" }),
                                " ",
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { type: "profile" }))))));
        });
    };
    StudentStatements.prototype.renderNoteModal = function () {
        if (this.state.selectedStatement == null) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__EditStatementNotesModal__["a" /* default */], { visible: this.state.selectedStatement != null, statement: this.state.selectedStatement, onCancel: this.closeModal, onOk: this.handleSubmit });
    };
    StudentStatements.prototype.render = function () {
        if (!this.state.isInitialized) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_spin__["a" /* default */], null);
        }
        if (this.state.statements.length === 0) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "student-statements" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: 'admin.statements.tableHeader' })),
            this.renderAllStatements(),
            this.renderNoteModal()));
    };
    return StudentStatements;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(StudentStatements));


/***/ }),
/* 2094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_upload__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_upload_style_index_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_icon_style_index_js__ = __webpack_require__(54);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


 // 'this' binder










var EditStatementNotesModal = /** @class */ (function (_super) {
    __extends(EditStatementNotesModal, _super);
    function EditStatementNotesModal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFileChange = function (info) {
            var newFileList = info.fileList.filter(function (file) { return file.status == null || file.status !== "removed"; });
            var removedFileIds = _this.state.removedFileIds;
            if (info.file.status != null && info.file.status === "removed" && info.file.originFileObj == null) {
                removedFileIds.push(info.file.uid);
            }
            _this.setState({ fileList: newFileList, removedFileIds: removedFileIds });
        };
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, EditStatementNotesModal.prototype);
        _this.state = {
            userCompletion: {},
            fileList: [],
            removedFileIds: [],
            submitting: false
        };
        return _this;
    }
    EditStatementNotesModal.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
    };
    EditStatementNotesModal.prototype.componentWillReceiveProps = function (newProps) {
        if (this.props.activeLanguage !== newProps.activeLanguage || this.props.statement.statementId !== newProps.statement.statementId) {
            this.deriveStateFromProps(newProps);
        }
    };
    EditStatementNotesModal.prototype.deriveStateFromProps = function (newProps) {
        this.setState({
            userCompletion: newProps.statement.userCompletion || {},
            fileList: newProps.statement.userCompletion != null
                ? newProps.statement.userCompletion.statementFiles.map(function (x) {
                    var newFile = undefined;
                    if (x != null) {
                        newFile = {
                            uid: x.id.toString(),
                            name: x.fileName,
                            status: 'done',
                            thumbUrl: x.azureFileUrl,
                        };
                    }
                    return newFile;
                })
                : [],
        });
    };
    EditStatementNotesModal.prototype.onOk = function (e) {
        this.setState({ submitting: true });
        var output = __assign(__assign({}, this.props.statement), { userCompletion: this.state.userCompletion, fileList: this.state.fileList, removedFileIds: this.state.removedFileIds });
        this.props.onOk(output);
    };
    EditStatementNotesModal.prototype.onCancel = function () {
        this.setState({
            userCompletion: null,
        });
        this.props.onCancel();
    };
    EditStatementNotesModal.prototype.handleStudentNoteChange = function (e) {
        var userCompletion = this.state.userCompletion;
        userCompletion.statementNotes = e.target.value;
        this.setState({
            userCompletion: userCompletion
        });
    };
    EditStatementNotesModal.prototype.render = function () {
        if (this.props.statement == null || this.state.userCompletion == null) {
            return null;
        }
        var uploadProps = {
            action: "",
            onChange: this.handleFileChange,
            beforeUpload: function (file) {
                // Stop the actual file upload process, we will do that later
                return false;
            },
            fileList: this.state.fileList,
            listType: "picture",
            multiple: true
        };
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_modal__["a" /* default */], { maskClosable: false, visible: this.props.visible, onOk: this.onOk, onCancel: this.onCancel, footer: [
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { key: "back", onClick: this.onCancel },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "admin.common.cancelButton" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { key: "submit", onClick: this.onOk, loading: this.state.submitting },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "admin.common.saveButton" }))
            ] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, this.props.statement.statementText),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null,
                    this.props.translate("public.studentStatements.notesHeader"),
                    ":"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_input__["a" /* default */].TextArea, { key: "studentNotes", rows: 3, autoComplete: "off", value: this.state.userCompletion.statementNotes, onChange: this.handleStudentNoteChange }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_upload__["a" /* default */], __assign({}, uploadProps),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_icon__["a" /* default */], { type: "upload" }),
                        " Select File"))));
    };
    return EditStatementNotesModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(EditStatementNotesModal));


/***/ }),
/* 2096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 2098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_public_GuideSection__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Parents_less__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Parents_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Parents_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




 // 'this' binder




var Parents = /** @class */ (function (_super) {
    __extends(Parents, _super);
    function Parents(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_4_src_utils_BindThisHelper__["a" /* default */])(_this, Parents.prototype);
        return _this;
    }
    Parents.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "parents-portal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.pageHeader" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.grade" + this.props.match.params.gradeId + ".overview.pageSubHeader" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_public_GuideSection__["a" /* default */], { headerKey: "public.parents.grade" + this.props.match.params.gradeId + ".overview.bigQuestion.header", bodyKey: "public.parents.grade" + this.props.match.params.gradeId + ".overview.bigQuestion.body" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_public_GuideSection__["a" /* default */], __assign({ headerKey: "public.parents.grade" + this.props.match.params.gradeId + ".overview.bigAdventure.header", bodyKey: "public.parents.grade" + this.props.match.params.gradeId + ".overview.bigAdventure.body" }, console.warn("Grade ID: " + this.props.match.params.gradeId))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_public_GuideSection__["a" /* default */], { headerKey: "public.parents.grade" + this.props.match.params.gradeId + ".overview.planetaryMissions.header", bodyKey: "public.parents.grade" + this.props.match.params.gradeId + ".overview.planetaryMissions.body" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS_PLANET, this.props.match.params.gradeId, 'planet-r') },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_button__["a" /* default */], { tabIndex: 0 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.planetLinks.planet-r" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS_PLANET, this.props.match.params.gradeId, 'planet-i') },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_button__["a" /* default */], { tabIndex: 0 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.planetLinks.planet-i" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS_PLANET, this.props.match.params.gradeId, 'planet-a') },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_button__["a" /* default */], { tabIndex: 0 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.planetLinks.planet-a" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS_PLANET, this.props.match.params.gradeId, 'planet-s') },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_button__["a" /* default */], { tabIndex: 0 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.planetLinks.planet-s" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS_PLANET, this.props.match.params.gradeId, 'planet-e') },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_button__["a" /* default */], { tabIndex: 0 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.planetLinks.planet-e" })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS_PLANET, this.props.match.params.gradeId, 'planet-c') },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_button__["a" /* default */], { tabIndex: 0 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.planetLinks.planet-c" }))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS_OBJECTIVES, this.props.match.params.gradeId) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_button__["a" /* default */], { tabIndex: 0 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.grade" + this.props.match.params.gradeId + ".overview.objectivesLink" }))));
    };
    return Parents;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["d" /* withLocalize */])(Parents));


/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_public_GuideSection__ = __webpack_require__(506);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




 // 'this' binder



var ParentsPlanet = /** @class */ (function (_super) {
    __extends(ParentsPlanet, _super);
    function ParentsPlanet(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_4_src_utils_BindThisHelper__["a" /* default */])(_this, ParentsPlanet.prototype);
        return _this;
    }
    ParentsPlanet.prototype.getListFromJSON = function (path, length) {
        var list = [];
        if (!path.endsWith('.')) {
            path += '.';
        }
        var i = 1;
        var errorMessage = "No default translation found! Ensure you've added translations for your default langauge.";
        while (i <= length) {
            var translationKey = path + i++;
            // Convert to string to ensure we can compare it properly
            var translation = this.props.translate(translationKey).toString();
            // Check if translation is missing or is the error message
            if (!translation || translation === "" || translation === errorMessage) {
                break;
            }
            list.push(translationKey);
        }
        return list;
    };
    ParentsPlanet.prototype.render = function () {
        var suggestions = this.getListFromJSON("public.parents.grade" + this.props.match.params.gradeId + "." + this.props.match.params.planet + ".suggestion.", 20);
        var books = this.getListFromJSON("public.parents.grade" + this.props.match.params.gradeId + "." + this.props.match.params.planet + ".book.", 20);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "parents-portal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.pageHeader" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.planetLinks." + this.props.match.params.planet })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_public_GuideSection__["a" /* default */], { bodyKey: [
                    "public.parents.grade" + this.props.match.params.gradeId + "." + this.props.match.params.planet + ".body1",
                    "public.parents.grade" + this.props.match.params.gradeId + "." + this.props.match.params.planet + ".body2",
                    "public.parents.suggestions"
                ], listBodyKeys: suggestions, listBodyKeysSecondLevel: books, headerKeySecondLevel: "public.parents.books" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS, this.props.match.params.gradeId) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_button__["a" /* default */], { icon: "left" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "common.back" }))));
    };
    return ParentsPlanet;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["d" /* withLocalize */])(ParentsPlanet));


/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_public_GuideSection__ = __webpack_require__(506);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




 // 'this' binder



var ParentsObjectives = /** @class */ (function (_super) {
    __extends(ParentsObjectives, _super);
    function ParentsObjectives(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_4_src_utils_BindThisHelper__["a" /* default */])(_this, ParentsObjectives.prototype);
        return _this;
    }
    ParentsObjectives.prototype.getListFromJSON = function (path, length) {
        var list = [];
        if (!path.endsWith('.')) {
            path += '.';
        }
        for (var i = 1; i <= length; ++i) {
            var translationKey = path + i;
            if (!this.props.translate(translationKey)) {
                break;
            }
            list.push(translationKey);
        }
        return list;
    };
    ParentsObjectives.prototype.render = function () {
        var objectives = this.getListFromJSON("public.parents.grade" + this.props.match.params.gradeId + ".objectives.objective.", 12);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "parents-portal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.pageHeader" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.grade" + this.props.match.params.gradeId + ".objectives.header" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_public_GuideSection__["a" /* default */], { bodyKey: "public.parents.grade" + this.props.match.params.gradeId + ".objectives.body", listBodyKeys: objectives }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS, this.props.match.params.gradeId) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_button__["a" /* default */], { icon: "left" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "common.back" }))));
    };
    return ParentsObjectives;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["d" /* withLocalize */])(ParentsObjectives));


/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Parents_less__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Parents_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Parents_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




 // 'this' binder



var ParentsHome = /** @class */ (function (_super) {
    __extends(ParentsHome, _super);
    function ParentsHome(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_4_src_utils_BindThisHelper__["a" /* default */])(_this, ParentsHome.prototype);
        return _this;
    }
    ParentsHome.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "parents-portal" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.header1" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.header2" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.p1" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.p2" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.p3.start" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS, 3) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.p3.link" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.p4" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.header3" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.p5" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS, "PK") },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.pk.avatar" })),
                "(",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.pk.level" }),
                ") - ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.pk.desc" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS, "K") },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.k.avatar" })),
                "(",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.k.level" }),
                ") - ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.k.desc" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS, 1) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.1.avatar" })),
                "(",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.1.level" }),
                ") - ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.1.desc" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS, 2) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.2.avatar" })),
                " (",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.2.level" }),
                ") - ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.2.desc" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS, 3) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.3.avatar" })),
                " (",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.3.level" }),
                ") - ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.3.desc" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS, 4) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.4.avatar" })),
                " (",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.4.level" }),
                ") - ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.4.desc" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_5_src_core_Routes__["a" /* default */].PARENTS, 5) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.5.avatar" })),
                " (",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.5.level" }),
                ") - ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["b" /* Translate */], { id: "public.parents.homeInstructions.gradeLinks.5.desc" })));
    };
    return ParentsHome;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ParentsHome);


/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var PageNotFound = /** @class */ (function (_super) {
    __extends(PageNotFound, _super);
    function PageNotFound(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, PageNotFound.prototype);
        return _this;
    }
    PageNotFound.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { backgroundColor: "white" } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", null, "404"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Woops! Nothing here."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                "Go back ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].BASE_ROUTE }, "Home")));
    };
    return PageNotFound;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PageNotFound);


/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_utils_DebugUtil__ = __webpack_require__(87);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};









var ErrorPage = /** @class */ (function (_super) {
    __extends(ErrorPage, _super);
    function ErrorPage(props) {
        var _this = _super.call(this, props) || this;
        _this.titleCss = { display: "inline-block", fontWeight: "bold" };
        _this.dataCss = { display: "inline-block" };
        _this.coolCss = { paddingLeft: "2vw" };
        _this.helperCss = { fontSize: "x-large", padding: "20px 0" };
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, ErrorPage.prototype);
        return _this;
    }
    ErrorPage.prototype.renderHelperMessage = function (error) {
        var output = [];
        if (error.message.includes("Check the render method of `Route`")) {
            output.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "Hey, you might have messed up your routing! Check the RouteLoader"));
        }
        if (error.message.includes("Actions must be plain objects")) {
            output.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "Check your dispatch calls from Redux. You should only use dispatch in binding calls"));
        }
        if (error.message.includes("Cannot read property 'errors'")) {
            output.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "Easter Egg! Congratulations on breaking the error page?"));
        }
        if (output.length > 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: this.helperCss },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign(__assign({}, this.coolCss), this.titleCss) }, "Helper Message"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: this.coolCss }, output));
        }
        return null;
    };
    ErrorPage.prototype.render = function () {
        // get the object from text
        var error = JSON.parse(this.props.location.state.errors);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { backgroundColor: "white" } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", null, "What have you done?!")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { gutter: 4 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { span: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"], { className: 'navbar-brand', to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].BASE_ROUTE, title: "Take me down to the very last city..." }, "Get me out of here!")),
                __WEBPACK_IMPORTED_MODULE_8_src_utils_DebugUtil__["a" /* default */].isDebugEnabled() &&
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { span: 4 },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"], { className: 'navbar-brand', to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].WHO_AM_I, title: "I mean, what even is?" }, "Who am I?"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: this.titleCss }, "Name:"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: this.dataCss }, error.name)),
            this.renderHelperMessage(error),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: this.titleCss }, "Message:"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: this.dataCss }, error.message)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: this.titleCss }, "Stack:"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("pre", { style: this.dataCss }, error.stack)));
    };
    return ErrorPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ErrorPage);


/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var ProdErrorPage = /** @class */ (function (_super) {
    __extends(ProdErrorPage, _super);
    function ProdErrorPage(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, ProdErrorPage.prototype);
        return _this;
    }
    ProdErrorPage.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { backgroundColor: "white", padding: 16 } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", null, "Whoops!"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null,
                    "Looks like you encountered an error! ",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"], { className: 'navbar-brand', to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].BASE_ROUTE }, "Click here to go back to the home screen"))));
    };
    return ProdErrorPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ProdErrorPage);


/***/ }),
/* 2107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_style__ = __webpack_require__(32);


// style dependencies


/***/ }),
/* 2111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);



/***/ }),
/* 2114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TableColumnState = {
    create: function (initValues) {
        return Object.assign({
            columnProp: '',
            filterVisible: false,
            searchText: null,
            filtered: false
        }, initValues);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (TableColumnState);


/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_date_picker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_date_picker_style_index_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_api_UserApiController__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_api_SchoolApiController__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__forms_AddEditUserForm__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_api_AccountApiController__ = __webpack_require__(216);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



























 // 'this' binder







var AddEditUser = /** @class */ (function (_super) {
    __extends(AddEditUser, _super);
    function AddEditUser(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_27_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditUser.prototype);
        var userId = Number(_this.props.match.params.userId);
        var classroomId = Number(_this.props.match.params.classroomId);
        var isAdmin = _this.props.match.params.isAdmin === 'true';
        var isSsoEnabled = _this.props.User.isSsoEnabled;
        userId = !isNaN(userId) ? userId : 0;
        classroomId = !isNaN(classroomId) ? classroomId : 0;
        _this.state = {
            schools: [],
            currentUser: {
                userId: userId,
                classroomId: classroomId,
            },
            emulationInfo: null,
            isLoadingSchools: true,
            isLoadingUser: true,
            isLoadingEmulation: true,
            isSubmitting: false,
            isSsoEnabled: false,
            hasShownRoleChangeWarning: false,
            showModal: false,
            userId: userId,
            classroomId: classroomId,
            isAdmin: isAdmin,
        };
        return _this;
    }
    AddEditUser.prototype.componentWillMount = function () {
        this.getSchools(this.props.User.districtId);
        this.getEmulationInfo();
        this.fillForm();
    };
    AddEditUser.prototype.getSchools = function (districtId) {
        var _this = this;
        var userRole = __WEBPACK_IMPORTED_MODULE_33_src_constants_Roles__["a" /* Roles */].FindById(this.props.User.roleID);
        // If our role will not allow us to get schools, don't
        if (![__WEBPACK_IMPORTED_MODULE_33_src_constants_Roles__["a" /* Roles */].KuderAdmin, __WEBPACK_IMPORTED_MODULE_33_src_constants_Roles__["a" /* Roles */].StateAdmin, __WEBPACK_IMPORTED_MODULE_33_src_constants_Roles__["a" /* Roles */].DistrictAdmin].some(function (x) { return x === userRole; })) {
            this.setState({
                schools: [],
                isLoadingSchools: false
            });
            return;
        }
        // If we aren't at a district, we are too broad to load schools
        if (districtId == null) {
            this.setState({
                schools: [],
                isLoadingSchools: false
            });
            return;
        }
        return __WEBPACK_IMPORTED_MODULE_31_src_api_SchoolApiController__["a" /* default */].getAllSchoolsByDistrict(districtId).then(function (schools) {
            _this.setState({
                schools: schools.data.sort(function (a, b) { return a.value < b.value ? -1 : a.value > b.value ? 1 : 0; }),
                isLoadingSchools: false
            });
        }).catch(function (e) {
            _this.setState({ isLoadingSchools: false });
            __WEBPACK_IMPORTED_MODULE_17_antd_es_message__["a" /* default */].error(_this.props.translate('admin.common.messageSchoolsInDistrictError'));
        });
    };
    AddEditUser.prototype.getEmulationInfo = function () {
        var _this = this;
        if (this.props.User.isEmulating) {
            return __WEBPACK_IMPORTED_MODULE_34_src_api_AccountApiController__["a" /* default */].getCurrentEmulationInfo().then(function (result) {
                _this.setState({
                    emulationInfo: result.data,
                    isLoadingEmulation: false
                });
            });
        }
        else {
            this.setState({
                emulationInfo: null,
                isLoadingEmulation: false
            });
        }
    };
    AddEditUser.prototype.fillForm = function () {
        var _this = this;
        if (this.state.userId === 0) {
            return this.setState({
                currentUser: {
                    userId: this.state.userId,
                    classroomId: this.state.classroomId,
                    roleId: this.props.User.roleID
                },
                isLoadingUser: false
            });
        }
        return __WEBPACK_IMPORTED_MODULE_30_src_api_UserApiController__["a" /* default */].getUser(this.state.userId).then(function (result) {
            _this.setState({
                currentUser: result.data,
                isLoadingUser: false
            });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_17_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditUser.messageRetrieveError'));
            _this.setState({
                currentUser: {
                    userId: _this.state.userId,
                    classroomId: _this.state.classroomId,
                },
                isLoadingUser: false
            });
        });
    };
    AddEditUser.prototype.onModalOk = function () {
        this.setState({
            hasShownRoleChangeWarning: true,
            showModal: false,
        });
    };
    AddEditUser.prototype.handleRoleChange = function (roleId) {
        if (this.state.hasShownRoleChangeWarning || this.state.userId < 1) {
            return;
        }
        this.setState({ showModal: true });
    };
    AddEditUser.prototype.handleSubmit = function (values) {
        var _this = this;
        this.setState({ isSubmitting: true });
        if (this.state.userId < 1) {
            // When adding a student, the classroomId will be populated
            if (this.state.classroomId > 0) {
                values.classroomId = this.state.classroomId;
            }
            // When isAdmin is false, we are adding a student
            values.roleId = this.state.isAdmin ? values.roleId : __WEBPACK_IMPORTED_MODULE_33_src_constants_Roles__["a" /* Roles */].Student.id;
            return __WEBPACK_IMPORTED_MODULE_30_src_api_UserApiController__["a" /* default */].addUser(values)
                .then(function (result) {
                _this.setState({ isSubmitting: false });
                if (result.data.isSuccess) {
                    __WEBPACK_IMPORTED_MODULE_17_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditUser.messageAdd'));
                    _this.handleRedirect();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_17_antd_es_message__["a" /* default */].error(result.data.errorMessage);
                }
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_17_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditUser.messageAddError'));
                _this.setState({ isSubmitting: false });
            });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_30_src_api_UserApiController__["a" /* default */].updateUser(values)
                .then(function (result) {
                _this.setState({ isSubmitting: false });
                if (result.data.isSuccess) {
                    __WEBPACK_IMPORTED_MODULE_17_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditUser.messageUpdate'));
                    _this.handleRedirect();
                }
                else {
                    var error = result.data.errorMessage || _this.props.translate('admin.addEditUser.messageUpdateError');
                    __WEBPACK_IMPORTED_MODULE_17_antd_es_message__["a" /* default */].error(error);
                }
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_17_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditUser.messageUpdateError'));
                _this.setState({ isSubmitting: false });
            });
        }
    };
    AddEditUser.prototype.handleRedirect = function () {
        // We rely on the state parameter to know where to go back to. If not provided, go home
        var state = this.props.location.state;
        var nextLocation = state != null && state.previousLocation != null ? state.previousLocation : __WEBPACK_IMPORTED_MODULE_28_src_core_Routes__["a" /* default */].BASE_ROUTE;
        this.props.history.push(nextLocation, state.previousState);
    };
    AddEditUser.prototype.renderTitle = function () {
        // If edit, show name, else show Add Student/Admin
        var user = this.state.currentUser;
        var text = this.state.userId > 0
            ? user.firstName + " " + user.lastName // Editing
            : this.state.isAdmin // Adding
                ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_react_localize_redux__["b" /* Translate */], { id: "admin.addEditUser.addHeader2" }) // Admin
                : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_react_localize_redux__["b" /* Translate */], { id: "admin.addEditUser.addHeader1" }); // Student
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, text);
    };
    AddEditUser.prototype.render = function () {
        if (this.state.isLoadingSchools || this.state.isLoadingUser || this.state.isLoadingEmulation) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_antd_es_spin__["a" /* default */], null);
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            this.renderTitle(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_antd_es_modal__["a" /* default */], { maskClosable: false, visible: this.state.showModal, footer: [
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_button__["a" /* default */], { key: "ok", type: "primary", onClick: this.onModalOk },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_react_localize_redux__["b" /* Translate */], { id: "admin.common.okButton" }))
                ] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, "Warning!"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Changing a user's role will change their permissions. Make sure you select the proper role before saving."))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_antd_es_col__["a" /* default */], { xs: 24, lg: 18, xl: 16, xxl: 12 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32__forms_AddEditUserForm__["a" /* default */], { isAdmin: this.state.isAdmin, userData: this.state.currentUser, schools: this.state.schools, emulationInfo: this.state.emulationInfo, isSubmitting: this.state.isSubmitting, onSubmit: this.handleSubmit, onCancel: this.handleRedirect, onRoleChange: this.handleRoleChange })))));
    };
    return AddEditUser;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_29_react_localize_redux__["d" /* withLocalize */])(AddEditUser)));


/***/ }),
/* 2117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_button__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_button_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_auto_complete__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_auto_complete_style_index_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_date_picker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_date_picker_style_index_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_utils_ArrayUtil__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__ = __webpack_require__(283);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};


 // 'this' binder



























var AddEditUserForm = /** @class */ (function (_super) {
    __extends(AddEditUserForm, _super);
    function AddEditUserForm(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditUserForm.prototype);
        _this.state = {
            filteredSchools: [],
            filteredGrades: [],
            filteredCultures: [],
        };
        return _this;
    }
    AddEditUserForm.prototype.handleFilterSchools = function (value) {
        var input = (value || "").toLowerCase();
        var items = this.props.schools;
        var filteredSchools = [];
        // Filter the clients if input is 3+ chars OR if the number of schools is small, like 50 or so
        if (input.length > 2 || items.length < 50) {
            filteredSchools = items
                .filter(function (x) { return x.value.toLowerCase().indexOf(input) >= 0; })
                .map(function (x) { return x.value; });
            filteredSchools = __WEBPACK_IMPORTED_MODULE_27_src_utils_ArrayUtil__["a" /* default */].Unique(filteredSchools);
        }
        this.setState({ filteredSchools: filteredSchools });
    };
    AddEditUserForm.prototype.handleFilterGrades = function (value) {
        var input = (value || "").toLowerCase();
        var items = __WEBPACK_IMPORTED_MODULE_26_src_constants_Grades__["a" /* Grades */].All;
        var filteredGrades = [];
        // Filter the clients if input is 3+ chars OR if the number of schools is small, like 50 or so
        if (input.length > 2 || items.length < 50) {
            filteredGrades = items
                .filter(function (x) { return x.name.toLowerCase().indexOf(input) >= 0; })
                .map(function (x) { return x.shortName; });
            filteredGrades = __WEBPACK_IMPORTED_MODULE_27_src_utils_ArrayUtil__["a" /* default */].Unique(filteredGrades);
        }
        this.setState({ filteredGrades: filteredGrades });
    };
    AddEditUserForm.prototype.handleFilterCultures = function (value) {
        var input = (value || "").toLowerCase();
        var items = __WEBPACK_IMPORTED_MODULE_28_src_constants_Languages__["a" /* default */].All;
        var filteredCultures = [];
        // Filter the clients if input is 3+ chars OR if the number of schools is small, like 50 or so
        if (input.length > 2 || items.length < 50) {
            filteredCultures = items
                .filter(function (x) { return x.name.toLowerCase().indexOf(input) >= 0; })
                .map(function (x) { return x.name + " (" + x.code + ")"; });
            filteredCultures = __WEBPACK_IMPORTED_MODULE_27_src_utils_ArrayUtil__["a" /* default */].Unique(filteredCultures);
        }
        this.setState({ filteredCultures: filteredCultures });
    };
    AddEditUserForm.prototype.handleCancel = function () {
        this.props.onCancel && this.props.onCancel();
    };
    AddEditUserForm.prototype.onSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.props.form.validateFields(function (errors, values) {
            var newValues = __assign(__assign({}, _this.props.userData), values);
            if (!errors) {
                _this.props.onSubmit && _this.props.onSubmit(newValues);
            }
        });
    };
    AddEditUserForm.prototype.onRoleChange = function (value, option) {
        this.props.onRoleChange && this.props.onRoleChange(Number(value));
    };
    AddEditUserForm.prototype.render = function () {
        var userData = this.props.userData != null ? this.props.userData : {};
        var emulateData = this.props.emulationInfo != null ? this.props.emulationInfo : {};
        var userRole = __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].FindById(this.props.form.getFieldValue(Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("roleId")) || userData.roleId);
        var currentUserRole = __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].FindById(this.props.User.roleID);
        var emulatedUserRole = __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].FindById(emulateData.roleId);
        var isAdmin = this.props.isAdmin;
        var isEdit = userData.userId > 0;
        var isClever = this.props.User.isSsoEnabled;
        var isEmulating = this.props.emulationInfo != null;
        // Determine what to show and when!
        var roleVisible = false;
        var statusVisible = false;
        var schoolVisible = false;
        var roleEdit = false;
        var statusEdit = false;
        var schoolEdit = false;
        var roles = [];
        // Dev Note: This is not as condensed as it could be but should be much more readable and MUCH easier to modify in the future
        switch (currentUserRole) {
            case __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].KuderAdmin:
                // When adding. Or, when editing a user that is an admin but not a KuderAdmin
                roleVisible = isEdit && isAdmin && ![__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].KuderAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].StateAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].Student].some(function (x) { return x === userRole; });
                statusVisible = isEdit;
                // When adding or editing a user that can have a school assigned to it
                schoolVisible = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].Student].some(function (x) { return x === userRole; });
                roleEdit = ![__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].KuderAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].Student].some(function (x) { return x === userRole; });
                statusEdit = isEdit;
                // When selecting a particular admin OR when a student does not have a school attached to them
                schoolEdit = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin].some(function (x) { return x === userRole; }) && !(userRole === __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].Student && userData.schoolId != null);
                roles = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].DistrictAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin];
                break;
            case __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].StateAdmin:
                // Dev Note: Currently, StateAdmins are not allowed to touch roles or school
                // roleVisible = isEdit && [Roles.DistrictAdmin, Roles.SchoolAdmin, Roles.TeacherCounselorAdmin].some(x => x === userRole);
                // schoolVisible = isEdit && [Roles.SchoolAdmin, Roles.TeacherCounselorAdmin].some(x => x === userRole);
                // schoolEdit = !isEdit || isEdit && userRole !== Roles.Student;
                // roles = [...Roles.All.filter(x => x.isAdmin && x !== Roles.KuderAdmin)];
                roleVisible = false;
                statusVisible = isEdit;
                schoolVisible = false;
                roleEdit = false;
                statusEdit = isEdit;
                schoolEdit = false;
                roles = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].StateAdmin];
                break;
            case __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].DistrictAdmin:
                if (!isClever) {
                    roleVisible = isEdit && isAdmin;
                    statusVisible = isEdit;
                    schoolVisible = isEdit && [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].Student].some(function (x) { return x === userRole; }) || !isEdit && !isAdmin;
                    roleEdit = isAdmin;
                    statusEdit = isEdit;
                    // When selecting a particular admin OR when a student does not have a school attached to them
                    schoolEdit = isEdit && ([__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin].some(function (x) { return x === userRole; }) || userRole === __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].Student && userData.schoolId != null)
                        || !isEdit && !isAdmin;
                    roles = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].DistrictAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin];
                }
                else {
                    roleVisible = isEdit && isAdmin;
                    statusVisible = isEdit && isAdmin;
                    schoolVisible = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].Student].some(function (x) { return x === userRole; }) || !isAdmin;
                    roleEdit = isEdit && isAdmin;
                    statusEdit = isEdit && isAdmin;
                    // When selecting a particular admin OR when a student does not have a school attached to them
                    schoolEdit = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin].some(function (x) { return x === userRole; });
                    // Clever DAs cannot add or edit teacher roles to or from
                    roles = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].DistrictAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin];
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin:
                if (!isClever) {
                    roleVisible = isAdmin;
                    statusVisible = isEdit;
                    schoolVisible = isEdit && isAdmin && isEmulating;
                    roleEdit = isAdmin;
                    statusEdit = isEdit;
                    schoolEdit = isEdit && isEmulating;
                    roles = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin, __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin];
                }
                else {
                    roleVisible = isAdmin && isEmulating;
                    statusVisible = isEdit && isAdmin;
                    schoolVisible = isEdit && isAdmin && isEmulating;
                    roleEdit = isAdmin;
                    statusEdit = isEdit;
                    schoolEdit = isEdit && isEmulating;
                    roles = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].SchoolAdmin];
                }
                // When emulating and editing, the user will be able to upgrade the user to DA
                if (isEmulating && isEdit) {
                    roles = __spreadArrays([__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].DistrictAdmin], roles);
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin:
                roleVisible = false;
                statusVisible = !isAdmin;
                schoolVisible = false;
                roleEdit = false;
                statusEdit = !isAdmin;
                schoolEdit = false;
                roles = [__WEBPACK_IMPORTED_MODULE_25_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin];
                break;
            default:
                // Students
                break;
        }
        // I don't think we should allow the user to disable themselves
        if (userData.userId === this.props.User.userId) {
            statusEdit = false;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_form__["a" /* default */], { className: "admin-form", onSubmit: this.onSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.addEditUser.formItem1" }), name: Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("firstName"), initialValue: userData.firstName, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_input__["a" /* default */], { autoComplete: "off" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.addEditUser.formItem2" }), name: Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("lastName"), initialValue: userData.lastName, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_input__["a" /* default */], { autoComplete: "off" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.addEditUser.formItem3" }), name: Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("email"), initialValue: userData.email, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                    { type: 'email', message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.common.emailRule" }) }
                ] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_input__["a" /* default */], { autoComplete: "off", type: "email" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.addEditUser.formItem7" }), name: Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("studentId"), initialValue: userData.studentId, visible: !this.props.isAdmin },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_input__["a" /* default */], { autoComplete: "off" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.addEditUser.formItem8" }), name: Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("dateOfBirth"), initialValue: userData.dateOfBirth ? __WEBPACK_IMPORTED_MODULE_24_moment___default()(userData.dateOfBirth, 'YYYY-MM-DD') : null, visible: !this.props.isAdmin },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_antd_es_date_picker__["a" /* default */], { format: "M/D/YYYY" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.addEditUser.formItem4" }), name: Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("gradeId"), initialValue: userData.gradeId, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ], visible: !this.props.isAdmin },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */], { optionFilterProp: "title", allowClear: true }, __WEBPACK_IMPORTED_MODULE_26_src_constants_Grades__["a" /* Grades */].All.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */].Option, { key: "grade" + x.id, value: x.id }, x.shortName); }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.addEditUser.formItem6" }), name: Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("schoolId"), initialValue: userData.schoolId, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ], visible: schoolVisible },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */], { allowClear: true, disabled: !schoolEdit }, this.props.schools.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */].Option, { key: "school" + x.key, value: x.key }, x.value); }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "report.admin.roleFilter.placeholder" }), name: Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("roleId"), initialValue: userData.roleId, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ], visible: roleVisible },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */], { optionFilterProp: "title", allowClear: true, disabled: !roleEdit, onSelect: this.onRoleChange }, roles.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */].Option, { key: "role" + x.id, value: x.id }, x.display); }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.addEditClient.formItem5" }), name: Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("currentCultureId"), initialValue: userData.currentCultureId, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */], { allowClear: true }, __WEBPACK_IMPORTED_MODULE_28_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable; }).map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */].Option, { key: "cultureIds" + x.id, value: x.id },
                    x.name,
                    " (",
                    x.code,
                    ")"); }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.universalUserSearch.columnHeader8" }), name: Object(__WEBPACK_IMPORTED_MODULE_23_src_utils_NameOf__["a" /* NameOf */])("isActive"), initialValue: userData.isActive ? "true" : "false", rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ], visible: statusVisible },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */], { disabled: !statusEdit },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */].Option, { key: "status-active", value: "true", title: "Active" }, "Active"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_select__["a" /* default */].Option, { key: "status-inactive", value: "false", title: "Inactive" }, "Inactive"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_form__["a" /* default */].Item, null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_button___default.a, { type: "primary", loading: this.props.isSubmitting, htmlType: "submit" }, this.props.translate("admin.common.saveButton")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_lib_button_button___default.a, { onClick: this.handleCancel }, this.props.translate("common.back")))));
    };
    return AddEditUserForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_7_antd_es_form__["a" /* default */].create()(AddEditUserForm))));


/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

exports['default'] = TransitionEvents;
module.exports = exports['default'];

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

exports['default'] = create;

var _index = __webpack_require__(837);

var _index2 = _interopRequireDefault(_index);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var customCache = new Set();
function create() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var scriptUrl = options.scriptUrl,
        _options$extraCommonP = options.extraCommonProps,
        extraCommonProps = _options$extraCommonP === undefined ? {} : _options$extraCommonP;
    /**
     * DOM API required.
     * Make sure in browser environment.
     * The Custom Icon will create a <script/>
     * that loads SVG symbols and insert the SVG Element into the document body.
     */

    if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
        var script = document.createElement('script');
        script.setAttribute('src', 'https:' + scriptUrl);
        script.setAttribute('data-namespace', scriptUrl);
        customCache.add(scriptUrl);
        document.body.appendChild(script);
    }
    var Iconfont = function Iconfont(props) {
        var type = props.type,
            children = props.children,
            restProps = __rest(props, ["type", "children"]);
        // component > children > type


        var content = null;
        if (props.type) {
            content = React.createElement('use', { xlinkHref: '#' + type });
        }
        if (children) {
            content = children;
        }
        return React.createElement(
            _index2['default'],
            (0, _extends3['default'])({}, restProps, extraCommonProps),
            content
        );
    };
    Iconfont.displayName = 'Iconfont';
    return Iconfont;
}
module.exports = exports['default'];

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.svgBaseProps = undefined;

var _defineProperty2 = __webpack_require__(11);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.getThemeFromTypeName = getThemeFromTypeName;
exports.removeTypeTheme = removeTypeTheme;
exports.withThemeSuffix = withThemeSuffix;

var _warning = __webpack_require__(838);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
var svgBaseProps = exports.svgBaseProps = (0, _defineProperty3["default"])({
    width: "1em",
    height: "1em",
    fill: "currentColor"
}, "aria-hidden", "true");
var fillTester = /-fill$/;
var outlineTester = /-o$/;
var twoToneTester = /-twotone$/;
function getThemeFromTypeName(type) {
    var result = null;
    if (fillTester.test(type)) {
        result = "filled";
    } else if (outlineTester.test(type)) {
        result = "outlined";
    } else if (twoToneTester.test(type)) {
        result = "twoTone";
    }
    return result;
}
function removeTypeTheme(type) {
    return type.replace(fillTester, "").replace(outlineTester, "").replace(twoToneTester, "");
}
function withThemeSuffix(type, theme) {
    var result = type;
    if (theme === "filled") {
        result += "-fill";
    } else if (theme === "outlined") {
        result += "-o";
    } else if (theme === "twoTone") {
        result += "-twotone";
    } else {
        (0, _warning2["default"])(false, "This icon '" + type + "' has unknown theme '" + theme + "'");
    }
    return result;
}

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTwoToneColor = setTwoToneColor;
exports.getTwoToneColor = getTwoToneColor;

var _iconsReact = __webpack_require__(300);

var _iconsReact2 = _interopRequireDefault(_iconsReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function setTwoToneColor(primaryColor) {
    return _iconsReact2['default'].setTwoToneColors({
        primaryColor: primaryColor
    });
}
function getTwoToneColor() {
    var colors = _iconsReact2['default'].getTwoToneColors();
    return colors.primaryColor;
}

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var AudioTest = /** @class */ (function (_super) {
    __extends(AudioTest, _super);
    function AudioTest(props) {
        var _this = _super.call(this, props) || this;
        _this.count = 0;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, AudioTest.prototype);
        _this.backgroundMusic = new Audio(__webpack_require__(2125));
        _this.backgroundMusic.pause();
        _this.sound = new Audio(__webpack_require__(839));
        _this.sound.pause();
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    AudioTest.prototype.componentWillUnmount = function () {
        this.backgroundMusic.pause();
    };
    AudioTest.prototype.playSoundAlpha = function (a) {
        this.backgroundMusic.play();
    };
    AudioTest.prototype.textChange = function () {
        var _this = this;
        this.sound.play().then(function () {
            _this.randoSound();
        });
    };
    AudioTest.prototype.randoSound = function () {
        var modCount = 2;
        if (this.count % modCount === 0) {
            this.sound = new Audio(__webpack_require__(839));
        }
        else if (this.count % modCount === 1) {
            this.sound = new Audio(__webpack_require__(2126));
        }
        this.sound.pause();
    };
    AudioTest.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Hey do you hear that? Thats music! Or a bird, maybe a duck?"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_button__["a" /* default */], { type: "primary", onClick: function (x) { return _this.playSoundAlpha(x); } }, " Click!"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { placeholder: "Hear cool typing sounds!", onChange: this.textChange }))));
    };
    return AudioTest;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AudioTest);


/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bird-chirping.a2a875f0.mp3";

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/keyboard-press-short.6a7b358d.mp3";

/***/ }),
/* 2127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_api_ClientApiController__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_button__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder


 // Connecting to Redux








var Clients = /** @class */ (function (_super) {
    __extends(Clients, _super);
    function Clients(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, Clients.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
        return _this;
    }
    Clients.prototype.emulateClient = function (stateId, districtId, schoolId) {
        var _this = this;
        var id;
        var userType;
        if (stateId != null) {
            id = stateId;
            userType = "state";
        }
        else if (districtId != null) {
            id = districtId;
            userType = "district";
        }
        else {
            id = schoolId;
            userType = "school";
        }
        // Fire emulation request, which will take some time, and direct user to emulation loading page
        this.props.emulateUser(id, userType).then(function (result) {
            if (!result) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate("admin.common.messageEmulateError"));
                return;
            }
        });
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_EMULATE_USER); // Show them a fancy page while we mess with their emulation info
    };
    Clients.prototype.editClient = function (clientId) {
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLIENT, clientId));
    };
    Clients.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_8_src_api_ClientApiController__["a" /* default */].getClientTableData(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    Clients.prototype.customTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLIENT, record.clientId); };
        return [
            __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["e" /* default */].StandardColumns.Text("admin.clients.columnHeader1", 'clientName'),
            // DataTable.StandardColumns.Text("admin.clients.columnHeader2", 'clientTypeName'),
            __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Enum(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.clients.columnHeader2" }), "clientTypeName", ["State", "District", "School"]),
            __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["e" /* default */].StandardColumns.Text("admin.clients.columnHeader3", 'locationName'),
            {
                columnProps: {
                    key: 'emulate',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.common.emulateColumnHeader" }), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_button___default.a, { shape: "circle", icon: "user", title: "view", onClick: function () { return _this.emulateClient(record.stateId, record.districtId, record.schoolId); } })));
                    }
                }
            },
            {
                columnProps: {
                    key: 'edit',
                    align: 'center',
                    width: 35,
                    render: function (text, record) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.common.editColumnHeader" }), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_button___default.a, { shape: "circle", icon: "edit", title: "edit", onClick: function () { return _this.editClient(record.clientId); } })));
                    }
                }
            },
        ];
    };
    Clients.prototype.render = function () {
        var _this = this;
        if (this.state.formRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLIENT, push: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.clients.tableHeader" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["e" /* default */], { serverSide: true, tableProps: { rowKey: 'clientId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["a" /* DataTableButton */]("admin.clients.addButton", function () { _this.setState({ formRedirect: true }); }),
                    new __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return Clients;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        emulateUser: function (id, type) { return __WEBPACK_IMPORTED_MODULE_6_src_redux_UserActions__["a" /* default */].EmulateUser(dispatch, type, id); },
    });
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(Clients)));


/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_radio__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_radio_style_index_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ClientSubscriptions__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__AdminFullSyncReports__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_api_ClientApiController__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_api_StateApiController__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_utils_FormUtil__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_constants_Languages__ = __webpack_require__(80);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};































var RadioGroup = __WEBPACK_IMPORTED_MODULE_20_antd_es_radio__["c" /* default */].Group;
// Form
var ClientForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    },
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        var _this = _super.call(this, props) || this;
        _this.validateState = function (rule, value, callback) {
            value ? callback() : callback(' ');
        };
        return _this;
    }
    class_1.prototype.generateOptionsForSelect = function (keyValues) {
        return keyValues.map(function (keyValue) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { value: keyValue.value, key: keyValue.key, title: keyValue.key }, keyValue.key)); });
    };
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        var rules = [];
        if (required) {
            rules.push({ required: true, message: this.props.translate('admin.common.requiredRule') });
        }
        if (id === 'stateId') {
            rules.push({ validator: this.validateState });
        }
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: rules,
            })(inputType)));
        }
    };
    class_1.prototype.render = function () {
        var _this = this;
        var choosenClientType = this.props.clientTypes.find(function (x) { return x.value === _this.props.currentClient.clientTypeId; }).key.toLowerCase();
        var isStateClient = choosenClientType === 'state';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_utils_FormUtil__["a" /* GenericFormItem */], { form: this.props.form, labelId: 'admin.addEditClient.formItem1', id: "clientName", initialValue: this.props.currentClient.clientName },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" })),
                    this.renderStandardFormItem('admin.addEditClient.formItem2', 'clientTypeId', this.props.currentClient.clientTypeId, this.props.currentClient.clientId ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], { disabled: true }, this.generateOptionsForSelect(this.props.clientTypes))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], null, this.generateOptionsForSelect(this.props.clientTypes)))),
                    this.renderStandardFormItem('admin.addEditClient.formItem3', 'countryId', this.props.currentClient.countryId, this.props.currentClient.clientId ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], { disabled: true }, this.generateOptionsForSelect(this.props.countries))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], null, this.generateOptionsForSelect(this.props.countries))), isStateClient),
                    this.renderStandardFormItem('admin.addEditClient.formItem4', 'stateId', this.props.currentClient.stateId, this.props.currentClient.clientId ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], { disabled: true }, this.generateOptionsForSelect(this.props.states)) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], null, this.generateOptionsForSelect(this.props.states)), isStateClient),
                    this.renderStandardFormItem('admin.addEditClient.' + choosenClientType, 'districtSchoolName', this.props.currentClient.districtSchoolName, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" }), !isStateClient),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_src_utils_FormUtil__["a" /* GenericFormItem */], { form: this.props.form, labelId: "admin.addEditClient.formItem5", id: "cultureIds", initialValue: this.props.currentClient.cultureIds },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], { mode: "multiple", allowClear: true, placeholder: "Please select culture" }, __WEBPACK_IMPORTED_MODULE_30_src_constants_Languages__["a" /* default */].All.map(function (x) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { key: "cultureIds" + x.id, value: x.id },
                            x.name,
                            " (",
                            x.code,
                            ")")); })))))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
// Full Sync Form
var FullSyncForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    },
})(/** @class */ (function (_super) {
    __extends(class_2, _super);
    function class_2(props) {
        var _this = _super.call(this, props) || this;
        _this.validateState = function (rule, value, callback) {
            value ? callback() : callback(' ');
        };
        return _this;
    }
    class_2.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        var rules = [];
        if (required) {
            rules.push({ required: true, message: this.props.translate('admin.common.requiredRule') });
        }
        if (id === 'stateId') {
            rules.push({ validator: this.validateState });
        }
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: rules,
            })(inputType)));
        }
    };
    class_2.prototype.renderCleverDistrictIdItem = function (translationId, id, initialValue) {
        var translatedLabel = this.props.translate(translationId);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
            initialValue: initialValue,
        })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" }))));
    };
    class_2.prototype.renderDistrictClassLinkTenantIdItem = function (translationId, id, initialValue) {
        var translatedLabel = this.props.translate(translationId);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
            initialValue: initialValue,
        })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" }))));
    };
    class_2.prototype.render = function () {
        var _this = this;
        var choosenClientType = this.props.clientTypes.find(function (x) { return x.value === _this.props.currentClient.clientTypeId; }).key.toLowerCase();
        var ssoDistrictId = choosenClientType === 'district' ? 'cleverDistrictId' : '';
        var syncStudents = choosenClientType === 'district' ? 'syncStudents' : '';
        var syncTeachers = choosenClientType === 'district' ? 'syncTeachers' : '';
        var fullSync = choosenClientType === 'district' ? 'fullSync' : '';
        var isStateClient = choosenClientType === 'state';
        var classLinkTenantId = choosenClientType === 'district' ? 'classLinkTenantId' : '';
        var syncClassLinkStudentsAndTeachers = choosenClientType === 'district' ? 'syncClassLinkStudentsAndTeachers' : '';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    this.renderCleverDistrictIdItem('admin.addEditClient.' + ssoDistrictId, 'cleverDistrictId', this.props.currentClient.cleverDistrictId),
                    this.renderStandardFormItem('admin.addEditClient.' + syncStudents, 'syncStudents', this.props.currentClient.syncStudents, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadioGroup, { name: "syncStudents", value: this.props.currentClient.syncStudents },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_radio__["c" /* default */], { value: true, checked: this.props.currentClient.syncStudents === true }, this.props.translate('admin.addEditClient.yes')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_radio__["c" /* default */], { value: false, checked: this.props.currentClient.syncStudents === false }, this.props.translate('admin.addEditClient.no'))), !isStateClient, false),
                    this.renderStandardFormItem('admin.addEditClient.' + syncTeachers, 'syncTeachers', this.props.currentClient.syncTeachers, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadioGroup, { name: "syncTeachers", value: this.props.currentClient.syncTeachers },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_radio__["c" /* default */], { value: true, checked: this.props.currentClient.syncTeachers === true }, this.props.translate('admin.addEditClient.yes')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_radio__["c" /* default */], { value: false, checked: this.props.currentClient.syncTeachers === false }, this.props.translate('admin.addEditClient.no'))), !isStateClient, false),
                    this.renderStandardFormItem('admin.addEditClient.' + fullSync, 'fullSync', this.props.currentClient.fullSync, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadioGroup, { name: "fullSync", value: this.props.currentClient.fullSync },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_radio__["c" /* default */], { value: true, checked: this.props.currentClient.fullSync === true }, this.props.translate('admin.addEditClient.yes')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_radio__["c" /* default */], { value: false, checked: this.props.currentClient.fullSync === false }, this.props.translate('admin.addEditClient.no'))), !isStateClient, false),
                    this.renderDistrictClassLinkTenantIdItem('admin.addEditClient.' + classLinkTenantId, 'classLinkTenantId', this.props.currentClient.classLinkTenantId),
                    this.renderStandardFormItem('admin.addEditClient.' + syncClassLinkStudentsAndTeachers, 'syncClassLinkStudentsAndTeachers', this.props.currentClient.syncClassLinkStudentsAndTeachers, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadioGroup, { name: "syncClassLinkStudentsAndTeachers", value: this.props.currentClient.syncClassLinkStudentsAndTeachers },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_radio__["c" /* default */], { value: true, checked: this.props.currentClient.syncClassLinkStudentsAndTeachers === true }, this.props.translate('admin.addEditClient.yes')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_radio__["c" /* default */], { value: false, checked: this.props.currentClient.syncClassLinkStudentsAndTeachers === false }, this.props.translate('admin.addEditClient.no'))), !isStateClient, false)))));
    };
    return class_2;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditClient = /** @class */ (function (_super) {
    __extends(AddEditClient, _super);
    function AddEditClient(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function (e) {
            e.preventDefault();
            if (!_this.state.currentClient.cleverDistrictId && !_this.state.currentClient.classLinkTenantId) {
                _this.validateAndSubmit();
            }
            else {
                // validate Clever District Id
                // this article helped with figuring out how to do async validation:
                // http://blog.frajtak.cz/2019/12/communicating-server-side-input-validation-failures-with-graphql-and-ant-design-form/
                if (_this.state.currentClient.cleverDistrictId != null && _this.state.currentClient.cleverDistrictId.trim() !== '') {
                    var client = __assign(__assign({}, _this.state.currentClient), { cleverDistrictId: _this.state.currentClient.cleverDistrictId });
                    __WEBPACK_IMPORTED_MODULE_27_src_api_ClientApiController__["a" /* default */].isDuplicateCleverDistrictId(client)
                        .then(function (result) {
                        if (result.data === true) {
                            _this.formRef.props.form.setFields({
                                cleverDistrictId: {
                                    value: _this.state.currentClient.cleverDistrictId,
                                    errors: [new Error('"This CleverId is already being used"')],
                                },
                            });
                        }
                        else {
                            _this.validateAndSubmit();
                        }
                    })
                        .catch(function (e) { return _this.validateAndSubmit(); });
                }
                else if (_this.state.currentClient.classLinkTenantId != null && _this.state.currentClient.classLinkTenantId > 0) {
                    var client = __assign(__assign({}, _this.state.currentClient), { classLinkTenantId: _this.state.currentClient.classLinkTenantId });
                    __WEBPACK_IMPORTED_MODULE_27_src_api_ClientApiController__["a" /* default */].isDuplicateClassLinkTenantId(client)
                        .then(function (result) {
                        if (result.data === true) {
                            _this.formRef.props.form.setFields({
                                classLinkTenantId: {
                                    value: _this.state.currentClient.classLinkTenantId,
                                    errors: [new Error('"This ClassLinkTenantId is already being used"')],
                                },
                            });
                        }
                        else {
                            _this.validateAndSubmit();
                        }
                    })
                        .catch(function (e) { return _this.validateAndSubmit(); });
                }
            }
        };
        Object(__WEBPACK_IMPORTED_MODULE_22_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditClient.prototype);
        var clientId = parseInt(_this.props.match.params.id, 10);
        var currentClient = {
            clientId: clientId,
            clientTypeId: 1,
            clientName: '',
            districtSchoolName: '',
            cleverDistrictId: '',
            syncStudents: false,
            syncTeachers: false,
            fullSync: false,
            fullSyncEndTimeStudents: null,
            fullSyncEndTimeTeachers: null,
            countryId: null,
            stateId: null,
            cultureIds: [],
            modifiedBy: '',
            modifiedDate: null,
            classLinkTenantId: null,
            syncClassLinkStudentsAndTeachers: false,
        };
        _this.state = {
            loading: true,
            isSubmitting: false,
            clientTypes: [],
            countries: [],
            states: [],
            currentClient: currentClient,
        };
        return _this;
    }
    AddEditClient.prototype.componentWillMount = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_27_src_api_ClientApiController__["a" /* default */].getClientTypes()
            .then(function (result) {
            _this.setState({ clientTypes: result.data }, _this.getCountries);
        })
            .catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.common.messageClientTypeError'));
        });
    };
    AddEditClient.prototype.getCountries = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_28_src_api_StateApiController__["a" /* default */].getCountries()
            .then(function (result) {
            _this.setState({ countries: result.data.keyValues }, _this.fillForm);
        })
            .catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.common.messageCountryError'));
        });
    };
    AddEditClient.prototype.fillForm = function () {
        var _this = this;
        if (this.state.currentClient.clientId) {
            __WEBPACK_IMPORTED_MODULE_27_src_api_ClientApiController__["a" /* default */].getClient(this.state.currentClient.clientId)
                .then(function (result) {
                _this.setState({
                    loading: false,
                    currentClient: result.data,
                }, _this.getStates);
            })
                .catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditClient.messageRetrieveError'));
            });
        }
        else {
            var firstCountryId = this.state.countries.find(function (_) { return true; }).value;
            var cultureIds = __WEBPACK_IMPORTED_MODULE_30_src_constants_Languages__["a" /* default */].All.map(function (x) { return x.id; });
            var newCurrentClient = __assign(__assign({}, this.state.currentClient), { countryId: firstCountryId, cultureIds: cultureIds });
            this.setState({
                loading: false,
                currentClient: newCurrentClient,
            }, this.getStates);
        }
    };
    AddEditClient.prototype.getStates = function (maybeCountryId) {
        var _this = this;
        var countryId = maybeCountryId ? maybeCountryId : this.state.currentClient.countryId;
        var includeClientStates = this.state.currentClient.clientId ? true : false;
        if (countryId) {
            __WEBPACK_IMPORTED_MODULE_28_src_api_StateApiController__["a" /* default */].getStatesByCountry(countryId, includeClientStates)
                .then(function (result) {
                var stateId = _this.state.currentClient.clientId ? _this.state.currentClient.stateId : result.data.keyValues.find(function (_) { return true; }).value;
                var newCurrentClient = __assign(__assign({}, _this.state.currentClient), { stateId: stateId });
                _this.setState({
                    states: result.data.keyValues,
                    currentClient: newCurrentClient,
                });
            })
                .catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.common.messageStateError'));
            });
        }
    };
    AddEditClient.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                if (key === 'countryId') {
                    this.getStates(field.value);
                }
                if (key === 'fullSync') {
                    if (field.value === true) {
                        newState['syncStudents'] = true;
                        newState['syncTeachers'] = true;
                    }
                    else {
                        newState['syncStudents'] = false;
                        newState['syncTeachers'] = false;
                    }
                }
                newState[key] = field.value;
            }
        }
        this.setState({
            currentClient: __assign(__assign({}, this.state.currentClient), newState),
        });
    };
    AddEditClient.prototype.addClient = function () {
        var _this = this;
        var AddClientDTO = {
            clientName: this.state.currentClient.clientName,
            clientTypeId: this.state.currentClient.clientTypeId,
            districtSchoolName: this.state.currentClient.districtSchoolName,
            countryId: this.state.currentClient.countryId,
            stateId: this.state.currentClient.stateId,
            cultureIds: this.state.currentClient.cultureIds,
        };
        __WEBPACK_IMPORTED_MODULE_27_src_api_ClientApiController__["a" /* default */].addClient(AddClientDTO)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditClient.messageAdd'));
            _this.setState({ isSubmitting: false });
            var redirectUrl = __WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLIENT, result.data.data);
            _this.props.history.push(redirectUrl);
        })
            .catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditClient.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditClient.prototype.updateClient = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_27_src_api_ClientApiController__["a" /* default */].updateClient(this.state.currentClient)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditClient.messageUpdate'));
            _this.setState({ isSubmitting: false });
            _this.handleRedirect();
        })
            .catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditClient.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditClient.prototype.validateAndSubmit = function () {
        var _this = this;
        var hasCleverInfo = this.state.currentClient.cleverDistrictId != null && this.state.currentClient.cleverDistrictId.trim() !== '';
        var hasClassLinkInfo = this.state.currentClient.classLinkTenantId != null && this.state.currentClient.classLinkTenantId > 0;
        if (hasCleverInfo && hasClassLinkInfo) {
            this.formRef.props.form.setFields({
                cleverDistrictId: {
                    value: this.state.currentClient.cleverDistrictId,
                    errors: [new Error('"Please only enter a value for either CleverId or ClassLinkTenantId, not both."')],
                },
                classLinkTenantId: {
                    value: this.state.currentClient.classLinkTenantId,
                    errors: [new Error('"Please only enter a value for either CleverId or ClassLinkTenantId, not both."')],
                }
            });
            return;
        }
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.state.currentClient.clientId ? _this.updateClient() : _this.addClient();
            }
        });
    };
    AddEditClient.prototype.handleRedirect = function () {
        var redirectUrl = __WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].ADMIN_CLIENTS);
        this.props.history.push(redirectUrl);
    };
    AddEditClient.prototype.handleCancel = function (e) {
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].ADMIN_CLIENTS);
    };
    AddEditClient.prototype.renderClientSubscriptions = function () {
        var dataTableProps = {
            clientId: this.state.currentClient.clientId,
        };
        if (this.state.currentClient.clientId) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__ClientSubscriptions__["a" /* default */], __assign({}, dataTableProps));
        }
    };
    AddEditClient.prototype.renderAdminFullSyncReports = function () {
        var fullSyncCompletionEndDateStudents = this.state.currentClient.fullSyncEndTimeStudents !== null ? new Date(this.state.currentClient.fullSyncEndTimeStudents.toLocaleString()) : '';
        var fullSyncCompletionEndDateTeachers = this.state.currentClient.fullSyncEndTimeTeachers !== null ? new Date(this.state.currentClient.fullSyncEndTimeTeachers.toLocaleString()) : '';
        var lastSyncModifiedBy = this.state.currentClient.modifiedBy !== null ? this.state.currentClient.modifiedBy : '';
        var lastSyncModifiedDate = this.state.currentClient.modifiedDate !== null ? new Date(this.state.currentClient.modifiedDate.toLocaleString()) : '';
        var dataTableProps = {
            districtId: this.state.currentClient.districtId,
            districtName: this.state.currentClient.clientName,
            fullSyncCompletionEndDateStudents: fullSyncCompletionEndDateStudents,
            fullSyncCompletionEndDateTeachers: fullSyncCompletionEndDateTeachers,
            lastSyncModifiedBy: lastSyncModifiedBy,
            lastSyncModifiedDate: lastSyncModifiedDate,
        };
        if (this.state.currentClient.districtId) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26__AdminFullSyncReports__["a" /* default */], __assign({}, dataTableProps));
        }
    };
    AddEditClient.prototype.render = function () {
        var _this = this;
        if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            currentClient: this.state.currentClient,
            clientTypes: this.state.clientTypes,
            countries: this.state.countries,
            states: this.state.states,
            translate: this.props.translate,
            onChange: this.handleInputChange,
        };
        var syncFormProps = {
            currentClient: this.state.currentClient,
            clientTypes: this.state.clientTypes,
            countries: this.state.countries,
            states: this.state.states,
            translate: this.props.translate,
            onChange: this.handleInputChange,
        };
        var choosenClientType = this.state.clientTypes.find(function (x) { return x.value === _this.state.currentClient.clientTypeId; }).key.toLowerCase();
        var isDistrict = !(choosenClientType === 'district');
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "full-sync-report" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.state.currentClient.clientId ? this.state.currentClient.clientName : this.props.translate('admin.addEditClient.addHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientForm, __assign({ wrappedComponentRef: function (ref) { return (_this.formRef = ref); } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { hidden: isDistrict },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "horizontal" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, this.props.translate('admin.addEditClient.fullSyncConfiguration')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FullSyncForm, __assign({ wrappedComponentRef: function (ref) { return (_this.formRef = ref); } }, syncFormProps))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate('admin.common.saveButton')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate('common.back'))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { hidden: isDistrict }, this.renderAdminFullSyncReports()),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "horizontal" }),
            this.renderClientSubscriptions()));
    };
    return AddEditClient;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["d" /* withLocalize */])(AddEditClient));


/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_api_ClientApiController__ = __webpack_require__(250);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder




var ClientSubscriptions = /** @class */ (function (_super) {
    __extends(ClientSubscriptions, _super);
    function ClientSubscriptions(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, ClientSubscriptions.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
        return _this;
    }
    ClientSubscriptions.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_6_src_api_ClientApiController__["a" /* default */].getClientSubscriptionTableData(requestState, this.props.clientId)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    ClientSubscriptions.prototype.customTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLIENT_SUBSCRIPTION, _this.props.clientId, record.clientSubscriptionId); };
        return [
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Number('admin.clientSubscriptions.columnHeader1', 'maximumUserCount'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Date('admin.clientSubscriptions.columnHeader2', 'subscriptionStartDate'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Date('admin.clientSubscriptions.columnHeader3', 'subscriptionExpirationDate'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit')
        ];
    };
    ClientSubscriptions.prototype.render = function () {
        var _this = this;
        if (this.state.formRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLIENT_SUBSCRIPTION, this.props.clientId, 0), push: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate("admin.clientSubscriptions.tableHeader")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */], { serverSide: true, tableProps: { rowKey: 'clientSubscriptionId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["a" /* DataTableButton */]("admin.clientSubscriptions.addButton", function () { _this.setState({ formRedirect: true }); }),
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return ClientSubscriptions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(ClientSubscriptions));


/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_date_picker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_date_picker_style_index_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_input_number__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_input_number_style_index_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_moment__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_api_ClientApiController__ = __webpack_require__(250);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



























 // 'this' binder




// Form
var ClientSubscriptionForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    }
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        return _super.call(this, props) || this;
    }
    class_1.prototype.getInitialDateValue = function (date) {
        return date ? __WEBPACK_IMPORTED_MODULE_29_moment___default()(date, 'YYYY-MM-DD') : null;
    };
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
            })(inputType)));
        }
    };
    class_1.prototype.render = function () {
        var _this = this;
        var dateFormat = "M/D/YYYY";
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    this.renderStandardFormItem("admin.addEditClientSubscription.formItem1", "maximumUserCount", this.props.currentClientSubscription.maximumUserCount, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_input_number__["a" /* default */], { autoComplete: "off", min: 0, formatter: function (value) { return ("" + value).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }, parser: function (value) { return parseInt(value.replace(/\$\s?|(,*)/g, ''), 10) || 0; } })),
                    this.renderStandardFormItem("admin.addEditClientSubscription.formItem2", "subscriptionStartDate", this.getInitialDateValue(this.props.currentClientSubscription.subscriptionStartDate), this.props.currentClientSubscription.clientSubscriptionId ?
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_date_picker__["a" /* default */], { format: dateFormat, disabled: true }) :
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_date_picker__["a" /* default */], { format: dateFormat, disabledDate: function (current) { return current && _this.props.currentClientSubscription.subscriptionExpirationDate && current > _this.props.form.getFieldValue('subscriptionExpirationDate'); } })),
                    this.renderStandardFormItem("admin.addEditClientSubscription.formItem3", "subscriptionExpirationDate", this.getInitialDateValue(this.props.currentClientSubscription.subscriptionExpirationDate), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_date_picker__["a" /* default */], { format: dateFormat, disabledDate: function (current) { return current && _this.props.currentClientSubscription.subscriptionStartDate && current < _this.props.form.getFieldValue('subscriptionStartDate'); } })),
                    this.renderStandardFormItem("admin.addEditClientSubscription.formItem4", "isActive", this.props.currentClientSubscription.isActive, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_checkbox__["a" /* default */], { checked: this.props.currentClientSubscription.isActive }), this.props.currentClientSubscription.clientSubscriptionId ? true : false)))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditClientSubscription = /** @class */ (function (_super) {
    __extends(AddEditClientSubscription, _super);
    function AddEditClientSubscription(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_27_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditClientSubscription.prototype);
        var clientId = parseInt(_this.props.match.params.clientId, 10);
        var clientSubscriptionId = parseInt(_this.props.match.params.clientSubscriptionId, 10);
        var currentClientSubscription = {
            clientSubscriptionId: clientSubscriptionId,
            isActive: false,
            maximumUserCount: null,
            subscriptionStartDate: null,
            subscriptionExpirationDate: null
        };
        _this.state = {
            loading: true,
            isSubmitting: false,
            redirect: false,
            clientId: clientId,
            currentClientSubscription: currentClientSubscription
        };
        return _this;
    }
    AddEditClientSubscription.prototype.componentWillMount = function () {
        this.fillForm();
    };
    AddEditClientSubscription.prototype.fillForm = function () {
        var _this = this;
        if (this.state.currentClientSubscription.clientSubscriptionId) {
            __WEBPACK_IMPORTED_MODULE_31_src_api_ClientApiController__["a" /* default */].getClientSubscription(this.state.currentClientSubscription.clientSubscriptionId)
                .then(function (result) {
                _this.setState({
                    loading: false,
                    currentClientSubscription: result.data
                });
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_16_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditClientSubscription.messageRetrieveError'));
            });
        }
        else {
            this.setState({
                loading: false
            });
        }
    };
    AddEditClientSubscription.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                newState[key] = field.value;
            }
        }
        this.setState({
            currentClientSubscription: __assign(__assign({}, this.state.currentClientSubscription), newState)
        });
    };
    AddEditClientSubscription.prototype.addClientSubscription = function () {
        var _this = this;
        var addClientSubscriptionDTO = {
            clientId: this.state.clientId,
            isActive: true,
            maximumUserCount: this.state.currentClientSubscription.maximumUserCount,
            subscriptionStartDate: this.state.currentClientSubscription.subscriptionStartDate,
            subscriptionExpirationDate: this.state.currentClientSubscription.subscriptionExpirationDate
        };
        __WEBPACK_IMPORTED_MODULE_31_src_api_ClientApiController__["a" /* default */].addClientSubscription(addClientSubscriptionDTO)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_16_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditClientSubscription.messageAdd'));
            _this.setState({ redirect: true, isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_16_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditClientSubscription.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditClientSubscription.prototype.updateClientSubscription = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_31_src_api_ClientApiController__["a" /* default */].updateClientSubscription(this.state.currentClientSubscription)
            .then(function (result) {
            _this.setState({ isSubmitting: false });
            if (result.data.isSuccess) {
                __WEBPACK_IMPORTED_MODULE_16_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditClientSubscription.messageUpdate'));
                _this.setState({ redirect: true });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_16_antd_es_message__["a" /* default */].error(result.data.errorMessage);
            }
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_16_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditClientSubscription.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditClientSubscription.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.state.currentClientSubscription.clientSubscriptionId ?
                    _this.updateClientSubscription() :
                    _this.addClientSubscription();
            }
        });
    };
    AddEditClientSubscription.prototype.handleCancel = function (e) {
        this.setState({ redirect: true });
    };
    AddEditClientSubscription.prototype.render = function () {
        var _this = this;
        if (this.state.redirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_28_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_28_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLIENT, this.state.clientId), push: true });
        }
        else if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            currentClientSubscription: this.state.currentClientSubscription,
            clientId: this.state.clientId,
            translate: this.props.translate,
            onChange: this.handleInputChange
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.state.currentClientSubscription.clientSubscriptionId ?
                this.props.translate("admin.addEditClientSubscription.editHeader") :
                this.props.translate("admin.addEditClientSubscription.addHeader")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientSubscriptionForm, __assign({ wrappedComponentRef: function (ref) { return _this.formRef = ref; } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate("admin.common.saveButton")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate("common.back")))));
    };
    return AddEditClientSubscription;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_30_react_localize_redux__["d" /* withLocalize */])(AddEditClientSubscription));


/***/ }),
/* 2131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_api_StatementApiController__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};













var Statements = /** @class */ (function (_super) {
    __extends(Statements, _super);
    function Statements(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, Statements.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false,
        };
        return _this;
    }
    Statements.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_7_src_api_StatementApiController__["a" /* default */].getStatementTableData(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    Statements.prototype.customTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) {
            if (record.allowEdit) {
                return __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_STATEMENT, record.statementId);
            }
            else {
                return "";
            }
        };
        var defaultTooltipProps = {
            mouseLeaveDelay: 0.5,
            mouseEnterDelay: 0.2
        };
        var columns = [
            __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.statements.columnHeader1', 'statementText'),
            {
                columnProps: {
                    title: this.props.translate('admin.statements.columnHeader2'),
                    dataIndex: 'grades',
                    render: (function (text) { return text.join(); }),
                    sorter: true
                },
                filterType: __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["d" /* Filterer */].Text
            },
            {
                columnProps: {
                    key: 'edit',
                    align: 'center',
                    width: 35,
                    render: function (text, statement, index) {
                        if (statement.allowEdit) {
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_tooltip__["a" /* default */], __assign({ placement: "bottom", title: _this.props.translate('admin.common.editColumnHeader'), arrowPointAtCenter: true }, defaultTooltipProps),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_STATEMENT, statement.statementId) },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: "edit" }))));
                        }
                        else {
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_tooltip__["a" /* default */], __assign({ placement: "bottom", title: _this.props.translate('admin.common.editColumnHeader'), arrowPointAtCenter: true }, defaultTooltipProps),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: "edit", disabled: true })));
                        }
                    }
                }
            }
        ];
        var deleteIcon = {
            columnProps: {
                key: 'delete',
                align: 'center',
                width: 35,
                render: function (text, statement, index) {
                    if (statement.allowEdit) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_tooltip__["a" /* default */], __assign({ placement: "bottom", title: _this.props.translate('admin.common.deleteColumnHeader'), arrowPointAtCenter: true }, defaultTooltipProps),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: "delete", onClick: function () { return _this.softDeleteStatement(statement); } })));
                    }
                    else {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_tooltip__["a" /* default */], __assign({ placement: "bottom", title: _this.props.translate('admin.common.deleteColumnHeader'), arrowPointAtCenter: true }, defaultTooltipProps),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: "delete", disabled: true })));
                    }
                }
            }
        };
        // If the deep copy button is showing, they haven't deep copied the generic statements, so don't let them delete them
        if (!this.showDeepCopyButton()) {
            columns.push(deleteIcon);
        }
        return columns;
    };
    /**
     * Clear Statement's IsActive property
     */
    Statements.prototype.softDeleteStatement = function (statement) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_7_src_api_StatementApiController__["a" /* default */].softDeleteStatement(statement.statementId).then(function () {
            // Refresh the datatable
            _this.dataTableRef.refresh();
        });
    };
    Statements.prototype.deepCopyGenericStatements = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_7_src_api_StatementApiController__["a" /* default */].copyKuderGenericIStatements().then(function () {
            // Refresh the datatable
            _this.dataTableRef.refresh();
        });
    };
    /**
     * Only show deep copy option if they aren't a kuder admin and they don't have any of their own "I" Statements
     */
    Statements.prototype.showDeepCopyButton = function () {
        if (this.props.User.roleID === __WEBPACK_IMPORTED_MODULE_8_src_constants_Roles__["a" /* Roles */].KuderAdmin.id || this.state.tableRecords.length === 0) {
            return false;
        }
        var tr;
        for (var _i = 0, _a = this.state.tableRecords; _i < _a.length; _i++) {
            tr = _a[_i];
            if (!tr.isKuderGeneric) {
                return false;
            }
        }
        return true;
    };
    Statements.prototype.getButtons = function () {
        var _this = this;
        var buttons = [
            new __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["a" /* DataTableButton */]('admin.statements.addButton', function () { _this.setState({ formRedirect: true }); }),
            new __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
        ];
        if (this.showDeepCopyButton()) {
            buttons.splice(0, 0, new __WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["a" /* DataTableButton */]('admin.statements.deepCopyButton', function () { _this.deepCopyGenericStatements(); }));
        }
        return buttons;
    };
    Statements.prototype.render = function () {
        var _this = this;
        if (this.state.formRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_STATEMENT, push: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.statements.tableHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'statementId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: this.getButtons() })));
    };
    return Statements;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_5_react_localize_redux__["d" /* withLocalize */])(Statements)));


/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_api_StatementApiController__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_admin_ViewStatementModal__ = __webpack_require__(843);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var StudentStatements = /** @class */ (function (_super) {
    __extends(StudentStatements, _super);
    function StudentStatements(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_9_src_utils_BindThisHelper__["a" /* default */])(_this, StudentStatements.prototype);
        var userId = parseInt(_this.props.match.params.userId, 10);
        var classroomId = parseInt(_this.props.match.params.classroomId, 10) || 0;
        _this.state = {
            tableRecords: [],
            loading: true,
            currentStudentId: userId,
            classroomId: classroomId,
            selectedStatement: null,
        };
        return _this;
    }
    StudentStatements.prototype.updateStudentStatement = function (statementId, gradeId) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_13_src_api_StatementApiController__["a" /* default */].adminUpdateStudentStatementCompletion(statementId, this.state.currentStudentId, gradeId)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_3_antd_es_message__["a" /* default */].success(_this.props.translate('admin.studentStatements.messageUpdate'));
            _this.dataTableRef.refresh();
        });
    };
    StudentStatements.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_13_src_api_StatementApiController__["a" /* default */].getStudentStatementTableData(requestState, this.state.currentStudentId)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results.length > 0 ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            console.log(tableRecords);
            callback(results.data);
        });
    };
    StudentStatements.prototype.openNotesModal = function (record) {
        this.setState({ selectedStatement: record });
    };
    StudentStatements.prototype.closeNotesModal = function () {
        this.setState({ selectedStatement: null });
    };
    StudentStatements.prototype.customTableColumns = function () {
        var _this = this;
        return [
            {
                columnProps: {
                    title: this.props.translate('admin.studentStatements.columnHeader2'),
                    dataIndex: 'isCompleted',
                    sorter: true,
                    render: function (text, record) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_checkbox__["a" /* default */], { checked: record.userCompletion != null ? record.userCompletion.isCompleted : false, onChange: function () { return _this.updateStudentStatement(record.statementId, record.gradeId); } })); },
                },
                filterType: __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["d" /* Filterer */].BooleanCheckbox
            },
            __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.studentStatements.columnHeader1" }), "statementText"),
            __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["e" /* default */].AdvancedColumns.CustomLegacy("Notes", "userCompletion", 80, "DEFAULT", "Text", function (text, record) {
                if (record.userCompletion == null || record.userCompletion.statementNotes == null || record.userCompletion.statementNotes.length < 1) {
                    return null;
                }
                return "Yes";
            }),
            __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["e" /* default */].AdvancedColumns.CustomLegacy("Files", "userCompletion", 80, "DEFAULT", "Text", function (text, record) {
                if (record.userCompletion == null || record.userCompletion.statementFiles == null || record.userCompletion.statementFiles.length === 0) {
                    return null;
                }
                return "Yes";
            }),
            {
                columnProps: {
                    key: 'view',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: "View Files", arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_button__["a" /* default */], { shape: "circle", icon: "profile", onClick: function () { return _this.openNotesModal(record); } })));
                    }
                }
            }
        ];
    };
    StudentStatements.prototype.handleRedirect = function () {
        var isAdminTable = false;
        var redirectUrl = this.state.classroomId ?
            __WEBPACK_IMPORTED_MODULE_10_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_10_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLASSROOM, this.state.classroomId) :
            __WEBPACK_IMPORTED_MODULE_10_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_10_src_core_Routes__["a" /* default */].ADMIN_USERS, isAdminTable);
        this.props.history.push(redirectUrl);
    };
    StudentStatements.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.studentStatements.tableHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'statementUserId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["a" /* DataTableButton */]('common.back', this.handleRedirect),
                    new __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_src_components_admin_ViewStatementModal__["a" /* default */], { visible: this.state.selectedStatement != null, statement: this.state.selectedStatement, onClose: this.closeNotesModal })));
    };
    return StudentStatements;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["d" /* withLocalize */])(StudentStatements));


/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_api_StatementApiController__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_input_TextArea__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_input_TextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_input_TextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_constants_Grades__ = __webpack_require__(78);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

























 // 'this' binder






// Form
var StatementForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    }
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        return _super.call(this, props) || this;
    }
    class_1.prototype.generateOptionsForSelect = function (keyValues) {
        return keyValues.map(function (keyValue) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { value: keyValue.value, key: keyValue.key, title: keyValue.key }, keyValue.key); });
    };
    class_1.prototype.generateLanguageOptions = function () {
        // Only available languages
        return __WEBPACK_IMPORTED_MODULE_30_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable; })
            .map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "cultureIds" + x.id, value: x.id },
            x.name,
            " (",
            x.code,
            ")"); });
    };
    class_1.prototype.renderTranslations = function () {
        var _this = this;
        if (this.props.currentStatement) {
            var translations = this.props.currentStatement.translations.filter(function (t) { return _this.props.allCultures.find(function (c) { return c.id === t.cultureId; }); });
            return translations.map(function (translation, index) {
                var id = "translations[" + index + "].text";
                var culture = _this.props.allCultures.find(function (culture) { return culture.id === translation.cultureId; }).code.toLowerCase();
                var translationId = "admin.addEditStatement." + culture;
                return _this.renderStandardFormItem(translationId, id, translation.text, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_antd_lib_input_TextArea___default.a, { rows: 4, autoComplete: "off" }), _this.props.selectedCultureId === translation.cultureId);
            });
        }
    };
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
            })(inputType)));
        }
    };
    class_1.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    this.renderStandardFormItem("admin.addEditStatement.formItem1", "gradeIds", this.props.currentStatement.gradeIds, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], { optionFilterProp: "title", mode: "multiple" }, __WEBPACK_IMPORTED_MODULE_31_src_constants_Grades__["a" /* Grades */].All.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "grade" + x.id, value: x.id }, x.shortName); }))),
                    this.renderStandardFormItem("admin.addEditStatement.formItem2", "selectedCultureId", this.props.selectedCultureId, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], null, this.generateLanguageOptions())),
                    this.renderTranslations()))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditStatement = /** @class */ (function (_super) {
    __extends(AddEditStatement, _super);
    function AddEditStatement(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_25_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditStatement.prototype);
        var statementId = parseInt(_this.props.match.params.id, 10);
        var currentStatement = {
            statementId: statementId,
            isActive: true,
            gradeIds: [],
            translations: []
        };
        _this.state = {
            loading: true,
            isSubmitting: false,
            redirect: false,
            allGrades: [],
            allCultures: [],
            selectedCultureId: 0,
            currentStatement: currentStatement
        };
        return _this;
    }
    AddEditStatement.prototype.componentWillMount = function () {
        var grades = __WEBPACK_IMPORTED_MODULE_31_src_constants_Grades__["a" /* Grades */].All;
        var cultures = __WEBPACK_IMPORTED_MODULE_30_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable; });
        this.setState({
            allGrades: grades,
            allCultures: cultures,
            selectedCultureId: cultures[0].id
        }, this.fillForm);
    };
    AddEditStatement.prototype.statementsAreCompleted = function () {
        var translations = this.state.currentStatement.translations;
        var emptyTranslations = translations.filter(function (translation) {
            return translation.text === null || translation.text === "";
        });
        return emptyTranslations.length === 0;
    };
    AddEditStatement.prototype.fillForm = function () {
        var _this = this;
        if (this.state.currentStatement.statementId) {
            __WEBPACK_IMPORTED_MODULE_28_src_api_StatementApiController__["a" /* default */].getStatement(this.state.currentStatement.statementId).then(function (result) {
                _this.setState({
                    currentStatement: result.data,
                    loading: false
                });
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditStatement.messageRetrieveError'));
            });
        }
        else {
            var translations = this.state.allCultures.map(function (culture) {
                var translation = {
                    cultureId: culture.id,
                    text: null
                };
                return translation;
            });
            var statement = {
                translations: translations
            };
            this.setState({
                currentStatement: __assign(__assign({}, this.state.currentStatement), statement),
                loading: false
            });
        }
    };
    AddEditStatement.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                // If key is the nested property
                if (key === 'translations') {
                    var fieldKey = '';
                    for (var fieldName in field) {
                        if (field.hasOwnProperty(fieldName)) {
                            fieldKey = fieldName;
                            break;
                        }
                    }
                    newState[key] = __spreadArrays(this.state.currentStatement[key]);
                    newState[key][fieldKey].text = field[fieldKey].text.value;
                }
                else if (key === 'selectedCultureId') {
                    this.setState({ selectedCultureId: field.value });
                    return;
                }
                else {
                    newState[key] = field.value;
                }
            }
        }
        this.setState({
            currentStatement: __assign(__assign({}, this.state.currentStatement), newState)
        });
    };
    AddEditStatement.prototype.addStatement = function () {
        var _this = this;
        var addStatementDTO = {
            isActive: true,
            gradeIds: this.state.currentStatement.gradeIds,
            translations: this.state.currentStatement.translations
        };
        __WEBPACK_IMPORTED_MODULE_28_src_api_StatementApiController__["a" /* default */].addStatement(addStatementDTO)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditStatement.messageAdd'));
            _this.setState({ redirect: true, isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditStatement.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditStatement.prototype.updateStatement = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_28_src_api_StatementApiController__["a" /* default */].updateStatement(this.state.currentStatement)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditStatement.messageUpdate'));
            _this.setState({ redirect: true, isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditStatement.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditStatement.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.state.currentStatement.statementId ? _this.updateStatement() : _this.addStatement();
            }
        });
    };
    AddEditStatement.prototype.handleCancel = function (e) {
        this.setState({ redirect: true });
    };
    AddEditStatement.prototype.renderSaveButton = function () {
        if (this.statementsAreCompleted()) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate("admin.common.saveButton")));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: this.props.translate('admin.addEditStatement.saveTooltip'), arrowPointAtCenter: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", disabled: true }, this.props.translate("admin.common.saveButton"))));
    };
    AddEditStatement.prototype.render = function () {
        var _this = this;
        if (this.state.redirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__["a" /* default */].ADMIN_STATEMENTS, push: true });
        }
        else if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            currentStatement: this.state.currentStatement,
            allGrades: this.state.allGrades,
            allCultures: this.state.allCultures,
            selectedCultureId: this.state.selectedCultureId,
            translate: this.props.translate,
            onChange: this.handleInputChange
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.state.currentStatement.statementId ?
                this.props.translate('admin.addEditStatement.editHeader') :
                this.props.translate('admin.addEditStatement.addHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatementForm, __assign({ wrappedComponentRef: function (ref) { return _this.formRef = ref; } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                this.renderSaveButton(),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate("common.back")))));
    };
    return AddEditStatement;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_27_react_localize_redux__["d" /* withLocalize */])(AddEditStatement));


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = calculateNodeHeight;
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var HIDDEN_TEXTAREA_STYLE = '\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
var computedStyleCache = {};
var hiddenTextarea = void 0;
function calculateNodeStyling(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && computedStyleCache[nodeRef]) {
        return computedStyleCache[nodeRef];
    }
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    var sizingStyle = SIZING_STYLE.map(function (name) {
        return name + ':' + style.getPropertyValue(name);
    }).join(';');
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) {
        computedStyleCache[nodeRef] = nodeInfo;
    }
    return nodeInfo;
}
function calculateNodeHeight(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (!hiddenTextarea) {
        hiddenTextarea = document.createElement('textarea');
        document.body.appendChild(hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) {
        hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    } else {
        hiddenTextarea.removeAttribute('wrap');
    }
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox

    var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
        paddingSize = _calculateNodeStyling.paddingSize,
        borderSize = _calculateNodeStyling.borderSize,
        boxSizing = _calculateNodeStyling.boxSizing,
        sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content


    hiddenTextarea.setAttribute('style', sizingStyle + ';' + HIDDEN_TEXTAREA_STYLE);
    hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    var minHeight = Number.MIN_SAFE_INTEGER;
    var maxHeight = Number.MAX_SAFE_INTEGER;
    var height = hiddenTextarea.scrollHeight;
    var overflowY = void 0;
    if (boxSizing === 'border-box') {
        // border-box: add border, since height = content + padding + border
        height = height + borderSize;
    } else if (boxSizing === 'content-box') {
        // remove padding, since height = content
        height = height - paddingSize;
    }
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        hiddenTextarea.value = ' ';
        var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') {
                minHeight = minHeight + paddingSize + borderSize;
            }
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') {
                maxHeight = maxHeight + paddingSize + borderSize;
            }
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    // Remove scroll bar flash when autosize without maxRows
    if (!maxRows) {
        overflowY = 'hidden';
    }
    return { height: height, minHeight: minHeight, maxHeight: maxHeight, overflowY: overflowY };
}
module.exports = exports['default'];

/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_api_DistrictApiController__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_button__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder











var Districts = /** @class */ (function (_super) {
    __extends(Districts, _super);
    function Districts(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, Districts.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
        return _this;
    }
    Districts.prototype.emulateDistrict = function (districtId) {
        var _this = this;
        return this.props.emulateDistrict(districtId).then(function (result) {
            if (!result) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate("admin.common.messageEmulateError"));
                return;
            }
            // New user info should exist at this point, but props might not have updated yet. Push to home screen
            _this.props.history.push(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].BASE_ROUTE); // Let login redirect them
        });
    };
    Districts.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_8_src_api_DistrictApiController__["a" /* default */].getDistrictTableData(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    Districts.prototype.customTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_DISTRICT, record.districtId); };
        return [
            __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.districts.columnHeader1', 'districtName'),
            {
                columnProps: {
                    key: 'emulate',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: _this.props.translate('admin.common.emulateColumnHeader'), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_button___default.a, { shape: "circle", icon: "user", onClick: function () { return _this.emulateDistrict(record.districtId); } })));
                    }
                }
            },
            __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit')
        ];
    };
    Districts.prototype.render = function () {
        var _this = this;
        if (this.state.formRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_DISTRICT, push: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.districts.tableHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["e" /* default */], { serverSide: true, tableProps: { rowKey: 'districtId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["a" /* DataTableButton */]('admin.districts.addButton', function () { _this.setState({ formRedirect: true }); }),
                    new __WEBPACK_IMPORTED_MODULE_7_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return Districts;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        emulateDistrict: function (districtId) { return __WEBPACK_IMPORTED_MODULE_6__redux_UserActions__["a" /* default */].EmulateUser(dispatch, "district", districtId); },
    });
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(null, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(Districts)));


/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_radio__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_radio_style_index_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_api_DistrictApiController__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__AdminFullSyncReports__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_api_ClientApiController__ = __webpack_require__(250);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





















 // 'this' binder





var RadioGroup = __WEBPACK_IMPORTED_MODULE_18_antd_es_radio__["c" /* default */].Group;
// Form
var DistrictForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    },
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        return _super.call(this, props) || this;
    }
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }],
            })(inputType)));
        }
    };
    class_1.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    this.renderStandardFormItem('admin.addEditDistrict.formItem1', 'districtName', this.props.currentDistrict.districtName, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" })),
                    this.renderStandardFormItem('admin.addEditDistrict.cleverDistrictId', 'cleverDistrictId', this.props.currentDistrict.cleverDistrictId, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" }), true, false),
                    this.renderStandardFormItem('admin.addEditDistrict.syncStudents', 'syncStudents', this.props.currentDistrict.syncStudents, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadioGroup, { name: "syncStudents", value: this.props.currentDistrict.syncStudents },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_radio__["c" /* default */], { value: true, checked: this.props.currentDistrict.syncStudents === true }, this.props.translate('admin.addEditDistrict.yes')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_radio__["c" /* default */], { value: false, checked: this.props.currentDistrict.syncStudents === false }, this.props.translate('admin.addEditDistrict.no'))), true, false),
                    this.renderStandardFormItem('admin.addEditDistrict.syncTeachers', 'syncTeachers', this.props.currentDistrict.syncTeachers, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadioGroup, { name: "syncTeachers", value: this.props.currentDistrict.syncTeachers },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_radio__["c" /* default */], { value: true, checked: this.props.currentDistrict.syncTeachers === true }, this.props.translate('admin.addEditDistrict.yes')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_radio__["c" /* default */], { value: false, checked: this.props.currentDistrict.syncTeachers === false }, this.props.translate('admin.addEditDistrict.no'))), true, false),
                    this.renderStandardFormItem('admin.addEditDistrict.fullSync', 'fullSync', this.props.currentDistrict.fullSync, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadioGroup, { name: "fullSync", value: this.props.currentDistrict.fullSync },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_radio__["c" /* default */], { value: true, checked: this.props.currentDistrict.fullSync === true }, this.props.translate('admin.addEditDistrict.yes')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_radio__["c" /* default */], { value: false, checked: this.props.currentDistrict.fullSync === false }, this.props.translate('admin.addEditDistrict.no'))), true, false),
                    this.renderStandardFormItem('admin.addEditDistrict.classLinkTenantId', 'classLinkTenantId', this.props.currentDistrict.classLinkTenantId, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" }), true, false),
                    this.renderStandardFormItem('admin.addEditDistrict.syncClassLinkStudentsAndTeachers', 'syncClassLinkStudentsAndTeachers', this.props.currentDistrict.syncClassLinkStudentsAndTeachers, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadioGroup, { name: "syncClassLinkStudentsAndTeachers", value: this.props.currentDistrict.syncStudents },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_radio__["c" /* default */], { value: true, checked: this.props.currentDistrict.syncClassLinkStudentsAndTeachers === true }, this.props.translate('admin.addEditDistrict.yes')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_radio__["c" /* default */], { value: false, checked: this.props.currentDistrict.syncClassLinkStudentsAndTeachers === false }, this.props.translate('admin.addEditDistrict.no'))), true, false)))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditDistrict = /** @class */ (function (_super) {
    __extends(AddEditDistrict, _super);
    function AddEditDistrict(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_21_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditDistrict.prototype);
        var districtId = parseInt(_this.props.match.params.id, 10);
        var currentDistrict = {
            districtId: districtId,
            districtName: '',
            cleverDistrictId: '',
            syncStudents: false,
            syncTeachers: false,
            fullSync: false,
            fullSyncEndTimeStudents: null,
            fullSyncEndTimeTeachers: null,
            modifiedBy: '',
            modifiedDate: null,
            classLinkTenantId: null,
            syncClassLinkStudentsAndTeachers: false,
        };
        _this.state = {
            loading: true,
            isSubmitting: false,
            redirect: false,
            currentDistrict: currentDistrict,
        };
        return _this;
    }
    AddEditDistrict.prototype.componentWillMount = function () {
        this.fillForm();
    };
    AddEditDistrict.prototype.fillForm = function () {
        var _this = this;
        if (this.state.currentDistrict.districtId) {
            __WEBPACK_IMPORTED_MODULE_24_src_api_DistrictApiController__["a" /* default */].getDistrict(this.state.currentDistrict.districtId)
                .then(function (result) {
                _this.setState({
                    loading: false,
                    currentDistrict: result.data,
                });
            })
                .catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_10_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditDistrict.messageRetrieveError'));
            });
        }
        else {
            this.setState({
                loading: false,
            });
        }
    };
    AddEditDistrict.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                newState[key] = field.value;
                if (key === 'fullSync') {
                    if (field.value === true) {
                        newState['syncStudents'] = true;
                        newState['syncTeachers'] = true;
                    }
                    else {
                        newState['syncStudents'] = false;
                        newState['syncTeachers'] = false;
                    }
                }
                newState[key] = field.value;
            }
        }
        this.setState({
            currentDistrict: __assign(__assign({}, this.state.currentDistrict), newState),
        });
    };
    AddEditDistrict.prototype.addDistrict = function () {
        var _this = this;
        var addDistrictDTO = {
            districtName: this.state.currentDistrict.districtName,
        };
        __WEBPACK_IMPORTED_MODULE_24_src_api_DistrictApiController__["a" /* default */].addDistrict(addDistrictDTO)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_10_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditDistrict.messageAdd'));
            _this.setState({ redirect: true, isSubmitting: false });
        })
            .catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_10_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditDistrict.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditDistrict.prototype.updateDistrict = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_24_src_api_DistrictApiController__["a" /* default */].updateDistrict(this.state.currentDistrict)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_10_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditDistrict.messageUpdate'));
            _this.setState({ redirect: true, isSubmitting: false });
        })
            .catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_10_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditDistrict.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditDistrict.prototype.validateAndSubmit = function () {
        var _this = this;
        var hasCleverInfo = this.state.currentDistrict.cleverDistrictId != null && this.state.currentDistrict.cleverDistrictId.trim() !== '';
        var hasClassLinkInfo = this.state.currentDistrict.classLinkTenantId != null && this.state.currentDistrict.classLinkTenantId > 0;
        if (hasCleverInfo && hasClassLinkInfo) {
            this.formRef.props.form.setFields({
                cleverDistrictId: {
                    value: this.state.currentDistrict.cleverDistrictId,
                    errors: [new Error('"Please only enter a value for either CleverId or ClassLinkTenantId, not both."')],
                },
                classLinkTenantId: {
                    value: this.state.currentDistrict.classLinkTenantId,
                    errors: [new Error('"Please only enter a value for either CleverId or ClassLinkTenantId, not both."')],
                },
            });
            return;
        }
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.state.currentDistrict.districtId ? _this.updateDistrict() : _this.addDistrict();
            }
        });
    };
    AddEditDistrict.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.validateAndSubmit();
        return;
        // TODO: The duplicate CleverDistrictId and ClassLInkTenantId checks require a KuderAdmin and don't take into account emulation
        var hasCleverInfo = this.state.currentDistrict.cleverDistrictId != null && this.state.currentDistrict.cleverDistrictId.trim() !== '';
        var hasClassLinkInfo = this.state.currentDistrict.classLinkTenantId != null && this.state.currentDistrict.classLinkTenantId > 0;
        if (!hasCleverInfo && !hasClassLinkInfo) {
            this.validateAndSubmit();
        }
        else {
            if (hasCleverInfo) {
                var client = __assign(__assign({}, this.state.currentDistrict), { cleverDistrictId: this.state.currentDistrict.cleverDistrictId });
                __WEBPACK_IMPORTED_MODULE_26_src_api_ClientApiController__["a" /* default */].isDistrictDuplicateCleverDistrictId(client)
                    .then(function (result) {
                    if (result.data === true) {
                        _this.formRef.props.form.setFields({
                            cleverDistrictId: {
                                value: _this.state.currentDistrict.cleverDistrictId,
                                errors: [new Error('"This CleverId is already being used"')],
                            },
                        });
                    }
                    else {
                        _this.validateAndSubmit();
                    }
                })
                    .catch(function (e) { return _this.validateAndSubmit(); });
            }
            else if (hasClassLinkInfo) {
                var client = __assign(__assign({}, this.state.currentDistrict), { classLinkTenantId: this.state.currentDistrict.classLinkTenantId });
                __WEBPACK_IMPORTED_MODULE_26_src_api_ClientApiController__["a" /* default */].isDistrictDuplicateClassLinkTenantId(client)
                    .then(function (result) {
                    if (result.data === true) {
                        _this.formRef.props.form.setFields({
                            classLinkTenantId: {
                                value: _this.state.currentDistrict.classLinkTenantId,
                                errors: [new Error('"This ClassLinkTenantId is already being used"')],
                            },
                        });
                    }
                    else {
                        _this.validateAndSubmit();
                    }
                })
                    .catch(function (e) { return _this.validateAndSubmit(); });
            }
        }
    };
    AddEditDistrict.prototype.handleCancel = function (e) {
        this.setState({ redirect: true });
    };
    AddEditDistrict.prototype.renderAdminFullSyncReports = function () {
        var fullSyncCompletionEndDateStudents = this.state.currentDistrict.fullSyncEndTimeStudents !== null ? new Date(this.state.currentDistrict.fullSyncEndTimeStudents.toLocaleString()) : '';
        var fullSyncCompletionEndDateTeachers = this.state.currentDistrict.fullSyncEndTimeTeachers !== null ? new Date(this.state.currentDistrict.fullSyncEndTimeTeachers.toLocaleString()) : '';
        var lastSyncModifiedBy = this.state.currentDistrict.modifiedBy !== null ? this.state.currentDistrict.modifiedBy : '';
        var lastSyncModifiedDate = this.state.currentDistrict.modifiedDate !== null ? new Date(this.state.currentDistrict.modifiedDate.toLocaleString()) : '';
        var dataTableProps = {
            districtId: this.state.currentDistrict.districtId,
            districtName: this.state.currentDistrict.districtName,
            fullSyncCompletionEndDateStudents: fullSyncCompletionEndDateStudents,
            fullSyncCompletionEndDateTeachers: fullSyncCompletionEndDateTeachers,
            lastSyncModifiedBy: lastSyncModifiedBy,
            lastSyncModifiedDate: lastSyncModifiedDate,
        };
        if (this.state.currentDistrict.districtId) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__AdminFullSyncReports__["a" /* default */], __assign({}, dataTableProps));
        }
    };
    AddEditDistrict.prototype.render = function () {
        var _this = this;
        if (this.state.redirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_22_src_core_Routes__["a" /* default */].ADMIN_DISTRICTS, push: true });
        }
        else if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            currentDistrict: this.state.currentDistrict,
            translate: this.props.translate,
            onChange: this.handleInputChange,
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "full-sync-report" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.state.currentDistrict.districtId ? this.state.currentDistrict.districtName : this.props.translate('admin.addEditDistrict.addHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DistrictForm, __assign({ wrappedComponentRef: function (ref) { return (_this.formRef = ref); } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate('admin.common.saveButton')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate('common.back'))),
            this.renderAdminFullSyncReports()));
    };
    return AddEditDistrict;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_23_react_localize_redux__["d" /* withLocalize */])(AddEditDistrict));


/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_api_DistrictApiController__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_table__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_table_style_index_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_tabs__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_tabs_style_index_js__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_tag__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_tag_style_index_js__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SyncManagement_less__ = __webpack_require__(2140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SyncManagement_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__SyncManagement_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

























var TabPane = __WEBPACK_IMPORTED_MODULE_12_antd_es_tabs__["a" /* default */].TabPane;
var Search = __WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */].Search;
var confirm = __WEBPACK_IMPORTED_MODULE_16_antd_es_modal__["a" /* default */].confirm;
var SyncManagement = /** @class */ (function (_super) {
    __extends(SyncManagement, _super);
    function SyncManagement(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSearch = function (value) {
            _this.setState({ searchText: value }, function () {
                _this.filterDistricts();
            });
        };
        _this.handleFilterStatusChange = function (value) {
            _this.setState({ filterStatus: value }, function () {
                _this.filterDistricts();
            });
        };
        _this.handleTabChange = function (activeKey) {
            var newTab = activeKey;
            _this.setState({ activeTab: newTab, selectedDistrictIds: [] }, function () {
                _this.filterDistricts();
            });
        };
        _this.handleSelectDistrict = function (districtId, checked) {
            var selectedDistrictIds = _this.state.selectedDistrictIds;
            if (checked) {
                _this.setState({ selectedDistrictIds: __spreadArrays(selectedDistrictIds, [districtId]) });
            }
            else {
                _this.setState({ selectedDistrictIds: selectedDistrictIds.filter(function (id) { return id !== districtId; }) });
            }
        };
        _this.handleSelectAll = function () {
            var filteredDistricts = _this.state.filteredDistricts;
            var allIds = filteredDistricts.map(function (d) { return d.districtId; });
            _this.setState({ selectedDistrictIds: allIds });
        };
        _this.handleDeselectAll = function () {
            _this.setState({ selectedDistrictIds: [] });
        };
        _this.handleBulkUpdate = function (action) {
            var selected = _this.getSelectedDistricts();
            if (selected.length === 0) {
                __WEBPACK_IMPORTED_MODULE_14_antd_es_message__["a" /* default */].warning(_this.props.translate("admin.syncManagement.noDistrictsSelected") || "Please select at least one district");
                return;
            }
            var districtIds = selected.map(function (d) { return d.districtId; });
            var count = districtIds.length;
            var confirmText = (_this.props.translate("admin.syncManagement.confirmBulkUpdate") || "Are you sure you want to update {count} district(s)?").replace("{count}", count.toString());
            confirm({
                title: confirmText,
                onOk: function () {
                    _this.performBulkUpdate(action, districtIds);
                }
            });
        };
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, SyncManagement.prototype);
        _this.state = {
            districts: [],
            filteredDistricts: [],
            selectedDistrictIds: [],
            activeTab: 'clever',
            loading: true,
            searchText: '',
            filterStatus: 'all',
            updating: false
        };
        return _this;
    }
    SyncManagement.prototype.componentDidMount = function () {
        this.loadDistricts();
    };
    SyncManagement.prototype.renderSortableTitle = function (displayName, columnKey) {
        var _this = this;
        var _a = this.state, sortColumn = _a.sortColumn, sortDirection = _a.sortDirection;
        var isActive = sortColumn === columnKey;
        var arrow = isActive ? (sortDirection === 'asc' ? '↑' : sortDirection === 'desc' ? '↓' : '⇅') : '⇅';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { marginRight: 8 } }, displayName),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { style: { cursor: 'pointer', color: isActive ? '#1890ff' : undefined }, onClick: function () { return _this.toggleSort(columnKey); } }, arrow)));
    };
    SyncManagement.prototype.toggleSort = function (columnKey) {
        var _this = this;
        var _a = this.state, sortColumn = _a.sortColumn, sortDirection = _a.sortDirection;
        var newDirection = 'asc';
        if (sortColumn === columnKey) {
            if (sortDirection === 'asc') {
                newDirection = 'desc';
            }
            else if (sortDirection === 'desc') {
                newDirection = null;
            }
            else {
                newDirection = 'asc';
            }
        }
        else {
            newDirection = 'asc';
        }
        this.setState({ sortColumn: newDirection ? columnKey : null, sortDirection: newDirection }, function () {
            _this.sortFilteredDistricts();
        });
    };
    SyncManagement.prototype.sortFilteredDistricts = function () {
        var _this = this;
        var _a = this.state, sortColumn = _a.sortColumn, sortDirection = _a.sortDirection, filteredDistricts = _a.filteredDistricts;
        if (!sortColumn || !sortDirection) {
            // If no sort, reload original filtered list from districts and current filters
            this.filterDistricts();
            return;
        }
        var sorted = __spreadArrays(filteredDistricts).sort(function (a, b) {
            var av = _this.getFieldValue(a, sortColumn);
            var bv = _this.getFieldValue(b, sortColumn);
            var cmp = _this.compareValues(av, bv);
            return sortDirection === 'asc' ? cmp : -cmp;
        });
        this.setState({ filteredDistricts: sorted });
    };
    SyncManagement.prototype.getFieldValue = function (obj, field) {
        if (!obj) {
            return null;
        }
        return obj[field];
    };
    SyncManagement.prototype.compareValues = function (a, b) {
        if (a == null && b == null) {
            return 0;
        }
        if (a == null) {
            return -1;
        }
        if (b == null) {
            return 1;
        }
        // Moment objects (from moment.js)
        if (a && typeof a === 'object' && 'isValid' in a && 'valueOf' in a) {
            if (b && typeof b === 'object' && 'isValid' in b && 'valueOf' in b) {
                if (a.isValid() && b.isValid()) {
                    return a.valueOf() - b.valueOf();
                }
                if (!a.isValid()) {
                    return -1;
                }
                if (!b.isValid()) {
                    return 1;
                }
            }
        }
        // Dates
        var aDate = Date.parse(a);
        var bDate = Date.parse(b);
        if (!isNaN(aDate) && !isNaN(bDate)) {
            return aDate - bDate;
        }
        // Booleans
        if (typeof a === 'boolean' || typeof b === 'boolean') {
            var av = a === true ? 1 : 0;
            var bv = b === true ? 1 : 0;
            return av - bv;
        }
        // Numbers
        if (!isNaN(Number(a)) && !isNaN(Number(b))) {
            return Number(a) - Number(b);
        }
        // Fallback to string comparison
        try {
            return String(a).localeCompare(String(b));
        }
        catch (e) {
            return 0;
        }
    };
    SyncManagement.prototype.loadDistricts = function () {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_3_src_api_DistrictApiController__["a" /* default */].getAllDistrictsWithSyncStatus()
            .then(function (results) {
            if (results.ok && results.data) {
                _this.setState({
                    districts: results.data,
                    filteredDistricts: results.data,
                    loading: false
                });
                _this.filterDistricts();
            }
            else {
                __WEBPACK_IMPORTED_MODULE_14_antd_es_message__["a" /* default */].error(_this.props.translate("admin.syncManagement.loadError") || "Failed to load districts");
                _this.setState({ loading: false });
            }
        })
            .catch(function (_error) {
            __WEBPACK_IMPORTED_MODULE_14_antd_es_message__["a" /* default */].error(_this.props.translate("admin.syncManagement.loadError") || "Failed to load districts");
            _this.setState({ loading: false });
        });
    };
    SyncManagement.prototype.filterDistricts = function () {
        var _this = this;
        var _a = this.state, districts = _a.districts, searchText = _a.searchText, filterStatus = _a.filterStatus, activeTab = _a.activeTab;
        var filtered = __spreadArrays(districts);
        // Filter by active tab (Clever or ClassLink)
        if (activeTab === 'clever') {
            filtered = filtered.filter(function (d) { return d.cleverDistrictId && d.cleverDistrictId.trim() !== ''; });
        }
        else {
            filtered = filtered.filter(function (d) { return d.hasClassLinkConfiguration; });
        }
        // Filter by search text
        if (searchText) {
            var searchLower_1 = searchText.toLowerCase();
            filtered = filtered.filter(function (d) {
                return d.districtName.toLowerCase().includes(searchLower_1) ||
                    (d.cleverDistrictId && d.cleverDistrictId.toLowerCase().includes(searchLower_1)) ||
                    (d.classLinkTenantId && d.classLinkTenantId.toString().includes(searchLower_1));
            });
        }
        // Filter by status
        if (filterStatus !== 'all') {
            if (activeTab === 'clever') {
                if (filterStatus === 'syncing') {
                    filtered = filtered.filter(function (d) { return d.isSyncRunning; });
                }
                else if (filterStatus === 'enabled') {
                    filtered = filtered.filter(function (d) { return d.fullSync === true; });
                }
                else if (filterStatus === 'disabled') {
                    filtered = filtered.filter(function (d) { return d.fullSync === false || d.fullSync == null; });
                }
            }
            else {
                if (filterStatus === 'syncing') {
                    filtered = filtered.filter(function (d) { return d.isSyncRunning; });
                }
                else if (filterStatus === 'enabled') {
                    filtered = filtered.filter(function (d) { return d.syncClassLinkStudentsAndTeachers === true; });
                }
                else if (filterStatus === 'disabled') {
                    filtered = filtered.filter(function (d) { return d.syncClassLinkStudentsAndTeachers === false || d.syncClassLinkStudentsAndTeachers == null; });
                }
            }
        }
        this.setState({ filteredDistricts: filtered }, function () {
            var _a = _this.state, sortColumn = _a.sortColumn, sortDirection = _a.sortDirection;
            if (sortColumn && sortDirection) {
                _this.sortFilteredDistricts();
            }
        });
    };
    SyncManagement.prototype.getSelectedDistricts = function () {
        var _a = this.state, districts = _a.districts, selectedDistrictIds = _a.selectedDistrictIds;
        return districts.filter(function (d) { return selectedDistrictIds.includes(d.districtId); });
    };
    SyncManagement.prototype.toggleSyncSetting = function (districtId, setting, currentValue) {
        var _this = this;
        this.setState({ updating: true });
        var dto = {
            districtIds: [districtId]
        };
        if (setting === 'syncStudents') {
            dto.syncStudents = !currentValue;
        }
        else {
            dto.syncTeachers = !currentValue;
        }
        __WEBPACK_IMPORTED_MODULE_3_src_api_DistrictApiController__["a" /* default */].bulkUpdateCleverSync(dto)
            .then(function (results) {
            if (results.ok) {
                __WEBPACK_IMPORTED_MODULE_14_antd_es_message__["a" /* default */].success("Successfully updated district");
                _this.setState({ updating: false });
                _this.loadDistricts();
            }
            else {
                __WEBPACK_IMPORTED_MODULE_14_antd_es_message__["a" /* default */].error(_this.props.translate("admin.syncManagement.updateError") || "Failed to update district");
                _this.setState({ updating: false });
            }
        })
            .catch(function (_error) {
            __WEBPACK_IMPORTED_MODULE_14_antd_es_message__["a" /* default */].error(_this.props.translate("admin.syncManagement.updateError") || "Failed to update district");
            _this.setState({ updating: false });
        });
    };
    SyncManagement.prototype.performBulkUpdate = function (action, districtIds) {
        var _this = this;
        this.setState({ updating: true });
        var dto = {
            districtIds: districtIds
        };
        var apiCall;
        if (action === 'enableFullSync') {
            dto.fullSync = true;
            dto.syncStudents = true;
            dto.syncTeachers = true;
            apiCall = __WEBPACK_IMPORTED_MODULE_3_src_api_DistrictApiController__["a" /* default */].bulkUpdateCleverSync(dto);
        }
        else if (action === 'disableFullSync') {
            dto.fullSync = false;
            apiCall = __WEBPACK_IMPORTED_MODULE_3_src_api_DistrictApiController__["a" /* default */].bulkUpdateCleverSync(dto);
        }
        else if (action === 'enableClassLinkSync') {
            dto.syncClassLinkStudentsAndTeachers = true;
            apiCall = __WEBPACK_IMPORTED_MODULE_3_src_api_DistrictApiController__["a" /* default */].bulkUpdateClassLinkSync(dto);
        }
        else {
            dto.syncClassLinkStudentsAndTeachers = false;
            apiCall = __WEBPACK_IMPORTED_MODULE_3_src_api_DistrictApiController__["a" /* default */].bulkUpdateClassLinkSync(dto);
        }
        apiCall
            .then(function (results) {
            if (results.ok) {
                var successText = (_this.props.translate("admin.syncManagement.updateSuccess") || "Successfully updated {count} district(s)").replace("{count}", districtIds.length.toString());
                __WEBPACK_IMPORTED_MODULE_14_antd_es_message__["a" /* default */].success(successText);
                _this.setState({ selectedDistrictIds: [], updating: false });
                _this.loadDistricts();
            }
            else {
                __WEBPACK_IMPORTED_MODULE_14_antd_es_message__["a" /* default */].error(_this.props.translate("admin.syncManagement.updateError") || "Failed to update districts");
                _this.setState({ updating: false });
            }
        })
            .catch(function (_error) {
            __WEBPACK_IMPORTED_MODULE_14_antd_es_message__["a" /* default */].error(_this.props.translate("admin.syncManagement.updateError") || "Failed to update districts");
            _this.setState({ updating: false });
        });
    };
    SyncManagement.prototype.getCleverTableColumns = function () {
        var _this = this;
        var selectedDistrictIds = this.state.selectedDistrictIds;
        return [
            {
                title: '',
                key: 'checkbox',
                width: 50,
                render: function (text, record) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_checkbox__["a" /* default */], { checked: selectedDistrictIds.includes(record.districtId), onChange: function (e) { return _this.handleSelectDistrict(record.districtId, e.target.checked); } })); }
            },
            {
                title: this.renderSortableTitle(this.props.translate("admin.syncManagement.districtName") || "District Name", 'districtName'),
                dataIndex: 'districtName',
                key: 'districtName'
            },
            {
                title: this.renderSortableTitle(this.props.translate("admin.syncManagement.cleverDistrictId") || "Clever District ID", 'cleverDistrictId'),
                dataIndex: 'cleverDistrictId',
                key: 'cleverDistrictId'
            },
            {
                title: this.renderSortableTitle(this.props.translate("admin.syncManagement.syncStudents") || "Sync Students", 'syncStudents'),
                dataIndex: 'syncStudents',
                key: 'syncStudents',
                render: function (value, record) {
                    var isEnabled = value === true;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_tag__["a" /* default */], { color: isEnabled ? "green" : "default", style: { cursor: 'pointer' }, onClick: function () { return _this.toggleSyncSetting(record.districtId, 'syncStudents', isEnabled); } }, isEnabled ? "Yes" : "No"));
                }
            },
            {
                title: this.renderSortableTitle(this.props.translate("admin.syncManagement.syncTeachers") || "Sync Teachers", 'syncTeachers'),
                dataIndex: 'syncTeachers',
                key: 'syncTeachers',
                render: function (value, record) {
                    var isEnabled = value === true;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_tag__["a" /* default */], { color: isEnabled ? "green" : "default", style: { cursor: 'pointer' }, onClick: function () { return _this.toggleSyncSetting(record.districtId, 'syncTeachers', isEnabled); } }, isEnabled ? "Yes" : "No"));
                }
            },
            {
                title: this.renderSortableTitle(this.props.translate("admin.syncManagement.fullSync") || "Full Sync", 'fullSync'),
                dataIndex: 'fullSync',
                key: 'fullSync',
                render: function (value) {
                    if (value === true) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_tag__["a" /* default */], { color: "green" }, "Enabled");
                    }
                    if (value === false) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_tag__["a" /* default */], { color: "red" }, "Disabled");
                    }
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_tag__["a" /* default */], { color: "default" }, "Not Set");
                }
            },
            {
                title: this.renderSortableTitle(this.props.translate("admin.syncManagement.lastSyncStudents") || "Last Student Sync", 'fullSyncEndTimeStudents'),
                dataIndex: 'fullSyncEndTimeStudents',
                key: 'fullSyncEndTimeStudents',
                render: function (value) { return value ? new Date(value).toLocaleString() : '-'; }
            },
            {
                title: this.renderSortableTitle(this.props.translate("admin.syncManagement.lastSyncTeachers") || "Last Teacher Sync", 'fullSyncEndTimeTeachers'),
                dataIndex: 'fullSyncEndTimeTeachers',
                key: 'fullSyncEndTimeTeachers',
                render: function (value) { return value ? new Date(value).toLocaleString() : '-'; }
            }
        ];
    };
    SyncManagement.prototype.getClassLinkTableColumns = function () {
        var _this = this;
        var selectedDistrictIds = this.state.selectedDistrictIds;
        return [
            {
                title: '',
                key: 'checkbox',
                width: 50,
                render: function (text, record) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_checkbox__["a" /* default */], { checked: selectedDistrictIds.includes(record.districtId), onChange: function (e) { return _this.handleSelectDistrict(record.districtId, e.target.checked); } })); }
            },
            {
                title: this.renderSortableTitle(this.props.translate("admin.syncManagement.districtName") || "District Name", 'districtName'),
                dataIndex: 'districtName',
                key: 'districtName'
            },
            {
                title: this.renderSortableTitle(this.props.translate("admin.syncManagement.classLinkTenantId") || "ClassLink Tenant ID", 'classLinkTenantId'),
                dataIndex: 'classLinkTenantId',
                key: 'classLinkTenantId',
                render: function (value) { return value || '-'; }
            },
            {
                title: this.renderSortableTitle(this.props.translate("admin.syncManagement.syncClassLinkStudentsAndTeachers") || "Sync ClassLink", 'syncClassLinkStudentsAndTeachers'),
                dataIndex: 'syncClassLinkStudentsAndTeachers',
                key: 'syncClassLinkStudentsAndTeachers',
                render: function (value) {
                    if (value === true) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_tag__["a" /* default */], { color: "green" }, "Enabled");
                    }
                    if (value === false) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_tag__["a" /* default */], { color: "red" }, "Disabled");
                    }
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_tag__["a" /* default */], { color: "default" }, "Not Set");
                }
            }
        ];
    };
    SyncManagement.prototype.render = function () {
        var _this = this;
        var _a = this.state, filteredDistricts = _a.filteredDistricts, selectedDistrictIds = _a.selectedDistrictIds, activeTab = _a.activeTab, loading = _a.loading, updating = _a.updating;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sync-management" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate("admin.syncManagement.pageTitle") || "District Sync Management"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_row__["a" /* default */], { gutter: 16, style: { marginBottom: 16 } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_col__["a" /* default */], { span: 24 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Search, { placeholder: this.props.translate("admin.syncManagement.filterByDistrict") || "Filter by district name", onSearch: this.handleSearch, onChange: function (e) { return _this.handleSearch(e.target.value); }, style: { width: '100%' } }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_tabs__["a" /* default */], { activeKey: activeTab, onChange: this.handleTabChange },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TabPane, { tab: this.props.translate("admin.syncManagement.cleverTab") || "Clever Sync", key: "clever" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { marginBottom: 16 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: function () { return _this.handleBulkUpdate('enableFullSync'); }, disabled: selectedDistrictIds.length === 0 || updating, style: { marginRight: 8 } }, this.props.translate("admin.syncManagement.enableFullSync") || "Enable Full Sync"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: function () { return _this.handleBulkUpdate('disableFullSync'); }, disabled: selectedDistrictIds.length === 0 || updating }, this.props.translate("admin.syncManagement.disableFullSync") || "Disable Full Sync")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_table__["a" /* default */], { columns: this.getCleverTableColumns(), dataSource: filteredDistricts, rowKey: "districtId", loading: loading || updating, pagination: { pageSize: 50 } })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TabPane, { tab: this.props.translate("admin.syncManagement.classLinkTab") || "ClassLink Sync", key: "classlink" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { marginBottom: 16 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleSelectAll, style: { marginRight: 8 } }, this.props.translate("admin.syncManagement.selectAll") || "Select All"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleDeselectAll, style: { marginRight: 16 } }, this.props.translate("admin.syncManagement.deselectAll") || "Deselect All"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: function () { return _this.handleBulkUpdate('enableClassLinkSync'); }, disabled: selectedDistrictIds.length === 0 || updating, style: { marginRight: 8 } }, this.props.translate("admin.syncManagement.enableClassLinkSync") || "Enable ClassLink Sync"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: function () { return _this.handleBulkUpdate('disableClassLinkSync'); }, disabled: selectedDistrictIds.length === 0 || updating }, this.props.translate("admin.syncManagement.disableClassLinkSync") || "Disable ClassLink Sync")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_table__["a" /* default */], { columns: this.getClassLinkTableColumns(), dataSource: filteredDistricts, rowKey: "districtId", loading: loading || updating, pagination: { pageSize: 50 } })))));
    };
    return SyncManagement;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(SyncManagement));


/***/ }),
/* 2139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_api_SchoolApiController__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button_button__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_redux_UserActions__ = __webpack_require__(108);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

 // 'this' binder


 // Connecting to Redux








var Schools = /** @class */ (function (_super) {
    __extends(Schools, _super);
    function Schools(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, Schools.prototype);
        _this.state = {
            tableRecords: [],
            isLoading: true
        };
        return _this;
    }
    Schools.prototype.emulateSchool = function (schoolId) {
        var _this = this;
        return this.props.emulateSchool(schoolId).then(function (result) {
            if (!result) {
                __WEBPACK_IMPORTED_MODULE_10_antd_es_message__["a" /* default */].error(_this.props.translate("admin.common.messageEmulateError"));
                return;
            }
            // New user info should exist at this point, but props might not have updated yet. Push to home screen
            _this.props.history.push(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].BASE_ROUTE); // Let login redirect them
        });
    };
    Schools.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ isLoading: true });
        return __WEBPACK_IMPORTED_MODULE_6_src_api_SchoolApiController__["a" /* default */].getSchoolTableData(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                isLoading: false
            });
            callback(results.data);
        });
    };
    Schools.prototype.customTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_SCHOOL, record.schoolId); };
        return [
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.schools.columnHeader1', 'schoolName'),
            {
                columnProps: {
                    key: 'emulate',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: _this.props.translate('admin.common.emulateColumnHeader'), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_lib_button_button___default.a, { shape: "circle", icon: "user", onClick: function () { return _this.emulateSchool(record.schoolId); } })));
                    }
                }
            },
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit')
        ];
    };
    Schools.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.schools.tableHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */], { serverSide: true, tableProps: { rowKey: 'schoolId', loading: this.state.isLoading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["a" /* DataTableButton */]('admin.schools.addButton', function () { return _this.props.history.push(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_SCHOOL, 0)); }),
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return Schools;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        emulateSchool: function (schoolId) { return __WEBPACK_IMPORTED_MODULE_12_src_redux_UserActions__["a" /* default */].EmulateUser(dispatch, "school", schoolId); },
    });
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(null, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["d" /* withLocalize */])(Schools)));


/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_api_SchoolApiController__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__forms_AddEditSchoolForm__ = __webpack_require__(2143);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




















 // 'this' binder




var AddEditSchool = /** @class */ (function (_super) {
    __extends(AddEditSchool, _super);
    function AddEditSchool(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_20_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditSchool.prototype);
        var schoolId = Number(_this.props.match.params.id);
        schoolId = !isNaN(schoolId) ? schoolId : 0;
        _this.state = {
            schoolId: schoolId,
            currentSchool: null,
            isLoading: true,
            isSubmitting: false
        };
        return _this;
    }
    AddEditSchool.prototype.componentDidMount = function () {
        this.fillForm();
    };
    AddEditSchool.prototype.fillForm = function () {
        var _this = this;
        if (this.state.schoolId > 0) {
            // Edit
            return __WEBPACK_IMPORTED_MODULE_23_src_api_SchoolApiController__["a" /* default */].getSchool(this.state.schoolId).then(function (result) {
                _this.setState({
                    isLoading: false,
                    currentSchool: result.data
                });
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditSchool.messageRetrieveError'));
                _this.setState({ isLoading: false });
            });
        }
        this.setState({ isLoading: false });
    };
    AddEditSchool.prototype.handleSubmit = function (values) {
        var _this = this;
        var _a, _b, _c;
        this.setState({ isSubmitting: true });
        // Trimming
        values.otherId = (_a = values.otherId) === null || _a === void 0 ? void 0 : _a.trim();
        values.schoolName = (_b = values.schoolName) === null || _b === void 0 ? void 0 : _b.trim();
        values.classLinkSourcedId = (_c = values.classLinkSourcedId) === null || _c === void 0 ? void 0 : _c.trim();
        if (this.state.schoolId < 1) {
            return __WEBPACK_IMPORTED_MODULE_23_src_api_SchoolApiController__["a" /* default */].addSchool(values).then(function (result) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditSchool.messageAdd'));
                _this.handleRedirect();
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditSchool.messageAddError'));
                _this.setState({ isSubmitting: false });
            });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_23_src_api_SchoolApiController__["a" /* default */].updateSchool(values).then(function (result) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditSchool.messageUpdate'));
                _this.handleRedirect();
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditSchool.messageUpdateError'));
                _this.setState({ isSubmitting: false });
            });
        }
    };
    AddEditSchool.prototype.handleRedirect = function () {
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_21_src_core_Routes__["a" /* default */].ADMIN_SCHOOLS);
    };
    AddEditSchool.prototype.render = function () {
        if (this.state.isLoading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], null);
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.state.schoolId > 0 ? this.state.currentSchool.schoolName : this.props.translate('admin.addEditSchool.addHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_col__["a" /* default */], { xs: 24, lg: 18, xl: 16, xxl: 12 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__forms_AddEditSchoolForm__["a" /* default */], { schoolData: this.state.currentSchool, isSubmitting: this.state.isSubmitting, onSubmit: this.handleSubmit, onCancel: this.handleRedirect })))));
    };
    return AddEditSchool;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22_react_localize_redux__["d" /* withLocalize */])(AddEditSchool));


/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_button__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_auto_complete__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_auto_complete_style_index_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_date_picker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_date_picker_style_index_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_utils_NameOf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_common_form_FieldDecorator__ = __webpack_require__(283);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

 // 'this' binder
























var AddEditSchoolForm = /** @class */ (function (_super) {
    __extends(AddEditSchoolForm, _super);
    function AddEditSchoolForm(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditSchoolForm.prototype);
        return _this;
    }
    AddEditSchoolForm.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        var otherId = this.props.form.getFieldValue(Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_NameOf__["a" /* NameOf */])("otherId"));
        var classLinkSourcedId = this.props.form.getFieldValue(Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_NameOf__["a" /* NameOf */])("classLinkSourcedId"));
        var hasCleverInfo = otherId != null && otherId.trim() !== '';
        var hasClassLinkInfo = classLinkSourcedId != null && classLinkSourcedId.trim() !== '';
        if (hasCleverInfo && hasClassLinkInfo) {
            this.props.form.setFields({
                otherId: {
                    value: this.props.schoolData.otherId,
                    errors: [new Error(this.props.translate('admin.addEditSchool.messageTooManySSOProvers').toString())],
                },
                classLinkSourcedId: {
                    value: this.props.schoolData.classLinkSourcedId,
                    errors: [new Error(this.props.translate('admin.addEditSchool.messageTooManySSOProvers').toString())],
                },
            });
            return false;
        }
        this.props.form.validateFields(function (errors, values) {
            var newValues = __assign(__assign({}, _this.props.schoolData), values);
            if (!errors) {
                _this.props.onSubmit && _this.props.onSubmit(newValues);
            }
        });
    };
    AddEditSchoolForm.prototype.handleCancel = function () {
        this.props.onCancel && this.props.onCancel();
    };
    AddEditSchoolForm.prototype.render = function () {
        var schoolData = this.props.schoolData != null ? this.props.schoolData : {};
        var isCleverEnabled = this.props.form.getFieldValue(Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_NameOf__["a" /* NameOf */])("connectToClever"));
        var isClassLinkEnabled = this.props.form.getFieldValue(Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_NameOf__["a" /* NameOf */])("connectToClassLink"));
        // GetFieldValue is undefined on form initialization
        isCleverEnabled = isCleverEnabled != null ? isCleverEnabled : schoolData.connectToClever;
        isClassLinkEnabled = isClassLinkEnabled != null ? isClassLinkEnabled : schoolData.connectToClassLink;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */], { className: "admin-form", onSubmit: this.handleSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "admin.addEditSchool.formItem1" }), name: Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_NameOf__["a" /* NameOf */])("schoolName"), initialValue: schoolData.schoolName, rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                ] },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_input__["a" /* default */], { autoComplete: "off" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "admin.addEditSchool.formItem3" }), name: Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_NameOf__["a" /* NameOf */])("connectToClever"), initialValue: schoolData.connectToClever },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_checkbox__["a" /* default */], { defaultChecked: schoolData.connectToClever })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "admin.addEditSchool.formItem2" }), name: Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_NameOf__["a" /* NameOf */])("otherId"), initialValue: schoolData.otherId },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_input__["a" /* default */], { autoComplete: "off", disabled: !isCleverEnabled, required: isCleverEnabled })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "admin.addEditSchool.formItem5" }), name: Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_NameOf__["a" /* NameOf */])("connectToClassLink"), initialValue: schoolData.connectToClassLink },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_checkbox__["a" /* default */], { defaultChecked: schoolData.connectToClassLink })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_src_components_common_form_FieldDecorator__["a" /* default */], { form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "admin.addEditSchool.formItem4" }), name: Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_NameOf__["a" /* NameOf */])("classLinkSourcedId"), initialValue: schoolData.classLinkSourcedId },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_input__["a" /* default */], { autoComplete: "off", disabled: !isClassLinkEnabled, required: isClassLinkEnabled })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_button___default.a, { type: "primary", loading: this.props.isSubmitting, htmlType: "submit" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "admin.common.saveButton" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_button___default.a, { onClick: this.handleCancel },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "common.back" })))));
    };
    return AddEditSchoolForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].create()(AddEditSchoolForm)));


/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_divider_style_index_js__ = __webpack_require__(53);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

 // 'this' binder






var Activities = /** @class */ (function (_super) {
    __extends(Activities, _super);
    function Activities(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, Activities.prototype);
        _this.state = {
            surveys: [],
            quizzes: [],
            loading: true
        };
        return _this;
    }
    Activities.prototype.fetchSurveys = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_5_src_api_ActivityApiController__["a" /* default */].getActivityTableData(requestState, true)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var surveys = results.data.results ? results.data.results : [];
            _this.setState({
                surveys: surveys,
                loading: false
            });
            callback(results.data);
        });
    };
    Activities.prototype.fetchQuizzes = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_5_src_api_ActivityApiController__["a" /* default */].getActivityTableData(requestState, false)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var quizzes = results.data.results ? results.data.results : [];
            _this.setState({
                quizzes: quizzes,
                loading: false
            });
            callback(results.data);
        });
    };
    Activities.prototype.customTableColumns = function () {
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_2_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY, record.activityId); };
        return [
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.activities.columnHeader1', 'title'),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit')
        ];
    };
    Activities.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.activities.tableHeader1')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */], { serverSide: true, tableProps: { rowKey: 'activityId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.surveys, fetchData: this.fetchSurveys, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.activities.tableHeader2')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */], { serverSide: true, tableProps: { rowKey: 'activityId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.quizzes, fetchData: this.fetchQuizzes, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] }));
    };
    return Activities;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["d" /* withLocalize */])(Activities));


/***/ }),
/* 2145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_es_alert__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_es_alert_style_index_js__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ActivityQuestions__ = __webpack_require__(2146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ActivityQuestionCategories__ = __webpack_require__(2147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_input_TextArea__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_input_TextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_antd_lib_input_TextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ActivitySummaries__ = __webpack_require__(2148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_constants_Languages__ = __webpack_require__(80);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};





































// Form
var ActivityForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    }
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        return _super.call(this, props) || this;
    }
    class_1.prototype.generateOptionsForSelect = function (keyValues) {
        return keyValues.map(function (keyValue) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { value: keyValue.value, key: keyValue.key, title: keyValue.key }, keyValue.key); });
    };
    class_1.prototype.generateLanguageOptions = function () {
        // Only available languages
        return __WEBPACK_IMPORTED_MODULE_36_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable; })
            .map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { key: "cultureIds" + x.id, value: x.id },
            x.name,
            " (",
            x.code,
            ")"); });
    };
    class_1.prototype.renderIntroTextTranslations = function () {
        var _this = this;
        if (this.props.currentActivity) {
            var translations = this.props.currentActivity.localizedText;
            return translations.map(function (translation, index) {
                var id = "introductionText[" + index + "].text";
                var culture = _this.props.allCultures.find(function (culture) { return culture.id === translation.cultureId; }).code.toLowerCase();
                var translationId = "admin.addEditActivity.introductionText." + culture;
                return _this.renderStandardFormItem(translationId, id, translation.introductionText, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_34_antd_lib_input_TextArea___default.a, { rows: 4, autoComplete: "off" }), _this.props.selectedCultureId === translation.cultureId, false);
            });
        }
    };
    class_1.prototype.renderConclusionTextTranslation = function () {
        var _this = this;
        if (this.props.currentActivity) {
            var translations = this.props.currentActivity.localizedText;
            return translations.map(function (translation, index) {
                var id = "conclusionText[" + index + "].text";
                var culture = _this.props.allCultures.find(function (culture) { return culture.id === translation.cultureId; }).code.toLowerCase();
                var translationId = "admin.addEditActivity.conclusionText." + culture;
                return _this.renderStandardFormItem(translationId, id, translation.conclusionText, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_34_antd_lib_input_TextArea___default.a, { rows: 4, autoComplete: "off" }), _this.props.selectedCultureId === translation.cultureId, false);
            });
        }
    };
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
            })(inputType)));
        }
    };
    class_1.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    this.renderStandardFormItem("admin.addEditActivity.formItem1", "title", this.props.currentActivity.title, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off", disabled: true })),
                    this.renderStandardFormItem("admin.addEditActivity.formItem2", "selectedCultureId", this.props.selectedCultureId, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], null, this.generateLanguageOptions())),
                    this.renderIntroTextTranslations(),
                    this.renderConclusionTextTranslation()))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditActivity = /** @class */ (function (_super) {
    __extends(AddEditActivity, _super);
    function AddEditActivity(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_28_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditActivity.prototype);
        var activityId = parseInt(_this.props.match.params.id, 10);
        var currentActivity = {
            activityId: activityId,
            title: "",
            isSurvey: false,
            localizedText: []
        };
        _this.state = {
            loading: true,
            isSubmitting: false,
            shouldRefreshTable: false,
            allCultures: [],
            selectedCultureId: 0,
            currentActivity: currentActivity
        };
        return _this;
    }
    AddEditActivity.prototype.componentWillMount = function () {
        var cultures = __WEBPACK_IMPORTED_MODULE_36_src_constants_Languages__["a" /* default */].All.filter(function (l) { return l.isAvailable; });
        this.setState({
            allCultures: cultures,
            selectedCultureId: cultures[0].id
        }, this.fillForm);
    };
    AddEditActivity.prototype.fillForm = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].getActivity(this.state.currentActivity.activityId).then(function (result) {
            _this.setState({
                loading: false,
                currentActivity: result.data
            });
            if (result.data.localizedText.length === 0) {
                var translations = _this.state.allCultures.map(function (culture) {
                    var translation = {
                        cultureId: culture.id,
                        introductionText: null,
                        conclusionText: null
                    };
                    return translation;
                });
                _this.setState({
                    currentActivity: __assign(__assign({}, _this.state.currentActivity), { localizedText: translations })
                });
            }
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditActivity.messageRetrieveError'));
        });
    };
    AddEditActivity.prototype.introductionTranslationsAreCompleted = function () {
        var localizedText = this.state.currentActivity.localizedText;
        var emptyTranslations = localizedText.filter(function (translation) {
            return translation.introductionText === null || translation.introductionText === "";
        });
        return emptyTranslations.length === 0;
    };
    /**
     * Conclusions are not required.
     * Therefore, they are considered completed if either none of the translations are empty, or all of them are empty
     */
    AddEditActivity.prototype.conclusionTranslationsAreCompleted = function () {
        var localizedText = this.state.currentActivity.localizedText;
        var emptyConclusions = localizedText.filter(function (translation) {
            return translation.conclusionText === null || translation.conclusionText === "";
        });
        return emptyConclusions.length === 0 || emptyConclusions.length === localizedText.length;
    };
    AddEditActivity.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                // If key is the nested property
                if (key === 'introductionText' || key === 'conclusionText') {
                    var fieldKey = '';
                    var localizedTextKey = 'localizedText';
                    for (var fieldName in field) {
                        if (field.hasOwnProperty(fieldName)) {
                            fieldKey = fieldName;
                            break;
                        }
                    }
                    newState[localizedTextKey] = __spreadArrays(this.state.currentActivity.localizedText);
                    newState[localizedTextKey][fieldKey][key] = field[fieldKey].text.value;
                }
                else if (key === 'selectedCultureId') {
                    this.setState({ selectedCultureId: field.value });
                    return;
                }
                else {
                    newState[key] = field.value;
                }
            }
        }
        this.setState({
            currentActivity: __assign(__assign({}, this.state.currentActivity), newState)
        });
    };
    AddEditActivity.prototype.updateActivity = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].updateActivity(this.state.currentActivity)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditActivity.messageUpdate'));
            _this.setState({ isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditActivity.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditActivity.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.updateActivity();
            }
        });
    };
    AddEditActivity.prototype.handleCancel = function (e) {
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_29_src_core_Routes__["a" /* default */].ADMIN_ACTIVITIES);
    };
    AddEditActivity.prototype.updateShouldRefreshTable = function () {
        this.setState({ shouldRefreshTable: !this.state.shouldRefreshTable });
    };
    AddEditActivity.prototype.renderSaveButton = function () {
        //if (!this.introductionTranslationsAreCompleted()) {
        //    return (
        //        <Tooltip placement="bottom" title={this.props.translate('admin.addEditActivity.saveTooltip')} arrowPointAtCenter>
        //            <Button type="primary" disabled>
        //                {this.props.translate("admin.common.saveButton")}
        //            </Button>
        //        </Tooltip>
        //    );
        //}
        //else if (!this.conclusionTranslationsAreCompleted()) {
        //    return (
        //        <Tooltip placement="bottom" title={this.props.translate('admin.addEditActivity.conclusionsTooltip')} arrowPointAtCenter>
        //            <Button type="primary" disabled>
        //                {this.props.translate("admin.common.saveButton")}
        //            </Button>
        //        </Tooltip>
        //    );
        //}
        //else {
        //    return (
        //        <Button type="primary" onClick={this.handleSubmit} loading={this.state.isSubmitting}>
        //            {this.props.translate("admin.common.saveButton")}
        //        </Button>
        //    );
        //}
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate("admin.common.saveButton")));
    };
    AddEditActivity.prototype.renderActivityQuestionCategories = function () {
        var categoriesTableProps = {
            activityId: this.state.currentActivity.activityId,
            updateShouldRefreshTable: this.updateShouldRefreshTable
        };
        if (!this.state.currentActivity.isSurvey) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32__ActivityQuestionCategories__["a" /* default */], __assign({}, categoriesTableProps)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null)));
        }
    };
    AddEditActivity.prototype.render = function () {
        var _this = this;
        if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            allCultures: this.state.allCultures,
            selectedCultureId: this.state.selectedCultureId,
            currentActivity: this.state.currentActivity,
            translate: this.props.translate,
            onChange: this.handleInputChange
        };
        var questionsTableProps = {
            activityId: this.state.currentActivity.activityId,
            isSurvey: this.state.currentActivity.isSurvey,
            shouldRefreshTable: this.state.shouldRefreshTable,
            updateShouldRefreshTable: this.updateShouldRefreshTable
        };
        var summaryTableProps = {
            activityId: this.state.currentActivity.activityId,
            shouldRefreshTable: this.state.shouldRefreshTable,
            updateShouldRefreshTable: this.updateShouldRefreshTable,
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.state.currentActivity.title),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ActivityForm, __assign({ wrappedComponentRef: function (ref) { return _this.formRef = ref; } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                this.renderSaveButton(),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate("common.back"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_31__ActivityQuestions__["a" /* default */], __assign({}, questionsTableProps)),
            this.renderActivityQuestionCategories(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35__ActivitySummaries__["a" /* default */], __assign({}, summaryTableProps))));
    };
    return AddEditActivity;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_30_react_localize_redux__["d" /* withLocalize */])(AddEditActivity));


/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder












var ActivityQuestions = /** @class */ (function (_super) {
    __extends(ActivityQuestions, _super);
    function ActivityQuestions(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, ActivityQuestions.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
        return _this;
    }
    ActivityQuestions.prototype.deleteActivityQuestion = function (activityQuestionId) {
        var ref = this.dataTableRef;
        var translate = this.props.translate;
        __WEBPACK_IMPORTED_MODULE_11_antd_es_modal__["a" /* default */].confirm({
            title: translate('admin.activityQuestions.confirmDelete'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            onOk: function () {
                var _this = this;
                __WEBPACK_IMPORTED_MODULE_6_src_api_ActivityApiController__["a" /* default */].deleteActivityQuestion(activityQuestionId).then(function (result) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].success(translate('admin.activityQuestions.messageDelete'));
                    ref.refresh();
                }).catch(function (e) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].error(_this.props.translate('admin.activityQuestions.messageDeleteError'));
                });
            },
        });
    };
    ActivityQuestions.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_6_src_api_ActivityApiController__["a" /* default */].getActivityQuestionTableData(requestState, this.props.activityId)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    ActivityQuestions.prototype.customTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION, _this.props.activityId, record.activityQuestionId); };
        var columns = [
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.activityQuestions.columnHeader1', 'questionText'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.activityQuestions.columnHeader2', 'displayOrder'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: _this.props.translate('admin.common.deleteColumnHeader'), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: "delete", onClick: function () { return _this.deleteActivityQuestion(record.activityQuestionId); } })));
                    }
                }
            }
        ];
        if (!this.props.isSurvey) {
            columns.splice(2, 0, __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.activityQuestions.columnHeader3', 'categoryTitle'));
        }
        return columns;
    };
    ActivityQuestions.prototype.render = function () {
        var _this = this;
        if (this.state.formRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION, this.props.activityId, 0), push: true });
        }
        else if (this.props.shouldRefreshTable) {
            this.dataTableRef.refresh();
            this.props.updateShouldRefreshTable();
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.activityQuestions.tableHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'activityQuestionId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["a" /* DataTableButton */]('admin.activityQuestions.addButton', function () { _this.setState({ formRedirect: true }); }),
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return ActivityQuestions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(ActivityQuestions));


/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder












var ActivityQuestionCategories = /** @class */ (function (_super) {
    __extends(ActivityQuestionCategories, _super);
    function ActivityQuestionCategories(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, ActivityQuestionCategories.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
        return _this;
    }
    ActivityQuestionCategories.prototype.deleteActivityQuestionCategory = function (activityQuestionCategoryId) {
        var ref = this.dataTableRef;
        var updateShouldRefreshTable = this.props.updateShouldRefreshTable;
        var translate = this.props.translate;
        __WEBPACK_IMPORTED_MODULE_11_antd_es_modal__["a" /* default */].confirm({
            title: translate('admin.activityQuestionCategories.confirmDelete'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            content: translate('admin.activityQuestionCategories.confirmContent'),
            onOk: function () {
                var _this = this;
                __WEBPACK_IMPORTED_MODULE_6_src_api_ActivityApiController__["a" /* default */].deleteActivityQuestionCategory(activityQuestionCategoryId).then(function (result) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].success(translate('admin.activityQuestionCategories.messageDelete'));
                    ref.refresh();
                    updateShouldRefreshTable();
                }).catch(function (e) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].error(_this.props.translate('admin.activityQuestionCategories.messageDeleteError'));
                });
            },
        });
    };
    ActivityQuestionCategories.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_6_src_api_ActivityApiController__["a" /* default */].getActivityQuestionCategoryTableData(requestState, this.props.activityId)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    ActivityQuestionCategories.prototype.customTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION_CATEGORY, _this.props.activityId, record.activityQuestionCategoryId); };
        return [
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.activityQuestionCategories.columnHeader1', 'titleText'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: _this.props.translate('admin.common.deleteColumnHeader'), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: "delete", onClick: function () { return _this.deleteActivityQuestionCategory(record.activityQuestionCategoryId); } })));
                    }
                }
            }
        ];
    };
    ActivityQuestionCategories.prototype.render = function () {
        var _this = this;
        if (this.state.formRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION_CATEGORY, this.props.activityId, 0), push: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.activityQuestionCategories.tableHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'activityQuestionCategoryId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["a" /* DataTableButton */]('admin.activityQuestionCategories.addButton', function () { _this.setState({ formRedirect: true }); }),
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return ActivityQuestionCategories;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(ActivityQuestionCategories));


/***/ }),
/* 2148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_api_ActivityApiController__ = __webpack_require__(126);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder












var ActivitySummaries = /** @class */ (function (_super) {
    __extends(ActivitySummaries, _super);
    function ActivitySummaries(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, ActivitySummaries.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false,
        };
        return _this;
    }
    ActivitySummaries.prototype.deleteActivitySummary = function (activitySummaryId) {
        var ref = this.dataTableRef;
        var translate = this.props.translate;
        __WEBPACK_IMPORTED_MODULE_10_antd_es_modal__["a" /* default */].confirm({
            title: translate('admin.activitySummaries.confirmDelete'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            onOk: function () {
                var _this = this;
                __WEBPACK_IMPORTED_MODULE_14_src_api_ActivityApiController__["a" /* default */].deleteActivitySummary(activitySummaryId).then(function (result) {
                    __WEBPACK_IMPORTED_MODULE_6_antd_es_message__["a" /* default */].success(translate('admin.activitySummaries.messageDelete'));
                    ref.refresh();
                }).catch(function (e) {
                    __WEBPACK_IMPORTED_MODULE_6_antd_es_message__["a" /* default */].error(_this.props.translate('admin.activitySummaries.messageDeleteError'));
                });
            },
        });
    };
    ActivitySummaries.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_14_src_api_ActivityApiController__["a" /* default */].getActivitySummaryTableData(requestState, this.props.activityId)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    ActivitySummaries.prototype.customTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_SUMMARY, _this.props.activityId, record.activitySummaryId); };
        var columns = [
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.activitySummaries.columnHeader1', 'text'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.NumberAllowZero('admin.activitySummaries.columnHeader2', 'scoreMin'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.NumberAllowZero('admin.activitySummaries.columnHeader3', 'scoreMax'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: _this.props.translate('admin.common.deleteColumnHeader'), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { shape: "circle", icon: "delete", onClick: function () { return _this.deleteActivitySummary(record.activitySummaryId); } })));
                    }
                }
            }
        ];
        return columns;
    };
    ActivitySummaries.prototype.render = function () {
        var _this = this;
        if (this.state.formRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_SUMMARY, this.props.activityId, 0), push: true });
        }
        else if (this.props.shouldRefreshTable) {
            this.dataTableRef.refresh();
            this.props.updateShouldRefreshTable();
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.activitySummaries.tableHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'activitySummaryId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["a" /* DataTableButton */]('admin.activitySummaries.addButton', function () { _this.setState({ formRedirect: true }); }),
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return ActivitySummaries;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(ActivitySummaries));


/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_es_input_number__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_es_input_number_style_index_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ActivityQuestionResponses__ = __webpack_require__(2150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_input_TextArea__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_input_TextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_antd_lib_input_TextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_utils_FormUtil__ = __webpack_require__(842);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};




























 // 'this' binder







// Form
var ActivityQuestionForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    }
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        return _super.call(this, props) || this;
    }
    class_1.prototype.generateOptionsForSelect = function (keyValues) {
        return keyValues.map(function (keyValue) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { value: keyValue.value, key: keyValue.key, title: keyValue.key }, keyValue.key); });
    };
    class_1.prototype.generateLanguageOptions = function () {
        // Only available languages
        return __WEBPACK_IMPORTED_MODULE_34_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable; })
            .map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { key: "cultureIds" + x.id, value: x.id },
            x.name,
            " (",
            x.code,
            ")"); });
    };
    class_1.prototype.renderQuestionTranslations = function () {
        var _this = this;
        if (this.props.currentActivityQuestion) {
            var translations = this.props.currentActivityQuestion.translations;
            return translations.map(function (translation, index) {
                var id = "questionText[" + index + "].text";
                // let cultureKey = this.props.allCultures.find(culture => culture.value === translation.cultureId).key.toLowerCase();
                var cultureKey = __WEBPACK_IMPORTED_MODULE_34_src_constants_Languages__["a" /* default */].FindById(translation.cultureId).code.toLowerCase();
                var translationId = "admin.addEditActivityQuestion.question-" + cultureKey;
                return _this.renderStandardFormItem(translationId, id, translation.questionText, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_33_antd_lib_input_TextArea___default.a, { rows: 4, autoComplete: "off" }), _this.props.selectedCultureId === translation.cultureId);
            });
        }
    };
    class_1.prototype.renderFeedbackTranslations = function () {
        var _this = this;
        if (this.props.currentActivityQuestion) {
            var translations = this.props.currentActivityQuestion.translations;
            return translations.map(function (translation, index) {
                var id = "feedbackText[" + index + "].text";
                var cultureKey = __WEBPACK_IMPORTED_MODULE_34_src_constants_Languages__["a" /* default */].FindById(translation.cultureId).code.toLowerCase();
                var translationId = "admin.addEditActivityQuestion.feedback-" + cultureKey;
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35_src_utils_FormUtil__["a" /* GenericFormItem */], { form: _this.props.form, labelId: translationId, id: id, initialValue: translation.feedbackText, required: false, visible: _this.props.selectedCultureId === translation.cultureId },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_33_antd_lib_input_TextArea___default.a, { rows: 4, autoComplete: "off" }));
            });
        }
    };
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
            })(inputType)));
        }
    };
    class_1.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    this.renderStandardFormItem("admin.addEditActivityQuestion.formItem1", "selectedCultureId", this.props.selectedCultureId, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], null, this.generateLanguageOptions())),
                    this.renderQuestionTranslations(),
                    this.renderFeedbackTranslations(),
                    this.renderStandardFormItem("admin.addEditActivityQuestion.formItem2", "displayOrder", this.props.currentActivityQuestion.displayOrder, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_antd_es_input_number__["a" /* default */], { autoComplete: "off", min: 1 })),
                    this.renderStandardFormItem("admin.addEditActivityQuestion.formItem3", "activityQuestionCategoryId", this.props.currentActivityQuestion.activityQuestionCategoryId, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], null, this.generateOptionsForSelect(this.props.questionCategories)), !this.props.currentActivityQuestion.isSurvey, false),
                    this.renderStandardFormItem("admin.addEditActivityQuestion.formItem4", "enableMultipleSelection", this.props.currentActivityQuestion.enableMultipleSelection, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox__["a" /* default */], { checked: this.props.currentActivityQuestion.enableMultipleSelection }), !this.props.currentActivityQuestion.isSurvey, false)))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditActivityQuestion = /** @class */ (function (_super) {
    __extends(AddEditActivityQuestion, _super);
    function AddEditActivityQuestion(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_28_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditActivityQuestion.prototype);
        var activityId = parseInt(_this.props.match.params.activityId, 10);
        var activityQuestionId = parseInt(_this.props.match.params.activityQuestionId, 10);
        var currentActivityQuestion = {
            activityQuestionId: activityQuestionId,
            activityId: activityId,
            activityQuestionCategoryId: null,
            translations: [],
            enableMultipleSelection: false,
            displayOrder: null,
            isSurvey: false
        };
        _this.state = {
            loading: true,
            visible: false,
            isSubmitting: false,
            categoryName: "",
            allCultures: [],
            questionCategories: [],
            selectedCultureId: 0,
            currentActivityQuestion: currentActivityQuestion
        };
        return _this;
    }
    AddEditActivityQuestion.prototype.componentWillMount = function () {
        var _this = this;
        var categoriesPromise = __WEBPACK_IMPORTED_MODULE_32_src_api_ActivityApiController__["a" /* default */].getActivityQuestionCategories(this.state.currentActivityQuestion.activityId);
        var cultures = __WEBPACK_IMPORTED_MODULE_34_src_constants_Languages__["a" /* default */].All.filter(function (l) { return l.isAvailable; });
        categoriesPromise.then(function (result) {
            var categories = result.data;
            _this.setState({
                questionCategories: categories.keyValues,
                allCultures: cultures,
                selectedCultureId: cultures[0].id
            }, _this.fillForm);
        });
    };
    AddEditActivityQuestion.prototype.fillForm = function () {
        var _this = this;
        if (this.state.currentActivityQuestion.activityQuestionId) {
            __WEBPACK_IMPORTED_MODULE_32_src_api_ActivityApiController__["a" /* default */].getActivityQuestion(this.state.currentActivityQuestion.activityQuestionId).then(function (result) {
                _this.setState({
                    loading: false,
                    currentActivityQuestion: result.data
                });
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditActivityQuestion.messageRetrieveError'));
            });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_32_src_api_ActivityApiController__["a" /* default */].getActivity(this.state.currentActivityQuestion.activityId).then(function (result) {
                var translations = _this.state.allCultures.map(function (culture) {
                    var translation = {
                        cultureId: culture.id,
                        questionText: null,
                        feedbackText: null
                    };
                    return translation;
                });
                var activityQuestion = {
                    translations: translations,
                    isSurvey: result.data.isSurvey
                };
                _this.setState({
                    currentActivityQuestion: __assign(__assign({}, _this.state.currentActivityQuestion), activityQuestion),
                    loading: false
                });
            });
        }
    };
    AddEditActivityQuestion.prototype.translationsAreCompleted = function () {
        var translations = this.state.currentActivityQuestion.translations;
        var emptyTranslations = translations.filter(function (translation) {
            return translation.questionText === null || translation.questionText === "";
        });
        return emptyTranslations.length === 0;
    };
    AddEditActivityQuestion.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                // If key is the nested property
                if (key === 'feedbackText' || key === 'questionText') {
                    var fieldKey = '';
                    var localizedTextKey = 'translations';
                    for (var fieldName in field) {
                        if (field.hasOwnProperty(fieldName)) {
                            fieldKey = fieldName;
                            break;
                        }
                    }
                    newState[localizedTextKey] = __spreadArrays(this.state.currentActivityQuestion.translations);
                    newState[localizedTextKey][fieldKey][key] = field[fieldKey].text.value;
                }
                else if (key === 'selectedCultureId') {
                    this.setState({ selectedCultureId: field.value });
                    return;
                }
                else {
                    newState[key] = field.value;
                }
            }
        }
        this.setState({
            currentActivityQuestion: __assign(__assign({}, this.state.currentActivityQuestion), newState)
        });
    };
    AddEditActivityQuestion.prototype.addActivityQuestion = function () {
        var _this = this;
        var addActivityQuestionDTO = {
            displayOrder: this.state.currentActivityQuestion.displayOrder,
            activityQuestionCategoryId: this.state.currentActivityQuestion.activityQuestionCategoryId,
            translations: this.state.currentActivityQuestion.translations,
            activityId: this.state.currentActivityQuestion.activityId,
            enableMultipleSelection: this.state.currentActivityQuestion.enableMultipleSelection
        };
        __WEBPACK_IMPORTED_MODULE_32_src_api_ActivityApiController__["a" /* default */].addActivityQuestion(addActivityQuestionDTO)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditActivityQuestion.messageAdd'));
            _this.setState({ isSubmitting: false });
            _this.props.history.push(__WEBPACK_IMPORTED_MODULE_29_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_29_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION, _this.state.currentActivityQuestion.activityId, result.data));
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditActivityQuestion.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditActivityQuestion.prototype.updateActivityQuestion = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_32_src_api_ActivityApiController__["a" /* default */].updateActivityQuestion(this.state.currentActivityQuestion)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditActivityQuestion.messageUpdate'));
            _this.setState({ isSubmitting: false });
            _this.props.history.push(__WEBPACK_IMPORTED_MODULE_29_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_29_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION, _this.state.currentActivityQuestion.activityId, _this.state.currentActivityQuestion.activityQuestionId));
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditActivityQuestion.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditActivityQuestion.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.state.currentActivityQuestion.activityQuestionId ? _this.updateActivityQuestion() : _this.addActivityQuestion();
            }
        });
    };
    AddEditActivityQuestion.prototype.handleCancel = function (e) {
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_29_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_29_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY, this.state.currentActivityQuestion.activityId));
    };
    AddEditActivityQuestion.prototype.renderSaveButton = function () {
        if (this.translationsAreCompleted()) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_30_react_localize_redux__["b" /* Translate */], { id: "admin.common.saveButton" })));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: this.props.translate('admin.addEditActivityQuestion.saveTooltip'), arrowPointAtCenter: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", disabled: true },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_30_react_localize_redux__["b" /* Translate */], { id: "admin.common.saveButton" }))));
    };
    AddEditActivityQuestion.prototype.renderActivityQuestionResponses = function () {
        var datatableProps = {
            activityId: this.state.currentActivityQuestion.activityId,
            activityQuestionId: this.state.currentActivityQuestion.activityQuestionId,
            isSurvey: this.state.currentActivityQuestion.isSurvey
        };
        if (this.state.currentActivityQuestion.activityQuestionId) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_31__ActivityQuestionResponses__["a" /* default */], __assign({}, datatableProps));
        }
    };
    AddEditActivityQuestion.prototype.render = function () {
        var _this = this;
        if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            currentActivityQuestion: this.state.currentActivityQuestion,
            allCultures: this.state.allCultures,
            questionCategories: this.state.questionCategories,
            selectedCultureId: this.state.selectedCultureId,
            translate: this.props.translate,
            onChange: this.handleInputChange
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_30_react_localize_redux__["b" /* Translate */], { id: "admin.addEditActivityQuestion.addHeader" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ActivityQuestionForm, __assign({ wrappedComponentRef: function (ref) { return _this.formRef = ref; } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                this.renderSaveButton(),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_30_react_localize_redux__["b" /* Translate */], { id: "common.back" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            this.renderActivityQuestionResponses()));
    };
    return AddEditActivityQuestion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_30_react_localize_redux__["d" /* withLocalize */])(AddEditActivityQuestion));


/***/ }),
/* 2150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder












var ActivityQuestionResponses = /** @class */ (function (_super) {
    __extends(ActivityQuestionResponses, _super);
    function ActivityQuestionResponses(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, ActivityQuestionResponses.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
        return _this;
    }
    ActivityQuestionResponses.prototype.deleteActivityQuestionResponse = function (activityQuestionResponseId) {
        var ref = this.dataTableRef;
        var translate = this.props.translate;
        __WEBPACK_IMPORTED_MODULE_11_antd_es_modal__["a" /* default */].confirm({
            title: translate('admin.activityQuestionResponses.confirmDelete'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            onOk: function () {
                var _this = this;
                __WEBPACK_IMPORTED_MODULE_6_src_api_ActivityApiController__["a" /* default */].deleteActivityQuestionResponse(activityQuestionResponseId).then(function (result) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].success(translate('admin.activityQuestionResponses.messageDelete'));
                    ref.refresh();
                }).catch(function (e) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].error(_this.props.translate('admin.activityQuestionResponses.messageDeleteError'));
                });
            },
        });
    };
    ActivityQuestionResponses.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_6_src_api_ActivityApiController__["a" /* default */].getActivityQuestionResponseTableData(requestState, this.props.activityQuestionId)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    ActivityQuestionResponses.prototype.customTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION_RESPONSE, _this.props.activityId, _this.props.activityQuestionId, record.activityQuestionResponseId); };
        return [
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.activityQuestionResponses.columnHeader1', 'responseText'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.activityQuestionResponses.columnHeader2', 'displayOrder'),
            this.props.isSurvey ?
                __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.activityQuestionResponses.columnHeader3', 'weight') :
                __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Boolean('admin.activityQuestionResponses.columnHeader4', 'isCorrect'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: _this.props.translate('admin.common.deleteColumnHeader'), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: "delete", onClick: function () { return _this.deleteActivityQuestionResponse(record.activityQuestionResponseId); } })));
                    }
                }
            }
        ];
    };
    ActivityQuestionResponses.prototype.render = function () {
        var _this = this;
        if (this.state.formRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION_RESPONSE, this.props.activityId, this.props.activityQuestionId, 0), push: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.activityQuestionResponses.tableHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'activityQuestionResponseId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["a" /* DataTableButton */]('admin.activityQuestionResponses.addButton', function () { _this.setState({ formRedirect: true }); }),
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return ActivityQuestionResponses;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(ActivityQuestionResponses));


/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_input_TextArea__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_input_TextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_input_TextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_constants_Languages__ = __webpack_require__(80);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

























 // 'this' binder





// Form
var ActivityQuestionCategoryForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    }
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        return _super.call(this, props) || this;
    }
    class_1.prototype.generateOptionsForSelect = function (keyValues) {
        return keyValues.map(function (keyValue) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { value: keyValue.value, key: keyValue.key, title: keyValue.key }, keyValue.key); });
    };
    class_1.prototype.generateLanguageOptions = function () {
        // Only available languages
        return __WEBPACK_IMPORTED_MODULE_30_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable; })
            .map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { key: "cultureIds" + x.id, value: x.id },
            x.name,
            " (",
            x.code,
            ")"); });
    };
    class_1.prototype.renderTranslations = function () {
        var _this = this;
        if (this.props.currentActivityQuestionCategory) {
            var translations = this.props.currentActivityQuestionCategory.translations;
            return translations.map(function (translation, index) {
                var id = "translations[" + index + "].text";
                var culture = _this.props.allCultures.find(function (culture) { return culture.id === translation.cultureId; }).code.toLowerCase();
                var translationId = "admin.addEditActivityQuestionCategory." + culture;
                return _this.renderStandardFormItem(translationId, id, translation.text, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_antd_lib_input_TextArea___default.a, { rows: 4, autoComplete: "off" }), _this.props.selectedCultureId === translation.cultureId);
            });
        }
    };
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
            })(inputType)));
        }
    };
    class_1.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    this.renderStandardFormItem("admin.addEditActivityQuestionCategory.formItem1", "selectedCultureId", this.props.selectedCultureId, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], null, this.generateLanguageOptions())),
                    this.renderTranslations()))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditActivityQuestionCategory = /** @class */ (function (_super) {
    __extends(AddEditActivityQuestionCategory, _super);
    function AddEditActivityQuestionCategory(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_25_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditActivityQuestionCategory.prototype);
        var activityId = parseInt(_this.props.match.params.activityId, 10);
        var activityQuestionCategoryId = parseInt(_this.props.match.params.activityQuestionCategoryId, 10);
        var currentActivityQuestionCategory = {
            activityQuestionCategoryId: activityQuestionCategoryId,
            translations: [],
            activityId: activityId
        };
        _this.state = {
            loading: true,
            isSubmitting: false,
            redirect: false,
            allCultures: [],
            selectedCultureId: 0,
            currentActivityQuestionCategory: currentActivityQuestionCategory
        };
        return _this;
    }
    AddEditActivityQuestionCategory.prototype.componentWillMount = function () {
        var cultures = __WEBPACK_IMPORTED_MODULE_30_src_constants_Languages__["a" /* default */].All.filter(function (l) { return l.isAvailable; });
        this.setState({
            allCultures: cultures,
            selectedCultureId: cultures[0].id
        }, this.fillForm);
    };
    AddEditActivityQuestionCategory.prototype.fillForm = function () {
        var _this = this;
        if (this.state.currentActivityQuestionCategory.activityQuestionCategoryId) {
            __WEBPACK_IMPORTED_MODULE_28_src_api_ActivityApiController__["a" /* default */].getActivityQuestionCategory(this.state.currentActivityQuestionCategory.activityQuestionCategoryId).then(function (result) {
                _this.setState({
                    loading: false,
                    currentActivityQuestionCategory: result.data
                });
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditActivityQuestionCategory.messageRetrieveError'));
            });
        }
        else {
            var translations = this.state.allCultures.map(function (culture) {
                var translation = {
                    cultureId: culture.id,
                    text: null
                };
                return translation;
            });
            var activityQuestionCategory = {
                translations: translations
            };
            this.setState({
                currentActivityQuestionCategory: __assign(__assign({}, this.state.currentActivityQuestionCategory), activityQuestionCategory),
                loading: false
            });
        }
    };
    AddEditActivityQuestionCategory.prototype.translationsAreCompleted = function () {
        var translations = this.state.currentActivityQuestionCategory.translations;
        var emptyTranslations = translations.filter(function (translation) {
            return translation.text === null || translation.text === "";
        });
        return emptyTranslations.length === 0;
    };
    AddEditActivityQuestionCategory.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                // If key is the nested property
                if (key === 'translations') {
                    var fieldKey = '';
                    for (var fieldName in field) {
                        if (field.hasOwnProperty(fieldName)) {
                            fieldKey = fieldName;
                            break;
                        }
                    }
                    newState[key] = __spreadArrays(this.state.currentActivityQuestionCategory[key]);
                    newState[key][fieldKey].text = field[fieldKey].text.value;
                }
                else if (key === 'selectedCultureId') {
                    this.setState({ selectedCultureId: field.value });
                    return;
                }
                else {
                    newState[key] = field.value;
                }
            }
        }
        this.setState({
            currentActivityQuestionCategory: __assign(__assign({}, this.state.currentActivityQuestionCategory), newState)
        });
    };
    AddEditActivityQuestionCategory.prototype.addActivityQuestionCategory = function () {
        var _this = this;
        var addActivityQuestionCategoryDTO = {
            translations: this.state.currentActivityQuestionCategory.translations,
            activityId: this.state.currentActivityQuestionCategory.activityId
        };
        __WEBPACK_IMPORTED_MODULE_28_src_api_ActivityApiController__["a" /* default */].addActivityQuestionCategory(addActivityQuestionCategoryDTO)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditActivityQuestionCategory.messageAdd'));
            _this.setState({ redirect: true, isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditActivityQuestionCategory.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditActivityQuestionCategory.prototype.updateActivityQuestionCategory = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_28_src_api_ActivityApiController__["a" /* default */].updateActivityQuestionCategory(this.state.currentActivityQuestionCategory)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditActivityQuestionCategory.messageUpdate'));
            _this.setState({ redirect: true, isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditActivityQuestionCategory.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditActivityQuestionCategory.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.state.currentActivityQuestionCategory.activityQuestionCategoryId ? _this.updateActivityQuestionCategory() : _this.addActivityQuestionCategory();
            }
        });
    };
    AddEditActivityQuestionCategory.prototype.handleCancel = function (e) {
        this.setState({ redirect: true });
    };
    AddEditActivityQuestionCategory.prototype.renderSaveButton = function () {
        if (this.translationsAreCompleted()) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate("admin.common.saveButton")));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: this.props.translate('admin.addEditActivityQuestionCategory.saveTooltip'), arrowPointAtCenter: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", disabled: true }, this.props.translate("admin.common.saveButton"))));
    };
    AddEditActivityQuestionCategory.prototype.render = function () {
        var _this = this;
        if (this.state.redirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_26_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY, this.state.currentActivityQuestionCategory.activityId), push: true });
        }
        else if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            currentActivityQuestionCategory: this.state.currentActivityQuestionCategory,
            allCultures: this.state.allCultures,
            selectedCultureId: this.state.selectedCultureId,
            translate: this.props.translate,
            onChange: this.handleInputChange
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.addEditActivityQuestionCategory.addHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ActivityQuestionCategoryForm, __assign({ wrappedComponentRef: function (ref) { return _this.formRef = ref; } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                this.renderSaveButton(),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate("common.back")))));
    };
    return AddEditActivityQuestionCategory;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_27_react_localize_redux__["d" /* withLocalize */])(AddEditActivityQuestionCategory));


/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_input_number__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_input_number_style_index_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_es_upload__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_es_upload_style_index_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_pages_admin_forms_AddEditActivityQuestionResponseForm__ = __webpack_require__(2153);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






























 // 'this' binder





var AddEditActivityQuestionResponse = /** @class */ (function (_super) {
    __extends(AddEditActivityQuestionResponse, _super);
    function AddEditActivityQuestionResponse(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_30_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditActivityQuestionResponse.prototype);
        var activityId = parseInt(_this.props.match.params.activityId, 10);
        var activityQuestionId = parseInt(_this.props.match.params.activityQuestionId, 10);
        var activityQuestionResponseId = parseInt(_this.props.match.params.activityQuestionResponseId, 10);
        var currentActivityQuestionResponse = {
            activityQuestionResponseId: activityQuestionResponseId,
            activityQuestionId: activityQuestionId,
            translations: [],
            isSurvey: false,
            isCorrect: false,
            weight: null,
            displayOrder: null,
        };
        _this.state = {
            isLoading: true,
            isSubmitting: false,
            isUpdate: false,
            activityId: activityId,
            currentActivityQuestionResponse: currentActivityQuestionResponse
        };
        return _this;
    }
    AddEditActivityQuestionResponse.prototype.componentDidMount = function () {
        var _this = this;
        var activityQuestionId = parseInt(this.props.match.params.activityQuestionId, 10);
        var activityQuestionResponseId = parseInt(this.props.match.params.activityQuestionResponseId, 10);
        if (activityQuestionResponseId != null && activityQuestionResponseId > 0) {
            // We are updating, load previous
            __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].getActivityQuestionResponse(activityQuestionResponseId).then(function (result) {
                if (result.ok) {
                    var translations = result.data.translations.map(function (x) {
                        return __assign({}, x);
                    });
                    var response = __assign(__assign({}, result.data), { translations: translations });
                    _this.setState({
                        isLoading: false,
                        isUpdate: true,
                        currentActivityQuestionResponse: response
                    });
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate("admin.addEditActivityQuestionResponse.messageRetrieveError"));
                }
            });
        }
        else {
            // New response, so get the question and merge information
            var availableLanguages_1 = __WEBPACK_IMPORTED_MODULE_34_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable; });
            __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].getActivityQuestion(activityQuestionId).then(function (result) {
                if (result.ok) {
                    var translations = availableLanguages_1.map(function (lang) {
                        return {
                            cultureId: lang.id,
                            text: "",
                        };
                    });
                    var response = __assign(__assign({}, result.data), { activityQuestionResponseId: 0, isCorrect: false, weight: 0, displayOrder: 0, translations: translations });
                    _this.setState({
                        isLoading: false,
                        isUpdate: false,
                        currentActivityQuestionResponse: response
                    });
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate("admin.addEditActivityQuestionResponse.messageRetrieveError"));
                }
            });
        }
    };
    AddEditActivityQuestionResponse.prototype.addActivityQuestionResponse = function (values, fileList) {
        var _this = this;
        var addActivityQuestionResponseDTO = {
            displayOrder: this.state.currentActivityQuestionResponse.displayOrder,
            translations: this.state.currentActivityQuestionResponse.translations,
            activityQuestionId: this.state.currentActivityQuestionResponse.activityQuestionId,
            weight: this.state.currentActivityQuestionResponse.weight,
            isCorrect: this.state.currentActivityQuestionResponse.isCorrect
        };
        __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].addActivityQuestionResponse()
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditActivityQuestionResponse.messageAdd'));
            _this.setState({ isSubmitting: false });
            _this.props.history.push(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION, _this.state.activityId, _this.state.currentActivityQuestionResponse.activityQuestionId));
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditActivityQuestionResponse.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    // This has been updated for a form based submission
    AddEditActivityQuestionResponse.prototype.updateActivityQuestionResponse = function (values, fileList) {
        var _this = this;
        var formData = new FormData();
        var json = JSON.stringify(values);
        formData.append('jsonStringifiedObject', json);
        // Filter by status as it is null on a new UploadFile object
        fileList.filter(function (x) { return x.file != null && x.file.status == null; }).forEach(function (file) {
            formData.append('Files[]', file.file);
        });
        __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].updateActivityQuestionResponse({ formData: formData }).then(function (result) {
            _this.setState({ isSubmitting: false });
            if (result.ok) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate("admin.addEditActivityQuestionResponse.messageAdd"));
                _this.props.history.push(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION, _this.state.activityId, _this.state.currentActivityQuestionResponse.activityQuestionId));
                return;
            }
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate("admin.addEditActivityQuestionResponse.messageAddError"));
        });
    };
    AddEditActivityQuestionResponse.prototype.onSubmit = function (values) {
        var _this = this;
        var cleanedValues = __assign(__assign({}, this.state.currentActivityQuestionResponse), { 
            // Values updated from the form
            displayOrder: values.displayOrder, isCorrect: values.isCorrect, weight: values.weight, translations: values.translations.map(function (x) {
                var cultureFile = values.fileList.find(function (y) { return y.cultureId === x.cultureId; });
                return __assign(__assign({}, x), { imageFileName: cultureFile.file != null ? cultureFile.file.name : "" });
            }) });
        var fileList = values.fileList;
        var formData = new FormData();
        var json = JSON.stringify(cleanedValues);
        formData.append('jsonStringifiedObject', json);
        // Filter by status as it is null on a new UploadFile object
        fileList.filter(function (x) { return x.file != null && x.file.status == null; }).forEach(function (file) {
            formData.append('Files[]', file.file);
        });
        this.setState({ isSubmitting: true });
        if (this.state.isUpdate) {
            return __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].updateActivityQuestionResponse({ formData: formData }).then(function (result) {
                _this.setState({ isSubmitting: false });
                if (result.ok) {
                    __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate("admin.addEditActivityQuestionResponse.messageUpdate"));
                    _this.props.history.push(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION, _this.state.activityId, _this.state.currentActivityQuestionResponse.activityQuestionId));
                    return;
                }
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate("admin.addEditActivityQuestionResponse.messageUpdateError"));
            });
        }
        return __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].addActivityQuestionResponse({ formData: formData }).then(function (result) {
            _this.setState({ isSubmitting: false });
            if (result.ok) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate("admin.addEditActivityQuestionResponse.messageAdd"));
                _this.props.history.push(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION, _this.state.activityId, _this.state.currentActivityQuestionResponse.activityQuestionId));
                return;
            }
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate("admin.addEditActivityQuestionResponse.messageAddError"));
        });
    };
    AddEditActivityQuestionResponse.prototype.onCancel = function () {
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_QUESTION, this.state.activityId, this.state.currentActivityQuestionResponse.activityQuestionId));
    };
    AddEditActivityQuestionResponse.prototype.render = function () {
        if (this.state.isLoading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            currentValues: this.state.currentActivityQuestionResponse,
            onSubmit: this.onSubmit,
            onCancel: this.onCancel,
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.addEditActivityQuestionResponse.addHeader" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35_src_pages_admin_forms_AddEditActivityQuestionResponseForm__["a" /* default */], __assign({}, formProps))));
    };
    return AddEditActivityQuestionResponse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["d" /* withLocalize */])(AddEditActivityQuestionResponse));


/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_input_number__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_input_number_style_index_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_es_upload__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_es_upload_style_index_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_es_collapse__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_es_collapse_style_index_js__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_input_TextArea__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_input_TextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_antd_lib_input_TextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_utils_ObjectUtil__ = __webpack_require__(364);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};































 // 'this' binder






var ActivityQuestionResponseForm = /** @class */ (function (_super) {
    __extends(ActivityQuestionResponseForm, _super);
    function ActivityQuestionResponseForm(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_31_src_utils_BindThisHelper__["a" /* default */])(_this, ActivityQuestionResponseForm.prototype);
        _this.state = {
            activityQuestionId: 0,
            activityQuestionResponseId: 0,
            displayOrder: 0,
            weight: 0,
            selectedCultureId: 0,
            isSurvey: false,
            isCorrect: false,
            translations: [],
            fileList: [],
            isLoading: true
        };
        return _this;
    }
    ActivityQuestionResponseForm.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
    };
    ActivityQuestionResponseForm.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.currentValues !== this.props.currentValues) {
            this.deriveStateFromProps(newProps);
        }
    };
    ActivityQuestionResponseForm.prototype.deriveStateFromProps = function (props) {
        var _this = this;
        // Update some state based on prop change
        var translations = props.currentValues.translations;
        if (translations.length === 0) {
            return this.setState(__assign(__assign({}, props.currentValues), { fileList: __WEBPACK_IMPORTED_MODULE_34_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable; }).map(function (x) {
                    return { cultureId: x.id, file: undefined };
                }), selectedCultureId: 1 }));
        }
        this.setState(__assign(__assign({}, props.currentValues), { fileList: translations.map(function (x) {
                var newFile = undefined;
                if (x.imageFile != null) {
                    var uid = Math.floor(Math.random() * 10000);
                    newFile = {
                        uid: uid.toString(),
                        name: x.imageFile.fileName,
                        status: 'done',
                        thumbUrl: x.imageFile.azureFileUrl,
                    };
                }
                return { cultureId: x.cultureId, file: newFile };
            }), selectedCultureId: translations[0].cultureId, isLoading: false }), function () {
            console.warn("this.state", _this.state); // JB - Remove this console.warn
        });
    };
    ActivityQuestionResponseForm.prototype.onSubmit = function (values) {
        console.warn("Valuies", values); // JB - Remove this console.warn
        // Values contains all values updated on the form. Merge those with what we have in state and return the result
        var merged = __WEBPACK_IMPORTED_MODULE_37_src_utils_ObjectUtil__["a" /* default */].DeepMergeObjects(this.state, values);
        var output = __assign(__assign({}, merged), { 
            // This cleans up the clobbering that DeepMerge does as the values object contains some very interesting stuff in the fileList attribute
            fileList: this.state.fileList });
        this.props.onSubmit(output);
    };
    ActivityQuestionResponseForm.prototype.onChange = function (values) {
        // This is involved with the form validation
        var merged = __WEBPACK_IMPORTED_MODULE_37_src_utils_ObjectUtil__["a" /* default */].DeepMergeObjects(this.state, values);
        this.setState(__assign({}, merged));
    };
    ActivityQuestionResponseForm.prototype.onCancel = function () {
        this.props.onCancel();
    };
    ActivityQuestionResponseForm.prototype.renderSaveButton = function () {
        var hasMissingTranslations = this.state.translations.some(function (x) { return x.text == null || x.text.length < 1; });
        var submitButton = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["a" /* AntFormItems */].SubmitButton, { type: "primary", loading: false, disabled: hasMissingTranslations, key: "submitButton" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.common.saveButton" }));
        if (hasMissingTranslations) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.addEditActivityQuestionResponse.saveTooltip" }), arrowPointAtCenter: true }, submitButton);
        }
        return submitButton;
    };
    ActivityQuestionResponseForm.prototype.renderCollapse = function () {
        var _this = this;
        var panels = this.state.translations.map(function (translation, index) {
            var culture = __WEBPACK_IMPORTED_MODULE_34_src_constants_Languages__["a" /* default */].FindById(translation.cultureId);
            var props = {
                action: "",
                onRemove: function (file) {
                    // File will be the only file for the current language in fileList
                    var fileList = _this.state.fileList;
                    fileList.find(function (x) { return x.cultureId === culture.id; }).file = undefined;
                    _this.setState({
                        fileList: fileList,
                    });
                },
                beforeUpload: function (file) {
                    var fileList = _this.state.fileList;
                    fileList.find(function (x) { return x.cultureId === culture.id; }).file = file;
                    _this.setState({
                        fileList: fileList,
                    });
                    // Stop the actual file upload process, we will do that later
                    return false;
                },
                fileList: _this.state.fileList.filter(function (x) { return x.cultureId === culture.id; }).map(function (x) { return x.file; }).filter(function (x) { return x; }),
                listType: "picture",
                accept: "image/x-png,image/gif,image/jpeg",
            };
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_antd_es_collapse__["a" /* default */].Panel, { header: "" + culture.name, key: "" + index, style: { display: "block" } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["a" /* AntFormItems */].Custom, { uniqueId: Object(__WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__["a" /* NameOf */])("translations") + "[" + index + "]." + Object(__WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__["a" /* NameOf */])("text"), label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.addEditActivityQuestionResponse." + culture.code.toLowerCase() }), initialValue: translation.text, key: "admin.addEditActivityQuestionResponse." + culture.code.toLowerCase(), rules: [__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["b" /* AntFormRules */].Required(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }))] },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_33_antd_lib_input_TextArea___default.a, { rows: 4, autoComplete: "off" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["a" /* AntFormItems */].Custom, { uniqueId: Object(__WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__["a" /* NameOf */])("translations") + "[" + index + "]." + Object(__WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__["a" /* NameOf */])("imageFile"), label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.addEditActivityQuestionResponse." + culture.code.toLowerCase() }), key: "admin.addEditActivityQuestionResponse." + culture.code.toLowerCase() + "2" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_antd_es_upload__["a" /* default */], __assign({}, props),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_button__["a" /* default */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27_antd_es_icon__["a" /* default */], { type: "upload" }),
                            " Select File"))));
        });
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29_antd_es_collapse__["a" /* default */], { key: "translations-panel", defaultActiveKey: ['0'], style: { display: "table-caption" } }, panels);
    };
    ActivityQuestionResponseForm.prototype.render = function () {
        var _this = this;
        if (this.props.currentValues == null || this.props.currentValues.translations == null) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["c" /* AntFormSimple */], { onSubmit: function (x) { return _this.onSubmit(x); }, onChange: this.onChange, className: "admin-form" },
                    this.renderCollapse(),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["a" /* AntFormItems */].Input, { uniqueId: Object(__WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__["a" /* NameOf */])("displayOrder"), key: Object(__WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__["a" /* NameOf */])("displayOrder"), label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.addEditActivityQuestionResponse.formItem2" }), initialValue: this.state.displayOrder, type: "number", rules: [__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["b" /* AntFormRules */].Required(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }))] }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["a" /* AntFormItems */].Input, { uniqueId: Object(__WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__["a" /* NameOf */])("weight"), key: Object(__WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__["a" /* NameOf */])("weight"), label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.addEditActivityQuestionResponse.formItem3" }), initialValue: this.state.weight, type: "number", rules: [__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["b" /* AntFormRules */].Required(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }))], visible: this.state.isSurvey }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["a" /* AntFormItems */].Custom, { uniqueId: Object(__WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__["a" /* NameOf */])("isCorrect"), key: Object(__WEBPACK_IMPORTED_MODULE_36_src_utils_NameOf__["a" /* NameOf */])("isCorrect"), label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.addEditActivityQuestionResponse.formItem4" }), initialValue: this.state.isCorrect },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_checkbox__["a" /* default */], { checked: this.state.isCorrect })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: "buttons" },
                        this.renderSaveButton(),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_divider__["a" /* default */], { type: "vertical" }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35_src_utils_formUtil_Form__["a" /* AntFormItems */].Button, { onClick: this.onCancel, key: "backButton" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "common.back" }))))));
    };
    return ActivityQuestionResponseForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ActivityQuestionResponseForm);


/***/ }),
/* 2154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AntFormItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_NameOf__ = __webpack_require__(154);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var AntFormItems;
(function (AntFormItems) {
    var Custom = /** @class */ (function (_super) {
        __extends(Custom, _super);
        function Custom(props) {
            var _this = _super.call(this, props) || this;
            Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, Custom.prototype);
            return _this;
        }
        Custom.prototype.render = function () {
            var children = this.props.children;
            var style = undefined;
            if (this.props.visible === false) {
                style = {
                    display: "none",
                };
            }
            // Debugging and catch statements
            if (this.props.uniqueId == null) {
                console.warn(Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_NameOf__["a" /* NameOf */])("uniqueId") + " is null. This is a required field");
                return null;
            }
            if (this.props.form == null) {
                console.warn("Form is null. Please pass in the antd form or be a child of the AntdForm");
                return null;
            }
            if (Array.isArray(children)) {
                console.warn("Form Item children must be a single react component, not an array. Rendering first element");
                children = children[0];
            }
            // Variable null check
            var rules = this.props.rules == null ? undefined : this.props.rules;
            var initialValue = this.props.initialValue == null ? undefined : this.props.initialValue;
            var uniqueId = this.props.uniqueId == null ? undefined : this.props.uniqueId;
            var label = this.props.label == null ? undefined : this.props.label;
            var formItemClassName = this.props.formItemClassName == null ? undefined : this.props.formItemClassName;
            // Create our fancy field decorator function
            var fieldDecorator = this.props.form.getFieldDecorator(uniqueId, {
                initialValue: initialValue,
                rules: rules
            });
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd__["Form"].Item, { label: label, className: formItemClassName, style: style }, fieldDecorator(children));
        };
        return Custom;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
    AntFormItems.Custom = Custom;
    var Button = /** @class */ (function (_super) {
        __extends(Button, _super);
        function Button(props) {
            var _this = _super.call(this, props) || this;
            Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, Button.prototype);
            return _this;
        }
        Button.prototype.render = function () {
            if (this.props.visible === false) {
                return null;
            }
            var size = this.props.size == null ? undefined : this.props.size;
            var type = this.props.type == null ? undefined : this.props.type;
            var disabled = this.props.disabled == null ? undefined : this.props.disabled;
            var loading = this.props.loading == null ? undefined : this.props.loading;
            var onClick = this.props.onClick == null ? undefined : this.props.onClick;
            var displayStuff = this.props.children == null ? this.props.text : this.props.children;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { size: size, type: type, disabled: disabled, loading: loading, onClick: onClick }, displayStuff);
        };
        return Button;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
    AntFormItems.Button = Button;
    var SubmitButton = /** @class */ (function (_super) {
        __extends(SubmitButton, _super);
        function SubmitButton(props) {
            var _this = _super.call(this, props) || this;
            Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, SubmitButton.prototype);
            return _this;
        }
        SubmitButton.prototype.render = function () {
            if (this.props.visible === false) {
                return null;
            }
            var size = this.props.size == null ? undefined : this.props.size;
            var type = this.props.type == null ? undefined : this.props.type;
            var disabled = this.props.disabled == null ? undefined : this.props.disabled;
            var loading = this.props.loading == null ? undefined : this.props.loading;
            var onClick = this.props.onClick == null ? undefined : this.props.onClick;
            var displayStuff = this.props.children == null ? this.props.text : this.props.children;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { size: size, type: type, disabled: disabled, loading: loading, onClick: onClick, htmlType: "submit" }, displayStuff);
        };
        return SubmitButton;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
    AntFormItems.SubmitButton = SubmitButton;
    var Input = /** @class */ (function (_super) {
        __extends(Input, _super);
        function Input(props) {
            var _this = _super.call(this, props) || this;
            Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, Input.prototype);
            return _this;
        }
        Input.prototype.componentWillReceiveProps = function (nextProps) {
            var _a;
            if (nextProps.value !== this.props.value) {
                this.props.form.setFieldsValue((_a = {},
                    _a[nextProps.uniqueId] = nextProps.value,
                    _a));
            }
        };
        Input.prototype.convertNumberValidationFunc = function (e) {
            var originalValue = e.currentTarget.value;
            var convertedValue = Number(originalValue);
            if (Number.isNaN(convertedValue)) {
                return originalValue;
            }
            return convertedValue;
        };
        Input.prototype.render = function () {
            if (this.props.visible === false) {
                return null;
            }
            // Debugging and catch statements
            if (this.props.uniqueId == null) {
                console.warn(Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_NameOf__["a" /* NameOf */])("uniqueId") + " is null. This is a required field");
                return null;
            }
            if (this.props.form == null) {
                console.warn("Form is null. Please pass in the antd form or be a child of the AntdForm");
                return null;
            }
            // Variable null check
            var rules = this.props.rules == null ? undefined : this.props.rules;
            var value = this.props.value == null ? undefined : this.props.value;
            var initialValue = this.props.initialValue == null ? undefined : this.props.initialValue;
            var uniqueId = this.props.uniqueId == null ? undefined : this.props.uniqueId;
            var label = this.props.label == null ? undefined : this.props.label;
            var size = this.props.size == null ? undefined : this.props.size;
            var type = this.props.type == null ? undefined : this.props.type;
            var placeholder = this.props.placeholder == null ? undefined : this.props.placeholder;
            var disabled = this.props.disabled == null ? undefined : this.props.disabled;
            var onClick = this.props.onClick == null ? undefined : this.props.onClick;
            var onBlur = this.props.onBlur == null ? function () { } : this.props.onBlur;
            var onChange = this.props.onChange == null ? function () { } : this.props.onChange;
            var className = this.props.className == null ? undefined : this.props.className;
            var formItemClassName = this.props.formItemClassName == null ? undefined : this.props.formItemClassName;
            // Special check for Number validation
            var getValueFromEvent = type === "number" || (rules != null && rules.find(function (x) { return x.type === "number"; })) ? this.convertNumberValidationFunc : undefined;
            // Create our fancy field decorator function
            var fieldDecorator = this.props.form.getFieldDecorator(uniqueId, {
                initialValue: value === undefined ? initialValue : value,
                rules: rules,
                getValueFromEvent: getValueFromEvent,
            });
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd__["Form"].Item, { label: label, className: formItemClassName }, fieldDecorator(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd__["Input"], { className: className, size: size, type: type, placeholder: placeholder, disabled: disabled, onClick: onClick, onBlur: function (event) { return onBlur(event.target.value); }, onChange: function (event) { return onChange(event.target.value); } })));
        };
        return Input;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
    AntFormItems.Input = Input;
})(AntFormItems || (AntFormItems = {}));
/**
 * Obsolete: Please use the `FieldDecorator` component instead. It is located in the `components/common/form` folder
 */



/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AntFormRules; });
var AntFormRules = /** @class */ (function () {
    function AntFormRules() {
        // Dont be that guy
        throw new Error("NOOOO");
    }
    /**
     * A rule indicating that this FormItem is **Required**
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    AntFormRules.Required = function (message) {
        if (message === void 0) { message = null; }
        return {
            required: true,
            message: message,
        };
    };
    /**
     * A rule indicating that this FormItem has an **Exact** value that it must be
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    AntFormRules.Exact = function (value, message) {
        if (message === void 0) { message = null; }
        var exactValidator = function (rule, current, callback) {
            if (current != null && current !== value) {
                console.warn("It's bad, do this"); // JB - Remove this console.warn
                callback(message);
            }
            callback();
        };
        return {
            validator: exactValidator,
            message: message,
        };
    };
    /**
     * A rule indicating that this FormItem has a **Minimum** value
     *
     * @param {number} [min] The minimum value inclusive. Defaults to 0
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    AntFormRules.Min = function (min, message) {
        if (min === void 0) { min = 0; }
        if (message === void 0) { message = null; }
        return {
            min: min,
            message: message,
        };
    };
    /**
     * A rule indicating that this FormItem has a **Maximum** value
     *
     * @param {number} [max] The maximum value inclusive. Defaults to 1000
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    AntFormRules.Max = function (max, message) {
        if (max === void 0) { max = 1000; }
        if (message === void 0) { message = null; }
        return {
            max: max,
            message: message,
        };
    };
    /**
     * A rule indicating that this FormItem has a **Length** requirement
     *
     * @param {number} [length] The maximum length inclusive. Defaults to 32
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    AntFormRules.Length = function (length, message) {
        if (length === void 0) { length = 32; }
        if (message === void 0) { message = null; }
        return {
            len: length,
            message: message,
        };
    };
    /**
     * A rule indicating that this FormItem is of the **Number** type
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    AntFormRules.Number = function (message) {
        if (message === void 0) { message = null; }
        return {
            type: "number",
            message: message,
        };
    };
    /**
     * A rule indicating that this FormItem is of the **Email** type
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    AntFormRules.Email = function (message) {
        if (message === void 0) { message = null; }
        return {
            type: "email",
            message: message,
        };
    };
    /**
     * A rule indicating that this FormItem is of the **Date** type
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    AntFormRules.Date = function (message) {
        if (message === void 0) { message = null; }
        return {
            type: "date",
            message: message,
        };
    };
    /**
     * A rule indicating that this FormItem is of the **Url** type
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    AntFormRules.Url = function (message) {
        if (message === void 0) { message = null; }
        return {
            type: "date",
            message: message,
        };
    };
    /**
     * A **Custom** rule to for this FormItem
     *
     * @param {(rule, value, callback) => void} [validatorFunc] A custom validation function. Takes in (Rule, CurrentValue, Callback) returning void (i think)
     *
     * **You must call 'callback' (3rd argument) when finished**
     *
     * The callback() function takes an array of Errors, or a boolean
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    AntFormRules.Custom = function (validatorFunc, message) {
        if (message === void 0) { message = null; }
        return {
            validator: validatorFunc,
            message: message,
        };
    };
    return AntFormRules;
}());



/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_es_input_number__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_es_input_number_style_index_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_es_slider__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_es_slider_style_index_js__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_input_TextArea__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_input_TextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_antd_lib_input_TextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_constants_Languages__ = __webpack_require__(80);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};






























 // 'this' binder





// Form
var ActivitySummaryForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    }
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        var _this = _super.call(this, props) || this;
        _this.validateScoreMin = function (rule, value, callback) {
            var currentMin = value;
            var currentMax = _this.props.form.getFieldValue("scoreMax");
            var errorString;
            // Not within [0 - max possible score]
            if (currentMin < 0 || currentMin > _this.props.activityMaxScore) {
                errorString = _this.props.translate("admin.addEditSummary.outOfRangeError")
                    .replace("%min%", 0 + "")
                    .replace("%max%", _this.props.activityMaxScore + "");
                callback(errorString);
            }
            if (currentMin > currentMax) {
                callback(_this.props.translate("admin.addEditSummary.minBiggerError"));
            }
            callback();
        };
        _this.validateScoreMax = function (rule, value, callback) {
            var currentMax = value;
            var currentMin = _this.props.form.getFieldValue("scoreMin");
            var errorString;
            // Not within [0 - max possible score]
            if (currentMax > _this.props.activityMaxScore || currentMax < 0) {
                errorString = _this.props.translate("admin.addEditSummary.outOfRangeError")
                    .replace("%min%", 0 + "")
                    .replace("%max%", _this.props.activityMaxScore + "");
                callback(errorString);
            }
            if (currentMax < currentMin) {
                callback(_this.props.translate("admin.addEditSummary.maxSmallerError"));
            }
            callback();
        };
        return _this;
    }
    class_1.prototype.generateOptionsForSelect = function (keyValues) {
        return keyValues.map(function (keyValue) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { value: keyValue.value, key: keyValue.key, title: keyValue.key }, keyValue.key); });
    };
    class_1.prototype.generateLanguageOptions = function () {
        // Only available languages
        return __WEBPACK_IMPORTED_MODULE_35_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable; })
            .map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { key: "cultureIds" + x.id, value: x.id },
            x.name,
            " (",
            x.code,
            ")"); });
    };
    class_1.prototype.renderTranslations = function () {
        var _this = this;
        if (this.props.currentActivitySummary) {
            var translations = this.props.currentActivitySummary.translations;
            return translations.map(function (translation, index) {
                var id = "translations[" + index + "].text";
                var culture = _this.props.allCultures.find(function (culture) { return culture.id === translation.cultureId; }).code.toLowerCase();
                var translationId = "admin.addEditSummary." + culture;
                return _this.renderStandardFormItem(translationId, id, translation.text, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_34_antd_lib_input_TextArea___default.a, { rows: 4, autoComplete: "off" }), _this.props.selectedCultureId === translation.cultureId);
            });
        }
    };
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }],
            })(inputType)));
        }
    };
    class_1.prototype.renderScoreMinFormItem = function () {
        var translatedLabel = this.props.translate("admin.addEditSummary.formItem2");
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator("scoreMin", {
            initialValue: this.props.currentActivitySummary.scoreMin,
            rules: [
                { required: true, message: this.props.translate('admin.common.requiredRule') },
                { validator: this.validateScoreMin }
            ],
        })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_antd_es_input_number__["a" /* default */], null))));
    };
    class_1.prototype.renderScoreMaxFormItem = function () {
        var translatedLabel = this.props.translate("admin.addEditSummary.formItem3");
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator("scoreMax", {
            initialValue: this.props.currentActivitySummary.scoreMax,
            rules: [
                { required: true, message: this.props.translate('admin.common.requiredRule') },
                { validator: this.validateScoreMax }
            ],
        })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_antd_es_input_number__["a" /* default */], null))));
    };
    class_1.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    this.renderStandardFormItem("admin.addEditSummary.formItem1", "selectedCultureId", this.props.selectedCultureId, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], null, this.generateLanguageOptions())),
                    this.renderTranslations(),
                    this.renderScoreMinFormItem(),
                    this.renderScoreMaxFormItem()))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditActivitySummary = /** @class */ (function (_super) {
    __extends(AddEditActivitySummary, _super);
    function AddEditActivitySummary(props) {
        var _this = _super.call(this, props) || this;
        _this.error = "";
        Object(__WEBPACK_IMPORTED_MODULE_30_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditActivitySummary.prototype);
        var activityId = parseInt(_this.props.match.params.activityId, 10);
        var activitySummaryId = parseInt(_this.props.match.params.activitySummaryId, 10);
        var currentActivitySummary = {
            activitySummaryId: activitySummaryId,
            activityId: activityId,
            scoreMin: 0,
            scoreMax: 0,
            translations: [],
        };
        _this.state = {
            loading: true,
            visible: false,
            isSubmitting: false,
            allCultures: [],
            selectedCultureId: 0,
            currentActivitySummary: currentActivitySummary,
            activityMaxScore: 0,
            allSummaries: [],
            isUpdate: activitySummaryId > 0,
        };
        return _this;
    }
    AddEditActivitySummary.prototype.componentDidMount = function () {
        var _this = this;
        var summariesPromise = __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].getActivitySummaries(this.state.currentActivitySummary.activityId);
        var cultures = __WEBPACK_IMPORTED_MODULE_35_src_constants_Languages__["a" /* default */].All.filter(function (l) { return l.isAvailable; });
        summariesPromise.then(function (result) {
            var summaries = result.data;
            _this.setState({
                allCultures: cultures,
                selectedCultureId: cultures[0].id,
                allSummaries: summaries.items
            }, _this.fillForm);
        });
    };
    AddEditActivitySummary.prototype.fillForm = function () {
        var _this = this;
        if (this.state.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].getActivitySummary(this.state.currentActivitySummary.activitySummaryId).then(function (result) {
                _this.setState({
                    loading: false,
                    currentActivitySummary: __assign(__assign({}, _this.state.currentActivitySummary), result.data),
                    activityMaxScore: result.data.maxScore,
                });
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditSummary.messageRetrieveError'));
            });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].getActivity(this.state.currentActivitySummary.activityId).then(function (result) {
                var translations = _this.state.allCultures.map(function (culture) {
                    var translation = {
                        cultureId: culture.id,
                        text: null
                    };
                    return translation;
                });
                // Initialize new activity form's Maximum Score value as the highest possible score you can get for that activity
                var activitySummary = {
                    translations: translations,
                    scoreMax: result.data.maxScore,
                    maxScore: result.data.maxScore
                };
                _this.setState({
                    currentActivitySummary: __assign(__assign({}, _this.state.currentActivitySummary), activitySummary),
                    activityMaxScore: result.data.maxScore,
                    loading: false,
                });
            });
        }
    };
    AddEditActivitySummary.prototype.translationsAreCompleted = function () {
        var translations = this.state.currentActivitySummary.translations;
        var emptyTranslations = translations.filter(function (translation) {
            return translation.text === null || translation.text === "";
        });
        return emptyTranslations.length === 0;
    };
    /**
     * Ensure that this range does not overlap with any of the existing summaries
     */
    AddEditActivitySummary.prototype.validateRange = function () {
        var currentMin = this.formRef.props.form.getFieldValue("scoreMin");
        var currentMax = this.formRef.props.form.getFieldValue("scoreMax");
        var errorString;
        var sum;
        for (var _i = 0, _a = this.state.allSummaries; _i < _a.length; _i++) {
            sum = _a[_i];
            // Don't compare with same summary (editing existing summary)
            if (sum.activitySummaryId === this.state.currentActivitySummary.activitySummaryId) {
                continue;
            }
            // Overlaps with an existing summary range
            if (this.isOverlapping(currentMin, currentMax, sum.scoreMin, sum.scoreMax)) {
                errorString = this.props.translate("admin.addEditSummary.rangeOverlapError")
                    .replace("$min$", currentMin)
                    .replace("$max$", currentMax)
                    .replace("%min%", sum.scoreMin + "")
                    .replace("%max%", sum.scoreMax + "");
                this.error = errorString;
                return false;
            }
        }
        this.error = "";
        return true;
    };
    AddEditActivitySummary.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        this.validateRange();
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                // If key is the nested property
                if (key === 'translations') {
                    var fieldKey = '';
                    for (var fieldName in field) {
                        if (field.hasOwnProperty(fieldName)) {
                            fieldKey = fieldName;
                            break;
                        }
                    }
                    newState[key] = __spreadArrays(this.state.currentActivitySummary[key]);
                    newState[key][fieldKey].text = field[fieldKey].text.value;
                }
                else if (key === 'selectedCultureId') {
                    this.setState({ selectedCultureId: field.value });
                    return;
                }
                else {
                    newState[key] = field.value;
                }
            }
        }
        this.setState({
            currentActivitySummary: __assign(__assign({}, this.state.currentActivitySummary), newState)
        });
    };
    AddEditActivitySummary.prototype.addActivitySummary = function () {
        var _this = this;
        var addActivitySummaryDTO = {
            translations: this.state.currentActivitySummary.translations,
            activityId: this.state.currentActivitySummary.activityId,
            scoreMin: this.state.currentActivitySummary.scoreMin,
            scoreMax: this.state.currentActivitySummary.scoreMax,
        };
        __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].addActivitySummary(addActivitySummaryDTO)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditSummary.messageAdd'));
            _this.setState({ isSubmitting: false });
            _this.props.history.push(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_SUMMARY, _this.state.currentActivitySummary.activityId, result.data));
            _this.handleRedirect();
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditSummary.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditActivitySummary.prototype.updateActivitySummary = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_33_src_api_ActivityApiController__["a" /* default */].updateActivitySummary(this.state.currentActivitySummary)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditSummary.messageUpdate'));
            _this.setState({ isSubmitting: false });
            _this.props.history.push(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY_SUMMARY, _this.state.currentActivitySummary.activityId, _this.state.currentActivitySummary.activitySummaryId));
            _this.handleRedirect();
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditSummary.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditActivitySummary.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        // Check again to make sure range is valid and don't allow submission if it isn't
        // Need to do this because it's separate from the actual form's validation
        if (!this.validateRange()) {
            return;
        }
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.state.currentActivitySummary.activitySummaryId ? _this.updateActivitySummary() : _this.addActivitySummary();
            }
        });
    };
    /**
    * https://stackoverflow.com/questions/3269434/whats-the-most-efficient-way-to-test-two-integer-ranges-for-overlap
    */
    AddEditActivitySummary.prototype.isOverlapping = function (x1, x2, y1, y2) {
        return Math.max(x1, y1) <= Math.min(x2, y2);
    };
    AddEditActivitySummary.prototype.handleRedirect = function () {
        var redirectUrl = __WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY, this.state.currentActivitySummary.activityId, true);
        this.props.history.push(redirectUrl);
    };
    AddEditActivitySummary.prototype.handleCancel = function (e) {
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_31_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACTIVITY, this.state.currentActivitySummary.activityId));
    };
    AddEditActivitySummary.prototype.renderSaveButton = function () {
        // Allow them to click save if translations are complete and there are no errors
        if (this.translationsAreCompleted() && !this.error) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate("admin.common.saveButton")));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: this.props.translate('admin.addEditSummary.saveTooltip'), arrowPointAtCenter: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", disabled: true }, this.props.translate("admin.common.saveButton"))));
    };
    AddEditActivitySummary.prototype.render = function () {
        var _this = this;
        if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            currentActivitySummary: this.state.currentActivitySummary,
            allCultures: this.state.allCultures,
            selectedCultureId: this.state.selectedCultureId,
            translate: this.props.translate,
            onChange: this.handleInputChange,
            activityMaxScore: this.state.activityMaxScore,
            allSummaries: this.state.allSummaries,
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                !this.state.isUpdate && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.addEditSummary.addHeader" }),
                this.state.isUpdate && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["b" /* Translate */], { id: "admin.addEditSummary.editHeader" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ActivitySummaryForm, __assign({ wrappedComponentRef: function (ref) { return _this.formRef = ref; } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { style: { color: "red" } }, this.error)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                this.renderSaveButton(),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate("common.back"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null)));
    };
    return AddEditActivitySummary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_32_react_localize_redux__["d" /* withLocalize */])(AddEditActivitySummary));


/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_style__ = __webpack_require__(52);


// style dependencies


/***/ }),
/* 2159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_api_ClassroomApiController__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder












var Classrooms = /** @class */ (function (_super) {
    __extends(Classrooms, _super);
    function Classrooms(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, Classrooms.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
        return _this;
    }
    Classrooms.prototype.deleteClassroom = function (classroomId) {
        var ref = this.dataTableRef;
        var translate = this.props.translate;
        __WEBPACK_IMPORTED_MODULE_9_antd_es_modal__["a" /* default */].confirm({
            title: translate('admin.classrooms.confirmDelete'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            onOk: function () {
                var _this = this;
                __WEBPACK_IMPORTED_MODULE_6_src_api_ClassroomApiController__["a" /* default */].deleteClassroom(classroomId).then(function (result) {
                    __WEBPACK_IMPORTED_MODULE_11_antd_es_message__["a" /* default */].success(translate('admin.classrooms.messageDelete'));
                    ref.refresh();
                }).catch(function (e) {
                    __WEBPACK_IMPORTED_MODULE_11_antd_es_message__["a" /* default */].error(_this.props.translate('admin.classrooms.messageDeleteError'));
                });
            },
        });
    };
    Classrooms.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_6_src_api_ClassroomApiController__["a" /* default */].getClassroomTableData(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    Classrooms.prototype.customTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLASSROOM, record.classroomId); };
        var reportLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_REPORT_CLASSROOM, record.classroomId); };
        return [
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.classrooms.columnHeader1', 'classroomName'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.reportColumnHeader', 'report', reportLink, 'download'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: _this.props.translate('admin.common.deleteColumnHeader'), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_button__["a" /* default */], { shape: "circle", icon: "delete", onClick: function () { return _this.deleteClassroom(record.classroomId); } })));
                    }
                }
            }
        ];
    };
    Classrooms.prototype.render = function () {
        var _this = this;
        if (this.state.formRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLASSROOM, push: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.classrooms.tableHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'classroomId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["a" /* DataTableButton */]('admin.classrooms.addButton', function () { _this.setState({ formRedirect: true }); }),
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return Classrooms;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(Classrooms));


/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Users__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_api_ClassroomApiController__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_api_UserApiController__ = __webpack_require__(147);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






















 // 'this' binder





// Form
var ClassroomForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    }
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        return _super.call(this, props) || this;
    }
    class_1.prototype.generateOptionsForSelect = function (keyValues) {
        return keyValues.map(function (keyValue) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_select__["a" /* default */].Option, { value: keyValue.key, key: keyValue.key, title: keyValue.value }, keyValue.value); });
    };
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
            })(inputType)));
        }
    };
    class_1.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    this.renderStandardFormItem("admin.addEditClassroom.formItem1", "classroomName", this.props.currentClassroom.classroomName, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" })),
                    this.renderStandardFormItem("admin.addEditClassroom.formItem2", "selectedTeacherCounselorAdminIds", this.props.currentClassroom.selectedTeacherCounselorAdminIds, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_select__["a" /* default */], { optionFilterProp: "title", mode: "multiple" }, this.generateOptionsForSelect(this.props.teacherCounselorsAtSchool)), this.props.currentClassroom.showTeacherCounselorAdminSelect, false)))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditClassroom = /** @class */ (function (_super) {
    __extends(AddEditClassroom, _super);
    function AddEditClassroom(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_22_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditClassroom.prototype);
        var classroomId = parseInt(_this.props.match.params.id, 10);
        var currentClassroom = {
            classroomId: classroomId,
            classroomName: "",
            showTeacherCounselorAdminSelect: false,
            selectedTeacherCounselorAdminIds: []
        };
        _this.state = {
            loading: true,
            isSubmitting: false,
            shouldRefreshTable: false,
            teacherCounselorsAtSchool: [],
            currentClassroom: currentClassroom
        };
        return _this;
    }
    AddEditClassroom.prototype.componentWillMount = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_27_src_api_UserApiController__["a" /* default */].getTeacherCounselorAdminsForSchool().then(function (result) {
            _this.setState({
                teacherCounselorsAtSchool: result.data
            }, _this.fillForm);
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.common.messageTeacherCounselorAdminsError'));
        });
    };
    AddEditClassroom.prototype.fillForm = function () {
        var _this = this;
        var classroomId = this.state.currentClassroom.classroomId ? this.state.currentClassroom.classroomId : 0;
        __WEBPACK_IMPORTED_MODULE_26_src_api_ClassroomApiController__["a" /* default */].getClassroom(classroomId).then(function (result) {
            _this.setState({
                loading: false,
                currentClassroom: result.data
            });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditClassroom.messageRetrieveError'));
        });
    };
    AddEditClassroom.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                newState[key] = field.value;
            }
        }
        this.setState({
            currentClassroom: __assign(__assign({}, this.state.currentClassroom), newState)
        });
    };
    AddEditClassroom.prototype.addClassroom = function () {
        var _this = this;
        var addClassroomDTO = {
            classroomName: this.state.currentClassroom.classroomName,
            selectedTeacherCounselorAdminIds: this.state.currentClassroom.selectedTeacherCounselorAdminIds
        };
        __WEBPACK_IMPORTED_MODULE_26_src_api_ClassroomApiController__["a" /* default */].addClassroom(addClassroomDTO)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditClassroom.messageAdd'));
            _this.setState({ isSubmitting: false });
            _this.props.history.push(__WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLASSROOM, result.data));
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditClassroom.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditClassroom.prototype.updateClassroom = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_26_src_api_ClassroomApiController__["a" /* default */].updateClassroom(this.state.currentClassroom)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditClassroom.messageUpdate'));
            _this.setState({ isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditClassroom.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditClassroom.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.state.currentClassroom.classroomId ? _this.updateClassroom() : _this.addClassroom();
            }
        });
    };
    AddEditClassroom.prototype.handleCancel = function (e) {
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_23_src_core_Routes__["a" /* default */].ADMIN_CLASSROOMS);
    };
    AddEditClassroom.prototype.updateShouldRefreshTable = function () {
        this.setState({ shouldRefreshTable: !this.state.shouldRefreshTable });
    };
    AddEditClassroom.prototype.renderStudents = function () {
        var classroomUsersProps = {
            classroomId: this.state.currentClassroom.classroomId,
            onlyClassroomUsers: true,
            updateShouldRefreshTable: this.updateShouldRefreshTable,
            shouldRefreshTable: this.state.shouldRefreshTable,
            history: this.props.history,
            location: this.props.location
        };
        var allUsersProps = {
            classroomId: this.state.currentClassroom.classroomId,
            onlyClassroomUsers: false,
            updateShouldRefreshTable: this.updateShouldRefreshTable,
            shouldRefreshTable: this.state.shouldRefreshTable,
            history: this.props.history,
            location: this.props.location
        };
        if (this.state.currentClassroom.classroomId) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__Users__["a" /* default */], __assign({}, classroomUsersProps)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__Users__["a" /* default */], __assign({}, allUsersProps))));
        }
    };
    AddEditClassroom.prototype.render = function () {
        var _this = this;
        if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            currentClassroom: this.state.currentClassroom,
            teacherCounselorsAtSchool: this.state.teacherCounselorsAtSchool,
            translate: this.props.translate,
            onChange: this.handleInputChange
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.state.currentClassroom.classroomId ?
                this.state.currentClassroom.classroomName :
                this.props.translate('admin.addEditClassroom.addHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClassroomForm, __assign({ wrappedComponentRef: function (ref) { return _this.formRef = ref; } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate("admin.common.saveButton")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate("common.back"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            this.renderStudents()));
    };
    return AddEditClassroom;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_24_react_localize_redux__["d" /* withLocalize */])(AddEditClassroom));


/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_api_AcademicApiController__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_modal_style_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder














var AcademicStandards = /** @class */ (function (_super) {
    __extends(AcademicStandards, _super);
    function AcademicStandards(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, AcademicStandards.prototype);
        _this.state = {
            loading: true,
            standardRedirect: false,
            frameworkRedirect: false,
            standards: [],
            frameworks: []
        };
        return _this;
    }
    AcademicStandards.prototype.deleteAcademicStandard = function (academicStandardId) {
        var ref = this.standardDataTableRef;
        var translate = this.props.translate;
        __WEBPACK_IMPORTED_MODULE_11_antd_es_modal__["a" /* default */].confirm({
            title: translate('admin.academics.confirmDelete1'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            onOk: function () {
                var _this = this;
                __WEBPACK_IMPORTED_MODULE_6_src_api_AcademicApiController__["a" /* default */].deleteAcademicStandard(academicStandardId).then(function (result) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].success(translate('admin.academics.messageDelete1'));
                    ref.refresh();
                }).catch(function (e) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].error(_this.props.translate('admin.sideNav.messageDeleteError1'));
                });
            },
        });
    };
    AcademicStandards.prototype.deleteAcademicStandardFramework = function (academicStandardFrameworkId) {
        var frameworkRef = this.frameworkDataTableRef;
        var standardRef = this.standardDataTableRef;
        var translate = this.props.translate;
        __WEBPACK_IMPORTED_MODULE_11_antd_es_modal__["a" /* default */].confirm({
            title: translate('admin.academics.confirmDelete2'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            content: translate('admin.academics.confirmContent'),
            onOk: function () {
                var _this = this;
                __WEBPACK_IMPORTED_MODULE_6_src_api_AcademicApiController__["a" /* default */].deleteAcademicStandardFramework(academicStandardFrameworkId).then(function (result) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].success(translate('admin.academics.messageDelete2'));
                    frameworkRef.refresh();
                    standardRef.refresh();
                }).catch(function (e) {
                    __WEBPACK_IMPORTED_MODULE_7_antd_es_message__["a" /* default */].error(_this.props.translate('admin.sideNav.messageDeleteError2'));
                });
            },
        });
    };
    AcademicStandards.prototype.fetchStandards = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_6_src_api_AcademicApiController__["a" /* default */].getAcademicStandardsForDatatable(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                standards: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    AcademicStandards.prototype.fetchFrameworks = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_6_src_api_AcademicApiController__["a" /* default */].getAcademicStandardFrameworksForDatatable(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                frameworks: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    AcademicStandards.prototype.standardTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACADEMIC_STANDARD, record.academicStandardId); };
        return [
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.academics.columnHeader1', 'standard'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.academics.columnHeader2', 'framework'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: _this.props.translate('admin.common.deleteColumnHeader'), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: "delete", onClick: function () { return _this.deleteAcademicStandard(record.academicStandardId); } })));
                    }
                }
            }
        ];
    };
    AcademicStandards.prototype.frameworkTableColumns = function () {
        var _this = this;
        var editLink = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACADEMIC_STANDARD_FRAMEWORK, record.academicStandardFrameworkId); };
        return [
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('admin.academics.columnHeader2', 'framework'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: _this.props.translate('admin.common.deleteColumnHeader'), arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_button__["a" /* default */], { shape: "circle", icon: "delete", onClick: function () { return _this.deleteAcademicStandardFramework(record.academicStandardFrameworkId); } })));
                    }
                }
            }
        ];
    };
    AcademicStandards.prototype.renderAcademicStandardsDataTable = function () {
        var _this = this;
        if (this.state.frameworks.length > 0) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.academics.tableHeader1')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.standardDataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'academicStandardId', loading: this.state.loading }, columns: this.standardTableColumns(), data: this.state.standards, fetchData: this.fetchStandards, buttonBar: [
                        new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["a" /* DataTableButton */]('admin.academics.addButton1', function () { _this.setState({ standardRedirect: true }); }),
                        new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                    ] }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_divider__["a" /* default */], { type: "horizontal" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null)));
        }
    };
    AcademicStandards.prototype.render = function () {
        var _this = this;
        if (this.state.standardRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACADEMIC_STANDARD, push: true });
        }
        else if (this.state.frameworkRedirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_ACADEMIC_STANDARD_FRAMEWORK, push: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            this.renderAcademicStandardsDataTable(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.academics.tableHeader2')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.frameworkDataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'academicStandardFrameworkId', loading: this.state.loading }, columns: this.frameworkTableColumns(), data: this.state.frameworks, fetchData: this.fetchFrameworks, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["a" /* DataTableButton */]('admin.academics.addButton2', function () { _this.setState({ frameworkRedirect: true }); }),
                    new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return AcademicStandards;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(AcademicStandards));


/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_api_AcademicApiController__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_api_StatementApiController__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_api_GameApiController__ = __webpack_require__(2164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_utils_ArrayUtil__ = __webpack_require__(282);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

























 // 'this' binder







// Form
var AcademicStandardForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    }
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        return _super.call(this, props) || this;
    }
    class_1.prototype.generateOptionsForSelect = function (keyValues) {
        return keyValues.map(function (keyValue) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { value: keyValue.value, key: keyValue.key, title: keyValue.key }, keyValue.key); });
    };
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
            })(inputType)));
        }
    };
    class_1.prototype.generateStatementOptions = function (statements) {
        return __WEBPACK_IMPORTED_MODULE_32_src_utils_ArrayUtil__["a" /* default */].Unique(statements.map(function (x) { return x.statementType; })) // Get the types (State/District/School/Generic)
            .map(function (statementType) { return ({ key: statementType, values: statements.filter(function (x) { return x.statementType === statementType; }) }); }) // Split based on Type
            .map(function (x) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].OptGroup, { label: x.key }, x.values.map(function (y) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */].Option, { value: y.statementId, key: y.statementText, title: y.statementText }, y.statementText); }))); });
    };
    class_1.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" },
                    this.renderStandardFormItem("admin.addEditAcademicStandard.formItem1", "standard", this.props.currentAcademicStandard.standard, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" })),
                    this.renderStandardFormItem("admin.addEditAcademicStandard.formItem2", "description", this.props.currentAcademicStandard.description, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" })),
                    this.renderStandardFormItem("admin.addEditAcademicStandard.formItem3", "academicStandardFrameworkId", this.props.currentAcademicStandard.academicStandardFrameworkId, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], null, this.generateOptionsForSelect(this.props.allFrameworks))),
                    this.renderStandardFormItem("admin.addEditAcademicStandard.formItem4", "activityIds", this.props.currentAcademicStandard.activityIds, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], { optionFilterProp: "title", mode: "multiple" }, this.generateOptionsForSelect(this.props.allActivities)), true, false),
                    this.renderStandardFormItem("admin.addEditAcademicStandard.formItem5", "gameIds", this.props.currentAcademicStandard.gameIds, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], { optionFilterProp: "title", mode: "multiple" }, this.generateOptionsForSelect(this.props.allGames)), true, false),
                    this.renderStandardFormItem("admin.addEditAcademicStandard.formItem6", "statementIds", this.props.currentAcademicStandard.statementIds, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_select__["a" /* default */], { optionFilterProp: "title", mode: "multiple" }, this.generateStatementOptions(this.props.allStatements)), true, false)))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditAcademicStandard = /** @class */ (function (_super) {
    __extends(AddEditAcademicStandard, _super);
    function AddEditAcademicStandard(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_25_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditAcademicStandard.prototype);
        var academicStandardId = parseInt(_this.props.match.params.id, 10);
        var currentAcademicStandard = {
            academicStandardId: academicStandardId,
            academicStandardFrameworkId: null,
            standard: "",
            description: "",
            activityIds: [],
            gameIds: [],
            statementIds: []
        };
        _this.state = {
            loading: true,
            isSubmitting: false,
            redirect: false,
            allActivities: [],
            allGames: [],
            allStatements: [],
            allFrameworks: [],
            currentAcademicStandard: currentAcademicStandard
        };
        return _this;
    }
    AddEditAcademicStandard.prototype.componentWillMount = function () {
        var _this = this;
        var activitiesPromise = __WEBPACK_IMPORTED_MODULE_31_src_api_ActivityApiController__["a" /* default */].getActivitiesForAcademicStandard();
        var gamesPromise = __WEBPACK_IMPORTED_MODULE_30_src_api_GameApiController__["a" /* default */].getGamesForAcademicStandard();
        var statementsPromise = __WEBPACK_IMPORTED_MODULE_29_src_api_StatementApiController__["a" /* default */].getStatementsForAcademicStandard();
        var frameworksPromise = __WEBPACK_IMPORTED_MODULE_28_src_api_AcademicApiController__["a" /* default */].getAcademicStandardFrameworksForAcademicStandard();
        Promise.all([activitiesPromise, gamesPromise, statementsPromise, frameworksPromise]).then(function (results) {
            var activities = results[0].data.keyValues;
            var games = results[1].data.keyValues;
            var statements = results[2].data;
            var frameworks = results[3].data.keyValues;
            _this.setState({
                allActivities: activities,
                allGames: games,
                allStatements: statements,
                allFrameworks: frameworks
            }, _this.fillForm);
        });
    };
    AddEditAcademicStandard.prototype.fillForm = function () {
        var _this = this;
        if (this.state.currentAcademicStandard.academicStandardId) {
            __WEBPACK_IMPORTED_MODULE_28_src_api_AcademicApiController__["a" /* default */].getAcademicStandard(this.state.currentAcademicStandard.academicStandardId).then(function (result) {
                _this.setState({
                    loading: false,
                    currentAcademicStandard: result.data
                });
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditAcademicStandard.messageRetrieveError'));
            });
        }
        else {
            this.setState({
                loading: false
            });
        }
    };
    AddEditAcademicStandard.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                newState[key] = field.value;
            }
        }
        this.setState({
            currentAcademicStandard: __assign(__assign({}, this.state.currentAcademicStandard), newState)
        });
    };
    AddEditAcademicStandard.prototype.addAcademicStandard = function () {
        var _this = this;
        var addAcademicStandardDTO = {
            academicStandardFrameworkId: this.state.currentAcademicStandard.academicStandardFrameworkId,
            standard: this.state.currentAcademicStandard.standard,
            description: this.state.currentAcademicStandard.description,
            activityIds: this.state.currentAcademicStandard.activityIds,
            gameIds: this.state.currentAcademicStandard.gameIds,
            statementIds: this.state.currentAcademicStandard.statementIds
        };
        __WEBPACK_IMPORTED_MODULE_28_src_api_AcademicApiController__["a" /* default */].addAcademicStandard(addAcademicStandardDTO)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditAcademicStandard.messageAdd'));
            _this.setState({ redirect: true, isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditAcademicStandard.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditAcademicStandard.prototype.updateAcademicStandard = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_28_src_api_AcademicApiController__["a" /* default */].updateAcademicStandard(this.state.currentAcademicStandard)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditAcademicStandard.messageUpdate'));
            _this.setState({ redirect: true, isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditAcademicStandard.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditAcademicStandard.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.state.currentAcademicStandard.academicStandardId ? _this.updateAcademicStandard() : _this.addAcademicStandard();
            }
        });
    };
    AddEditAcademicStandard.prototype.handleCancel = function (e) {
        this.setState({ redirect: true });
    };
    AddEditAcademicStandard.prototype.render = function () {
        var _this = this;
        if (this.state.redirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__["a" /* default */].ADMIN_ACADEMICS, push: true });
        }
        else if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            allActivities: this.state.allActivities,
            allGames: this.state.allGames,
            allStatements: this.state.allStatements,
            allFrameworks: this.state.allFrameworks,
            currentAcademicStandard: this.state.currentAcademicStandard,
            translate: this.props.translate,
            onChange: this.handleInputChange
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.addEditAcademicStandard.addHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AcademicStandardForm, __assign({ wrappedComponentRef: function (ref) { return _this.formRef = ref; } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate("admin.common.saveButton")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate("common.back")))));
    };
    return AddEditAcademicStandard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_27_react_localize_redux__["d" /* withLocalize */])(AddEditAcademicStandard));


/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GameApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var GameApiController = /** @class */ (function () {
    function GameApiController() {
        // post: Game/GetGamesForAcademicStandard
        this.RouteGetGamesForAcademicStandard = function () { return "Game/GetGamesForAcademicStandard"; };
    }
    GameApiController.prototype.getGamesForAcademicStandard = function (requestOptions) {
        var url = this.RouteGetGamesForAcademicStandard();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'post', url, requestOptions);
    };
    return GameApiController;
}());

var service = new GameApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_api_AcademicApiController__ = __webpack_require__(508);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

























 // 'this' binder



// Form
var AcademicStandardFrameworkForm = __WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    }
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        return _super.call(this, props) || this;
    }
    class_1.prototype.renderStandardFormItem = function (translationId, id, initialValue, inputType, visible, required) {
        if (visible === void 0) { visible = true; }
        if (required === void 0) { required = true; }
        var translatedLabel = this.props.translate(translationId);
        if (visible) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, { label: translatedLabel }, this.props.form.getFieldDecorator(id, {
                initialValue: initialValue,
                rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
            })(inputType)));
        }
    };
    class_1.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { className: "admin-form" }, this.renderStandardFormItem("admin.addEditAcademicStandardFramework.formItem1", "framework", this.props.currentAcademicStandardFramework.framework, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { autoComplete: "off" }))))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var AddEditAcademicStandardFramework = /** @class */ (function (_super) {
    __extends(AddEditAcademicStandardFramework, _super);
    function AddEditAcademicStandardFramework(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_25_src_utils_BindThisHelper__["a" /* default */])(_this, AddEditAcademicStandardFramework.prototype);
        var academicStandardFrameworkId = parseInt(_this.props.match.params.id, 10);
        var currentAcademicStandardFramework = {
            academicStandardFrameworkId: academicStandardFrameworkId,
            framework: ""
        };
        _this.state = {
            loading: true,
            redirect: false,
            isSubmitting: false,
            currentAcademicStandardFramework: currentAcademicStandardFramework
        };
        return _this;
    }
    AddEditAcademicStandardFramework.prototype.componentWillMount = function () {
        this.fillForm();
    };
    AddEditAcademicStandardFramework.prototype.fillForm = function () {
        var _this = this;
        if (this.state.currentAcademicStandardFramework.academicStandardFrameworkId) {
            __WEBPACK_IMPORTED_MODULE_28_src_api_AcademicApiController__["a" /* default */].getAcademicStandardFramework(this.state.currentAcademicStandardFramework.academicStandardFrameworkId).then(function (result) {
                _this.setState({
                    loading: false,
                    currentAcademicStandardFramework: result.data
                });
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditAcademicStandardFramework.messageRetrieveError'));
            });
        }
        else {
            this.setState({
                loading: false
            });
        }
    };
    AddEditAcademicStandardFramework.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                newState[key] = field.value;
            }
        }
        this.setState({
            currentAcademicStandardFramework: __assign(__assign({}, this.state.currentAcademicStandardFramework), newState)
        });
    };
    AddEditAcademicStandardFramework.prototype.addAcademicStandardFramework = function () {
        var _this = this;
        var addAcademicStandardFrameworkDTO = {
            framework: this.state.currentAcademicStandardFramework.framework
        };
        __WEBPACK_IMPORTED_MODULE_28_src_api_AcademicApiController__["a" /* default */].addAcademicStandardFramework(addAcademicStandardFrameworkDTO)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditAcademicStandardFramework.messageAdd'));
            _this.setState({ redirect: true, isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditAcademicStandardFramework.messageAddError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditAcademicStandardFramework.prototype.updateAcademicStandardFramework = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_28_src_api_AcademicApiController__["a" /* default */].updateAcademicStandardFramework(this.state.currentAcademicStandardFramework)
            .then(function (result) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('admin.addEditAcademicStandardFramework.messageUpdate'));
            _this.setState({ redirect: true, isSubmitting: false });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditAcademicStandardFramework.messageUpdateError'));
            _this.setState({ isSubmitting: false });
        });
    };
    AddEditAcademicStandardFramework.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                _this.state.currentAcademicStandardFramework.academicStandardFrameworkId ? _this.updateAcademicStandardFramework() : _this.addAcademicStandardFramework();
            }
        });
    };
    AddEditAcademicStandardFramework.prototype.handleCancel = function (e) {
        this.setState({ redirect: true });
    };
    AddEditAcademicStandardFramework.prototype.saveFormRef = function (formRef) {
        this.formRef = formRef;
    };
    AddEditAcademicStandardFramework.prototype.render = function () {
        if (this.state.redirect) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__["a" /* default */].ADMIN_ACADEMICS, push: true });
        }
        else if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], null);
        }
        var formProps = {
            currentAcademicStandardFramework: this.state.currentAcademicStandardFramework,
            translate: this.props.translate,
            onChange: this.handleInputChange
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.addEditAcademicStandardFramework.addHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AcademicStandardFrameworkForm, __assign({ wrappedComponentRef: this.saveFormRef }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate("admin.common.saveButton")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate("common.back")))));
    };
    return AddEditAcademicStandardFramework;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_27_react_localize_redux__["d" /* withLocalize */])(AddEditAcademicStandardFramework));


/***/ }),
/* 2166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_api_UserApiController__ = __webpack_require__(147);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



















 // 'this' binder



// Form
var ResetPasswordForm = __WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].create({
    onFieldsChange: function (props, changedFields) {
        props.onChange(changedFields);
    }
})(/** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        var _this = _super.call(this, props) || this;
        _this.compareToFirstPassword = function (rule, value, callback) {
            if (value && value !== _this.props.form.getFieldValue('newPassword')) {
                callback(_this.props.translate('account.resetPassword.saveTooltip').toString());
            }
            else {
                callback();
            }
        };
        _this.validateToNextPassword = function (rule, value, callback) {
            if (_this.props.form.getFieldValue('confirmPassword')) {
                _this.props.form.validateFields(['confirmPassword'], { force: true }, function (errors, values) { return console.log('Revalidating'); });
            }
            callback();
        };
        return _this;
    }
    class_1.prototype.render = function () {
        var formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 5 },
        };
        var passwordMinLength = 8;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, __assign({}, formItemLayout, { label: this.props.translate('account.resetPassword.formItem1') }), this.props.form.getFieldDecorator('newPassword', {
                initialValue: this.props.currentResetPassword.newPassword,
                rules: [
                    { required: true, message: this.props.translate('admin.common.requiredRule') },
                    { min: passwordMinLength, message: this.props.translate("admin.common.minLengthRule").toString() + passwordMinLength },
                    { validator: this.validateToNextPassword }
                ]
            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_input__["a" /* default */], { autoComplete: "off", type: "password" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, __assign({}, formItemLayout, { label: this.props.translate('account.resetPassword.formItem2') }), this.props.form.getFieldDecorator('confirmPassword', {
                initialValue: this.props.currentResetPassword.confirmPassword,
                rules: [
                    { required: true, message: this.props.translate('admin.common.requiredRule') },
                    { validator: this.compareToFirstPassword }
                ]
            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_input__["a" /* default */], { autoComplete: "off", type: "password" })))));
    };
    return class_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));
var ResetPassword = /** @class */ (function (_super) {
    __extends(ResetPassword, _super);
    function ResetPassword(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_19_src_utils_BindThisHelper__["a" /* default */])(_this, ResetPassword.prototype);
        var userId = parseInt(_this.props.match.params.userId, 10);
        _this.state = {
            isSubmitting: false,
            currentResetPassword: {
                userId: userId,
                newPassword: "",
                confirmPassword: ""
            }
        };
        return _this;
    }
    ResetPassword.prototype.handleInputChange = function (changedFields) {
        var newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                var field = changedFields[key];
                newState[key] = field.value;
            }
        }
        this.setState({
            currentResetPassword: __assign(__assign({}, this.state.currentResetPassword), newState)
        });
    };
    ResetPassword.prototype.handleRedirect = function () {
        var classroomId = parseInt(this.props.match.params.classroomId, 10);
        var isAdmin = this.props.match.params.isAdmin === 'true' ? true : false;
        var redirectUrl = classroomId ?
            __WEBPACK_IMPORTED_MODULE_20_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_20_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLASSROOM, classroomId) :
            __WEBPACK_IMPORTED_MODULE_20_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_20_src_core_Routes__["a" /* default */].ADMIN_USERS, isAdmin);
        this.props.history.push(redirectUrl);
    };
    ResetPassword.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.formRef.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({ isSubmitting: true });
                __WEBPACK_IMPORTED_MODULE_22_src_api_UserApiController__["a" /* default */].adminPasswordReset(_this.state.currentResetPassword).then(function (result) {
                    __WEBPACK_IMPORTED_MODULE_11_antd_es_message__["a" /* default */].success(_this.props.translate('account.resetPassword.messageReset'));
                    _this.setState({ isSubmitting: false });
                    _this.handleRedirect();
                }).catch(function (e) {
                    __WEBPACK_IMPORTED_MODULE_11_antd_es_message__["a" /* default */].error(_this.props.translate('account.resetPassword.messageResetError'));
                    _this.setState({ isSubmitting: false });
                });
            }
        });
    };
    ResetPassword.prototype.render = function () {
        var _this = this;
        var formProps = {
            currentResetPassword: this.state.currentResetPassword,
            translate: this.props.translate,
            onChange: this.handleInputChange
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('account.resetPassword.header')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ResetPasswordForm, __assign({ wrappedComponentRef: function (ref) { return _this.formRef = ref; } }, formProps)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_button__["a" /* default */], { type: "primary", onClick: this.handleSubmit, loading: this.state.isSubmitting }, this.props.translate('account.resetPassword.button1')),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_button__["a" /* default */], { onClick: this.handleRedirect }, this.props.translate('account.resetPassword.button2')))));
    };
    return ResetPassword;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_react_localize_redux__["d" /* withLocalize */])(ResetPassword));


/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_admin_AdminReport__ = __webpack_require__(2168);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var AdminReports = /** @class */ (function (_super) {
    __extends(AdminReports, _super);
    function AdminReports(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, AdminReports.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    AdminReports.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_admin_AdminReport__["a" /* default */], null));
    };
    return AdminReports;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AdminReports);


/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_date_picker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_date_picker_style_index_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_ReportApiController__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_DownloadUtil__ = __webpack_require__(281);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















 // 'this' binder



var AdminReport = /** @class */ (function (_super) {
    __extends(AdminReport, _super);
    function AdminReport(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_15_src_utils_BindThisHelper__["a" /* default */])(_this, AdminReport.prototype);
        _this.state = {
            isSubmitting: false,
            countries: [],
            states: [],
            districts: [],
            schools: [],
            selectedCountryIds: [],
            selectedStateIds: [],
            selectedDistrictIds: []
        };
        return _this;
    }
    AdminReport.prototype.componentDidMount = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_17__api_ReportApiController__["a" /* default */].getCountryHavingStates().then(function (response) {
            _this.setState({ countries: response.data });
        });
        this.populateFiltersByCountryIds([]);
    };
    AdminReport.prototype.populateFiltersByCountryIds = function (countryIds) {
        var _this = this;
        var dto = { listOfInts: countryIds };
        __WEBPACK_IMPORTED_MODULE_17__api_ReportApiController__["a" /* default */].filterByCountries(dto).then(function (response) {
            _this.setState({
                selectedCountryIds: countryIds,
                states: response.data.states,
                districts: response.data.districts,
                schools: response.data.schools
            });
        });
    };
    AdminReport.prototype.populateFiltersByStateIds = function (stateIds) {
        var _this = this;
        if (stateIds.length === 0) {
            this.populateFiltersByCountryIds(this.state.selectedCountryIds);
            return;
        }
        var dto = { listOfInts: stateIds };
        __WEBPACK_IMPORTED_MODULE_17__api_ReportApiController__["a" /* default */].filterByStates(dto).then(function (response) {
            _this.setState({
                selectedStateIds: stateIds,
                districts: response.data.districts,
                schools: response.data.schools
            });
        });
    };
    AdminReport.prototype.populateFiltersByDistrictIds = function (districtIds) {
        var _this = this;
        if (districtIds.length === 0) {
            this.populateFiltersByStateIds(this.state.selectedStateIds);
            return;
        }
        var dto = { listOfInts: districtIds };
        __WEBPACK_IMPORTED_MODULE_17__api_ReportApiController__["a" /* default */].filterByDistricts(dto).then(function (response) {
            _this.setState({
                selectedDistrictIds: districtIds,
                schools: response.data
            });
        });
    };
    AdminReport.prototype.countriesChange = function (e) {
        var selectedCountryIds = e;
        this.populateFiltersByCountryIds(selectedCountryIds);
    };
    AdminReport.prototype.statesChange = function (e) {
        var selectedStateIds = e;
        this.populateFiltersByStateIds(selectedStateIds);
    };
    AdminReport.prototype.districtsChage = function (e) {
        var selectedDistrictIds = e;
        this.populateFiltersByDistrictIds(selectedDistrictIds);
    };
    AdminReport.prototype.submit = function (e) {
        var _this = this;
        e.preventDefault();
        // Make sure all fields are valid
        this.props.form.validateFields(function (errors, values) {
            // Loading for finish button
            _this.setState({
                isSubmitting: !errors
            });
            __WEBPACK_IMPORTED_MODULE_17__api_ReportApiController__["a" /* default */].getAdminReport(values).then(function (response) {
                Object(__WEBPACK_IMPORTED_MODULE_18__utils_DownloadUtil__["a" /* downloadFile */])(response.data.data, _this.props.translate("report.admin.fileName").toString(), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                _this.setState({
                    isSubmitting: false
                });
            });
        });
    };
    AdminReport.prototype.disabledStartDate = function (current) {
        var endDate = this.props.form.getFieldValue("toCreationDate");
        if (!current || !endDate) {
            return false;
        }
        return current.valueOf() >= endDate.valueOf();
    };
    AdminReport.prototype.disabledEndDate = function (current) {
        var startDate = this.props.form.getFieldValue("fromCreationDate");
        if (!current || !startDate) {
            return false;
        }
        return current.valueOf() <= startDate.valueOf();
    };
    AdminReport.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */], { layout: "vertical", onSubmit: this.submit },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: this.props.translate("report.admin.roleFilter.label").toString() }, this.props.form.getFieldDecorator("roleIds")(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */], { mode: "multiple", placeholder: this.props.translate("report.admin.roleFilter.placeholder").toString() },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { value: 1 }, this.props.translate("report.admin.roleFilter.KuderAdmin")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { value: 2 }, this.props.translate("report.admin.roleFilter.StateAdmin")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { value: 3 }, this.props.translate("report.admin.roleFilter.DistrictAdmin")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { value: 4 }, this.props.translate("report.admin.roleFilter.SchoolAdmin")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { value: 5 }, this.props.translate("report.admin.roleFilter.TeacherCounselorAdmin"))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_row__["a" /* default */], { gutter: 20 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_col__["a" /* default */], { span: 12 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: this.props.translate("common.from").toString() }, this.props.form.getFieldDecorator("fromCreationDate")(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_date_picker__["a" /* default */], { disabledDate: this.disabledStartDate })))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_col__["a" /* default */], { span: 12 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: this.props.translate("common.to").toString() }, this.props.form.getFieldDecorator("toCreationDate")(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_date_picker__["a" /* default */], { disabledDate: this.disabledEndDate }))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_row__["a" /* default */], { gutter: 20 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_col__["a" /* default */], { span: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: this.props.translate("report.admin.countryFilter.label").toString() }, this.props.form.getFieldDecorator("countryIds")(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */], { filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, onChange: this.countriesChange, mode: "multiple", placeholder: this.props.translate("report.admin.countryFilter.placeholder").toString() }, this.state.countries &&
                        this.state.countries.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { key: x.key.toString(), value: x.key, title: x.value }, x.value); }))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_col__["a" /* default */], { span: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: this.props.translate("report.admin.stateFilter.label").toString() }, this.props.form.getFieldDecorator("stateIds")(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */], { filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, mode: "multiple", onChange: this.statesChange, placeholder: this.props.translate("report.admin.stateFilter.placeholder").toString() }, this.state.states &&
                        this.state.states.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { key: x.key.toString(), value: x.key, title: x.value },
                            " ",
                            x.value); }))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_col__["a" /* default */], { span: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: this.props.translate("report.admin.districtFilter.label").toString() }, this.props.form.getFieldDecorator("districtIds")(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */], { filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, onChange: this.districtsChage, mode: "multiple", placeholder: this.props.translate("report.admin.districtFilter.placeholder").toString() }, this.state.districts &&
                        this.state.districts.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { key: x.key.toString(), value: x.key, title: x.value }, x.value); }))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_col__["a" /* default */], { span: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: this.props.translate("report.admin.schoolFilter.label").toString() }, this.props.form.getFieldDecorator("schoolIds")(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */], { filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, mode: "multiple", placeholder: this.props.translate("report.admin.schoolFilter.placeholder").toString() }, this.state.schools &&
                        this.state.schools.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { key: x.key.toString(), value: x.key, title: x.value }, x.value); })))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_button__["a" /* default */], { type: "primary", icon: "download", loading: this.state.isSubmitting, htmlType: "submit" }, "Download Report"));
    };
    return AdminReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].create()(AdminReport)));


/***/ }),
/* 2169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_common_ReportHeader__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_ReportApiController__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdminReports_less__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdminReports_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AdminReports_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_icon_style_index_js__ = __webpack_require__(54);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder






var StudentActivityDetailReport = /** @class */ (function (_super) {
    __extends(StudentActivityDetailReport, _super);
    // private pageSize: number = 7;
    function StudentActivityDetailReport(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, StudentActivityDetailReport.prototype);
        _this.state = {
            isLoading: false,
            filterParams: null
        };
        return _this;
    }
    StudentActivityDetailReport.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        // Add custom filtering into the request
        requestState.filterData = this.state.filterParams;
        // Debug, change the page size manually
        // console.warn("Setting page size", { prev: requestState.pageLength, curr: this.pageSize }); // JB - Remove this console.warn
        // requestState.pageLength = this.pageSize;
        // Dev Note: We can do Object.keys() as a shortcut because we are using NameOf for the columns which is tied to the backend models
        // requestState.filters = Object.keys(this.state.filterParams).map(key => ({ columnProp: key, filter: this.state.filterParams[key] as string }));
        // Show nothing in datatable if there are no filters, represented as {} from the reset function
        if (this.state.filterParams == null) {
            // Clear out the datatable as the clear button ends up here as well
            callback({ results: [], filteredCount: 0 });
            return;
        }
        this.setState({ isLoading: true });
        __WEBPACK_IMPORTED_MODULE_5_src_api_ReportApiController__["a" /* default */].getStudentActivityReport(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            _this.setState({
                isLoading: false
            });
            callback(results.data);
        });
    };
    StudentActivityDetailReport.prototype.handleOnReset = function () {
        var _this = this;
        this.setState({ filterParams: null }, function () { return _this.standardDataTableRef.refresh(); });
    };
    StudentActivityDetailReport.prototype.handleOnSubmit = function (filterParams) {
        var _this = this;
        this.setState({ filterParams: filterParams }, function () { return _this.standardDataTableRef.refresh(); });
    };
    StudentActivityDetailReport.prototype.customTableColumns = function () {
        var columns = [
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.firstName' }), "firstName"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.lastName' }), "lastName"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].BetterColumns.Custom(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.currentGrade' }), "currentGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: function (a, b) { return a.currentGradeId - b.currentGradeId; }
            }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].BetterColumns.Custom(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.activityGrade' }), "activityGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: function (a, b) { return a.activityGradeId - b.activityGradeId; }
            }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.planet' }), "activityPlanetName"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.activityType' }), "activityType"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.activity' }), "activityName"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Date(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.completedDate' }), "completedDate")
        ];
        return columns;
    };
    StudentActivityDetailReport.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "admin-report student-activity-detail-report" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.activityDetailReport" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Activity Detail Report provides quick access to review the surveys and quizzes completed by students in your school. Choose one of the activities (Survey/Quiz), Reporting period and Grades to view the results."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Report period is setup to use school years. School years start on August 1st and end on July 31st."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_icon__["a" /* default */], { className: "info-icon", type: "info-circle" }),
                " Click these icons for additional information."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_src_components_common_ReportHeader__["a" /* default */], { reportingEvent: "Activity", defaultSchoolYears: "Previous 2", isLoading: false, onSubmit: this.handleOnSubmit, onReset: this.handleOnReset }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.standardDataTableRef = ref; }, serverSide: true, tableProps: {
                    // UserId is not unique
                    // rowKey: NameOf<StudentActivityReportDTO>("userId"),
                    loading: this.state.isLoading,
                    pagination: {
                        defaultPageSize: 100,
                        showTotal: __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].StandardTotalsRenderer,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "25", "100", "9999"],
                    }
                }, columns: this.customTableColumns(), data: [], fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["b" /* DataTableButtonExport */]("Activity Detail Report")
                ] })));
    };
    return StudentActivityDetailReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StudentActivityDetailReport);


/***/ }),
/* 2170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_date_picker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_date_picker_style_index_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_utils_ObjectUtil__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LetterRangeSelector_less__ = __webpack_require__(2172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LetterRangeSelector_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__LetterRangeSelector_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};







 // 'this' binder


var LetterRangeSelector = /** @class */ (function (_super) {
    __extends(LetterRangeSelector, _super);
    function LetterRangeSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.defaults = {
            placeholder: { lower: "Start", upper: "End" },
            renderMode: "Disabled",
            disabled: false
        };
        Object(__WEBPACK_IMPORTED_MODULE_7_src_utils_BindThisHelper__["a" /* default */])(_this, LetterRangeSelector.prototype);
        return _this;
    }
    LetterRangeSelector.prototype.getProps = function (props) {
        if (props === void 0) { props = this.props; }
        return __WEBPACK_IMPORTED_MODULE_8_src_utils_ObjectUtil__["a" /* default */].DeepMergeObjects(this.defaults, props);
    };
    LetterRangeSelector.prototype.handleLeftOnChange = function (e) {
        var lower = e === null || e === void 0 ? void 0 : e.toString();
        var upper = this.props.value.upper;
        this.setState({ lower: lower });
        if (this.props.onChange) {
            this.props.onChange({ lower: lower, upper: upper });
        }
    };
    LetterRangeSelector.prototype.handleRightOnChange = function (e) {
        var upper = e === null || e === void 0 ? void 0 : e.toString();
        var lower = this.props.value.lower;
        this.setState({ upper: upper });
        if (this.props.onChange) {
            this.props.onChange({ lower: lower, upper: upper });
        }
    };
    LetterRangeSelector.prototype.renderLowerSelectOptions = function () {
        var _a, _b;
        var props = this.getProps();
        // let lowerCharCode = this.props.limits?.lower?.charCodeAt(0) || "A".charCodeAt(0);
        // let upperCharCode = this.props.limits?.upper?.charCodeAt(0) || "Z".charCodeAt(0);
        var lowerCharCode = "A".charCodeAt(0);
        var upperCharCode = "Z".charCodeAt(0);
        // Limit based on other selection
        var limit = Math.min(upperCharCode, ((_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.upper) === null || _b === void 0 ? void 0 : _b.charCodeAt(0)) || upperCharCode);
        var charCodes = Array.from(Array(upperCharCode - lowerCharCode + 1).keys()).map(function (x) { return x + lowerCharCode; });
        if (props.renderMode === "Hidden") {
            charCodes = charCodes.map(function (x) { return x <= limit ? x : null; }).filter(function (x) { return x; });
        }
        return charCodes.map(function (x) {
            var letter = String.fromCharCode(x);
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_select__["a" /* default */].Option, { key: x, disabled: limit < x, value: letter }, letter);
        });
    };
    LetterRangeSelector.prototype.renderRightSelectOptions = function () {
        var _a, _b;
        var props = this.getProps();
        var lowerCharCode = "A".charCodeAt(0);
        var upperCharCode = "Z".charCodeAt(0);
        // Limit based on other selection
        var limit = Math.max(lowerCharCode, ((_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.lower) === null || _b === void 0 ? void 0 : _b.charCodeAt(0)) || lowerCharCode);
        var charCodes = Array.from(Array(upperCharCode - lowerCharCode + 1).keys()).map(function (x) { return x + lowerCharCode; });
        if (props.renderMode === "Hidden") {
            charCodes = charCodes.map(function (x) { return x >= limit ? x : null; }).filter(function (x) { return x; });
        }
        return charCodes.map(function (x) {
            var letter = String.fromCharCode(x);
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_select__["a" /* default */].Option, { key: x, disabled: limit > x, value: letter }, letter);
        });
    };
    LetterRangeSelector.prototype.render = function () {
        // Details on the showAction for the selects: https://github.com/ant-design/ant-design/issues/6873#issuecomment-439392727
        var _a = this.getProps(), value = _a.value, defaultValue = _a.defaultValue, disabled = _a.disabled, placeholder = _a.placeholder;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "letter-range-selector" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_input__["a" /* default */].Group, { compact: true },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_select__["a" /* default */], __assign({ className: "left-box", defaultValue: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.lower, value: (value === null || value === void 0 ? void 0 : value.lower) || undefined, placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.lower, disabled: disabled, showSearch: true, showArrow: false, allowClear: true, onChange: this.handleLeftOnChange }, { showAction: ["focus", "click"] }), this.renderLowerSelectOptions()),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_input__["a" /* default */], { className: "center-box", placeholder: "To", disabled: true }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_select__["a" /* default */], __assign({ className: "right-box", defaultValue: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.upper, value: (value === null || value === void 0 ? void 0 : value.upper) || undefined, placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.upper, disabled: disabled, showSearch: true, showArrow: false, allowClear: true, onChange: this.handleRightOnChange }, { showAction: ["focus", "click"] }), this.renderRightSelectOptions()))));
    };
    return LetterRangeSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (LetterRangeSelector);


/***/ }),
/* 2172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivityTypes; });
var ActivityTypes = /** @class */ (function () {
    function ActivityTypes() {
    }
    ActivityTypes.FindById = function (id) {
        return this.All.find(function (x) { return x.id === id; }) || this.None;
    };
    ActivityTypes.None = { id: 0, name: "None" };
    ActivityTypes.Survey = { id: 1, name: "Survey" };
    ActivityTypes.Quiz = { id: 2, name: "Quiz" };
    ActivityTypes.All = [
        ActivityTypes.Survey,
        ActivityTypes.Quiz,
    ];
    return ActivityTypes;
}());



/***/ }),
/* 2174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_radio__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_radio_style_index_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_redux_CheckpointActions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_constants_Checkpoints__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_localize_redux__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
























var StudentViews = /** @class */ (function (_super) {
    __extends(StudentViews, _super);
    function StudentViews(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, StudentViews.prototype);
        _this.state = {
            gradeId: __WEBPACK_IMPORTED_MODULE_20_src_constants_Grades__["a" /* Grades */].PreK.id,
            planetId: __WEBPACK_IMPORTED_MODULE_21_src_constants_Planets__["a" /* Planets */].R.id,
            checkpointId: __WEBPACK_IMPORTED_MODULE_22_src_constants_Checkpoints__["a" /* Checkpoints */].Video.id
        };
        return _this;
    }
    StudentViews.prototype.handleGradeChange = function (value) {
        this.setState({
            gradeId: value.target.value
        });
    };
    StudentViews.prototype.handlePlanetChange = function (value) {
        this.setState({
            planetId: value.target.value
        });
    };
    StudentViews.prototype.handleCheckpointChange = function (value) {
        this.setState({
            checkpointId: value.target.value
        });
    };
    StudentViews.prototype.renderGrades = function () {
        var _this = this;
        var grades = __WEBPACK_IMPORTED_MODULE_20_src_constants_Grades__["a" /* Grades */].All;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Group, { value: grades.find(function (g) { return g.id === _this.state.gradeId; }).id, onChange: this.handleGradeChange, buttonStyle: "solid" }, grades.map(function (grade) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Button, { value: grade.id, key: grade.id }, grade.name); }));
    };
    StudentViews.prototype.renderPlanet = function () {
        var _this = this;
        var planets = __WEBPACK_IMPORTED_MODULE_21_src_constants_Planets__["a" /* Planets */].All;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Group, { value: planets.find(function (p) { return p.id === _this.state.planetId; }).id, onChange: this.handlePlanetChange, buttonStyle: "solid" }, planets.map(function (planet) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Button, { value: planet.id, key: planet.id }, planet.name); }));
    };
    StudentViews.prototype.renderCheckpoint = function () {
        var _this = this;
        var checkpoints = [__WEBPACK_IMPORTED_MODULE_22_src_constants_Checkpoints__["a" /* Checkpoints */].Video, __WEBPACK_IMPORTED_MODULE_22_src_constants_Checkpoints__["a" /* Checkpoints */].Game, __WEBPACK_IMPORTED_MODULE_22_src_constants_Checkpoints__["a" /* Checkpoints */].Activity];
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Group, { value: checkpoints.find(function (c) { return c.id === _this.state.checkpointId; }).id, onChange: this.handleCheckpointChange, buttonStyle: "solid" }, checkpoints.map(function (checkpoint) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Button, { value: checkpoint.id, key: checkpoint.id }, checkpoint.name); }));
    };
    StudentViews.prototype.renderGrid = function () {
        var items = [
            { name: "Grade", value: this.renderGrades() },
            { name: "Planet", value: this.renderPlanet() },
            { name: "Checkpoint", value: this.renderCheckpoint() },
        ];
        return items.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], { key: item.name, className: "grid-items" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { sm: 4, md: 6, lg: 4, xl: 2 }, item.name),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { sm: 20, md: 18, lg: 20, xl: 22 }, item.value));
        });
    };
    StudentViews.prototype.viewAsStudent = function () {
        // Set correct grade
        this.props.setLogin(__assign(__assign({}, this.props.User), { gradeId: this.state.gradeId }));
        // Set debug checkpoint status
        this.props.setCheckpoint(__assign(__assign({}, this.props.Mission), { current: {
                checkpointId: this.state.checkpointId,
                planetId: this.state.planetId,
                stepId: 1
            }, currentDirection: "forwards" }));
        // Set the start and end checkpoints
        var replayStart = {
            planetId: this.state.planetId,
            checkpointId: this.state.checkpointId,
            stepId: 1
        };
        var replayEnd = {
            planetId: this.state.planetId,
            checkpointId: this.state.checkpointId + 1,
            stepId: 1
        };
        this.props.startReplay(replayStart, replayEnd, __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_STUDENT_VIEWS);
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].STUDENT_HOME);
    };
    StudentViews.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "student-views" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_react_localize_redux__["b" /* Translate */], { id: "admin.studentViews.header" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_react_localize_redux__["b" /* Translate */], { id: "admin.studentViews.body1" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_react_localize_redux__["b" /* Translate */], { id: "admin.studentViews.body2" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_react_localize_redux__["b" /* Translate */], { id: "admin.studentViews.body3" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            this.renderGrid(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_button__["a" /* default */], { type: "primary", onClick: this.viewAsStudent }, "View As Student"));
    };
    return StudentViews;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        setLogin: function (request) { return __WEBPACK_IMPORTED_MODULE_18_src_redux_UserActions__["a" /* default */].SetLogin(dispatch, request); },
        setCheckpoint: function (request) { return __WEBPACK_IMPORTED_MODULE_19_src_redux_CheckpointActions__["a" /* default */].SetUserStatus(dispatch, request); },
        startReplay: function (start, end, returnLocation) { return __WEBPACK_IMPORTED_MODULE_19_src_redux_CheckpointActions__["a" /* default */].StartReplay(dispatch, start, end, returnLocation); },
    });
}
function mapStateToProps(state) {
    return {
        User: state.User,
        Mission: state.Mission,
        Constants: state.Constants
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(StudentViews));


/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_Config__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(38);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};








var DownloadableResources = /** @class */ (function (_super) {
    __extends(DownloadableResources, _super);
    function DownloadableResources(props) {
        var _this = _super.call(this, props) || this;
        _this.files = [];
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, DownloadableResources.prototype);
        // Load all azure bob urls
        var files = [
            { name: "Galaxy Administrator Login Instructions", extension: "pdf" },
            { name: "Galaxy Adding Students Tool Tips", extension: "pdf" },
            { name: "Galaxy Quick Guide", extension: "pdf" },
            { name: "Galaxy Student Login Card", extension: "pdf" },
            { name: "Galaxy Flier", extension: "pdf" },
            { name: "RIASEC Poster", extension: "pdf" },
            { name: "Parent Communication Template", extension: "docx" },
            { name: "Parent Communication Template - Spanish Version", extension: "docx" },
            { name: "Galaxy Poster 18X24", extension: "pdf" },
            { name: "Galaxy Badge Worksheets", extension: "pdf" },
        ];
        var getIconFromExtension = function (extension) {
            switch (extension) {
                case "pdf":
                    return "file-pdf";
                case "docx":
                    return "file-word";
                case "jpg":
                    return "file-jpg";
                default:
                    return "file-unknown";
            }
        };
        _this.files = files.map(function (x) {
            var fileName = x.name + "." + x.extension;
            return __assign(__assign({}, x), { url: __WEBPACK_IMPORTED_MODULE_5_src_constants_Config__["a" /* default */].GetAzureUrl(fileName, "static", _this.props.User.cultureCode), iconName: getIconFromExtension(x.extension), fileName: fileName });
        });
        return _this;
    }
    DownloadableResources.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "downloadable-resources" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["b" /* Translate */], { id: "admin.resources.header" })),
            this.files.map(function (x) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { key: x.fileName },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_icon__["a" /* default */], { type: x.iconName }),
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: x.url }, x.name))); }));
    };
    return DownloadableResources;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(DownloadableResources)));


/***/ }),
/* 2177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_api_LessonPlanApiController__ = __webpack_require__(2178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_constants_Config__ = __webpack_require__(285);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
















var LessonPlans = /** @class */ (function (_super) {
    __extends(LessonPlans, _super);
    function LessonPlans(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, LessonPlans.prototype);
        _this.fetchData = _this.fetchData.bind(_this);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {
            selectedGrade: __WEBPACK_IMPORTED_MODULE_7_src_constants_Grades__["a" /* Grades */].First,
            allTableRecords: [],
            filteredTableRecords: [],
            loading: false
        };
        return _this;
    }
    LessonPlans.prototype.handleGradeChange = function (value) {
        var _this = this;
        this.setState({
            selectedGrade: __WEBPACK_IMPORTED_MODULE_7_src_constants_Grades__["a" /* Grades */].All.find(function (i) { return i.id === value.target.value; }),
            filteredTableRecords: this.state.allTableRecords.filter(function (i) { return i.gradeLevelId === value.target.value; })
        }, function () {
            _this.dataTableRef.refresh();
        });
    };
    LessonPlans.prototype.componentDidMount = function () {
        this.fetchData();
    };
    LessonPlans.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lesson-plans" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.lessonPlans.title')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, this.props.translate('admin.lessonPlans.description')),
            this.renderGrid(),
            this.renderDownloadAll(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return (_this.dataTableRef = ref); }, serverSide: false, tableProps: { rowKey: 'rowKey', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.filteredTableRecords })));
    };
    LessonPlans.prototype.renderGrades = function () {
        var _this = this;
        var grades = [];
        grades.push(__WEBPACK_IMPORTED_MODULE_7_src_constants_Grades__["a" /* Grades */].First, __WEBPACK_IMPORTED_MODULE_7_src_constants_Grades__["a" /* Grades */].Second, __WEBPACK_IMPORTED_MODULE_7_src_constants_Grades__["a" /* Grades */].Third, __WEBPACK_IMPORTED_MODULE_7_src_constants_Grades__["a" /* Grades */].Fourth, __WEBPACK_IMPORTED_MODULE_7_src_constants_Grades__["a" /* Grades */].Fifth);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a.Group, { value: grades.find(function (g) { return g.id === _this.state.selectedGrade.id; }).id, onChange: this.handleGradeChange, buttonStyle: "solid" }, grades.map(function (grade) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio___default.a.Button, { value: grade.id, key: grade.id }, grade.name)); })));
    };
    LessonPlans.prototype.renderGrid = function () {
        var items = [{ name: this.props.translate('common.grade').toString(), value: this.renderGrades() }];
        return items.map(function (item) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_row__["a" /* default */], { key: item.name, className: "grid-items" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_col__["a" /* default */], { sm: 4, md: 6, lg: 4, xl: 2 }, item.name),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_col__["a" /* default */], { sm: 20, md: 18, lg: 20, xl: 22 }, item.value)));
        });
    };
    LessonPlans.prototype.renderDownloadAll = function () {
        var _this = this;
        var link = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null);
        if (this.state.filteredTableRecords.some(function (i) {
            return i.postLaunchDisplayName !== _this.props.translate('admin.lessonPlans.comingSoon').toString() ||
                i.preLaunchDisplayName !== _this.props.translate('admin.lessonPlans.comingSoon').toString();
        })) {
            var azureUrl = __WEBPACK_IMPORTED_MODULE_15_src_constants_Config__["a" /* default */].GetAzureUrl("galaxy_lesson-plans_grade-" + this.state.selectedGrade.level + ".zip", 'lesson-plan', this.props.User.cultureCode);
            link = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: azureUrl }, this.props.translate('admin.lessonPlans.downloadAll').toString()));
        }
        return link;
    };
    LessonPlans.prototype.fetchData = function () {
        var _this = this;
        this.setState({ loading: true });
        var lessonPlanPromise = __WEBPACK_IMPORTED_MODULE_1_src_api_LessonPlanApiController__["a" /* default */].getAllLessonPlans();
        Promise.all([lessonPlanPromise]).then(function (response) {
            var lessonPlans = response[0].data;
            var tableRecords = new Array();
            var _loop_1 = function (grade) {
                var _loop_2 = function (planet) {
                    if (planet.id > 0) {
                        var tableRecord = {};
                        tableRecord.rowKey = grade.id + "-" + planet.id;
                        tableRecord.gradeLevel = grade.name;
                        tableRecord.gradeLevelId = grade.id;
                        tableRecord.planetId = planet.id;
                        tableRecord.planetName = planet.name;
                        tableRecord.cultureName = _this.props.User.cultureCode;
                        var preLaunch = lessonPlans.find(function (i) { return i.cultureId === _this.props.User.cultureId && i.gradeLevelId === grade.id && i.planetId === planet.id && i.isPreLaunch; });
                        if (preLaunch != null) {
                            tableRecord.preLaunchDisplayName = preLaunch.displayName;
                            tableRecord.preLaunchFileName = "" + preLaunch.fileName;
                        }
                        else {
                            tableRecord.preLaunchDisplayName = _this.props.translate('admin.lessonPlans.comingSoon').toString();
                            tableRecord.preLaunchFileName = '';
                        }
                        var postLaunch = lessonPlans.find(function (i) { return i.cultureId === _this.props.User.cultureId && i.gradeLevelId === grade.id && i.planetId === planet.id && !i.isPreLaunch; });
                        if (postLaunch != null) {
                            tableRecord.postLaunchDisplayName = postLaunch.displayName;
                            tableRecord.postLaunchFileName = "" + postLaunch.fileName;
                        }
                        else {
                            tableRecord.postLaunchDisplayName = _this.props.translate('admin.lessonPlans.comingSoon').toString();
                            tableRecord.postLaunchFileName = '';
                        }
                        tableRecords.push(tableRecord);
                    }
                };
                for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_8_src_constants_Planets__["a" /* Planets */].All; _i < _a.length; _i++) {
                    var planet = _a[_i];
                    _loop_2(planet);
                }
            };
            for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_7_src_constants_Grades__["a" /* Grades */].All; _i < _a.length; _i++) {
                var grade = _a[_i];
                _loop_1(grade);
            }
            _this.setState({ allTableRecords: tableRecords, filteredTableRecords: tableRecords.filter(function (i) { return i.gradeLevelId === _this.state.selectedGrade.id; }), loading: false }, function () {
                _this.dataTableRef.refresh();
            });
        });
    };
    LessonPlans.prototype.customTableColumns = function () {
        var _this = this;
        var preLaunchLink = function (text, record) {
            return record.preLaunchFileName;
        };
        var postLaunchLink = function (text, record) {
            return record.preLaunchFileName;
        };
        var columns = [
            __WEBPACK_IMPORTED_MODULE_2_src_components_common_DataTable__["e" /* default */].StandardColumns.Text('common.planet', 'planetName'),
            {
                columnProps: {
                    title: this.props.translate('admin.lessonPlans.documentTableHeaderColumn2'),
                    dataIndex: 'preLaunchDisplayName',
                    render: function (text, record) {
                        if (record.preLaunchDisplayName !== _this.props.translate('admin.lessonPlans.comingSoon').toString()) {
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_icon__["a" /* default */], { type: "file-pdf" }),
                                " ",
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: __WEBPACK_IMPORTED_MODULE_15_src_constants_Config__["a" /* default */].GetAzureUrl(record.preLaunchFileName, 'lesson-plan', record.cultureName) }, record.preLaunchDisplayName)));
                        }
                        else {
                            return record.preLaunchDisplayName;
                        }
                    }
                }
            },
            {
                columnProps: {
                    title: this.props.translate('admin.lessonPlans.documentTableHeaderColumn3'),
                    dataIndex: 'postLaunchDisplayName',
                    render: function (text, record) {
                        if (record.postLaunchDisplayName !== _this.props.translate('admin.lessonPlans.comingSoon').toString()) {
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_icon__["a" /* default */], { type: "file-pdf" }),
                                " ",
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: __WEBPACK_IMPORTED_MODULE_15_src_constants_Config__["a" /* default */].GetAzureUrl(record.postLaunchFileName, 'lesson-plan', record.cultureName) }, record.postLaunchDisplayName)));
                        }
                        else {
                            return record.postLaunchDisplayName;
                        }
                    }
                }
            }
        ];
        return columns;
    };
    return LessonPlans;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* withLocalize */])(LessonPlans)));


/***/ }),
/* 2178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LessonPlanApiController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpApi__ = __webpack_require__(77);

var LessonPlanApiController = /** @class */ (function () {
    function LessonPlanApiController() {
        // get: LessonPlan/GetAllLessonPlans
        this.RouteGetAllLessonPlans = function () { return "LessonPlan/GetAllLessonPlans"; };
    }
    LessonPlanApiController.prototype.getAllLessonPlans = function (requestOptions) {
        var url = this.RouteGetAllLessonPlans();
        return __WEBPACK_IMPORTED_MODULE_0__HttpApi__["a" /* default */].RestRequest(null, 'get', url, requestOptions);
    };
    return LessonPlanApiController;
}());

var service = new LessonPlanApiController();
/* harmony default export */ __webpack_exports__["a"] = (service);


/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = exports.Button = undefined;

var _radio = __webpack_require__(510);

var _radio2 = _interopRequireDefault(_radio);

var _group = __webpack_require__(2180);

var _group2 = _interopRequireDefault(_group);

var _radioButton = __webpack_require__(2181);

var _radioButton2 = _interopRequireDefault(_radioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_radio2['default'].Button = _radioButton2['default'];
_radio2['default'].Group = _group2['default'];
exports.Button = _radioButton2['default'];
exports.Group = _group2['default'];
exports['default'] = _radio2['default'];

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(11);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(6);

var PropTypes = _interopRequireWildcard(_propTypes);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__(79);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _radio = __webpack_require__(510);

var _radio2 = _interopRequireDefault(_radio);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getCheckedValue(children) {
    var value = null;
    var matched = false;
    React.Children.forEach(children, function (radio) {
        if (radio && radio.props && radio.props.checked) {
            value = radio.props.value;
            matched = true;
        }
    });
    return matched ? { value: value } : undefined;
}

var RadioGroup = function (_React$Component) {
    (0, _inherits3['default'])(RadioGroup, _React$Component);

    function RadioGroup(props) {
        (0, _classCallCheck3['default'])(this, RadioGroup);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props));

        _this.onRadioChange = function (ev) {
            var lastValue = _this.state.value;
            var value = ev.target.value;

            if (!('value' in _this.props)) {
                _this.setState({
                    value: value
                });
            }
            var onChange = _this.props.onChange;
            if (onChange && value !== lastValue) {
                onChange(ev);
            }
        };
        var value = void 0;
        if ('value' in props) {
            value = props.value;
        } else if ('defaultValue' in props) {
            value = props.defaultValue;
        } else {
            var checkedValue = getCheckedValue(props.children);
            value = checkedValue && checkedValue.value;
        }
        _this.state = {
            value: value
        };
        return _this;
    }

    (0, _createClass3['default'])(RadioGroup, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                radioGroup: {
                    onChange: this.onRadioChange,
                    value: this.state.value,
                    disabled: this.props.disabled,
                    name: this.props.name
                }
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({
                    value: nextProps.value
                });
            } else {
                var checkedValue = getCheckedValue(nextProps.children);
                if (checkedValue) {
                    this.setState({
                        value: checkedValue.value
                    });
                }
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var props = this.props;
            var prefixCls = props.prefixCls,
                _props$className = props.className,
                className = _props$className === undefined ? '' : _props$className,
                options = props.options,
                buttonStyle = props.buttonStyle;

            var groupPrefixCls = prefixCls + '-group';
            var classString = (0, _classnames2['default'])(groupPrefixCls, groupPrefixCls + '-' + buttonStyle, (0, _defineProperty3['default'])({}, groupPrefixCls + '-' + props.size, props.size), className);
            var children = props.children;
            // 如果存在 options, 优先使用
            if (options && options.length > 0) {
                children = options.map(function (option, index) {
                    if (typeof option === 'string') {
                        // 此处类型自动推导为 string
                        return React.createElement(
                            _radio2['default'],
                            { key: index, prefixCls: prefixCls, disabled: _this2.props.disabled, value: option, onChange: _this2.onRadioChange, checked: _this2.state.value === option },
                            option
                        );
                    } else {
                        // 此处类型自动推导为 { label: string value: string }
                        return React.createElement(
                            _radio2['default'],
                            { key: index, prefixCls: prefixCls, disabled: option.disabled || _this2.props.disabled, value: option.value, onChange: _this2.onRadioChange, checked: _this2.state.value === option.value },
                            option.label
                        );
                    }
                });
            }
            return React.createElement(
                'div',
                { className: classString, style: props.style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, id: props.id },
                children
            );
        }
    }]);
    return RadioGroup;
}(React.Component);

exports['default'] = RadioGroup;

RadioGroup.defaultProps = {
    disabled: false,
    prefixCls: 'ant-radio',
    buttonStyle: 'outline'
};
RadioGroup.childContextTypes = {
    radioGroup: PropTypes.any
};
module.exports = exports['default'];

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(6);

var PropTypes = _interopRequireWildcard(_propTypes);

var _radio = __webpack_require__(510);

var _radio2 = _interopRequireDefault(_radio);

var _wave = __webpack_require__(836);

var _wave2 = _interopRequireDefault(_wave);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var RadioButton = function (_React$Component) {
    (0, _inherits3['default'])(RadioButton, _React$Component);

    function RadioButton() {
        (0, _classCallCheck3['default'])(this, RadioButton);
        return (0, _possibleConstructorReturn3['default'])(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
    }

    (0, _createClass3['default'])(RadioButton, [{
        key: 'render',
        value: function render() {
            var radioProps = (0, _extends3['default'])({}, this.props);
            if (this.context.radioGroup) {
                radioProps.onChange = this.context.radioGroup.onChange;
                radioProps.checked = this.props.value === this.context.radioGroup.value;
                radioProps.disabled = this.props.disabled || this.context.radioGroup.disabled;
            }
            return React.createElement(
                _wave2['default'],
                null,
                React.createElement(_radio2['default'], radioProps)
            );
        }
    }]);
    return RadioButton;
}(React.Component);

exports['default'] = RadioButton;

RadioButton.defaultProps = {
    prefixCls: 'ant-radio-button'
};
RadioButton.contextTypes = {
    radioGroup: PropTypes.any
};
module.exports = exports['default'];

/***/ }),
/* 2182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_spin_style_index_js__ = __webpack_require__(47);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var EmulateUser = /** @class */ (function (_super) {
    __extends(EmulateUser, _super);
    function EmulateUser(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, EmulateUser.prototype);
        return _this;
    }
    EmulateUser.prototype.render = function () {
        // If loading is complete, redirect to redux.config.previous page
        // if nothing in there, maybe send them to the login page? maybe just send them there anyway...
        if (this.props.User.state === "finished") {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].LOGIN });
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "emulate-user" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "Emulating User"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_spin__["a" /* default */], { size: "large" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Please wait while we prepare the emulation request"));
    };
    return EmulateUser;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(EmulateUser));


/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OccupationDb_less__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OccupationDb_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OccupationDb_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_api_OccupationApiController__ = __webpack_require__(848);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

 // 'this' binder








var OccupationDb = /** @class */ (function (_super) {
    __extends(OccupationDb, _super);
    function OccupationDb(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, OccupationDb.prototype);
        _this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
        return _this;
    }
    OccupationDb.prototype.customTableColumns = function () {
        var route = this.props.location.pathname.includes('admin') ? __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].ADMIN_OCCUPATION : __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].OCCUPATION;
        var viewLInk = function (text, record) { return __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(route, record.occupationId); };
        return [
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text("public.occupationdb.occupation", 'title'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Text("public.occupationdb.hollandcode", 'hollandCode'),
            __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */].StandardColumns.Link("admin.common.emulateColumnHeader", 'occupationid', viewLInk, 'search')
        ];
    };
    OccupationDb.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_8_src_api_OccupationApiController__["a" /* default */].getOccupationsTableData(requestState, { additionalHeaders: { CultureCode: this.props.activeLanguage.code } })
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    OccupationDb.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationDb" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.occupationdb.title" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["e" /* default */], { serverSide: true, tableProps: { rowKey: 'occupationId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [new __WEBPACK_IMPORTED_MODULE_5_src_components_common_DataTable__["c" /* DataTableButtonReset */]()] })));
    };
    return OccupationDb;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(OccupationDb));


/***/ }),
/* 2184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_api_OccupationApiController__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OccupationDb_less__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OccupationDb_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__OccupationDb_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var Occupation = /** @class */ (function (_super) {
    __extends(Occupation, _super);
    function Occupation(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_BindThisHelper__["a" /* default */])(_this, Occupation.prototype);
        var currentOccupation = {
            id: 0,
            title: "",
            description: "",
            entryLevelEducation: "",
            futureOutlook: "",
            entryEarnings: "",
            averageEarnings: "",
            hollandCode: "",
            skills: [],
            schoolSubjects: [],
            relatedJobs: []
        };
        _this.state = {
            loading: true,
            currentOccupation: currentOccupation
        };
        return _this;
    }
    Occupation.prototype.componentDidMount = function () {
        var _this = this;
        var occupationId = parseInt(this.props.match.params.id, 10);
        __WEBPACK_IMPORTED_MODULE_12_src_api_OccupationApiController__["a" /* default */].getOccupationDetails(occupationId, { additionalHeaders: { CultureCode: this.props.activeLanguage.code } }).then(function (result) {
            if (!result.ok) {
                return;
            }
            var occupationDetails = result.data;
            _this.setState({
                loading: false,
                currentOccupation: occupationDetails
            });
        });
    };
    Occupation.prototype.handleCancel = function (e) {
        var route = this.props.location.pathname.includes('admin') ? __WEBPACK_IMPORTED_MODULE_10_src_core_Routes__["a" /* default */].ADMIN_OCCUPATIONDB : __WEBPACK_IMPORTED_MODULE_10_src_core_Routes__["a" /* default */].OCCUPATIONDB;
        this.props.history.push(route);
    };
    Occupation.prototype.renderHollandCode = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationSection" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Holland Code:\u00A0"),
            this.state.currentOccupation.hollandCode);
    };
    Occupation.prototype.renderDescription = function () {
        if (this.state.currentOccupation.description) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationSection" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Description:"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, this.state.currentOccupation.description)));
        }
    };
    Occupation.prototype.renderFutureOutlook = function () {
        if (this.state.currentOccupation.futureOutlook) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationSection" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Future Outlook:"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, this.state.currentOccupation.futureOutlook)));
        }
    };
    Occupation.prototype.renderEntryEarnings = function () {
        if (this.state.currentOccupation.entryEarnings) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationSection" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Typical Entry-level Earnings:"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, this.state.currentOccupation.entryEarnings)));
        }
    };
    Occupation.prototype.renderAvgEarnings = function () {
        if (this.state.currentOccupation.averageEarnings) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationSection" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Average Earnings:"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, this.state.currentOccupation.averageEarnings)));
        }
    };
    Occupation.prototype.renderEntryLevelEdu = function () {
        if (this.state.currentOccupation.entryLevelEducation) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationSection" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Typical Entry-Level Education:"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, this.state.currentOccupation.entryLevelEducation)));
        }
    };
    Occupation.prototype.renderSkills = function () {
        if (this.state.currentOccupation.skills.length > 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationSection" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Skills"),
                this.state.currentOccupation.skills.map(function (skill) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, skill); }));
        }
    };
    Occupation.prototype.renderSchoolSubjects = function () {
        if (this.state.currentOccupation.schoolSubjects.length > 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationSection" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Important School Subjects"),
                this.state.currentOccupation.schoolSubjects.map(function (subject) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, subject); }));
        }
    };
    Occupation.prototype.renderRelatedOccupations = function () {
        if (this.state.currentOccupation.relatedJobs.length > 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationSection" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, "Related Occupations"),
                this.state.currentOccupation.relatedJobs.map(function (relatedJob) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, relatedJob); }));
        }
    };
    Occupation.prototype.render = function () {
        if (this.state.loading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_spin__["a" /* default */], null);
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "occupationDb" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                this.state.currentOccupation.title,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_button__["a" /* default */], { onClick: this.handleCancel }, this.props.translate("common.back"))),
            this.renderHollandCode(),
            this.renderDescription(),
            this.renderEntryLevelEdu(),
            this.renderFutureOutlook(),
            this.renderEntryEarnings(),
            this.renderAvgEarnings(),
            this.renderSkills(),
            this.renderSchoolSubjects(),
            this.renderRelatedOccupations()));
    };
    return Occupation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["d" /* withLocalize */])(Occupation));


/***/ }),
/* 2185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_api_SchoolApiController__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_api_DistrictApiController__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_common_DataTable__ = __webpack_require__(58);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();























var SyncResults = /** @class */ (function (_super) {
    __extends(SyncResults, _super);
    function SyncResults(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_17_src_utils_BindThisHelper__["a" /* default */])(_this, SyncResults.prototype);
        _this.state = {
            loading: true,
            district: {},
        };
        return _this;
    }
    SyncResults.prototype.componentDidMount = function () {
        var _this = this;
        var districtId = parseInt(this.props.match.params.districtId, 10);
        if (districtId) {
            __WEBPACK_IMPORTED_MODULE_20_src_api_DistrictApiController__["a" /* default */].getDistrict(districtId).then(function (result) {
                if (!result.ok) {
                    return;
                }
                _this.setState({
                    loading: false,
                    district: result.data
                });
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_9_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditDistrict.messageRetrieveError'));
            });
        }
    };
    SyncResults.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        var syncId = parseInt(this.props.match.params.id, 10);
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_19_src_api_SchoolApiController__["a" /* default */].getSchoolFullSyncTableData(requestState, syncId)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            _this.setState({
                loading: false
            });
            callback(results.data);
        });
    };
    SyncResults.prototype.customTableColumns = function () {
        return [
            __WEBPACK_IMPORTED_MODULE_22_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text('School Name', 'name'),
            __WEBPACK_IMPORTED_MODULE_22_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Number('Total Students', 'studentsCount'),
            __WEBPACK_IMPORTED_MODULE_22_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Number('Total Teachers', 'teachersCount'),
        ];
    };
    SyncResults.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sync-results-container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "Full Sync Results"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, this.state.district.districtName),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_react_router_dom__["Link"], { className: "back-to-client-report", to: __WEBPACK_IMPORTED_MODULE_18_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_18_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_CLIENT, this.state.district.clientId) }, "Back to Client Report"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_src_components_common_DataTable__["e" /* default */], { serverSide: true, tableProps: { rowKey: 'districtId', loading: this.state.loading }, columns: this.customTableColumns(), data: [], fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_22_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] })));
    };
    return SyncResults;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SyncResults);


/***/ }),
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_MatchmakerForm__ = __webpack_require__(2187);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var Matchmaker = /** @class */ (function (_super) {
    __extends(Matchmaker, _super);
    function Matchmaker(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, Matchmaker.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    Matchmaker.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__forms_MatchmakerForm__["a" /* default */], null));
    };
    return Matchmaker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Matchmaker);


/***/ }),
/* 2187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_date_picker__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_date_picker_style_index_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_api_MatchmakerApiController__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_api_DistrictApiController__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_api_SchoolApiController__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_utils_ArrayUtil__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_utils_NameOf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_utils_DownloadUtil__ = __webpack_require__(281);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



















 // 'this' binder







var MatchmakerForm = /** @class */ (function (_super) {
    __extends(MatchmakerForm, _super);
    function MatchmakerForm(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_19_src_utils_BindThisHelper__["a" /* default */])(_this, MatchmakerForm.prototype);
        _this.state = {
            districts: [],
            schools: [],
            filteredDistricts: [],
            filteredSchools: [],
            isFilteringDistrict: false,
            isFilteringSchool: false,
            useSchoolClients: false,
            isLoadingDistricts: true,
            isLoadingSchools: true,
            isSubmitting: false,
        };
        return _this;
    }
    MatchmakerForm.prototype.componentDidMount = function () {
        this.getDistricts();
        this.getSchools();
    };
    MatchmakerForm.prototype.getDistricts = function () {
        var _this = this;
        this.setState({ isLoadingDistricts: true });
        return __WEBPACK_IMPORTED_MODULE_22_src_api_DistrictApiController__["a" /* default */].getAllDistricts().then(function (result) {
            _this.setState({
                districts: result.data.sort(function (a, b) { return a.value < b.value ? -1 : a.value > b.value ? 1 : 0; }),
                isLoadingDistricts: false
            });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_17_antd_es_message__["a" /* default */].error(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "admin.addEditDistrict.messageRetrieveError" }));
            _this.setState({ isLoadingDistricts: false });
        });
    };
    MatchmakerForm.prototype.getSchools = function (districtIds) {
        var _this = this;
        var request = districtIds == null || districtIds.length < 1
            ? __WEBPACK_IMPORTED_MODULE_23_src_api_SchoolApiController__["a" /* default */].getAllSchoolsForSchoolClientType()
            : __WEBPACK_IMPORTED_MODULE_23_src_api_SchoolApiController__["a" /* default */].getSchoolsByDistricts({ listOfInts: districtIds });
        this.setState({ isLoadingSchools: true });
        return request.then(function (result) {
            _this.setState({
                schools: result.data.sort(function (a, b) { return a.value < b.value ? -1 : a.value > b.value ? 1 : 0; }),
                isLoadingSchools: false
            });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_17_antd_es_message__["a" /* default */].error(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "admin.common.messageSchoolsInDistrictError" }));
            _this.setState({ isLoadingSchools: false });
        });
    };
    MatchmakerForm.prototype.onCheckboxChange = function (value) {
        var _this = this;
        this.setState({ useSchoolClients: !this.state.useSchoolClients });
        // Clear out the districts and schools before continuing
        this.props.form.setFieldsValue({
            districtIds: [],
            schoolIds: []
        });
        this.getSchools().then(function () {
            // Update the school filter list
            _this.handleSchoolSearch("");
        });
    };
    MatchmakerForm.prototype.handleDistrictFilter = function (values) {
        var _this = this;
        // Called when an item is selected from the dropdown
        this.getSchools(values).then(function () {
            // Update the school filter list
            _this.handleSchoolSearch("");
            _this.props.form.setFieldsValue({
                schoolIds: []
            });
        });
    };
    MatchmakerForm.prototype.handleDistrictSearch = function (value) {
        var input = (value || "").toLowerCase();
        // Filter the districts if input is 2+ chars OR if the number of districts is small, like 50 or so
        if (input.length >= 2 || this.state.districts.length < 50) {
            var filteredDistricts = this.state.districts
                .filter(function (x) { return x.value.toLowerCase().indexOf(input) >= 0; });
            this.setState({
                filteredDistricts: __WEBPACK_IMPORTED_MODULE_24_src_utils_ArrayUtil__["a" /* default */].Unique(filteredDistricts),
                isFilteringDistrict: true
            });
            return;
        }
        this.setState({
            filteredDistricts: [],
            isFilteringDistrict: false
        });
    };
    MatchmakerForm.prototype.handleDistrictBlur = function () {
        // Run through the same logic, but make sure we cleared out the text
        this.handleDistrictSearch("");
    };
    MatchmakerForm.prototype.handleSchoolSearch = function (value) {
        var input = (value || "").toLowerCase();
        // Filter the schools if input is 2+ chars OR if the number of schools is small, like 50 or so
        if (input.length >= 2 || this.state.schools.length < 50) {
            var filteredSchools = this.state.schools
                .filter(function (x) { return x.value.toLowerCase().indexOf(input) >= 0; });
            this.setState({
                filteredSchools: __WEBPACK_IMPORTED_MODULE_24_src_utils_ArrayUtil__["a" /* default */].Unique(filteredSchools),
                isFilteringSchool: true
            });
            return;
        }
        this.setState({
            filteredSchools: [],
            isFilteringSchool: false
        });
    };
    MatchmakerForm.prototype.handleSchoolBlur = function () {
        // Run through the same logic, but make sure we cleared out the text
        this.handleSchoolSearch("");
    };
    MatchmakerForm.prototype.submit = function (e) {
        var _this = this;
        e.preventDefault();
        // Make sure all fields are valid
        this.props.form.validateFields(function (errors, values) {
            // Loading for finish button
            _this.setState({
                isSubmitting: !errors
            });
            __WEBPACK_IMPORTED_MODULE_21_src_api_MatchmakerApiController__["a" /* default */].getUserDetails(values).then(function (response) {
                Object(__WEBPACK_IMPORTED_MODULE_26_src_utils_DownloadUtil__["a" /* downloadFile */])(response.data.data, 'Matchmaker.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                _this.setState({
                    isSubmitting: false
                });
            });
        });
    };
    MatchmakerForm.prototype.render = function () {
        var localDistrictIds = this.props.form.getFieldValue(Object(__WEBPACK_IMPORTED_MODULE_25_src_utils_NameOf__["a" /* NameOf */])("districtIds")) || [];
        var localSchoolIds = this.props.form.getFieldValue(Object(__WEBPACK_IMPORTED_MODULE_25_src_utils_NameOf__["a" /* NameOf */])("schoolIds")) || [];
        var schoolsDisabled = !this.state.useSchoolClients && (localDistrictIds.length === 0) || this.state.isLoadingSchools;
        var districtsDisabled = this.state.useSchoolClients || this.state.isLoadingDistricts;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */], { layout: "vertical", onSubmit: this.submit },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "Download Matchmaker File"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_row__["a" /* default */], { gutter: 20 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_col__["a" /* default */], { span: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_antd_es_checkbox__["a" /* default */], { onChange: this.onCheckboxChange, checked: this.state.useSchoolClients }, "Search by School Only"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_row__["a" /* default */], { gutter: 20 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_col__["a" /* default */], { span: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "report.admin.districtFilter.label" }) }, this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_25_src_utils_NameOf__["a" /* NameOf */])("districtIds"))(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */], { filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, onChange: this.handleDistrictFilter, onSearch: this.handleDistrictSearch, onBlur: this.handleDistrictBlur, placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "report.admin.districtFilter.placeholder" }), allowClear: true, showSearch: true, disabled: districtsDisabled, notFoundContent: this.state.isFilteringDistrict ? "No Results" : "Please type 2 or more characters to search", mode: "multiple" }, this.state.filteredDistricts.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { key: x.key, value: x.key, title: x.value }, x.value); }))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_col__["a" /* default */], { span: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "report.admin.schoolFilter.label" }) }, this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_25_src_utils_NameOf__["a" /* NameOf */])("schoolIds"))(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */], { filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, onSearch: this.handleSchoolSearch, onBlur: this.handleSchoolBlur, placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "report.admin.schoolFilter.placeholder" }), allowClear: true, showSearch: true, disabled: schoolsDisabled, notFoundContent: this.state.isFilteringSchool
                            ? "Not Found"
                            : this.state.schools.length === 0
                                ? "No Results from District Filter"
                                : "Please type 2 or more characters to search" // You have to select ALOT to get this one
                        , mode: "multiple" }, this.state.filteredSchools.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_select__["a" /* default */].Option, { key: x.key, value: x.key, title: x.value }, x.value); }))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_col__["a" /* default */], { span: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, { label: "Download Matchmaker File" }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_button__["a" /* default */], { type: "primary", icon: "download", loading: this.state.isSubmitting, disabled: localDistrictIds.length === 0 && localSchoolIds.length === 0, htmlType: "submit" }, "Download\u00A0\u00A0\u00A0")))));
    };
    return MatchmakerForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].create()(MatchmakerForm)));


/***/ }),
/* 2188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admin_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Admin_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_radio__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_radio_style_index_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_upload__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_upload_style_index_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_api_MatchmakerApiController__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__UsersUploadErrorModal__ = __webpack_require__(835);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};































var SyncMatchmakerData = /** @class */ (function (_super) {
    __extends(SyncMatchmakerData, _super);
    function SyncMatchmakerData(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_27_src_utils_BindThisHelper__["a" /* default */])(_this, SyncMatchmakerData.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {
            loading: true,
            uploading: false,
            tableRecords: [],
            uploadStatus: "none",
            uploadErrorMessage: "",
            uploadFileName: "",
            uploadTableData: [],
            showUploadModal: false
        };
        return _this;
    }
    SyncMatchmakerData.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_29_src_api_MatchmakerApiController__["a" /* default */].getSyncMatchmakerDataLogTableData(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            callback(results.data);
        });
    };
    SyncMatchmakerData.prototype.customTableColumns = function () {
        return [
            __WEBPACK_IMPORTED_MODULE_28_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26_react_localize_redux__["b" /* Translate */], { id: 'admin.syncMatchmakerHistory.columnHeader1' }), 'districtName'),
            __WEBPACK_IMPORTED_MODULE_28_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Number(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26_react_localize_redux__["b" /* Translate */], { id: 'admin.syncMatchmakerHistory.columnHeader2' }), 'totalRecordsSynced'),
            __WEBPACK_IMPORTED_MODULE_28_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26_react_localize_redux__["b" /* Translate */], { id: 'admin.syncMatchmakerHistory.columnHeader3' }), 'userFullName'),
            __WEBPACK_IMPORTED_MODULE_28_src_components_common_DataTable__["e" /* default */].AdvancedColumns.DateTime(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26_react_localize_redux__["b" /* Translate */], { id: 'admin.syncMatchmakerHistory.columnHeader4' }), 'createdDt')
        ];
    };
    SyncMatchmakerData.prototype.handleModelClose = function () {
        this.setState({ showUploadModal: false });
    };
    SyncMatchmakerData.prototype.handleBeforeUpload = function (file, fileList) {
        this.setState({ uploading: true, uploadStatus: "uploading", uploadErrorMessage: "" });
        return true;
    };
    SyncMatchmakerData.prototype.handleUploadOnChange = function (info) {
        if (info.file.status === 'uploading') {
            return;
        }
        // We are finished uploading in some fashion
        this.setState({ uploading: false });
        // Get error from response. If it's a really bad error (500), then response will actually have a message attached to it rather than a proper response
        var response = (info.file.response || {});
        var error = info.file.response != null && info.file.response.message != null ? info.file.response.message : response.errorMessage;
        if (info.file.status === 'done' && response.isSuccess) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(info.file.name + " - " + this.props.translate('admin.users.messageUpload'));
            this.setState({
                uploadStatus: "success",
                uploadFileName: info.file.name,
                uploadErrorMessage: error,
                uploadTableData: response.data
            });
            this.dataTableRef.refresh();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(info.file.name + " - " + this.props.translate('admin.users.messageUploadError'));
            this.setState({
                uploadStatus: "failed",
                uploadFileName: info.file.name,
                uploadErrorMessage: error,
                uploadTableData: response.data
            });
        }
    };
    SyncMatchmakerData.prototype.renderUploadCompleteIcon = function () {
        var _this = this;
        if (this.state.uploadStatus === "success") {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_antd_es_icon__["a" /* default */], { type: "check-circle", theme: "twoTone", twoToneColor: "#52c41a" }));
        }
        if (this.state.uploadStatus === "failed") {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { onClick: function () { return _this.setState({ showUploadModal: true }); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_antd_es_icon__["a" /* default */], { type: "exclamation-circle", theme: "twoTone", twoToneColor: "#c41a1a" }),
                " View Upload Errors");
        }
    };
    SyncMatchmakerData.prototype.renderFileUpload = function () {
        var uploadProps = {
            name: 'file',
            showUploadList: false,
            action: "/" + __WEBPACK_IMPORTED_MODULE_29_src_api_MatchmakerApiController__["a" /* default */].RouteMatchmakerDataUpload(),
            disabled: this.state.uploadStatus === "uploading" || this.state.uploading,
            beforeUpload: this.handleBeforeUpload,
            onChange: this.handleUploadOnChange,
            data: { isCompleteMode: true } // Dev Note: This is not used but the API needs it because reasons
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mass-upload-buttons" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Select a file to upload"),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_upload__["a" /* default */], __assign({}, uploadProps),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { disabled: this.state.uploadStatus === "uploading" || this.state.uploading },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_antd_es_icon__["a" /* default */], { type: "upload" }),
                        " Upload Softmatch File")),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_spin__["a" /* default */], { spinning: this.state.uploading }),
                this.renderUploadCompleteIcon())));
    };
    SyncMatchmakerData.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "admin-sync-matchmaker-data" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_30__UsersUploadErrorModal__["a" /* default */], { errorMessage: this.state.uploadErrorMessage, fileName: this.state.uploadFileName, tableData: this.state.uploadTableData, visible: this.state.showUploadModal, onOkay: this.handleModelClose }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "Sync Matchmaker Data"),
            this.renderFileUpload(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_divider__["a" /* default */], { type: "horizontal" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "Matchmaker Sync History"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: true, 
                // tableProps={{ rowKey: 'userId', loading: this.state.loading }}
                tableProps: { loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData })));
    };
    return SyncMatchmakerData;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_26_react_localize_redux__["d" /* withLocalize */])(SyncMatchmakerData));


/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Login_less__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Login_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Login_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_utils_FullscreenHelper__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_utils_RoleRedirect__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_redux_ConfigActions__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_cookie_consent_notification__ = __webpack_require__(2190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_cookie_consent_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react_cookie_consent_notification__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


























var logo = __webpack_require__(286);
var classlinkLogo = __webpack_require__(2191);
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_16_src_utils_BindThisHelper__["a" /* default */])(_this, Login.prototype);
        return _this;
    }
    Login.prototype.componentWillMount = function () {
        this.checkUserLogin(this.props);
    };
    Login.prototype.componentDidMount = function () {
        var search = window.location.search;
        var params = new URLSearchParams(search);
        var clientId = parseInt(params.get('clientId'));
        var ref = params.get('ref');
        if (ref === 'afl') {
            document.getElementById("cleverButton").style.display = "none";
        }
        else {
            document.getElementById("registerButton").style.display = "none";
        }
    };
    Login.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.User.errorMsg !== nextProps.User.errorMsg && nextProps.User.errorMsg !== "") {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(this.props.translate(nextProps.User.errorMsg));
            this.props.updateUserError("");
        }
        this.checkUserLogin(nextProps);
    };
    Login.prototype.handleLogin = function (e) {
        var _this = this;
        e.preventDefault();
        // Prevent crushing the login button
        if (this.props.User.state === "loading") {
            return;
        }
        this.props.form.validateFields(function (errors, values) {
            // Make sure all fields are filled out
            if (!errors) {
                // Fire the login request
                if (!__WEBPACK_IMPORTED_MODULE_22_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
                    __WEBPACK_IMPORTED_MODULE_20_src_utils_FullscreenHelper__["a" /* default */].RequestFullscreen(document.body);
                }
                _this.props.login(values);
            }
        });
    };
    Login.prototype.checkUserLogin = function (props) {
        if (props.User.state === "finished" && props.Constants.state === "finished") {
            // User is logged in and can be directed to either their homepage, or a redirect page if one is set
            // JB: This will set the language whenever the login page is rendered
            if (this.props.User.cultureCode != null) {
                var language = __WEBPACK_IMPORTED_MODULE_24_src_constants_Languages__["a" /* default */].FindByCode(this.props.User.cultureCode);
                this.props.setActiveLanguage(language.code);
            }
            var route = __WEBPACK_IMPORTED_MODULE_21_src_utils_RoleRedirect__["a" /* default */].GetRoleRoute(props.User.roleID, props.User.gradeId);
            if (this.props.Config.previousLocation != null) {
                route = this.props.Config.previousLocation;
                this.props.clearPreviousLocation();
            }
            // With this, we can skip the rendering cost of the login page and just send the user to the proper page
            // Set push to false to remove '/login' from the users history
            return props.history.replace(route);
        }
    };
    Login.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { type: "flex", justify: "center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 22, sm: 22, md: 18, lg: 14, xl: 11, className: "login-form" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_17_src_core_Routes__["a" /* default */].BASE_ROUTE, className: "logo", tabIndex: -1 },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: logo, alt: "Kuder Galaxy", height: "100%", width: "100%", tabIndex: -1 })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { hideRequiredMark: true, onSubmit: this.handleLogin },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["b" /* Translate */], { id: "account.login.header1" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "email" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["b" /* Translate */], { id: "account.login.formItem1" })),
                            this.props.form.getFieldDecorator('email', {
                                rules: [
                                    {
                                        required: true,
                                        message: this.props.translate("admin.common.requiredRule")
                                            .toString()
                                    },
                                    {
                                        pattern: /^.+\@.+\..+$/,
                                        message: this.props.translate("admin.common.emailRule").toString()
                                    }
                                ]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { tabIndex: 1, size: "large", "aria-label": this.props
                                    .translate("account.login.formItem1")
                                    .toString(), placeholder: this.props.translate("account.login.formItem1")
                                    .toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "password" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["b" /* Translate */], { id: "account.login.formItem2" })),
                            this.props.form.getFieldDecorator('password', {
                                rules: [
                                    {
                                        required: true,
                                        message: this.props.translate("admin.common.requiredRule")
                                            .toString()
                                    }
                                ]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { tabIndex: 1, size: "large", "aria-label": this.props
                                    .translate("account.login.formItem2")
                                    .toString(), placeholder: this.props.translate("account.login.formItem2")
                                    .toString(), type: "password" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { tabIndex: 1, loading: this.props.User.state === "loading", size: "large", type: "primary", htmlType: "submit" }, this.props.User.state !== "loading" &&
                                this.props.translate("account.login.loginButton")),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { id: "registerButton", tabIndex: 1, loading: this.props.User.state === "loading", size: "large", type: "primary", onClick: registerLink }, this.props.User.state !== "loading" &&
                                this.props.translate("account.register.registerButton"))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ant-row ant-form-item", id: "cleverButton" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ant-form-item-control-wrapper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "clever-login-container" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", onClick: cleverLink, className: "clever-btn" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "clever-c" }, "C"),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "clever-btn-text" }, "Log in with Clever"))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ant-row ant-form-item", id: "classLinkButton" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "ant-form-item-control-wrapper" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "classlink-login-container" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", onClick: classLinkLink, className: "classlink-btn" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "classlink-c" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: classlinkLogo, alt: "ClassLink", height: "100%", width: "100%" })),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "classlink-btn-text" }, "Log in with ClassLink")))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["Link"], { hidden: true, tabIndex: 1, to: __WEBPACK_IMPORTED_MODULE_17_src_core_Routes__["a" /* default */].REGISTER },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["b" /* Translate */], { id: "account.login.registerLink" })),
                    "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["Link"], { tabIndex: 1, to: __WEBPACK_IMPORTED_MODULE_17_src_core_Routes__["a" /* default */].FORGOT_PASSWORD },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["b" /* Translate */], { id: "account.login.forgotPassword" })),
                    "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["Link"], { tabIndex: 1, to: __WEBPACK_IMPORTED_MODULE_17_src_core_Routes__["a" /* default */].PARENTS_HOME },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["b" /* Translate */], { id: "public.parents.link" })))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cookie-app" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_react_cookie_consent_notification___default.a, { background: '#004A86', bottomPosition: true, buttonText: this.props.translate("account.login.iAgree"), color: '#fff', padding: 20 }, this.props.translate("account.login.cookiePopContent"))),
            ";");
    };
    return Login;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function cleverLink() {
    var link = "https://clever.com/oauth/instant-login?client_id=" + cleverClientId + "&district_id=";
    window.location.href = link;
}
function classLinkLink() {
    var host = window.location.host;
    var protocol = window.location.protocol;
    var redirect_uri = encodeURIComponent(protocol + "//" + host + "/oauth/classlink/");
    var link = "https://launchpad.classlink.com/oauth2/v2/auth?scope=profile,oneroster,openid&redirect_uri=" + redirect_uri + "&response_type=code&client_id=" + classLinkClientId;
    window.location.href = link;
}
function registerLink() {
    var search = window.location.search;
    var params = new URLSearchParams(search);
    var clientId = parseInt(params.get('clientId'));
    var originLink = window.location.origin;
    var link = originLink + "/register-afl?clientId=" + clientId;
    window.location.href = link;
}
function mapDispatchToProps(dispatch) {
    return ({
        login: function (loginModel) { return __WEBPACK_IMPORTED_MODULE_19_src_redux_UserActions__["a" /* default */].Login(dispatch, loginModel); },
        updateUserError: function (msg) { return Object(__WEBPACK_IMPORTED_MODULE_19_src_redux_UserActions__["b" /* updateUserError */])(dispatch, msg); },
        clearPreviousLocation: function () { return __WEBPACK_IMPORTED_MODULE_23_src_redux_ConfigActions__["a" /* default */].SetPreviousLocation(dispatch, null); },
    });
}
function mapStateToProps(state) {
    return {
        User: state.User,
        Constants: state.Constants,
        Config: state.Config,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create()(Login))));


/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(t){var e={};function n(o){if(e[o])return e[o].exports;var r=e[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,o){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(o,r,function(e){return t[e]}.bind(null,r));return o},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/",n(n.s=5)}([function(t,e,n){t.exports=n(3)()},function(t,e){t.exports=__webpack_require__(0)},function(t,e){t.exports=function(t){var e={};function n(o){if(e[o])return e[o].exports;var r=e[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,o){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(o,r,function(e){return t[e]}.bind(null,r));return o},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/",n(n.s=0)}([function(t,e,n){"use strict";function o(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}n.r(e),n.d(e,"Cookie",(function(){return a})),n.d(e,"LocalStorage",(function(){return u})),n.d(e,"SessionStorage",(function(){return s}));var r=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.cookie=e}var e,n;return e=t,(n=[{key:"get",value:function(t){var e=this.cookie.match(new RegExp("(?:^|; )".concat(t.replace(/([.$?*|{}()[\]\\/+^])/g,"\\$1"),"=([^;]*)")));return e?decodeURIComponent(e[1]):void 0}},{key:"set",value:function(t,e,n){var o=new Date;o.setTime(o.getTime()+24*n*60*60*1e3);var r="expires=".concat(o.toUTCString());this.cookie="".concat(t,"=").concat(e,";").concat(r,";path=/")}},{key:"remove",value:function(t){this.set(t,"",-1)}}])&&o(e.prototype,n),t}();function i(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}var c=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.storage=e}var e,n;return e=t,(n=[{key:"set",value:function(t,e){this.storage.setItem(t,"string"==typeof e?e:JSON.stringify(e))}},{key:"get",value:function(t){var e=this.storage.getItem(t),n=e&&(e.indexOf("}")>e.indexOf("{")||e.indexOf("]")>e.indexOf("["))?JSON.parse(e):e;return e?n:null}},{key:"remove",value:function(t){this.storage.removeItem(t)}},{key:"clear",value:function(){this.storage.clear()}},{key:"setObject",value:function(t,e){this.storage.setItem(t,JSON.stringify(e))}},{key:"getObject",value:function(t){return this.storage.getItem(t)?JSON.parse(this.storage.getItem(t)):{}}}])&&i(e.prototype,n),t}(),a=new r(document.cookie),u="undefined"!=typeof localStorage?new c(localStorage):null,s="undefined"!=typeof sessionStorage?new c(sessionStorage):null}])},function(t,e,n){"use strict";var o=n(4);function r(){}function i(){}i.resetWarningCache=r,t.exports=function(){function t(t,e,n,r,i,c){if(c!==o){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:i,resetWarningCache:r};return n.PropTypes=n,n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){"use strict";n.r(e);var o=n(1),r=n.n(o),i=n(0),c=n.n(i),a=n(2);function u(t){return(u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function s(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,o)}return n}function f(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?s(Object(n),!0).forEach((function(e){h(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function l(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function p(t,e){return!e||"object"!==u(e)&&"function"!=typeof e?b(t):e}function b(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function y(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}function d(t){return(d=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function g(t,e){return(g=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function h(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var m={position:"fixed",display:"flex",alignItems:"center",justifyContent:"space-between",right:0,left:0,boxShadow:"0 0 3px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.24)",zIndex:900},v={borderRadius:"3px",boxShadow:"0 0 3px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.24)",whiteSpace:"nowrap",cursor:"pointer"},O=function(t){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&g(t,e)}(u,t);var e,n,o,i,c=(e=u,function(){var t,n=d(e);if(y()){var o=d(this).constructor;t=Reflect.construct(n,arguments,o)}else t=n.apply(this,arguments);return p(this,t)});function u(t){var e;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,u),(e=c.call(this,t)).state={close:!1,widthScreen:1e3,hasStorage:!!a.LocalStorage.get("react-cookie-consent-notification")},e.consentAction=e.consentAction.bind(b(e)),e}return n=u,(o=[{key:"consentAction",value:function(){this.setState({close:!0}),a.LocalStorage.set("react-cookie-consent-notification",!0),this.props.bottomPosition||(document.body.style.marginTop=0),this.props.consentFunction(!0)}},{key:"componentDidMount",value:function(){var t=this;this.setState({widthScreen:document.body.clientWidth},(function(){if(!t.state.hasStorage&&!t.props.bottomPosition){var e=document.getElementById("cookie-consent").offsetHeight;document.body.style.marginTop="".concat(e,"px")}})),this.props.consentFunction(this.state.hasStorage)}},{key:"render",value:function(){if(this.state.hasStorage)return null;var t=this.props,e=t.background,n=t.bottomPosition,o=t.buttonText,i=t.buttonBackground,c=t.buttonColor,a=t.buttonFontSize,u=t.buttonClassName,s=t.children,l=t.className,p=t.color,b=t.padding,y=this.state.close,d=n?{bottom:0}:{top:0},g=this.state.widthScreen<580,h=f({visibility:y?"hidden":"visible",backgroundColor:e,padding:"".concat(b/2,"px"),flexFlow:g?"column":"row",color:p},d,{},m),O=f({backgroundColor:i,color:c,height:"".concat(a,"px"),lineHeight:"".concat(a,"px"),fontSize:"".concat(a,"px"),margin:g?"".concat(b/2,"px 0"):"0 ".concat(b/2,"px"),padding:"".concat(b/2,"px ").concat(b,"px")},v);return r.a.createElement("div",{id:"cookie-consent",className:l,style:l?{}:h},r.a.createElement("div",{style:{padding:"".concat(b/2,"px")}},s),r.a.createElement("div",{id:"cookie-consent-button",onClick:this.consentAction,className:u,style:u?{}:O},o))}}])&&l(n.prototype,o),i&&l(n,i),u}(o.Component);h(O,"propTypes",{background:c.a.string,bottomPosition:c.a.bool,buttonText:c.a.string,buttonBackground:c.a.string,buttonColor:c.a.string,buttonFontSize:c.a.number,buttonClassName:c.a.string,children:c.a.any,className:c.a.string,color:c.a.string,consentFunction:c.a.func,padding:c.a.number}),h(O,"defaultProps",{background:"#fff",bottomPosition:!1,buttonText:"I agree",buttonBackground:"#fff",buttonColor:"#000",buttonFontSize:16,children:"This website uses cookies to improve service, for analytical and advertising purposes.",color:"#000",consentFunction:function(){},padding:20});var S=O;e.default=S}]);

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/60182f5c9e9d2a1f6fead710_classlink-icon-symbol-large.25e0b706.png";

/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_utils_FullscreenHelper__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_core_ConfigureHistory__ = __webpack_require__(337);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var Logout = /** @class */ (function (_super) {
    __extends(Logout, _super);
    function Logout(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_5_src_utils_BindThisHelper__["a" /* default */])(_this, Logout.prototype);
        return _this;
    }
    Logout.prototype.componentDidMount = function () {
        // This will empty to the redux cache and send user to login land
        this.props.logoutUser().then(function () {
            __WEBPACK_IMPORTED_MODULE_8_src_utils_FullscreenHelper__["a" /* default */].CancelFullscreen();
            __WEBPACK_IMPORTED_MODULE_9_src_core_ConfigureHistory__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_6_src_core_Routes__["a" /* default */].LOGIN);
        });
    };
    Logout.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_spin__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "" }))));
    };
    return Logout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        logoutUser: function () { return __WEBPACK_IMPORTED_MODULE_7_src_redux_UserActions__["a" /* default */].LogoutUser(dispatch); },
    });
}
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Logout));


/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_api_AccountApiController__ = __webpack_require__(216);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
























 // 'this' binder


var logo = __webpack_require__(286);

var ForgotPassword = /** @class */ (function (_super) {
    __extends(ForgotPassword, _super);
    function ForgotPassword(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_24_src_utils_BindThisHelper__["a" /* default */])(_this, ForgotPassword.prototype);
        _this.state = {
            isSubmitting: false
        };
        return _this;
    }
    ForgotPassword.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({
                    isSubmitting: true
                });
                __WEBPACK_IMPORTED_MODULE_27_src_api_AccountApiController__["a" /* default */].sendForgotPasswordEmail(values).then(function (result) {
                    _this.setState({
                        isSubmitting: false
                    });
                    __WEBPACK_IMPORTED_MODULE_11_antd_es_message__["a" /* default */].success(_this.props.translate('account.forgotPassword.messageSend'));
                    _this.props.history.push(__WEBPACK_IMPORTED_MODULE_25_src_core_Routes__["a" /* default */].LOGIN);
                });
            }
        });
    };
    ForgotPassword.prototype.renderForm = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */], { hideRequiredMark: true, onSubmit: this.handleSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, this.props.translate('account.forgotPassword.header')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, null, this.props.form.getFieldDecorator('email', {
                rules: [
                    { required: true, message: this.props.translate("admin.common.requiredRule").toString() },
                    { type: 'email', message: this.props.translate("admin.common.emailRule").toString() }
                ]
            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_input__["a" /* default */], { size: "large", placeholder: this.props.translate("account.forgotPassword.formItem1").toString(), type: "email" }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_button__["a" /* default */], { className: "ant-btn ant-btn-lg", loading: this.state.isSubmitting, htmlType: "submit" }, !this.state.isSubmitting && this.props.translate("account.forgotPassword.button1"))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_25_src_core_Routes__["a" /* default */].LOGIN },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_button__["a" /* default */], { className: "ant-btn ant-btn-lg" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26_react_localize_redux__["b" /* Translate */], { id: "account.forgotPassword.button2" })))));
    };
    ForgotPassword.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_antd_es_row__["a" /* default */], { type: "flex", justify: "center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_antd_es_col__["a" /* default */], { xs: 22, sm: 22, md: 18, lg: 14, xl: 11, className: "login-form" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_25_src_core_Routes__["a" /* default */].BASE_ROUTE, className: "logo" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: logo, alt: "Kuder Galaxy" })),
                    this.renderForm())));
    };
    return ForgotPassword;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_26_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].create()(ForgotPassword)));


/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Login_less__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Login_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Login_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_api_AccountApiController__ = __webpack_require__(216);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

























 // 'this' binder



var logo = __webpack_require__(286);
var ResetPassword = /** @class */ (function (_super) {
    __extends(ResetPassword, _super);
    function ResetPassword(props) {
        var _this = _super.call(this, props) || this;
        _this.compareToFirstPassword = function (rule, value, callback) {
            if (value && value !== _this.props.form.getFieldValue('newPassword')) {
                callback(_this.props.translate('account.resetPassword.saveTooltip').toString());
            }
            else {
                callback();
            }
        };
        _this.validateToNextPassword = function (rule, value, callback) {
            if (_this.props.form.getFieldValue('confirmPassword')) {
                _this.props.form.validateFields(['confirmPassword'], { force: true }, function (errors, values) { return console.log('Revalidating'); });
            }
            callback();
        };
        Object(__WEBPACK_IMPORTED_MODULE_25_src_utils_BindThisHelper__["a" /* default */])(_this, ResetPassword.prototype);
        _this.state = {
            isSubmitting: false
        };
        return _this;
    }
    ResetPassword.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.props.form.validateFields(function (error, values) {
            if (!error) {
                _this.setState({
                    isSubmitting: true
                });
                var userId = parseInt(_this.props.match.params.userId, 10);
                var resetPasswordId = _this.props.match.params.resetPasswordId;
                var resetPasswordDTO = __assign(__assign({}, values), { "userId": userId, "resetPasswordId": resetPasswordId });
                __WEBPACK_IMPORTED_MODULE_28_src_api_AccountApiController__["a" /* default */].selfServePasswordReset(resetPasswordDTO).then(function (result) {
                    _this.setState({
                        isSubmitting: true
                    });
                    __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].success(_this.props.translate('account.resetPassword.messageReset'));
                    _this.props.history.push(__WEBPACK_IMPORTED_MODULE_26_src_core_Routes__["a" /* default */].LOGIN);
                });
            }
        });
    };
    ResetPassword.prototype.render = function () {
        var passwordMinLength = 8;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_row__["a" /* default */], { type: "flex", justify: "center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_antd_es_col__["a" /* default */], { xs: 22, sm: 22, md: 18, lg: 14, xl: 11, className: "login-form" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__["a" /* default */].BASE_ROUTE, className: "logo", tabIndex: -1 },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: logo, alt: "Kuder Galaxy", height: "100%", width: "100%", tabIndex: -1 })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { hideRequiredMark: true, onSubmit: this.handleSubmit },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, this.props.translate('account.resetPassword.header')),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null, this.props.form.getFieldDecorator('newPassword', {
                            rules: [
                                { required: true, message: this.props.translate("admin.common.requiredRule").toString() },
                                { min: passwordMinLength, message: this.props.translate("admin.common.minLengthRule").toString() + passwordMinLength },
                                { validator: this.validateToNextPassword }
                            ]
                        })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { type: "password", size: "large", placeholder: this.props.translate("account.resetPassword.formItem1").toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null, this.props.form.getFieldDecorator('confirmPassword', {
                            rules: [
                                { required: true, message: this.props.translate("admin.common.requiredRule").toString() },
                                { validator: this.compareToFirstPassword }
                            ]
                        })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_input__["a" /* default */], { type: "password", size: "large", placeholder: this.props.translate("account.resetPassword.formItem2").toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { loading: this.state.isSubmitting, size: "large", type: "primary", htmlType: "submit" }, !this.state.isSubmitting && this.props.translate("account.resetPassword.button1")))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_26_src_core_Routes__["a" /* default */].LOGIN },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_button__["a" /* default */], { className: "ant-btn ant-btn-lg" }, this.props.translate("account.resetPassword.button2")))))));
    };
    return ResetPassword;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_27_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create()(ResetPassword)));


/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_ExampleActions__ = __webpack_require__(2196);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ReduxTest = /** @class */ (function (_super) {
    __extends(ReduxTest, _super);
    function ReduxTest(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ReduxTest.prototype);
        return _this;
    }
    ReduxTest.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "Hey you just made the ReduxTest component, woot!"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, "Counter "),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, this.props.count)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_button__["a" /* default */], { type: "primary", onClick: function () { return _this.props.addItems(42); } }, "Increment"))));
    };
    return ReduxTest;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        addItems: function (newCount) { return Object(__WEBPACK_IMPORTED_MODULE_5__redux_ExampleActions__["a" /* updateUserCounter */])(dispatch, newCount); }
    });
}
function mapStateToProps(state) {
    return {
        count: state.User.cultureId
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ReduxTest));


/***/ }),
/* 2196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateUserCounter;
// User helper method
function updateUserCounter(dispatch, count) {
    dispatch(addCounterAction(count));
}
// Private helper method
function addCounterAction(count) {
    return {
        type: "ADD_COUNT",
        data: count
    };
}


/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MultilingualTest = /** @class */ (function (_super) {
    __extends(MultilingualTest, _super);
    function MultilingualTest(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, MultilingualTest.prototype);
        return _this;
    }
    MultilingualTest.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "Here's some title"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "greeting" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "example.farewell" })));
    };
    return MultilingualTest;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (MultilingualTest);


/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var VideoExample = /** @class */ (function (_super) {
    __extends(VideoExample, _super);
    function VideoExample(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, VideoExample.prototype);
        return _this;
    }
    VideoExample.prototype.render = function () {
        var subtitles = [
        // { src: require("src/assets/online-assets/video/jellies.vtt"), kind: "subtitles", srcLang: "en-US", label: "English" },
        // { src: require("src/assets/online-assets/video/jellies.vtt"), kind: "subtitles", srcLang: "en-AU", label: "Aus English" }
        ];
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "Hey you just made the VideoExample component, woot!"));
    };
    return VideoExample;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (VideoExample);


/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_pages_examples_FormTestSimpleForm__ = __webpack_require__(2200);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








// import FormTestForm, { UpdateThingDTO } from "src/pages/examples/FormTestForm";

var FormTest = /** @class */ (function (_super) {
    __extends(FormTest, _super);
    function FormTest(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, FormTest.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    FormTest.prototype.onSubmit = function (values) {
        console.warn("Form Submitted!", values); // JB - Remove this console.warn
    };
    FormTest.prototype.render = function () {
        // let values = {
        //     username: "potato",
        //     password: "pass",
        //     subMember: {
        //         name: "blah blah blah",
        //         value: "Nope!",
        //     },
        //     isActive: false
        // } as UpdateThingDTO;
        var values = {
            username: "potato",
            password: "pass",
            isActive: false,
            age: 25,
        };
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "Just Showing the things"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_src_pages_examples_FormTestSimpleForm__["a" /* default */], { values: values, onSubmit: this.onSubmit }));
    };
    return FormTest;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FormTest);


/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UpdateThingDTO */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_utils_NameOf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_utils_ObjectUtil__ = __webpack_require__(364);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var UpdateThingDTO = /** @class */ (function () {
    function UpdateThingDTO() {
    }
    return UpdateThingDTO;
}());

var FormTestSimpleForm = /** @class */ (function (_super) {
    __extends(FormTestSimpleForm, _super);
    function FormTestSimpleForm(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, FormTestSimpleForm.prototype);
        _this.state = {
            formData: {},
        };
        return _this;
    }
    FormTestSimpleForm.prototype.onSubmit = function (values) {
        this.props.onSubmit(values);
    };
    FormTestSimpleForm.prototype.onChange = function (values) {
        console.warn("Receiving onChange"); // JB - Remove this console.warn
        this.setState({
            formData: __WEBPACK_IMPORTED_MODULE_14_src_utils_ObjectUtil__["a" /* default */].DeepMergeObjects(this.state.formData, values),
        });
    };
    FormTestSimpleForm.prototype.render = function () {
        var _this = this;
        var formData = this.state.formData || {};
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_col__["a" /* default */], { span: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["c" /* AntFormSimple */], { onChange: function (x) { return _this.onChange(x); }, onSubmit: function (x) { return _this.onSubmit(x); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["a" /* AntFormItems */].Input, { uniqueId: Object(__WEBPACK_IMPORTED_MODULE_12_src_utils_NameOf__["a" /* NameOf */])("username"), label: "Username", initialValue: this.props.values.username }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["a" /* AntFormItems */].Input, { uniqueId: Object(__WEBPACK_IMPORTED_MODULE_12_src_utils_NameOf__["a" /* NameOf */])("password"), label: "Password", type: "password", rules: [
                            __WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["b" /* AntFormRules */].Required("Required!!"),
                            __WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["b" /* AntFormRules */].Min(3, "Must have a length of 3"),
                            __WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["b" /* AntFormRules */].Max(7, "Must have a length less than 7"),
                        ] }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["a" /* AntFormItems */].Input, { uniqueId: Object(__WEBPACK_IMPORTED_MODULE_12_src_utils_NameOf__["a" /* NameOf */])("confirmPassword"), label: "Password Again", type: "password", rules: [__WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["b" /* AntFormRules */].Exact(formData.password, "Must match Real Password")] }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["a" /* AntFormItems */].Input, { uniqueId: Object(__WEBPACK_IMPORTED_MODULE_12_src_utils_NameOf__["a" /* NameOf */])("age"), label: "Password Again", initialValue: this.props.values.age, rules: [__WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["b" /* AntFormRules */].Number("Must be a Number")] }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_src_utils_formUtil_Form__["a" /* AntFormItems */].SubmitButton, null, "Submit!"))));
    };
    return FormTestSimpleForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FormTestSimpleForm);


/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WhoAmI_less__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WhoAmI_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__WhoAmI_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_radio__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_radio_style_index_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_redux_CheckpointActions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_constants_Checkpoints__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_utils_DebugUtil__ = __webpack_require__(87);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};























var WhoAmI = /** @class */ (function (_super) {
    __extends(WhoAmI, _super);
    function WhoAmI(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, WhoAmI.prototype);
        _this.state = {
            isLoading: true
        };
        return _this;
    }
    WhoAmI.prototype.componentDidMount = function () {
        var locationState = this.props.location.state;
        if (locationState != null) {
            this.props.setLogin(__assign(__assign({}, this.props.User), { gradeId: locationState.gradeId }));
            this.props.setCheckpoint(__assign(__assign({}, this.props.Mission), { current: __assign(__assign({}, this.props.Mission.current), { planetId: locationState.planetId, checkpointId: locationState.checkpointId }), currentDirection: "forwards" }));
        }
        else {
            this.persistChanges();
        }
        this.setState({
            isLoading: false
        });
    };
    WhoAmI.prototype.handleGradeChange = function (value) {
        this.props.setLogin(__assign(__assign({}, this.props.User), { gradeId: value.target.value }));
        this.persistChanges();
    };
    WhoAmI.prototype.handlePlanetChange = function (value) {
        this.props.setCheckpoint(__assign(__assign({}, this.props.Mission), { current: __assign(__assign({}, this.props.Mission.current), { planetId: value.target.value }), currentDirection: "forwards" }));
        this.persistChanges();
    };
    WhoAmI.prototype.handleCheckpointChange = function (value) {
        this.props.setCheckpoint(__assign(__assign({}, this.props.Mission), { current: __assign(__assign({}, this.props.Mission.current), { checkpointId: value.target.value }), currentDirection: "forwards" }));
        this.persistChanges();
    };
    WhoAmI.prototype.persistChanges = function () {
        var _this = this;
        setTimeout(function () {
            _this.props.history.push({
                pathname: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].WHO_AM_I,
                state: {
                    gradeId: _this.props.User.gradeId,
                    planetId: _this.props.Mission.current.planetId,
                    checkpointId: _this.props.Mission.current.checkpointId
                }
            });
        }, 100);
    };
    WhoAmI.prototype.hardRefresh = function () {
        this.props.history.replace({
            pathname: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].WHO_AM_I,
            state: {}
        });
        window.location.reload();
    };
    WhoAmI.prototype.renderGrades = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Group, { value: __WEBPACK_IMPORTED_MODULE_18_src_constants_Grades__["a" /* Grades */].FindById(this.props.User.gradeId).id, onChange: this.handleGradeChange, buttonStyle: "solid" }, __WEBPACK_IMPORTED_MODULE_18_src_constants_Grades__["a" /* Grades */].All.map(function (grade) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Button, { value: grade.id, key: grade.id }, grade.name); }));
    };
    WhoAmI.prototype.renderPlanet = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Group, { value: __WEBPACK_IMPORTED_MODULE_19_src_constants_Planets__["a" /* Planets */].FindById(this.props.Mission.current.planetId).id, onChange: this.handlePlanetChange, buttonStyle: "solid" }, __WEBPACK_IMPORTED_MODULE_19_src_constants_Planets__["a" /* Planets */].All.map(function (planet) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Button, { value: planet.id, key: planet.id }, planet.name); }));
    };
    WhoAmI.prototype.renderCheckpoint = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Group, { value: __WEBPACK_IMPORTED_MODULE_20_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(this.props.Mission.current.checkpointId).id, onChange: this.handleCheckpointChange, buttonStyle: "solid" }, __WEBPACK_IMPORTED_MODULE_20_src_constants_Checkpoints__["a" /* Checkpoints */].All.map(function (checkpoint) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_radio__["c" /* default */].Button, { value: checkpoint.id, key: checkpoint.id }, checkpoint.name); }));
    };
    WhoAmI.prototype.renderGrid = function () {
        var items = [
            { name: "Name", value: this.props.User.lastName + ", " + this.props.User.firstName },
            { name: "Email", value: this.props.User.email },
            { name: "Role", value: __WEBPACK_IMPORTED_MODULE_21_src_constants_Roles__["a" /* Roles */].FindById(this.props.User.roleID).name },
            { name: "Grade", value: this.renderGrades() },
            { name: "Planet", value: this.renderPlanet() },
            { name: "Checkpoint", value: this.renderCheckpoint() },
        ];
        return items.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "gridlines", key: item.name },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 6 }, item.name),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 18 }, item.value));
        });
    };
    WhoAmI.prototype.render = function () {
        if (!__WEBPACK_IMPORTED_MODULE_22_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].PAGE_NOT_FOUND });
        }
        if (this.state.isLoading) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "whoami" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "Welcome to the Who Am I? Page!"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "This page will allow you to temporarily change your user information. These are not persisted, so experiment away!"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Note: Changing checkpoints/planets will not immediately update. However, browsing the student pages will cause the changes to persist"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("b", null, "Page will now hold onto the selected items below, if you refresh from this page")),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 18 }, this.renderGrid()),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].WHO_AM_I, onClick: this.hardRefresh },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_icon__["a" /* default */], { type: "profile", theme: "twoTone" }),
                            " Hard Refresh")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].ADMIN_CLIENTS },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_icon__["a" /* default */], { type: "profile" }),
                            " Admin Home")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].STUDENT_HOME },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_icon__["a" /* default */], { type: "profile" }),
                            " Student Home")))));
    };
    return WhoAmI;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        setLogin: function (request) { return __WEBPACK_IMPORTED_MODULE_16_src_redux_UserActions__["a" /* default */].SetLogin(dispatch, request); },
        setCheckpoint: function (request) { return __WEBPACK_IMPORTED_MODULE_17_src_redux_CheckpointActions__["a" /* default */].Debug_SetCheckpoint(dispatch, request); },
    });
}
function mapStateToProps(state) {
    return {
        User: state.User,
        Mission: state.Mission,
        Constants: state.Constants
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(WhoAmI));


/***/ }),
/* 2202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Diagnostics_less__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Diagnostics_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Diagnostics_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_collapse__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_es_collapse_style_index_js__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_redux_CheckpointActions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_constants_Checkpoints__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_constants_Games__ = __webpack_require__(15);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};






























var Option = __WEBPACK_IMPORTED_MODULE_10_antd_es_select__["a" /* default */].Option;
var Diagnostics = /** @class */ (function (_super) {
    __extends(Diagnostics, _super);
    function Diagnostics(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, Diagnostics.prototype);
        _this.state = {
            jsonBoxText: "",
            jsonBoxResultText: "",
            jsonKeepValues: true,
            intersectLeftText: "",
            intersectRightText: "",
            intersectResult: "",
            differenceLeft: "",
            differenceRight: ""
        };
        return _this;
    }
    Diagnostics.prototype.handleJsonCheckboxChange = function (e) {
        this.setState({
            jsonKeepValues: e.target.checked
        });
    };
    Diagnostics.prototype.handleJsonChange = function (e) {
        this.setState({
            jsonBoxText: e.target.value
        });
    };
    Diagnostics.prototype.handleResultJsonChange = function (e) {
        this.setState({
            jsonBoxResultText: e.target.value
        });
    };
    Diagnostics.prototype.handleIntersectLeftChange = function (e) {
        this.setState({
            intersectLeftText: e.target.value
        });
    };
    Diagnostics.prototype.handleIntersectRightChange = function (e) {
        this.setState({
            intersectRightText: e.target.value
        });
    };
    Diagnostics.prototype.squishJson = function (input, includeValues) {
        if (input == null || input.length < 1) {
            return;
        }
        var json = this.messyToClean(input);
        var output = this.squishJsonInternal(json, includeValues).join('\n');
        this.setState({
            jsonBoxResultText: output,
        });
    };
    Diagnostics.prototype.squishJsonInternal = function (obj, includeValues, root) {
        if (root === void 0) { root = null; }
        if (obj == null) {
            return [];
        }
        var keys = Reflect.ownKeys(obj);
        var output = [];
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var subObj = obj[key];
            if (subObj != null && typeof subObj === 'object') {
                var result = this.squishJsonInternal(subObj, includeValues, root == null ? "" + key.toString() : root + "." + key.toString());
                output = __spreadArrays(output, result);
            }
            else {
                output.push((root == null ? "" + key.toString() : root + "." + key.toString()) + " " + (includeValues ? subObj : ""));
            }
        }
        return output;
    };
    Diagnostics.prototype.unsquishJson = function (input, includeValues) {
        var output;
        // Try to split on newlines
        var jsons = input.split('\n');
        output = this.unsquishJsonInternal(jsons, includeValues);
        this.setState({
            jsonBoxText: JSON.stringify(output, null, 2)
        });
    };
    Diagnostics.prototype.unsquishJsonInternal = function (jsons, includeValues) {
        // Inspiration taken from here
        // https://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference
        var newObj = new Object();
        if (jsons == null || jsons.length < 1) {
            return [];
        }
        for (var _i = 0, jsons_1 = jsons; _i < jsons_1.length; _i++) {
            var json = jsons_1[_i];
            var object = newObj;
            var value = json.includes(' ') ? json.substring(json.indexOf(' ')).trim() : "";
            var splits = json.includes(' ') ? json.substring(0, json.indexOf(' ')).trim().split('.') : json.trim().split('.');
            for (var i = 0; i < splits.length - 1; i++) {
                var sup = object[splits[i]];
                if (sup == null) {
                    object = object[splits[i]] = {};
                }
                else {
                    object = object[splits[i]];
                }
            }
            object[splits[splits.length - 1]] = includeValues ? value : "";
        }
        return newObj;
    };
    Diagnostics.prototype.messyToClean = function (json) {
        if (json == null || json.length < 3) {
            return null;
        }
        // Ensure property names are wrapped in quotes
        var cleanedJson = json.trim().split('\n').map(function (x) {
            var t = x.trim();
            if (!t.includes(':')) {
                return t;
            }
            if (t.slice(0, 1) !== "\"") {
                var first = t.substring(0, t.indexOf(':')).trim();
                var second = t.substring(t.indexOf(':') + 1).trim();
                return "\"" + first + "\": " + second;
            }
            return t;
        }).join('\n');
        return this.messyToCleanInternal(cleanedJson);
    };
    Diagnostics.prototype.messyToCleanInternal = function (json, retry) {
        if (retry === void 0) { retry = 10; }
        if (retry < 1) {
            return null;
        }
        try {
            var result = JSON.parse(json);
            return result;
        }
        catch (error) {
            // Attempt some cleanup
            // Sometimes we are missing the braces all around the json
            if (json.slice(0, 1) !== '{') {
                var result = this.messyToCleanInternal("{" + json, retry - 1);
                if (result != null) {
                    return result;
                }
            }
            // Sometimes we have an extra ',' at the end
            if (json.slice(-1) === ',') {
                var result = this.messyToCleanInternal(json.slice(0, -1), retry - 1);
                if (result != null) {
                    return result;
                }
            }
            // Maybe we just need more braces
            return this.messyToCleanInternal(json + "}", retry - 1);
        }
    };
    Diagnostics.prototype.intersectArrays = function (left, right) {
        if (left == null || right == null || left.length < 1 || right.length < 1) {
            return;
        }
        // Split, remove whitespace, remove empty
        var leftArray = left.split('\n').map(function (x) { return x.trim(); }).filter(function (x) { return x; });
        var rightArray = right.split('\n').map(function (x) { return x.trim(); }).filter(function (x) { return x; });
        var intersection = leftArray.filter(function (x) { return rightArray.includes(x); });
        var differenceLeft = leftArray.filter(function (x) { return !rightArray.includes(x); });
        var differenceRight = rightArray.filter(function (x) { return !leftArray.includes(x); });
        // Remove duplicates
        intersection = intersection.filter(function (e, i, c) { return c.indexOf(e) === i; });
        differenceLeft = differenceLeft.filter(function (e, i, c) { return c.indexOf(e) === i; });
        differenceRight = differenceRight.filter(function (e, i, c) { return c.indexOf(e) === i; });
        this.setState({
            intersectResult: intersection.join('\n'),
            differenceLeft: differenceLeft.join('\n'),
            differenceRight: differenceRight.join('\n'),
        });
    };
    Diagnostics.prototype.renderIds = function (user) {
        var state = "";
        var district = "";
        var school = "";
        if (user.stateId != null) {
            state = "State: " + user.stateId;
        }
        if (user.districtId != null) {
            district = "District: " + user.districtId;
        }
        if (user.schoolId != null) {
            school = "School: " + user.schoolId;
        }
        return state + " " + district + " " + school;
    };
    Diagnostics.prototype.renderGameGuide = function () {
        return __WEBPACK_IMPORTED_MODULE_29_src_constants_Games__["a" /* Games */].All
            .sort(function (a, b) { return b.grade.level - a.grade.level || a.planet.order - b.planet.order; })
            .map(function (game) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 6 }, game.grade.name),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 6 }, game.planet.name),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 6 }, "" + game.grade.shortName + game.planet.name),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 6 }, game.name))); });
    };
    Diagnostics.prototype.render = function () {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_28_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].PAGE_NOT_FOUND });
        }
        var user = this.props.ReduxState.User;
        var mission = this.props.ReduxState.Mission;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "diagnostics" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "Welcome to the Diagnostics Page"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "This page will show diagnostic information from your login, the project, translations and maybe some other stuff when I get around to it"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], { gutter: 16 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { xs: 24, xl: 12 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_collapse__["a" /* default */], { defaultActiveKey: ['3'], onChange: function () { } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_collapse__["a" /* default */].Panel, { header: "Json Squisher", key: "1" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], { className: "collapsed-grid" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Changes json to and from dot notation"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 12 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Json Squish"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_input__["a" /* default */].TextArea, { autosize: { minRows: 8, maxRows: 24 }, value: this.state.jsonBoxText, onChange: function (e) { return _this.handleJsonChange(e); } }),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_button__["a" /* default */], { onClick: function () { return _this.squishJson(_this.state.jsonBoxText, _this.state.jsonKeepValues); } }, "Squish"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_antd_es_checkbox__["a" /* default */], { checked: this.state.jsonKeepValues, onChange: function (e) { return _this.handleJsonCheckboxChange(e); } }, "Retain Values")),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 12 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Json Un-Squish"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_input__["a" /* default */].TextArea, { autosize: { minRows: 8, maxRows: 24 }, value: this.state.jsonBoxResultText, onChange: function (e) { return _this.handleResultJsonChange(e); } }),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_button__["a" /* default */], { onClick: function () { return _this.unsquishJson(_this.state.jsonBoxResultText, _this.state.jsonKeepValues); } }, "UnSquish")))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_collapse__["a" /* default */].Panel, { header: "Array Intersect", key: "2" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], { className: "collapsed-grid" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Outputs values that are in both lists. Supports only lists, items separated by new line (\\n)"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 12 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Left Source"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_input__["a" /* default */].TextArea, { autosize: { minRows: 8, maxRows: 16 }, value: this.state.intersectLeftText, onChange: function (e) { return _this.handleIntersectLeftChange(e); } })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 12 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Right Source"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_input__["a" /* default */].TextArea, { autosize: { minRows: 8, maxRows: 16 }, value: this.state.intersectRightText, onChange: function (e) { return _this.handleIntersectRightChange(e); } }),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_button__["a" /* default */], { onClick: function () { return _this.intersectArrays(_this.state.intersectLeftText, _this.state.intersectRightText); } }, "Do the Check"))),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 8 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Left Only"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_input__["a" /* default */].TextArea, { autosize: { minRows: 8, maxRows: 24 }, value: this.state.differenceLeft, readOnly: true })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 8 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Both"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_input__["a" /* default */].TextArea, { autosize: { minRows: 8, maxRows: 24 }, value: this.state.intersectResult, readOnly: true })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 8 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Right Only"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_input__["a" /* default */].TextArea, { autosize: { minRows: 8, maxRows: 24 }, value: this.state.differenceRight, readOnly: true })))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { xs: 24, xl: 12 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_collapse__["a" /* default */], { defaultActiveKey: ['2'], onChange: function () { } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_collapse__["a" /* default */].Panel, { header: "Full User Info (Raw Output)", key: "1" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], { className: "collapsed-grid" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 8 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Name"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Email"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "IsEmulating?"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "State/District/School Ids"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Cultures"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Role"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Grade"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Planet"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "Checkpoint")),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 16, className: "gridlines" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, user.lastName + ", " + user.firstName),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, user.email),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "" + user.isEmulating),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, this.renderIds(user)),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, "CultureId: " + user.cultureId + " CultureCode: " + user.cultureCode),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_27_src_constants_Roles__["a" /* Roles */].FindById(user.roleID).name),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_24_src_constants_Grades__["a" /* Grades */].FindById(user.gradeId).name),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_25_src_constants_Planets__["a" /* Planets */].FindById(mission.current.planetId).name),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_26_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(mission.current.checkpointId).name)))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_es_collapse__["a" /* default */].Panel, { header: "Game/Planet Guide", key: "2" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { className: "collapsed-grid" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_row__["a" /* default */], null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 6 }, "Grade"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 6 }, "Planet"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 6 }, "Combo"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_col__["a" /* default */], { span: 6 }, "Game")),
                                this.renderGameGuide()))))));
    };
    return Diagnostics;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        setLogin: function (request) { return __WEBPACK_IMPORTED_MODULE_22_src_redux_UserActions__["a" /* default */].SetLogin(dispatch, request); },
        setCheckpoint: function (request) { return __WEBPACK_IMPORTED_MODULE_23_src_redux_CheckpointActions__["a" /* default */].Debug_SetCheckpoint(dispatch, request); }
    });
}
function mapStateToProps(state) {
    return {
        // Note: You would not normally do this, do not copy this around the project
        ReduxState: state,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Diagnostics));


/***/ }),
/* 2204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TextBoxConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameIntroTextBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var TextBoxConfig = /** @class */ (function () {
    function TextBoxConfig() {
        this.padding = 20;
    }
    return TextBoxConfig;
}());

var GameIntroTextBox = /** @class */ (function (_super) {
    __extends(GameIntroTextBox, _super);
    function GameIntroTextBox(scene, ob, config) {
        var _this = _super.call(this, scene, ob.x, ob.y, []) || this;
        _this.obWidth = ob.width;
        _this.config = config;
        _this.createBox();
        scene.add.existing(_this);
        return _this;
    }
    GameIntroTextBox.prototype.createBox = function () {
        var _this = this;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_1__ColorValue__["a" /* Color */].PLANET_COLORS.get(this.config.hollandCode.toUpperCase());
        var verticalSpacing = this.config.padding;
        var paragraphSpacing = 5;
        this.paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: this.config.fontSize, padding: 10 };
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.config.translationKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.scene.add.text(_this.config.padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(_this.obWidth - 2 * _this.config.padding, true);
            _this.paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            _this.setSize(Math.max(_this.obWidth, paragraph.width), verticalSpacing);
        });
        // Back button
        if (this.config.onBack != null) {
            this.backButton = __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* PhaserButton */].createQuickBackButton(this.scene, this.config.padding + textStyle.padding, 0);
            this.backButton.setName("back");
            this.backButton.setVisible(false);
            this.backButton.on('buttonClicked', function () {
                _this.config.onBack();
            });
        }
        // Next Button
        this.nextButton = __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* PhaserButton */].createQuickNextButton(this.scene, 0, 0);
        this.nextButton.getBackground().setTint(__WEBPACK_IMPORTED_MODULE_1__ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON);
        this.setSize(this.width, this.height + this.nextButton.displayHeight + 2 * this.config.padding);
        this.nextButton.on('buttonClicked', function () {
            _this.config.onNext();
        });
        this.nextButton.setY(this.displayHeight - this.nextButton.displayHeight - this.config.padding);
        if (this.backButton != null) {
            this.backButton.setY(this.displayHeight - this.backButton.displayHeight - this.config.padding);
        }
        // Add text box background
        this.background = this.scene.add.image(0, 0, "pixel");
        this.background.setOrigin(0);
        this.background.setDisplaySize(this.displayWidth, this.displayHeight);
        this.background.setTint(0x000000);
        this.background.setPosition(borderWidth + this.config.padding + textStyle.padding, borderWidth + this.config.padding + textStyle.padding);
        // Add text box border
        this.border = this.scene.add.image(0, 0, "pixel");
        this.border.setOrigin(0);
        this.border.setDisplaySize(this.background.displayWidth + 2 * borderWidth, this.background.displayHeight + 2 * borderWidth);
        this.border.setTint(borderColor);
        this.background.setPosition(borderWidth, borderWidth);
        this.nextButton.setX(this.border.getBounds().right - this.nextButton.displayWidth - this.config.padding - textStyle.padding);
        this.add(this.border);
        this.add(this.background);
        this.add(this.paragraphs);
        if (this.backButton != null) {
            this.add(this.backButton);
        }
        this.add(this.nextButton);
        this.setDepth(2);
    };
    // The button is a little off for some reason, so not using this.
    GameIntroTextBox.prototype.updateBox = function (newKey, backButtonVisibility) {
        var _this = this;
        this.paragraphs.forEach(function (p) { return p.destroy(); });
        this.paragraphs = [];
        var borderWidth = 10;
        var verticalSpacing = this.config.padding;
        var paragraphSpacing = 5;
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: this.config.fontSize, padding: 10 };
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(newKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.scene.add.text(_this.config.padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(_this.obWidth - 2 * _this.config.padding, true);
            _this.paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            _this.setSize(Math.max(_this.obWidth, paragraph.width), verticalSpacing);
        });
        this.add(this.paragraphs);
        this.setSize(this.width, this.height + this.backButton.displayHeight + 2 * this.config.padding);
        this.backButton.setY(this.displayHeight - this.backButton.displayHeight - this.config.padding);
        this.backButton.visible = backButtonVisibility;
        this.nextButton.setY(this.displayHeight - this.nextButton.displayHeight - this.config.padding);
        this.background.setDisplaySize(this.displayWidth, this.displayHeight);
        this.background.setPosition(borderWidth + this.config.padding + textStyle.padding, borderWidth + this.config.padding + textStyle.padding);
        this.border.setDisplaySize(this.background.displayWidth + 2 * borderWidth, this.background.displayHeight + 2 * borderWidth);
        this.background.setPosition(borderWidth, borderWidth);
        this.nextButton.setX(this.border.getBounds().right - this.nextButton.displayWidth - this.config.padding - textStyle.padding);
        var audio = this.scene.sound.add(newKey);
        audio.play();
    };
    return GameIntroTextBox;
}(Phaser.GameObjects.Container));



/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(852);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Landscaping;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "Landscaping.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Landscaping.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "Landscaping.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InstructionsTextBoxConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameInstructionsTextBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var InstructionsTextBoxConfig = /** @class */ (function () {
    function InstructionsTextBoxConfig() {
        this.padding = 20;
    }
    return InstructionsTextBoxConfig;
}());

var GameInstructionsTextBox = /** @class */ (function (_super) {
    __extends(GameInstructionsTextBox, _super);
    function GameInstructionsTextBox(scene, ob, config) {
        var _this = _super.call(this, scene, ob.x, ob.y, []) || this;
        _this.obWidth = ob.width;
        _this.config = config;
        _this.createBox();
        scene.add.existing(_this);
        return _this;
    }
    GameInstructionsTextBox.prototype.createBox = function () {
        var _this = this;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_1__ColorValue__["a" /* Color */].PLANET_COLORS.get(this.config.hollandCode.toUpperCase());
        var verticalSpacing = this.config.padding;
        var paragraphSpacing = 5;
        this.paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: this.config.fontSize, padding: 10 };
        // Add all the paragraphs to one big textbox
        this.config.translationKeys.forEach(function (key) {
            var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(key);
            // Split the translated text by newlines to create paragraphs
            translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
                var paragraph = _this.scene.add.text(_this.config.padding, verticalSpacing, para, textStyle);
                paragraph.setWordWrapWidth(_this.obWidth - 2 * _this.config.padding, true);
                _this.paragraphs.push(paragraph);
                verticalSpacing += paragraph.height + paragraphSpacing;
                _this.setSize(Math.max(_this.obWidth, paragraph.width), verticalSpacing);
            });
        });
        // Back button
        this.backButton = __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* PhaserButton */].createQuickBackButton(this.scene, this.config.padding + textStyle.padding, 0);
        this.backButton.setName("back");
        this.backButton.tabIndex = 1;
        this.backButton.on('buttonClicked', function () {
            _this.config.onBack();
        });
        // Next Button
        this.startGameButton = new __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* PhaserButton */](this.scene, 0, 0, 300, 100, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("common.startGame"), __WEBPACK_IMPORTED_MODULE_0__Button__["b" /* PhaserButtonConfig */].NextButtonConfig);
        this.startGameButton.tabIndex = 1;
        this.setSize(this.width, this.height + this.startGameButton.displayHeight + 2 * this.config.padding);
        this.startGameButton.on('buttonClicked', function () {
            _this.config.onStartGame();
        });
        this.startGameButton.setY(this.displayHeight - this.startGameButton.displayHeight - this.config.padding);
        if (this.backButton != null) {
            this.backButton.setY(this.displayHeight - this.backButton.displayHeight - this.config.padding);
        }
        // Add text box background
        this.background = this.scene.add.image(0, 0, "pixel");
        this.background.setOrigin(0);
        this.background.setDisplaySize(this.displayWidth, this.displayHeight);
        this.background.setTint(0x000000);
        this.background.setPosition(borderWidth + this.config.padding + textStyle.padding, borderWidth + this.config.padding + textStyle.padding);
        // Add text box border
        this.border = this.scene.add.image(0, 0, "pixel");
        this.border.setOrigin(0);
        this.border.setDisplaySize(this.background.displayWidth + 2 * borderWidth, this.background.displayHeight + 2 * borderWidth);
        this.border.setTint(borderColor);
        this.background.setPosition(borderWidth, borderWidth);
        this.startGameButton.setX(this.border.getBounds().right - this.startGameButton.displayWidth - this.config.padding - textStyle.padding);
        this.add(this.border);
        this.add(this.background);
        this.add(this.paragraphs);
        this.add(this.backButton);
        this.add(this.startGameButton);
        this.setDepth(2);
    };
    GameInstructionsTextBox.prototype.createKeyboardInstructionsButton = function () {
        var _this = this;
        var config = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_1__ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON,
            smartSize: true
        };
        // Button to show keyboard instructions
        var keyboardButton = new __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* PhaserButton */](this.scene, 0, 0, 300, 50, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("public.keyboardInstructions"), config);
        // Hide this textbox show another one with they keyboard instructions
        keyboardButton.on('buttonClicked', function () {
            _this.config.onKeyboardInstructions();
        });
    };
    return GameInstructionsTextBox;
}(Phaser.GameObjects.Container));



/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_Zone__ = __webpack_require__(2212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_Item__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__objects_Deadzone__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










//import { EndGameScene } from "src/games/LandscapingGame/scenes/EndGameScene";

var ScoreObject = /** @class */ (function () {
    function ScoreObject() {
    }
    return ScoreObject;
}());
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.speed = 0;
        _this.scores = [];
        _this.scoreTiles = [];
        _this.deadZones = [];
        _this.xVel = 0;
        _this.yVel = 0;
        _this.translateString = "Landscaping.Phaser.MainScene.";
        _this.WALKING_SPEED = 100;
        _this.DRIVING_SPEED = 250;
        return _this;
    }
    MainScene.prototype.preload = function () {
        var _this = this;
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON('map', __webpack_require__(859));
        this.load.image('help', __webpack_require__(860));
        this.load.atlas("landscape", __webpack_require__(861), __webpack_require__(862));
        this.load.atlas("star-disk", __webpack_require__(2215), __webpack_require__(2216));
        this.load.atlas("star-hauler", __webpack_require__(2217), __webpack_require__(2218));
        this.load.image("rover", __webpack_require__(2219));
        this.load.spritesheet('player', __webpack_require__(863), { frameWidth: 42, frameHeight: 64 });
        this.load.image("background", __webpack_require__(516));
        __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
        var keys = [
            "Landscaping.Phaser.Feedback1",
            "Landscaping.Phaser.Feedback2",
            "Landscaping.Phaser.Feedback3",
        ];
        keys.forEach(function (key) {
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_10_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    MainScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.initialize();
        this.generateGamepad();
        this.generateVehicles();
        this.generatePlayer();
        this.generateScene();
        this.generateObjects();
        this.generateItemDropZones();
        this.updateScoreboard();
        this.generateDeadzones();
        this.speechBubble = this.createBubble(500, 100, __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "starHaulerWrong")).setVisible(false);
        Object(__WEBPACK_IMPORTED_MODULE_8_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    MainScene.prototype.generatePlayer = function () {
        this.player = this.physics.add.sprite(this.starDisk.getBottomLeft().x - 50, this.starDisk.getTopLeft().y + 50, "player");
        this.player.setOrigin(.5);
        this.player.setDisplaySize(32, 48);
        this.player.setDepth(4);
        this.player.setFrame(4);
        //  Player animations, turning, walking left and walking right.
        this.anims.create({
            key: 'left',
            frames: this.anims.generateFrameNumbers('player', { start: 0, end: 3 }),
            frameRate: 10,
            repeat: -1
        });
        this.anims.create({
            key: 'turn',
            frames: [{ key: 'player', frame: 4 }],
            frameRate: 20
        });
        this.anims.create({
            key: 'right',
            frames: this.anims.generateFrameNumbers('player', { start: 5, end: 8 }),
            frameRate: 10,
            repeat: -1
        });
        this.player.setCollideWorldBounds(true);
    };
    MainScene.prototype.addHelpButton = function () {
        var _this = this;
        this.helpButton = this.add.image(0, 0, "help");
        this.helpButton.setOrigin(0);
        this.helpButton.setDisplaySize(30, 30);
        this.helpButton.setPosition(this.gameWidth - this.helpButton.displayWidth - 30, 30);
        this.helpButton.setInteractive();
        this.createHelpText();
        this.helpButton.on('pointerdown', function () {
            _this.toggleHelpText();
            _this.showingHelpText = !_this.showingHelpText;
        });
    };
    MainScene.prototype.generateVehicles = function () {
        var _this = this;
        this.map.getObjectLayer("Misc").objects.forEach(function (ob) {
            if (ob.name === "disk") {
                _this.starDisk = _this.physics.add.sprite(ob.x, ob.y, "star-disk", "star-disc-landed-empty");
                _this.starDisk.setDepth(4);
                _this.starDisk.setOrigin(.5);
                _this.starDisk.setDisplaySize(ob.width, ob.height);
                _this.starDisk.setName("starDisk");
            }
            else if (ob.name === "hauler") {
                _this.starHauler = _this.physics.add.sprite(ob.x, ob.y, "star-hauler", "star-hauler-left");
                _this.starHauler.setDepth(4);
                _this.starHauler.setOrigin(.5);
                _this.starHauler.setDisplaySize(ob.width, ob.height);
            }
        });
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.allItems = [];
        this.allZones = [];
        this.deadZones = [];
        this.map = this.make.tilemap({ key: 'map' });
        this.speed = this.WALKING_SPEED;
        this.xVel = 0;
        this.yVel = 0;
        this.showingHelpText = true;
        //this.scores.push({ id: TranslateApi.translate(this.translateString + "Items.1.id"), display: TranslateApi.translate(this.translateString + "Items.1.display"), score: 3 });
        //this.scores.push({ id: TranslateApi.translate(this.translateString + "Items.2.id"), display: TranslateApi.translate(this.translateString + "Items.2.display"), score: 10 });
        //this.scores.push({ id: TranslateApi.translate(this.translateString + "Items.3.id"), display: TranslateApi.translate(this.translateString + "Items.3.display"), score: 1 });
        //this.scores.push({ id: TranslateApi.translate(this.translateString + "Items.4.id"), display: TranslateApi.translate(this.translateString + "Items.4.display"), score: 1 });
        this.scores.push({ id: "Tree", display: __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Items.1.display"), score: 3 });
        this.scores.push({ id: "Bush", display: __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Items.2.display"), score: 10 });
        this.scores.push({ id: "Fountain", display: __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Items.3.display"), score: 1 });
        this.scores.push({ id: "Satellite", display: __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Items.4.display"), score: 1 });
    };
    MainScene.prototype.generateScene = function () {
        var _this = this;
        this.background = this.add.image(0, 0, "background");
        this.background.setOrigin(0);
        this.background.setDepth(-1);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.addHelpButton();
        var sceneLayer = this.map.getObjectLayer('Scene');
        var fontStyle1 = { fontSize: 16, color: '#ffffff', align: 'right' };
        var fontStyle2 = { fontSize: 16, color: '#ffffff' };
        // Generate Objects
        sceneLayer.objects.forEach(function (ob) {
            if (ob.type !== "") {
                console.warn("Unknown Type Detected", ob.type);
                return;
            }
            var tileName = ob.name.toLowerCase();
            if (tileName === "buildings") {
                var garage = _this.add.image(ob.x, ob.y, "landscape", "buildings");
                garage.setOrigin(0);
                garage.setDepth(2);
                garage.setDisplaySize(ob.width, ob.height);
            }
            else if (tileName === "beams") {
                var beams = _this.add.image(ob.x, ob.y, "landscape", "beams");
                beams.setOrigin(0);
                beams.setDepth(0);
                beams.setDisplaySize(ob.width, ob.height);
            }
            else if (tileName === "crane") {
                var crane = _this.add.image(ob.x, ob.y, "landscape", "crane");
                crane.setOrigin(0);
                crane.setDepth(0);
                crane.setAngle(15);
                crane.setScale(0.35);
            }
            else if (tileName === "scoreboard") {
                var scoreboard = _this.add.image(ob.x, ob.y, "pixel");
                scoreboard.setOrigin(0);
                scoreboard.setDepth(0);
                scoreboard.setTint(__WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY);
                scoreboard.setDisplaySize(ob.width, ob.height);
                var border = _this.add.image(ob.x - 5, ob.y - 5, "pixel");
                border.setOrigin(0);
                border.setDepth(-.5);
                border.setTint(0x000000);
                border.setDisplaySize(scoreboard.displayWidth + 10, scoreboard.displayHeight + 10);
            }
            else if (tileName === "blueprint") {
                var blueprint = _this.add.image(ob.x, ob.y, "landscape", "blueprint");
                blueprint.setOrigin(0);
                blueprint.setDepth(0);
                blueprint.setDisplaySize(ob.width + 10, ob.height + 10);
            }
            else if (tileName === "score_1") {
                var txt = _this.add.text(ob.x, ob.y, "", fontStyle1);
                txt.setName(tileName);
                txt.setOrigin(0);
                txt.setFontFamily('Russo One, Roboto Mono, Arial');
                txt.setDepth(1);
                txt.setStroke('#ffffff', .5);
                _this.scoreTiles.push(txt);
            }
            else if (tileName === "score_2") {
                var txt = _this.add.text(ob.x, ob.y, "", fontStyle2);
                txt.setName(tileName);
                txt.setOrigin(0);
                txt.setDepth(1);
                txt.setFontFamily('Russo One, Roboto Mono, Arial');
                _this.scoreTiles.push(txt);
            }
        });
    };
    MainScene.prototype.generateDeadzones = function () {
        var _this = this;
        this.map.getObjectLayer("Deadzones").objects.forEach(function (ob) {
            var zone = _this.add.zone(ob.x, ob.y, ob.width, ob.height);
            zone.name = ob.name;
            zone.setOrigin(0);
            _this.physics.add.existing(zone, true);
            _this.physics.add.collider(_this.player, zone, null, _this.checkCollision);
            var deadZone = new __WEBPACK_IMPORTED_MODULE_9__objects_Deadzone__["a" /* Deadzone */](ob.name, ob.properties["canHover"], ob.properties["canDrive"]);
            deadZone.zone = zone;
            _this.deadZones.push(deadZone);
        });
    };
    MainScene.prototype.checkCollision = function (player, zone) {
        var deadZone = this.deadZones.find(function (dz) { return dz.name === zone.name; });
        if (this.drivingStarDisk) {
            if (deadZone.canHover) {
                return false;
            }
        }
        if (this.drivingStarHauler) {
            if (deadZone.canDrive) {
                return false;
            }
        }
        // Can walk on bushes deadzone
        if (!this.drivingStarDisk && !this.drivingStarHauler && deadZone.name === "bushes") {
            return false;
        }
        return true;
    };
    MainScene.prototype.inDeadZone = function () {
        var deadZone;
        for (var _i = 0, _a = this.deadZones; _i < _a.length; _i++) {
            deadZone = _a[_i];
            var areaToCheck = this.drivingStarDisk ? this.starDisk.getBounds() : this.starHauler.getBounds();
            if (Phaser.Geom.Intersects.RectangleToRectangle(areaToCheck, deadZone.zone.getBounds())) {
                return deadZone;
            }
        }
        return null;
    };
    MainScene.prototype.generateObjects = function () {
        var _this = this;
        var ob = this.map.getObjectLayer("Misc").objects.find(function (ob) {
            return ob.name === "itemBackground";
        });
        var itemsBackground = this.add.image(ob.x, ob.y, "pixel");
        itemsBackground.setOrigin(0);
        itemsBackground.setDisplaySize(ob.width, ob.height);
        itemsBackground.setTint(__WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY);
        var border = this.add.image(ob.x - 5, ob.y - 5, "pixel");
        border.setOrigin(0);
        border.setDepth(-.5);
        border.setTint(0x000000);
        border.setDisplaySize(itemsBackground.displayWidth + 10, itemsBackground.displayHeight + 10);
        var tree = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Items.1.id");
        var bush = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Items.2.id");
        var fountain = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Items.3.id");
        var satellite = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Items.4.id");
        var items = [
            {
                name: "Tree",
                texture: "landscape",
                frame: "tree",
                count: this.scores.find(function (x) { return x.id === "Tree"; }).score
            },
            {
                name: "Bush",
                texture: "landscape",
                frame: "shrub",
                count: this.scores.find(function (x) { return x.id === "Bush"; }).score
            },
            {
                name: "Fountain",
                texture: "landscape",
                frame: "fountain",
                count: this.scores.find(function (x) { return x.id === "Fountain"; }).score
            },
            {
                name: "Satellite",
                texture: "landscape",
                frame: "satellite",
                count: this.scores.find(function (x) { return x.id === "Satellite"; }).score
            }
        ];
        var i = 0;
        var textStyle = { fontFamily: 'Russo One, Arial', padding: 20, color: "#ffffff", fontSize: 20 };
        this.map.getObjectLayer("Misc").objects.forEach(function (ob) {
            if (ob.type === "PickupZone") {
                var item = items[i];
                var object;
                for (var index = 0; index < item.count; index++) {
                    object = _this.add.image(ob.x, ob.y, item.texture, item.frame);
                    object.setOrigin(0);
                    object.setDisplaySize(ob.width, ob.height);
                    object.setName(item.name);
                    var items_1 = new __WEBPACK_IMPORTED_MODULE_3__objects_Item__["a" /* Item */](object, item.name, object.getBounds(), false, item.texture, item.frame);
                    _this.allItems.push(items_1);
                }
                i++;
                // Label for item
                var itemName = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "Items." + i + ".id");
                var itemLabel = _this.add.text(ob.x, object.getBottomLeft().y - 5, itemName, textStyle);
                itemLabel.setX(object.x + object.displayWidth / 2 - itemLabel.width / 2);
            }
            else if (ob.name === "text") {
                // Label above all items
                var choose = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "itemsLabel");
                var text = _this.add.text(ob.x, ob.y, choose, textStyle);
                text.setX(itemsBackground.x + +itemsBackground.displayWidth / 2 - text.width / 2);
            }
        });
    };
    /*
     * Start driving a vehicle
     */
    MainScene.prototype.aDown = function () {
        if (!this.canGetOutHere()) {
            return;
        }
        // If they were carrying an item, put it back in it's pick up zone
        if (this.carryingItem) {
            this.resetItem();
        }
        // Stop driving star disk
        if (this.drivingStarDisk) {
            this.speed = this.WALKING_SPEED;
            this.drivingStarDisk = false;
            this.player.setX(this.starDisk.getBottomRight().x + 20);
            this.player.setVisible(true);
            this.children.moveDown(this.starDisk);
            this.children.bringToTop(this.player);
            this.player.setSize(32, 55);
            this.player.setOffset(5, 10);
        }
        // Stop driving star hauler
        else if (this.drivingStarHauler) {
            this.speed = this.WALKING_SPEED;
            this.drivingStarHauler = false;
            this.player.setX(this.starHauler.getBottomRight().x + 20);
            this.player.setVisible(true);
            this.children.moveDown(this.starHauler);
            this.children.bringToTop(this.player);
            this.player.setSize(32, 55);
            this.player.setOffset(5, 10);
            // Make sure don't have beam 
            if (this.starHauler.frame.name.startsWith("star-hauler-left")) {
                this.starHauler.setFrame("star-hauler-left");
            }
            else {
                this.starHauler.setFrame("star-hauler-right");
            }
        }
        // Start driving star disk
        else if (Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), this.starDisk.getBounds()) && !this.drivingStarHauler) {
            this.speed = this.DRIVING_SPEED;
            this.starDisk.setFrame("star-disc-landed-w-pilot");
            this.player.setVisible(false);
            this.drivingStarDisk = true;
            this.drivingStarHauler = false;
            this.children.bringToTop(this.starDisk);
            // Set player bounds to be bounds of star disk
            this.player.setSize(125, 80);
            this.player.setOffset(-40, -30);
        }
        // Start driving star hauler
        else if (Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), this.starHauler.getBounds()) && !this.drivingStarDisk) {
            this.speed = this.DRIVING_SPEED;
            this.drivingStarHauler = true;
            this.drivingStarDisk = false;
            if (this.starHauler.frame.name === "star-hauler-left") {
                this.starHauler.setFrame("star-hauler-left");
            }
            else {
                this.starHauler.setFrame("star-hauler-right");
            }
            this.player.setVisible(false);
            this.children.bringToTop(this.starHauler);
            // Set player bounds to be bounds of star hauler
            this.player.setSize(165, 90);
            this.player.setOffset(-60, -10);
        }
    };
    MainScene.prototype.canGetOutHere = function () {
        // If they are in a deadzone they can't get out
        var deadzone = this.inDeadZone();
        if (deadzone) {
            return false;
        }
        // Don't allow getting out if on top of the other vehicle
        if (this.drivingStarDisk && Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), this.starHauler.getBounds())) {
            return false;
        }
        if (this.drivingStarHauler && Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), this.starDisk.getBounds())) {
            return false;
        }
        return true;
    };
    /**
     * Pick up item with vehicle
     */
    MainScene.prototype.bDown = function () {
        var _this = this;
        // Drop an item if you're carrying it
        if (this.carryingItem) {
            var zone;
            for (var _i = 0, _a = this.allZones; _i < _a.length; _i++) {
                zone = _a[_i];
                // Dropped in correct zone
                if (Phaser.Geom.Intersects.RectangleToRectangle(this.currentItem.object.getBounds(), zone.rect) &&
                    this.currentItem.name === zone.name && !zone.placed) {
                    this.currentItem.object.setPosition(zone.object.x, zone.object.y);
                    this.currentItem.object.setDisplaySize(zone.object.displayWidth, zone.object.displayHeight);
                    zone.placed = true;
                    this.scores.find(function (x) { return x.id === _this.currentItem.object.name; }).score--;
                    this.updateScoreboard();
                    this.carryingItem = false;
                    this.currentItem.follow = false;
                    this.currentItem.dropped = true;
                    this.currentItem.object.setDepth(-.5);
                    this.currentItem = null;
                    break;
                }
            }
        }
        else {
            // Pick up an item with star disk
            if (this.drivingStarDisk) {
                this.starDisk.setFrame("star-disc-beam");
                var smallItem;
                for (var _b = 0, _c = this.allItems; _b < _c.length; _b++) {
                    smallItem = _c[_b];
                    var doesIntersect = Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), smallItem.rect);
                    if (doesIntersect && (smallItem.name === "Tree" || smallItem.name === "Bush") && !smallItem.dropped) {
                        this.currentItem = smallItem;
                        this.currentItem.name = smallItem.object.name;
                        this.currentItem.object.setDepth(3);
                        if (smallItem.name === "Bush") {
                            // Make bush a little bigger than the size it will be when it's placed
                            this.currentItem.object.setDisplaySize(smallItem.object.displayWidth * .35, smallItem.object.displayHeight * .35);
                        }
                        if (smallItem.name === "Tree") {
                            this.currentItem.object.setDisplaySize(smallItem.object.displayWidth * .5, smallItem.object.displayHeight * .5);
                        }
                        this.carryingItem = true;
                        this.currentItem.follow = true;
                        this.children.bringToTop(this.starDisk);
                        this.currentItem.object.setDepth(this.starHauler.depth + 1);
                        this.fadeOutFeedback();
                        break;
                    }
                    else if (doesIntersect && (smallItem.name !== "Tree" && smallItem.name !== "Bush")) {
                        if (smallItem.name === "Fountain" && this.scores.find(function (x) { return x.id === "Fountain"; }).score !== 0) {
                            this.setSpeechBubbleText(__WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "starDiskWrong"));
                            this.tweenFeedback();
                        }
                        if (smallItem.name === "Satellite" && this.scores.find(function (x) { return x.id === "Satellite"; }).score !== 0) {
                            this.setSpeechBubbleText(__WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "starDiskWrong"));
                            this.tweenFeedback();
                        }
                    }
                }
            }
            // Pick up an item with star hauler
            if (this.drivingStarHauler) {
                // Switch to texture with the beam
                if (this.starHauler.frame.name === "star-hauler-left") {
                    this.starHauler.setFrame("star-hauler-left-beam");
                }
                else if (this.starHauler.frame.name === "star-hauler-right") {
                    this.starHauler.setFrame('star-hauler-right-beam');
                }
                var largeItem;
                for (var _d = 0, _e = this.allItems; _d < _e.length; _d++) {
                    largeItem = _e[_d];
                    var doesIntersect = Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), largeItem.rect);
                    if (doesIntersect && (largeItem.name === "Fountain" || largeItem.name === "Satellite") && !largeItem.dropped) {
                        this.currentItem = largeItem;
                        this.currentItem.name = largeItem.object.name;
                        this.currentItem.object.setDisplaySize(largeItem.object.displayWidth * .6, largeItem.object.displayHeight * .6);
                        this.currentItem.object.setDepth(3);
                        this.carryingItem = true;
                        this.currentItem.follow = true;
                        this.currentItem.object.setDepth(this.starDisk.depth + 1);
                        this.fadeOutFeedback();
                        break;
                    }
                    else if (doesIntersect && (largeItem.name !== "Fountain" && largeItem.name !== "Satellite")) {
                        if (largeItem.name === "Bush" && this.scores.find(function (x) { return x.id === "Bush"; }).score !== 0) {
                            this.setSpeechBubbleText(__WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "starHaulerWrong"));
                            this.tweenFeedback();
                        }
                        if (largeItem.name === "Tree" && this.scores.find(function (x) { return x.id === "Tree"; }).score !== 0) {
                            this.setSpeechBubbleText(__WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "starHaulerWrong"));
                            this.tweenFeedback();
                        }
                    }
                }
            }
        }
    };
    MainScene.prototype.tweenFeedback = function () {
        var _this = this;
        if (this.tweens.isTweening(this.speechBubble)) {
            this.tweens.killTweensOf(this.speechBubble);
        }
        this.tweens.add({
            targets: this.speechBubble,
            x: this.speechBubble.x,
            duration: 2000,
            ease: "Linear",
            onStart: function () {
                _this.speechBubble.setAlpha(1);
                _this.speechBubble.setVisible(true);
                _this.children.bringToTop(_this.speechBubble);
            },
            onComplete: function () {
                _this.fadeOutFeedback();
            }
        });
    };
    MainScene.prototype.fadeOutFeedback = function () {
        var _this = this;
        this.tweens.add({
            targets: this.speechBubble,
            x: this.speechBubble.x,
            duration: 500,
            alpha: {
                getStart: function () { return 1; },
                getEnd: function () { return 0; },
            },
            ease: "Linear",
            onComplete: function () {
                _this.speechBubble.setVisible(false);
                _this.children.moveDown(_this.speechBubble);
            }
        });
    };
    MainScene.prototype.updateScoreboard = function () {
        var _this = this;
        var numberTile = this.scoreTiles.find(function (x) { return x.name === "score_1"; });
        var textTile = this.scoreTiles.find(function (x) { return x.name === "score_2"; });
        numberTile.setText([
            this.scores[0].score.toString(),
            "",
            this.scores[1].score.toString(),
            "",
            this.scores[2].score.toString(),
            "",
            this.scores[3].score.toString(),
            ""
        ]);
        textTile.setText([
            this.scores[0].display,
            "",
            this.scores[1].display,
            "",
            this.scores[2].display,
            "",
            this.scores[3].display,
            ""
        ]);
        // Game is done
        if (this.isDone()) {
            setTimeout(function () {
                _this.player.disableBody();
                var config = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
                config.title = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "doneText");
                config.buttonConfig = new __WEBPACK_IMPORTED_MODULE_7_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
                config.buttonConfig.smartSize = true;
                config.forceResponse = true;
                var modal = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["a" /* PhaserModal */](_this, 0, 0, [{ id: 1, displayText: __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate("common.done") }], config);
                modal.setDepth(100);
                modal.setPosition(_this.gameWidth / 2 - modal.width / 2, _this.gameHeight / 2 - modal.height / 2);
                modal.on("optionClicked", function () {
                    _this.sound.stopAll();
                    modal.destroy();
                    _this.player.disableBody();
                    _this.input.setDefaultCursor("default");
                    _this.input.removeAllListeners();
                    //    this.scene.add("EndGameScene", EndGameScene, true); // rm double scene
                    _this.scene.remove(_this);
                    _this.sound.stopAll();
                    // Game Over
                    _this.sys.game.onComplete();
                });
            }, 1000);
        }
    };
    MainScene.prototype.updateObjectVehiclePosition = function () {
        if (this.drivingStarDisk) {
            if (this.carryingItem) {
                this.starDisk.setFrame("star-disc-beam");
            }
            else {
                this.starDisk.setFrame("star-disc-floating");
            }
            this.starDisk.x = this.player.x;
            this.starDisk.y = this.player.y;
            if (this.currentItem != null && this.currentItem.follow) {
                this.currentItem.object.x = this.player.x - this.currentItem.object.displayWidth / 2;
                if (this.currentItem.name === "Tree") {
                    this.currentItem.object.y = this.starDisk.y + 35;
                }
                else if (this.currentItem.name === "Bush") {
                    this.currentItem.object.y = this.starDisk.y + 30;
                }
            }
        }
        else {
            this.starDisk.setFrame("star-disc-landed-empty");
        }
        if (this.drivingStarHauler) {
            this.starHauler.x = this.player.x;
            this.starHauler.y = this.player.y;
            if (this.currentItem != null && this.currentItem.follow) {
                if (this.starHauler.frame.name === "star-hauler-left-beam") {
                    // Driving left
                    this.currentItem.object.x = this.player.x + 15;
                }
                else if (this.starHauler.frame.name === "star-hauler-right-beam") {
                    // Driving right
                    this.currentItem.object.x = this.player.x - 50;
                }
                // Moving up or down
                this.currentItem.object.y = this.player.y - 45;
            }
        }
    };
    MainScene.prototype.generateItemDropZones = function () {
        var _this = this;
        var objectLayer = this.map.getObjectLayer('DropZones');
        objectLayer.objects.forEach(function (ob) {
            var object = _this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "landscape", "hotspot");
            object.setOrigin(0);
            object.setDepth(2);
            object.setName(ob.name);
            object.setVisible(false);
            object.setDisplaySize(ob.width, ob.height);
            var zone = new __WEBPACK_IMPORTED_MODULE_2__objects_Zone__["a" /* Zone */](object, ob.name, object.getBounds(), false);
            _this.allZones.push(zone);
        });
    };
    MainScene.prototype.createHelpText = function () {
        var translateString = "Landscaping.Phaser.Instruction.";
        var borderColor = 0xffffff;
        var textStyle = { fontFamily: 'Russo One, Arial', fontSize: 16, padding: 10 };
        var bpText = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "bp");
        var bpTextOb = this.add.text(1000, 280, bpText, textStyle).setDepth(3).setWordWrapWidth(300);
        bpTextOb.setBackgroundColor("#000000").setOrigin(0);
        var bpBorder = this.add.image(bpTextOb.x - 5, bpTextOb.y - 5, "pixel").setDepth(1);
        bpBorder.setDisplaySize(bpTextOb.displayWidth + 10, bpTextOb.displayHeight + 10).setTint(borderColor).setOrigin(0);
        var diskText = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "disk");
        var diskTextOb = this.add.text(this.starDisk.getBottomLeft().x, this.starDisk.getBottomRight().y - 5, diskText, textStyle).setDepth(3).setWordWrapWidth(260);
        diskTextOb.setName('diskTextOb');
        diskTextOb.setBackgroundColor("#000000");
        var diskBorder = this.add.image(this.starDisk.getCenter().x, diskTextOb.y - 5, "pixel").setDepth(1);
        diskBorder.setName("diskBorder");
        diskBorder.setDisplaySize(diskTextOb.displayWidth + 10, diskTextOb.displayHeight + 10).setTint(borderColor);
        Phaser.Display.Align.In.Center(diskBorder, diskTextOb);
        var haulText = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "haul");
        var haulTextOb = this.add.text(this.starHauler.getBottomLeft().x, this.starHauler.getBottomRight().y + 10, haulText, textStyle).setDepth(3).setWordWrapWidth(300);
        haulTextOb.setName("haulerTextOb");
        haulTextOb.setBackgroundColor("#000000");
        var haulBorder = this.add.image(this.starHauler.getCenter().x, haulTextOb.getCenter().y, "pixel").setDepth(1);
        haulBorder.setName("haulerBorder");
        haulBorder.setDisplaySize(haulTextOb.displayWidth + 10, haulTextOb.displayHeight + 10).setTint(borderColor);
        Phaser.Display.Align.In.Center(haulBorder, haulTextOb);
        var carText = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "car");
        var carTextOb = this.add.text(500, 40, carText, textStyle).setDepth(3).setWordWrapWidth(250);
        carTextOb.setBackgroundColor("#000000").setOrigin(0);
        var carBorder = this.add.image(carTextOb.x - 5, carTextOb.y - 5, "pixel").setDepth(1);
        carBorder.setDisplaySize(carTextOb.displayWidth + 10, carTextOb.displayHeight + 10).setTint(borderColor).setOrigin(0);
        var houseText = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "house");
        var houseTextOb = this.add.text(1050, 450, houseText, textStyle).setDepth(3).setWordWrapWidth(215);
        houseTextOb.setBackgroundColor("#000000").setOrigin(0);
        var houseBorder = this.add.image(houseTextOb.x - 5, houseTextOb.y - 5, "pixel").setDepth(1);
        houseBorder.setDisplaySize(houseTextOb.displayWidth + 10, houseTextOb.displayHeight + 10).setTint(borderColor).setOrigin(0);
        this.helpText = [bpBorder, bpTextOb, carBorder, carTextOb, houseBorder, houseTextOb, diskBorder, diskTextOb, haulBorder, haulTextOb];
    };
    MainScene.prototype.toggleHelpText = function () {
        var _this = this;
        var diskTextOb, diskBorder, haulerTextOb, haulerBorder;
        this.helpText.forEach(function (ob) {
            ob.visible = !ob.visible;
            if (ob.name === "diskTextOb") {
                diskTextOb = ob;
            }
            else if (ob.name === "diskBorder") {
                diskBorder = ob;
            }
            else if (ob.name === "haulerTextOb") {
                haulerTextOb = ob;
            }
            else if (ob.name === "haulerBorder") {
                haulerBorder = ob;
            }
            if (ob.visible) {
                _this.children.bringToTop(ob);
            }
            else {
                _this.children.moveDown(ob);
            }
        });
        // Don't let the star disk and star hauler labels run off the screen
        var x, y;
        x = Math.max(75, Math.min(this.starDisk.getCenter().x, this.gameWidth - this.starDisk.displayWidth));
        y = Math.min(this.starDisk.y + this.starDisk.displayHeight / 2 + 5, this.gameHeight - this.starDisk.displayHeight);
        diskBorder.setPosition(x, y);
        Phaser.Display.Align.In.Center(diskTextOb, diskBorder);
        x = Math.max(75, Math.min(this.starHauler.getCenter().x - 5, this.gameWidth - this.starHauler.displayWidth));
        y = Math.min(this.starHauler.y + this.starHauler.displayHeight, this.gameHeight - this.starHauler.displayHeight - 10);
        haulerBorder.setPosition(x, y);
        Phaser.Display.Align.In.Center(haulerTextOb, haulerBorder);
    };
    MainScene.prototype.createBubble = function (x, y, text) {
        var padding = 10;
        var fontSize = 14;
        var borderWidth = 5;
        var borderColor = __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("R");
        var textBox = this.add.container(x, y);
        var textStyle = { fontFamily: 'Russo One, Arial', color: "#ffffff", fontSize: fontSize, padding: 10 };
        var textObject = this.add.text(padding + borderWidth, padding + borderWidth, text, textStyle);
        textObject.setWordWrapWidth(195 + padding, true);
        textObject.setName("Bubble");
        textBox.setSize(textObject.displayWidth + padding + borderWidth, textObject.displayHeight + padding + borderWidth);
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(textObject);
        return textBox;
    };
    MainScene.prototype.resetItem = function () {
        this.currentItem.object.setDisplaySize(64, 64);
        this.currentItem.object.setPosition(this.currentItem.startPosition.x, this.currentItem.startPosition.y);
        this.currentItem.object.setDepth(this.starDisk.depth - 1);
        this.currentItem = null;
        this.carryingItem = false;
        // Get rid of beam
        if (this.drivingStarHauler) {
            if (this.starHauler.frame.name === "star-hauler-left-beam") {
                this.starHauler.setFrame("star-hauler-left");
            }
            else if (this.starHauler.frame.name === "star-hauler-right-beam") {
                this.starHauler.setFrame("star-hauler-right");
            }
        }
    };
    // Checks if all items have been dropped in their respective dragzones
    MainScene.prototype.isDone = function () {
        for (var i = 0; i < this.scores.length; i++) {
            if (this.scores[i].score > 0) {
                return false;
            }
        }
        return true;
    };
    // Show speech bubble
    MainScene.prototype.setSpeechBubbleText = function (text) {
        this.speechBubble.setVisible(true);
        var textObject = this.speechBubble.list.find(function (c) {
            return c.name === "Bubble";
        });
        textObject.setText(text);
    };
    MainScene.prototype.update = function () {
        this.updatePlayerMovement();
        this.updateObjectVehiclePosition();
    };
    /**
     * GamePad/Player Movement
     */
    MainScene.prototype.generateGamepad = function () {
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.gamePad.on("keydown_a", this.aDown);
        this.gamePad.on("keydown_b", this.bDown);
    };
    MainScene.prototype.updatePlayerMovement = function () {
        if (!this.player.body.enable) {
            return;
        }
        this.xVel = 0;
        this.yVel = 0;
        if (this.gamePad.keys.left.isDown) {
            this.xVel += -this.speed;
        }
        if (this.gamePad.keys.right.isDown) {
            this.xVel += this.speed;
        }
        if (this.gamePad.keys.down.isDown) {
            this.yVel += this.speed;
        }
        if (this.gamePad.keys.up.isDown) {
            this.yVel += -this.speed;
        }
        this.player.setVelocity(this.xVel, this.yVel);
        // If showing help text and moving, hide the help text
        if (this.showingHelpText && (this.xVel !== 0 || this.yVel !== 0)) {
            this.showingHelpText = false;
            this.toggleHelpText();
        }
        // Play walking animations
        if (this.xVel > 0) {
            this.player.anims.play('right', true);
        }
        else if (this.xVel < 0) {
            this.player.anims.play('left', true);
        }
        else {
            this.player.anims.play('turn');
        }
        if (this.drivingStarHauler) {
            this.updateStarHauler();
        }
    };
    MainScene.prototype.updateStarHauler = function () {
        if (this.drivingStarHauler && this.player.body.velocity.x < 0) {
            // Going left
            if (!this.carryingItem) {
                this.starHauler.setFrame("star-hauler-left");
            }
            else {
                this.starHauler.setFrame("star-hauler-left-beam");
            }
        }
        else if (this.drivingStarHauler && this.player.body.velocity.x > 0) {
            // Going right
            if (!this.carryingItem) {
                this.starHauler.setFrame("star-hauler-right");
            }
            else {
                this.starHauler.setFrame("star-hauler-right-beam");
            }
        }
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gamepad.eaeefaaa.png";

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gamepad.7bb6f45e.json";

/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Zone; });
var Zone = /** @class */ (function () {
    function Zone(zone, name, rect, placed) {
        this.object = zone;
        this.name = name;
        this.rect = rect;
        this.placed = placed;
    }
    return Zone;
}());



/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Item; });
var Item = /** @class */ (function () {
    function Item(object, name, rect, follow, itemTexture, itemFrame) {
        this.object = object;
        this.name = name;
        this.rect = rect;
        this.follow = follow;
        this.itemTexture = itemTexture;
        this.itemFrame = itemFrame;
        this.startPosition = new Phaser.Math.Vector2(object.x, object.y);
        this.dropped = false;
    }
    return Item;
}());



/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Deadzone; });
var Deadzone = /** @class */ (function () {
    function Deadzone(name, canHover, canDrive) {
        this.name = name;
        this.zone = null;
        this.canDrive = canDrive;
        this.canHover = canHover;
    }
    return Deadzone;
}());



/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/starDisk.35e6de41.png";

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/starDisk.c56b0bfa.json";

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/starHauler.8b142de8.png";

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/starHauler.7b7d1633.json";

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/star-ship_R.45d2cf6b.png";

/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_Helpers__ = __webpack_require__(111);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


// import { MainScene } from "./MainScene";
// import { GameIntroScene } from "./GameIntro";


var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        /** JB: Note
         * This game was designed VERY early in this product's life and, as such,
         *  exceptions like this need to be accounted for in the new base class system.
         */
        __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current = new __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */]();
        var nextSceneObject = __WEBPACK_IMPORTED_MODULE_3__objects_Helpers__["a" /* Helpers */].getNextScene(0);
        __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.sceneNumber = 1;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Diagnosis;
        _this.mainScene = nextSceneObject;
        _this.gameObjectiveTextKey = "Diagnosis.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Diagnosis.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "Diagnosis.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    HowToPlayScene.prototype.preload = function () {
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        // Loading only the needed terrain
        this.load.image('terrain', __webpack_require__(368));
        // Load the NPC
        // JB: I wanted this to be offset for grades next to each other, so 1R would be different from 2R, like an offset matrix
        var mustard = (this.gameRef.grade.level + this.gameRef.planet.order) % 3; // 3 is how many aliens we have
        switch (mustard) {
            case 0:
                this.load.image("npc", __webpack_require__(287));
                break;
            case 1:
                this.load.image("npc", __webpack_require__(168));
                break;
            case 2:
            default:
                this.load.image("npc", __webpack_require__(155));
                break;
        }
        // Load all assets here, then reference them in every subsequent scene for free!
        this.load.atlas("assets", __webpack_require__(2242), __webpack_require__(2243));
        this.load.image("background", __webpack_require__(2244));
        _super.prototype.preload.call(this);
    };
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Diagnosis; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__ = __webpack_require__(16);

/**
 *  Represents a "diagnosis":
 * - Disease name
 * - Color for the color changing test
 * - Healthy cell color for normal cells
 * - Unhealthy cell color for sick cells
 * - Bacteria count and color for count bacteria
 */
var Diagnosis = /** @class */ (function () {
    function Diagnosis(diseaseName) {
        Diagnosis.DIAGNOSIS_OPTIONS.pop();
    }
    // Get a random fictional alien disease name
    Diagnosis.getRandomDiseaseName = function () {
        var names = [
            "Diagnosis.Phaser.diseaseNames.0",
            "Diagnosis.Phaser.diseaseNames.1",
            "Diagnosis.Phaser.diseaseNames.2",
            "Diagnosis.Phaser.diseaseNames.3",
            "Diagnosis.Phaser.diseaseNames.4",
            "Diagnosis.Phaser.diseaseNames.5",
        ];
        return names[Phaser.Math.Between(0, names.length - 1)];
    };
    Diagnosis.getRandomReaction = function () {
        var reactionOptions = ["phaser_flare", "phaser_bubble"];
        return reactionOptions[Phaser.Math.Between(0, reactionOptions.length - 1)];
    };
    // Checks to see if the two diseases are the same
    Diagnosis.hasSameDiseaseName = function (disease_1, disease_2) {
        if (disease_1 !== disease_2) {
            return false;
        }
        return true;
    };
    Diagnosis.DIAGNOSIS_OPTIONS = [
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.0",
            healthyCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('pink'),
            sickCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('red'),
            bacteriaColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('purple'),
            colorChangerColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('blue'),
            bacteriaCount: 2,
            reactionAsset: "phaser_flare",
        },
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.3",
            healthyCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('pink'),
            sickCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('red'),
            bacteriaColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('green'),
            colorChangerColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('blue'),
            bacteriaCount: 3,
            reactionAsset: "phaser_flare",
        },
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.1",
            healthyCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('red'),
            sickCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('pink'),
            bacteriaColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('yellow'),
            colorChangerColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('blue'),
            bacteriaCount: 1,
            reactionAsset: "phaser_bubble",
        },
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.2",
            healthyCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('red'),
            sickCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('orange'),
            bacteriaColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('yellow'),
            colorChangerColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('green'),
            bacteriaCount: 3,
            reactionAsset: "phaser_bubble",
        },
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.4",
            healthyCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('orange'),
            sickCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('pink'),
            bacteriaColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('teal'),
            colorChangerColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('purple'),
            bacteriaCount: 3,
            reactionAsset: "phaser_bubble",
        },
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.5",
            healthyCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('orange'),
            sickCellColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('red'),
            bacteriaColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('blue'),
            colorChangerColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('purple'),
            bacteriaCount: 1,
            reactionAsset: "phaser_bubble",
        },
    ];
    return Diagnosis;
}());



/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DrawBloodScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DrawBloodScene = /** @class */ (function (_super) {
    __extends(DrawBloodScene, _super);
    function DrawBloodScene() {
        return _super.call(this, {
            key: "DrawBloodScene_" + Math.random(),
        }) || this;
    }
    DrawBloodScene.prototype.preload = function () {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("draw_blood_scene_map", __webpack_require__(2223));
    };
    DrawBloodScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    DrawBloodScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'draw_blood_scene_map' });
    };
    DrawBloodScene.prototype.generateScene = function () {
        var background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);
        this.addObjects();
    };
    DrawBloodScene.prototype.addObjects = function () {
        var _this = this;
        var syringe;
        var translateString = "Diagnosis.Phaser.DrawBloodScene.";
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "alien") {
                var alien = _this.add.image(ob.x, ob.y, "assets", "sleb_sick");
                alien.setOrigin(0);
                alien.setDisplaySize(ob.width, ob.height);
                alien.setDepth(3);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text");
                var box = _this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(_this.gameWidth / 2 - box.displayWidth / 2);
                _this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "syringe") {
                _this.syringe = _this.add.image(ob.x, ob.y, "assets", "syringe_empty");
                _this.syringe.setOrigin(0);
                _this.syringe.setDisplaySize(ob.width, ob.height);
                _this.syringe.setInteractive();
                var radians = _this.toRadians(ob.rotation);
                _this.syringe.setRotation(radians);
                __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].flashObject(_this, _this.syringe);
            }
        });
        this.syringe.on('pointerdown', function () {
            _this.syringe.setAlpha(1);
            _this.syringe.disableInteractive();
            _this.tweens.killTweensOf(_this.syringe);
            _this.takeBloodSample();
        });
    };
    /**
    * Simulates drop of "blood" coming out of eyedropper into beaker
   */
    DrawBloodScene.prototype.takeBloodSample = function () {
        var _this = this;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "blood") {
                var blood = _this.add.image(ob.x, ob.y, "assets", "syringe_liquid");
                blood.setOrigin(0);
                blood.setDisplaySize(ob.width, 0);
                blood.setFlipY(true);
                blood.setDepth(20);
                blood.setRotation(_this.syringe.rotation);
                blood.setTint(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("alien_blood"));
                _this.tweens.add({
                    targets: blood,
                    duration: 2000,
                    x: _this.syringe.x + 35,
                    y: {
                        value: _this.syringe.y - 3,
                    },
                    ease: "Stepped",
                    easeParams: [1000],
                    displayHeight: {
                        value: 175,
                    },
                    onComplete: function () {
                        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addNextButton(_this);
                    }
                });
            }
        });
    };
    DrawBloodScene.prototype.toRadians = function (degrees) {
        return degrees * (Math.PI / 180);
    };
    return DrawBloodScene;
}(Phaser.Scene));



/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/lab_diagnosis_draw_blood_scene.296f3997.json";

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SickCellInfoScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var SickCellInfoScene = /** @class */ (function (_super) {
    __extends(SickCellInfoScene, _super);
    function SickCellInfoScene() {
        return _super.call(this, {
            key: "SickCellInfoScene_" + Math.random(),
        }) || this;
    }
    SickCellInfoScene.prototype.preload = function () {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("sick_cell_info_scene_map", __webpack_require__(2225));
    };
    SickCellInfoScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    SickCellInfoScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'sick_cell_info_scene_map' });
        this.correctDiagnosis = __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis;
    };
    SickCellInfoScene.prototype.generateScene = function () {
        var background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);
        background.setDepth(0);
        var notesBackground = this.add.image(100, 300, "pixel").setOrigin(0).setDisplaySize(450, 350).setTint(0x000000).setAlpha(0.7);
        this.addObjects();
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addNextButton(this);
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addBackButton(this);
    };
    SickCellInfoScene.prototype.addObjects = function () {
        var _this = this;
        var fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: "#ffffff" };
        var translateString = "Diagnosis.Phaser.SickCellInfoScene.";
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "microscope") {
                var microscope = _this.add.image(ob.x, ob.y, "assets", "microscope");
                microscope.setOrigin(0);
                microscope.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text");
                var box = _this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(_this.gameWidth / 2 - box.displayWidth / 2);
                _this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "sick_cells") {
                var sickCellColors = __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].getRandomUniqueColors(3);
                var sickColor = sickCellColors.findIndex(function (c) {
                    return c === _this.correctDiagnosis.sickCellColor;
                });
                // If the sick cell color isn't there, add it
                if (sickColor === -1) {
                    sickCellColors.push(_this.correctDiagnosis.sickCellColor);
                }
                var indexOfHealthyColor = sickCellColors.findIndex(function (c) {
                    return c === _this.correctDiagnosis.healthyCellColor;
                });
                // If the healthy color is there, remove it
                if (indexOfHealthyColor !== -1) {
                    sickCellColors.splice(indexOfHealthyColor, 1);
                }
                var group = _this.add.group();
                for (var i = 0; i < sickCellColors.length; i++) {
                    var malformed_cell = _this.add.image(0, 0, "assets", "temp_sick_cell");
                    malformed_cell.setOrigin(0);
                    malformed_cell.setDisplaySize(80, 80);
                    malformed_cell.setTint(sickCellColors[i]);
                    group.add(malformed_cell);
                }
                Phaser.Actions.GridAlign(group.getChildren(), {
                    x: ob.x,
                    y: ob.y,
                    cellHeight: 100,
                    cellWidth: 100,
                    height: sickCellColors.length / 2,
                    width: 2,
                    position: Phaser.Display.Align.CENTER,
                });
                var labelText1 = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "abnormalLabel");
                var mc_label = _this.add.text(120, ob.y, labelText1, fontStyle);
            }
            else if (ob.name === "normal_cell") {
                var normal_cell = _this.add.image(ob.x, ob.y, "assets", "temp_normal_cell");
                normal_cell.setOrigin(0);
                normal_cell.setDepth(1);
                normal_cell.setDisplaySize(ob.width, ob.height);
                normal_cell.setTint(_this.correctDiagnosis.healthyCellColor);
                var nc_bounds = normal_cell.getTopRight();
                var labelText2 = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "normalLabel");
                var nc_label = _this.add.text(120, nc_bounds.y + normal_cell.height / 2, labelText2, fontStyle);
            }
        });
    };
    return SickCellInfoScene;
}(Phaser.Scene));



/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/lab_diagnosis_sick_cell_info_scene.902880d3.json";

/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SickCellsScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var SickCellsScene = /** @class */ (function (_super) {
    __extends(SickCellsScene, _super);
    function SickCellsScene() {
        return _super.call(this, {
            key: "SickCellsScene_" + Math.random(),
        }) || this;
    }
    SickCellsScene.prototype.preload = function () {
        // All assets were loaded in MainScene
        this.load.image('circle', __webpack_require__(865));
        this.load.tilemapTiledJSON("analyze_blood_scene_map", __webpack_require__(866));
    };
    SickCellsScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        this.registerEvents();
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    SickCellsScene.prototype.registerEvents = function () {
        // Drag around the blood sample to see through the lense
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
    };
    SickCellsScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'analyze_blood_scene_map' });
        this.correctDiagnosis = __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis;
    };
    SickCellsScene.prototype.generateScene = function () {
        this.background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "pixel");
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.background.setOrigin(0.5);
        this.background.setTint(0x2d2d39);
        this.addObjects();
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addNextButton(this);
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addBackButton(this);
    };
    SickCellsScene.prototype.addObjects = function () {
        var _this = this;
        var graphics = this.add.graphics();
        var bloodSample, lensMask;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "sample") {
                bloodSample = _this.createBloodSample(ob, true);
            }
            else if (ob.name === "lens") {
                // Look through lens to analyze the blood
                lensMask = _this.make.sprite({
                    x: ob.x,
                    y: ob.y,
                    key: 'circle',
                    add: false,
                });
                lensMask.setPosition(ob.x + ob.width / 2, ob.y + ob.height / 2);
                lensMask.setDisplaySize(ob.width, ob.height);
                // Outline of the lens
                var circle = new Phaser.Geom.Circle(lensMask.x, lensMask.y, lensMask.displayWidth / 2 + 20);
                circle.setPosition(lensMask.getCenter().x, lensMask.getCenter().y);
                graphics.fillStyle(0x000000);
                graphics.fillCircleShape(circle);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20 };
                var translateString = "Diagnosis.Phaser.SickCellsScene.";
                var translatedText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text");
                var text = _this.add.text(ob.x, ob.y, translatedText, title_fontStyle).setDepth(1);
                text.setX(_this.gameWidth / 2 - text.width / 2);
                text.setWordWrapWidth(ob.width, true);
                _this.add.image(text.x - 5, text.y - 5, "pixel").setDisplaySize(text.displayWidth + 10, text.displayHeight + 10).setDepth(.5).setOrigin(0).setDepth(.75).setTint(0x000000);
                _this.add.image(text.x - 10, text.y - 10, "pixel").setDisplaySize(text.displayWidth + 20, text.displayHeight + 20).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
        });
        bloodSample.mask = new Phaser.Display.Masks.BitmapMask(this, lensMask);
    };
    /**
     * Dynamically creates a "blood sample" by randomly adding different cells to a "petri dish"
     */
    SickCellsScene.prototype.createBloodSample = function (ob, isUnhealthy) {
        var _this = this;
        var bloodSample = this.add.container(ob.x + ob.width / 2, ob.y + ob.height / 2);
        bloodSample.setSize(ob.width, ob.height);
        var background = this.add.image(0, 0, "circle");
        background.setTint(0xffffff);
        background.setDisplaySize(ob.width, ob.height);
        bloodSample.add(background);
        if (isUnhealthy) {
            this.addNormalCells(15, bloodSample);
            this.addSickCells(this.correctDiagnosis.sickCellColor, 5, bloodSample);
        }
        else {
            this.addNormalCells(30, bloodSample);
        }
        bloodSample.setInteractive({
            hitArea: background.getBounds(),
            hitAreaCallback: function (pointer) {
                return _this.background.getBounds().contains(pointer.x, pointer.y);
            }
        });
        this.input.setDraggable(bloodSample);
        bloodSample.setScale(1.1);
        return bloodSample;
    };
    SickCellsScene.prototype.addNormalCells = function (count, sample) {
        for (var i = 0; i < count; i++) {
            var normal_cell = this.add.image(0, 0, "assets", "temp_normal_cell");
            normal_cell.setDisplaySize(40, 40);
            normal_cell.setTint(this.correctDiagnosis.healthyCellColor);
            var maxDistanceX = sample.displayWidth / 2 - 3 * normal_cell.displayWidth;
            var maxDisanceY = sample.displayHeight / 2 - 3 * normal_cell.displayHeight;
            var x = Phaser.Math.Between(-maxDistanceX, maxDistanceX);
            var y = Phaser.Math.Between(-maxDisanceY, maxDisanceY);
            normal_cell.setPosition(x, y);
            sample.add(normal_cell);
        }
    };
    SickCellsScene.prototype.addSickCells = function (color, count, sample) {
        for (var i = 0; i < count; i++) {
            var sick_cell = this.add.image(0, 0, "assets", "temp_sick_cell");
            sick_cell.setDisplaySize(40, 40);
            sick_cell.setTint(color);
            var maxDistanceX = sample.displayWidth / 2 - 3 * sick_cell.displayWidth;
            var maxDisanceY = sample.displayHeight / 2 - 3 * sick_cell.displayHeight;
            var x = Phaser.Math.Between(-maxDistanceX, maxDistanceX);
            var y = Phaser.Math.Between(-maxDisanceY, maxDisanceY);
            sick_cell.setPosition(x, y);
            sample.add(sick_cell);
        }
    };
    SickCellsScene.prototype.update = function () {
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["b" /* updateInteractiveCursor */])(this);
    };
    return SickCellsScene;
}(Phaser.Scene));



/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BacteriaInfoScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var BacteriaInfoScene = /** @class */ (function (_super) {
    __extends(BacteriaInfoScene, _super);
    function BacteriaInfoScene() {
        return _super.call(this, {
            key: "BacteriaInfoScene_" + Math.random(),
        }) || this;
    }
    BacteriaInfoScene.prototype.preload = function () {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("bacteria_info_scene_map", __webpack_require__(2228));
    };
    BacteriaInfoScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    BacteriaInfoScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'bacteria_info_scene_map' });
        this.correctDiagnosis = __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis;
    };
    BacteriaInfoScene.prototype.generateScene = function () {
        var background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);
        background.setDepth(0);
        var notesBackground = this.add.image(100, 450, "pixel").setOrigin(0).setDisplaySize(225, 150).setTint(0x000000).setAlpha(0.7);
        this.addObjects();
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addNextButton(this);
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addBackButton(this);
    };
    BacteriaInfoScene.prototype.addObjects = function () {
        var _this = this;
        var translateString = "Diagnosis.Phaser.BacteriaInfoScene.";
        var fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: "#ffffff" };
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "microscope") {
                var microscope = _this.add.image(ob.x, ob.y, "assets", "microscope");
                microscope.setOrigin(0);
                microscope.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text");
                var box = _this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(_this.gameWidth / 2 - box.displayWidth / 2);
                _this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "bacteria") {
                var bacteria = _this.add.image(ob.x, ob.y, "assets", "temp_bacteria");
                bacteria.setOrigin(0);
                bacteria.setDisplaySize(ob.width, ob.height);
                bacteria.setTint(_this.correctDiagnosis.bacteriaColor);
                var bacteriaBounds = bacteria.getTopRight();
                var labelText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "labelText");
                var bacteriaLabel = _this.add.text(120, bacteriaBounds.y + bacteria.height / 2, labelText, fontStyle);
            }
        });
    };
    return BacteriaInfoScene;
}(Phaser.Scene));



/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/lab_diagnosis_bacteria_info_scene.c287e5aa.json";

/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CountBacteriaScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var CountBacteriaScene = /** @class */ (function (_super) {
    __extends(CountBacteriaScene, _super);
    function CountBacteriaScene() {
        return _super.call(this, {
            key: "CountBacteriaScene_" + Math.random(),
        }) || this;
    }
    CountBacteriaScene.prototype.preload = function () {
        // All assets were loaded in MainScene
        this.load.image("circle", __webpack_require__(865));
        this.load.tilemapTiledJSON("analyze_blood_scene_map", __webpack_require__(866));
    };
    CountBacteriaScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        this.registerEvents();
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    CountBacteriaScene.prototype.registerEvents = function () {
        // Drag around the blood sample to see through the lense
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
    };
    CountBacteriaScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'analyze_blood_scene_map' });
        this.correctDiagnosis = __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis;
    };
    CountBacteriaScene.prototype.generateScene = function () {
        this.background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "pixel");
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.background.setOrigin(0.5);
        this.background.setTint(0x2d2d39);
        this.addObjects();
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addNextButton(this);
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addBackButton(this);
    };
    CountBacteriaScene.prototype.addObjects = function () {
        var _this = this;
        var graphics = this.add.graphics();
        var bloodSample, lensMask;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "sample") {
                bloodSample = _this.createBloodSample(ob, true);
            }
            else if (ob.name === "lens") {
                // Look through lens to analyze the blood
                lensMask = _this.make.sprite({
                    x: ob.x,
                    y: ob.y,
                    key: 'circle',
                    add: false,
                });
                lensMask.setPosition(ob.x + ob.width / 2, ob.y + ob.height / 2);
                lensMask.setDisplaySize(ob.width, ob.height);
                // Outline of the lens
                var circle = new Phaser.Geom.Circle(lensMask.x, lensMask.y, lensMask.displayWidth / 2 + 20);
                circle.setPosition(lensMask.getCenter().x, lensMask.getCenter().y);
                graphics.fillStyle(0x000000);
                graphics.fillCircleShape(circle);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20 };
                var translateString = "Diagnosis.Phaser.CountBacteriaScene.";
                var translatedText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text");
                var text = _this.add.text(ob.x, ob.y, translatedText, title_fontStyle).setDepth(1);
                text.setX(_this.gameWidth / 2 - text.width / 2);
                text.setWordWrapWidth(ob.width, true);
                _this.add.image(text.x - 5, text.y - 5, "pixel").setDisplaySize(text.displayWidth + 10, text.displayHeight + 10).setDepth(.5).setOrigin(0).setDepth(.75).setTint(0x000000);
                _this.add.image(text.x - 10, text.y - 10, "pixel").setDisplaySize(text.displayWidth + 20, text.displayHeight + 20).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
        });
        bloodSample.mask = new Phaser.Display.Masks.BitmapMask(this, lensMask);
    };
    CountBacteriaScene.prototype.createBloodSample = function (ob, isUnhealthy) {
        var _this = this;
        var bloodSample = this.add.container(ob.x + ob.width / 2, ob.y + ob.height / 2);
        bloodSample.setSize(ob.width, ob.height);
        var background = this.add.image(0, 0, "circle");
        background.setTint(0xffffff);
        background.setDisplaySize(ob.width, ob.height);
        bloodSample.add(background);
        if (isUnhealthy) {
            this.addNormalCells(15, bloodSample);
            this.addSickCells(this.correctDiagnosis.sickCellColor, 3, bloodSample);
            this.addBacteria(__WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis.bacteriaCount, this.correctDiagnosis.bacteriaColor, bloodSample);
        }
        else {
            this.addNormalCells(30, bloodSample);
        }
        bloodSample.setInteractive({ hitArea: background.getBounds(), hitAreaCallback: function (pointer) {
                return _this.background.getBounds().contains(pointer.x, pointer.y);
            } });
        this.input.setDraggable(bloodSample);
        bloodSample.setScale(1.1);
        return bloodSample;
    };
    CountBacteriaScene.prototype.addBacteria = function (count, color, sample) {
        for (var i = 0; i < count; i++) {
            var bacteriaCell = this.add.image(0, 0, "assets", "temp_bacteria");
            bacteriaCell.setDisplaySize(40, 40);
            bacteriaCell.setTint(color);
            var maxDistanceX = sample.displayWidth / 2 - 3 * bacteriaCell.displayWidth;
            var maxDisanceY = sample.displayHeight / 2 - 3 * bacteriaCell.displayHeight;
            var x = Phaser.Math.Between(-maxDistanceX, maxDistanceX);
            var y = Phaser.Math.Between(-maxDisanceY, maxDisanceY);
            bacteriaCell.setPosition(x, y);
            sample.add(bacteriaCell);
        }
    };
    CountBacteriaScene.prototype.addNormalCells = function (count, sample) {
        for (var i = 0; i < count; i++) {
            var normal_cell = this.add.image(0, 0, "assets", "temp_normal_cell");
            normal_cell.setDisplaySize(40, 40);
            normal_cell.setTint(this.correctDiagnosis.healthyCellColor);
            var maxDistanceX = sample.displayWidth / 2 - 3 * normal_cell.displayWidth;
            var maxDisanceY = sample.displayHeight / 2 - 3 * normal_cell.displayHeight;
            var x = Phaser.Math.Between(-maxDistanceX, maxDistanceX);
            var y = Phaser.Math.Between(-maxDisanceY, maxDisanceY);
            normal_cell.setPosition(x, y);
            sample.add(normal_cell);
        }
    };
    CountBacteriaScene.prototype.addSickCells = function (color, count, sample) {
        for (var i = 0; i < count; i++) {
            var sick_cell = this.add.image(0, 0, "assets", "temp_sick_cell");
            sick_cell.setDisplaySize(40, 40);
            sick_cell.setTint(color);
            var maxDistanceX = sample.displayWidth / 2 - 3 * sick_cell.displayWidth;
            var maxDisanceY = sample.displayHeight / 2 - 3 * sick_cell.displayHeight;
            var x = Phaser.Math.Between(-maxDistanceX, maxDistanceX);
            var y = Phaser.Math.Between(-maxDisanceY, maxDisanceY);
            sick_cell.setPosition(x, y);
            sample.add(sick_cell);
        }
    };
    CountBacteriaScene.prototype.update = function () {
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["b" /* updateInteractiveCursor */])(this);
    };
    return CountBacteriaScene;
}(Phaser.Scene));



/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TestTubeInfoScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var TestTubeInfoScene = /** @class */ (function (_super) {
    __extends(TestTubeInfoScene, _super);
    function TestTubeInfoScene() {
        return _super.call(this, {
            key: "TestTubeInfoScene_" + Math.random(),
        }) || this;
    }
    TestTubeInfoScene.prototype.preload = function () {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("test_tube_info_scene_map", __webpack_require__(2231));
    };
    TestTubeInfoScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    TestTubeInfoScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'test_tube_info_scene_map' });
        this.correctDiagnosis = __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis;
    };
    TestTubeInfoScene.prototype.generateScene = function () {
        this.background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.background.setOrigin(0.5);
        this.background.setDepth(0);
        this.addObjects();
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addNextButton(this);
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addBackButton(this);
    };
    TestTubeInfoScene.prototype.addObjects = function () {
        var _this = this;
        var fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
        var translateString = "Diagnosis.Phaser.TestTubeInfoScene.";
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text");
                var box = _this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(_this.gameWidth / 2 - box.displayWidth / 2);
                _this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "tube_with_bubbles") {
                var tube1 = _this.add.image(ob.x, ob.y, "assets", "test_tube_green");
                tube1.setOrigin(0);
                tube1.setDisplaySize(ob.width, ob.height);
                _this.addReaction(tube1, "phaser_bubble");
            }
            else if (ob.name === "tube_with_flares") {
                var tube2 = _this.add.image(ob.x, ob.y, "assets", "test_tube_purple");
                tube2.setOrigin(0);
                tube2.setDisplaySize(ob.width, ob.height);
                _this.addReaction(tube2, "phaser_flare");
            }
        });
    };
    /**
     * Adds a "reaction" from the test tube using a particle emitter
     */
    TestTubeInfoScene.prototype.addReaction = function (tube, reactionAsset) {
        var reaction = this.add.particles("assets", reactionAsset);
        var emitter = reaction.createEmitter({
            x: tube.x + tube.displayWidth / 2,
            y: tube.getTopLeft().y,
            scale: { start: 0.3, end: 0.4 },
            angle: { min: 200, max: 330 },
            speed: 100,
            lifespan: 1200,
            blendMode: Phaser.BlendModes.SCREEN,
        });
    };
    return TestTubeInfoScene;
}(Phaser.Scene));



/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/lab_diagnosis_test_tube_info_scene.af480869.json";

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TestTubeScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var TestTubeScene = /** @class */ (function (_super) {
    __extends(TestTubeScene, _super);
    function TestTubeScene() {
        return _super.call(this, {
            key: "TestTubeScene_" + Math.random(),
        }) || this;
    }
    TestTubeScene.prototype.preload = function () {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("test_tube_scene_map", __webpack_require__(2233));
    };
    TestTubeScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        this.registerEvents();
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    TestTubeScene.prototype.registerEvents = function () {
        // Drag around the blood sample to see through the lense
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
    };
    TestTubeScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'test_tube_scene_map' });
        this.correctDiagnosis = __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis;
    };
    TestTubeScene.prototype.generateScene = function () {
        this.background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.background.setOrigin(0.5);
        this.addObjects();
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addBackButton(this);
    };
    TestTubeScene.prototype.addObjects = function () {
        var _this = this;
        var translateString = "Diagnosis.Phaser.TestTubeScene.";
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text");
                var box = _this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(_this.gameWidth / 2 - box.displayWidth / 2);
                _this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "test_tube") {
                _this.testTube = _this.add.image(ob.x, ob.y, "assets", "test_tube_green");
                _this.testTube.setOrigin(0);
                _this.testTube.setDisplaySize(ob.width, ob.height);
                _this.testTube.setInteractive();
                _this.testTube.on('pointerdown', function () {
                    _this.testTube.setAlpha(1);
                    _this.tweens.killTweensOf(_this.testTube);
                    _this.testTube.disableInteractive();
                    _this.addReaction();
                });
                __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].flashObject(_this, _this.testTube);
            }
        });
    };
    /**
     * Adds a "reaction" from the test tube using a particle emitter
     */
    TestTubeScene.prototype.addReaction = function () {
        var _this = this;
        this.tweens.add({
            targets: this.testTube,
            x: this.testTube.x + 25,
            duration: 100,
            ease: Phaser.Math.Easing.Circular,
            repeat: 5,
            yoyo: true,
            onComplete: function () {
                // Start reaction after a little delay
                setTimeout(function () {
                    var reactionAsset = __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis.reactionAsset;
                    var reaction = _this.add.particles("assets", reactionAsset);
                    var emitter = reaction.createEmitter({
                        x: _this.testTube.x + _this.testTube.displayWidth / 2,
                        y: _this.testTube.getTopLeft().y,
                        scale: { start: 0.3, end: 0.4 },
                        angle: { min: 200, max: 330 },
                        speed: 100,
                        lifespan: 1200,
                        blendMode: Phaser.BlendModes.SCREEN,
                    });
                    __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addNextButton(_this);
                }, 900);
            }
        });
    };
    return TestTubeScene;
}(Phaser.Scene));



/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/lab_diagnosis_test_tube.7094ad52.json";

/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorChangerInfoScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var ColorChangerInfoScene = /** @class */ (function (_super) {
    __extends(ColorChangerInfoScene, _super);
    function ColorChangerInfoScene() {
        return _super.call(this, {
            key: "ColorChangerInfoScene_" + Math.random(),
        }) || this;
    }
    ColorChangerInfoScene.prototype.preload = function () {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("color_changer_info_scene_map", __webpack_require__(2235));
    };
    ColorChangerInfoScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    ColorChangerInfoScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'color_changer_info_scene_map' });
        this.correctDiagnosis = __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis;
    };
    ColorChangerInfoScene.prototype.generateScene = function () {
        var background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);
        background.setDepth(0);
        this.addObjects();
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addNextButton(this);
        __WEBPACK_IMPORTED_MODULE_1__objects_Helpers__["a" /* Helpers */].addBackButton(this);
    };
    ColorChangerInfoScene.prototype.addObjects = function () {
        var _this = this;
        var translateString = "Diagnosis.Phaser.ColorChangerInfoScene.";
        var fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 10, backgroundColor: "#000000" };
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000 " };
                var text = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text");
                var box = _this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(_this.gameWidth / 2 - box.displayWidth / 2);
                _this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "before") {
                var tube1 = _this.add.image(ob.x, ob.y, "assets", "before");
                tube1.setOrigin(0);
                tube1.setDisplaySize(ob.width, ob.height);
                var before = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "before");
                var tube1Label = _this.add.text(0, tube1.getTopRight().y - 60, before, fontStyle).setDepth(1);
                tube1Label.setX(tube1.getCenter().x - tube1Label.width / 2);
                _this.add.image(tube1Label.x - 5, tube1Label.y - 5, "pixel").setDisplaySize(tube1Label.displayWidth + 10, tube1Label.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "after") {
                var tube2 = _this.add.image(ob.x, ob.y, "assets", "after");
                tube2.setOrigin(0);
                tube2.setDisplaySize(ob.width, ob.height);
                var after = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "after");
                var tube2Label = _this.add.text(0, tube2.getTopRight().y - 60, after, fontStyle).setDepth(1);
                tube2Label.setX(tube2.getCenter().x - tube2Label.width / 2);
                _this.add.image(tube2Label.x - 5, tube2Label.y - 5, "pixel").setDisplaySize(tube2Label.displayWidth + 10, tube2Label.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
        });
    };
    return ColorChangerInfoScene;
}(Phaser.Scene));



/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/lab_diagnosis_color_changer_info_scene.b226a0d1.json";

/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorChangerScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ColorChangerScene = /** @class */ (function (_super) {
    __extends(ColorChangerScene, _super);
    function ColorChangerScene() {
        return _super.call(this, {
            key: "ColorChangerScene_" + Math.random(),
        }) || this;
    }
    ColorChangerScene.prototype.preload = function () {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("color_changer_scene_map", __webpack_require__(2237));
    };
    ColorChangerScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_3_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    ColorChangerScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'color_changer_scene_map' });
    };
    ColorChangerScene.prototype.generateScene = function () {
        var background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);
        background.setDepth(0);
        this.addObjects();
        __WEBPACK_IMPORTED_MODULE_2__objects_Helpers__["a" /* Helpers */].addBackButton(this);
    };
    ColorChangerScene.prototype.addObjects = function () {
        var _this = this;
        var translateString = "Diagnosis.Phaser.ColorChangerScene.";
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "beaker") {
                _this.beaker = _this.add.image(ob.x, ob.y, "assets", "beaker_empty");
                _this.beaker.setOrigin(0);
                _this.beaker.setDisplaySize(ob.width, ob.height);
                _this.beakerLiquid = _this.add.image(ob.x, ob.y, "assets", "beaker_liquid");
                _this.beakerLiquid.setOrigin(0);
                _this.beakerLiquid.setDepth(1);
                _this.beakerLiquid.setDisplaySize(ob.width, ob.height);
                _this.beakerLiquid.setTint(__WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('light grey'));
            }
            else if (ob.name === "eyedropper") {
                _this.eyedropper = _this.add.image(ob.x, ob.y, "assets", "eyedropper_empty");
                _this.eyedropper.setOrigin(0);
                _this.eyedropper.setDisplaySize(ob.width, ob.height);
                _this.eyedropper.setInteractive();
                _this.eyedropper.setRotation(0.785); // 45 degrees (in radians)
                _this.eyedropper.on('pointerdown', function () {
                    _this.eyedropper.setAlpha(1);
                    _this.eyedropperLiquid.setAlpha(1);
                    _this.tweens.killTweensOf(_this.eyedropper);
                    _this.tweens.killTweensOf(_this.eyedropperLiquid);
                    _this.eyedropper.disableInteractive();
                    _this.dropBloodIntoBeaker();
                });
                _this.eyedropperLiquid = _this.add.image(ob.x, ob.y, "assets", "eyedropper_liquid");
                _this.eyedropperLiquid.setOrigin(0);
                _this.eyedropperLiquid.setDisplaySize(ob.width, ob.height);
                _this.eyedropperLiquid.setRotation(0.785); // 45 degrees (in radians)
                _this.eyedropperLiquid.setTint(__WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('alien_blood'));
                __WEBPACK_IMPORTED_MODULE_2__objects_Helpers__["a" /* Helpers */].flashObject(_this, _this.eyedropper);
                __WEBPACK_IMPORTED_MODULE_2__objects_Helpers__["a" /* Helpers */].flashObject(_this, _this.eyedropperLiquid);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text");
                var box = _this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(_this.gameWidth / 2 - box.displayWidth / 2);
                _this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
        });
    };
    /**
     * Simulates drop of "blood" coming out of eyedropper into beaker
    */
    ColorChangerScene.prototype.dropBloodIntoBeaker = function () {
        var _this = this;
        this.map.getObjectLayer("Animation").objects.forEach(function (ob) {
            if (ob.name === "drop") {
                var drop = _this.add.image(ob.x, ob.y, "assets", "droplet");
                drop.setOrigin(0);
                drop.setTint(__WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("alien_blood"));
                drop.setDisplaySize(ob.width, ob.height);
                // Tween to empty eyedropper liquid (shrinks height)
                _this.tweens.add({
                    targets: _this.eyedropperLiquid,
                    duration: 4000,
                    x: _this.eyedropper.getBottomLeft().x + 0.5,
                    y: drop.y - 1,
                    ease: "Power2",
                    displayHeight: {
                        value: 0,
                    },
                });
                // Tween to empty eyedropper liquid (shrink when get to the bottom of dropper)
                _this.tweens.add({
                    targets: _this.eyedropperLiquid,
                    duration: 2000,
                    delay: 1750,
                    x: drop.x,
                    y: drop.y,
                    ease: "Power2",
                    scaleX: {
                        value: 0.2,
                    },
                });
                // Tween to drop 3 droplets of blood from eyedropper into beaker, then change liquid color
                _this.tweens.add({
                    delay: 100,
                    targets: drop,
                    repeat: 2,
                    y: {
                        value: 600,
                        duration: 1200,
                        ease: 'Power2'
                    },
                    alpha: {
                        value: 0,
                        duration: 1000,
                    },
                    onComplete: function () {
                        // Simulate liquid in beaker changing to new color
                        __WEBPACK_IMPORTED_MODULE_2__objects_Helpers__["a" /* Helpers */].fadeOut(_this, _this.beakerLiquid, 2500, 0.3, 1);
                        _this.currColor = __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis.colorChangerColor;
                        _this.beakerLiquid.setTint(_this.currColor);
                        // Test is over, now can let them move on to the next one
                        __WEBPACK_IMPORTED_MODULE_2__objects_Helpers__["a" /* Helpers */].addNextButton(_this);
                    }
                });
            }
        });
    };
    return ColorChangerScene;
}(Phaser.Scene));



/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/lab_diagnosis_color_changer_scene.32030513.json";

/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagnosisScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_Helpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var DiagnosisScene = /** @class */ (function (_super) {
    __extends(DiagnosisScene, _super);
    function DiagnosisScene() {
        var _this = _super.call(this, {
            key: "DiagnosisScene_" + Math.random(),
        }) || this;
        _this.translateString = "Diagnosis.Phaser.DiagnosisScene.";
        return _this;
    }
    DiagnosisScene.prototype.preload = function () {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("diagnosis_map", __webpack_require__(2239));
    };
    DiagnosisScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_4_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    DiagnosisScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'diagnosis_map' });
        if (!__WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.hasSeenQuiz) {
            // Randomly insert correct diagnosis in options if this is the first time showing the diagnosis options
            var random_index = Phaser.Math.Between(0, __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.numberOfDiagnosisOptions + 1);
            __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.diagnosisOptions.splice(random_index, 0, __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis);
        }
        __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.hasSeenQuiz = true;
    };
    DiagnosisScene.prototype.generateScene = function () {
        this.background = this.add.image(0, 0, "background");
        this.background.setOrigin(0);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        var notesBackground = this.add.image(50, 50, "pixel").setOrigin(0).setDisplaySize(this.gameWidth - 200, this.gameHeight - 200).setTint(0x000000).setAlpha(0.7);
        this.addObjects();
        __WEBPACK_IMPORTED_MODULE_3__objects_Helpers__["a" /* Helpers */].addBackButton(this);
    };
    DiagnosisScene.prototype.addObjects = function () {
        var _this = this;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "title") {
                var text = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "title");
                var title = _this.add.text(ob.x, ob.y + 10, text);
                title.setOrigin(0);
                title.setFontFamily('Russo One, Roboto Mono, Arial');
                title.setTint(0xffffff);
                title.setFontSize(50);
            }
            else if (ob.name === "alien") {
                var alien = _this.add.image(ob.x, ob.y, "assets", "sleb_sick_portrait");
                alien.setOrigin(0);
                alien.setDisplaySize(ob.width, ob.height);
            }
        });
        this.showDiagnosisOptions();
    };
    DiagnosisScene.prototype.createButton = function (x, y, color, text) {
        var config = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.backgroundColor = color;
        config.smartHeight = true;
        var translatedText = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(text);
        var button = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Button__["a" /* PhaserButton */](this, x, y, 150, 50, translatedText, config);
        return button;
    };
    /**
     * Shows the diagnosis options for the user to pick from (including the correct one somewhere random)
     * */
    DiagnosisScene.prototype.showDiagnosisOptions = function () {
        var x = 100;
        var y = 200;
        this.addTitles();
        // Display different diagnosis options
        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.numberOfDiagnosisOptions + 1; i++) {
            var option = __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.diagnosisOptions[i];
            var group = this.add.group();
            var optionDiseaseName = option.diseaseName;
            this.addColorSample(option.colorChangerColor, group);
            this.addCell(option.healthyCellColor, "temp_normal_cell", group);
            this.addCell(option.sickCellColor, "temp_sick_cell", group);
            this.addBacteriaCount(option.bacteriaColor, option.bacteriaCount, group);
            this.addReaction(option.reactionAsset, group);
            this.addDiseaseButton(optionDiseaseName, group);
            Phaser.Actions.GridAlign(group.getChildren(), {
                x: x,
                y: y,
                cellWidth: 175,
                cellHeight: 150,
                height: 1,
                width: 6,
                position: Phaser.Display.Align.CENTER,
            });
            y += 100;
        }
    };
    DiagnosisScene.prototype.addTitles = function () {
        var group = this.add.group();
        var x, y;
        x = 100;
        y = 140;
        var labels = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "tableHeaders").split("\n");
        for (var _i = 0, labels_1 = labels; _i < labels_1.length; _i++) {
            var title = labels_1[_i];
            var label = this.add.text(0, 0, title);
            label.setFontFamily('Russo One, Roboto Mono, Arial').setColor("#ffffff").setFontSize(25).setX(50 - label.width / 2);
            group.add(this.add.container(0, 0, label));
        }
        Phaser.Actions.GridAlign(group.getChildren(), {
            x: x,
            y: y,
            cellWidth: 175,
            cellHeight: 150,
            height: 1,
            width: labels.length,
            position: Phaser.Display.Align.CENTER,
        });
    };
    DiagnosisScene.prototype.addReaction = function (reaction, group) {
        var reactionLabel = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "reaction1");
        if (reaction === "phaser_flare") {
            reactionLabel = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "reaction2");
        }
        var label = this.add.text(0, 0, reactionLabel);
        label.setFontSize(20).setFontFamily('Russo One, Roboto Mono, Arial').setColor("#ffffff").setX(50 - label.width / 2);
        var reactionExample = this.add.image(30, 30, "assets", reaction);
        reactionExample.setOrigin(0);
        reactionExample.setDisplaySize(30, 30);
        var container = this.add.container(0, 0);
        container.setSize(100, 100);
        container.add(label);
        container.add(reactionExample);
        group.add(container);
    };
    DiagnosisScene.prototype.addDiseaseButton = function (name, group) {
        var _this = this;
        // Button to choose that disease
        var optionButton = this.createButton(0, 100, __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON, name);
        optionButton.setDataEnabled();
        optionButton.setData("name", name);
        optionButton.on('buttonClicked', function () {
            if (optionButton.getData("name") === __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis.diseaseName) {
                _this.showModal(true);
            }
            else {
                _this.showModal(false);
            }
        });
        group.add(optionButton);
    };
    DiagnosisScene.prototype.addCell = function (color, texture, group) {
        var cell = this.add.image(0, 0, "assets", texture);
        cell.setOrigin(0);
        cell.setDisplaySize(80, 80);
        cell.setTint(color);
        var container = this.add.container(0, 0);
        container.setSize(100, 100);
        container.add(cell);
        group.add(container);
    };
    DiagnosisScene.prototype.addBacteriaCount = function (color, count, group) {
        var label = this.add.text(0, 0, "" + count);
        label.setFontSize(50);
        label.setColor("#ffffff");
        label.setFontFamily('Russo One, Roboto Mono, Arial');
        var cell = this.add.image(10, 10, "assets", "temp_bacteria");
        cell.setOrigin(0);
        cell.setDisplaySize(80, 80);
        cell.setTint(color);
        var container = this.add.container(0, 0);
        container.setSize(100, 100);
        container.add(cell);
        container.add(label);
        group.add(container);
    };
    DiagnosisScene.prototype.addColorSample = function (color, group) {
        var graphics = this.add.graphics();
        graphics.lineStyle(3, 0x000000);
        var circle = new Phaser.Geom.Circle(50, 50, 40);
        graphics.fillStyle(color);
        var line = graphics.strokeCircleShape(circle);
        var sample = graphics.fillCircleShape(circle);
        var container = this.add.container(0, 0);
        container.setSize(100, 100);
        container.add(sample);
        container.add(line);
        group.add(container);
    };
    /**
     * Show a modal for the feedback on their diagnosis
     * */
    DiagnosisScene.prototype.showModal = function (correct) {
        var _this = this;
        var text;
        if (!correct) {
            // If they don't get it right, start the game over
            text = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "modalText");
            var modalConfig = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
            modalConfig.title = text;
            modalConfig.buttonWidth = 80;
            modalConfig.buttonConfig = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
            modalConfig.buttonConfig.backgroundColor = __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
            var modalButtonText = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate("common.ok");
            var modalOptions = [
                { displayText: modalButtonText, id: 2 },
            ];
            var modal = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, modalOptions, modalConfig);
            modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
            modal.on('optionClicked', function (op) {
                _this.scene.setActive(false);
                _this.scene.remove(_this);
                // Go back to first test (scene 2)
                var nextSceneObject = __WEBPACK_IMPORTED_MODULE_3__objects_Helpers__["a" /* Helpers */].SCENE_ORDER[2];
                __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.sceneNumber = 3;
                _this.scene.add(nextSceneObject.key, nextSceneObject.scene, true);
            });
        }
        else {
            // Go to game over scene
            var nextSceneObject = __WEBPACK_IMPORTED_MODULE_3__objects_Helpers__["a" /* Helpers */].getNextScene(__WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.sceneNumber);
            __WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.sceneNumber += 1;
            this.scene.add(nextSceneObject.key, nextSceneObject.scene, true);
        }
    };
    return DiagnosisScene;
}(Phaser.Scene));



/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/lab_diagnosis_diagnosis_scene.8d2189a3.json";

/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameOverScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_GameState__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var GameOverScene = /** @class */ (function (_super) {
    __extends(GameOverScene, _super);
    function GameOverScene() {
        return _super.call(this, {
            key: "GameOverScene_" + Math.random(),
        }) || this;
    }
    GameOverScene.prototype.preload = function () {
        // All assets were loaded in DrawBloodScene
        this.load.tilemapTiledJSON("game_over_scene_map", __webpack_require__(2241));
    };
    GameOverScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_1_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    GameOverScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'game_over_scene_map' });
    };
    GameOverScene.prototype.generateScene = function () {
        var background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);
        background.setDepth(0);
        this.addObjects();
    };
    GameOverScene.prototype.addObjects = function () {
        var _this = this;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "alien") {
                var alien = _this.add.image(ob.x, ob.y, "assets", "sleb_normal");
                alien.setOrigin(0);
                alien.setDisplaySize(ob.width, ob.height);
                alien.setDepth(3);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Roboto Mono, Arial', fontSize: 20, color: '#F8E71C', padding: 20, backgroundColor: "#000000" };
                var translateString = "Diagnosis.Phaser.GameOverScene.";
                var text1 = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text1");
                var text2 = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "text2");
                var diseaseName = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(__WEBPACK_IMPORTED_MODULE_0__objects_GameState__["a" /* GameState */].current.correctDiagnosis.diseaseName);
                var translatedText = text1 + diseaseName + text2;
                var box = _this.add.text(ob.x, ob.y, translatedText, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(_this.gameWidth / 2 - box.displayWidth / 2);
                _this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
        });
        var config = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        var button = new __WEBPACK_IMPORTED_MODULE_3__shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 200, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("common.done"), config);
        button.setPosition(this.gameWidth - button.width - 50, this.gameHeight - button.height - 50);
        button.on("buttonClicked", function () {
            // Game Over
            _this.sys.game.onComplete();
        });
    };
    return GameOverScene;
}(Phaser.Scene));



/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/lab_diagnosis_game_over_scene.724ecddb.json";

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameLabDiagnosis.eb1b11b9.png";

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameLabDiagnosis.fece4fd0.json";

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/labDiagnosis_bg.49f1cc21.jpg";

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_DesertTerraformGame_scenes_MainScene__ = __webpack_require__(370);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "a";
        _this.gameClosingTextKey = "Collage.Phaser.doneText";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            // Game Over
            _this.sys.game.onComplete(__WEBPACK_IMPORTED_MODULE_4_src_games_DesertTerraformGame_scenes_MainScene__["a" /* MainScene */].CROPPED_IMAGE);
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_DesertTerraformGame_scenes_MainScene__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "a";
        _this.gameClosingTextKey = "DesertTerraform.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(155));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete(__WEBPACK_IMPORTED_MODULE_4_src_games_DesertTerraformGame_scenes_MainScene__["a" /* MainScene */].CROPPED_IMAGE);
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameTerraform.e0339971.png";

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameTerraform.4002d3e6.json";

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/desert_terraform.a3d5c5d1.json";

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TextItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var TextItem = /** @class */ (function (_super) {
    __extends(TextItem, _super);
    function TextItem(scene, x, y, textId) {
        var _this = this;
        var style = {
            color: "#000000",
            align: "centered",
            fontFamily: 'Russo One, Roboto Mono,  Arial',
            fontSize: 70,
        };
        var text = __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate("Collage.Phaser.CollageAssets." + textId);
        _this = _super.call(this, scene, x, y, text, style) || this;
        _this.textId = textId;
        _this.startingAngle = 0;
        _this.startingPosition = null;
        _this.setOrigin(0.5);
        _this.setWordWrapWidth(900, true);
        _this.shrink();
        _this.type = "TextItem";
        _this.translationKey = "Collage.Phaser.CollageAssets." + textId;
        _this.scene.add.existing(_this);
        // One time event that will play it's audio 
        _this.once("dragstart", function () {
            _this.scene.sound.stopAll();
            _this.scene.sound.play(_this.translationKey);
        });
        return _this;
    }
    TextItem.prototype.shrink = function () {
        this.displayHeight *= 0.3;
        this.displayWidth *= 0.3;
        this.startingSize = new Phaser.Math.Vector2(this.displayWidth, this.displayHeight);
        this.setInteractive();
        this.scene.input.setDraggable(this);
    };
    return TextItem;
}(Phaser.GameObjects.Text));

var ImageItem = /** @class */ (function (_super) {
    __extends(ImageItem, _super);
    function ImageItem(scene, x, y, texture) {
        var _this = _super.call(this, scene, x, y, texture) || this;
        _this.startingAngle = 0;
        _this.startingPosition = null;
        _this.type = "ImageItem";
        _this.scene.add.existing(_this);
        return _this;
    }
    return ImageItem;
}(Phaser.GameObjects.Image));



/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/collage.eaef1ca6.jpg";

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/resize_icon.9806d0ea.png";

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rotate_icon.38f4dd2f.png";

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/reset_icon.297a1439.png";

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/collage_1.229e83bb.jpg";

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/collage_2.7332d9c3.jpg";

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/collage_3.a90b2550.jpg";

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/collage_4.550749bc.jpg";

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/collage_5.c7170620.jpg";

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/collage_6.b2d15012.jpg";

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/collage_7.2a7784f6.jpg";

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/collage.29e0ba4f.json";

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InterviewScene__ = __webpack_require__(869);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Collage;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__InterviewScene__["a" /* InterviewScene */];
        _this.gameObjectiveTextKey = "Collage.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Collage.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "Collage.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/collage-interview.5fabbfa8.json";

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/student_front.aeb4d18b.png";

/***/ }),
/* 2266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(871);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].JobMatching;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "JobMatching.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "JobMatching.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "JobMatching.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_Character__ = __webpack_require__(2268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Occupation__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Gamepad__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.doubleJump = true;
        _this.frameCount = 0;
        _this.xVel = 0;
        _this.yVel = 0;
        _this.JUMPING_VELOCITY = 400;
        _this.WALKING_VELOCITY = 200;
        _this.buttonConfig = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_9_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON,
            smartSize: true
        };
        _this.modalConfig = {
            title: "",
            buttonWidth: 220,
            buttonConfig: _this.buttonConfig,
        };
        _this.translateString = "JobMatching.Phaser.";
        return _this;
    }
    MainScene.prototype.preload = function () {
        var _this = this;
        this.load.image('drawtiles', __webpack_require__(873));
        this.load.image('background', __webpack_require__(2270));
        this.load.tilemapTiledJSON('map', __webpack_require__(2271));
        this.load.image("pixel", __webpack_require__(60));
        this.load.atlas("pilots", __webpack_require__(189), __webpack_require__(190));
        this.load.atlas("aliens", __webpack_require__(874), __webpack_require__(875));
        this.load.spritesheet('player', __webpack_require__(863), { frameWidth: 42, frameHeight: 64 });
        this.load.atlas("aliens", __webpack_require__(2272), __webpack_require__(2273));
        this.load.image('help', __webpack_require__(860));
        this.load.image('hollandCodes', __webpack_require__(876));
        __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
        __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__["a" /* PhaserButton */].preload(this);
        __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__["a" /* PhaserModal */].preload(this);
        var keys = [
            "JobMatching.Phaser.npc.A",
            "JobMatching.Phaser.npc.C",
            "JobMatching.Phaser.npc.E",
            "JobMatching.Phaser.npc.I",
            "JobMatching.Phaser.npc.R",
            "JobMatching.Phaser.npc.S",
        ];
        keys.forEach(function (key) {
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_10_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.characters = [];
        this.initializeMap();
    };
    MainScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.initialize();
        this.generateScene();
        this.initializeGame();
        this.setBorderCollisions();
        Object(__WEBPACK_IMPORTED_MODULE_7_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    /**
     * Initializes the tilemap and sets tile collision properties
     * */
    MainScene.prototype.initializeMap = function () {
        this.map = this.make.tilemap({ key: 'map' });
        var backgroundTiles = this.map.addTilesetImage('background');
        backgroundTiles.setTileSize(16, 16);
        this.map.createDynamicLayer('Background Layer', backgroundTiles, 0, 0);
        this.collisionLayer = this.map.getObjectLayer('Collisions');
        this.characterLayer = this.map.getObjectLayer('Object Layer');
    };
    MainScene.prototype.setBorderCollisions = function () {
        var _this = this;
        this.map.getObjectLayer("Borders").objects.forEach(function (object) {
            // The group will have an array of objects - these are the individual collision shapes
            var gameObject = new Phaser.GameObjects.Zone(_this, object.x, object.y, object.width, object.height);
            gameObject.type = object.type;
            _this.physics.add.existing(gameObject, true);
            _this.physics.add.collider(_this.player, gameObject);
        });
    };
    MainScene.prototype.initializeGame = function () {
        // Reset players
        this.characters.forEach(function (c) {
            c.enabled = true;
            c.label = null;
            c.assignedOccupation = null;
        });
        // Reinitialize possible occupations
        this.possibleOccupations = new Set(__WEBPACK_IMPORTED_MODULE_1__objects_Occupation__["a" /* Occupation */].OCCUPATIONS);
    };
    MainScene.prototype.generateScene = function () {
        var _this = this;
        this.generateNPCs();
        this.generatePlayer();
        this.setCollisions();
        this.createGamePad();
        // Setup the camera to follow the player
        this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);
        this.cameras.main.startFollow(this.player);
        // Initialize score
        var scoreText = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "score") + ": ";
        this.score = this.add.text(0, 0, scoreText + 0, { backgroundColor: '#000000', fontSize: 20, padding: 24, fontFamily: 'Russo One, Arial' });
        this.score.setTint(0xffffff);
        this.score.setDataEnabled();
        this.score.setData('score', 0);
        this.score.setDepth(4);
        this.score.setScrollFactor(0); // Make it stay on screen when camera changes
        this.score.setPosition(this.gameWidth - this.score.width - 60, 50);
        // Border around score
        this.scoreBorder = this.add.image(this.score.x - 5, this.score.y - 5, "pixel");
        this.scoreBorder.setOrigin(0);
        this.scoreBorder.setDepth(1);
        this.scoreBorder.setDisplaySize(this.score.displayWidth + 10, this.score.displayHeight + 10);
        this.scoreBorder.setTint(0xff0700);
        this.scoreBorder.setScrollFactor(0);
        var helpIcon = this.add.image(0, 0, "help");
        helpIcon.setOrigin(0);
        helpIcon.setDisplaySize(30, 30);
        helpIcon.setScrollFactor(0);
        helpIcon.setName('help');
        helpIcon.setPosition(this.gameWidth - 45, 15);
        helpIcon.setInteractive();
        this.hollandCodeGraphic = this.add.image(0, 0, "hollandCodes");
        this.hollandCodeGraphic.setOrigin(0);
        this.hollandCodeGraphic.setScrollFactor(0);
        this.hollandCodeGraphic.setVisible(false);
        this.hollandCodeGraphic.setScale(0.5);
        this.hollandCodeGraphic.setPosition(this.gameWidth / 2 - this.hollandCodeGraphic.displayWidth / 2, this.gameHeight / 2 - this.hollandCodeGraphic.displayHeight / 2);
        helpIcon.on('pointerdown', function () {
            _this.hollandCodeGraphic.setVisible(!_this.hollandCodeGraphic.visible);
            if (_this.hollandCodeGraphic.visible) {
                _this.children.bringToTop(_this.hollandCodeGraphic);
                _this.sound.stopAll();
                // Close any modals on screen and disable the player so  that focus is on the help image
                _this.closeOnScreenModals();
                _this.player.disableBody();
            }
            else {
                _this.children.moveDown(_this.hollandCodeGraphic);
                _this.player.enableBody(true, _this.player.x, _this.player.y, true, true);
            }
        });
    };
    /**
     * Generates the player with animations
     * */
    MainScene.prototype.generatePlayer = function () {
        this.player = this.physics.add.sprite(600, 220, "player");
        this.player.setBounce(0.2);
        this.player.setFrame(4);
        // For collision bounds
        this.player.setSize(30, 48);
        this.player.setOffset(8, 15);
        this.player.setDisplaySize(32, 48);
        //  Player animations, turning, walking left and walking right.
        this.anims.create({
            key: 'left',
            frames: this.anims.generateFrameNumbers('player', { start: 0, end: 3 }),
            frameRate: 10,
            repeat: -1
        });
        this.anims.create({
            key: 'turn',
            frames: [{ key: 'player', frame: 4 }],
            frameRate: 20
        });
        this.anims.create({
            key: 'right',
            frames: this.anims.generateFrameNumbers('player', { start: 5, end: 8 }),
            frameRate: 10,
            repeat: -1
        });
        // Player collides with the borders
        this.physics.add.collider(this.player, this.borders);
    };
    /**
     * Generates the astronaut and 10 characters with their Holland Codes
     */
    MainScene.prototype.generateNPCs = function () {
        var _this = this;
        this.characters = [];
        var characterCodes = [
            __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__["a" /* HollandCode */].R,
            __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__["a" /* HollandCode */].I,
            __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__["a" /* HollandCode */].I,
            __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__["a" /* HollandCode */].A,
            __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__["a" /* HollandCode */].A,
            __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__["a" /* HollandCode */].S,
            __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__["a" /* HollandCode */].S,
            __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__["a" /* HollandCode */].S,
            __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__["a" /* HollandCode */].E,
            __WEBPACK_IMPORTED_MODULE_2__objects_HollandCode__["a" /* HollandCode */].C,
        ];
        // Shuffle them
        characterCodes = characterCodes.sort(function () { return .5 - Math.random(); });
        var i = 0;
        this.characterLayer.objects.forEach(function (ob) {
            if (ob.name === "astronaut") {
                _this.astronaut = _this.physics.add.sprite(ob.x, ob.y, "pilots", "s");
                _this.astronaut.setDisplaySize(32, 48);
                _this.astronaut.setDataEnabled();
                _this.astronaut.setData('enabled', true);
                _this.physics.add.collider(_this.astronaut, _this.borders);
                _this.physics.add.overlap(_this.astronaut, _this.player);
            }
            else {
                var char = _this.physics.add.sprite(ob.x, ob.y + 30, "aliens", ob.type);
                char.setDisplaySize(40, 38);
                _this.physics.add.collider(char, _this.borders);
                _this.physics.add.overlap(char, _this.player);
                _this.characters.push(new __WEBPACK_IMPORTED_MODULE_0__objects_Character__["a" /* Character */](ob.id, characterCodes[i], char));
                i++;
            }
        });
    };
    MainScene.prototype.setCollisions = function () {
        var _this = this;
        this.collisionLayer.objects.forEach(function (object) {
            // The group will have an array of objects - these are the individual collision shapes
            var gameObject = new Phaser.GameObjects.Zone(_this, object.x, object.y, object.width, object.height);
            gameObject.type = object.type;
            _this.physics.add.existing(gameObject, true);
            _this.physics.add.collider(_this.player, gameObject, function (player, object) {
                if (object.type === "canJumpThrough") {
                    // Allow player to jump up through these platforms
                    object.body.checkCollision.down = false;
                }
            });
            _this.physics.add.collider(_this.astronaut, gameObject);
            _this.characters.forEach(function (c) {
                _this.physics.add.collider(c.object, gameObject);
            });
        });
    };
    /**
     * Called when meeting the astronaut, checks if the game is over or not
     * */
    MainScene.prototype.talkToAstronaut = function () {
        var _this = this;
        this.astronaut.setData('enabled', false);
        if (!this.isModalOnScreen()) {
            var text, buttonText, id, positive1, positive2;
            var nextToAstro = true;
            var config = this.modalConfig;
            config.buttonWidth = 100;
            // Check if the game is over yet
            if (this.isGameOver()) {
                text = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.complete");
                buttonText = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate("common.done");
                id = 1;
                nextToAstro = false;
            }
            else {
                // Check if they have assigned all characters, otherwise game isn't over because score < 20
                var numNotAssigned = 0;
                this.characters.forEach(function (c) {
                    if (c.assignedOccupation == null) {
                        numNotAssigned++;
                    }
                });
                if (numNotAssigned === 1) {
                    positive1 = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.keepGoing1_singular");
                    positive2 = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.keepGoing2_singular");
                    text = positive1 + numNotAssigned + positive2;
                }
                else if (numNotAssigned > 1) {
                    positive1 = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.keepGoing1_plural");
                    positive2 = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.keepGoing2_plural");
                    text = positive1 + numNotAssigned + positive2;
                }
                else {
                    // They have assigned all but their score is < 20, so tell them to try different matches
                    text = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.wrongAnswers");
                }
                buttonText = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate("common.ok");
                id = 2;
            }
            config.title = text;
            this.astronautModal = new __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, [{ displayText: buttonText, id: id }], config);
            this.astronautModal.depth = 1001;
            if (nextToAstro) {
                this.astronautModal.setPosition(this.astronaut.getBottomRight().x - this.astronautModal.width / 2, this.gameHeight - 300);
            }
            else {
                this.astronautModal.setPosition(this.astronaut.getBottomRight().x - this.astronautModal.width / 2, this.gameHeight - 400);
            }
            this.astronautModal.on('optionClicked', function (op) {
                if (op.id === 2) {
                    // Just continue on with the game
                    _this.astronautModal.destroy();
                }
                else {
                    _this.player.disableBody();
                    // Game Over
                    _this.sys.game.onComplete();
                }
            });
        }
    };
    MainScene.prototype.getKeyPressKey = function (index) {
        var key;
        index++;
        if (index <= 9) {
            key = index.toString();
        }
        else if (index === 10) {
            key = "0";
        }
        return key;
    };
    /**
     * Called when player meets a character, asks user for occupation assignment
     * */
    MainScene.prototype.talkToCharacter = function (character) {
        var _this = this;
        if (!this.isModalOnScreen()) {
            character.enabled = false;
            var text = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "npc." + character.hollandCode.actualCode);
            var audio = this.sound.add(this.translateString + "npc." + character.hollandCode.actualCode);
            audio.play();
            var options = [];
            var id = 0;
            this.possibleOccupations.forEach(function (occ) {
                //var translatedJob = this.getKeyPressKey(id) + ': ' + TranslateApi.translate(occ.title);
                var translatedJob = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(occ.title);
                var option = { displayText: translatedJob, id: id, object: occ };
                options.push(option);
                id++;
            });
            // Last option is always for None/Unassign
            //var none = "DEL : " + TranslateApi.translate(this.translateString + "none");
            var none = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "none");
            options.push({ displayText: none, id: id, object: null });
            var config = this.modalConfig;
            config.title = text;
            config.buttonWidth = 220;
            this.characterModal = new __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, options, config);
            // On top of gamepad!
            this.characterModal.depth = 1001;
            this.moveModal(character);
            this.characterModal.on('optionClicked', function (op) {
                // Assign character new occupation (op.object)
                _this.updateScoreboard(character, op.object);
                _this.showAssignedOccupation(character);
                _this.characterModal.destroy();
            });
        }
    };
    /**
     * Updates score based on the character/occupation
     */
    MainScene.prototype.updateScoreboard = function (character, newOccupation) {
        var currentScore = this.score.getData('score');
        var assignmentPoints;
        var characterCode = character.hollandCode;
        // Unassigning Character (None)
        if (newOccupation == null) {
            // Get their previous assignment points
            if (character.assignedOccupation != null) {
                var assignedOccupationCode = character.assignedOccupation.hollandCode;
                var prevPoints = this.getAssignmentPoints(characterCode, assignedOccupationCode);
                // Subtract those points from current score
                currentScore -= prevPoints;
                // Add their previous assigned occupation back to the list
                this.possibleOccupations.add(character.assignedOccupation);
                character.assignedOccupation = null;
                // Update Score
                this.changeScore(currentScore);
            }
            return;
        }
        // Assigning Character a real occupation
        var occupationCode = newOccupation.hollandCode;
        var isAlreadyAssigned = character.assignedOccupation != null;
        if (!isAlreadyAssigned) {
            // First time assigning this character
            assignmentPoints = this.getAssignmentPoints(characterCode, occupationCode);
        }
        else {
            // Get their previous assignment points
            var assignedOccupationCode = character.assignedOccupation.hollandCode;
            var prevPoints = this.getAssignmentPoints(characterCode, assignedOccupationCode);
            // Subtract those points from current score
            currentScore -= prevPoints;
            // Calculate new points
            assignmentPoints = this.getAssignmentPoints(characterCode, occupationCode);
            // Add their previous assigned occupation back to the list
            this.possibleOccupations.add(character.assignedOccupation);
        }
        // Reassign
        character.assignedOccupation = newOccupation;
        // Remove this occupation from list of possible occupations
        this.possibleOccupations.delete(newOccupation);
        // Finally, update Score
        var newScore = currentScore + assignmentPoints;
        this.changeScore(newScore);
    };
    MainScene.prototype.changeScore = function (newScore) {
        var _this = this;
        var color, tweenX;
        tweenX = this.score.x;
        if (newScore < this.score.getData("score")) {
            color = __WEBPACK_IMPORTED_MODULE_9_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("red");
            tweenX += 5;
        }
        else if (newScore > this.score.getData("score")) {
            color = __WEBPACK_IMPORTED_MODULE_9_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("green");
        }
        this.tweens.add({
            targets: this.score,
            duration: 50,
            repeat: 4,
            yoyo: true,
            ease: "Linear",
            x: tweenX,
            onStart: function () {
                _this.score.setTint(color);
            },
            onComplete: function () {
                _this.score.clearTint();
            }
        });
        var scoreText = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "score") + ": ";
        this.score.setData('score', newScore);
        this.score.setText(scoreText + newScore);
        this.scoreBorder.setDisplaySize(this.score.displayWidth + 10, this.score.displayHeight + 10);
    };
    MainScene.prototype.update = function () {
        this.updatePlayerMovement();
        this.checkIfPlayerIsNextToAstronaut();
        this.updateModalVisibility();
    };
    MainScene.prototype.checkIfPlayerIsNextToAstronaut = function () {
        var area = this.astronaut.getBounds();
        var rect = new Phaser.Geom.Rectangle(area.x, area.y, 75, 50);
        rect.centerX = this.astronaut.getCenter().x;
        rect.centerY = this.astronaut.getCenter().y;
        if (Phaser.Geom.Intersects.RectangleToRectangle(rect, this.player.getBounds()) && this.astronaut.getData('enabled')) {
            this.talkToAstronaut();
        }
        if (!Phaser.Geom.Intersects.RectangleToRectangle(rect, this.player.getBounds()) && !this.astronaut.getData('enabled')) {
            // Once they leave the astronaut, set it as enabled again so they can keep checking the game state/end the game
            this.astronaut.setData('enabled', true);
            if (this.astronautModal != null && this.isModalOnScreen()) {
                this.astronautModal.destroy();
                this.sound.stopAll();
            }
        }
    };
    /**
     * Closes modals if player walks away from them
     */
    MainScene.prototype.updateModalVisibility = function () {
        var c;
        for (var _i = 0, _a = this.characters; _i < _a.length; _i++) {
            c = _a[_i];
            var rect = c.object.getBounds();
            rect.width = 100;
            rect.height = 100;
            rect.centerX = c.object.getCenter().x;
            rect.centerY = c.object.getCenter().y;
            // Player is next to a candidate so just return (modal should be open)
            if (Phaser.Geom.Intersects.RectangleToRectangle(rect, this.player.getBounds())) {
                return;
            }
        }
        // Player isn't next to any candidate, so close the modal
        if (this.isModalOnScreen() && this.characterModal != null) {
            this.characterModal.destroy();
            this.sound.stopAll();
        }
    };
    MainScene.prototype.isGameOver = function () {
        // Are all characters assigned to an occupation?
        var c;
        for (var _i = 0, _a = this.characters; _i < _a.length; _i++) {
            c = _a[_i];
            if (c.assignedOccupation == null) {
                return false;
            }
        }
        // Have to have at least 20 points to end game
        if (this.score.getData('score') >= 20) {
            return true;
        }
    };
    /**
     * Show the assigned occupation as a label next to the character
     * */
    MainScene.prototype.showAssignedOccupation = function (character) {
        // No label to show, they chose "None"
        if (character.assignedOccupation == null) {
            // Delete the current label 
            if (character.label != null) {
                character.label.destroy();
                character.label = null;
            }
            return;
        }
        // Remove their existing label if they have one
        if (character.label) {
            character.label.destroy();
            character.label = null;
        }
        var x = character.object.x - 10;
        if (character.object.x > this.gameWidth - 30) {
            x = character.object.x - 6 * character.assignedOccupation.title.length;
        }
        var label = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(character.assignedOccupation.title);
        var labelStyle = { fontSize: 15, fontFamily: 'Russo One, Arial', padding: 10, align: 'center', backgroundColor: '#000000', color: '#ffffff' };
        character.label = this.add.text(0, 0, label, labelStyle);
        character.label.x = character.object.getCenter().x - character.label.width / 2;
        if (character.label.x < 100) {
            character.label.x = character.object.x;
        }
        if (character.label.getBottomRight().x >= this.gameWidth - 10) {
            character.label.x = this.gameWidth - character.label.width - 10;
        }
        character.label.y = character.object.getTopLeft().y - character.label.height - 10;
        character.label.setAlpha(0.75);
    };
    // For debugging only
    MainScene.prototype.getCharacterInfo = function () {
        this.characters.forEach(function (c) {
            console.log(c.assignedOccupation, c.label);
        });
    };
    /**
     * Finds the best possible matching occupation for the specified character (since there is not a 1:1 ratio of codes/occupations)
     */
    MainScene.prototype.findBestMatch = function (character) {
        var _this = this;
        var best = 0;
        var bestOcc = null;
        this.possibleOccupations.forEach(function (occ) {
            var points = _this.getAssignmentPoints(character.hollandCode, occ.hollandCode);
            if (points > best) {
                best = points;
                bestOcc = occ;
            }
        });
        return bestOcc;
    };
    /**
     * Get the correct number of points for the specified character holland code/occupation code assignment
     */
    MainScene.prototype.getAssignmentPoints = function (characterCode, occupationCode) {
        var matrix = [
            [3, 2, 1, 0, 1, 2],
            [2, 3, 2, 1, 0, 1],
            [1, 2, 3, 2, 1, 0],
            [0, 1, 2, 3, 2, 1],
            [1, 0, 1, 2, 3, 2],
            [2, 1, 0, 1, 2, 3]
        ];
        var code_index = ["R", "I", "A", "S", "E", "C"];
        return matrix[code_index.indexOf(characterCode.actualCode)][code_index.indexOf(occupationCode.actualCode)];
    };
    /**
     * Checks if there is already a modal open on screen (we don't want to be able to add more than one modal to a scene)
     */
    MainScene.prototype.isModalOnScreen = function () {
        for (var _i = 0, _a = this.children.list; _i < _a.length; _i++) {
            var c = _a[_i];
            if (c.type === "PhaserModal") {
                return true;
            }
        }
        return false;
    };
    MainScene.prototype.moveModal = function (character) {
        var x, y;
        var padding = character.object.displayWidth;
        var characterX = character.object.x - this.cameras.main.scrollX;
        // If running off the right, put modal on the left of the character
        if (characterX + padding + this.characterModal.width >= this.gameWidth - padding) {
            x = characterX - this.characterModal.width - padding;
        }
        else {
            // Otherwise, put it to the right of the character
            x = characterX + padding;
        }
        var characterY = character.object.getBottomRight().y - this.cameras.main.scrollY;
        // If running off the bottom or top, vertically center modal
        if ((characterY + this.characterModal.height / 2 >= this.gameHeight - padding) || (characterY - this.characterModal.height / 2 <= padding)) {
            y = this.gameHeight / 2 - this.characterModal.height / 2;
        }
        else {
            // Otherwise, put it next to the character
            y = characterY - this.characterModal.height / 2;
        }
        this.characterModal.setPosition(x, y);
    };
    MainScene.prototype.closeOnScreenModals = function () {
        this.children.list.forEach(function (c) {
            if (c.type === "PhaserModal") {
                var modal = c;
                modal.destroy();
            }
        });
    };
    /**
     * GamePad/Player Movement
     * EVENT BASED FOR JUMPING, UPDATE BASED FOR LEFT/RIGHT
     */
    MainScene.prototype.createGamePad = function () {
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.gamePad.on("keydown_up", this.playerJump);
        this.gamePad.on("keydown_a", this.playerJump);
        this.gamePad.on("keydown_b", this.bDown);
    };
    MainScene.prototype.moveLeft = function () {
        if (this.player.body.enable) {
            this.xVel += -this.WALKING_VELOCITY;
            this.player.anims.play('left', true);
        }
    };
    MainScene.prototype.moveRight = function () {
        if (this.player.body.enable) {
            this.xVel += this.WALKING_VELOCITY;
            this.player.anims.play('right', true);
        }
    };
    MainScene.prototype.bDown = function () {
        if (this.hollandCodeGraphic.visible) {
            return;
        }
        if (this.astronautModal && this.astronautModal.active) {
            this.astronautModal.selectLastOption();
            return;
        }
        for (var _i = 0, _a = this.characters; _i < _a.length; _i++) {
            var c = _a[_i];
            var area = c.object.getBounds();
            area.width = 150;
            area.height = 150;
            var rect = new Phaser.Geom.Rectangle(area.x, area.y, area.width, area.height);
            rect.centerX = c.object.getCenter().x;
            rect.centerY = c.object.getCenter().y;
            if (Phaser.Geom.Intersects.RectangleToRectangle(rect, this.player.getBounds())) {
                this.talkToCharacter(c);
            }
        }
    };
    MainScene.prototype.playerJump = function () {
        if (this.player.body.onFloor()) {
            this.player.body.setVelocityY(-this.JUMPING_VELOCITY);
        }
        else if (this.doubleJump) {
            this.doubleJump = false;
            this.player.body.setVelocityY(-this.JUMPING_VELOCITY);
        }
    };
    MainScene.prototype.updatePlayerMovement = function () {
        this.xVel = 0;
        if (this.gamePad.keys.left.isDown) {
            this.moveLeft();
        }
        if (this.gamePad.keys.right.isDown) {
            this.moveRight();
        }
        this.player.setVelocityX(this.xVel);
        if (this.xVel === 0) {
            this.player.anims.play('turn');
        }
        if (this.frameCount % 4 === 0) {
            if (this.player.body.onFloor()) {
                this.doubleJump = true;
            }
        }
        if (this.frameCount > 64000) {
            this.frameCount = 0;
        }
        this.frameCount++;
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Character; });
var Character = /** @class */ (function () {
    function Character(id, hollandCode, object) {
        this.hollandCode = hollandCode;
        this.id = id;
        this.assignedOccupation = null;
        this.object = object;
        this.label = null;
        this.enabled = true;
    }
    return Character;
}());



/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Occupation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HollandCode__ = __webpack_require__(872);

var Occupation = /** @class */ (function () {
    function Occupation(title, code) {
        this.title = title;
        this.hollandCode = code;
    }
    Occupation.OCCUPATIONS = [
        new Occupation("JobMatching.Phaser.jobs.R.1", __WEBPACK_IMPORTED_MODULE_0__HollandCode__["a" /* HollandCode */].R),
        new Occupation("JobMatching.Phaser.jobs.R.2", __WEBPACK_IMPORTED_MODULE_0__HollandCode__["a" /* HollandCode */].R),
        new Occupation("JobMatching.Phaser.jobs.I.1", __WEBPACK_IMPORTED_MODULE_0__HollandCode__["a" /* HollandCode */].I),
        new Occupation("JobMatching.Phaser.jobs.I.2", __WEBPACK_IMPORTED_MODULE_0__HollandCode__["a" /* HollandCode */].I),
        new Occupation("JobMatching.Phaser.jobs.A.1", __WEBPACK_IMPORTED_MODULE_0__HollandCode__["a" /* HollandCode */].A),
        new Occupation("JobMatching.Phaser.jobs.S.1", __WEBPACK_IMPORTED_MODULE_0__HollandCode__["a" /* HollandCode */].S),
        new Occupation("JobMatching.Phaser.jobs.S.2", __WEBPACK_IMPORTED_MODULE_0__HollandCode__["a" /* HollandCode */].S),
        new Occupation("JobMatching.Phaser.jobs.E.1", __WEBPACK_IMPORTED_MODULE_0__HollandCode__["a" /* HollandCode */].E),
        new Occupation("JobMatching.Phaser.jobs.E.2", __WEBPACK_IMPORTED_MODULE_0__HollandCode__["a" /* HollandCode */].E),
        new Occupation("JobMatching.Phaser.jobs.C.1", __WEBPACK_IMPORTED_MODULE_0__HollandCode__["a" /* HollandCode */].C),
    ];
    return Occupation;
}());



/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/grade5-S__ bg.5bc7f787.jpg";

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/job_matching.dde9f57a.json";

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameUniversity.8341620b.png";

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameUniversity.7e3d3275.json";

/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseScene__ = __webpack_require__(2275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_GameState__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Character__ = __webpack_require__(880);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Colony;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__BaseScene__["a" /* BaseScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "Colony.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Colony.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "Colony.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    HowToPlayScene.prototype.create = function () {
        _super.prototype.create.call(this);
        /** JB: Note
         * Required because this game was an early prototype made real
         * This properly loads the gamestate, starting at slide 1 when moving to the next scene
         */
        // Get the first slide and initialize GameState
        var slides = __webpack_require__(881);
        var startSlide = slides[0];
        var dialog = startSlide.dialogKey;
        var options = startSlide.options;
        __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current = new __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */](__WEBPACK_IMPORTED_MODULE_5__objects_Character__["a" /* Character */].EEBOT, dialog, options);
    };
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_GameState__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_Character__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_constants_KeyboardNumKeys__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var BaseScene = /** @class */ (function (_super) {
    __extends(BaseScene, _super);
    function BaseScene() {
        var _this = _super.call(this, {
            key: "BaseScene" + Math.random()
        }) || this;
        _this.optionArea1 = null;
        _this.optionArea2 = null;
        _this.optionArea3 = null;
        _this.dialogBoxArea = null;
        _this.padding = 20;
        _this.characterArea = null;
        _this.chartOnScreen = false;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, BaseScene.prototype);
        return _this;
    }
    BaseScene.prototype.preload = function () {
        var _this = this;
        // Slides
        this.slides = __webpack_require__(881);
        // Skip the regular preload operations because they are already loaded
        if (__WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.isLoaded) {
            return;
        }
        // Catch load errors here
        this.load.on("loaderror", function (file) {
            console.error("File load error: " + file.key);
            // Audio file missed, load blank audio as it *should* always exist
            if (file.type === "audio") {
                _this.load.audio(file.key, __webpack_require__(514));
            }
        });
        this.load.tilemapTiledJSON("map", __webpack_require__(2276));
        this.load.atlas("assets", __webpack_require__(2277), __webpack_require__(2278));
        // Terrains (Backgrounds)
        this.load.image("terrain_r", __webpack_require__(367));
        this.load.image("terrain_i", __webpack_require__(368));
        this.load.image("terrain_s", __webpack_require__(515));
        this.load.image("terrain_c", __webpack_require__(369));
        // Charts
        this.load.image('chart1', __webpack_require__(2279));
        this.load.image('chart2', __webpack_require__(2280));
        this.load.image('chart3', __webpack_require__(2281));
        this.load.image('chart4', __webpack_require__(2282));
        this.load.image('chart5', __webpack_require__(2283));
        // Audio
        this.slides.forEach(function (slide) {
            _this.load.audio(slide.dialogKey, __WEBPACK_IMPORTED_MODULE_6_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(slide.dialogKey, __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
            slide.options.forEach(function (option) {
                _this.load.audio(option.textKey, __WEBPACK_IMPORTED_MODULE_6_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(option.textKey, __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
            });
        });
        __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.isLoaded = true;
    };
    BaseScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "map" });
    };
    BaseScene.prototype.create = function () {
        this.initialize();
        if (__WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.currentSlideID <= this.slides.length) {
            this.generateScene();
        }
        this.bindNumKeys();
    };
    BaseScene.prototype.generateScene = function () {
        var _this = this;
        this.addBackground();
        var currentSlideId = __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.currentSlideID;
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "character") {
                _this.characterArea = ob;
            }
            else if (ob.name === "dialog") {
                _this.dialogBoxArea = ob;
                _this.dialogHeight = _this.addDialog();
            }
            else if (ob.name === "option_1") {
                _this.optionArea1 = ob;
            }
            else if (ob.name === "option_2") {
                _this.optionArea2 = ob;
            }
            else if (ob.name === "option_3") {
                _this.optionArea3 = ob;
            }
        });
        // Add chart if necessary
        if (currentSlideId === 27) {
            this.addChart(1);
        }
        else if (currentSlideId === 31) {
            this.addChart(2);
        }
        else if (currentSlideId === 46) {
            this.addChart(3);
        }
        else if (currentSlideId === 58) {
            this.addChart(4);
        }
        else if (currentSlideId === 73) {
            this.addChart(5);
        }
        // Load audio
        var currentSlide = this.slides.find(function (x) { return x.id === __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.currentSlideID; });
        var dialogSound = this.sound.add(currentSlide.dialogKey);
        dialogSound.play();
        if (currentSlide.options.length > 0) {
            var firstOptionKey = currentSlide.options[0].textKey;
            var firstOptionSound = this.sound.add(firstOptionKey);
            firstOptionSound.play("", { delay: dialogSound.totalDuration });
            if (currentSlide.options.length > 1) {
                var secondOptionKey = currentSlide.options[1].textKey;
                var secondOptionSound = this.sound.add(secondOptionKey);
                secondOptionSound.play("", { delay: dialogSound.totalDuration + firstOptionSound.totalDuration });
            }
        }
        this.addOptions();
        this.addCharacter();
    };
    /**
     * Adds the appropriate background to the scene according to the slideCharacter
     */
    BaseScene.prototype.addBackground = function () {
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(0x6eb8e5);
        var background = this.add.image(200, 0, __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.slideCharacter.backgroundAsset);
        background.setOrigin(0);
        background.setPosition(0, this.gameHeight - background.height);
        var nameSet = new Set(__WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.slideCharacter.assetNames);
        // Librarius's background has Mr. Tiger pants somewhere (can take this out if the background itself includes him)
        if (nameSet.has("librarius")) {
            var tiger = this.add.image(0, 0, "assets", "tiger1");
            tiger.setOrigin(0);
            tiger.setDisplaySize(200, 100);
            tiger.setPosition(50, 650);
        }
    };
    BaseScene.prototype.addOptions = function () {
        if (__WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.slideOptions.length > 1) {
            // Use optionArea1 and optionArea2
            var option1 = this.createOptionButton(this.optionArea1, 0, false);
            var option2 = this.createOptionButton(this.optionArea2, 1, false);
            option2.setY(option1.y + option1.height + this.padding);
        }
        else {
            // Just optionArea3
            var singleOption = this.createOptionButton(this.optionArea3, 0, true);
            // Get best button size and center it under the dialog box area
            singleOption.setDisplaySize(singleOption.getIdealButtonWidth() + this.padding, singleOption.getIdealButtonHeight() + this.padding);
            singleOption.setX(this.dialogBoxArea.x + this.dialogBoxArea.width / 2 - singleOption.width / 2);
        }
    };
    BaseScene.prototype.createOptionButton = function (ob, index, isPrimary) {
        var _this = this;
        var option = __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.slideOptions[index];
        var buttonConfig = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        buttonConfig.backgroundColor = isPrimary ? __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON : __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON;
        buttonConfig.smartHeight = true;
        var yPos = this.dialogHeight + 100;
        var optionButton = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, ob.x + 5, yPos + 5, ob.width, ob.height, (index + 1) + ' :' + __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(option.textKey), buttonConfig);
        optionButton.setDepth(5);
        if (optionButton.getIdealButtonHeight() <= ob.height) {
            optionButton.setDisplaySize(optionButton.width, optionButton.getIdealButtonHeight());
        }
        optionButton.on('buttonClicked', function () {
            _this.selectOption(option);
        });
        return optionButton;
    };
    BaseScene.prototype.addDialog = function () {
        var ob = this.dialogBoxArea;
        var dialogText = __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.slideDialog;
        var dialog = this.add.text(ob.x, ob.y, dialogText);
        dialog.setOrigin(0);
        dialog.setPadding(this.padding, this.padding, this.padding, this.padding);
        dialog.setFontFamily('Roboto Mono, Arial');
        dialog.setFontSize(this.getDialogTextSize(dialogText));
        dialog.setWordWrapWidth(ob.width - (2 * this.padding), true);
        dialog.setDepth(10);
        dialog.setColor("#F8E71C");
        var height = this.getDialogHeight(ob.height, dialogText);
        // Background for the dialog that spans across the scene
        var outline = this.add.image(ob.x - 5, ob.y - 5, "pixel");
        outline.setOrigin(0);
        outline.setTint(__WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.slideCharacter.color);
        outline.setDisplaySize(ob.width + 10, height + 10);
        var dialogBackground = this.add.image(ob.x, ob.y, "pixel");
        dialogBackground.setOrigin(0);
        dialogBackground.setTint(0x000000);
        dialogBackground.setDepth(0);
        dialogBackground.setDisplaySize(ob.width, height);
        return height;
    };
    BaseScene.prototype.getDialogHeight = function (origHeight, dialogText) {
        if (dialogText.length >= 840) {
            return origHeight;
        }
        var numLines = Math.ceil(dialogText.length / 60);
        return Math.min(40 + numLines * 25, origHeight);
    };
    BaseScene.prototype.getDialogTextSize = function (dialog) {
        var l = dialog.length;
        if (l <= 840) {
            return 18;
        }
        l -= 840;
        var size = 17;
        while (l > 0 && size >= 1) {
            if (l <= 100) {
                return size;
            }
            l -= 70;
            size -= 1;
        }
        return size;
    };
    /**
     * Character is on the left of the screen and right on top of the dialog strip
     */
    BaseScene.prototype.addCharacter = function () {
        var ob = this.characterArea;
        var slide = this.slides[__WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.currentSlideID - 1];
        var character = this.add.image(ob.x, ob.y, "assets", slide.characterAssetKey);
        character.setOrigin(0);
        var char = this.findCharacter(slide);
        if (this.chartOnScreen) {
            character.setScale(char.scale - 0.1);
        }
        else {
            character.setScale(char.scale);
        }
        character.setY(this.gameHeight - character.displayHeight);
    };
    /**
     * Adds the specified chart to the scene to the top right corner
     */
    BaseScene.prototype.addChart = function (chartNumber) {
        var chart = this.add.image(0, 0, "chart" + chartNumber);
        chart.setOrigin(0);
        chart.setScale(0.6);
        chart.setPosition(this.gameWidth - chart.getBounds().width - this.padding, this.padding);
        this.chartOnScreen = true;
    };
    /**
     * Will change the game state based on the option given
     */
    BaseScene.prototype.setNextGameState = function (option) {
        var nextSlide = this.slides[option.nextSlideID - 1];
        __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.slideDialog = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(nextSlide.dialogKey);
        __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.slideOptions = nextSlide.options;
        __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.slideCharacter = this.findCharacter(nextSlide);
        __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.currentSlideID = option.nextSlideID;
    };
    BaseScene.prototype.getBestButtonSize = function (button1, button2) {
        var maxWidth = Math.max(button1.getIdealButtonWidth(), button2.getIdealButtonWidth()) + this.padding;
        var maxHeight = Math.max(button1.getIdealButtonHeight(), button2.getIdealButtonHeight()) + this.padding;
        var actualMaxWidth = Math.min(maxWidth, this.optionArea1.width - this.padding);
        var actualMaxHeight = Math.min(maxHeight, this.optionArea1.height - this.padding);
        return new Phaser.Math.Vector2(actualMaxWidth, actualMaxHeight);
    };
    BaseScene.prototype.findCharacter = function (slide) {
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_3__objects_Character__["a" /* Character */].CHARACTERS; _i < _a.length; _i++) {
            var c = _a[_i];
            var nameSet = new Set(c.assetNames);
            if (nameSet.has(slide.characterAssetKey)) {
                return c;
            }
        }
        return null;
    };
    BaseScene.prototype.selectOption = function (option) {
        this.sound.stopAll();
        if (option.nextSlideID != null) {
            this.setNextGameState(option);
            this.scene.remove(this);
            this.scene.add("BaseScene", BaseScene, true);
        }
        else {
            // Game Over
            this.sys.game.onComplete();
        }
    };
    BaseScene.prototype.onKeydown = function (event) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        keys.forEach(function (key) {
            _this.input.keyboard.on('keydown_' + key, event);
        });
    };
    BaseScene.prototype.bindNumKeys = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_7_src_constants_KeyboardNumKeys__["a" /* numKeys */].forEach(function (key) {
            _this.onKeydown(function () {
                var slideOption = __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.slideOptions[key.index];
                if (slideOption) {
                    _this.selectOption(slideOption);
                }
            }, key.keyCode, key.altKeyCode);
        });
    };
    return BaseScene;
}(Phaser.Scene));



/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/colony.59d35a39.json";

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameColony.f9c0dfcc.png";

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameColony.44be979b.json";

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/temp_chart1.c47d15bf.png";

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/temp_chart2.bb4b68c4.png";

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/temp_chart3.c711ec5a.png";

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/temp_chart4.27486596.png";

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/temp_chart5.9dab6efd.png";

/***/ }),
/* 2284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(883);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].PuzzleSlider;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "PuzzleSlider.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "PuzzleSlider.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
// Resources:
// https://www.youtube.com/watch?v=BuJ3yrpSj-g
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// import 'phaser';




var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.BOARD_DIM = 4;
        _this.GAME_WIDTH = 1360;
        _this.GAME_HEIGHT = 768;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        if (_this.BOARD_DIM !== 4) {
            throw new Error("Invalid board dimension");
        }
        _this.startTime = false;
        _this.helpFlag = false;
        _this.borderSize = 5;
        _this.PIECE_WIDTH = Math.floor(_this.GAME_WIDTH / 8);
        _this.PIECE_HEIGHT = _this.PIECE_WIDTH;
        return _this;
    }
    MainScene.prototype.preload = function () {
        var num = Math.ceil(Math.random() * 6);
        if (num === 1) {
            this.load.spritesheet("key", __webpack_require__(520), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", __webpack_require__(520), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", __webpack_require__(520));
        }
        else if (num === 2) {
            this.load.spritesheet("key", __webpack_require__(521), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", __webpack_require__(521), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", __webpack_require__(521));
        }
        else if (num === 3) {
            this.load.spritesheet("key", __webpack_require__(522), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", __webpack_require__(522), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", __webpack_require__(522));
        }
        else if (num === 4) {
            this.load.spritesheet("key", __webpack_require__(523), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", __webpack_require__(523), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", __webpack_require__(523));
        }
        else if (num === 5) {
            this.load.spritesheet("key", __webpack_require__(524), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", __webpack_require__(524), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", __webpack_require__(524));
        }
        else if (num === 6) {
            this.load.spritesheet("key", __webpack_require__(525), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", __webpack_require__(525), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", __webpack_require__(525));
        }
        this.load.image("white", __webpack_require__(884));
        this.load.image("pixel", __webpack_require__(60));
        this.load.image('terrain', __webpack_require__(369));
        this.load.atlas("pilots", __webpack_require__(189), __webpack_require__(190));
    };
    MainScene.prototype.create = function () {
        this.translateString = "PuzzleSlider.Phaser.";
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.GAME_WIDTH, this.GAME_HEIGHT);
        sky.setTint(0x6eb8e5, 0x6eb8e5, 0xffffff, 0xffffff); // Gradient sky!
        var terrain = this.add.image(0, 400, "terrain");
        terrain.setScale(0.8);
        terrain.setOrigin(0);
        this.timeText = this.add.text(this.GAME_WIDTH - 125, 200, "0:00", { fill: "#000000", align: "center" }).setDepth(10).setOrigin().setFontFamily('Russo One, Roboto Mono, Arial').setFontSize(30);
        this.setupText();
        this.setupTimer();
        this.setupBoard();
        this.count = this.checkNumLeft();
        this.addControlPanel();
        this.addRescrambleButton();
        this.makeBlocksLeftBox();
    };
    MainScene.prototype.setupText = function () {
        this.text = this.add.text(935, 505, "", { fill: "#ffffff", align: "center" }).setFontFamily('Roboto Mono, Russo One, Arial').setFontSize(24);
        this.text.setWordWrapWidth(230);
        this.text.setOrigin(.5);
        this.text.setDepth(3);
        this.speechBox = this.add.image(820, 455, "pixel");
        this.speechBox.setOrigin(0);
        this.speechBox.setTint(0x000000);
        this.speechBox.setDepth(2.75);
        this.speechBox.setDisplaySize(230, 130);
        this.speechBox.setAlpha(0);
        this.outline = this.add.image(815, 450, "pixel");
        this.outline.setOrigin(0);
        this.outline.setTint(0xFFFF00);
        this.outline.setDisplaySize(240, 140);
        this.outline.setDepth(2.5);
        this.outline.setAlpha(0);
    };
    MainScene.prototype.setupTimer = function () {
        this.timer = this.time.addEvent({ delay: 10000000, timeScale: 1.0 });
        var clock = this.add.image(this.GAME_WIDTH - 125, 200, "pixel").setDisplaySize(110, 50).setDepth(6.5);
        var clockBorder = this.add.image(clock.x, clock.y, "pixel").setDisplaySize(120, 60).setDepth(6).setTint(0x000000);
    };
    MainScene.prototype.setupBoard = function () {
        this.clickLock = false;
        var order = [];
        order = this.createSolvableIndexArray();
        this.createBlocks(order, "key");
    };
    MainScene.prototype.makeBlocksLeftBox = function () {
        var box = this.add.image(this.blocksLeftText.x, this.blocksLeftText.y, "pixel");
        box.setDisplaySize(this.blocksLeftText.displayWidth + 20, this.blocksLeftText.displayHeight + 10);
        box.setDepth(2);
        var edge = this.add.image(box.x, box.y, "pixel");
        edge.setDisplaySize(box.displayWidth + 10, box.displayHeight + 10);
        edge.setTint(0x000000);
        edge.setDepth(1.5);
    };
    MainScene.prototype.createBlocks = function (orderArray, key) {
        var _this = this;
        this.blockGroup = [];
        var count = 0;
        var padding = 4 * this.borderSize;
        for (var row = 0; row < this.BOARD_DIM; row++) {
            var _loop_1 = function (col) {
                // Wherever the largest number is in the order array, use that index for the black block
                if (orderArray[count] === this_1.BOARD_DIM * this_1.BOARD_DIM - 1) {
                    this_1.blackBlock = this_1.add.sprite((col) * (this_1.PIECE_WIDTH + 2) + padding, (row) * (this_1.PIECE_HEIGHT + 2) + 2 * padding, "white");
                    this_1.blackBlock.setOrigin(0);
                    this_1.blackBlock.setDepth(1);
                    this_1.blackBlock.setTint(0xd3d3d3);
                    this_1.blackBlock.setDisplaySize(this_1.PIECE_WIDTH, this_1.PIECE_HEIGHT);
                    this_1.blackBlock.setAlpha(0);
                    this_1.blackBlock.name = "black";
                    this_1.blackBlock.setData("key", orderArray[count]);
                    this_1.blockGroup.push(this_1.blackBlock);
                    count++;
                }
                // Create normal blocks using the sprite for the rest of the blocks
                else {
                    var block_1 = this_1.add.sprite((col) * (this_1.PIECE_WIDTH + 2) + padding, (row) * (this_1.PIECE_HEIGHT + 2) + 2 * padding, key, orderArray[count]);
                    block_1.setOrigin(0);
                    block_1.setInteractive();
                    block_1.setDepth(2);
                    block_1.setDisplaySize(this_1.PIECE_WIDTH, this_1.PIECE_HEIGHT);
                    block_1.setData("key", orderArray[count]);
                    block_1.on('pointerdown', function () {
                        _this.switchBlocks(block_1, _this.blackBlock);
                    });
                    count++;
                    this_1.blockGroup.push(block_1);
                }
            };
            var this_1 = this;
            for (var col = 0; col < this.BOARD_DIM; col++) {
                _loop_1(col);
            }
        }
    };
    MainScene.prototype.addRescrambleButton = function () {
        var _this = this;
        var config = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.backgroundColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        config.smartSize = true;
        var text = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "reshuffle");
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, this.GAME_WIDTH - 200, 50, 150, 50, text, config);
        button.setX(this.GAME_WIDTH - button.width - 69);
        button.setDepth(3);
        button.on('buttonClicked', function () {
            if (!_this.clickLock) {
                _this.destroyOldPieces();
                if (_this.BOARD_DIM === 4) {
                    _this.setupBoard();
                }
                else if (_this.BOARD_DIM === 3) {
                    _this.setup3Board();
                }
                if (_this.helpFlag) {
                    _this.yesButton.destroy();
                    _this.noButton.destroy();
                }
                _this.helpFlag = false;
                _this.startTime = false;
                _this.timeText.setText("0:00");
                _this.setupTimer();
                _this.text.setText("");
                _this.outline.setAlpha(0);
                _this.speechBox.setAlpha(0);
                _this.blocksLeftText.destroy();
                _this.checkNumLeft();
            }
        });
    };
    MainScene.prototype.addControlPanel = function () {
        var pic = this.add.image(780, 55, "finishedKey");
        pic.setDepth(3);
        pic.setOrigin(0);
        pic.setAlpha(1);
        pic.setDisplaySize(320, 320);
        var border = this.add.image(775, 50, "pixel");
        border.setTint(0x000000);
        border.setOrigin(0);
        border.setDisplaySize(330, 330);
        border.setDepth(2);
        var astronaut = this.add.image(1200, 603, "pilots", "c");
        astronaut.setDepth(3);
        astronaut.setOrigin(.5);
        astronaut.setScale(.5, .5);
    };
    MainScene.prototype.switchBlocks = function (toSwitch, black) {
        if (this.clickLock) {
            return;
        }
        var diffX = Math.abs(black.x - toSwitch.x);
        var diffY = Math.abs(black.y - toSwitch.y);
        if (!this.isBlockMovable(diffX, diffY)) {
            return;
        }
        this.clickLock = true;
        if (!this.startTime) {
            this.setupTimer();
            this.startTime = true;
        }
        // Change the block's locations in the blockgroup array
        var swIndex = this.blockGroup.indexOf(toSwitch);
        var blIndex = this.blockGroup.indexOf(black);
        this.blockGroup[blIndex] = toSwitch;
        this.blockGroup[swIndex] = black;
        this.moveBlock(toSwitch, this.blackBlock);
    };
    /**
     * moveBlock function adds tween animation to moving blocks
     * @param block
     * @param blackBlock
     */
    MainScene.prototype.moveBlock = function (block, blackBlock) {
        var _this = this;
        this.tweens.add({
            targets: blackBlock,
            x: block.x,
            y: block.y,
            duration: 400,
            onComplete: function () {
            }
        });
        this.tweens.add({
            targets: block,
            x: blackBlock.x,
            y: blackBlock.y,
            duration: 400,
            onComplete: function () {
                _this.clickLock = false;
                _this.checkIfCompleted();
            }
        });
    };
    MainScene.prototype.isBlockMovable = function (diffX, diffY) {
        if (diffX === (this.PIECE_WIDTH + 2) && diffY === (this.PIECE_HEIGHT + 2)) {
            return false;
        }
        if (diffX > (this.PIECE_WIDTH + 2) || diffY > (this.PIECE_HEIGHT + 2)) {
            return false;
        }
        return true;
    };
    MainScene.prototype.createSolvableIndexArray = function () {
        var indexArray = [];
        for (var i = 0; i < this.BOARD_DIM * this.BOARD_DIM; i++) {
            indexArray.push(i);
        }
        var scrambleIndex = 0;
        while (scrambleIndex < 10) {
            for (var j = 0; j < 75; j++) {
                var blackIndex = indexArray.indexOf(15);
                var rand = Math.random() * 4;
                if (rand < 1) {
                    if (blackIndex !== 0 && blackIndex !== 4 && blackIndex !== 8 && blackIndex !== 12) {
                        this.swap(indexArray, blackIndex, blackIndex - 1);
                    }
                }
                else if (rand < 2) {
                    if (blackIndex !== 0 && blackIndex !== 1 && blackIndex !== 2 && blackIndex !== 3) {
                        this.swap(indexArray, blackIndex, blackIndex - 4);
                    }
                }
                else if (rand < 3) {
                    if (blackIndex !== 3 && blackIndex !== 7 && blackIndex !== 11 && blackIndex !== 15) {
                        this.swap(indexArray, blackIndex, blackIndex + 1);
                    }
                }
                else if (rand < 4) {
                    if (blackIndex !== 12 && blackIndex !== 13 && blackIndex !== 14 && blackIndex !== 15) {
                        this.swap(indexArray, blackIndex, blackIndex + 4);
                    }
                }
            }
            for (var i = 0; i < indexArray.length; i++) {
                if (indexArray[i] !== i) {
                    scrambleIndex++;
                }
            }
        }
        return indexArray;
    };
    MainScene.prototype.swap = function (arr, blackIndex, toSwap) {
        var temp = arr[toSwap];
        arr[toSwap] = arr[blackIndex];
        arr[blackIndex] = temp;
    };
    MainScene.prototype.checkIfCompleted = function () {
        var count = 0;
        var iter = this.blockGroup.values();
        for (var row = 0; row < this.BOARD_DIM; row++) {
            for (var col = 0; col < this.BOARD_DIM; col++) {
                if (iter.next().value.getData("key") !== count) {
                    if (!this.helpFlag) {
                        this.outline.setAlpha(0);
                        this.speechBox.setAlpha(0);
                        this.text.setText("");
                    }
                    this.blocksLeftText.destroy();
                    var num = this.checkNumLeft();
                    if (this.count > num && !this.helpFlag) {
                        var rand = Math.random() * 4;
                        if (rand < 1) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(__WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "feedback.1"));
                        }
                        else if (rand < 2) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(__WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "feedback.2"));
                        }
                        else if (rand < 3) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(__WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "feedback.3"));
                        }
                        else {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(__WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "feedback.4"));
                        }
                    }
                    this.count = num;
                    return;
                }
                count++;
            }
        }
        this.showFinishedText();
        this.blocksLeftText.destroy();
    };
    MainScene.prototype.checkNumLeft = function () {
        var num = 0;
        var iter = this.blockGroup.values();
        for (var i = 0; i < this.blockGroup.length; i++) {
            var next = iter.next().value.getData("key");
            if (next !== i) {
                if ((this.BOARD_DIM === 3 && next === 8) || (this.BOARD_DIM === 4 && next === 15)) {
                    // dont add to num, black block
                }
                else {
                    num++;
                }
            }
        }
        var scoreText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "score");
        var str = scoreText + num;
        this.blocksLeftText = this.add.text(945, 410, str, { fill: "#000000", align: "center" }).setFontFamily('Russo One, Roboto Mono, Arial').setFontSize(24);
        this.blocksLeftText.setDepth(3);
        this.blocksLeftText.setOrigin(.5);
        return num;
    };
    MainScene.prototype.showFinishedText = function () {
        var _this = this;
        this.clickLock = true;
        this.startTime = false;
        var style = { font: "40px Arial", fill: "#0C0C0C", align: "center" };
        var finish = this.add.image(0, 0, "finishedKey").setDepth(3).setOrigin(0).setAlpha(1).setDisplaySize(726, 726);
        finish.setPosition(this.GAME_WIDTH / 2 - finish.displayWidth / 2, this.GAME_HEIGHT / 2 - finish.displayHeight / 2);
        var text = this.add.text(360, 360, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "finished"), style).setFontFamily('Russo One, Roboto Mono, Arial').setFontSize(30).setOrigin(0).setDepth(5);
        text.setPosition(this.GAME_WIDTH / 2 - text.width / 2, this.GAME_HEIGHT / 2 - text.height / 2);
        this.add.image(text.getCenter().x, text.getCenter().y, "pixel").setDisplaySize(text.displayWidth + 10, text.displayHeight + 10).setDepth(4).setOrigin(.5);
        this.add.image(text.getCenter().x, text.getCenter().y, "pixel").setDisplaySize(text.displayWidth + 20, text.displayHeight + 20).setDepth(3.5).setOrigin(.5).setTint(0x000000);
        var moveOn = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("student.postgame.button");
        var buttonConfig = { backgroundColor: 0x6ec213, textColor: 0xffffff, textSize: 30 };
        var buttonText = this.add.text(0, 0, moveOn, style).setVisible(false);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, text.getCenter().x, text.getCenter().y + 200, buttonText.displayWidth + 10, buttonText.displayHeight + 10, moveOn, buttonConfig);
        button.setDepth(4).setPosition(button.x - button.displayOriginX, button.y - button.displayOriginY);
        button.on("buttonClicked", function () {
            // Game Over
            _this.sys.game.onComplete();
        });
    };
    MainScene.prototype.destroyOldPieces = function () {
        var iter = this.blockGroup.values();
        for (var i = 0; i < this.blockGroup.length; i++) {
            iter.next().value.destroy();
        }
    };
    MainScene.prototype.setTime = function () {
        if (this.startTime) {
            var minute = Math.floor(this.timer.getElapsedSeconds() / 60);
            var second = Math.floor(this.timer.getElapsedSeconds() % 60);
            if (second < 10) {
                this.timeText.setText(minute.toString() + ":0" + second.toString());
            }
            else {
                this.timeText.setText(minute.toString() + ":" + second.toString());
            }
            // Change these conditions to reduce or increase time until reduce difficulty option
            // Allow reduction option every 7 minutes until they say yes or finish
            if ((minute % 7 === 0 && minute !== 0) && second === 0 && !this.helpFlag && !this.clickLock && this.BOARD_DIM !== 3) {
                this.helpFlag = true;
                this.reduceDifficulty();
            }
        }
    };
    MainScene.prototype.reduceDifficulty = function () {
        var _this = this;
        console.warn("reduce difficulty");
        this.outline.setAlpha(1);
        this.speechBox.setAlpha(1);
        this.text.setText(__WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "help"));
        var yesConfig = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        yesConfig.backgroundColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        var noConfig = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        noConfig.backgroundColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON;
        this.yesButton = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 850, 610, 190, 30, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "yes"), yesConfig);
        this.yesButton.setDepth(3);
        this.noButton = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 850, 655, 190, 30, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "no"), noConfig);
        this.noButton.setDepth(3);
        this.yesButton.on('buttonClicked', function () {
            if (!_this.clickLock) {
                _this.destroyOldPieces();
                _this.setup3Board();
                _this.checkNumLeft();
                _this.timer = _this.time.addEvent({ delay: 10000000, timeScale: 1.0 });
                _this.timeText.setText("0:00");
                _this.startTime = false;
                _this.helpFlag = false;
                _this.yesButton.destroy();
                _this.noButton.destroy();
            }
        });
        this.noButton.on('buttonClicked', function () {
            if (!_this.clickLock) {
                _this.timer.elapsed = _this.timer.elapsed + 1000;
                _this.outline.setAlpha(0);
                _this.speechBox.setAlpha(0);
                _this.text.setText("");
                _this.helpFlag = false;
                _this.noButton.destroy();
                _this.yesButton.destroy();
            }
        });
    };
    MainScene.prototype.setup3Board = function () {
        this.BOARD_DIM = 3;
        this.PIECE_WIDTH = Math.floor(this.GAME_WIDTH / 6);
        this.PIECE_HEIGHT = this.PIECE_WIDTH;
        this.blocksLeftText.destroy();
        this.outline.setAlpha(0);
        this.speechBox.setAlpha(0);
        this.text.setText("");
        this.clickLock = false;
        var order = [];
        order = this.create3SolvableIndexArray();
        this.createBlocks(order, "key3");
    };
    MainScene.prototype.create3SolvableIndexArray = function () {
        var indexArray = [];
        for (var i = 0; i < this.BOARD_DIM * this.BOARD_DIM; i++) {
            indexArray.push(i);
        }
        var scrambleIndex = 0;
        while (scrambleIndex < 6) {
            for (var j = 0; j < 100; j++) {
                var blackIndex = indexArray.indexOf(8);
                var rand = Math.random() * 4;
                if (rand < 1) {
                    if (blackIndex !== 0 && blackIndex !== 3 && blackIndex !== 6) {
                        this.swap(indexArray, blackIndex, blackIndex - 1);
                    }
                }
                else if (rand < 2) {
                    if (blackIndex !== 0 && blackIndex !== 1 && blackIndex !== 2) {
                        this.swap(indexArray, blackIndex, blackIndex - 3);
                    }
                }
                else if (rand < 3) {
                    if (blackIndex !== 2 && blackIndex !== 5 && blackIndex !== 8) {
                        this.swap(indexArray, blackIndex, blackIndex + 1);
                    }
                }
                else if (rand < 4) {
                    if (blackIndex !== 6 && blackIndex !== 7 && blackIndex !== 8) {
                        this.swap(indexArray, blackIndex, blackIndex + 3);
                    }
                }
            }
            for (var i = 0; i < indexArray.length; i++) {
                if (indexArray[i] !== i) {
                    scrambleIndex++;
                }
            }
        }
        return indexArray;
    };
    MainScene.prototype.update = function () {
        this.setTime();
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(886);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Plumbing;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "Plumbing.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Plumbing.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "Plumbing.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_PlumbingObject__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_PlumbingTool__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_PlumbingGame_scenes_EndGameScene__ = __webpack_require__(2290);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.doubleJump = false;
        _this.frameCount = 0;
        _this.gameOver = false;
        _this.pickingTool = false;
        _this.translateString = "Plumbing.Phaser.MainScene.";
        _this.xVel = 0;
        _this.yVel = 0;
        _this.TILESIZE = 32;
        _this.JUMPING_VELOCITY = 400;
        _this.WALKING_VELOCITY = 200;
        _this.CLOGGED_ALPHA = .2;
        _this.FIXED_ALPHA = 1;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        // All preload assets will be stored in the texture manager by the given key
        this.load.tilemapTiledJSON('map', __webpack_require__(2291));
        this.load.image('gridtiles', __webpack_require__(2292));
        this.load.image('walls-and-water', __webpack_require__(2293));
        this.load.atlas("assets", __webpack_require__(2294), __webpack_require__(2295));
        this.load.spritesheet('player', __webpack_require__(887), { frameWidth: 64, frameHeight: 96 });
        __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
        __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__["a" /* PhaserModal */].preload(this);
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.gamepad = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.plumbingObjects = [];
        this.plumbingTools = __WEBPACK_IMPORTED_MODULE_4__objects_PlumbingTool__["a" /* PlumbingTool */].TOOLS;
        this.initializeMap();
        this.currentPlumbingObject = null;
        this.currentTool = null;
        this.toolIndex = 0;
        this.pickingTool = false;
    };
    MainScene.prototype.create = function () {
        this.initialize();
        this.createGamePad();
        this.generateScene();
        this.generatePlayer();
        this.initPolygonZones();
        this.createFeedbackBubble();
    };
    MainScene.prototype.initializeMap = function () {
        var _this = this;
        this.map = this.make.tilemap({ key: 'map' });
        var bgTiles = this.map.addTilesetImage('gridtiles');
        var walls = this.map.addTilesetImage('walls-and-water');
        this.backgroundLayer = this.map.createStaticLayer('Background', bgTiles, 0, 0);
        this.backgroundLayer.setAlpha(0.75);
        this.pipeLayer = this.map.createDynamicLayer('PipesClogged', walls, 0, 0);
        this.groundLayer = this.map.createStaticLayer('Walls', walls, 0, 0);
        // Tile IDs with collision
        this.groundLayer.setCollisionBetween(0, 500);
        this.pipeLayer.layer.data.forEach(function (row) {
            row.forEach(function (tile) {
                tile.setAlpha(_this.CLOGGED_ALPHA);
            });
        });
        this.zoneLayer = this.map.getObjectLayer("Zones");
    };
    MainScene.prototype.createFeedbackBubble = function () {
        this.feedbackBorder = this.add.image(0, 0, "pixel");
        this.feedbackBorder.setOrigin(0);
        this.feedbackBorder.setScrollFactor(0);
        this.feedbackBorder.setTint(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("R"));
        this.feedbackBorder.setVisible(false);
        var textStyle = { fontFamily: 'Russo One, Arial', color: "#ffffff", fontSize: 20, backgroundColor: "#000000", padding: 20 };
        this.feedbackText = this.add.text(5, 5, "", textStyle);
        this.feedbackText.setScrollFactor(0);
        this.feedbackText.setWordWrapWidth(300, true);
        this.feedbackText.setVisible(false);
    };
    MainScene.prototype.generatePlayer = function () {
        this.player = this.physics.add.sprite(this.TILESIZE * 38, this.TILESIZE * 37, "player");
        this.player.setBounce(0.1);
        this.player.setSize(50, 80);
        this.player.setOffset(6, 15);
        //  Player animations, turning, walking left and walking right.
        this.anims.create({
            key: 'left',
            frames: this.anims.generateFrameNumbers('player', { start: 0, end: 3 }),
            frameRate: 10,
            repeat: -1
        });
        this.anims.create({
            key: 'turn',
            frames: [{ key: 'player', frame: 4 }],
            frameRate: 20
        });
        this.anims.create({
            key: 'right',
            frames: this.anims.generateFrameNumbers('player', { start: 5, end: 8 }),
            frameRate: 10,
            repeat: -1
        });
        this.physics.add.collider(this.player, this.groundLayer);
        // Setup the camera
        this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);
        this.cameras.main.startFollow(this.player);
    };
    MainScene.prototype.generateScene = function () {
        this.addCloggedObjects();
        this.showUncloggedPipes();
    };
    MainScene.prototype.addCloggedObjects = function () {
        var _this = this;
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            var id = ob.properties["id"];
            var zoneID = ob.properties["zoneID"];
            var dependentOn = ob.properties["dependentOn"].split(',');
            if (ob.name === "toilet") {
                var toilet = new __WEBPACK_IMPORTED_MODULE_3__objects_PlumbingObject__["a" /* PlumbingObject */](id, "toilet", "toilet_pipe_broken", "toilet_pipe_fixed", zoneID, dependentOn);
                var toiletObject = _this.add.sprite(ob.x, ob.y, "assets", toilet.cloggedFrame);
                toiletObject.setOrigin(0);
                toiletObject.setDisplaySize(ob.width, ob.height);
                toilet.object = toiletObject;
                _this.plumbingObjects.push(toilet);
            }
            else if (ob.name === "tub") {
                var tub = new __WEBPACK_IMPORTED_MODULE_3__objects_PlumbingObject__["a" /* PlumbingObject */](id, "tub", "tub_not-fixed", "tub_fixed", zoneID, dependentOn);
                var tubObject = _this.add.sprite(ob.x, ob.y, "assets", tub.cloggedFrame);
                tubObject.setOrigin(0);
                tubObject.setDisplaySize(ob.width, ob.height);
                tub.object = tubObject;
                _this.plumbingObjects.push(tub);
            }
            else if (ob.name === "sink") {
                var sink = new __WEBPACK_IMPORTED_MODULE_3__objects_PlumbingObject__["a" /* PlumbingObject */](id, "sink", "sink_broken", "sink_fixed", zoneID, dependentOn);
                var sinkObject = _this.add.sprite(ob.x, ob.y, "assets", sink.cloggedFrame);
                sinkObject.setOrigin(0);
                sinkObject.setDisplaySize(ob.width, ob.height);
                sink.object = sinkObject;
                _this.plumbingObjects.push(sink);
            }
        });
    };
    MainScene.prototype.showUncloggedPipes = function () {
        var _this = this;
        this.map.getObjectLayer("Unclogged").objects.forEach(function (ob) {
            ob.polygon.forEach(function (point) {
                point.x += ob.x;
                point.y += ob.y;
            });
            var polygon = new Phaser.Geom.Polygon(ob.polygon);
            _this.pipeLayer.layer.data.forEach(function (row) {
                row.forEach(function (tile) {
                    if (polygon.contains(tile.pixelX, tile.pixelY)) {
                        tile.setAlpha(_this.FIXED_ALPHA);
                    }
                });
            });
        });
    };
    MainScene.prototype.isPlayerNextToPlumbingObject = function (object) {
        var objectArea = object.getBounds();
        objectArea.width = 150;
        objectArea.centerX = object.getCenter().x;
        return Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), objectArea);
    };
    /**
    * Fixes the plumbing object
    */
    MainScene.prototype.fixPlumbingObject = function () {
        // Correct tool to fix this object
        if (this.currentTool.name === this.currentPlumbingObject.toolName) {
            this.currentPlumbingObject.object.setTexture("assets", this.currentPlumbingObject.fixedFrame);
            this.currentPlumbingObject.isClogged = false;
            this.updateObjectPipeZone(this.currentPlumbingObject, this.FIXED_ALPHA);
            if (this.needToReclogDependents()) {
                this.reclogDependents();
                // Would be nice to show an animation here if possible (to show they messed up)
                this.showFeedback(__WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "oopsText"));
            }
            else {
                this.showFeedback(__WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "fixedText" + Phaser.Math.Between(1, 3)));
            }
            this.currentPlumbingObject = null;
            this.currentTool.object.destroy();
            this.currentTool = null;
            // Re-enable the player
            this.player.enableBody(false, this.player.x, this.player.y, true, true);
        }
        else {
            if (!this.tweens.isTweening(this.currentTool.object)) {
                this.wrongToolTween();
            }
        }
    };
    MainScene.prototype.wrongToolTween = function () {
        var _this = this;
        this.tweens.add({
            name: 'tool',
            targets: this.currentTool.object,
            x: this.currentTool.object.x + 10,
            ease: "Linear",
            duration: 40,
            repeat: 3,
            yoyo: true,
            onComplete: function () {
                if (_this.currentTool != null) {
                    _this.currentTool.object.x = _this.player.getCenter().x - _this.currentTool.object.displayWidth / 2;
                }
            }
        });
    };
    /**
     * Checks we need to reclog objects below this one because it was done out of order
     */
    MainScene.prototype.needToReclogDependents = function () {
        // Not dependent on anything, no problem
        if (this.currentPlumbingObject.dependentOn.length === 0) {
            return false;
        }
        else {
            var dependents = this.getAllDependents();
            var dependent;
            for (var _i = 0, dependents_1 = dependents; _i < dependents_1.length; _i++) {
                dependent = dependents_1[_i];
                if (dependent.isClogged) {
                    // There's a dependent that's not unclogged, so have to reclog all dependents
                    return true;
                }
            }
            return false;
        }
    };
    MainScene.prototype.reclogDependents = function () {
        var _this = this;
        var dependents = this.getAllDependents();
        // Reclog current object first
        dependents.splice(0, 0, this.currentPlumbingObject);
        dependents.forEach(function (po) {
            po.isClogged = true;
            po.object.setFrame(po.cloggedFrame);
            // Update the pipes for that zone to show them with no flow now
            _this.updateObjectPipeZone(po, _this.CLOGGED_ALPHA);
        });
    };
    MainScene.prototype.getAllDependents = function () {
        var _this = this;
        var dependents = [];
        this.currentPlumbingObject.dependentOn.forEach(function (id) {
            var obj = _this.plumbingObjects.find(function (po) {
                return po.id === id;
            });
            dependents.push(obj);
        });
        return dependents;
    };
    MainScene.prototype.showFeedback = function (text) {
        if (!this.feedbackText.visible) {
            this.feedbackText.setText(text);
            this.feedbackBorder.setDisplaySize(this.feedbackText.displayWidth + 10, this.feedbackText.displayHeight + 10);
            this.feedbackBorder.setVisible(true);
            this.feedbackText.setVisible(true);
            var playerX = Math.min(this.player.x - this.cameras.main.scrollX - this.feedbackBorder.displayWidth / 2 + 5, this.gameWidth - this.feedbackBorder.displayWidth - 15);
            var playerY = this.player.getTopRight().y - this.cameras.main.scrollY - this.feedbackBorder.displayHeight - 10;
            this.feedbackText.setPosition(playerX + 5, playerY + 5);
            this.feedbackBorder.setPosition(playerX, playerY);
            this.delayHide();
        }
    };
    /**
     * Alternative way to make something disappear after a set time (rather than settimeout)
     */
    MainScene.prototype.delayHide = function () {
        var _this = this;
        if (!this.tweens.isTweening(this.feedbackBorder)) {
            this.tweens.add({
                targets: [this.feedbackBorder, this.feedbackText],
                duration: 3500,
                ease: "Linear",
                x: "+=0",
                onComplete: function () {
                    _this.hideFeedback();
                }
            });
        }
    };
    MainScene.prototype.hideFeedback = function () {
        this.feedbackBorder.setVisible(false);
        this.feedbackText.setVisible(false);
    };
    MainScene.prototype.showToolPicker = function () {
        // Have to be on the floor to bring up tool picker
        if (!this.player.body.onFloor()) {
            return;
        }
        this.pickingTool = true;
        if (this.feedbackText.visible) {
            this.hideFeedback();
        }
        this.player.anims.play("turn");
        if (this.currentTool != null) {
            this.currentTool.object.destroy();
        }
        this.currentTool = this.plumbingTools[this.toolIndex % this.plumbingTools.length];
        var tool = this.add.sprite(this.player.getCenter().x - this.currentTool.width / 2, this.player.getTopLeft().y - 50, "assets", this.currentTool.frame);
        tool.setOrigin(0);
        tool.setDisplaySize(this.currentTool.width, this.currentTool.height);
        this.currentTool.object = tool;
        this.toolIndex++;
    };
    /**
     * Set up polygon zones by adjusting their position from the map
     */
    MainScene.prototype.initPolygonZones = function () {
        var _this = this;
        this.plumbingObjects.forEach(function (po) {
            // Find the corresponding zone
            var zone = _this.zoneLayer.objects.find(function (item) {
                var zoneID = parseInt(item.name);
                return po.zoneID === zoneID;
            });
            // Make the points relative to the current object's position
            zone.polygon.forEach(function (point) {
                point.x += zone.x;
                point.y += zone.y;
            });
        });
    };
    /**
     * Update the pipes to show them getting unclogged
     */
    MainScene.prototype.updateObjectPipeZone = function (plumbingObject, alpha) {
        // Find the corresponding zone
        var zone = this.zoneLayer.objects.find(function (item) {
            var zoneID = parseInt(item.name);
            return plumbingObject.zoneID === zoneID;
        });
        // If the piping is in the zone, change the alpha to reflect it getting unclogged and having normal flow
        var polygon = new Phaser.Geom.Polygon(zone.polygon);
        this.pipeLayer.layer.data.forEach(function (row) {
            row.forEach(function (tile) {
                if (polygon.contains(tile.pixelX, tile.pixelY)) {
                    tile.setAlpha(alpha);
                }
            });
        });
    };
    MainScene.prototype.isGameOver = function () {
        var _this = this;
        var object;
        // Check that everything is unclogged and that everything was fixed in the correct order
        for (var _i = 0, _a = this.plumbingObjects; _i < _a.length; _i++) {
            object = _a[_i];
            if (object.isClogged) {
                return;
            }
        }
        // Game is over!
        this.gameOver = true;
        this.player.disableBody();
        setTimeout(function () {
            var modalConfig = new __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
            var doneText = __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "doneText");
            modalConfig.title = doneText;
            modalConfig.buttonWidth = 200;
            modalConfig.buttonConfig.smartSize = true;
            var modal = new __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__["a" /* PhaserModal */](_this, 0, 0, [{ id: 1, displayText: __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "doneButton") }], modalConfig);
            modal.setPosition(_this.gameWidth / 2 - modal.width / 2, _this.gameHeight / 2 - modal.height / 2);
            modal.on('optionClicked', function () {
                modal.destroy();
                _this.input.removeAllListeners();
                _this.input.setDefaultCursor("default");
                _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_7_src_games_PlumbingGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
                _this.scene.remove(_this);
            });
        }, 1000);
    };
    MainScene.prototype.update = function () {
        if (!this.gameOver) {
            this.updatePlayerMovement();
            this.isGameOver();
            // Abandoning the tool picker
            if (this.pickingTool && this.currentPlumbingObject != null && !this.isPlayerNextToPlumbingObject(this.currentPlumbingObject.object)) {
                this.currentTool.object.destroy();
                this.currentTool = null;
                this.currentPlumbingObject = null;
                this.pickingTool = false;
            }
        }
    };
    /**
    * GamePad/Player Movement
    * EVENT BASED FOR JUMPING, UPDATE BASED FOR LEFT/RIGHT
    */
    MainScene.prototype.createGamePad = function () {
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.gamePad.on("keydown_up", this.playerJump);
        this.gamePad.on("keydown_a", this.aDown);
        this.gamePad.on("keydown_b", this.bDown);
    };
    MainScene.prototype.updatePlayerMovement = function () {
        if (!this.player.body.enable) {
            return;
        }
        this.xVel = 0;
        if (this.gamePad.keys.left.isDown) {
            this.moveLeft();
        }
        if (this.gamePad.keys.right.isDown) {
            this.moveRight();
        }
        this.player.setVelocityX(this.xVel);
        if (this.xVel === 0) {
            this.player.anims.play('turn');
        }
        if (this.frameCount % 4 === 0) {
            if (this.player.body.onFloor()) {
                this.doubleJump = true;
            }
        }
        if (this.frameCount > 64000) {
            this.frameCount = 0;
        }
        this.frameCount++;
        if (this.pickingTool && this.currentTool != null) {
            this.currentTool.object.x = this.player.getCenter().x - this.currentTool.width / 2;
            this.currentTool.object.y = this.player.getTopLeft().y - 50;
        }
    };
    /**
    * A/Spacebar is used to select a tool
    */
    MainScene.prototype.aDown = function () {
        if (this.currentPlumbingObject == null) {
            // Find the first clogged plumbing object next to the player and show the tool picker
            var plumbingObject;
            for (var _i = 0, _a = this.plumbingObjects; _i < _a.length; _i++) {
                plumbingObject = _a[_i];
                if (this.isPlayerNextToPlumbingObject(plumbingObject.object) && plumbingObject.isClogged) {
                    this.currentPlumbingObject = plumbingObject;
                    this.showToolPicker();
                    break;
                }
            }
        }
        else {
            this.showToolPicker();
        }
    };
    /**
     * B/Shift is used to fix the object with the current tool
     */
    MainScene.prototype.bDown = function () {
        // Select to use the tool to fix the object
        if (this.currentTool != null) {
            this.currentTool.usingTool = true;
            this.fixPlumbingObject();
        }
    };
    MainScene.prototype.playerJump = function () {
        if (this.player.body.onFloor() && this.player.body.enable) {
            this.player.setVelocityY(-this.JUMPING_VELOCITY);
        }
        else if (this.doubleJump) {
            this.player.setVelocityY(-this.JUMPING_VELOCITY);
            this.doubleJump = false;
        }
    };
    MainScene.prototype.moveLeft = function () {
        if (this.player.body.enable) {
            this.xVel += -this.WALKING_VELOCITY;
            this.player.anims.play('left', true);
        }
    };
    MainScene.prototype.moveRight = function () {
        if (this.player.body.enable) {
            this.xVel += this.WALKING_VELOCITY;
            this.player.anims.play('right', true);
        }
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlumbingObject; });
var PlumbingObject = /** @class */ (function () {
    function PlumbingObject(id, name, cloggedFrame, fixedFrame, zoneId, dependentOn) {
        var _this = this;
        this.id = id;
        this.name = name;
        this.cloggedFrame = cloggedFrame;
        this.fixedFrame = fixedFrame;
        this.isClogged = true;
        this.zoneID = zoneId;
        this.dependentOn = [];
        if (dependentOn[0] !== "none") {
            dependentOn.forEach(function (s) {
                _this.dependentOn.push(parseInt(s));
            });
        }
        // Can change the correct tool to be used to fix the object (currently not using blowtorch or tape for anything)
        if (this.name === "toilet") {
            this.toolName = "plunger";
        }
        else if (this.name === "tub" || this.name === "sink") {
            this.toolName = "wrench";
        }
    }
    return PlumbingObject;
}());



/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlumbingTool; });
var PlumbingTool = /** @class */ (function () {
    function PlumbingTool() {
    }
    PlumbingTool.TOOLS = [
        {
            name: "plunger",
            frame: "plunger",
            usingTool: false,
            width: 64,
            height: 64,
        },
        {
            name: "wrench",
            frame: "wrench",
            usingTool: false,
            width: 32,
            height: 64,
        },
        {
            name: "blowtorch",
            frame: "blowtorch",
            usingTool: false,
            width: 64,
            height: 64,
        },
        {
            name: "tape",
            frame: "tape",
            usingTool: false,
            width: 32,
            height: 32,
        }
    ];
    return PlumbingTool;
}());



/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "r";
        _this.gameClosingTextKey = "Plumbing.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gamePlumbing2.751dfe71.json";

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gridtiles.5d33f289.png";

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/walls-and-water.b3ea027a.png";

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gamePlumbing.8fdf8264.png";

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gamePlumbing.97d1fc8d.json";

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(889);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].University;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "University.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "University.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "University.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Gamepad__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_Student__ = __webpack_require__(2298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_UniversityGame_scenes_EndGameScene__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};








var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.distanceBetween = 32;
        _this.speed = 200;
        _this.generalSize = 32;
        _this.playerHasKey = false;
        _this.xVel = 0;
        _this.yVel = 0;
        _this.translateString = "University.Phaser.";
        return _this;
    }
    MainScene.prototype.preload = function () {
        var _this = this;
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON("map", __webpack_require__(2301));
        this.load.spritesheet('player', __webpack_require__(890), { frameWidth: 32, frameHeight: 48 });
        this.load.image('tiles', __webpack_require__(2302));
        this.load.atlas('aliens', __webpack_require__(874), __webpack_require__(875));
        this.load.image('help', __webpack_require__(2303));
        this.load.image('campusMap', __webpack_require__(2304));
        this.load.image('gate', __webpack_require__(2305));
        this.load.image('key', __webpack_require__(2306));
        this.load.atlas('pilots', __webpack_require__(189), __webpack_require__(190));
        __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
        var keys = [
            "University.Phaser.NPCs.artsStudent.goodbye",
            "University.Phaser.NPCs.artsStudent.greeting",
            "University.Phaser.NPCs.businessStudent.goodbye",
            "University.Phaser.NPCs.businessStudent.greeting",
            "University.Phaser.NPCs.engineeringStudent.goodbye",
            "University.Phaser.NPCs.engineeringStudent.greeting",
            "University.Phaser.NPCs.medicalStudent.goodbye",
            "University.Phaser.NPCs.medicalStudent.greeting",
        ];
        keys.forEach(function (key) {
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_7_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    MainScene.prototype.initializeGame = function () {
        this.currentStudent = null;
        this.endGame = false;
        this.students.forEach(function (s) {
            s.complete = false;
        });
        this.playerHasKey = false;
    };
    MainScene.prototype.create = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.stopAllMovement = false;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.initializeMap();
        this.addNPCs();
        this.addNPStudents();
        this.createPopUpMap();
        this.generateGamepad();
        this.createColliders();
        this.setupCameras();
        this.setWalkCollisions();
        this.addObstacles();
        this.addKeys();
        this.currentStudent = null;
        this.initializeGame();
        this.speechBubble = this.createBubble(0, 100, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "wrongCollege"));
        this.speechBubble.setX(this.gameWidth / 2 - this.speechBubble.width / 2);
        this.speechBubble.setVisible(false);
        this.children.bringToTop(this.player);
    };
    MainScene.prototype.initializeMap = function () {
        this.map = this.make.tilemap({ key: "map" });
        this.tiles = this.map.addTilesetImage('tiles');
        this.keysLayer = this.map.getObjectLayer('Keys');
        this.gatesLayer = this.map.getObjectLayer('Gates');
        this.gateTimeout = null;
        this.gateCollisions = [];
        this.gateIcons = [];
        this.keyIcons = [];
        this.collisionLayer = this.map.getObjectLayer('Collisions');
        var backgroundLayer = this.map.createDynamicLayer('Background', this.tiles, 0, 0);
        this.groundLayer = this.map.createDynamicLayer('Ground Layer', this.tiles, 0, 0);
        this.collegeLayer = this.map.createDynamicLayer('Colleges', this.tiles, 0, 0);
        // Boundaries
        this.groundLayer.setCollisionBetween(246, 248);
    };
    MainScene.prototype.createPopUpMap = function () {
        var config = { fontFamily: "Russo One, Roboto Mono, Arial", fill: "#ffffff", align: "center", fontSize: 36 };
        this.popupText = [];
        this.popupText.push(this.add.text(140, 90, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Map.1"), config));
        this.popupText.push(this.add.text(1025, 75, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Map.2"), config));
        this.popupText.push(this.add.text(90, 420, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Map.3"), config));
        this.popupText.push(this.add.text(960, 445, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "Map.4"), config));
        var text;
        for (var _i = 0, _a = this.popupText; _i < _a.length; _i++) {
            text = _a[_i];
            text.setOrigin(0);
            text.setScrollFactor(0);
            text.setDepth(91);
            text.setWordWrapWidth(200);
            text.setVisible(false);
        }
        this.popupMap = this.add.image(0, 0, "campusMap");
        this.popupMap.setOrigin(0);
        this.popupMap.setDisplaySize(this.gameWidth, this.gameHeight);
        this.popupMap.setScrollFactor(0);
        this.popupMap.setDepth(90);
        this.popupMap.setVisible(false);
    };
    MainScene.prototype.addObstacles = function () {
        var _this = this;
        var count = 0;
        this.gatesLayer.objects.forEach(function (object) {
            // The group will have an array of objects - these are the individual collision shapes
            var gameObject = new Phaser.GameObjects.Zone(_this, object.x, object.y, object.width, object.height);
            gameObject.type = object.type;
            _this.physics.add.existing(gameObject, true);
            _this.gateCollisions[count] = _this.physics.add.collider(_this.player, gameObject);
            if (count === 0) {
                _this.gateIcons[count] = _this.add.image(gameObject.getCenter().x, gameObject.getCenter().y, 'gate');
            }
            else if (count === 1) {
                _this.gateIcons[count] = _this.add.image(gameObject.getCenter().x + gameObject.width, gameObject.getCenter().y, 'gate').setAngle(90);
            }
            _this.gateIcons[count].setDepth(15).setDisplaySize(gameObject.width, gameObject.height).setOrigin(0);
            count++;
        });
        this.makeGateText();
    };
    MainScene.prototype.addKeys = function () {
        var _this = this;
        var count = 0;
        this.keysLayer.objects.forEach(function (object) {
            // The group will have an array of objects - these are the individual collision shapes
            var gameObject = new Phaser.GameObjects.Zone(_this, object.x, object.y, object.width, object.height);
            gameObject.type = object.type;
            if (count === 0) {
                _this.keyIcons[count] = _this.add.image(gameObject.getCenter().x + gameObject.width, gameObject.getCenter().y, 'key');
            }
            else if (count === 1) {
                _this.keyIcons[count] = _this.add.image(gameObject.getCenter().x + gameObject.width, gameObject.getCenter().y, 'key');
            }
            _this.keyIcons[count].setDepth(15).setDisplaySize(object.width, object.height).setOrigin(0);
            count++;
        });
    };
    MainScene.prototype.setWalkCollisions = function () {
        var _this = this;
        this.collisionLayer.objects.forEach(function (object) {
            // The group will have an array of objects - these are the individual collision shapes
            var gameObject = new Phaser.GameObjects.Zone(_this, object.x, object.y, object.width, object.height);
            gameObject.type = object.type;
            _this.physics.add.existing(gameObject, true);
            _this.physics.add.collider(_this.player, gameObject);
        });
    };
    MainScene.prototype.createColliders = function () {
        var _this = this;
        this.physics.add.collider(this.player, this.groundLayer);
        this.students.forEach(function (s) {
            _this.physics.add.collider(s.object, _this.groundLayer);
        });
        // Set collisions by tiled's tileset editor collider bounds
        this.groundLayer.forEachTile(function (tile) {
            var tileWorldPos = _this.groundLayer.tileToWorldXY(tile.x, tile.y);
            var collisionGroup = _this.tiles.getTileCollisionGroup(tile.index);
            if (!collisionGroup || collisionGroup["objects"].length === 0) {
                return;
            }
            // The group will have an array of objects - these are the individual collision shapes
            var objects = collisionGroup["objects"];
            for (var i = 0; i < objects.length; i++) {
                var object = objects[i];
                var objectX = tileWorldPos.x + object.x;
                var objectY = tileWorldPos.y + object.y;
                // Add collider for rectangles
                if (object.rectangle) {
                    var gameObject = new Phaser.GameObjects.Zone(_this, objectX, objectY, object.width, object.height);
                    _this.physics.add.existing(gameObject, true);
                    _this.collideAll(gameObject);
                }
            }
        });
        // Colleges
        this.collegeLayer.forEachTile(function (tile) {
            var tileWorldPos = _this.collegeLayer.tileToWorldXY(tile.x, tile.y);
            var collisionGroup = _this.tiles.getTileCollisionGroup(tile.index);
            if (!collisionGroup || collisionGroup["objects"].length === 0) {
                return;
            }
            // The group will have an array of objects - these are the individual collision shapes
            var objects = collisionGroup["objects"];
            for (var i = 0; i < objects.length; i++) {
                var object = objects[i];
                var objectX = tileWorldPos.x + object.x;
                var objectY = tileWorldPos.y + object.y;
                // Add collider for rectangles
                if (object.rectangle) {
                    var gameObject = new Phaser.GameObjects.Zone(_this, objectX, objectY, object.width, object.height);
                    _this.physics.add.existing(gameObject, true);
                    _this.collideAll(gameObject);
                }
            }
        });
    };
    MainScene.prototype.createBubble = function (x, y, text) {
        var padding = 10;
        var fontSize = 20;
        var borderWidth = 2;
        var borderColor = __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("I");
        var textBox = this.add.container(x, y);
        var textStyle = { fontFamily: 'Russo One, Arial', color: "#ffffff", fontSize: fontSize, padding: 10 };
        var textObject = this.add.text(padding + borderWidth, padding + borderWidth, text, textStyle);
        textObject.setWordWrapWidth(400 + 2 * padding, true);
        textObject.setName("Bubble");
        textBox.setSize(textObject.displayWidth + 2 * padding + borderWidth, textObject.displayHeight + 2 * padding + borderWidth);
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(textObject);
        textBox.setScrollFactor(0);
        return textBox;
    };
    MainScene.prototype.collideAll = function (object) {
        var _this = this;
        this.physics.add.collider(this.player, object);
        this.students.forEach(function (s) {
            _this.physics.add.collider(s.object, object);
        });
    };
    MainScene.prototype.addNPCs = function () {
        var _this = this;
        var layer = this.map.getObjectLayer("NPCS").objects;
        var areas = [];
        layer.forEach(function (ob) {
            if (ob.name === "player") {
                _this.generatePlayer(ob);
            }
            else if (ob.name === "1" || ob.name === '2' || ob.name === '3' || ob.name === '4') {
                areas.push(ob);
            }
        });
        this.createStudentNPCs(areas);
    };
    MainScene.prototype.addNPStudents = function () {
        var _this = this;
        var layer = this.map.getObjectLayer("NPCS").objects;
        layer.forEach(function (ob) {
            if (ob.name === "100") {
                var num = Math.floor(Math.random() * 4);
                var alien = "snib-1";
                if (num === 0) {
                    "snib-1";
                }
                else if (num === 1) {
                    alien = "snib-2";
                }
                else if (num === 2) {
                    alien = "sleb-1";
                }
                else if (num === 3) {
                    alien = "sleb-2";
                }
                var al = _this.physics.add.sprite(ob.x, ob.y, "aliens", alien);
                al.setDisplaySize(32, 32);
                al.setOrigin(0);
                al.setOffset(32, 32);
            }
        });
    };
    MainScene.prototype.modalPop = function (text, buttonKey) {
        var _this = this;
        this.player.setVelocity(0, 0);
        this.stopAllMovement = true;
        this.player.disableBody();
        var config = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
        config.title = text;
        config.buttonConfig.smartSize = true;
        config.forceResponse = true;
        var buttonText;
        if (buttonKey === "done") {
            buttonText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("common.done");
        }
        else if (buttonKey === "yes") {
            buttonText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("admin.common.confirmYes");
        }
        else if (buttonKey === "ok") {
            buttonText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("common.ok");
        }
        var modal = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, [{ id: 1, displayText: buttonText }], config);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2).setDepth(20);
        modal.on('optionClicked', function () { return _this.modalOptionClicked(modal); });
    };
    MainScene.prototype.modalOptionClicked = function (modal) {
        modal.destroy();
        this.player.enableBody(false, this.player.x, this.player.y, true, true);
        if (this.endGame) {
            this.player.disableBody();
            this.input.removeAllListeners();
            this.input.setDefaultCursor("default");
            this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_6_src_games_UniversityGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
            this.scene.remove(this);
        }
        this.stopAllMovement = false;
    };
    MainScene.prototype.setupCameras = function () {
        this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);
        this.cameras.main.startFollow(this.player, true);
    };
    /**
    * Generates the player with animations
    * */
    MainScene.prototype.generatePlayer = function (ob) {
        this.player = this.physics.add.sprite(ob.x, ob.y, "player");
        this.startPosition = new Phaser.Geom.Rectangle(ob.x, ob.y, ob.width, ob.height);
        this.player.setOrigin(0);
        // For collision bounds
        this.player.setSize(20, 38);
        this.player.setOffset(22, 34);
        this.player.setDisplaySize(32, 48);
        this.player.setFrame(4);
        this.player.setDepth(15);
        //  Player animations, turning, walking left and walking right.
        this.anims.create({
            key: 'left',
            frames: this.anims.generateFrameNumbers('player', { start: 0, end: 3 }),
            frameRate: 10,
            repeat: -1
        });
        this.anims.create({
            key: 'turn',
            frames: [{ key: 'player', frame: 4 }],
            frameRate: 20
        });
        this.anims.create({
            key: 'right',
            frames: this.anims.generateFrameNumbers('player', { start: 5, end: 8 }),
            frameRate: 10,
            repeat: -1
        });
    };
    MainScene.prototype.createStudentNPCs = function (obs) {
        var _this = this;
        this.students = [];
        this.colleges = [];
        var students = __spreadArrays(__WEBPACK_IMPORTED_MODULE_4__objects_Student__["a" /* Student */].STUDENTS);
        students.forEach(function (s) {
            var ob = obs.pop();
            var object = _this.physics.add.sprite(ob.x, ob.y, "aliens", s.frame);
            object.setOrigin(0);
            object.setInteractive();
            object.setSize(30, 60);
            object.setOffset(50, 30);
            object.setDepth(10);
            object.setDisplaySize(_this.generalSize, _this.generalSize);
            s.object = object;
            var icon = _this.add.image(object.getCenter().x - 10, object.y - 25, "help");
            icon.setOrigin(0);
            icon.setDisplaySize(20, 20);
            s.icon = icon;
            var collegeObject = _this.map.getObjectLayer("College Zones").objects.find(function (ob) {
                return ob.name === s.college.id;
            });
            s.college.zone = new Phaser.Geom.Rectangle(collegeObject.x, collegeObject.y, collegeObject.width, collegeObject.height);
            _this.students.push(s);
            _this.colleges.push(s.college);
        });
    };
    MainScene.prototype.updateCurrentStudentNPC = function () {
        if (this.currentStudent != null) {
            this.currentStudent.object.update();
            //NPC Directional Facing Controls
            if (this.currentStudent.object.x - this.player.x >= 0) {
                this.currentStudent.object.setFlipX(true);
            }
            else if (this.currentStudent.object.x - this.player.x < 0) {
                this.currentStudent.object.setFlipX(false);
            }
            if (this.npcUp) {
                this.currentStudent.object.y = this.player.y + 60;
                this.currentStudent.object.x = this.player.x;
            }
            else if (this.npcDown) {
                this.currentStudent.object.y = this.player.y - 40;
                this.currentStudent.object.x = this.player.x;
            }
            else if (this.npcRight) {
                this.currentStudent.object.y = this.player.y + 12;
                this.currentStudent.object.x = this.player.x - 40;
            }
            else if (this.npcLeft) {
                this.currentStudent.object.y = this.player.y + 12;
                this.currentStudent.object.x = this.player.x + 40;
            }
            // If they took them to the wrong college, show a little feedback to remind the user to look at the map
            if (this.isNPCInWrongCollege()) {
                this.speechBubble.setVisible(true);
            }
            else {
                this.speechBubble.setVisible(false);
            }
        }
    };
    MainScene.prototype.checkKeys = function () {
        // Player is overlapping with a visible key, and they don't already have a key
        if (Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), this.keyIcons[0].getBounds()) && this.keyIcons[0].visible && !this.playerHasKey) {
            this.keyIcons[0].setVisible(false);
            this.playerHasKey = true;
        }
        else if (Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), this.keyIcons[1].getBounds()) && this.keyIcons[1].visible && !this.playerHasKey) {
            this.keyIcons[1].setVisible(false);
            this.playerHasKey = true;
        }
    };
    MainScene.prototype.checkGates = function () {
        for (var i = 0; i < this.gateIcons.length; i++) {
            var gate = this.gateIcons[i];
            // If the gate is there and player runs into it:
            if (gate.visible && Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), gate.getBounds())) {
                // If the player has a key, open the gate and then reset so they don't have a key anymore (they have to get the other one)
                if (this.playerHasKey) {
                    this.gateCollisions[i].active = false;
                    gate.setVisible(false);
                    this.playerHasKey = false;
                }
                else {
                    // Player doesn't have a key, so show the text that they need a key
                    this.gateText.setVisible(true);
                    this.gateTextBorder.setVisible(true);
                }
            }
        }
        // If the text is showing and the player isn't by a gate, hide the text
        if (this.gateText.visible &&
            !Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), this.gateIcons[0].getBounds()) &&
            !Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), this.gateIcons[1].getBounds())) {
            // Don't show gate text
            this.gateText.setVisible(false);
            this.gateTextBorder.setVisible(false);
        }
    };
    MainScene.prototype.makeGateText = function () {
        var config = { fontFamily: "Russo One, Roboto Mono, Arial", fill: "#ffffff", align: "center", fontSize: 18 };
        var txt = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "gate");
        this.gateText = this.add.text(this.gameWidth / 2, this.gameHeight / 2, txt, config);
        this.gateText.setPadding(20, 20, 20, 20).setBackgroundColor("#000000").setDepth(25).setScrollFactor(0).setOrigin(.5).setVisible(false);
        this.gateTextBorder = this.add.image(this.gateText.x, this.gateText.y, "pixel").setDepth(24.5).setScrollFactor(0).setOrigin(.5);
        this.gateTextBorder.setDisplaySize(this.gateText.displayWidth + 10, this.gateText.displayHeight + 10).setVisible(false);
    };
    MainScene.prototype.checkIfNPCComplete = function () {
        if (this.currentStudent != null && Phaser.Geom.Intersects.RectangleToRectangle(this.currentStudent.object.getBounds(), this.currentStudent.college.zone)
            && !this.currentStudent.complete
            // Also force player to be in the college before we say they got them (some edge cases can falsely put npc in college zone)
            && Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), this.currentStudent.college.zone)) {
            this.modalPop(__WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.currentStudent.goodbye), "ok");
            this.sound.stopAll();
            var goodbyeAudio = this.sound.add(this.currentStudent.goodbye);
            goodbyeAudio.play();
            this.currentStudent.complete = true;
            this.putStudentInCollege();
        }
        else if (this.allNPCsComplete() && this.astronaut == null) {
            if (!this.isModalOnScreen()) {
                var displayText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "endText");
                this.endGame = true;
                this.modalPop(displayText, "done");
            }
        }
    };
    /**
     * Checks if the current npc is in the wrong college
     */
    MainScene.prototype.isNPCInWrongCollege = function () {
        var college;
        for (var _i = 0, _a = this.colleges; _i < _a.length; _i++) {
            college = _a[_i];
            // If the player and npc are in the wrong college, tell them (some edge cases can falsely put npc in college zone)
            if (college.id !== this.currentStudent.college.id && Phaser.Geom.Intersects.RectangleToRectangle(this.currentStudent.object.getBounds(), college.zone)
                && Phaser.Geom.Intersects.RectangleToRectangle(this.player.getBounds(), college.zone)) {
                return true;
            }
        }
        return false;
    };
    /**
     * Put candidate in center of booth and disable them from leaving
     */
    MainScene.prototype.putStudentInCollege = function () {
        var _this = this;
        var college = this.currentStudent.college.zone;
        var right = college.x + 3 * college.width / 4;
        var bottom = college.y + 3 * college.height / 4;
        this.add.tween({
            targets: this.currentStudent.object,
            x: right,
            y: bottom,
            ease: Phaser.Math.Easing.Circular,
            duration: 1000,
            onStart: function () {
                _this.currentStudent.object.disableBody();
            },
            onComplete: function () {
                _this.currentStudent = null;
            }
        });
    };
    MainScene.prototype.allNPCsComplete = function () {
        var student;
        for (var _i = 0, _a = this.students; _i < _a.length; _i++) {
            student = _a[_i];
            if (!student.complete) {
                return false;
            }
        }
        return true;
    };
    /**
    * Checks if there is already a modal open on screen (we don't want to be able to add more than one modal to a scene)
    */
    MainScene.prototype.isModalOnScreen = function () {
        var modal = this.getModal();
        return modal !== null;
    };
    MainScene.prototype.getModal = function () {
        for (var _i = 0, _a = this.children.list; _i < _a.length; _i++) {
            var c = _a[_i];
            if (c.type === "PhaserModal") {
                return c;
            }
        }
        return null;
    };
    MainScene.prototype.update = function () {
        if (!this.endGame) {
            this.updatePlayerMovement();
            this.updateCurrentStudentNPC();
            this.checkIfNPCComplete();
            this.checkKeys();
            this.checkGates();
        }
    };
    /**
     * GamePad/Player Movement
     */
    MainScene.prototype.generateGamepad = function () {
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.gamePad.on("keydown_a", this.aDown);
        this.gamePad.on("keydown_b", this.bDown);
        this.gamePad.on("keyup_a", this.stopA);
    };
    /**
    * Talk to character
    */
    MainScene.prototype.bDown = function () {
        var modal = this.getModal();
        var isModalOnScreen = modal !== null;
        var playerBounds = this.player.getBounds();
        if (isModalOnScreen) {
            this.modalOptionClicked(modal);
            return;
        }
        // Only need to do this if we don't already have a student
        if (this.currentStudent == null) {
            var student;
            for (var _i = 0, _a = this.students; _i < _a.length; _i++) {
                student = _a[_i];
                var studentArea = student.object.getBounds();
                studentArea.width += 25;
                studentArea.height += 25;
                studentArea.centerX = student.object.getCenter().x;
                studentArea.centerY = student.object.getCenter().y;
                // If we are next to student, they are not already done, and there isn't already a modal on the screen, start talking to this character
                if (Phaser.Geom.Intersects.RectangleToRectangle(playerBounds, studentArea) && !student.complete && !isModalOnScreen) {
                    this.currentStudent = student;
                    this.currentStudent.icon.destroy();
                    this.interactWithCurrentStudent();
                    break;
                }
            }
        }
        else {
            this.interactWithCurrentStudent();
        }
    };
    MainScene.prototype.interactWithCurrentStudent = function () {
        var student = this.currentStudent;
        this.modalPop(__WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(student.greeting), "yes");
        this.sound.stopAll();
        var greetingAudio = this.sound.add(student.greeting);
        greetingAudio.play();
    };
    /**
     * Show pop up map
     */
    MainScene.prototype.aDown = function () {
        this.popupMap.setVisible(true);
        this.popupText[0].setVisible(true);
        this.popupText[1].setVisible(true);
        this.popupText[2].setVisible(true);
        this.popupText[3].setVisible(true);
        this.gamePad.setDepth(-1);
        this.stopAllMovement = true;
    };
    MainScene.prototype.stopA = function () {
        this.popupMap.setVisible(false);
        this.popupText[0].setVisible(false);
        this.popupText[1].setVisible(false);
        this.popupText[2].setVisible(false);
        this.popupText[3].setVisible(false);
        this.cameras.main.setVisible(true);
        this.gamePad.setDepth(1);
        this.stopAllMovement = false;
    };
    MainScene.prototype.updatePlayerMovement = function () {
        if (this.popupMap.visible || this.isModalOnScreen()) {
            this.player.anims.play('turn');
            return;
        }
        this.xVel = 0;
        this.yVel = 0;
        if (this.gamePad.keys.left.isDown) {
            this.xVel += -this.speed;
            this.npcLeft = true;
            this.npcRight = false;
            this.npcUp = false;
            this.npcDown = false;
        }
        if (this.gamePad.keys.right.isDown) {
            this.xVel += this.speed;
            this.npcLeft = false;
            this.npcRight = true;
            this.npcUp = false;
            this.npcDown = false;
        }
        if (this.gamePad.keys.up.isDown) {
            this.yVel += -this.speed;
            this.npcLeft = false;
            this.npcRight = false;
            this.npcDown = false;
            this.npcUp = true;
        }
        if (this.gamePad.keys.down.isDown) {
            this.yVel += this.speed;
            this.npcLeft = false;
            this.npcRight = false;
            this.npcUp = false;
            this.npcDown = true;
        }
        this.player.setVelocity(this.xVel, this.yVel);
        // Play walking animations
        if (this.xVel > 0) {
            this.player.anims.play('right', true);
        }
        else if (this.xVel < 0) {
            this.player.anims.play('left', true);
        }
        else {
            this.player.anims.play('turn');
        }
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Student; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_UniversityGame_objects_College__ = __webpack_require__(2299);

var Student = /** @class */ (function () {
    function Student(greeting, goodbye, frame, college) {
        this.complete = false;
        this.object = null;
        this.greeting = greeting;
        this.goodbye = goodbye;
        this.frame = frame;
        this.college = college;
    }
    Student.STUDENTS = [
        new Student("University.Phaser.NPCs.businessStudent.greeting", "University.Phaser.NPCs.businessStudent.goodbye", 'sleb-2', new __WEBPACK_IMPORTED_MODULE_0_src_games_UniversityGame_objects_College__["a" /* College */]("business", "University.Phaser.Colleges.business")),
        new Student("University.Phaser.NPCs.engineeringStudent.greeting", "University.Phaser.NPCs.engineeringStudent.goodbye", "sleb-1", new __WEBPACK_IMPORTED_MODULE_0_src_games_UniversityGame_objects_College__["a" /* College */]("engineering", "University.Phaser.Colleges.engineering")),
        new Student("University.Phaser.NPCs.artsStudent.greeting", "University.Phaser.NPCs.artsStudent.goodbye", 'squeelo-1', new __WEBPACK_IMPORTED_MODULE_0_src_games_UniversityGame_objects_College__["a" /* College */]("arts", "University.Phaser.Colleges.arts")),
        new Student("University.Phaser.NPCs.medicalStudent.greeting", "University.Phaser.NPCs.medicalStudent.goodbye", 'snib-1', new __WEBPACK_IMPORTED_MODULE_0_src_games_UniversityGame_objects_College__["a" /* College */]("medical", "University.Phaser.Colleges.medical")),
    ];
    return Student;
}());



/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return College; });
var College = /** @class */ (function () {
    function College(id, name) {
        this.id = id;
        this.name = name;
        this.zone = null;
    }
    return College;
}());



/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "i";
        _this.gameClosingTextKey = "University.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/campus.18330ec6.json";

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sheet.4f9c41d8.png";

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chat-help.a7901285.png";

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/campusWholeMap_colleges.24316543.png";

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gate.fc4b5a2d.png";

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/key.fc7e20bb.png";

/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(892);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Paint;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "Paint.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Paint.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "Paint.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_TriSlider__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorWheel__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_ImageHelper__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_PaintGame_scenes_EndGameScene__ = __webpack_require__(2312);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








// Paintbrush helper class to hold drawing attributes
var PaintBrush = /** @class */ (function () {
    // default color yellow, thickness 5
    function PaintBrush() {
        this.thickness = 5;
        this.color = 0x223e93;
        this.alpha = 1;
    }
    return PaintBrush;
}());
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.paintBrushCursor = 'url(' + __webpack_require__(518) + '), pointer';
        _this.ellipseCursor = 'url(' + __webpack_require__(2313) + '), pointer';
        _this.rectangleCursor = 'url(' + __webpack_require__(2314) + '), pointer';
        _this.eraseCursor = 'url(' + __webpack_require__(2315) + '), pointer';
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image("pixel", __webpack_require__(60));
        this.load.atlas("assets", __webpack_require__(2316), __webpack_require__(2317));
        this.load.image("control-background", __webpack_require__(2318));
        __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorWheel__["a" /* PhaserColorWheel */].preload(this);
        __WEBPACK_IMPORTED_MODULE_0_src_games_shared_TriSlider__["a" /* PhaserSlider */].preload(this);
    };
    MainScene.prototype.create = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        var easelArea = new Phaser.Geom.Rectangle(0, 0, this.sys.canvas.width - 300, this.sys.canvas.height);
        var controlArea = new Phaser.Geom.Rectangle(easelArea.width, 0, 300, this.sys.canvas.height);
        this.paintBrush = new PaintBrush();
        this.brushColor = this.paintBrush.color;
        this.brushThickness = this.paintBrush.thickness;
        this.buildEasel(easelArea);
        this.buildControlArea(controlArea);
        this.buildControls(controlArea);
        this.lineHistory = [];
        this.makeLine = false;
        this.makeRect = false;
        this.makeEllipse = false;
        // Register the click events
        this.registerEvents();
        this.refreshPaintBrush();
        this.input.setDefaultCursor(this.paintBrushCursor);
        this.rectButton.setAlpha(0.5);
        this.ellipseButton.setAlpha(0.5);
        this.eraseButton.setAlpha(0.5);
    };
    MainScene.prototype.buildEasel = function (easelArea) {
        this.easel = this.add.image(easelArea.x, easelArea.y, "pixel");
        this.easel.setOrigin(0, 0);
        this.easel.setDisplaySize(easelArea.width, easelArea.height);
        this.easel.setTint(0xffffff);
        this.easel.setDepth(-1);
        this.easelTexture = this.add.renderTexture(0, 0, this.sys.canvas.width - 300, this.sys.canvas.height);
        this.easelTexture.setOrigin(0);
        this.easelTexture.setDepth(0);
        this.easelGraphic = this.add.graphics();
        this.easelGraphic.setDepth(0);
    };
    MainScene.prototype.buildControlArea = function (controlArea) {
        this.easelControls = this.add.image(controlArea.x, controlArea.y, "control-background");
        this.easelControls.setOrigin(0, 0);
        this.easelControls.setDisplaySize(controlArea.width, controlArea.height);
        this.easelControls.setDepth(1);
    };
    MainScene.prototype.buildControls = function (controlArea) {
        this.buildThicknessSlider(controlArea);
        this.buildLineButton();
        this.buildRectButton();
        this.buildEllipseButton();
        this.buildScreenshotButton(controlArea);
        this.buildEraseButton();
        this.buildColorWheel(controlArea);
        var iconsBackground = this.add.image(controlArea.centerX, 280, "pixel");
        iconsBackground.setDisplaySize(160, 160);
        iconsBackground.setDepth(1);
        Phaser.Actions.GridAlign([this.lineButton, this.rectButton, this.ellipseButton, this.eraseButton], {
            x: iconsBackground.x - iconsBackground.displayWidth / 4,
            y: iconsBackground.y - iconsBackground.displayHeight / 4,
            width: 2,
            height: 2,
            cellHeight: 80,
            cellWidth: 80
        });
    };
    MainScene.prototype.refreshPaintBrush = function () {
        if (this.erase) {
            this.paintBrush.color = 0xffffff;
        }
        else {
            this.paintBrush.color = this.brushColor;
        }
        this.easelGraphic.lineStyle(this.paintBrush.thickness, this.paintBrush.color, this.paintBrush.alpha);
    };
    MainScene.prototype.registerEvents = function () {
        // If pointer goes up outside the canvas, stop drawing
        document.addEventListener('mouseup', this.pointerUp);
        // When mouse click is pressed
        this.input.on('pointerdown', this.pointerDown);
        // When mouse click is released
        this.input.on('pointerup', this.pointerUp);
        // When mouse is moving after click is pressed
        this.input.on('pointermove', this.pointerMove);
        this.input.addPointer(5);
    };
    MainScene.prototype.pointerDown = function (pointer) {
        if (this.slider.getIsSliding()) {
            return;
        }
        else if (this.makeRect) {
            this.startX = pointer.x;
            this.startY = pointer.y;
            this.drawShape = true;
        }
        else if (this.makeEllipse) {
            this.startX = pointer.x;
            this.startY = pointer.y;
            this.drawShape = true;
        }
        else {
            this.makeLine = true;
            this.lineHistory = [];
        }
    };
    MainScene.prototype.pointerUp = function () {
        this.makeLine = false;
        this.drawShape = false;
        // Capture the graphics as a texture
        this.easelGraphic.generateTexture("background-drawn", this.sys.canvas.width - 300, this.sys.canvas.height);
        this.easelGraphic.clear();
        var tempImage = this.add.image(0, 0, "background-drawn");
        this.easelTexture.save();
        this.easelTexture.draw(tempImage.texture, tempImage.frame, 0, 0);
        this.easelTexture.restore();
        tempImage.destroy();
    };
    MainScene.prototype.pointerMove = function (pointer) {
        // Show the shape being drawn as the mouse moves
        this.easelGraphic.clear();
        this.refreshPaintBrush();
        if (this.makeRect && this.drawShape) {
            // This fixes a strange issue the rectangle has at the corners when pulled a certain way
            var x1 = Math.min(this.startX, pointer.x);
            var x2 = Math.max(this.startX, pointer.x);
            var y1 = Math.min(this.startY, pointer.y);
            var y2 = Math.max(this.startY, pointer.y);
            var rect = new Phaser.Geom.Rectangle(x1, y1, x2 - x1, y2 - y1);
            this.easelGraphic.strokeRectShape(rect);
        }
        else if (this.makeEllipse && this.drawShape) {
            // This fixes an issue where ellipses are constructed from the center... Why?
            var ellipse = new Phaser.Geom.Ellipse(this.startX, this.startY, pointer.x - this.startX, pointer.y - this.startY);
            ellipse.left = this.startX;
            ellipse.top = this.startY;
            ellipse.right = pointer.x;
            ellipse.bottom = pointer.y;
            this.easelGraphic.strokeEllipseShape(ellipse, 1024);
        }
        else if (this.makeLine && !this.slider.getIsSliding()) {
            // Add the new points to the point history arrays
            this.lineHistory.push(new Phaser.Geom.Point(pointer.x, pointer.y));
            // Do the drawing
            this.easelGraphic.strokePoints(this.lineHistory);
        }
    };
    // Generate icon button for ellipse
    MainScene.prototype.buildLineButton = function () {
        var _this = this;
        this.lineButton = this.add.image(0, 0, "assets", "line_icon");
        this.lineButton.setOrigin(0);
        this.lineButton.setDisplaySize(75, 75);
        this.lineButton.setDepth(2);
        this.lineButton.setInteractive();
        this.lineButton.on("pointerdown", function () {
            _this.input.setDefaultCursor(_this.paintBrushCursor);
            _this.makeRect = false;
            _this.makeEllipse = false;
            _this.erase = false;
            _this.makeLine = true;
            // Grey out other buttons
            _this.lineButton.setAlpha(1);
            _this.rectButton.setAlpha(0.5);
            _this.ellipseButton.setAlpha(0.5);
            _this.eraseButton.setAlpha(0.5);
        });
    };
    // Generate icon button for rectangles
    MainScene.prototype.buildRectButton = function () {
        var _this = this;
        this.rectButton = this.add.image(0, 0, "assets", "rectangle_icon");
        this.rectButton.setDisplaySize(75, 75);
        this.rectButton.setOrigin(0);
        this.rectButton.setDepth(2);
        this.rectButton.setInteractive();
        this.rectButton.on("pointerdown", function () {
            _this.input.setDefaultCursor(_this.rectangleCursor);
            _this.makeRect = true;
            _this.makeEllipse = false;
            _this.makeLine = false;
            _this.erase = false;
            // Grey out other buttons
            _this.rectButton.setAlpha(1);
            _this.lineButton.setAlpha(0.5);
            _this.ellipseButton.setAlpha(0.5);
            _this.eraseButton.setAlpha(0.5);
        });
    };
    MainScene.prototype.buildEraseButton = function () {
        var _this = this;
        this.eraseButton = this.add.image(0, 0, "assets", "erase_icon");
        this.eraseButton.setDisplaySize(75, 75);
        this.eraseButton.setOrigin(0);
        this.eraseButton.setDepth(2);
        this.eraseButton.setInteractive();
        this.eraseButton.on("pointerdown", function () {
            // Change to erasing
            _this.input.setDefaultCursor(_this.eraseCursor);
            _this.makeRect = false;
            _this.makeEllipse = false;
            _this.makeLine = false;
            _this.erase = true;
            // Grey out other buttons
            _this.eraseButton.setAlpha(1);
            _this.lineButton.setAlpha(0.5);
            _this.ellipseButton.setAlpha(0.5);
            _this.rectButton.setAlpha(0.5);
        });
    };
    // Generate icon button for ellipse
    MainScene.prototype.buildEllipseButton = function () {
        var _this = this;
        this.ellipseButton = this.add.image(0, 0, "assets", "ellipse_icon");
        this.ellipseButton.setDisplaySize(75, 75);
        this.ellipseButton.setDepth(2);
        this.ellipseButton.setOrigin(0);
        this.ellipseButton.setInteractive();
        this.ellipseButton.on("pointerdown", function () {
            _this.input.setDefaultCursor(_this.ellipseCursor);
            _this.makeRect = false;
            _this.makeEllipse = true;
            _this.makeLine = false;
            _this.erase = false;
            // Grey out other buttons
            _this.ellipseButton.setAlpha(1);
            _this.rectButton.setAlpha(0.5);
            _this.lineButton.setAlpha(0.5);
            _this.eraseButton.setAlpha(0.5);
        });
    };
    // Generate icon button to screenshot the drawing
    MainScene.prototype.buildScreenshotButton = function (controlArea) {
        var _this = this;
        var doneConfig = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_6_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON,
            smartSize: true
        };
        this.screenshotButton = new __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Button__["a" /* PhaserButton */](this, this.gameWidth - 200, 50, 200, 50, __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].translate("Paint.Phaser.thatsawrap"), doneConfig).setDepth(1);
        this.screenshotButton.setX(controlArea.x + controlArea.width / 2 - this.screenshotButton.width / 2);
        this.screenshotButton.on('buttonClicked', function () {
            // Grey out other buttons
            _this.ellipseButton.setAlpha(0.5);
            _this.rectButton.setAlpha(0.5);
            _this.eraseButton.setAlpha(0.5);
            // Defaults back to line
            _this.lineButton.setAlpha(1);
            _this.makeRect = false;
            _this.makeEllipse = false;
            _this.makeLine = false;
            _this.erase = false;
            // Screenshot for later
            _this.registry.parent.renderer.snapshot(function (image) {
                image.onload = function () {
                    var croppedImage = __WEBPACK_IMPORTED_MODULE_3_src_utils_ImageHelper__["a" /* default */].CropImageToDataURI(image, 0, 0, _this.sys.canvas.width - 300, _this.sys.canvas.height);
                    console.warn("Screenshot!", croppedImage); // JB - Remove this console.warn
                    _this.endGame(croppedImage);
                };
            });
        });
    };
    // Generate thickness slider
    MainScene.prototype.buildThicknessSlider = function (controlArea) {
        var _this = this;
        this.slider = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_TriSlider__["a" /* PhaserSlider */](this, controlArea.x + 22.5, 125, controlArea.height / 3, controlArea.width / 6);
        this.slider.setDepth(2);
        this.slider.on("slide", function (ratio) {
            _this.paintBrush.thickness = Math.round(ratio * 20 + 5);
            _this.brushThickness = Math.round(ratio * 20 + 5);
            _this.refreshPaintBrush();
        });
    };
    MainScene.prototype.buildColorWheel = function (controlArea) {
        var _this = this;
        this.colorWheel = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorWheel__["a" /* PhaserColorWheel */](this, controlArea.x, controlArea.height - controlArea.width, controlArea.width, controlArea.width);
        this.refreshPaintBrush();
        this.colorWheel.on("colorChange", function (color) {
            _this.paintBrush.color = color.color;
            _this.brushColor = color.color;
            _this.refreshPaintBrush();
            if (_this.makeEllipse) {
                _this.input.setDefaultCursor(_this.ellipseCursor);
            }
            else if (_this.makeRect) {
                _this.input.setDefaultCursor(_this.rectangleCursor);
            }
            else if (_this.erase) {
                _this.input.setDefaultCursor(_this.eraseCursor);
            }
            else {
                _this.input.setDefaultCursor(_this.paintBrushCursor);
            }
        });
        this.colorWheel.setDepth(2);
    };
    // Give the button attributes shared by all the buttons
    MainScene.prototype.setupButton = function (rect) {
        var button = this.add.image(rect.x, rect.y, "pixel");
        button.setOrigin(0);
        button.setDepth(2);
        button.setInteractive();
        button.setDisplaySize(rect.width, rect.height);
        return button;
    };
    MainScene.prototype.endGame = function (image) {
        document.removeEventListener('mouseup', this.pointerUp);
        this.input.setDefaultCursor("default");
        this.input.removeAllListeners();
        MainScene.CROPPED_IMAGE = image;
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_7_src_games_PaintGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    MainScene.CROPPED_IMAGE = null;
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhaserSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PhaserSlider = /** @class */ (function (_super) {
    __extends(PhaserSlider, _super);
    function PhaserSlider(scene, x, y, width, height) {
        var _this = _super.call(this, scene, x, y) || this;
        // Boolean to hold the slider's sliding state
        _this.isSliding = false;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserSlider.prototype);
        _this.width = width;
        _this.height = height;
        _this.initialize();
        _this.registerEvents();
        return _this;
    }
    PhaserSlider.preload = function (scene) {
        scene.load.image("triangle", __webpack_require__(2310));
        scene.load.image("pixel", __webpack_require__(60));
        // Construct a circle to slide slider and make it a texture
        var tempGraphic = scene.add.graphics();
        tempGraphic.setDepth(0);
        tempGraphic.lineStyle(1, 0x000000);
        tempGraphic.fillStyle(0x000000);
        tempGraphic.fillEllipse(8, 8, 16, 16);
        tempGraphic.generateTexture("slider-graphic", 16, 16);
        tempGraphic.clear();
        tempGraphic.destroy();
    };
    PhaserSlider.prototype.initialize = function () {
        // Set size to size of background image
        this.setSize(this.width, this.height);
        // Construct Objects
        this.constructObjects();
        // Only after we have set size can we change our scale to fit what was passed in
        this.setDisplaySize(this.width, this.height);
        // Add items to self and self to scene
        this.add(this.background);
        this.add(this.triangle);
        this.add(this.pickerImage);
        this.scene.add.existing(this);
    };
    PhaserSlider.prototype.constructObjects = function () {
        this.background = this.scene.add.image(0, 0, "pixel");
        this.background.setDisplaySize(this.width, this.height);
        this.background.setDepth(0);
        this.background.setOrigin(0);
        this.triangle = this.scene.add.image(this.background.height / 2, this.background.width / 2 + 34, "triangle");
        this.triangle.setDisplaySize(this.height - 15, this.width - 15);
        this.triangle.setAngle(270);
        this.triangle.setDepth(.5);
        this.triangle.setOrigin(0);
        this.pickerImage = this.scene.add.image(this.triangle.x + 10, this.background.getCenter().y, "slider-graphic");
        this.pickerImage.setDepth(1);
        var ellipse = new Phaser.Geom.Ellipse(this.background.frame.realWidth / 2, this.background.frame.realHeight / 2, 32, 32);
        this.pickerImage.setInteractive(ellipse, Phaser.Geom.Ellipse.Contains);
        this.background.setInteractive();
    };
    PhaserSlider.prototype.registerEvents = function () {
        var _this = this;
        // Allow just a click on the component to change the value
        this.background.on("pointerdown", function (pointer, x, y) {
            if (!_this.checkBounds(pointer.x - _this.x)) {
                return;
            }
            _this.isSliding = true;
            _this.pickerImage.x = pointer.x - _this.x;
        });
        // Normal sliding events
        this.pickerImage.on("pointerdown", function (pointer, x, y) {
            if (!_this.checkBounds(pointer.x - _this.x)) {
                return;
            }
            _this.isSliding = true;
            _this.pickerImage.x = pointer.x - _this.x;
        });
        this.pickerImage.on("pointermove", function (pointer, x, y) {
            if (!_this.checkBounds(pointer.x - _this.x)) {
                return;
            }
            if (_this.isSliding) {
                _this.pickerImage.x = pointer.x - _this.x;
            }
        });
        this.pickerImage.on("pointerup", function (pointer, x, y) {
            _this.isSliding = false;
        });
        // Emit value when pointer is released. Include when pointer moves off pickerImage
        this.scene.input.on("pointerup", function (pointer, x, y) {
            if (_this.isSliding) {
                _this.isSliding = false;
                var ratio = (_this.pickerImage.x) / (_this.triangle.displayHeight);
                _this.emit("slide", ratio);
            }
        });
    };
    // Dont slide the pickerimage beyond the triangle
    PhaserSlider.prototype.checkBounds = function (point) {
        if (point < this.triangle.x + 5 || point > this.triangle.x + this.triangle.displayHeight - 5) {
            return false;
        }
        else {
            return true;
        }
    };
    // Determine if the slider is sliding
    PhaserSlider.prototype.getIsSliding = function () {
        return this.isSliding;
    };
    return PhaserSlider;
}(Phaser.GameObjects.Container));



/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/triangle.e096fd2f.png";

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/color-wheel.238f318f.png";

/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_DesertTerraformGame_scenes_MainScene__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "a";
        _this.gameClosingTextKey = "Paint.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete(__WEBPACK_IMPORTED_MODULE_4_src_games_DesertTerraformGame_scenes_MainScene__["a" /* MainScene */].CROPPED_IMAGE);
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ellipse_cursor.cddaf72c.cur";

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rectangle_icon.e3c7a046.cur";

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eraser_cursor.005e3607.cur";

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gamePaint.57939508.png";

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gamePaint.3fcaf9f8.json";

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/astrology.2bce8f89.png";

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(894);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Diner;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "Diner.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Diner.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "Diner.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_NPC__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_Food__ = __webpack_require__(2322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_DinerGame_scenes_EndGameScene__ = __webpack_require__(2323);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "GameScene"
        }) || this;
        _this.foodWidth = 56;
        _this.foodHeight = 36;
        _this.speed = 200;
        _this.generalSize = 64;
        _this.npcArea = [];
        _this.foodItems = [];
        _this.serving = false;
        _this.foodTextures = ["food1", "food2", "food3", "food4", "food5", "food6"];
        _this.currentTime = 0;
        _this.score = 0;
        _this.break = false;
        _this.stars = [];
        _this.currentFoodExists = false;
        _this.xVel = 0;
        _this.yVel = 0;
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image("patron", __webpack_require__(2324));
        this.load.tilemapTiledJSON("map", __webpack_require__(2325));
        this.load.spritesheet('player', __webpack_require__(887), { frameWidth: 64, frameHeight: 96 });
        this.load.image("star", __webpack_require__(895));
        this.load.image("food1", __webpack_require__(2326));
        this.load.image("food2", __webpack_require__(2327));
        this.load.image("food3", __webpack_require__(2328));
        this.load.image("food4", __webpack_require__(2329));
        this.load.image("food5", __webpack_require__(2330));
        this.load.image("food6", __webpack_require__(2331));
        this.load.image("tiles", __webpack_require__(2332));
        __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
    };
    MainScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_4_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.timeElapsed = this.add.text(96, 64, "0:00", { fill: "#000000", align: "center" }).setScrollFactor(0).setDepth(7.5).setOrigin().setFontFamily('Russo One, Roboto Mono, Arial').setFontSize(30);
        this.createMap();
        this.createPlayer();
        this.createFoodTable();
        this.createFoods();
        this.createTimer();
        this.createRating();
        this.createCollision();
        this.createCameras();
        this.generateGamepad();
        this.onKeydown(function () {
            if (_this.finishModal) {
                _this.finishModal.selectLastOption();
            }
        }, 'ENTER', 'SPACE');
    };
    MainScene.prototype.modalPop = function (text, gameover) {
        var _this = this;
        if (gameover) {
            this.player.disableBody();
        }
        var config = new __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
        config.title = text;
        config.buttonConfig.smartSize = true;
        this.finishModal = new __WEBPACK_IMPORTED_MODULE_5_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, [{ id: 1, displayText: __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("common.done") }], config);
        this.finishModal.setPosition(this.gameWidth / 2 - this.finishModal.width / 2, this.gameHeight / 2 - this.finishModal.height / 2);
        this.finishModal.on('optionClicked', function () {
            _this.finishModal.destroy();
            if (gameover) {
                _this.input.setDefaultCursor("default");
                _this.input.removeAllListeners();
                _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_6_src_games_DinerGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
                _this.scene.remove(_this);
            }
        });
    };
    MainScene.prototype.createMap = function () {
        this.map = this.make.tilemap({ key: "map" });
        this.tiles = this.map.addTilesetImage('tiles');
        this.groundLayer = this.map.createDynamicLayer('Background', this.tiles, 0, 0);
        this.objectLayer = this.map.createDynamicLayer('Objects', this.tiles, 0, 0);
    };
    MainScene.prototype.createFoodTable = function () {
        this.createEatingTable(6, 5, "patron");
        this.createEatingTable(15, 5, "patron");
        this.createEatingTable(5, 9, "patron");
        this.createEatingTable(17, 9, "patron");
        this.createEatingTable(23, 6, "patron");
    };
    MainScene.prototype.createFoods = function () {
        var _this = this;
        var i = 0;
        this.map.getObjectLayer("Food").objects.forEach(function (ob) {
            var food = _this.foodTextures[i];
            var foodPlate = _this.add.image(ob.x, ob.y, food);
            foodPlate.setOrigin(0);
            foodPlate.setDepth(3);
            foodPlate.setDisplaySize(ob.width, ob.height);
            var rect = new Phaser.Geom.Rectangle(foodPlate.x + 8, foodPlate.y, 32, 96);
            _this.foodItems.push(new __WEBPACK_IMPORTED_MODULE_3__objects_Food__["a" /* FoodItems */](foodPlate, rect, false, food));
            i++;
        });
    };
    MainScene.prototype.createEatingTable = function (posX, posY, texture) {
        this.createNPC(posX - 1, posY, texture, false);
        this.createNPC(posX + 3, posY, texture, true);
    };
    MainScene.prototype.createNPC = function (x, y, texture, flip) {
        var translateString = "Diner.Phaser.";
        var npcGoodGreeting = ["correct.1", "correct.2", "correct.3", "correct.4"];
        var npcBadGreeting = ["wrong.1", "wrong.2", "wrong.3"];
        npcGoodGreeting = npcGoodGreeting.sort(function () { return .5 - Math.random(); });
        npcBadGreeting = npcBadGreeting.sort(function () { return .5 - Math.random(); });
        var npc = this.physics.add.staticImage(64 * x + 32, 64 * y + 32, texture);
        // ** This is for the physics/collision bounds **
        npc.setSize(64, 45);
        npc.setOffset(0, 35);
        npc.setFlipX(flip);
        npc.setDisplaySize(64, 64);
        this.physics.add.collider(npc, this.player);
        this.foodTextures = this.scrambleArray(this.foodTextures);
        var food = this.add.image(64 * x + 32, 64 * (y - 1) + 32, this.foodTextures[Phaser.Math.Between(0, this.foodTextures.length - 1)]);
        food.setVisible(false);
        food.setDisplaySize(this.foodWidth, this.foodHeight);
        var rect = new Phaser.Geom.Rectangle(64 * (x - 1) + 32, 64 * (y - 1) + 32, 64 * 2, 64 * 2);
        var npcGoodText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateString + npcGoodGreeting[0]);
        var npcBadText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateString + npcBadGreeting[0]);
        this.npcArea.push(new __WEBPACK_IMPORTED_MODULE_1__objects_NPC__["a" /* NPC */](food, npc, rect, null, npcGoodText, npcBadText, 0));
    };
    MainScene.prototype.addTextBlurb = function (x, y, text) {
        var padding = 5;
        var fontSize = 14;
        var borderWidth = 2;
        var borderColor = 0xff0000;
        var textBox = this.add.container(x, y);
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#ffffff", fontSize: fontSize, padding: 10 };
        var textObject = this.add.text(padding + borderWidth, padding + borderWidth, text, textStyle);
        textObject.setWordWrapWidth(textObject.width + padding, true);
        textBox.setSize(textObject.displayWidth + padding + borderWidth, textObject.displayHeight + padding + borderWidth);
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(textObject);
        return textBox;
    };
    MainScene.prototype.createCameras = function () {
        this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);
        this.cameras.main.startFollow(this.player);
    };
    MainScene.prototype.createCollision = function () {
        var _this = this;
        this.physics.add.collider(this.player, this.groundLayer);
        this.physics.add.collider(this.player, this.objectLayer);
        this.objectLayer.forEachTile(function (tile) {
            var tileWorldPos = _this.objectLayer.tileToWorldXY(tile.x, tile.y);
            var collisionGroup = _this.tiles.getTileCollisionGroup(tile.index);
            if (!collisionGroup || collisionGroup["objects"].length === 0) {
                return;
            }
            // The group will have an array of objects - these are the individual collision shapes
            var objects = collisionGroup["objects"];
            for (var i = 0; i < objects.length; i++) {
                var object = objects[i];
                var objectX = tileWorldPos.x + object.x;
                var objectY = tileWorldPos.y + object.y;
                // Add collider for rectangles
                if (object.rectangle) {
                    var gameObject = new Phaser.GameObjects.Zone(_this, objectX, objectY, object.width, object.height);
                    _this.physics.add.existing(gameObject, true);
                    _this.physics.add.collider(_this.player, gameObject);
                }
            }
        });
    };
    MainScene.prototype.createTimer = function () {
        this.timer = this.time.addEvent({ delay: 10000000, timeScale: 1.0 });
        var clock = this.add.image(this.timeElapsed.x, this.timeElapsed.y, "pixel");
        clock.setDisplaySize(this.timeElapsed.displayWidth + 30, this.timeElapsed.displayHeight + 20).setDepth(6.5).setScrollFactor(0);
        var clockBorder = this.add.image(clock.x, clock.y, "pixel");
        clockBorder.setDisplaySize(clock.displayWidth + 10, clock.displayHeight + 10).setDepth(6).setTint(0x000000).setScrollFactor(0);
    };
    MainScene.prototype.createPlayer = function () {
        this.player = this.physics.add.sprite(64 * 11 + 32, 64 * 6.5 + 32, "player");
        // ** This is for the physics/collision bounds - if you want to see a visual, set debug: true in Main.tsx**
        this.player.setSize(50, 80);
        this.player.setOffset(6, 15);
        this.player.setFrame(4);
        this.physics.world.setBounds(0, 0, 64 * 30, 64 * 14);
        this.player.setCollideWorldBounds(true);
        //  Player animations, turning, walking left and walking right.
        this.anims.create({
            key: 'left',
            frames: this.anims.generateFrameNumbers('player', { start: 0, end: 3 }),
            frameRate: 10,
            repeat: -1
        });
        this.anims.create({
            key: 'turn',
            frames: [{ key: 'player', frame: 4 }],
            frameRate: 20
        });
        this.anims.create({
            key: 'right',
            frames: this.anims.generateFrameNumbers('player', { start: 5, end: 8 }),
            frameRate: 10,
            repeat: -1
        });
    };
    MainScene.prototype.createRating = function () {
        var xCoor = this.gameWidth - 5 * 50;
        var yCoor = 32;
        var score = this.add.group();
        for (var i = 0; i < 5; i++) {
            var star = this.add.image(0, 0, "star");
            star.setOrigin(0);
            star.setDisplaySize(48, 48);
            star.setScrollFactor(0);
            score.add(star);
            this.stars.push(star);
        }
        score.setDepth(5, 0);
        Phaser.Actions.GridAlign(score.getChildren(), {
            x: xCoor,
            y: yCoor,
            width: 5,
            height: 1,
            cellHeight: 50,
            cellWidth: 50,
        });
    };
    MainScene.prototype.updateNPC = function () {
        var _this = this;
        this.npcArea.forEach(function (npc) {
            if (!npc.served) {
                var doesIntersect = Phaser.Geom.Intersects.RectangleToRectangle(_this.player.getBounds(), npc.rect);
                if (doesIntersect) {
                    npc.food.setVisible(true);
                }
                else {
                    npc.food.setVisible(false);
                }
            }
        });
    };
    MainScene.prototype.updateFoodPosition = function () {
        var _this = this;
        this.foodItems.forEach(function (food) {
            if (food.follow) {
                _this.currentFood.y = _this.player.y + 20;
                if (_this.player.body.velocity.x < 0) {
                    _this.currentFood.x = _this.player.x - 32;
                }
                else if (_this.player.body.velocity.x > 0) {
                    _this.currentFood.x = _this.player.x + 32;
                }
                else {
                    _this.currentFood.x = _this.player.x;
                }
            }
        });
    };
    MainScene.prototype.increaseTime = function () {
        var time = Math.trunc(this.timer.getElapsedSeconds());
        var minute = Math.floor(time / 60);
        var second = Math.floor(time % 60);
        if (time % 45 === 1) {
            this.droppedScore = false;
            this.timeElapsed.setColor("0x000000");
        }
        if (time !== 0 && time % 45 === 0 && !this.droppedScore) {
            this.timeElapsed.setColor('#ff0000');
            this.score--;
            if (this.score >= 0 && this.score <= 4) {
                this.stars[this.score].setTint(0xffffff);
            }
            this.droppedScore = true;
        }
        if (second < 10) {
            this.timeElapsed.setText(minute.toString() + ":0" + second.toString());
        }
        else {
            this.timeElapsed.setText(minute.toString() + ":" + second.toString());
        }
    };
    /**
   * Shuffle the candidates so they're not in the same order every time
   * https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
   */
    MainScene.prototype.scrambleArray = function (array) {
        var j, x, i;
        for (i = array.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = array[i];
            array[i] = array[j];
            array[j] = x;
        }
        return array;
    };
    MainScene.prototype.fadeOutFeedback = function (blurb, npc, positive) {
        var _this = this;
        this.tweens.add({
            targets: blurb,
            x: npc.rect.x,
            duration: 2000,
            ease: "Linear",
            onComplete: function () {
                _this.tweens.add({
                    targets: blurb,
                    duration: 500,
                    x: blurb.x,
                    ease: "Linear",
                    alpha: {
                        getStart: function () { return 1; },
                        getEnd: function () { return 0; },
                    },
                    onComplete: function () {
                        blurb.destroy();
                        if (!positive) {
                            npc.served = null;
                        }
                    },
                });
            }
        });
    };
    MainScene.prototype.update = function () {
        this.updatePlayerMovement();
        this.updateNPC();
        this.updateFoodPosition();
        this.increaseTime();
    };
    /**
       * GamePad/Player Movement
       */
    MainScene.prototype.generateGamepad = function () {
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.gamePad.on("keydown_a", this.aDown);
        this.gamePad.on("keydown_b", this.bDown);
        this.gamePad.on("keyup_a", this.stopA);
    };
    MainScene.prototype.bDown = function () {
        var _this = this;
        if (this.finishModal) {
            this.finishModal.selectLastOption();
            return;
        }
        if (this.serving) {
            this.npcArea.forEach(function (npc) {
                if (!_this.break) {
                    var doesIntersect = Phaser.Geom.Intersects.RectangleToRectangle(_this.player.getBounds(), npc.rect);
                    if (doesIntersect
                        && npc.food.texture === _this.currentFood.texture
                        && !npc.served) {
                        npc.food.setVisible(true);
                        npc.served = true;
                        npc.time = _this.currentTime;
                        if (npc.npc.flipX) {
                            npc.food.setPosition(npc.food.x - 64, npc.food.y + 64);
                        }
                        else {
                            npc.food.setPosition(npc.food.x + 64, npc.food.y + 64);
                        }
                        _this.currentFood.destroy();
                        _this.serving = false;
                        if (_this.score >= 0 && _this.score <= 4) {
                            _this.stars[_this.score].setTint(0xffff00);
                        }
                        _this.score++;
                        // Show good feedback
                        var blurb = _this.addTextBlurb(npc.rect.x, npc.rect.y - 20, npc.goodText);
                        _this.fadeOutFeedback(blurb, npc, true);
                        _this.break = true;
                    }
                    if (doesIntersect
                        && npc.food.texture !== _this.currentFood.texture
                        && !npc.served) {
                        npc.served = false;
                        npc.time = _this.currentTime;
                        _this.score--;
                        if (_this.score >= 0 && _this.score <= 4) {
                            _this.stars[_this.score].setTint(0xffffff);
                        }
                        // Show bad feedback
                        blurb = _this.addTextBlurb(npc.rect.x, npc.rect.y - 20, npc.badText);
                        _this.fadeOutFeedback(blurb, npc, false);
                    }
                }
            });
            this.break = false;
        }
        this.foodItems.forEach(function (food) {
            var doesIntersect = Phaser.Geom.Intersects.RectangleToRectangle(_this.player.getBounds(), food.rect);
            if (doesIntersect) {
                if (_this.currentFoodExists) {
                    _this.currentFood.destroy();
                    _this.currentFoodExists = false;
                }
                _this.currentFood = _this.add.image(0, 0, food.foodTexture);
                _this.currentFood.setDisplaySize(_this.foodWidth, _this.foodHeight);
                _this.serving = true;
                _this.currentFoodExists = true;
                food.follow = true;
            }
        });
        if (this.npcArea[0].served && this.npcArea[1].served && this.npcArea[2].served
            && this.npcArea[3].served && this.npcArea[4].served && this.npcArea[5].served
            && this.npcArea[6].served && this.npcArea[7].served && this.npcArea[8].served
            && this.npcArea[9].served) {
            if (this.score >= 5) {
                this.score = 5;
            }
            if (this.score <= 0) {
                this.score = 0;
            }
            var doneText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("Diner.Phaser.doneText") + "\n";
            var scoreText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("Diner.Phaser.score") + ": ";
            this.modalPop(doneText + scoreText + this.score, true);
            this.timer.paused = true;
        }
    };
    MainScene.prototype.aDown = function () {
        if (this.finishModal) {
            this.finishModal.selectLastOption();
            return;
        }
        // Turn on Turbo speed
        this.speed = 300;
    };
    MainScene.prototype.stopA = function () {
        // Turn off Turbo speed
        this.speed = 200;
    };
    MainScene.prototype.updatePlayerMovement = function () {
        this.xVel = 0;
        this.yVel = 0;
        if (this.gamePad.keys.left.isDown) {
            this.xVel += -this.speed;
        }
        if (this.gamePad.keys.right.isDown) {
            this.xVel += this.speed;
        }
        if (this.gamePad.keys.down.isDown) {
            this.yVel += this.speed;
        }
        if (this.gamePad.keys.up.isDown) {
            this.yVel += -this.speed;
        }
        this.player.setVelocity(this.xVel, this.yVel);
        // Play walking animations
        if (this.xVel > 0) {
            this.player.anims.play('right', true);
        }
        else if (this.xVel < 0) {
            this.player.anims.play('left', true);
        }
        else {
            this.player.anims.play('turn');
        }
    };
    MainScene.prototype.onKeydown = function (event) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        keys.forEach(function (key) {
            _this.input.keyboard.on('keydown_' + key, event);
        });
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NPC; });
var NPC = /** @class */ (function () {
    function NPC(food, npc, rect, served, goodText, badText, time) {
        this.food = food;
        this.npc = npc;
        this.rect = rect;
        this.served = served;
        this.goodText = goodText;
        this.badText = badText;
        this.time = time;
    }
    return NPC;
}());



/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FoodItems; });
var FoodItems = /** @class */ (function () {
    function FoodItems(food, rect, follow, foodTexture) {
        this.food = food;
        this.rect = rect;
        this.follow = follow;
        this.foodTexture = foodTexture;
    }
    return FoodItems;
}());



/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "s";
        _this.gameClosingTextKey = "Diner.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(168));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/leftside.c4b3922d.png";

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/diner.a986b2ff.json";

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/item__food-1.ee62a301.png";

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/item__food-2.5eaacc85.png";

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/item__food-3.e77f0f44.png";

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/item__food-4.2f8986e8.png";

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/item__food-5.8637d2da.png";

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/item__food-6.9365896e.png";

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/diner_game.b088dbaf.png";

/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(897);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].CareerFair;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "CareerFair.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "CareerFair.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "CareerFair.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Candidate__ = __webpack_require__(2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_Career__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_Booth__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ModalTitle__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_shared_Gamepad__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_games_CareerFairGame_scenes_EndGameScene__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};













var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene" + Math.random()
        }) || this;
        _this.candidates = __WEBPACK_IMPORTED_MODULE_1__objects_Candidate__["a" /* Candidate */].CANDIDATES;
        _this.doubleJump = true;
        _this.careers = __WEBPACK_IMPORTED_MODULE_2__objects_Career__["a" /* Career */].CAREERS;
        _this.currentCareer = null;
        _this.booths = [];
        _this.currentCandidate = null;
        _this.currentBooth = null;
        _this.playerAlwaysLeads = false;
        _this.boothModal = null;
        _this.frameCount = 0;
        _this.stopMovement = false;
        _this.xVel = 0;
        _this.yVel = 0;
        _this.JUMPING_VELOCITY = 400;
        _this.WALKING_VELOCITY = 200;
        _this.modalConfig = {
            buttonWidth: 200,
            title: "",
            buttonConfig: new __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__["b" /* PhaserButtonConfig */]()
        };
        _this.modalTitleConfig = {
            borderColor: 0xffae00,
            buttonWidth: 100,
            buttonConfig: new __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__["b" /* PhaserButtonConfig */]()
        };
        _this.translateString = "CareerFair.Phaser.MainScene.";
        return _this;
    }
    MainScene.prototype.preload = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.load.image('blocks', __webpack_require__(2338));
        this.load.image('background', __webpack_require__(2339));
        this.load.tilemapTiledJSON('map', __webpack_require__(2340));
        this.load.image("pixel", __webpack_require__(60));
        this.load.image("exclamation-point", __webpack_require__(900));
        this.load.spritesheet('player', __webpack_require__(890), { frameWidth: 32, frameHeight: 48 });
        this.load.atlas('assets', __webpack_require__(2341), __webpack_require__(2342));
        this.load.atlas('pilots', __webpack_require__(189), __webpack_require__(190));
        var code = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code;
        var keys = [
            "MainScene.correctCandidate",
            "MainScene.incorrectCandidate",
        ];
        // All the careers audio
        for (var i = 1; i < 5; i++) {
            keys.push("Careers." + i + ".boothText.1");
            keys.push("Careers." + i + ".boothText.2");
            keys.push("Careers." + i + ".question1");
            keys.push("Careers." + i + ".question2");
            keys.push("Careers." + i + ".responses1.1");
            keys.push("Careers." + i + ".responses1.2");
            keys.push("Careers." + i + ".responses1.3");
            keys.push("Careers." + i + ".responses2.1");
            keys.push("Careers." + i + ".responses2.2");
            keys.push("Careers." + i + ".responses2.3");
        }
        keys.forEach(function (subkey) {
            _this.load.audio("CareerFair.Phaser." + subkey, __WEBPACK_IMPORTED_MODULE_12_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage("CareerFair.Phaser." + subkey, code).url);
        });
        __WEBPACK_IMPORTED_MODULE_7_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
        __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__["a" /* PhaserButton */].preload(this);
        __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["a" /* PhaserModal */].preload(this);
    };
    MainScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.initializeMap();
        this.generateScene();
    };
    // Initializes the tilemap and sets tile collision properties
    MainScene.prototype.initializeMap = function () {
        this.map = this.make.tilemap({ key: 'map' });
        var groundTiles = this.map.addTilesetImage('blocks');
        var backgroundTiles = this.map.addTilesetImage('background');
        this.map.createStaticLayer('Background Layer', backgroundTiles, 0, 0);
        this.groundLayer = this.map.createStaticLayer('Ground Layer', groundTiles, 0, 0);
        this.borderLayer = this.map.getObjectLayer("Borders");
        this.candidateLayer = this.map.getObjectLayer('Candidate Layer');
        this.boothLayer = this.map.getObjectLayer('Booth Layer');
        this.groundLayer.setCollisionBetween(this.groundLayer.tileset.firstgid, this.groundLayer.tileset.firstgid + 20);
    };
    MainScene.prototype.setCollisions = function () {
        var _this = this;
        this.borderLayer.objects.forEach(function (object) {
            // The group will have an array of objects - these are the individual collision shapes
            var gameObject = new Phaser.GameObjects.Zone(_this, object.x, object.y, object.width, object.height);
            gameObject.type = object.type;
            _this.physics.add.existing(gameObject, true);
            _this.physics.add.collider(_this.player, gameObject);
            _this.physics.add.collider(_this.astronaut, gameObject);
            _this.candidates.forEach(function (c) {
                _this.physics.add.collider(c.object, gameObject);
            });
        });
    };
    MainScene.prototype.generateScene = function () {
        this.generatePlayer();
        this.generateNPCs();
        this.setCollisions();
        this.generateBooths();
        this.createGamePad();
        // Setup the camera to follow the player
        this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);
        this.cameras.main.startFollow(this.player);
        Object(__WEBPACK_IMPORTED_MODULE_9_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    MainScene.prototype.generatePlayer = function () {
        this.player = this.physics.add.sprite(640, 630, "player");
        this.player.setBounce(0.2);
        this.player.setDepth(1);
        this.player.setFrame(4);
        //  Player animations, turning, walking left and walking right.
        this.anims.create({
            key: 'left',
            frames: this.anims.generateFrameNumbers('player', { start: 0, end: 3 }),
            frameRate: 10,
            repeat: -1
        });
        this.anims.create({
            key: 'turn',
            frames: [{ key: 'player', frame: 4 }],
            frameRate: 20
        });
        this.anims.create({
            key: 'right',
            frames: this.anims.generateFrameNumbers('player', { start: 5, end: 8 }),
            frameRate: 10,
            repeat: -1
        });
        this.physics.add.collider(this.player, this.groundLayer);
    };
    /**
     * Generates the astronaut and candidates with their careers
     * */
    MainScene.prototype.generateNPCs = function () {
        var _this = this;
        var i = 0;
        // Scramble candidates so that they're not always in the same place
        this.candidates = this.scrambleArray(this.candidates);
        this.candidateLayer.objects.forEach(function (ob) {
            if (ob.name === "astronaut") {
                _this.astronaut = _this.physics.add.image(ob.x, ob.y, "pilots", "e");
                _this.astronaut.setDisplaySize(32, 48);
                _this.physics.add.collider(_this.astronaut, _this.groundLayer);
                _this.physics.add.overlap(_this.astronaut, _this.player);
                _this.astronaut.setDataEnabled();
                _this.astronaut.setData('enabled', true);
            }
            else {
                var candidateObject;
                if (_this.candidates[i].actualCareer == null) {
                    candidateObject = _this.physics.add.sprite(ob.x, ob.y, "player");
                    candidateObject.setTint(0xff00000);
                    candidateObject.setDisplaySize(32, 48);
                    _this.candidates[i].object = candidateObject;
                }
                else {
                    candidateObject = _this.physics.add.sprite(ob.x, ob.y, "player");
                    candidateObject.setTint(0x4286f4);
                    candidateObject.setDisplaySize(32, 48);
                    candidateObject.setDataEnabled();
                    candidateObject.setData('position', new Phaser.Geom.Point(ob.x, ob.y));
                    _this.candidates[i].object = candidateObject;
                }
                i++;
                candidateObject.setFrame(4);
                _this.physics.add.collider(candidateObject, _this.groundLayer);
                _this.physics.add.overlap(candidateObject, _this.player);
            }
        });
    };
    MainScene.prototype.generateBooths = function () {
        var _this = this;
        var careers = __spreadArrays(this.careers);
        this.boothLayer.objects.forEach(function (ob) {
            var image = _this.physics.add.staticImage(ob.x, ob.y, "assets", ob.type);
            var career = careers.find(function (c) {
                return c.id === ob.type;
            });
            var booth = new __WEBPACK_IMPORTED_MODULE_3__objects_Booth__["a" /* Booth */](image, career);
            booth.object.setOrigin(0);
            booth.object.setSize(ob.width, ob.height);
            booth.object.setDisplaySize(ob.width, ob.height);
            _this.booths.push(booth);
        });
    };
    /**
     * Called when player overlaps with a booth
     */
    MainScene.prototype.insideBooth = function (boothImage) {
        var _this = this;
        var booth = this.booths.find(function (b) {
            return b.object === boothImage;
        });
        booth.playerEnabled = false;
        // Only show modal if we aren't already looking for a candidate
        if (this.currentCareer == null && !booth.isComplete && !this.isModalOnScreen()) {
            var text1 = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(booth.career.boothText + ".1");
            var text2 = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(booth.career.boothText + ".2");
            var audio1 = this.sound.add(booth.career.boothText + ".1");
            audio1.play();
            var audio2 = this.sound.add(booth.career.boothText + ".2");
            audio2.play("", {
                delay: audio1.totalDuration
            });
            var modalConfig = this.modalTitleConfig;
            modalConfig.title = text1;
            modalConfig.bodyText = text2;
            modalConfig.buttonConfig.backgroundColor = __WEBPACK_IMPORTED_MODULE_10_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
            var ok = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate("common.ok");
            var modalOptions = [
                { displayText: ok, id: 1 },
            ];
            this.boothModal = new __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ModalTitle__["a" /* PhaserModalTitle */](this, 0, 0, this.modalTitleConfig, modalOptions);
            this.boothModal.setPosition(this.gameWidth / 2 - this.boothModal.width / 2, this.gameHeight / 2 - this.boothModal.height / 2);
            this.boothModal.on('optionClicked', function (op) {
                _this.currentCareer = booth.career;
                _this.currentBooth = booth;
                booth.object.setAlpha(0.7);
                _this.boothModal.destroy();
                _this.boothModal = null;
            });
        }
    };
    /**
     * Player interaction with the candidate
     * Ask questions, get responses, decide to choose/not choose the candidate
     */
    MainScene.prototype.talkToCandidate = function (candidate) {
        var _this = this;
        if (!candidate.enabled) {
            return;
        }
        // Only able to talk to a candidate if you are already helping a booth, there's no modal already on screen, and nobody is following you
        if (this.currentCareer != null && !this.isModalOnScreen() && this.currentCandidate == null) {
            var questionModalConfig = this.modalConfig;
            var text = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "ask");
            var booth = this.booths.find(function (b) {
                return b.career.title === _this.currentCareer.title;
            });
            // First modal asks player to ask a question
            questionModalConfig.title = text;
            questionModalConfig.buttonConfig.backgroundColor = __WEBPACK_IMPORTED_MODULE_10_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON;
            questionModalConfig.buttonWidth = 300;
            questionModalConfig.buttonConfig.smartSize = true;
            var dialogs = [this.currentCareer.interviewDialog[0], this.currentCareer.interviewDialog[1]];
            var modalOptions = [
                { displayText: __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(dialogs[0].question), id: 1, object: dialogs[0] },
                { displayText: __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(dialogs[1].question), id: 2, object: dialogs[1] },
                { displayText: __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "exit"), id: 3 },
            ];
            var audio1 = this.sound.add(dialogs[0].question);
            audio1.play();
            var audio2 = this.sound.add(dialogs[1].question);
            audio2.play("", {
                delay: audio1.totalDuration
            });
            this.questionModal = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, modalOptions, questionModalConfig);
            // Over gamepad!
            this.questionModal.setDepth(1001);
            this.moveModalNextToPlayer(this.questionModal);
            this.questionModal.on('optionClicked', function (op) {
                if (op.id !== 3) {
                    _this.questionModal.setVisible(false);
                    // Ask question
                    var dialog = op.object;
                    var responseKey = _this.getCandidateResponse(candidate, dialog);
                    var response = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(responseKey);
                    // Create new modal on top with candidate's response added
                    var responseModalConfig = _this.modalConfig;
                    responseModalConfig.title = response;
                    var audio3 = _this.sound.add(responseKey);
                    audio3.play();
                    var modalOptions;
                    if (candidate.actualCareer == null) {
                        // Just have them move on
                        modalOptions = [
                            { displayText: __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "try"), id: 3 },
                        ];
                        responseModalConfig.buttonWidth = 300;
                    }
                    else {
                        modalOptions = [
                            { displayText: __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "follow"), id: 1 },
                            { displayText: __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate("common.back"), id: 2 },
                        ];
                        responseModalConfig.buttonWidth = 200;
                    }
                    _this.responseModal = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["a" /* PhaserModal */](_this, 0, 0, modalOptions, responseModalConfig);
                    // Over gamepad!
                    _this.responseModal.setDepth(1001);
                    _this.moveModalNextToPlayer(_this.responseModal);
                    _this.responseModal.on('optionClicked', function (op) {
                        _this.responseModal.destroy();
                        _this.questionModal.setVisible(true);
                        if (op.id === 1) {
                            // Now they will start following player
                            _this.currentCandidate = candidate;
                            _this.children.bringToTop(_this.currentCandidate.object);
                            _this.children.bringToTop(_this.player);
                            _this.questionModal.destroy();
                        }
                        else if (op.id === 3) {
                            _this.questionModal.destroy();
                            _this.responseModal.destroy();
                        }
                    });
                }
                else {
                    // Exit button
                    _this.questionModal.destroy();
                }
            });
        }
    };
    MainScene.prototype.getCandidateResponse = function (candidate, dialog) {
        var response;
        // Not a candidate, just a filler person
        if (candidate.actualCareer == null) {
            response = this.getCandidateResponseText(dialog, null);
        }
        else {
            if (candidate.actualCareer.title === this.currentCareer.title) {
                // Answer positively, they are the correct candidate
                response = this.getCandidateResponseText(dialog, true);
            }
            else {
                // Try to trick the player by making them answer positively first, then negatively
                if (candidate.tryToTrickPlayer) {
                    response = this.getCandidateResponseText(dialog, true);
                    candidate.tryToTrickPlayer = false;
                }
                else {
                    response = this.getCandidateResponseText(dialog, false);
                }
            }
        }
        return response;
    };
    MainScene.prototype.getCandidateResponseText = function (dialog, value) {
        var response = dialog.responses.find(function (r) {
            return r.isCorrect === value;
        });
        return response.text;
    };
    /**
     * Checks if the current candidate is a match for the current booth/career, shows feedback
     */
    MainScene.prototype.checkCandidate = function () {
        var _this = this;
        if (!this.isModalOnScreen() && this.currentCandidate != null) {
            this.stopMovement = true;
            var candidate = this.candidates.find(function (c) {
                return c.object === _this.currentCandidate.object;
            });
            this.currentBooth.candidateEnabled = false;
            var modalConfig = this.modalConfig;
            if (this.isCorrectCandidate(candidate)) {
                var audio = this.sound.add(this.translateString + "correctCandidate");
                audio.play();
                // Put player on the ground and disable them
                this.player.y = this.currentBooth.object.getBottomLeft().y - this.player.displayHeight / 2;
                this.player.anims.play('turn');
                this.player.disableBody();
                this.putCandidateInBooth();
                candidate.assignedCareer = this.currentCareer;
                modalConfig.title = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "correctCandidate");
                this.correctCandidateModal = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, [{ displayText: __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate("common.ok"), id: 1 }], modalConfig);
                // Over gamepad!
                this.correctCandidateModal.setDepth(1001);
                this.correctCandidateModal.setPosition(this.cameras.main.width / 2 - this.correctCandidateModal.width / 2, this.cameras.main.height / 2 - this.correctCandidateModal.height / 2);
                this.correctCandidateModal.on('optionClicked', function () {
                    _this.correctCandidateModal.destroy();
                    _this.player.enableBody(false, _this.player.x, _this.player.y, true, true);
                    _this.stopMovement = false;
                });
            }
            else {
                var audio = this.sound.add(this.translateString + "incorrectCandidate");
                audio.play();
                // Put candidate on the ground and disable them
                this.currentCandidate.object.y = this.currentBooth.object.getBottomLeft().y - this.currentCandidate.object.displayHeight / 2;
                this.currentCandidate.object.anims.play('turn');
                this.currentCandidate.object.disableBody();
                modalConfig.title = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "incorrectCandidate");
                var incorrectCandidateModal = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, [{ displayText: __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate("common.ok"), id: 1 }], modalConfig);
                incorrectCandidateModal.setPosition(this.cameras.main.width / 2 - incorrectCandidateModal.width / 2, this.cameras.main.height / 2 - incorrectCandidateModal.height / 2);
                // Over gamepad!
                incorrectCandidateModal.setDepth(1001);
                incorrectCandidateModal.on('optionClicked', function () {
                    _this.currentCandidate = null;
                    incorrectCandidateModal.destroy();
                    _this.stopMovement = false;
                    // "Teleport" the candidate back to it's original position
                    _this.tweens.add({
                        targets: candidate.object,
                        duration: 1000,
                        ease: "Power2",
                        alpha: {
                            getStart: function () { return 1; },
                            getEnd: function () { return 0; }
                        },
                        onComplete: function () {
                            var originalPosition = candidate.object.getData('position');
                            // Put them back where they started
                            candidate.object.setPosition(originalPosition.x, originalPosition.y);
                            _this.tweens.add({
                                targets: candidate.object,
                                duration: 1000,
                                ease: "Power2",
                                alpha: {
                                    getStart: function () { return 0; },
                                    getEnd: function () { return 1; }
                                },
                                onStart: function () {
                                    candidate.object.enableBody(false, originalPosition.x, originalPosition.y, true, true);
                                }
                            });
                        }
                    });
                });
            }
        }
    };
    /**
     * Put candidate in center of booth and disable them from leaving
     */
    MainScene.prototype.putCandidateInBooth = function () {
        var _this = this;
        var rightSideOfBooth = this.currentBooth.object.getBottomRight().x + 5;
        var boothFloor = this.currentBooth.object.getBottomLeft().y - this.currentCandidate.object.displayHeight / 2;
        this.add.tween({
            targets: this.currentCandidate.object,
            x: rightSideOfBooth,
            y: boothFloor,
            ease: Phaser.Math.Easing.Circular,
            onStart: function () {
                // Disable the candidate so they can't jump out of box before the tween starts
                _this.currentCandidate.object.disableBody();
            },
            onComplete: function () {
                // Set current career to null so they know they need to go back to a booth
                _this.currentCandidate.object.setVelocityX(0);
                _this.currentCandidate.object.anims.play('turn');
                _this.currentCandidate.enabled = false;
                _this.currentCareer = null;
                _this.currentCandidate = null;
                _this.currentBooth.isComplete = true;
                _this.stopMovement = false;
            }
        });
    };
    /**
     * Astronaut is the end trigger. Checks if the game is over or not, let's player move on
     * */
    MainScene.prototype.talkToAstronaut = function () {
        var _this = this;
        this.astronaut.setData('enabled', false);
        if (!this.isModalOnScreen()) {
            var x, y;
            x = this.gameWidth - 200;
            y = this.astronaut.y - 20;
            var text, buttonText, text1, text2, id;
            id = 0;
            var modalConfig = this.modalConfig;
            if (this.isGameOver()) {
                text = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.doneText");
                buttonText = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate("common.done");
                id = 0;
            }
            else {
                // Find out how many booths need employees
                var numNotAssigned = 0;
                this.booths.forEach(function (c) {
                    if (!c.isComplete) {
                        numNotAssigned++;
                    }
                });
                if (numNotAssigned === 1) {
                    text1 = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.keepGoing1_singular");
                    text2 = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.keepGoing2_singular");
                }
                else {
                    text1 = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.keepGoing1_plural");
                    text2 = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "astronaut.keepGoing2_plural");
                }
                text = text1 + numNotAssigned + text2;
                buttonText = __WEBPACK_IMPORTED_MODULE_8_src_utils_TranslateHelper__["a" /* default */].translate("common.ok");
                x = this.gameWidth - 350;
                id = 1;
            }
            modalConfig.buttonWidth = 150;
            modalConfig.buttonConfig.smartSize = true;
            modalConfig.title = text || null;
            this.astronautModal = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["a" /* PhaserModal */](this, x, y, [{ displayText: buttonText, id: id }], modalConfig);
            this.moveModalNextToPlayer(this.astronautModal);
            // Over gamepad!
            this.astronautModal.setDepth(1001);
            this.astronautModal.on('optionClicked', function (op) {
                _this.astronautModal.destroy();
                if (op.id === 0) {
                    _this.player.disableBody();
                    _this.input.setDefaultCursor("default");
                    _this.input.removeAllListeners();
                    _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_11_src_games_CareerFairGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
                    _this.scene.remove(_this);
                }
            });
        }
    };
    /**
     * Handles user input
     * */
    MainScene.prototype.update = function () {
        this.updatePlayerMovement();
        if (this.currentCandidate != null) {
            this.updateNPC();
        }
        this.checkIfCandidateIsInBooth();
        this.checkIfPlayerIsInBooth();
        this.checkIfPlayerIsNextToAstronaut();
        this.closeAbandonedModals();
    };
    MainScene.prototype.checkIfPlayerIsNextToAstronaut = function () {
        var area = this.astronaut.getBounds();
        var rect = new Phaser.Geom.Rectangle(area.x, area.y, 50, 50);
        rect.centerX = this.astronaut.getCenter().x;
        rect.centerY = this.astronaut.getCenter().y;
        if (Phaser.Geom.Intersects.RectangleToRectangle(rect, this.player.getBounds()) && this.astronaut.getData('enabled')) {
            this.talkToAstronaut();
        }
        if (!Phaser.Geom.Intersects.RectangleToRectangle(rect, this.player.getBounds()) && !this.astronaut.getData('enabled')) {
            // Once they leave the astronaut, set it as enabled again so they can keep checking the game state/end the game
            this.astronaut.setData('enabled', true);
            if (this.isModalOnScreen()) {
                this.astronautModal.destroy();
                this.sound.stopAll();
            }
        }
    };
    MainScene.prototype.closeAbandonedModals = function () {
        var _this = this;
        var closeModal = true;
        this.candidates.forEach(function (c) {
            var rect = c.object.getBounds();
            rect.width = 100;
            rect.height = 100;
            rect.centerX = c.object.getCenter().x;
            rect.centerY = c.object.getCenter().y;
            if (Phaser.Geom.Intersects.RectangleToRectangle(rect, _this.player.getBounds())) {
                closeModal = false;
            }
        });
        if (this.boothModal != null) {
            return;
        }
        if (this.isModalOnScreen() && closeModal && this.questionModal != null) {
            this.questionModal.destroy();
            this.questionModal = null;
            this.sound.stopAll();
        }
        if (this.isModalOnScreen() && closeModal && this.responseModal != null) {
            this.responseModal.destroy();
            this.responseModal = null;
            this.sound.stopAll();
        }
    };
    /**
     * If the current candidate is inside the current booth (the player chose them and now we need to check if they were correct or not)
     */
    MainScene.prototype.checkIfCandidateIsInBooth = function () {
        if (this.currentBooth != null && this.currentCandidate != null) {
            if (this.currentBooth.object.getBounds().contains(this.currentCandidate.object.x, this.currentCandidate.object.y) && this.currentBooth.candidateEnabled) {
                this.checkCandidate();
            }
            if (!this.currentBooth.object.getBounds().contains(this.currentCandidate.object.x, this.currentCandidate.object.y) && !this.currentBooth.candidateEnabled) {
                this.currentBooth.candidateEnabled = true;
            }
        }
    };
    /**
     * If player is in booth then call inside booth, otherwise enable the booth so that next time they're in it the modal will pop up again
     */
    MainScene.prototype.checkIfPlayerIsInBooth = function () {
        for (var _i = 0, _a = this.booths; _i < _a.length; _i++) {
            var booth = _a[_i];
            if ((Phaser.Geom.Intersects.RectangleToRectangle(booth.object.getBounds(), this.player.getBounds()) && booth.playerEnabled)) {
                this.insideBooth(booth.object);
            }
            if (!Phaser.Geom.Intersects.RectangleToRectangle(booth.object.getBounds(), this.player.getBounds()) && !booth.playerEnabled) {
                // Once they leave the booth, set it as enabled again
                booth.playerEnabled = true;
                if (this.isModalOnScreen()) {
                    this.boothModal.destroy();
                    this.boothModal = null;
                    this.sound.stopAll();
                }
            }
        }
    };
    MainScene.prototype.updateNPC = function () {
        if (this.currentCandidate != null && this.currentCandidate.object.body.enable) {
            if (this.player.body.velocity.x < 0) {
                this.currentCandidate.object.anims.play('left', true);
                this.physics.moveTo(this.currentCandidate.object, this.player.x + 32, this.player.y, this.WALKING_VELOCITY);
            }
            else if (this.player.body.velocity.x > 0) {
                this.currentCandidate.object.anims.play('right', true);
                this.physics.moveTo(this.currentCandidate.object, this.player.x - 32, this.player.y, this.WALKING_VELOCITY);
            }
            else {
                this.currentCandidate.object.anims.play('turn', true);
            }
            this.currentCandidate.object.y = this.player.y;
        }
    };
    MainScene.prototype.isGameOver = function () {
        for (var _i = 0, _a = this.candidates; _i < _a.length; _i++) {
            var c = _a[_i];
            if (c.actualCareer != null && c.assignedCareer == null) {
                return false;
            }
            else if (c.actualCareer != null && c.assignedCareer != null) {
                if (c.actualCareer.title !== c.assignedCareer.title) {
                    return false;
                }
            }
        }
        return true;
    };
    /**
     * Moves the modal either to the left or right of the player, while ensuring it doesn't run off the screen
     */
    MainScene.prototype.moveModalNextToPlayer = function (modal) {
        var x, y;
        var padding = 30;
        var actualCandidateX = this.player.getBottomRight().x - this.cameras.main.scrollX;
        x = actualCandidateX;
        y = this.gameHeight / 2 - modal.height / 2;
        // Running off the right side of the screen, so put the modal on the left of the npc
        if (actualCandidateX + modal.width + padding > (this.gameWidth - padding)) {
            var maxX = this.gameWidth - modal.width - padding;
            x = Math.min(maxX, this.player.getBottomLeft().x - this.cameras.main.scrollX - modal.width);
        }
        modal.setPosition(x, y);
    };
    /**
     * Checks if there is already a modal open on screen (we don't want to be able to add more than one modal to a scene)
     */
    MainScene.prototype.isModalOnScreen = function () {
        for (var _i = 0, _a = this.children.list; _i < _a.length; _i++) {
            var c = _a[_i];
            if (c.type === "PhaserModal") {
                return true;
            }
        }
        return false;
    };
    /**
     * Check if they assigned the candidate correctly
     * */
    MainScene.prototype.isCorrectCandidate = function (candidate) {
        if (candidate.actualCareer.title === this.currentCareer.title) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
    * Shuffle the candidates so they're not in the same order every time
    * https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
    */
    MainScene.prototype.scrambleArray = function (array) {
        var j, x, i;
        for (i = array.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = array[i];
            array[i] = array[j];
            array[j] = x;
        }
        return array;
    };
    /**
      * GamePad/Player Movement
      * EVENT BASED FOR JUMPING, UPDATE BASED FOR LEFT/RIGHT
      */
    MainScene.prototype.createGamePad = function () {
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_7_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.gamePad.on("keydown_up", this.playerJump);
        this.gamePad.on("keydown_a", this.playerJump);
        this.gamePad.on("keydown_b", this.bDown);
    };
    MainScene.prototype.bDown = function () {
        var _this = this;
        this.candidates.forEach(function (c) {
            // If you're close enough, talk to nearest character
            if ((Math.abs(c.object.x - _this.player.x) / 32 < 2) && (Math.abs(c.object.y - _this.player.y) / 32 < 2)) {
                _this.talkToCandidate(c);
            }
        });
        // If you're close enough, talk to astronaut
        if ((Math.abs(this.astronaut.x - this.player.x) / 32 < 2) && (Math.abs(this.astronaut.y - this.player.y) / 32 < 2)) {
            this.talkToAstronaut();
        }
        if (this.boothModal && this.boothModal.active) {
            this.boothModal.selectLastOption();
        }
        if (this.correctCandidateModal && this.correctCandidateModal.active) {
            this.correctCandidateModal.selectLastOption();
        }
    };
    MainScene.prototype.playerJump = function () {
        if (!this.stopMovement && this.player.body.enable) {
            if (this.player.body.onFloor()) {
                this.player.body.setVelocityY(-this.JUMPING_VELOCITY);
            }
            else if (this.doubleJump) {
                this.doubleJump = false;
                this.player.body.setVelocityY(-this.JUMPING_VELOCITY);
            }
        }
    };
    MainScene.prototype.moveLeft = function () {
        if (!this.stopMovement && this.player.body.enable) {
            this.xVel += -this.WALKING_VELOCITY;
            this.player.anims.play('left', true);
        }
        if (this.currentCandidate != null && this.currentCandidate.object.body.enable) {
            this.currentCandidate.object.setPosition(this.player.x + 32, this.player.y);
        }
    };
    MainScene.prototype.moveRight = function () {
        if (!this.stopMovement && this.player.body.enable) {
            this.xVel += this.WALKING_VELOCITY;
            this.player.anims.play('right', true);
        }
        if (this.currentCandidate != null && this.currentCandidate.object.body.enable) {
            this.currentCandidate.object.setPosition(this.player.x - 32, this.player.y);
        }
    };
    MainScene.prototype.updatePlayerMovement = function () {
        this.xVel = 0;
        if (this.gamePad.keys.left.isDown) {
            this.moveLeft();
        }
        if (this.gamePad.keys.right.isDown) {
            this.moveRight();
        }
        this.player.setVelocityX(this.xVel);
        if (this.xVel === 0) {
            this.player.anims.play('turn');
            if (this.currentCandidate != null && this.currentCandidate.object.body.enable) {
                if (this.player.x > this.currentCandidate.object.x) {
                    // NPC is on the left of the player
                    this.currentCandidate.object.setPosition(this.player.x - 32, this.player.y);
                }
                else {
                    // NPC is on the right of the player
                    this.currentCandidate.object.setPosition(this.player.x + 32, this.player.y);
                }
            }
        }
        if (this.frameCount % 4 === 0) {
            if (this.player.body.onFloor()) {
                this.doubleJump = true;
            }
        }
        if (this.frameCount > 64000) {
            this.frameCount = 0;
        }
        this.frameCount++;
    };
    MainScene.prototype.getActiveModal = function () {
        var modal;
        if (this.questionModal && this.questionModal.active) {
            modal = this.questionModal;
        }
        if (this.responseModal && this.responseModal.active) {
            modal = this.responseModal;
        }
        if (this.astronautModal && this.astronautModal.active) {
            modal = this.astronautModal;
        }
        if (this.correctCandidateModal && this.correctCandidateModal.active) {
            modal = this.correctCandidateModal;
        }
        return modal;
    };
    MainScene.prototype.selectModalOption = function (modal, index) {
        if (!modal) {
            return;
        }
        if (index < 0) {
            modal.selectLastOption();
        }
        else {
            modal.selectOption(index);
        }
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Candidate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Career__ = __webpack_require__(898);

var Candidate = /** @class */ (function () {
    function Candidate(actualCareer, tryToTrickPlayer) {
        this.actualCareer = actualCareer;
        this.assignedCareer = null;
        this.object = null;
        this.tryToTrickPlayer = tryToTrickPlayer;
        this.enabled = true;
    }
    Candidate.CANDIDATES = [
        new Candidate(__WEBPACK_IMPORTED_MODULE_0__Career__["a" /* Career */].CAREERS[0], true),
        new Candidate(__WEBPACK_IMPORTED_MODULE_0__Career__["a" /* Career */].CAREERS[1], false),
        new Candidate(__WEBPACK_IMPORTED_MODULE_0__Career__["a" /* Career */].CAREERS[2], true),
        new Candidate(__WEBPACK_IMPORTED_MODULE_0__Career__["a" /* Career */].CAREERS[3], false),
        new Candidate(null, false),
        new Candidate(null, false),
        new Candidate(null, false),
        new Candidate(null, false),
        new Candidate(null, false),
        new Candidate(null, false),
    ];
    return Candidate;
}());



/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Booth; });
var Booth = /** @class */ (function () {
    function Booth(object, career) {
        this.object = object;
        this.career = career;
        this.isComplete = false;
        this.playerEnabled = true;
        this.candidateEnabled = true;
    }
    return Booth;
}());



/***/ }),
/* 2337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "e";
        _this.gameClosingTextKey = "CareerFair.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.crossOrigin = "anonymous";
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4__constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/blocks.87c4a31e.png";

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/career_fair_bg.2ceb3dc5.jpg";

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/career_fair.91546c8d.json";

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameCareerFair.96dfa825.png";

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameCareerFair.019fced6.json";

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DeskScene__ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_GameState__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Utilities__ = __webpack_require__(906);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].OrganizeDesk;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__DeskScene__["a" /* DeskScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "OrganizeDesk.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "OrganizeDesk.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "OrganizeDesk.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    HowToPlayScene.prototype.create = function () {
        _super.prototype.create.call(this);
        /** JB: Note
         * Required because this game was made before we really standardized the process.
         * This properly loads the gamestate, starting at desk 1 when moving to the next scene
         */
        // Game config for the first desk
        var deskOrder = __WEBPACK_IMPORTED_MODULE_5__objects_Utilities__["a" /* Utilities */].getRandomDeskOrder();
        var firstDesk = deskOrder.pop();
        var deskSupplies = __WEBPACK_IMPORTED_MODULE_5__objects_Utilities__["a" /* Utilities */].initializeDeskSupplies();
        var deskGarbageItems = __WEBPACK_IMPORTED_MODULE_5__objects_Utilities__["a" /* Utilities */].initializeGarbageItems();
        var config = {
            deskOrder: deskOrder,
            mapKey: "desk_" + firstDesk,
            deskSupplies: deskSupplies,
            deskGarbageItems: deskGarbageItems,
            spill: true,
        };
        __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current = new __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */](config);
    };
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeskScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_dropzone_DropZone__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_dropzone_DropZoneSprite__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_GameState__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_DeskItem__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Utilities__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_games_OrganizeDeskGame_scenes_EndGameScene__ = __webpack_require__(2346);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












var DeskScene = /** @class */ (function (_super) {
    __extends(DeskScene, _super);
    function DeskScene() {
        var _this = _super.call(this, {
            key: "DeskScene" + Math.random()
        }) || this;
        _this.translateString = "OrganizeDesk.Phaser.DeskScene.";
        return _this;
    }
    DeskScene.prototype.preload = function () {
        this.load.atlas("assets", __webpack_require__(2347), __webpack_require__(2348));
        this.load.image('background', __webpack_require__(2349));
        // Load different desk layouts and their corresponding finished layout pictures
        this.load.tilemapTiledJSON('desk_5', __webpack_require__(2350));
        this.load.tilemapTiledJSON('desk_6', __webpack_require__(2351));
        this.load.tilemapTiledJSON('desk_3', __webpack_require__(2352));
        this.load.tilemapTiledJSON('desk_4', __webpack_require__(2353));
        this.load.tilemapTiledJSON('desk_2', __webpack_require__(2354));
        this.load.tilemapTiledJSON('desk_1', __webpack_require__(2355));
    };
    DeskScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, DeskScene.prototype);
        this.initialize();
        this.generateScene();
        this.generateEvents();
        Object(__WEBPACK_IMPORTED_MODULE_3_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    DeskScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.mapKey });
        this.objectLayer = this.map.getObjectLayer('Object Layer');
        this.dropZoneLayer = this.map.getObjectLayer('DropZone Layer');
        this.dropZones = [];
        this.allDeskItems = [];
        this.itemID = 0;
        this.garbageItems = [];
    };
    DeskScene.prototype.generateEvents = function () {
        var _this = this;
        this.input.on('dragstart', function (pointer, gameObject) {
            if (_this.tweens.isTweening(gameObject)) {
                _this.tweens.killTweensOf(gameObject);
            }
            gameObject.x = pointer.downX;
            gameObject.y = pointer.downY;
            gameObject.setAngle();
            _this.children.bringToTop(gameObject);
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = pointer.x;
            gameObject.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, gameObject, dropped) {
            // Move dropped object back to start if not dropped onto a dropzone
            if (!dropped) {
                _this.putItemBack(gameObject);
            }
        });
    };
    DeskScene.prototype.generateScene = function () {
        var _this = this;
        var background = this.add.image(0, 0, "background");
        background.setOrigin(0);
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        var textStyle = { fontSize: 20, color: "#ffffff", fontFamily: "Russo One, Arial" };
        var finishedLabel = this.add.text(100, 150, __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "desired"), textStyle);
        finishedLabel.setX(this.gameWidth / 2 - finishedLabel.width / 2 + 20);
        var starPilot = this.add.image(-50, 375, "pilots", "c");
        starPilot.setOrigin(0);
        starPilot.setDisplaySize(300, 500);
        var deskNumber = this.add.text(0, 30, __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "desk") + " " + __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.deskNumber, { fontSize: 30, color: "#000000", fontFamily: "Russo One, Arial" });
        this.addObjects();
        this.addDropZones();
        if (__WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.spill) {
            this.addSpill();
        }
        this.addFinishedDeskLayout();
        var config = new __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.backgroundColor = __WEBPACK_IMPORTED_MODULE_10_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        config.smartHeight = true;
        var text = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "check");
        var button = new __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__["a" /* PhaserButton */](this, this.gameWidth - 200, 80, 150, 50, text, config);
        button.on('buttonClicked', function () {
            if (button.isEnabled()) {
                button.setEnabled(false);
                _this.checkDeskButtonHandler(button);
            }
        });
        var hintButtonText = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "hint");
        config.backgroundColor = __WEBPACK_IMPORTED_MODULE_10_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON;
        button = new __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__["a" /* PhaserButton */](this, this.gameWidth - 200, 160, 150, 50, hintButtonText, config);
        button.on('buttonClicked', function () {
            _this.giveHint();
        });
        deskNumber.setX(this.gameWidth - deskNumber.width - 75);
    };
    DeskScene.prototype.putItemBack = function (gameObject) {
        var actualItem = __WEBPACK_IMPORTED_MODULE_7__objects_DeskItem__["a" /* DeskItem */].ALL_ITEMS.concat(__WEBPACK_IMPORTED_MODULE_7__objects_DeskItem__["a" /* DeskItem */].CLEANING_ITEM).find(function (i) {
            return i.name === gameObject.name;
        });
        // If it was dropped on the pile
        // it's a normal desk item
        // it started on the cart and wasn't accepted
        // Put it back in the pile and reset it
        if (Phaser.Geom.Intersects.RectangleToRectangle(this.cart, gameObject.getBounds()) &&
            this.isNormalDeskItem(gameObject) ||
            this.cart.contains(gameObject.input.dragStartX, gameObject.input.dragStartY)) {
            gameObject.x = actualItem.startX;
            gameObject.y = actualItem.startY;
            gameObject.setAngle(actualItem.angle);
        }
        else {
            // Reset item
            gameObject.x = gameObject.input.dragStartX;
            gameObject.y = gameObject.input.dragStartY;
            if (gameObject.type === "deskItem" || gameObject.name === "sponge") {
                gameObject.setAngle(gameObject.getData('startAngle'));
            }
        }
        this.children.bringToTop(gameObject);
    };
    DeskScene.prototype.isNormalDeskItem = function (gameObject) {
        return (gameObject.name !== "sponge" && gameObject.name !== "paper_wad" && gameObject.name !== "plane");
    };
    DeskScene.prototype.addFinishedDeskLayout = function () {
        var _this = this;
        this.map.getObjectLayer("Finished").objects.forEach(function (ob) {
            var item = __WEBPACK_IMPORTED_MODULE_7__objects_DeskItem__["a" /* DeskItem */].ALL_ITEMS.find(function (i) {
                return i.name === ob.name;
            });
            var deskItem = _this.add.image(ob.x, ob.y, "assets", item.name);
            deskItem.setOrigin(0);
            deskItem.setDisplaySize(item.display_width * 0.75, item.display_height * 0.75);
        });
    };
    DeskScene.prototype.addObjects = function () {
        var _this = this;
        console.warn("this.objectLayer", this.objectLayer); // JB - Remove this console.warn
        this.objectLayer.objects.forEach(function (ob) {
            if (ob.name === "deskTop") {
                _this.deskTop = _this.add.image(ob.x, ob.y, "pixel");
                _this.deskTop.setOrigin(0);
                _this.deskTop.setDisplaySize(ob.width, ob.height);
                _this.deskTop.setVisible(false);
            }
            else if (ob.name === "cart") {
                _this.cart = new Phaser.Geom.Rectangle(ob.x, ob.y, ob.width, ob.height);
            }
        });
        this.createDeskItems();
    };
    DeskScene.prototype.addDropZones = function () {
        var _this = this;
        this.dropZoneLayer.objects.forEach(function (ob) {
            var x = ob.x + ob.width / 2;
            var y = ob.y + ob.height / 2;
            if (ob.type === "deskItem") {
                _this.createCartItem(ob);
            }
            else {
                if (ob.type === "cleaningItem") {
                    _this.createCleaningItem(ob);
                }
                var config = {
                    height: ob.height,
                    width: ob.width,
                    square: ob.properties.square,
                    backgroundTexture: ob.properties.asset,
                    backgroundFrame: "",
                    ellipse: ob.properties.ellipse,
                    lineColor: null,
                    dragLineColor: 0x00000,
                    allowStacking: ob.properties.allowStacking,
                    allowRedrop: ob.properties.allowRedrop,
                    allowResize: false,
                    allowSnapToCenter: ob.properties.allowSnapToCenter,
                    allowDropzoneDisappear: false,
                    acceptedKeys: (ob.properties.acceptedKeys || "").split(','),
                };
                var dropZone = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_dropzone_DropZone__["a" /* DropZone */](_this, x, y, config);
                dropZone.type = ob.type;
                dropZone.name = ob.name;
                dropZone.angle = ob.rotation;
                dropZone.on('drop', function (dropzone, gameObject, accepted) {
                    var item;
                    if (accepted) {
                        item = _this.allDeskItems.find(function (i) {
                            return i.getData('id') === gameObject.getData('id');
                        });
                        item.setData('dropped', true);
                        // Accepted items thrown in trash just disappear
                        if (dropzone.name === "trash") {
                            gameObject.setVisible(false);
                        }
                    }
                    else {
                        _this.putItemBack(gameObject);
                    }
                });
                _this.dropZones.push(dropZone);
            }
        });
    };
    /**
     * Adds a random "spill" to the desk.
     * Initialized as not "cleaned"
     */
    DeskScene.prototype.addSpill = function () {
        var spillColors = [0x68f442, 0x381696, 0xe03d18, 0x9820aa];
        var minX = this.deskTop.getBottomLeft().x - 10;
        var minY = this.deskTop.getTopLeft().y - 10;
        var maxX = this.deskTop.getBottomRight().x - 10;
        var maxY = this.deskTop.getBottomLeft().y - 10;
        var mess = __WEBPACK_IMPORTED_MODULE_7__objects_DeskItem__["a" /* DeskItem */].SPILL;
        var point = __WEBPACK_IMPORTED_MODULE_8__objects_Utilities__["a" /* Utilities */].getRandomPoint(minX + mess.display_width / 4, maxX - mess.display_width / 4, minY + mess.display_height / 4, maxY - mess.display_height / 4);
        this.spill = this.add.image(point.x, point.y, "assets", "spill");
        this.spill.setTint(spillColors[__WEBPACK_IMPORTED_MODULE_8__objects_Utilities__["a" /* Utilities */].getRandomArrayIndex(spillColors.length)]);
        this.spill.setDisplaySize(mess.display_width, mess.display_height);
        this.spill.setInteractive();
        this.spill.setDepth(5);
        this.spill.setDataEnabled();
        this.spill.setData("cleaned", false);
        this.spill.setName(mess.name);
    };
    /**
     * Creates desk items (including garbage) which are spread across the desk randomly
     */
    DeskScene.prototype.createDeskItems = function () {
        var _this = this;
        var minX = this.deskTop.getBottomLeft().x - 10;
        var minY = this.deskTop.getTopLeft().y - 10;
        var maxX = this.deskTop.getBottomRight().x - 10;
        var maxY = this.deskTop.getBottomLeft().y - 10;
        __WEBPACK_IMPORTED_MODULE_7__objects_DeskItem__["a" /* DeskItem */].ALL_ITEMS.forEach(function (item) {
            for (var i = 0; i < item.quantity; i++) {
                var point = __WEBPACK_IMPORTED_MODULE_8__objects_Utilities__["a" /* Utilities */].getRandomPoint(minX + item.display_width / 4, maxX - item.display_width / 4, minY + item.display_height / 4, maxY - item.display_height / 4);
                var deskItem = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_dropzone_DropZoneSprite__["a" /* default */](_this, item.name, point.x, point.y, "assets", item.name);
                deskItem.setDisplaySize(item.display_width, item.display_height);
                deskItem.setInteractive();
                deskItem.setName(item.name);
                deskItem.type = "deskItem";
                deskItem.setAngle(Math.random() * (100) + 5);
                deskItem.setDepth(10);
                deskItem.setData('id', _this.itemID++);
                deskItem.setData('startAngle', deskItem.angle);
                _this.input.setDraggable(deskItem);
                if (item.id === 5 || item.id === 6) {
                    _this.garbageItems.push(deskItem);
                }
                _this.allDeskItems.push(deskItem);
            }
        });
    };
    /**
     * Creates an item on the cart that can be put on the desk (school supplies)
     */
    DeskScene.prototype.createCartItem = function (ob) {
        var item = __WEBPACK_IMPORTED_MODULE_7__objects_DeskItem__["a" /* DeskItem */].SUPPLIES.find(function (i) {
            return i.name === ob.name;
        });
        for (var i = 0; i < 5; i++) {
            var cartItem = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_dropzone_DropZoneSprite__["a" /* default */](this, item.name, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", item.name);
            item.startX = cartItem.x;
            item.startY = cartItem.y;
            cartItem.setDisplaySize(item.display_width, item.display_height);
            cartItem.setInteractive();
            cartItem.setDepth(10);
            cartItem.setAngle(item.angle);
            cartItem.setName(item.name);
            cartItem.type = "cartItem";
            cartItem.setDataEnabled();
            cartItem.setData('id', this.itemID++);
            cartItem.setData('startAngle', cartItem.angle);
            this.input.setDraggable(cartItem);
            this.allDeskItems.push(cartItem);
        }
    };
    /**
     * Creates a cleaning item (sponge or rag) that can be used to clean the spill
     */
    DeskScene.prototype.createCleaningItem = function (ob) {
        var item = __WEBPACK_IMPORTED_MODULE_7__objects_DeskItem__["a" /* DeskItem */].CLEANING_ITEM;
        this.sponge = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_dropzone_DropZoneSprite__["a" /* default */](this, item.name, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", item.name);
        item.startX = this.sponge.x;
        item.startY = this.sponge.y;
        this.sponge.setDisplaySize(item.display_width, item.display_height);
        this.sponge.setInteractive();
        this.sponge.setDepth(10);
        this.sponge.setAngle(ob.rotation);
        this.sponge.setTint(0xe5d824);
        this.sponge.setName(item.name);
        this.sponge.type = "cleaningItem";
        this.sponge.setData('id', this.itemID++);
        this.sponge.setData('startAngle', this.sponge.angle);
        this.input.setDraggable(this.sponge);
        this.allDeskItems.push(this.sponge);
    };
    /**
     * Checks to see if the desk is organized/cleaned:
     * --All necessary desk supplies are on desk
     * --All garbage has been put in the trash
     * --No unnecessary items on the desk top
     * --If there is a spill, it's cleaned
     */
    DeskScene.prototype.isDeskOrganized = function () {
        // First, check that each dropzone has one item dropped in it and the trash has all garbage in it
        for (var _i = 0, _a = this.dropZones; _i < _a.length; _i++) {
            var dz = _a[_i];
            if (dz.type === "DropZone" && dz.name !== "cart") {
                // A drop zone doesn't have an item dropped in it
                if (dz.children.length !== 1) {
                    return false;
                }
            }
            else if (dz.type === "TrashDropZone") {
                var numberOfItemsDropped = dz.children.length;
                // The trash drop zone doesn't contain all garbage items
                if (numberOfItemsDropped < __WEBPACK_IMPORTED_MODULE_8__objects_Utilities__["a" /* Utilities */].getNumberOfItems(__WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.deskGarbageItems)) {
                    return false;
                }
            }
        }
        // If that passes, check now if there are unnecessary items on the desk
        if (__WEBPACK_IMPORTED_MODULE_8__objects_Utilities__["a" /* Utilities */].checkIfExtraItemsOnDesk(this.deskTop, this.allDeskItems)) {
            return false;
        }
        // Check if the spill is cleaned
        if (__WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.spill && !this.spill.getData('cleaned')) {
            return false;
        }
        // If all of that passes, the desk is organized
        return true;
    };
    /**
     * Checks if the desk is cleaned/organized properly.
     * Will either allow the player to move on or tell the player to keep organizing.
     */
    DeskScene.prototype.checkDeskButtonHandler = function (button) {
        var _this = this;
        var modalConfig;
        var modalOptions;
        var modal;
        modalConfig = __WEBPACK_IMPORTED_MODULE_8__objects_Utilities__["a" /* Utilities */].getModalConfig();
        if (this.isDeskOrganized()) {
            modalConfig.title = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "deskDone");
            if (__WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.deskNumber === __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].NUMBER_OF_DESKS) {
                // This was the last desk in the classroom, game is done
                modalOptions = [{ displayText: __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate("student.postgame.button"), id: 2 }];
            }
            else {
                modalOptions = [{ displayText: __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "nextDesk"), id: 1 }];
            }
            modal = new __WEBPACK_IMPORTED_MODULE_9_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, modalOptions, modalConfig);
            modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
            modal.setDepth(10);
            modal.on('optionClicked', function (op) {
                modal.destroy();
                if (op.id === 2) {
                    _this.input.removeAllListeners();
                    _this.input.setDefaultCursor("default");
                    _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_11_src_games_OrganizeDeskGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
                    _this.scene.remove(_this);
                }
                else {
                    // Initialize game state for the next DeskScene
                    __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.deskNumber = __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.deskNumber + 1;
                    __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.deskGarbageItems = __WEBPACK_IMPORTED_MODULE_8__objects_Utilities__["a" /* Utilities */].initializeGarbageItems();
                    __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.deskSupplies = __WEBPACK_IMPORTED_MODULE_8__objects_Utilities__["a" /* Utilities */].initializeDeskSupplies();
                    __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.mapKey = "desk_" + __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.deskOrder.pop();
                    __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.spill = Math.random() >= 0.5; // Randomly choose if there is a spill or not
                    // Stop the current scene and start a new one with the new game state
                    _this.scene.add("DeskScene", DeskScene, true);
                    _this.scene.remove(_this);
                }
            });
        }
        else {
            modalConfig.title = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "notDone");
            modalConfig.titleSize = 20;
            modalOptions = [{ displayText: __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate("common.ok"), id: 1 }];
            modal = new __WEBPACK_IMPORTED_MODULE_9_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, modalOptions, modalConfig);
            modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
            modal.setDepth(10);
            modal.on('optionClicked', function () {
                modal.destroy();
                button.setEnabled(true);
            });
        }
    };
    /**
     * Checks for stuff on the desk that student did incorrectly so we can give them a hint (draw their attention to) whatever they missed
     * First checks if any of the necessary items for the desk layout are empty (show the outlined dropzone)
     * Then checks if there is any visible garbage still on the desk (wiggle the garbage)
     * Then checks if there are any unneeded items on the desk (wiggle the item)
     * Finally, checks if the spill is still there (flash the spill, wiggle the sponge)
     */
    DeskScene.prototype.giveHint = function () {
        var dz;
        //  Outline any empty dropzones
        for (var _i = 0, _a = this.dropZones.filter(function (d) { return d.type === "DropZone"; }); _i < _a.length; _i++) {
            dz = _a[_i];
            if (dz.children.length === 0) {
                dz.graphics.lineStyle(2, __WEBPACK_IMPORTED_MODULE_10_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("grey"));
                dz.graphics.strokeRectShape(dz.getBounds());
                // Only show outline of dropzone for one second
                setTimeout(function () {
                    dz.graphics.clear();
                }, 1000);
                return;
            }
        }
        // Draw attention to any visible garbage
        for (var _b = 0, _c = this.garbageItems.filter(function (g) { return g.visible; }); _b < _c.length; _b++) {
            var garbage = _c[_b];
            this.drawAttentionTo(garbage);
            return;
        }
        // Draw attention to any stray items on the desk
        var deskTopBounds = this.deskTop.getBounds();
        var rect = new Phaser.Geom.Rectangle(this.deskTop.x, this.deskTop.y, deskTopBounds.width, deskTopBounds.height);
        for (var _d = 0, _e = this.allDeskItems.filter(function (x) { return !x.getData("dropped"); }); _d < _e.length; _d++) {
            var i = _e[_d];
            if (rect.contains(i.x, i.y) && !i.getData('dropped')) {
                this.drawAttentionTo(i);
                return;
            }
        }
        // Finally, flash the spill and sponge
        if (this.spill != null && !this.spill.getData('cleaned')) {
            this.flashObject(this.spill);
            this.drawAttentionTo(this.sponge);
        }
    };
    // Simple tween that slightly wiggles object
    DeskScene.prototype.drawAttentionTo = function (gameObject) {
        var _this = this;
        if (!this.tweens.isTweening(gameObject)) {
            this.tweens.add({
                targets: gameObject,
                onStart: function () {
                    _this.children.bringToTop(gameObject);
                },
                angle: {
                    value: "+=20",
                    duration: 300
                },
                yoyo: true,
                repeat: 2,
            });
        }
    };
    DeskScene.prototype.flashObject = function (target) {
        var _this = this;
        if (!this.tweens.isTweening(target)) {
            this.tweens.add({
                targets: target,
                onStart: function () {
                    _this.children.bringToTop(target);
                    target.alpha = 1;
                },
                alpha: {
                    value: 0.3,
                    duration: 500,
                },
                yoyo: true,
                repeat: 2,
            });
        }
    };
    DeskScene.prototype.update = function () {
        var _this = this;
        // Continuously check if the player is trying to clean up the spill
        if (this.spill) {
            if (!this.spill.getData("cleaned") && __WEBPACK_IMPORTED_MODULE_8__objects_Utilities__["a" /* Utilities */].isPlayerCleaningSpill(this.sponge, this.spill)) {
                // Make spill disappear
                this.tweens.add({
                    targets: this.spill,
                    alpha: { value: 0, duration: 800, ease: "Power1" },
                    onComplete: function () {
                        _this.spill.setData("cleaned", true);
                    }
                });
            }
        }
    };
    DeskScene.prototype.isGarbage = function (gameObject) {
        var item = __WEBPACK_IMPORTED_MODULE_7__objects_DeskItem__["a" /* DeskItem */].ALL_ITEMS.find(function (x) { return x.name === gameObject.name; });
        return item.id === 5 || item.id === 6;
    };
    return DeskScene;
}(Phaser.Scene));



/***/ }),
/* 2345 */
/***/ (function(module, exports) {



/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "c";
        _this.gameClosingTextKey = "OrganizeDesk.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(168));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameDeskCleanup.20361332.png";

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameDeskCleanup.411a6820.json";

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameCleanDesk.a91416b3.jpg";

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/organize_desk_game_desk_2.023d56ea.json";

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/organize_desk_game_desk_3.e06292ad.json";

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/organize_desk_game_desk_4.2e74cbde.json";

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/organize_desk_game_desk_5.5beba22f.json";

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/organize_desk_game_desk_6.031fb993.json";

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/organize_desk_game_desk_1.a0c92efa.json";

/***/ }),
/* 2356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InstructionScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainScene__ = __webpack_require__(2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_DiseasedTreesGame_objects_GameState__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IntroductionScene__ = __webpack_require__(909);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var InstructionScene = /** @class */ (function (_super) {
    __extends(InstructionScene, _super);
    function InstructionScene() {
        var _this = _super.call(this, {
            key: "LandscapeInstructions"
        }) || this;
        _this.translateString = "DiseasedTrees.Phaser.InstructionScene.";
        _this.gameScene = __WEBPACK_IMPORTED_MODULE_3__MainScene__["a" /* MainScene */];
        return _this;
    }
    InstructionScene.prototype.preload = function () {
        this.load.image("pixel", __webpack_require__(60));
        this.load.atlas("trees", __webpack_require__(911), __webpack_require__(912));
        this.load.image('terrain', __webpack_require__(367));
    };
    InstructionScene.prototype.create = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, InstructionScene.prototype);
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(0x6eb8e5, 0x6eb8e5, 0xffffff, 0xffffff); // Gradient sky!
        var terrain = this.add.image(0, 400, "terrain");
        terrain.setScale(0.8);
        terrain.setOrigin(0);
        this.addTrees();
        this.addInstruction();
        this.addButtons();
    };
    InstructionScene.prototype.addTrees = function () {
        var healthy = this.add.image(this.gameWidth / 3, this.gameHeight / 2 + 70, "trees", "tree-1");
        healthy.setDepth(1);
        var diseased = this.add.image(2 * this.gameWidth / 3, this.gameHeight / 2 + 40, "trees", "tree-1");
        diseased.setDepth(1).setTint(0xff8e51);
    };
    InstructionScene.prototype.addInstruction = function () {
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: 30, padding: 10 };
        var diseasedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "diseased");
        var diseasedTextOb = this.add.text(2 * this.gameWidth / 3, 230, diseasedText, textStyle).setDepth(3);
        diseasedTextOb.setBackgroundColor("#000000").setOrigin(.5);
        var diseasedBorder = this.add.image(diseasedTextOb.x, diseasedTextOb.y, "pixel").setDepth(1);
        diseasedBorder.setDisplaySize(diseasedTextOb.displayWidth + 10, diseasedTextOb.displayHeight + 10).setTint(0x00de0e).setOrigin(.5);
        var healthyText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "healthy");
        var healthyTextOb = this.add.text(this.gameWidth / 3, 230, healthyText, textStyle).setDepth(3);
        healthyTextOb.setBackgroundColor("#000000").setOrigin(.5);
        var healthyBorder = this.add.image(healthyTextOb.x, healthyTextOb.y, "pixel").setDepth(1);
        healthyBorder.setDisplaySize(healthyTextOb.displayWidth + 10, healthyTextOb.displayHeight + 10).setTint(0x00de0e).setOrigin(.5);
    };
    InstructionScene.prototype.addButtons = function () {
        var _this = this;
        var config = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.backgroundColor = __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON;
        config.smartSize = true;
        config.keyMapping = "keydown_RIGHT";
        var txt = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "go");
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, this.gameWidth - 150, this.gameHeight - 100, 150, 60, txt, config).setDepth(0);
        button.on('buttonClicked', function () {
            _this.scene.remove(_this);
            __WEBPACK_IMPORTED_MODULE_5_src_games_DiseasedTreesGame_objects_GameState__["a" /* GameState */].current = __WEBPACK_IMPORTED_MODULE_5_src_games_DiseasedTreesGame_objects_GameState__["a" /* GameState */].GAME_STATES[0];
            _this.scene.add("GameScene", _this.gameScene, true);
        });
        var back = __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */].createQuickBackButton(this, 50, this.gameHeight - 100);
        back.on("buttonClicked", function () {
            _this.input.enabled = false;
            _this.scene.remove(_this);
            _this.scene.add("GameIntroScene", __WEBPACK_IMPORTED_MODULE_6__IntroductionScene__["a" /* HowToPlayScene */], true);
        });
    };
    return InstructionScene;
}(Phaser.Scene));



/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_GameState__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_DiseasedTreesGame_scenes_EndGameScene__ = __webpack_require__(2358);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene" + Math.random()
        }) || this;
        _this.gameOver = false;
        _this.marking = false;
        _this.cleaning = false;
        _this.touchSupport = false;
        _this.translateString = "DiseasedTrees.Phaser.MainScene.";
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image("pixel", __webpack_require__(60));
        this.load.atlas("pilots", __webpack_require__(189), __webpack_require__(190));
        this.load.atlas("assets", __webpack_require__(911), __webpack_require__(912));
        this.load.image("bubble", __webpack_require__(2359));
        // Load maps
        this.load.tilemapTiledJSON('map1', __webpack_require__(2360));
        this.load.tilemapTiledJSON('map2', __webpack_require__(2361));
        this.load.tilemapTiledJSON('map3', __webpack_require__(2362));
        // Load backgrounds
        this.load.image("background", __webpack_require__(516));
    };
    MainScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.initialize();
        this.generateScene();
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        // Check if we have touch support or not
        this.touchSupport = this.sys.game.device.input.touch;
        this.gameState = __WEBPACK_IMPORTED_MODULE_1__objects_GameState__["a" /* GameState */].current;
        this.map = this.make.tilemap({ key: this.gameState.mapKey });
        this.treeGroup = null;
        this.gameOver = false;
    };
    MainScene.prototype.generateScene = function () {
        this.background = this.add.image(0, 0, "background");
        this.background.setOrigin(0);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.addTools();
        this.addHealthyTrees();
        this.addDiseasedTrees();
        this.addObjects();
        // Create weather according to game state
        if (this.gameState.hasRain) {
            this.background.setAlpha(0.8);
            this.addRain();
        }
        if (this.gameState.hasSnow) {
            this.addSnow();
        }
        if (this.gameState.hasClouds) {
            this.addClouds();
        }
        if (this.gameState.hasFog) {
            this.addFog();
        }
        this.input.on('pointermove', this.pointerMove);
        this.useSprayer();
    };
    MainScene.prototype.addTools = function () {
        var _this = this;
        var toolLayer = this.map.getObjectLayer('Tool Layer');
        toolLayer.objects.forEach(function (ob) {
            if (ob.name === "toolBackground") {
                var background = _this.add.image(ob.x, ob.y, "pixel");
                background.setTint(0x6eb8e5);
                background.setOrigin(0);
                background.setDisplaySize(ob.width, ob.height);
                var text = _this.add.text(0, 0, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "instructions"));
                text.setStyle({ fontSize: 20, fontFamily: "Russo One, Arial", align: "center" });
                text.setOrigin(0.5);
                text.setPosition(background.getCenter().x, background.getTopLeft().y - 2 * text.height);
                text.setWordWrapWidth(background.displayWidth, true);
            }
            else {
                var tool = _this.add.image(ob.x, ob.y, "assets", ob.name);
                tool.setOrigin(0);
                tool.setDisplaySize(ob.width, ob.height);
                tool.setName(ob.name);
                tool.setInteractive();
                tool.setDepth(2);
                tool.setDataEnabled();
                tool.setFlipX(true);
                tool.setData('position', new Phaser.Geom.Point(tool.x, tool.y));
                if (tool.name === "sprayer") {
                    _this.markingTool = tool;
                }
                else {
                    _this.cleaningTool = tool;
                }
                // Make it easier to grab the tool by giving it a larger zone
                var zoneSize = 25;
                var toolZone = _this.add.zone(tool.x - zoneSize / 2, tool.y - zoneSize / 2, tool.displayWidth + zoneSize, tool.displayHeight + zoneSize);
                toolZone.setOrigin(0);
                toolZone.setInteractive();
                toolZone.setDepth(10);
                toolZone.on("pointerdown", function (pointer) {
                    if (tool.name === "sprayer") {
                        _this.useSprayer();
                    }
                    else {
                        _this.useCleaningTool();
                    }
                });
            }
        });
    };
    MainScene.prototype.useSprayer = function () {
        this.marking = true;
        this.cleaning = false;
        // Set this tool selected and the other is greyed out
        this.markingTool.clearTint();
        this.cleaningTool.setTint(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("light grey"));
        this.cursor = this.markingTool;
        var cleaningToolPosition = this.cleaningTool.getData('position');
        this.cleaningTool.setPosition(cleaningToolPosition.x, cleaningToolPosition.y);
        // Change cursor/mouse to the tool if we don't have touch support
        this.input.setDefaultCursor('none');
        this.cursor.setPosition(this.input.activePointer.position.x, this.input.activePointer.position.y);
        this.markingTool.setDepth(this.cleaningTool.depth + .01);
    };
    MainScene.prototype.useCleaningTool = function () {
        this.marking = false;
        this.cleaning = true;
        // Set this tool selected and the other is greyed out
        this.markingTool.setTint(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("light grey"));
        this.cleaningTool.clearTint();
        this.cursor = this.cleaningTool;
        var markingToolPosition = this.markingTool.getData('position');
        this.markingTool.setPosition(markingToolPosition.x, markingToolPosition.y);
        // Change cursor/mouse to the tool if we don't have touch support
        this.input.setDefaultCursor('none');
        this.cursor.setPosition(this.input.activePointer.position.x, this.input.activePointer.position.y);
        this.cleaningTool.setDepth(this.markingTool.depth + .01);
    };
    MainScene.prototype.addHealthyTrees = function () {
        var _this = this;
        var healthyTreeLayer = this.map.getObjectLayer("Healthy Trees");
        this.treeGroup = this.add.group();
        healthyTreeLayer.objects.forEach(function (ob) {
            var healthyTree = _this.add.image(ob.x, ob.y, "assets", "tree-" + Phaser.Math.Between(1, 5));
            healthyTree.setOrigin(0);
            healthyTree.setDisplaySize(ob.width, ob.height);
            healthyTree.setDataEnabled();
            healthyTree.setData('marked', false);
            healthyTree.setData('isDiseased', false);
            var zone = _this.add.zone(healthyTree.x + healthyTree.displayWidth / 8, healthyTree.y, healthyTree.displayWidth * 0.75, healthyTree.displayHeight * 0.75);
            zone.setOrigin(0);
            zone.setInteractive();
            zone.setDepth(10);
            zone.on('pointerdown', function () {
                if (_this.marking) {
                    _this.markTree(healthyTree);
                }
                else if (_this.cleaning) {
                    _this.cleanTree(healthyTree);
                }
            });
            _this.treeGroup.add(healthyTree);
        });
    };
    MainScene.prototype.addDiseasedTrees = function () {
        var _this = this;
        var diseasedTreeLayer = this.map.getObjectLayer("Diseased Trees");
        diseasedTreeLayer.objects.forEach(function (ob) {
            var diseasedTree = _this.add.image(ob.x, ob.y, "assets", "tree-" + Phaser.Math.Between(1, 5));
            diseasedTree.setOrigin(0);
            diseasedTree.setDisplaySize(ob.width, ob.height);
            diseasedTree.setTint(0xff8e51);
            diseasedTree.setDataEnabled();
            diseasedTree.setData('marked', false);
            diseasedTree.setData('isDiseased', true);
            var zone = _this.add.zone(diseasedTree.x + diseasedTree.displayWidth / 8, diseasedTree.y, diseasedTree.displayWidth * 0.75, diseasedTree.displayHeight * 0.75);
            zone.setOrigin(0);
            zone.setInteractive();
            zone.setDepth(10);
            zone.on('pointerdown', function () {
                if (_this.marking) {
                    _this.markTree(diseasedTree);
                }
                else if (_this.cleaning) {
                    _this.cleanTree(diseasedTree);
                }
            });
            _this.treeGroup.add(diseasedTree);
        });
    };
    MainScene.prototype.addObjects = function () {
        var _this = this;
        var layer = this.map.getObjectLayer("Astronaut Layer");
        layer.objects.forEach(function (ob) {
            if (ob.name === "astronaut") {
                var astro = _this.add.image(ob.x, ob.y, "pilots", "r");
                astro.setOrigin(0);
                astro.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "bubble") {
                _this.bubble = _this.add.text(ob.x, ob.y, "");
                _this.bubble.setStyle({ color: "#ffffff", backgroundColor: "#000000", fontFamily: 'Russo One, Arial' });
                _this.bubble.setPadding(20, 20, 20, 20);
                _this.bubble.setWordWrapWidth(ob.width - 40, true);
                _this.bubble.setDepth(20);
                _this.bubbleBorder = _this.add.image(_this.bubble.x - 5, _this.bubble.y - 5, "pixel");
                _this.bubbleBorder.setOrigin(0);
                _this.bubbleBorder.setTint(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("R"));
                _this.bubbleBorder.setDepth(20);
                _this.bubble.setVisible(false);
                _this.bubbleBorder.setVisible(false);
            }
        });
    };
    MainScene.prototype.addSnow = function () {
        var particles, scale, gravity, y, lifespan;
        y = -10;
        particles = this.add.particles("assets", 'snowflake');
        scale = 0.2;
        gravity = 30;
        lifespan = 10000;
        particles.setDepth(10);
        var fall = {
            width: 100,
            height: 10,
            getPoints: function (quantity) {
                var cols = (new Array(fall.width)).fill(0);
                var lastCol = cols.length - 1;
                var Between = Phaser.Math.Between;
                var points = [];
                for (var i = 0; i < quantity; i++) {
                    var col = Between(0, lastCol);
                    points[i] = new Phaser.Math.Vector2(16 * col, y);
                }
                return points;
            }
        };
        particles.createEmitter({
            angle: 0,
            gravityY: gravity,
            lifespan: lifespan,
            scale: scale,
            blendMode: 'ADD',
            emitZone: { type: "edge", source: fall, quantity: 100, yoyo: true },
        });
    };
    MainScene.prototype.addRain = function () {
        var rain, scale, gravity, y, lifespan;
        y = -10;
        rain = this.add.particles("assets", 'rain');
        scale = 0.6;
        gravity = 220;
        lifespan = 7000;
        rain.setDepth(10);
        var fall = {
            width: 100,
            height: 10,
            getPoints: function (quantity) {
                var cols = (new Array(fall.width)).fill(0);
                var lastCol = cols.length - 1;
                var Between = Phaser.Math.Between;
                var points = [];
                for (var i = 0; i < quantity; i++) {
                    var col = Between(0, lastCol);
                    points[i] = new Phaser.Math.Vector2(16 * col, y);
                }
                return points;
            }
        };
        rain.createEmitter({
            angle: 0,
            gravityY: gravity,
            lifespan: lifespan,
            scale: scale,
            blendMode: 'ADD',
            emitZone: { type: "edge", source: fall, quantity: 100, yoyo: true },
        });
    };
    MainScene.prototype.addFog = function () {
        var fog = this.add.image(-400, 200, "assets", 'fog');
        fog.setOrigin(0);
        this.tweens.add({
            targets: fog,
            x: this.gameWidth,
            ease: 'Linear',
            duration: 300000,
            repeat: -1
        });
    };
    MainScene.prototype.addClouds = function () {
        var clouds = this.add.image(-400, 10, "assets", 'clouds');
        clouds.setOrigin(0);
        this.tweens.add({
            targets: clouds,
            x: this.gameWidth,
            ease: 'Linear',
            duration: 200000,
            repeat: -1
        });
    };
    /**
     * Called when spray can overlaps with a tree
     * Adds the disease label
     * Shows feedback if not actually diseased
     */
    MainScene.prototype.markTree = function (tree) {
        if (!tree.getData("marked")) {
            var diseaseLabel = this.add.image(0, 0, "assets", "marker");
            diseaseLabel.setOrigin(0);
            diseaseLabel.setDisplaySize(30, 30);
            diseaseLabel.setTint(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("red"));
            if (tree.frame.name === "tree-1" || tree.frame.name === "tree-2" || tree.frame.name === "tree-4") {
                diseaseLabel.setPosition(tree.getCenter().x - diseaseLabel.displayWidth / 2, tree.getTopLeft().y + tree.displayHeight / 5);
            }
            else if (tree.frame.name === "tree-3") {
                diseaseLabel.setPosition(tree.getCenter().x - diseaseLabel.displayWidth * 0.75, tree.getTopLeft().y + tree.displayHeight / 8);
            }
            else if (tree.frame.name === "tree-5") {
                diseaseLabel.setPosition(tree.getCenter().x + diseaseLabel.displayWidth / 5, tree.getTopLeft().y + tree.displayHeight / 8);
            }
            tree.setData('marked', true);
            tree.setData('mark', diseaseLabel);
            if (!tree.getData('isDiseased')) {
                var bubbleText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "wrongMark");
                this.bubble.setText(bubbleText).setDepth(1);
                this.bubble.setVisible(true);
                this.bubbleBorder.setDisplaySize(this.bubble.displayWidth + 10, this.bubble.displayHeight + 10);
                this.bubbleBorder.setVisible(true).setDepth(.5);
            }
        }
    };
    /**
     * Called when spray can overlaps with a tree
     * Removes the disease label if there
     */
    MainScene.prototype.cleanTree = function (tree) {
        if (tree.getData('marked')) {
            this.animateCleaning(tree);
        }
    };
    MainScene.prototype.animateCleaning = function (tree) {
        var reaction = this.add.particles("bubble");
        var mark = tree.getData("mark");
        // Emit some bubbles
        var emitter = reaction.createEmitter({
            x: mark.getCenter().x,
            y: mark.getCenter().y,
            scale: 0.3,
            speed: 20,
            lifespan: 1200,
            blendMode: Phaser.BlendModes.ADD,
        });
        // Fade out the mark
        this.add.tween({
            targets: mark,
            duration: 1000,
            alpha: {
                getStart: function () { return 1; },
                getEnd: function () { return 0; }
            },
            ease: "Linear",
            onComplete: function () {
                reaction.destroy();
                mark.destroy();
                tree.setData('marked', false);
            }
        });
    };
    MainScene.prototype.isGameOver = function () {
        for (var _i = 0, _a = this.treeGroup.getChildren(); _i < _a.length; _i++) {
            var tree = _a[_i];
            if (tree.getData("isDiseased") && !tree.getData('marked')) {
                // Diseased tree isn't marked
                return false;
            }
            if (!tree.getData("isDiseased") && tree.getData('marked')) {
                // Healthy tree is incorrectly marked
                return false;
            }
        }
        return true;
    };
    MainScene.prototype.pointerMove = function () {
        if (this.cursor != null) {
            if (this.marking) {
                this.cursor.setPosition(this.input.activePointer.position.x, this.input.activePointer.position.y);
            }
            else {
                this.cursor.setPosition(this.input.activePointer.position.x - this.cursor.displayWidth / 2, this.input.activePointer.position.y - this.cursor.displayHeight / 2);
            }
        }
    };
    MainScene.prototype.update = function () {
        this.updateBubbleVisibility();
        this.checkIfGameIsOver();
    };
    MainScene.prototype.checkIfGameIsOver = function () {
        var _this = this;
        var config = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
        config.buttonWidth = 100;
        var buttonConfig = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON,
            smartSize: true
        };
        config.buttonConfig = buttonConfig;
        var options;
        // Check if the game is over
        if (this.isGameOver() && !this.gameOver) {
            this.cleaning = false;
            this.marking = false;
            this.cursor.setVisible(false);
            this.input.setDefaultCursor('default');
            this.removeAllInputListeners();
            config.title = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "sceneDone");
            if (this.gameState.sceneIndex === 3) {
                options = [{ displayText: __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("common.done"), id: 2 }];
            }
            else {
                options = [{ displayText: __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("common.next"), id: 1 }];
            }
            var modal = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, options, config);
            modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2).setDepth(1);
            modal.setDepth(15);
            modal.on('optionClicked', function (op) {
                modal.destroy();
                if (op.id === 2) {
                    _this.input.setDefaultCursor("default");
                    _this.input.removeAllListeners();
                    _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_5_src_games_DiseasedTreesGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
                    _this.scene.remove(_this);
                }
                else {
                    // Next scene
                    _this.scene.remove(_this);
                    var nextSceneIndex = _this.gameState.sceneIndex + 1;
                    _this.gameState = __WEBPACK_IMPORTED_MODULE_1__objects_GameState__["a" /* GameState */].GAME_STATES[nextSceneIndex - 1];
                    // Update global game state
                    __WEBPACK_IMPORTED_MODULE_1__objects_GameState__["a" /* GameState */].current = _this.gameState;
                    _this.scene.add("MainScene", MainScene, true);
                }
            });
            this.gameOver = true;
            return;
        }
    };
    MainScene.prototype.updateBubbleVisibility = function () {
        // If there are any healthy trees incorrectly marked, the bubble with feedback will show until they are all corrected
        var visible = false;
        for (var _i = 0, _a = this.treeGroup.getChildren(); _i < _a.length; _i++) {
            var tree = _a[_i];
            if (!tree.getData('isDiseased') && tree.getData('marked')) {
                visible = true;
            }
        }
        this.bubble.setVisible(visible);
        this.bubbleBorder.setVisible(visible);
    };
    MainScene.prototype.removeAllInputListeners = function () {
        this.children.list.forEach(function (c) {
            c.removeAllListeners();
        });
        this.input.removeAllListeners();
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "r";
        _this.gameClosingTextKey = "DiseasedTrees.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(168));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/phaser_bubble.9635eaa4.png";

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/diseased_trees_game_1.705778f6.json";

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/diseased_trees_game_2.47ac7290.json";

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/diseased_trees_game_3.3b127579.json";

/***/ }),
/* 2363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(914);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].XRay;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "XRay.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "XRay.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "XRay.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_XraySlider_scenes_EndGameScene__ = __webpack_require__(2365);
// Resources:
// https://www.youtube.com/watch?v=BuJ3yrpSj-g
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// import 'phaser';





var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.BOARD_DIM = 3;
        _this.GAME_WIDTH = 1360;
        _this.GAME_HEIGHT = 768;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        _this.startTime = false;
        if (_this.BOARD_DIM === 3) {
            _this.borderSize = 5;
            _this.PIECE_WIDTH = Math.floor(_this.GAME_WIDTH / 6);
            _this.PIECE_HEIGHT = _this.PIECE_WIDTH;
        }
        else {
            try {
                throw new Error("Not a valid board dimension, must be 3");
            }
            catch (e) {
                console.warn(e);
            }
        }
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.spritesheet("key", __webpack_require__(915), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
        this.load.image("finishedKey", __webpack_require__(915));
        this.load.image("template", __webpack_require__(2366));
        this.load.image("white", __webpack_require__(884));
        this.load.atlas("pilots", __webpack_require__(189), __webpack_require__(190));
        this.load.image("pixel", __webpack_require__(60));
        this.load.image("bg", __webpack_require__(2367));
        this.load.image("bg_done", __webpack_require__(2368));
    };
    MainScene.prototype.create = function () {
        this.translateString = "XRay.Phaser.";
        this.add.image(0, 0, "bg").setOrigin(0).setDisplaySize(this.GAME_WIDTH, this.GAME_HEIGHT).setDepth(0);
        this.timeText = this.add.text(this.GAME_WIDTH - 125, 200, "0:00", { fill: "#000000", align: "center" }).setDepth(7.5).setOrigin().setFontFamily('Russo One, Roboto Mono, Arial').setFontSize(30);
        this.setupTimer();
        this.setupBoard();
        this.checkNumLeft();
        this.addControlPanel();
        this.addRescrambleButton();
        this.makeBlocksLeftBox();
    };
    MainScene.prototype.setupBoard = function () {
        this.clickLock = false;
        var order = [];
        order = this.createSolvableIndexArray();
        this.createBlocks(order);
    };
    MainScene.prototype.createBlocks = function (orderArray) {
        var _this = this;
        this.blockGroup = [];
        var count = 0;
        var padding = 4 * this.borderSize;
        for (var row = 0; row < this.BOARD_DIM; row++) {
            var _loop_1 = function (col) {
                // Wherever the largest number is in the order array, use that index for the black block
                if (orderArray[count] === this_1.BOARD_DIM * this_1.BOARD_DIM - 1) {
                    this_1.blackBlock = this_1.add.sprite((col) * (this_1.PIECE_WIDTH + 2) + padding, (row) * (this_1.PIECE_HEIGHT + 2) + 2 * padding, "white");
                    this_1.blackBlock.setOrigin(0);
                    this_1.blackBlock.setDepth(1);
                    this_1.blackBlock.setAlpha(0);
                    this_1.blackBlock.setDisplaySize(this_1.PIECE_WIDTH, this_1.PIECE_HEIGHT);
                    this_1.blackBlock.name = "black";
                    this_1.blackBlock.setData("key", orderArray[count]);
                    this_1.blockGroup.push(this_1.blackBlock);
                    count++;
                }
                // Create normal blocks using the sprite for the rest of the blocks
                else {
                    var block_1 = this_1.add.sprite((col) * (this_1.PIECE_WIDTH + 2) + padding, (row) * (this_1.PIECE_HEIGHT + 2) + 2 * padding, "key", orderArray[count]);
                    block_1.setOrigin(0);
                    block_1.setInteractive();
                    block_1.setDepth(2);
                    block_1.setDisplaySize(this_1.PIECE_WIDTH, this_1.PIECE_HEIGHT);
                    block_1.setData("key", orderArray[count]);
                    block_1.on('pointerdown', function () {
                        _this.switchBlocks(block_1, _this.blackBlock);
                    });
                    count++;
                    this_1.blockGroup.push(block_1);
                }
            };
            var this_1 = this;
            for (var col = 0; col < this.BOARD_DIM; col++) {
                _loop_1(col);
            }
        }
    };
    MainScene.prototype.addRescrambleButton = function () {
        var _this = this;
        var config = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.backgroundColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        config.smartHeight = true;
        var text = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "reshuffle");
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, this.GAME_WIDTH - 200, 50, 150, 50, text, config);
        button.setDepth(3);
        button.on('buttonClicked', function () {
            if (!_this.clickLock) {
                _this.startTime = false;
                _this.timeText.setText("0:00");
                _this.setupTimer();
                _this.text.setText("");
                _this.outline.setAlpha(0);
                _this.speechBox.setAlpha(0);
                _this.destroyOldPieces();
                _this.setupBoard();
                _this.blocksLeftText.destroy();
                _this.checkNumLeft();
            }
        });
    };
    MainScene.prototype.addControlPanel = function () {
        var pic = this.add.image(780, 55, "template");
        pic.setDepth(3);
        pic.setOrigin(0);
        pic.setAlpha(1);
        pic.setDisplaySize(320, 320);
        var border = this.add.image(775, 50, "pixel");
        border.setTint(0x000000);
        border.setOrigin(0);
        border.setDisplaySize(330, 330);
        border.setDepth(2);
        var astronaut = this.add.image(1200, 603, "pilots", "i");
        astronaut.setDepth(9);
        astronaut.setOrigin(.5);
        astronaut.setScale(.5, .5);
    };
    MainScene.prototype.switchBlocks = function (toSwitch, black) {
        if (this.clickLock) {
            return;
        }
        var diffX = Math.abs(black.x - toSwitch.x);
        var diffY = Math.abs(black.y - toSwitch.y);
        if (!this.isBlockMovable(diffX, diffY)) {
            return;
        }
        this.clickLock = true;
        if (!this.startTime) {
            this.setupTimer();
            this.startTime = true;
        }
        // Change the block's locations in the blockgroup array
        var swIndex = this.blockGroup.indexOf(toSwitch);
        var blIndex = this.blockGroup.indexOf(black);
        this.blockGroup[blIndex] = toSwitch;
        this.blockGroup[swIndex] = black;
        this.moveBlock(toSwitch, this.blackBlock);
    };
    /**
     * moveBlock function adds tween animation to moving blocks
     * @param block
     * @param blackBlock
     */
    MainScene.prototype.moveBlock = function (block, blackBlock) {
        var _this = this;
        this.tweens.add({
            targets: blackBlock,
            x: block.x,
            y: block.y,
            duration: 400,
            onComplete: function () {
            }
        });
        this.tweens.add({
            targets: block,
            x: blackBlock.x,
            y: blackBlock.y,
            duration: 400,
            onComplete: function () {
                _this.clickLock = false;
                _this.checkIfCompleted();
            }
        });
    };
    MainScene.prototype.isBlockMovable = function (diffX, diffY) {
        if (diffX === (this.PIECE_WIDTH + 2) && diffY === (this.PIECE_HEIGHT + 2)) {
            return false;
        }
        if (diffX > (this.PIECE_WIDTH + 2) || diffY > (this.PIECE_HEIGHT + 2)) {
            return false;
        }
        return true;
    };
    MainScene.prototype.createSolvableIndexArray = function () {
        var indexArray = [];
        for (var i = 0; i < this.BOARD_DIM * this.BOARD_DIM; i++) {
            indexArray.push(i);
        }
        var scrambleIndex = 0;
        while (scrambleIndex < 6) {
            for (var j = 0; j < 100; j++) {
                var blackIndex = indexArray.indexOf(8);
                var rand = Math.random() * 4;
                if (rand < 1) {
                    if (blackIndex !== 0 && blackIndex !== 3 && blackIndex !== 6) {
                        this.swap(indexArray, blackIndex, blackIndex - 1);
                    }
                }
                else if (rand < 2) {
                    if (blackIndex !== 0 && blackIndex !== 1 && blackIndex !== 2) {
                        this.swap(indexArray, blackIndex, blackIndex - 3);
                    }
                }
                else if (rand < 3) {
                    if (blackIndex !== 2 && blackIndex !== 5 && blackIndex !== 8) {
                        this.swap(indexArray, blackIndex, blackIndex + 1);
                    }
                }
                else if (rand < 4) {
                    if (blackIndex !== 6 && blackIndex !== 7 && blackIndex !== 8) {
                        this.swap(indexArray, blackIndex, blackIndex + 3);
                    }
                }
            }
            for (var i = 0; i < indexArray.length; i++) {
                if (indexArray[i] !== i) {
                    scrambleIndex++;
                }
            }
        }
        return indexArray;
    };
    MainScene.prototype.swap = function (arr, blackIndex, toSwap) {
        var temp = arr[toSwap];
        arr[toSwap] = arr[blackIndex];
        arr[blackIndex] = temp;
    };
    MainScene.prototype.makeBlocksLeftBox = function () {
        this.blocksLeftText.setDepth(3);
        var box = this.add.image(this.blocksLeftText.x, this.blocksLeftText.y, "pixel");
        box.setDisplaySize(this.blocksLeftText.displayWidth + 10, this.blocksLeftText.displayHeight + 10);
        box.setDepth(2);
        var edge = this.add.image(box.x, box.y, "pixel");
        edge.setDisplaySize(box.displayWidth + 10, box.displayHeight + 10);
        edge.setTint(0x000000);
        edge.setDepth(1.5);
    };
    MainScene.prototype.checkIfCompleted = function () {
        var count = 0;
        var iter = this.blockGroup.values();
        for (var row = 0; row < this.BOARD_DIM; row++) {
            for (var col = 0; col < this.BOARD_DIM; col++) {
                if (iter.next().value.getData("key") !== count) {
                    this.outline.destroy();
                    this.speechBox.destroy();
                    this.blocksLeftText.destroy();
                    this.text.destroy();
                    var num = this.checkNumLeft();
                    if (this.count > num) {
                        var rand = Math.random() * 4;
                        if (rand < 1) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(__WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "feedback.1"));
                        }
                        else if (rand < 2) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(__WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "feedback.2"));
                        }
                        else if (rand < 3) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(__WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "feedback.3"));
                        }
                        else {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(__WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "feedback.4"));
                        }
                    }
                    this.count = num;
                    return;
                }
                count++;
            }
        }
        this.showFinishedText();
        this.blocksLeftText.destroy();
    };
    MainScene.prototype.checkNumLeft = function () {
        var num = 0;
        var iter = this.blockGroup.values();
        for (var i = 0; i < this.blockGroup.length; i++) {
            var next = iter.next().value.getData("key");
            if (next !== i) {
                if ((this.BOARD_DIM === 3 && next === 8)) {
                    // dont add to num, black block
                }
                else {
                    num++;
                }
            }
        }
        var scoreText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "score");
        var str = scoreText + num;
        this.blocksLeftText = this.add.text(945, 410, str, { fontFamily: 'Russo One, Roboto Mono, Arial', fill: "#000000", align: "center" }).setFontSize(20);
        this.blocksLeftText.setDepth(3);
        this.blocksLeftText.setOrigin(.5);
        this.text = this.add.text(945, 525, "", { fontFamily: 'Roboto Mono, Russo One, Arial', fill: "#ffffff", align: "center" }).setFontSize(25);
        this.text.setOrigin(.5);
        this.text.setDepth(3);
        this.outline = this.add.image(845, 470, "pixel");
        this.outline.setOrigin(0);
        this.outline.setTint(0x0000ff);
        this.outline.setDisplaySize(200, 110);
        this.outline.setDepth(2.5);
        this.outline.setAlpha(0);
        this.speechBox = this.add.image(850, 475, "pixel");
        this.speechBox.setOrigin(0);
        this.speechBox.setTint(0x000000);
        this.speechBox.setDepth(2.75);
        this.speechBox.setDisplaySize(190, 100);
        this.speechBox.setAlpha(0);
        return num;
    };
    MainScene.prototype.showFinishedText = function () {
        var _this = this;
        var style = { fontFamily: 'Russo One, Roboto Mono, Arial', fill: "#0C0C0C", align: "center", font: "40px Arial" };
        this.add.image(0, 0, "bg_done").setDepth(10).setOrigin(0).setDisplaySize(this.GAME_WIDTH, this.GAME_HEIGHT);
        var moveOn = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("common.done");
        var buttonConfig = { backgroundColor: 0x6ec213, textColor: 0xffffff, textSize: 30 };
        var buttonText = this.add.text(0, 0, moveOn, style).setVisible(false).setWordWrapWidth(500);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 100, 50, buttonText.displayWidth + 10, buttonText.displayHeight + 10, moveOn, buttonConfig);
        button.setDepth(10);
        button.on("buttonClicked", function () {
            _this.input.setDefaultCursor("default");
            _this.input.removeAllListeners();
            _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_4_src_games_XraySlider_scenes_EndGameScene__["a" /* EndGameScene */], true);
            _this.scene.remove(_this);
        });
    };
    MainScene.prototype.setupTimer = function () {
        this.timer = this.time.addEvent({ delay: 10000000, timeScale: 1.0 });
        var clock = this.add.image(this.GAME_WIDTH - 125, 200, "pixel").setDisplaySize(110, 50).setDepth(6.5);
        var clockBorder = this.add.image(clock.x, clock.y, "pixel").setDisplaySize(120, 60).setDepth(6).setTint(0x000000);
    };
    MainScene.prototype.setTime = function () {
        if (this.startTime) {
            var minute = Math.floor(this.timer.getElapsedSeconds() / 60);
            var second = Math.floor(this.timer.getElapsedSeconds() % 60);
            if (second < 10) {
                this.timeText.setText(minute.toString() + ":0" + second.toString());
            }
            else {
                this.timeText.setText(minute.toString() + ":" + second.toString());
            }
        }
    };
    MainScene.prototype.destroyOldPieces = function () {
        var iter = this.blockGroup.values();
        for (var i = 0; i < this.blockGroup.length; i++) {
            iter.next().value.destroy();
        }
    };
    MainScene.prototype.update = function () {
        this.setTime();
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "i";
        _this.gameClosingTextKey = "XRay.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xray__key.77fe846f.png";

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/grade3-I__bg.f9e553c7.png";

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/grade3-I__bg-completed.00ca214c.png";

/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(917);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].DesertTerraform;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "DesertTerraform.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "DesertTerraform.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "DesertTerraform.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_GameState__ = __webpack_require__(289);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].FitFive;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "FitFive.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "FitFive.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "FitFive.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    HowToPlayScene.prototype.create = function () {
        _super.prototype.create.call(this);
        // This properly loads gamestate for the next scene
        __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current = new __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */](null);
    };
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_NPC__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TalkToNPCScene__ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_GameState__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PictureWallScene__ = __webpack_require__(2374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_constants_KeyboardNumKeys__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.endScene = false;
        _this.translateString = "FitFive.Phaser.MainScene.";
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('map', __webpack_require__(2380));
        this.load.atlas("assets", __webpack_require__(2381), __webpack_require__(2382));
        this.load.image("pixel", __webpack_require__(60));
        this.load.image("gym", __webpack_require__(2383));
        this.load.image("gym-zoomed-1", __webpack_require__(2384));
        this.load.image("gym-zoomed-2", __webpack_require__(2385));
        this.load.image("gym-zoomed-3", __webpack_require__(2386));
        this.load.image("gym-zoomed-4", __webpack_require__(2387));
        this.load.image("gym-zoomed-5", __webpack_require__(2388));
    };
    MainScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_3_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
        this.bindNumKeys();
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.allNPCs = [];
        this.endScene = false;
    };
    MainScene.prototype.generateScene = function () {
        this.background = this.add.image(0, 0, "gym");
        this.background.setOrigin(0);
        this.addNPCs();
        this.resetNPCs();
    };
    MainScene.prototype.addNPCs = function () {
        var _this = this;
        var layer = this.map.getObjectLayer("NPC");
        var npcs = __WEBPACK_IMPORTED_MODULE_0__objects_NPC__["a" /* NPC */].ALL_NPCS;
        layer.objects.forEach(function (ob) {
            var labelObject = _this.map.getObjectLayer("labels").objects.find(function (l) { return l.name === ob.name; });
            var npc = npcs.find(function (character) { return character.assetKey === ob.name; });
            var npcObject = _this.add.image(ob.x, ob.y, "assets", npc.assetKey);
            npcObject.setOrigin(0);
            npcObject.setDisplaySize(ob.width, ob.height);
            npcObject.setInteractive();
            npc.object = npcObject;
            npcObject.on('pointerdown', function () {
                _this.clickedNPC(npc);
            });
            var name = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(npc.name);
            var job = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(npc.job);
            var labelText = (npc.id) + ': ' + name + __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "the") + job;
            var labelStyle = { fontSize: 14, fontFamily: 'Russo One, Arial', align: "center", backgroundColor: "#000000", padding: 10 };
            var npcLabel = _this.add.text(labelObject.x, labelObject.y, labelText, labelStyle).setDepth(1);
            npcLabel.setWordWrapWidth(200, true);
            npc.label = npcLabel;
            var border = _this.add.image(npcLabel.x - 2, npcLabel.y - 2, "pixel").setDisplaySize(npcLabel.displayWidth + 4, npcLabel.displayHeight + 4);
            border.setDepth(0.5).setOrigin(0).setTint(__WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("S"));
            border.setInteractive();
            border.on('pointerdown', function () {
                _this.clickedNPC(npc);
            });
            _this.allNPCs.push(npc);
        });
    };
    MainScene.prototype.clickedNPC = function (npc) {
        if (npc.enabled) {
            // Update GameState and go to talk to character scene
            __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.currentNPC = npc;
            __WEBPACK_IMPORTED_MODULE_0__objects_NPC__["b" /* Question */].HELLO.textID.replace("%", npc.id.toString());
            __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.question = __WEBPACK_IMPORTED_MODULE_0__objects_NPC__["b" /* Question */].HELLO;
            __WEBPACK_IMPORTED_MODULE_2__objects_GameState__["a" /* GameState */].current.response = npc.responses.find(function (r) { return r.questionId === 0; });
            this.scene.pause("MainScene");
            this.scene.add("TalkToNPCScene", __WEBPACK_IMPORTED_MODULE_1__TalkToNPCScene__["a" /* TalkToNPCScene */], true);
            npc.label.setTint(__WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].COLORS.get('light grey'));
        }
    };
    MainScene.prototype.haveTalkedToAllNPCs = function () {
        for (var _i = 0, _a = this.allNPCs; _i < _a.length; _i++) {
            var npc = _a[_i];
            if (!npc.talkedTo) {
                return false;
            }
        }
        return true;
    };
    MainScene.prototype.resetNPCs = function () {
        this.allNPCs.forEach(function (npc) {
            npc.enabled = true;
            npc.talkedTo = false;
            npc.picked = false;
        });
    };
    MainScene.prototype.update = function () {
        if (this.haveTalkedToAllNPCs() && !this.endScene) {
            this.endScene = true;
            this.scene.remove(this);
            this.scene.add("PictureWallScene", __WEBPACK_IMPORTED_MODULE_6__PictureWallScene__["a" /* PictureWallScene */], true);
            return;
        }
    };
    MainScene.prototype.onKeydown = function (event) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        keys.forEach(function (key) {
            _this.input.keyboard.on('keydown_' + key, event);
        });
    };
    MainScene.prototype.bindNumKeys = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_7_src_constants_KeyboardNumKeys__["a" /* numKeys */].forEach(function (key) {
            _this.onKeydown(function () {
                var npc = __WEBPACK_IMPORTED_MODULE_0__objects_NPC__["a" /* NPC */].ALL_NPCS[key.index];
                _this.clickedNPC(npc);
            }, key.keyCode, key.altKeyCode);
        });
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TalkToNPCScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_FitFiveGame_objects_NPC__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_constants_KeyboardNumKeys__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var TalkToNPCScene = /** @class */ (function (_super) {
    __extends(TalkToNPCScene, _super);
    function TalkToNPCScene() {
        var _this = _super.call(this, {
            key: "TalkToNPCScene" + Math.random()
        }) || this;
        _this.padding = 20;
        return _this;
    }
    TalkToNPCScene.prototype.preload = function () {
        var _this = this;
        this.load.tilemapTiledJSON('character_focused', __webpack_require__(2373));
        var keys = [
            "FitFive.Phaser.NPCS.1.dialog.1", "FitFive.Phaser.NPCS.1.dialog.2", "FitFive.Phaser.NPCS.1.dialog.3", "FitFive.Phaser.NPCS.1.dialog.4",
            "FitFive.Phaser.NPCS.2.dialog.1", "FitFive.Phaser.NPCS.2.dialog.2", "FitFive.Phaser.NPCS.2.dialog.3", "FitFive.Phaser.NPCS.2.dialog.4",
            "FitFive.Phaser.NPCS.3.dialog.1", "FitFive.Phaser.NPCS.3.dialog.2", "FitFive.Phaser.NPCS.3.dialog.3", "FitFive.Phaser.NPCS.3.dialog.4",
            "FitFive.Phaser.NPCS.4.dialog.1", "FitFive.Phaser.NPCS.4.dialog.2", "FitFive.Phaser.NPCS.4.dialog.3", "FitFive.Phaser.NPCS.4.dialog.4",
            "FitFive.Phaser.NPCS.5.dialog.1", "FitFive.Phaser.NPCS.5.dialog.2", "FitFive.Phaser.NPCS.5.dialog.3", "FitFive.Phaser.NPCS.5.dialog.4",
        ];
        keys.forEach(function (key) {
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_6_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_3__utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    TalkToNPCScene.prototype.create = function () {
        this.enableMainSceneInput(false);
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_4__shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    TalkToNPCScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'character_focused' });
        this.options = this.getOptions();
    };
    TalkToNPCScene.prototype.generateScene = function () {
        var _this = this;
        this.background = this.add.image(0, 0, __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.backgroundAssetKey);
        this.background.setOrigin(0);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        var i = 0;
        this.map.getObjectLayer("Object").objects.forEach(function (ob) {
            if (ob.name === "npc") {
                _this.npcArea = ob;
                var npc = _this.add.image(ob.x, ob.y, 'assets', __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.assetKey);
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "dialog") {
                _this.dialogArea = ob;
                _this.addDialog();
            }
            else if (ob.name.startsWith("button")) {
                if (_this.options[i]) {
                    _this.createQuestionButton(ob, i);
                    i++;
                }
            }
        });
    };
    TalkToNPCScene.prototype.addDialog = function () {
        var ob = this.dialogArea;
        var npcResponse = __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.responses.find(function (r) { return r.questionId === __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.question.id; });
        var translatedDialog = __WEBPACK_IMPORTED_MODULE_3__utils_TranslateHelper__["a" /* default */].translate(npcResponse.textID);
        var fSize = translatedDialog.length < 670 ? 16 : translatedDialog.length < 780 ? 15 : 14;
        var dialogStyle = { padding: this.padding, fontSize: fSize, fontFamily: "Roboto Mono, Arial", color: "#F8E71C" };
        var dialog = this.add.text(ob.x, ob.y, translatedDialog, dialogStyle);
        dialog.setOrigin(0);
        dialog.setWordWrapWidth(ob.width - 2 * this.padding, true);
        dialog.setDepth(10);
        var outline = this.add.image(ob.x - 5, ob.y - 5, "pixel");
        outline.setOrigin(0);
        outline.setTint(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("S"));
        outline.setDisplaySize(ob.width + 10, ob.height + 10);
        var dialogBackground = this.add.image(ob.x, ob.y, "pixel");
        dialogBackground.setOrigin(0);
        dialogBackground.setTint(0x000000);
        dialogBackground.setDepth(0);
        dialogBackground.setDisplaySize(ob.width, ob.height);
        var audio = this.sound.add(npcResponse.textID);
        audio.play();
    };
    TalkToNPCScene.prototype.createQuestionButton = function (ob, index) {
        var _this = this;
        if (ob.name === "button_1") {
            this.buttonYCoordinate = ob.y;
        }
        var question = this.options[index];
        var config = this.getButtonConfig();
        var translatedText = (index + 1) + ' : ' + __WEBPACK_IMPORTED_MODULE_3__utils_TranslateHelper__["a" /* default */].translate(question.textID);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, ob.x, ob.y, ob.width, ob.height, translatedText, config);
        button.setDisplaySize(button.width, button.getIdealButtonHeight());
        if (ob.name !== "button_1") {
            button.setY(this.buttonYCoordinate);
        }
        this.buttonYCoordinate += button.displayHeight + 30;
        button.name = name;
        button.on('buttonClicked', function () {
            _this.responseSelected(question);
        });
        var numKey = __WEBPACK_IMPORTED_MODULE_7_src_constants_KeyboardNumKeys__["a" /* numKeys */][index];
        this.onKeydown(function () {
            _this.responseSelected(question);
        }, numKey.keyCode, numKey.altKeyCode);
    };
    TalkToNPCScene.prototype.responseSelected = function (question) {
        this.sound.stopAll();
        if (question.id === 4) {
            // Return to main scene
            __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.response = null;
            __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.question = null;
            this.resetQuestions();
            this.enableMainSceneInput(true);
            __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.talkedTo = true;
            this.scene.remove(this);
            this.scene.resume("MainScene");
        }
        else {
            question.asked = true;
            __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.response = __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.responses.find(function (r) { return r.questionId === question.id; });
            __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.question = question;
            this.scene.remove(this);
            this.scene.add("TalkToNPCScene", TalkToNPCScene, true);
        }
    };
    TalkToNPCScene.prototype.enableMainSceneInput = function (enabled) {
        this.scene.get("MainScene").children.list.forEach(function (c) {
            if (c.input != null) {
                c.input.enabled = enabled;
            }
        });
    };
    TalkToNPCScene.prototype.resetQuestions = function () {
        __WEBPACK_IMPORTED_MODULE_5_src_games_FitFiveGame_objects_NPC__["b" /* Question */].QUESTIONS.forEach(function (q) {
            q.asked = false;
        });
    };
    TalkToNPCScene.prototype.getOptions = function () {
        var options = [];
        __WEBPACK_IMPORTED_MODULE_5_src_games_FitFiveGame_objects_NPC__["b" /* Question */].QUESTIONS.forEach(function (q) {
            if (!q.asked && q.id !== 4) {
                options.push(q);
            }
        });
        if (options.length === 0) {
            options.push(__WEBPACK_IMPORTED_MODULE_5_src_games_FitFiveGame_objects_NPC__["b" /* Question */].QUESTIONS.find(function (q) { return q.id === 4; }));
        }
        return options;
    };
    TalkToNPCScene.prototype.getButtonConfig = function () {
        var config = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.smartHeight = true;
        config.backgroundColor = __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON;
        return config;
    };
    TalkToNPCScene.prototype.onKeydown = function (event) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        keys.forEach(function (key) {
            _this.input.keyboard.on('keydown_' + key, event);
        });
    };
    return TalkToNPCScene;
}(Phaser.Scene));



/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/character_focused.be43aa74.json";

/***/ }),
/* 2374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PictureWallScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_NPC__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_GameState__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CharacterFeedbackScene__ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_games_FitFiveGame_scenes_EndGameScene__ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_constants_KeyboardNumKeys__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var PictureWallScene = /** @class */ (function (_super) {
    __extends(PictureWallScene, _super);
    function PictureWallScene() {
        var _this = _super.call(this, {
            key: "PictureWallScene"
        }) || this;
        _this.gameOver = false;
        _this.translateString = "FitFive.Phaser.MainScene.";
        return _this;
    }
    PictureWallScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('picture_wall', __webpack_require__(2378));
        this.load.image("correct", __webpack_require__(2379));
        this.load.image("wrong", __webpack_require__(519));
    };
    PictureWallScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_3_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    PictureWallScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'picture_wall' });
        this.gameOver = false;
    };
    PictureWallScene.prototype.generateScene = function () {
        this.background = this.add.image(0, 0, "gym");
        this.background.setOrigin(0);
        this.addNPCs();
        this.bindNumKeys();
    };
    PictureWallScene.prototype.addNPCs = function () {
        var _this = this;
        var layer = this.map.getObjectLayer("NPC");
        var npcs = __WEBPACK_IMPORTED_MODULE_0__objects_NPC__["a" /* NPC */].ALL_NPCS;
        layer.objects.forEach(function (ob) {
            if (ob.name === "astro") {
                _this.astronaut = _this.add.image(ob.x, ob.y, "pilots", "s");
                _this.astronaut.setOrigin(0);
                _this.astronaut.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "dialog") {
                var style = { fontSize: 15, fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", backgroundColor: "#000000", padding: 10 };
                var text = _this.add.text(ob.x, ob.y, __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "quiz"), style);
                text.setDepth(1);
                text.setWordWrapWidth(ob.width, true);
                var border = _this.add.image(text.x - 5, text.y - 5, "pixel");
                border.setOrigin(0);
                border.setDepth(.25);
                border.setDisplaySize(text.displayWidth + 10, text.displayHeight + 10);
                border.setTint(__WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("S"));
            }
            else if (ob.type === "NPC") {
                var labelObject = _this.map.getObjectLayer("labels").objects.find(function (l) { return l.name === ob.name; });
                var npc = npcs.find(function (character) { return character.assetKey === ob.name; });
                var npcObject = _this.add.image(ob.x, ob.y, "assets", npc.assetKey);
                npcObject.setOrigin(0);
                npcObject.setDisplaySize(ob.width, ob.height);
                npcObject.setInteractive();
                npc.object = npcObject;
                npcObject.on('pointerdown', function () {
                    _this.clickedNPC(npc);
                });
                var name = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(npc.name);
                var job = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(npc.job);
                var labelText = (npc.id) + ': ' + name + __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "the") + job;
                var labelStyle = { fontSize: 14, fontFamily: 'Russo One, Arial', align: "center", backgroundColor: "#000000", padding: 10 };
                var npcLabel = _this.add.text(labelObject.x, labelObject.y, labelText, labelStyle).setDepth(1);
                npcLabel.setWordWrapWidth(200, true);
                npc.label = npcLabel;
                var border = _this.add.image(npcLabel.x - 2, npcLabel.y - 2, "pixel").setDisplaySize(npcLabel.displayWidth + 4, npcLabel.displayHeight + 4);
                border.setDepth(0.5).setOrigin(0).setTint(__WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("S"));
                border.setInteractive();
                border.on('pointerdown', function () {
                    _this.clickedNPC(npc);
                });
                ////// On the computer, show labels only on hovering (makes it look much less cluttered!)
                ////if (!this.sys.game.device.input.touch) {
                ////    npcLabel.setVisible(false);
                ////    border.setVisible(false);
                ////    npcObject.on('pointerover', () => {
                ////        npcLabel.setVisible(true);
                ////        border.setVisible(true);
                ////    });
                ////    npcObject.on('pointerout', () => {
                ////        npcLabel.setVisible(false);
                ////        border.setVisible(false);
                ////    });
                ////}
            }
        });
    };
    PictureWallScene.prototype.clickedNPC = function (npc) {
        if (this.gameOver) {
            // If the modal is on screen, it's because the game is over..don't let them keep messing around
            return;
        }
        __WEBPACK_IMPORTED_MODULE_1__objects_GameState__["a" /* GameState */].current.currentNPC = npc;
        this.scene.setVisible(false, "PictureWallScene");
        this.scene.pause("PictureWallScene");
        this.scene.add("CharacterFeedbackScene", __WEBPACK_IMPORTED_MODULE_7__CharacterFeedbackScene__["a" /* CharacterFeedbackScene */], true);
        var loc = npc.object.getTopRight();
        var icon = this.add.image(loc.x + 5, loc.y - 5, "wrong");
        icon.setOrigin(0);
        icon.setDisplaySize(50, 50);
        icon.name = "icon";
        if (npc.id === 2 || npc.id === 5) {
            icon.setTexture('correct');
            icon.setDisplaySize(50, 50);
            npc.label.setTint(__WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("green"));
        }
        else {
            npc.label.setTint(__WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("light grey"));
        }
    };
    /**
     * Helper used when creating a modal
     */
    PictureWallScene.prototype.getModalConfig = function (title, buttonWidth, width, height) {
        var config = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
        config.title = title;
        config.buttonWidth = buttonWidth;
        config.buttonConfig = new __WEBPACK_IMPORTED_MODULE_6_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.buttonConfig.smartSize = true;
        return config;
    };
    /**
     * Checks if there is already a modal open on screen (we don't want to be able to add more than one modal to a scene)
     */
    PictureWallScene.prototype.isModalOnScreen = function () {
        var hasModal = this.children.list.find(function (c) {
            return c.type === "PhaserModal";
        });
        if (hasModal) {
            return true;
        }
        else {
            return false;
        }
    };
    PictureWallScene.prototype.isGameOver = function () {
        var npc;
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_0__objects_NPC__["a" /* NPC */].ALL_NPCS; _i < _a.length; _i++) {
            npc = _a[_i];
            // Correct npc wasn't picked
            if (npc.id === 2 && !npc.picked) {
                return false;
            }
            if (npc.id === 5 && !npc.picked) {
                return false;
            }
        }
        return true;
    };
    PictureWallScene.prototype.update = function () {
        var _this = this;
        if (this.isGameOver() && !this.gameOver) {
            this.gameOver = true;
            // Pause one second before showing that the game is over
            setTimeout(function () {
                var text = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "passedQuiz");
                var config = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
                config.title = text;
                config.buttonConfig.smartSize = true;
                var options = [{ id: 1, displayText: __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate("common.done") }];
                var modal = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Modal__["a" /* PhaserModal */](_this, 0, 0, options, config);
                modal.setDepth(10);
                modal.setPosition(_this.gameWidth / 2 - modal.width / 2, _this.gameHeight / 2 - modal.height / 2);
                modal.on('optionClicked', function () {
                    modal.destroy();
                    _this.input.removeAllListeners();
                    _this.input.setDefaultCursor("default");
                    _this.scene.setVisible(false, "PictureWallScene");
                    _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_8_src_games_FitFiveGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
                    _this.scene.remove(_this);
                });
            }, 1000);
        }
    };
    PictureWallScene.prototype.onKeydown = function (event) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        keys.forEach(function (key) {
            _this.input.keyboard.on('keydown_' + key, event);
        });
    };
    PictureWallScene.prototype.bindNumKeys = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_9_src_constants_KeyboardNumKeys__["a" /* numKeys */].forEach(function (key) {
            _this.onKeydown(function () {
                var npc = __WEBPACK_IMPORTED_MODULE_0__objects_NPC__["a" /* NPC */].ALL_NPCS[key.index];
                _this.clickedNPC(npc);
            }, key.keyCode, key.altKeyCode);
        });
    };
    return PictureWallScene;
}(Phaser.Scene));



/***/ }),
/* 2375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CharacterFeedbackScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_constants_KeyboardNumKeys__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var CharacterFeedbackScene = /** @class */ (function (_super) {
    __extends(CharacterFeedbackScene, _super);
    function CharacterFeedbackScene() {
        var _this = _super.call(this, {
            key: "CharacterFeedbackScene" + Math.random()
        }) || this;
        _this.padding = 20;
        return _this;
    }
    CharacterFeedbackScene.prototype.preload = function () {
        var _this = this;
        this.load.tilemapTiledJSON('character_feedback', __webpack_require__(2376));
        var keys = [
            "FitFive.Phaser.NPCS.1.feedback",
            "FitFive.Phaser.NPCS.2.feedback",
            "FitFive.Phaser.NPCS.3.feedback",
            "FitFive.Phaser.NPCS.4.feedback",
            "FitFive.Phaser.NPCS.5.feedback",
            "FitFive.Phaser.Okay", "FitFive.Phaser.Thanks"
        ];
        keys.forEach(function (key) {
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_3__utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    CharacterFeedbackScene.prototype.create = function () {
        this.enablePictureWallSceneInput(false);
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_4__shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    CharacterFeedbackScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'character_feedback' });
    };
    CharacterFeedbackScene.prototype.generateScene = function () {
        var _this = this;
        this.background = this.add.image(0, 0, __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.backgroundAssetKey);
        this.background.setOrigin(0);
        this.map.getObjectLayer("Object").objects.forEach(function (ob) {
            if (ob.name === "npc") {
                _this.npcArea = ob;
                var npc = _this.add.image(ob.x, ob.y, 'assets', __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.assetKey);
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "dialog") {
                _this.dialogArea = ob;
                _this.addDialog();
            }
            else if (ob.name.startsWith("button")) {
                _this.createButton(ob);
            }
        });
    };
    CharacterFeedbackScene.prototype.addDialog = function () {
        var ob = this.dialogArea;
        var text = __WEBPACK_IMPORTED_MODULE_3__utils_TranslateHelper__["a" /* default */].translate(__WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.feedback);
        var dialogStyle = { padding: this.padding, fontSize: 16, fontFamily: "Roboto Mono, Arial", color: "#F8E71C" };
        var dialog = this.add.text(ob.x, ob.y, text, dialogStyle);
        dialog.setOrigin(0);
        dialog.setWordWrapWidth(ob.width - 2 * this.padding, true);
        dialog.setDepth(10);
        var outline = this.add.image(ob.x - 5, ob.y - 5, "pixel");
        outline.setOrigin(0);
        outline.setTint(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("S"));
        outline.setDisplaySize(ob.width + 10, ob.height + 10);
        var dialogBackground = this.add.image(ob.x, ob.y, "pixel");
        dialogBackground.setOrigin(0);
        dialogBackground.setTint(0x000000);
        dialogBackground.setDepth(0);
        dialogBackground.setDisplaySize(ob.width, ob.height);
        var audio = this.sound.add(__WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.feedback);
        audio.play();
    };
    CharacterFeedbackScene.prototype.createButton = function (ob) {
        var _this = this;
        var config = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.backgroundColor = __WEBPACK_IMPORTED_MODULE_0_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        config.smartSize = true;
        config.keyMapping = "keydown_RIGHT";
        var translatedText;
        if (__WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.id === 5 || __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.id === 2) {
            var name = __WEBPACK_IMPORTED_MODULE_3__utils_TranslateHelper__["a" /* default */].translate(__WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.name);
            translatedText = __WEBPACK_IMPORTED_MODULE_3__utils_TranslateHelper__["a" /* default */].translate("FitFive.Phaser.Thanks").replace("%name%", name);
        }
        else {
            translatedText = __WEBPACK_IMPORTED_MODULE_3__utils_TranslateHelper__["a" /* default */].translate("common.ok");
        }
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, ob.x, ob.y, ob.width, ob.height, '1 : ' + translatedText, config);
        button.setDisplaySize(button.width, button.getIdealButtonHeight());
        button.setX(this.dialogArea.x + this.dialogArea.width / 2 - button.width / 2);
        button.on('buttonClicked', function () {
            _this.responseSelected();
        });
        this.onKeydown(function () {
            _this.responseSelected();
        }, __WEBPACK_IMPORTED_MODULE_6_src_constants_KeyboardNumKeys__["a" /* numKeys */][0].keyCode, __WEBPACK_IMPORTED_MODULE_6_src_constants_KeyboardNumKeys__["a" /* numKeys */][0].altKeyCode);
    };
    CharacterFeedbackScene.prototype.responseSelected = function () {
        this.sound.stopAll();
        // Return to picture wall
        __WEBPACK_IMPORTED_MODULE_2_src_games_FitFiveGame_objects_GameState__["a" /* GameState */].current.currentNPC.picked = true;
        this.enablePictureWallSceneInput(true);
        this.scene.remove(this);
        this.scene.setVisible(true, "PictureWallScene");
        this.scene.resume("PictureWallScene");
    };
    CharacterFeedbackScene.prototype.enablePictureWallSceneInput = function (enabled) {
        this.scene.get("PictureWallScene").children.list.forEach(function (c) {
            if (c.input != null) {
                c.input.enabled = enabled;
            }
        });
    };
    CharacterFeedbackScene.prototype.onKeydown = function (event) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        keys.forEach(function (key) {
            _this.input.keyboard.on('keydown_' + key, event);
        });
    };
    return CharacterFeedbackScene;
}(Phaser.Scene));



/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/character_feedback.bea78e6b.json";

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "s";
        _this.gameClosingTextKey = "FitFive.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/picture_wall.b97ce987.json";

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/correct_icon.be465449.png";

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/fit_five_game.b62f9496.json";

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameFitFive.ad3eb612.png";

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameFitFive.37a55b46.json";

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gym.31621241.jpg";

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gym-zoomed-1.0f048044.jpg";

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gym-zoomed-2.a8b87f30.jpg";

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gym-zoomed-3.ff5dc874.jpg";

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gym-zoomed-4.4d394c0b.jpg";

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gym-zoomed-5.65374f75.jpg";

/***/ }),
/* 2389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnswerPatronQuestionScene__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_GameState__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Utils__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__objects_AlienPatron__ = __webpack_require__(528);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].HotelAurora;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__AnswerPatronQuestionScene__["a" /* AnswerPatronQuestionScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "HotelAurora.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "HotelAurora.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "HotelAurora.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    HowToPlayScene.prototype.create = function () {
        _super.prototype.create.call(this);
        // Initialized gamestate
        __WEBPACK_IMPORTED_MODULE_5__objects_Utils__["a" /* Utils */].scrambleResponses(__WEBPACK_IMPORTED_MODULE_6__objects_AlienPatron__["a" /* AlienPatron */].ALL_PATRONS[0]);
        __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current = new __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */]();
    };
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultsScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_AlienPatron__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnswerPatronQuestionScene__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_Utils__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_GameState__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var ResultsScene = /** @class */ (function (_super) {
    __extends(ResultsScene, _super);
    function ResultsScene() {
        var _this = _super.call(this, {
            key: "ResultsScene" + Math.random(),
        }) || this;
        _this.SCORE_THRESHOLD = 10;
        return _this;
    }
    ResultsScene.prototype.preload = function () {
        var _this = this;
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON("map", __webpack_require__(923));
        this.load.image('lobby_zoomed', __webpack_require__(2391));
        // Alien Patrons
        this.load.image('alien_1', __webpack_require__(287));
        this.load.image('alien_2', __webpack_require__(155));
        this.load.image('alien_3', __webpack_require__(168));
        var keys = [
            "HotelAurora.Phaser.ResultsScene.success1",
            "HotelAurora.Phaser.ResultsScene.success2",
            "HotelAurora.Phaser.ResultsScene.success3",
            "HotelAurora.Phaser.ResultsScene.tryAgain1",
            "HotelAurora.Phaser.ResultsScene.tryAgain2",
            "HotelAurora.Phaser.ResultsScene.tryAgain3"
        ];
        keys.forEach(function (key) {
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_9_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    ResultsScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_6_src_utils_BindThisHelper__["a" /* default */])(this, ResultsScene.prototype);
        this.initialize();
        this.generateScene();
        Object(__WEBPACK_IMPORTED_MODULE_7_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    ResultsScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
    };
    /**
     * Scene: Patron tells student whether or not they want to stay at Hotel Aurora
     * If they do, student can move on...
     * If they don't, student can start over by meeting a new AlienPatron
     */
    ResultsScene.prototype.generateScene = function () {
        var _this = this;
        this.background = this.add.image(0, 0, "lobby_zoomed");
        this.background.setOrigin(0);
        this.background.setDepth(0);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        var resultText, buttonText;
        var gameOver = false;
        var patron = __WEBPACK_IMPORTED_MODULE_0__objects_AlienPatron__["a" /* AlienPatron */].ALL_PATRONS[__WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.alienIndex];
        var translateString = "HotelAurora.Phaser.ResultsScene.";
        var key;
        if (__WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.score >= this.SCORE_THRESHOLD) {
            // Patron decided to stay at Hotel Aurora
            resultText = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "success" + patron.id);
            buttonText = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate("common.done");
            key = translateString + "success" + patron.id;
            gameOver = true;
        }
        else {
            // Choose not to stay
            resultText = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "tryAgain" + patron.id);
            buttonText = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(translateString + "tryAgainButton");
            key = translateString + "tryAgain" + patron.id;
        }
        var audio = this.sound.add(key);
        audio.play();
        this.map.getObjectLayer("Patron Decision Layer").objects.forEach(function (ob) {
            if (ob.name === "npc") {
                var patronImage = _this.add.image(ob.x, ob.y, "npc");
                patronImage.setOrigin(0);
                patronImage.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "dialog") {
                var text = __WEBPACK_IMPORTED_MODULE_2__objects_Utils__["a" /* Utils */].createDialog(_this, ob, resultText);
            }
            else if (ob.name === "button") {
                var config = __WEBPACK_IMPORTED_MODULE_2__objects_Utils__["a" /* Utils */].getButtonConfig();
                config.backgroundColor = __WEBPACK_IMPORTED_MODULE_8_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
                config.smartSize = true;
                config.keyMapping = "keydown_RIGHT";
                var button = new __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Button__["a" /* PhaserButton */](_this, ob.x, ob.y, ob.width, ob.height, buttonText, config);
                button.setX(_this.gameWidth - button.width - 50);
                button.on("buttonClicked", function () {
                    _this.input.enabled = false;
                    _this.sound.stopAll();
                    if (gameOver) {
                        // Game Over
                        _this.sys.game.onComplete();
                    }
                    else {
                        // Restart game with new patron
                        var newAlienIndex = (__WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.alienIndex + 1) % __WEBPACK_IMPORTED_MODULE_0__objects_AlienPatron__["a" /* AlienPatron */].ALL_PATRONS.length;
                        __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.alienIndex = newAlienIndex;
                        __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.dialogIndex = 0;
                        __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current.score = 0;
                        __WEBPACK_IMPORTED_MODULE_2__objects_Utils__["a" /* Utils */].scrambleResponses(__WEBPACK_IMPORTED_MODULE_0__objects_AlienPatron__["a" /* AlienPatron */].ALL_PATRONS[newAlienIndex]);
                        _this.scene.add("AnswerPatronQuestionScene", __WEBPACK_IMPORTED_MODULE_1__AnswerPatronQuestionScene__["a" /* AnswerPatronQuestionScene */], true);
                        _this.scene.remove(_this);
                    }
                });
            }
        });
    };
    return ResultsScene;
}(Phaser.Scene));



/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hotel_lobby_zoomed.0fcbc9d2.jpg";

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hotel_lobby.3e330784.jpg";

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hotel_desk.b52a6727.png";

/***/ }),
/* 2394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(925);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Warehouse;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "Warehouse.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Warehouse.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Item__ = __webpack_require__(2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_WarehouseGame_scenes_EndGameScene__ = __webpack_require__(2397);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene" + Math.random()
        }) || this;
        _this.debug = false; // Change to true if you want to see the polygons drawn
        _this.translateString = "Warehouse.Phaser.MainScene.";
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('map', __webpack_require__(2398));
        this.load.atlas("assets", __webpack_require__(2399), __webpack_require__(2400));
        this.load.json("shapes", __webpack_require__(2401));
        this.load.image("delete", __webpack_require__(519));
        this.load.image('background', __webpack_require__(2402));
    };
    MainScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        this.generateEvents();
        Object(__WEBPACK_IMPORTED_MODULE_2_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.items = [];
        this.shapes = this.cache.json.get("shapes");
    };
    MainScene.prototype.generateScene = function () {
        this.background = this.add.image(0, 0, "background");
        this.background.setOrigin(0);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.addObjects();
        this.addItems();
    };
    MainScene.prototype.generateEvents = function () {
        var _this = this;
        // Wire up events
        this.input.on('dragstart', function (pointer, gameObject) {
            var item = _this.getItemFromGameObject(gameObject);
            _this.children.bringToTop(item.object);
            item.object.setDisplaySize(item.placedWidth, item.placedHeight);
            _this.setCurrentPolygon(item);
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            var item = _this.getItemFromGameObject(gameObject);
            item.object.x = pointer.x - item.object.displayWidth / 2;
            item.object.y = pointer.y - item.object.displayHeight / 2;
        });
        this.input.on('dragend', function (pointer, gameObject, dropped) {
            var item = _this.getItemFromGameObject(gameObject);
            _this.setCurrentPolygon(item);
            if (_this.debug) {
                _this.drawPolygon(item.currentPolygon);
            }
            _this.checkItem(gameObject);
        });
    };
    MainScene.prototype.addObjects = function () {
        var _this = this;
        var layer = this.map.getObjectLayer('Objects');
        var config = new __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        config.smartSize = true;
        var buttonText, button;
        layer.objects.forEach(function (ob) {
            if (ob.name === "crate") {
                _this.crate = _this.add.image(ob.x, ob.y, "assets", ob.name);
                _this.crate.setOrigin(0);
                _this.crate.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "crateZone") {
                _this.crateZone = _this.add.zone(ob.x, ob.y, ob.width, ob.height);
                _this.crateZone.setOrigin(0);
                _this.crateZone.setInteractive();
            }
            else if (ob.name === "items") {
                var side = _this.add.image(ob.x, ob.y, "pixel");
                side.setOrigin(0);
                side.setDisplaySize(ob.width, ob.height);
                side.setTint(__WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY);
                var textStyle = { fontFamily: 'Russo One, Arial', color: "#ffffff", fontSize: 20, padding: 10 };
                var text = _this.add.text(0, 20, __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "moveItems"), textStyle);
                text.setWordWrapWidth(300, true);
                text.setX(side.x + side.displayWidth / 2 - text.width / 2);
            }
            else if (ob.name === "done") {
                buttonText = __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "buttonText");
                config.backgroundColor = __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
                _this.doneButton = new __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Button__["a" /* PhaserButton */](_this, ob.x, ob.y, ob.width, ob.height, buttonText, config);
                _this.doneButton.on('buttonClicked', function () {
                    if (_this.doneButton.isEnabled()) {
                        _this.enableEverything(false);
                        _this.tryToEndGame();
                    }
                });
            }
            else if (ob.name === "hint") {
                buttonText = __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate(_this.translateString + "hint");
                config.backgroundColor = __WEBPACK_IMPORTED_MODULE_1_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON;
                _this.hintButton = new __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Button__["a" /* PhaserButton */](_this, ob.x, ob.y, ob.width, ob.height, buttonText, config);
                _this.hintButton.on('buttonClicked', function () {
                    if (_this.hintButton.isEnabled()) {
                        _this.enableEverything(false);
                        _this.giveHint();
                    }
                });
            }
            else if (ob.name === "pilot") {
                var pilot = _this.add.image(ob.x, ob.y, "pilots", "c");
                pilot.setOrigin(0);
                pilot.setDisplaySize(ob.width, ob.height);
            }
        });
    };
    MainScene.prototype.addItems = function () {
        var _this = this;
        var layer = this.map.getObjectLayer("Items");
        layer.objects.forEach(function (ob) {
            var object = _this.add.image(ob.x, ob.y, "assets", ob.name);
            object.setOrigin(0);
            object.setDisplaySize(ob.width, ob.height);
            object.setInteractive(_this.shapes[ob.name]);
            object.setName(ob.name);
            var bounds = object.getBounds();
            var background = _this.add.image(bounds.x, bounds.y, "pixel");
            background.setOrigin(0);
            background.setTint(0x000000);
            background.setAlpha(0.3);
            background.setDisplaySize(bounds.width, bounds.height);
            background.setVisible(false);
            _this.children.moveDown(background);
            _this.input.setDraggable(object);
            var item = new __WEBPACK_IMPORTED_MODULE_5__objects_Item__["a" /* Item */](ob.name, ob.x, ob.y, ob.properties["placedWidth"], ob.properties["placedHeight"]);
            item.object = object;
            item.startHeight = ob.height;
            item.startWidth = ob.width;
            var polyPoints = [];
            for (var i = 0; i < _this.shapes[ob.name].fixtures[0].vertices.length; i++) {
                _this.shapes[ob.name].fixtures[0].vertices[i].forEach(function (v) {
                    polyPoints.push(new Phaser.Geom.Point(v.x, v.y));
                });
            }
            var sorted = _this.sortPoints(polyPoints);
            item.polygon = new Phaser.Geom.Polygon(sorted);
            _this.items.push(item);
        });
    };
    MainScene.prototype.drawPolygon = function (polygon) {
        var graphics = this.add.graphics();
        graphics.lineStyle(2, 0x000000);
        graphics.beginPath();
        graphics.moveTo(polygon.points[0].x, polygon.points[0].y);
        for (var j = 1; j < polygon.points.length; j++) {
            graphics.lineTo(polygon.points[j].x, polygon.points[j].y);
        }
        graphics.closePath();
        graphics.strokePath();
    };
    MainScene.prototype.checkItem = function (gameObject) {
        var item = this.getItemFromGameObject(gameObject);
        if (!this.isItemInCrateZone(item)) {
            item.successfullyPlaced = false;
            this.putItemBack(item);
            return;
        }
        if (this.isItemOverlappingWithOtherItems(item)) {
            item.successfullyPlaced = false;
            this.putItemBack(item);
            return;
        }
        // Mark this item as successfully placed
        item.successfullyPlaced = true;
    };
    MainScene.prototype.setCurrentPolygon = function (item) {
        var newPolyPoints = [];
        item.polygon.points.forEach(function (p) {
            var x = item.object.x + p.x * item.object.scaleX;
            var y = item.object.y + p.y * item.object.scaleY;
            newPolyPoints.push(new Phaser.Geom.Point(x, y));
        });
        item.currentPolygon = new Phaser.Geom.Polygon(newPolyPoints);
    };
    MainScene.prototype.putItemBack = function (item) {
        item.object.setPosition(item.startX, item.startY);
        item.object.setDisplaySize(item.startWidth, item.startHeight);
    };
    MainScene.prototype.isItemInCrateZone = function (item) {
        var union = Phaser.Geom.Rectangle.Union(this.crateZone.getBounds(), item.object.getBounds());
        if (Phaser.Geom.Rectangle.Perimeter(union) - Phaser.Geom.Rectangle.Perimeter(this.crateZone.getBounds()) <= 3) {
            return true;
        }
        else {
            // If they were close to the crate, shake the crate
            if (Phaser.Geom.Intersects.RectangleToRectangle(this.crate.getBounds(), item.object.getBounds())) {
                this.shakeObject(this.crate);
            }
            return false;
        }
    };
    MainScene.prototype.shakeObject = function (target) {
        this.add.tween({
            targets: target,
            x: target.x + 5,
            ease: "Bounce",
            duration: 50,
            repeat: 3,
            yoyo: true,
        });
    };
    MainScene.prototype.isItemOverlappingWithOtherItems = function (itemToCheck) {
        var item;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            item = _a[_i];
            if (this.doPolygonsOverlap(itemToCheck, item) && Phaser.Geom.Intersects.RectangleToRectangle(this.crate.getBounds(), item.object.getBounds())) {
                this.shakeObject(item.object);
                return true;
            }
        }
        return false;
    };
    MainScene.prototype.doPolygonsOverlap = function (item1, item2) {
        var poly1 = item1.currentPolygon;
        var poly2 = item2.currentPolygon;
        if (poly1 == null || poly2 == null || item1.name === item2.name) {
            return false;
        }
        var p;
        for (var _i = 0, _a = poly1.points; _i < _a.length; _i++) {
            p = _a[_i];
            if (poly2.contains(p.x, p.y)) {
                return true;
            }
        }
        return false;
    };
    MainScene.prototype.isGameOver = function () {
        var item;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            item = _a[_i];
            if (!item.successfullyPlaced) {
                return false;
            }
        }
        return true;
    };
    /**
     * Show one of a few different images of the crate correctly packed
     */
    MainScene.prototype.giveHint = function () {
        var _this = this;
        var imageBackground = this.add.image(0, 0, "pixel");
        imageBackground.setOrigin(0);
        imageBackground.setTint(0x000000);
        imageBackground.setDisplaySize(this.crate.displayWidth + 20, this.crate.displayHeight + 20);
        imageBackground.setPosition(this.crate.x - 10, this.crate.y - 10);
        var hintImage = this.add.image(0, 0, "assets", "solution" + Phaser.Math.Between(1, 3));
        hintImage.setOrigin(0);
        hintImage.setDisplaySize(this.crate.displayWidth, this.crate.displayHeight);
        hintImage.setPosition(this.crate.x, this.crate.y);
        var textStyle = { fontFamily: 'Russo One, Arial', color: "#ffffff", fontSize: 20, padding: 10 };
        var text = this.add.text(0, imageBackground.getTopLeft().y + 10, __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "hintText"), textStyle);
        text.setX(imageBackground.x + imageBackground.displayWidth / 2 - text.width / 2);
        var exitButton = this.add.image(0, 0, "delete");
        exitButton.setOrigin(0);
        exitButton.setDisplaySize(50, 50);
        exitButton.setInteractive({ useHandCursor: true });
        exitButton.setPosition(imageBackground.getTopRight().x + exitButton.displayWidth - 10, imageBackground.y);
        this.enableEverything(false);
        exitButton.on('pointerdown', function () {
            hintImage.destroy();
            text.destroy();
            imageBackground.destroy();
            exitButton.destroy();
            _this.enableEverything(true);
        });
    };
    MainScene.prototype.enableEverything = function (enabled) {
        this.doneButton.setEnabled(enabled);
        this.hintButton.setEnabled(enabled);
        this.items.forEach(function (i) {
            i.object.input.enabled = enabled;
        });
    };
    MainScene.prototype.tryToEndGame = function () {
        var _this = this;
        var config = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
        config.buttonWidth = 100;
        var modal, options;
        if (this.isGameOver()) {
            this.input.setDefaultCursor("default");
            this.input.removeAllListeners();
            this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_6_src_games_WarehouseGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
            this.scene.remove(this);
        }
        else {
            var buttonConfig = new __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
            buttonConfig.smartSize = true;
            config.buttonConfig = buttonConfig;
            config.title = __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "notDoneText");
            options = [{ displayText: __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + "ok"), id: 1 }];
            config.buttonWidth = 100;
            modal = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, options, config);
            modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
            modal.on('optionClicked', function (op) {
                _this.enableEverything(true);
                modal.destroy();
            });
        }
    };
    MainScene.prototype.getItemFromGameObject = function (gameObject) {
        var item = this.items.find(function (i) {
            return i.name === gameObject.name;
        });
        return item;
    };
    /**
     * Sorts the points in counter-clockwise
     * Source: https://stackoverflow.com/questions/45660743/sort-points-in-counter-clockwise-in-javascript
     */
    MainScene.prototype.sortPoints = function (points) {
        points.sort(function (a, b) { return a.y - b.y; });
        // Get center y
        var cy = (points[0].y + points[points.length - 1].y) / 2;
        // Sort from right to left
        points.sort(function (a, b) { return b.x - a.x; });
        // Get center x
        var cx = (points[0].x + points[points.length - 1].x) / 2;
        // Center point
        var center = { x: cx, y: cy };
        // Starting angle used to reference other angles
        var startAng;
        points.forEach(function (point) {
            var ang = Math.atan2(point.y - center.y, point.x - center.x);
            if (!startAng) {
                startAng = ang;
            }
            else {
                if (ang < startAng) { // ensure that all points are clockwise of the start point
                    ang += Math.PI * 2;
                }
            }
            point.angle = ang; // add the angle to the point
        });
        // Sort clockwise;
        points.sort(function (a, b) { return a.angle - b.angle; });
        return points;
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Item; });
var Item = /** @class */ (function () {
    function Item(name, startX, startY, placedWidth, placedHeight) {
        this.name = name;
        this.startX = startX;
        this.startY = startY;
        this.placedHeight = placedHeight;
        this.placedWidth = placedWidth;
        this.successfullyPlaced = false;
    }
    return Item;
}());



/***/ }),
/* 2397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "c";
        _this.gameClosingTextKey = "Warehouse.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/warehouse_game.7554bb33.json";

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameWarehouse.81cf5cf7.png";

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameWarehouse.925bdf18.json";

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameWarehousePhysics.4fbc5dba.json";

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/planet_c_top.c6d54bef.jpg";

/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_GameState__ = __webpack_require__(929);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].RocketRepair;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "RocketRepair.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "RocketRepair.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "RocketRepair.Phaser.HowToPlay.tabletInstructions";
        __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */].current = new __WEBPACK_IMPORTED_MODULE_4__objects_GameState__["a" /* GameState */]();
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_RocketPart__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_ToolBin__ = __webpack_require__(2417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_games_RocketRepairGame_scenes_EndGameScene__ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene" + Math.random()
        }) || this;
        _this.beltDistance = 1200;
        _this.debug = false;
        _this.id = 1;
        _this.assemblyAssets = [
            __webpack_require__(2419),
            __webpack_require__(2420),
            __webpack_require__(2421),
            __webpack_require__(2422),
            __webpack_require__(2423),
            __webpack_require__(2424),
            __webpack_require__(2425),
            __webpack_require__(2426),
            __webpack_require__(2427),
            __webpack_require__(2428),
            __webpack_require__(2429),
            __webpack_require__(2430),
            __webpack_require__(2431),
        ];
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image('background', __webpack_require__(2432));
        this.load.tilemapTiledJSON("map", __webpack_require__(2433));
        this.load.spritesheet("button", __webpack_require__(2434), { frameWidth: 275, frameHeight: 110 });
        this.load.image('box', __webpack_require__(2435));
        this.load.spritesheet("belt", __webpack_require__(2436), { frameWidth: 1360, frameHeight: 115 });
        this.load.spritesheet("bin", __webpack_require__(2437), { frameWidth: 400, frameHeight: 150 });
        this.load.spritesheet("monitor", __webpack_require__(2438), { frameWidth: 118, frameHeight: 95 });
        this.load.spritesheet("items", __webpack_require__(2439), { frameWidth: 80, frameHeight: 95 });
        // Component and Assembly spritesheets
        var i = 1;
        for (var _i = 0, _a = this.assemblyAssets; _i < _a.length; _i++) {
            var assembly = _a[_i];
            this.load.spritesheet("assembly" + i, assembly, { frameWidth: 990, frameHeight: 550 });
            i++;
        }
        for (var _b = 0, _c = __WEBPACK_IMPORTED_MODULE_1__objects_RocketPart__["a" /* RocketPart */].ROCKET_PARTS; _b < _c.length; _b++) {
            var part = _c[_b];
            this.load.spritesheet(part.name, part.src, { frameWidth: part.frameWidth, frameHeight: part.frameHeight });
        }
        this.loadAudio();
    };
    MainScene.prototype.loadAudio = function () {
        var _this = this;
        var soundbits = ["tooLittleScrews", "tooManyScrews", "tooLittleBolts", "tooManyBolts", "correct"];
        soundbits.forEach(function (soundKey) {
            var key = "RocketRepair.Phaser." + soundKey;
            _this.load.audio(key, __WEBPACK_IMPORTED_MODULE_9__constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(key, __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
        });
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "map" });
        this.boxes = [];
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background");
        background.setOrigin(0);
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.addObjects();
        this.registerEvents();
        Object(__WEBPACK_IMPORTED_MODULE_6__shared_InteractiveCursorUtil__["a" /* default */])(this);
        // Start game by moving everything along the conveyor belt
        this.movePartIn();
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.dragDistanceThreshold = 10;
        this.input.on('dragstart', function (pointer, box) {
            _this.children.bringToTop(box);
        });
        if (this.debug) {
            this.input.on('dragenter', function (pointer, box, dropzone) {
                dropzone.setTint(__WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("blue"));
            });
            this.input.on('dragleave', function (pointer, box, dropzone) {
                dropzone.setTint(__WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].COLORS.get("light grey"));
            });
        }
        this.input.on('drag', function (pointer, box, dragX, dragY) {
            box.x = dragX;
            box.y = dragY;
        });
        this.input.on('dragend', function (pointer, box, dropped) {
            if (!dropped) {
                _this.putBack(box);
            }
        });
        this.input.on('drop', function (pointer, box, toolBin) {
            // If it's in the toolBin, add it to the items
            _this.addBoxToToolBin(box);
        });
    };
    MainScene.prototype.addObjects = function () {
        var _this = this;
        this.map.getObjectLayer('Objects').objects.forEach(function (ob) {
            if (ob.name === "belt") {
                _this.conveyorBelt = _this.add.sprite(0, ob.y, "belt", 0);
                _this.conveyorBelt.setOrigin(0);
                _this.anims.create({
                    key: "moveBelt",
                    frames: _this.anims.generateFrameNumbers("belt", { start: 0, end: 4 }),
                    frameRate: 14,
                    repeat: 8
                });
            }
            else if (ob.name === "part") {
                _this.partOb = ob;
                _this.createPart();
            }
            else if (ob.name === "bin") {
                _this.binOb = ob;
                _this.createToolBin();
            }
            else if (ob.name === "button") {
                _this.button = _this.add.sprite(ob.x, ob.y, "button", 1);
                _this.button.setOrigin(0);
                _this.button.setInteractive({ useHandCursor: true });
                _this.button.on('pointerover', function () {
                    _this.button.setFrame(0);
                });
                _this.button.on('pointerout', function () {
                    _this.button.setFrame(1);
                });
                _this.button.on('pointerdown', function () {
                    if (_this.tweens.isTweening(_this.part)) {
                        return;
                    }
                    _this.button.disableInteractive();
                    _this.checkCount();
                });
            }
            else if (ob.name === "parts_box") {
                var partsBox = _this.add.image(ob.x, ob.y, "box");
                partsBox.setOrigin(0);
            }
            else if (ob.name === "assembly") {
                _this.ship = _this.add.sprite(ob.x, ob.y, __WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].current.shipTexture, 0);
                _this.ship.setOrigin(0);
                _this.anims.create({
                    key: "flashy_" + __WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].current.shipTexture,
                    frames: _this.anims.generateFrameNumbers(__WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].current.shipTexture, { start: 0, end: 1 }),
                    frameRate: 2,
                    repeat: -1,
                });
                _this.ship.anims.play('flashy_' + __WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].current.shipTexture);
            }
            else if (ob.name === "monitor") {
                var monitor = _this.add.sprite(ob.x, ob.y, "monitor", 0);
                monitor.setOrigin(0);
                _this.anims.create({
                    key: "monitorCursor",
                    frames: _this.anims.generateFrameNumbers("monitor", { start: 0, end: 1 }),
                    frameRate: 2,
                    repeat: -1
                });
                monitor.anims.play("monitorCursor");
            }
        });
        this.createBoxes();
    };
    MainScene.prototype.createBoxes = function () {
        var _this = this;
        this.map.getObjectLayer("Items").objects.forEach(function (ob) {
            var config = {
                frame: ob.properties["frame"],
                count: ob.properties["count"],
                type: ob.properties["type"],
            };
            // Placeholder - static image of the box
            var placeholder = _this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "items", config.frame);
            // Only one actual draggable box
            var box = new __WEBPACK_IMPORTED_MODULE_3__objects_ToolBin__["a" /* Box */](_this, ob.x + ob.width / 2, ob.y + ob.height / 2, config, _this.id++);
            _this.boxes.push(box);
        });
    };
    MainScene.prototype.checkCount = function () {
        var correctScrewCount = this.part.screws;
        var correctBoltCount = this.part.bolts;
        if (this.bin.screwCount < correctScrewCount) {
            this.modal("tooLittleScrews", "tryAgain");
        }
        else if (this.bin.screwCount > correctScrewCount) {
            this.modal("tooManyScrews", "tryAgain");
        }
        else if (this.bin.boltCount < correctBoltCount) {
            this.modal("tooLittleBolts", "tryAgain");
        }
        else if (this.bin.boltCount > correctBoltCount) {
            this.modal("tooManyBolts", "tryAgain");
        }
        else {
            // Move on to next part
            this.modal("correct", "next", true);
        }
    };
    MainScene.prototype.putBack = function (box) {
        if (box.inToolBin) {
            this.removeBoxFromToolBin(box);
        }
        this.tweens.add({
            targets: box,
            x: box.pilePosition.x,
            y: box.pilePosition.y,
            duration: 800,
            ease: Phaser.Math.Easing.Back.Out,
        });
    };
    MainScene.prototype.nextPart = function () {
        var _this = this;
        // Change current game state
        var gameOver = __WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].getNextPart();
        this.updateShip();
        if (gameOver) {
            setTimeout(function () {
                _this.input.setDefaultCursor("default");
                _this.input.removeAllListeners();
                _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_8_src_games_RocketRepairGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
                _this.scene.remove(_this);
            }, 2000);
        }
        else {
            this.createPart();
            this.createToolBin();
            this.movePartIn();
        }
    };
    MainScene.prototype.updateShip = function () {
        this.ship.anims.stop();
        this.ship.setTexture(__WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].current.shipTexture, 0);
        this.anims.create({
            key: "flashy_" + __WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].current.shipTexture,
            frames: this.anims.generateFrameNumbers(__WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].current.shipTexture, { start: 0, end: 1 }),
            frameRate: 2,
            repeat: -1,
        });
        this.ship.anims.play('flashy_' + __WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].current.shipTexture);
    };
    /**
     * Creates a tool bin as a custom dropzone
     */
    MainScene.prototype.createToolBin = function () {
        var ob = this.binOb;
        this.bin = new __WEBPACK_IMPORTED_MODULE_3__objects_ToolBin__["b" /* ToolBin */](this, ob, "bin");
        this.bin.x -= this.beltDistance;
        this.bin.actualX = ob.x + ob.width / 2;
    };
    MainScene.prototype.createPart = function () {
        var partConfig = __WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].current.partConfig;
        var x = this.binOb.x - partConfig.frameWidth - 50;
        var y = this.bin.y - partConfig.frameHeight / 2;
        // Big wings - adjusted position to keep from covering boxes
        if (partConfig.id === 12) {
            x = this.binOb.x - partConfig.frameHeight - 50;
            y = this.binOb.y + partConfig.frameWidth / 2;
        }
        this.part = new __WEBPACK_IMPORTED_MODULE_1__objects_RocketPart__["a" /* RocketPart */](this, x - this.beltDistance, y, __WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_objects_GameState__["a" /* GameState */].current.partConfig);
    };
    MainScene.prototype.removeBoxFromToolBin = function (box) {
        box.inToolBin = false;
        box.type === "Screw" ? this.bin.screwCount -= box.count : this.bin.boltCount -= box.count;
        var boxToRemove = this.bin.boxes.findIndex(function (b) { return b.id === box.id; });
        this.bin.boxes.splice(boxToRemove, 1);
    };
    MainScene.prototype.addBoxToToolBin = function (box) {
        if (box.inToolBin) {
            return;
        }
        // Create a new box inside the bin
        var newBox = new __WEBPACK_IMPORTED_MODULE_3__objects_ToolBin__["a" /* Box */](this, box.x, this.bin.y, box.config, this.id++);
        newBox.pilePosition = box.pilePosition;
        this.boxes.push(newBox);
        // Put back the actual box
        box.x = box.pilePosition.x;
        box.y = box.pilePosition.y;
        newBox.inToolBin = true;
        newBox.type === "Screw" ? this.bin.screwCount += newBox.count : this.bin.boltCount += newBox.count;
        this.bin.boxes.push(newBox);
    };
    MainScene.prototype.modal = function (textKey, buttonKey, moveOn) {
        var _this = this;
        var key = "RocketRepair.Phaser." + textKey;
        var text = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate(key);
        var sound = this.sound.add(key);
        if (sound.duration) {
            sound.play();
        }
        var buttonConfig = {
            smartSize: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON
        };
        var config = {
            title: text,
            buttonWidth: 200,
            buttonConfig: buttonConfig
        };
        var buttonText = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate("RocketRepair.Phaser." + buttonKey);
        var options = [{ id: 1, displayText: buttonText }];
        var modal = new __WEBPACK_IMPORTED_MODULE_7_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, options, config);
        modal.setDepth(10);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
        modal.on("optionClicked", function () {
            modal.destroy();
            _this.button.setInteractive();
            if (moveOn) {
                // They got it right, so go to the next part
                _this.movePartOut();
            }
        });
    };
    /**
     *  Move everything on conveyor belt to the right
     */
    MainScene.prototype.movePartOut = function () {
        var _this = this;
        this.disableEverything();
        var targets = [this.part, this.bin];
        this.bin.boxes.forEach(function (i) { return targets.push(i); });
        this.conveyorBelt.anims.play("moveBelt");
        this.tweens.add({
            targets: targets,
            x: "+=" + this.beltDistance,
            ease: "Linear",
            duration: 3000,
            onComplete: function () {
                _this.part.destroy();
                _this.bin.destroy();
                _this.nextPart();
            }
        });
    };
    /**
     * Move everything on conveyor belt from the left
     */
    MainScene.prototype.movePartIn = function () {
        var _this = this;
        var targets = [this.part, this.bin];
        this.disableEverything();
        this.conveyorBelt.anims.play("moveBelt");
        this.tweens.add({
            targets: targets,
            x: "+=" + this.beltDistance,
            ease: "Linear",
            duration: 3000,
            onComplete: function () {
                _this.enableEverything();
            }
        });
    };
    MainScene.prototype.enableEverything = function () {
        this.button.setInteractive();
        this.boxes.forEach(function (box) {
            box.input.enabled = true;
        });
    };
    MainScene.prototype.disableEverything = function () {
        this.button.disableInteractive();
        this.boxes.forEach(function (box) {
            box.input.enabled = false;
        });
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component1.181e8d70.png";

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component2.f92423fc.png";

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component3.6d2f636a.png";

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component4.dd5334d8.png";

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component5.449e8b24.png";

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component6.3ac93712.png";

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component7.a60d0a91.png";

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component8.567f4b4d.png";

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component9.399668fe.png";

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component10.b668f7bf.png";

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component11.8a59b6c1.png";

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/component12.1e06a3da.png";

/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ToolBin; });
/* unused harmony export BoxConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Box; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ToolBin = /** @class */ (function (_super) {
    __extends(ToolBin, _super);
    function ToolBin(scene, ob, texture) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, texture, 0) || this;
        _this.boxes = [];
        _this.screwCount = 0;
        _this.boltCount = 0;
        // Set as a dropzone
        _this.setInteractive();
        _this.input.dropZone = true;
        scene.add.existing(_this);
        return _this;
    }
    return ToolBin;
}(Phaser.GameObjects.Sprite));

var BoxConfig = /** @class */ (function () {
    function BoxConfig() {
    }
    return BoxConfig;
}());

var Box = /** @class */ (function (_super) {
    __extends(Box, _super);
    function Box(scene, x, y, config, id) {
        var _this = _super.call(this, scene, x, y, "items", config.frame) || this;
        _this.config = config;
        _this.id = id;
        _this.type = config.type;
        _this.count = config.count;
        _this.inToolBin = false;
        _this.setInteractive();
        _this.pilePosition = new Phaser.Geom.Point(x, y);
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    return Box;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "r";
        _this.gameClosingTextKey = "RocketRepair.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(155));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly1.1a60f293.png";

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly2.bfbff7df.png";

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly3.2e6dd537.png";

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly4.5a51646d.png";

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly5.86dafd64.png";

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly6.b67de053.png";

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly7.ca4d5c30.png";

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly8.9e36a423.png";

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly9.9e36a423.png";

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly10.2963dc93.png";

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly11.3dbb7b4c.png";

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly12.5ec3e6a2.png";

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/assembly13.8e242daf.png";

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2r_background.ceeec3d9.png";

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/rocket_repair.6afa90bf.json";

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/button.16d1415f.png";

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/parts_box.cf8c8f17.png";

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/conveyor.858098ae.png";

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bin.7ace881c.png";

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/monitor.ade84bc0.png";

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/parts.af02afe4.png";

/***/ }),
/* 2440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(931);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].ProgramRobot;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "ProgramRobot.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "ProgramRobot.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "ProgramRobot.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_CommandSlot__ = __webpack_require__(2442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_Command__ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_ProgramRobotGame_objects_Arrow__ = __webpack_require__(2444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_games_ProgramRobotGame_scenes_EndGameScene__ = __webpack_require__(2445);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('map', __webpack_require__(2446));
        this.load.image('background', __webpack_require__(2447));
        this.load.spritesheet("buttons", __webpack_require__(2448), { frameWidth: 88, frameHeight: 88 });
        this.load.spritesheet("robot", __webpack_require__(2449), { frameWidth: 105, frameHeight: 250 });
        this.load.spritesheet("flames", __webpack_require__(2450), { frameWidth: 285, frameHeight: 363 });
        this.load.spritesheet("spaceship", __webpack_require__(2451), { frameWidth: 285, frameHeight: 363 });
        this.load.image('console', __webpack_require__(2452));
        this.load.image('crystal', __webpack_require__(2453));
    };
    MainScene.prototype.initialize = function () {
        this.map = this.make.tilemap({ key: 'map' });
        this.commandSlots = [];
        this.commands = [];
        this.arrows = [];
        this.openingDoor = false;
        this.gameOver = false;
    };
    MainScene.prototype.create = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.initialize();
        var background = this.add.image(0, 0, "background");
        background.setOrigin(0);
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.createScene();
        this.addArrows();
        this.addCommandSlots();
        this.registerEvents();
        Object(__WEBPACK_IMPORTED_MODULE_1__shared_InteractiveCursorUtil__["a" /* default */])(this);
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.on('dragstart', function (pointer, gameObject) {
            _this.children.bringToTop(gameObject);
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
        this.input.on('dragend', function (pointer, gameObject, dropped) {
            if (!dropped) {
                var arrow = _this.getArrow(gameObject);
                _this.putArrowBackInPile(arrow);
            }
        });
        this.input.on('drop', function (pointer, gameObject, commandSlot) {
            _this.children.bringToTop(gameObject);
            var arrow = _this.getArrow(gameObject);
            _this.acceptArrowInSlot(arrow, commandSlot);
        });
    };
    /**
     * Adds up, down, left, right arrows as "pick up zones"
     * Actually just an image and a draggable image
     */
    MainScene.prototype.addArrows = function () {
        var _this = this;
        var arrowId = 0;
        this.map.getObjectLayer("Pickup").objects.forEach(function (ob) {
            var frame, id;
            if (ob.name === "up") {
                frame = 0;
                id = 1;
            }
            else if (ob.name === "down") {
                frame = 2;
                id = 2;
            }
            else if (ob.name === "left") {
                frame = 3;
                id = 3;
            }
            else if (ob.name === "right") {
                frame = 1;
                id = 4;
            }
            // Picture of the arrow that doesn't move
            var placeholderArrow = _this.add.image(ob.x, ob.y, "buttons", frame);
            placeholderArrow.setOrigin(0);
            // Draggable arrow on top
            var object = _this.add.image(ob.x, ob.y, "buttons", frame);
            object.setOrigin(0);
            object.setName("arrow" + arrowId);
            object.type = ob.name;
            object.setInteractive();
            object.setDataEnabled();
            _this.input.setDraggable(object);
            var command = new __WEBPACK_IMPORTED_MODULE_3__objects_Command__["a" /* Command */](id, ob.name, new Phaser.Geom.Point(placeholderArrow.x, placeholderArrow.y));
            var arrow = new __WEBPACK_IMPORTED_MODULE_7_src_games_ProgramRobotGame_objects_Arrow__["a" /* Arrow */](arrowId, command, object);
            _this.arrows.push(arrow);
            _this.commands.push(command);
            arrowId++;
        });
    };
    /**
     * Adds CommandSlots (Zones) labeled with index, starting as "unfilled"
     */
    MainScene.prototype.addCommandSlots = function () {
        var _this = this;
        var i = 1;
        this.map.getObjectLayer('Answers').objects.forEach(function (ob) {
            var commandSlot = new __WEBPACK_IMPORTED_MODULE_2__objects_CommandSlot__["a" /* CommandSlot */](_this, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height, i);
            commandSlot.setCircleDropZone(88);
            commandSlot.filled = false;
            commandSlot.setName("slot" + i);
            var image = _this.add.image(commandSlot.x, commandSlot.y, "buttons", 0);
            image.setVisible(false);
            commandSlot.image = image;
            // Show index of command on the answer slot
            var style = { fontSize: 38, fontFamily: "Russo One, Arial" };
            var commandIndex = _this.add.text(ob.x, ob.y, i + "", style);
            commandSlot.textObject = commandIndex;
            Phaser.Display.Align.In.Center(commandIndex, commandSlot);
            _this.commandSlots.push(commandSlot);
            i++;
        });
    };
    MainScene.prototype.acceptedArrow = function (arrow, commandSlot) {
        return (!commandSlot.filled) ||
            (commandSlot.filled && arrow.command.direction !== commandSlot.arrow.command.direction);
    };
    /**
     * Called when a CommandSlot has accepted an arrow
     */
    MainScene.prototype.acceptArrowInSlot = function (arrow, commandSlot) {
        // Either it's not filled yet, or it already has the same arrow there
        if (!commandSlot.filled || (commandSlot.filled && commandSlot.arrow.command.direction === arrow.command.direction)) {
            arrow.object.x = arrow.command.pilePosition.x;
            arrow.object.y = arrow.command.pilePosition.y;
        }
        // It's filled and has a different arrow there
        else if (commandSlot.filled && commandSlot.arrow.command.direction !== arrow.command.direction) {
            // Put it back in the pile
            this.putArrowBackInPile(arrow);
        }
        // Update this slot
        commandSlot.arrow = arrow;
        commandSlot.filled = true;
        commandSlot.image.setFrame(arrow.object.frame.name);
        commandSlot.image.setVisible(true);
        this.children.bringToTop(commandSlot.image);
        // Update this arrow
        arrow.slot = commandSlot;
    };
    MainScene.prototype.putArrowBackInPile = function (arrow) {
        var goTox, goToy;
        goTox = arrow.command.pilePosition.x;
        goToy = arrow.command.pilePosition.y;
        var object = arrow.object;
        // Put the arrow back
        if (!this.tweens.isTweening(object)) {
            this.tweens.add({
                targets: object,
                x: goTox,
                y: goToy,
                duration: 800,
                ease: Phaser.Math.Easing.Back.Out,
            });
        }
    };
    MainScene.prototype.createScene = function () {
        var _this = this;
        var consoleArea = this.add.image(0, 0, "console");
        consoleArea.setOrigin(0);
        consoleArea.setY(this.gameHeight - consoleArea.height);
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "robot") {
                _this.robot = _this.add.sprite(ob.x, ob.y, "robot", 0);
                _this.robot.setOrigin(0);
                _this.robot.setScale(0.5);
                _this.anims.create({
                    key: "bob",
                    frames: _this.anims.generateFrameNumbers("robot", { start: 0, end: 4 }),
                    frameRate: 4,
                    repeat: -1,
                });
                _this.robot.anims.play("bob");
                _this.anims.create({
                    key: "turn",
                    frames: [
                        { key: "robot", frame: 0 },
                        { key: "robot", frame: 5 },
                        { key: "robot", frame: 15 },
                    ],
                    frameRate: 8
                });
            }
            else if (ob.name === "spaceship") {
                _this.spaceship = _this.add.sprite(ob.x, ob.y, "spaceship", 6);
                _this.spaceship.setOrigin(0);
                _this.anims.create({
                    key: "openDoor",
                    frames: [
                        { key: "spaceship", frame: 6 },
                        { key: "spaceship", frame: 5 },
                        { key: "spaceship", frame: 4 },
                        { key: "spaceship", frame: 3 },
                        { key: "spaceship", frame: 2 },
                        { key: "spaceship", frame: 1 },
                        { key: "spaceship", frame: 0 },
                    ],
                    frameRate: 8
                });
                _this.spaceship.on("animationcomplete", function () {
                    setTimeout(function () {
                        // End game
                        _this.gameOver = true;
                        _this.input.setDefaultCursor("default");
                        _this.input.removeAllListeners();
                        _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_8_src_games_ProgramRobotGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
                        _this.scene.remove(_this);
                    }, 1000);
                });
            }
            else if (ob.name === "button") {
                _this.doneButton = _this.add.sprite(ob.x, ob.y, "buttons", 5);
                _this.doneButton.setOrigin(0);
                _this.doneButton.setInteractive({ useHandCursor: true });
                _this.doneButton.on("pointerover", function () {
                    _this.doneButton.setFrame(4);
                });
                _this.doneButton.on("pointerout", function () {
                    _this.doneButton.setFrame(5);
                });
                _this.doneButton.on("pointerdown", function () {
                    _this.doneButton.disableInteractive();
                    _this.checkCommands();
                });
            }
            else if (ob.name === "remove") {
                _this.deleteArea = new Phaser.Geom.Rectangle(ob.x, ob.y, ob.width, ob.height);
            }
            else if (ob.name === "crystal") {
                var crystal = _this.add.image(ob.x, ob.y, "crystal");
                crystal.setOrigin(0);
                crystal.setDepth(5);
            }
        });
    };
    MainScene.prototype.getArrow = function (gameObject) {
        var arrow = this.arrows.find(function (ar) { return "arrow" + ar.arrowId === gameObject.name; });
        return arrow;
    };
    MainScene.prototype.drawPolygon = function (polygon) {
        var graphics = this.add.graphics();
        graphics.fillStyle(0x000000, 1);
        graphics.beginPath();
        graphics.moveTo(polygon.points[0].x, polygon.points[0].y);
        for (var j = 1; j < polygon.points.length; j++) {
            graphics.lineTo(polygon.points[j].x, polygon.points[j].y);
        }
        graphics.closePath();
        graphics.fillPath();
    };
    MainScene.prototype.checkCommands = function () {
        var correctCommands = __WEBPACK_IMPORTED_MODULE_3__objects_Command__["a" /* Command */].CORRECT_COMMANDS;
        if (this.getNumberOfCommands() !== correctCommands.length) {
            // Need to fill in more commands
            this.modal("incomplete");
            return;
        }
        for (var i = 0; i < correctCommands.length; i++) {
            if (this.commandSlots[i].arrow.command.id !== correctCommands[i].id) {
                // Incorrect command
                this.modal('incorrect', false, true);
                return;
            }
        }
        this.modal("correct", true, false);
    };
    /**
     * Will go through the student's commands and remove the wrong ones but keep the correct ones
     */
    MainScene.prototype.removeWrongOnes = function () {
        var correctCommands = __WEBPACK_IMPORTED_MODULE_3__objects_Command__["a" /* Command */].CORRECT_COMMANDS;
        for (var i = 0; i < correctCommands.length; i++) {
            var commandSlot = this.commandSlots[i];
            if (commandSlot.arrow.command.id !== correctCommands[i].id) {
                // Incorrect command
                commandSlot.image.setVisible(false);
                commandSlot.arrow = null;
                commandSlot.filled = false;
            }
        }
    };
    MainScene.prototype.getNumberOfCommands = function () {
        var count = 0;
        this.commandSlots.forEach(function (cs) {
            if (cs.filled) {
                count++;
            }
        });
        return count;
    };
    MainScene.prototype.modal = function (translationKey, correct, helpPlayer) {
        var _this = this;
        var text = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate("ProgramRobot.Phaser." + translationKey);
        var buttonConfig = {
            smartSize: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON
        };
        var config = {
            title: text,
            buttonWidth: 200,
            buttonConfig: buttonConfig
        };
        var buttonText;
        if (translationKey === "correct") {
            buttonText = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate("ProgramRobot.Phaser.run");
        }
        else {
            buttonText = __WEBPACK_IMPORTED_MODULE_5_src_utils_TranslateHelper__["a" /* default */].translate("ProgramRobot.Phaser.tryAgain");
        }
        var options = [{ id: 1, displayText: buttonText }];
        var modal = new __WEBPACK_IMPORTED_MODULE_6__shared_Modal__["a" /* PhaserModal */](this, 0, 0, options, config);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
        modal.on("optionClicked", function () {
            modal.destroy();
            _this.doneButton.setInteractive();
            if (helpPlayer) {
                _this.removeWrongOnes();
            }
            if (correct) {
                // Game is over, play animation of robot
                _this.playAnimation();
            }
        });
    };
    MainScene.prototype.playAnimation = function () {
        var _this = this;
        this.disableEverything();
        this.children.bringToTop(this.robot);
        this.map.getObjectLayer("Path").objects.forEach(function (ob) {
            _this.points = [];
            _this.points = ob["polyline"];
            _this.points.forEach(function (p) {
                p.x += ob.x;
                p.y += ob.y;
            });
            var robotPath = new Phaser.Curves.Path(_this.robot.x + _this.robot.displayWidth / 2, _this.robot.y + _this.robot.displayHeight);
            robotPath.splineTo(_this.points);
            _this.follower = _this.add.follower(robotPath, _this.robot.x + _this.robot.displayWidth / 2, _this.robot.y + _this.robot.displayHeight / 2, "robot", 0);
            _this.follower.setDepth(3);
            _this.follower.setScale(0.5);
            _this.robot.setVisible(false);
            _this.anims.play("turn", _this.follower);
            _this.follower.on("animationcomplete", function () {
                _this.follower.startFollow({
                    duration: 10000,
                });
                _this.follower.stopFollow();
            });
        });
    };
    MainScene.prototype.update = function () {
        if (this.gameOver) {
            return;
        }
        if (this.follower != null) {
            if (this.follower.isFollowing()) {
                this.animateRobotAndSpaceShip();
            }
        }
    };
    MainScene.prototype.animateRobotAndSpaceShip = function () {
        if ((this.follower.x > 95 && this.follower.x < 370) ||
            (this.follower.x > 400 && this.follower.x < 675) ||
            (this.follower.x > 713 && this.follower.x < 988) ||
            (this.follower.x > 1015 && this.follower.x < 1175)) {
            this.follower.setFrame(5);
        }
        if ((this.follower.x < 95) ||
            (this.follower.x > 370 && this.follower.x < 400) ||
            (this.follower.x > 1175)) {
            this.follower.setFrame(15);
        }
        if ((this.follower.x > 675 && this.follower.x < 713) ||
            (this.follower.x > 988 && this.follower.x < 1015)) {
            this.follower.setFrame(0);
        }
        if (this.follower.x > 1015 && !this.openingDoor) {
            this.spaceship.anims.play("openDoor");
            this.openingDoor = true;
        }
    };
    MainScene.prototype.disableEverything = function () {
        this.doneButton.disableInteractive();
        this.arrows.forEach(function (a) {
            a.object.input.enabled = false;
        });
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommandSlot; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CommandSlot = /** @class */ (function (_super) {
    __extends(CommandSlot, _super);
    function CommandSlot(scene, x, y, width, height, index) {
        var _this = _super.call(this, scene, x, y, width, height) || this;
        _this.index = index;
        _this.filled = false;
        return _this;
    }
    return CommandSlot;
}(Phaser.GameObjects.Zone));



/***/ }),
/* 2443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Command; });
var Command = /** @class */ (function () {
    function Command(id, direction, pilePosition) {
        this.id = id;
        this.direction = direction;
        this.pilePosition = pilePosition;
    }
    // up 1
    // down 2
    // left 3
    // right 4
    Command.CORRECT_COMMANDS = [
        { id: 1, direction: "up" },
        { id: 4, direction: "right" },
        { id: 1, direction: "up" },
        { id: 4, direction: "right" },
        { id: 2, direction: "down" },
        { id: 4, direction: "right" },
        { id: 2, direction: "down" },
        { id: 4, direction: "right" },
    ];
    return Command;
}());



/***/ }),
/* 2444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Arrow; });
var Arrow = /** @class */ (function () {
    function Arrow(arrowId, command, object) {
        this.arrowId = arrowId;
        this.command = command;
        this.object = object;
        this.slot = null;
    }
    return Arrow;
}());



/***/ }),
/* 2445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "i";
        _this.gameClosingTextKey = "ProgramRobot.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(155));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/program_robot.971b71f4.json";

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2i_background.8f569bf9.png";

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/buttons.05bd2471.png";

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/robot.8685a840.png";

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rocket_flames.98356c88.png";

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/spaceship.7a48973c.png";

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/console.929b7f08.png";

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/crystal.8c9ee351.png";

/***/ }),
/* 2454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(933);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].JigsawPuzzle;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "JigsawPuzzle.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "JigsawPuzzle.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_InteractiveCursorUtil__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_PuzzlePiece__ = __webpack_require__(2456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Slot__ = __webpack_require__(2457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_JigsawPuzzleGame_scenes_EndGameScene__ = __webpack_require__(2458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_games_shared_Modal__ = __webpack_require__(73);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.showSlotLines = false;
        _this.translateString = "JigsawPuzzle.Phaser.";
        return _this;
    }
    /**
     * NOTE: It is ESSENTIAL for the pieces to be named correctly in the atlas file!
     * Each piece should be named "piece-<correct row>-<correct column>"
     * e.g. "piece-0-0" corresponds to the piece that should be placed in the top left corner of the puzzle
     */
    MainScene.prototype.preload = function () {
        this.load.image("background", __webpack_require__(2459));
        // Uncomment for 5x5 puzzle
        this.load.atlas("assets", __webpack_require__(2460), __webpack_require__(2461));
        this.load.image("final-picture", __webpack_require__(2462));
        this.load.tilemapTiledJSON("map", __webpack_require__(2463));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.finalPicture = this.add.image(0, 0, "final-picture");
        this.finalPicture.setAlpha(0);
        // Count the number of frames in the atlas file to get the number of pieces
        this.NUMBER_OF_PIECES = this.textures.get("assets").getFrameNames().length;
        this.GRID_SIZE = Math.sqrt(this.NUMBER_OF_PIECES);
        this.SLOT_SIZE = this.finalPicture.width / this.GRID_SIZE;
        this.pieces = [];
        for (var row = 0; row < this.GRID_SIZE; row++) {
            this.pieces[row] = [];
        }
        this.slots = [];
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.on('dragstart', function (pointer, piece, dragX, dragY) {
            piece.x = pointer.downX;
            piece.y = pointer.downY;
            if (_this.tweens.isTweening(piece)) {
                _this.tweens.killAll();
            }
            _this.children.bringToTop(piece);
        });
        this.input.on('drag', function (pointer, piece, dragX, dragY) {
            piece.x = pointer.x;
            piece.y = pointer.y;
        });
        this.input.on('drop', function (pointer, piece, slot) {
            _this.children.moveDown(piece);
            _this.acceptPieceInSlot(piece, slot);
        });
    };
    MainScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.initialize();
        this.generateScene();
        this.matchPiecesWithSlots();
        Object(__WEBPACK_IMPORTED_MODULE_1_src_games_shared_InteractiveCursorUtil__["a" /* default */])(this);
        this.registerEvents();
    };
    MainScene.prototype.generateScene = function () {
        var _this = this;
        var background = this.add.image(0, 0, "background");
        background.setOrigin(0);
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        var legend;
        this.piecesInfo = __webpack_require__(2464);
        this.map.getObjectLayer("Game").objects.forEach(function (ob) {
            if (ob.name === "tray") {
                var id = 0;
                for (var _i = 0, _a = _this.textures.get("assets").getFrameNames(); _i < _a.length; _i++) {
                    var frameName = _a[_i];
                    var piece = _this.createPiece(id, frameName, ob);
                    id++;
                    _this.pieces[piece.correctPosition.x][piece.correctPosition.y] = piece;
                }
            }
            else if (ob.name === "target") {
                _this.targetArea = new Phaser.Geom.Rectangle(ob.x, ob.y, _this.finalPicture.width, _this.finalPicture.height);
                _this.add.graphics().lineStyle(4, 0xffffff).strokeRectShape(_this.targetArea);
                var x, y;
                id = 0;
                for (var row = 0; row < _this.GRID_SIZE; row++) {
                    y = ob.y + (row * _this.SLOT_SIZE);
                    _this.slots[row] = [];
                    for (var col = 0; col < _this.GRID_SIZE; col++) {
                        x = ob.x + (col * _this.SLOT_SIZE);
                        var slot = _this.createSlot(id, x, y, row, col);
                        _this.slots[row][col] = slot;
                        id++;
                    }
                }
            }
            else if (ob.name === "legend") {
                legend = _this.add.image(ob.x, ob.y, "final-picture");
                legend.setOrigin(0);
                legend.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "pilot") {
                var pilot = _this.add.image(ob.x, ob.y, "pilots", "s");
                pilot.setOrigin(0);
                pilot.setDisplaySize(ob.width, ob.height);
            }
        });
    };
    MainScene.prototype.acceptPieceInSlot = function (piece, slot) {
        if (this.isCorrectMatch(piece, slot)) {
            this.lockPiece(piece, slot);
        }
    };
    /**
     * Animation of shaking the piece cause it's wrong
     */
    MainScene.prototype.shakePiece = function (piece) {
        if (this.tweens.isTweening(piece)) {
            return;
        }
        // Little shake effect
        this.tweens.add({
            targets: piece,
            duration: 100,
            repeat: 5,
            ease: "Linear",
            x: "+=8"
        });
    };
    /**
     * It's the correct piece, lock it into it's rightful slot
     */
    MainScene.prototype.lockPiece = function (piece, slot) {
        slot.filled = true;
        piece.enabled = false;
        piece.disableInteractive();
        this.setX(piece, slot);
        this.setY(piece, slot);
        // Check if the game is over
        this.isGameOver();
    };
    MainScene.prototype.setY = function (piece, slot) {
        var knobs = this.piecesInfo[slot.position.x][slot.position.y];
        var offsetY = piece.height - slot.height;
        // Only knob on the top, center with offset a little to the top
        if (knobs.top === "out" && knobs.bottom !== "out") {
            piece.y = slot.y - offsetY / 2;
        }
        // Only knob on the bottom, center with offset a little to the bottom
        else if (knobs.top !== "out" && knobs.bottom === "out") {
            piece.y = slot.y + offsetY / 2;
        }
        else {
            // Either two knobs out, or no knobs out, centered already
            piece.y = slot.y;
        }
    };
    MainScene.prototype.setX = function (piece, slot) {
        var knobs = this.piecesInfo[slot.position.x][slot.position.y];
        var offsetX = piece.width - slot.width;
        // Only knob out on the right, center with offset a little to the right
        if (knobs.right === "out" && knobs.left !== "out") {
            piece.x = slot.x + offsetX / 2;
        }
        // Only knob on the left, center with offset a little to the left
        else if (knobs.left === "out" && knobs.right !== "out") {
            piece.x = slot.x - offsetX / 2;
        }
        else {
            // Either two knobs out, or no knobs out
            piece.x = slot.x;
        }
    };
    MainScene.prototype.isCorrectMatch = function (piece, slot) {
        return (piece.correctPosition.x === slot.position.x && piece.correctPosition.y === slot.position.y);
    };
    MainScene.prototype.createSlot = function (id, x, y, row, col) {
        var position = new Phaser.Math.Vector2(row, col);
        var slot = new __WEBPACK_IMPORTED_MODULE_5__objects_Slot__["a" /* Slot */](this, x, y, this.SLOT_SIZE, this.SLOT_SIZE, id, position);
        // Debug - draw lines
        if (this.showSlotLines) {
            this.add.graphics().lineStyle(2, 0xffffff).strokeRectShape(slot.getBounds());
        }
        return slot;
    };
    MainScene.prototype.createPiece = function (id, frameName, tray) {
        var padding = 50;
        // Parse the given pieces' frame name to get it's correct slot position
        var name = frameName.split("-");
        var row = parseInt(name[1]);
        var col = parseInt(name[2]);
        var correctPosition = new Phaser.Math.Vector2(row, col);
        var currentPosition = new Phaser.Math.Vector2(-1, -1);
        var piece = new __WEBPACK_IMPORTED_MODULE_4__objects_PuzzlePiece__["a" /* PuzzlePiece */](this, 0, 0, frameName, id, currentPosition, correctPosition);
        piece.setRandomPosition(tray.x, tray.y, tray.width - padding, tray.height - padding);
        return piece;
    };
    MainScene.prototype.getCorrectSlot = function (piece) {
        return this.slots[piece.correctPosition.x][piece.correctPosition.y];
    };
    /**
     * Links up the pieces and slots correctly
     */
    MainScene.prototype.matchPiecesWithSlots = function () {
        for (var row = 0; row < this.GRID_SIZE; row++) {
            for (var col = 0; col < this.GRID_SIZE; col++) {
                var piece = this.pieces[row][col];
                piece.correctSlotId = this.getCorrectSlot(piece).id;
            }
        }
    };
    MainScene.prototype.modal = function (translationKey) {
        var text = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.translateString + translationKey);
        var buttonConfig = {
            smartSize: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON
        };
        var config = {
            title: text,
            buttonWidth: 200,
            buttonConfig: buttonConfig
        };
        var buttonText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("common.ok");
        var options = [{ id: 1, displayText: buttonText }];
        var modal = new __WEBPACK_IMPORTED_MODULE_7_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, options, config);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
        modal.on("optionClicked", function () {
            modal.destroy();
        });
    };
    MainScene.prototype.isGameOver = function () {
        for (var row = 0; row < this.GRID_SIZE; row++) {
            for (var col = 0; col < this.GRID_SIZE; col++) {
                var slot = this.slots[row][col];
                if (!slot.filled) {
                    return;
                }
            }
        }
        this.showFinalPictureTween();
    };
    MainScene.prototype.showFinalPictureTween = function () {
        var _this = this;
        this.finalPicture.setOrigin(0);
        this.finalPicture.setPosition(this.targetArea.x, this.targetArea.y);
        this.finalPicture.setDepth(2);
        this.tweens.add({
            targets: this.finalPicture,
            ease: "Power1",
            duration: 1500,
            alpha: {
                getStart: function () { return 0; },
                getEnd: function () { return 1; },
            },
            onComplete: function () {
                // Go to end game scene
                _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_6_src_games_JigsawPuzzleGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
                _this.scene.remove(_this);
            }
        });
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PuzzlePiece; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var PuzzlePiece = /** @class */ (function (_super) {
    __extends(PuzzlePiece, _super);
    function PuzzlePiece(scene, x, y, frame, id, currentPosition, correctPosition) {
        var _this = _super.call(this, scene, x, y, "assets", frame) || this;
        _this.id = id;
        _this.currentPosition = currentPosition;
        _this.correctPosition = correctPosition;
        _this.enabled = true;
        _this.setInteractive();
        scene.input.setDraggable(_this);
        scene.add.existing(_this);
        return _this;
    }
    return PuzzlePiece;
}(Phaser.GameObjects.Image));



/***/ }),
/* 2457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slot; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Slot = /** @class */ (function (_super) {
    __extends(Slot, _super);
    function Slot(scene, x, y, width, height, id, position) {
        var _this = _super.call(this, scene, x + width / 2, y + height / 2, width, height) || this;
        _this.id = id;
        _this.position = position;
        _this.filled = false;
        var dropzoneThresholdDistance = 70;
        // this.setOrigin(0);
        _this.setRectangleDropZone(_this.width - dropzoneThresholdDistance, _this.height - dropzoneThresholdDistance);
        // Debug - draw the actual hit area
        // var graphics = scene.add.graphics().lineStyle(2, 0x000000)
        //     .strokeRect(this.x + this.input.hitArea.x, this.y + this.input.hitArea.y,
        //         this.input.hitArea.width, this.input.hitArea.height);
        // scene.add.existing(graphics);
        scene.add.existing(_this);
        return _this;
    }
    return Slot;
}(Phaser.GameObjects.Zone));



/***/ }),
/* 2458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "s";
        _this.gameClosingTextKey = "JigsawPuzzle.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(168));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/planet_s_top.2162d76a.jpg";

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameJigsawPuzzle5x5.bf5196c8.png";

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameJigsawPuzzle5x5.5f0e0145.json";

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2s_puzzle.311c166d.png";

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/jigsaw_puzzle_game.cd8e68b2.json";

/***/ }),
/* 2464 */
/***/ (function(module, exports) {

module.exports = {"0":{"0":{"top":"none","bottom":"out","left":"none","right":"in"},"1":{"top":"none","bottom":"out","left":"out","right":"in"},"2":{"top":"none","bottom":"out","left":"out","right":"out"},"3":{"top":"none","bottom":"in","left":"in","right":"out"},"4":{"top":"none","bottom":"in","left":"in","right":"none"}},"1":{"0":{"top":"in","bottom":"in","left":"none","right":"out"},"1":{"top":"in","bottom":"in","left":"in","right":"in"},"2":{"top":"in","bottom":"out","left":"out","right":"in"},"3":{"top":"out","bottom":"out","left":"out","right":"out"},"4":{"top":"out","bottom":"out","left":"in","right":"none"}},"2":{"0":{"top":"out","bottom":"out","left":"none","right":"out"},"1":{"top":"out","bottom":"out","left":"in","right":"out"},"2":{"top":"in","bottom":"in","left":"in","right":"out"},"3":{"top":"in","bottom":"in","left":"in","right":"out"},"4":{"top":"in","bottom":"in","left":"in","right":"none"}},"3":{"0":{"top":"in","bottom":"in","left":"none","right":"out"},"1":{"top":"in","bottom":"out","left":"in","right":"out"},"2":{"top":"out","bottom":"out","left":"in","right":"in"},"3":{"top":"out","bottom":"out","left":"out","right":"in"},"4":{"top":"out","bottom":"out","left":"out","right":"none"}},"4":{"0":{"top":"out","bottom":"none","left":"none","right":"in"},"1":{"top":"in","bottom":"none","left":"out","right":"out"},"2":{"top":"in","bottom":"none","left":"in","right":"in"},"3":{"top":"in","bottom":"none","left":"out","right":"in"},"4":{"top":"in","bottom":"none","left":"out","right":"none"}}}

/***/ }),
/* 2465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(935);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].SpacePort;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "SpacePort.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "SpacePort.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_SpacePortGame_scenes_EndGameScene__ = __webpack_require__(2467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_LandingPad__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_SpaceShip__ = __webpack_require__(2474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_shared_ColorValue__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};







var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        // Landing Pad frame numbers that match their state
        _this.FUELING = 2;
        _this.UNAVAILABLE = 1;
        _this.AVAILABLE = 0;
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON("map", __webpack_require__(2475));
        this.load.image("planet", __webpack_require__(2476));
        this.load.image("cancel", __webpack_require__(2477));
        this.load.spritesheet("largeShip", __webpack_require__(2478), { frameWidth: 235, frameHeight: 240, });
        this.load.spritesheet("largePlatform", __webpack_require__(2479), { frameWidth: 354, frameHeight: 250, });
        this.load.spritesheet("mediumShip", __webpack_require__(2480), { frameWidth: 168, frameHeight: 215, });
        this.load.spritesheet("mediumPlatform", __webpack_require__(2481), { frameWidth: 288, frameHeight: 215, });
        this.load.spritesheet("smallShip", __webpack_require__(2482), { frameWidth: 146, frameHeight: 198, });
        this.load.spritesheet("smallPlatform", __webpack_require__(2483), { frameWidth: 221, frameHeight: 181, });
        this.load.spritesheet("port", __webpack_require__(2484), { frameWidth: 870, frameHeight: 130, });
        this.load.spritesheet("background", __webpack_require__(2485), { frameWidth: 1360, frameHeight: 768, });
    };
    MainScene.prototype.initialize = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "map" });
        this.shipConfigs = __spreadArrays(__WEBPACK_IMPORTED_MODULE_3__objects_SpaceShip__["a" /* SpaceShip */].SpaceShipConfigs.reverse());
        this.ships = [];
        this.TOTAL_SHIPS = this.shipConfigs.length;
        this.landingPads = [];
        this.shipCount = 0;
        this.finishedCount = 0;
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.sprite(0, 0, "background", 0);
        background.setOrigin(0);
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        var planet = this.add.image(0, 0, "planet").setOrigin(0);
        // Twinkly stars in background
        this.anims.create({
            key: "twinkle",
            frames: this.anims.generateFrameNumbers("background", { start: 0, end: 2 }),
            frameRate: 1,
            repeat: -1
        });
        background.anims.play("twinkle");
        this.addObjects();
        this.addTimedEvents();
        this.cancelIcon = this.add.image(-100, 0, "cancel");
        this.cancelIcon.setDisplaySize(75, 75);
        this.cancelIcon.setDepth(10);
    };
    MainScene.prototype.addTimedEvents = function () {
        var _this = this;
        // Decrease ship fuel level every 5 seconds
        this.time.addEvent({
            delay: 5000,
            callback: function () { return _this.decreaseShipFuelLevel(); },
            loop: true,
        });
        // Increase ship fuel level every 1.5 seconds when refueling
        this.time.addEvent({
            delay: 1500,
            callback: function () { return _this.increaseShipFuelLevel(); },
            loop: true,
        });
    };
    MainScene.prototype.addObjects = function () {
        var _this = this;
        this.map.getObjectLayer("Station").objects.forEach(function (ob) {
            if (ob.name === "port") {
                // Little "port" at the bottom of the page with flashy lights
                var port = _this.add.sprite(_this.gameWidth / 2, _this.gameHeight - ob.height / 2, "port", 0);
                _this.anims.create({
                    key: "flashy",
                    frames: _this.anims.generateFrameNumbers("port", { start: 0, end: 2 }),
                    frameRate: 3,
                    repeat: -1
                });
                port.anims.play("flashy");
            }
            else {
                var size = (ob.type === "small") ? __WEBPACK_IMPORTED_MODULE_2__objects_LandingPad__["b" /* Size */].SMALL : (ob.type === "medium") ? __WEBPACK_IMPORTED_MODULE_2__objects_LandingPad__["b" /* Size */].MEDIUM : __WEBPACK_IMPORTED_MODULE_2__objects_LandingPad__["b" /* Size */].LARGE;
                var landingPad = new __WEBPACK_IMPORTED_MODULE_2__objects_LandingPad__["a" /* LandingPad */](_this, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.type + "Platform", 0, size);
                landingPad.setDepth(2);
                landingPad.on("pointerdown", function () {
                    _this.currentLandingPad = landingPad;
                    if (_this.canLand(_this.currentShip, landingPad)) {
                        _this.landShip(_this.currentShip, landingPad);
                        _this.currentShip = null;
                    }
                });
                _this.landingPads.push(landingPad);
            }
        });
        // Update landing pads every second
        this.time.addEvent({
            delay: 1000,
            callback: function () { return _this.updateLandingPads(); },
            loop: true
        });
        for (var i = 0; i < 3; i++) {
            this.addShip();
        }
    };
    MainScene.prototype.addShip = function () {
        if (this.shipCount < this.TOTAL_SHIPS) {
            var config = this.shipConfigs.pop();
            this.createShip(config);
        }
    };
    MainScene.prototype.createShip = function (config) {
        var _this = this;
        var ship = new __WEBPACK_IMPORTED_MODULE_3__objects_SpaceShip__["a" /* SpaceShip */](this, this.shipCount, 0, 0, config);
        ship.setRandomPosition(100, -200, 1200, 100);
        // Ensures that the ship won't overlap with any others that are currently hovering
        while (this.overlaps(ship)) {
            ship.setRandomPosition(100, -200, 1200, 100);
        }
        this.shipCount++;
        ship.on('pointerdown', function () {
            // Only allow them to click on the ship if it's hovering and it's not tweening (moving somewhere)
            if (ship.state === "hovering" && !_this.tweens.isTweening(ship)) {
                _this.currentShip = ship;
                // Untint all other ships
                _this.ships.forEach(function (s) {
                    if (s.id !== _this.currentShip.id) {
                        s.clearTint();
                    }
                });
                _this.updateLandingPads();
                // Tint this ship so you have some indication that it's the "currentShip"
                _this.currentShip.setTint(0xb0b4ba);
            }
            else if (ship.state === "ready") {
                _this.takeOff(ship);
            }
        });
        this.ships.push(ship);
        var y = Phaser.Math.Between(100, 150);
        // Have ships come down from top of screen
        this.tweens.add({
            targets: ship,
            y: y,
            ease: "Linear",
            duration: ship.size.weight * 1000
        });
    };
    MainScene.prototype.decreaseShipFuelLevel = function () {
        this.ships.forEach(function (s) {
            var frame = parseInt(s.frame.name) - 1;
            // Tank is less than full
            if (frame < 8) {
                s.needsFuel = true;
            }
            if (s.state === "hovering") {
                s.setFrame(Math.min(Math.max(0, frame), 8));
            }
        });
    };
    MainScene.prototype.increaseShipFuelLevel = function () {
        var _this = this;
        this.ships.forEach(function (s) {
            var frame = parseInt(s.frame.name) + 1;
            if (s.state === "fueling") {
                s.setFrame(Math.min(Math.max(0, frame), 8));
                // Tank is almost full, add another ship
                if (frame === 6) {
                    _this.addShip();
                }
                // Tank is full, update state
                if (frame === 8) {
                    s.needsFuel = false;
                    s.state = "ready";
                    s.landingPad.state = "ready";
                    s.landingPad.setFrame(_this.AVAILABLE);
                }
            }
        });
    };
    MainScene.prototype.canLand = function (ship, landingPad) {
        if (ship == null || landingPad == null) {
            return false;
        }
        // Can only land if landing pad is empty
        if (landingPad.state === "empty" && landingPad.size.weight >= ship.size.weight) {
            return true;
        }
        else {
            // If they could land but the ship is too big, show some feedback
            if (landingPad.state === "empty" && landingPad.size.weight < ship.size.weight) {
                this.feedback("SpacePort.Phaser.tooSmall", landingPad);
            }
            return false;
        }
    };
    /**
     * Update landing pad frames (the color of the light on the landing pad that indicates it's state)
     */
    MainScene.prototype.updateLandingPads = function () {
        var _this = this;
        this.landingPads.forEach(function (lp) {
            // First check if it's currently fueling
            if (lp.state === "fueling") {
                lp.setFrame(_this.FUELING);
            }
            // Otherwise, check it's availability
            else {
                if (lp.state === "empty" || lp.state === "ready") {
                    if (_this.currentShip != null) {
                        if (lp.size.weight >= _this.currentShip.size.weight) {
                            lp.setFrame(_this.AVAILABLE);
                        }
                        else {
                            lp.setFrame(_this.UNAVAILABLE);
                        }
                    }
                    else {
                        lp.setFrame(_this.AVAILABLE);
                    }
                }
            }
        });
    };
    /**
     * Lands the ship using nested tweens
     * First tween moves the ship above the landing pad (navigating from somewhere to the correct location)
     * Second tween moves it directly down on top of the pad (actually landing it)
     */
    MainScene.prototype.landShip = function (ship, landingPad) {
        var _this = this;
        var abovePad = landingPad.getTopLeft().y - ship.height * 1.2;
        var onPad = landingPad.getTopLeft().y - ship.height / 4;
        // Change the state of the landing pad to waiting because it's no longer available, it's waiting for 
        // a ship to land there (needed because of the tweens)
        landingPad.state = "waiting";
        ship.clearTint();
        var distance = ship.x - landingPad.x;
        var duration = Math.min(3000, (Math.sqrt(distance * distance) / ((4 - ship.size.weight) * 100)) * 1000);
        this.tweens.add({
            targets: ship,
            // duration: duration,
            x: landingPad.x,
            y: abovePad,
            ease: "Linear",
            onComplete: function () {
                // Vertically land the ship on the pad
                _this.tweens.add({
                    targets: ship,
                    duration: 1000,
                    y: onPad,
                    ease: "Linear",
                    onComplete: function () {
                        landingPad.state = "fueling";
                        ship.landingPad = landingPad;
                        ship.state = "landed";
                        landingPad.setFrame(_this.FUELING);
                        ship.state = "fueling";
                    }
                });
            }
        });
    };
    MainScene.prototype.takeOff = function (ship) {
        var _this = this;
        this.tweens.add({
            targets: ship,
            duration: ship.size.weight * 1000,
            y: -100,
            ease: "Linear",
            onStart: function () {
                ship.landingPad.state = "empty";
                ship.landingPad.setFrame(_this.AVAILABLE);
            },
            onComplete: function () {
                ship.destroy();
                _this.finishedCount++;
                _this.checkIfGameOver();
            }
        });
    };
    /**
    * Returns true if the current ship will end up overlapping with another hovering ship
    */
    MainScene.prototype.overlaps = function (ship) {
        var hovering = this.ships.filter(function (s) { return s.state === "hovering" && s.id !== ship.id; });
        for (var _i = 0, hovering_1 = hovering; _i < hovering_1.length; _i++) {
            var h = hovering_1[_i];
            var tempRect = h.getBounds();
            // Match their y values (don't care about y values because ships come from above anyway)
            tempRect.y = ship.y;
            // Check if they intersect
            if (Phaser.Geom.Intersects.RectangleToRectangle(tempRect, ship.getBounds())) {
                return true;
            }
        }
        return false;
    };
    MainScene.prototype.modal = function (translationKey) {
        var text = __WEBPACK_IMPORTED_MODULE_5__utils_TranslateHelper__["a" /* default */].translate(translationKey);
        var buttonConfig = {
            smartSize: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_6_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON
        };
        var config = {
            title: text,
            buttonWidth: 200,
            buttonConfig: buttonConfig
        };
        var buttonText = __WEBPACK_IMPORTED_MODULE_5__utils_TranslateHelper__["a" /* default */].translate("common.ok");
        var options = [{ id: 1, displayText: buttonText }];
        var modal = new __WEBPACK_IMPORTED_MODULE_4_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, options, config);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
        modal.on("optionClicked", function () {
            modal.destroy();
        });
    };
    MainScene.prototype.feedback = function (key, landingPad) {
        var _this = this;
        var text = __WEBPACK_IMPORTED_MODULE_5__utils_TranslateHelper__["a" /* default */].translate(key);
        var style = {
            fontSize: 20,
            fontFamily: "Russo One, Arial",
            backgroundColor: "#000000",
            padding: 10
        };
        var blurb = this.add.text(landingPad.x, landingPad.y - landingPad.height / 2 - 50, text, style);
        blurb.setOrigin(0.5);
        this.tweens.add({
            targets: [blurb, this.cancelIcon],
            duration: 3000,
            alpha: {
                getStart: function () { return 1; },
                getEnd: function () { return 0; }
            },
            onStart: function () {
                _this.cancelIcon.setPosition(landingPad.x, landingPad.y - landingPad.height / 4);
            },
            ease: "Linear",
            onComplete: function () {
                blurb.destroy();
            }
        });
    };
    MainScene.prototype.checkIfGameOver = function () {
        if (this.finishedCount === this.shipCount) {
            this.endGame();
        }
    };
    MainScene.prototype.endGame = function () {
        this.input.setDefaultCursor("default");
        this.input.removeAllListeners();
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_1_src_games_SpacePortGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_ShipPainting_scenes_MainScene__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "e";
        _this.gameClosingTextKey = "SpacePort.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(287));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("\n").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete(__WEBPACK_IMPORTED_MODULE_4_src_games_ShipPainting_scenes_MainScene__["a" /* MainScene */].CROPPED_IMAGE);
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_ShipPainting_scenes_MainScene__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "a";
        _this.gameClosingTextKey = "ShipPainting.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(155));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete(__WEBPACK_IMPORTED_MODULE_4_src_games_ShipPainting_scenes_MainScene__["a" /* MainScene */].CROPPED_IMAGE);
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2a_background.4112090a.png";

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/art_board.a8360ae8.png";

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ship.c4836b38.png";

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/stickers.8c28b454.png";

/***/ }),
/* 2473 */
/***/ (function(module, exports) {

module.exports = {"polygon":[{"x":0,"y":0},{"x":140,"y":-60},{"x":226.666666666667,"y":-114.666666666667},{"x":460,"y":-114.5},{"x":581.5,"y":-70},{"x":644.666666666667,"y":-71.3333333333333},{"x":828,"y":-216},{"x":985.333333333333,"y":-220},{"x":982.666666666667,"y":-181.333333333333},{"x":944,"y":-168},{"x":930.666666666667,"y":-108},{"x":829.333333333333,"y":-89.3333333333333},{"x":809.333333333333,"y":-77.3333333333333},{"x":838.666666666667,"y":-42.6666666666667},{"x":861.333333333333,"y":-44},{"x":954.666666666667,"y":-85.3333333333333},{"x":977.333333333333,"y":-58.6666666666667},{"x":964,"y":106.666666666667},{"x":886.666666666667,"y":101.333333333333},{"x":862.666666666667,"y":70.6666666666667},{"x":840,"y":70.6666666666667},{"x":813.333333333333,"y":100},{"x":814.666666666667,"y":118.666666666667},{"x":921.333333333333,"y":130.666666666667},{"x":942.666666666667,"y":188},{"x":974.666666666667,"y":208},{"x":990.666666666667,"y":242.666666666667},{"x":836,"y":242.666666666667},{"x":649.333333333333,"y":105.333333333333},{"x":593.333333333333,"y":86.6666666666667},{"x":436,"y":121.333333333333},{"x":306.666666666667,"y":117.333333333333},{"x":228,"y":100},{"x":116,"y":72},{"x":0,"y":12}]}

/***/ }),
/* 2474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SpaceShipConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpaceShip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LandingPad__ = __webpack_require__(938);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SpaceShipConfig = /** @class */ (function () {
    function SpaceShipConfig(size, frame) {
        this.size = size;
        this.frame = frame;
    }
    return SpaceShipConfig;
}());

var SpaceShip = /** @class */ (function (_super) {
    __extends(SpaceShip, _super);
    function SpaceShip(scene, id, x, y, config) {
        var _this = _super.call(this, scene, x, y, config.size.id + "Ship", config.frame) || this;
        _this.id = id;
        _this.size = config.size;
        _this.state = "hovering";
        _this.needsFuel = parseInt(_this.frame.name) < 7;
        _this.x = x + _this.width / 2;
        _this.y = y + _this.height / 2;
        _this.setDepth(5);
        _this.setInteractive();
        _this.scene.add.existing(_this);
        return _this;
    }
    /**
     * All of the ships that will appear in the game
     */
    SpaceShip.SpaceShipConfigs = [
        new SpaceShipConfig(__WEBPACK_IMPORTED_MODULE_0__LandingPad__["b" /* Size */].LARGE, 1),
        new SpaceShipConfig(__WEBPACK_IMPORTED_MODULE_0__LandingPad__["b" /* Size */].SMALL, 5),
        new SpaceShipConfig(__WEBPACK_IMPORTED_MODULE_0__LandingPad__["b" /* Size */].MEDIUM, 0),
        new SpaceShipConfig(__WEBPACK_IMPORTED_MODULE_0__LandingPad__["b" /* Size */].LARGE, 3),
        new SpaceShipConfig(__WEBPACK_IMPORTED_MODULE_0__LandingPad__["b" /* Size */].MEDIUM, 4),
        new SpaceShipConfig(__WEBPACK_IMPORTED_MODULE_0__LandingPad__["b" /* Size */].MEDIUM, 2),
        new SpaceShipConfig(__WEBPACK_IMPORTED_MODULE_0__LandingPad__["b" /* Size */].SMALL, 2),
        new SpaceShipConfig(__WEBPACK_IMPORTED_MODULE_0__LandingPad__["b" /* Size */].MEDIUM, 4),
        new SpaceShipConfig(__WEBPACK_IMPORTED_MODULE_0__LandingPad__["b" /* Size */].SMALL, 1),
        new SpaceShipConfig(__WEBPACK_IMPORTED_MODULE_0__LandingPad__["b" /* Size */].LARGE, 1),
    ];
    return SpaceShip;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/2e_space_port.0baf0a6a.json";

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/planet.3ac6c771.png";

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cancel.e1140b51.png";

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/large_ship.226be300.png";

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/large_platform.e3a106da.png";

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medium_ship.6a13d1aa.png";

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medium_platform.e14051d8.png";

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/small_ship.8803cde0.png";

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/small_platform.f411731e.png";

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/station_control_rooms.9d423541.png";

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/starfield.fa59f710.png";

/***/ }),
/* 2486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SortScene__ = __webpack_require__(2487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(940);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].MailDelivery;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__SortScene__["a" /* SortScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "MailDelivery.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "MailDelivery.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SortScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_MailDeliveryGame_objects_Envelope__ = __webpack_require__(2488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_Slot__ = __webpack_require__(2489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_MailDeliveryGame_scenes_EndGameScene__ = __webpack_require__(2490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_games_MailDeliveryGame_objects_House__ = __webpack_require__(2491);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};







var SortScene = /** @class */ (function (_super) {
    __extends(SortScene, _super);
    function SortScene() {
        var _this = _super.call(this, {
            key: "GameScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, SortScene.prototype);
        return _this;
    }
    SortScene.prototype.preload = function () {
        this.load.image('background', __webpack_require__(2492));
        this.load.tilemapTiledJSON("map", __webpack_require__(2493));
        this.load.atlas("assets", __webpack_require__(2494), __webpack_require__(2495));
        this.load.spritesheet("truck", __webpack_require__(2496), {
            frameWidth: 100,
            frameHeight: 75
        });
        this.load.spritesheet("button", __webpack_require__(2497), {
            frameWidth: 150,
            frameHeight: 150
        });
        this.load.spritesheet("address", __webpack_require__(2498), {
            frameWidth: 228,
            frameHeight: 60
        });
    };
    SortScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "map" });
        this.envelopes = [];
        this.slots = [];
        this.addressLabels = [];
        this.houses = [];
    };
    SortScene.prototype.create = function () {
        this.initialize();
        this.addObjects();
        this.registerEvents();
    };
    SortScene.prototype.addObjects = function () {
        var _this = this;
        var background = this.add.image(0, 0, "background");
        background.setOrigin(0);
        var crater_house;
        this.map.getObjectLayer("Layout").objects.forEach(function (ob) {
            if (ob.name === "go") {
                var panel = _this.add.image(ob.x, ob.y, "assets", "button_panel");
                panel.setOrigin(0);
                var center = panel.getCenter();
                _this.goButton = _this.add.sprite(center.x, center.y, "button");
                _this.goButton.setFrame(0); // Purple button
                _this.goButton.setInteractive();
                _this.goButton.on("pointerdown", function () {
                    _this.checkEnvelopes();
                });
            }
            else if (ob.name === "tray") {
                _this.tray = _this.add.image(ob.x, ob.y, "pixel");
                _this.tray.setOrigin(0);
                _this.tray.setTint(0x000000);
                _this.tray.setAlpha(0.8);
                _this.tray.setDisplaySize(ob.width, ob.height);
                _this.addSlots();
                _this.addEnvelopes();
            }
            else if (ob.name === "truck") {
                _this.truck = _this.add.sprite(ob.x, ob.y, "truck", 4);
                _this.truck.setOrigin(0);
            }
            else if (ob.name === "house") {
                crater_house = _this.add.image(ob.x, ob.y, "assets", "crater_house");
                crater_house.setOrigin(0);
                crater_house.setDepth(10);
            }
            else if (ob.name === "path") {
                var json = __webpack_require__(2499);
                _this.points = json["path"];
                _this.points.forEach(function (p) {
                    p.x += ob.x;
                    p.y += ob.y;
                });
            }
        });
        this.addHouseZones();
    };
    SortScene.prototype.addHouseZones = function () {
        var _this = this;
        this.map.getObjectLayer("Houses").objects.forEach(function (ob) {
            var info = __WEBPACK_IMPORTED_MODULE_6_src_games_MailDeliveryGame_objects_House__["a" /* House */].Houses.find(function (h) { return h.id === parseInt(ob.name); });
            // For whatever reason..not able to use the House class which extends Zone...so just use normal zones
            var house = _this.add.zone(ob.x, ob.y, ob.width, ob.height);
            house.setOrigin(0);
            house.setInteractive();
            var label = _this.add.sprite(ob.x, ob.y, "address", info.frame);
            label.type = "label";
            label.name = info.id + "";
            label.setPosition(Math.min(ob.x + label.width / 2, _this.gameWidth - label.width / 2 - 10));
            label.setY(ob.y - label.height / 2);
            label.setVisible(false);
            _this.addressLabels.push(label);
            // Clicking a house shows/hides it's address label
            house.on("pointerdown", function () {
                label.visible = !label.visible;
                // Hide all other labels
                _this.addressLabels.forEach(function (l) {
                    if (l.name !== label.name) {
                        l.setVisible(false);
                    }
                });
            });
            _this.houses.push(house);
        });
    };
    SortScene.prototype.addEnvelopes = function () {
        var _this = this;
        var slots = __spreadArrays(this.slots);
        __WEBPACK_IMPORTED_MODULE_3_src_games_MailDeliveryGame_objects_Envelope__["a" /* Envelope */].Envelopes.forEach(function (info) {
            var slot = slots.pop();
            var envelope = new __WEBPACK_IMPORTED_MODULE_3_src_games_MailDeliveryGame_objects_Envelope__["a" /* Envelope */](_this, 0, 0, info);
            envelope.x = slot.x;
            envelope.y = slot.y;
            slot.envelopeId = envelope.id;
            _this.envelopes.push(envelope);
        });
    };
    SortScene.prototype.addSlots = function () {
        var _this = this;
        var slotWidth = 175;
        var slotHeight = 125;
        __WEBPACK_IMPORTED_MODULE_4__objects_Slot__["a" /* Slot */].Slots.forEach(function (config) {
            var slot = new __WEBPACK_IMPORTED_MODULE_4__objects_Slot__["a" /* Slot */](_this, 0, 0, slotWidth, slotHeight, config);
            _this.slots.push(slot);
        });
        Phaser.Actions.GridAlign(this.slots, {
            x: 200,
            y: slotHeight / 2 + 15,
            width: 4,
            height: 2,
            cellWidth: slotWidth + 25,
            cellHeight: slotHeight + 10,
        });
        var style = {
            fontSize: 30,
            fontFamily: "Russo One, Arial",
            align: "center"
        };
        this.slots.forEach(function (s) {
            _this.add.graphics().lineStyle(3, 0x000000).strokeRectShape(s.getBounds());
            var number = _this.add.text(0, 0, (s.id + 1) + "", style);
            Phaser.Display.Align.In.Center(number, s);
        });
    };
    SortScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.on('dragstart', function (pointer, envelope) {
            // Restrict to the tray
            if ((pointer.y > (_this.tray.getBottomRight().y - 20)) || (pointer.x > 1050)) {
                return;
            }
            envelope.x = pointer.downX;
            envelope.y = pointer.downY;
            _this.children.bringToTop(envelope);
            envelope.setScale(0.8);
        });
        this.input.on('drag', function (pointer, envelope, dragX, dragY) {
            // Restrict to the tray
            if ((pointer.y > (_this.tray.getBottomRight().y - 20)) || (pointer.x > 1050)) {
                return;
            }
            envelope.x = pointer.x;
            envelope.y = pointer.y - 20;
        });
        this.input.on('dragend', function (pointer, envelope, dropped) {
            _this.children.moveDown(envelope);
        });
        this.input.on('drop', function (pointer, envelope, slot) {
            if (!_this.inTray(envelope)) {
                return;
            }
            _this.dropEnvelope(envelope, slot);
        });
    };
    SortScene.prototype.dropEnvelope = function (envelope, slot) {
        // Slot is filled already, don't assign it
        if (this.isSlotFilled(slot, envelope)) {
            return;
        }
        // Snap envelope to center
        envelope.x = slot.x;
        envelope.y = slot.y;
        slot.envelopeId = envelope.id;
        envelope.setScale(1);
    };
    /**
     * Checks if the slot contains any of the envelopes by using rectangle/bounds
     * Don't include the envelope you're currently trying to drop in (otherwise it would always return true)
     */
    SortScene.prototype.isSlotFilled = function (slot, currentEnvelope) {
        var envelope;
        for (var _i = 0, _a = this.envelopes; _i < _a.length; _i++) {
            envelope = _a[_i];
            if (envelope.id !== currentEnvelope.id && Phaser.Geom.Rectangle.ContainsPoint(slot.getBounds(), envelope.getCenter())) {
                return true;
            }
        }
        return false;
    };
    SortScene.prototype.checkEnvelopes = function () {
        var slot;
        var open = 0;
        var incorrect = 0;
        for (var _i = 0, _a = this.slots; _i < _a.length; _i++) {
            slot = _a[_i];
            if (slot.correctEnvelopeId !== slot.envelopeId) {
                incorrect++;
            }
            // Check that the slot's assigned envelope is actually inside the slot, if not, it's not "locked" (it's open)
            var envelope = this.envelopes.find(function (e) { return e.id === slot.envelopeId; });
            if (!Phaser.Geom.Rectangle.ContainsPoint(slot.getBounds(), envelope.getCenter())) {
                open++;
            }
        }
        // Prioritize by only first caring if they didn't get all the envelopes
        if (open > 0) {
            this.modalPop("notDone", false);
            return;
        }
        // Then tell them if they got any wrong
        if (incorrect > 0) {
            this.modalPop("incorrect", false);
            return;
        }
        // Otherwise, good to go
        this.moveTruck();
    };
    SortScene.prototype.modalPop = function (key, gameover) {
        var _this = this;
        var config = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
        config.title = __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate("MailDelivery.Phaser." + key);
        config.buttonConfig.smartSize = true;
        var modal = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, [{ id: 1, displayText: __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate("common.ok") }], config);
        modal.setDepth(12);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
        modal.on('optionClicked', function () {
            modal.destroy();
            if (gameover) {
                _this.input.setDefaultCursor("default");
                _this.input.removeAllListeners();
                _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_5_src_games_MailDeliveryGame_scenes_EndGameScene__["a" /* EndGameScene */], true);
                _this.scene.remove(_this);
            }
        });
    };
    SortScene.prototype.inTray = function (envelope) {
        return Phaser.Geom.Intersects.RectangleToRectangle(this.tray.getBounds(), envelope.getBounds());
    };
    /**
    * Shuffle the slots so they're not in the same order every time
    * https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
    */
    SortScene.prototype.randomizeSlots = function (slots) {
        var j, x, i;
        for (i = slots.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = slots[i];
            slots[i] = slots[j];
            slots[j] = x;
        }
        return slots;
    };
    SortScene.prototype.isCorrectOrder = function (slots) {
        var correctOrder = [];
        var sorted = this.slots.sort(function (s1, s2) { return s1.id - s2.id; });
        sorted.forEach(function (s) { return correctOrder.push(s.id); });
        for (var i = 0; i < correctOrder.length; i++) {
            if (correctOrder[i] !== slots[i].id) {
                return false;
            }
        }
        return true;
    };
    SortScene.prototype.moveTruck = function () {
        var _this = this;
        // Hide all address labels
        this.addressLabels.forEach(function (l) {
            l.setVisible(false);
        });
        this.goButton.setFrame(1); // Green
        var truckPath = new Phaser.Curves.Path(this.truck.x + this.truck.width / 2, this.truck.y + this.truck.height / 2);
        truckPath.splineTo(this.points);
        this.follower = this.add.follower(truckPath, this.truck.x + this.truck.width / 2, this.truck.y + this.truck.height / 2, "truck", 4);
        this.follower.setDepth(8);
        this.truck.setVisible(false);
        this.follower.startFollow({
            duration: 14000,
        });
        this.follower.stopFollow();
        this.anims.create({
            key: "path",
            frames: [
                { key: "truck", frame: 4, duration: 1800 },
                // Turn 1
                { key: "truck", frame: 2 },
                { key: "truck", frame: 1 },
                { key: "truck", frame: 0 },
                { key: "truck", frame: 3, duration: 700 },
                // Turn 2
                { key: "truck", frame: 0 },
                { key: "truck", frame: 1 },
                { key: "truck", frame: 2, duration: 500 },
                // Turn 3
                { key: "truck", frame: 2 },
                { key: "truck", frame: 1 },
                { key: "truck", frame: 0 },
                { key: "truck", frame: 3, duration: 3900 },
                // Turn 4
                { key: "truck", frame: 5 },
                { key: "truck", frame: 6 },
                { key: "truck", frame: 7, duration: 500 },
                // Turn 5
                { key: "truck", frame: 4, duration: 400 },
                { key: "truck", frame: 7 },
                { key: "truck", frame: 6 },
                { key: "truck", frame: 5 },
                { key: "truck", frame: 3, duration: 600 },
                // Turn 6
                { key: "truck", frame: 6 },
                { key: "truck", frame: 7 },
                { key: "truck", frame: 4, duration: 1100 },
            ],
            frameRate: 8,
        });
        this.anims.play("path", this.follower);
        this.goButton.disableInteractive();
        this.input.removeAllListeners();
        this.envelopes.forEach(function (e) { return e.removeInteractive(); });
        this.houses.forEach(function (h) { return h.removeInteractive(); });
        this.follower.on("animationcomplete", function () {
            // For some reason the animation completes a little early, so wait until the truck stops moving to show them the modal
            setTimeout(function () {
                _this.modalPop("deliveredAll", true);
            }, 1700);
        });
    };
    return SortScene;
}(Phaser.Scene));



/***/ }),
/* 2488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EnvelopeInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Envelope; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var EnvelopeInfo = /** @class */ (function () {
    function EnvelopeInfo(id, address, frame) {
        this.id = id;
        this.address = address;
        this.frame = frame;
    }
    return EnvelopeInfo;
}());

var Envelope = /** @class */ (function (_super) {
    __extends(Envelope, _super);
    function Envelope(scene, x, y, info) {
        var _this = _super.call(this, scene, x, y, "assets", info.frame) || this;
        _this.id = info.id;
        _this.address = info.address;
        _this.delivered = false;
        // this.setScale(0.9);
        _this.setInteractive();
        scene.input.setDraggable(_this);
        scene.add.existing(_this);
        return _this;
    }
    Envelope.Envelopes = [
        new EnvelopeInfo(1, "101 Lightyear Lane.", "invitation1"),
        new EnvelopeInfo(5, "101 Asteroid Alley", "invitation6"),
        new EnvelopeInfo(3, "103 Lightyear Lane.", "invitation3"),
        new EnvelopeInfo(6, "201 Asteroid Alley", "invitation5"),
        new EnvelopeInfo(2, "102 Lightyear Lane.", "invitation2"),
        new EnvelopeInfo(7, "308 Asteroid Alley", "invitation7"),
        new EnvelopeInfo(4, "600 Big Bang Blvd.", "invitation4"),
    ];
    return Envelope;
}(Phaser.GameObjects.Image));



/***/ }),
/* 2489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SlotConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slot; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SlotConfig = /** @class */ (function () {
    function SlotConfig(id, correctEnvelopeId) {
        this.id = id;
        this.correctEnvelopeId = correctEnvelopeId;
    }
    return SlotConfig;
}());

var Slot = /** @class */ (function (_super) {
    __extends(Slot, _super);
    function Slot(scene, x, y, width, height, config) {
        var _this = _super.call(this, scene, x, y, width, height) || this;
        _this.id = config.id;
        _this.correctEnvelopeId = config.correctEnvelopeId;
        _this.envelopeId = -1;
        _this.correct = false;
        _this.setRectangleDropZone(width, height);
        scene.add.existing(_this);
        return _this;
    }
    Slot.Slots = [
        new SlotConfig(0, 1),
        new SlotConfig(1, 2),
        new SlotConfig(2, 3),
        new SlotConfig(3, 4),
        new SlotConfig(4, 5),
        new SlotConfig(5, 6),
        new SlotConfig(6, 7),
    ];
    return Slot;
}(Phaser.GameObjects.Zone));



/***/ }),
/* 2490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "c";
        _this.gameClosingTextKey = "MailDelivery.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(168));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HouseInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return House; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var HouseInfo = /** @class */ (function () {
    function HouseInfo(id, address, frame) {
        this.id = id;
        this.address = address;
        this.frame = frame;
    }
    return HouseInfo;
}());

var House = /** @class */ (function (_super) {
    __extends(House, _super);
    function House(scene, x, y, width, height, info) {
        var _this = _super.call(this, scene, x, y, width, height) || this;
        _this.id = info.id;
        _this.address = info.address;
        _this.frame = info.frame;
        _this.setOrigin(0);
        _this.setDepth(5);
        scene.add.existing(_this);
        return _this;
    }
    House.Houses = [
        new HouseInfo(1, "101 Lightyear Lane.", 0),
        new HouseInfo(2, "102 Lightyear Lane.", 1),
        new HouseInfo(3, "103 Lightyear Lane.", 2),
        new HouseInfo(4, "600 Big Bang Blvd.", 6),
        new HouseInfo(5, "101 Asteroid Alley", 3),
        new HouseInfo(6, "201 Asteroid Alley", 4),
        new HouseInfo(7, "308 Asteroid Alley", 5),
    ];
    return House;
}(Phaser.GameObjects.Zone));



/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2c_background.e6437360.png";

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/2c_mail_delivery.4f374ff4.json";

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameMailDelivery.48274f94.png";

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameMailDelivery.7c283e02.json";

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/truck.4f2f48ae.png";

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/go_button.94bb1161.png";

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/addresses.dae3d225.png";

/***/ }),
/* 2499 */
/***/ (function(module, exports) {

module.exports = {"path":[{"x":0,"y":0},{"x":200,"y":-9.33333333333326},{"x":340,"y":-40},{"x":457.333333333333,"y":-89.3333333333333},{"x":438.666666666667,"y":-121.333333333333},{"x":188,"y":-162.666666666667},{"x":185.333333333333,"y":-188},{"x":357.333333333333,"y":-273.333333333333},{"x":310.666666666667,"y":-318.666666666667},{"x":208,"y":-330.666666666667},{"x":69.3333333333333,"y":-326.666666666667},{"x":-89.3333333333334,"y":-305.333333333333},{"x":-292,"y":-316},{"x":-378.666666666667,"y":-341.333333333333},{"x":-490.666666666667,"y":-353.333333333333},{"x":-724,"y":-345.333333333333},{"x":-768,"y":-309.333333333333},{"x":-768,"y":-261.333333333333},{"x":-728,"y":-228},{"x":-700,"y":-222.666666666667},{"x":-666.666666666667,"y":-212},{"x":-602.666666666667,"y":-212},{"x":-538.666666666667,"y":-210.666666666667},{"x":-512,"y":-181.333333333333},{"x":-544,"y":-157.333333333333},{"x":-629.333333333333,"y":-140},{"x":-718.666666666667,"y":-133.333333333333},{"x":-761.333333333333,"y":-120},{"x":-733.333333333333,"y":-104},{"x":-664,"y":-100},{"x":-612,"y":-94.6666666666666},{"x":-558.666666666667,"y":-89.3333333333333},{"x":-508,"y":-80},{"x":-189.333333333333,"y":-1.33333333333326},{"x":-88,"y":-2.66666666666663},{"x":-24,"y":0}]}

/***/ }),
/* 2500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(942);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].ShipPainting;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "ShipPainting.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "ShipPainting.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "ShipPainting.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(944);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].SpacePets;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "SpacePets.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "SpacePets.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "SpacePets.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Pet__ = __webpack_require__(2503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EndGameScene__ = __webpack_require__(2504);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON('map', __webpack_require__(2505));
        this.load.image('background', __webpack_require__(2506));
        this.load.atlas("assets", __webpack_require__(2507), __webpack_require__(2508));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.pets = [];
        this.items = [];
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);
        this.createHomes();
        this.createShelf();
        this.createPets();
        this.registerEvents();
    };
    MainScene.prototype.createShelf = function () {
        var _this = this;
        var id = 0;
        this.map.getObjectLayer("Shelf").objects.forEach(function (ob) {
            if (ob.name === "shelf") {
                var shelf = _this.add.sprite(ob.x, ob.y, "assets", "counter");
                shelf.setOrigin(0);
                shelf.name = "shelf";
                shelf.setInteractive();
                shelf.input.dropZone = true;
            }
            else if (ob.type === "PetItem") {
                _this.createPetItem(ob, id++);
            }
        });
    };
    MainScene.prototype.createHomes = function () {
        var _this = this;
        this.map.getObjectLayer("Homes").objects.forEach(function (ob) {
            var home = new __WEBPACK_IMPORTED_MODULE_1__objects_Pet__["b" /* PetHome */](_this, ob);
        });
    };
    MainScene.prototype.createPets = function () {
        var _this = this;
        var id = 0;
        this.map.getObjectLayer("Pets").objects.forEach(function (ob) {
            var pet = new __WEBPACK_IMPORTED_MODULE_1__objects_Pet__["a" /* Pet */](_this, ob, id++);
            _this.pets.push(pet);
        });
    };
    MainScene.prototype.createPetItem = function (ob, id) {
        var item = new __WEBPACK_IMPORTED_MODULE_1__objects_Pet__["c" /* PetItem */](this, ob, id);
        this.items.push(item);
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.dragDistanceThreshold = 10;
        this.input.on('dragstart', function (pointer, gameObject) {
            _this.children.bringToTop(gameObject);
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
        this.input.on('dragend', function (pointer, gameObject, dropped) {
            if (!dropped) {
                // Put back
                gameObject.x = gameObject.input.dragStartX;
                gameObject.y = gameObject.input.dragStartY;
            }
        });
        this.input.on('drop', function (pointer, gameObject, zone) {
            if (zone.name === "shelf") {
                gameObject.setPosition(gameObject.startingPosition.x, gameObject.startingPosition.y);
                return;
            }
            else {
                var home = zone;
                _this.drop(gameObject, home);
            }
        });
    };
    MainScene.prototype.drop = function (gameObject, home) {
        this.children.bringToTop(gameObject);
        if (gameObject.type === "Pet") {
            var pet = gameObject;
            home.isOccupied = true;
        }
        else if (gameObject.type === "PetItem") {
            var item = gameObject;
            home.items.add(item);
        }
        // They are locked into their home
        if (gameObject.homeId === home.id) {
            gameObject.isHome = true;
            gameObject.input.enabled = false;
            // Change to the rightful frame
            home.updateHome(gameObject);
            gameObject.destroy();
        }
        else {
            // Ensure that the misplaced item is on top of everything so it can always be moved
            gameObject.setDepth(5);
            gameObject.isHome = false;
        }
        this.isGameOver();
    };
    MainScene.prototype.isGameOver = function () {
        var _this = this;
        var pet;
        for (var _i = 0, _a = this.pets; _i < _a.length; _i++) {
            pet = _a[_i];
            if (!pet.isHome) {
                return false;
            }
        }
        var item;
        for (var _b = 0, _c = this.items; _b < _c.length; _b++) {
            item = _c[_b];
            if (!item.isHome) {
                return false;
            }
        }
        // Wait a second and then end the game
        setTimeout(function () {
            _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_5__EndGameScene__["a" /* EndGameScene */], true);
            _this.scene.remove(_this);
        }, 1000);
        return true;
    };
    MainScene.prototype.modal = function (translationKey) {
        var text = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("SpacePets.Phaser." + translationKey);
        var buttonConfig = {
            smartSize: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].KUDER_SECONDARY_BUTTON
        };
        var config = {
            title: text,
            buttonWidth: 50,
            buttonConfig: buttonConfig
        };
        var options = [{ id: 1, displayText: __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("common.ok") }];
        var modal = new __WEBPACK_IMPORTED_MODULE_3_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, options, config);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
        modal.on("optionClicked", function () {
            modal.destroy();
        });
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PetItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PetHome; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pet = /** @class */ (function (_super) {
    __extends(Pet, _super);
    function Pet(scene, ob, id) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name + "1") || this;
        _this.id = id;
        _this.homeId = ob.properties["id"];
        _this.name = ob.name;
        _this.isHome = false;
        _this.type = "Pet";
        _this.startingPosition = new Phaser.Geom.Point(_this.x, _this.y);
        _this.setDepth(5);
        var topLeft = _this.getTopLeft();
        var rect = new Phaser.Geom.Rectangle(topLeft.x - ob.properties["x"], topLeft.y - ob.properties["y"], ob.properties["width"], ob.properties["height"]);
        _this.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
        _this.scene.input.setDraggable(_this);
        _this.playAnimation(ob);
        _this.scene.add.existing(_this);
        return _this;
    }
    Pet.prototype.playAnimation = function (ob) {
        this.scene.anims.create({
            key: ob.name,
            frames: this.scene.anims.generateFrameNames("assets", {
                prefix: ob.name,
                start: 1,
                end: 4
            }),
            frameRate: 6,
            repeat: -1,
            delay: 500 * this.id,
            repeatDelay: 300
        });
        this.anims.play(ob.name);
    };
    return Pet;
}(Phaser.GameObjects.Sprite));

var PetItem = /** @class */ (function (_super) {
    __extends(PetItem, _super);
    function PetItem(scene, ob, id) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name) || this;
        _this.id = id;
        _this.homeId = ob.properties['id'];
        _this.name = ob.name;
        _this.isHome = false;
        _this.type = "PetItem";
        _this.startingPosition = new Phaser.Geom.Point(_this.x, _this.y);
        _this.setInteractive();
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    return PetItem;
}(Phaser.GameObjects.Sprite));

var PetHome = /** @class */ (function (_super) {
    __extends(PetHome, _super);
    function PetHome(scene, ob) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name) || this;
        _this.id = ob.properties["id"];
        _this.name = ob.name;
        _this.isOccupied = false;
        _this.items = new Set();
        _this.type = "PetHome";
        if (_this.name !== "tree") {
            _this.setDepth(1);
        }
        // Set as a dropzone
        _this.setInteractive();
        _this.input.dropZone = true;
        // Add top layer over whatever is in the tank/cage (cage bars, tank glass)
        if (_this.name === "tank" || _this.name === "cage") {
            _this.topLayer = _this.scene.add.sprite(_this.x, _this.y, "assets", _this.name + "Front");
            _this.topLayer.setDepth(4);
        }
        _this.scene.add.existing(_this);
        return _this;
    }
    PetHome.prototype.updateHome = function (item) {
        var name = this.name + "-" + item.name;
        var frame = name;
        if (item.type === "Pet") {
            frame += "1";
        }
        var homeWithItem = this.scene.add.sprite(this.x, this.y, "assets", frame);
        if (item.name === "brush" || item.name === "cheesy_acorns") {
            homeWithItem.setDepth(3.5);
        }
        else if (item.name === "honey_bugs") {
            homeWithItem.setDepth(4.1);
        }
        else {
            homeWithItem.setDepth(3.1);
        }
        // Animation for pet inside it's home
        if (item.type === "Pet") {
            this.animatePetInHouse(name, homeWithItem);
        }
    };
    PetHome.prototype.animatePetInHouse = function (name, homeWithItem) {
        this.scene.anims.create({
            key: name,
            frames: this.scene.anims.generateFrameNames("assets", {
                prefix: name,
                start: 1,
                end: 2,
            }),
            frameRate: 4,
            repeat: -1
        });
        homeWithItem.anims.play(name);
    };
    return PetHome;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "c";
        _this.gameClosingTextKey = "SpacePets.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/space_pets.7ac0b80e.json";

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1c_background.da94f3c6.png";

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameSpacePets.7b7e8a68.png";

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameSpacePets.943d19aa.json";

/***/ }),
/* 2509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(946);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].WaiterMemory;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "WaiterMemory.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "WaiterMemory.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EndGameScene__ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_DinnerItem__ = __webpack_require__(2512);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON('map', __webpack_require__(2513));
        this.load.image('background', __webpack_require__(2514));
        this.load.atlas("assets", __webpack_require__(2515), __webpack_require__(2516));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.round = "drink";
        this.items = [];
        this.patrons = [];
    };
    MainScene.prototype.setupRound = function () {
        var _this = this;
        this.input.enabled = false;
        // Reset patrons and match them with a desired item randomly
        this.patrons.forEach(function (p) {
            p.served = false;
            var id = _this.round === "drink" ? p.drinkId : _this.round === "entree" ? p.entreeId : p.dessertId;
            p.desiredItem.setFrame("bubblefood" + id);
            p.desiredItem.setVisible(true);
            p.bubble.setVisible(true);
            p.desiredItem.y = p.bubble.y - 20;
            p.desiredItem.x = p.bubble.x + 10;
        });
        this.createTray();
        // Hide tray items
        this.items.forEach(function (i) {
            if (!i.served) {
                i.setVisible(false);
            }
        });
        // Wait then show tray items and hide patron's desired items
        setTimeout(function () {
            _this.input.enabled = true;
            _this.patrons.forEach(function (p) {
                p.desiredItem.setVisible(false);
                p.bubble.setVisible(false);
            });
            _this.items.forEach(function (i) { return i.setVisible(true); });
        }, 2000);
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);
        this.createPatronZones();
        this.registerEvents();
        this.setupRound();
    };
    MainScene.prototype.createTray = function () {
        var _this = this;
        var ids = [];
        if (this.round === "drink") {
            this.patrons.forEach(function (p) { return ids.push(p.drinkId); });
        }
        else if (this.round === "entree") {
            this.patrons.forEach(function (p) { return ids.push(p.entreeId); });
        }
        else {
            this.patrons.forEach(function (p) { return ids.push(p.dessertId); });
        }
        ids = this.scrambleArray(ids);
        this.map.getObjectLayer("Tray").objects.forEach(function (ob) {
            // Only create tray if on drink round (first round)
            if (ob.name === "tray" && _this.round === "drink") {
                var tray = _this.add.sprite(ob.x, ob.y, "assets", "tray").setOrigin(0);
            }
            else if (ob.type === "Item") {
                var item = new __WEBPACK_IMPORTED_MODULE_2__objects_DinnerItem__["a" /* DinnerItem */](_this, ob, _this.round, ids.pop());
                _this.items.push(item);
            }
        });
    };
    MainScene.prototype.createPatronZones = function () {
        var _this = this;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            var patron = new __WEBPACK_IMPORTED_MODULE_2__objects_DinnerItem__["b" /* Patron */](_this, ob);
            patron.on('pointerdown', function () {
                // Ignore if this patron is already served or if their desired item is already showing
                if (patron.served || patron.desiredItem.visible) {
                    return;
                }
                _this.showPatronItemReminder(patron);
            });
            ob = _this.map.getObjectLayer("Plates").objects.find(function (ob) { return ob.properties["id"] === patron.id; });
            patron.plate = new Phaser.Geom.Rectangle(ob.x, ob.y, ob.width, ob.height);
            _this.patrons.push(patron);
        });
    };
    MainScene.prototype.showPatronItemReminder = function (patron) {
        var _this = this;
        // Disable input and show this patrons item, hide all others
        this.input.enabled = false;
        patron.desiredItem.setVisible(true);
        patron.bubble.setVisible(true);
        this.patrons.forEach(function (p) {
            if (p.id !== patron.id) {
                p.desiredItem.setVisible(false);
                p.bubble.setVisible(false);
            }
        });
        this.items.forEach(function (i) {
            if (!i.served) {
                i.setVisible(false);
            }
        });
        // After a second, hide this patrons item again and show tray items
        setTimeout(function () {
            patron.desiredItem.setVisible(false);
            patron.bubble.setVisible(false);
            _this.items.forEach(function (i) { return i.setVisible(true); });
            _this.input.enabled = true;
        }, 600);
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.dragDistanceThreshold = 10;
        this.input.on('dragstart', function (pointer, item) {
            _this.children.bringToTop(item);
            pointer.x = item.x;
            pointer.y = item.y;
        });
        this.input.on('drag', function (pointer, item, dragX, dragY) {
            item.x = pointer.x;
            item.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, item, dropped) {
            if (!dropped) {
                // Put back
                item.x = item.input.dragStartX;
                item.y = item.input.dragStartY;
            }
        });
        this.input.on('drop', function (pointer, item, patron) {
            _this.drop(item, patron);
        });
    };
    MainScene.prototype.drop = function (item, patron) {
        this.children.bringToTop(item);
        // They are locked into their home
        if (this.isCorrectMatch(item, patron)) {
            item.served = true;
            item.input.enabled = false;
            patron.served = true;
            item.putOnPlate(patron);
        }
        else {
            // Put back
            item.x = item.input.dragStartX;
            item.y = item.input.dragStartY;
            item.served = false;
        }
        this.isGameOver();
    };
    MainScene.prototype.isCorrectMatch = function (item, patron) {
        return this.round === "drink" && item.id === patron.drinkId ||
            this.round === "entree" && item.id === patron.entreeId ||
            this.round === "dessert" && item.id === patron.dessertId;
    };
    MainScene.prototype.isGameOver = function () {
        var _this = this;
        // First check that all patrons have been served
        for (var _i = 0, _a = this.patrons; _i < _a.length; _i++) {
            var patron = _a[_i];
            if (!patron.served) {
                return false;
            }
        }
        // Now switch to the next round
        switch (this.round) {
            case this.round = "drink":
                this.round = "entree";
                break;
            case this.round = "entree":
                this.round = "dessert";
                break;
            case this.round = "dessert":
                //  Wait a second and then end the game
                setTimeout(function () {
                    _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_1__EndGameScene__["a" /* EndGameScene */], true);
                    _this.scene.remove(_this);
                }, 1000);
                return;
        }
        this.setupRound();
    };
    MainScene.prototype.scrambleArray = function (array) {
        var j, x, i;
        for (i = array.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = array[i];
            array[i] = array[j];
            array[j] = x;
        }
        return array;
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "s";
        _this.gameClosingTextKey = "WaiterMemory.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DinnerItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Patron; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DinnerItem = /** @class */ (function (_super) {
    __extends(DinnerItem, _super);
    function DinnerItem(scene, ob, type, id) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "trayfood" + id) || this;
        _this.type = type;
        _this.id = id;
        _this.served = false;
        _this.setDepth(3);
        _this.setInteractive({ useHandCursor: true });
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    DinnerItem.prototype.putOnPlate = function (patron) {
        if (this.type === "drink") {
            this.x = patron.plate.right + 20;
            this.y = patron.plate.centerY;
        }
        else if (this.type === "entree") {
            this.x = patron.plate.centerX - 25;
            this.y = patron.plate.centerY - 5;
        }
        else if (this.type === "dessert") {
            this.x = patron.plate.centerX + 25;
            this.y = patron.plate.centerY;
        }
        this.setDepth(2);
        this.setFrame("platefood" + this.id);
    };
    return DinnerItem;
}(Phaser.GameObjects.Sprite));

var Patron = /** @class */ (function (_super) {
    __extends(Patron, _super);
    function Patron(scene, ob) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height) || this;
        _this.id = ob.properties["id"];
        _this.served = false;
        _this.drinkId = ob.properties["drinkId"];
        _this.entreeId = ob.properties["entreeId"];
        _this.dessertId = ob.properties["dessertId"];
        _this.scene.add.existing(_this);
        _this.bubble = _this.scene.add.image(_this.x, 100, "assets", "bubble");
        _this.bubble.setVisible(false);
        _this.desiredItem = _this.scene.add.image(_this.x, _this.bubble.y, "assets", "bubblefood" + _this.drinkId);
        _this.desiredItem.setVisible(false);
        Phaser.Display.Align.In.Center(_this.desiredItem, _this.bubble);
        _this.setRectangleDropZone(_this.width, _this.height);
        return _this;
    }
    return Patron;
}(Phaser.GameObjects.Zone));



/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/waiter_memory.581d3c5a.json";

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ks_background.c8241413.png";

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameWaiterMemory.ceef87d9.png";

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameWaiterMemory.e1418ac7.json";

/***/ }),
/* 2517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(948);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Zoo;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "Zoo.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Zoo.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Animal__ = __webpack_require__(2519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EndGameScene__ = __webpack_require__(2520);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON('map', __webpack_require__(2521));
        this.load.image('background', __webpack_require__(2522));
        this.load.atlas("assets", __webpack_require__(2523), __webpack_require__(2524));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.animals = [];
        this.food = [];
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);
        this.createHabitats();
        this.createAnimals();
        this.createFoods();
        this.registerEvents();
    };
    MainScene.prototype.createHabitats = function () {
        var _this = this;
        this.map.getObjectLayer("Habitats").objects.forEach(function (ob) {
            var habitat = new __WEBPACK_IMPORTED_MODULE_1__objects_Animal__["c" /* Habitat */](_this, ob);
            var animal = _this.map.getObjectLayer("AnimalPlaced").objects.find(function (ob) { return ob.properties["id"] === habitat.id; });
            var food = _this.map.getObjectLayer("FoodPlaced").objects.find(function (ob) { return ob.properties["id"] === habitat.id; });
            habitat.animalPoint.x = animal.x + animal.width / 2;
            habitat.animalPoint.y = animal.y + animal.height / 2;
            habitat.foodPoint.x = food.x + food.width / 2;
            habitat.foodPoint.y = food.y + food.height / 2;
        });
    };
    MainScene.prototype.createAnimals = function () {
        var _this = this;
        this.map.getObjectLayer("Animals").objects.forEach(function (ob) {
            var animal = new __WEBPACK_IMPORTED_MODULE_1__objects_Animal__["a" /* Animal */](_this, ob);
            _this.animals.push(animal);
        });
    };
    MainScene.prototype.createFoods = function () {
        var _this = this;
        this.map.getObjectLayer("Food").objects.forEach(function (ob) {
            var food = new __WEBPACK_IMPORTED_MODULE_1__objects_Animal__["b" /* Food */](_this, ob);
            _this.food.push(food);
        });
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.dragDistanceThreshold = 10;
        this.input.on('dragstart', function (pointer, gameObject) {
            _this.children.bringToTop(gameObject);
            pointer.x = gameObject.x;
            pointer.y = gameObject.y;
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = pointer.x;
            gameObject.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, gameObject, dropped) {
            if (!dropped) {
                // Put back
                gameObject.x = gameObject.input.dragStartX;
                gameObject.y = gameObject.input.dragStartY;
            }
        });
        this.input.on('drop', function (pointer, gameObject, habitat) {
            _this.drop(gameObject, habitat);
        });
    };
    MainScene.prototype.drop = function (gameObject, habitat) {
        if (gameObject.id === habitat.id) {
            gameObject.isInHabitat = true;
            gameObject.input.enabled = false;
            gameObject.putInHabitat(habitat);
        }
        else {
            gameObject.isInHabitat = false;
            // Put back
            gameObject.x = gameObject.input.dragStartX;
            gameObject.y = gameObject.input.dragStartY;
        }
        this.isGameOver();
    };
    MainScene.prototype.isGameOver = function () {
        var _this = this;
        var animal;
        for (var _i = 0, _a = this.animals; _i < _a.length; _i++) {
            animal = _a[_i];
            if (!animal.isInHabitat) {
                return false;
            }
        }
        var food;
        for (var _b = 0, _c = this.food; _b < _c.length; _b++) {
            food = _c[_b];
            if (!food.isInHabitat) {
                return false;
            }
        }
        this.input.enabled = false;
        // Wait a second and then end the game
        setTimeout(function () {
            _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_2__EndGameScene__["a" /* EndGameScene */], true);
            _this.scene.remove(_this);
        }, 1000);
        return true;
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Animal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Food; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Habitat; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Animal = /** @class */ (function (_super) {
    __extends(Animal, _super);
    function Animal(scene, ob) {
        var _this = this;
        var id = ob.properties["id"];
        _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "animal" + id) || this;
        _this.id = id;
        _this.name = ob.name;
        _this.isInHabitat = false;
        _this.type = "Animal";
        _this.startingPosition = new Phaser.Geom.Point(_this.x, _this.y);
        _this.setInteractive({ useHandCursor: true });
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    Animal.prototype.playAnimation = function (ob) {
        this.scene.anims.create({
            key: ob.name,
            frames: this.scene.anims.generateFrameNames("assets", {
                prefix: ob.name,
                start: 1,
                end: 4
            }),
            frameRate: 6,
            repeat: -1,
            delay: 500 * this.id,
            repeatDelay: 300
        });
        this.anims.play(ob.name);
    };
    Animal.prototype.putInHabitat = function (habitat) {
        this.setDepth(2);
        this.setFrame(this.frame.name + "Small");
        this.setPosition(habitat.animalPoint.x, habitat.animalPoint.y);
    };
    return Animal;
}(Phaser.GameObjects.Sprite));

var Food = /** @class */ (function (_super) {
    __extends(Food, _super);
    function Food(scene, ob) {
        var _this = this;
        var id = ob.properties["id"];
        _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "food" + id) || this;
        _this.id = id;
        _this.name = ob.name;
        _this.isInHabitat = false;
        _this.type = "Food";
        _this.startingPosition = new Phaser.Geom.Point(_this.x, _this.y);
        _this.setInteractive({ useHandCursor: true });
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    Food.prototype.putInHabitat = function (habitat) {
        this.setDepth(3);
        this.setFrame(this.frame.name + "Small");
        this.setPosition(habitat.foodPoint.x, habitat.foodPoint.y);
    };
    return Food;
}(Phaser.GameObjects.Sprite));

var Habitat = /** @class */ (function (_super) {
    __extends(Habitat, _super);
    function Habitat(scene, ob) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height) || this;
        _this.id = ob.properties["id"];
        _this.name = ob.name;
        _this.type = "Habitat";
        _this.foodPoint = new Phaser.Geom.Point();
        _this.animalPoint = new Phaser.Geom.Point();
        _this.setRectangleDropZone(_this.width, _this.height);
        _this.scene.add.existing(_this);
        return _this;
    }
    return Habitat;
}(Phaser.GameObjects.Zone));



/***/ }),
/* 2520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "i";
        _this.gameClosingTextKey = "Zoo.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/zoo.f8fd4f39.json";

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ki_background.bbf3ae81.png";

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameZoo.44285b1a.png";

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameZoo.1a38fe76.json";

/***/ }),
/* 2525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(950);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Librarian;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "Librarian.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Librarian.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EndGameScene__ = __webpack_require__(2527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_Books__ = __webpack_require__(2528);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('map', __webpack_require__(2529));
        this.load.image('background', __webpack_require__(2530));
        this.load.atlas("assets", __webpack_require__(2531), __webpack_require__(2532));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.books = [];
        this.slots = [];
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var white = this.add.image(0, 0, "pixel").setOrigin(0).setDisplaySize(this.gameWidth, this.gameHeight);
        this.shelves = this.add.image(0, 0, "background").setOrigin(0).setDepth(0.5);
        var table = this.add.image(60, 0, "assets", "table");
        table.setOrigin(0);
        table.setY(this.gameHeight - table.height);
        table.setDepth(1);
        this.createShelves();
        this.createBooks();
        this.registerEvents();
    };
    MainScene.prototype.createBooks = function () {
        var _this = this;
        this.map.getObjectLayer('Books').objects.forEach(function (ob) {
            var book = new __WEBPACK_IMPORTED_MODULE_2__objects_Books__["a" /* Book */](_this, ob);
            book.setDepth(1);
            _this.books.push(book);
        });
    };
    MainScene.prototype.createShelves = function () {
        var _this = this;
        this.map.getObjectLayer('Shelves').objects.forEach(function (ob) {
            if (ob.type === "Book") {
                var spot = new __WEBPACK_IMPORTED_MODULE_2__objects_Books__["b" /* BookSlot */](_this, ob);
                _this.slots.push(spot);
            }
        });
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.on('dragstart', function (pointer, book) {
            _this.children.bringToTop(book);
            book.setScale(0.75);
            pointer.x = book.x;
            pointer.y = book.y;
        });
        this.input.on('drag', function (pointer, book, dragX, dragY) {
            book.x = pointer.x;
            book.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, book, dropped) {
            if (!dropped) {
                _this.putBack(book);
            }
        });
        this.input.on('drop', function (pointer, book, slot) {
            _this.drop(book, slot);
        });
    };
    MainScene.prototype.drop = function (book, slot) {
        // Lock book in place
        if (book.id === slot.id) {
            book.onShelf = true;
            book.input.enabled = false;
            slot.input.enabled = false;
            book.x = slot.shelfX;
            book.y = slot.y + 10;
            book.setScale(0.75);
        }
        else {
            this.putBack(book);
        }
        this.isGameOver();
    };
    MainScene.prototype.putBack = function (book) {
        book.x = book.input.dragStartX;
        book.y = book.input.dragStartY;
        book.setScale(1);
    };
    MainScene.prototype.isGameOver = function () {
        var _this = this;
        for (var _i = 0, _a = this.books; _i < _a.length; _i++) {
            var b = _a[_i];
            if (!b.onShelf) {
                return;
            }
        }
        this.input.enabled = false;
        // Wait a second and then end the game
        setTimeout(function () {
            _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_1__EndGameScene__["a" /* EndGameScene */], true);
            _this.scene.remove(_this);
        }, 1000);
        return true;
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "c";
        _this.gameClosingTextKey = "Librarian.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y - 100);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Book; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BookSlot; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Book = /** @class */ (function (_super) {
    __extends(Book, _super);
    function Book(scene, ob) {
        var _this = this;
        var id = ob.properties["id"];
        _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "book" + id) || this;
        _this.id = id;
        _this.onShelf = false;
        _this.setInteractive({ useHandCursor: true });
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    return Book;
}(Phaser.GameObjects.Sprite));

var BookSlot = /** @class */ (function (_super) {
    __extends(BookSlot, _super);
    function BookSlot(scene, ob) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height) || this;
        _this.id = ob.properties["id"];
        _this.shelfX = ob.properties["shelfX"];
        _this.setRectangleDropZone(_this.width, _this.height);
        _this.scene.add.existing(_this);
        return _this;
    }
    return BookSlot;
}(Phaser.GameObjects.Zone));



/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/librarian.c5aad305.json";

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/kc_background.806845ce.png";

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameLibrarian.e59f059e.png";

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameLibrarian.e9ab57ea.json";

/***/ }),
/* 2533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(952);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].UniformDesign;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "UniformDesign.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "UniformDesign.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EndGameScene__ = __webpack_require__(2535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_Uniform__ = __webpack_require__(2536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ColorChooserPopUpScene__ = __webpack_require__(2537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







// Paintbrush helper class to hold drawing attributes
var PaintBrush = /** @class */ (function () {
    // default color yellow, thickness 5
    function PaintBrush() {
        this.thickness = 8;
        this.color = 0x223e93;
        this.alpha = 1;
    }
    return PaintBrush;
}());
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    // Note: Starts out with sleb type of uniform
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.paintBrush = new PaintBrush();
        _this.div = document.createElement('div');
        _this.paintGunCursor = 'url(' + __webpack_require__(518) + '), pointer';
        _this.drawingMode = false;
        _this.num = 0;
        _this.debug = false;
        _this.textStyle = { fontFamily: "Russo One, Arial", fontSize: 22, align: "center" };
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON("map", __webpack_require__(2539));
        this.load.image("background", __webpack_require__(2540));
        this.load.atlas("other", __webpack_require__(2541), __webpack_require__(2542));
        this.load.atlas("sleb", __webpack_require__(2543), __webpack_require__(2544));
        this.load.atlas("human", __webpack_require__(2545), __webpack_require__(2546));
        __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__["a" /* PhaserColorWheel */].preload(this);
    };
    MainScene.prototype.initialize = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "map" });
        this.mascots = [];
        this.lineHistory = [];
        this.drawing = false;
        this.drawingMode = false;
        document.body.appendChild(this.div);
    };
    MainScene.prototype.create = function () {
        this.initialize();
        this.buildBackgroundContent();
        this.registerEvents();
    };
    MainScene.prototype.buildBackgroundContent = function () {
        var background = this.add.image(0, 0, "background").setOrigin(0);
        this.buildUniform();
        this.buildButton();
        this.buildColorChoosers();
        this.buildTypeChooser();
        this.createText();
        this.createMascots();
        this.buildColorWheel();
    };
    MainScene.prototype.buildUniform = function () {
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "uniform"; });
        this.uniform = new __WEBPACK_IMPORTED_MODULE_4__objects_Uniform__["a" /* Uniform */](this, ob.x + ob.width / 2, ob.y + ob.height / 2, "other");
        this.createUniformAreas();
        this.uniformTexture = this.add.renderTexture(0, 0, this.gameWidth, this.gameHeight);
        this.uniformTexture.setDepth(6);
        this.uniformGraphic = this.add.graphics();
        this.uniformGraphic.setDepth(6);
    };
    MainScene.prototype.buildColorChoosers = function () {
        var _this = this;
        var colors = this.map.getObjectLayer("Scene").objects.filter(function (ob) { return ob.type === "color"; });
        colors.forEach(function (ob) {
            if (ob.name === "primary") {
                _this.primaryColorChooser = _this.add.sprite(ob.x, ob.y, "other", "color" + _this.uniform.primaryColor); // Color picker sprite
                _this.primaryColorChooser.setOrigin(0);
                _this.primaryColorChooser.setInteractive({ useHandCursor: true });
                _this.primaryColorChooser.setDisplaySize(80, 40);
                _this.primaryColorChooser.on("pointerdown", function () {
                    _this.scene.setActive(false);
                    _this.scene.add("ColorChooserScene", new __WEBPACK_IMPORTED_MODULE_5__ColorChooserPopUpScene__["a" /* ColorChooserPopUpScene */]("primary", _this.num++), true);
                });
            }
            else if (ob.name === "secondary") {
                _this.secondaryColorChooser = _this.add.sprite(ob.x, ob.y, "other", "color" + _this.uniform.secondaryColor); // Color picker sprite
                _this.secondaryColorChooser.setOrigin(0);
                _this.secondaryColorChooser.setInteractive({ useHandCursor: true });
                _this.secondaryColorChooser.setDisplaySize(80, 40);
                _this.secondaryColorChooser.on("pointerdown", function () {
                    _this.scene.setActive(false);
                    _this.scene.add("ColorChooserScene", new __WEBPACK_IMPORTED_MODULE_5__ColorChooserPopUpScene__["a" /* ColorChooserPopUpScene */]("secondary", _this.num++), true);
                });
            }
            else if (ob.name === "tertiary") {
                _this.tertiaryColorChooser = _this.add.sprite(ob.x, ob.y, "other", "color" + _this.uniform.tertiaryColor); // Color picker sprite
                _this.tertiaryColorChooser.setOrigin(0);
                _this.tertiaryColorChooser.setInteractive({ useHandCursor: true });
                _this.tertiaryColorChooser.setDisplaySize(80, 40);
                _this.tertiaryColorChooser.on("pointerdown", function () {
                    _this.scene.setActive(false);
                    _this.scene.add("ColorChooserScene", new __WEBPACK_IMPORTED_MODULE_5__ColorChooserPopUpScene__["a" /* ColorChooserPopUpScene */]("tertiary", _this.num++), true);
                });
            }
        });
    };
    MainScene.prototype.buildButton = function () {
        var _this = this;
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "button"; });
        this.finishButton = this.add.sprite(ob.x, ob.y, "other", "button1");
        this.finishButton.setOrigin(0);
        this.finishButton.setInteractive({ useHandCursor: true });
        this.finishButton.on('pointerover', function () {
            _this.finishButton.setFrame("button2");
        });
        this.finishButton.on('pointerout', function () {
            _this.finishButton.setFrame("button1");
        });
        this.finishButton.on("pointerdown", function () {
            _this.finishButton.setFrame("button2");
            _this.drawingMode = false;
            // Screenshot for later
            _this.registry.parent.renderer.snapshot(function (image) {
                image.onload = function () {
                    var croppedImage = __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__["a" /* default */].CropImageToDataURI(image, 0, 0, _this.sys.canvas.width - 300, _this.sys.canvas.height);
                    console.warn("Screenshot!", croppedImage); // JB - Remove this console.warn
                    _this.endGame(croppedImage);
                };
            });
        });
    };
    MainScene.prototype.buildTypeChooser = function () {
        var _this = this;
        var ob;
        // radio1 = unselected, radio2 = selected
        ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "human"; });
        this.humanRadioButton = this.add.sprite(ob.x, ob.y, "other", "radio1");
        this.humanRadioButton.setInteractive({ useHandCursor: true });
        this.humanRadioButton.on("pointerdown", function () {
            _this.humanRadioButton.setFrame("radio2");
            _this.slebRadioButton.setFrame("radio1");
            _this.uniform.type = "human";
            _this.uniform.refresh();
        });
        ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "sleb"; });
        this.slebRadioButton = this.add.sprite(ob.x, ob.y, "other", "radio2");
        this.slebRadioButton.setInteractive({ useHandCursor: true });
        this.slebRadioButton.on("pointerdown", function () {
            _this.slebRadioButton.setFrame("radio2");
            _this.humanRadioButton.setFrame("radio1");
            _this.uniform.type = "sleb";
            _this.uniform.refresh();
        });
    };
    MainScene.prototype.createUniformAreas = function () {
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "slebPoly"; });
        var points = ob["polygon"];
        points.forEach(function (p) {
            p.x += ob.x;
            p.y += ob.y;
        });
        this.slebUniformArea = new Phaser.Geom.Polygon(points);
        ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "humanPoly"; });
        points = ob["polygon"];
        points.forEach(function (p) {
            p.x += ob.x;
            p.y += ob.y;
        });
        this.humanUniformArea = new Phaser.Geom.Polygon(points);
        if (this.debug) {
            this.drawPolygonUniformArea(this.slebUniformArea);
            this.drawPolygonUniformArea(this.humanUniformArea);
        }
    };
    MainScene.prototype.buildColorWheel = function () {
        var _this = this;
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "colorwheel"; });
        var colorWheel = new __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__["a" /* PhaserColorWheel */](this, ob.x, ob.y, 175, 175);
        colorWheel.on("colorChange", function (color) {
            _this.drawingMode = true;
            _this.paintBrush.color = color.color;
            _this.refreshPaintBrush();
            _this.input.setDefaultCursor(_this.paintGunCursor);
        });
        colorWheel.setDepth(2);
    };
    MainScene.prototype.createText = function () {
        var _this = this;
        this.map.getObjectLayer("Text").objects.forEach(function (ob) {
            var key = ob.name === "done" ? "common.done" : "UniformDesign.Phaser." + ob.properties["key"];
            var text = _this.add.text(ob.x, ob.y, __WEBPACK_IMPORTED_MODULE_6_src_utils_TranslateHelper__["a" /* default */].translate(key), _this.textStyle);
            text.setWordWrapWidth(200, true);
            if (ob.name === "done") {
                text.setColor("#000000");
            }
        });
    };
    MainScene.prototype.createMascots = function () {
        var _this = this;
        this.mascots = [];
        this.map.getObjectLayer("Mascots").objects.forEach(function (ob) {
            _this.createMascot(ob);
        });
    };
    MainScene.prototype.createMascot = function (ob) {
        var _this = this;
        var mascot = this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "other", ob.name);
        mascot.setInteractive({ useHandCursor: true });
        mascot.name = ob.name;
        mascot.on("pointerdown", function () {
            _this.drawingMode = false;
            _this.drawing = false;
            if (mascot.name === "remove") {
                if (_this.uniform.mascot != null) {
                    _this.uniform.mascot.destroy();
                    _this.uniform.mascot = null;
                    _this.uniform.mascotKey = null;
                }
            }
            else {
                _this.uniform.mascotKey = ob.name;
            }
            _this.uniform.refresh();
        });
        this.mascots.push(mascot);
    };
    MainScene.prototype.refreshPaintBrush = function () {
        this.uniformGraphic.lineStyle(this.paintBrush.thickness, this.paintBrush.color, this.paintBrush.alpha);
    };
    MainScene.prototype.registerEvents = function () {
        this.input.on('pointerdown', this.pointerDown);
        this.input.on('pointerup', this.pointerUp);
        this.input.on('pointermove', this.pointerMove);
    };
    MainScene.prototype.canDraw = function (pointer) {
        var area = this.uniform.type === "sleb" ? this.slebUniformArea : this.humanUniformArea;
        if (area.contains(pointer.x, pointer.y)) {
            return true;
        }
        return false;
    };
    MainScene.prototype.pointerDown = function (pointer) {
        if (this.drawingMode && this.canDraw(pointer)) {
            this.drawing = true;
        }
        this.lineHistory = [];
    };
    MainScene.prototype.pointerUp = function (pointer) {
        this.drawing = false;
        this.uniformGraphic.generateTexture("background-drawn", this.gameWidth, this.gameHeight);
        this.uniformGraphic.clear();
        var tempImage = this.add.image(0, 0, "background-drawn");
        this.uniformTexture.save();
        this.uniformTexture.draw(tempImage.texture, tempImage.frame, 0, 0);
        this.uniformTexture.restore();
        tempImage.destroy();
    };
    MainScene.prototype.pointerMove = function (pointer) {
        if (this.drawing && this.canDraw(pointer)) {
            this.uniformGraphic.clear();
            this.refreshPaintBrush();
            this.lineHistory.push(new Phaser.Geom.Point(pointer.x, pointer.y));
            // Do the drawing
            this.uniformGraphic.strokePoints(this.lineHistory);
        }
        if (this.drawingMode && this.canDraw(pointer)) {
            this.input.setDefaultCursor(this.paintGunCursor);
        }
        else {
            this.input.setDefaultCursor("pointer");
        }
    };
    MainScene.prototype.endGame = function (image) {
        MainScene.CROPPED_IMAGE = image;
        this.input.setDefaultCursor("default");
        this.input.removeAllListeners();
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_3__EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    MainScene.prototype.drawPolygonUniformArea = function (polygon) {
        // Draw polygon and set it up
        var graphics = this.add.graphics();
        graphics.lineStyle(2, 0x000000);
        graphics.beginPath();
        graphics.moveTo(polygon.points[0].x, polygon.points[0].y);
        for (var i = 1; i < polygon.points.length; i++) {
            graphics.lineTo(polygon.points[i].x, polygon.points[i].y);
        }
        graphics.closePath();
        graphics.strokePath();
    };
    MainScene.prototype.changeColor = function (colorType, color) {
        if (colorType === "primary") {
            this.uniform.primaryColor = color;
            this.primaryColorChooser.setFrame("color" + color);
        }
        else if (colorType === "secondary") {
            this.uniform.secondaryColor = color;
            this.secondaryColorChooser.setFrame("color" + color);
        }
        else if (colorType === "tertiary") {
            this.uniform.tertiaryColor = color;
            this.tertiaryColorChooser.setFrame("color" + color);
        }
        this.uniform.refresh();
        this.scene.setActive(true);
    };
    MainScene.CROPPED_IMAGE = null;
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_ShipPainting_scenes_MainScene__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "a";
        _this.gameClosingTextKey = "UniformDesign.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(155));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete(__WEBPACK_IMPORTED_MODULE_4_src_games_ShipPainting_scenes_MainScene__["a" /* MainScene */].CROPPED_IMAGE);
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UniformConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Uniform; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UniformConfig = /** @class */ (function () {
    function UniformConfig() {
    }
    return UniformConfig;
}());

var Uniform = /** @class */ (function (_super) {
    __extends(Uniform, _super);
    function Uniform(scene, x, y, texture) {
        var _this = _super.call(this, scene, x, y, "other", "slebBase") || this;
        _this.primaryColor = 1;
        _this.secondaryColor = 1;
        _this.tertiaryColor = 1;
        _this.mascotKey = null;
        _this.type = "sleb";
        _this.primaryLayer = _this.scene.add.sprite(_this.x, _this.y, _this.type, _this.type + "PrimaryColor" + _this.primaryColor);
        _this.secondaryLayer = _this.scene.add.sprite(_this.x, _this.y, _this.type, _this.type + "SecondaryColor" + _this.secondaryColor);
        _this.tertiaryLayer = _this.scene.add.sprite(_this.x, _this.y, _this.type, _this.type + "TertiaryColor" + _this.tertiaryColor);
        _this.mascot = null;
        _this.tertiaryLayer.setDepth(4);
        _this.secondaryLayer.setDepth(3);
        _this.primaryLayer.setDepth(2);
        _this.setInteractive({ useHandCursor: true });
        _this.setDepth(5);
        _this.scene.add.existing(_this);
        return _this;
    }
    Uniform.prototype.refresh = function () {
        this.primaryLayer.setTexture(this.type, this.type + "PrimaryColor" + this.primaryColor);
        this.secondaryLayer.setTexture(this.type, this.type + "SecondaryColor" + this.secondaryColor);
        this.tertiaryLayer.setTexture(this.type, this.type + "TertiaryColor" + this.tertiaryColor);
        if (this.mascot != null) {
            this.mascot.setFrame(this.mascotKey);
            this.positionMascot();
        }
        else if (this.mascotKey != null) {
            this.createMascot();
        }
        this.setTexture("other", this.type + "Base");
    };
    Uniform.prototype.createMascot = function () {
        this.mascot = this.scene.add.sprite(this.x, this.y, "other", this.mascotKey);
        this.positionMascot();
        this.mascot.setDepth(6.1);
    };
    Uniform.prototype.positionMascot = function () {
        if (this.type === "sleb") {
            this.mascot.setPosition(this.x, this.y);
        }
        else {
            this.mascot.setPosition(this.x + 10, this.y - 175);
        }
    };
    return Uniform;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorChooserPopUpScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColorChooserPopUp__ = __webpack_require__(2538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ColorChooserPopUpScene = /** @class */ (function (_super) {
    __extends(ColorChooserPopUpScene, _super);
    function ColorChooserPopUpScene(colorType, num) {
        var _this = _super.call(this, {
            key: "ColorChooserPopUp_" + num,
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ColorChooserPopUpScene.prototype);
        _this.colorType = colorType;
        return _this;
    }
    ColorChooserPopUpScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        var popup = new __WEBPACK_IMPORTED_MODULE_0__ColorChooserPopUp__["a" /* ColorChooserPopUp */](this, this.gameWidth / 2, this.gameHeight / 2);
        popup.on('choseColor', function (color) {
            popup.destroy();
            // Hacky way of calling a method in another scene!
            var mainScene = _this.scene.get("MainScene");
            mainScene.changeColor(_this.colorType, color);
        });
    };
    return ColorChooserPopUpScene;
}(Phaser.Scene));



/***/ }),
/* 2538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorChooserPopUp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ColorChooserPopUp = /** @class */ (function (_super) {
    __extends(ColorChooserPopUp, _super);
    function ColorChooserPopUp(scene, x, y) {
        var _this = _super.call(this, scene, x, y, []) || this;
        _this.colors = [
            1,
            3,
            4,
            5,
            6,
            7,
            9,
            11
        ];
        _this.setDepth(10);
        _this.setSize(380, 480);
        _this.addBackground();
        _this.addColors();
        _this.scene.add.existing(_this);
        return _this;
    }
    ColorChooserPopUp.prototype.addBackground = function () {
        var background = this.scene.add.image(0, 0, "pixel");
        background.setDisplaySize(this.width, this.height);
        background.setTint(0x000000);
        background.setDepth(0);
        this.add(background);
        var style = { fontFamily: "Russo One, Arial", fontSize: 20, align: "center" };
        var title = this.scene.add.text(0, -215, __WEBPACK_IMPORTED_MODULE_0_src_utils_TranslateHelper__["a" /* default */].translate("UniformDesign.Phaser.popupTitle"), style);
        title.setOrigin(0.5);
        this.add(title);
    };
    ColorChooserPopUp.prototype.addColors = function () {
        var squares = [];
        for (var _i = 0, _a = this.colors; _i < _a.length; _i++) {
            var color = _a[_i];
            var square = this.createColorSquare(color);
            this.add(square);
            squares.push(square);
        }
        Phaser.Actions.GridAlign(squares, {
            x: -60,
            y: -110,
            width: 2,
            height: -1,
            cellWidth: 120,
            cellHeight: 100,
        });
    };
    ColorChooserPopUp.prototype.createColorSquare = function (color) {
        var _this = this;
        var square = this.scene.add.image(0, 0, "other", "color" + color);
        square.setDepth(1);
        square.setInteractive({ useHandCursor: true });
        square.on("pointerdown", function () {
            _this.emit("choseColor", color);
        });
        return square;
    };
    return ColorChooserPopUp;
}(Phaser.GameObjects.Container));



/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/uniform_design.5d735fe4.json";

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1a_background.17227bae.png";

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameUniformDesignOther.2710cf87.png";

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameUniformDesignOther.b97231a7.json";

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameUniformDesignSleb.a1087901.png";

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameUniformDesignSleb.a0a93b9d.json";

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameUniformDesignHuman.982b8aec.png";

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameUniformDesignHuman.4db2a0b9.json";

/***/ }),
/* 2547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(954);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].OceanCleanup;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "OceanCleanup.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "OceanCleanup.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "OceanCleanup.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Trash__ = __webpack_require__(2549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Gamepad__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EndGameScene__ = __webpack_require__(2554);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.xVel = 0;
        _this.yVel = 0;
        _this.NORMAL_SPEED = 200;
        _this.TURBO_SPEED = _this.NORMAL_SPEED + 100;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.spritesheet("background", __webpack_require__(2555), { frameWidth: 1360, frameHeight: 768 });
        this.load.spritesheet("foreground", __webpack_require__(2556), { frameWidth: 1360, frameHeight: 768 });
        this.load.tilemapTiledJSON("map", __webpack_require__(2557));
        this.load.spritesheet('diver', __webpack_require__(2558), { frameWidth: 40, frameHeight: 80 });
        this.load.spritesheet('boat', __webpack_require__(2559), { frameWidth: 900, frameHeight: 170 });
        this.load.spritesheet('fishy', __webpack_require__(2560), { frameWidth: 375, frameHeight: 300 });
        this.load.spritesheet('snugglefish', __webpack_require__(2561), { frameWidth: 250, frameHeight: 150 });
        this.load.spritesheet('bubbles', __webpack_require__(2562), { frameWidth: 15, frameHeight: 60 });
        this.load.spritesheet("immobile-trash", __webpack_require__(2563), { frameWidth: 100, frameHeight: 100 });
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_1__objects_Trash__["b" /* TrashConfig */].TRASH; _i < _a.length; _i++) {
            var spritesheet = _a[_i];
            this.load.spritesheet(spritesheet.name, spritesheet.src, { frameWidth: 70, frameHeight: 70 });
        }
        __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.trash = this.physics.add.group();
        this.currentTrash = null;
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_2_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.gamePad.on("keydown_a", this.speedBoost);
        this.speed = this.NORMAL_SPEED;
        this.bubbles = [];
        this.counter = 0;
    };
    MainScene.prototype.create = function () {
        this.initialize();
        this.createScene();
        this.createCollisions();
        this.createBubbles();
        this.createCounter();
    };
    MainScene.prototype.createDiver = function () {
        this.diver = this.physics.add.sprite(this.gameWidth / 2, 250, "diver", 4);
        this.diver.setSize(40, 75);
        this.diver.setDepth(2.6);
        this.diver.setCollideWorldBounds(true);
        this.diver.body.allowRotation = true;
        this.anims.create({
            key: "swim",
            frames: this.anims.generateFrameNumbers("diver", { start: 0, end: 1 }),
            frameRate: 4,
            repeat: -1,
        });
        this.diver.anims.play('swim');
    };
    /**
     * Pressing A gives a turbo boost for 1/2 second
     */
    MainScene.prototype.speedBoost = function () {
        var _this = this;
        if (this.speed > this.NORMAL_SPEED) {
            return;
        }
        this.speed = this.TURBO_SPEED;
        setTimeout(function () {
            _this.speed = _this.NORMAL_SPEED;
        }, 500);
    };
    MainScene.prototype.createScene = function () {
        var _this = this;
        var background = this.add.sprite(0, 0, "background", 0);
        background.setOrigin(0);
        background.setDepth(0);
        var foreground = this.add.sprite(0, 0, "foreground", 0);
        foreground.setOrigin(0);
        foreground.setDepth(3);
        this.anims.create({
            key: "background",
            frames: this.anims.generateFrameNumbers("background", { start: 0, end: 1 }),
            frameRate: 1,
            repeat: -1
        });
        background.anims.play('background');
        this.anims.create({
            key: "foreground",
            frames: this.anims.generateFrameNumbers("foreground", { start: 0, end: 1 }),
            frameRate: 1,
            repeat: -1
        });
        foreground.anims.play('foreground');
        this.createDiver();
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "boat") {
                _this.boat = _this.physics.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "boat", 0);
                _this.boat.setSize(850, 100);
                _this.boat.setOffset(25, 60);
                _this.anims.create({
                    key: "bob",
                    frames: _this.anims.generateFrameNumbers("boat", { start: 0, end: 3 }),
                    frameRate: 1,
                    repeat: -1,
                });
                _this.boat.anims.play('bob');
                // If diver is carrying trash and overlaps with the boat AND B is pressed, put trash on the boat
                _this.physics.add.overlap(_this.diver, _this.boat, _this.putTrashOnBoat, _this.canPutTrashOnBoat);
            }
            else if (ob.type === "trash") {
                var config = __WEBPACK_IMPORTED_MODULE_1__objects_Trash__["b" /* TrashConfig */].TRASH.find(function (t) { return t.name === ob.name; });
                if (config == null) {
                    config = __WEBPACK_IMPORTED_MODULE_1__objects_Trash__["b" /* TrashConfig */].IMMOBILE_TRASH.find(function (t) { return t.name === ob.name; });
                }
                var pieceOfTrash = new __WEBPACK_IMPORTED_MODULE_1__objects_Trash__["a" /* Trash */](_this, ob.x + ob.width / 2, ob.y + ob.height / 2, config);
                if (config.name === "cans" || config.name === "bottle") {
                    pieceOfTrash.setSize(50, 50);
                }
                if (config.animates) {
                    _this.createTrashAnimation(config, pieceOfTrash);
                }
                _this.trash.add(pieceOfTrash);
            }
            else if (ob.name === "fishy") {
                _this.fishy = _this.add.sprite(ob.x, ob.y, "fishy", 0);
                _this.fishy.setOrigin(0);
                _this.fishy.setDepth(2.5);
                _this.anims.create({
                    key: 'fishy',
                    frames: _this.anims.generateFrameNumbers("fishy", { start: 1, end: 3 }),
                    frameRate: 3,
                    repeat: -1
                });
                _this.fishy.anims.play('fishy');
                _this.anims.create({
                    key: 'openMouth',
                    frames: _this.anims.generateFrameNumbers("fishy", { start: 1, end: 4 }),
                    frameRate: 8,
                });
            }
            else if (ob.name === "snugglefish") {
                _this.snugglefish = _this.physics.add.sprite(ob.x, ob.y, "snugglefish", 0);
                _this.snugglefish.setOrigin(0);
                _this.snugglefish.setDepth(2);
                _this.anims.create({
                    key: 'snugglefish',
                    frames: _this.anims.generateFrameNumbers("snugglefish", { start: 0, end: 3 }),
                    frameRate: 3,
                    repeat: -1
                });
                _this.snugglefish.anims.play('snugglefish');
            }
            else if (ob.name === "nearSnuggleFish") {
                var snuggleFishZone = _this.add.zone(ob.x, ob.y, ob.width, ob.height);
                snuggleFishZone.setOrigin(0);
                _this.physics.add.existing(snuggleFishZone, true);
                _this.physics.add.overlap(_this.diver, snuggleFishZone, _this.hideSnugglefish);
            }
            else if (ob.name === "nearFishy") {
                var fishyZone = _this.add.zone(ob.x, ob.y, ob.width, ob.height);
                fishyZone.setOrigin(0);
                _this.physics.add.existing(fishyZone, true);
                _this.physics.add.overlap(_this.diver, fishyZone, _this.openFishyMouth);
            }
        });
        // If the diver isn't carrying any trash and overlaps with a piece of trash that isn't already on the boat, pick up that trash
        this.physics.add.overlap(this.diver, this.trash, this.pickUpTrash, this.canPickUpTrash);
    };
    MainScene.prototype.createCollisions = function () {
        var _this = this;
        this.map.getObjectLayer("Collision").objects.forEach(function (ob) {
            var zone = _this.add.zone(ob.x, ob.y, ob.width, ob.height);
            zone.setOrigin(0);
            _this.physics.add.existing(zone, true);
            _this.physics.add.collider(_this.diver, zone);
        });
    };
    MainScene.prototype.createBubbles = function () {
        var _this = this;
        this.map.getObjectLayer("Bubbles").objects.forEach(function (ob) {
            var bubbles = _this.add.sprite(ob.x, ob.y, "bubbles", 0);
            bubbles.setOrigin(0);
            bubbles.setName(ob.name);
            _this.anims.create({
                key: ob.name,
                frames: _this.anims.generateFrameNumbers("bubbles", { start: 0, end: 3 }),
                frameRate: 2,
                repeat: -1
            });
            bubbles.anims.play(ob.name);
            _this.bubbles.push(bubbles);
        });
    };
    MainScene.prototype.createCounter = function () {
        this.counter = this.trash.getChildren().length;
        var style = { fontFamily: "Russo One, Arial", fontSize: 35, color: "#000000" };
        this.counterText = this.add.text(this.gameWidth - 50, 20, this.counter + "", style);
    };
    MainScene.prototype.isCarryingTrash = function () {
        return this.currentTrash != null;
    };
    MainScene.prototype.canPutTrashOnBoat = function (diver, boat) {
        return this.isCarryingTrash();
    };
    /**
     * Only pick up trash if you're not already carrying some and it's not already on the boat
     */
    MainScene.prototype.canPickUpTrash = function (diver, trash) {
        return !this.isCarryingTrash() && !trash.onBoat;
    };
    /**
     * Diver picks up trash
     */
    MainScene.prototype.pickUpTrash = function (diver, trash) {
        trash.depth = diver.depth;
        this.currentTrash = trash;
        // Destroy the animations
        trash.anims.stop();
        var anim = this.anims.get(trash.name + "_bubbles");
        if (anim != null) {
            anim.destroy();
        }
        // Destroy the bubbles if it has them
        var bubbles = this.bubbles.find(function (b) { return b.name === trash.name + "_bubbles"; });
        if (bubbles != null) {
            bubbles.destroy();
        }
        // When you pick up something other than the cans, it'll resume fishy's normal animation
        if (trash.name !== "cans") {
            this.fishy.anims.play("fishy", true);
        }
    };
    MainScene.prototype.createTrashAnimation = function (config, trash) {
        this.anims.create({
            key: config.name,
            frames: this.anims.generateFrameNumbers(config.name, { start: 0, end: 3 }),
            frameRate: 1,
            repeat: -1
        });
        trash.anims.play(config.name);
    };
    MainScene.prototype.putTrashOnBoat = function (diver, boat) {
        var trash = this.currentTrash;
        this.currentTrash = null;
        this.counter--;
        this.counterText.setText(this.counter + "");
        trash.onBoat = true;
        trash.setVisible(false);
        // Check if the game is over
        this.isGameOver();
        // If they just got rid of the cans, delete the open mouth animation
        if (trash.name === "cans") {
            this.anims.get("openMouth").destroy();
        }
        // If the snugglefish is hidden, show it again
        if (this.snugglefish.x <= -100) {
            this.showSnugglefish();
        }
        this.fishy.anims.play("fishy");
    };
    MainScene.prototype.isGameOver = function () {
        var trash;
        for (var _i = 0, _a = this.trash.getChildren(); _i < _a.length; _i++) {
            trash = _a[_i];
            if (!trash.onBoat) {
                return false;
            }
        }
        this.endGame();
        return true;
    };
    MainScene.prototype.update = function () {
        this.updatePlayerMovement();
    };
    MainScene.prototype.updatePlayerMovement = function () {
        if (!this.diver.body.enable) {
            return;
        }
        this.diver.setAngularVelocity(0);
        this.diver.setVelocity(0);
        if (this.gamePad.keys.left.isDown) {
            this.diver.setAngularVelocity(-this.speed);
        }
        if (this.gamePad.keys.right.isDown) {
            this.diver.setAngularVelocity(this.speed);
        }
        if (this.gamePad.keys.up.isDown) {
            var vel = this.physics.velocityFromAngle(this.diver.angle + 90, this.speed);
            this.diver.setVelocity(vel.x, vel.y);
        }
        // Diver is carrying trash
        if (this.isCarryingTrash()) {
            this.currentTrash.x = this.diver.x + 60;
            this.currentTrash.y = this.diver.y;
        }
    };
    MainScene.prototype.endGame = function () {
        var _this = this;
        this.diver.setVelocity(0, 0);
        this.diver.disableBody();
        this.input.enabled = false;
        setTimeout(function () {
            _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_3__EndGameScene__["a" /* EndGameScene */], true);
            _this.scene.remove(_this);
        }, 1000);
    };
    MainScene.prototype.hideSnugglefish = function (diver, snugglefishZone) {
        this.tweens.add({
            targets: this.snugglefish,
            x: -110,
            duration: 1000,
            ease: "Linear",
        });
    };
    MainScene.prototype.showSnugglefish = function () {
        this.tweens.add({
            targets: this.snugglefish,
            x: 90,
            duration: 2500,
            ease: "Linear",
        });
    };
    MainScene.prototype.openFishyMouth = function (diver, fishyzone) {
        if (this.fishy.anims.getCurrentKey() === "openMouth") {
            return;
        }
        this.fishy.anims.play('openMouth', true);
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TrashConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Trash; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var TrashConfig = /** @class */ (function () {
    function TrashConfig() {
    }
    TrashConfig.TRASH = [
        { id: 0, name: "tire", src: __webpack_require__(2550), animates: true },
        { id: 1, name: "bottle", src: __webpack_require__(2551), animates: true },
        { id: 2, name: "bag", src: __webpack_require__(2552), animates: true },
        { id: 3, name: "barrel", src: __webpack_require__(2553), animates: true }
    ];
    TrashConfig.IMMOBILE_TRASH = [
        { id: 4, name: "bike", frame: 2, depth: 3 },
        { id: 5, name: "spaceship-part", frame: 0, depth: 3 },
        { id: 6, name: "fridge", frame: 1 },
        { id: 7, name: "satellite", frame: 3, depth: 3 },
        { id: 8, name: "cans", frame: 4 },
    ];
    return TrashConfig;
}());

var Trash = /** @class */ (function (_super) {
    __extends(Trash, _super);
    function Trash(scene, x, y, config) {
        var _this = this;
        if (config.animates != null && config.animates) {
            _this = _super.call(this, scene, x, y, config.name, 0) || this;
        }
        else {
            _this = _super.call(this, scene, x, y, "immobile-trash", config.frame) || this;
        }
        _this.name = config.name;
        _this.id = config.id;
        _this.onBoat = false;
        if (config.depth) {
            _this.setDepth(config.depth);
        }
        else {
            _this.setDepth(2);
        }
        scene.add.existing(_this);
        scene.physics.add.existing(_this);
        return _this;
    }
    return Trash;
}(Phaser.Physics.Arcade.Sprite));



/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tire.b88a64f8.png";

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bottle.8def4027.png";

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bag.1d0b6b69.png";

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/barrel.8442e579.png";

/***/ }),
/* 2554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "r";
        _this.gameClosingTextKey = "OceanCleanup.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/background.a51a7f95.png";

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/foreground.ce382891.png";

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/ocean_cleanup.37198c01.json";

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/diver.fe95c7c2.png";

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/submarine.126e390c.png";

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fishy.c1aa02f7.png";

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/snugglefish.c27aa1bc.png";

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bubbles.10fa8b08.png";

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/immobile_assets.a4f9ffb1.png";

/***/ }),
/* 2564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GameIntro__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChooseVehicleScene__ = __webpack_require__(2565);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].ConstructionMaze;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_3__ChooseVehicleScene__["a" /* ChooseVehicleScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_2__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "ConstructionMaze.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "ConstructionMaze.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "ConstructionMaze.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChooseVehicleScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainScene__ = __webpack_require__(2566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ChooseVehicleScene = /** @class */ (function (_super) {
    __extends(ChooseVehicleScene, _super);
    function ChooseVehicleScene() {
        var _this = _super.call(this, {
            key: "ChooseVehicleScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, ChooseVehicleScene.prototype);
        return _this;
    }
    ChooseVehicleScene.prototype.preload = function () {
        this.load.image("background", __webpack_require__(2569));
        this.load.atlas("assets", __webpack_require__(2570), __webpack_require__(2571));
    };
    ChooseVehicleScene.prototype.create = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        var background = this.add.image(0, 0, "background").setOrigin(0);
        var modal = this.add.image(0, 0, "assets", "Modal").setOrigin(0);
        var x = 400;
        var y = 550;
        var style = { fontSize: 20, fontFamily: "Russo One, Arial", color: "#000000" };
        var title = this.add.text(150, 400, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("ConstructionMaze.Phaser.modalTitle"), style);
        title.setFontSize(30);
        for (var i = 1; i < 4; i++) {
            var vehicle = this.createVehicle(x, y, i);
            var label = this.add.text(x, y, i + ':' + __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("ConstructionMaze.Phaser.vehicle" + i), style);
            Phaser.Display.Align.In.TopCenter(label, vehicle);
            label.y += 250;
            x += 300;
        }
        this.bindKeyboard();
    };
    ChooseVehicleScene.prototype.selectVehicle = function (id) {
        __WEBPACK_IMPORTED_MODULE_1__MainScene__["a" /* MainScene */].VehicleFrame = "vehicle" + id + "little";
        this.input.enabled = false;
        this.scene.add("MainScene", __WEBPACK_IMPORTED_MODULE_1__MainScene__["a" /* MainScene */], true);
        this.scene.remove("ChooseVehicleScene");
    };
    ChooseVehicleScene.prototype.createVehicle = function (x, y, id) {
        var _this = this;
        var vehicle = this.add.image(x, y, "assets", "vehicle" + id + "big");
        vehicle.setInteractive({ useHandCursor: true });
        vehicle.on('pointerdown', function () {
            _this.selectVehicle(id);
        });
        return vehicle;
    };
    ChooseVehicleScene.prototype.onKeydown = function (event) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        keys.forEach(function (key) {
            _this.input.keyboard.on('keydown_' + key, event);
        });
    };
    ChooseVehicleScene.prototype.bindKeyboard = function () {
        var _this = this;
        this.onKeydown(function () { _this.selectVehicle(1); }, 'ONE', 'NUMPAD_ONE');
        this.onKeydown(function () { _this.selectVehicle(2); }, 'TWO', 'NUMPAD_TWO');
        this.onKeydown(function () { _this.selectVehicle(3); }, 'THREE', 'NUMPAD_THREE');
    };
    return ChooseVehicleScene;
}(Phaser.Scene));



/***/ }),
/* 2566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Gamepad__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EndGameScene__ = __webpack_require__(2567);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON("map", __webpack_require__(2568));
        __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
    };
    MainScene.prototype.create = function () {
        this.initialize();
        this.createScene();
        this.createCollisions();
    };
    MainScene.prototype.createVehicle = function () {
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "vehicle"; });
        this.vehicle = this.matter.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", MainScene.VehicleFrame);
        this.vehicle.setFrictionAir(0.1);
        this.vehicle.setBody({
            type: 'rectangle',
            width: this.vehicle.frame.name === "vehicle1little" ? 50 : this.vehicle.frame.name === "vehicle2little" ? 35 : 60,
            height: this.vehicle.frame.name === "vehicle1little" ? 25 : this.vehicle.frame.name === "vehicle2little" ? 10 : 30
        }, {});
        this.vehicle.setMass(2);
        this.matter.world.setBounds(0, 0, this.gameWidth, this.gameHeight);
    };
    MainScene.prototype.createScene = function () {
        var background = this.add.image(0, 0, "background").setOrigin(0);
        this.createFinish();
        this.createVehicle();
    };
    MainScene.prototype.createCollisions = function () {
        var _this = this;
        this.map.getObjectLayer("Collision").objects.forEach(function (ob) {
            var zone = _this.matter.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "pixel");
            zone.setAlpha(0);
            zone.setDisplaySize(ob.width, ob.height);
            zone.setBody({
                type: 'rectangle',
                width: ob.width,
                height: ob.height,
            }, { isStatic: true });
        });
        var frame = 1;
        this.map.getObjectLayer("Obstacles").objects.forEach(function (ob) {
            if (frame === 7) {
                frame = 1;
            }
            if (ob.type === "horizontal") {
                var horizontalObstacle = _this.matter.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "HorizontalBarricade");
                horizontalObstacle.setBody({
                    type: 'rectangle',
                    width: 80,
                    height: 75,
                }, { isStatic: true });
            }
            else {
                var verticalObstacle = _this.matter.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "VerticalBarricade");
                verticalObstacle.setBody({
                    type: 'rectangle',
                    width: 75,
                    height: 80,
                }, { isStatic: true });
            }
        });
    };
    MainScene.prototype.createFinish = function () {
        var _this = this;
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "finish"; });
        var finish = this.matter.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "pixel", null, { label: 'finish' });
        finish.setAlpha(0);
        finish.setBody({
            type: 'rectangle',
            width: ob.width,
            height: ob.height,
        }, { isStatic: true, isSensor: true });
        finish.setSensor(true);
        finish.setStatic(true);
        this.matter.world.on('collisionstart', function (event, bodyA, bodyB) {
            if (bodyB.id === 7) {
                _this.endGame();
            }
        });
    };
    MainScene.prototype.update = function () {
        this.updatePlayerMovement();
    };
    MainScene.prototype.updatePlayerMovement = function () {
        if (this.gamePad.keys.left.isDown) {
            this.vehicle.setAngularVelocity(-0.05);
        }
        else if (this.gamePad.keys.right.isDown) {
            this.vehicle.setAngularVelocity(0.05);
        }
        else if (this.gamePad.keys.left.isUp || this.gamePad.keys.right.isUp) {
            this.vehicle.setAngularVelocity(0);
        }
        if (this.gamePad.keys.up.isDown) {
            this.vehicle.thrust(0.015);
        }
        else if (this.gamePad.keys.up.isUp) {
            this.vehicle.setVelocity(0);
        }
        if (this.gamePad.keys.down.isDown) {
            this.vehicle.thrustBack(0.015);
        }
        else if (this.gamePad.keys.down.isUp) {
            this.vehicle.setVelocity(0);
        }
    };
    MainScene.prototype.endGame = function () {
        var _this = this;
        this.vehicle.setStatic(true);
        this.input.removeAllListeners();
        setTimeout(function () {
            _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_2__EndGameScene__["a" /* EndGameScene */], true);
            _this.scene.remove(_this);
        }, 1000);
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "r";
        _this.gameClosingTextKey = "ConstructionMaze.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/construction_maze.22572fbb.json";

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/kr_background.d1ab7175.png";

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameConstructionMaze.bf5f0c69.png";

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameConstructionMaze.b7e5ec90.json";

/***/ }),
/* 2572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(958);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].VendingMachine;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "VendingMachine.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "VendingMachine.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Coin__ = __webpack_require__(2574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_VendingItem__ = __webpack_require__(2575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EndGameScene__ = __webpack_require__(2576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene" + Math.random()
        }) || this;
        _this.boughtItemsX = 550;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image('background', __webpack_require__(2577));
        this.load.tilemapTiledJSON('map', __webpack_require__(2578));
        this.load.atlas("assets", __webpack_require__(2579), __webpack_require__(2580));
        this.load.spritesheet('button', __webpack_require__(937), { frameWidth: 90, frameHeight: 90 });
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.coins = [];
        this.items = [];
        this.total = 0;
        this.currentAmount = 0;
    };
    MainScene.prototype.create = function () {
        this.initialize();
        this.createScene();
        this.registerEvents();
        this.createFeedbacks("tooMuch", "tooLittle");
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.dragDistanceThreshold = 10;
        this.input.on('dragstart', function (pointer, coin) {
            _this.children.bringToTop(coin);
            coin.setScale(0.3);
        });
        this.input.on('drag', function (pointer, coin, dragX, dragY) {
            coin.x = pointer.x;
            coin.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, coin, dropped) {
            // Move dropped object back to start if not dropped onto a dropzone
            if (!dropped) {
                coin.x = coin.input.dragStartX;
                coin.y = coin.input.dragStartY;
                coin.setScale(1);
            }
        });
        this.input.on("drop", function (pointer, coin, dropzone) {
            if (dropzone.name === "tray") {
                coin.putBackInPile();
            }
            else {
                _this.insertCoin(coin, dropzone);
            }
            _this.updateCounters();
        });
    };
    MainScene.prototype.createScene = function () {
        var _this = this;
        var background = this.add.image(0, 0, "background").setOrigin(0);
        var coinId = 0;
        var textStyle = {
            fontSize: 25,
            fontFamily: "Russo One, Arial",
            padding: 20,
            color: "#ffffff"
        };
        var text, box;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "button") {
                _this.createDoneButton(ob);
            }
            else if (ob.name === "tray") {
                _this.createCoinTray(ob);
            }
            else if (ob.type === "Coin") {
                var coin = new __WEBPACK_IMPORTED_MODULE_1__objects_Coin__["a" /* Coin */](_this, ob, coinId++);
                _this.coins.push(coin);
                _this.total += coin.value;
            }
            else if (ob.name === "machine") {
                var machineBack = _this.add.sprite(ob.x, ob.y, "assets", "machine-back");
                machineBack.setOrigin(0);
                machineBack.setDepth(1);
                var machineFront = _this.add.sprite(ob.x, ob.y, "assets", "machine-front");
                machineFront.setOrigin(0);
                machineFront.setDepth(3);
            }
            else if (ob.name === "counter") {
                text = _this.add.text(ob.x + 20, ob.y + 15, __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].translate("VendingMachine.Phaser.yourGold"), textStyle);
                _this.totalCounter = _this.add.text(_this.gameWidth - 170, ob.y, _this.total + "", textStyle);
                _this.totalCounter.setDepth(3.5);
                _this.totalCounter.setFontSize(50);
            }
        });
        this.createVendingMachine(textStyle);
    };
    MainScene.prototype.createVendingMachine = function (textStyle) {
        var _this = this;
        var itemId = 0;
        this.map.getObjectLayer("VendingMachine").objects.forEach(function (ob) {
            if (ob.type === "VendingItem") {
                var item = new __WEBPACK_IMPORTED_MODULE_2__objects_VendingItem__["a" /* VendingItem */](_this, ob, itemId++);
                item.on("pointerdown", function () {
                    _this.tryToBuyItem(item);
                });
                _this.items.push(item);
            }
            else if (ob.name === "machine_count") {
                textStyle.color = "#000000";
                _this.machineCounter = _this.add.text(ob.x + ob.width / 2, ob.y + ob.height / 2, _this.currentAmount + "", textStyle);
                _this.machineCounter.setOrigin(0.5);
                _this.machineCounter.setDepth(5);
            }
            else if (ob.name === "coin_zone") {
                _this.coinZone = _this.add.zone(ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);
                _this.coinZone.setRectangleDropZone(ob.width, ob.height);
                _this.coinZone.setDepth(10);
            }
            else if (ob.name === "eject") {
                var eject = _this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "eject_button");
                eject.setDepth(12);
                eject.setInteractive({ useHandCursor: true });
                eject.on("pointerdown", function () {
                    _this.ejectCoins();
                });
            }
        });
    };
    MainScene.prototype.tryToBuyItem = function (item) {
        if (this.currentAmount > item.cost) {
            this.showFeedback(true);
        }
        else if (this.currentAmount < item.cost) {
            this.showFeedback(false);
        }
        else {
            this.tweens.killTweensOf([this.tooLittleFeedback, this.tooMuchFeedback]);
            this.tooLittleFeedback.setAlpha(0);
            this.tooMuchFeedback.setAlpha(0);
            this.coins.forEach(function (c) {
                if (c.inMachine) {
                    c.spent = true;
                }
            });
            item.free(this.boughtItemsX, 650);
            this.currentAmount = 0;
            this.updateCounters();
            this.boughtItemsX += 130;
        }
    };
    MainScene.prototype.insertCoin = function (coin, dropzone) {
        this.currentAmount += coin.value;
        this.total -= coin.value;
        coin.inMachine = true;
        coin.setVisible(false);
        this.updateCounters();
    };
    MainScene.prototype.endGame = function () {
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_3__EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    MainScene.prototype.createDoneButton = function (ob) {
        var _this = this;
        this.doneButton = this.add.sprite(ob.x, ob.y, "button", 1);
        this.doneButton.setOrigin(0);
        this.doneButton.setDepth(3);
        this.doneButton.setInteractive({ useHandCursor: true });
        this.doneButton.on('pointerover', function () {
            _this.doneButton.setFrame(0);
        });
        this.doneButton.on('pointerout', function () {
            _this.doneButton.setFrame(1);
        });
        this.doneButton.on("pointerdown", function () {
            _this.doneButton.setFrame(0);
            _this.endGame();
        });
        var style = { fontFamily: "Russo One, Arial", fontSize: 18, color: "#000000" };
        var text = this.add.text(ob.x, this.doneButton.y, __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].translate("VendingMachine.Phaser.save"), style);
        Phaser.Display.Align.In.TopCenter(text, this.doneButton);
        text.y -= 30;
    };
    MainScene.prototype.createCoinTray = function (ob) {
        this.tray = this.add.zone(ob.x, ob.y, ob.width, ob.height);
        this.tray.setOrigin(0);
        this.tray.setDepth(2);
        // Tray is also a dropzone for the coins 
        this.tray.setName("tray");
        this.tray.setRectangleDropZone(ob.width, ob.height);
    };
    MainScene.prototype.createFeedbacks = function (key1, key2) {
        var style = { fontSize: 18, fontFamily: "Russo One, Arial", padding: 10, align: "center" };
        var tooMuchText = this.add.text(0, 0, __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].translate("VendingMachine.Phaser." + key1), style);
        tooMuchText.setOrigin(0.5);
        tooMuchText.setWordWrapWidth(300, true);
        var tooMuchBackground = this.add.image(0, 0, "pixel").setTint(0).setDisplaySize(tooMuchText.width + 20, tooMuchText.height + 20);
        var tooMuchBorder = this.add.image(0, 0, "pixel").setTint(__WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("E")).setDisplaySize(tooMuchBackground.displayWidth + 5, tooMuchBackground.displayHeight + 5);
        this.tooMuchFeedback = this.add.container(0, 0, [tooMuchBorder, tooMuchBackground, tooMuchText]);
        this.tooMuchFeedback.setPosition(this.gameWidth / 2 - this.tooMuchFeedback.displayWidth / 2, this.gameHeight / 2 - this.tooMuchFeedback.displayHeight / 2);
        this.tooMuchFeedback.setAlpha(0);
        this.tooMuchFeedback.setDepth(5);
        var tooLittleText = this.add.text(0, 0, __WEBPACK_IMPORTED_MODULE_4_src_utils_TranslateHelper__["a" /* default */].translate("VendingMachine.Phaser." + key2), style);
        tooLittleText.setOrigin(0.5);
        tooLittleText.setWordWrapWidth(300, true);
        var tooLittleBackground = this.add.image(0, 0, "pixel").setTint(0).setDisplaySize(tooLittleText.width + 20, tooLittleText.height + 20);
        var tooLittleBorder = this.add.image(0, 0, "pixel").setTint(__WEBPACK_IMPORTED_MODULE_5_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get("E")).setDisplaySize(tooLittleBackground.displayWidth + 5, tooLittleBackground.displayHeight + 5);
        this.tooLittleFeedback = this.add.container(0, 0, [tooLittleBorder, tooLittleBackground, tooLittleText]);
        this.tooLittleFeedback.setPosition(this.gameWidth / 2 - this.tooLittleFeedback.displayWidth / 2, this.gameHeight / 2 - this.tooLittleFeedback.displayHeight / 2);
        this.tooLittleFeedback.setAlpha(0);
        this.tooLittleFeedback.setDepth(5);
    };
    MainScene.prototype.showFeedback = function (tooMuch) {
        var container;
        this.tweens.killTweensOf([this.tooLittleFeedback, this.tooMuchFeedback]);
        if (tooMuch) {
            container = this.tooMuchFeedback;
            this.tooLittleFeedback.setAlpha(0);
        }
        else {
            container = this.tooLittleFeedback;
            this.tooMuchFeedback.setAlpha(0);
        }
        container.setPosition(700, 100);
        container.setAlpha(1);
        this.tweens.add({
            targets: container,
            delay: 2000,
            duration: 1000,
            alpha: {
                getStart: function () { return 1; },
                getEnd: function () { return 0; },
            },
        });
    };
    MainScene.prototype.updateCounters = function () {
        this.totalCounter.setText(this.total + "");
        this.machineCounter.setText(this.currentAmount + "");
    };
    MainScene.prototype.ejectCoins = function () {
        var _this = this;
        this.coins.forEach(function (c) {
            if (c.inMachine && !c.spent) {
                c.putBackInPile();
                c.setVisible(true);
                _this.currentAmount -= c.value;
                _this.total += c.value;
            }
        });
        this.updateCounters();
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Coin; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Coin = /** @class */ (function (_super) {
    __extends(Coin, _super);
    function Coin(scene, ob, id) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name + "g") || this;
        _this.id = id;
        _this.value = ob.properties["value"];
        _this.inMachine = false;
        _this.spent = false;
        _this.setDepth(3);
        _this.startPosition = new Phaser.Geom.Point(_this.x, _this.y);
        _this.setInteractive();
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    Coin.prototype.putBackInPile = function () {
        this.x = this.startPosition.x;
        this.y = this.startPosition.y;
        this.inMachine = false;
        this.setScale(1);
    };
    return Coin;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VendingItem; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var VendingItem = /** @class */ (function (_super) {
    __extends(VendingItem, _super);
    function VendingItem(scene, ob, id) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name + "-little") || this;
        _this.id = id;
        _this.name = ob.name;
        _this.cost = ob.properties["cost"];
        _this.currentAmount = 0;
        _this.paid = false;
        _this.setDepth(2);
        _this.setInteractive({ useHandCursor: true });
        _this.scene.add.existing(_this);
        return _this;
    }
    VendingItem.prototype.free = function (newX, newY) {
        var _this = this;
        this.disableInteractive();
        this.scene.tweens.add({
            targets: this,
            y: 650,
            ease: "Linear",
            duration: 1000,
            onStart: function () {
                _this.scene.input.enabled = false;
            },
            onComplete: function () {
                _this.scene.input.enabled = true;
                var purchasedItem = _this.scene.add.sprite(newX, newY, "assets", _this.name + "-big");
                purchasedItem.setScale(0.75);
            }
        });
    };
    return VendingItem;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "e";
        _this.gameClosingTextKey = "VendingMachine.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1e_background.efa29527.png";

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/vending_machine.83af2b84.json";

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameVendingMachine.c97f9892.png";

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameVendingMachine.8e8cf10c.json";

/***/ }),
/* 2581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(960);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].SeekAndFind;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "SeekAndFind.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "SeekAndFind.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "SeekAndFind.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EndGameScene__ = __webpack_require__(2583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_SeekItem__ = __webpack_require__(2584);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        return _super.call(this, {
            key: "MainScene"
        }) || this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON("map", __webpack_require__(2585));
        this.load.image("background", __webpack_require__(2586));
        this.load.atlas("assets", __webpack_require__(2587), __webpack_require__(2588));
    };
    MainScene.prototype.initialize = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "map" });
        this.cards = [];
        this.items = [];
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.sprite(0, 0, "background", 0).setOrigin(0);
        this.createScene();
        this.registerEvents();
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        // Prevents dragstart from acting like pointerdown
        this.input.dragDistanceThreshold = 5;
        this.input.on('dragstart', function (pointer, card) {
            card.x = pointer.downX;
            card.y = pointer.downY;
            _this.children.bringToTop(card);
            card.setScale(0.3);
        });
        this.input.on('drag', function (pointer, card, dragX, dragY) {
            card.x = pointer.x;
            card.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, card, dropped) {
            _this.children.moveDown(card);
            if (!dropped) {
                _this.putCardBack(card);
            }
        });
        this.input.on('drop', function (pointer, card, zone) {
            if (card.id === zone.id) {
                _this.dropCard(card, zone);
            }
            else {
                _this.putCardBack(card);
            }
        });
    };
    MainScene.prototype.dropCard = function (card, zone) {
        card.setVisible(false);
        zone.found = true;
        zone.overlay.setVisible(false);
        this.checkGameEnd();
    };
    MainScene.prototype.putCardBack = function (card) {
        card.setScale(1);
        card.setPosition(card.position.x, card.position.y);
    };
    MainScene.prototype.createScene = function () {
        var _this = this;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "tray") {
                var tray = _this.add.sprite(ob.x, ob.y, "pixel");
                tray.setDepth(1);
                tray.setOrigin(0);
                tray.setDisplaySize(ob.width, ob.height);
                tray.setTint(0).setAlpha(0.9);
            }
            else if (ob.type === "SeekCard") {
                var seekCard = new __WEBPACK_IMPORTED_MODULE_5__objects_SeekItem__["a" /* SeekCard */](_this, ob);
                _this.cards.push(seekCard);
            }
            else if (ob.type === "SeekItem") {
                var seekItem = new __WEBPACK_IMPORTED_MODULE_5__objects_SeekItem__["b" /* SeekItem */](_this, ob);
                seekItem.overlay = _this.add.image(0, 0, "assets", "overlay" + ob.properties["id"]).setOrigin(0);
                _this.items.push(seekItem);
            }
        });
    };
    MainScene.prototype.modal = function (translationKey) {
        var text = __WEBPACK_IMPORTED_MODULE_2__utils_TranslateHelper__["a" /* default */].translate(translationKey);
        var buttonConfig = {
            smartSize: true,
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON
        };
        var config = {
            title: text,
            buttonWidth: 200,
            buttonConfig: buttonConfig
        };
        var buttonText = __WEBPACK_IMPORTED_MODULE_2__utils_TranslateHelper__["a" /* default */].translate("common.ok");
        var options = [{ id: 1, displayText: buttonText }];
        var modal = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__["a" /* PhaserModal */](this, 0, 0, options, config);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
        modal.on("optionClicked", function () {
            modal.destroy();
        });
    };
    MainScene.prototype.endGame = function () {
        this.input.setDefaultCursor("default");
        this.input.enabled = false;
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_4__EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    MainScene.prototype.checkGameEnd = function () {
        var _this = this;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var i = _a[_i];
            if (!i.found) {
                return false;
            }
        }
        setTimeout(function () {
            _this.endGame();
        }, 1000);
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "s";
        _this.gameClosingTextKey = "SeekAndFind.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SeekCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SeekItem; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SeekCard = /** @class */ (function (_super) {
    __extends(SeekCard, _super);
    function SeekCard(scene, ob) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "card" + ob.properties["id"]) || this;
        _this.id = ob.properties["id"];
        _this.name = ob.name;
        _this.position = new Phaser.Geom.Point(_this.x, _this.y);
        _this.setDepth(2);
        _this.setDisplaySize(ob.width, ob.height);
        _this.setInteractive();
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    return SeekCard;
}(Phaser.GameObjects.Sprite));

var SeekItem = /** @class */ (function (_super) {
    __extends(SeekItem, _super);
    function SeekItem(scene, ob) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height) || this;
        _this.id = ob.properties["id"];
        _this.name = ob.name;
        _this.found = false;
        _this.setDepth(2);
        _this.setRectangleDropZone(_this.width, _this.height);
        _this.scene.add.existing(_this);
        return _this;
    }
    return SeekItem;
}(Phaser.GameObjects.Zone));



/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/seek_and_find.10aa82fd.json";

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1s_background.11952c5d.jpg";

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameSeekAndFind.725049f9.png";

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameSeekAndFind.f95bef7b.json";

/***/ }),
/* 2589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(962);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].FindHelpers;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "FindHelpers.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "RideMechanic.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Helper__ = __webpack_require__(2591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EndGameScene__ = __webpack_require__(2592);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('map', __webpack_require__(2593));
        this.load.image('background', __webpack_require__(2594));
        this.load.atlas("assets", __webpack_require__(2595), __webpack_require__(2596));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.helpers = [];
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);
        this.createLineDropzone();
        this.createHelpers();
        this.registerEvents();
        var people = this.add.image(0, 0, "assets", "people").setOrigin(0);
    };
    MainScene.prototype.createLineDropzone = function () {
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "line"; });
        this.line = this.add.zone(ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);
        this.line.setRectangleDropZone(ob.width, ob.height);
        this.add.graphics()
            .strokeRect(this.line.x - this.line.input.hitArea.width / 2, this.line.y - this.line.input.hitArea.height / 2, this.line.input.hitArea.width, this.line.input.hitArea.height);
    };
    MainScene.prototype.createHelpers = function () {
        var _this = this;
        var id = 0;
        this.map.getObjectLayer("Helpers").objects.forEach(function (ob) {
            var helper = new __WEBPACK_IMPORTED_MODULE_1__objects_Helper__["a" /* Helper */](_this, ob, id++);
            var spot = _this.map.getObjectLayer("Zones").objects.find(function (ob) { return ob.properties[0].value === helper.id; });
            helper.setLinePosition(spot);
            _this.helpers.push(helper);
        });
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.dragDistanceThreshold = 10;
        this.input.on('dragstart', function (pointer, helper) {
            _this.children.bringToTop(helper);
        });
        this.input.on('drag', function (pointer, helper, dragX, dragY) {
            helper.x = dragX;
            helper.y = dragY;
        });
        this.input.on('dragend', function (pointer, helper, dropped) {
            if (!dropped) {
                // Put back
                helper.x = helper.input.dragStartX;
                helper.y = helper.input.dragStartY;
            }
        });
        this.input.on('drop', function (pointer, helper, zone) {
            _this.drop(helper);
        });
    };
    MainScene.prototype.drop = function (helper) {
        this.children.bringToTop(helper);
        helper.isInLine = true;
        helper.putInLine();
        this.isGameOver();
    };
    MainScene.prototype.isGameOver = function () {
        var _this = this;
        var helper;
        for (var _i = 0, _a = this.helpers; _i < _a.length; _i++) {
            helper = _a[_i];
            if (!helper.isInLine) {
                return false;
            }
        }
        this.input.enabled = false;
        // Wait a second and then end the game
        setTimeout(function () {
            _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_2__EndGameScene__["a" /* EndGameScene */], true);
            _this.scene.remove(_this);
        }, 1000);
        return true;
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Helper; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Helper = /** @class */ (function (_super) {
    __extends(Helper, _super);
    function Helper(scene, ob, id) {
        var _this = this;
        var id = ob.properties[0].value;
        _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "helper" + id) || this;
        _this.id = id;
        _this.name = ob.name;
        _this.isInLine = false;
        _this.setInteractive({ useHandCursor: true });
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    Helper.prototype.setLinePosition = function (ob) {
        this.linePosition = new Phaser.Geom.Point(ob.x + ob.width / 2, ob.y + ob.height / 2);
    };
    Helper.prototype.putInLine = function () {
        this.x = this.linePosition.x;
        this.y = this.linePosition.y;
        this.input.enabled = false;
    };
    return Helper;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "s";
        _this.gameClosingTextKey = "FindHelpers.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/find_helpers.9128f568.json";

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pks_background.0652edd9.png";

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameFindHelpers.f85912c2.png";

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameFindHelpers.4c5bc02f.json";

/***/ }),
/* 2597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(964);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].TicketTaker;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "TicketTaker.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "TicketTaker.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Rider__ = __webpack_require__(2599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EndGameScene__ = __webpack_require__(2600);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};



var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('map', __webpack_require__(2601));
        this.load.image('background', __webpack_require__(2602));
        this.load.atlas("assets", __webpack_require__(2603), __webpack_require__(2604));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.riders = [];
        this.seats = [];
        this.count = 0;
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0);
        this.createScene();
        this.createSeats();
        this.createRiders();
        this.registerEvents();
    };
    MainScene.prototype.createScene = function () {
        var _this = this;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "train") {
                _this.train = _this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "train");
                var rails = _this.add.image(0, 0, "assets", "rails").setOrigin(0);
            }
            else if (ob.name === "counter") {
                var style = { fontSize: 60, fontFamily: "Russo One", color: "#000000" };
                _this.counter = _this.add.text(ob.x + ob.width / 2, ob.y + ob.height / 2, _this.count + "", style);
                // If we decide that the counter is necessary, we can show it
                _this.counter.setVisible(false);
            }
        });
    };
    MainScene.prototype.createSeats = function () {
        var _this = this;
        this.map.getObjectLayer("Seats").objects.forEach(function (ob) {
            var seat = new __WEBPACK_IMPORTED_MODULE_1__objects_Rider__["b" /* Seat */](_this, ob);
            _this.seats.push(seat);
        });
    };
    MainScene.prototype.createRiders = function () {
        var _this = this;
        this.map.getObjectLayer("Riders").objects.forEach(function (ob) {
            var rider = new __WEBPACK_IMPORTED_MODULE_1__objects_Rider__["a" /* Rider */](_this, ob);
            _this.riders.push(rider);
        });
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.dragDistanceThreshold = 10;
        this.input.on('dragstart', function (pointer, rider) {
            _this.children.bringToTop(rider);
            pointer.x = rider.x;
            pointer.y = rider.y;
        });
        this.input.on('drag', function (pointer, rider, dragX, dragY) {
            rider.x = pointer.x;
            rider.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, rider, dropped) {
            if (!dropped) {
                // Put back
                rider.x = rider.input.dragStartX;
                rider.y = rider.input.dragStartY;
            }
        });
        this.input.on('drop', function (pointer, helper, seat) {
            _this.drop(helper, seat);
        });
    };
    MainScene.prototype.drop = function (rider, seat) {
        this.children.bringToTop(rider);
        rider.setFrame("passenger" + rider.id);
        rider.onTrain = true;
        rider.x = seat.x;
        rider.y = seat.y - 50;
        rider.input.enabled = false;
        seat.input.enabled = false;
        seat.occupied = true;
        rider.setDepth(0.9);
        this.count++;
        this.counter.setText(this.count + "");
        this.isGameOver();
    };
    MainScene.prototype.isGameOver = function () {
        var _this = this;
        if (this.count !== 7) {
            return;
        }
        this.input.enabled = false;
        this.tweens.add({
            targets: __spreadArrays([this.train], this.riders.filter(function (r) { return r.onTrain; })),
            x: "-=1000",
            duration: 3000,
            ease: "Linear",
            onComplete: function () {
                _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_2__EndGameScene__["a" /* EndGameScene */], true);
                _this.scene.remove(_this);
            }
        });
        return true;
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Rider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Seat; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Rider = /** @class */ (function (_super) {
    __extends(Rider, _super);
    function Rider(scene, ob) {
        var _this = this;
        var id = ob.properties[0].value;
        _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "guest" + id) || this;
        _this.id = id;
        _this.name = ob.name;
        _this.onTrain = false;
        _this.setInteractive({ useHandCursor: true });
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    Rider.prototype.setTrainPosition = function (ob) {
        this.trainPosition = new Phaser.Geom.Point(ob.x + ob.width / 2, ob.y + ob.height / 2);
    };
    return Rider;
}(Phaser.GameObjects.Sprite));

var Seat = /** @class */ (function (_super) {
    __extends(Seat, _super);
    function Seat(scene, ob) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height) || this;
        _this.occupied = false;
        _this.setRectangleDropZone(ob.width, ob.height);
        _this.scene.add.existing(_this);
        return _this;
    }
    return Seat;
}(Phaser.GameObjects.Zone));



/***/ }),
/* 2600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "e";
        _this.gameClosingTextKey = "TicketTaker.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/ticket_taker.814a8a60.json";

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pke_background.d6af335a.png";

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameTicketTaker.acf762da.png";

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameTicketTaker.be4418fc.json";

/***/ }),
/* 2605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(966);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].FossilFinder;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "FossilFinder.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "FossilFinder.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "FossilFinder.Phaser.HowToPlay.tabletInstructions";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EndGameScene__ = __webpack_require__(2607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_Fossil__ = __webpack_require__(2608);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        return _super.call(this, {
            key: "MainScene"
        }) || this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON("map", __webpack_require__(2609));
        this.load.image("background", __webpack_require__(2610));
        this.load.atlas("assets", __webpack_require__(2611), __webpack_require__(2612));
        this.brushCursor = 'url(' + __webpack_require__(2613) + '), pointer';
    };
    MainScene.prototype.initialize = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "map" });
        this.fossils = [];
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0);
        this.createScene();
        this.input.setDefaultCursor(this.brushCursor);
    };
    MainScene.prototype.createScene = function () {
        var _this = this;
        this.map.getObjectLayer("Fossils").objects.forEach(function (ob) {
            var fossil = new __WEBPACK_IMPORTED_MODULE_2__objects_Fossil__["a" /* Fossil */](_this, ob);
            fossil.on("pointerdown", function () {
                // First time they touch it make it appear
                if (fossil.alpha < 1) {
                    fossil.setAlpha(1);
                }
                else {
                    fossil.dig();
                    _this.checkGameEnd();
                }
            });
            _this.fossils.push(fossil);
        });
        var bucketStuff = this.add.image(0, 0, "assets", "decoration").setOrigin(0);
    };
    MainScene.prototype.endGame = function () {
        this.input.setDefaultCursor("default");
        this.input.enabled = false;
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_1__EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    MainScene.prototype.checkGameEnd = function () {
        var _this = this;
        for (var _i = 0, _a = this.fossils; _i < _a.length; _i++) {
            var fossil = _a[_i];
            if (!fossil.dug) {
                return false;
            }
        }
        setTimeout(function () {
            _this.endGame();
        }, 1200);
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "i";
        _this.gameClosingTextKey = "FossilFinder.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Fossil; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Fossil = /** @class */ (function (_super) {
    __extends(Fossil, _super);
    function Fossil(scene, ob) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name + "1") || this;
        _this.name = ob.name;
        _this.index = 1;
        _this.setAlpha(0.01);
        _this.setInteractive();
        _this.scene.add.existing(_this);
        return _this;
    }
    Fossil.prototype.dig = function () {
        this.index++;
        this.setFrame(this.name + this.index);
        if (this.index === 4) {
            this.dug = true;
            this.input.enabled = false;
        }
    };
    return Fossil;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/fossil_finder.fc5e96ad.json";

/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pki_background.6fd5acaa.png";

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameFossilFinder.e340bf8a.png";

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameFossilFinder.4fd2ebf4.json";

/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fossil_brush.396e1b0a.cur";

/***/ }),
/* 2614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(968);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].GroceryBagger;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "GroceryBagger.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "GroceryBagger.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EndGameScene__ = __webpack_require__(2616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_GroceryItem__ = __webpack_require__(2617);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('map', __webpack_require__(2618));
        this.load.image('background', __webpack_require__(2619));
        this.load.atlas("assets", __webpack_require__(2620), __webpack_require__(2621));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.items = [];
        this.currentId = 1;
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);
        this.createItems();
        this.createScene();
        this.registerEvents();
        this.moveItems();
    };
    MainScene.prototype.createScene = function () {
        var _this = this;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "bag") {
                _this.bag = _this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "bag1");
                _this.bag.name = "bag";
                _this.bag.setInteractive();
                _this.bag.input.dropZone = true;
            }
            else if (ob.name === "scanner") {
                _this.scanner = _this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "scanner1");
                _this.scanner.setInteractive();
                _this.scanner.name = "scanner";
                _this.scanner.setDisplaySize(ob.width, ob.height);
                _this.scanner.input.dropZone = true;
                _this.anims.create({
                    key: "scan",
                    frames: [
                        { key: 'assets', frame: 'scanner2', duration: 100 },
                        { key: 'assets', frame: 'scanner1' },
                    ],
                    frameRate: 2,
                });
            }
            else if (ob.name === "price") {
                _this.price = _this.add.sprite(ob.x, ob.y, 'assets', 'price');
                _this.price.setOrigin(0);
                _this.price.setAlpha(0);
            }
        });
    };
    MainScene.prototype.createItems = function () {
        var _this = this;
        this.map.getObjectLayer("Items").objects.forEach(function (ob) {
            var item = new __WEBPACK_IMPORTED_MODULE_2__objects_GroceryItem__["a" /* GroceryItem */](_this, ob);
            _this.items.push(item);
        });
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.dragDistanceThreshold = 10;
        this.input.on('dragstart', function (pointer, item) {
            if (item.id !== _this.currentId) {
                return;
            }
            _this.children.bringToTop(item);
            pointer.x = item.x;
            pointer.y = item.y;
        });
        this.input.on('dragenter', function (pointer, item, dropzone) {
            if (item.id !== _this.currentId) {
                return;
            }
            if (dropzone.name === "scanner") {
                _this.scanItem(item);
            }
        });
        this.input.on('drag', function (pointer, item, dragX, dragY) {
            if (item.id !== _this.currentId) {
                return;
            }
            item.x = pointer.x;
            item.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, item, dropped) {
            if (!dropped) {
                // Put back
                item.x = item.input.dragStartX;
                item.y = item.input.dragStartY;
            }
        });
        this.input.on('drop', function (pointer, item, zone) {
            if (zone.name === "scanner") {
                item.x = item.input.dragStartX;
                item.y = item.input.dragStartY;
                return;
            }
            if (item.id !== _this.currentId) {
                return;
            }
            _this.drop(item);
        });
    };
    MainScene.prototype.scanItem = function (item) {
        var _this = this;
        item.scanned = true;
        this.scanner.anims.play('scan', true);
        if (this.tweens.isTweening(this.price)) {
            this.tweens.killTweensOf(this.price);
        }
        this.tweens.add({
            targets: this.price,
            duration: 500,
            x: this.price.x,
            onStart: function () {
                _this.price.setAlpha(1);
            },
            onComplete: function () {
                _this.price.setAlpha(0);
            }
        });
    };
    MainScene.prototype.moveItems = function () {
        var _this = this;
        this.input.enabled = false;
        this.tweens.add({
            targets: this.items.filter(function (i) { return !i.bagged; }),
            duration: 1000,
            x: "+= 200",
            onComplete: function () {
                _this.input.enabled = true;
            }
        });
    };
    MainScene.prototype.drop = function (item) {
        this.children.bringToTop(item);
        if (!item.scanned) {
            item.x = item.input.dragStartX;
            item.y = item.input.dragStartY;
            return;
        }
        item.setVisible(false);
        item.bagged = true;
        item.input.enabled = false;
        this.currentId++;
        this.moveItems();
        if (this.currentId >= 8) {
            this.bag.setFrame("bag3");
        }
        else if (this.currentId >= 4) {
            this.bag.setFrame("bag2");
        }
        this.isGameOver();
    };
    MainScene.prototype.isGameOver = function () {
        var _this = this;
        var item;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            item = _a[_i];
            if (!item.scanned && !item.bagged) {
                return false;
            }
        }
        // Wait a second and then end the game
        setTimeout(function () {
            _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_1__EndGameScene__["a" /* EndGameScene */], true);
            _this.scene.remove(_this);
        }, 1000);
        return true;
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "c";
        _this.gameClosingTextKey = "GroceryBagger.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroceryItem; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var GroceryItem = /** @class */ (function (_super) {
    __extends(GroceryItem, _super);
    function GroceryItem(scene, ob) {
        var _this = this;
        var id = ob.properties[0].value;
        _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "item" + id) || this;
        _this.id = id;
        _this.bagged = false;
        _this.scanned = false;
        _this.type = "Pet";
        _this.setDepth(5);
        _this.setInteractive({ useHandCursor: true });
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    return GroceryItem;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/grocery_bagger.0541fb73.json";

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pkc_background.6988b341.png";

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameGroceryBagger.6454ec0d.png";

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameGroceryBagger.4eaa0c34.json";

/***/ }),
/* 2622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(970);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].CakeDecorating;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "CakeDecorating.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "CakeDecorating.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EndGameScene__ = __webpack_require__(2624);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





// Paintbrush helper class to hold drawing attributes
var PaintBrush = /** @class */ (function () {
    // default color yellow, thickness 5
    function PaintBrush() {
        this.thickness = 10;
        this.color = 0x223e93;
        this.alpha = 1;
    }
    return PaintBrush;
}());
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.paintBrush = new PaintBrush();
        _this.div = document.createElement('div');
        _this.frostingGunCursor = 'url(' + __webpack_require__(2625) + '), pointer';
        _this.drawingMode = false;
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.image("background", __webpack_require__(2626));
        this.load.tilemapTiledJSON("map", __webpack_require__(2627));
        this.load.atlas("assets", __webpack_require__(2628), __webpack_require__(2629));
        __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__["a" /* PhaserColorWheel */].preload(this);
    };
    MainScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.input.setDefaultCursor(this.frostingGunCursor);
        this.map = this.make.tilemap({ key: "map" });
        this.buildBackgroundContent();
        this.lineHistory = [];
        this.pastedImages = [];
        this.drawing = false;
        this.drawingMode = true;
        document.body.appendChild(this.div);
        // Register the click events
        this.registerEvents();
    };
    MainScene.prototype.buildBackgroundContent = function () {
        var background = this.add.image(0, 0, "background").setOrigin(0);
        this.easelControls = new Phaser.Geom.Rectangle(815, 0, this.gameWidth - 815, 768);
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "cake"; });
        this.cake = this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "cake");
        this.frostingOverlay = this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "frosting2");
        this.frostingOverlay.setInteractive();
        this.currentSticker = this.add.image(0, 0, "assets", "sprinkles1");
        this.currentSticker.setDepth(2);
        this.currentSticker.setVisible(false);
        this.buildEasel();
        this.buildButton();
        this.buildColorWheel();
        this.buildSprinkles();
        this.buildFrostings();
        this.buildCandles();
        this.buildText();
    };
    MainScene.prototype.buildEasel = function () {
        var _this = this;
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "cakePoly"; });
        var points = ob["polygon"];
        var topLeft = this.cake.getTopLeft();
        points.forEach(function (p) {
            p.x += ob.x;
            p.y += ob.y;
        });
        this.cakePolygon = new Phaser.Geom.Polygon(points);
        this.frostingOverlay.on('pointerdown', function (pointer) {
            _this.pasteImage(pointer);
        });
        this.cakeTexture = this.add.renderTexture(0, 0, this.gameWidth, this.gameHeight);
        this.cakeTexture.setOrigin(0);
        this.cakeTexture.setDepth(2);
        this.cakeGraphic = this.add.graphics();
        this.cakeGraphic.setDepth(2);
    };
    MainScene.prototype.buildText = function () {
        var _this = this;
        var style = { fontFamily: "Russo One, Arial", fontSize: 22, align: "center" };
        this.map.getObjectLayer("Text").objects.forEach(function (ob) {
            var key = "CakeDecorating.Phaser." + ob.name;
            var text = _this.add.text(ob.x, ob.y, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(key), style);
            text.setWordWrapWidth(200, true);
        });
    };
    MainScene.prototype.buildFrostings = function () {
        var _this = this;
        this.map.getObjectLayer("Frostings").objects.forEach(function (ob) {
            var id = ob.properties["id"];
            var frosting = _this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "frostingPicker" + id);
            frosting.setInteractive({ useHandCursor: true });
            frosting.on("pointerdown", function () {
                _this.frostingOverlay.setFrame("frosting" + id);
            });
        });
    };
    MainScene.prototype.buildCandles = function () {
        var _this = this;
        var id = 1;
        this.map.getObjectLayer("Candles").objects.forEach(function (ob) {
            var candle = _this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "candle" + id + "1");
            candle.setInteractive({ useHandCursor: true });
            candle.on("pointerdown", function () {
                _this.drawingMode = false;
                _this.drawing = false;
                _this.currentSticker.setFrame(candle.frame.name);
                _this.currentSticker.setVisible(true);
                _this.input.setDefaultCursor('none');
                _this.children.bringToTop(_this.currentSticker);
            });
            candle.setDepth(2);
            _this.anims.create({
                key: 'candle' + id,
                frames: _this.anims.generateFrameNames('assets', { prefix: 'candle' + id, start: 1, end: 2 }),
                frameRate: 3,
                repeat: -1
            });
            candle.anims.play('candle' + id, true, Phaser.Math.Between(1, 2));
            id++;
        });
    };
    MainScene.prototype.buildSprinkles = function () {
        var _this = this;
        var id = 1;
        this.map.getObjectLayer("Sprinkles").objects.forEach(function (ob) {
            var sprinkles = _this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "sprinkles" + id++);
            sprinkles.setInteractive({ useHandCursor: true });
            sprinkles.on("pointerdown", function () {
                _this.drawingMode = false;
                _this.drawing = false;
                _this.currentSticker.setFrame(sprinkles.frame.name);
                _this.currentSticker.setVisible(true);
                _this.input.setDefaultCursor('none');
                _this.children.bringToTop(_this.currentSticker);
            });
            sprinkles.setDepth(2);
        });
    };
    MainScene.prototype.canPaste = function () {
        // Don't even have a sticker right now
        if (!this.currentSticker.visible) {
            return false;
        }
        return this.inCakeArea();
    };
    MainScene.prototype.inCakeArea = function () {
        var bounds = this.currentSticker.getBounds();
        var center = this.currentSticker.getCenter();
        bounds.width *= 0.1;
        bounds.height *= 0.1;
        bounds.centerX = center.x;
        bounds.centerY = center.y;
        if (this.cakePolygon.contains(center.x, center.y)) {
            return true;
        }
        // Check if it contains any of the 4 corners (polygons don't have an intersects method)
        if (this.cakePolygon.contains(bounds.left, bounds.bottom) ||
            this.cakePolygon.contains(bounds.right, bounds.bottom) ||
            this.cakePolygon.contains(bounds.left, bounds.top) ||
            this.cakePolygon.contains(bounds.right, bounds.top)) {
            return true;
        }
        return false;
    };
    MainScene.prototype.pasteImage = function (pointer) {
        if (this.canPaste()) {
            this.paste = this.add.sprite(pointer.x, pointer.y, "assets", this.currentSticker.frame.name);
            this.paste.setInteractive();
            this.input.setDraggable(this.paste);
            this.pastedImages.push(this.paste);
            this.paste.setDepth(this.cakeTexture.depth + 0.1);
            if (this.currentSticker.frame.name.startsWith("candle")) {
                var anim = this.currentSticker.frame.name.slice(0, this.currentSticker.frame.name.length - 1);
                this.paste.anims.play(anim);
            }
        }
    };
    MainScene.prototype.buildButton = function () {
        var _this = this;
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "button"; });
        this.finishButton = this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "button");
        this.finishButton.setInteractive({ useHandCursor: true });
        this.finishButton.on("pointerdown", function () {
            _this.drawingMode = false;
            _this.currentSticker.setVisible(false);
            // Screenshot for later
            _this.registry.parent.renderer.snapshot(function (image) {
                image.onload = function () {
                    var croppedImage = __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__["a" /* default */].CropImageToDataURI(image, 0, 0, _this.sys.canvas.width - 300, _this.sys.canvas.height);
                    console.warn("Screenshot!", croppedImage); // JB - Remove this console.warn
                    _this.endGame(croppedImage);
                };
            });
        });
        var style = { fontSize: 18, fontFamily: "Russo One, Arial", color: "#5a108a" };
        var text = this.add.text(0, 0, __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate("common.done"), style);
        Phaser.Display.Align.In.Center(text, this.finishButton);
    };
    MainScene.prototype.buildColorWheel = function () {
        var _this = this;
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "colorwheel"; });
        var colorWheel = new __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__["a" /* PhaserColorWheel */](this, ob.x, ob.y, ob.width, ob.height);
        colorWheel.on("colorChange", function (color) {
            _this.drawingMode = true;
            _this.paintBrush.color = color.color;
            _this.refreshPaintBrush();
            _this.input.setDefaultCursor(_this.frostingGunCursor);
            _this.currentSticker.setVisible(false);
        });
        colorWheel.setDepth(2);
    };
    MainScene.prototype.createSticker = function (x, y, id) {
        var _this = this;
        var sticker = this.add.image(x, y, "assets", "sticker" + id);
        sticker.setDepth(2);
        sticker.setInteractive();
        sticker.on("pointerdown", function () {
            _this.drawingMode = false;
            _this.drawing = false;
            _this.currentSticker.setFrame(sticker.frame.name);
            _this.currentSticker.setVisible(true);
            _this.input.setDefaultCursor('none');
            _this.children.bringToTop(_this.currentSticker);
        });
    };
    MainScene.prototype.refreshPaintBrush = function () {
        this.cakeGraphic.lineStyle(this.paintBrush.thickness, this.paintBrush.color, this.paintBrush.alpha);
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.on('pointerdown', this.pointerDown);
        this.input.on('pointerup', this.pointerUp);
        this.input.on('pointermove', this.pointerMove);
        this.input.on('dragstart', function (pointer, gameObject) {
            if (!_this.drawingMode) {
                _this.children.bringToTop(gameObject);
                _this.drawingMode = false;
                gameObject.x = pointer.downX;
                gameObject.y = pointer.downY;
            }
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            if (_this.drawingMode) {
                return;
            }
            gameObject.x = pointer.x;
            gameObject.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, gameObject) {
            // If we're drawing, no need to do anything
            if (_this.drawing || _this.drawingMode) {
                return;
            }
            if (!_this.inCakeArea()) {
                gameObject.destroy();
            }
            else {
                _this.children.moveDown(gameObject);
            }
        });
    };
    MainScene.prototype.canDraw = function (pointer) {
        if (this.cakePolygon.contains(pointer.x, pointer.y)) {
            return true;
        }
        return false;
    };
    MainScene.prototype.pointerDown = function (pointer) {
        if (this.drawingMode && this.canDraw(pointer)) {
            this.drawing = true;
        }
        this.lineHistory = [new Phaser.Geom.Point(pointer.x, pointer.y)];
    };
    MainScene.prototype.pointerUp = function (pointer) {
        this.drawing = false;
        // Capture the graphics as a texture
        this.cakeGraphic.generateTexture("background-drawn", this.sys.canvas.width, this.sys.canvas.height);
        this.cakeGraphic.clear();
        var tempImage = this.add.image(0, 0, "background-drawn");
        this.cakeTexture.save();
        this.cakeTexture.draw(tempImage.texture, tempImage.frame, 0, 0);
        this.cakeTexture.restore();
        tempImage.destroy();
    };
    MainScene.prototype.pointerMove = function (pointer) {
        if (this.drawing && this.canDraw(pointer)) {
            this.cakeGraphic.clear();
            this.refreshPaintBrush();
            this.lineHistory.push(new Phaser.Geom.Point(pointer.x, pointer.y));
            // Do the drawing
            this.cakeGraphic.strokePoints(this.lineHistory);
        }
        this.currentSticker.x = pointer.x;
        this.currentSticker.y = pointer.y;
        if (this.drawingMode) {
            this.currentSticker.setVisible(false);
            this.input.setDefaultCursor(this.frostingGunCursor);
        }
        else {
            this.currentSticker.setVisible(true);
            this.input.setDefaultCursor("none");
            if (this.isMovingExistingImage(pointer)) {
                this.currentSticker.setVisible(false);
                this.input.setDefaultCursor('-webkit-grabbing');
            }
        }
        if (this.easelControls.contains(this.input.activePointer.x, this.input.activePointer.y)) {
            this.currentSticker.setVisible(false);
            this.input.setDefaultCursor('pointer');
        }
    };
    MainScene.prototype.isMovingExistingImage = function (pointer) {
        for (var _i = 0, _a = this.pastedImages; _i < _a.length; _i++) {
            var i = _a[_i];
            if (i.getBounds().contains(pointer.x, pointer.y)) {
                return true;
            }
        }
        return false;
    };
    MainScene.prototype.endGame = function (image) {
        MainScene.CROPPED_IMAGE = image;
        this.input.setDefaultCursor("default");
        this.input.removeAllListeners();
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_4__EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    MainScene.prototype.drawPolygon = function (polygon) {
        // Draw polygon and set it up
        var graphics = this.add.graphics();
        graphics.lineStyle(2, 0x000000);
        graphics.beginPath();
        graphics.moveTo(polygon.points[0].x, polygon.points[0].y);
        for (var i = 1; i < polygon.points.length; i++) {
            graphics.lineTo(polygon.points[i].x, polygon.points[i].y);
        }
        graphics.closePath();
        graphics.strokePath();
    };
    MainScene.CROPPED_IMAGE = null;
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "a";
        _this.gameClosingTextKey = "CakeDecorating.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y - 100);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/frosting_gun.f5deb850.cur";

/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ka_background.5a0a690b.png";

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/cake_decorating.cf5ab99b.json";

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameCakeDecorating.e0466ddd.png";

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameCakeDecorating.57d60f89.json";

/***/ }),
/* 2630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(972);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].RideMechanic;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "RideMechanic.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "RideMechanic.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EndGameScene__ = __webpack_require__(2632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_Cart__ = __webpack_require__(2633);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('map', __webpack_require__(2634));
        this.load.image('background', __webpack_require__(2635));
        this.load.atlas("assets", __webpack_require__(2636), __webpack_require__(2637));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.carts = [];
        this.index = 2;
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);
        var struts = this.add.image(0, 0, 'assets', 'struts').setOrigin(0);
        struts.setDepth(2);
        this.createZones();
        this.createCarts();
        this.registerEvents();
    };
    MainScene.prototype.createZones = function () {
        var _this = this;
        this.map.getObjectLayer("Zones").objects.forEach(function (ob) {
            if (ob.name === "brokenWheel") {
                _this.wheel = _this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "brokenWheel");
                _this.wheel.setDepth(1);
            }
            else {
                var zone = _this.add.zone(ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);
                zone.setRectangleDropZone(ob.width, ob.height);
                // this.add.graphics()
                //     .strokeRect(zone.x - zone.input.hitArea.width / 2, zone.y - zone.input.hitArea.height / 2, zone.input.hitArea.width, zone.input.hitArea.height);
            }
        });
    };
    MainScene.prototype.createCarts = function () {
        var _this = this;
        this.map.getObjectLayer("Carts").objects.forEach(function (ob) {
            var cart = new __WEBPACK_IMPORTED_MODULE_2__objects_Cart__["a" /* Cart */](_this, ob);
            _this.carts.push(cart);
        });
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.dragDistanceThreshold = 10;
        this.input.on('dragstart', function (pointer, cart) {
            _this.children.bringToTop(cart);
            pointer.x = cart.x;
            pointer.y = cart.y;
        });
        this.input.on('drag', function (pointer, cart, dragX, dragY) {
            cart.x = pointer.x;
            cart.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, cart, dropped) {
            if (!dropped) {
                // Put back
                cart.x = cart.input.dragStartX;
                cart.y = cart.input.dragStartY;
            }
        });
        this.input.on('drop', function (pointer, cart, zone) {
            _this.drop(cart, zone);
        });
    };
    MainScene.prototype.drop = function (cart, zone) {
        this.children.moveDown(cart);
        cart.isFixed = true;
        cart.input.enabled = false;
        zone.input.enabled = false;
        cart.setDepth(0.5);
        cart.x = zone.x;
        cart.y = zone.y + 30;
        this.isGameOver();
    };
    MainScene.prototype.isGameOver = function () {
        var _this = this;
        var cart;
        for (var _i = 0, _a = this.carts; _i < _a.length; _i++) {
            cart = _a[_i];
            if (!cart.isFixed) {
                return false;
            }
        }
        this.carts.forEach(function (c) { return c.setVisible(false); });
        this.input.enabled = false;
        // Animate ferris wheel spinning
        this.anims.create({
            key: 'spin',
            frames: this.anims.generateFrameNames("assets", { prefix: "wheelSpin", start: 1, end: 12 }),
            frameRate: 2,
        });
        this.wheel.play('spin');
        // End the game
        setTimeout(function () {
            _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_1__EndGameScene__["a" /* EndGameScene */], true);
            _this.scene.remove(_this);
        }, 3500);
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "r";
        _this.gameClosingTextKey = "RideMechanic.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cart; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Cart = /** @class */ (function (_super) {
    __extends(Cart, _super);
    function Cart(scene, ob) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name) || this;
        _this.name = ob.name;
        _this.isFixed = false;
        _this.setDepth(2);
        _this.setInteractive({ useHandCursor: true });
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    return Cart;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/ride_mechanic.4f6a9555.json";

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pkr_background.70141d7b.png";

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameRideMechanic.90ecd908.png";

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameRideMechanic.5acd1142.json";

/***/ }),
/* 2638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(974);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].Starball;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "Starball.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Starball.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EndGameScene__ = __webpack_require__(2640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_Player__ = __webpack_require__(2641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_KeyboardNumKeys__ = __webpack_require__(169);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Command = /** @class */ (function () {
    function Command() {
    }
    return Command;
}());
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.commands = [
            {
                name: "throw",
                coachCommand: __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].translate("Starball.Phaser.throw"),
                coachEncouragement: __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].translate("Starball.Phaser.throwEncouragement"),
                keyboardBinding: 2
            },
            {
                name: "pass",
                coachCommand: __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].translate("Starball.Phaser.pass"),
                coachEncouragement: __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].translate("Starball.Phaser.passEncouragement"),
                keyboardBinding: 3
            },
            {
                name: "shoot",
                coachCommand: __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].translate("Starball.Phaser.shoot"),
                coachEncouragement: __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].translate("Starball.Phaser.shootEncouragement"),
                keyboardBinding: 1
            },
        ];
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('map', __webpack_require__(2642));
        this.load.image('background', __webpack_require__(2643));
        this.load.atlas("assets", __webpack_require__(2644), __webpack_require__(2645));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        this.command = this.commands[0];
        this.buttons = [];
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0);
        this.createScene();
        this.createButtons();
        this.createPlayers();
        this.ballHandler = this.thrower;
        this.bindNumKeys();
    };
    MainScene.prototype.createButtons = function () {
        var _this = this;
        var style = { fontFamily: "Russo One, Arial", fontSize: 20, color: "#000000" };
        var i = 1;
        this.map.getObjectLayer("Buttons").objects.forEach(function (ob) {
            var button = _this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", 'button');
            button.setName(ob.name);
            button.setInteractive({ useHandCursor: true });
            if (button.name !== "throw") {
                button.setTint(0x767a82);
                button.input.enabled = false;
            }
            button.on('pointerdown', function () {
                if (_this.tweens.isTweening(_this.ball)) {
                    return;
                }
                switch (button.name) {
                    case "throw":
                        _this.throw();
                        return;
                    case "pass":
                        _this.pass();
                        return;
                    case "shoot":
                        _this.shoot();
                        return;
                }
            });
            _this.buttons.push(button);
            var keyboardBinding = _this.commands.find(function (c) { return c.name === ob.name; }).keyboardBinding;
            var text = _this.add.text(ob.x, ob.y, keyboardBinding + ': ' + __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].translate("Starball.Phaser." + ob.name), style);
            Phaser.Display.Align.In.Center(text, button);
            i++;
        });
    };
    MainScene.prototype.createScene = function () {
        var _this = this;
        this.map.getObjectLayer("Scene").objects.forEach(function (ob) {
            if (ob.name === "coach") {
                var coach = _this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "coach");
            }
            else if (ob.name === "text") {
                var style = { fontSize: 50, fontFamily: "Russo One, Arial", color: "#000000", align: "center" };
                _this.commandText = _this.add.text(ob.x, ob.y, _this.command.coachCommand, style);
                _this.commandText.setWordWrapWidth(300, true);
            }
            else if (ob.name === "bubble") {
                var bubble = _this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "bubble");
            }
            else if (ob.name === "bubbleArea") {
                _this.bubbleArea = _this.add.zone(ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);
            }
            else if (ob.name === "ball") {
                _this.ball = _this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "ball1");
                _this.anims.create({
                    key: "rotate",
                    frames: _this.anims.generateFrameNames("assets", { prefix: "ball", start: 1, end: 4 }),
                    frameRate: 4,
                });
            }
            else if (ob.name === "goal") {
                var goal = _this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "goal");
            }
        });
        Phaser.Display.Align.In.Center(this.commandText, this.bubbleArea);
    };
    MainScene.prototype.createPlayers = function () {
        var _this = this;
        this.map.getObjectLayer("Players").objects.forEach(function (ob) {
            if (ob.name === "passer") {
                _this.passer = new __WEBPACK_IMPORTED_MODULE_3__objects_Player__["a" /* Player */](_this, ob);
            }
            else if (ob.name === "shooter") {
                _this.shooter = new __WEBPACK_IMPORTED_MODULE_3__objects_Player__["a" /* Player */](_this, ob);
            }
            else if (ob.type === "Visitor") {
                var id = ob.properties["id"];
                var visitor = _this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "visitor" + id + "1");
                _this.anims.create({
                    key: "visitor" + id,
                    frames: _this.anims.generateFrameNames("assets", { prefix: "visitor" + id, start: 1, end: 2 }),
                    frameRate: ob.properties["rate"],
                    repeat: -1,
                });
                visitor.anims.play("visitor" + id);
            }
            else if (ob.name === "thrower") {
                _this.thrower = new __WEBPACK_IMPORTED_MODULE_3__objects_Player__["a" /* Player */](_this, ob);
                _this.thrower.hasBall = true;
            }
        });
    };
    MainScene.prototype.throw = function () {
        var _this = this;
        if (!this.thrower.hasBall) {
            return;
        }
        this.thrower.play('throw');
        this.ball.play("rotate");
        this.input.enabled = false;
        this.buttons.forEach(function (b) {
            if (b.name === "throw") {
                b.input.enabled = false;
            }
            _this.buttons.forEach(function (b) {
                b.setTint(0x767a82);
            });
        });
        // Arc tween like throwing in from sideline to player1
        var timeline = this.tweens.timeline({
            targets: this.ball,
            delay: 120,
            tweens: [
                {
                    x: this.passer.x,
                    ease: 'Sine.easeInOut',
                    duration: 1200,
                },
                {
                    y: 300,
                    ease: 'Sine.easeOut',
                    duration: 600,
                    offset: 0
                },
                {
                    y: this.passer.y,
                    ease: "Bounce.easeOut",
                    duration: 600
                }
            ],
            onComplete: function () {
                _this.ballHandler = _this.passer;
                _this.commandText.setText(_this.command.coachEncouragement);
                Phaser.Display.Align.In.Center(_this.commandText, _this.bubbleArea);
                setTimeout(function () {
                    _this.setCommand(1);
                    _this.buttons.forEach(function (b) {
                        if (b.name !== "throw") {
                            b.clearTint();
                            b.input.enabled = true;
                        }
                    });
                }, 1000);
            }
        });
    };
    MainScene.prototype.pass = function () {
        var _this = this;
        this.input.enabled = false;
        this.buttons.forEach(function (b) {
            b.setTint(0x767a82);
        });
        var newBallHandler;
        if (this.ballHandler.name === "shooter") {
            newBallHandler = this.passer;
        }
        else if (this.ballHandler.name === "passer") {
            newBallHandler = this.shooter;
        }
        this.ballHandler.anims.play(this.ballHandler.name + 'kick');
        this.ball.play("rotate");
        // Linear tween like kicking ball diagonally to player 2
        this.tweens.add({
            targets: this.ball,
            delay: 120,
            x: newBallHandler.x,
            y: newBallHandler.y,
            ease: "Linear",
            duration: 1000,
            onComplete: function () {
                _this.ballHandler = newBallHandler;
                _this.commandText.setText(_this.commands.find(function (c) { return c.name === "pass"; }).coachEncouragement);
                Phaser.Display.Align.In.Center(_this.commandText, _this.bubbleArea);
                if (_this.ballHandler.name === "shooter") {
                    // Passed correctly to the shooter, now move on to next command
                    setTimeout(function () {
                        _this.setCommand(2);
                    }, 1000);
                }
                else {
                    // Passed incorrectly to the passer, show "Shoot" command again
                    setTimeout(function () {
                        _this.setCommand(1);
                    }, 1000);
                }
            }
        });
    };
    MainScene.prototype.shoot = function () {
        this.buttons.forEach(function (b) {
            b.setTint(0x767a82);
        });
        if (this.ballHandler.name === "shooter") {
            this.shootAndScore();
        }
        else {
            this.shootAndBlock();
        }
    };
    MainScene.prototype.shootAndBlock = function () {
        var _this = this;
        this.ballHandler.anims.play(this.ballHandler.name + 'kick');
        this.ball.play("rotate");
        this.input.enabled = false;
        // Linear tween like kicking ball into goal
        this.tweens.timeline({
            targets: this.ball,
            tweens: [
                {
                    x: this.gameWidth / 2 + 35,
                    ease: 'Sine.easeInOut',
                    duration: 1000,
                    y: 430,
                },
                {
                    x: this.ballHandler.x,
                    ease: 'Sine.easeInOut',
                    duration: 1000,
                    y: this.ballHandler.y,
                }
            ],
            onComplete: function () {
                _this.commandText.setText(__WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].translate("Starball.Phaser.blocked"));
                Phaser.Display.Align.In.Center(_this.commandText, _this.bubbleArea);
                setTimeout(function () {
                    _this.setCommand(1);
                }, 1000);
            }
        });
    };
    MainScene.prototype.shootAndScore = function () {
        var _this = this;
        this.ballHandler.anims.play(this.ballHandler.name + 'kick');
        this.ball.play("rotate");
        this.input.enabled = false;
        // Linear tween like kicking ball into goal
        this.tweens.add({
            targets: this.ball,
            x: this.gameWidth / 2 - 50,
            ease: 'Sine.easeInOut',
            duration: 1000,
            y: 480,
            onComplete: function () {
                _this.endGame();
            }
        });
    };
    MainScene.prototype.setCommand = function (index) {
        this.command = this.commands[index];
        this.commandText.setText(this.command.coachCommand);
        Phaser.Display.Align.In.Center(this.commandText, this.bubbleArea);
        this.input.enabled = true;
        this.buttons.forEach(function (b) {
            if (b.name !== "throw") {
                b.clearTint();
            }
        });
    };
    MainScene.prototype.endGame = function () {
        var _this = this;
        this.commandText.setText(this.command.coachEncouragement);
        Phaser.Display.Align.In.Center(this.commandText, this.bubbleArea);
        setTimeout(function () {
            _this.input.enabled = false;
            _this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_2__EndGameScene__["a" /* EndGameScene */], true);
            _this.scene.remove(_this);
        }, 1000);
    };
    MainScene.prototype.onKeydown = function (event) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        keys.forEach(function (key) {
            _this.input.keyboard.on('keydown_' + key, event);
        });
    };
    MainScene.prototype.bindNumKeys = function () {
        var _this = this;
        this.commands.forEach(function (command) {
            var numKey = __WEBPACK_IMPORTED_MODULE_4_src_constants_KeyboardNumKeys__["a" /* numKeys */][command.keyboardBinding - 1];
            _this.onKeydown(function () {
                if (_this.tweens.isTweening(_this.ball)) {
                    return;
                }
                switch (command.name) {
                    case "throw":
                        _this.throw();
                        return;
                    case "pass":
                        _this.pass();
                        return;
                    case "shoot":
                        _this.shoot();
                        return;
                }
            }, numKey.keyCode, numKey.altKeyCode);
        });
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "e";
        _this.gameClosingTextKey = "Starball.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Player; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Player = /** @class */ (function (_super) {
    __extends(Player, _super);
    function Player(scene, ob) {
        var _this = _super.call(this, scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.properties["frame"]) || this;
        _this.hasBall = false;
        _this.canPass = ob.properties["canPass"];
        _this.canShoot = ob.properties["canShoot"];
        _this.canThrow = ob.properties["canThrow"];
        _this.name = ob.name;
        _this.createAnim();
        _this.scene.add.existing(_this);
        return _this;
    }
    Player.prototype.createAnim = function () {
        if (this.canPass) {
            this.animation = this.scene.anims.create({
                key: this.name + "kick",
                frames: [
                    { key: "assets", frame: "home1" },
                    { key: "assets", frame: "home2" },
                    { key: "assets", frame: "home1" },
                ],
                frameRate: 9,
            });
        }
        else if (this.canThrow) {
            this.animation = this.scene.anims.create({
                key: "throw",
                frames: this.scene.anims.generateFrameNames("assets", { prefix: "throw", start: 1, end: 3 }),
                frameRate: 5
            });
        }
    };
    return Player;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/starball.d8f1187f.json";

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ke_background.2e039656.png";

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameStarball.07873076.png";

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameStarball.838fe320.json";

/***/ }),
/* 2646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainScene__ = __webpack_require__(2647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameIntro__ = __webpack_require__(976);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].CityBuilder;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_2__MainScene__["a" /* MainScene */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_3__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "CityBuilder.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "CityBuilder.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_TrayState__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_GridTile__ = __webpack_require__(2648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EndGameScene__ = __webpack_require__(2649);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, { key: "MainScene" }) || this;
        _this.GRID_HEIGHT = 5;
        _this.GRID_WIDTH = 13;
        _this.GRID_TILE_SIZE = 100;
        // These are the two columns which need to be checked if attempting to drop a 200x200 CityTile on a GridTile in either of these columns
        // Because the left side and the right side will not be in the same zone
        _this.PROBLEM_COL_1 = 3;
        _this.PROBLEM_COL_2 = 8;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(_this, MainScene.prototype);
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.load.tilemapTiledJSON("map", __webpack_require__(2650));
        this.load.image("background", __webpack_require__(2651));
        this.load.atlas("assets", __webpack_require__(2652), __webpack_require__(2653));
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: "map" });
        this.grid = [];
        for (var row = 0; row < this.GRID_HEIGHT; row++) {
            this.grid[row] = [];
        }
        this.staticTiles = [];
        this.moveableTiles = [];
        this.state = __WEBPACK_IMPORTED_MODULE_2__objects_TrayState__["a" /* TrayState */].ROADS;
    };
    MainScene.prototype.create = function () {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0);
        var commercialZone = this.add.image(0, 0, "assets", "commercialZone");
        commercialZone.setOrigin(0).setName("commercial");
        var residentialZone = this.add.image(0, 0, "assets", "residentialZone");
        residentialZone.setOrigin(0).setName("residential");
        var industrialZone = this.add.image(0, 0, "assets", "industrialZone");
        industrialZone.setOrigin(0).setName("industrial");
        this.zones = [commercialZone, residentialZone, industrialZone];
        this.buildTrayArea();
        this.buildGrid();
        this.registerEvents();
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.on('dragstart', function (pointer, tile, dragX, dragY) {
            pointer.x = tile.x + 30;
            pointer.y = tile.y - 30;
            _this.children.bringToTop(tile);
        });
        this.input.on('drag', function (pointer, tile, dragX, dragY) {
            tile.x = pointer.x - 30;
            tile.y = pointer.y + 30;
        });
        this.input.on('dragend', function (pointer, tile, dropped) {
            if (!dropped) {
                _this.putBack(tile);
            }
        });
        this.input.on('drop', function (pointer, tile, zone) {
            if (zone.name === "tray") {
                _this.putTileInTray(tile);
            }
            else {
                _this.dropTile(tile, zone);
            }
        });
    };
    MainScene.prototype.buildTrayArea = function () {
        var _this = this;
        this.map.getObjectLayer('Tray').objects.forEach(function (ob) {
            if (ob.name === "tray") {
                _this.tray = _this.add.sprite(0, ob.y, "assets", "toolbar");
                _this.tray.setY(_this.gameHeight - _this.tray.height);
                _this.tray.setOrigin(0);
                _this.tray.setName("tray");
                // Tray is also a dropzone
                _this.tray.setInteractive();
                _this.tray.input.dropZone = true;
            }
            else if (ob.name === "buttons") {
                _this.createButtons(ob);
            }
            else if (ob.name === "items") {
                _this.createCityTiles(ob, "roads");
                _this.createCityTiles(ob, "commercial");
                _this.createCityTiles(ob, "industrial");
                _this.createCityTiles(ob, "residential");
            }
            else if (ob.name === "button") {
                var done = _this.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "button");
                done.setInteractive({ useHandCursor: true });
                done.on("pointerdown", function () {
                    _this.endGame();
                });
                var style = { fontFamily: "Russo One, Arial", fontSize: 20, align: "center" };
                var text = _this.add.text(ob.x, ob.y, __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].translate("common.done"), style);
                Phaser.Display.Align.In.Center(text, done);
            }
        });
        this.showTiles("roads");
    };
    MainScene.prototype.buildGrid = function () {
        var ob = this.map.getObjectLayer('Scene').objects.find(function (ob) { return ob.name === "grid"; });
        var x, y;
        var id = 0;
        for (var row = 0; row < this.GRID_HEIGHT; row++) {
            y = ob.y + (row * this.GRID_TILE_SIZE + this.GRID_TILE_SIZE / 2);
            this.grid[row] = [];
            for (var col = 0; col < this.GRID_WIDTH; col++) {
                x = ob.x + (col * this.GRID_TILE_SIZE + this.GRID_TILE_SIZE / 2);
                var tile = new __WEBPACK_IMPORTED_MODULE_3__objects_GridTile__["a" /* GridTile */](this, x, y, 100, 100, id);
                this.grid[row][col] = tile;
                tile.row = row;
                tile.col = col;
                id++;
            }
        }
    };
    MainScene.prototype.createButtons = function (ob) {
        var buttons = [];
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_2__objects_TrayState__["a" /* TrayState */].TRAYSTATES; _i < _a.length; _i++) {
            var state = _a[_i];
            var button = this.createButton(state);
            buttons.push(button);
        }
        Phaser.Actions.GridAlign(buttons, {
            x: ob.x + 100,
            y: ob.y + 20,
            width: 1,
            height: 4,
            cellHeight: 40,
            cellWidth: 150,
            position: Phaser.Display.Align.TOP_LEFT
        });
        this.buttonIndicator = this.add.image(45, 570, "assets", "arrow2");
    };
    MainScene.prototype.createButton = function (state) {
        var _this = this;
        var style = { fontFamily: "Russo One, Arial", fontSize: 20, align: "left" };
        var button = this.add.text(0, 0, __WEBPACK_IMPORTED_MODULE_1_src_utils_TranslateHelper__["a" /* default */].translate("CityBuilder.Phaser." + state.type), style);
        button.setOrigin(0.5);
        button.setTint(state.color);
        button.setInteractive({ useHandCursor: true });
        button.on("pointerdown", function () {
            _this.state = state;
            _this.showTiles(state.type);
            _this.buttonIndicator.setY(button.y);
        });
        return button;
    };
    MainScene.prototype.createCityTiles = function (ob, tileType) {
        var id = 1;
        var num = tileType === "roads" ? 11 : tileType === "commercial" ? 5 : tileType === "industrial" ? 3 : tileType === "residential" ? 6 : 0;
        var y = this.tray.getCenter().y;
        var x = ob.x;
        for (var i = 0; i < num; i++) {
            var setY;
            if (tileType === "roads") {
                // Reset x to start second row
                if (i === 8) {
                    x = ob.x;
                }
                // y is different for top and bottom row
                if (i <= 7) {
                    setY = y;
                }
                else {
                    setY = y + 110;
                }
            }
            else {
                setY = y + 100;
            }
            var staticTile = new __WEBPACK_IMPORTED_MODULE_3__objects_GridTile__["c" /* StaticCityTile */](this, x, 0, "assets", id, tileType);
            staticTile.setY(setY);
            staticTile.updateOutline();
            this.staticTiles.push(staticTile);
            var tile = new __WEBPACK_IMPORTED_MODULE_3__objects_GridTile__["b" /* MoveableCityTile */](this, x, 0, "assets", id, tileType);
            tile.setY(setY);
            tile.setVisible(false);
            this.moveableTiles.push(tile);
            x += staticTile.displayWidth + 10;
            id++;
        }
    };
    MainScene.prototype.dropTile = function (cityTile, gridTile) {
        if (cityTile.type === gridTile.type || cityTile.type === "roads") {
            if (cityTile.displayHeight === 200 && gridTile.row === 0) {
                // Case where the top part is off the screen - don't let them do it!
                this.putBack(cityTile);
                return;
            }
            // 200x200 Tile - 4x4 grid
            if (cityTile.displayWidth === 200 && cityTile.displayHeight === 200) {
                if (cityTile.type !== "roads" && (gridTile.col === this.PROBLEM_COL_1 || gridTile.col === this.PROBLEM_COL_2)) {
                    // Case where the right side falls into another zone - don't allow them to do it!
                    this.putBack(cityTile);
                    return;
                }
            }
            // Snap it to the bottom left of the gridTile, mark it as placed
            Phaser.Display.Align.In.BottomLeft(cityTile, gridTile);
            this.children.moveDown(cityTile);
            cityTile.placed = true;
            if (this.needMoveableTile(cityTile)) {
                // Add a new CityTile to replace this one and put it on top of the correct static tile in the tray
                var newMoveableTile = new __WEBPACK_IMPORTED_MODULE_3__objects_GridTile__["b" /* MoveableCityTile */](this, cityTile.x, cityTile.y, "assets", cityTile.id, cityTile.type);
                var staticTile = this.findMatchingStaticTile(cityTile);
                newMoveableTile.x = staticTile.x;
                newMoveableTile.y = staticTile.y;
                newMoveableTile.visible = newMoveableTile.type === this.state.type;
                this.moveableTiles.push(newMoveableTile);
            }
        }
        else {
            this.putBack(cityTile);
        }
    };
    MainScene.prototype.needMoveableTile = function (tile) {
        return this.moveableTiles.find(function (t) { return !t.placed && t.type === tile.type && t.id === tile.id; }) == null;
    };
    /**
     * Put it back where it was picked up
     */
    MainScene.prototype.putBack = function (tile) {
        tile.x = tile.input.dragStartX;
        tile.y = tile.input.dragStartY;
    };
    MainScene.prototype.putTileInTray = function (tile) {
        var staticTile = this.findMatchingStaticTile(tile);
        tile.x = staticTile.x;
        tile.y = staticTile.y;
        tile.placed = false;
        if (this.state.type !== tile.type) {
            tile.setVisible(false);
        }
    };
    MainScene.prototype.showTiles = function (type) {
        this.staticTiles.forEach(function (t) {
            if (t.type === type) {
                t.visibility(true);
            }
            else {
                t.visibility(false);
            }
        });
        // The actual CityTiles are always showing if they're placed on the grid
        this.moveableTiles.forEach(function (t) {
            if (t.placed) {
                t.setVisible(true);
            }
            else {
                if (t.type === type) {
                    t.setVisible(true);
                }
                else {
                    t.setVisible(false);
                }
            }
        });
        this.zones.forEach(function (z) {
            z.visible = type === "roads" || z.name === type;
        });
    };
    MainScene.prototype.findMatchingStaticTile = function (cityTile) {
        return this.staticTiles.find(function (t) { return t.type === cityTile.type && t.id === cityTile.id; });
    };
    MainScene.prototype.endGame = function () {
        this.input.removeAllListeners();
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_4__EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridTile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MoveableCityTile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StaticCityTile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TrayState__ = __webpack_require__(977);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var GridTile = /** @class */ (function (_super) {
    __extends(GridTile, _super);
    function GridTile(scene, x, y, width, height, id) {
        var _this = _super.call(this, scene, x, y, width, height) || this;
        _this.COMMERCIAL_CUTOFF = 400;
        _this.RESIDENTIAL_CUTOFF = 900;
        _this.id = id;
        var color;
        if (_this.x < _this.COMMERCIAL_CUTOFF) {
            _this.type = "commercial";
            color = __WEBPACK_IMPORTED_MODULE_0__TrayState__["a" /* TrayState */].COMMERCIAL.color;
        }
        else if (_this.x > _this.COMMERCIAL_CUTOFF && _this.x < _this.RESIDENTIAL_CUTOFF) {
            _this.type = "residential";
            color = __WEBPACK_IMPORTED_MODULE_0__TrayState__["a" /* TrayState */].RESIDENTIAL.color;
        }
        else {
            _this.type = "industrial";
            color = __WEBPACK_IMPORTED_MODULE_0__TrayState__["a" /* TrayState */].INDUSTRIAL.color;
        }
        _this.setRectangleDropZone(_this.width, _this.height);
        _this.scene.add.existing(_this);
        return _this;
    }
    return GridTile;
}(Phaser.GameObjects.Zone));

var MoveableCityTile = /** @class */ (function (_super) {
    __extends(MoveableCityTile, _super);
    function MoveableCityTile(scene, x, y, texture, id, type) {
        var _this = this;
        var f = type === "roads" ? "road" : type === "commercial" ? "comm" : type === "industrial" ? "ind" : type === "residential" ? "res" : null;
        _this = _super.call(this, scene, x, y, texture, f + id) || this;
        _this.id = id;
        _this.type = type;
        _this.placed = false;
        _this.setOrigin(0, 1);
        _this.setDepth(5);
        _this.setInteractive({ useHandCursor: true });
        _this.scene.input.setDraggable(_this);
        _this.scene.add.existing(_this);
        return _this;
    }
    return MoveableCityTile;
}(Phaser.GameObjects.Sprite));

var StaticCityTile = /** @class */ (function (_super) {
    __extends(StaticCityTile, _super);
    function StaticCityTile(scene, x, y, texture, id, type) {
        var _this = this;
        var f = type === "roads" ? "road" : type === "commercial" ? "comm" : type === "industrial" ? "ind" : type === "residential" ? "res" : null;
        _this = _super.call(this, scene, x, y, texture, f + id) || this;
        _this.id = id;
        _this.type = type;
        _this.placed = false;
        var size = (_this.width === 200 && _this.height === 200) ? "L" : (_this.width === 100 && _this.height === 200) ? "S" : "";
        _this.outline = _this.scene.add.sprite(_this.x - 2.5, _this.y - 2.5, "assets", f + size);
        _this.outline.setDisplaySize(_this.width + 5, _this.height + 5);
        _this.outline.setVisible(false);
        Phaser.Display.Align.In.Center(_this.outline, _this);
        _this.setOrigin(0, 1);
        _this.setDepth(1);
        _this.scene.add.existing(_this);
        return _this;
    }
    StaticCityTile.prototype.updateOutline = function () {
        this.outline.setVisible(true);
        Phaser.Display.Align.In.Center(this.outline, this);
    };
    StaticCityTile.prototype.visibility = function (visible) {
        this.setVisible(visible);
        this.outline.setVisible(visible);
    };
    return StaticCityTile;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "i";
        _this.gameClosingTextKey = "CityBuilder.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_4_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete();
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/city_builder.0533eff9.json";

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1i_background.5ca251c2.png";

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameCityBuilder.a76a462a.png";

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameCityBuilder.2cb5a787.json";

/***/ }),
/* 2654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GameIntro__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PickAHead__ = __webpack_require__(2655);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this) || this;
        _this.gameRef = __WEBPACK_IMPORTED_MODULE_1_src_constants_Games__["a" /* Games */].FacePainting;
        _this.mainScene = __WEBPACK_IMPORTED_MODULE_3__PickAHead__["a" /* PickAFace */];
        _this.gameIntroScene = __WEBPACK_IMPORTED_MODULE_2__GameIntro__["a" /* GameIntroScene */];
        _this.gameObjectiveTextKey = "FacePainting.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "FacePainting.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "";
        return _this;
    }
    return HowToPlayScene;
}(__WEBPACK_IMPORTED_MODULE_0_src_games_shared_scenes_HowToPlaySceneBase__["a" /* HowToPlaySceneBase */]));



/***/ }),
/* 2655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickAFace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainScene__ = __webpack_require__(2656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var PickAFace = /** @class */ (function (_super) {
    __extends(PickAFace, _super);
    function PickAFace() {
        return _super.call(this, {
            key: "PickAFace"
        }) || this;
    }
    PickAFace.prototype.preload = function () {
        this.load.image("background", __webpack_require__(2658));
        this.load.tilemapTiledJSON('map', __webpack_require__(2659));
        this.load.atlas('assets', __webpack_require__(2660), __webpack_require__(2661));
    };
    PickAFace.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.map = this.make.tilemap({ key: 'map' });
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, PickAFace.prototype);
    };
    PickAFace.prototype.create = function () {
        var _this = this;
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setAlpha(0.5);
        this.map.getObjectLayer('ChooseFace').objects.forEach(function (ob) {
            if (ob.name === "pickAHead1") {
                var head1 = _this.add.image(ob.x, ob.y, "assets", ob.name);
                head1.setOrigin(0);
                head1.setInteractive({ useHandCursor: true });
                head1.on('pointerdown', function () {
                    __WEBPACK_IMPORTED_MODULE_1__MainScene__["a" /* MainScene */].FACE = 1;
                    _this.endGame();
                });
            }
            else if (ob.name === "pickAHead2") {
                var head2 = _this.add.image(ob.x, ob.y, "assets", ob.name);
                head2.setOrigin(0);
                head2.setInteractive({ useHandCursor: true });
                head2.on('pointerdown', function () {
                    __WEBPACK_IMPORTED_MODULE_1__MainScene__["a" /* MainScene */].FACE = 2;
                    _this.endGame();
                });
            }
            else if (ob.name === "pickAHead3") {
                var head3 = _this.add.image(ob.x, ob.y, "assets", ob.name);
                head3.setOrigin(0);
                head3.setInteractive({ useHandCursor: true });
                head3.on('pointerdown', function () {
                    __WEBPACK_IMPORTED_MODULE_1__MainScene__["a" /* MainScene */].FACE = 3;
                    _this.endGame();
                });
            }
        });
        var title = this.add.text(this.gameWidth / 2, 200, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate("FacePainting.Phaser.pickAHead"), {
            fontFamily: "Russo One, Arial",
            fontSize: 30,
        });
        Phaser.Display.Align.In.TopCenter(title, background);
        title.y = 75;
    };
    PickAFace.prototype.endGame = function () {
        this.input.setDefaultCursor("default");
        this.input.removeAllListeners();
        this.scene.add("MainScene", __WEBPACK_IMPORTED_MODULE_1__MainScene__["a" /* MainScene */], true);
        this.scene.remove(this);
    };
    return PickAFace;
}(Phaser.Scene));



/***/ }),
/* 2656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EndGameScene__ = __webpack_require__(2657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_Languages__ = __webpack_require__(80);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






// Paintbrush helper class to hold drawing attributes
var PaintBrush = /** @class */ (function () {
    // default color yellow, thickness 5
    function PaintBrush() {
        this.thickness = 12;
        this.color = 0x223e93;
        this.alpha = 1;
    }
    return PaintBrush;
}());
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        // Paintbrush holds draw stroke attributes
        _this.paintBrush = new PaintBrush();
        _this.div = document.createElement('div');
        _this.paintGunCursor = 'url(' + __webpack_require__(936) + '), pointer';
        _this.drawingMode = false;
        return _this;
    }
    MainScene.prototype.preload = function () {
        __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__["a" /* PhaserColorWheel */].preload(this);
    };
    MainScene.prototype.initialize = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.input.setDefaultCursor(this.paintGunCursor);
        this.map = this.make.tilemap({ key: 'map' });
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
    };
    MainScene.prototype.create = function () {
        this.initialize();
        this.buildBackgroundContent();
        this.stickers = [];
        this.lineHistory = [];
        this.pastedImages = [];
        this.drawing = false;
        this.drawingMode = true;
        document.body.appendChild(this.div);
        // Register the click events
        this.registerEvents();
    };
    MainScene.prototype.buildBackgroundContent = function () {
        var background = this.add.image(0, 0, "background").setOrigin(0);
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "cover"; });
        var artBoard = this.add.image(ob.x, ob.y, "assets", "cover");
        artBoard.setOrigin(0);
        this.easelControls = artBoard.getBounds();
        ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "alien"; });
        this.alien = this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "bigHead" + MainScene.FACE);
        this.alien.setInteractive();
        this.buildEasel();
        this.buildButton();
        this.createTattoos();
        this.buildColorWheel();
    };
    MainScene.prototype.buildEasel = function () {
        var _this = this;
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "drawArea" + MainScene.FACE; });
        var points = ob["polygon"];
        points.forEach(function (p) {
            p.x += ob.x;
            p.y += ob.y;
        });
        this.drawArea = new Phaser.Geom.Polygon(points);
        this.alien.on('pointerdown', function (pointer) {
            _this.pasteImage(pointer);
        });
        this.alienTexture = this.add.renderTexture(0, 0, this.gameWidth, this.gameHeight);
        this.alienTexture.setOrigin(0);
        this.alienTexture.setDepth(0);
        this.alienGraphic = this.add.graphics();
        this.alienGraphic.setDepth(0);
    };
    MainScene.prototype.canPaste = function () {
        // Don't even have a sticker right now
        if (!this.currentImage.visible) {
            return false;
        }
        return this.inDrawArea();
    };
    MainScene.prototype.inDrawArea = function () {
        var bounds = this.currentImage.getBounds();
        var center = this.currentImage.getCenter();
        bounds.width *= 0.1;
        bounds.height *= 0.1;
        bounds.centerX = center.x;
        bounds.centerY = center.y;
        if (this.drawArea.contains(center.x, center.y)) {
            return true;
        }
        // Check if it contains any of the 4 corners (polygons don't have an intersects method)
        if (this.drawArea.contains(bounds.left, bounds.bottom) ||
            this.drawArea.contains(bounds.right, bounds.bottom) ||
            this.drawArea.contains(bounds.left, bounds.top) ||
            this.drawArea.contains(bounds.right, bounds.top)) {
            return true;
        }
        return false;
    };
    MainScene.prototype.pasteImage = function (pointer) {
        if (this.canPaste()) {
            this.paste = this.add.image(pointer.x, pointer.y, "assets", this.currentImage.frame.name);
            this.paste.setInteractive();
            this.input.setDraggable(this.paste);
            this.pastedImages.push(this.paste);
        }
    };
    MainScene.prototype.buildButton = function () {
        var _this = this;
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "button"; });
        this.finishButton = this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", __WEBPACK_IMPORTED_MODULE_4__utils_TranslateHelper__["a" /* default */].currentLanguage === __WEBPACK_IMPORTED_MODULE_5__constants_Languages__["a" /* default */].Spanish ? "button_sp" : "button");
        this.finishButton.setInteractive({ useHandCursor: true });
        this.finishButton.on("pointerdown", function () {
            _this.drawingMode = false;
            _this.currentImage.setVisible(false);
            // Screenshot for later
            _this.registry.parent.renderer.snapshot(function (image) {
                image.onload = function () {
                    var croppedImage = __WEBPACK_IMPORTED_MODULE_1_src_utils_ImageHelper__["a" /* default */].CropImageToDataURI(image, 0, 0, _this.sys.canvas.width - 300, _this.sys.canvas.height);
                    _this.endGame(croppedImage);
                };
            });
        });
    };
    MainScene.prototype.buildColorWheel = function () {
        var _this = this;
        var ob = this.map.getObjectLayer("Scene").objects.find(function (ob) { return ob.name === "colorwheel"; });
        var colorWheel = new __WEBPACK_IMPORTED_MODULE_2__shared_ColorWheel__["a" /* PhaserColorWheel */](this, ob.x, ob.y, ob.width, ob.height);
        colorWheel.on("colorChange", function (color) {
            _this.drawingMode = true;
            _this.paintBrush.color = color.color;
            _this.refreshPaintBrush();
            _this.input.setDefaultCursor(_this.paintGunCursor);
            _this.currentImage.setVisible(false);
        });
        colorWheel.setDepth(2);
    };
    MainScene.prototype.createTattoos = function () {
        var _this = this;
        this.currentImage = this.add.image(0, 0, "assets", "tattoo1");
        this.currentImage.setDepth(1);
        this.currentImage.setVisible(false);
        this.stickers = [];
        this.map.getObjectLayer('Tattoos').objects.forEach(function (ob) {
            _this.createSticker(ob.x + ob.width / 2, ob.y + ob.height / 2, ob.name);
        });
    };
    MainScene.prototype.createSticker = function (x, y, frame) {
        var _this = this;
        var sticker = this.add.image(x, y, 'assets', frame);
        sticker.setDepth(2);
        sticker.setInteractive();
        sticker.on("pointerdown", function () {
            _this.drawingMode = false;
            _this.drawing = false;
            _this.currentImage.setFrame(sticker.frame.name);
            _this.currentImage.setVisible(true);
            _this.input.setDefaultCursor('none');
        });
        this.stickers.push(sticker);
    };
    MainScene.prototype.refreshPaintBrush = function () {
        this.alienGraphic.lineStyle(this.paintBrush.thickness, this.paintBrush.color, this.paintBrush.alpha);
    };
    MainScene.prototype.registerEvents = function () {
        var _this = this;
        this.input.on('pointerdown', this.pointerDown);
        this.input.on('pointerup', this.pointerUp);
        this.input.on('pointermove', this.pointerMove);
        this.input.on('dragstart', function (pointer, gameObject) {
            if (!_this.drawingMode) {
                _this.children.bringToTop(gameObject);
                _this.drawingMode = false;
                gameObject.x = pointer.downX;
                gameObject.y = pointer.downY;
            }
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            if (_this.drawingMode) {
                return;
            }
            gameObject.x = pointer.x;
            gameObject.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, gameObject) {
            // If we're drawing, no need to do anything
            if (_this.drawing || _this.drawingMode) {
                return;
            }
            if (!_this.inDrawArea()) {
                gameObject.destroy();
            }
            else {
                _this.children.moveDown(gameObject);
            }
        });
    };
    MainScene.prototype.canDraw = function (pointer) {
        if (this.drawArea.contains(pointer.x, pointer.y)) {
            return true;
        }
        return false;
    };
    MainScene.prototype.pointerDown = function (pointer) {
        if (this.drawingMode && this.canDraw(pointer)) {
            this.drawing = true;
        }
        this.lineHistory = [];
    };
    MainScene.prototype.pointerUp = function (pointer) {
        this.drawing = false;
        // Capture the graphics as a texture
        this.alienGraphic.generateTexture("background-drawn", this.sys.canvas.width, this.sys.canvas.height);
        this.alienGraphic.clear();
        var tempImage = this.add.image(0, 0, "background-drawn");
        this.alienTexture.save();
        this.alienTexture.draw(tempImage.texture, tempImage.frame, 0, 0);
        this.alienTexture.restore();
        tempImage.destroy();
    };
    MainScene.prototype.pointerMove = function (pointer) {
        if (this.drawing && this.canDraw(pointer)) {
            this.alienGraphic.clear();
            this.refreshPaintBrush();
            this.lineHistory.push(new Phaser.Geom.Point(pointer.x, pointer.y));
            // Do the drawing
            this.alienGraphic.strokePoints(this.lineHistory);
        }
        this.currentImage.x = pointer.x;
        this.currentImage.y = pointer.y;
        if (this.drawingMode) {
            this.currentImage.setVisible(false);
            this.input.setDefaultCursor(this.paintGunCursor);
        }
        else {
            this.currentImage.setVisible(true);
            this.input.setDefaultCursor("none");
            if (this.isMovingExistingImage(pointer)) {
                this.currentImage.setVisible(false);
                this.input.setDefaultCursor('-webkit-grabbing');
            }
        }
        if (this.easelControls.contains(this.input.activePointer.x, this.input.activePointer.y)) {
            this.currentImage.setVisible(false);
            this.input.setDefaultCursor('pointer');
        }
    };
    MainScene.prototype.isMovingExistingImage = function (pointer) {
        for (var _i = 0, _a = this.pastedImages; _i < _a.length; _i++) {
            var i = _a[_i];
            if (i.getBounds().contains(pointer.x, pointer.y)) {
                return true;
            }
        }
        return false;
    };
    MainScene.prototype.endGame = function (image) {
        MainScene.CROPPED_IMAGE = image;
        this.input.setDefaultCursor("default");
        this.input.removeAllListeners();
        this.scene.add("EndGameScene", __WEBPACK_IMPORTED_MODULE_3__EndGameScene__["a" /* EndGameScene */], true);
        this.scene.remove(this);
    };
    MainScene.prototype.drawPolygonDrawingArea = function () {
        // Draw polygon and set it up
        var graphics = this.add.graphics();
        graphics.lineStyle(2, 0x000000);
        graphics.beginPath();
        graphics.moveTo(this.drawArea.points[0].x, this.drawArea.points[0].y);
        for (var i = 1; i < this.drawArea.points.length; i++) {
            graphics.lineTo(this.drawArea.points[i].x, this.drawArea.points[i].y);
        }
        graphics.closePath();
        graphics.strokePath();
    };
    MainScene.CROPPED_IMAGE = null;
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_ShipPainting_scenes_MainScene__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var EndGameScene = /** @class */ (function (_super) {
    __extends(EndGameScene, _super);
    function EndGameScene() {
        var _this = _super.call(this, {
            key: "EndGameScene"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "a";
        _this.gameClosingTextKey = "FacePainting.Phaser.GameClosing";
        _this.buttonTextKey = "student.postgame.button";
        return _this;
    }
    EndGameScene.prototype.preload = function () {
        this.load.tilemapTiledJSON('outro-map', __webpack_require__(40));
        this.load.image("npc", __webpack_require__(155));
        this.load.audio(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.gameClosingTextKey, __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].currentLanguage.code).url);
    };
    EndGameScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, EndGameScene.prototype);
        this.map = this.make.tilemap({ key: "outro-map" });
        var sound = this.sound.add(this.gameClosingTextKey);
        sound.play();
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                _this.addDialogBoxWithButton(ob, _this.gameClosingTextKey);
            }
            else if (ob.name === "npc") {
                var npc = _this.add.image(ob.x, ob.y, "npc");
                npc.setOrigin(0);
                npc.setDisplaySize(ob.width, ob.height);
                npc.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    EndGameScene.prototype.addDialogBoxWithButton = function (ob, translateKey) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_3_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        // Add all the paragraphs to one big textbox
        var translatedText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(translateKey);
        // Split the translated text by newlines to create paragraphs
        translatedText.split(" | ").forEach(function (para) {
            var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
            paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
            paragraphs.push(paragraph);
            verticalSpacing += paragraph.height + paragraphSpacing;
            textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true,
            keyMapping: "keydown_RIGHT"
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_2_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.sound.stopAll();
            // Game Over
            _this.sys.game.onComplete(__WEBPACK_IMPORTED_MODULE_4_src_games_ShipPainting_scenes_MainScene__["a" /* MainScene */].CROPPED_IMAGE);
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return EndGameScene;
}(Phaser.Scene));



/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pka_background.fd141fb6.png";

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/face_painting.e7d96231.json";

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gameFacePainting.4a921c23.png";

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/gameFacePainting.effcb8d9.json";

/***/ }),
/* 2662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_table__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_table_style_index_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_api_ReportApiController__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_constants_Checkpoints__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_common_DataTable__ = __webpack_require__(58);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Classroom report (per-student Holland planet columns R–C).
 *
 * Recent change (CRM-4204): Planet completion columns match UserService / UserProgression rules
 * instead of only comparing current planet order. A planet counts complete when the student has
 * moved past that planet, or is still on that planet with checkpoint >= Leaving (fixes cases such
 * as finished planet C at checkpoint 12 / BetweenPlanets where the old UI required checkpoint > 12).
 * Shared logic: isHollandPlanetComplete().
 */






















/**
 * Matches UserService progression completion for Holland planets: target planet is "done" when
 * the student has moved past it, or is still on that planet with checkpoint >= Leaving.
 */
function isHollandPlanetComplete(currentPlanet, checkpoint, targetPlanet) {
    return (currentPlanet.order > targetPlanet.order ||
        (currentPlanet.id === targetPlanet.id && checkpoint.order >= __WEBPACK_IMPORTED_MODULE_19_src_constants_Checkpoints__["a" /* Checkpoints */].Leaving.order));
}
var ClassroomReport = /** @class */ (function (_super) {
    __extends(ClassroomReport, _super);
    function ClassroomReport(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, ClassroomReport.prototype);
        var classroomId = parseInt(_this.props.match.params.classroomId, 10);
        _this.state = {
            classroomId: classroomId,
            classroomName: "",
            students: [],
            isLoading: true,
        };
        return _this;
    }
    ClassroomReport.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
    };
    ClassroomReport.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    ClassroomReport.prototype.deriveStateFromProps = function (props) {
        var _this = this;
        var classroomId = parseInt(this.props.match.params.classroomId, 10);
        __WEBPACK_IMPORTED_MODULE_17_src_api_ReportApiController__["a" /* default */].getClassroomReport({ classroomId: classroomId }).then(function (response) {
            if (response.ok) {
                // Doing a thing
                var students = response.data.students.map(function (student) {
                    var planet = __WEBPACK_IMPORTED_MODULE_18_src_constants_Planets__["a" /* Planets */].FindById(student.planetId);
                    var checkpoint = __WEBPACK_IMPORTED_MODULE_19_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(student.checkpointId);
                    return {
                        firstname: student.firstName,
                        lastname: student.lastName,
                        fullname: student.lastName + ", " + student.firstName,
                        level: student.grade,
                        R: isHollandPlanetComplete(planet, checkpoint, __WEBPACK_IMPORTED_MODULE_18_src_constants_Planets__["a" /* Planets */].R),
                        I: isHollandPlanetComplete(planet, checkpoint, __WEBPACK_IMPORTED_MODULE_18_src_constants_Planets__["a" /* Planets */].I),
                        A: isHollandPlanetComplete(planet, checkpoint, __WEBPACK_IMPORTED_MODULE_18_src_constants_Planets__["a" /* Planets */].A),
                        S: isHollandPlanetComplete(planet, checkpoint, __WEBPACK_IMPORTED_MODULE_18_src_constants_Planets__["a" /* Planets */].S),
                        E: isHollandPlanetComplete(planet, checkpoint, __WEBPACK_IMPORTED_MODULE_18_src_constants_Planets__["a" /* Planets */].E),
                        C: isHollandPlanetComplete(planet, checkpoint, __WEBPACK_IMPORTED_MODULE_18_src_constants_Planets__["a" /* Planets */].C),
                    };
                });
                _this.setState({
                    classroomId: response.data.classroomId,
                    classroomName: response.data.classroomName,
                    students: students,
                    isLoading: false,
                });
            }
        });
    };
    ClassroomReport.prototype.render = function () {
        if (this.state.isLoading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "teacher-reports" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "report.classroom.headerText" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "report.classroom.loadingText" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_spin__["a" /* default */], null));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "teacher-reports" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "report.classroom.headerText" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, this.state.classroomName),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_src_components_common_DataTable__["e" /* default */], { data: this.state.students, className: "report-container-new", tableProps: { rowKey: 'activityId', loading: this.state.isLoading }, columns: [
                    __WEBPACK_IMPORTED_MODULE_21_src_components_common_DataTable__["e" /* default */].StandardColumns.Text("report.classroom.header.fullname", "fullname"),
                    __WEBPACK_IMPORTED_MODULE_21_src_components_common_DataTable__["e" /* default */].StandardColumns.Text("report.classroom.header.level", "level"),
                    {
                        renderer: false,
                        columnProps: {
                            key: "R",
                            align: "center",
                            title: "R",
                            render: function (value, row, index) { return row.R === true ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_icon__["a" /* default */], { type: "check" }) : null; }
                        }
                    }, {
                        renderer: false,
                        columnProps: {
                            key: "I",
                            align: "center",
                            title: "I",
                            render: function (value, row, index) { return row.I === true ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_icon__["a" /* default */], { type: "check" }) : null; }
                        }
                    }, {
                        renderer: false,
                        columnProps: {
                            key: "A",
                            align: "center",
                            title: "A",
                            render: function (value, row, index) { return row.A === true ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_icon__["a" /* default */], { type: "check" }) : null; }
                        }
                    }, {
                        renderer: false,
                        columnProps: {
                            key: "S",
                            align: "center",
                            title: "S",
                            render: function (value, row, index) { return row.S === true ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_icon__["a" /* default */], { type: "check" }) : null; }
                        }
                    }, {
                        renderer: false,
                        columnProps: {
                            key: "E",
                            align: "center",
                            title: "E",
                            render: function (value, row, index) { return row.E === true ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_icon__["a" /* default */], { type: "check" }) : null; }
                        }
                    }, {
                        renderer: false,
                        columnProps: {
                            key: "C",
                            align: "center",
                            title: "C",
                            render: function (value, row, index) { return row.C === true ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_icon__["a" /* default */], { type: "check" }) : null; }
                        }
                    }
                ] }));
    };
    return ClassroomReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["d" /* withLocalize */])(ClassroomReport)));


/***/ }),
/* 2663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_table__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_table_style_index_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_api_ReportApiController__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_common_DataTable__ = __webpack_require__(58);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




















var PrincipalReport = /** @class */ (function (_super) {
    __extends(PrincipalReport, _super);
    function PrincipalReport(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, PrincipalReport.prototype);
        _this.state = {
            teachers: [],
            isLoading: true,
        };
        return _this;
    }
    PrincipalReport.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
    };
    PrincipalReport.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage) {
            this.deriveStateFromProps(nextProps);
        }
    };
    PrincipalReport.prototype.deriveStateFromProps = function (props) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_17_src_api_ReportApiController__["a" /* default */].getPrincipalReport().then(function (response) {
            if (response.ok) {
                _this.setState({
                    teachers: response.data,
                    isLoading: false
                });
            }
        });
    };
    PrincipalReport.prototype.render = function () {
        if (this.state.isLoading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "teacher-reports" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["b" /* Translate */], { id: "report.principal.headerText" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["b" /* Translate */], { id: "report.classroom.loadingText" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_spin__["a" /* default */], null));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "teacher-reports" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_src_components_common_DataTable__["e" /* default */], { data: this.state.teachers, className: "report-container-new", tableProps: { loading: this.state.isLoading }, columns: [
                    __WEBPACK_IMPORTED_MODULE_19_src_components_common_DataTable__["e" /* default */].StandardColumns.Text("report.principal.header.teacherName", "teacherName"),
                    __WEBPACK_IMPORTED_MODULE_19_src_components_common_DataTable__["e" /* default */].StandardColumns.Text("report.principal.header.percent", "percentComplete"),
                ], buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_19_src_components_common_DataTable__["a" /* DataTableButton */]("dataTable.export", function () { return window.location.href = "/" + __WEBPACK_IMPORTED_MODULE_17_src_api_ReportApiController__["a" /* default */].RouteExportPrincipalReport(); })
                ] }));
    };
    return PrincipalReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["d" /* withLocalize */])(PrincipalReport)));


/***/ }),
/* 2664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_table__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_table_style_index_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_api_ReportApiController__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_common_DataTable__ = __webpack_require__(58);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




















var SuperintendentReport = /** @class */ (function (_super) {
    __extends(SuperintendentReport, _super);
    function SuperintendentReport(props) {
        var _this = _super.call(this, props) || this;
        _this.expandedRowRender = function (record, index, indent, expanded) {
            var columns = [
                {
                    dataIndex: "grade",
                    align: "center"
                },
                {
                    dataIndex: "percentComplete",
                    align: "center"
                }
            ];
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_table__["a" /* default */], { size: "small", style: { maxWidth: 300 }, rowKey: "id", columns: columns, dataSource: record.grades, pagination: false, showHeader: false }));
        };
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, SuperintendentReport.prototype);
        _this.state = {
            schools: [],
            isLoading: true,
        };
        return _this;
    }
    SuperintendentReport.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
    };
    SuperintendentReport.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage) {
            this.deriveStateFromProps(nextProps);
        }
    };
    SuperintendentReport.prototype.deriveStateFromProps = function (props) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_17_src_api_ReportApiController__["a" /* default */].getSuperintendentReport().then(function (response) {
            if (response.ok) {
                _this.setState({
                    schools: response.data,
                    isLoading: false
                });
            }
        });
    };
    SuperintendentReport.prototype.render = function () {
        if (this.state.isLoading) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "teacher-reports" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["b" /* Translate */], { id: "report.superintendent.headerText" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["b" /* Translate */], { id: "report.classroom.loadingText" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_spin__["a" /* default */], null));
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "teacher-reports" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_src_components_common_DataTable__["e" /* default */], { data: this.state.schools, className: "report-container-new", tableProps: {
                    rowKey: "schoolId",
                    loading: this.state.isLoading,
                    expandedRowRender: this.expandedRowRender
                }, columns: [
                    __WEBPACK_IMPORTED_MODULE_19_src_components_common_DataTable__["e" /* default */].StandardColumns.Text("report.superintendent.header.schoolName", "school"),
                    __WEBPACK_IMPORTED_MODULE_19_src_components_common_DataTable__["e" /* default */].StandardColumns.Text("report.principal.header.percent", "percentComplete"),
                ], buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_19_src_components_common_DataTable__["a" /* DataTableButton */]("dataTable.export", function () { return window.location.href = "/" + __WEBPACK_IMPORTED_MODULE_17_src_api_ReportApiController__["a" /* default */].RouteExportSuperintendentReport(); })
                ] }));
    };
    return SuperintendentReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapStateToProps(state) {
    return {
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_18_react_localize_redux__["d" /* withLocalize */])(SuperintendentReport)));


/***/ }),
/* 2665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Register_less__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Register_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Register_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_utils_FullscreenHelper__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_utils_RoleRedirect__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_redux_ConfigActions__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_constants_Grades__ = __webpack_require__(78);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




























var logo = __webpack_require__(286);
var Register = /** @class */ (function (_super) {
    __extends(Register, _super);
    function Register(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_BindThisHelper__["a" /* default */])(_this, Register.prototype);
        return _this;
    }
    Register.prototype.componentWillMount = function () {
        this.checkUserRegister(this.props);
    };
    Register.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.User.errorMsg !== nextProps.User.errorMsg && nextProps.User.errorMsg !== '') {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(this.props.translate(nextProps.User.errorMsg));
            this.props.updateUserError('');
        }
        this.checkUserRegister(nextProps);
    };
    Register.prototype.handleRegister = function (e) {
        var _this = this;
        e.preventDefault();
        // Prevent crushing the register button
        if (this.props.User.state === 'loading') {
            return;
        }
        this.props.form.validateFields(function (errors, values) {
            // Make sure all fields are filled out
            if (!errors) {
                // Fire the register request
                if (!__WEBPACK_IMPORTED_MODULE_24_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
                    __WEBPACK_IMPORTED_MODULE_22_src_utils_FullscreenHelper__["a" /* default */].RequestFullscreen(document.body);
                }
                _this.props.register(values);
            }
        });
    };
    Register.prototype.checkUserRegister = function (props) {
        if (props.User.state === 'finished' && props.Constants.state === 'finished') {
            // User is logged in and can be directed to either their homepage, or a redirect page if one is set
            // JB: This will set the language whenever the register page is rendered
            if (this.props.User.cultureCode != null) {
                var language = __WEBPACK_IMPORTED_MODULE_26_src_constants_Languages__["a" /* default */].FindByCode(this.props.User.cultureCode);
                this.props.setActiveLanguage(language.code);
            }
            var route = __WEBPACK_IMPORTED_MODULE_23_src_utils_RoleRedirect__["a" /* default */].GetRoleRoute(props.User.roleID, props.User.gradeId);
            if (this.props.Config.previousLocation != null) {
                route = this.props.Config.previousLocation;
                this.props.clearPreviousLocation();
            }
            // With this, we can skip the rendering cost of the register page and just send the user to the proper page
            // Set push to false to remove '/register' from the users history
            return props.history.replace(route);
        }
    };
    Register.prototype.render = function () {
        // Register has been removed so send them back to the login page to have it deal with them
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_19_src_core_Routes__["a" /* default */].LOGIN }));
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { type: "flex", justify: "center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 22, sm: 22, md: 18, lg: 14, xl: 11, className: "register-form" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_19_src_core_Routes__["a" /* default */].BASE_ROUTE, className: "logo", tabIndex: -1 },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: logo, alt: "Kuder Galaxy", height: "100%", width: "100%", tabIndex: -1 })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { hideRequiredMark: true, onSubmit: this.handleRegister },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: 'account.register.header1' })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "firstName" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.firstName" })),
                            this.props.form.getFieldDecorator('firstName', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { tabIndex: 1, size: "large", "aria-label": this.props.translate('account.register.firstName').toString(), placeholder: this.props.translate('account.register.firstName').toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "lastName" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.lastName" })),
                            this.props.form.getFieldDecorator('lastName', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { tabIndex: 1, size: "large", "aria-label": this.props.translate('account.register.lastName').toString(), placeholder: this.props.translate('account.register.lastName').toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "email" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.email" })),
                            this.props.form.getFieldDecorator('email', {
                                rules: [
                                    { required: true, message: this.props.translate('admin.common.requiredRule').toString() },
                                    { pattern: /^.+\@.+\..+$/, message: this.props.translate('admin.common.emailRule').toString() }
                                ]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { tabIndex: 1, size: "large", "aria-label": this.props.translate('account.register.email').toString(), placeholder: this.props.translate('account.register.email').toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "stateAbbreviation" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.stateAbbreviation" })),
                            this.props.form.getFieldDecorator('stateAbbreviation', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { tabIndex: 1, size: "large", "aria-label": this.props.translate('account.register.stateAbbreviation').toString(), placeholder: this.props.translate('account.register.stateAbbreviation').toString(), maxLength: 2, minLength: 2 }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "districtName" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.districtName" })),
                            this.props.form.getFieldDecorator('districtName', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { tabIndex: 1, size: "large", "aria-label": this.props.translate('account.register.districtName').toString(), placeholder: this.props.translate('account.register.districtName').toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "schoolName" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.schoolName" })),
                            this.props.form.getFieldDecorator('schoolName', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { tabIndex: 1, size: "large", "aria-label": this.props.translate('account.register.schoolName').toString(), placeholder: this.props.translate('account.register.schoolName').toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "cultureId" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.culture" })),
                            this.props.form.getFieldDecorator('cultureId', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], { allowClear: true, placeholder: "Please select culture", size: "large", tabIndex: 1 }, this.generateLanguageOptions()))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "gradeId" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.gradeLevel" })),
                            this.props.form.getFieldDecorator('gradeId', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], { optionFilterProp: "title", placeholder: "Please select grade", size: "large", tabIndex: 1 }, __WEBPACK_IMPORTED_MODULE_27_src_constants_Grades__["a" /* Grades */].All.map(function (x) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "grade" + x.id, value: x.id }, x.shortName)); })))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "password" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.password" })),
                            this.props.form.getFieldDecorator('password', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { tabIndex: 1, size: "large", "aria-label": this.props.translate('account.register.password').toString(), placeholder: this.props.translate('account.register.password').toString(), type: "password" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "confirmPassword" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.confirmPassword" })),
                            this.props.form.getFieldDecorator('confirmPassword', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { tabIndex: 1, size: "large", "aria-label": this.props.translate('account.register.confirmPassword').toString(), placeholder: this.props.translate('account.register.confirmPassword').toString(), type: "password" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { tabIndex: 1, loading: this.props.User.state === 'loading', size: "large", type: "primary", htmlType: "submit" }, this.props.User.state !== 'loading' && this.props.translate('account.register.registerButton'))))))));
    };
    Register.prototype.generateLanguageOptions = function () {
        // Only available languages
        return __WEBPACK_IMPORTED_MODULE_26_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable && x.code !== 'en-au'; }).map(function (x) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "cultureIds" + x.id, value: x.id },
            x.name,
            " (",
            x.code,
            ")")); });
    };
    return Register;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return {
        register: function (registerModel) { return __WEBPACK_IMPORTED_MODULE_21_src_redux_UserActions__["a" /* default */].Register(dispatch, registerModel); },
        updateUserError: function (msg) { return Object(__WEBPACK_IMPORTED_MODULE_21_src_redux_UserActions__["b" /* updateUserError */])(dispatch, msg); },
        clearPreviousLocation: function () { return __WEBPACK_IMPORTED_MODULE_25_src_redux_ConfigActions__["a" /* default */].SetPreviousLocation(dispatch, null); }
    };
}
function mapStateToProps(state) {
    return {
        User: state.User,
        Constants: state.Constants,
        Config: state.Config
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create()(Register))));


/***/ }),
/* 2666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_popover__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_popover_style_index_js__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_button_button__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_button_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_button_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_utils_NameOf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_utils_DownloadUtil__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_api_UserApiController__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_api_StateApiController__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_api_ReportApiController__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_api_DistrictApiController__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_api_SchoolApiController__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_api_ClientApiController__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__UniversalUserSearchForm__ = __webpack_require__(2667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__ = __webpack_require__(110);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

 // Connecting to Redux

















 // 'this' binder













var UniversalUserSearch = /** @class */ (function (_super) {
    __extends(UniversalUserSearch, _super);
    function UniversalUserSearch(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_19_src_utils_BindThisHelper__["a" /* default */])(_this, UniversalUserSearch.prototype);
        _this.state = {
            isLoading: false,
            isFilterLoading: false,
            searchParams: {},
            states: [],
            districts: [],
            schools: [],
            clients: [],
        };
        return _this;
    }
    UniversalUserSearch.prototype.componentDidMount = function () {
        this.getStates();
        this.getDistricts();
        this.getSchools();
        this.getClients();
    };
    UniversalUserSearch.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        // Add custom filtering into the request
        // Dev Note: We can do Object.keys() as a shortcut because we are using NameOf for the columns which is tied to the backend models
        requestState.filters = Object.keys(this.state.searchParams).map(function (key) { return ({ columnProp: key, filter: _this.state.searchParams[key] }); });
        // Business logic time! Ensure that atleast one of the filter has been filled in
        if (!requestState.filters.some(function (x) { return x.filter != null && x.filter.toString().length > 0; })) {
            // Clear out the datatable as the clear button ends up here as well
            callback({ results: [], filteredCount: 0 });
            return;
        }
        this.setState({ isLoading: true });
        __WEBPACK_IMPORTED_MODULE_25_src_api_UserApiController__["a" /* default */].getUniversalUserSearchTableData(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            _this.setState({
                isLoading: false
            });
            callback(results.data);
        });
    };
    UniversalUserSearch.prototype.getStates = function () {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_26_src_api_StateApiController__["a" /* default */].getAllStates().then(function (result) {
            _this.setState({ states: result.data.sort(function (a, b) { return a.value < b.value ? -1 : a.value > b.value ? 1 : 0; }) });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_6_antd_es_message__["a" /* default */].error(_this.props.translate('admin.common.messageStateError'));
        });
    };
    UniversalUserSearch.prototype.getDistricts = function (stateId) {
        var _this = this;
        var request = stateId == null || isNaN(stateId) ? __WEBPACK_IMPORTED_MODULE_28_src_api_DistrictApiController__["a" /* default */].getAllDistricts() : __WEBPACK_IMPORTED_MODULE_28_src_api_DistrictApiController__["a" /* default */].getAllDistrictsByState(stateId);
        return request.then(function (result) {
            _this.setState({ districts: result.data.sort(function (a, b) { return a.value < b.value ? -1 : a.value > b.value ? 1 : 0; }) });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_6_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditDistrict.messageRetrieveError'));
        });
    };
    UniversalUserSearch.prototype.getClients = function () {
        var _this = this;
        var request = __WEBPACK_IMPORTED_MODULE_30_src_api_ClientApiController__["a" /* default */].getAllClients();
        return request.then(function (result) {
            _this.setState({ clients: result.data.sort(function (a, b) { return a.value < b.value ? -1 : a.value > b.value ? 1 : 0; }) });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_6_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditDistrict.messageRetrieveError'));
        });
    };
    UniversalUserSearch.prototype.getSchools = function (districtId) {
        var _this = this;
        var request = districtId == null || isNaN(districtId) ? __WEBPACK_IMPORTED_MODULE_29_src_api_SchoolApiController__["a" /* default */].getAllSchools() : __WEBPACK_IMPORTED_MODULE_29_src_api_SchoolApiController__["a" /* default */].getAllSchoolsByDistrict(districtId);
        return request.then(function (result) {
            _this.setState({ schools: result.data.sort(function (a, b) { return a.value < b.value ? -1 : a.value > b.value ? 1 : 0; }) });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_6_antd_es_message__["a" /* default */].error(_this.props.translate('admin.addEditSchool.messageRetrieveError'));
        });
    };
    UniversalUserSearch.prototype.getStudentReport = function (record) {
        var _this = this;
        var reportName = record.firstName + record.lastName + '.xlsx';
        __WEBPACK_IMPORTED_MODULE_27_src_api_ReportApiController__["a" /* default */].getStudentReport(record.userId).then(function (result) {
            __WEBPACK_IMPORTED_MODULE_6_antd_es_message__["a" /* default */].success(_this.props.translate('admin.users.messageReport'));
            Object(__WEBPACK_IMPORTED_MODULE_21_src_utils_DownloadUtil__["a" /* downloadFile */])(result.data, reportName);
        });
    };
    UniversalUserSearch.prototype.handleEmulation = function (record) {
        var _this = this;
        var id;
        var userType;
        var userRole = __WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__["a" /* Roles */].FindById(record.roleId);
        switch (userRole) {
            case __WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__["a" /* Roles */].StateAdmin:
                id = record.stateId;
                userType = "state";
                break;
            case __WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__["a" /* Roles */].DistrictAdmin:
                id = record.districtId;
                userType = "district";
                break;
            case __WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__["a" /* Roles */].SchoolAdmin:
                id = record.schoolId;
                userType = "school";
                break;
            case __WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin:
                id = record.schoolId;
                userType = "school";
                break;
        }
        // Fire emulation request, which will take some time, and direct user to emulation loading page
        this.props.emulateUser(id, userType).then(function (result) {
            if (!result) {
                __WEBPACK_IMPORTED_MODULE_6_antd_es_message__["a" /* default */].error(_this.props.translate("admin.common.messageEmulateError"));
                return;
            }
        });
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_22_src_core_Routes__["a" /* default */].ADMIN_EMULATE_USER); // Show them a fancy page while we mess with their emulation info
    };
    UniversalUserSearch.prototype.customTableColumns = function () {
        var _this = this;
        var statementsLink = function (record) { return __WEBPACK_IMPORTED_MODULE_22_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_22_src_core_Routes__["a" /* default */].ADMIN_UNIVERSAL_USER_SEARCH_STUDENT_STATEMENTS, record.userId); };
        var changePasswordLink = function (record) { return __WEBPACK_IMPORTED_MODULE_22_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_22_src_core_Routes__["a" /* default */].ADMIN_UNIVERSAL_USER_SEARCH_RESET_PASSWORD, record.userId); };
        var editLink = function (record) { return __WEBPACK_IMPORTED_MODULE_22_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_22_src_core_Routes__["a" /* default */].ADMIN_ADD_EDIT_USER, 0, record.userId, __WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__["a" /* Roles */].FindById(record.roleId).isAdmin); };
        var defaultTooltipProps = {
            mouseLeaveDelay: 0.5,
            mouseEnterDelay: 0.2
        };
        var columns = [
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].BetterColumns.Custom(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader8' }), "status", {
                width: 80,
                filterType: "NONE",
                render: function (record) { return (record.status ? "Active" : "Inactive"); }
            }),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].BetterColumns.Custom(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader11' }), "roleId", {
                width: 80,
                filterType: "NONE",
                render: function (record) { return (__WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__["a" /* Roles */].FindById(record.roleId).display); }
            }),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader1' }), "firstName", 110),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader2' }), "lastName", 110),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader3' }), "email", 160),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader4' }), "stateName", 100),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader5' }), "districtName", 100),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader6' }), "schoolName", 100),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader7' }), "clientName", 100),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader9' }), "studentId", 110),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.universalUserSearch.columnHeader10' }), "gradeName", 80),
            __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].BetterColumns.FullManual(null, "actions", {
                align: "right",
                width: 160,
                filterType: "NONE",
                sorter: false,
                // fixed: "right", // Dev Note: This can force some of the columns to stay in place if we add a horizontal scroll
                render: function (record) {
                    var buttons = [];
                    // Admin or Student?
                    if (record.roleId !== __WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__["a" /* Roles */].Student.id) {
                        // Emulate
                        buttons.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_popover__["a" /* default */], { trigger: "hover", placement: "bottom", content: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.common.emulateColumnHeader' }) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_lib_button_button___default.a, { shape: "circle", icon: "user", onClick: function () { return _this.handleEmulation(record); } })));
                    }
                    else {
                        // I Statements
                        buttons.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_popover__["a" /* default */], { trigger: "hover", placement: "bottom", content: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.users.columnHeader3' }) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"], { to: { pathname: statementsLink(record), state: _this.state.searchParams } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_lib_button_button___default.a, { shape: "circle", icon: "profile" }))));
                        // Student Report
                        buttons.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_popover__["a" /* default */], { trigger: "hover", placement: "bottom", content: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.users.columnHeader8' }) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_lib_button_button___default.a, { shape: "circle", icon: "download", onClick: function () { return _this.getStudentReport(record); } })));
                    }
                    // Dev Note: Allow edit & password reset for Clever/ClassLink users, but not St or Te
                    if ((record.isClever || record.isClassLink) && [__WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__["a" /* Roles */].Student.id, __WEBPACK_IMPORTED_MODULE_32_src_constants_Roles__["a" /* Roles */].TeacherCounselorAdmin.id].some(function (x) { return x === record.roleId; })) {
                        // Password reset
                        buttons.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_popover__["a" /* default */], { trigger: "hover", placement: "bottom", content: "Cannot reset password of a Clever or ClassLink user" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_lib_button_button___default.a, { shape: "circle", icon: "lock", disabled: true })));
                        // Edit
                        buttons.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_popover__["a" /* default */], { trigger: "hover", placement: "bottom", content: "Cannot edit a Clever or ClassLink user" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_lib_button_button___default.a, { shape: "circle", icon: "edit", disabled: true })));
                    }
                    else {
                        // Password reset
                        buttons.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_popover__["a" /* default */], { trigger: "hover", placement: "bottom", content: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.users.columnHeader7' }) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"], { to: { pathname: changePasswordLink(record), state: { previousLocation: _this.props.location.pathname, previousState: _this.state.searchParams } } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_lib_button_button___default.a, { shape: "circle", icon: "lock" }))));
                        // Edit
                        buttons.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_popover__["a" /* default */], { trigger: "hover", placement: "bottom", content: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: 'admin.common.editColumnHeader' }) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"], { to: { pathname: editLink(record), state: { previousLocation: _this.props.location.pathname, previousState: _this.state.searchParams } } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_antd_lib_button_button___default.a, { shape: "circle", icon: "edit" }))));
                    }
                    // And render
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_row__["a" /* default */], { type: "flex", justify: "end", gutter: 4 }, buttons.map(function (x, index) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_col__["a" /* default */], { key: index }, x); }));
                }
            })
        ];
        // Turn off all filtering with this beautiful one-liner
        columns.forEach(function (col) { return col.filterType = __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["d" /* Filterer */].NONE; });
        return columns;
    };
    UniversalUserSearch.prototype.onSubmit = function (searchParams) {
        var _this = this;
        this.setState({ searchParams: searchParams }, function () { return _this.standardDataTableRef.refresh(); });
    };
    UniversalUserSearch.prototype.onReset = function () {
        var _this = this;
        this.getStates();
        this.getDistricts();
        this.setState({ searchParams: {} }, function () { return _this.standardDataTableRef.refresh(); });
    };
    UniversalUserSearch.prototype.onStateFilter = function (value) {
        var _this = this;
        this.getDistricts(Number(value)).then(function () {
            _this.setState({ isFilterLoading: false });
        });
    };
    UniversalUserSearch.prototype.onDistrictFilter = function (value) {
        var _this = this;
        this.getSchools(Number(value)).then(function () {
            _this.setState({ isFilterLoading: false });
        });
    };
    UniversalUserSearch.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "universal-user-search" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["b" /* Translate */], { id: "admin.universalUserSearch.title" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_31__UniversalUserSearchForm__["a" /* default */], { isLoading: this.state.isLoading, isFilterLoading: this.state.isFilterLoading, states: this.state.states, districts: this.state.districts, schools: this.state.schools, clients: this.state.clients, onSubmit: this.onSubmit, onReset: this.onReset, onStateFilter: this.onStateFilter, onDistrictFilter: this.onDistrictFilter }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.standardDataTableRef = ref; }, serverSide: true, tableProps: {
                    rowKey: Object(__WEBPACK_IMPORTED_MODULE_20_src_utils_NameOf__["a" /* NameOf */])("userId"),
                    loading: this.state.isLoading,
                    pagination: { pageSize: 100, showTotal: __WEBPACK_IMPORTED_MODULE_23_src_components_common_DataTable__["e" /* default */].StandardTotalsRenderer },
                }, columns: this.customTableColumns(), data: [], fetchData: this.fetchData })));
    };
    return UniversalUserSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return ({
        emulateUser: function (id, type) { return __WEBPACK_IMPORTED_MODULE_24_src_redux_UserActions__["a" /* default */].EmulateUser(dispatch, type, id); },
    });
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(null, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_8_antd_es_form__["a" /* default */].create()(UniversalUserSearch))));


/***/ }),
/* 2667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_button__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_auto_complete__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_auto_complete_style_index_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_router__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_utils_ArrayUtil__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_common_form_FieldDecorator__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_utils_DebugUtil__ = __webpack_require__(87);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

 // 'this' binder























var UniversalUserSearchForm = /** @class */ (function (_super) {
    __extends(UniversalUserSearchForm, _super);
    function UniversalUserSearchForm(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, UniversalUserSearchForm.prototype);
        _this.state = {
            filter: {},
            isResetting: false,
            filteredSchools: [],
            filteredClients: []
        };
        return _this;
    }
    UniversalUserSearchForm.prototype.componentDidMount = function () {
        // Check if state exists so we can just repopulate it for the user
        var locationState = this.props.location.state;
        if (locationState != null) {
            this.props.form.setFieldsValue(locationState);
            if (this.props.onSubmit != null) {
                this.props.onSubmit(locationState);
            }
        }
        // Clear state on reload
        this.props.history.replace(__assign(__assign({}, this.props.history.location), { state: undefined }));
    };
    UniversalUserSearchForm.prototype.handleFilterSchools = function (value) {
        var input = (value || "").toLowerCase();
        // Filter the schools if input is 3+ chars OR if the number of schools is small, like 50 or so
        if (input.length > 2 || this.props.schools.length < 50) {
            var filteredSchools = this.props.schools
                .filter(function (x) { return x.value.toLowerCase().indexOf(input) >= 0; })
                .map(function (x) { return x.value; });
            this.setState({ filteredSchools: __WEBPACK_IMPORTED_MODULE_22_src_utils_ArrayUtil__["a" /* default */].Unique(filteredSchools) });
            return;
        }
        this.setState({ filteredSchools: [] });
    };
    UniversalUserSearchForm.prototype.handleFilterClients = function (value) {
        var input = (value || "").toLowerCase();
        // Filter the clients if input is 3+ chars OR if the number of schools is small, like 50 or so
        if (input.length > 2 || this.props.clients.length < 50) {
            var filteredClients = this.props.clients
                .filter(function (x) { return x.value.toLowerCase().indexOf(input) >= 0; })
                .map(function (x) { return x.value; });
            this.setState({ filteredClients: __WEBPACK_IMPORTED_MODULE_22_src_utils_ArrayUtil__["a" /* default */].Unique(filteredClients) });
            return;
        }
        this.setState({ filteredClients: [] });
    };
    UniversalUserSearchForm.prototype.handleReset = function () {
        var _this = this;
        this.setState({
            isResetting: true
        }, function () { return _this.props.form.resetFields(); });
    };
    UniversalUserSearchForm.prototype.onSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        // Don't validate on reset
        if (this.state.isResetting) {
            this.setState({ isResetting: false });
            if (this.props.onReset != null) {
                this.props.onReset();
            }
            return;
        }
        // Make sure all fields are valid
        this.props.form.validateFields(function (errors, values) {
            /** Business logic time! **/
            // Ensure that atleast one of the filter has been filled in
            var filters = Object.keys(values).map(function (key) { return ({ key: key, value: values[key] }); });
            var filtersInUse = filters.filter(function (x) { return x.value != null && x.value.toString().length > 0; });
            if (filtersInUse.length === 0) {
                // Oh no!
                __WEBPACK_IMPORTED_MODULE_4_antd_es_message__["a" /* default */].error("You must select at least one filter below to search");
                return;
            }
            // There are a few filters that require a second filter to be used
            if (filtersInUse.length === 1) {
                var filter = filtersInUse[0];
                var restrictedFilters = ["Status", "studentId", "gradeId", "stateId", "districtName", "clientName"];
                if (restrictedFilters.indexOf(filter.key) > 0) {
                    __WEBPACK_IMPORTED_MODULE_4_antd_es_message__["a" /* default */].error("You must select a second filter as the one you selected is too general");
                    return;
                }
            }
            // Reduce 'values' to just the values that have values
            var reducedValues = {};
            Object.keys(values).forEach(function (x) {
                var newVal = values[x];
                if (newVal != null && newVal.toString().length > 0) {
                    reducedValues[x] = newVal;
                }
            });
            if (!errors) {
                if (_this.props.onSubmit != null) {
                    _this.props.onSubmit(reducedValues);
                }
            }
        });
    };
    UniversalUserSearchForm.prototype.render = function () {
        var _this = this;
        var formItemLayout = {
            labelCol: { xs: { span: 12 }, lg: { span: 10 } },
            wrapperCol: { xs: { span: 12 }, lg: { span: 14 } },
        };
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */], { layout: "horizontal", onSubmit: this.onSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_row__["a" /* default */], { type: "flex", align: "middle", justify: "center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 8, pull: 1 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "Role" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("roleId"))(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], { filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, allowClear: true, showSearch: true, mode: "default" }, __WEBPACK_IMPORTED_MODULE_19_src_constants_Roles__["a" /* Roles */].All.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: x.id, value: x.id, title: x.display }, x.display); }))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "First Name" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("firstName"), {
                                rules: [{ min: 2, message: "Please enter 2 or more characters" }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_input__["a" /* default */], { autoComplete: "off" })))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "Last Name" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("lastName"), {
                                rules: [{ min: 2, message: "Please enter 2 or more characters" }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_input__["a" /* default */], { autoComplete: "off" })))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "Email" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("email"), {
                                rules: [{ min: 2, message: "Please enter 2 or more characters" }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_input__["a" /* default */], { autoComplete: "off" })))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 8, pull: 1 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "State Name" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("stateId"))(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], { filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, onChange: function (value) { return _this.props.onStateFilter(value); }, allowClear: true, showSearch: true, mode: "default" }, this.props.states.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: x.key, value: x.key, title: x.value }, x.value); }))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "District Name" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("districtId"))(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], { filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, onChange: function (value) { return _this.props.onDistrictFilter(value); }, allowClear: true, showSearch: true, mode: "default" }, this.props.districts.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: x.key, value: x.key, title: x.value }, x.value); }))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "School Name" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("schoolName"))(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_auto_complete__["a" /* default */], __assign({ allowClear: true, onChange: this.handleFilterSchools }, { onFocus: this.handleFilterSchools }), this.state.filteredSchools.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_auto_complete__["a" /* default */].Option, { key: x }, x); }))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "Client Name" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("clientName"))(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_auto_complete__["a" /* default */], __assign({ allowClear: true, onChange: this.handleFilterClients }, { onFocus: this.handleFilterClients }), this.state.filteredClients.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_antd_es_auto_complete__["a" /* default */].Option, { key: x }, x); }))))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 8, pull: 1 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "Student ID" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("studentId"), {
                                rules: [{ min: 2, message: "Please enter 2 or more characters" }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_input__["a" /* default */], { autoComplete: "off" })))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "Grade" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("gradeId"))(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], { filterOption: function (input, option) { return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, allowClear: true, showSearch: true, mode: "default" }, __WEBPACK_IMPORTED_MODULE_20_src_constants_Grades__["a" /* Grades */].All.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: x.id, value: x.id, title: x.shortName }, x.shortName); }))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, __assign({ label: "Status" }, formItemLayout), this.props.form.getFieldDecorator(Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("status"))(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */]
                            // filterOption={(input, option) => option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            , { 
                                // filterOption={(input, option) => option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                allowClear: true, 
                                // showSearch
                                mode: "default" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "status-active", value: "true", title: "Active" }, "Active"),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "status-inactive", value: "false", title: "Inactive" }, "Inactive"))))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_src_components_common_form_FieldDecorator__["a" /* default */], __assign({ form: this.props.form, label: "Is Clever", name: Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("isClever"), visible: __WEBPACK_IMPORTED_MODULE_24_src_utils_DebugUtil__["a" /* default */].isDebugEnabled() }, formItemLayout),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], { allowClear: true, mode: "default" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "clever-yes", value: "true" }, "Yes"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "clever-no", value: "false" }, "No")))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_src_components_common_form_FieldDecorator__["a" /* default */], __assign({ form: this.props.form, label: "Is ClassLink", name: Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_NameOf__["a" /* NameOf */])("isClassLink"), visible: __WEBPACK_IMPORTED_MODULE_24_src_utils_DebugUtil__["a" /* default */].isDebugEnabled() }, formItemLayout),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], { allowClear: true, mode: "default" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "classlink-yes", value: "true" }, "Yes"),
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "classlink-no", value: "false" }, "No")))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], { span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_row__["a" /* default */], { type: "flex", justify: "end" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_antd_es_col__["a" /* default */], null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].Item, null,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_button___default.a, { type: "primary", icon: "download", loading: this.props.isLoading || this.props.isFilterLoading, htmlType: "submit" }, "Search"),
                                        "\u00A0",
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_lib_button_button___default.a, { type: "default", onClick: this.handleReset, htmlType: "submit" }, "Clear")))))))));
    };
    return UniversalUserSearchForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_react_router__["b" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_6_antd_es_form__["a" /* default */].create()(UniversalUserSearchForm))));


/***/ }),
/* 2668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_api_StatementApiController__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_admin_ViewStatementModal__ = __webpack_require__(843);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var USStudentStatements = /** @class */ (function (_super) {
    __extends(USStudentStatements, _super);
    function USStudentStatements(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_9_src_utils_BindThisHelper__["a" /* default */])(_this, USStudentStatements.prototype);
        var userId = parseInt(_this.props.match.params.userId, 10);
        _this.state = {
            tableRecords: [],
            loading: true,
            currentStudentId: userId,
            selectedStatement: null,
        };
        return _this;
    }
    USStudentStatements.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        this.setState({ loading: true });
        __WEBPACK_IMPORTED_MODULE_13_src_api_StatementApiController__["a" /* default */].getStudentStatementTableData(requestState, this.state.currentStudentId)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            var tableRecords = results.data.results.length > 0 ? results.data.results : [];
            _this.setState({
                tableRecords: tableRecords,
                loading: false
            });
            console.log(tableRecords);
            callback(results.data);
        });
    };
    USStudentStatements.prototype.openNotesModal = function (record) {
        this.setState({ selectedStatement: record });
    };
    USStudentStatements.prototype.closeNotesModal = function () {
        this.setState({ selectedStatement: null });
    };
    USStudentStatements.prototype.customTableColumns = function () {
        var _this = this;
        return [
            {
                columnProps: {
                    title: this.props.translate('admin.studentStatements.columnHeader2'),
                    dataIndex: 'isCompleted',
                    width: 120,
                    sorter: true,
                    render: function (text, record) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_checkbox__["a" /* default */], { checked: record.userCompletion != null ? record.userCompletion.isCompleted : false, disabled: true })); },
                },
                filterType: __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["d" /* Filterer */].BooleanCheckbox
            },
            __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["b" /* Translate */], { id: "admin.studentStatements.columnHeader1" }), "statementText"),
            __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["e" /* default */].AdvancedColumns.CustomLegacy("Notes", "userCompletion", 100, "DEFAULT", "Text", function (text, record) {
                if (record.userCompletion == null || record.userCompletion.statementNotes == null || record.userCompletion.statementNotes.length < 1) {
                    return null;
                }
                return "Yes";
            }),
            __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["e" /* default */].AdvancedColumns.CustomLegacy("Files", "userCompletion", 100, "DEFAULT", "Text", function (text, record) {
                if (record.userCompletion == null || record.userCompletion.statementFiles == null || record.userCompletion.statementFiles.length === 0) {
                    return null;
                }
                return "Yes";
            }),
            {
                columnProps: {
                    key: 'view',
                    align: 'center',
                    width: 35,
                    render: function (text, record, index) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_tooltip__["a" /* default */], { placement: "bottom", title: "View Files", arrowPointAtCenter: true },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_button__["a" /* default */], { shape: "circle", icon: "profile", onClick: function () { return _this.openNotesModal(record); } })));
                    }
                }
            }
        ];
    };
    USStudentStatements.prototype.handleRedirect = function () {
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_10_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_10_src_core_Routes__["a" /* default */].ADMIN_UNIVERSAL_USER_SEARCH), this.props.location.state);
    };
    USStudentStatements.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, this.props.translate('admin.studentStatements.tableHeader')),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.dataTableRef = ref; }, serverSide: true, tableProps: { rowKey: 'statementUserId', loading: this.state.loading }, columns: this.customTableColumns(), data: this.state.tableRecords, fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["a" /* DataTableButton */]('common.back', this.handleRedirect),
                    new __WEBPACK_IMPORTED_MODULE_12_src_components_common_DataTable__["c" /* DataTableButtonReset */]()
                ] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_src_components_admin_ViewStatementModal__["a" /* default */], { visible: this.state.selectedStatement != null, statement: this.state.selectedStatement, onClose: this.closeNotesModal })));
    };
    return USStudentStatements;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_localize_redux__["d" /* withLocalize */])(USStudentStatements));


/***/ }),
/* 2669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_spin__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_spin_style_index_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_es_tooltip__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_es_tooltip_style_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_api_UserApiController__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__USResetPasswordForm__ = __webpack_require__(2670);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



















 // 'this' binder




var USResetPassword = /** @class */ (function (_super) {
    __extends(USResetPassword, _super);
    function USResetPassword(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_19_src_utils_BindThisHelper__["a" /* default */])(_this, USResetPassword.prototype);
        var userId = parseInt(_this.props.match.params.userId, 10);
        _this.state = {
            isSubmitting: false,
            currentResetPassword: {
                userId: userId,
                newPassword: "",
                confirmPassword: ""
            }
        };
        return _this;
    }
    USResetPassword.prototype.handleRedirect = function () {
        // We rely on the state parameter to know where to go back to. If not provided, go home
        var state = this.props.location.state;
        var nextLocation = state != null && state.previousLocation != null ? state.previousLocation : __WEBPACK_IMPORTED_MODULE_20_src_core_Routes__["a" /* default */].BASE_ROUTE;
        this.props.history.push(nextLocation, state.previousState);
    };
    USResetPassword.prototype.handleSubmit = function (values) {
        var _this = this;
        this.setState({ isSubmitting: true });
        return __WEBPACK_IMPORTED_MODULE_22_src_api_UserApiController__["a" /* default */].adminPasswordReset(values).then(function (result) {
            __WEBPACK_IMPORTED_MODULE_11_antd_es_message__["a" /* default */].success(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_react_localize_redux__["b" /* Translate */], { id: "account.resetPassword.messageReset" }));
            _this.setState({ isSubmitting: false });
            _this.handleRedirect();
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_11_antd_es_message__["a" /* default */].error(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_react_localize_redux__["b" /* Translate */], { id: "account.resetPassword.messageResetError" }));
            _this.setState({ isSubmitting: false });
        });
    };
    USResetPassword.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_react_localize_redux__["b" /* Translate */], { id: "account.resetPassword.header" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__USResetPasswordForm__["a" /* default */], { isSubmitting: this.state.isSubmitting, passwordData: this.state.currentResetPassword, onCancel: this.handleRedirect, onSubmit: this.handleSubmit })));
    };
    return USResetPassword;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21_react_localize_redux__["d" /* withLocalize */])(USResetPassword));


/***/ }),
/* 2670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_divider__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_divider_style_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_utils_NameOf__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_common_form_FieldDecorator__ = __webpack_require__(283);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};











 // 'this' binder



var USResetPasswordForm = /** @class */ (function (_super) {
    __extends(USResetPasswordForm, _super);
    function USResetPasswordForm(props) {
        var _this = _super.call(this, props) || this;
        _this.compareToFirstPassword = function (rule, value, callback) {
            if (value && value !== _this.props.form.getFieldValue('newPassword')) {
                callback(_this.props.translate('account.resetPassword.saveTooltip').toString());
            }
            else {
                callback();
            }
        };
        _this.validateToNextPassword = function (rule, value, callback) {
            if (_this.props.form.getFieldValue('confirmPassword')) {
                _this.props.form.validateFields(['confirmPassword'], { force: true }, function (errors, values) { return console.log('Revalidating'); });
            }
            callback();
        };
        Object(__WEBPACK_IMPORTED_MODULE_11_src_utils_BindThisHelper__["a" /* default */])(_this, USResetPasswordForm.prototype);
        return _this;
    }
    USResetPasswordForm.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        this.props.form.validateFields(function (errors, values) {
            var newValues = __assign(__assign({}, _this.props.passwordData), values);
            if (!errors) {
                _this.props.onSubmit && _this.props.onSubmit(newValues);
            }
        });
    };
    USResetPasswordForm.prototype.handleCancel = function () {
        this.props.onCancel && this.props.onCancel();
    };
    USResetPasswordForm.prototype.render = function () {
        var formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 5 },
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */], { className: "password-reset", onSubmit: this.handleSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_src_components_common_form_FieldDecorator__["a" /* default */], __assign({ form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_localize_redux__["b" /* Translate */], { id: "account.resetPassword.formItem1" }), name: Object(__WEBPACK_IMPORTED_MODULE_13_src_utils_NameOf__["a" /* NameOf */])("newPassword"), rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                    { min: 8, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_localize_redux__["b" /* Translate */], { id: "admin.common.minLengthRule" }),
                            " 8") },
                    { validator: this.validateToNextPassword }
                ] }, formItemLayout),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_input__["a" /* default */], { autoComplete: "off", type: "password" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_src_components_common_form_FieldDecorator__["a" /* default */], __assign({ form: this.props.form, label: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_localize_redux__["b" /* Translate */], { id: "account.resetPassword.formItem2" }), name: Object(__WEBPACK_IMPORTED_MODULE_13_src_utils_NameOf__["a" /* NameOf */])("confirmPassword"), rules: [
                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                    { validator: this.compareToFirstPassword }
                ] }, formItemLayout),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_input__["a" /* default */], { autoComplete: "off", type: "password" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].Item, null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_button__["a" /* default */], { type: "primary", loading: this.props.isSubmitting, htmlType: "submit" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_localize_redux__["b" /* Translate */], { id: "admin.common.saveButton" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_divider__["a" /* default */], { type: "vertical" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_button__["a" /* default */], { onClick: this.handleCancel },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_localize_redux__["b" /* Translate */], { id: "common.back" })))));
    };
    return USResetPasswordForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_1_antd_es_form__["a" /* default */].create()(USResetPasswordForm)));


/***/ }),
/* 2671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Register_less__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Register_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Register_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_form__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_form_style_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_input_style_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_select__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_es_select_style_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_redux_UserActions__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_utils_FullscreenHelper__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_utils_RoleRedirect__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_redux_ConfigActions__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_api_SchoolApiController__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_utils_ArrayUtil__ = __webpack_require__(282);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






























var logo = __webpack_require__(286);
var RegisterAfl = /** @class */ (function (_super) {
    __extends(RegisterAfl, _super);
    function RegisterAfl(props) {
        var _this = _super.call(this, props) || this;
        _this.compareToFirstPassword = function (rule, value, callback) {
            if (value && value !== _this.props.form.getFieldValue('password')) {
                callback(_this.props.translate('account.resetPassword.saveTooltip').toString());
            }
            else {
                callback();
            }
        };
        _this.validateToNextPassword = function (rule, value, callback) {
            if (_this.props.form.getFieldValue('confirmPassword')) {
                _this.props.form.validateFields(['confirmPassword'], { force: true });
            }
            callback();
        };
        Object(__WEBPACK_IMPORTED_MODULE_18_src_utils_BindThisHelper__["a" /* default */])(_this, RegisterAfl.prototype);
        _this.state = {
            schools: [],
            schoolId: 0,
            filteredDistricts: [],
            filteredSchools: [],
            isFilteringDistrict: false,
            isFilteringSchool: false,
            useSchoolClients: false,
            isLoadingDistricts: true,
            isLoadingSchools: true,
            isSubmitting: false,
        };
        return _this;
    }
    RegisterAfl.prototype.componentWillMount = function () {
        this.checkUserRegister(this.props);
        this.getSchools();
    };
    RegisterAfl.prototype.getSchools = function () {
        var _this = this;
        var search = window.location.search;
        var params = new URLSearchParams(search);
        var clientId = parseInt(params.get('clientId'));
        if (isNaN(clientId)) {
            return;
        }
        this.setState({ isLoadingSchools: true });
        return __WEBPACK_IMPORTED_MODULE_28_src_api_SchoolApiController__["a" /* default */].getAllSchoolsByClientId(clientId).then(function (result) {
            _this.setState({
                schools: result.data.sort(function (a, b) { return a.value < b.value ? -1 : a.value > b.value ? 1 : 0; }),
                isLoadingSchools: false
            });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "admin.addEditDistrict.messageRetrieveError" }));
            _this.setState({ isLoadingSchools: false });
        });
    };
    RegisterAfl.prototype.handleSchoolSearch = function (value) {
        var input = (value || "").toLowerCase();
        // Filter the districts if input is 2+ chars OR if the number of districts is small, like 50 or so
        if (input.length >= 2 || this.state.schools.length < 50) {
            var filteredSchools = this.state.schools
                .filter(function (x) { return x.value.toLowerCase().indexOf(input) >= 0; });
            this.setState({
                filteredSchools: __WEBPACK_IMPORTED_MODULE_29_src_utils_ArrayUtil__["a" /* default */].Unique(filteredSchools),
                isFilteringSchool: true
            });
            return;
        }
        this.setState({
            filteredSchools: [],
            isFilteringSchool: false
        });
    };
    RegisterAfl.prototype.handleSchoolBlur = function () {
        // Run through the same logic, but make sure we cleared out the text
        this.handleSchoolSearch("");
    };
    RegisterAfl.prototype.handleSchoolFilter = function (event) {
        var _this = this;
        this.setState({ schoolId: event }, function () {
            console.log(_this.state.schoolId, 'schoolId');
        });
    };
    RegisterAfl.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.User.errorMsg !== nextProps.User.errorMsg && nextProps.User.errorMsg !== '') {
            __WEBPACK_IMPORTED_MODULE_12_antd_es_message__["a" /* default */].error(this.props.translate(nextProps.User.errorMsg));
            this.props.updateUserError('');
        }
        this.checkUserRegister(nextProps);
    };
    RegisterAfl.prototype.handleRegister = function (e) {
        var _this = this;
        e.preventDefault();
        // Prevent crushing the register button
        if (this.props.User.state === 'loading') {
            return;
        }
        this.props.form.validateFields(function (errors, values) {
            // Make sure all fields are filled out
            if (!errors) {
                // Fire the register request
                if (!__WEBPACK_IMPORTED_MODULE_24_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
                    __WEBPACK_IMPORTED_MODULE_22_src_utils_FullscreenHelper__["a" /* default */].RequestFullscreen(document.body);
                }
                _this.props.register(values);
            }
        });
    };
    RegisterAfl.prototype.checkUserRegister = function (props) {
        if (props.User.state === 'finished' && props.Constants.state === 'finished') {
            // User is logged in and can be directed to either their homepage, or a redirect page if one is set
            // JB: This will set the language whenever the register page is rendered
            if (this.props.User.cultureCode != null) {
                var language = __WEBPACK_IMPORTED_MODULE_26_src_constants_Languages__["a" /* default */].FindByCode(this.props.User.cultureCode);
                this.props.setActiveLanguage(language.code);
            }
            var route = __WEBPACK_IMPORTED_MODULE_23_src_utils_RoleRedirect__["a" /* default */].GetRoleRoute(props.User.roleID, props.User.gradeId);
            if (this.props.Config.previousLocation != null) {
                route = this.props.Config.previousLocation;
                this.props.clearPreviousLocation();
            }
            // With this, we can skip the rendering cost of the register page and just send the user to the proper page
            // Set push to false to remove '/register' from the users history
            return props.history.replace(route);
        }
    };
    RegisterAfl.prototype.render = function () {
        var schoolsDisabled = this.state.useSchoolClients || this.state.isLoadingSchools;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { type: "flex", justify: "center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 22, sm: 22, md: 18, lg: 14, xl: 11, className: "register-form" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_19_src_core_Routes__["a" /* default */].BASE_ROUTE, className: "logo", tabIndex: -1 },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: logo, alt: "Kuder Galaxy", height: "100%", width: "100%", tabIndex: -1 })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */], { hideRequiredMark: true, onSubmit: this.handleRegister },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.header1" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "firstName" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.firstName" })),
                            this.props.form.getFieldDecorator('firstName', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { size: "large", "aria-label": this.props.translate('account.register.firstName').toString(), placeholder: this.props.translate('account.register.firstName').toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "lastName" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.lastName" })),
                            this.props.form.getFieldDecorator('lastName', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { size: "large", "aria-label": this.props.translate('account.register.lastName').toString(), placeholder: this.props.translate('account.register.lastName').toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "email" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.email" })),
                            this.props.form.getFieldDecorator('email', {
                                rules: [
                                    { required: true, message: this.props.translate('admin.common.requiredRule').toString() },
                                    { pattern: /^.+\@.+\..+$/, message: this.props.translate('admin.common.emailRule').toString() }
                                ]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { size: "large", "aria-label": this.props.translate('account.register.email').toString(), placeholder: this.props.translate('account.register.email').toString() }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "cultureId" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.culture" })),
                            this.props.form.getFieldDecorator('cultureId', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], __assign({ placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.languageSelect" }), showSearch: true, size: "large" }, { showAction: ["focus", "click"] }), this.generateLanguageOptions()))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "gradeId" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.gradeLevel" })),
                            this.props.form.getFieldDecorator('gradeId', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], __assign({ optionFilterProp: "title", placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.selectGrade" }), showSearch: true, size: "large" }, { showAction: ["focus", "click"] }), __WEBPACK_IMPORTED_MODULE_27_src_constants_Grades__["a" /* Grades */].All.map(function (x) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "grade" + x.id, value: x.id }, x.shortName)); })))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "schoolId" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.librarySearch.name" })),
                            this.props.form.getFieldDecorator('schoolid', {
                                rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */], __assign({ optionFilterProp: "title", placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.librarySearch.select" }), size: "large", allowClear: true, showSearch: true, disabled: schoolsDisabled, showArrow: false, notFoundContent: null, onChange: this.handleSchoolFilter, onSearch: this.handleSchoolSearch, onBlur: this.handleSchoolBlur }, { showAction: ["focus", "click"] }), this.state.filteredSchools.map(function (x) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: x.key, value: x.key, title: x.value }, x.value); })))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "password" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.password" })),
                            this.props.form.getFieldDecorator('password', {
                                rules: [
                                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                                    { min: 8, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "admin.common.minLengthRule" }),
                                            " 8") },
                                    { validator: this.validateToNextPassword }
                                ]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { size: "large", "aria-label": this.props.translate('account.register.password').toString(), placeholder: this.props.translate('account.register.password').toString(), autoComplete: "off", type: "password" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "screen-reader-hidden", htmlFor: "confirmPassword" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "account.register.confirmPassword" })),
                            this.props.form.getFieldDecorator('confirmPassword', {
                                rules: [
                                    { required: true, message: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["b" /* Translate */], { id: "admin.common.requiredRule" }) },
                                    { validator: this.compareToFirstPassword }
                                ]
                            })(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_antd_es_input__["a" /* default */], { size: "large", "aria-label": this.props.translate('account.register.confirmPassword').toString(), placeholder: this.props.translate('account.register.confirmPassword').toString(), autoComplete: "off", type: "password" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].Item, null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { loading: this.props.User.state === 'loading', size: "large", type: "primary", htmlType: "submit" }, this.props.User.state !== 'loading' && this.props.translate('account.register.registerButton'))))))));
    };
    RegisterAfl.prototype.generateLanguageOptions = function () {
        // Only available languages
        return __WEBPACK_IMPORTED_MODULE_26_src_constants_Languages__["a" /* default */].All.filter(function (x) { return x.isAvailable && x.code !== 'en-au'; }).map(function (x) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_antd_es_select__["a" /* default */].Option, { key: "cultureIds" + x.id, value: x.id },
            x.name,
            " (",
            x.code,
            ")")); });
    };
    return RegisterAfl;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return {
        register: function (registerModel) { return __WEBPACK_IMPORTED_MODULE_21_src_redux_UserActions__["a" /* default */].Register(dispatch, registerModel); },
        updateUserError: function (msg) { return Object(__WEBPACK_IMPORTED_MODULE_21_src_redux_UserActions__["b" /* updateUserError */])(dispatch, msg); },
        clearPreviousLocation: function () { return __WEBPACK_IMPORTED_MODULE_25_src_redux_ConfigActions__["a" /* default */].SetPreviousLocation(dispatch, null); }
    };
}
function mapStateToProps(state) {
    return {
        User: state.User,
        Constants: state.Constants,
        Config: state.Config
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_20_react_localize_redux__["d" /* withLocalize */])(__WEBPACK_IMPORTED_MODULE_2_antd_es_form__["a" /* default */].create()(RegisterAfl))));


/***/ }),
/* 2672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_common_ReportHeader__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_ReportApiController__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdminReports_less__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdminReports_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AdminReports_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_icon_style_index_js__ = __webpack_require__(54);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder






var StudentPlanetCompletionReport = /** @class */ (function (_super) {
    __extends(StudentPlanetCompletionReport, _super);
    function StudentPlanetCompletionReport(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, StudentPlanetCompletionReport.prototype);
        _this.state = {
            isLoading: false,
            filterParams: null
        };
        return _this;
    }
    StudentPlanetCompletionReport.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        // Add custom filtering into the request
        requestState.filterData = this.state.filterParams;
        // Show nothing in datatable if there are no filters, represented as {} from the reset function
        if (this.state.filterParams == null) {
            // Clear out the datatable as the clear button ends up here as well
            callback({ results: [], filteredCount: 0 });
            return;
        }
        this.setState({ isLoading: true });
        __WEBPACK_IMPORTED_MODULE_5_src_api_ReportApiController__["a" /* default */].getStudentPlanetCompletionReport(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            _this.setState({
                isLoading: false
            });
            callback(results.data);
        });
    };
    StudentPlanetCompletionReport.prototype.handleOnReset = function () {
        var _this = this;
        this.setState({ filterParams: null }, function () { return _this.standardDataTableRef.refresh(); });
    };
    StudentPlanetCompletionReport.prototype.handleOnSubmit = function (filterParams) {
        var _this = this;
        this.setState({ filterParams: filterParams }, function () { return _this.standardDataTableRef.refresh(); });
    };
    StudentPlanetCompletionReport.prototype.customTableColumns = function () {
        var columns = [
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.firstName' }), "firstName"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.lastName' }), "lastName"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].BetterColumns.Custom(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.currentGrade' }), "currentGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: function (a, b) { return a.currentGradeId - b.currentGradeId; }
            }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].BetterColumns.Custom(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.activityGrade' }), "activityGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: function (a, b) { return a.activityGradeId - b.activityGradeId; }
            }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Custom("R", "planetR", undefined, function (record) { return (record.planetR ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "green-icon fas fa-check" }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "red-icon fas fa-times" })); }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Custom("I", "planetI", undefined, function (record) { return (record.planetI ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "green-icon fas fa-check" }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "red-icon fas fa-times" })); }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Custom("A", "planetA", undefined, function (record) { return (record.planetA ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "green-icon fas fa-check" }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "red-icon fas fa-times" })); }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Custom("S", "planetS", undefined, function (record) { return (record.planetS ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "green-icon fas fa-check" }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "red-icon fas fa-times" })); }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Custom("E", "planetE", undefined, function (record) { return (record.planetE ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "green-icon fas fa-check" }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "red-icon fas fa-times" })); }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Custom("C", "planetC", undefined, function (record) { return (record.planetC ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "green-icon fas fa-check" }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "red-icon fas fa-times" })); })
        ];
        return columns;
    };
    StudentPlanetCompletionReport.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "admin-report student-planet-completion-report" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.planetCompletionReport" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Planet Completion Detail Report provides quick access to review planets completed by students in your school. Currently, reporting data is available only if student grade has occurred. Please click on the help icon to view a detailed example."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Activity Grade indicates the Grade level in which student completed the activity."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_icon__["a" /* default */], { className: "info-icon", type: "info-circle" }),
                " Click these icons for additional information."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_src_components_common_ReportHeader__["a" /* default */], { reportingEvent: "Planet Completion", isLoading: this.state.isLoading, defaultSchoolYears: "Current", onSubmit: this.handleOnSubmit, onReset: this.handleOnReset }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.standardDataTableRef = ref; }, serverSide: true, tableProps: {
                    // UserId is not unique
                    // rowKey: NameOf<StudentPlanetCompletionReportDTO>("userId"),
                    loading: this.state.isLoading,
                    pagination: {
                        defaultPageSize: 100,
                        showTotal: __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].StandardTotalsRenderer,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "25", "100", "9999"],
                    }
                }, columns: this.customTableColumns(), data: [], fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["b" /* DataTableButtonExport */]("Planet Completion Report")
                ] })));
    };
    return StudentPlanetCompletionReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StudentPlanetCompletionReport);


/***/ }),
/* 2673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_common_ReportHeader__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_ReportApiController__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdminReports_less__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdminReports_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AdminReports_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_icon_style_index_js__ = __webpack_require__(54);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


 // 'this' binder






var StudentGameCompletionReport = /** @class */ (function (_super) {
    __extends(StudentGameCompletionReport, _super);
    function StudentGameCompletionReport(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, StudentGameCompletionReport.prototype);
        _this.state = {
            isLoading: false,
            filterParams: null
        };
        return _this;
    }
    StudentGameCompletionReport.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        // Add custom filtering into the request
        requestState.filterData = this.state.filterParams;
        // Show nothing in datatable if there are no filters, represented as {} from the reset function
        if (this.state.filterParams == null) {
            // Clear out the datatable as the clear button ends up here as well
            callback({ results: [], filteredCount: 0 });
            return;
        }
        this.setState({ isLoading: true });
        __WEBPACK_IMPORTED_MODULE_5_src_api_ReportApiController__["a" /* default */].getStudentGameCompletionReport(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            _this.setState({
                isLoading: false
            });
            callback(results.data);
        });
    };
    StudentGameCompletionReport.prototype.handleOnReset = function () {
        var _this = this;
        this.setState({ filterParams: null }, function () { return _this.standardDataTableRef.refresh(); });
    };
    StudentGameCompletionReport.prototype.handleOnSubmit = function (filterParams) {
        var _this = this;
        this.setState({ filterParams: filterParams }, function () { return _this.standardDataTableRef.refresh(); });
    };
    StudentGameCompletionReport.prototype.customTableColumns = function () {
        var columns = [
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.firstName' }), "firstName"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.lastName' }), "lastName"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].BetterColumns.Custom(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.currentGrade' }), "currentGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: function (a, b) { return a.currentGradeId - b.currentGradeId; }
            }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].BetterColumns.Custom(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.activityGrade' }), "activityGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: function (a, b) { return a.activityGradeId - b.activityGradeId; }
            }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.planet' }), "planetName"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.game' }), "gameName"),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Date(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.completedDate' }), "completedDate"),
        ];
        return columns;
    };
    StudentGameCompletionReport.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "admin-report student-planet-completion-report" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.gameCompletionReport" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Games Completion Report provides quick access to review games completed by students in your school. Grade column in the result table indicates student\u2019s current grade."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "Report period is setup to use school years. School years start on August 1st and end on July 31st."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_icon__["a" /* default */], { className: "info-icon", type: "info-circle" }),
                " Click these icons for additional information."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_src_components_common_ReportHeader__["a" /* default */], { reportingEvent: "Game Completion", isLoading: this.state.isLoading, defaultSchoolYears: "Previous 2", onSubmit: this.handleOnSubmit, onReset: this.handleOnReset }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.standardDataTableRef = ref; }, serverSide: true, tableProps: {
                    // UserId is not unique
                    // rowKey: NameOf<StudentGameCompletionReportDTO>("userId"),
                    loading: this.state.isLoading,
                    pagination: {
                        defaultPageSize: 100,
                        showTotal: __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].StandardTotalsRenderer,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "25", "100", "9999"],
                    }
                }, columns: this.customTableColumns(), data: [], fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["b" /* DataTableButtonExport */]("Game Completion Report")
                ] })));
    };
    return StudentGameCompletionReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StudentGameCompletionReport);


/***/ }),
/* 2674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_common_ReportHeader__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_api_ReportApiController__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdminReports_less__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdminReports_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AdminReports_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_popover__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_popover_style_index_js__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_row_style_index_js__ = __webpack_require__(23);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};


 // 'this' binder












var StudentStatementReport = /** @class */ (function (_super) {
    __extends(StudentStatementReport, _super);
    // private pageSize: number = 7;
    function StudentStatementReport(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, StudentStatementReport.prototype);
        _this.state = {
            isLoading: false,
            filterParams: null
        };
        return _this;
    }
    StudentStatementReport.prototype.fetchData = function (requestState, checkEcho, callback) {
        var _this = this;
        // Add custom filtering into the request
        requestState.filterData = this.state.filterParams;
        // Show nothing in datatable if there are no filters, represented as {} from the reset function
        if (this.state.filterParams == null) {
            // Clear out the datatable as the clear button ends up here as well
            callback({ results: [], filteredCount: 0 });
            return;
        }
        this.setState({ isLoading: true });
        __WEBPACK_IMPORTED_MODULE_5_src_api_ReportApiController__["a" /* default */].getStudentStatementReport(requestState)
            .then(function (results) {
            if (!checkEcho()) {
                return;
            }
            _this.setState({
                isLoading: false
            });
            callback(results.data);
        });
    };
    StudentStatementReport.prototype.handleOnReset = function () {
        var _this = this;
        this.setState({ filterParams: null }, function () { return _this.standardDataTableRef.refresh(); });
    };
    StudentStatementReport.prototype.handleOnSubmit = function (filterParams) {
        var _this = this;
        this.setState({ filterParams: filterParams }, function () { return _this.standardDataTableRef.refresh(); });
    };
    StudentStatementReport.prototype.customTableColumns = function () {
        var columns = [
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.firstName' }), "firstName", 200),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].AdvancedColumns.Text(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.lastName' }), "lastName", 200),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].BetterColumns.Custom(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: 'common.headers.currentGrade' }), "currentGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: function (a, b) { return a.currentGradeId - b.currentGradeId; }
            }),
            __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].BetterColumns.Custom("I Statements Completed", "statements", {
                render: function (record) {
                    if (record.statements.length === 0) {
                        return null;
                    }
                    return __spreadArrays([
                        // Header
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: record.userId + "header", className: "statement-grid" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "grades" }, "Activity Grade"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "attachments" }, "Attachments"),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "description" }, "Statement"))
                    ], record.statements.map(function (x) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: x.id, className: "statement-grid" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "grades" }, x.activityGradeName),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "attachments" }, x.hasFilesAttached ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_popover__["a" /* default */], { trigger: "hover", content: "Student has uploaded files to this I Statement" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "far fa-file" })) : null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "description" }, x.description));
                    }));
                }
            })
        ];
        return columns;
    };
    StudentStatementReport.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "admin-report student-statement-report" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "I Statement Completion Report"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null, "I Statement Completion Report provides quick access to review I Statements completed by students in your school. Reporting Period will be available in future. Grade column in the result table indicates student's current grade. In the results table, \"I Statements Completed\" would also have an indication for the grade."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_icon__["a" /* default */], { className: "info-icon", type: "info-circle" }),
                " Click these icons for additional information."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_src_components_common_ReportHeader__["a" /* default */], { reportingEvent: "I Statement", defaultSchoolYears: "Previous 1", isLoading: false, onSubmit: this.handleOnSubmit, onReset: this.handleOnReset }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */], { ref: function (ref) { return _this.standardDataTableRef = ref; }, serverSide: true, tableProps: {
                    // UserId is not unique
                    // rowKey: NameOf<StudentStatementReportDTO>("userId"),
                    loading: this.state.isLoading,
                    pagination: {
                        defaultPageSize: 100,
                        showTotal: __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["e" /* default */].StandardTotalsRenderer,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "25", "100", "9999"],
                    }
                }, columns: this.customTableColumns(), data: [], fetchData: this.fetchData, buttonBar: [
                    new __WEBPACK_IMPORTED_MODULE_4_src_components_common_DataTable__["b" /* DataTableButtonExport */]("I Statement Completion Report")
                ] })));
    };
    return StudentStatementReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StudentStatementReport);


/***/ }),
/* 2675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_SceneManager__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_redux_CheckpointActions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_common_AudioPlayer__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_pages_student_StudentPages_less__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_pages_student_StudentPages_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_src_pages_student_StudentPages_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_providers_TelemetryService__ = __webpack_require__(148);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var PlanetHome = /** @class */ (function (_super) {
    __extends(PlanetHome, _super);
    function PlanetHome(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, PlanetHome.prototype);
        _this.state = {
            audioUrl: ""
        };
        return _this;
    }
    PlanetHome.prototype.onNextClick = function () {
        // Increment the step and re-render!
        var _a = this.props.Mission.current, checkpointId = _a.checkpointId, stepId = _a.stepId, planetId = _a.planetId; // #TypescriptMagic
        var nextStep = __WEBPACK_IMPORTED_MODULE_5_src_constants_SceneManager__["a" /* default */].GetNextStep(checkpointId, stepId, planetId);
        var newMissionStatus = {
            planetId: nextStep.planetId,
            checkpointId: nextStep.checkpointId,
            stepId: nextStep.stepId,
            currentDirection: "forwards",
        };
        console.log('planet home moving to next step');
        console.log(newMissionStatus);
        this.props.updateMissionStatus(newMissionStatus);
        return;
    };
    PlanetHome.prototype.skipToCheckpoint = function (checkpoint) {
        this.props.updateMissionStatus({
            planetId: this.props.Mission.current.planetId,
            checkpointId: checkpoint.id,
            stepId: 1,
            currentDirection: "forwards",
        });
    };
    PlanetHome.prototype.onBackClick = function () {
        // Increment the step and re-render!
        var _a = this.props.Mission.current, checkpointId = _a.checkpointId, stepId = _a.stepId, planetId = _a.planetId; // #TypescriptMagic
        var nextStep = __WEBPACK_IMPORTED_MODULE_5_src_constants_SceneManager__["a" /* default */].GetPreviousStep(checkpointId, stepId, planetId);
        var newMissionStatus = {
            planetId: nextStep.planetId,
            checkpointId: nextStep.checkpointId,
            stepId: nextStep.stepId,
            currentDirection: "backwards",
        };
        console.log('planet home moving to previous step');
        console.log(newMissionStatus);
        this.props.updateMissionStatus(newMissionStatus);
        return;
    };
    PlanetHome.prototype.onChangeAudio = function (audioUrl) {
        if (audioUrl !== this.state.audioUrl) {
            this.setState({ audioUrl: audioUrl });
        }
    };
    PlanetHome.prototype.componentDidMount = function () {
        var _a = this.props.Mission.current, checkpointId = _a.checkpointId, stepId = _a.stepId, planetId = _a.planetId;
        var checkpoint = __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(checkpointId);
        var planet = __WEBPACK_IMPORTED_MODULE_9_src_constants_Planets__["a" /* Planets */].FindById(planetId);
        __WEBPACK_IMPORTED_MODULE_13_src_providers_TelemetryService__["a" /* Track */].Planet(planet.name, planet.id, checkpoint.name, checkpointId, stepId);
    };
    PlanetHome.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props.Mission.current, currentCheckpointId = _a.checkpointId, currentStepId = _a.stepId, currentPlanetId = _a.planetId;
        var _b = prevProps.Mission.current, prevCheckpointId = _b.checkpointId, prevStepId = _b.stepId, prevPlanetId = _b.planetId;
        if (prevCheckpointId !== currentCheckpointId || prevStepId !== currentStepId) {
            var currentCheckpoint = __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(currentCheckpointId);
            var currentPlanet = __WEBPACK_IMPORTED_MODULE_9_src_constants_Planets__["a" /* Planets */].FindById(currentPlanetId);
            __WEBPACK_IMPORTED_MODULE_13_src_providers_TelemetryService__["a" /* Track */].Planet(currentPlanet.name, currentPlanet.id, currentCheckpoint.name, currentCheckpoint.id, currentStepId);
        }
    };
    PlanetHome.prototype.render = function () {
        var currentGrade = __WEBPACK_IMPORTED_MODULE_8_src_constants_Grades__["a" /* Grades */].FindById(this.props.User.gradeId);
        var currentPlanet = __WEBPACK_IMPORTED_MODULE_9_src_constants_Planets__["a" /* Planets */].FindById(this.props.Mission.current.planetId);
        var currentGame = __WEBPACK_IMPORTED_MODULE_10_src_constants_Games__["a" /* Games */].FindByGradeAndPlanet(currentGrade.id, currentPlanet.id);
        var checkpoint = __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(this.props.Mission.current.checkpointId);
        var level = __WEBPACK_IMPORTED_MODULE_5_src_constants_SceneManager__["a" /* default */].FindByIds(this.props.Mission.current.checkpointId, this.props.Mission.current.stepId);
        if (!this.props.Mission.isReplayModeActive && this.props.Config.previousLocation != null) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].LOGIN });
        }
        if (this.props.Mission.state === "fresh") {
            // User has logged in recently and needs to be welcomed back
            if (this.props.Mission.current.checkpointId > __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding.id) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].STUDENT_RETURN });
            }
        }
        if (checkpoint.type === "SpaceStation") {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].STUDENT_HOME });
        }
        else if (checkpoint.type === "Planet") {
            if (level == null || level.component == null) {
                // Catches errors with the sceneManager. Move on to next area essentially
                if (this.props.Mission.state !== "none") {
                    this.onNextClick();
                }
                return null;
            }
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_src_components_common_AudioPlayer__["a" /* default */], { audioURL: this.state.audioUrl, isPlaying: true }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](level.component, { onNext: this.onNextClick, onBack: this.onBackClick, currentDirection: this.props.Mission.currentDirection, currentGrade: currentGrade, currentPlanet: currentPlanet, currentGame: currentGame, Mission: this.props.Mission, User: this.props.User, Config: this.props.Config, onChangeAudio: this.onChangeAudio, skipToCheckpoint: this.skipToCheckpoint }));
        }
        return null;
    };
    return PlanetHome;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return {
        updateMissionStatus: function (request) { return __WEBPACK_IMPORTED_MODULE_6_src_redux_CheckpointActions__["a" /* default */].UpdateCurrentUserStatus(dispatch, request); },
    };
}
function mapStateToProps(state) {
    return {
        Mission: state.Mission,
        User: state.User,
        Config: state.Config,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(PlanetHome));


/***/ }),
/* 2676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









/**
 * Dialog box with only body text and a next arrow button
 * Contains terrain, star pilot, and star pod
 */
var Exploring1 = /** @class */ (function (_super) {
    __extends(Exploring1, _super);
    function Exploring1(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, Exploring1.prototype);
        _this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
        return _this;
    }
    Exploring1.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    Exploring1.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    Exploring1.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    Exploring1.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    Exploring1.prototype.hasNextButton = function () {
        return true;
    };
    Exploring1.prototype.hasBackButton = function () {
        return this.state.translationStep > 0;
    };
    Exploring1.prototype.onNext = function () {
        // Update the state step first
        var step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    };
    Exploring1.prototype.onBack = function () {
        // Update the state step first (go backwards)
        var step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    };
    Exploring1.prototype.deriveStateFromProps = function (newProps) {
        var translatedKey = "%game%.Intro.PreVid"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        var translatedText = newProps.translate(translatedKey).toString();
        var translatedArray = (translatedText || "").split("|").map(function (x) { return x.trim(); });
        var translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;
        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        });
    };
    Exploring1.prototype.renderHeader = function () {
        if (this.state.translationStep === 0) {
            var headerTranslateKey = "student.exploring.title".replace("%game%", (this.props.currentGame || { name: "" }).name);
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: headerTranslateKey }));
        }
        return null;
    };
    Exploring1.prototype.render = function () {
        var planetCode = (this.props.currentPlanet || { name: "" }).name.toLowerCase();
        var currentDialog = (this.state.translationArray || [""])[this.state.translationStep];
        var terrainClassName = "planet-terrain planet-terrain-" + planetCode;
        var podClassName = "star-pod star-pod-landed star-pod-" + planetCode + "-landed";
        var pilotClassName = "star-pilot star-pilot-" + planetCode;
        var translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = translationKey + ".part" + (this.state.translationStep + 1);
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, lg: 16, xl: 14 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                            this.renderHeader(),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, currentDialog))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: pilotClassName }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: podClassName }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: terrainClassName }));
    };
    return Exploring1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(Exploring1));


/***/ }),
/* 2677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_mission_InfoBox__ = __webpack_require__(191);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var SpaceStation1 = /** @class */ (function (_super) {
    __extends(SpaceStation1, _super);
    function SpaceStation1(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, SpaceStation1.prototype);
        _this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: [],
        };
        return _this;
    }
    SpaceStation1.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStation1.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStation1.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    SpaceStation1.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    SpaceStation1.prototype.hasNextButton = function () {
        return true;
    };
    SpaceStation1.prototype.hasBackButton = function () {
        return this.state.translationStep > 0;
    };
    SpaceStation1.prototype.onNext = function () {
        // Update the state step first
        var step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    };
    SpaceStation1.prototype.onBack = function () {
        // Update the state step first
        var step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
    };
    SpaceStation1.prototype.deriveStateFromProps = function (newProps) {
        var translatedKey = "student.welcome.grade%gradeNumber%.page1"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        var translatedText = newProps.translate(translatedKey).toString();
        var translatedArray = (translatedText || "").split("|").map(function (x) { return x.trim(); });
        var translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;
        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        });
    };
    SpaceStation1.prototype.renderHeader = function () {
        if (this.props.Mission.current.stepId === 1) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.welcome.common.page1Header" }));
        }
    };
    SpaceStation1.prototype.render = function () {
        var currentDialog = (this.state.translationArray || [""])[this.state.translationStep];
        var translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = translationKey + ".part" + (this.state.translationStep + 1);
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, xl: 14 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                        this.renderHeader(),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, currentDialog)))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: 23, md: { span: 7, push: 1 }, xl: 9 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 23, push: 1 }, lg: { span: 20, push: 4 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_src_components_mission_InfoBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 20, push: 2 }, lg: { span: 21, push: 1 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "station-commander", alt: "Commander " + this.props.currentGrade.commander, src: this.props.currentGrade.commanderPath, height: "100%", width: "100%" })))));
    };
    return SpaceStation1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(SpaceStation1));


/***/ }),
/* 2678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_mission_InfoBox__ = __webpack_require__(191);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var SpaceStation2 = /** @class */ (function (_super) {
    __extends(SpaceStation2, _super);
    function SpaceStation2(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, SpaceStation2.prototype);
        _this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: [""]
        };
        return _this;
    }
    SpaceStation2.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStation2.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStation2.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    SpaceStation2.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    SpaceStation2.prototype.hasNextButton = function () {
        return true;
    };
    SpaceStation2.prototype.hasBackButton = function () {
        return true;
    };
    SpaceStation2.prototype.onNext = function () {
        // Update the state step first
        var step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    };
    SpaceStation2.prototype.onBack = function () {
        // Update the state step first (go backwards)
        var step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    };
    SpaceStation2.prototype.deriveStateFromProps = function (newProps) {
        var translatedKey = "student.welcome.grade%gradeNumber%.page2"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        var translatedText = newProps.translate(translatedKey).toString();
        var translatedArray = (translatedText || "").split("|").map(function (x) { return x.trim(); });
        var translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;
        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        });
    };
    SpaceStation2.prototype.render = function () {
        var currentDialog = (this.state.translationArray || [""])[this.state.translationStep];
        var translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = translationKey + ".part" + (this.state.translationStep + 1);
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, xl: 14 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, currentDialog)))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: 23, md: { span: 7, push: 1 }, xl: 9 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 23, push: 1 }, lg: { span: 20, push: 4 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_src_components_mission_InfoBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 20, push: 2 }, lg: { span: 21, push: 1 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "station-commander", alt: "Commander " + this.props.currentGrade.commander, src: this.props.currentGrade.commanderPath, height: "100%", width: "100%" })))));
    };
    return SpaceStation2;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(SpaceStation2));


/***/ }),
/* 2679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_mission_InfoBox__ = __webpack_require__(191);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var SpaceStation3 = /** @class */ (function (_super) {
    __extends(SpaceStation3, _super);
    function SpaceStation3(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, SpaceStation3.prototype);
        _this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
        return _this;
    }
    SpaceStation3.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStation3.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStation3.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    SpaceStation3.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    SpaceStation3.prototype.hasNextButton = function () {
        return true;
    };
    SpaceStation3.prototype.hasBackButton = function () {
        return true;
    };
    SpaceStation3.prototype.onNext = function () {
        // Update the state step first
        var step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    };
    SpaceStation3.prototype.onBack = function () {
        // Update the state step first
        var step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    };
    SpaceStation3.prototype.deriveStateFromProps = function (newProps) {
        var translatedKey = "student.welcome.grade%gradeNumber%.page3"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        var translatedText = newProps.translate(translatedKey).toString();
        var translatedArray = (translatedText || "").split("|").map(function (x) { return x.trim(); });
        var translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;
        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        });
    };
    SpaceStation3.prototype.render = function () {
        var currentDialog = (this.state.translationArray || [""])[this.state.translationStep];
        var translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = translationKey + ".part" + (this.state.translationStep + 1);
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, xl: 14 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, currentDialog)))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: 23, md: { span: 7, push: 1 }, xl: 9 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 23, push: 1 }, lg: { span: 20, push: 4 } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_src_components_mission_InfoBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 20, push: 2 }, lg: { span: 21, push: 1 } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "station-commander", alt: "Commander " + this.props.currentGrade.commander, src: this.props.currentGrade.commanderPath, height: "100%", width: "100%" }))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pilots" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "star-pilot", alt: "Star Pilot R", src: __webpack_require__(830), height: "100%", width: "100%" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "star-pilot", alt: "Star Pilot I", src: __webpack_require__(2089), height: "100%", width: "100%" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "star-pilot", alt: "Star Pilot A", src: __webpack_require__(2090), height: "100%", width: "100%" })));
    };
    return SpaceStation3;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(SpaceStation3));


/***/ }),
/* 2680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_mission_InfoBox__ = __webpack_require__(191);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var SpaceStation4 = /** @class */ (function (_super) {
    __extends(SpaceStation4, _super);
    function SpaceStation4(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, SpaceStation4.prototype);
        _this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
        return _this;
    }
    SpaceStation4.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStation4.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStation4.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    SpaceStation4.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    SpaceStation4.prototype.hasNextButton = function () {
        return true;
    };
    SpaceStation4.prototype.hasBackButton = function () {
        return true;
    };
    SpaceStation4.prototype.onNext = function () {
        // Update the state step first
        var step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    };
    SpaceStation4.prototype.onBack = function () {
        // Update the state step first (go backwards)
        var step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    };
    SpaceStation4.prototype.deriveStateFromProps = function (newProps) {
        var translatedKey = "student.welcome.grade%gradeNumber%.page4"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        var translatedText = newProps.translate(translatedKey).toString();
        var translatedArray = (translatedText || "").split("|").map(function (x) { return x.trim(); });
        var translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;
        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        });
    };
    SpaceStation4.prototype.render = function () {
        var currentDialog = (this.state.translationArray || [""])[this.state.translationStep];
        var translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = translationKey + ".part" + (this.state.translationStep + 1);
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, xl: 14 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, currentDialog)))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: 23, md: { span: 7, push: 1 }, xl: 9 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 23, push: 1 }, lg: { span: 20, push: 4 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_src_components_mission_InfoBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 20, push: 2 }, lg: { span: 21, push: 1 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "station-commander", alt: "Commander " + this.props.currentGrade.commander, src: this.props.currentGrade.commanderPath, height: "100%", width: "100%" })))));
    };
    return SpaceStation4;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(SpaceStation4));


/***/ }),
/* 2681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_mission_InfoBox__ = __webpack_require__(191);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var SpaceStation5 = /** @class */ (function (_super) {
    __extends(SpaceStation5, _super);
    function SpaceStation5(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, SpaceStation5.prototype);
        _this.state = {
            countdownTimer: 5,
            intervalId: null,
            translationKey: "",
            translationStep: 0,
            translationArray: [],
        };
        return _this;
    }
    SpaceStation5.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStation5.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStation5.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    SpaceStation5.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    SpaceStation5.prototype.hasNextButton = function () {
        return !this.state.intervalId;
    };
    SpaceStation5.prototype.hasBackButton = function () {
        return !this.state.intervalId;
    };
    SpaceStation5.prototype.onNext = function () {
        var _this = this;
        if (!this.state.intervalId) {
            this.setState({ intervalId: setInterval(function () { return _this.onNext(); }, 1000) });
        }
        else if (this.state.countdownTimer > 1) {
            this.setState({ countdownTimer: this.state.countdownTimer - 1 });
        }
        else {
            clearInterval(this.state.intervalId);
            this.props.onNext();
        }
    };
    SpaceStation5.prototype.onBack = function () {
        this.props.onBack();
    };
    SpaceStation5.prototype.deriveStateFromProps = function (newProps) {
        var translatedKey = "student.welcome.grade%gradeNumber%.page5"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        var translatedText = newProps.translate(translatedKey).toString();
        var translatedArray = (translatedText || "").split("|").map(function (x) { return x.trim(); });
        var translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;
        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        });
    };
    SpaceStation5.prototype.render = function () {
        var currentDialog = (this.state.translationArray || [""])[this.state.translationStep];
        var translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = translationKey + ".part" + (this.state.translationStep + 1);
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, xl: 14 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonTextKey: "student.welcome.common.page5Button", buttonNextType: this.hasNextButton() ? "standard" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, currentDialog),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { textAlign: 'center' } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.welcome.common.page5Header" })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "countdown-txt", hidden: !this.state.intervalId }, this.state.countdownTimer))))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: 23, md: { span: 7, push: 1 }, xl: 9 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 23, push: 1 }, lg: { span: 20, push: 4 } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_src_components_mission_InfoBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 20, push: 2 }, lg: { span: 21, push: 1 } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "station-commander", alt: "Commander " + this.props.currentGrade.commander, src: this.props.currentGrade.commanderPath, height: "100%", width: "100%" }))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "pilot-dialog" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "star-pilot", alt: "Star Pilot R", src: __webpack_require__(830), height: "100%", width: "100%" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.welcome.common.page5Pilot" })))));
    };
    return SpaceStation5;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(SpaceStation5));


/***/ }),
/* 2682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var StudentPostGame = /** @class */ (function (_super) {
    __extends(StudentPostGame, _super);
    function StudentPostGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, StudentPostGame.prototype);
        _this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
        return _this;
    }
    StudentPostGame.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    StudentPostGame.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    StudentPostGame.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    StudentPostGame.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    StudentPostGame.prototype.hasNextButton = function () {
        return true;
    };
    StudentPostGame.prototype.hasBackButton = function () {
        return true;
    };
    StudentPostGame.prototype.onNext = function () {
        // Update the state step first
        var step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    };
    StudentPostGame.prototype.onBack = function () {
        // Update the state step first (go backwards)
        var step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    };
    StudentPostGame.prototype.deriveStateFromProps = function (newProps) {
        var translatedKey = "%game%.GameActivityTransition"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        var translatedText = newProps.translate(translatedKey).toString();
        // Sometimes, we just don't have text. Nothing to show? Move on!
        if (translatedText == null || translatedText.length < 1) {
            this.onNext();
        }
        var translatedArray = translatedText.split("|").map(function (x) { return x.trim(); });
        var translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;
        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        });
    };
    StudentPostGame.prototype.render = function () {
        var planetCode = (this.props.currentPlanet || { name: "" }).name.toLowerCase();
        var currentDialog = (this.state.translationArray || [""])[this.state.translationStep];
        var translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = translationKey + ".part" + (this.state.translationStep + 1);
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, lg: 16, xl: 14 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, currentDialog)))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pilot star-pilot-" + planetCode }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pod star-pod-landed star-pod-" + planetCode + "-landed" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "planet-terrain planet-terrain-" + planetCode }));
    };
    return StudentPostGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(StudentPostGame));


/***/ }),
/* 2683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









/**
 * Dialog box with header, body text, and an actual button (not a next arrow button)
 * This page includes the terrain, star pilot, and star pod
 */
var StudentPreGame = /** @class */ (function (_super) {
    __extends(StudentPreGame, _super);
    function StudentPreGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, StudentPreGame.prototype);
        _this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
        return _this;
    }
    StudentPreGame.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    StudentPreGame.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    StudentPreGame.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    StudentPreGame.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    StudentPreGame.prototype.hasNextButton = function () {
        return true;
    };
    StudentPreGame.prototype.hasBackButton = function () {
        return true;
    };
    StudentPreGame.prototype.onNext = function () {
        // Update the state step first
        var step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    };
    StudentPreGame.prototype.onBack = function () {
        // Update the state step first (go backwards)
        var step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    };
    StudentPreGame.prototype.deriveStateFromProps = function (newProps) {
        var translatedKey = "%game%.Intro.PostVid"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        var translatedText = newProps.translate(translatedKey).toString();
        var translatedArray = (translatedText || "").split("|").map(function (x) { return x.trim(); });
        var translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;
        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        });
    };
    StudentPreGame.prototype.renderHeader = function () {
        if (this.state.translationStep === this.state.translationArray.length - 1) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.pregame.header" }));
        }
        return null;
    };
    StudentPreGame.prototype.render = function () {
        var planetCode = (this.props.currentPlanet || { name: "" }).name.toLowerCase();
        var currentDialog = (this.state.translationArray || [""])[this.state.translationStep];
        var translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = translationKey + ".part" + (this.state.translationStep + 1);
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, lg: 16, xl: 14 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, currentDialog)))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pilot star-pilot-" + planetCode }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pod star-pod-landed star-pod-" + planetCode + "-landed" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "planet-terrain planet-terrain-" + planetCode }));
    };
    return StudentPreGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(StudentPreGame));


/***/ }),
/* 2684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_api_ActivityApiController__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_student_ActivityIntro__ = __webpack_require__(2685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_student_ActivitySummary__ = __webpack_require__(2687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_student_ActivityConclusion__ = __webpack_require__(2688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_student_ActivityQuestion__ = __webpack_require__(2689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_localize_redux__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};













var StudentActivity = /** @class */ (function (_super) {
    __extends(StudentActivity, _super);
    function StudentActivity(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, StudentActivity.prototype);
        _this.state = {
            activityCounter: 0,
            activityStep: -1,
            activities: [],
            studentResponses: [],
            studentSummary: null,
            isSubmitting: false,
            isLoading: false,
        };
        return _this;
    }
    StudentActivity.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
    };
    StudentActivity.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    StudentActivity.prototype.deriveStateFromProps = function (newProps) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_7_src_api_ActivityApiController__["a" /* default */].getStudentActivities({ gradeId: newProps.currentGrade.id, planetCode: newProps.currentPlanet.name }).then(function (result) {
            if (result == null || result.data.length < 1) {
                _this.props.onNext();
                return;
            }
            _this.setState({
                activities: result.data
            });
            _this.pickNextDisplay();
            result.data.forEach(function (activity) {
                __WEBPACK_IMPORTED_MODULE_7_src_api_ActivityApiController__["a" /* default */].getStudentActivityResponses(activity.id).then(function (studentResponse) {
                    // We can't be 100% sure what order they will return, so we need to use the fancy setState() method
                    _this.setState(function (newState) {
                        var newResponse = { activityId: activity.id, data: studentResponse.data.items };
                        return { studentResponses: __spreadArrays(newState.studentResponses, [newResponse]) };
                    });
                });
            });
        });
    };
    StudentActivity.prototype.hasNextButton = function () {
        return this.state.activityStep !== 1;
    };
    StudentActivity.prototype.hasBackButton = function () {
        return this.state.activityStep < 1;
    };
    StudentActivity.prototype.pickNextDisplay = function () {
        var step = this.state.activityStep;
        var counter = this.state.activityCounter;
        do {
            step++;
            if (step > 3) {
                // Overflow! inc counter
                counter++;
                step = 0;
            }
            if (counter > this.state.activities.length) {
                // Finished!
                return this.props.onNext();
            }
        } while (!this.isValidActivityStep(step, counter));
        this.setState({
            activityStep: step,
            activityCounter: counter,
        });
    };
    StudentActivity.prototype.pickPreviousDisplay = function () {
        var step = this.state.activityStep;
        var counter = this.state.activityCounter;
        do {
            step--;
            if (step < 0) {
                // Underflow! dec counter
                counter--;
                step = 3;
            }
            if (counter < 0) {
                // Goto Previous page
                return this.props.onBack();
            }
        } while (!this.isValidActivityStep(step, counter));
        this.setState({
            activityStep: step,
            activityCounter: counter,
        });
    };
    StudentActivity.prototype.isValidActivityStep = function (step, counter) {
        // Check intro, summary and conclusion
        if (this.state.activities == null || this.state.activities.length < 1) {
            return false;
        }
        var activity = this.state.activities[counter];
        if (activity == null) {
            return false;
        }
        switch (step) {
            case 0: // Intro
                return activity.introduction != null && activity.introduction.text != null && activity.introduction.text.trim().length > 0;
            case 1: // Questions
                return activity.questions != null && activity.questions.length > 0;
            case 2: // Summary
                return this.state.studentSummary != null && this.state.studentSummary.text != null && this.state.studentSummary.text.trim().length > 0;
            case 3: // Conclusion
                return activity.conclusion != null && activity.conclusion.text != null && activity.conclusion.text.trim().length > 0;
            default:
                break;
        }
    };
    StudentActivity.prototype.handleQuestionSubmit = function (studentResponses) {
        var _this = this;
        var currentActivity = this.state.activities[this.state.activityCounter];
        this.setState({ isSubmitting: true });
        __WEBPACK_IMPORTED_MODULE_7_src_api_ActivityApiController__["a" /* default */].submitStudentActivity({ activityId: currentActivity.id, responses: studentResponses }).then(function () {
            _this.setState({
                isSubmitting: false,
                isLoading: true,
            });
            // Get summary for this student/activity
            __WEBPACK_IMPORTED_MODULE_7_src_api_ActivityApiController__["a" /* default */].getStudentActivitySummary(currentActivity.id).then(function (result) {
                // Data comes back as null when there is no summary. This is OK as it will reset the studentSummary to null
                _this.setState({
                    studentSummary: result.data,
                    isLoading: false,
                }, function () { return _this.pickNextDisplay(); });
            });
        });
    };
    StudentActivity.prototype.renderDialog = function () {
        if (this.state.activities == null || this.state.activities.length < 1) {
            return null;
        }
        var currentActivity = this.state.activities[this.state.activityCounter];
        var studentResponses = this.state.studentResponses.find(function (x) { return x.activityId === currentActivity.id; });
        if (currentActivity == null || studentResponses == null) {
            return null;
        }
        var props = {
            activity: currentActivity,
            currentGame: this.props.currentGame,
            onNext: this.pickNextDisplay,
            onBack: this.pickPreviousDisplay,
        };
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onNext: this.pickNextDisplay, onBack: this.pickPreviousDisplay },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                this.state.activityStep === 0 ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_src_components_student_ActivityIntro__["a" /* default */], __assign({}, props)) : null,
                this.state.activityStep === 1 ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_src_components_student_ActivityQuestion__["a" /* default */], __assign({}, props, { onFinish: this.handleQuestionSubmit, studentResponses: studentResponses.data, isSubmitting: this.state.isSubmitting })) : null,
                this.state.activityStep === 2 ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_src_components_student_ActivitySummary__["a" /* default */], __assign({}, props, { summary: this.state.studentSummary })) : null,
                this.state.activityStep === 3 ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_src_components_student_ActivityConclusion__["a" /* default */], __assign({}, props)) : null));
    };
    StudentActivity.prototype.renderActivityStepSwitch = function (activityStep, props, studentResponsesdata) {
        switch (activityStep) {
            case 0:
                if (this.isValidActivityStep(0, 0)) {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_src_components_student_ActivityIntro__["a" /* default */], __assign({}, props));
                }
                else {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_src_components_student_ActivityQuestion__["a" /* default */], __assign({}, props, { onFinish: this.handleQuestionSubmit, studentResponses: studentResponsesdata, isSubmitting: this.state.isSubmitting }));
                }
            case 1:
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_src_components_student_ActivityQuestion__["a" /* default */], __assign({}, props, { onFinish: this.handleQuestionSubmit, studentResponses: studentResponsesdata, isSubmitting: this.state.isSubmitting }));
            case 2:
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_src_components_student_ActivitySummary__["a" /* default */], __assign({}, props, { summary: this.state.studentSummary }));
            case 3:
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_src_components_student_ActivityConclusion__["a" /* default */], __assign({}, props));
            default:
                return null;
        }
    };
    StudentActivity.prototype.render = function () {
        var planetCode = (this.props.currentPlanet || { name: "" }).name.toLowerCase();
        this.props.onChangeAudio("");
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, lg: 16, xl: 14 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd_es_row__["a" /* default */], null, this.renderDialog()))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pilot star-pilot-" + planetCode }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pod star-pod-landed star-pod-" + planetCode + "-landed" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "planet-terrain planet-terrain-" + planetCode }));
    };
    return StudentActivity;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_localize_redux__["d" /* withLocalize */])(StudentActivity));


/***/ }),
/* 2685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Activity_less__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Activity_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Activity_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_AudioPlayer__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_providers_TelemetryService__ = __webpack_require__(148);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var ActivityIntro = /** @class */ (function (_super) {
    __extends(ActivityIntro, _super);
    function ActivityIntro(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, ActivityIntro.prototype);
        return _this;
    }
    ActivityIntro.prototype.componentDidMount = function () {
        document.addEventListener("keydown", this.handleKeyPress, false);
        var _a = this.props, activity = _a.activity, currentGame = _a.currentGame;
        var activityType = activity.isSurvey ? 'Survey' : 'Quiz';
        var activityName = currentGame.name + "_" + currentGame.grade.shortName + currentGame.planet.name + "_" + activityType;
        __WEBPACK_IMPORTED_MODULE_6_src_providers_TelemetryService__["a" /* Track */].Activity(activity.isSurvey ? 'SURVEY' : 'QUIZ', activityName, activity.id, 'INTRO', 1);
    };
    ActivityIntro.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    ActivityIntro.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.props.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.props.onBack();
            }
        }
    };
    ActivityIntro.prototype.hasNextButton = function () {
        return true;
    };
    ActivityIntro.prototype.hasBackButton = function () {
        return true;
    };
    ActivityIntro.prototype.render = function () {
        if (this.props.activity == null || this.props.activity.id < 1) {
            return null;
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.props.activity.introduction.audioKey, this.props.activeLanguage.code);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "activity-form" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_AudioPlayer__["a" /* default */], { audioURL: audioTrans.url, isPlaying: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, this.props.activity.introduction.text));
    };
    return ActivityIntro;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(ActivityIntro));


/***/ }),
/* 2686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Activity_less__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Activity_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Activity_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_AudioPlayer__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_providers_TelemetryService__ = __webpack_require__(148);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var ActivitySummaryComponent = /** @class */ (function (_super) {
    __extends(ActivitySummaryComponent, _super);
    function ActivitySummaryComponent(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, ActivitySummaryComponent.prototype);
        return _this;
    }
    ActivitySummaryComponent.prototype.componentDidMount = function () {
        this.reloadComponent(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
        var _a = this.props, activity = _a.activity, currentGame = _a.currentGame;
        var activityType = activity.isSurvey ? 'Survey' : 'Quiz';
        var activityName = currentGame.name + "_" + currentGame.grade.shortName + currentGame.planet.name + "_" + activityType;
        __WEBPACK_IMPORTED_MODULE_6_src_providers_TelemetryService__["a" /* Track */].Activity(activity.isSurvey ? 'SURVEY' : 'QUIZ', activityName, activity.id, 'SUMMARY', 1);
    };
    ActivitySummaryComponent.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    ActivitySummaryComponent.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.props.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.props.onBack();
            }
        }
    };
    ActivitySummaryComponent.prototype.hasNextButton = function () {
        return true;
    };
    ActivitySummaryComponent.prototype.hasBackButton = function () {
        return true;
    };
    ActivitySummaryComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if ((this.props.activity == null && nextProps.activity != null)
            || (this.props.activity.id !== nextProps.activity.id)
            || this.props.summary.text !== nextProps.summary.text) {
            this.reloadComponent(nextProps);
        }
    };
    ActivitySummaryComponent.prototype.reloadComponent = function (props) {
        if (props.summary == null || props.summary.text == null || props.summary.text.length < 1) {
            this.props.onNext();
        }
    };
    ActivitySummaryComponent.prototype.render = function () {
        if (this.props.activity == null || this.props.activity.id < 1) {
            return null;
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.props.summary.audioKey, this.props.activeLanguage.code);
        return [
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_AudioPlayer__["a" /* default */], { audioURL: audioTrans.url, isPlaying: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "student.activity.summary" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "student.activity.score" }),
                this.props.summary.score),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, this.props.summary.text || ""),
        ];
    };
    return ActivitySummaryComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(ActivitySummaryComponent));


/***/ }),
/* 2688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Activity_less__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Activity_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Activity_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_AudioPlayer__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_providers_TelemetryService__ = __webpack_require__(148);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var ActivityConclusion = /** @class */ (function (_super) {
    __extends(ActivityConclusion, _super);
    function ActivityConclusion(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, ActivityConclusion.prototype);
        return _this;
    }
    ActivityConclusion.prototype.componentDidMount = function () {
        document.addEventListener("keydown", this.handleKeyPress, false);
        var _a = this.props, activity = _a.activity, currentGame = _a.currentGame;
        var activityType = activity.isSurvey ? 'Survey' : 'Quiz';
        var activityName = currentGame.name + "_" + currentGame.grade.shortName + currentGame.planet.name + "_" + activityType;
        __WEBPACK_IMPORTED_MODULE_6_src_providers_TelemetryService__["a" /* Track */].Activity(activity.isSurvey ? 'SURVEY' : 'QUIZ', activityName, activity.id, 'CONCLUSION', 1);
    };
    ActivityConclusion.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    ActivityConclusion.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            this.props.onNext();
        }
        else if (event.key === "ArrowLeft") {
            this.props.onBack();
        }
    };
    ActivityConclusion.prototype.render = function () {
        if (this.props.activity == null || this.props.activity.id < 1) {
            return null;
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_5_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(this.props.activity.conclusion.audioKey, this.props.activeLanguage.code);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "activity-form" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_AudioPlayer__["a" /* default */], { audioURL: audioTrans.url, isPlaying: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, this.props.activity.conclusion.text || ""));
    };
    return ActivityConclusion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(ActivityConclusion));


/***/ }),
/* 2689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_student_ActivityQuestionDisplay__ = __webpack_require__(2690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_providers_TelemetryService__ = __webpack_require__(148);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};








var ActivityQuestion = /** @class */ (function (_super) {
    __extends(ActivityQuestion, _super);
    function ActivityQuestion(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ActivityQuestion.prototype);
        _this.state = {
            step: 0,
            isLoading: false,
            isCategoryAudioComplete: false,
            sortedQuestions: [],
            studentResponses: [],
        };
        return _this;
    }
    ActivityQuestion.prototype.componentDidMount = function () {
        this.reloadComponent(this.props);
        var _a = this.props, activity = _a.activity, currentGame = _a.currentGame;
        var activityType = activity.isSurvey ? 'Survey' : 'Quiz';
        var activityName = currentGame.name + "_" + currentGame.grade.shortName + currentGame.planet.name + "_" + activityType;
        var step = this.state.step;
        __WEBPACK_IMPORTED_MODULE_7_src_providers_TelemetryService__["a" /* Track */].Activity(activity.isSurvey ? 'SURVEY' : 'QUIZ', activityName, activity.id, 'QUESTION', step);
    };
    ActivityQuestion.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, currentActivity = _a.activity, currentCurrentGame = _a.currentGame;
        var prevActivity = prevProps.activity, prevCurrentGame = prevProps.currentGame;
        var currentStep = this.state.step;
        var prevStep = prevState.step;
        if (prevActivity.id !== currentActivity.id || prevStep !== currentStep) {
            var activityType = currentActivity.isSurvey ? 'Survey' : 'Quiz';
            var activityName = currentCurrentGame.name + "_" + currentCurrentGame.grade.shortName + currentCurrentGame.planet.name + "_" + activityType;
            __WEBPACK_IMPORTED_MODULE_7_src_providers_TelemetryService__["a" /* Track */].Activity(currentActivity.isSurvey ? 'SURVEY' : 'QUIZ', activityName, currentActivity.id, 'QUESTION', currentStep);
        }
    };
    ActivityQuestion.prototype.componentWillReceiveProps = function (nextProps) {
        if ((this.props.activity == null && nextProps.activity != null) || (this.props.activity.id !== nextProps.activity.id)) {
            this.reloadComponent(nextProps);
        }
    };
    ActivityQuestion.prototype.reloadComponent = function (props) {
        // Sort the questions
        var items = props.activity.questions.sort(function (first, second) { return first.displayOrder - second.displayOrder; });
        var categoryIndex = 0;
        var questionIndex = 0;
        var currentIndex = 0;
        var currentCategory = items[0].category;
        var fooItems = items.map(function (item) {
            if (item.category.id !== currentCategory.id) {
                currentCategory = item.category;
                categoryIndex++;
                questionIndex = 0;
            }
            var result = {
                order: currentIndex,
                categoryIndex: categoryIndex,
                questionIndex: questionIndex,
                question: item
            };
            currentIndex++;
            questionIndex++;
            return result;
        });
        this.setState({
            sortedQuestions: fooItems,
            isLoading: false,
            studentResponses: props.studentResponses.length > 0 ? props.studentResponses : this.props.studentResponses,
            step: 0,
        });
    };
    ActivityQuestion.prototype.onPrev = function () {
        var newStep = this.state.step - 1;
        // 0 is the lower limit
        if (newStep < 0) {
            this.props.onBack();
            return;
        }
        this.setState({
            step: newStep,
        });
    };
    ActivityQuestion.prototype.onNext = function () {
        var newStep = this.state.step + 1;
        if (newStep > this.props.activity.questions.length - 1) {
            // Submit after validating
            if (this.validate()) {
                this.props.onFinish(this.state.studentResponses);
                return;
            }
        }
        return this.setState({
            step: newStep,
        });
    };
    ActivityQuestion.prototype.updateStudentResponses = function (questionId, responseIds) {
        var otherResponses = this.state.studentResponses.filter(function (x) { return x.activityQuestionId !== questionId; });
        var newResponses = responseIds.map(function (x) {
            return {
                activityQuestionId: questionId,
                activityQuestionResponseId: x,
            };
        });
        this.setState({
            studentResponses: __spreadArrays(otherResponses, newResponses)
        });
    };
    ActivityQuestion.prototype.validate = function () {
        var _this = this;
        if (this.props.activity == null || this.state.sortedQuestions == null || this.state.sortedQuestions.length < 1) {
            return false;
        }
        // Check if all questions have a response attached to them
        return this.state.sortedQuestions.every(function (x) { return _this.state.studentResponses.findIndex(function (y) { return y.activityQuestionId === x.question.id; }) > -1; });
    };
    ActivityQuestion.prototype.debugRandom = function () {
        var newResponses = this.state.sortedQuestions.map(function (x) { return x.question; }).map(function (question) {
            var max = question.responses.length;
            // For 4 responses, we should get a spread from 0 - 3 but never quite making it to 4, which is good on a 0-indexed array
            var index = Math.floor(Math.random() * max);
            var response = question.responses[index];
            return {
                activityQuestionId: question.id,
                activityQuestionResponseId: response.id
            };
        });
        this.setState({ studentResponses: newResponses });
    };
    ActivityQuestion.prototype.debugGotoEnd = function () {
        this.setState({ step: this.props.activity.questions.length - 1 });
    };
    ActivityQuestion.prototype.render = function () {
        var _this = this;
        if (this.props.activity == null || this.props.activity.id < 1) {
            return null;
        }
        var step = this.state.step;
        // let canLeft = step > 0;
        var canLeft = true;
        var canRight = step < this.props.activity.questions.length - 1;
        var isValid = this.validate();
        var isSubmitting = this.props.isSubmitting;
        var currentQuestion = this.state.sortedQuestions.find(function (x) { return x.question.displayOrder === _this.state.step + 1; });
        var studentResponse = this.state.studentResponses.filter(function (x) { return x.activityQuestionId === currentQuestion.question.id; });
        return [
            __WEBPACK_IMPORTED_MODULE_6_src_utils_DebugUtil__["a" /* default */].isDebugEnabled() && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_button__["a" /* default */], { tabIndex: -1, key: "goFrontDoorYourSelf", type: "primary", onClick: this.debugRandom }, "DEBUG: Fill Randomly"),
            __WEBPACK_IMPORTED_MODULE_6_src_utils_DebugUtil__["a" /* default */].isDebugEnabled() && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_button__["a" /* default */], { tabIndex: -1, key: "goSideDoorYourSelf", type: "primary", onClick: this.debugGotoEnd }, "DEBUG: Step To End"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_src_components_student_ActivityQuestionDisplay__["a" /* default */], { key: "QuestionDisplay", currentGame: this.props.currentGame, onNext: this.onNext, onPrev: this.onPrev, updateStudentResponses: this.updateStudentResponses, canLeft: canLeft, canRight: canRight, currentQuestion: currentQuestion, studentResponses: studentResponse, isSurvey: this.props.activity.isSurvey, isValid: isValid, isSubmitting: isSubmitting })
        ];
    };
    return ActivityQuestion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(ActivityQuestion));


/***/ }),
/* 2690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_common_AudioPlayer__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_icon_style_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_checkbox__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_checkbox_style_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_radio__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_es_radio_style_index_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

















var ActivityQuestionDisplay = /** @class */ (function (_super) {
    __extends(ActivityQuestionDisplay, _super);
    function ActivityQuestionDisplay(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ActivityQuestionDisplay.prototype);
        _this.state = {
            isCategory: false,
            isCategoryNew: false,
            hasQuestionFeedback: false,
            showQuestionFeedback: false,
        };
        return _this;
    }
    ActivityQuestionDisplay.prototype.componentDidMount = function () {
        this.reloadComponent(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    ActivityQuestionDisplay.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    ActivityQuestionDisplay.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.currentQuestion == null || nextProps.currentQuestion.question == null) {
            return;
        }
        // Used purely to check if the question has changed. We can also use its ID
        if (this.props.currentQuestion == null || this.props.currentQuestion.order !== nextProps.currentQuestion.order) {
            this.reloadComponent(nextProps);
        }
    };
    ActivityQuestionDisplay.prototype.reloadComponent = function (props) {
        if (props.currentQuestion == null || props.currentQuestion.question == null) {
            return;
        }
        var currentCategoryId = this.props.currentQuestion != null && this.props.currentQuestion.question != null ? this.props.currentQuestion.question.category.id : 0;
        var newCategoryId = props.currentQuestion.question.category.id;
        var isCategory = newCategoryId > 0;
        var isCategoryNew = currentCategoryId !== newCategoryId;
        var feedback = props.currentQuestion.question.feedbackText;
        var hasQuestionFeedback = feedback != null && feedback.length > 1;
        this.setState({
            isCategory: isCategory,
            isCategoryNew: isCategoryNew,
            hasQuestionFeedback: hasQuestionFeedback,
            showQuestionFeedback: false,
        });
    };
    ActivityQuestionDisplay.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            return this.onNext();
        }
        else if (event.key === "ArrowLeft") {
            return this.onBack();
        }
        // Check if a 'number' was pressed
        if (!isNaN(event.key)) {
            var selectedNumber = Number(event.key);
            var question = this.props.currentQuestion.question;
            if (selectedNumber === 0 || selectedNumber > question.responses.length) {
                // 0 is not supported and the number pressed has to be in range
                return;
            }
            var selectedResponse_1 = question.responses[selectedNumber - 1];
            if (!question.multipleSelection) {
                this.handleRadioChange(question.id, selectedResponse_1.id);
            }
            else {
                // Get current responses, flip the one we selected and push them out
                var studentResponse = this.props.studentResponses.find(function (x) { return x.activityQuestionResponseId === selectedResponse_1.id; });
                var responseIds = this.props.studentResponses.map(function (x) { return x.activityQuestionResponseId; });
                if (studentResponse == null) {
                    // Add it
                    responseIds.push(selectedResponse_1.id);
                }
                else {
                    // Remove it from array
                    responseIds = responseIds.filter(function (x) { return x !== selectedResponse_1.id; });
                }
                // Submit array
                this.handleCheckboxChange(question.id, responseIds);
            }
        }
    };
    ActivityQuestionDisplay.prototype.clearFocus = function () {
        var x = document.querySelector('div[tabIndex="1"]');
        x.focus();
    };
    ActivityQuestionDisplay.prototype.onNext = function () {
        // Check if user has selected an answer
        if (this.props.studentResponses.length < 1) {
            return;
        }
        if (this.state.hasQuestionFeedback) {
            if (this.state.showQuestionFeedback) {
                if (this.props.canRight || !this.isSubmitDisabled()) {
                    this.clearFocus();
                    this.props.onNext();
                }
            }
            else {
                this.setState({ showQuestionFeedback: true });
            }
        }
        else {
            if (this.props.canRight || !this.isSubmitDisabled()) {
                this.clearFocus();
                this.props.onNext();
            }
        }
    };
    ActivityQuestionDisplay.prototype.onBack = function () {
        this.props.onPrev();
    };
    ActivityQuestionDisplay.prototype.handleCheckboxChange = function (questionId, responseIds) {
        this.props.updateStudentResponses(questionId, responseIds.map(Number));
    };
    ActivityQuestionDisplay.prototype.handleRadioChange = function (questionId, responseId) {
        this.props.updateStudentResponses(questionId, [Number(responseId)]);
    };
    ActivityQuestionDisplay.prototype.isSubmitDisabled = function () {
        return !this.props.isValid || this.props.isSubmitting;
    };
    ActivityQuestionDisplay.prototype.onAudioComplete = function () {
        if (this.state.isCategoryNew) {
            this.setState({ isCategoryNew: false });
        }
    };
    ActivityQuestionDisplay.prototype.renderCategory = function () {
        var currentQuestion = this.props.currentQuestion;
        if (currentQuestion == null || currentQuestion.question == null || currentQuestion.question.category == null) {
            return null;
        }
        var titleText = currentQuestion.question.category.titleText;
        if (titleText == null || titleText.length === 0) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null, titleText);
    };
    ActivityQuestionDisplay.prototype.renderQuestionText = function () {
        var currentQuestion = this.props.currentQuestion;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "activity-question-text" }, currentQuestion.question.questionText);
    };
    ActivityQuestionDisplay.prototype.renderResponseImage = function (response) {
        // The url is coming back right now. In future, it shouldn't. For now, just check on the filename itself
        if (response.imageFile != null && response.imageFile.fileName != null && response.imageFile.fileName.length > 1) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: response.imageFile.azureFileUrl });
        }
    };
    ActivityQuestionDisplay.prototype.selectResponse = function (e, currentQuestionId) {
        if (e.which === 32) // space
         {
            var selectedValue = e.target.querySelector('input').value;
            this.handleRadioChange(currentQuestionId, selectedValue);
        }
    };
    ActivityQuestionDisplay.prototype.renderQuestionResponse = function () {
        var _this = this;
        var currentQuestion = this.props.currentQuestion.question;
        if (currentQuestion == null) {
            return null;
        }
        // let selectedResponses = this.props.studentResponses.filter(x => x.activityQuestionId === currentQuestion.id);
        var selections = this.props.studentResponses.map(function (x) { return x.activityQuestionResponseId; });
        if (currentQuestion.multipleSelection) {
            var checkboxes = currentQuestion.responses
                .sort(function (first, second) { return first.displayOrder - second.displayOrder; })
                .map(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_checkbox__["a" /* default */], { tabIndex: -1, key: "checkbox-" + response.id, value: response.id, className: "label-class" },
                    _this.renderResponseImage(response),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, response.responseText));
            });
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_antd_es_checkbox__["a" /* default */].Group, { key: "checkbox-group-" + currentQuestion.id, className: "question-response question-response-checkbox", value: selections, onChange: function (e) { return _this.handleCheckboxChange(currentQuestion.id, e); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_row__["a" /* default */], null, checkboxes.map(function (box) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_col__["a" /* default */], { tabIndex: 1, onKeyPress: function (e) { return _this.selectResponse(e, currentQuestion.id); }, className: "activity-response", span: 24, key: "col" + box.key }, box); })));
        }
        var radios = currentQuestion.responses.map(function (response) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_radio__["c" /* default */], { tabIndex: -1, key: "radio-" + response.id, value: response.id, className: "label-class" },
                _this.renderResponseImage(response),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, response.responseText));
        });
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_antd_es_radio__["c" /* default */].Group, { key: "radio-group-" + currentQuestion.id, className: "question-response question-response-radio", value: selections[0], onChange: function (e) { return _this.handleRadioChange(currentQuestion.id, e.target.value); } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_antd_es_row__["a" /* default */], null, radios.map(function (radio) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_antd_es_col__["a" /* default */], { tabIndex: 1, onKeyPress: function (e) { return _this.selectResponse(e, currentQuestion.id); }, className: "activity-response", span: 24, key: "col" + radio.key }, radio); })));
    };
    ActivityQuestionDisplay.prototype.renderNavigationButtons = function () {
        var canLeft = this.props.canLeft;
        var canRight = this.props.canRight;
        var hasFeedback = this.state.hasQuestionFeedback && !this.state.showQuestionFeedback;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_button__["a" /* default */].Group, null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_button__["a" /* default */], { tabIndex: 1, onClick: this.onBack, disabled: !canLeft },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_icon__["a" /* default */], { type: "left" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_react_localize_redux__["b" /* Translate */], { id: "common.previous" })),
            canRight || hasFeedback
                ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_button__["a" /* default */], { tabIndex: 1, onClick: this.onNext, disabled: this.props.studentResponses.length < 1 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_react_localize_redux__["b" /* Translate */], { id: "common.next" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_icon__["a" /* default */], { type: "right" }))
                : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_button__["a" /* default */], { className: "finish-btn", tabIndex: 1, onClick: this.onNext, type: "primary", disabled: this.isSubmitDisabled() },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_icon__["a" /* default */], { type: "check" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_react_localize_redux__["b" /* Translate */], { id: "common.finish" })));
    };
    ActivityQuestionDisplay.prototype.renderFeedback = function () {
        if (!this.state.showQuestionFeedback) {
            return null;
        }
        var currentQuestion = this.props.currentQuestion;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", null, currentQuestion.question.feedbackText);
    };
    ActivityQuestionDisplay.prototype.render = function () {
        var currentQuestion = this.props.currentQuestion;
        if (currentQuestion == null) {
            return null;
        }
        var isCategory = this.state.isCategory;
        var isSurvey = this.props.isSurvey;
        var isCategoryNew = this.state.isCategoryNew;
        // Activities are now named: <Grade><Planet Code>.<Activity type>.
        var categoryKey = "" + this.props.currentGame.grade.shortName + this.props.currentGame.planet.name + "." + (isSurvey ? "Survey" : "Quiz");
        if (isCategory) {
            categoryKey = categoryKey + ".Category" + (currentQuestion.categoryIndex + 1);
        }
        var questionKey = categoryKey + ".Question" + (currentQuestion.questionIndex + 1);
        var feedbackKey = questionKey + ".Feedback";
        var questionAudio = __WEBPACK_IMPORTED_MODULE_16_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(questionKey, this.props.activeLanguage.code);
        var categoryAudio = __WEBPACK_IMPORTED_MODULE_16_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(categoryKey, this.props.activeLanguage.code);
        var feedbackAudio = __WEBPACK_IMPORTED_MODULE_16_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(feedbackKey, this.props.activeLanguage.code);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "activity-form" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_components_common_AudioPlayer__["a" /* default */], { audioURL: isCategoryNew ? categoryAudio.url : this.state.showQuestionFeedback ? feedbackAudio.url : questionAudio.url, isPlaying: true, onComplete: this.onAudioComplete }),
            this.renderCategory(),
            this.renderQuestionText(),
            this.renderQuestionResponse(),
            this.renderNavigationButtons(),
            this.renderFeedback());
    };
    return ActivityQuestionDisplay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_react_localize_redux__["d" /* withLocalize */])(ActivityQuestionDisplay));


/***/ }),
/* 2691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_constants_Planets__ = __webpack_require__(92);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










/**
 * Dialog box with only body text and a next arrow button
 * Contains terrain, star pilot, and star pod
 */
var StudentReward = /** @class */ (function (_super) {
    __extends(StudentReward, _super);
    function StudentReward(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, StudentReward.prototype);
        _this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
        return _this;
    }
    StudentReward.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    StudentReward.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    StudentReward.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    StudentReward.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    StudentReward.prototype.hasNextButton = function () {
        return true;
    };
    StudentReward.prototype.hasBackButton = function () {
        return true;
    };
    StudentReward.prototype.onNext = function () {
        // Update the state step first
        var step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    };
    StudentReward.prototype.onBack = function () {
        // Update the state step first (go backwards)
        var step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    };
    StudentReward.prototype.deriveStateFromProps = function (newProps) {
        var translatedKey = "student.reward.body"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        var translatedText = newProps.translate(translatedKey).toString();
        var translatedArray = (translatedText || "").split("|").map(function (x) { return x.trim(); });
        var translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;
        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        });
    };
    StudentReward.prototype.renderHeader = function () {
        if (this.state.translationStep === 0) {
            var headerTranslateKey = "student.reward.header".replace("%game%", (this.props.currentGame || { name: "" }).name);
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: headerTranslateKey }));
        }
        return null;
    };
    StudentReward.prototype.render = function () {
        var badgeStyle = { width: 141, height: 150 };
        var planetCode = (this.props.currentPlanet || { name: "" }).name.toLowerCase();
        var currentDialog = (this.state.translationArray || [""])[this.state.translationStep];
        var translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = translationKey + ".part" + (this.state.translationStep + 1);
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 18 }, lg: 16, xl: 14 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                            this.renderHeader(),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, currentDialog),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: __WEBPACK_IMPORTED_MODULE_9_src_constants_Planets__["a" /* Planets */].FindById(this.props.Mission.current.planetId).badgePath, alt: "Planet Badge", style: badgeStyle }))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pilot star-pilot-" + planetCode }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pod star-pod-landed star-pod-" + planetCode + "-landed" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "planet-terrain planet-terrain-" + planetCode }));
    };
    return StudentReward;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(StudentReward));


/***/ }),
/* 2692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_mission_InfoBox__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
















var SpaceStationComplete = /** @class */ (function (_super) {
    __extends(SpaceStationComplete, _super);
    function SpaceStationComplete(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, SpaceStationComplete.prototype);
        return _this;
    }
    SpaceStationComplete.prototype.renderBadges = function () {
        // Use C as it's the last planet
        return __WEBPACK_IMPORTED_MODULE_13_src_constants_Planets__["a" /* Planets */].GetPlanetListByPlanetId(__WEBPACK_IMPORTED_MODULE_13_src_constants_Planets__["a" /* Planets */].C.id).map(function (planet) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "badge", alt: "Planet Badge", src: planet.badgePath, key: "badge" + planet.id })); });
    };
    /**
     * Visible for grades 4+
     */
    SpaceStationComplete.prototype.renderTrainingAndEducationGuideButton = function () {
        if (this.props.currentGrade.level >= __WEBPACK_IMPORTED_MODULE_14_src_constants_Grades__["a" /* Grades */].Fourth.level) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].TRAINING_AND_EDUCATION_GUIDE, this.props.Mission.current.planetId) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { size: "small" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "common.trainingAndEducation" })));
        }
    };
    /**
     * Visible for grades 3+
     */
    SpaceStationComplete.prototype.renderOccupationDb = function () {
        if (this.props.currentGrade.level >= __WEBPACK_IMPORTED_MODULE_14_src_constants_Grades__["a" /* Grades */].Third.level) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].OCCUPATIONDB },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { size: "small" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "public.occupationdb.title" }))));
        }
    };
    /**
     * Visible for grades 3+
     */
    SpaceStationComplete.prototype.renderHollandGuideButton = function () {
        if (this.props.currentGrade.level >= __WEBPACK_IMPORTED_MODULE_14_src_constants_Grades__["a" /* Grades */].Third.level) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].HOLLAND_AREAS_GUIDE, this.props.Mission.current.planetId) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { size: "small" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "common.hollandAreas" })));
        }
    };
    SpaceStationComplete.prototype.render = function () {
        var translationKey = "student.galaxyEnd.doneWithGrade";
        var audioTrans = __WEBPACK_IMPORTED_MODULE_15_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey + "Complete", this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { className: "mission-complete" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, xl: 14 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, onNext: null },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "galaxyEnd-header" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.galaxyEnd.title" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "galaxyEnd-body" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: translationKey })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 13, xl: 13, xxl: 15 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.galaxyEnd.badges" })),
                                this.renderBadges()),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 11, xl: 11, xxl: 9 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "common.menu" })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "resource-buttons" },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["Link"], { to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].STATEMENTS },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { size: "small" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.iStatementsText" }))),
                                    this.renderOccupationDb(),
                                    this.renderHollandGuideButton(),
                                    this.renderTrainingAndEducationGuideButton()))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.galaxyEnd.conclusion" }))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 23, md: { span: 7, push: 1 }, xl: 9 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: { span: 23, push: 1 }, lg: { span: 20, push: 4 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_src_components_mission_InfoBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: { span: 20, push: 2 }, lg: { span: 21, push: 1 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "station-commander", alt: "Commander " + this.props.currentGrade.commander, src: this.props.currentGrade.commanderPath, height: "100%", width: "100%" })))));
    };
    return SpaceStationComplete;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(SpaceStationComplete));


/***/ }),
/* 2693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_layout_style_index_js__ = __webpack_require__(89);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Content = __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Content;
var Landing1 = /** @class */ (function (_super) {
    __extends(Landing1, _super);
    function Landing1(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, Landing1.prototype);
        return _this;
    }
    Landing1.prototype.onNext = function () {
        this.props.onNext();
    };
    Landing1.prototype.componentDidMount = function () {
        var _this = this;
        document.body.classList.add("pod-to-planet");
        setTimeout(function () {
            _this.onNext();
        }, 2750);
    };
    Landing1.prototype.componentWillUnmount = function () {
        document.body.classList.remove("pod-to-planet");
    };
    Landing1.prototype.render = function () {
        var code = this.props.currentPlanet.name.toLowerCase();
        var podClassName = "star-pod star-pod-" + code;
        var planetClassName = "planet planet-" + code;
        this.props.onChangeAudio("");
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, { style: { height: '100vh', overflow: 'hidden' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "star-pod", className: podClassName }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "planet", className: planetClassName }));
    };
    return Landing1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Landing1);


/***/ }),
/* 2694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_SVGComponent__ = __webpack_require__(531);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Content = __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Content;
var SmokeImagePath = __webpack_require__(2695);
var Landing2 = /** @class */ (function (_super) {
    __extends(Landing2, _super);
    function Landing2(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, Landing2.prototype);
        return _this;
    }
    Landing2.prototype.onNext = function () {
        this.props.onNext();
    };
    Landing2.prototype.componentDidMount = function () {
        var _this = this;
        document.body.classList.add("landing");
        setTimeout(function () {
            _this.onNext();
        }, 4000);
    };
    Landing2.prototype.componentWillUnmount = function () {
        document.body.classList.remove("landing");
    };
    Landing2.prototype.render = function () {
        var planetCode = this.props.currentPlanet.name.toLowerCase();
        var terrainClassName = "planet-terrain planet-terrain-" + planetCode;
        var podClassName = "star-pod star-pod-landing star-pod-" + planetCode + "-landing";
        var podClassLanded = "star-pod star-pod-landed star-pod-" + planetCode + "-landed";
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, { style: { height: '100vh', overflow: 'hidden' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pod-animated" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: podClassName }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: podClassLanded }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_SVGComponent__["a" /* default */], { path: SmokeImagePath, id: "smoke" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: terrainClassName }));
    };
    return Landing2;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Landing2);


/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/smoke.bb9f9069.svg";

/***/ }),
/* 2696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_SVGComponent__ = __webpack_require__(531);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Content = __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Content;
var SmokeImagePath = __webpack_require__(2697);
var Leaving1 = /** @class */ (function (_super) {
    __extends(Leaving1, _super);
    function Leaving1(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, Leaving1.prototype);
        return _this;
    }
    Leaving1.prototype.onNext = function () {
        this.props.onNext();
    };
    Leaving1.prototype.componentDidMount = function () {
        var _this = this;
        document.body.classList.add("take-off");
        setTimeout(function () {
            _this.onNext();
        }, 4000);
    };
    Leaving1.prototype.componentWillUnmount = function () {
        document.body.classList.remove("take-off");
    };
    Leaving1.prototype.render = function () {
        var planetCode = this.props.currentPlanet.name.toLowerCase();
        var terrainClassName = "planet-terrain planet-terrain-" + planetCode;
        var podClassName = "star-pod star-pod-landing star-pod-" + planetCode + "-landing";
        var podClassLanded = "star-pod star-pod-landed star-pod-" + planetCode + "-landed";
        this.props.onChangeAudio("");
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, { style: { height: '100vh', overflow: 'hidden' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pod-animated" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: podClassName }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: podClassLanded }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_components_common_SVGComponent__["a" /* default */], { path: SmokeImagePath, id: "smoke" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: terrainClassName }));
    };
    return Leaving1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Leaving1);


/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/smoke-takeoff.8ccbff0f.svg";

/***/ }),
/* 2698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_layout_style_index_js__ = __webpack_require__(89);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Content = __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Content;
var Leaving2 = /** @class */ (function (_super) {
    __extends(Leaving2, _super);
    function Leaving2(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, Leaving2.prototype);
        return _this;
    }
    Leaving2.prototype.onNext = function () {
        this.props.onNext();
    };
    Leaving2.prototype.componentDidMount = function () {
        var _this = this;
        document.body.classList.add("pod-to-station");
        setTimeout(function () {
            _this.onNext();
        }, 2500);
    };
    Leaving2.prototype.componentWillUnmount = function () {
        document.body.classList.remove("pod-to-station");
    };
    Leaving2.prototype.render = function () {
        var code = this.props.currentPlanet.name.toLowerCase();
        var planetClassName = "planet planet-" + code;
        var podClassName = "star-pod star-pod-" + code + "-flipped";
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, { style: { height: '100vh', overflow: 'hidden' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "star-pod", className: podClassName }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "planet", className: planetClassName }));
    };
    return Leaving2;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Leaving2);


/***/ }),
/* 2699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_layout__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_layout_style_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_api_UserApiController__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_constants_Checkpoints__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_providers_TelemetryService__ = __webpack_require__(148);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var Content = __WEBPACK_IMPORTED_MODULE_6_antd_es_layout__["a" /* default */].Content;
var StudentGame = /** @class */ (function (_super) {
    __extends(StudentGame, _super);
    function StudentGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, StudentGame.prototype);
        return _this;
    }
    StudentGame.prototype.componentDidMount = function () {
        var _a = this.props.currentGame, gameId = _a.id, gameName = _a.name;
        var _b = this.props.currentPlanet, planetId = _b.id, planetName = _b.name;
        __WEBPACK_IMPORTED_MODULE_13_src_providers_TelemetryService__["a" /* Track */].PlayGame(gameName, gameId, planetName, planetId);
    };
    StudentGame.prototype.skipGame = function () {
        var _a = this.props.currentGame, gameId = _a.id, gameName = _a.name;
        var _b = this.props.currentPlanet, planetId = _b.id, planetName = _b.name;
        __WEBPACK_IMPORTED_MODULE_13_src_providers_TelemetryService__["a" /* Track */].SkipGame(gameName, gameId, planetName, planetId);
        this.props.skipToCheckpoint(__WEBPACK_IMPORTED_MODULE_12_src_constants_Checkpoints__["a" /* Checkpoints */].Activity);
    };
    StudentGame.prototype.completeGame = function () {
        this.informBackend();
        var _a = this.props.currentGame, gameId = _a.id, gameName = _a.name;
        var _b = this.props.currentPlanet, planetId = _b.id, planetName = _b.name;
        __WEBPACK_IMPORTED_MODULE_13_src_providers_TelemetryService__["a" /* Track */].CompleteGame(gameName, gameId, planetName, planetId);
        this.props.onNext();
    };
    StudentGame.prototype.informBackend = function () {
        var updatedUserGameDTO = {
            gameId: this.props.currentGame.id
        };
        __WEBPACK_IMPORTED_MODULE_10_src_api_UserApiController__["a" /* default */].markGameCompleted(updatedUserGameDTO).then(function (result) {
            if (__WEBPACK_IMPORTED_MODULE_11_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
                console.warn("Marked Game as Completed in DB");
            }
        });
    };
    StudentGame.prototype.renderGame = function () {
        var _this = this;
        if (this.props.currentGame.component != null) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](this.props.currentGame.component, { onComplete: function () { return _this.completeGame(); } });
        }
        return null;
    };
    StudentGame.prototype.render = function () {
        var _this = this;
        this.props.onChangeAudio("");
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content, { className: "mission-game", style: { height: '100vh', overflow: 'hidden' } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { tabIndex: 0, type: "primary", className: "skip-game", onClick: function () { return _this.skipGame(); } }, "Skip Game"),
            this.renderGame());
    };
    return StudentGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StudentGame);


/***/ }),
/* 2700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var PlanetClose = /** @class */ (function (_super) {
    __extends(PlanetClose, _super);
    function PlanetClose(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, PlanetClose.prototype);
        _this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
        return _this;
    }
    PlanetClose.prototype.componentDidMount = function () {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    PlanetClose.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    PlanetClose.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    };
    PlanetClose.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    PlanetClose.prototype.hasNextButton = function () {
        return true;
    };
    PlanetClose.prototype.hasBackButton = function () {
        return this.state.translationStep > 0;
    };
    PlanetClose.prototype.onNext = function () {
        // Update the state step first
        var step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    };
    PlanetClose.prototype.onBack = function () {
        // Update the state step first (go backwards)
        var step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    };
    PlanetClose.prototype.deriveStateFromProps = function (newProps) {
        var translatedKey = "%game%.PlanetClosing"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        var translatedText = newProps.translate(translatedKey).toString();
        var translatedArray = (translatedText || "").split("|").map(function (x) { return x.trim(); });
        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
        });
    };
    PlanetClose.prototype.render = function () {
        var planetCode = (this.props.currentPlanet || { name: "" }).name.toLowerCase();
        var currentDialog = (this.state.translationArray || [""])[this.state.translationStep];
        var translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = translationKey + ".part" + (this.state.translationStep + 1);
        }
        var audioTrans = __WEBPACK_IMPORTED_MODULE_8_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, lg: 16, xl: 14 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, currentDialog))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pilot star-pilot-" + planetCode }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "star-pod star-pod-landed star-pod-" + planetCode + "-landed" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "planet-terrain planet-terrain-" + planetCode }));
    };
    return PlanetClose;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(PlanetClose));


/***/ }),
/* 2701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_utils_DebugUtil__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_common_VideoPlayer__ = __webpack_require__(2702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_constants_VideoTranslations__ = __webpack_require__(2709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_api_UserApiController__ = __webpack_require__(147);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












var StudentVideo = /** @class */ (function (_super) {
    __extends(StudentVideo, _super);
    function StudentVideo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, StudentVideo.prototype);
        _this.state = {
            hasFinished: __WEBPACK_IMPORTED_MODULE_8_src_utils_DebugUtil__["a" /* default */].isDebugEnabled(),
            hasWatched: false
        };
        return _this;
    }
    StudentVideo.prototype.componentDidMount = function () {
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    StudentVideo.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    StudentVideo.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    };
    StudentVideo.prototype.hasNextButton = function () {
        return this.state.hasFinished;
    };
    StudentVideo.prototype.hasBackButton = function () {
        return true;
    };
    StudentVideo.prototype.onNext = function () {
        this.props.onNext();
    };
    StudentVideo.prototype.onBack = function () {
        this.props.onBack();
    };
    StudentVideo.prototype.onEnd = function () {
        if (__WEBPACK_IMPORTED_MODULE_8_src_utils_DebugUtil__["a" /* default */].isDebugEnabled()) {
            console.warn("Finished!"); // JB - Remove this console.warn
        }
        // Mark the video as watched once
        if (!this.state.hasWatched) {
            __WEBPACK_IMPORTED_MODULE_11_src_api_UserApiController__["a" /* default */].markVideoWatched({ gradeId: this.props.User.gradeId, planetId: this.props.currentPlanet.id });
        }
        this.setState({
            hasFinished: true,
            hasWatched: true
        });
    };
    StudentVideo.prototype.render = function () {
        var planetCode = (this.props.currentPlanet || { name: "" }).name.toLowerCase();
        var terrainClassName = "planet-terrain planet-terrain-" + planetCode;
        var podClassName = "star-pod star-pod-landed star-pod-" + planetCode + "-landed";
        var pilotClassName = "star-pilot star-pilot-" + planetCode;
        var videoTranslation = __WEBPACK_IMPORTED_MODULE_10_src_constants_VideoTranslations__["a" /* default */].FindByGradePlanetAndLanguage(this.props.currentGrade, this.props.currentPlanet, this.props.activeLanguage.code);
        var subtitles = [];
        if (videoTranslation.subtitleUrl != null && videoTranslation.subtitleUrl.length > 0) {
            subtitles = [
                { src: videoTranslation.subtitleUrl, label: "English", srcLang: "en-US" }
            ];
        }
        this.props.onChangeAudio("");
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content video-wrapper", xs: { span: 22, push: 1 }, md: { span: 16 }, lg: 16, xl: 14 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_src_components_common_VideoPlayer__["a" /* default */], { key: "videoPlayerKey", src: videoTranslation.videoUrl, subtitles: subtitles, playing: true, controls: true, width: "100%", height: "100%", muted: !this.props.Config.audioEnabled, onEnded: this.onEnd }))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: pilotClassName }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: podClassName }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: terrainClassName }));
    };
    return StudentVideo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(StudentVideo));


/***/ }),
/* 2702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_player__ = __webpack_require__(2703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_player__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var VideoPlayer = /** @class */ (function (_super) {
    __extends(VideoPlayer, _super);
    function VideoPlayer(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, VideoPlayer.prototype);
        return _this;
    }
    VideoPlayer.prototype.onReady = function () {
        var videoElement = document.getElementById("react-player").getElementsByTagName("video")[0];
        if (videoElement != null) {
            videoElement.crossOrigin = "anonymous";
        }
        if (this.props.onReady != null) {
            this.props.onReady();
        }
        // Since FF cannot deal with the azure URLs, they must be turned into blobs
        // This works with chrome without issue and im sure will break the iPad for no reason other than that Safari devs just hate us
        this.props.subtitles.forEach(function (subtitle) {
            if (subtitle.src == null) {
                return;
            }
            fetch(subtitle.src)
                .then(function (response) { return response.text(); }) // Get the string of the response
                .then(function (text) {
                var blob = new Blob([text], { type: "text/vtt" });
                var blobUrl = URL.createObjectURL(blob);
                var track = document.createElement("track");
                track.kind = "subtitles";
                track.label = subtitle.label || subtitle.srcLang;
                track.srclang = subtitle.srcLang;
                track.src = blobUrl;
                videoElement.appendChild(track);
            });
        });
    };
    VideoPlayer.prototype.generateConfig = function () {
        if (this.props.subtitles == null || this.props.subtitles.length < 1) {
            return {};
        }
        return {
            file: {
                tracks: this.props.subtitles.map(function (x) {
                    return {
                        src: x.src,
                        kind: "subtitles",
                        srcLang: x.srcLang,
                        label: x.label || x.srcLang
                    };
                })
            }
        };
    };
    VideoPlayer.prototype.render = function () {
        var coolProps = __assign(__assign({}, this.props), { url: this.props.src });
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_player___default.a, __assign({}, coolProps, { onReady: this.onReady, id: "react-player" }));
    };
    return VideoPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (VideoPlayer);


/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePlayer = exports.Mixcloud = exports.DailyMotion = exports.Twitch = exports.Wistia = exports.Streamable = exports.Facebook = exports.Vimeo = exports.SoundCloud = exports.YouTube = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _YouTube = __webpack_require__(533);

Object.defineProperty(exports, 'YouTube', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_YouTube)['default'];
  }
});

var _SoundCloud = __webpack_require__(535);

Object.defineProperty(exports, 'SoundCloud', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SoundCloud)['default'];
  }
});

var _Vimeo = __webpack_require__(536);

Object.defineProperty(exports, 'Vimeo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Vimeo)['default'];
  }
});

var _Facebook = __webpack_require__(982);

Object.defineProperty(exports, 'Facebook', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Facebook)['default'];
  }
});

var _Streamable = __webpack_require__(983);

Object.defineProperty(exports, 'Streamable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Streamable)['default'];
  }
});

var _Wistia = __webpack_require__(984);

Object.defineProperty(exports, 'Wistia', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Wistia)['default'];
  }
});

var _Twitch = __webpack_require__(985);

Object.defineProperty(exports, 'Twitch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Twitch)['default'];
  }
});

var _DailyMotion = __webpack_require__(537);

Object.defineProperty(exports, 'DailyMotion', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DailyMotion)['default'];
  }
});

var _Mixcloud = __webpack_require__(986);

Object.defineProperty(exports, 'Mixcloud', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Mixcloud)['default'];
  }
});

var _FilePlayer = __webpack_require__(987);

Object.defineProperty(exports, 'FilePlayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FilePlayer)['default'];
  }
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(371);

var _utils = __webpack_require__(112);

var _players = __webpack_require__(2706);

var _players2 = _interopRequireDefault(_players);

var _Player4 = __webpack_require__(534);

var _Player5 = _interopRequireDefault(_Player4);

var _Preview = __webpack_require__(2707);

var _Preview2 = _interopRequireDefault(_Preview);

var _preload = __webpack_require__(2708);

var _preload2 = _interopRequireDefault(_preload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SUPPORTED_PROPS = Object.keys(_props2.propTypes);

var customPlayers = [];

var ReactPlayer = function (_Component) {
  _inherits(ReactPlayer, _Component);

  function ReactPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.state = {
      showPreview: !!_this.props.light
    }, _this.onClickPreview = function () {
      _this.setState({ showPreview: false });
    }, _this.getDuration = function () {
      if (!_this.player) return null;
      return _this.player.getDuration();
    }, _this.getCurrentTime = function () {
      if (!_this.player) return null;
      return _this.player.getCurrentTime();
    }, _this.getSecondsLoaded = function () {
      if (!_this.player) return null;
      return _this.player.getSecondsLoaded();
    }, _this.getInternalPlayer = function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';

      if (!_this.player) return null;
      return _this.player.getInternalPlayer(key);
    }, _this.seekTo = function (fraction, type) {
      if (!_this.player) return null;
      _this.player.seekTo(fraction, type);
    }, _this.onReady = function () {
      _this.props.onReady(_this);
    }, _this.wrapperRef = function (wrapper) {
      _this.wrapper = wrapper;
    }, _this.activePlayerRef = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.progressFrequency) {
        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _utils.isEqual)(this.props, nextProps) || !(0, _utils.isEqual)(this.state, nextState);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
      if (!this.props.light && nextProps.light) {
        this.setState({ showPreview: true });
      }
    }
  }, {
    key: 'getActivePlayer',
    value: function getActivePlayer(url) {
      var _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

      for (var _i = 0; _i < _arr.length; _i++) {
        var _Player = _arr[_i];
        if (_Player.canPlay(url)) {
          return _Player;
        }
      }
      // Fall back to FilePlayer if nothing else can play the URL
      return _FilePlayer.FilePlayer;
    }
  }, {
    key: 'renderActivePlayer',
    value: function renderActivePlayer(url, activePlayer) {
      if (!url) return null;
      return _react2['default'].createElement(_Player5['default'], _extends({}, this.props, {
        key: activePlayer.displayName,
        ref: this.activePlayerRef,
        config: this.config,
        activePlayer: activePlayer,
        onReady: this.onReady
      }));
    }
  }, {
    key: 'sortPlayers',
    value: function sortPlayers(a, b) {
      // Retain player order to prevent weird iframe behaviour when switching players
      if (a && b) {
        return a.key < b.key ? -1 : 1;
      }
      return 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          controls = _props.controls,
          style = _props.style,
          width = _props.width,
          height = _props.height,
          light = _props.light,
          Wrapper = _props.wrapper;

      var showPreview = this.state.showPreview && url;
      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
      var activePlayer = this.getActivePlayer(url);
      var renderedActivePlayer = this.renderActivePlayer(url, activePlayer);
      var preloadPlayers = (0, _preload2['default'])(url, controls, this.config);
      var players = [renderedActivePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);
      var preview = _react2['default'].createElement(_Preview2['default'], { url: url, light: light, onClick: this.onClickPreview });
      return _react2['default'].createElement(
        Wrapper,
        _extends({ ref: this.wrapperRef, style: _extends({}, style, { width: width, height: height }) }, otherProps),
        showPreview ? preview : players
      );
    }
  }]);

  return ReactPlayer;
}(_react.Component);

ReactPlayer.addCustomPlayer = function (player) {
  customPlayers.push(player);
};

ReactPlayer.removeCustomPlayers = function () {
  customPlayers = [];
};

ReactPlayer.displayName = 'ReactPlayer';
ReactPlayer.propTypes = _props2.propTypes;
ReactPlayer.defaultProps = _props2.defaultProps;

ReactPlayer.canPlay = function (url) {
  var _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var _Player2 = _arr2[_i2];
    if (_Player2.canPlay(url)) {
      return true;
    }
  }
  return false;
};

ReactPlayer.canEnablePIP = function (url) {
  var _arr3 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

  for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
    var _Player3 = _arr3[_i3];
    if (_Player3.canEnablePIP && _Player3.canEnablePIP(url)) {
      return true;
    }
  }
  return false;
};

exports['default'] = ReactPlayer;

/***/ }),
/* 2704 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.deepmerge = factory());
}(this, function () { 'use strict';

	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};

	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}

	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);

		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}

	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}

	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}

	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}

	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}

	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}

	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols
			? Object.getOwnPropertySymbols(target).filter(function(symbol) {
				return target.propertyIsEnumerable(symbol)
			})
			: []
	}

	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	}

	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			}
		});
		return destination
	}

	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;

		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}

	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}

		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};

	var deepmerge_1 = deepmerge;

	return deepmerge_1;

}));


/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _YouTube = __webpack_require__(533);

var _SoundCloud = __webpack_require__(535);

var _Vimeo = __webpack_require__(536);

var _Facebook = __webpack_require__(982);

var _Streamable = __webpack_require__(983);

var _Wistia = __webpack_require__(984);

var _Twitch = __webpack_require__(985);

var _DailyMotion = __webpack_require__(537);

var _Mixcloud = __webpack_require__(986);

var _FilePlayer = __webpack_require__(987);

exports['default'] = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICON_SIZE = '64px';

var Preview = function (_Component) {
  _inherits(Preview, _Component);

  function Preview() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Preview.__proto__ || Object.getPrototypeOf(Preview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      image: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Preview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchImage(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.url !== nextProps.url) {
        this.fetchImage(nextProps);
      }
    }
  }, {
    key: 'fetchImage',
    value: function fetchImage(_ref2) {
      var _this2 = this;

      var url = _ref2.url,
          light = _ref2.light;

      if (typeof light === 'string') {
        this.setState({ image: light });
        return;
      }
      this.setState({ image: null });
      return window.fetch('https://noembed.com/embed?url=' + url).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.thumbnail_url) {
          var image = data.thumbnail_url.replace('height=100', 'height=480');
          _this2.setState({ image: image });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var onClick = this.props.onClick;
      var image = this.state.image;

      var flexCenter = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
      var styles = {
        preview: _extends({
          width: '100%',
          height: '100%',
          backgroundImage: image ? 'url(' + image + ')' : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer'
        }, flexCenter),
        shadow: _extends({
          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
          borderRadius: ICON_SIZE,
          width: ICON_SIZE,
          height: ICON_SIZE
        }, flexCenter),
        playIcon: {
          borderStyle: 'solid',
          borderWidth: '16px 0 16px 26px',
          borderColor: 'transparent transparent transparent white',
          marginLeft: '7px'
        }
      };
      return _react2['default'].createElement(
        'div',
        { style: styles.preview, className: 'react-player__preview', onClick: onClick },
        _react2['default'].createElement(
          'div',
          { style: styles.shadow, className: 'react-player__shadow' },
          _react2['default'].createElement('div', { style: styles.playIcon, className: 'react-player__play-icon' })
        )
      );
    }
  }]);

  return Preview;
}(_react.Component);

exports['default'] = Preview;

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = renderPreloadPlayers;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Player = __webpack_require__(534);

var _Player2 = _interopRequireDefault(_Player);

var _YouTube = __webpack_require__(533);

var _SoundCloud = __webpack_require__(535);

var _Vimeo = __webpack_require__(536);

var _DailyMotion = __webpack_require__(537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PRELOAD_PLAYERS = [{
  Player: _YouTube.YouTube,
  configKey: 'youtube',
  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
}, {
  Player: _SoundCloud.SoundCloud,
  configKey: 'soundcloud',
  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
}, {
  Player: _Vimeo.Vimeo,
  configKey: 'vimeo',
  url: 'https://vimeo.com/300970506'
}, {
  Player: _DailyMotion.DailyMotion,
  configKey: 'dailymotion',
  url: 'http://www.dailymotion.com/video/xqdpyk'
}];

function renderPreloadPlayers(url, controls, config) {
  var players = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = PRELOAD_PLAYERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var player = _step.value;

      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
        players.push(_react2['default'].createElement(_Player2['default'], {
          key: player.Player.displayName,
          activePlayer: player.Player,
          url: player.url,
          controls: controls,
          playing: true,
          muted: true,
          style: { display: 'none' }
        }));
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return players;
}

/***/ }),
/* 2709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Config__ = __webpack_require__(285);


var VideoTranslations = /** @class */ (function () {
    function VideoTranslations() {
    }
    VideoTranslations.FindByGradePlanetAndLanguage = function (grade, planet, languageCode) {
        var languageCodeEnhanced = languageCode.toLowerCase();
        var key = "" + (grade || { shortName: "" }).shortName + (planet || { name: "" }).name;
        var videoUrl = __WEBPACK_IMPORTED_MODULE_1_src_constants_Config__["a" /* default */].GetAzureUrl(key, "video", languageCodeEnhanced);
        var subtitleUrl = __WEBPACK_IMPORTED_MODULE_1_src_constants_Config__["a" /* default */].GetAzureUrl(key, "subtitle", languageCodeEnhanced);
        return {
            key: key.length < 1 ? "" : key,
            language: __WEBPACK_IMPORTED_MODULE_0_src_constants_Languages__["a" /* default */].FindByCode(languageCodeEnhanced),
            videoUrl: key.length < 1 ? "" : videoUrl,
            subtitleUrl: key.length < 1 ? "" : subtitleUrl,
        };
    };
    return VideoTranslations;
}());
/* harmony default export */ __webpack_exports__["a"] = (VideoTranslations);


/***/ }),
/* 2710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_mission_InfoBox__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_constants_Grades__ = __webpack_require__(78);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var MissionLog = /** @class */ (function (_super) {
    __extends(MissionLog, _super);
    function MissionLog(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, MissionLog.prototype);
        return _this;
    }
    MissionLog.prototype.onNextClick = function () {
        this.props.onNext();
    };
    MissionLog.prototype.renderCurrentBadges = function () {
        var planetImages = __WEBPACK_IMPORTED_MODULE_12_src_constants_Planets__["a" /* Planets */].GetPlanetListByPlanetId(this.props.Mission.current.planetId).map(function (planet) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "badge", alt: "Planet Badge", src: planet.badgePath, key: "badge" + planet.id })); });
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, planetImages);
    };
    /**
     * Visible for grades 4+
     */
    MissionLog.prototype.renderTrainingAndEducationGuideButton = function () {
        if (this.props.currentGrade.level >= __WEBPACK_IMPORTED_MODULE_14_src_constants_Grades__["a" /* Grades */].Fourth.level) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].TRAINING_AND_EDUCATION_GUIDE, this.props.Mission.current.planetId) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { tabIndex: 1, size: "small" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "common.trainingAndEducation" })));
        }
    };
    /**
     * Visible for grades 3+
     */
    MissionLog.prototype.renderOccupationDb = function () {
        if (this.props.currentGrade.level >= __WEBPACK_IMPORTED_MODULE_14_src_constants_Grades__["a" /* Grades */].Third.level) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].OCCUPATIONDB },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { tabIndex: 1, size: "small" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "public.occupationdb.title" }))));
        }
    };
    /**
    * Visible for grades 3+
    */
    MissionLog.prototype.renderHollandGuideButton = function () {
        if (this.props.currentGrade.level >= __WEBPACK_IMPORTED_MODULE_14_src_constants_Grades__["a" /* Grades */].Third.level) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].getRoute(__WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].HOLLAND_AREAS_GUIDE, this.props.Mission.current.planetId) },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { tabIndex: 1, size: "small" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "common.hollandAreas" })));
        }
    };
    MissionLog.prototype.render = function () {
        this.props.onChangeAudio("");
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { className: "mission-log" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, xl: 14 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.missionLog.header1" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.missionLog.body1" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 12, xl: 14, xxl: 16 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.missionLog.header2" })),
                            this.renderCurrentBadges(),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { autoFocus: true, tabIndex: 1, type: "primary", size: "large", onClick: this.onNextClick },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "student.missionLog.nextMission" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 12, xl: 10, xxl: 8 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "common.menu" })),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "resource-buttons" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["Link"], { tabIndex: -1, to: __WEBPACK_IMPORTED_MODULE_3_src_core_Routes__["a" /* default */].STATEMENTS },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_es_button__["a" /* default */], { tabIndex: 1, size: "small" },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: "admin.sideNav.iStatementsText" }))),
                                this.renderOccupationDb(),
                                this.renderHollandGuideButton(),
                                this.renderTrainingAndEducationGuideButton()))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 24, md: { span: 7, push: 1 }, xl: 9 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: { span: 23, push: 1 }, lg: { span: 20, push: 4 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_src_components_mission_InfoBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: { span: 20, push: 2 }, lg: { span: 21, push: 1 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "station-commander", alt: "Commander " + this.props.currentGrade.commander, src: this.props.currentGrade.commanderPath, height: "100%", width: "100%" })))));
    };
    return MissionLog;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (MissionLog);


/***/ }),
/* 2711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_button__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_es_button_style_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_mission_InfoBox__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_constants_AudioTranslations__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













var SpaceStationCeremony = /** @class */ (function (_super) {
    __extends(SpaceStationCeremony, _super);
    function SpaceStationCeremony(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_2_src_utils_BindThisHelper__["a" /* default */])(_this, SpaceStationCeremony.prototype);
        return _this;
    }
    SpaceStationCeremony.prototype.hasNextButton = function () {
        return true;
    };
    SpaceStationCeremony.prototype.hasBackButton = function () {
        return false;
    };
    SpaceStationCeremony.prototype.onNext = function () {
        this.props.onNext();
    };
    SpaceStationCeremony.prototype.onBack = function () {
        this.props.onBack();
    };
    SpaceStationCeremony.prototype.renderCompletionBadge = function () {
        //let grade = Grades.FindById(this.props.User.gradeId);
        var rewardsPath = __WEBPACK_IMPORTED_MODULE_11_src_constants_Grades__["a" /* Grades */].GetCeremonyRewardsPath(this.props.User.gradeId);
        //return <img className="galaxy-award" alt="Grade Award" src={grade.rewardsPath} key={`award${grade.id}`} />;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "galaxy-award", alt: "Grade Award", src: rewardsPath });
    };
    SpaceStationCeremony.prototype.render = function () {
        // Note: title is combined with body in audio file because it is so much easier this way
        var translationKey = "student.galaxyCeremony.grade%gradeNumber%"
            .replace("%gradeNumber%", this.props.currentGrade.shortName);
        var headerKey = "student.galaxyCeremony.title";
        var bodyKey = translationKey + ".body";
        var audioTrans = __WEBPACK_IMPORTED_MODULE_12_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage(bodyKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { className: "galaxy-ceremony" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, xl: 14 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_src_components_mission_DialogBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onBack: this.onBack, onNext: this.onNext },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", { className: "galaxy-ceremony-header" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: headerKey })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "galaxy-ceremony-body" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* Translate */], { id: bodyKey })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "galaxy-ceremony-container" }, this.renderCompletionBadge())))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: 23, md: { span: 7, push: 1 }, xl: 9 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 23, push: 1 }, lg: { span: 20, push: 4 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_src_components_mission_InfoBox__["a" /* default */], { currentGrade: this.props.currentGrade, currentPlanet: this.props.currentPlanet }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd_es_col__["a" /* default */], { xs: { span: 20, push: 2 }, lg: { span: 21, push: 1 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "station-commander", alt: "Commander " + this.props.currentGrade.commander, src: this.props.currentGrade.commanderPath, height: "100%", width: "100%" })))));
    };
    return SpaceStationCeremony;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["d" /* withLocalize */])(SpaceStationCeremony));


/***/ }),
/* 2712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_constants_SceneManager__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_redux_CheckpointActions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_constants_Games__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_common_AudioPlayer__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_pages_student_StudentPages_less__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_pages_student_StudentPages_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_src_pages_student_StudentPages_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_providers_TelemetryService__ = __webpack_require__(148);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var SpaceStationHome = /** @class */ (function (_super) {
    __extends(SpaceStationHome, _super);
    function SpaceStationHome(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, SpaceStationHome.prototype);
        _this.state = {
            audioUrl: ""
        };
        return _this;
    }
    SpaceStationHome.prototype.onNextClick = function () {
        // Increment the step and re-render!
        var _a = this.props.Mission.current, checkpointId = _a.checkpointId, stepId = _a.stepId, planetId = _a.planetId; // #TypescriptMagic
        var nextStep = __WEBPACK_IMPORTED_MODULE_5_src_constants_SceneManager__["a" /* default */].GetNextStep(checkpointId, stepId, planetId);
        var newMissionStatus = {
            planetId: nextStep.planetId,
            checkpointId: nextStep.checkpointId,
            stepId: nextStep.stepId,
            currentDirection: "forwards",
        };
        this.props.updateMissionStatus(newMissionStatus);
        return;
    };
    SpaceStationHome.prototype.skipToCheckpoint = function (checkpoint) {
        this.props.updateMissionStatus({
            planetId: this.props.Mission.current.planetId,
            checkpointId: checkpoint.id,
            stepId: 1,
            currentDirection: "forwards",
        });
    };
    SpaceStationHome.prototype.onBackClick = function () {
        // Increment the step and re-render!
        var _a = this.props.Mission.current, checkpointId = _a.checkpointId, stepId = _a.stepId, planetId = _a.planetId; // #TypescriptMagic
        var nextStep = __WEBPACK_IMPORTED_MODULE_5_src_constants_SceneManager__["a" /* default */].GetPreviousStep(checkpointId, stepId, planetId);
        var newMissionStatus = {
            planetId: nextStep.planetId,
            checkpointId: nextStep.checkpointId,
            stepId: nextStep.stepId,
            currentDirection: "backwards",
        };
        this.props.updateMissionStatus(newMissionStatus);
        return;
    };
    SpaceStationHome.prototype.onChangeAudio = function (audioUrl) {
        if (audioUrl !== this.state.audioUrl) {
            this.setState({ audioUrl: audioUrl });
        }
    };
    SpaceStationHome.prototype.componentDidMount = function () {
        var _a = this.props.Mission.current, checkpointId = _a.checkpointId, stepId = _a.stepId;
        var checkpoint = __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(checkpointId);
        __WEBPACK_IMPORTED_MODULE_13_src_providers_TelemetryService__["a" /* Track */].SpaceStation(checkpoint.name, checkpointId, stepId);
    };
    SpaceStationHome.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props.Mission.current, currentCheckpointId = _a.checkpointId, currentStepId = _a.stepId;
        var _b = prevProps.Mission.current, prevCheckpointId = _b.checkpointId, prevStepId = _b.stepId;
        if (prevCheckpointId !== currentCheckpointId || prevStepId !== currentStepId) {
            var currentCheckpoint = __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(currentCheckpointId);
            __WEBPACK_IMPORTED_MODULE_13_src_providers_TelemetryService__["a" /* Track */].SpaceStation(currentCheckpoint.name, currentCheckpoint.id, currentStepId);
        }
    };
    SpaceStationHome.prototype.render = function () {
        var currentGrade = __WEBPACK_IMPORTED_MODULE_8_src_constants_Grades__["a" /* Grades */].FindById(this.props.User.gradeId);
        var currentPlanet = __WEBPACK_IMPORTED_MODULE_9_src_constants_Planets__["a" /* Planets */].FindById(this.props.Mission.current.planetId);
        var currentGame = __WEBPACK_IMPORTED_MODULE_10_src_constants_Games__["a" /* Games */].FindByGradeAndPlanet(currentGrade.id, currentPlanet.id);
        var checkpoint = __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__["a" /* Checkpoints */].FindById(this.props.Mission.current.checkpointId);
        var level = __WEBPACK_IMPORTED_MODULE_5_src_constants_SceneManager__["a" /* default */].FindByIds(this.props.Mission.current.checkpointId, this.props.Mission.current.stepId);
        if (!this.props.Mission.isReplayModeActive && this.props.Config.previousLocation != null) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].LOGIN });
        }
        if (this.props.Mission.state === "fresh") {
            // User has logged in recently and needs to be welcomed back
            if (this.props.Mission.current.checkpointId > __WEBPACK_IMPORTED_MODULE_7_src_constants_Checkpoints__["a" /* Checkpoints */].Onboarding.id) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].STUDENT_RETURN });
            }
            else {
                this.props.updateFreshness("not-fresh");
            }
        }
        if (checkpoint.type === "Planet") {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: __WEBPACK_IMPORTED_MODULE_4_src_core_Routes__["a" /* default */].STUDENT_PLANET });
        }
        else if (checkpoint.type === "SpaceStation") {
            if (level == null || level.component == null) {
                // Catches errors with the sceneManager. Move on to next area essentially
                if (this.props.Mission.state !== "none") {
                    this.onNextClick();
                }
                return null;
            }
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_src_components_common_AudioPlayer__["a" /* default */], { audioURL: this.state.audioUrl, isPlaying: true }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](level.component, { onNext: this.onNextClick, onBack: this.onBackClick, currentDirection: this.props.Mission.currentDirection, currentGrade: currentGrade, currentPlanet: currentPlanet, currentGame: currentGame, Mission: this.props.Mission, User: this.props.User, Config: this.props.Config, onChangeAudio: this.onChangeAudio, skipToCheckpoint: this.skipToCheckpoint }));
        }
        return null;
    };
    return SpaceStationHome;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return {
        updateMissionStatus: function (request) { return __WEBPACK_IMPORTED_MODULE_6_src_redux_CheckpointActions__["a" /* default */].UpdateCurrentUserStatus(dispatch, request); },
        updateFreshness: function (request) { return __WEBPACK_IMPORTED_MODULE_6_src_redux_CheckpointActions__["a" /* default */].SetFreshnessStatus(dispatch, request); }
    };
}
function mapStateToProps(state) {
    return {
        Mission: state.Mission,
        User: state.User,
        Config: state.Config,
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(SpaceStationHome));


/***/ }),
/* 2713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserDemo_Main__ = __webpack_require__(2714);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var PhaserGameDemo = /** @class */ (function (_super) {
    __extends(PhaserGameDemo, _super);
    function PhaserGameDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserGameDemo.prototype);
        return _this;
    }
    PhaserGameDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserDemo_Main__["a" /* default */], null)));
    };
    return PhaserGameDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserGameDemo);


/***/ }),
/* 2714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_gameScene__ = __webpack_require__(989);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var phaserConfig = {
    title: "Phaser Demo",
    url: "https://github.com/digitsensitive/phaser3-typescript",
    version: "1.1",
    width: 768,
    height: 576,
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 200 }
        }
    },
    backgroundColor: "#3A99D9",
    "render.pixelArt": true // 'Anti-Aliasing' when off
};
var templateConfig = {
    title: "Title goes here!",
    version: "0.0.1-superAlpha",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 999 }
        }
    },
    backgroundColor: "#000000"
};
var PhaserDemo = /** @class */ (function (_super) {
    __extends(PhaserDemo, _super);
    function PhaserDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserDemo.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    PhaserDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_gameScene__["a" /* GameScene */], config: phaserConfig })));
    };
    return PhaserDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserDemo);


/***/ }),
/* 2715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Coin; });
/**
 * @author       Digitsensitive <digit.sensitivee@gmail.com>
 * @copyright    2018 Digitsensitive
 * @description  Coin Runner: Coin
 * @license      Digitsensitive
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Coin = /** @class */ (function (_super) {
    __extends(Coin, _super);
    function Coin(params) {
        var _this = _super.call(this, params.scene, params.x, params.y, params.key) || this;
        _this.moveToBottom = true;
        _this.setFieldSide();
        _this.initImage();
        _this.initEvents(params);
        params.scene.add.existing(_this);
        return _this;
    }
    Coin.prototype.initImage = function () {
        this.setScale(0.8);
        this.setSize(56, 56);
        this.setAlpha(1);
        this.setOrigin(0, 0);
    };
    Coin.prototype.initEvents = function (params) {
        this.changePositionTimer = params.scene.time.addEvent({
            delay: 2000,
            callback: this.changePosition,
            callbackScope: this,
            loop: true
        });
    };
    Coin.prototype.update = function () { };
    Coin.prototype.changePosition = function () {
        this.setNewPosition();
        this.setFieldSide();
        this.changePositionTimer.reset({
            delay: 2000,
            callback: this.changePosition,
            callbackScope: this,
            loop: true
        });
    };
    Coin.prototype.setNewPosition = function () {
        if (this.lastPosition === "right") {
            this.x = Phaser.Math.RND.integerInRange(100, 384);
        }
        else {
            this.x = Phaser.Math.RND.integerInRange(385, 700);
        }
        this.y = Phaser.Math.RND.integerInRange(100, 500);
    };
    Coin.prototype.setFieldSide = function () {
        if (this.x <= 384) {
            this.lastPosition = "left";
        }
        else {
            this.lastPosition = "right";
        }
    };
    return Coin;
}(Phaser.GameObjects.Image));



/***/ }),
/* 2716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Player; });
/**
 * @author       Digitsensitive <digit.sensitivee@gmail.com>
 * @copyright    2018 Digitsensitive
 * @description  Coin Runner: Player
 * @license      Digitsensitive
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Player = /** @class */ (function (_super) {
    __extends(Player, _super);
    function Player(params) {
        var _this = _super.call(this, params.scene, params.x, params.y, params.key) || this;
        _this.walkingSpeed = 5;
        _this.initImage();
        _this.initInput(params);
        params.scene.add.existing(_this);
        return _this;
    }
    Player.prototype.initImage = function () {
        this.setDisplaySize(40, 50);
        this.setOrigin(0.5, 0.5);
    };
    Player.prototype.initInput = function (params) {
        // this.cursors = (params.scene as Phaser.Scene).input.keyboard.createCursorKeys();
        this.cursors = params.keyboard;
    };
    Player.prototype.update = function () {
        this.handleInput();
    };
    Player.prototype.handleInput = function () {
        if (this.cursors == null) {
            return;
        }
        if (this.cursors.right.isDown) {
            this.x += this.walkingSpeed;
            this.setFlipX(false);
        }
        if (this.cursors.left.isDown) {
            this.x -= this.walkingSpeed;
            this.setFlipX(true);
        }
        if (this.cursors.up.isDown) {
            this.y -= this.walkingSpeed;
        }
        if (this.cursors.down.isDown) {
            this.y += this.walkingSpeed;
        }
    };
    return Player;
}(Phaser.GameObjects.Image));



/***/ }),
/* 2717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserDragDropDemo_Main__ = __webpack_require__(2718);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var DragDropDemo = /** @class */ (function (_super) {
    __extends(DragDropDemo, _super);
    function DragDropDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, DragDropDemo.prototype);
        return _this;
    }
    DragDropDemo.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserDragDropDemo_Main__["a" /* default */], null));
    };
    return DragDropDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DragDropDemo);


/***/ }),
/* 2718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__ = __webpack_require__(2719);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Drag Drop Demo - Phaser",
    version: "4.2-demo",
    width: 768,
    height: 576,
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 200 }
        }
    },
    backgroundColor: "#3A99D9"
};
var DragDropDemo = /** @class */ (function (_super) {
    __extends(DragDropDemo, _super);
    function DragDropDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, DragDropDemo.prototype);
        return _this;
    }
    DragDropDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__["a" /* MainScene */], config: gameConfig })));
    };
    return DragDropDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DragDropDemo);


/***/ }),
/* 2719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objects_ClickyItem__ = __webpack_require__(2720);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.coins = [];
        return _this;
    }
    MainScene.prototype.preload = function () {
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image("background", __webpack_require__(372));
        this.load.image("player", __webpack_require__(192));
        this.load.image("coin", __webpack_require__(373));
    };
    MainScene.prototype.create = function () {
        // create background
        this.background = this.add.image(0, 0, "background");
        this.background.setOrigin(0, 0);
        // create objects
        var gameWidth = this.textures.game.config.width;
        var gameHeight = this.textures.game.config.height;
        for (var row = 0; row < 5; row++) {
            for (var col = 0; col < 5; col++) {
                var coin_1 = new __WEBPACK_IMPORTED_MODULE_0__objects_ClickyItem__["a" /* ClickyItem */]({
                    scene: this,
                    textureKey: "coin",
                    // x: row * 50,
                    // y: col * 50
                    x: (Math.random() * (gameWidth - 100)) + 50,
                    y: (Math.random() * (gameHeight - 100)) + 50
                });
                this.coins.push(coin_1);
                this.add.existing(coin_1);
            }
        }
        // DEBUG INFO
        var coin = this.coins[0];
        console.warn("Coin Info", coin); // JB - Remove this console.warn
        console.warn("Game Size", this.textures.game.config); // JB - Remove this console.warn
        // END DEBUG
        // Input dragables
        // This will fire anytime something that is draggable is dragged
        this.input.on('dragstart', function (pointer, gameObject) {
            // gameObject.setTint(0xff0000);
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });
        this.input.on('dragend', function (pointer, gameObject) {
            // gameObject.clearTint();
        });
    };
    MainScene.prototype.setupTouch = function () {
    };
    MainScene.prototype.update = function () {
        // Update on screen objects
        // this.item.update();
    };
    MainScene.prototype.gameover = function () {
        this.scene.start("MainScene");
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickyItem; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ClickyItem = /** @class */ (function (_super) {
    __extends(ClickyItem, _super);
    function ClickyItem(params) {
        var _this = _super.call(this, params.scene, params.x, params.y, params.textureKey) || this;
        // Hang onto scene
        _this.scene = params.scene;
        _this.initImage();
        _this.initDraggable();
        return _this;
    }
    ClickyItem.prototype.initImage = function () {
        this.setScale(0.8);
        this.setSize(56, 56);
        this.setAlpha(1);
        this.setOrigin(0, 0);
        this.setInteractive();
    };
    ClickyItem.prototype.update = function () { };
    ClickyItem.prototype.initDraggable = function () {
        var _this = this;
        this.on('pointerover', function (a) {
            _this.setAlpha(0.5);
        });
        this.on('pointerout', function () {
            _this.clearAlpha();
        });
        this.scene.input.setDraggable(this);
    };
    return ClickyItem;
}(Phaser.GameObjects.Sprite));



/***/ }),
/* 2721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserComplexPaintDemo_Main__ = __webpack_require__(2722);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ComplexPaintDemo = /** @class */ (function (_super) {
    __extends(ComplexPaintDemo, _super);
    function ComplexPaintDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ComplexPaintDemo.prototype);
        return _this;
    }
    ComplexPaintDemo.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserComplexPaintDemo_Main__["a" /* default */], null));
    };
    return ComplexPaintDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ComplexPaintDemo);


/***/ }),
/* 2722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__ = __webpack_require__(2723);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Complex Paint Demo - Phaser",
    width: 800,
    height: 600,
    version: "0.2-demo",
    backgroundColor: "#000000"
};
var PhaserComplexPaintDemo = /** @class */ (function (_super) {
    __extends(PhaserComplexPaintDemo, _super);
    function PhaserComplexPaintDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserComplexPaintDemo.prototype);
        return _this;
    }
    PhaserComplexPaintDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__["a" /* MainScene */], config: gameConfig })));
    };
    return PhaserComplexPaintDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserComplexPaintDemo);


/***/ }),
/* 2723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var PaintBrush = /** @class */ (function () {
    function PaintBrush() {
        this.thickness = 20;
        this.color = 0xFFFF00;
        this.alpha = 1;
    }
    return PaintBrush;
}());
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.coins = [];
        _this.paintBrush = new PaintBrush();
        return _this;
    }
    MainScene.prototype.preload = function () {
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image("background", __webpack_require__(372));
        this.load.image("control-background", __webpack_require__(990));
        this.load.image("pixel", __webpack_require__(60));
    };
    MainScene.prototype.create = function () {
        // Generate Easel
        // Generate Control area
        // Generate Controls
        // Wire up events, include the 'options'
        var _this = this;
        // START!!!
        // var gameWidth = (this.textures.game.config as GameConfig).width as number;
        // var gameHeight = (this.textures.game.config as GameConfig).height as number;
        var easelArea = { width: 600, height: 600 };
        var controlArea = { width: 200, height: 600 };
        // Generate Easel
        this.easel = this.add.image(0, 0, "background");
        this.easel.setOrigin(0, 0);
        this.easel.setScale(easelArea.width / this.easel.width, easelArea.height / this.easel.height);
        this.easel.setSize(easelArea.width, easelArea.height);
        this.easel.depth = -1;
        // Generate Control area
        this.easelControls = this.add.image(easelArea.width, 0, "control-background");
        this.easelControls.setOrigin(0, 0);
        this.easelControls.setScale(controlArea.width / this.easelControls.width, controlArea.height / this.easelControls.height);
        this.easelControls.setSize(controlArea.width, controlArea.height);
        this.easelControls.depth = 1;
        // Generate Controls
        // this.add.image(100, 400, 'atlas', 'supercars-parsec');
        // Auto generate based on colors
        var colors = [0xffff00, 0xf46842, 0x77f441, 0x419df4];
        var buttonSize = { height: 75, width: 75 };
        var yCoord = 200;
        var _loop_1 = function (color) {
            button = this_1.add.image(this_1.easelControls.x, yCoord, "pixel");
            button.setOrigin(0);
            button.setDepth(1);
            button.setInteractive();
            button.setTint(color);
            button.setDisplaySize(buttonSize.width, buttonSize.height);
            button.on("pointerdown", function () {
                var _color = color;
                _this.paintBrush.color = _color;
                graphics.lineStyle(_this.paintBrush.thickness, _this.paintBrush.color, _this.paintBrush.alpha);
                graphics.fillStyle(_this.paintBrush.color, _this.paintBrush.alpha);
            });
            yCoord += 75;
        };
        var this_1 = this, button;
        for (var _i = 0, colors_1 = colors; _i < colors_1.length; _i++) {
            var color = colors_1[_i];
            _loop_1(color);
        }
        // Generate Paint Layer
        var graphics = this.add.graphics();
        graphics.setPosition(0, 0);
        var previousLocation = { x: 0, y: 0 };
        graphics.lineStyle(this.paintBrush.thickness, this.paintBrush.color, this.paintBrush.alpha);
        graphics.fillStyle(this.paintBrush.color, this.paintBrush.alpha);
        // Paint Events
        var draw = false;
        this.input.on('pointerdown', function (pointer) {
            // Figure out if we are in the easel before we start drawing
            previousLocation = { x: pointer.x, y: pointer.y };
            graphics.fillCircleShape(new Phaser.Geom.Circle(pointer.x, pointer.y, 2));
            // graphics.strokeLineShape(new Phaser.Geom.Line(previousLocation.x, previousLocation.y, pointer.x, pointer.y));
            draw = true;
        });
        this.input.on('pointerup', function () {
            draw = false;
        });
        this.input.on('pointermove', function (pointer) {
            if (draw) {
                graphics.strokeLineShape(new Phaser.Geom.Line(previousLocation.x, previousLocation.y, pointer.x, pointer.y));
                previousLocation = { x: pointer.x, y: pointer.y };
            }
        });
        // graphics.clear();
        // generate a line from the previous location?
        // var t = new Phaser.Geom.Line(pointer.downX, pointer.downY, pointer.x, pointer.y);
        // graphics.strokeRect(previousLocation.x, previousLocation.y, pointer.x - pointer.downX, pointer.y - pointer.downY);
    };
    MainScene.prototype.update = function () {
        // Update on screen objects
        // this.item.update();
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserPlatformerDemo_Main__ = __webpack_require__(2725);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var PlatformerDemo = /** @class */ (function (_super) {
    __extends(PlatformerDemo, _super);
    function PlatformerDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PlatformerDemo.prototype);
        return _this;
    }
    PlatformerDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserPlatformerDemo_Main__["a" /* default */], null)));
    };
    return PlatformerDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PlatformerDemo);


/***/ }),
/* 2725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__ = __webpack_require__(2726);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Platformer Demo - Phaser",
    version: "0.2-demo",
    width: 800,
    height: 600,
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 600 }
        }
    },
    backgroundColor: "#000000"
};
var PhaserPlatformerDemo = /** @class */ (function (_super) {
    __extends(PhaserPlatformerDemo, _super);
    function PhaserPlatformerDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserPlatformerDemo.prototype);
        return _this;
    }
    PhaserPlatformerDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__["a" /* MainScene */], config: gameConfig })));
    };
    return PhaserPlatformerDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserPlatformerDemo);


/***/ }),
/* 2726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.showDebug = false;
        _this.coinsCollected = 0;
        _this.doubleJump = true;
        _this.frameCount = 0;
        _this.spriteTiles = [];
        return _this;
    }
    MainScene.prototype.preload = function () {
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image('ground_1x1', __webpack_require__(991));
        this.load.tilemapTiledJSON('map', __webpack_require__(992));
        this.load.spritesheet('coin', __webpack_require__(993), { frameWidth: 32, frameHeight: 32 });
        this.load.image('player', __webpack_require__(2727));
        this.load.image("jump-button", __webpack_require__(192));
    };
    MainScene.prototype.create = function () {
        var _this = this;
        this.map = this.make.tilemap({ key: 'map' });
        var groundTiles = this.map.addTilesetImage('ground_1x1');
        var coinTiles = this.map.addTilesetImage('coin');
        this.map.createDynamicLayer('Background Layer', groundTiles, 0, 0);
        this.groundLayer = this.map.createDynamicLayer('Ground Layer', groundTiles, 0, 0);
        this.coinLayer = this.map.createDynamicLayer('Coin Layer', coinTiles, 0, 0);
        // Tiles with IDs 1-25 will cause collision
        this.groundLayer.setCollisionBetween(1, 25);
        // Allow collision from the bottom only on tile 17. Platforms anyone?
        this.groundLayer.layer.data.forEach(function (row) {
            row.forEach(function (tile) {
                if (tile.index === 17) {
                    tile.setCollision(false, false, true, false);
                }
            });
        });
        // The IDs are generated from the tilemap
        // This will set Tile ID 26-30 (the coin tile) to call the function "hitCoin" when collided with
        this.coinLayer.setTileIndexCallback([26, 27, 28, 29, 30], this.hitCoin, this);
        this.coinLayer.layer.data.forEach(function (row) {
            row.forEach(function (tile) {
                if (tile.index === 26) {
                    _this.spriteTiles.push(tile);
                }
            });
        });
        // This will set the map location (2, 0) to call the function "hitSecretDoor" Un-comment this to
        // be jump through the ceiling above where the player spawns. You can use this to create a
        // secret area.
        this.groundLayer.setTileLocationCallback(2, 0, 1, 1, this.hitSecretDoor, this);
        this.player = this.physics.add.sprite(80, 70, 'player');
        this.player.setBounceY(0.1);
        // We want the player to physically collide with the ground, but the coin layer should only
        // trigger an overlap so that collection a coin doesn't kill player movement.
        this.physics.add.collider(this.player, this.groundLayer);
        this.physics.add.overlap(this.player, this.coinLayer);
        // Setup the camera
        this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);
        this.cameras.main.startFollow(this.player);
        this.debugGraphics = this.add.graphics();
        this.input.keyboard.on('keydown_C', function (event) {
            _this.showDebug = !_this.showDebug;
            _this.drawDebug();
        });
        this.input.keyboard.on('keydown_SPACE', function () {
            _this.attemptJump();
        });
        this.input.keyboard.on('keydown_UP', function () {
            _this.attemptJump();
        });
        this.cursors = this.input.keyboard.createCursorKeys();
        // STUFF
        // Lets do a button on click thingy
        var jumpButton = this.add.sprite(10, this.textures.game.config.height - 70, "jump-button");
        jumpButton.setOrigin(0);
        jumpButton.setInteractive();
        jumpButton.setDisplaySize(64, 64);
        jumpButton.setScrollFactor(0); // Stops this item from scrolling with the background via the camera
        jumpButton.setAlpha(.33);
        jumpButton.on("pointerdown", function () {
            _this.attemptJump();
            _this.player.emit("funtimes", _this.player.x, _this.player.y);
        });
        this.player.setDragX(10);
        this.player.setBounceX(0);
        // END STUFF
        // ADD NPC
        var blockConst = this.map.tileWidth;
        var npc = this.add.sprite(1 * blockConst, 9 * blockConst, "jump-button");
        npc.setOrigin(0);
        npc.setInteractive();
        npc.setDisplaySize(blockConst, blockConst);
        var npcText = this.add.text(npc.x, npc.y - 32, "DANG, YOU FOUND ME!");
        npcText.visible = false;
        // Check if player is nearby when this is fired
        this.player.on('funtimes', function (x, y) {
            console.warn("X", Math.abs(npc.x - x) / 32); // JB - Remove this console.warn
            console.warn("Y", Math.abs(npc.y - y) / 32); // JB - Remove this console.warn
            if ((Math.abs(npc.x - x) / 32 < 2) && (Math.abs(npc.y - y) / 32 < 2)) {
                npc.setAlpha(.33);
                npcText.visible = true;
            }
            else {
                npc.clearAlpha();
                npcText.visible = false;
            }
        });
        // END ADD NPC
        this.text = this.add.text(16, 16, '', {
            fontSize: '20px',
            fill: '#ffffff'
        });
        this.text.setScrollFactor(0);
    };
    MainScene.prototype.hitCoin = function (sprite, tile) {
        this.coinLayer.removeTileAt(tile.x, tile.y);
        this.coinsCollected += 1;
        // Return true to exit processing collision of this tile vs the sprite - in this case, it
        // doesn't matter since the coin tiles are not set to collide.
        return false;
    };
    MainScene.prototype.hitSecretDoor = function (sprite, tile) {
        tile.alpha = 0.25;
        // Return true to exit processing collision of this tile vs the sprite - here, we want to allow
        // the player jump "through" the block and not collide.
        return true;
    };
    MainScene.prototype.update = function (time, delta) {
        // Horizontal movement
        this.player.body.setVelocityX(0);
        if (this.cursors.left.isDown) {
            this.player.body.setVelocityX(-200);
        }
        else if (this.cursors.right.isDown) {
            this.player.body.setVelocityX(200);
        }
        if (this.frameCount % 4 === 0) {
            this.updateText();
            // Check if we are back on the ground to reset the second jump
            if (!this.doubleJump && this.player.body.onFloor()) {
                this.doubleJump = true;
            }
        }
        if (this.frameCount % 8 === 0) {
            // Dont want to update them too fast!
            this.updateCoins();
        }
        if (this.frameCount > 64000) {
            this.frameCount = 0;
        }
        this.frameCount++;
    };
    MainScene.prototype.attemptJump = function () {
        if (this.player.body.onFloor()) {
            this.doubleJump = true;
            this.player.body.setVelocityY(-400);
        }
        else if (this.doubleJump) {
            this.doubleJump = false;
            this.player.body.setVelocityY(-400);
        }
    };
    MainScene.prototype.drawDebug = function () {
        this.debugGraphics.clear();
        if (this.showDebug) {
            // Pass in null for any of the style options to disable drawing that component
            this.groundLayer.renderDebug(this.debugGraphics, {
                tileColor: null,
                collidingTileColor: new Phaser.Display.Color(243, 134, 48, 200),
                faceColor: new Phaser.Display.Color(40, 39, 37, 255) // Colliding face edges
            });
        }
    };
    MainScene.prototype.updateText = function () {
        var location = this.player.getBottomLeft().lerp(this.player.getTopRight(), 0.5);
        this.text.setText('Arrow keys to move. Space to jump' +
            '\nPress "C" to toggle debug visuals: ' + (this.showDebug ? 'on' : 'off') +
            '\nCoins collected: ' + this.coinsCollected +
            "\nLocation: (" + (location.x / 32).toFixed(0) + ", " + (location.y / 32).toFixed(0) + ")");
    };
    MainScene.prototype.updateCoins = function () {
        this.spriteTiles.forEach(function (x) {
            x.index++;
            if (x.index > 31) {
                x.index = 26;
            }
        });
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/phaser-dude.39a24a75.png";

/***/ }),
/* 2728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserAnimationDemo_Main__ = __webpack_require__(2729);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var AnimationDemo = /** @class */ (function (_super) {
    __extends(AnimationDemo, _super);
    function AnimationDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, AnimationDemo.prototype);
        return _this;
    }
    AnimationDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserAnimationDemo_Main__["a" /* default */], null)));
    };
    return AnimationDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AnimationDemo);


/***/ }),
/* 2729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__ = __webpack_require__(2730);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Animation Demo - Phaser",
    version: "0.0.1-demo",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 600 }
        }
    },
    backgroundColor: "#3A99D9"
};
var PhaserAnimationDemo = /** @class */ (function (_super) {
    __extends(PhaserAnimationDemo, _super);
    function PhaserAnimationDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserAnimationDemo.prototype);
        return _this;
    }
    PhaserAnimationDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__["a" /* MainScene */], config: gameConfig })));
    };
    return PhaserAnimationDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserAnimationDemo);


/***/ }),
/* 2730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.showDebug = false;
        _this.coinsCollected = 0;
        _this.doubleJump = true;
        _this.frameCount = 0;
        _this.spriteTiles = [];
        return _this;
    }
    MainScene.prototype.preload = function () {
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image('ground_1x1', __webpack_require__(991));
        this.load.tilemapTiledJSON('map', __webpack_require__(992));
        this.load.spritesheet('coin', __webpack_require__(993), { frameWidth: 32, frameHeight: 32 });
        // this.load.image('player', require("/src/assets/phaser-assets/sprites/phaser-dude.png"));
        this.load.image("jump-button", __webpack_require__(192));
        this.load.spritesheet('dude', __webpack_require__(994), { frameWidth: 32, frameHeight: 48 });
    };
    MainScene.prototype.create = function () {
        var _this = this;
        this.map = this.make.tilemap({ key: 'map' });
        var groundTiles = this.map.addTilesetImage('ground_1x1');
        var coinTiles = this.map.addTilesetImage('coin');
        this.map.createDynamicLayer('Background Layer', groundTiles, 0, 0);
        this.groundLayer = this.map.createDynamicLayer('Ground Layer', groundTiles, 0, 0);
        this.coinLayer = this.map.createDynamicLayer('Coin Layer', coinTiles, 0, 0);
        // Tiles with IDs 1-25 will cause collision
        this.groundLayer.setCollisionBetween(1, 25);
        // Allow collision from the bottom only on tile 17. Platforms anyone?
        this.groundLayer.layer.data.forEach(function (row) {
            row.forEach(function (tile) {
                if (tile.index === 17) {
                    tile.setCollision(false, false, true, false);
                }
            });
        });
        // The IDs are generated from the tilemap
        // This will set Tile ID 26-30 (the coin tile) to call the function "hitCoin" when collided with
        this.coinLayer.setTileIndexCallback([26, 27, 28, 29, 30], this.hitCoin, this);
        this.coinLayer.layer.data.forEach(function (row) {
            row.forEach(function (tile) {
                if (tile.index === 26) {
                    _this.spriteTiles.push(tile);
                }
            });
        });
        // This will set the map location (2, 0) to call the function "hitSecretDoor" Un-comment this to
        // be jump through the ceiling above where the player spawns. You can use this to create a
        // secret area.
        this.groundLayer.setTileLocationCallback(2, 0, 1, 1, this.hitSecretDoor, this);
        // this.player = this.physics.add.sprite(80, 70, 'player');
        this.player = this.physics.add.sprite(80, 70, 'dude');
        this.player.setBounceY(0.1);
        // We want the player to physically collide with the ground, but the coin layer should only
        // trigger an overlap so that collection a coin doesn't kill player movement.
        this.physics.add.collider(this.player, this.groundLayer);
        this.physics.add.overlap(this.player, this.coinLayer);
        // Setup the camera
        this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);
        this.cameras.main.startFollow(this.player);
        this.debugGraphics = this.add.graphics();
        this.input.keyboard.on('keydown_C', function (event) {
            _this.showDebug = !_this.showDebug;
            _this.drawDebug();
        });
        this.input.keyboard.on('keydown_SPACE', function () {
            _this.attemptJump();
        });
        this.input.keyboard.on('keydown_UP', function () {
            _this.attemptJump();
        });
        //  Set up our player animations, turning, walking left and walking right.
        this.anims.create({
            key: 'left',
            // use frames 0-3 of the spritesheet to walk left
            frames: this.anims.generateFrameNumbers('dude', { start: 0, end: 3 }),
            frameRate: 10,
            repeat: -1
        });
        // use frame 4 of the spritesheet to turn to the camera
        this.anims.create({
            key: 'turn',
            frames: [{ key: 'dude', frame: 4 }],
            frameRate: 20
        });
        // use frames 5-8 of the spritesheet to walk right
        this.anims.create({
            key: 'right',
            frames: this.anims.generateFrameNumbers('dude', { start: 5, end: 8 }),
            frameRate: 10,
            repeat: -1
        });
        // end of stuff to make the walking animations
        this.cursors = this.input.keyboard.createCursorKeys();
        // STUFF
        // Lets do a button on click thingy
        var jumpButton = this.add.sprite(10, this.textures.game.config.height - 70, "jump-button");
        jumpButton.setOrigin(0);
        jumpButton.setInteractive();
        jumpButton.setDisplaySize(64, 64);
        jumpButton.setScrollFactor(0); // Stops this item from scrolling with the background via the camera
        jumpButton.setAlpha(.33);
        jumpButton.on("pointerdown", function () {
            _this.attemptJump();
            _this.player.emit("funtimes", _this.player.x, _this.player.y);
        });
        this.player.setDragX(10);
        this.player.setBounceX(0);
        // END STUFF
        // ADD NPC
        var blockConst = this.map.tileWidth;
        var npc = this.add.sprite(1 * blockConst, 9 * blockConst, "jump-button");
        npc.setOrigin(0);
        npc.setInteractive();
        npc.setDisplaySize(blockConst, blockConst);
        var npcText = this.add.text(npc.x, npc.y - 32, "DANG, YOU FOUND ME!");
        npcText.visible = false;
        // Check if player is nearby when this is fired
        this.player.on('funtimes', function (x, y) {
            console.warn("X", Math.abs(npc.x - x) / 32); // JB - Remove this console.warn
            console.warn("Y", Math.abs(npc.y - y) / 32); // JB - Remove this console.warn
            if ((Math.abs(npc.x - x) / 32 < 2) && (Math.abs(npc.y - y) / 32 < 2)) {
                npc.setAlpha(.33);
                npcText.visible = true;
            }
            else {
                npc.clearAlpha();
                npcText.visible = false;
            }
        });
        // END ADD NPC
        this.text = this.add.text(16, 16, '', {
            fontSize: '20px',
            fill: '#ffffff'
        });
        this.text.setScrollFactor(0);
    };
    MainScene.prototype.hitCoin = function (sprite, tile) {
        this.coinLayer.removeTileAt(tile.x, tile.y);
        this.coinsCollected += 1;
        // Return true to exit processing collision of this tile vs the sprite - in this case, it
        // doesn't matter since the coin tiles are not set to collide.
        return false;
    };
    MainScene.prototype.hitSecretDoor = function (sprite, tile) {
        tile.alpha = 0.25;
        // Return true to exit processing collision of this tile vs the sprite - here, we want to allow
        // the player jump "through" the block and not collide.
        return true;
    };
    MainScene.prototype.update = function (time, delta) {
        // Horizontal movement, call the animations to show walking
        this.player.body.setVelocityX(0);
        if (this.cursors.left.isDown) {
            this.player.body.setVelocityX(-200);
            this.player.anims.play('left', true);
        }
        else if (this.cursors.right.isDown) {
            this.player.body.setVelocityX(200);
            this.player.anims.play('right', true);
        }
        else {
            this.player.body.setVelocityX(0);
            this.player.anims.play('turn', true);
        }
        if (this.frameCount % 4 === 0) {
            this.updateText();
            // Check if we are back on the ground to reset the second jump
            if (!this.doubleJump && this.player.body.onFloor()) {
                this.doubleJump = true;
            }
        }
        if (this.frameCount % 8 === 0) {
            // Dont want to update them too fast!
            this.updateCoins();
        }
        if (this.frameCount > 64000) {
            this.frameCount = 0;
        }
        this.frameCount++;
    };
    MainScene.prototype.attemptJump = function () {
        if (this.player.body.onFloor()) {
            this.doubleJump = true;
            this.player.body.setVelocityY(-400);
        }
        else if (this.doubleJump) {
            this.doubleJump = false;
            this.player.body.setVelocityY(-400);
        }
    };
    MainScene.prototype.drawDebug = function () {
        this.debugGraphics.clear();
        if (this.showDebug) {
            // Pass in null for any of the style options to disable drawing that component
            this.groundLayer.renderDebug(this.debugGraphics, {
                tileColor: null,
                collidingTileColor: new Phaser.Display.Color(243, 134, 48, 200),
                faceColor: new Phaser.Display.Color(40, 39, 37, 255) // Colliding face edges
            });
        }
    };
    MainScene.prototype.updateText = function () {
        var location = this.player.getBottomLeft().lerp(this.player.getTopRight(), 0.5);
        this.text.setText('Arrow keys to move. Space to jump' +
            '\nPress "C" to toggle debug visuals: ' + (this.showDebug ? 'on' : 'off') +
            '\nCoins collected: ' + this.coinsCollected +
            "\nLocation: (" + (location.x / 32).toFixed(0) + ", " + (location.y / 32).toFixed(0) + ")");
    };
    MainScene.prototype.updateCoins = function () {
        this.spriteTiles.forEach(function (x) {
            x.index++;
            if (x.index > 31) {
                x.index = 26;
            }
        });
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserMultiSceneDemo_Main__ = __webpack_require__(2732);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MultiSceneDemo = /** @class */ (function (_super) {
    __extends(MultiSceneDemo, _super);
    function MultiSceneDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, MultiSceneDemo.prototype);
        return _this;
    }
    MultiSceneDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserMultiSceneDemo_Main__["a" /* default */], null)));
    };
    return MultiSceneDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (MultiSceneDemo);


/***/ }),
/* 2732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_scene1__ = __webpack_require__(2733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenes_scene2__ = __webpack_require__(2735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scenes_scene3__ = __webpack_require__(2737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scenes_switcherScene__ = __webpack_require__(2739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenes_menuScene__ = __webpack_require__(2740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__phaserDemo_scenes_gameScene__ = __webpack_require__(989);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



// Import all Scenes here and add to the config var "scene" array (order matters for rendering!)





// import { MainScene } from '../gradeFive_Landscaping/scenes/MainScene';

var gameConfig = {
    title: "Multi Scene Demo",
    width: 800,
    height: 600,
    version: "0.0.1-demo",
    backgroundColor: "#000000"
};
var PhaserMultiSceneDemo = /** @class */ (function (_super) {
    __extends(PhaserMultiSceneDemo, _super);
    function PhaserMultiSceneDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserMultiSceneDemo.prototype);
        return _this;
    }
    PhaserMultiSceneDemo.prototype.render = function () {
        var scenes = [__WEBPACK_IMPORTED_MODULE_7__scenes_menuScene__["a" /* MenuScene */], __WEBPACK_IMPORTED_MODULE_6__scenes_switcherScene__["a" /* SwitcherScene */], __WEBPACK_IMPORTED_MODULE_8__phaserDemo_scenes_gameScene__["a" /* GameScene */], __WEBPACK_IMPORTED_MODULE_3__scenes_scene1__["a" /* Scene1 */], __WEBPACK_IMPORTED_MODULE_4__scenes_scene2__["a" /* Scene2 */], __WEBPACK_IMPORTED_MODULE_5__scenes_scene3__["a" /* Scene3 */]];
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: scenes, config: gameConfig })));
    };
    return PhaserMultiSceneDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserMultiSceneDemo);


/***/ }),
/* 2733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scene1; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Scene1 = /** @class */ (function (_super) {
    __extends(Scene1, _super);
    function Scene1() {
        return _super.call(this, {
            key: "Scene1"
        }) || this;
    }
    Scene1.prototype.preload = function () {
        this.load.image("factory", __webpack_require__(2734));
    };
    Scene1.prototype.create = function () {
        var im = this.add.image(200, 250, "factory");
        im.setOrigin(0);
        im.setDisplaySize(400, 400);
    };
    Scene1.prototype.update = function () {
    };
    return Scene1;
}(Phaser.Scene));



/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/factory.cb89f5e3.png";

/***/ }),
/* 2735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scene2; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Scene2 = /** @class */ (function (_super) {
    __extends(Scene2, _super);
    function Scene2() {
        return _super.call(this, {
            key: "Scene2"
        }) || this;
    }
    Scene2.prototype.preload = function () {
        this.load.image("metal", __webpack_require__(2736));
    };
    Scene2.prototype.create = function () {
        var im = this.add.image(200, 250, "metal");
        im.setOrigin(0);
        im.setDisplaySize(400, 400);
    };
    Scene2.prototype.update = function () {
    };
    return Scene2;
}(Phaser.Scene));



/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/metal.6dd78813.png";

/***/ }),
/* 2737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scene3; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Scene3 = /** @class */ (function (_super) {
    __extends(Scene3, _super);
    function Scene3() {
        return _super.call(this, {
            key: "Scene3"
        }) || this;
    }
    Scene3.prototype.preload = function () {
        this.load.image("ooze", __webpack_require__(2738));
    };
    Scene3.prototype.create = function () {
        var im = this.add.image(200, 250, "ooze");
        im.setOrigin(0);
        im.setDisplaySize(400, 400);
    };
    Scene3.prototype.update = function () {
    };
    return Scene3;
}(Phaser.Scene));



/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ooze.61e72e61.png";

/***/ }),
/* 2739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SwitcherScene; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SwitcherScene = /** @class */ (function (_super) {
    __extends(SwitcherScene, _super);
    function SwitcherScene() {
        return _super.call(this, {
            key: "SwitcherScene"
        }) || this;
    }
    // Data that is passed in from MenuScene
    SwitcherScene.prototype.init = function (data) {
        this.nextScene = data.next;
    };
    SwitcherScene.prototype.preload = function () {
        this.load.image("button", __webpack_require__(995));
    };
    SwitcherScene.prototype.create = function () {
        var _this = this;
        // Title of the scene
        this.add.text(0, 0, this.nextScene);
        // Menu button
        var menu = this.add.image(700, 100, "button");
        menu.setInteractive();
        menu.setDisplaySize(100, 100);
        menu.setDepth(20);
        // Menu text
        var txt = this.add.text(685, 100, "Menu");
        txt.setDepth(20);
        // Menu onClick: put the current scene to sleep and start menu scene again
        // Note: the games WILL save their state since we are just continuously sleeping/waking them
        menu.on('pointerdown', function () {
            console.warn("Putting " + _this.nextScene + " to sleep and starting MenuScene");
            _this.scene.sleep(_this.currentScene);
            _this.scene.start("MenuScene");
            _this.currentScene = "MenuScene";
        });
        // Some Notes:
        // this.scene.start() shuts down current scene and starts a new one (will overlap the same scene over and over again so need to check for activity)
        // this.scene.launch() runs the new scene in parallel (overlaps the contents of both scenes...probably not wanted)
        // this.scene.switch() puts current scene to sleep and starts new one
        // If the next scene doesn't exist (not sleeping) then launch a new scene for it 
        if (!this.scene.isSleeping(this.nextScene)) {
            this.scene.launch(this.nextScene);
            // Set the camera so it's a smaller version of the scene (so that we don't cover the menu button)
            var cam = this.scene.get(this.nextScene).cameras.main;
            cam.zoom = 0.5;
            this.currentScene = this.nextScene;
        }
        // Else, wake up the sleeping scene instead of launching a new one
        else {
            this.scene.wake(this.nextScene);
            this.currentScene = this.nextScene;
        }
    };
    SwitcherScene.prototype.update = function () {
    };
    return SwitcherScene;
}(Phaser.Scene));



/***/ }),
/* 2740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuScene; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var MenuScene = /** @class */ (function (_super) {
    __extends(MenuScene, _super);
    function MenuScene() {
        var _this = _super.call(this, {
            key: "MenuScene", active: true //want this scene active first
        }) || this;
        _this.currentScene = 0;
        return _this;
    }
    MenuScene.prototype.preload = function () {
        this.load.image("button1", __webpack_require__(995));
        this.load.image("button2", __webpack_require__(2741));
    };
    MenuScene.prototype.create = function () {
        var _this = this;
        // Get all scenes other than the menu and "scene switcher" scenes
        var scenes = [];
        for (var _i = 0, _a = this.scene.manager.scenes.slice(2, this.scene.manager.scenes.length); _i < _a.length; _i++) {
            var s = _a[_i];
            scenes.push(s.scene.key);
        }
        // Title
        this.add.text(5, 5, "MENU: CLick through scenes");
        // Menu button
        var menu = this.add.image(700, 100, "button1");
        menu.setInteractive();
        menu.setDisplaySize(100, 100);
        // Menu text
        this.add.text(685, 100, "Menu");
        // Menu onClick
        menu.on('pointerdown', function () {
            _this.scene.bringToTop("MenuScene");
        });
        // Next button
        var next = this.add.image(700, 500, "button2");
        next.setInteractive();
        next.setDisplaySize(100, 100);
        // Next text
        this.add.text(685, 500, "Next");
        // Next onClick: go to next scene in the scene list
        next.on('pointerdown', function () {
            // Get next scene from the array and send to the SwitcherScene as the "next" parameter (data.nextScene)
            var nextScene = _this.currentScene % (scenes.length);
            // Can pass data to scene using start(<scene>, {<data>})
            _this.scene.start("SwitcherScene", { next: scenes[nextScene] });
            _this.currentScene++;
        });
    };
    MenuScene.prototype.update = function () {
    };
    return MenuScene;
}(Phaser.Scene));



/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/square-button-blue.ef40519b.png";

/***/ }),
/* 2742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserPathFindingDemo_Main__ = __webpack_require__(2743);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var PathFindingDemo = /** @class */ (function (_super) {
    __extends(PathFindingDemo, _super);
    function PathFindingDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PathFindingDemo.prototype);
        return _this;
    }
    PathFindingDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserPathFindingDemo_Main__["a" /* default */], null)));
    };
    return PathFindingDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PathFindingDemo);


/***/ }),
/* 2743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_gameScene__ = __webpack_require__(2744);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Path Finding Demo",
    version: "0.0.2-demo",
    backgroundColor: "#000000"
};
var PhaserPathFindingDemo = /** @class */ (function (_super) {
    __extends(PhaserPathFindingDemo, _super);
    function PhaserPathFindingDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserPathFindingDemo.prototype);
        return _this;
    }
    PhaserPathFindingDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_gameScene__["a" /* GameScene */], config: gameConfig })));
    };
    return PhaserPathFindingDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserPathFindingDemo);


/***/ }),
/* 2744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameScene; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var GameScene = /** @class */ (function (_super) {
    __extends(GameScene, _super);
    function GameScene() {
        var _this = _super.call(this, {
            key: "GameScene"
        }) || this;
        _this.distanceBetween = 50;
        _this.speed = 200;
        return _this;
    }
    GameScene.prototype.preload = function () {
        this.load.image("background", __webpack_require__(996));
        this.load.image("player", __webpack_require__(192));
        this.load.image("npc", __webpack_require__(997));
        this.load.image("wall", __webpack_require__(998));
        this.load.image("coin", __webpack_require__(373));
    };
    GameScene.prototype.create = function () {
        this.createBackground();
        this.createCursors();
        this.createNPCFollowingText();
        this.setCenter();
        this.createPlayer();
        this.createNPC();
        this.createObstacles();
        this.createLocation();
        this.createWinText();
    };
    GameScene.prototype.createBackground = function () {
        this.background = this.add.image(0, 0, "background");
        this.background.setOrigin(0, 0);
    };
    GameScene.prototype.createCursors = function () {
        this.cursors = this.input.keyboard.addKeys({
            up: Phaser.Input.Keyboard.KeyCodes.W,
            down: Phaser.Input.Keyboard.KeyCodes.S,
            left: Phaser.Input.Keyboard.KeyCodes.A,
            right: Phaser.Input.Keyboard.KeyCodes.D,
        });
    };
    GameScene.prototype.createNPCFollowingText = function () {
        this.npcFollowingText = this.add.text(16, 16, '', {
            fontSize: '20px',
            fill: '#ffffff'
        });
    };
    GameScene.prototype.setCenter = function () {
        this.centerX = this.sys.canvas.width / 2;
        this.centerY = this.sys.canvas.height / 2;
    };
    GameScene.prototype.createPlayer = function () {
        this.player = this.physics.add.image(this.centerX + 300, this.centerY, "player");
        this.player.setOrigin(.5, .5);
        this.player.setDisplaySize(32, 32);
    };
    GameScene.prototype.createObstacles = function () {
        this.createWall(this.centerX, this.centerY - 150, "wall");
        this.createWall(this.centerX, this.centerY + 150, "wall");
        this.createWall(this.centerX - 150, this.centerY, "wall");
        this.createWall(this.centerX + 150, this.centerY, "wall");
    };
    GameScene.prototype.createWall = function (x, y, texture) {
        var wallObject = this.physics.add.image(x, y, texture);
        wallObject.setOrigin(.5);
        wallObject.setImmovable();
        this.physics.add.collider(this.npc, wallObject);
    };
    GameScene.prototype.createNPC = function () {
        var _this = this;
        this.npc = this.physics.add.image(this.centerX - 300, this.centerY, "npc");
        this.npc.setOrigin(.5);
        this.npc.setInteractive();
        this.npc.setDisplaySize(32, 32);
        this.npc.on("pointerdown", function (pointer) {
            _this.enableNPC = !_this.enableNPC;
        });
    };
    GameScene.prototype.createLocation = function () {
        this.coin = this.physics.add.image(this.centerX, this.centerY, "coin");
        this.coin.setOrigin(.5, .5);
    };
    GameScene.prototype.createWinText = function () {
        this.winText = this.add.text(this.coin.x, this.coin.y - 50, "", {
            fontSize: '20px',
            fill: '#ffffff'
        });
        this.winText.setOrigin(.5, .5);
    };
    GameScene.prototype.update = function () {
        this.updatePlayer();
        this.updateNPC();
        this.winCondition();
    };
    GameScene.prototype.updateNPC = function () {
        this.npc.update();
        //NPC Following Controls
        if (this.enableNPC) {
            //NPC Directional Facing Controls
            if (this.npc.x - this.player.x >= 0) {
                this.npc.setFlipX(true);
            }
            if (this.npc.x - this.player.x < 0) {
                this.npc.setFlipX(false);
            }
            //NPC Distance Determining Controls
            if (Math.abs(this.npc.x - this.player.x) >= this.distanceBetween + this.bungee
                || Math.abs(this.npc.y - this.player.y) >= this.distanceBetween + this.bungee) {
                this.bungee = 0;
                this.physics.moveToObject(this.npc, this.player, this.speed);
            }
            else {
                this.bungee = 25;
                this.npc.setVelocity(0);
            }
            this.npcFollowingText.setText("NPC is Following");
        }
        else {
            this.npc.setVelocity(0);
            this.npcFollowingText.setText("NPC is not Following");
        }
    };
    GameScene.prototype.updatePlayer = function () {
        this.player.update();
        this.player.body.setVelocityX(0);
        this.player.body.setVelocityY(0);
        if (this.cursors.left.isDown) {
            this.player.body.setVelocityX(-this.speed);
            this.player.setFlipX(true);
        }
        if (this.cursors.right.isDown) {
            this.player.body.setVelocityX(this.speed);
            this.player.setFlipX(false);
        }
        if (this.cursors.up.isDown) {
            this.player.body.setVelocityY(-this.speed);
        }
        if (this.cursors.down.isDown) {
            this.player.body.setVelocityY(this.speed);
        }
    };
    GameScene.prototype.winCondition = function () {
        if (Phaser.Geom.Intersects.RectangleToRectangle(this.npc.getBounds(), this.coin.getBounds())) {
            this.winText.setText("I Made it");
            this.enableNPC = false;
        }
        else {
            this.winText.setText("");
        }
    };
    return GameScene;
}(Phaser.Scene));



/***/ }),
/* 2745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserImagePasteDemo_Main__ = __webpack_require__(2746);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ImagePasteDemo = /** @class */ (function (_super) {
    __extends(ImagePasteDemo, _super);
    function ImagePasteDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ImagePasteDemo.prototype);
        return _this;
    }
    ImagePasteDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserImagePasteDemo_Main__["a" /* default */], null)));
    };
    return ImagePasteDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ImagePasteDemo);


/***/ }),
/* 2746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__ = __webpack_require__(2747);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "Image Pasting Test",
    version: "0.0.2-demo",
    width: 800,
    height: 600,
    backgroundColor: "#000000"
};
var PhaserImagePasteDemo = /** @class */ (function (_super) {
    __extends(PhaserImagePasteDemo, _super);
    function PhaserImagePasteDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserImagePasteDemo.prototype);
        return _this;
    }
    PhaserImagePasteDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__["a" /* MainScene */], config: gameConfig })));
    };
    return PhaserImagePasteDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserImagePasteDemo);


/***/ }),
/* 2747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.images = ["chestBlue", "chestGreen", "chestRed", "chestYellow", "clear"];
        _this.currentImage = "clear";
        _this.imageWidth = 75;
        _this.imageHeight = 75;
        return _this;
    }
    MainScene.prototype.preload = function () {
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image("background", __webpack_require__(372));
        this.load.image("control-background", __webpack_require__(990));
        this.load.image("chestBlue", __webpack_require__(2748));
        this.load.image("chestGreen", __webpack_require__(2749));
        this.load.image("chestRed", __webpack_require__(2750));
        this.load.image("chestYellow", __webpack_require__(2751));
        this.load.image("clear", __webpack_require__(2752));
    };
    MainScene.prototype.create = function () {
        this.createEasel();
        this.createKeyboards();
        this.createText();
        this.generateEvents();
    };
    MainScene.prototype.createKeyboards = function () {
        this.cursors = this.input.keyboard.addKeys({
            makeTaller: Phaser.Input.Keyboard.KeyCodes.UP,
            makeShorter: Phaser.Input.Keyboard.KeyCodes.DOWN,
            makeSlimmer: Phaser.Input.Keyboard.KeyCodes.LEFT,
            makeWider: Phaser.Input.Keyboard.KeyCodes.RIGHT,
        });
    };
    MainScene.prototype.createEasel = function () {
        var _this = this;
        var easelArea = { width: 600, height: 600 };
        var controlArea = { width: 200, height: 600 };
        // Generate Easel
        this.easel = this.add.image(0, 0, "background");
        this.easel.setOrigin(0, 0);
        this.easel.setDisplaySize(easelArea.width, easelArea.height);
        this.easel.setInteractive();
        this.easel.depth = -1;
        this.easel.on('pointerdown', function (pointer) {
            _this.pasteImage(pointer);
        }, this);
        // Generate Control area
        this.easelControls = this.add.image(easelArea.width, 0, "control-background");
        this.easelControls.setOrigin(0, 0);
        this.easelControls.setDisplaySize(controlArea.width, controlArea.height);
        this.easelControls.depth = 1;
        //Generate Images
        var buttonSize = { height: 75, width: 75 };
        var yCoord = 200;
        var _loop_1 = function (image) {
            button = this_1.add.image(this_1.easelControls.x + 20, yCoord, image);
            button.setOrigin(0);
            button.setDepth(1);
            button.setInteractive();
            button.setDisplaySize(buttonSize.width, buttonSize.height);
            button.on("pointerdown", function () {
                _this.currentImage = image;
                _this.currentPaste.setTexture(_this.currentImage);
            });
            yCoord += 75;
        };
        var this_1 = this, button;
        for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
            var image = _a[_i];
            _loop_1(image);
        }
        this.currentPaste = this.add.image(this.easelControls.x + 110, this.easelControls.y + 10, "clear");
        this.currentPaste.setOrigin(0);
        this.currentPaste.setDepth(1);
        this.currentPaste.setDisplaySize(75, 75);
    };
    MainScene.prototype.pasteImage = function (pointer) {
        if (this.currentImage !== "clear") {
            this.paste = this.add.image(pointer.x, pointer.y, this.currentImage);
            this.paste.setInteractive();
            this.paste.setDisplaySize(this.imageWidth, this.imageHeight);
            this.input.setDraggable(this.paste);
        }
    };
    MainScene.prototype.generateEvents = function () {
        var _this = this;
        // Wire up events
        this.input.on('dragstart', function (pointer, gameObject) {
            gameObject.x = pointer.downX;
            gameObject.y = pointer.downY;
            gameObject.setAngle();
            _this.children.bringToTop(gameObject);
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = pointer.x;
            gameObject.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, gameObject) {
            _this.children.moveDown(gameObject);
        });
    };
    MainScene.prototype.createText = function () {
        this.createTextInstances(this.easelControls.x + 10, this.easelControls.y + 30, "Image:");
        this.createTextInstances(this.easelControls.x + 10, this.easelControls.y + 90, "Width: ");
        this.createTextInstances(this.easelControls.x + 10, this.easelControls.y + 150, "Height: ");
        this.currentWidthText = this.add.text(this.easelControls.x + 120, this.easelControls.y + 90, "", {
            fontSize: '24px',
            fill: '#ffffff'
        });
        this.currentWidthText.setOrigin(0);
        this.currentWidthText.setDepth(1);
        this.currentHeightText = this.add.text(this.easelControls.x + 120, this.easelControls.y + 150, "", {
            fontSize: '24px',
            fill: '#ffffff'
        });
        this.currentHeightText.setOrigin(0);
        this.currentHeightText.setDepth(1);
    };
    MainScene.prototype.createTextInstances = function (x, y, textString) {
        var text = this.add.text(x, y, textString, {
            fontSize: '24px',
            fill: '#ffffff'
        });
        text.setOrigin(0);
        text.setDepth(1);
    };
    MainScene.prototype.update = function () {
        this.updateSize();
        this.updateText();
    };
    MainScene.prototype.updateSize = function () {
        if (this.cursors.makeTaller.isDown) {
            this.imageHeight++;
        }
        if (this.cursors.makeShorter.isDown) {
            this.imageHeight--;
        }
        if (this.cursors.makeSlimmer.isDown) {
            this.imageWidth--;
        }
        if (this.cursors.makeWider.isDown) {
            this.imageWidth++;
        }
    };
    MainScene.prototype.updateText = function () {
        this.currentWidthText.setText("" + this.imageWidth);
        this.currentHeightText.setText("" + this.imageHeight);
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ChestBlue.9c51e5ac.png";

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ChestGreen.c3a3e8d1.png";

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ChestRed.02c28958.png";

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ChestYellow.dc7f6a17.png";

/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clear.47cb13ca.png";

/***/ }),
/* 2753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserGamePadDemo_Main__ = __webpack_require__(2754);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GamePadDemo = /** @class */ (function (_super) {
    __extends(GamePadDemo, _super);
    function GamePadDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, GamePadDemo.prototype);
        return _this;
    }
    GamePadDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserGamePadDemo_Main__["a" /* default */], null)));
    };
    return GamePadDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (GamePadDemo);


/***/ }),
/* 2754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_EventScene__ = __webpack_require__(538);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var config = {
    title: "Gamepad",
    version: "0.0.1-demo",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000"
};
var PhaserGamePadDemo = /** @class */ (function (_super) {
    __extends(PhaserGamePadDemo, _super);
    function PhaserGamePadDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserGamePadDemo.prototype);
        return _this;
    }
    PhaserGamePadDemo.prototype.render = function () {
        // <PhaserGameComponent scenes={[EventScene, UpdateScene]} config={config} />
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_EventScene__["a" /* EventScene */], config: config })));
    };
    return PhaserGamePadDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserGamePadDemo);


/***/ }),
/* 2755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdateScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventScene__ = __webpack_require__(538);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var UpdateScene = /** @class */ (function (_super) {
    __extends(UpdateScene, _super);
    function UpdateScene() {
        var _this = _super.call(this, {
            key: "UpdateScene"
        }) || this;
        _this.initialized = false;
        _this.speed = 100;
        _this.generalSize = 64;
        _this.xVel = 0;
        _this.yVel = 0;
        return _this;
    }
    UpdateScene.prototype.init = function (data) {
        console.warn("Running Init", UpdateScene.name, data); // JB - Remove this console.warn
        if (data != null && this.initialized) {
            this.player.setPosition(data.x, data.y);
        }
    };
    UpdateScene.prototype.preload = function () {
        this.load.image("player", __webpack_require__(192));
        __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
    };
    UpdateScene.prototype.create = function () {
        if (this.initialized) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(this, UpdateScene.prototype);
        this.input.addPointer(6);
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.createObjects();
        this.initialized = true;
    };
    UpdateScene.prototype.createObjects = function () {
        var _this = this;
        var blackground = this.add.image(0, 0, "background")
            .setOrigin(0)
            .setTint(0xffddff);
        var overlay = this.add.text(16, 16, "This demo uses an update loop approach to moving the player around", {
            fontSize: '24px',
            fill: '#ffffff'
        });
        var switcherButton = this.add.image(this.sys.canvas.width - 128 - 16, 16, "pixel");
        switcherButton.setTint(0x003355);
        switcherButton.setDisplaySize(128, 64);
        switcherButton.setInteractive();
        switcherButton.setDepth(2);
        switcherButton.on("pointerdown", function () {
            _this.scene.remove(_this);
            _this.scene.add("EventScene", __WEBPACK_IMPORTED_MODULE_2__EventScene__["a" /* EventScene */], true);
            // this.scene.switch(EventScene.name);
            // this.scene.run(EventScene.name, new Phaser.Geom.Rectangle(this.player.x, this.player.y));
            // this.scene.pause(UpdateScene.name);
        });
        var buttonText = this.add.text(switcherButton.x, switcherButton.y, "Flip!", {
            fontSize: '16px',
            fill: '#ffffff'
        });
        buttonText.setDepth(2);
        Phaser.Display.Align.In.Center(buttonText, switcherButton);
        this.player = this.physics.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "player");
        this.player.setOrigin(.5);
        this.player.setDisplaySize(this.generalSize, this.generalSize);
    };
    UpdateScene.prototype.update = function () {
        console.log('using update scene');
        // Local reference not needed, but its like 4 properties in and tidies up the code nicely
        var keys = this.gamePad.keys;
        var scale = 1;
        // Zero out the velocities
        this.xVel = 0;
        this.yVel = 0;
        if (keys.up.isDown) {
            this.yVel += -this.speed;
        }
        // Note: If you do an `else if` you will only ever be able to use one button
        if (keys.down.isDown) {
            this.yVel += this.speed;
        }
        if (keys.left.isDown) {
            this.xVel += -this.speed;
        }
        if (keys.right.isDown) {
            this.xVel += this.speed;
        }
        // Check scaling
        if (keys.a.isDown) {
            scale *= .5;
        }
        if (keys.b.isDown) {
            scale *= 3;
        }
        this.player.setDisplaySize(this.generalSize * scale, this.generalSize * scale);
        this.player.setVelocity(this.xVel * scale, this.yVel * scale);
        // Check the flip
        if (this.xVel !== 0 && (this.gamePad.keys.left.isDown || this.gamePad.keys.right.isDown)) {
            this.player.setFlipX(this.xVel < 0);
        }
    };
    return UpdateScene;
}(Phaser.Scene));



/***/ }),
/* 2756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserCameraAnimationDemo_Main__ = __webpack_require__(2757);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var CameraAnimationDemo = /** @class */ (function (_super) {
    __extends(CameraAnimationDemo, _super);
    function CameraAnimationDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, CameraAnimationDemo.prototype);
        return _this;
    }
    CameraAnimationDemo.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_phaserCameraAnimationDemo_Main__["a" /* default */], null));
    };
    return CameraAnimationDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CameraAnimationDemo);


/***/ }),
/* 2757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_gameScene__ = __webpack_require__(2758);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var config = {
    title: "Camera Animations",
    version: "0.0.1-superAlpha",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000"
};
var PhaserCameraAnimationDemo = /** @class */ (function (_super) {
    __extends(PhaserCameraAnimationDemo, _super);
    function PhaserCameraAnimationDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserCameraAnimationDemo.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    PhaserCameraAnimationDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_gameScene__["a" /* GameScene */], config: config })));
    };
    return PhaserCameraAnimationDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserCameraAnimationDemo);


/***/ }),
/* 2758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameScene; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var GameScene = /** @class */ (function (_super) {
    __extends(GameScene, _super);
    function GameScene() {
        var _this = _super.call(this, {
            key: "GameScene"
        }) || this;
        _this.distanceBetween = 50;
        _this.speed = 200;
        return _this;
    }
    GameScene.prototype.preload = function () {
        this.load.image("background", __webpack_require__(996));
        this.load.image("player", __webpack_require__(192));
        this.load.image("npc", __webpack_require__(997));
        this.load.image("wall", __webpack_require__(998));
        this.load.image("coin", __webpack_require__(373));
    };
    GameScene.prototype.create = function () {
        this.createCamera();
        this.createBackground();
        this.createCursors();
        this.createNPCFollowingText();
        this.setCenter();
        this.createPlayer();
        this.createNPC();
        this.createObstacles();
        this.createLocation();
        this.createWinText();
    };
    GameScene.prototype.createCamera = function () {
        this.miniMap = this.cameras.add(this.sys.canvas.width - (1366 / 3), this.sys.canvas.height - (768 / 3), 1366 / 3, 768 / 3).setZoom(.2);
    };
    GameScene.prototype.createBackground = function () {
        this.background = this.add.image(0, 0, "background");
        this.background.setOrigin(0, 0);
    };
    GameScene.prototype.createCursors = function () {
        this.cursors = this.input.keyboard.addKeys({
            up: Phaser.Input.Keyboard.KeyCodes.W,
            down: Phaser.Input.Keyboard.KeyCodes.S,
            left: Phaser.Input.Keyboard.KeyCodes.A,
            right: Phaser.Input.Keyboard.KeyCodes.D,
        });
    };
    GameScene.prototype.createNPCFollowingText = function () {
        this.npcFollowingText = this.add.text(16, 16, '', {
            fontSize: '20px',
            fill: '#ffffff'
        });
    };
    GameScene.prototype.setCenter = function () {
        this.centerX = this.sys.canvas.width / 2;
        this.centerY = this.sys.canvas.height / 2;
    };
    GameScene.prototype.createPlayer = function () {
        this.player = this.physics.add.image(this.centerX + 300, this.centerY, "player");
        this.player.setOrigin(.5, .5);
        this.player.setDisplaySize(32, 32);
    };
    GameScene.prototype.createObstacles = function () {
        this.createWall(this.centerX, this.centerY - 150, "wall");
        this.createWall(this.centerX, this.centerY + 150, "wall");
        this.createWall(this.centerX - 150, this.centerY, "wall");
        this.createWall(this.centerX + 150, this.centerY, "wall");
    };
    GameScene.prototype.createWall = function (x, y, texture) {
        var wallObject = this.physics.add.image(x, y, texture);
        wallObject.setOrigin(.5);
        wallObject.setImmovable();
        this.physics.add.collider(this.npc, wallObject);
        this.physics.add.collider(this.player, wallObject);
    };
    GameScene.prototype.createNPC = function () {
        var _this = this;
        this.npc = this.physics.add.image(this.centerX - 300, this.centerY, "npc");
        this.npc.setOrigin(.5);
        this.npc.setInteractive();
        this.npc.setDisplaySize(32, 32);
        this.npc.on("pointerdown", function (pointer) {
            _this.enableNPC = !_this.enableNPC;
        });
    };
    GameScene.prototype.createLocation = function () {
        var _this = this;
        this.coin = this.physics.add.image(this.centerX, this.centerY, "coin");
        this.coin.setOrigin(.5, .5);
        this.coin.setInteractive();
        this.coin.on("pointerdown", function () {
            _this.cameras.main.shake(500);
        });
        var shakeText = this.add.text(this.centerX, 30, "Press Coin", {
            fontSize: '20px',
            fill: '#ffffff'
        });
        shakeText.setOrigin(.5);
    };
    GameScene.prototype.createWinText = function () {
        this.winText = this.add.text(this.coin.x, this.coin.y - 50, "", {
            fontSize: '20px',
            fill: '#ffffff'
        });
        this.winText.setOrigin(.5, .5);
    };
    GameScene.prototype.update = function () {
        this.updatePlayer();
        this.updateNPC();
        this.winCondition();
    };
    GameScene.prototype.updateNPC = function () {
        this.npc.update();
        //NPC Following Controls
        if (this.enableNPC) {
            //NPC Directional Facing Controls
            if (this.npc.x - this.player.x >= 0) {
                this.npc.setFlipX(true);
            }
            if (this.npc.x - this.player.x < 0) {
                this.npc.setFlipX(false);
            }
            //NPC Distance Determining Controls
            if (Math.abs(this.npc.x - this.player.x) >= this.distanceBetween + this.bungee
                || Math.abs(this.npc.y - this.player.y) >= this.distanceBetween + this.bungee) {
                this.bungee = 0;
                this.physics.moveToObject(this.npc, this.player, this.speed);
            }
            else {
                this.bungee = 25;
                this.npc.setVelocity(0);
            }
            this.npcFollowingText.setText("NPC is Following");
        }
        else {
            this.npc.setVelocity(0);
            this.npcFollowingText.setText("NPC is not Following");
        }
    };
    GameScene.prototype.updatePlayer = function () {
        this.player.update();
        this.player.body.setVelocityX(0);
        this.player.body.setVelocityY(0);
        if (this.cursors.left.isDown) {
            this.player.body.setVelocityX(-this.speed);
            this.player.setFlipX(true);
        }
        if (this.cursors.right.isDown) {
            this.player.body.setVelocityX(this.speed);
            this.player.setFlipX(false);
        }
        if (this.cursors.up.isDown) {
            this.player.body.setVelocityY(-this.speed);
        }
        if (this.cursors.down.isDown) {
            this.player.body.setVelocityY(this.speed);
        }
    };
    GameScene.prototype.winCondition = function () {
        if (Phaser.Geom.Intersects.RectangleToRectangle(this.npc.getBounds(), this.coin.getBounds())) {
            this.winText.setText("I Made it");
            this.enableNPC = false;
        }
        else {
            this.winText.setText("");
        }
    };
    return GameScene;
}(Phaser.Scene));



/***/ }),
/* 2759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_modalButtonComponentDemo_Main__ = __webpack_require__(2760);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ModalButtonDemo = /** @class */ (function (_super) {
    __extends(ModalButtonDemo, _super);
    function ModalButtonDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ModalButtonDemo.prototype);
        return _this;
    }
    ModalButtonDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_modalButtonComponentDemo_Main__["a" /* default */], null)));
    };
    return ModalButtonDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ModalButtonDemo);


/***/ }),
/* 2760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__ = __webpack_require__(2761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_demos_phaserGamePadDemo_scenes_EventScene__ = __webpack_require__(538);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var config = {
    title: "Modal Button Demo",
    version: "0.0.1-superAlpha",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000"
};
var PhaserModalButtonDemo = /** @class */ (function (_super) {
    __extends(PhaserModalButtonDemo, _super);
    function PhaserModalButtonDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserModalButtonDemo.prototype);
        return _this;
    }
    PhaserModalButtonDemo.prototype.render = function () {
        var scenes = [__WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__["a" /* MainScene */], __WEBPACK_IMPORTED_MODULE_4_src_games_demos_phaserGamePadDemo_scenes_EventScene__["a" /* EventScene */]];
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: scenes, config: config })));
    };
    return PhaserModalButtonDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserModalButtonDemo);


/***/ }),
/* 2761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_ModalTitle__ = __webpack_require__(899);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        return _super.call(this, {
            key: "MainScene", active: true
        }) || this;
    }
    MainScene.prototype.preload = function () {
        this.load.image('pixel', __webpack_require__(60));
    };
    MainScene.prototype.create = function () {
        var _this = this;
        // Add a button to launch a modal with some options
        var buttonConfig = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
        buttonConfig.backgroundColor = 0xff0000;
        var button = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__["a" /* PhaserButton */](this, this.cameras.main.width - 200, 50, 150, 50, "Click To Open Modal", buttonConfig);
        button.setDepth(200);
        // Set button onClick handler
        button.on('buttonClicked', function (pointer, x, y) {
            var modalConfig = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__["b" /* PhaserModalConfig */]();
            modalConfig.title = "This is a modal!";
            // Override the default title and button colors
            modalConfig.buttonConfig = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__["b" /* PhaserButtonConfig */]();
            modalConfig.buttonConfig.smartSize = true;
            modalConfig.buttonConfig.backgroundColor = 0x4286f4;
            // Options are essentially buttons
            var modalOptions = [
                { id: 1, displayText: "Change Modal Position" },
                { id: 2, displayText: "Add Text To Scene" },
                { id: 3, displayText: "Close Modal" },
            ];
            // Create modal with 3 options
            var modal = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Modal__["a" /* PhaserModal */](_this, _this.cameras.main.width / 2, _this.cameras.main.height / 2, modalOptions, modalConfig);
            modal.setDepth(200);
            // Set option onClick handler
            modal.on('optionClicked', function (option) {
                if (option.id === 1) {
                    modal.setRandomPosition(0, 0, 500, 500);
                }
                else if (option.id === 2) {
                    console.log(option);
                    // Do something custom here... (e.g. change some game state or the scene)
                    _this.add.text(0, 0, "Just Added This To The Scene!").setRandomPosition(0, 0, 500, 500);
                }
                else {
                    modal.destroy();
                }
            });
        });
        var background = this.add.image(0, 0, "pixel");
        background.setOrigin(0);
        background.setDisplaySize(this.cameras.main.width, this.cameras.main.height);
        var config = new __WEBPACK_IMPORTED_MODULE_2__shared_ModalTitle__["b" /* PhaserModalTitleConfig */]();
        config.title = "This is the Title make it a long title for this example to see what it does in this case";
        config.bodyText = "Some jobs need special training, or certificates, (also called credentials) in order for a person to work in a specific job. Some workers need to be certified or licensed in order to show employers and customers that they are qualified to do the work. This means that workers have studied and taken exams to show that they are dedicated and interested in learning about their work. Credentials and certifications also help a worker stay up-to-date on any new information that is important to their job.";
        config.borderColor = 0xff0000;
        config.buttonWidth = 100;
        var button2 = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_Button__["a" /* PhaserButton */](this, this.cameras.main.width - 400, 50, 150, 50, "Click To Open Title Modal");
        button2.setDepth(200);
        button2.on('buttonClicked', function () {
            var titleModal = new __WEBPACK_IMPORTED_MODULE_2__shared_ModalTitle__["a" /* PhaserModalTitle */](_this, 100, 100, config, [{ id: 1, displayText: "button" }]);
            titleModal.on('optionClicked', function () { return titleModal.destroy(); });
        });
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_npcFollowingDemo_Main__ = __webpack_require__(2763);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var NPCFollowingDemo = /** @class */ (function (_super) {
    __extends(NPCFollowingDemo, _super);
    function NPCFollowingDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, NPCFollowingDemo.prototype);
        return _this;
    }
    NPCFollowingDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_npcFollowingDemo_Main__["a" /* default */], null)));
    };
    return NPCFollowingDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (NPCFollowingDemo);


/***/ }),
/* 2763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__ = __webpack_require__(2764);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var gameConfig = {
    title: "NPC Following Demo",
    version: "0.2-demo",
    backgroundColor: "#000000",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 300 }
        },
    },
};
var PhaserNPCFollowingDemo = /** @class */ (function (_super) {
    __extends(PhaserNPCFollowingDemo, _super);
    function PhaserNPCFollowingDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserNPCFollowingDemo.prototype);
        return _this;
    }
    PhaserNPCFollowingDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__["a" /* MainScene */], config: gameConfig })));
    };
    return PhaserNPCFollowingDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserNPCFollowingDemo);


/***/ }),
/* 2764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Gamepad__ = __webpack_require__(139);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.doubleJump = true;
        _this.speed = 180;
        _this.playerAlwaysLeads = false;
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        this.load.image('drawtiles', __webpack_require__(873));
        this.load.tilemapTiledJSON('map', __webpack_require__(2765));
        this.load.image("pixel", __webpack_require__(60));
        this.load.image("astronaut", __webpack_require__(999));
        this.load.image("exclamation-point", __webpack_require__(900));
        this.load.spritesheet('dude', __webpack_require__(994), { frameWidth: 32, frameHeight: 48 });
        __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Gamepad__["a" /* PhaserGamePad */].preload(this);
    };
    MainScene.prototype.create = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, MainScene.prototype);
        this.initializeMap();
        this.generateScene();
    };
    MainScene.prototype.createGamePad = function () {
        this.gamePad = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Gamepad__["a" /* PhaserGamePad */](this);
        this.gamePad.on("keydown_up", this.moveUp);
        this.gamePad.on("keydown_down", this.moveDownStart);
        this.gamePad.on("keydown_left", this.moveLeft);
        this.gamePad.on("keydown_right", this.moveRight);
        this.gamePad.on("keydown_a", this.aDownStart);
        this.gamePad.on("keydown_b", this.bDownStart);
        this.gamePad.on("keyup_up", this.moveUpStop);
        this.gamePad.on("keyup_down", this.moveDownStop);
        this.gamePad.on("keyup_left", this.stopLeftRight);
        this.gamePad.on("keyup_right", this.stopLeftRight);
        this.gamePad.on("keyup_a", this.stopAB);
        this.gamePad.on("keyup_b", this.stopAB);
    };
    // Initializes the tilemap and sets tile collision properties
    MainScene.prototype.initializeMap = function () {
        this.map = this.make.tilemap({ key: 'map' });
        var groundTiles = this.map.addTilesetImage('drawtiles');
        this.map.addTilesetImage('dude').setTileSize(32, 48);
        this.map.createDynamicLayer('Background Layer', groundTiles, 0, 0);
        this.groundLayer = this.map.createDynamicLayer('Ground Layer', groundTiles, 0, 0);
        this.npcLayer = this.map.getObjectLayer('NPC Layer');
        // Tiles with IDs 10-24 will cause collision
        this.groundLayer.setCollisionBetween(10, 24);
        // Allow collision from the bottom only on tile 20
        this.groundLayer.layer.data.forEach(function (row) {
            row.forEach(function (tile) {
                if (tile.index === 20) {
                    tile.setCollision(false, false, true, false);
                }
            });
        });
    };
    MainScene.prototype.generateScene = function () {
        this.generatePlayer();
        this.generateNPCs();
        this.createGamePad();
        // Setup the camera to follow the player
        this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);
        this.cameras.main.startFollow(this.player);
    };
    MainScene.prototype.generatePlayer = function () {
        this.player = this.physics.add.sprite(50, 100, "dude");
        this.player.setBounce(0.2);
        //  Player animations, turning, walking left and walking right.
        this.anims.create({
            key: 'left',
            frames: this.anims.generateFrameNumbers('dude', { start: 0, end: 3 }),
            frameRate: 10,
            repeat: -1
        });
        this.anims.create({
            key: 'turn',
            frames: [{ key: 'dude', frame: 4 }],
            frameRate: 20
        });
        this.anims.create({
            key: 'right',
            frames: this.anims.generateFrameNumbers('dude', { start: 5, end: 8 }),
            frameRate: 10,
            repeat: -1
        });
        this.player.setDepth(100);
        this.physics.add.collider(this.player, this.groundLayer);
    };
    /**
     * Generates the astronaut and candidates with their careers
     * */
    MainScene.prototype.generateNPCs = function () {
        var _this = this;
        var i = 0;
        this.npcs = [];
        this.npcLayer.objects.forEach(function (ob) {
            var npc = _this.physics.add.sprite(ob.x + 16, ob.y + 10, "dude");
            npc.setTint(0x4286f4);
            npc.setFrame(4);
            npc.setDataEnabled();
            npc.setData('enabled', true);
            npc.setInteractive();
            npc.setDepth(0);
            npc.on('pointerdown', function () {
                // Start following
                _this.currentNPC = npc;
                _this.physics.moveToObject(_this.currentNPC, _this.player, _this.speed);
            });
            _this.physics.add.collider(npc, _this.groundLayer);
            _this.physics.add.overlap(npc, _this.player);
            _this.npcs.push(npc);
        });
    };
    /**
     * Handles user input
     * */
    MainScene.prototype.update = function () {
        //  Player Movement
        var cursors = this.input.keyboard.createCursorKeys();
        if (this.currentNPC != null) {
            this.updateNPC();
        }
        if (cursors.left.isDown || this.gamePad.keys.left.isDown) {
            this.moveLeft();
        }
        else if (cursors.right.isDown || this.gamePad.keys.right.isDown) {
            this.moveRight();
        }
        else {
            this.stopLeftRight();
        }
        if (cursors.up.isDown || this.gamePad.keys.up.isDown) {
            this.moveUp();
        }
        // Check if we are back on the ground to reset the second jump
        if (!this.doubleJump && this.player.body.onFloor()) {
            this.doubleJump = true;
        }
    };
    MainScene.prototype.updateNPC = function () {
        if (this.currentNPC.body.velocity.x > 0) {
            this.currentNPC.anims.play('right', true);
            this.physics.moveTo(this.currentNPC, this.player.getBottomLeft().x - 2 * this.player.width, this.player.y, this.speed);
        }
        else if (this.currentNPC.body.velocity.x < 0) {
            this.currentNPC.anims.play('left', true);
            this.physics.moveTo(this.currentNPC, this.player.getBottomRight().x + 2 * this.player.width, this.player.y, this.speed);
        }
    };
    MainScene.prototype.moveUp = function () {
        if (this.player.body.onFloor()) {
            this.attemptJump();
        }
    };
    MainScene.prototype.moveDownStart = function () {
        this.player.setVelocityY(this.speed);
        if (this.currentNPC != null) {
            this.currentNPC.setVelocityY(this.speed);
        }
    };
    MainScene.prototype.moveLeft = function () {
        this.player.setVelocityX(-this.speed);
        this.player.anims.play('left', true);
        if (this.currentNPC != null) {
            this.moveNPCLeft();
        }
    };
    MainScene.prototype.moveNPCLeft = function () {
        if (this.playerAlwaysLeads) {
            // Only move the NPC if they're not too far away
            if (!this.isNPCTooFarAway()) {
                if (this.isNPCLeftOfPlayer()) {
                    // Moving left and npc is on the left, so move them to the right of the player
                    var dest;
                    var x = this.player.getCenter().x + this.player.width;
                    // If the player is under the current npc, move to them
                    if (this.player.y < this.currentNPC.y) {
                        dest = new Phaser.Geom.Rectangle(x, this.player.getCenter().y, this.currentNPC.width, this.currentNPC.height);
                    }
                    else {
                        // The player is above the npc, so don't move up to it
                        dest = new Phaser.Geom.Rectangle(x, this.currentNPC.getCenter().y, this.currentNPC.width, this.currentNPC.height);
                    }
                    this.physics.moveToObject(this.currentNPC, dest, this.speed);
                }
            }
        }
        else {
            this.currentNPC.setVelocityX(-this.speed);
        }
    };
    MainScene.prototype.moveRight = function () {
        this.player.setVelocityX(this.speed);
        this.player.anims.play('right', true);
        if (this.currentNPC != null) {
            this.moveNPCRight();
        }
    };
    MainScene.prototype.moveNPCRight = function () {
        if (this.playerAlwaysLeads) {
            // Only move the NPC if they're not too far away
            if (!this.isNPCTooFarAway()) {
                if (this.isNPCRightOfPlayer()) {
                    this.currentNPC.setVelocityX(this.speed);
                    // Moving right and npc is on the right, so move them over to the left of the npc
                    var dest;
                    var x = this.player.getCenter().x - this.player.width;
                    // If the player is under the current npc, move to them
                    if (this.player.y < this.currentNPC.y) {
                        dest = new Phaser.Geom.Rectangle(x, this.player.getCenter().y, this.currentNPC.width, this.currentNPC.height);
                    }
                    else {
                        // The player is above the npc, so don't move up to it
                        dest = new Phaser.Geom.Rectangle(x, this.currentNPC.getCenter().y, this.currentNPC.width, this.currentNPC.height);
                    }
                    this.physics.moveToObject(this.currentNPC, dest, this.speed);
                }
                else {
                    this.currentNPC.setVelocityX(this.speed);
                }
            }
        }
        else {
            this.currentNPC.setVelocityX(this.speed);
        }
    };
    MainScene.prototype.isNPCRightOfPlayer = function () {
        return this.currentNPC.x > (this.player.x - this.player.width);
    };
    MainScene.prototype.isNPCLeftOfPlayer = function () {
        return this.currentNPC.x <= (this.player.x + this.player.width);
    };
    MainScene.prototype.isNPCTooFarAway = function () {
        return false;
        // return Math.abs(this.currentNPC.x - this.player.x) > 100;
    };
    MainScene.prototype.moveUpStop = function () {
        // NOOP
    };
    MainScene.prototype.moveDownStop = function () {
        this.player.setVelocityY(this.speed);
        this.player.anims.play('turn');
    };
    MainScene.prototype.stopLeftRight = function () {
        this.player.setVelocityX(0);
        this.player.anims.play('turn');
        if (this.currentNPC != null) {
            this.currentNPC.setVelocityX(0);
            this.currentNPC.anims.play('turn');
        }
    };
    MainScene.prototype.aDownStart = function () {
    };
    MainScene.prototype.bDownStart = function () {
        // NOOP
    };
    MainScene.prototype.stopAB = function () {
        // NOOP
    };
    MainScene.prototype.attemptJump = function () {
        var _this = this;
        if (this.player.body.onFloor()) {
            this.doubleJump = true;
            this.player.body.setVelocityY(-400);
        }
        else if (this.doubleJump) {
            this.doubleJump = false;
            this.player.body.setVelocityY(-400);
        }
        // Delay the npc jump
        if (this.currentNPC != null && !this.isNPCTooFarAway()) {
            setTimeout(function () {
                if (_this.currentNPC.body.onFloor()) {
                    _this.doubleJump = true;
                    _this.currentNPC.body.setVelocityY(-400);
                }
                else if (_this.doubleJump) {
                    _this.doubleJump = false;
                    _this.currentNPC.body.setVelocityY(-400);
                }
            }, 200);
        }
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/other/npc_following_demo_map.6bc1ba82.json";

/***/ }),
/* 2766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_LandscapingDemo_Main__ = __webpack_require__(2767);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var LandscapingGame = /** @class */ (function (_super) {
    __extends(LandscapingGame, _super);
    function LandscapingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, LandscapingGame.prototype);
        return _this;
    }
    LandscapingGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_LandscapingDemo_Main__["a" /* default */], null));
    };
    return LandscapingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LandscapingGame);


/***/ }),
/* 2767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__ = __webpack_require__(2768);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DemoConfig = {
    title: "Landscaping Demo",
    version: "0.9.3",
    backgroundColor: "#d3d3d3"
};
var PhaserLandscapeDemo = /** @class */ (function (_super) {
    __extends(PhaserLandscapeDemo, _super);
    function PhaserLandscapeDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserLandscapeDemo.prototype);
        return _this;
    }
    PhaserLandscapeDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_MainScene__["a" /* MainScene */], config: DemoConfig })));
    };
    return PhaserLandscapeDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserLandscapeDemo);


/***/ }),
/* 2768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_games_shared_dropzone_DropZone__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_dropzone_DropZoneSprite__ = __webpack_require__(904);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ScoreObject = /** @class */ (function () {
    function ScoreObject() {
    }
    return ScoreObject;
}());
var MainScene = /** @class */ (function (_super) {
    __extends(MainScene, _super);
    function MainScene() {
        var _this = _super.call(this, {
            key: "MainScene"
        }) || this;
        _this.scores = [];
        _this.scoreTiles = [];
        return _this;
    }
    MainScene.prototype.preload = function () {
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON('map', __webpack_require__(859));
        this.load.image("astronaut", __webpack_require__(999));
        this.load.atlas("assets", __webpack_require__(861), __webpack_require__(862));
    };
    MainScene.prototype.create = function () {
        this.initialize();
        this.generateScene();
        this.generateEvents();
        this.generateDropZones();
        this.generateDraggables();
        this.updateScoreboard();
    };
    MainScene.prototype.initialize = function () {
        this.map = this.make.tilemap({ key: 'map' });
        this.scores.push({ id: "trees", display: "Trees to place", score: 3 });
        this.scores.push({ id: "bushes", display: "Shrubs to place", score: 10 });
        this.scores.push({ id: "fountains", display: "Fountain to place", score: 1 });
        this.scores.push({ id: "satellites", display: "Satellite dish to place", score: 1 });
        this.bubbleText = this.add.text(this.gameWidth - 230, this.gameHeight - 300, "");
        this.bubbleText.setOrigin(0);
        this.bubbleText.setDepth(2);
        this.bubbleText.setFontFamily("Arial");
        this.bubbleText.setFontSize(20);
        this.bubbleText.setPadding(20, 20, 20, 20);
        this.bubbleText.setColor('#000000');
        this.bubbleText.setWordWrapWidth(150);
        this.bubbleText.setBackgroundColor('#ffffff');
    };
    MainScene.prototype.generateScene = function () {
        var _this = this;
        // Red Background
        this.background = this.add.image(0, 0, "pixel");
        this.background.setOrigin(0);
        this.background.setDepth(0);
        this.background.setTint(0xef4a4d);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        Phaser.Display.Align.In.Center(this.background, this.add.zone(8, 8, this.gameWidth, this.gameHeight));
        var sceneLayer = this.map.getObjectLayer('Scene');
        var fontStyle1 = { fontSize: 16, color: '#ffffff', align: 'right' };
        var fontStyle2 = { fontSize: 16, color: '#ffffff' };
        // Generate Objects
        sceneLayer.objects.forEach(function (ob) {
            if (ob.type !== "") {
                console.warn("Unknown Type Detected", ob.type);
                return;
            }
            var tileName = ob.name.toLowerCase();
            if (tileName === "house") {
                var house = _this.add.image(ob.x, ob.y, "assets", "house");
                house.setOrigin(0);
                house.setDepth(2);
                house.setDisplaySize(ob.width, ob.height);
            }
            else if (tileName === "path") {
                var path = _this.add.image(ob.x, ob.y, "assets", "path");
                path.setOrigin(0);
                path.setDepth(1);
                path.setDisplaySize(ob.width, ob.height);
            }
            else if (tileName === "garage") {
                var garage = _this.add.image(ob.x, ob.y, "assets", "garage");
                garage.setOrigin(0);
                garage.setDepth(2);
                garage.setDisplaySize(ob.width, ob.height);
            }
            else if (tileName === "scoreboard") {
                var scoreboard = _this.add.image(ob.x, ob.y, "pixel");
                scoreboard.setOrigin(0);
                scoreboard.setDepth(0);
                scoreboard.setTint(0x157CAD);
                scoreboard.setDisplaySize(ob.width, ob.height);
            }
            else if (tileName === "blueprint") {
                var blueprint = _this.add.image(ob.x, ob.y, "assets", "blueprint");
                blueprint.setOrigin(0);
                blueprint.setDepth(1);
                blueprint.setTint(0xffffff);
                blueprint.setDisplaySize(ob.width + 10, ob.height + 10);
            }
            else if (tileName === "score_1") {
                var txt = _this.add.text(ob.x, ob.y, "", fontStyle1);
                txt.setName(tileName);
                txt.setOrigin(0);
                txt.setFontFamily("Arial");
                txt.setDepth(1);
                txt.setStroke('#ffffff', .5);
                _this.scoreTiles.push(txt);
            }
            else if (tileName === "score_2") {
                var txt = _this.add.text(ob.x, ob.y, "", fontStyle2);
                txt.setName(tileName);
                txt.setOrigin(0);
                txt.setDepth(1);
                txt.setFontFamily("Arial");
                _this.scoreTiles.push(txt);
            }
            else if (tileName === "exit") {
                var exitButton = _this.add.image(ob.x, ob.y, "pixel");
                exitButton.setOrigin(0);
                exitButton.setDepth(1);
                exitButton.setInteractive();
                exitButton.setTint(0x157CAD);
                exitButton.setDisplaySize(ob.width, ob.height);
                exitButton.on("pointerdown", function () {
                    document[_this.sys.game.device.fullscreen.cancel]();
                });
            }
            else if (tileName === "exittext") {
                var exitText = _this.add.text(ob.x + 10, ob.y, "Exit");
                exitText.setOrigin(0);
                exitText.setDepth(1);
                exitText.setInteractive();
                exitText.setFontFamily("Arial");
                exitText.setFontSize(30);
                exitText.on("pointerdown", function () {
                    document[_this.sys.game.device.fullscreen.cancel]();
                });
            }
            else if (tileName === "astronaut") {
                var astronaut = _this.add.image(ob.x, ob.y, "astronaut");
                astronaut.setOrigin(0);
                astronaut.setDepth(1);
                astronaut.setDisplaySize(ob.width, ob.height);
            }
        });
    };
    MainScene.prototype.generateEvents = function () {
        var _this = this;
        // Wire up events
        this.input.on('dragstart', function (pointer, gameObject) {
            gameObject.x = pointer.downX;
            gameObject.y = pointer.downY;
            gameObject.setAngle();
            _this.children.bringToTop(gameObject);
        });
        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = pointer.x;
            gameObject.y = pointer.y;
        });
        this.input.on('dragend', function (pointer, gameObject, dropped) {
            // Move dropped object if not dropped onto a dropzone
            if (!dropped) {
                // Change feedback text to let them know they aren't dropping on a dropzone
                _this.setSpeechBubbleText("Oops, try a drop zone!");
                gameObject.x = gameObject.input.dragStartX;
                gameObject.y = gameObject.input.dragStartY;
            }
            _this.children.moveDown(gameObject);
        });
    };
    MainScene.prototype.generateDropZones = function () {
        var _this = this;
        // Generate DZs
        var objectLayer = this.map.getObjectLayer('DropZones');
        objectLayer.objects.forEach(function (ob) {
            if (ob.type !== "DropZone") {
                console.warn("Unknown Type Detected", ob.type);
                return;
            }
            // Merge config with properties, adjusting for accepted keys which is a comma delimited string
            var config = {
                //...ob.properties,
                height: ob.height,
                width: ob.width,
                square: ob.square,
                // Optional arguments for when we want an image rather than plain circle dropzones
                backgroundTexture: "assets",
                backgroundFrame: "hotspot",
                ellipse: ob.ellipse,
                lineColor: _this.rgbaHexToNumber(ob.properties.lineColor),
                dragLineColor: 0x83d86c,
                acceptedKeys: (ob.properties.acceptedKeys || "").split(',')
            };
            var dropZone = new __WEBPACK_IMPORTED_MODULE_0_src_games_shared_dropzone_DropZone__["a" /* DropZone */](_this, ob.x + ob.width / 2, ob.y + ob.height / 2, config);
            dropZone.on('drop', function (dropzone, gameObject, accepted) {
                var fontStyle2 = { fontSize: 16, color: '#ffffff' };
                if (accepted) {
                    // Choose a random good feedback to say
                    var good = ["Good Job!", "Nice!", "Perfect!", "Great Job!"];
                    _this.setSpeechBubbleText(good[Math.floor(Math.random() * good.length)]);
                    _this.scores.find(function (x) { return x.id === gameObject.name; }).score--;
                    _this.updateScoreboard();
                }
                else {
                    // Choose a random bad feedback to say
                    var bad = ["Not Quite!", "Oops!", "That's okay!", "Try Again!"];
                    _this.setSpeechBubbleText(bad[Math.floor(Math.random() * bad.length)]);
                    gameObject.x = gameObject.input.dragStartX;
                    gameObject.y = gameObject.input.dragStartY;
                }
            });
        });
    };
    // Show speech bubble and text (hide when click on something else)
    MainScene.prototype.setSpeechBubbleText = function (text) {
        var _this = this;
        this.bubbleText.setText(text);
        this.input.on('pointerdown', function () {
            _this.bubbleText.setText("");
        });
    };
    MainScene.prototype.rgbaHexToNumber = function (color) {
        if (color == null || color.length < 8) {
            return undefined;
        }
        return parseInt(color.substring(0, 8));
    };
    MainScene.prototype.generateDraggables = function () {
        var _this = this;
        // Generate Plants
        var atlasTexture = this.textures.get('assets');
        var frames = atlasTexture.getFrameNames();
        var items = [
            {
                name: "trees",
                keys: ["item", "tree"],
                x: 160,
                y: 120,
                height: 64,
                width: 64,
                texture: "assets",
                frame: "tree",
                count: this.scores.find(function (x) { return x.id === "trees"; }).score
            },
            {
                name: "bushes",
                keys: ["item", "bush"],
                x: 256,
                y: 120,
                height: 64,
                width: 64,
                texture: "assets",
                frame: "shrub",
                count: this.scores.find(function (x) { return x.id === "bushes"; }).score
            },
            {
                name: "fountains",
                keys: ["item", "fountain"],
                x: 352,
                y: 120,
                height: 64,
                width: 64,
                texture: "assets",
                frame: "fountain",
                count: this.scores.find(function (x) { return x.id === "fountains"; }).score
            },
            {
                name: "satellites",
                keys: ["item", "satellite"],
                x: 448,
                y: 120,
                height: 64,
                width: 64,
                texture: "assets",
                frame: "satellite",
                count: this.scores.find(function (x) { return x.id === "satellites"; }).score
            }
        ];
        items.forEach(function (item) {
            for (var index = 0; index < item.count; index++) {
                var dropZoneSprite = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_dropzone_DropZoneSprite__["a" /* default */](_this, item.keys, item.x, item.y, item.texture, item.frame);
                dropZoneSprite.setDisplaySize(item.width, item.height);
                dropZoneSprite.setInteractive();
                dropZoneSprite.setName(item.name);
                _this.input.setDraggable(dropZoneSprite);
            }
        });
    };
    MainScene.prototype.updateScoreboard = function () {
        var numberTile = this.scoreTiles.find(function (x) { return x.name === "score_1"; });
        var textTile = this.scoreTiles.find(function (x) { return x.name === "score_2"; });
        var numbers;
        var texts;
        numberTile.setText([
            this.scores[0].score.toString(),
            "",
            this.scores[1].score.toString(),
            "",
            this.scores[2].score.toString(),
            "",
            this.scores[3].score.toString(),
            ""
        ]);
        textTile.setText([
            this.scores[0].display,
            "",
            this.scores[1].display,
            "",
            this.scores[2].display,
            "",
            this.scores[3].display,
            ""
        ]);
        // Game is done
        if (this.isDone()) {
            var finished = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "pixel");
            finished.setDepth(4);
            finished.setTint(0x00000);
            finished.setDisplaySize(600, 200);
            var txt = 'Mission Complete!';
            var text = this.add.text(this.gameWidth / 2, this.gameHeight / 2, txt);
            text.setFontFamily('Arial');
            text.setFontSize(64);
            text.setDepth(4);
            text.setOrigin(.5);
            return;
        }
    };
    // Checks if all items have been dropped in their respective dragzones
    MainScene.prototype.isDone = function () {
        for (var i = 0; i < this.scores.length; i++) {
            if (this.scores[i].score > 0) {
                return false;
            }
        }
        return true;
    };
    return MainScene;
}(Phaser.Scene));



/***/ }),
/* 2769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_demos_howToPlayScene_Main__ = __webpack_require__(2770);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var HowToPlaySceneDemo = /** @class */ (function (_super) {
    __extends(HowToPlaySceneDemo, _super);
    function HowToPlaySceneDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, HowToPlaySceneDemo.prototype);
        return _this;
    }
    HowToPlaySceneDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_demos_howToPlayScene_Main__["a" /* default */], null)));
    };
    return HowToPlaySceneDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (HowToPlaySceneDemo);


/***/ }),
/* 2770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_HowToPlay__ = __webpack_require__(2771);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var DemoConfig = {
    title: "How To Play Scene Demo",
    version: "0.9.3",
    backgroundColor: "#d3d3d3"
};
var PhaserHowToPlaySceneDemo = /** @class */ (function (_super) {
    __extends(PhaserHowToPlaySceneDemo, _super);
    function PhaserHowToPlaySceneDemo(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PhaserHowToPlaySceneDemo.prototype);
        return _this;
    }
    PhaserHowToPlaySceneDemo.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_shared_phaserHelpers_PhaserGameComponent__["a" /* default */], { scenes: __WEBPACK_IMPORTED_MODULE_3__scenes_HowToPlay__["a" /* HowToPlayScene */], config: DemoConfig })));
    };
    return PhaserHowToPlaySceneDemo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PhaserHowToPlaySceneDemo);


/***/ }),
/* 2771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HowToPlayScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollageGame_scenes_MainScene__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__ = __webpack_require__(16);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var HowToPlayScene = /** @class */ (function (_super) {
    __extends(HowToPlayScene, _super);
    function HowToPlayScene() {
        var _this = _super.call(this, {
            key: "HowToPlay"
        }) || this;
        _this.skyColor = 0x6eb8e5;
        _this.hollandCode = "r";
        _this.gameObjectiveTextKey = "Landscaping.Phaser.HowToPlay.objectiveText";
        _this.howToPlayOnComputerTextKey = "Landscaping.Phaser.HowToPlay.computerInstructions";
        _this.howToPlayOnTabletTextKey = "Landscaping.Phaser.HowToPlay.tabletInstructions";
        _this.buttonTextKey = "Landscaping.Phaser.HowToPlay.getStarted";
        _this.gameScene = __WEBPACK_IMPORTED_MODULE_2__CollageGame_scenes_MainScene__["a" /* MainScene */];
        return _this;
    }
    HowToPlayScene.prototype.preload = function () {
        this.load.image("pixel", __webpack_require__(60));
        this.load.tilemapTiledJSON('intro-map', __webpack_require__(855));
        // Loading only the needed terrain
        switch (this.hollandCode) {
            case this.hollandCode = "r": {
                this.load.image('terrain', __webpack_require__(367));
            }
            case this.hollandCode = "i": {
                this.load.image('terrain', __webpack_require__(368));
            }
            case this.hollandCode = "a": {
                this.load.image('terrain', __webpack_require__(853));
            }
            case this.hollandCode = "s": {
                this.load.image('terrain', __webpack_require__(515));
            }
            case this.hollandCode = "e": {
                this.load.image('terrain', __webpack_require__(854));
            }
            case this.hollandCode = "c": {
                this.load.image('terrain', __webpack_require__(369));
            }
        }
        this.load.atlas("pilots", __webpack_require__(189), __webpack_require__(190));
        this.load.atlas("starPods", __webpack_require__(856), __webpack_require__(857));
    };
    HowToPlayScene.prototype.create = function () {
        var _this = this;
        this.gameWidth = this.textures.game.config.width;
        this.gameHeight = this.textures.game.config.height;
        Object(__WEBPACK_IMPORTED_MODULE_0_src_utils_BindThisHelper__["a" /* default */])(this, HowToPlayScene.prototype);
        var instructionsTextKey;
        this.map = this.make.tilemap({ key: "intro-map" });
        var sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(this.skyColor, this.skyColor, 0xffffff, 0xffffff); // Gradient sky!
        // Optional - only show instructions for the device you're on
        // Supports iPads, Android tablets, Kindle Fire tablets
        var isTablet = (/iPad|Android|Mobi|Silk/i.test(navigator.userAgent));
        if (this.sys.game.device.input.touch) {
            if (isTablet) {
                instructionsTextKey = this.howToPlayOnTabletTextKey;
            }
            else {
                // Touch screen computer
                instructionsTextKey = [this.howToPlayOnComputerTextKey, this.howToPlayOnTabletTextKey];
            }
        }
        else {
            instructionsTextKey = this.howToPlayOnComputerTextKey;
        }
        this.map.getObjectLayer("Objects").objects.forEach(function (ob) {
            if (ob.name === "text") {
                // One text box for the game objective and how to play instructions
                _this.addDialogBoxWithButton(ob, [_this.gameObjectiveTextKey].concat(instructionsTextKey));
            }
            else if (ob.name === "pod") {
                var starPod = _this.add.image(ob.x, ob.y, "starPods", _this.hollandCode);
                starPod.setOrigin(0);
                starPod.setDepth(2);
                starPod.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "pilot") {
                var starPilot = _this.add.image(ob.x, ob.y, "pilots", _this.hollandCode);
                starPilot.setOrigin(0);
                starPilot.setDisplaySize(ob.width, ob.height);
                starPilot.setDepth(3);
            }
            else if (ob.name === "terrain") {
                var terrain = _this.add.image(ob.x, ob.y, "terrain");
                terrain.setScale(0.8);
                terrain.setDepth(0);
                terrain.setOrigin(0);
            }
        });
    };
    /**
     * Creates a nice looking text box with multiple paragraphs and a button
     * @param translateKeys array of strings - these are the translation file keys of each paragraph you want in the text box
     */
    HowToPlayScene.prototype.addDialogBoxWithButton = function (ob, translateKeys) {
        var _this = this;
        // Feel free to edit these variables if the text isn't looking nice
        var padding = 30;
        var fontSize = 25;
        var borderWidth = 10;
        var borderColor = __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].PLANET_COLORS.get(this.hollandCode.toUpperCase());
        var verticalSpacing = padding;
        var paragraphSpacing = 20;
        var textBox = this.add.container(ob.x, ob.y);
        var paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: fontSize, padding: 10 };
        var buttonColor = __WEBPACK_IMPORTED_MODULE_4_src_games_shared_ColorValue__["a" /* Color */].KUDER_PRIMARY_BUTTON;
        var buttonTextColor = 0xffffff;
        // Add all the paragraphs to one big textbox
        translateKeys.forEach(function (key) {
            var translatedText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(key);
            // Split the translated text by newlines to create paragraphs
            translatedText.split("|").map(function (x) { return x.trim(); }).forEach(function (para) {
                var paragraph = _this.add.text(padding, verticalSpacing, para, textStyle);
                paragraph.setWordWrapWidth(ob.width - 2 * padding, true);
                paragraphs.push(paragraph);
                verticalSpacing += paragraph.height + paragraphSpacing;
                textBox.setSize(Math.max(ob.width, paragraph.width), verticalSpacing);
            });
        });
        var config = {
            backgroundColor: buttonColor,
            smartSize: true
        };
        // Button to start your game
        var buttonText = __WEBPACK_IMPORTED_MODULE_3_src_utils_TranslateHelper__["a" /* default */].translate(this.buttonTextKey);
        var button = new __WEBPACK_IMPORTED_MODULE_1_src_games_shared_Button__["a" /* PhaserButton */](this, 0, 0, 200, 50, buttonText, config);
        textBox.setSize(textBox.width, textBox.height + button.displayHeight + 2 * padding);
        button.setPosition(padding + textStyle.padding, textBox.displayHeight - button.displayHeight - padding);
        button.on('buttonClicked', function () {
            _this.scene.remove(_this);
            _this.scene.add("GameScene", _this.gameScene, true);
        });
        // Add text box background
        var textBoxBackground = this.add.image(0, 0, "pixel");
        textBoxBackground.setOrigin(0);
        textBoxBackground.setDisplaySize(textBox.displayWidth, textBox.displayHeight);
        textBoxBackground.setTint(0x000000);
        textBoxBackground.setPosition(borderWidth + padding + textStyle.padding, borderWidth + padding + textStyle.padding);
        // Add text box border
        var textBoxBorder = this.add.image(0, 0, "pixel");
        textBoxBorder.setOrigin(0);
        textBoxBorder.setDisplaySize(textBoxBackground.displayWidth + 2 * borderWidth, textBoxBackground.displayHeight + 2 * borderWidth);
        textBoxBorder.setTint(borderColor);
        textBoxBackground.setPosition(borderWidth, borderWidth);
        textBox.add(textBoxBorder);
        textBox.add(textBoxBackground);
        textBox.add(paragraphs);
        textBox.add(button);
        textBox.setDepth(2);
    };
    return HowToPlayScene;
}(Phaser.Scene));



/***/ }),
/* 2772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var GameHome = /** @class */ (function (_super) {
    __extends(GameHome, _super);
    function GameHome(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, GameHome.prototype);
        return _this;
    }
    GameHome.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "Hey you just made the GameHome component, woot!"));
    };
    return GameHome;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (GameHome);


/***/ }),
/* 2773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_PaintGame_Main__ = __webpack_require__(891);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var PaintGame = /** @class */ (function (_super) {
    __extends(PaintGame, _super);
    function PaintGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PaintGame.prototype);
        return _this;
    }
    PaintGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    PaintGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_PaintGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return PaintGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PaintGame);


/***/ }),
/* 2774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_LandscapingGame_Main__ = __webpack_require__(851);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var LandscapingGame = /** @class */ (function (_super) {
    __extends(LandscapingGame, _super);
    function LandscapingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, LandscapingGame.prototype);
        return _this;
    }
    LandscapingGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    LandscapingGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_LandscapingGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return LandscapingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LandscapingGame);


/***/ }),
/* 2775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_JobMatchingGame_Main__ = __webpack_require__(870);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var JobMatchingGame = /** @class */ (function (_super) {
    __extends(JobMatchingGame, _super);
    function JobMatchingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, JobMatchingGame.prototype);
        return _this;
    }
    JobMatchingGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    JobMatchingGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_JobMatchingGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return JobMatchingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (JobMatchingGame);


/***/ }),
/* 2776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_PuzzleSlider_Main__ = __webpack_require__(882);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var PuzzleSliderGame = /** @class */ (function (_super) {
    __extends(PuzzleSliderGame, _super);
    function PuzzleSliderGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PuzzleSliderGame.prototype);
        return _this;
    }
    PuzzleSliderGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    PuzzleSliderGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_PuzzleSlider_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return PuzzleSliderGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PuzzleSliderGame);


/***/ }),
/* 2777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_DiseasedTreesGame_Main__ = __webpack_require__(907);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var DiseasedTreesGame = /** @class */ (function (_super) {
    __extends(DiseasedTreesGame, _super);
    function DiseasedTreesGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, DiseasedTreesGame.prototype);
        return _this;
    }
    DiseasedTreesGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    DiseasedTreesGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_DiseasedTreesGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return DiseasedTreesGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DiseasedTreesGame);


/***/ }),
/* 2778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_UniversityGame_Main__ = __webpack_require__(888);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var UniversityGame = /** @class */ (function (_super) {
    __extends(UniversityGame, _super);
    function UniversityGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, UniversityGame.prototype);
        return _this;
    }
    UniversityGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    UniversityGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_UniversityGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return UniversityGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (UniversityGame);


/***/ }),
/* 2779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_OrganizeDeskGame_Main__ = __webpack_require__(901);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var OrganizeDeskGame = /** @class */ (function (_super) {
    __extends(OrganizeDeskGame, _super);
    function OrganizeDeskGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, OrganizeDeskGame.prototype);
        return _this;
    }
    OrganizeDeskGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    OrganizeDeskGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_OrganizeDeskGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return OrganizeDeskGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (OrganizeDeskGame);


/***/ }),
/* 2780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_CareerFairGame_Main__ = __webpack_require__(896);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CareerFairGame = /** @class */ (function (_super) {
    __extends(CareerFairGame, _super);
    function CareerFairGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, CareerFairGame.prototype);
        return _this;
    }
    CareerFairGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    CareerFairGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_CareerFairGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return CareerFairGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CareerFairGame);


/***/ }),
/* 2781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_ColonyGame_Main__ = __webpack_require__(877);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ColonyGame = /** @class */ (function (_super) {
    __extends(ColonyGame, _super);
    function ColonyGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ColonyGame.prototype);
        return _this;
    }
    ColonyGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    ColonyGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_ColonyGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return ColonyGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ColonyGame);


/***/ }),
/* 2782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_DiagnosisGame_Main__ = __webpack_require__(864);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var PlatformerGame = /** @class */ (function (_super) {
    __extends(PlatformerGame, _super);
    function PlatformerGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PlatformerGame.prototype);
        return _this;
    }
    PlatformerGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    PlatformerGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_DiagnosisGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return PlatformerGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PlatformerGame);


/***/ }),
/* 2783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_DinerGame_Main__ = __webpack_require__(893);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var DinerGame = /** @class */ (function (_super) {
    __extends(DinerGame, _super);
    function DinerGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, DinerGame.prototype);
        return _this;
    }
    DinerGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    DinerGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_DinerGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return DinerGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DinerGame);


/***/ }),
/* 2784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_WarehouseGame_Main__ = __webpack_require__(924);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var WarehouseGame = /** @class */ (function (_super) {
    __extends(WarehouseGame, _super);
    function WarehouseGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, WarehouseGame.prototype);
        return _this;
    }
    WarehouseGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    WarehouseGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_WarehouseGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return WarehouseGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (WarehouseGame);


/***/ }),
/* 2785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_FitFiveGame_Main__ = __webpack_require__(918);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var FitFiveGame = /** @class */ (function (_super) {
    __extends(FitFiveGame, _super);
    function FitFiveGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, FitFiveGame.prototype);
        return _this;
    }
    FitFiveGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    FitFiveGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_FitFiveGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return FitFiveGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FitFiveGame);


/***/ }),
/* 2786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_HotelAuroraGame_Main__ = __webpack_require__(920);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var HotelAuroraGame = /** @class */ (function (_super) {
    __extends(HotelAuroraGame, _super);
    function HotelAuroraGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, HotelAuroraGame.prototype);
        return _this;
    }
    HotelAuroraGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    HotelAuroraGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_HotelAuroraGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return HotelAuroraGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (HotelAuroraGame);


/***/ }),
/* 2787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_DesertTerraformGame_Main__ = __webpack_require__(916);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TerraformingGame = /** @class */ (function (_super) {
    __extends(TerraformingGame, _super);
    function TerraformingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, TerraformingGame.prototype);
        return _this;
    }
    TerraformingGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    TerraformingGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_DesertTerraformGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return TerraformingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (TerraformingGame);


/***/ }),
/* 2788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_PlumbingGame_Main__ = __webpack_require__(885);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var PlumbingGame = /** @class */ (function (_super) {
    __extends(PlumbingGame, _super);
    function PlumbingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, PlumbingGame.prototype);
        return _this;
    }
    PlumbingGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    PlumbingGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_PlumbingGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return PlumbingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PlumbingGame);


/***/ }),
/* 2789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_CollageGame_Main__ = __webpack_require__(867);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CollageGame = /** @class */ (function (_super) {
    __extends(CollageGame, _super);
    function CollageGame(props) {
        var _this = _super.call(this, props) || this;
        _this.game = null;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, CollageGame.prototype);
        return _this;
    }
    CollageGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    CollageGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_CollageGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return CollageGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CollageGame);


/***/ }),
/* 2790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_XraySlider_Main__ = __webpack_require__(913);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var XraySliderGame = /** @class */ (function (_super) {
    __extends(XraySliderGame, _super);
    function XraySliderGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, XraySliderGame.prototype);
        return _this;
    }
    XraySliderGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    XraySliderGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_XraySlider_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return XraySliderGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (XraySliderGame);


/***/ }),
/* 2791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_ShipPainting_Main__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_message_style_index_js__ = __webpack_require__(14);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ShipPaintingGame = /** @class */ (function (_super) {
    __extends(ShipPaintingGame, _super);
    function ShipPaintingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ShipPaintingGame.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    ShipPaintingGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_3_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    ShipPaintingGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_ShipPainting_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return ShipPaintingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ShipPaintingGame);


/***/ }),
/* 2792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_row__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_row_style_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_es_col__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_es_col_style_index_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_mission_DialogBox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_constants_Planets__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_common_AudioPlayer__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_constants_AudioTranslations__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_core_Routes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_redux_CheckpointActions__ = __webpack_require__(183);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var SpaceStationReturn = /** @class */ (function (_super) {
    __extends(SpaceStationReturn, _super);
    function SpaceStationReturn(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_3_src_utils_BindThisHelper__["a" /* default */])(_this, SpaceStationReturn.prototype);
        return _this;
    }
    SpaceStationReturn.prototype.onNext = function () {
        this.props.history.push(__WEBPACK_IMPORTED_MODULE_13_src_core_Routes__["a" /* default */].STUDENT_PLANET);
    };
    SpaceStationReturn.prototype.componentDidMount = function () {
        this.props.updateFreshness("not-fresh");
        document.addEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStationReturn.prototype.componentWillUnmount = function () {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    };
    SpaceStationReturn.prototype.handleKeyPress = function (event) {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
    };
    SpaceStationReturn.prototype.hasNextButton = function () {
        return true;
    };
    SpaceStationReturn.prototype.hasBackButton = function () {
        return false;
    };
    SpaceStationReturn.prototype.render = function () {
        var currentGrade = __WEBPACK_IMPORTED_MODULE_9_src_constants_Grades__["a" /* Grades */].FindById(this.props.User.gradeId);
        var currentPlanet = __WEBPACK_IMPORTED_MODULE_10_src_constants_Planets__["a" /* Planets */].FindById(this.props.Mission.current.planetId);
        var audioTrans = __WEBPACK_IMPORTED_MODULE_12_src_constants_AudioTranslations__["a" /* default */].FindByKeyAndLanguage("student.welcomeBack.body", this.props.activeLanguage.code);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_src_components_common_AudioPlayer__["a" /* default */], { audioURL: audioTrans.url, isPlaying: true }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { className: "dialog-content", xs: { span: 22, push: 1 }, md: { span: 16 }, xl: 14 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_src_components_mission_DialogBox__["a" /* default */], { currentGrade: currentGrade, currentPlanet: currentPlanet, buttonNextType: this.hasNextButton() ? "arrow" : "none", buttonBackType: this.hasBackButton() ? "arrow" : "none", onNext: this.onNext },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "student.welcomeBack.header" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "student.welcomeBack.body" }))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: 23, md: { span: 7, push: 1 }, xl: 9 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_es_row__["a" /* default */], { type: "flex", justify: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_es_col__["a" /* default */], { xs: { span: 20, push: 2 }, lg: { span: 21, push: 1 } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "station-commander", alt: "Commander " + currentGrade.commander, src: currentGrade.commanderPath, height: "100%", width: "100%" })))));
    };
    return SpaceStationReturn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
function mapDispatchToProps(dispatch) {
    return {
        updateFreshness: function (request) { return __WEBPACK_IMPORTED_MODULE_14_src_redux_CheckpointActions__["a" /* default */].SetFreshnessStatus(dispatch, request); }
    };
}
function mapStateToProps(state) {
    return {
        Mission: state.Mission,
        User: state.User
    };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(SpaceStationReturn)));


/***/ }),
/* 2793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_ProgramRobotGame_Main__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_message_style_index_js__ = __webpack_require__(14);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ProgramRobotGame = /** @class */ (function (_super) {
    __extends(ProgramRobotGame, _super);
    function ProgramRobotGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ProgramRobotGame.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    ProgramRobotGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_3_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    ProgramRobotGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_ProgramRobotGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return ProgramRobotGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ProgramRobotGame);


/***/ }),
/* 2794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_Main__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_message_style_index_js__ = __webpack_require__(14);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var RocketRepairGame = /** @class */ (function (_super) {
    __extends(RocketRepairGame, _super);
    function RocketRepairGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, RocketRepairGame.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    RocketRepairGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_3_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    RocketRepairGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_src_games_RocketRepairGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return RocketRepairGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (RocketRepairGame);


/***/ }),
/* 2795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__games_JigsawPuzzleGame_Main__ = __webpack_require__(932);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var JigsawPuzzleGame = /** @class */ (function (_super) {
    __extends(JigsawPuzzleGame, _super);
    function JigsawPuzzleGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, JigsawPuzzleGame.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    JigsawPuzzleGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    JigsawPuzzleGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__games_JigsawPuzzleGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return JigsawPuzzleGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (JigsawPuzzleGame);


/***/ }),
/* 2796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__games_SpacePortGame_Main__ = __webpack_require__(934);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SpacePortGame = /** @class */ (function (_super) {
    __extends(SpacePortGame, _super);
    function SpacePortGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, SpacePortGame.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    SpacePortGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    SpacePortGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__games_SpacePortGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return SpacePortGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SpacePortGame);


/***/ }),
/* 2797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_MailDeliveryGame_Main__ = __webpack_require__(939);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MailDeliveryGame = /** @class */ (function (_super) {
    __extends(MailDeliveryGame, _super);
    function MailDeliveryGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, MailDeliveryGame.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    MailDeliveryGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    MailDeliveryGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_MailDeliveryGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return MailDeliveryGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (MailDeliveryGame);


/***/ }),
/* 2798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_CityBuilderGame_Main__ = __webpack_require__(975);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CityBuilderGame = /** @class */ (function (_super) {
    __extends(CityBuilderGame, _super);
    function CityBuilderGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, CityBuilderGame.prototype);
        return _this;
    }
    CityBuilderGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    CityBuilderGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_CityBuilderGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return CityBuilderGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CityBuilderGame);


/***/ }),
/* 2799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GalaxyGuidePage_less__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GalaxyGuidePage_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__GalaxyGuidePage_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

 // 'this' binder


var HollandAreasGuide = /** @class */ (function (_super) {
    __extends(HollandAreasGuide, _super);
    function HollandAreasGuide(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, HollandAreasGuide.prototype);
        return _this;
    }
    HollandAreasGuide.prototype.renderSections = function () {
        var sections = [];
        for (var i = 1; i <= 6; i++) {
            var section = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.section" + i + ".header" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.section" + i + ".para1" })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.section" + i + ".para2" })));
            sections.push(section);
        }
        return sections;
    };
    HollandAreasGuide.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "galaxy-guide" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.header" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.intro1" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.intro2" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.intro3" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "hollandCodes", src: __webpack_require__(876) }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.subheader1" })),
            this.renderSections(),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.subheader2" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.conclusion1" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.hollandAreas.conclusion2" })));
    };
    return HollandAreasGuide;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(HollandAreasGuide));


/***/ }),
/* 2800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GalaxyGuidePage_less__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GalaxyGuidePage_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__GalaxyGuidePage_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

 // 'this' binder


var TrainingAndEducationGuide = /** @class */ (function (_super) {
    __extends(TrainingAndEducationGuide, _super);
    function TrainingAndEducationGuide(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, TrainingAndEducationGuide.prototype);
        return _this;
    }
    TrainingAndEducationGuide.prototype.renderSections = function () {
        var sections = [];
        for (var i = 1; i <= 8; i++) {
            var body = this.props.translate("public.guide.trainingAndEducation.section" + i + ".body").split(" | ");
            var section = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.trainingAndEducation.section" + i + ".header" })),
                body.map(function (para) { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, para); }));
            sections.push(section);
        }
        return sections;
    };
    TrainingAndEducationGuide.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "galaxy-guide" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["b" /* Translate */], { id: "public.guide.trainingAndEducation.header" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
            this.renderSections());
    };
    return TrainingAndEducationGuide;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* withLocalize */])(TrainingAndEducationGuide));


/***/ }),
/* 2801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_VendingMachine_Main__ = __webpack_require__(957);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var VendingMachineGame = /** @class */ (function (_super) {
    __extends(VendingMachineGame, _super);
    function VendingMachineGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, VendingMachineGame.prototype);
        return _this;
    }
    VendingMachineGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    VendingMachineGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_VendingMachine_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return VendingMachineGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (VendingMachineGame);


/***/ }),
/* 2802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_SeekAndFindGame_Main__ = __webpack_require__(959);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SeekAndFindGame = /** @class */ (function (_super) {
    __extends(SeekAndFindGame, _super);
    function SeekAndFindGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, SeekAndFindGame.prototype);
        return _this;
    }
    SeekAndFindGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    SeekAndFindGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_SeekAndFindGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return SeekAndFindGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SeekAndFindGame);


/***/ }),
/* 2803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_SpacePets_Main__ = __webpack_require__(943);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SpacePetsGame = /** @class */ (function (_super) {
    __extends(SpacePetsGame, _super);
    function SpacePetsGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, SpacePetsGame.prototype);
        return _this;
    }
    SpacePetsGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    SpacePetsGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_SpacePets_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return SpacePetsGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SpacePetsGame);


/***/ }),
/* 2804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_OceanCleanupGame_Main__ = __webpack_require__(953);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var OceanCleanupGame = /** @class */ (function (_super) {
    __extends(OceanCleanupGame, _super);
    function OceanCleanupGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, OceanCleanupGame.prototype);
        return _this;
    }
    OceanCleanupGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    OceanCleanupGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_OceanCleanupGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return OceanCleanupGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (OceanCleanupGame);


/***/ }),
/* 2805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_WaiterMemoryGame_Main__ = __webpack_require__(945);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var WaiterMemoryGame = /** @class */ (function (_super) {
    __extends(WaiterMemoryGame, _super);
    function WaiterMemoryGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, WaiterMemoryGame.prototype);
        return _this;
    }
    WaiterMemoryGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    WaiterMemoryGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_WaiterMemoryGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return WaiterMemoryGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (WaiterMemoryGame);


/***/ }),
/* 2806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_CakeDecorating_Main__ = __webpack_require__(969);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CakeDecoratingGame = /** @class */ (function (_super) {
    __extends(CakeDecoratingGame, _super);
    function CakeDecoratingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, CakeDecoratingGame.prototype);
        return _this;
    }
    CakeDecoratingGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    CakeDecoratingGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_CakeDecorating_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return CakeDecoratingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CakeDecoratingGame);


/***/ }),
/* 2807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_LibrarianGame_Main__ = __webpack_require__(949);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var LibrarianGame = /** @class */ (function (_super) {
    __extends(LibrarianGame, _super);
    function LibrarianGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, LibrarianGame.prototype);
        return _this;
    }
    LibrarianGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    LibrarianGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_LibrarianGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return LibrarianGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LibrarianGame);


/***/ }),
/* 2808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_ZooGame_Main__ = __webpack_require__(947);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ZooGame = /** @class */ (function (_super) {
    __extends(ZooGame, _super);
    function ZooGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ZooGame.prototype);
        return _this;
    }
    ZooGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    ZooGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_ZooGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return ZooGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ZooGame);


/***/ }),
/* 2809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_UniformDesignGame_main__ = __webpack_require__(951);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var UniformDesignGame = /** @class */ (function (_super) {
    __extends(UniformDesignGame, _super);
    function UniformDesignGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, UniformDesignGame.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    UniformDesignGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    UniformDesignGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_UniformDesignGame_main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return UniformDesignGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (UniformDesignGame);


/***/ }),
/* 2810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_TicketTakerGame_Main__ = __webpack_require__(963);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TicketTakerGame = /** @class */ (function (_super) {
    __extends(TicketTakerGame, _super);
    function TicketTakerGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, TicketTakerGame.prototype);
        return _this;
    }
    TicketTakerGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    TicketTakerGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_TicketTakerGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return TicketTakerGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (TicketTakerGame);


/***/ }),
/* 2811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_FindHelpersGame_Main__ = __webpack_require__(961);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var FindHelpersGame = /** @class */ (function (_super) {
    __extends(FindHelpersGame, _super);
    function FindHelpersGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, FindHelpersGame.prototype);
        return _this;
    }
    FindHelpersGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    FindHelpersGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_FindHelpersGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return FindHelpersGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FindHelpersGame);


/***/ }),
/* 2812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_GroceryBaggerGame_Main__ = __webpack_require__(967);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var GroceryBaggerGame = /** @class */ (function (_super) {
    __extends(GroceryBaggerGame, _super);
    function GroceryBaggerGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, GroceryBaggerGame.prototype);
        return _this;
    }
    GroceryBaggerGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    GroceryBaggerGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_GroceryBaggerGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return GroceryBaggerGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (GroceryBaggerGame);


/***/ }),
/* 2813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_ConstructionMazeGame_Main__ = __webpack_require__(955);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ConstructionMazeGame = /** @class */ (function (_super) {
    __extends(ConstructionMazeGame, _super);
    function ConstructionMazeGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, ConstructionMazeGame.prototype);
        return _this;
    }
    ConstructionMazeGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    ConstructionMazeGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_ConstructionMazeGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return ConstructionMazeGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ConstructionMazeGame);


/***/ }),
/* 2814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_StarballGame_Main__ = __webpack_require__(973);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var StarballGame = /** @class */ (function (_super) {
    __extends(StarballGame, _super);
    function StarballGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, StarballGame.prototype);
        return _this;
    }
    StarballGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    StarballGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_StarballGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return StarballGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (StarballGame);


/***/ }),
/* 2815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_RideMechanicGame_Main__ = __webpack_require__(971);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var RideMechanicGame = /** @class */ (function (_super) {
    __extends(RideMechanicGame, _super);
    function RideMechanicGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, RideMechanicGame.prototype);
        return _this;
    }
    RideMechanicGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    RideMechanicGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_RideMechanicGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return RideMechanicGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (RideMechanicGame);


/***/ }),
/* 2816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_FossilFinderGame_Main__ = __webpack_require__(965);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var FossilFinderGame = /** @class */ (function (_super) {
    __extends(FossilFinderGame, _super);
    function FossilFinderGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, FossilFinderGame.prototype);
        return _this;
    }
    FossilFinderGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    FossilFinderGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_FossilFinderGame_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return FossilFinderGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FossilFinderGame);


/***/ }),
/* 2817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_message_style_index_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_games_FacePainting_Main__ = __webpack_require__(978);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var FacePaintingGame = /** @class */ (function (_super) {
    __extends(FacePaintingGame, _super);
    function FacePaintingGame(props) {
        var _this = _super.call(this, props) || this;
        Object(__WEBPACK_IMPORTED_MODULE_1_src_utils_BindThisHelper__["a" /* default */])(_this, FacePaintingGame.prototype);
        // You are allowed to set defaults here, based on your state object above
        _this.state = {};
        return _this;
    }
    FacePaintingGame.prototype.completeGame = function () {
        return __WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success("You finished the game!");
    };
    FacePaintingGame.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_src_games_FacePainting_Main__["a" /* default */], { onComplete: this.completeGame }));
    };
    return FacePaintingGame;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FacePaintingGame);


/***/ }),
/* 2818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_CheckpointReducer__ = __webpack_require__(2819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_UserReducer__ = __webpack_require__(2820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_redux_ConstantReducer__ = __webpack_require__(2821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_ConfigReducer__ = __webpack_require__(2822);







var rootReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
    User: __WEBPACK_IMPORTED_MODULE_4__redux_UserReducer__["a" /* UserReducer */],
    localize: __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["c" /* localizeReducer */],
    Mission: __WEBPACK_IMPORTED_MODULE_3__redux_CheckpointReducer__["a" /* MissionReducer */],
    Constants: __WEBPACK_IMPORTED_MODULE_5_src_redux_ConstantReducer__["a" /* ConstantReducer */],
    Config: __WEBPACK_IMPORTED_MODULE_6__redux_ConfigReducer__["a" /* ConfigReducer */],
});
var windowIfDefined = typeof window === 'undefined' ? null : window;
// If devTools is installed, connect to it
var devToolsExtension = windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__;
// devToolsExtension is either the function or null
// DEBUG
/**
 * This is the configured redux store. It includes all redux reducers and middleware, such as devtools
 */
var ConfiguredReduxStore = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(rootReducer, {}, Object(__WEBPACK_IMPORTED_MODULE_0_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a), devToolsExtension != null ? devToolsExtension() : function (f) { return f; }));
/* harmony default export */ __webpack_exports__["a"] = (ConfiguredReduxStore);
// END DEBUG
/**
 * This is the configured redux store. It includes all redux reducers and middleware, such as devtools
 */
// let ConfiguredReduxStore = devToolsExtension == null ? createStore(rootReducer) : createStore(rootReducer, {}, devToolsExtension());
// export default ConfiguredReduxStore;


/***/ }),
/* 2819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MissionState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MissionReducer; });
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var MissionState = /** @class */ (function () {
    function MissionState() {
        this.current = null;
        this.furthest = null;
        this.previous = null;
        this.replay = null;
        this.state = "none";
        this.currentDirection = "forwards";
        this.isReplayModeActive = false;
    }
    return MissionState;
}());

var MissionReducer = function (state, action) {
    if (state === void 0) { state = new MissionState(); }
    switch (action.type) {
        case "SET_CHECKPOINT":
            var setAction = action;
            if (setAction.data == null) {
                return __assign({}, state);
            }
            return __assign(__assign({}, state), { current: setAction.data.current || state.current, previous: setAction.data.previous || state.previous, furthest: setAction.data.furthest || state.furthest, replay: setAction.data.replay || state.replay, currentDirection: setAction.data.currentDirection || state.currentDirection });
        case "UPDATE_CHECKPOINT":
            var updateAction = action;
            if (updateAction.data == null) {
                return __assign({}, state);
            }
            return __assign(__assign({}, state), { current: updateAction.data.current || state.current, furthest: updateAction.data.furthest || state.furthest, currentDirection: updateAction.data.currentDirection || state.currentDirection });
        case "ENABLE_REPLAY_CHECKPOINT":
            var enableReplayAction = action;
            var newCurrent = __assign({}, enableReplayAction.data.start);
            var newReplay = __assign({}, enableReplayAction.data.end);
            var newPrevious = __assign({}, state.current);
            return __assign(__assign({}, state), { current: newCurrent, previous: newPrevious, replay: newReplay, isReplayModeActive: true });
        case "DISABLE_REPLAY_CHECKPOINT":
            var disableReplayAction = action;
            return __assign(__assign({}, state), { current: __assign({}, state.previous), previous: null, replay: null, isReplayModeActive: false });
        case "UPDATE_STATE_CHECKPOINT":
            var updateStateAction = action;
            return __assign(__assign({}, state), { state: updateStateAction.data });
        case "RESET_CHECKPOINT":
            var resetAction = action;
            return new MissionState();
        default:
            // JB - Clarification: The following line is fucking magic
            var exhaustiveCheck = action;
    }
    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    //  (or default initial state if none was supplied)
    return state;
};


/***/ }),
/* 2820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserReducer; });
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * This is both the UserState and the default for the given state
 */
var UserState = /** @class */ (function () {
    function UserState() {
        this.firstName = "unknown";
        this.lastName = "unknown";
        this.email = "";
        this.roleID = 1;
        this.gradeId = 0;
        this.cultureId = 1;
        this.cultureCode = "en-us";
        this.isEmulating = false;
        this.state = "none";
        this.emulationInfo = null;
    }
    return UserState;
}());

var UserReducer = function (state, action) {
    if (state === void 0) { state = new UserState(); }
    switch (action.type) {
        case "LOGIN_USER":
            var loginAction = action;
            return __assign(__assign({}, state), { 
                // Statically using the names below in case they change
                firstName: loginAction.data.firstName, lastName: loginAction.data.lastName, email: loginAction.data.email, roleID: loginAction.data.roleID, gradeId: loginAction.data.gradeId, cultureId: loginAction.data.cultureId, cultureCode: loginAction.data.cultureCode, districtId: loginAction.data.districtId, schoolId: loginAction.data.schoolId, stateId: loginAction.data.stateId, isEmulating: loginAction.data.isEmulating, isSsoEnabled: loginAction.data.isSsoEnabled, clientId: loginAction.data.clientId, clientName: loginAction.data.clientName, userId: loginAction.data.userId, stateName: loginAction.data.stateName, districtName: loginAction.data.districtName, schoolName: loginAction.data.schoolName, checkpointId: loginAction.data.checkpointId, planetId: loginAction.data.planetId, stepId: loginAction.data.stepId });
        case "UPDATE_USER":
            var updateAction = action;
            return __assign(__assign({}, state), { 
                // Statically using the names below in case they change
                firstName: updateAction.data.firstName, lastName: updateAction.data.lastName, email: updateAction.data.email, roleID: updateAction.data.roleID, gradeId: updateAction.data.gradeId, cultureId: updateAction.data.cultureId, cultureCode: updateAction.data.cultureCode, districtId: updateAction.data.districtId, schoolId: updateAction.data.schoolId, stateId: updateAction.data.stateId, isEmulating: updateAction.data.isEmulating, isSsoEnabled: updateAction.data.isSsoEnabled, clientId: updateAction.data.clientId, clientName: updateAction.data.clientName, userId: updateAction.data.userId, stateName: updateAction.data.stateName, districtName: updateAction.data.districtName, schoolName: updateAction.data.schoolName, checkpointId: updateAction.data.checkpointId, planetId: updateAction.data.planetId, stepId: updateAction.data.stepId });
        case "UPDATE_STATE_USER":
            var updateStateAction = action;
            return __assign(__assign({}, state), { state: updateStateAction.data });
        case "UPDATE_ERROR_USER":
            var updateErrorAction = action;
            return __assign(__assign({}, state), { errorMsg: updateErrorAction.data });
        case "RESET_USER":
            var resetUserAction = action;
            return new UserState();
        case "UPDATE_EMULATE_INFO_USER":
            var updateEmulateUserAction = action;
            return __assign(__assign({}, state), { emulationInfo: updateEmulateUserAction.data });
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            // JB - Clarification: The following line is fucking magic
            var exhaustiveCheck = action;
    }
    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    //  (or default initial state if none was supplied)
    return state;
};


/***/ }),
/* 2821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConstantState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConstantReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_constants_Roles__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_constants_Languages__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_constants_Config__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_constants_Checkpoints__ = __webpack_require__(123);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var ConstantState = /** @class */ (function () {
    function ConstantState() {
        this.Grades = __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */];
        this.Roles = __WEBPACK_IMPORTED_MODULE_1_src_constants_Roles__["a" /* Roles */];
        this.Languages = __WEBPACK_IMPORTED_MODULE_2_src_constants_Languages__["a" /* default */];
        this.Config = __WEBPACK_IMPORTED_MODULE_3_src_constants_Config__["a" /* default */];
        this.state = "none";
    }
    return ConstantState;
}());

var ConstantReducer = function (state, action) {
    if (state === void 0) { state = new ConstantState(); }
    switch (action.type) {
        case "UPDATE_ROLES_CONSTANTS":
            var rolesAction = action;
            if (rolesAction.data == null) {
                return __assign({}, state);
            }
            var _loop_1 = function (item) {
                var feels = __WEBPACK_IMPORTED_MODULE_1_src_constants_Roles__["a" /* Roles */].All.find(function (x) { return x.name === item.key; });
                if (feels == null) {
                    return "continue";
                }
                feels.id = item.value;
            };
            for (var _i = 0, _a = rolesAction.data; _i < _a.length; _i++) {
                var item = _a[_i];
                _loop_1(item);
            }
            return __assign(__assign({}, state), { Roles: __WEBPACK_IMPORTED_MODULE_1_src_constants_Roles__["a" /* Roles */] });
        case "UPDATE_GRADES_CONSTANTS":
            var gradeAction = action;
            if (gradeAction.data == null) {
                return __assign({}, state);
            }
            var _loop_2 = function (item) {
                var lives = __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */].All.find(function (x) { return x.shortName === item.key; });
                if (lives == null) {
                    return "continue";
                }
                lives.id = item.value;
            };
            for (var _b = 0, _c = gradeAction.data; _b < _c.length; _b++) {
                var item = _c[_b];
                _loop_2(item);
            }
            return __assign(__assign({}, state), { Grades: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */] });
        case "UPDATE_CHECKPOINTS_CONSTANTS":
            var checkpointAction = action;
            if (checkpointAction.data == null) {
                return __assign({}, state);
            }
            var _loop_3 = function (item) {
                var lives = __WEBPACK_IMPORTED_MODULE_4_src_constants_Checkpoints__["a" /* Checkpoints */].All.find(function (x) { return x.name === item.key; });
                if (lives == null) {
                    return "continue";
                }
                lives.id = item.value;
            };
            for (var _d = 0, _e = checkpointAction.data; _d < _e.length; _d++) {
                var item = _e[_d];
                _loop_3(item);
            }
            return __assign(__assign({}, state), { Grades: __WEBPACK_IMPORTED_MODULE_0_src_constants_Grades__["a" /* Grades */] });
        case "UPDATE_LANGUAGES_CONSTANTS":
            var languageAction = action;
            if (languageAction.data == null) {
                return __assign({}, state);
            }
            var _loop_4 = function (item) {
                var langs = __WEBPACK_IMPORTED_MODULE_2_src_constants_Languages__["a" /* default */].All.find(function (x) { return x.code === item.key.toLowerCase(); });
                if (langs == null) {
                    return "continue";
                }
                langs.id = item.value;
            };
            for (var _f = 0, _g = languageAction.data; _f < _g.length; _f++) {
                var item = _g[_f];
                _loop_4(item);
            }
            return __assign(__assign({}, state), { Languages: __WEBPACK_IMPORTED_MODULE_2_src_constants_Languages__["a" /* default */] });
        case "UPDATE_STATE_CONSTANTS":
            var updateStateAction = action;
            return __assign(__assign({}, state), { state: updateStateAction.data });
        case "UPDATE_CULTURE_CONSTANTS":
            var updateCultureAction = action;
            if (updateCultureAction.data == null) {
                return __assign({}, state);
            }
            // Reset all to false as a default
            __WEBPACK_IMPORTED_MODULE_2_src_constants_Languages__["a" /* default */].All.forEach(function (x) { return x.isAvailable = false; });
            var _loop_5 = function (item) {
                var langs = __WEBPACK_IMPORTED_MODULE_2_src_constants_Languages__["a" /* default */].All.find(function (x) { return x.code === item.value.toLowerCase(); });
                if (langs == null) {
                    return "continue";
                }
                langs.isAvailable = true;
            };
            for (var _h = 0, _j = updateCultureAction.data; _h < _j.length; _h++) {
                var item = _j[_h];
                _loop_5(item);
            }
            return __assign(__assign({}, state), { Languages: __WEBPACK_IMPORTED_MODULE_2_src_constants_Languages__["a" /* default */] });
        case "UPDATE_CONFIG_CONSTANTS":
            var updateConfigAction = action;
            __WEBPACK_IMPORTED_MODULE_3_src_constants_Config__["a" /* default */].AzureUrl = updateConfigAction.data.azureBaseUrl;
            __WEBPACK_IMPORTED_MODULE_3_src_constants_Config__["a" /* default */].AzureKey = updateConfigAction.data.azureKey;
            return __assign(__assign({}, state), { Config: __WEBPACK_IMPORTED_MODULE_3_src_constants_Config__["a" /* default */] });
        default:
            // JB - Clarification: The following line is fucking magic
            var exhaustiveCheck = action;
    }
    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    //  (or default initial state if none was supplied)
    return state;
};


/***/ }),
/* 2822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConfigState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_ConfigUtil__ = __webpack_require__(513);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * This is both the UserState and the default for the given state
 */
var ConfigState = /** @class */ (function () {
    function ConfigState() {
        this.audioEnabled = true;
        this.previousLocation = null;
    }
    return ConfigState;
}());

var ConfigReducer = function (state, action) {
    if (state === void 0) { state = new ConfigState(); }
    switch (action.type) {
        case "TOGGLE_AUDIO_CONFIG":
            var toggleAudioAction = action;
            // Update local storage because redux hates pure TS
            __WEBPACK_IMPORTED_MODULE_0_src_utils_ConfigUtil__["a" /* default */].AudioEnabled = toggleAudioAction.data;
            return __assign(__assign({}, state), { audioEnabled: toggleAudioAction.data });
        case "SET_PREVIOUS_LOCATION_CONFIG":
            var setPreviousLocationAction = action;
            return __assign(__assign({}, state), { previousLocation: setPreviousLocationAction.data });
        case "RESET_CONFIG": {
            var resetConfigAction = action;
            return new ConfigState();
        }
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            // JB - Clarification: The following line is fucking magic
            var exhaustiveCheck = action;
    }
    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    // (or default initial state if none was supplied)
    return state;
};


/***/ }),
/* 2823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_react_js__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TelemetryService__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(30);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var TelemetryProvider = /** @class */ (function (_super) {
    __extends(TelemetryProvider, _super);
    function TelemetryProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            initialized: false
        };
        return _this;
    }
    TelemetryProvider.prototype.componentDidMount = function () {
        var history = this.props.history;
        var initialized = this.state.initialized;
        var AppInsightsInstrumentationKey = this.props.instrumentationKey;
        if (!Boolean(initialized) && Boolean(AppInsightsInstrumentationKey) && Boolean(history)) {
            __WEBPACK_IMPORTED_MODULE_2__TelemetryService__["c" /* ai */].initialize(AppInsightsInstrumentationKey, history);
            this.setState({ initialized: true });
        }
    };
    TelemetryProvider.prototype.render = function () {
        var children = this.props.children;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, children);
    };
    return TelemetryProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_react_js__["b" /* withAITracking */])(__WEBPACK_IMPORTED_MODULE_2__TelemetryService__["c" /* ai */].reactPlugin, TelemetryProvider)));


/***/ }),
/* 2824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_webfontloader__ = __webpack_require__(2825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_webfontloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_webfontloader__);

// // This doesnt need to be in a function, but it works with our structure
// var ConfiguredFonts = () => {
//     WebFont.load({
//         google: {
//             families: ['Russo One', 'Roboto Mono:500']
//         },
//         loading: () => {
//             console.warn("Hello! Loading the fonts now :)");
//         },
//         fontloading: (a, b) => {
//             console.warn("Loaded a font", a, b);
//         }
//     });
// };
// export default ConfiguredFonts;
__WEBPACK_IMPORTED_MODULE_0_webfontloader__["load"]({
    google: {
        families: ['Russo One', 'Roboto Mono:500', 'Merriweather']
    },
    loading: function () {
        // console.warn("Hello! Loading the fonts now :)");
    },
    fontloading: function (a, b) {
        // console.warn("Loaded a font", a, b);
    }
});


/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function B(){this.a=0;this.c=null}function C(a){a.a++;return function(){a.a--;D(a)}}function E(a,b){a.c=b;D(a)}function D(a){0==a.a&&a.c&&(a.c(),a.c=null)};function F(a){this.a=a||"-"}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading")}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}K(a,"inactive")}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function N(a){u(a.c,"body",a.a)}function O(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")};function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25)},function(){e()})}f()}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f)});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a)},function(){b.j(b.a)})};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m)}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this)};
function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return!0;return!1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v)}function ma(a){setTimeout(p(function(){U(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this)};
W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e)}K(b,"fontinactive",a);na(this)};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a))};function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a)};
function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else{b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
X=x?42<parseInt(x[1],10):xa?!1:!0}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r)}for(h=0;h<l.length;h++)l[h].start()}},0)}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c)})};function ra(a,b){this.c=a;this.a=b}
ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+d}else a([])};function sa(a,b){this.c=a;this.a=b}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f)})};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||""}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function ya(a){this.f=a;this.a=[];this.c={}}
var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else{k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("")}}else k="";k&&g.push(k)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d))}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]))}};function Ea(a,b){this.c=a;this.a=b}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa)})};function Ga(a,b){this.c=a;this.a=b}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(l){}a(e)}},2E3):a([])};function Ha(a,b){this.c=a;this.f=b;this.a=[]}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return Z}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 2826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[1848]);


// WEBPACK FOOTER //
// static/js/main.f7b737eb.js